import _, { isPlainObject } from 'lodash';
import numeral from 'numeral';
import dayjs from 'dayjs';
import { Parser, ERROR_REF } from '@fortune-sheet/formula-parser';
import { v4 } from 'uuid';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var en = {
  generalDialog: {
    partiallyError: "Cannot perform this operation on partially merged cells",
    readOnlyError: "Cannot perform this operation in read-only mode",
    dataNullError: "Cannot perform this operation on data that does not exist",
    noSeletionError: "The selection operation has not been performed yet",
    cannotSelectMultiple: "Cannot select multiple selections"
  },
  functionlist: [{
    n: "SUMIF",
    t: 0,
    d: "Returns a conditional sum across a range.",
    a: "A conditional sum across a range.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The range which is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sum_range",
      detail: "The range to be summed, if different from `range`.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TAN",
    t: 0,
    d: "Returns the tangent of an angle provided in radians.",
    a: "Tangent of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the tangent of, in radians.",
      example: "45*PI()/180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TANH",
    t: 0,
    d: "Returns the hyperbolic tangent of any real number.",
    a: "Hyperbolic tangent of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic tangent of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CEILING",
    t: 0,
    d: "Rounds a number up to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number up to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round up to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN",
    t: 0,
    d: "Returns the inverse tangent of a value, in radians.",
    a: "Inverse tangent of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse tangent.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ASINH",
    t: 0,
    d: "Returns the inverse hyperbolic sine of a number.",
    a: "Inverse hyperbolic sine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic sine.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ABS",
    t: 0,
    d: "Returns the absolute value of a number.",
    a: "Absolute value of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number of which to return the absolute value.",
      example: "-2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOS",
    t: 0,
    d: "Returns the inverse cosine of a value, in radians.",
    a: "Inverse cosine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOSH",
    t: 0,
    d: "Returns the inverse hyperbolic cosine of a number.",
    a: "Inverse hyperbolic cosine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTINOMIAL",
    t: 0,
    d: "Returns the factorial of the sum of values divided by the product of the values' factorials.",
    a: "Multinomial distribution function.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "ATANH",
    t: 0,
    d: "Returns the inverse hyperbolic tangent of a number.",
    a: "Inverse hyperbolic tangent of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN2",
    t: 0,
    d: "Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",
    a: "Arctangent of a value.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "y",
      detail: "The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTBLANK",
    t: 1,
    d: "Returns the number of empty values in a list of values and ranges.",
    a: "Number of empty values.",
    m: [1, 1],
    p: [{
      name: "value1",
      detail: "The first value or range in which to count the number of blanks.",
      example: "A2:C100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "COSH",
    t: 0,
    d: "Returns the hyperbolic cosine of any real number.",
    a: "Hyperbolic cosine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic cosine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INT",
    t: 0,
    d: "Rounds a number down to the nearest integer that is less than or equal to it.",
    a: "Rounds number down to nearest integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISEVEN",
    t: 0,
    d: "Checks whether the provided value is even.",
    a: "Whether the provided value is even.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as even.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISODD",
    t: 0,
    d: "Checks whether the provided value is odd.",
    a: "Whether the provided value is odd.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as odd.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LCM",
    t: 0,
    d: "Returns the least common multiple of one or more integers.",
    a: "Least common multiple of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the least common multiple.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the least common multiple.",
      example: "3",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LN",
    t: 0,
    d: "Returns the logarithm of a number, base e (Euler's number).",
    a: "The logarithm of a number, base e (euler's number).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base e.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG",
    t: 0,
    d: "Returns the logarithm of a number with respect to a base.",
    a: "The logarithm of a number with respect to a base.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm.",
      example: "128",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "base",
      detail: "The base to use for calculation of the logarithm.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG10",
    t: 0,
    d: "Returns the logarithm of a number, base 10.",
    a: "The logarithm of a number, base 10.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base 10.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MOD",
    t: 0,
    d: "Returns the result of the modulo operator, the remainder after a division operation.",
    a: "Modulo (remainder) operator.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided to find the remainder.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MROUND",
    t: 0,
    d: "Rounds one number to the nearest integer multiple of another.",
    a: "Rounds a number to the nearest integer multiple.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The number to round to the nearest integer multiple of another.",
      example: "21",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ODD",
    t: 0,
    d: "Rounds a number up to the nearest odd integer.",
    a: "Rounds a number up to the nearest odd integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest odd number.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMSQ",
    t: 0,
    d: "Returns the sum of the squares of a series of numbers and/or cells.",
    a: "Sum of squares.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range whose squares to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges whose squares to add to the square(s) of `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMBIN",
    t: 0,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects.",
    a: "Number of combinations from a set of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUM",
    t: 0,
    d: "Returns the sum of a series of numbers and/or cells.",
    a: "Sum of a series of numbers and/or cells.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges to add to `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SUBTOTAL",
    t: 0,
    d: "Returns a subtotal for a vertical range of cells using a specified aggregation function.",
    a: "Subtotal for a range using a specific function.",
    m: [2, 256],
    p: [{
      name: "function_code",
      detail: "The function to use in subtotal aggregation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range1",
      detail: "The first range over which to calculate a subtotal.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "range2",
      detail: "Additional ranges over which to calculate subtotals.",
      example: "B2:B8",
      require: "o",
      repeat: "y",
      type: "range"
    }]
  }, {
    n: "ASIN",
    t: 0,
    d: "Returns the inverse sine of a value, in radians.",
    a: "Inverse sine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTIF",
    t: 1,
    d: "Returns a conditional count across a range.",
    a: "A conditional count across a range.",
    m: [2, 2],
    p: [{
      name: "range",
      detail: "The range that is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RADIANS",
    t: 0,
    d: "Converts an angle value in degrees to radians.",
    a: "Converts an angle value in degrees to radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from degrees to radians.",
      example: "180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RAND",
    t: 0,
    d: "Returns a random number between 0 inclusive and 1 exclusive.",
    a: "A random number between 0 inclusive and 1 exclusive.",
    m: [0, 0],
    p: []
  }, {
    n: "COUNTUNIQUE",
    t: 0,
    d: "Counts the number of unique values in a list of specified values and ranges.",
    a: "Counts number of unique values in a range.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider for uniqueness.",
      example: "A1:C100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider for uniqueness.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DEGREES",
    t: 0,
    d: "Converts an angle value in radians to degrees.",
    a: "Converts an angle value in radians to degrees.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from radians to degrees.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ERFC",
    t: 9,
    d: "Returns the complementary Gauss error function of a value.",
    a: "Complementary gauss error function of a value.",
    m: [1, 1],
    p: [{
      name: "z",
      detail: "The number for which to calculate the complementary Gauss error function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVEN",
    t: 0,
    d: "Rounds a number up to the nearest even integer.",
    a: "Rounds a number up to the nearest even integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest even number.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EXP",
    t: 0,
    d: "Returns Euler's number, e (~2.718) raised to a power.",
    a: "Euler's number, e (~2.718) raised to a power.",
    m: [1, 1],
    p: [{
      name: "exponent",
      detail: "The exponent to raise e to.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACT",
    t: 0,
    d: "Returns the factorial of a number.",
    a: "Factorial of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose factorial will be calculated and returned.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACTDOUBLE",
    t: 0,
    d: 'Returns the "double factorial" of a number.',
    a: '"double factorial" of a number.',
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose double factorial will be calculated and returned.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PI",
    t: 0,
    d: "Returns the value of Pi to 14 decimal places.",
    a: "The number pi.",
    m: [0, 0],
    p: []
  }, {
    n: "FLOOR",
    t: 0,
    d: "Rounds a number down to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number down to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GCD",
    t: 0,
    d: "Returns the greatest common divisor of one or more integers.",
    a: "Greatest common divisor of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the greatest common divisor.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the greatest common divisor.",
      example: "96",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANDBETWEEN",
    t: 0,
    d: "Returns a uniformly random integer between two values, inclusive.",
    a: "Random integer between two values, inclusive.",
    m: [2, 2],
    p: [{
      name: "low",
      detail: "The low end of the random range.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high",
      detail: "The high end of the random range.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUND",
    t: 0,
    d: "Rounds a number to a certain number of decimal places according to standard rules.",
    a: "Rounds a number according to standard rules.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDDOWN",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",
    a: "Rounds down a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding down.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDUP",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",
    a: "Rounds up a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding up.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SERIESSUM",
    t: 0,
    d: "Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",
    a: "Sum of a power series.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The initial power to which to raise `x` in the power series.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "m",
      detail: "The additive increment by which to increase `x`.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "a",
      detail: "The array or range containing the coefficients of the power series.",
      example: "{FACT(0)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIGN",
    t: 0,
    d: "Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",
    a: "Sign of a provided number (+/-/0).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose sign will be evaluated.",
      example: "-42",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIN",
    t: 0,
    d: "Returns the sine of an angle provided in radians.",
    a: "Sine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the sine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SINH",
    t: 0,
    d: "Returns the hyperbolic sine of any real number.",
    a: "Hyperbolic sine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic sine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRT",
    t: 0,
    d: "Returns the positive square root of a positive number.",
    a: "Positive square root of a positive number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number for which to calculate the positive square root.",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRTPI",
    t: 0,
    d: "Returns the positive square root of the product of Pi and the given positive number.",
    a: "Square root of the product of pi and number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number which will be multiplied by Pi and have the product's square root returned",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GAMMALN",
    t: 1,
    d: "Returns the logarithm of a specified Gamma function, base e (Euler's number).",
    a: "Logarithm of gamma function.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COS",
    t: 0,
    d: "Returns the cosine of an angle provided in radians.",
    a: "Cosine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the cosine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRUNC",
    t: 0,
    d: "Truncates a number to a certain number of significant digits by omitting less significant digits.",
    a: "Truncates a number.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value to be truncated.",
      example: "3.141592654",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of significant digits to the right of the decimal point to retain.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUOTIENT",
    t: 0,
    d: "Returns one number divided by another.",
    a: "One number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POWER",
    t: 0,
    d: "Returns a number raised to a power.",
    a: "A number raised to a power.",
    m: [2, 2],
    p: [{
      name: "base",
      detail: "The number to raise to the `exponent` power.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "exponent",
      detail: "The exponent to raise `base` to.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMIFS",
    t: 0,
    d: "Returns the sum of a range depending on multiple criteria.",
    a: "Sums a range depending on multiple criteria.",
    m: [3, 257],
    p: [{
      name: "sum_range",
      detail: "The range to sum.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criteria_range1",
      detail: "The range to check against criterion1.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to criteria_range1.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTIFS",
    t: 1,
    d: "Returns the count of a range depending on multiple criteria.",
    a: "Count values depending on multiple criteria.",
    m: [2, 256],
    p: [{
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " B1:B10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PRODUCT",
    t: 0,
    d: "Returns the result of multiplying a series of numbers together.",
    a: "Result of multiplying a series of numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "More numbers or ranges to calculate for the product.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HARMEAN",
    t: 1,
    d: "Calculates the harmonic mean of a dataset.",
    a: "The harmonic mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HYPGEOMDIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",
    a: "Hypergeometric distribution probability.",
    m: [5, 5],
    p: [{
      name: "num_successes",
      detail: "The desired number of successes.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_draws",
      detail: "The number of permitted draws.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "successes_in_pop",
      detail: "The total number of successes in the population.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The total size of the population",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INTERCEPT",
    t: 1,
    d: "Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",
    a: "Y-intercept of line derived via linear regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "KURT",
    t: 1,
    d: 'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',
    a: "Kurtosis of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LARGE",
    t: 1,
    d: "Returns the nth largest element from a data set, where n is user-defined.",
    a: "Nth largest element from a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The rank from largest to smallest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVA",
    t: 1,
    d: "Calculates the standard deviation based on a sample, setting text to the value `0`.",
    a: "Standard deviation of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVP",
    t: 1,
    d: "Calculates the standard deviation based on an entire population.",
    a: "Standard deviation of an entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "GEOMEAN",
    t: 1,
    d: "Calculates the geometric mean of a dataset.",
    a: "The geometric mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANK_EQ",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",
    a: "Top rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANK_AVG",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",
    a: "Average rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERCENTRANK_EXC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 exclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTRANK_INC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 inclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: " A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FORECAST",
    t: 1,
    d: "Calculates the expected y-value for a specified x based on a linear regression of a dataset.",
    a: "Expected y-value based of linear regression.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The value on the x-axis to forecast.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHERINV",
    t: 1,
    d: "Returns the inverse Fisher transformation of a specified value.",
    a: "Inverse fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHER",
    t: 1,
    d: "Returns the Fisher transformation of a specified value.",
    a: "Fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MODE_SNGL",
    t: 1,
    d: "Returns the most commonly occurring value in a dataset.",
    a: "Most commonly occurring value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating mode.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating mode.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "WEIBULL_DIST",
    t: 1,
    d: "Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",
    a: "Weibull distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the Weibull distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "shape",
      detail: "The shape parameter of the Weibull distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "scale",
      detail: "The scale parameter of the Weibull distribution function.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the cumulative distribution function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COUNT",
    t: 1,
    d: "Returns the number of numeric values in a dataset.",
    a: "The number of numeric values in dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTA",
    t: 1,
    d: "Returns the number of values in a dataset.",
    a: "The number of values in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVEDEV",
    t: 1,
    d: "Calculates the average of the magnitudes of deviations of data from a dataset's mean.",
    a: "Average magnitude of deviations from mean.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "AVERAGE",
    t: 1,
    d: "Returns the numerical average value in a dataset, ignoring text.",
    a: "Numerical average value in a dataset, ignoring text.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEA",
    t: 1,
    d: "Returns the numerical average value in a dataset.",
    a: "Numerical average value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",
    a: "Binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_successes",
      detail: "The number of successes for which to calculate the probability in `num_trials` trials.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the binomial cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_INV",
    t: 1,
    d: "Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",
    a: "Inverse cumulative binomial distribution function.",
    m: [3, 3],
    p: [{
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "target_prob",
      detail: "The desired threshold probability.",
      example: "0.8",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONFIDENCE_NORM",
    t: 1,
    d: "Calculates the width of half the confidence interval for a normal distribution.",
    a: "Confidence interval for a normal distribution.",
    m: [3, 3],
    p: [{
      name: "alpha",
      detail: "One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",
      example: "0.05",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the population.",
      example: "1.6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The size of the population.",
      example: "250",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CORREL",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_P",
    t: 1,
    d: "Calculates the covariance of a dataset.",
    a: "The covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_S",
    t: 1,
    d: "Calculates the sample covariance of a dataset.",
    a: "The sample covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEVSQ",
    t: 1,
    d: "Calculates the sum of squares of deviations based on a sample.",
    a: "The sum of squares of deviations based on a sample.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "EXPON_DIST",
    t: 1,
    d: "Returns the value of the exponential distribution function with a specified lambda at a specified value.",
    a: "Exponential distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the exponential distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "lambda",
      detail: "The lambda to specify the exponential distribution function.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the exponential cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIF",
    t: 1,
    d: "Returns the average of a range depending on criteria.",
    a: "Average of values depending on criteria.",
    m: [2, 3],
    p: [{
      name: "criteria_range",
      detail: "The range to check against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `criteria_range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "average_range",
      detail: "The range to average. If not included, `criteria_range` is used for the average instead.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIFS",
    t: 1,
    d: "Returns the average of a range depending on multiple criteria.",
    a: "Average of values depending on multiple criteria.",
    m: [2, 255],
    p: [{
      name: "average_range",
      detail: "The range to average.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERMUT",
    t: 1,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",
    a: "Number of permutations from a number of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRIMMEAN",
    t: 1,
    d: "Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",
    a: "Mean of a dataset excluding high/low ends.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "exclude_proportion",
      detail: "The proportion of the dataset to exclude, from the extremities of the set.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_EXC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset exclusive of 0 and 1.",
    a: "Value at a given percentile of a dataset exclusive of 0 and 1.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_INC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset.",
    a: "Value at a given percentile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile whose value within `data` will be calculated and returned.`",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PEARSON",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_INV",
    t: 1,
    d: "Returns the value of the inverse standard normal distribution function for a specified value.",
    a: "Inverse standard normal distribution function.",
    m: [1, 1],
    p: [{
      name: "x",
      detail: "The input to the inverse standard normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_DIST",
    t: 1,
    d: "Returns the value of the standard normal cumulative distribution function for a specified value.",
    a: "Standard normal cumulative distribution function.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the standard normal cumulative distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NORM_INV",
    t: 1,
    d: "Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",
    a: "Inverse normal distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_DIST",
    t: 1,
    d: "Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",
    a: "Normal distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the normal distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the normal cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NEGBINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",
    a: "Negative binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_failures",
      detail: "The number of failures to model.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_successes",
      detail: "The number of successes to model.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINA",
    t: 1,
    d: "Returns the minimum numeric value in a dataset.",
    a: "Minimum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MIN",
    t: 1,
    d: "Returns the minimum value in a numeric dataset.",
    a: "Minimum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MEDIAN",
    t: 1,
    d: "Returns the median value in a numeric dataset.",
    a: "Median value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the median value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the median value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAXA",
    t: 1,
    d: "Returns the maximum numeric value in a dataset.",
    a: "Maximum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAX",
    t: 1,
    d: "Returns the maximum value in a numeric dataset.",
    a: "Maximum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_INV",
    t: 1,
    d: "Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Inverse log-normal cumulative distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse log-normal cumulative distribution function.",
      example: "0.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the inverse log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_DIST",
    t: 1,
    d: "Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Log-normal cumulative distribution probability.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "Z_TEST",
    t: 1,
    d: "Returns the one-tailed p-value of a Z-test with standard distribution.",
    a: "One-tailed p-value of a z-test.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "value",
      detail: "The test statistic to use in the Z-test.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",
      example: "3",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PROB",
    t: 1,
    d: "Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",
    a: "Probability values lie in a range.",
    m: [3, 4],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A3:A6",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "probabilities",
      detail: "Array or range containing probabilities corresponding to `data`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "low_limit",
      detail: "The lower bound on the value range for which to calculate the probability.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high_limit",
      detail: "The upper bound on the value range for which to calculate the probability.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_EXC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",
    a: "Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_INC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset.",
    a: "Value nearest to a specific quartile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile value to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POISSON_DIST",
    t: 1,
    d: "Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",
    a: "Poisson distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the Poisson distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the Poisson distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the Poisson cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RSQ",
    t: 1,
    d: "Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Square of the correlation coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST",
    t: 1,
    d: "Calculates the left tail probability for a Student's t-distribution with a given input (x).",
    a: "The left-tailed Student's t-distribution",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T_DIST_2T",
    t: 1,
    d: "Calculates the probability for two tailed Student's t-distribution with a given input (x).",
    a: "The two tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST_RT",
    t: 1,
    d: "Calculates the right tail probability for a Student's t-distribution with a given input (x).",
    a: "The right-tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV",
    t: 1,
    d: "Calculates the negative inverse of the one-tailed TDIST function.",
    a: "T.INV",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV_2T",
    t: 1,
    d: "Calculates the inverse of the two-tailed TDIST function.",
    a: "T.INV.2T",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_TEST",
    t: 1,
    d: "t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",
    a: "Returns the probability associated with t-test.",
    m: [4, 4],
    p: [{
      name: "range1",
      detail: "The first sample of data or group of cells to consider for the t-test.",
      example: "A1:A4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range2",
      detail: "The second sample of data or group of cells to consider for the t-test.",
      example: "B1:B4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "Specifies the number of distribution tails.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "Specifies the type of t-test.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "F_DIST",
    t: 1,
    d: "Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution (left-tailed).",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Logical value that determines the form of the function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "F_DIST_RT",
    t: 1,
    d: "Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_P",
    t: 1,
    d: "Calculates the variance based on an entire population.",
    a: "Variance of entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_S",
    t: 1,
    d: "Calculates the variance based on a sample.",
    a: "Variance.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARA",
    t: 1,
    d: "Calculates the variance based on a sample, setting text to the value `0`.",
    a: "Variance of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARPA",
    t: 1,
    d: "Calculates the variance based on an entire population, setting text to the value `0`.",
    a: "Variance of entire population (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STEYX",
    t: 1,
    d: "Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",
    a: "Standard error of predicted y-values in regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STANDARDIZE",
    t: 1,
    d: "Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",
    a: "Normalized equivalent of a random variable.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The value of the random variable to normalize.",
      example: "96",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean of the distribution.",
      example: "80",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the distribution.",
      example: "6.7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SMALL",
    t: 1,
    d: "Returns the nth smallest element from a data set, where n is user-defined.",
    a: "Nth smallest element in a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "n",
      detail: "The rank from smallest to largest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLOPE",
    t: 1,
    d: "Calculates the slope of the line resulting from linear regression of a dataset.",
    a: "Slope of line from linear regression of data.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SKEW",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",
    a: "Skewness of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SKEW_P",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",
    a: "Skewness of a population's dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "VLOOKUP",
    t: 2,
    d: "Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",
    a: "Vertical lookup.",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The column index of the value to be returned, where the first column in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HLOOKUP",
    t: 2,
    d: "Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",
    a: "Horizontal lookup",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",
      example: "A2:Z6",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The row index of the value to be returned, where the first row in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the row to be searched (the first row of the specified range) is sorted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOOKUP",
    t: 2,
    d: "Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",
    a: "Look up a value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_range|search_result_array",
      detail: "One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "result_range",
      detail: "The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",
      example: "B1:B100",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADDRESS",
    t: 2,
    d: "Returns a cell reference as a string.",
    a: "Cell reference as a string.",
    m: [2, 5],
    p: [{
      name: "row",
      detail: "The row number of the cell reference",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The column number (not name) of the cell reference. `A` is column number `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "absolute_relative_mode",
      detail: "An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "use_a1_notation",
      detail: "A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sheet",
      detail: "Text indicating the name of the sheet into which the address points.",
      example: '"Sheet2"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INDIRECT",
    t: 2,
    d: "Returns a cell reference specified by a string.",
    a: "A cell reference specified by a string.",
    m: [1, 2],
    p: [{
      name: "cell_reference_as_string",
      detail: "A cell reference, written as a string with surrounding quotation marks.",
      example: '"Sheet2!"&B10',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "is_A1_notation",
      detail: "Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROW",
    t: 2,
    d: "Returns the row number of a specified cell.",
    a: "Row number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose row number will be returned.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROWS",
    t: 2,
    d: "Returns the number of rows in a specified array or range.",
    a: "Number of rows in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose row count will be returned.",
      example: "A9:A62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COLUMN",
    t: 2,
    d: "Returns the column number of a specified cell, with `A=1`.",
    a: "Column number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose column number will be returned. Column `A` corresponds to `1`.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNS",
    t: 2,
    d: "Returns the number of columns in a specified array or range.",
    a: "Number of columns in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose column count will be returned.",
      example: "A9:W62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OFFSET",
    t: 2,
    d: "Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",
    a: "A range reference offset relative to a cell.",
    m: [3, 5],
    p: [{
      name: "cell_reference",
      detail: "The starting point from which to count the offset rows and columns.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "offset_rows",
      detail: "The number of rows to offset by.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "offset_columns",
      detail: "The number of columns to offset by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "height",
      detail: "The height of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "width",
      detail: "The width of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MATCH",
    t: 2,
    d: "Returns the relative position of an item in a range that matches a specified value.",
    a: "Position of item in range that matches value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: '"Sunday"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The one-dimensional array to be searched.",
      example: "A2:A9",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "search_type",
      detail: "The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INDEX",
    t: 2,
    d: "Returns the content of a cell, specified by row and column offset.",
    a: "Content of cell specified by row and column offset.",
    m: [2, 3],
    p: [{
      name: "reference",
      detail: "The array of cells to be offset into.",
      example: "A1:C20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "row",
      detail: "The number of offset rows.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The number of offset columns.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GETPIVOTDATA",
    t: 2,
    d: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    a: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    m: [2, 254],
    p: [{
      name: "value_name",
      detail: "The name of the value in the pivot table for which you want to get data.",
      example: '"SUM of number of units"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "any_pivot_table_cell",
      detail: "Any reference to a cell in the desired pivot table (top corner recommended).",
      example: "'Pivot table'!A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "original_column",
      detail: "The name of the column in the original data set (not the pivot table).",
      example: '"division"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }, {
      name: "pivot_item",
      detail: "The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",
      example: '"east"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CHOOSE",
    t: 2,
    d: "Returns an element from a list of choices based on index.",
    a: "An element from a list of choices based on index.",
    m: [2, 255],
    p: [{
      name: "index",
      detail: "Which choice (of the up to 30 provided) to return.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "choice1",
      detail: "A potential value to return. Required. May be a reference to a cell or an individual value.",
      example: '"A"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "choice2",
      detail: "Additional values among which to choose.",
      example: '"B"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "HYPERLINK",
    t: 2,
    d: "Creates a hyperlink inside a cell.",
    a: "Creates a hyperlink inside a cell.",
    p: [{
      name: "url",
      detail: "The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",
      example: '"http://www.luckysheet.com/"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "link_label",
      detail: "The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",
      example: '"luckysheet"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TIME",
    t: 6,
    d: "Converts a provided hour, minute, and second into a time.",
    a: "Converts hour/minute/second into a time.",
    m: [3, 3],
    p: [{
      name: "hour",
      detail: "The hour component of the time.",
      example: "11",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "minute",
      detail: "The minute component of the time.",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "second",
      detail: "The second component of the time.",
      example: "59",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TIMEVALUE",
    t: 6,
    d: "Returns the fraction of a 24-hour day the time represents.",
    a: "Converts a time string into its serial number representation.",
    m: [1, 1],
    p: [{
      name: "time_string",
      detail: "The string that holds the time representation.",
      example: '"2:15 PM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EOMONTH",
    t: 6,
    d: "Returns a date on the last day of a month that falls a specified number of months before or after another date.",
    a: "Last day of a month before or after a date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to consider.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EDATE",
    t: 6,
    d: "Returns a date a specified number of months before or after another date.",
    a: "Date a number of months before/after another date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to calculate.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SECOND",
    t: 6,
    d: "Returns the second component of a specific time, in numeric format.",
    a: "Second component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the second component",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINUTE",
    t: 6,
    d: "Returns the minute component of a specific time, in numeric format.",
    a: "Minute component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the minute component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HOUR",
    t: 6,
    d: "Returns the hour component of a specific time, in numeric format.",
    a: "Hour component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the hour component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOW",
    t: 6,
    d: "Returns the current date and time as a date value.",
    a: "Current date and time as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "NETWORKDAYS",
    t: 6,
    d: "Returns the number of net working days between two provided days.",
    a: "Net working days between two provided days.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the date serial numbers to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NETWORKDAYS_INTL",
    t: 6,
    d: "Returns the number of net working days between two provided days excluding specified weekend days and holidays.",
    a: "Net working days between two dates (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider as holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISOWEEKNUM",
    t: 6,
    d: "Returns a number representing the ISO week of the year where the provided date falls.",
    a: "ISO week number of the year.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WEEKNUM",
    t: 6,
    d: "Returns a number representing the week of the year where the provided date falls.",
    a: "Week number of the year.",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number representing the day that a week starts on. Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "WEEKDAY",
    t: 6,
    d: "Returns a number representing the day of the week of the date provided.",
    a: "Day of the week of the date provided (as number).",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DAY",
    t: 6,
    d: "Returns the day of the month that a specific date falls on, in numeric format.",
    a: "Day of the month that a specific date falls on.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the day.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS",
    t: 6,
    d: "Returns the number of days between two dates.",
    a: "Number of days between two dates.",
    m: [2, 2],
    p: [{
      name: "end_date",
      detail: "The end of the date range.",
      example: "2011-3-15",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_date",
      detail: "The start of the date range.",
      example: "2011-2-1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS360",
    t: 6,
    d: "Returns the difference between two days based on the 360 day year used in some financial interest calculations.",
    a: "Days between two dates on a 360-day year.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "method",
      detail: "An indicator of what day count method to use.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATE",
    t: 6,
    d: "Converts a provided year, month, and day into a date.",
    a: "Converts year/month/day into a date.",
    m: [3, 3],
    p: [{
      name: "year",
      detail: "The year component of the date.",
      example: "1969",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The month component of the date.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day",
      detail: "The day component of the date.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATEVALUE",
    t: 6,
    d: "Converts a provided date string in a known format to a date value.",
    a: "Converts a date string to a date value.",
    m: [1, 1],
    p: [{
      name: "date_string",
      detail: "The string representing the date.",
      example: '"1969-7-20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATEDIF",
    t: 6,
    d: "Calculates the number of days, months, or years between two dates.",
    a: "Date Difference.",
    m: [3, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "unit",
      detail: 'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',
      example: "16)",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY",
    t: 6,
    d: "Calculates the date after a number of working days from a specified start date.",
    a: "Number of working days from start date.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY_INTL",
    t: 6,
    d: "Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",
    a: "Date after a number of workdays (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEAR",
    t: 6,
    d: "Returns the year specified by a given date.",
    a: "Year specified by a given date.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the year.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEARFRAC",
    t: 6,
    d: "Returns the number of years, including fractional years, between two dates using a specified day count convention.",
    a: "Exact number of years between two dates.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TODAY",
    t: 6,
    d: "Returns the current date as a date value.",
    a: "Current date as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "MONTH",
    t: 6,
    d: "Returns the month of the year a specific date falls in, in numeric format.",
    a: "Month of the year a specific date falls in.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the month.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EFFECT",
    t: 8,
    d: "Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",
    a: "Annual effective interest rate.",
    m: [2, 2],
    p: [{
      name: "nominal_rate",
      detail: "The nominal interest rate per year.",
      example: "0.99",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLAR",
    t: 12,
    d: "Formats a number into the currency specific to your spreadsheet locale.",
    a: "Formats a number as currency specific to your spreadsheet locale.",
    m: [1, 2],
    p: [{
      name: "number",
      detail: "The value to be formatted.",
      example: "1.2351",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARDE",
    t: 8,
    d: "Converts a price quotation given as a decimal fraction into a decimal value.",
    a: "Converts a decimal fraction to decimal value.",
    m: [2, 2],
    p: [{
      name: "fractional_price",
      detail: "The price quotation given using fractional decimal conventions.",
      example: "100.10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARFR",
    t: 8,
    d: "Converts a price quotation given as a decimal value into a decimal fraction.",
    a: "Converts a decimal value to decimal fraction.",
    m: [2, 2],
    p: [{
      name: "decimal_price",
      detail: "The price quotation given as a decimal value.",
      example: "100.125",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",
    a: "Depreciation via declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The number of months in the first year of depreciation.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DDB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the double-declining balance method.",
    a: "Depreciation via double-declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The factor by which depreciation decreases.",
      example: "2.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RATE",
    t: 8,
    d: "Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",
    a: "Interest rate of an annuity investment.",
    m: [3, 6],
    p: [{
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_per_period",
      detail: "The amount per period to be paid.",
      example: "-100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the interest rate will be.",
      example: "0.1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CUMPRINC",
    t: 8,
    d: "Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative principal paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNUM",
    t: 8,
    d: "Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",
    a: "Number of coupons between settlement and maturity.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "02",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SYD",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the sum of years digits method.",
    a: "Depreciation via sum of years digits method.",
    m: [4, 4],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLEQ",
    t: 8,
    d: "Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",
    a: "Equivalent rate of return for a Treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "2)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLYIELD",
    t: 8,
    d: "Calculates the yield of a US Treasury Bill based on price.",
    a: "The yield of a us treasury bill based on price.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLPRICE",
    t: 8,
    d: "Calculates the price of a US Treasury Bill based on discount rate.",
    a: "Price of US treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PV",
    t: 8,
    d: "Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Present value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACCRINT",
    t: 8,
    d: "Calculates the accrued interest of a security that has periodic payments.",
    a: "Accrued interest of security with periodic payments.",
    m: [6, 8],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "first_payment",
      detail: "The first date interest will be paid.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calc_method",
      detail: "[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ACCRINTM",
    t: 8,
    d: "Calculates the accrued interest of a security that pays interest at maturity.",
    a: "Accrued interest of security paying at maturity.",
    m: [4, 5],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity date of the security.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "1000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYBS",
    t: 8,
    d: "Calculates the number of days from the first coupon, or interest payment, until settlement.",
    a: "Number of days from first coupon to settlement.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYS",
    t: 8,
    d: "Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",
    a: "Days in coupon period containing settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYSNC",
    t: 8,
    d: "Calculates the number of days from the settlement date until the next coupon, or interest payment.",
    a: "Days from settlement until next coupon.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNCD",
    t: 8,
    d: "Calculates next coupon, or interest payment, date after the settlement date.",
    a: "Next coupon date after the settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPPCD",
    t: 8,
    d: "Calculates last coupon, or interest payment, date before the settlement date.",
    a: "Last coupon date before settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FV",
    t: 8,
    d: "Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Future value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FVSCHEDULE",
    t: 8,
    d: "Calculates the future value of some principal based on a specified series of potentially varying interest rates.",
    a: "Future value of principal from series of rates.",
    m: [2, 2],
    p: [{
      name: "principal",
      detail: "The amount of initial capital or value to compound against.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_schedule",
      detail: "A series of interest rates to compound against the `principal`.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "YIELD",
    t: 8,
    d: "Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",
    a: "Annual yield of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "YIELDDISC",
    t: 8,
    d: "Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",
    a: "Annual yield of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NOMINAL",
    t: 8,
    d: "Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",
    a: "Annual nominal interest rate.",
    m: [2, 2],
    p: [{
      name: "effective_rate",
      detail: "The effective interest rate per year.",
      example: "0.85",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "XIRR",
    t: 8,
    d: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    a: "Internal rate of return given non-periodic cashflows.",
    m: [2, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "250",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MIRR",
    t: 8,
    d: "Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",
    a: "Modified internal rate of return.",
    m: [3, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "financing_rate",
      detail: "The interest rate paid on funds invested.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "reinvestment_return_rate",
      detail: "The return (as a percentage) earned on reinvestment of income received from the investment.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IRR",
    t: 8,
    d: "Calculates the internal rate of return on an investment based on a series of periodic cash flows.",
    a: "Internal rate of return given periodic cashflows.",
    m: [1, 2],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "200",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",
    a: "The net present value of an investment based on a series of periodic cash flows and a discount rate.",
    m: [2, 255],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow1",
      detail: "The first future cash flow.",
      example: "200",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "cashflow2",
      detail: "Additional future cash flows.",
      example: "250",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "XNPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",
    a: "Net present value given non-periodic cashflows.",
    m: [3, 3],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow_amounts",
      detail: "A range of cells containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CUMIPMT",
    t: 8,
    d: "Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative interest paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PMT",
    t: 8,
    d: "Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Periodic payment for an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: " 100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IPMT",
    t: 8,
    d: "Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on interest for an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "80000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "E2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PPMT",
    t: 8,
    d: "Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on the principal of an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "3*12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INTRATE",
    t: 8,
    d: "Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",
    a: "Calculates effective interest rate.",
    m: [4, 5],
    p: [{
      name: "buy_date",
      detail: "The date of purchase of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sell_date",
      detail: "The date of sale of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "buy_price",
      detail: "The price at which the investment was purchased.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sell_price",
      detail: "The price at which the investment was sold.",
      example: "101200",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICE",
    t: 8,
    d: "Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Price of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.065",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEDISC",
    t: 8,
    d: "Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",
    a: "Price of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the security at time of purchase.",
      example: "0.0525",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEMAT",
    t: 8,
    d: "Calculates the price of a security paying interest at maturity, based on expected yield.",
    a: "Price of security paying interest at maturity.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RECEIVED",
    t: 8,
    d: "Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",
    a: "Amount received at maturity for a security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "The amount invested (irrespective of face value of each security).",
      example: "10000000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "discount",
      detail: "The discount rate of the security invested in.",
      example: "0.0575",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DISC",
    t: 8,
    d: "Calculates the discount rate of a security based on price.",
    a: "The discount rate of a security based on price.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "97.975",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPER",
    t: 8,
    d: "Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Number of payment periods for an investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount of each payment made.",
      example: "500",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "40000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLN",
    t: 8,
    d: "Calculates the depreciation of an asset for one period using the straight-line method.",
    a: "Depreciation of asset using the straight-line method.",
    m: [3, 3],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "300000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "75000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DURATION",
    t: 8,
    d: "Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",
    a: "Number of periods for an investment to reach a value.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MDURATION",
    t: 8,
    d: "Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Modified Macaulay duration.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2DEC",
    t: 9,
    d: "Converts a signed binary number to decimal format.",
    a: "Converts a signed binary number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to decimal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIN2HEX",
    t: 9,
    d: "Converts a signed binary number to signed hexadecimal format.",
    a: "Converts a binary number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2OCT",
    t: 9,
    d: "Converts a signed binary number to signed octal format.",
    a: "Converts a binary number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed octal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2BIN",
    t: 9,
    d: "Converts a decimal number to signed binary format.",
    a: "Converts a decimal number to signed binary format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed binary, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2HEX",
    t: 9,
    d: "Converts a decimal number to signed hexadecimal format.",
    a: "Converts a decimal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed hexadecimal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2OCT",
    t: 9,
    d: "Converts a decimal number to signed octal format.",
    a: "Converts a decimal number to signed octal format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed octal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2BIN",
    t: 9,
    d: "Converts a signed hexadecimal number to signed binary format.",
    a: "Converts a hexadecimal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2DEC",
    t: 9,
    d: "Converts a signed hexadecimal number to decimal format.",
    a: "Converts a hexadecimal number to decimal.",
    m: [1, 1],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HEX2OCT",
    t: 9,
    d: "Converts a signed hexadecimal number to signed octal format.",
    a: "Converts a hexadecimal number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2BIN",
    t: 9,
    d: "Converts a signed octal number to signed binary format.",
    a: "Converts an octal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed binary, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2DEC",
    t: 9,
    d: "Converts a signed octal number to decimal format.",
    a: "Converts a signed octal number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to decimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OCT2HEX",
    t: 9,
    d: "Converts a signed octal number to signed hexadecimal format.",
    a: "Converts an octal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COMPLEX",
    t: 9,
    d: "Creates a complex number given real and imaginary coefficients.",
    a: "Creates a complex number.",
    m: [2, 3],
    p: [{
      name: "real_part",
      detail: "The real coefficient.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "imaginary_part",
      detail: "The imaginary coefficient.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suffix",
      detail: "The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",
      example: '"j"',
      require: "o",
      repeat: "n",
      type: "rangestring"
    }]
  }, {
    n: "IMREAL",
    t: 9,
    d: "Returns the real coefficient of a complex number.",
    a: "The real coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMAGINARY",
    t: 9,
    d: "Returns the imaginary coefficient of a complex number.",
    a: "The imaginary coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMCONJUGATE",
    t: 9,
    d: "Returns the complex conjugate of a number.",
    a: "The complex conjugate of a number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the conjugate for.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMABS",
    t: 9,
    d: "Returns absolute value (or modulus) of a complex number.",
    a: "The absolute value of a complex number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the absolute value of.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DELTA",
    t: 9,
    d: "Compare two numeric values, returning 1 if they're equal.",
    a: "Compare two numeric values.",
    m: [1, 2],
    p: [{
      name: "number1",
      detail: "The first number to compare.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number2",
      detail: "The second number to compare.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IMSUM",
    t: 9,
    d: "Returns the sum of a series of complex numbers.",
    a: "Sum of a series of complex numbers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first complex number or range to add together.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional complex numbers or ranges to add to `value1`.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMSUB",
    t: 9,
    d: "Returns the difference between two complex numbers.",
    a: "The difference between two complex numbers.",
    m: [2, 2],
    p: [{
      name: "first_number",
      detail: "The complex number to subtract second_number from.",
      example: '"6+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "second_number",
      detail: "The complex number to subtract from first_number.",
      example: '"2+3i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMPRODUCT",
    t: 9,
    d: "Returns the result of multiplying a series of complex numbers together.",
    a: "Result of multiplying a series of complex numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "factor2",
      detail: "Additional complex numbers or ranges to calculate for the product.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMDIV",
    t: 9,
    d: "Returns one complex number divided by another.",
    a: "One complex number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The complex number to be divided.",
      example: '"11+16i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "divisor",
      detail: "The complex number to divide by.",
      example: '"3+2i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOT",
    t: 10,
    d: "Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",
    a: "Returns opposite of provided logical value.",
    m: [1, 1],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell holding an expression that represents some logical value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRUE",
    t: 10,
    d: "Returns the logical value `TRUE`.",
    a: "Logical value `true`.",
    m: [0, 0],
    p: []
  }, {
    n: "FALSE",
    t: 10,
    d: "Returns the logical value `FALSE`.",
    a: "Logical value `false`.",
    m: [0, 0],
    p: []
  }, {
    n: "AND",
    t: 10,
    d: "Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",
    a: "Logical `and` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that represent logical values.",
      example: 'A3 = "bar"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IFERROR",
    t: 10,
    d: "Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",
    a: "Value if it is not an error, otherwise 2nd argument.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to return if `value` itself is not an error.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_error",
      detail: "The value the function returns if `value` is an error.",
      example: '"Error in cell A1"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IF",
    t: 10,
    d: "Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",
    a: "Returns value depending on logical expression.",
    m: [2, 3],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_true",
      detail: "The value the function returns if `logical_expression` is `TRUE`.",
      example: '"A2 is foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_false",
      detail: "The value the function returns if `logical_expression` is `FALSE`.",
      example: '"A2 was false"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OR",
    t: 10,
    d: "Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",
    a: "Logical `or` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that evaluate to logical values.",
      example: ' A3 = "bar"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NE",
    t: 11,
    d: "Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",
    a: "Not equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for inequality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EQ",
    t: 11,
    d: "Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",
    a: "Equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for equality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",
    a: "Strictly greater than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",
    a: "Greater than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",
    a: "Less than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",
    a: "Less than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADD",
    t: 11,
    d: "Returns the sum of two numbers. Equivalent to the `+` operator.",
    a: "Sum of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first addend.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The second addend.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINUS",
    t: 11,
    d: "Returns the difference of two numbers. Equivalent to the `-` operator.",
    a: "Difference of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The minuend, or number to be subtracted from.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The subtrahend, or number to subtract from `value1`.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTIPLY",
    t: 11,
    d: "Returns the product of two numbers. Equivalent to the `*` operator.",
    a: "Product of two numbers",
    m: [2, 2],
    p: [{
      name: "factor1",
      detail: "The first multiplicand.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "The second multiplicand.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DIVIDE",
    t: 11,
    d: "Returns one number divided by another. Equivalent to the `/` operator.",
    a: "One number divided by another",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCAT",
    t: 11,
    d: "Returns the concatenation of two values. Equivalent to the `&` operator.",
    a: "Concatenation of two values",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to which `value2` will be appended.",
      example: '"de"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to append to `value1`.",
      example: '"mystify"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNARY_PERCENT",
    t: 11,
    d: "Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",
    a: "Value interpreted as a percentage.",
    m: [1, 1],
    p: [{
      name: "percentage",
      detail: "The value to interpret as a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCATENATE",
    t: 12,
    d: "Appends strings to one another.",
    a: "Appends strings to one another.",
    m: [1, 255],
    p: [{
      name: "string1",
      detail: "The initial string.",
      example: '"Super"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "More strings to append in sequence.",
      example: '"calla"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CODE",
    t: 12,
    d: "Returns the numeric Unicode map value of the first character in the string provided.",
    a: "Numeric unicode map value of character.",
    m: [1, 1],
    p: [{
      name: "string",
      detail: "The string whose first character's Unicode map value will be returned.",
      example: '"a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CHAR",
    t: 12,
    d: "Convert a number into a character according to the current Unicode table.",
    a: "Gets character associated with number.",
    m: [1, 1],
    p: [{
      name: "table_number",
      detail: "The number of the character to look up from the current Unicode table in decimal format.",
      example: "97",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ARABIC",
    t: 12,
    d: "Computes the value of a Roman numeral.",
    a: "Computes the value of a roman numeral.",
    m: [1, 1],
    p: [{
      name: "roman_numeral",
      detail: "The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",
      example: '"XIV"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROMAN",
    t: 12,
    d: "Formats a number in Roman numerals.",
    a: "Formats a number in Roman numerals.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The number to format, between 1 and 3999, inclusive.",
      example: "499",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "REGEXEXTRACT",
    t: 12,
    d: "Extracts matching substrings according to a regular expression.",
    a: "Extracts matching substrings with regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The input text.",
      example: '"Needle in a haystack"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The first part of `text` that matches this expression will be returned.",
      example: '".e{2}dle"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXMATCH",
    t: 12,
    d: "Whether a piece of text matches a regular expression.",
    a: "Whether a piece of text matches regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The text to be tested against the regular expression.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression to test the text against.",
      example: '"S.r"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXREPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string using regular expressions.",
    a: "Replaces text with regular expressions.",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression.  All matching instances in `text` will be replaced.",
      example: '"S.*d"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replacement",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T",
    t: 12,
    d: "Returns string arguments as text, or the empty string if the value is not text.",
    a: "String arguments as text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIXED",
    t: 12,
    d: "Formats a number with a fixed number of decimal places.",
    a: "Formats number with fixed number of decimal places.",
    m: [1, 3],
    p: [{
      name: "number",
      detail: "The number to format.",
      example: "3.141592653",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display in the result.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suppress_separator",
      detail: "Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIND",
    t: 12,
    d: "Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, case-sensitive.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FINDB",
    t: 12,
    d: "Returns the position at which a string is first found within text counting each double-character as 2.",
    a: "Position at which a string is first found within text (binary).",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"new"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: '"new year"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "JOIN",
    t: 12,
    d: "Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",
    a: "Concatenates elements of arrays with delimiter.",
    m: [2, 255],
    p: [{
      name: "delimiter",
      detail: "The character or string to place between each concatenated value.",
      example: '" and-a "',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array1",
      detail: "The value or values to be appended using `delimiter`.",
      example: "{1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array2",
      detail: "More values to be appended using `delimiter`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LEFT",
    t: 12,
    d: "Returns a substring from the beginning of a specified string.",
    a: "Substring from beginning of specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the left portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the left side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RIGHT",
    t: 12,
    d: "Returns a substring from the end of a specified string.",
    a: "A substring from the end of a specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the right portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the right side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MID",
    t: 12,
    d: "Returns a segment of a string.",
    a: "A segment of a string.",
    m: [3, 3],
    p: [{
      name: "string",
      detail: "The string to extract a segment from.",
      example: '"get this"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "extract_length",
      detail: "The length of the segment to extract.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LEN",
    t: 12,
    d: "Returns the length of a string.",
    a: "Length of a string.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LENB",
    t: 12,
    d: "Returns the length of a string in bytes.",
    a: "Length of a string in bytes.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOWER",
    t: 12,
    d: "Converts a specified string to lowercase.",
    a: "Converts a specified string to lowercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to lowercase.",
      example: '"LOREM IPSUM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UPPER",
    t: 12,
    d: "Converts a specified string to uppercase.",
    a: "Converts a specified string to uppercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to uppercase.",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EXACT",
    t: 12,
    d: "Tests whether two strings are identical.",
    a: "Tests whether two strings are identical.",
    m: [2, 2],
    p: [{
      name: "string1",
      detail: "The first string to compare",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "The second string to compare",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string.",
    a: "Replaces part of a text string with different text.",
    m: [4, 4],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "position",
      detail: "The position where the replacement will begin (starting from 1).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "length",
      detail: "The number of characters in the text to be replaced.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_text",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPT",
    t: 12,
    d: "Returns specified text repeated a number of times.",
    a: "Specified text repeated a number of times.",
    m: [2, 2],
    p: [{
      name: "text_to_repeat",
      detail: "The character or string to repeat.",
      example: '"ha"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_repetitions",
      detail: "The number of times `text_to_repeat` should appear in the value returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEARCH",
    t: 12,
    d: "Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, ignoring case.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUBSTITUTE",
    t: 12,
    d: "Replaces existing text with new text in a string.",
    a: "Replaces existing text with new text in a string.",
    m: [3, 4],
    p: [{
      name: "text_to_search",
      detail: "The text within which to search and replace.",
      example: '"search for it"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_for",
      detail: "The string to search for within `text_to_search`.",
      example: '"search for"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replace_with",
      detail: "The string that will replace `search_for`.",
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurrence_number",
      detail: "The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CLEAN",
    t: 12,
    d: "Returns the text with the non-printable ASCII characters removed.",
    a: "Removes non-printable characters from a piece of text.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text whose non-printable characters are to be removed.",
      example: '"AF"&CHAR(31)',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TEXT",
    t: 12,
    d: "Converts a number into text according to a specified format.",
    a: "Formats a number into text.",
    m: [2, 2],
    p: [{
      name: "number",
      detail: "The number, date, or time to format.",
      example: "1.23",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "format",
      detail: "The pattern by which to format the number, enclosed in quotation marks.",
      example: '"$0.00"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRIM",
    t: 12,
    d: "Removes leading, trailing, and repeated spaces in text.",
    a: "Removes space characters.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text or reference to a cell containing text to be trimmed.",
      example: '" lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "VALUE",
    t: 12,
    d: "Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",
    a: "Converts a date/time/number string into a number.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string containing the value to be converted.",
      example: '"123"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROPER",
    t: 12,
    d: "Capitalizes each word in a specified string.",
    a: "Capitalizes each word in a specified string.",
    m: [1, 1],
    p: [{
      name: "text_to_capitalize",
      detail: "The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",
      example: '"united states"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CONVERT",
    t: 13,
    d: "Converts a numeric value to a different unit of measure.",
    a: "Unit conversion for numbers.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The numeric value in `start_unit` to convert to `end_unit`.",
      example: "5.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_unit",
      detail: "The starting unit, the unit currently assigned to `value`.",
      example: '"g"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_unit",
      detail: "The unit of measure into which to convert the argument, `value`.",
      example: '"kg"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "SUMX2MY2",
    t: 14,
    d: "Calculates the sum of the differences of the squares of values in two arrays.",
    a: "Sum of the differences of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMX2PY2",
    t: 14,
    d: "Calculates the sum of the sums of the squares of values in two arrays.",
    a: "Sum of the sums of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMXMY2",
    t: 14,
    d: "Calculates the sum of the squares of differences of values in two arrays.",
    a: "Sum of the squares of differences.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRANSPOSE",
    t: 14,
    d: "Transposes the rows and columns of an array or range of cells.",
    a: "Transposes the rows and columns of an array.",
    m: [1, 1],
    p: [{
      name: "array_or_range",
      detail: "The array or range whose rows and columns will be swapped.",
      example: "{1,2}",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TREND",
    t: 14,
    d: "Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",
    a: "Fits points to linear trend derived via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FREQUENCY",
    t: 14,
    d: "Calculates the frequency distribution of a one-column array into specified classes.",
    a: "The frequency distribution of array.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the values to be counted.",
      example: "A2:A40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "classes",
      detail: "The array or range containing the set of classes.",
      example: "B2:B5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GROWTH",
    t: 14,
    d: "Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",
    a: "Fits points to exponential growth trend.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINEST",
    t: 14,
    d: "Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",
    a: "Best-fit linear trend via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calculate_b",
      detail: "Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOGEST",
    t: 14,
    d: "Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",
    a: "Best-fit exponential growth curve.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MDETERM",
    t: 14,
    d: "Returns the matrix determinant of a square matrix specified as an array or range.",
    a: "Matrix determinant of a square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINVERSE",
    t: 14,
    d: "Returns the multiplicative inverse of a square matrix specified as an array or range.",
    a: "Multiplicative inverse of square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MMULT",
    t: 14,
    d: "Calculates the matrix product of two matrices specified as arrays or ranges.",
    a: "The matrix product of two matrices.",
    m: [2, 2],
    p: [{
      name: "matrix1",
      detail: "The first matrix in the matrix multiplication operation, represented as an array or range.",
      example: "A1:B3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "matrix2",
      detail: "The second matrix in the matrix multiplication operation, represented as an array or range.",
      example: "C1:F2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMPRODUCT",
    t: 14,
    d: "Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",
    a: "Sum of products of elements in two arrays.",
    m: [1, 255],
    p: [{
      name: "array1",
      detail: "The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",
      example: "A2:C5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",
      example: "D2:F5",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "ISFORMULA",
    t: 15,
    d: "Checks whether a value is a formula.",
    a: "Whether a value is a formula.",
    m: [1, 1],
    p: [{
      name: "cell",
      detail: "The cell to be verified as containing a formula.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CELL",
    t: 15,
    d: "Returns the requested information about the specified cell.",
    a: "Gets information about a cell.",
    m: [2, 2],
    p: [{
      name: "info_type",
      detail: "The type of information requested (see article for available types)",
      example: '"type"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "reference",
      detail: "The reference to the cell.",
      example: "C2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "NA",
    t: 15,
    d: 'Returns the "value not available" error, `#N/A`.',
    a: "The `#N/A` error.",
    m: [0, 0],
    p: []
  }, {
    n: "ERROR_TYPE",
    t: 15,
    d: "Returns a number corresponding to the error value in a different cell.",
    a: "Error value of cell (as number).",
    m: [1, 1],
    p: [{
      name: "reference",
      detail: "The cell to find the error number for although you can also provide the error value directly.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISBLANK",
    t: 15,
    d: "Checks whether the referenced cell is empty.",
    a: "Whether the referenced cell is empty.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Reference to the cell that will be checked for emptiness.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISERR",
    t: 15,
    d: "Checks whether a value is an error other than `#N/A`.",
    a: "Whether a value is an error other than `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type other than `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISERROR",
    t: 15,
    d: "Checks whether a value is an error.",
    a: "Whether a value is an error.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISLOGICAL",
    t: 15,
    d: "Checks whether a value is `TRUE` or `FALSE`.",
    a: "Whether a value is `true` or `false`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a logical `TRUE` or `FALSE`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNA",
    t: 15,
    d: "Checks whether a value is the error `#N/A`.",
    a: "Whether a value is the error `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be compared with the error value `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNONTEXT",
    t: 15,
    d: "Checks whether a value is non-textual.",
    a: "Whether a value is non-textual.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be checked.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNUMBER",
    t: 15,
    d: "Checks whether a value is a number.",
    a: "Whether a value is a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISREF",
    t: 15,
    d: "Checks whether a value is a valid cell reference.",
    a: "Whether a value is a valid cell reference.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a cell reference.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISTEXT",
    t: 15,
    d: "Checks whether a value is text.",
    a: "Whether a value is text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TYPE",
    t: 15,
    d: "Returns a number associated with the type of data passed into the function.",
    a: "Get the type of a value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose type is to be determined.",
      example: "C4",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "N",
    t: 15,
    d: "Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",
    a: "Argument provided as a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DATE",
    t: 16,
    d: "Converts a provided number to a date.",
    a: "Converts a provided number to a date.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a date.",
      example: "25405",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PURE_NUMBER",
    t: 16,
    d: "Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",
    a: "Converts any numeric value to a pure number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a pure number.",
      example: "50%",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_TEXT",
    t: 16,
    d: "Converts a provided numeric value to a text value.",
    a: "Converts a provided numeric value to a text value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to text.",
      example: "24",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DOLLARS",
    t: 16,
    d: "Converts a provided number to a dollar value.",
    a: "Converts a provided number to a dollar value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a dollar value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PERCENT",
    t: 16,
    d: "Converts a provided number to a percentage.",
    a: "Converts a provided number to a percentage.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DGET",
    t: 17,
    d: "Returns a single value from a database table-like array or range using a SQL-like query.",
    a: "Single value from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMAX",
    t: 17,
    d: "Returns the maximum value selected from a database table-like array or range using a SQL-like query.",
    a: "Maximum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMIN",
    t: 17,
    d: "Returns the minimum value selected from a database table-like array or range using a SQL-like query.",
    a: "Minimum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DAVERAGE",
    t: 17,
    d: "Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",
    a: "Average of a set of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNT",
    t: 17,
    d: "Counts numeric values selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNTA",
    t: 17,
    d: "Counts values, including text, selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values and text from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DPRODUCT",
    t: 17,
    d: "Returns the product of values selected from a database table-like array or range using a SQL-like query.",
    a: "Product of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEV",
    t: 17,
    d: "Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of population sample from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEVP",
    t: 17,
    d: "Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of entire population from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSUM",
    t: 17,
    d: "Returns the sum of values selected from a database table-like array or range using a SQL-like query.",
    a: "Sum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVAR",
    t: 17,
    d: "Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of population sample from table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVARP",
    t: 17,
    d: "Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of a population from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "AGE_BY_IDCARD",
    t: "3",
    d: "Calculate the age based on the Chinese ID number. Support 15 or 18",
    a: "Get age based on ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: "A1",
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Deadline",
      example: '"2017-10-01"',
      detail: "The deadline or range of age calculation. The default is the current day.",
      require: "o",
      repeat: "n",
      type: "rangedatetime"
    }]
  }, {
    n: "SEX_BY_IDCARD",
    t: "3",
    d: "Calculate gender based on Chinese ID number. Support 15 or 18",
    a: "Get gender based on ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIRTHDAY_BY_IDCARD",
    t: "3",
    d: "Calculate the birthday based on the Chinese ID number. Support 15 or 18",
    a: "Get the birthday based on the ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Birthday format",
      example: "0",
      detail: "Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROVINCE_BY_IDCARD",
    t: "3",
    d: "Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the province of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CITY_BY_IDCARD",
    t: "3",
    d: "Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the city of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "STAR_BY_IDCARD",
    t: "3",
    d: "Calculate the constellation based on the Chinese ID number. Support 15 or 18",
    a: "Get the constellation based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ANIMAL_BY_IDCARD",
    t: "3",
    d: "Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",
    a: "Get the zodiac according to the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISIDCARD",
    t: "3",
    d: "Verify that the format of the ID card is correct. Support 15 or 18",
    a: "Verify the correctness of the ID card format.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DM_TEXT_CUTWORD",
    t: "4",
    d: "Text segmentation. Split a series of words into a series of individual words",
    a: "Chinese text segmentation.",
    m: [1, 2],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Word segmentation mode",
      example: "0",
      detail: "The default is 0[precision mode], 1[full mode], 2[search engine mode].",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TFIDF",
    t: "4",
    d: "Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",
    a: "tf-idf keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TEXTRANK",
    t: "4",
    d: "Use TextRank algorithm to extract keywords. Identify keywords from a series of text",
    a: "TextRank keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_CLOSE",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock closing price of A shares.",
    a: "Returns the closing price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_OPEN",
    t: "5",
    d: "According to the stock code and date, return the opening price of stock.",
    a: "Return the opening price of a shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MAX",
    t: "5",
    d: "According to the stock code and date, return the highest price of stock.",
    a: "Return the highest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MIN",
    t: "5",
    d: "According to the stock code and date, return the lowest price of stock.",
    a: "Returns the lowest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_VOLUMN",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock trading volume of A shares.",
    a: "Returns the corresponding stock trading volume of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_AMOUNT",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock turnover of A shares.",
    a: "Returns the corresponding stock turnover of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISDATE",
    t: "6",
    d: "Returns whether a value is a date.",
    a: "Whether a value is a date.",
    m: [1, 1],
    p: [{
      name: "value",
      example: '"1990-01-01"',
      detail: "The value to be verified as a date.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell to describe the continuous trend of data",
    a: "Generate sparklines line chart",
    m: [1, 8],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Maximum mark",
      example: "#fc5c5c",
      detail: "Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Minimum mark",
      example: "#fc5c5c",
      detail: "Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Mark size",
      example: "1.5",
      detail: "The maximum and minimum mark size settings, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AREASPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",
    a: "Generate sparklines area chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Fill color",
      example: "#CCF3F4",
      detail: "Form an area chart, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",
    a: "Generate sparklines vertical histogram",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKCOLUMNSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative vertical histogram",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BARSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the size of discrete data",
    a: "Generate sparklines horizontal bar graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKBARSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative horizontal bar graph",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "DISCRETESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",
    a: "Generate sparklines discrete graph",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Segmentation threshold",
      example: "1",
      detail: "Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Above threshold color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Below threshold color",
      example: "#fc5c5c",
      detail: "The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRISTATESPLINES",
    t: "3",
    d: "Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",
    a: "Generate sparklines three-state graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Zero value bar color",
      example: "#999",
      detail: "Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PIESPLINES",
    t: "3",
    d: "Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",
    a: "Generate sparklines pie chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Rotation angle",
      example: "0",
      detail: "The rotation angle of the pie chart, the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "border",
      example: "0",
      detail: "Pie chart border size, default is none 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Border color",
      example: "#000",
      detail: "The border color of the pie chart, the default is #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BOXSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",
    a: "Generate sparklines box plot",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Outlier ratio",
      example: "1.5",
      detail: "The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Target value",
      example: "10",
      detail: "The target value setting on the box plot, the default is false and does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Point size",
      example: "1.5",
      detail: "The radius of the target point and outlier is set, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BULLETSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the task achievement rate",
    a: "Generating sparklines bullets",
    m: [2, 3],
    p: [{
      name: "Target",
      example: "10",
      detail: "The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "achieved",
      example: "8",
      detail: "Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Contrast",
      example: "12",
      detail: "Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMPOSESPLINES",
    t: "3",
    d: "Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",
    a: "Combine sparklines graphs into one cell",
    m: [1, 1],
    p: [{
      name: "config",
      example: "PIESPLINES(A1:A20)",
      detail: "Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",
      require: "m",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SORT",
    t: "14",
    d: "Sorts the rows of a given array or range by the values in one or more columns.",
    a: "Sorts rows of range by specified column.",
    m: [1, 4],
    p: [{
      name: "range",
      detail: "The data to be sorted.",
      example: "A2:A17",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column",
      detail: "The index of the column in `range` or a range outside of `range` containing the values by which to sort.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_ascending",
      detail: "`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",
      example: "-1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column2",
      detail: "Additional columns.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FILTER",
    t: "14",
    d: "Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",
    a: "Filters a range based off provided conditions.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The data to be filtered.",
      example: "A5:D20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition1",
      detail: "A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition2",
      detail: "Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",
      example: '""',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNIQUE",
    t: "14",
    d: "Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",
    a: "Unique rows in the provided source range.",
    m: [1, 3],
    p: [{
      name: "range",
      detail: "The data to filter by unique entries.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurs_once",
      detail: "[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANDARRAY",
    t: "14",
    d: "Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",
    a: "Returns a grid of random numbers.",
    m: [0, 2],
    p: [{
      name: "rows",
      detail: "The number of rows to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEQUENCE",
    t: "14",
    d: "Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",
    a: "Returns a grid of sequential numbers.",
    m: [1, 4],
    p: [{
      name: "rows",
      detail: "The number of rows in the function's resulting grid.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start",
      detail: "The number, at which to start the sequence. If omitted, the sequence will start at 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "step",
      detail: "The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVALUATE",
    t: "3",
    d: "Evaluate a formula or expression expressed in words and return the result",
    a: "Evaluate according to literal formula or expression.",
    m: [1, 1],
    p: [{
      name: "expression",
      example: '"A1+5*2^2"',
      detail: "Formula or expression",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REMOTE",
    t: "5",
    d: "Calls a function on a remote server",
    a: "Calls a function on a remote back end server/API.",
    m: [1, 1],
    p: [{
      name: "remote_expression",
      example: "SUM(A1:A10000000)",
      detail: "Formula",
      require: "m",
      repeat: "n",
      type: "string"
    }]
  }],
  toolbar: {
    toolbar: "Toolbar",
    undo: "Undo",
    redo: "Redo",
    "clear-format": "Clear Format",
    "format-painter": "Format-Painter",
    paintFormat: "Paint format",
    "currency-format": "Format as currency",
    "percentage-format": "Format as percent",
    "number-decrease": "Decrease decimal places",
    "number-increase": "Increase decimal places",
    moreFormats: "More formats",
    "border-all": "Border All",
    "merge-all": "Merge All Cell",
    font: "Font",
    "font-size": "Font size",
    bold: "Bold (Ctrl+B)",
    italic: "Italic (Ctrl+I)",
    "strike-through": "Strikethrough (Alt+Shift+5)",
    underline: "Underline",
    "font-color": "Font color",
    "align-left": "Left aligned",
    "align-center": "Horizontal Center",
    "align-right": "Right aligned",
    "align-top": "Top aligned",
    "align-mid": "Vertical Center",
    "align-bottom": "Bottom aligned",
    chooseColor: "choose color",
    resetColor: "Reset",
    customColor: "CUSTOM",
    alternatingColors: "Alternating colors",
    confirmColor: "OK",
    cancelColor: "Cancel",
    collapse: "Collapse",
    background: "Fill color",
    border: "Border",
    borderStyle: "Border style",
    "merge-cell": "Merge cells",
    chooseMergeType: "Choose merge type",
    horizontalAlign: "Horizontal align",
    verticalAlign: "Vertical align",
    alignment: "Alignment",
    textWrap: "Text wrap",
    textWrapMode: "Text wrap mode",
    textRotate: "Text rotate",
    textRotateMode: "Text rotate mode",
    freeze: "Freeze",
    sort: "Sort",
    filter: "Filter",
    sortAndFilter: "Sort and filter",
    findAndReplace: "Find and replace",
    "formula-sum": "SUM",
    autoSum: "Auto SUM",
    moreFunction: "More functions",
    conditionalFormat: "Conditional format",
    comment: "Comment",
    pivotTable: "Pivot Table",
    chart: "Chart",
    screenshot: "Screenshot",
    splitColumn: "Split text",
    insertImage: "Insert image",
    insertLink: "Insert link",
    dataVerification: "Data verification",
    protection: "Protect the sheet",
    clearText: "Clear color",
    noColorSelectedText: "No color is selected",
    toolMore: "More",
    toolLess: "Less",
    toolClose: "Close",
    toolMoreTip: "More features",
    moreOptions: "More options",
    cellFormat: "Cell format config",
    print: "Print"
  },
  alternatingColors: {
    applyRange: "Apply to range",
    selectRange: "Select a data range",
    header: "Header",
    footer: "Footer",
    errorInfo: "Cannot perform this operation on multiple selection areas, please select a single area and try again",
    textTitle: "Format style",
    custom: "CUSTOM",
    close: "close",
    selectionTextColor: "Click to select text color",
    selectionCellColor: "Click to select cell color",
    removeColor: "Remove alternating colors",
    colorShow: "color",
    currentColor: "Current",
    tipSelectRange: "Please select the range of alternating colors",
    errorNoRange: "No range is selected",
    errorExistColors: "Alternating colors already exist and cannot be edited"
  },
  button: {
    confirm: "OK",
    cancel: "Cancel",
    close: "Close",
    update: "Update",
    delete: "Delete",
    insert: "Insert",
    prevPage: "Previous",
    nextPage: "Next",
    total: "total:"
  },
  paint: {
    start: "Paint format start",
    end: "ESC",
    tipSelectRange: "Please select the range to be copied",
    tipNotMulti: "Cannot perform this operation on multiple selection ranges"
  },
  format: {
    moreCurrency: "More currency formats",
    moreDateTime: "More date and time formats",
    moreNumber: "More number formats",
    titleCurrency: "Currency formats",
    decimalPlaces: "Decimal places",
    titleDateTime: "Date and time formats",
    titleNumber: "Number formats",
    tipDecimalPlaces: "The decimal places must be between 0-9!",
    select: "Select",
    format: "format",
    currency: "currency"
  },
  info: {
    detailUpdate: "New opened",
    detailSave: "Local cache restored",
    row: "",
    column: "",
    loading: "Loading...",
    copy: "Copy",
    return: "Exit",
    rename: "Rename",
    tips: "WorkBook rename",
    noName: "Untitled spreadsheet",
    wait: "waiting for update",
    add: "Add",
    addLast: "more rows at bottom",
    backTop: "Back to the top",
    pageInfo: "Total ${total}，${totalPage} page，current ${currentPage}",
    nextPage: "Next",
    tipInputNumber: "Please enter the number",
    tipInputNumberLimit: "The increase range is limited to 1-100",
    tipRowHeightLimit: "Row height must be between 0 ~ 545",
    tipColumnWidthLimit: "The column width must be between 0 ~ 2038",
    pageInfoFull: "Total ${total}，${totalPage} page，All data displayed"
  },
  currencyDetail: [{
    name: "RMB",
    pos: "before",
    value: "¥"
  }, {
    name: "US dollar",
    pos: "before",
    value: "$"
  }, {
    name: "EUR",
    pos: "before",
    value: "€"
  }, {
    name: "GBP",
    pos: "before",
    value: "￡"
  }, {
    name: "HK",
    pos: "before",
    value: "$"
  }, {
    name: "JPY",
    pos: "before",
    value: "￥"
  }, {
    name: "Albanian Lek",
    pos: "before",
    value: "Lek"
  }, {
    name: "Algerian Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Afghani",
    pos: "after",
    value: "Af"
  }, {
    name: "Argentine Peso",
    pos: "before",
    value: "$"
  }, {
    name: "United Arab Emirates Dirham",
    pos: "before",
    value: "dh"
  }, {
    name: "Aruban Florin",
    pos: "before",
    value: "Afl"
  }, {
    name: "Omani Rial",
    pos: "before",
    value: "Rial"
  }, {
    name: "Azerbaijani manat",
    pos: "before",
    value: "?"
  }, {
    name: "Egyptian Pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Ethiopian Birr",
    pos: "before",
    value: "Birr"
  }, {
    name: "Angola Kwanza",
    pos: "before",
    value: "Kz"
  }, {
    name: "Australian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Patacas",
    pos: "before",
    value: "MOP"
  }, {
    name: "Barbados Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Papua New Guinea Kina",
    pos: "before",
    value: "PGK"
  }, {
    name: "Bahamian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Pakistan Rupee",
    pos: "before",
    value: "Rs"
  }, {
    name: "Paraguayan Guarani",
    pos: "after",
    value: "Gs"
  }, {
    name: "Bahraini Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Panamanian Balboa",
    pos: "before",
    value: "B/"
  }, {
    name: "Brazilian real",
    pos: "before",
    value: "R$"
  }, {
    name: "Belarusian ruble",
    pos: "after",
    value: "р"
  }, {
    name: "Bermudian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Bulgarian Lev",
    pos: "before",
    value: "lev"
  }, {
    name: "Iceland Krona",
    pos: "before",
    value: "kr"
  }, {
    name: "Bosnia-Herzegovina Convertible Mark",
    pos: "before",
    value: "KM"
  }, {
    name: "Polish Zloty",
    pos: "after",
    value: "z?"
  }, {
    name: "Boliviano",
    pos: "before",
    value: "Bs"
  }, {
    name: "Belize Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Botswana Pula",
    pos: "before",
    value: "P"
  }, {
    name: "Not Dannuzhamu",
    pos: "before",
    value: "Nu"
  }, {
    name: "Burundi Franc",
    pos: "before",
    value: "FBu"
  }, {
    name: "North Korean Won",
    pos: "before",
    value: "?KP"
  }, {
    name: "Danish Krone",
    pos: "after",
    value: "kr"
  }, {
    name: "East Caribbean Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Dominica Peso",
    pos: "before",
    value: "RD$"
  }, {
    name: "Russian Ruble",
    pos: "after",
    value: "?"
  }, {
    name: "Eritrean Nakfa",
    pos: "before",
    value: "Nfk"
  }, {
    name: "CFA franc",
    pos: "before",
    value: "CFA"
  }, {
    name: "Philippine Peso",
    pos: "before",
    value: "?"
  }, {
    name: "Fiji Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Cape Verde Escudo",
    pos: "before",
    value: "CVE"
  }, {
    name: "Falkland Islands Pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Gambian Dalasi",
    pos: "before",
    value: "GMD"
  }, {
    name: "Congolese franc",
    pos: "before",
    value: "FrCD"
  }, {
    name: "Colombian Peso",
    pos: "before",
    value: "$"
  }, {
    name: "Costa Rican Colon",
    pos: "before",
    value: "?"
  }, {
    name: "Cuban Peso",
    pos: "before",
    value: "$"
  }, {
    name: "Cuban convertible peso",
    pos: "before",
    value: "$"
  }, {
    name: "Guyana Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Kazakhstan Tenge",
    pos: "before",
    value: "?"
  }, {
    name: "Haitian gourde",
    pos: "before",
    value: "HTG"
  }, {
    name: "won",
    pos: "before",
    value: "?"
  }, {
    name: "Netherlands Antilles Guilder",
    pos: "before",
    value: "NAf."
  }, {
    name: "Honduras lempiras",
    pos: "before",
    value: "L"
  }, {
    name: "Djibouti Franc",
    pos: "before",
    value: "Fdj"
  }, {
    name: "Kyrgyzstan Som",
    pos: "before",
    value: "KGS"
  }, {
    name: "Guinea Franc",
    pos: "before",
    value: "FG"
  }, {
    name: "Canadian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Ghanaian Cedi",
    pos: "before",
    value: "GHS"
  }, {
    name: "Cambodian riel",
    pos: "before",
    value: "Riel"
  }, {
    name: "Czech Koruna",
    pos: "after",
    value: "K?"
  }, {
    name: "Zimbabwe Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Qatari Riyal",
    pos: "before",
    value: "Rial"
  }, {
    name: "Cayman Islands Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Comorian franc",
    pos: "before",
    value: "CF"
  }, {
    name: "Kuwaiti Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Croatian Kuna",
    pos: "before",
    value: "kn"
  }, {
    name: "Kenyan Shilling",
    pos: "before",
    value: "Ksh"
  }, {
    name: "Lesotho Loti",
    pos: "before",
    value: "LSL"
  }, {
    name: "Lao Kip",
    pos: "before",
    value: "?"
  }, {
    name: "Lebanese Pound",
    pos: "before",
    value: "L￡"
  }, {
    name: "Lithuanian litas",
    pos: "before",
    value: "Lt"
  }, {
    name: "Libyan Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Liberian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Rwanda Franc",
    pos: "before",
    value: "RF"
  }, {
    name: "Romanian Leu",
    pos: "before",
    value: "RON"
  }, {
    name: "Malagasy Ariary",
    pos: "before",
    value: "Ar"
  }, {
    name: "Maldivian Rufiyaa",
    pos: "before",
    value: "Rf"
  }, {
    name: "Malawi Kwacha",
    pos: "before",
    value: "MWK"
  }, {
    name: "Malaysian Ringgit",
    pos: "before",
    value: "RM"
  }, {
    name: "Macedonia wearing Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Mauritius Rupee",
    pos: "before",
    value: "MURs"
  }, {
    name: "Mauritanian Ouguiya",
    pos: "before",
    value: "MRO"
  }, {
    name: "Mongolian Tugrik",
    pos: "before",
    value: "?"
  }, {
    name: "Bangladeshi Taka",
    pos: "before",
    value: "?"
  }, {
    name: "Peruvian Nuevo Sol",
    pos: "before",
    value: "S/"
  }, {
    name: "Myanmar Kyat",
    pos: "before",
    value: "K"
  }, {
    name: "Moldovan Leu",
    pos: "before",
    value: "MDL"
  }, {
    name: "Moroccan Dirham",
    pos: "before",
    value: "dh"
  }, {
    name: "Mozambique Metical",
    pos: "before",
    value: "MTn"
  }, {
    name: "Mexican Peso",
    pos: "before",
    value: "$"
  }, {
    name: "Namibian Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "South African Rand",
    pos: "before",
    value: "R"
  }, {
    name: "South Sudanese Pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Nicaragua Cordoba",
    pos: "before",
    value: "C$"
  }, {
    name: "Nepalese Rupee",
    pos: "before",
    value: "Rs"
  }, {
    name: "Nigerian Naira",
    pos: "before",
    value: "?"
  }, {
    name: "Norwegian Krone",
    pos: "after",
    value: "kr"
  }, {
    name: "Georgian Lari",
    pos: "before",
    value: "GEL"
  }, {
    name: "Swedish Krona",
    pos: "after",
    value: "kr"
  }, {
    name: "Swiss Franc",
    pos: "before",
    value: "CHF"
  }, {
    name: "Serbian Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Sierra Leone",
    pos: "before",
    value: "SLL"
  }, {
    name: "Seychelles Rupee",
    pos: "before",
    value: "SCR"
  }, {
    name: "Saudi Riyal",
    pos: "before",
    value: "Rial"
  }, {
    name: "Sao Tome Dobra",
    pos: "before",
    value: "Db"
  }, {
    name: "Saint Helena pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Sri Lanka Rupee",
    pos: "before",
    value: "Rs"
  }, {
    name: "Swaziland Lilangeni",
    pos: "before",
    value: "SZL"
  }, {
    name: "Sudanese Pound",
    pos: "before",
    value: "SDG"
  }, {
    name: "Surinamese dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Solomon Islands Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Somali Shilling",
    pos: "before",
    value: "SOS"
  }, {
    name: "Tajikistan Somoni",
    pos: "before",
    value: "Som"
  }, {
    name: "Pacific Franc",
    pos: "after",
    value: "FCFP"
  }, {
    name: "Thai Baht",
    pos: "before",
    value: "?"
  }, {
    name: "Tanzanian Shilling",
    pos: "before",
    value: "TSh"
  }, {
    name: "Tongan Pa'anga",
    pos: "before",
    value: "T$"
  }, {
    name: "Trinidad and Tobago Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Tunisian Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Turkish Lira",
    pos: "before",
    value: "?"
  }, {
    name: "Vanuatu Vatu",
    pos: "before",
    value: "VUV"
  }, {
    name: "Guatemalan Quetzal",
    pos: "before",
    value: "Q"
  }, {
    name: "Commission Bolivar",
    pos: "before",
    value: "Bs"
  }, {
    name: "Brunei Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Ugandan Shilling",
    pos: "before",
    value: "UGX"
  }, {
    name: "Ukrainian Hryvnia",
    pos: "before",
    value: "грн."
  }, {
    name: "Uruguayan Peso",
    pos: "before",
    value: "$"
  }, {
    name: "Uzbekistan som",
    pos: "before",
    value: "so?m"
  }, {
    name: "Western Samoa Tala",
    pos: "before",
    value: "WST"
  }, {
    name: "Singapore Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "NT",
    pos: "before",
    value: "NT$"
  }, {
    name: "New Zealand Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Hungarian Forint",
    pos: "before",
    value: "Ft"
  }, {
    name: "Syrian Pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Jamaican Dollar",
    pos: "before",
    value: "$"
  }, {
    name: "Armenian Dram",
    pos: "before",
    value: "Dram"
  }, {
    name: "Yemeni Rial",
    pos: "before",
    value: "Rial"
  }, {
    name: "Iraqi Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "Iranian Rial",
    pos: "before",
    value: "Rial"
  }, {
    name: "New Israeli Shekel",
    pos: "before",
    value: "?"
  }, {
    name: "Indian Rupee",
    pos: "before",
    value: "?"
  }, {
    name: "Indonesian Rupiah",
    pos: "before",
    value: "Rp"
  }, {
    name: "Jordanian Dinar",
    pos: "before",
    value: "din"
  }, {
    name: "VND",
    pos: "after",
    value: "?"
  }, {
    name: "Zambian Kwacha",
    pos: "before",
    value: "ZMW"
  }, {
    name: "Gibraltar Pound",
    pos: "before",
    value: "￡"
  }, {
    name: "Chilean Peso",
    pos: "before",
    value: "$"
  }, {
    name: "CFA Franc BEAC",
    pos: "before",
    value: "FCFA"
  }],
  defaultFmt: function defaultFmt(currency) {
    return [{
      text: "Automatic",
      value: "General",
      example: ""
    }, {
      text: "Plain text",
      value: "@",
      example: ""
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Number",
      value: "##0.00",
      example: "1000.12"
    }, {
      text: "Percent",
      value: "#0.00%",
      example: "12.21%"
    }, {
      text: "Scientific",
      value: "0.00E+00",
      example: "1.01E+5"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Accounting",
      value: "".concat(currency, "(0.00)"),
      example: "".concat(currency, "(1200.09)")
    }, {
      text: "Currency",
      value: "".concat(currency, "0.00"),
      example: "".concat(currency, "1200.09")
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Date",
      value: "yyyy-MM-dd",
      example: "2017-11-29"
    }, {
      text: "Time",
      value: "hh:mm AM/PM",
      example: "3:00 PM"
    }, {
      text: "Time 24H",
      value: "hh:mm",
      example: "15:00"
    }, {
      text: "Date time",
      value: "yyyy-MM-dd hh:mm AM/PM",
      example: "2017-11-29 3:00 PM"
    }, {
      text: "Date time 24 H",
      value: "yyyy-MM-dd hh:mm",
      example: "2017-11-29 15:00"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Custom formats",
      value: "fmtOtherSelf",
      example: "",
      icon: "rightArrow"
    }];
  },
  dateFmtList: [{
    name: "1930-08-05",
    value: "yyyy-MM-dd"
  }, {
    name: "1930/8/5",
    value: "yyyy/MM/dd"
  }, {
    name: "08-05",
    value: "MM-dd"
  }, {
    name: "8-5",
    value: "M-d"
  }, {
    name: "13:30:30",
    value: "h:mm:ss"
  }, {
    name: "13:30",
    value: "h:mm"
  }, {
    name: "PM 01:30",
    value: "AM/PM hh:mm"
  }, {
    name: "PM 1:30",
    value: "AM/PM h:mm"
  }, {
    name: "PM 1:30:30",
    value: "AM/PM h:mm:ss"
  }, {
    name: "08-05 PM 01:30",
    value: "MM-dd AM/PM hh:mm"
  }],
  fontFamily: {
    MicrosoftYaHei: "YaHei"
  },
  fontarray: ["Times New Roman", "Arial", "Tahoma", "Verdana"],
  fontjson: {
    "times new roman": 0,
    arial: 1,
    tahoma: 2,
    verdana: 3
  },
  border: {
    borderTop: "Top border",
    borderBottom: "Bottom border",
    borderLeft: "Left border",
    borderRight: "Right border",
    borderNone: "No border",
    borderAll: "All borders",
    borderOutside: "Outside border",
    borderInside: "Inside border",
    borderHorizontal: "Horizontal borders",
    borderVertical: "Vertical borders",
    borderColor: "border color",
    borderSize: "border size",
    borderSlash: "Slash border",
    borderDefault: "default",
    borderStyle: "border style"
  },
  merge: {
    mergeAll: "Merge all",
    mergeV: "Merge Vertically",
    mergeH: "Merge Horizontally",
    mergeCancel: "Unmerge",
    overlappingError: "Cannot merge overlapping areas",
    partiallyError: "Cannot perform this operation on partially merged cells"
  },
  align: {
    left: "left",
    center: "center",
    right: "right",
    top: "Top",
    middle: "Middle",
    bottom: "Bottom"
  },
  textWrap: {
    overflow: "Overflow",
    wrap: "Wrap",
    clip: "Clip"
  },
  rotation: {
    none: "None",
    angleup: "Tilt Up",
    angledown: "Tilt Down",
    vertical: "Stack Vertically",
    rotationUp: "Rotate Up",
    rotationDown: "Rotate Down"
  },
  freezen: {
    default: "Freeze",
    freezenRow: "First Row",
    freezenColumn: "First Column",
    freezenRC: "Both",
    freezenRowRange: "Freeze to current row",
    freezenColumnRange: "Freeze to current column",
    freezenRCRange: "Freeze to current cell",
    freezenCancel: "Cancel freezing",
    noSeletionError: "No Range to be selected",
    rangeRCOverErrorTitle: "Freeze reminder",
    rangeRCOverError: "The frozen pane is beyond the visible range, which will lead to abnormal operation. Please reset the frozen area."
  },
  sort: {
    asc: "Ascending ",
    desc: "Descending ",
    custom: "Custom sort",
    hasTitle: "Data has a header row",
    sortBy: "Sort by",
    addOthers: "Add another sort column",
    close: "close",
    confirm: "sort",
    columnOperation: "Column",
    secondaryTitle: "then by",
    sortTitle: "Sort range",
    sortRangeTitle: "Sort range from",
    sortRangeTitleTo: "to",
    noRangeError: "Cannot perform this operation on multiple selection areas, please select a single range and try again",
    mergeError: "There are merged cells in the selection, this operation cannot be performed!"
  },
  filter: {
    filter: "create filter",
    sortByAsc: "Ascending sort",
    sortByDesc: "Descending sort",
    filterByColor: "Filter by color",
    filterByCondition: "Filter by condition",
    filterByValues: "Filter by values",
    filiterInputNone: "None",
    filiterInputTip: "Enter filter value",
    filiterRangeStartTip: "Value for formula",
    filiterRangeEndTip: "Value for formula",
    filterValueByAllBtn: "Check all",
    filterValueByClearBtn: "Clear",
    filterValueByInverseBtn: "Inverse",
    filterValueByTip: "filter By Values",
    filterConform: "Confirm",
    filterCancel: "Cancel",
    clearFilter: "Clear filter",
    conditionNone: "None",
    conditionCellIsNull: "Is empty",
    conditionCellNotNull: "Is not empty",
    conditionCellTextContain: "Text contains",
    conditionCellTextNotContain: "Text does not contain",
    conditionCellTextStart: "Text starts with",
    conditionCellTextEnd: "Text ends with",
    conditionCellTextEqual: "Text is exactly",
    conditionCellDateEqual: "Date is",
    conditionCellDateBefore: "Date is before",
    conditionCellDateAfter: "Date is after",
    conditionCellGreater: "Greater than",
    conditionCellGreaterEqual: "Greater than or equal to",
    conditionCellLess: "Less than",
    conditionCellLessEqual: "Less than or equal to",
    conditionCellEqual: "Is equal to",
    conditionCellNotEqual: "Is not equal to",
    conditionCellBetween: "Is between",
    conditionCellNotBetween: "Is not between",
    filiterMoreDataTip: "Big amount of data! please wait",
    filiterMonthText: "Month",
    filiterYearText: "Year",
    filiterByColorTip: "Filter by cell color",
    filiterByTextColorTip: "Filter by font color",
    filterContainerOneColorTip: "This column contains only one color",
    filterDateFormatTip: "Date format",
    valueBlank: "(Null)",
    mergeError: "There are merged cells in the filter selection, this operation cannot be performed!"
  },
  rightclick: {
    copy: "Copy",
    copyAs: "Copy as",
    paste: "Paste",
    insert: "Insert",
    image: "Insert image",
    link: "Insert link",
    delete: "Delete",
    deleteCell: "Delete cell",
    deleteSelected: "Delete selected ",
    hide: "Hide",
    hideSelected: "Hide selected ",
    showHide: "Show hidden ",
    to: "Towards",
    left: "Left",
    right: "Right",
    top: "Above",
    bottom: "Below",
    moveLeft: "Move left",
    moveUp: "Move up",
    add: "Add",
    row: "Row",
    column: "Column",
    width: "Width",
    height: "Height",
    number: "Number",
    confirm: "Confirm",
    orderAZ: "Ascending sort",
    orderZA: "Descending sort",
    clearContent: "Clear content",
    matrix: "Matrix operation",
    sortSelection: "Sort",
    filterSelection: "Filter",
    chartGeneration: "Create chart",
    firstLineTitle: "first line title",
    untitled: "untitled",
    array1: "One-dimensional array",
    array2: "Two-dimensional array",
    array3: "Multidimensional Arrays",
    diagonal: "Diagonal",
    antiDiagonal: "Anti-diagonal",
    diagonalOffset: "Diagonal offset",
    offset: "Offset",
    boolean: "Boolean",
    flip: "Flip",
    upAndDown: "Up and down",
    leftAndRight: "Left and right",
    clockwise: "Clockwise",
    counterclockwise: "Counterclockwise",
    transpose: "Transpose",
    matrixCalculation: "Matrix calculation",
    plus: "Plus",
    minus: "Minus",
    multiply: "Multiply",
    divided: "Divided",
    power: "Power",
    root: "Root",
    log: "Log",
    delete0: "Delete 0 values at both ends",
    removeDuplicate: "Remove duplicate values",
    byRow: "By row",
    byCol: "By column",
    generateNewMatrix: "Generate new matrix",
    noMulti: "Cannot perform this operation on multiple selection areas, please select a single area",
    cannotDeleteAllRow: "Cannot delete all rows",
    cannotDeleteAllColumn: "Cannot delete all columns",
    cannotDeleteRowReadOnly: "Cannot delete row readonly",
    cannotDeleteColumnReadOnly: "Cannot delete column readonly",
    cannotInsertOnRowReadOnly: "Cannot insert on read-only row",
    cannotInsertOnColumnReadOnly: "Cannot insert into read-only column",
    rowOverLimit: "10000 row limit exceeded",
    columnOverLimit: "1000 column limit exceeded"
  },
  comment: {
    insert: "Insert",
    edit: "Edit",
    delete: "Delete",
    showOne: "Show/Hide",
    showAll: "Show/Hide All"
  },
  screenshot: {
    screenshotTipNoSelection: "Please select the scope of the screenshot",
    screenshotTipTitle: "Warning！",
    screenshotTipHasMerge: "This operation cannot be performed on merged cells",
    screenshotTipHasMulti: "This operation cannot be performed on multiple selection regions",
    screenshotTipSuccess: "Successful",
    screenshotImageName: "Screenshot",
    downLoadClose: "Close",
    downLoadCopy: "Copy to clipboard",
    downLoadBtn: "Download",
    browserNotTip: "not supported by IE browser!",
    rightclickTip: 'Please right-click "copy" on the picture',
    successTip: 'Successfully (if pasting fails, please right-click on the image to "copy image")'
  },
  splitText: {
    splitDelimiters: "Delimiters",
    splitOther: "Other",
    splitContinueSymbol: "Consecutive separators are treated as a single",
    splitDataPreview: "Preview",
    splitTextTitle: "Split text",
    splitConfirmToExe: "There is already data here, do you want to replace it?",
    splitSymbols: [{
      name: "Tab",
      value: "Tab"
    }, {
      name: "semicolon",
      value: "semicolon"
    }, {
      name: "comma",
      value: "comma"
    }, {
      name: "space",
      value: "space"
    }],
    tipNoMulti: "Cannot perform this operation on multiple selection areas, please select a single area and try again",
    tipNoMultiColumn: "Only one column of data can be converted at a time. The selected area can have multiple rows but not multiple columns. Please try again after selecting a single column range",
    tipNoSelect: "You cannot separate a cell without selecting it"
  },
  imageText: {
    imageSetting: "Image setting",
    close: "Close",
    conventional: "Conventional",
    moveCell1: "Move and resize cells",
    moveCell2: "Move and do not resize the cell",
    moveCell3: "Do not move and resize the cell",
    fixedPos: "Fixed position",
    border: "Border",
    width: "Width",
    radius: "Radius",
    style: "Style",
    solid: "Solid",
    dashed: "Dashed",
    dotted: "Dotted",
    double: "Double",
    color: "Color"
  },
  punctuation: {
    tab: "Tab",
    semicolon: "semicolon",
    comma: "comma",
    space: "space"
  },
  findAndReplace: {
    find: "Find",
    replace: "Replace",
    goto: "Go to",
    location: "Location",
    formula: "Formula",
    date: "Date",
    number: "Number",
    string: "String",
    error: "Error",
    condition: "Condition",
    rowSpan: "Row span",
    columnSpan: "Column span",
    locationExample: "Location",
    lessTwoRowTip: "Please select at least two rows",
    lessTwoColumnTip: "Please select at least two columns",
    findTextbox: "Find Content",
    replaceTextbox: "Replace Content",
    regexTextbox: "Regular Expression",
    wholeTextbox: "Whole word",
    distinguishTextbox: "Case sensitive",
    allReplaceBtn: "Replace All",
    replaceBtn: "Replace",
    allFindBtn: "Find All",
    findBtn: "Find next",
    noFindTip: "The content was not found",
    modeTip: "This operation is not available in this mode",
    searchTargetSheet: "Sheet",
    searchTargetCell: "Cell",
    searchTargetValue: "Value",
    searchInputTip: "Please enter the search content",
    noReplceTip: "There is nothing to replace",
    noMatchTip: "No match found",
    successTip: "${xlength} items found",
    locationConstant: "Constant",
    locationFormula: "Formula",
    locationDate: "Date",
    locationDigital: "Number",
    locationString: "String",
    locationBool: "Logical",
    locationError: "Error",
    locationNull: "Null",
    locationCondition: "Conditional format",
    locationRowSpan: "Row span",
    locationColumnSpan: "Column span",
    locationTiplessTwoRow: "Please select at least two rows",
    locationTiplessTwoColumn: "Please select at least two columns",
    locationTipNotFindCell: "Cell not found"
  },
  sheetconfig: {
    delete: "Delete",
    copy: "Copy",
    rename: "Rename",
    changeColor: "Change color",
    hide: "Hide",
    unhide: "Unhide",
    moveLeft: "Move left",
    moveRight: "Move right",
    resetColor: "Reset color",
    cancelText: "Cancel",
    chooseText: "Confirm color",
    focus: "Focus",
    tipNameRepeat: "The name of the tab page cannot be repeated! Please revise",
    noMoreSheet: "The workbook contains at least one visual worksheet. To delete the selected worksheet, please insert a new worksheet or show a hidden worksheet.",
    confirmDelete: "Are you sure to delete",
    redoDelete: "Can be undo by Ctrl+Z",
    noHide: "Can't hide, at least keep one sheet tag",
    chartEditNoOpt: "This operation is not allowed in chart editing mode!",
    sheetNameSpecCharError: "The name cannot contain:[ ] :  ? * / ' \"",
    sheetNamecannotIsEmptyError: "Sheet name cannot be empty"
  },
  conditionformat: {
    conditionformat_greaterThan: "Conditionformat-GreaterThan",
    conditionformat_greaterThan_title: "Format cells greater than",
    conditionformat_lessThan: "Conditionformat-LessThan",
    conditionformat_lessThan_title: "Format cells smaller than",
    conditionformat_between: "Conditionformat-Betweenness",
    conditionformat_between_title: "Format cells with values between",
    conditionformat_equal: "Conditionformat-Equal",
    conditionformat_equal_title: "Format cells equal to",
    conditionformat_textContains: "Conditionformat-TextContains",
    conditionformat_textContains_title: "Format cells containing the following text",
    conditionformat_occurrenceDate: "Conditionformat-OccurrenceDate",
    conditionformat_occurrenceDate_title: "Format cells containing the following dates",
    conditionformat_duplicateValue: "Conditionformat-DuplicateValue",
    conditionformat_duplicateValue_title: "Format cells containing the following types of values",
    conditionformat_top10: "Conditionformat-Top10",
    conditionformat_top10_percent: "Conditionformat-Top10%",
    conditionformat_top10_title: "Format the cells with the highest value",
    conditionformat_last10: "Conditionformat-Last10",
    conditionformat_last10_percent: "Conditionformat-Last10%",
    conditionformat_last10_title: "Format the cells with the smallest value",
    conditionformat_aboveAverage: "Conditionformat-AboveAverage",
    conditionformat_aboveAverage_title: "Format cells above average",
    conditionformat_belowAverage: "Conditionformat-SubAverage",
    conditionformat_belowAverage_title: "Format cells below average",
    rule: "Rule",
    newRule: "New rule",
    editRule: "Edit rule",
    deleteRule: "Delete rule",
    deleteCellRule: "Delete cell rule",
    deleteSheetRule: "Delete sheet rule",
    manageRules: "Management rules",
    showRules: "Show its formatting rules",
    highlightCellRules: "Highlight cell rules",
    itemSelectionRules: "Item selection rules",
    conditionformatManageRules: "Conditional Formatting Rule Manager",
    format: "Format",
    setFormat: "Set format",
    setAs: "Set as",
    setAsByArea: "For the selected area, set to",
    applyRange: "Apply range",
    selectRange: "Select application range",
    selectRange_percent: "Percentage of selected range",
    selectRange_average: "Average value of selected range",
    selectRange_value: "Value in the selected range",
    pleaseSelectRange: "Please select application range",
    selectDataRange: "Select data range",
    selectCell: "select cell",
    pleaseSelectCell: "Please select cell",
    pleaseSelectADate: "Please select a date",
    pleaseEnterInteger: "Please enter an integer between 1 and 1000",
    onlySingleCell: "Only a single cell can be referenced",
    conditionValueCanOnly: "The condition value can only be a number or a single cell",
    ruleTypeItem1: "Format all cells based on their respective values",
    ruleTypeItem2: "Only format cells that contain",
    ruleTypeItem2_title: "Only for cells that meet the following conditions",
    ruleTypeItem3: "Format only the top or bottom numbers",
    ruleTypeItem3_title: "Is the value in the following ranking",
    ruleTypeItem4: "Format only values above or below the average",
    ruleTypeItem4_title: "Is a value that satisfies the following conditions",
    ruleTypeItem5: "Format only unique or repeated values",
    ruleTypeItem6: "Use formulas to determine which cells to format",
    formula: "Formula",
    textColor: "Text color",
    cellColor: "Cell color",
    confirm: "Confirm",
    confirmColor: "Confirm color",
    cancel: "Cancel",
    close: "Close",
    clearColorSelect: "Clear color select",
    sheet: "Sheet",
    currentSheet: "Current Sheet",
    dataBar: "data bar",
    dataBarColor: "data bar color",
    gradientDataBar_1: "Blue-white gradient data bar",
    gradientDataBar_2: "Green-white gradient data bar",
    gradientDataBar_3: "Red-white gradient data bar",
    gradientDataBar_4: "Orange-white gradient stripes",
    gradientDataBar_5: "Light blue-white gradient stripes",
    gradientDataBar_6: "Purple-white gradient data bar",
    solidColorDataBar_1: "Blue data bar",
    solidColorDataBar_2: "Green data bar",
    solidColorDataBar_3: "Red data bar",
    solidColorDataBar_4: "Orange data bar",
    solidColorDataBar_5: "Light blue data bar",
    solidColorDataBar_6: "Purple data bar",
    colorGradation: "color gradation",
    colorGradation_1: "Green-yellow-red color gradation",
    colorGradation_2: "Red-yellow-green color gradation",
    colorGradation_3: "Green-white-red color gradation",
    colorGradation_4: "Red-white-green color gradation",
    colorGradation_5: "Blue-white-red color gradation",
    colorGradation_6: "Red-white-blue color gradation",
    colorGradation_7: "White-red color gradation",
    colorGradation_8: "Red-white color gradation",
    colorGradation_9: "Green-white color gradation",
    colorGradation_10: "White-green color gradation",
    colorGradation_11: "Green-yellow color gradation",
    colorGradation_12: "Yellow-green color gradation",
    icons: "icons",
    pleaseSelectIcon: "Please click to select a group of icons:",
    cellValue: "Cell value",
    specificText: "Specific text",
    occurrenceDate: "Date",
    greaterThan: "Greater than",
    lessThan: "Less than",
    between: "Between",
    equal: "Equal",
    in: "In",
    between2: "",
    contain: "Contain",
    textContains: "Text contains",
    duplicateValue: "Duplicate value",
    uniqueValue: "Unique value",
    top: "Top",
    top10: "Top 10",
    top10_percent: "Top 10%",
    last: "Last",
    last10: "Last 10",
    last10_percent: "Last 10%",
    oneself: "",
    above: "Above",
    aboveAverage: "Above average",
    below: "Below",
    belowAverage: "Below average",
    all: "All",
    yesterday: "YTD",
    today: "Today",
    tomorrow: "Tomorrow",
    lastWeek: "Last week",
    thisWeek: "This week",
    lastMonth: "Last month",
    thisMonth: "This month",
    lastYear: "Last year",
    thisYear: "This year",
    last7days: "Last 7 days",
    last30days: "Last 30 days",
    next7days: "Next 7 days",
    next30days: "Next 30 days",
    next60days: "Next 60 days",
    chooseRuleType: "Choose rule type",
    editRuleDescription: "Edit rule description",
    newFormatRule: "New format rule",
    editFormatRule: "Edit format rule",
    formatStyle: "Style",
    fillType: "Fill",
    color: "Color",
    twocolor: "Two-color",
    tricolor: "Tricolor",
    multicolor: "Multi color",
    grayColor: "Gray color",
    gradient: "Gradient",
    solid: "Solid",
    maxValue: "Max value",
    medianValue: "Median value",
    minValue: "Min value",
    direction: "Direction",
    threeWayArrow: "Three-way arrow",
    fourWayArrow: "Four-way arrow",
    fiveWayArrow: "Five-way arrow",
    threeTriangles: "Three triangles",
    shape: "Shape",
    threeColorTrafficLight: "Three-color traffic light",
    fourColorTrafficLight: "Four-color traffic light",
    threeSigns: "Three signs",
    greenRedBlackGradient: "Green-red-black gradient",
    rimless: "Rimless",
    bordered: "Bordered",
    mark: "Mark",
    threeSymbols: "Three symbols",
    tricolorFlag: "Tricolor flag",
    circled: "Circled",
    noCircle: "No circle",
    grade: "Grade",
    grade4: "4 Grade",
    grade5: "5 Grade",
    threeStars: "3 Stars",
    fiveQuadrantDiagram: "Five-quadrant diagram",
    fiveBoxes: "5 Boxes"
  },
  insertLink: {
    linkText: "Display text",
    linkType: "Link type",
    linkAddress: "Link address",
    linkSheet: "Worksheet",
    linkCell: "Cell range",
    linkTooltip: "Tooltip",
    selectCellRange: "Select cell range",
    cellRangePlaceholder: "Select cells using the cursor or enter directly",
    placeholder1: "Please enter the web link address",
    placeholder2: "Please enter the cell to be quoted, example A1",
    placeholder3: "Please enter the prompt content",
    tooltipInfo1: "Please enter a valid link",
    invalidCellRangeTip: "Please enter the correct ell range, such as Sheet1!A1:C8",
    openLink: "Open link",
    goTo: "Go to ${linkAddress}"
  },
  linkTypeList: [{
    text: "Webpages",
    value: "webpage"
  }, {
    text: "Cell range",
    value: "cellrange"
  }, {
    text: "Sheet",
    value: "sheet"
  }],
  dataVerification: {
    cellRange: "Cell range",
    selectCellRange: "Click to select a cell range",
    selectCellRange2: "Please select a range of cells",
    verificationCondition: "Verification condition",
    allowMultiSelect: "Allow multiple selection",
    dropdown: "drop-down list",
    checkbox: "Checkbox",
    number: "Number",
    number_integer: "Number-integer",
    number_decimal: "Number-decimal",
    text_content: "Text-content",
    text_length: "Text-length",
    date: "Date",
    validity: "Effectiveness",
    placeholder1: "Please enter the options, separated by commas, such as 1,2,3,4,5",
    placeholder2: "Please enter content",
    placeholder3: "Numeric value, such as 10",
    placeholder4: "Please enter the specified text",
    placeholder5: "Please enter the prompt displayed when the cell is selected",
    selected: "Selected",
    notSelected: "Not selected",
    between: "Between",
    notBetween: "Not between",
    equal: "Equal",
    notEqualTo: "Not equal to",
    moreThanThe: "More than the",
    lessThan: "Less than",
    greaterOrEqualTo: "Greater or equal to",
    lessThanOrEqualTo: "Less than or equal to",
    include: "Include",
    exclude: "Exclude",
    earlierThan: "Earlier than",
    noEarlierThan: "No earlier than",
    laterThan: "Later than",
    noLaterThan: "No later than",
    identificationNumber: "Identification number",
    phoneNumber: "Phone number",
    remote: "Automatic remote acquisition option",
    prohibitInput: "Prohibit input when input data is invalid",
    hintShow: "Show prompt when the cell is selected",
    deleteVerification: "Delete verification",
    tooltipInfo1: "The drop-down list option cannot be empty",
    tooltipInfo2: "Checkbox content cannot be empty",
    tooltipInfo3: "The value entered is not a numeric type",
    tooltipInfo4: "The value 2 cannot be less than the value 1",
    tooltipInfo5: "The text content cannot be empty",
    tooltipInfo6: "The value entered is not a date type",
    tooltipInfo7: "Date 2 cannot be less than date 1",
    textlengthInteger: "Text length must be an integer greater than or equal to 0"
  },
  formula: {
    sum: "Sum",
    average: "Average",
    count: "Count",
    max: "Max",
    min: "Min",
    ifGenerate: "If formula generator",
    find: "Learn more",
    tipNotBelongToIf: "This cell function does not belong to the if formula!",
    tipSelectCell: "Please select the cell to insert the function",
    ifGenCompareValueTitle: "Comparison value",
    ifGenSelectCellTitle: "Click to select cell",
    ifGenRangeTitle: "Range",
    ifGenRangeTo: "to",
    ifGenRangeEvaluate: "Range evaluate",
    ifGenSelectRangeTitle: "Click to select range",
    ifGenCutWay: "Partition way",
    ifGenCutSame: "Same Partition value",
    ifGenCutNpiece: "Partition by N",
    ifGenCutCustom: "Custom",
    ifGenCutConfirm: "Confirm",
    ifGenTipSelectCell: "Select cells",
    ifGenTipSelectCellPlace: "Please select cells",
    ifGenTipSelectRange: "Select range",
    ifGenTipSelectRangePlace: "Please select range",
    ifGenTipNotNullValue: "The comparison value cannot be empty!",
    ifGenTipLableTitile: "Label",
    ifGenTipRangeNotforNull: "The range cannot be empty!",
    ifGenTipCutValueNotforNull: "The partition value cannot be empty!",
    ifGenTipNotGenCondition: "No conditions are available for generation!"
  },
  formulaMore: {
    valueTitle: "Value",
    tipSelectDataRange: "Select data range",
    tipDataRangeTile: "Data range",
    findFunctionTitle: "Search function",
    tipInputFunctionName: "Function name or brief description of function",
    Array: "Array",
    Database: "Database",
    Date: "Date",
    Engineering: "Engineering",
    Filter: "Filter",
    Financial: "Financial",
    luckysheet: "Luckysheet",
    other: "Other",
    Logical: "Logical",
    Lookup: "Lookup",
    Math: "Math",
    Operator: "Operator",
    Parser: "Parser",
    Statistical: "Statistical",
    Text: "Text",
    dataMining: "Data Mining",
    selectFunctionTitle: "Select a function",
    calculationResult: "Result",
    tipSuccessText: "Success",
    tipParamErrorText: "Parameter type error",
    helpClose: "Close",
    helpCollapse: "Collapse",
    helpExample: "Example",
    helpAbstract: "Abstract",
    execfunctionError: "Error in the formula",
    execfunctionSelfError: "The formula cannot refer to its own cell",
    execfunctionSelfErrorResult: "The formula cannot refer to its own cell, which will lead to inaccurate calculation results",
    allowRepeatText: "Repeatable",
    allowOptionText: "Optional",
    selectCategory: "Or select a category"
  },
  drag: {
    noMerge: "Cannot perform this operation on merged cells",
    affectPivot: "This change cannot be made to the selected cell because it will affect the pivot table!",
    noMulti: "Cannot perform this operation on multiple selection areas, please select a single area",
    noPaste: "Unable to paste this content here, please select a cell in the paste area and try to paste again",
    noPartMerge: "Cannot perform this operation on partially merged cells",
    inputCorrect: "Please enter the correct value",
    notLessOne: "The number of rows and columns cannot be less than 1",
    offsetColumnLessZero: "The offset column cannot be negative!",
    pasteMustKeybordAlert: "在表格中进行复制粘贴: Ctrl + C 进行复制, Ctrl + V 进行粘贴, Ctrl + X 进行剪切",
    pasteMustKeybordAlertHTMLTitle: "在表格中进行复制粘贴",
    pasteMustKeybordAlertHTML: "<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;进行复制<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;进行粘贴<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;进行剪切"
  },
  pivotTable: {
    title: "Pivot Table",
    closePannel: "Close",
    editRange: "Range",
    tipPivotFieldSelected: "Select the fields",
    tipClearSelectedField: "Clear all fields",
    btnClearSelectedField: "Clear",
    btnFilter: "Filter",
    titleRow: "Row",
    titleColumn: "Column",
    titleValue: "Value",
    tipShowColumn: "Statistics fields are displayed as columns",
    tipShowRow: "Statistics fields are displayed as rows",
    titleSelectionDataRange: "Select range",
    titleDataRange: "Data range",
    valueSum: "SUM",
    valueStatisticsSUM: "Sum",
    valueStatisticsCOUNT: "Count",
    valueStatisticsCOUNTA: "Count A",
    valueStatisticsCOUNTUNIQUE: "Count Unique",
    valueStatisticsAVERAGE: "Average",
    valueStatisticsMAX: "Max",
    valueStatisticsMIN: "Min",
    valueStatisticsMEDIAN: "Median",
    valueStatisticsPRODUCT: "Product",
    valueStatisticsSTDEV: "Stdev",
    valueStatisticsSTDEVP: "Stdevp",
    valueStatisticslet: "Var",
    valueStatisticsVARP: "VarP",
    errorNotAllowEdit: "This operation is prohibited in non-editing mode!",
    errorNotAllowMulti: "Cannot perform this operation on multiple selection areas, please select a single range and try again",
    errorSelectRange: "Please select the range of the new pivot table",
    errorIsDamage: "The source data of this pivot table is corrupted!",
    errorNotAllowPivotData: "Cannot select pivot table as source data!",
    errorSelectionRange: "Selection failed, wrong input range!",
    errorIncreaseRange: "Please expand the selected range!",
    titleAddColumn: "Add column to pivot table",
    titleMoveColumn: "Move the column to the white box below",
    titleClearColumnFilter: "Clear the filter for this column",
    titleFilterColumn: "Filter",
    titleSort: "Sort",
    titleNoSort: "No sort",
    titleSortAsc: "ASC",
    titleSortDesc: "DESC",
    titleSortBy: "Sort by",
    titleShowSum: "Show total",
    titleStasticTrue: "Yes",
    titleStasticFalse: "No"
  },
  dropCell: {
    copyCell: "Copy",
    sequence: "Sequence",
    onlyFormat: "Only format",
    noFormat: "Not format",
    day: "Day",
    workDay: "Work Day",
    month: "Month",
    year: "Year",
    chineseNumber: "Chinese numbers"
  },
  imageCtrl: {
    borderTile: "Image border color",
    borderCur: "Color"
  },
  protection: {
    protectiontTitle: "Protection",
    enterPassword: "Enter a password (optional)",
    enterHintTitle: "Prompt when editing is prohibited (optional)",
    enterHint: "The cell or chart you are trying to change is in a protected worksheet. If you want to change it, please unprotect the worksheet. You may need to enter a password",
    swichProtectionTip: "Protect the sheet and contents of locked cells",
    authorityTitle: "Allow users of this sheet to:",
    selectLockedCells: "Select locked cells",
    selectunLockedCells: "Select unlocked cells",
    formatCells: "Format cells",
    formatColumns: "Format columns",
    formatRows: "Format rows",
    insertColumns: "Insert columns",
    insertRows: "Insert rows",
    insertHyperlinks: "Insert hyperlinks",
    deleteColumns: "Delete columns",
    deleteRows: "Delete rows",
    sort: "Sort",
    filter: "Filter",
    usePivotTablereports: "Use Pivot Table reports",
    editObjects: "Edit objects",
    editScenarios: "Edit scenarios",
    allowRangeTitle: "Allow users of range to:",
    allowRangeAdd: "New...",
    allowRangeAddTitle: "Title",
    allowRangeAddSqrf: "Reference",
    selectCellRange: "Click to select a cell range",
    selectCellRangeHolder: "Cell range",
    allowRangeAddTitlePassword: "Password",
    allowRangeAddTitleHint: "Prompt",
    allowRangeAddTitleHintTitle: "Prompt when a password is set (optional)",
    allowRangeAddtitleDefault: "Input range name",
    rangeItemDblclick: "Double click to edit",
    rangeItemHasPassword: "Has password",
    rangeItemErrorTitleNull: "Title is null",
    rangeItemErrorRangeNull: "Reference is null",
    rangeItemErrorRange: "Reference is error",
    validationTitle: "Password validation",
    validationTips: "Need to enter a password to unlock the protection of the worksheet",
    validationInputHint: "Enter a password",
    checkPasswordNullalert: "Password is required!",
    checkPasswordWrongalert: "Incorrect password, please try again!",
    checkPasswordSucceedalert: "Unlock Succeed!",
    defaultRangeHintText: "The cell is being password protected.",
    defaultSheetHintText: "The cell or chart is in a protected worksheet. To make changes, please unprotect the worksheet. You may need to enter a password"
  },
  cellFormat: {
    cellFormatTitle: "Format cells",
    protection: "Protection",
    locked: "Locked",
    hidden: "Hidden",
    protectionTips: "To lock cells or hide formulas, protect the worksheet. On the toolbar, Click Protect Sheet Button",
    tipsPart: "Partial checked",
    tipsAll: "All checked",
    selectionIsNullAlert: "Selection is required!",
    sheetDataIsNullAlert: "error, Data is none!"
  },
  print: {
    normalBtn: "Normal",
    layoutBtn: "Page Layout",
    pageBtn: "Page break preview",
    menuItemPrint: "Print (Ctrl+P)",
    menuItemAreas: "Print areas",
    menuItemRows: "Print title rows",
    menuItemColumns: "Print title columns"
  },
  edit: {
    typing: "typing"
  },
  websocket: {
    success: "WebSocket connection success",
    refresh: "An error occurred in the WebSocket connection, please refresh the page!",
    wait: "An error occurred in the WebSocket connection, please be patient!",
    close: "WebSocket connection closed",
    contact: "Server communication error occurred, please refresh the page and try again, if not, please contact the administrator!",
    support: "The current browser does not support WebSocket"
  }
};

var zh = {
  generalDialog: {
    partiallyError: "无法对部分合并单元格执行此操作",
    readOnlyError: "无法对只读模式执行此操作",
    dataNullError: "无法对不存在的数据执行此操作",
    noSeletionError: "还未进行选区操作",
    cannotSelectMultiple: "无法选择多选区"
  },
  functionlist: [{
    n: "SUMIF",
    t: 0,
    d: "对范围中符合指定条件的值求和。",
    a: "对范围中符合指定条件的值求和。",
    m: [2, 3],
    p: [{
      name: "范围",
      detail: "要根据条件进行检测的范围。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "条件",
      detail: "要应用于范围的模式或测试条件。\n\n如果范围包含的是要检测的文本，则条件必须为字符串。条件可以包含通配符，包括用于匹配单个字符的?或用于匹配零个或连续多个字符的*。要匹配问号星号本身，请在该字符前面加上波浪号(~)前缀（即~?和~*）。字符串条件必须用引号括起来。函数会检查范围中的每个单元格与条件是否相等或匹配（如果使用了通配符）。\n\n如果范围包含的是要检测的数字，则条件可以是字符串也可以是数字。如果给定的条件是一个数字，则检查范围中的每个单元格是否等于条件。另外，条件也可能是包含数字的字符串（也将对其进行相等检测），或者带有以下前缀的数字：=（检查是否相等）、>（检查范围单元格的值是否大于条件值）或<（检查范围单元格的值是否小于条件值）",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "求和范围",
      detail: "要求和的范围（如果与范围不同）。",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TAN",
    t: 0,
    d: "返回已知角度的正切值。",
    a: "返回已知角度的正切值。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要求其正切值的角度，以弧度表示。",
      example: "45*PI()/180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TANH",
    t: 0,
    d: "返回给定实数的双曲正切值。",
    a: "返回给定实数的双曲正切值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其双曲正切值的实数。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CEILING",
    t: 0,
    d: "将数值向上取整为最接近的指定因数的倍数。",
    a: "将数值向上取整为最接近的指定因数的倍数。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要向上舍入的数值。",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因数",
      detail: "要将值舍入到此数的整数倍。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN",
    t: 0,
    d: "返回数值的反正切值，以弧度表示。",
    a: "返回数值的反正切值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反正切值的数值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ASINH",
    t: 0,
    d: "返回数值的反双曲正弦值。",
    a: "返回数值的反双曲正弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反双曲正弦值的数值。",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ABS",
    t: 0,
    d: "返回数值的绝对值。",
    a: "返回数值的绝对值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要返回其绝对值的数。",
      example: "-2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOS",
    t: 0,
    d: "返回数值的反余弦值，以弧度表示。",
    a: "返回数值的反余弦值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反余弦值的数值。必须介于-1和1之间，包括两端值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOSH",
    t: 0,
    d: "返回数值的反双曲余弦值。",
    a: "返回数值的反双曲余弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反双曲余弦值的数值。必须大于等于1。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTINOMIAL",
    t: 0,
    d: "返回参数和的阶乘除以各参数阶乘的乘积后得到的值。",
    a: "返回参数和的阶乘除以各参数阶乘的乘积后得到的值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "用于计算的第一项数值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "用于计算的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "ATANH",
    t: 0,
    d: "返回数值的反双曲正切值。",
    a: "返回数值的反双曲正切值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反双曲正切值的数值。必须介于-1和1之间（不包括-1和1）。",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN2",
    t: 0,
    d: "以弧度为单位返回 x 轴与从原点 (0,0) 到指定坐标点 (`x`,`y`) 之间连线的夹角。",
    a: "以弧度为单位返回 x 轴与从原点 (0,0) 到指定坐标点 (`x`,`y`) 之间连线的夹角。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "要计算其与x轴夹角大小的线段的终点x坐标。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "y",
      detail: "要计算其与x轴夹角大小的线段的终点y坐标。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTBLANK",
    t: 1,
    d: "返回给定范围内的空单元格数。",
    a: "返回给定范围内的空单元格数。",
    m: [1, 1],
    p: [{
      name: "范围",
      detail: "要统计空白单元格数量的范围。",
      example: "A2:C100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "COSH",
    t: 0,
    d: "返回给定实数的双曲余弦值。",
    a: "返回给定实数的双曲余弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其双曲余弦值的实数值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INT",
    t: 0,
    d: "将数值向下取整为小于或等于该数的最接近的整数。",
    a: "将数值向下取整为小于或等于该数的最接近的整数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向下取整为最接近的整数的数值。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISEVEN",
    t: 0,
    d: "检查所提供的数值是否为偶数。",
    a: "检查所提供的数值是否为偶数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要验证其是否为偶数的数值。\n\n如果值为偶数或指向包含偶数的单元格的引用，ISEVEN将返回TRUE，否则返回FALSE。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISODD",
    t: 0,
    d: "检查所提供的数值是否为奇数。",
    a: "检查所提供的数值是否为奇数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要验证其是否为奇数的数值。\n\n如果值为奇数或指向包含奇数的单元格，ISODD将返回TRUE，否则返回FALSE。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LCM",
    t: 0,
    d: "返回一个或多个整数的最小公倍数。",
    a: "返回一个或多个整数的最小公倍数。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要在求最小公倍数数的计算中检查其因数的第一项数值或范围。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可选] - 在求最小公倍数时要考虑其因数的其他数值或范围。",
      example: "3",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LN",
    t: 0,
    d: "返回数值以 e（欧拉数）为底的对数。",
    a: "返回数值以 e（欧拉数）为底的对数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要以 e 为底数计算其对数的值。\n\n值必须为正数。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG",
    t: 0,
    d: "根据指定底数返回数字的对数。",
    a: "根据指定底数返回数字的对数。",
    m: [1, 2],
    p: [{
      name: "值",
      detail: "想要计算其对数的正实数。",
      example: "128",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "底数",
      detail: "[可选] - 对数的底数。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG10",
    t: 0,
    d: "返回数值以10为底的对数。",
    a: "返回数值以10为底的对数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其以10为底的对数的数值。\n\n值必须为正值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MOD",
    t: 0,
    d: "返回两数相除的余数, 结果的符号与除数相同。",
    a: "返回两数相除的余数。",
    m: [2, 2],
    p: [{
      name: "被除数",
      detail: "要将其相除以得到余数的数值。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "除数",
      detail: "用于除其他数的数值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MROUND",
    t: 0,
    d: "将数值取整为另一整数最接近的整数倍。",
    a: "将数值取整为另一整数最接近的整数倍。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要取整为另一整数最接近的整数倍的数值。",
      example: "21",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因数",
      detail: "值将取此因数的整数倍。",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ODD",
    t: 0,
    d: "将数值向上取整为最接近的奇整数。",
    a: "将数值向上取整为最接近的奇整数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向上取整的数值，取整值为大于此值的最接近的奇数。\n\n如果值为负数，则将其取整为绝对值大于该值的相邻负奇数。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMSQ",
    t: 0,
    d: "返回一组数值和/或单元格的平方总和。",
    a: "返回一组数值和/或单元格的平方总和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要将其平方相加的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 要将其平方与值1的平方相加的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMBIN",
    t: 0,
    d: "给定集合中的对象总数和要选择的对象数量，返回共有多少种不同选择方式。",
    a: "给定集合中的对象总数和要选择的对象数量",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "要从中进行选择的对象集合的大小。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "要选择的对象数量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUM",
    t: 0,
    d: "返回一组数值和/或单元格的总和。",
    a: "返回一组数值和/或单元格的总和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要相加的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可选] - 要相加的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SUBTOTAL",
    t: 0,
    d: "使用指定的汇总函数，返回一系列纵向单元格的分类汇总。",
    a: "使用指定的汇总函数",
    m: [2, 256],
    p: [{
      name: "函数代码",
      detail: "用于计算分类汇总的函数。\n\n1代表AVERAGE\n\n2代表COUNT\n\n3代表COUNTA\n\n4代表MAX\n\n5代表MIN\n\n6代表PRODUCT\n\n7代表STDEV\n\n8代表STDEVP\n\n9代表SUM\n\n10代表VAR\n\n11代表VARP\n\n通过在这些2位代码前附加10（对于1位代码）或1（对于2位代码），可以将隐藏值忽略。例如，102代表忽略隐藏单元格的COUNT，而110则代表忽略隐藏值的VAR。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "范围1",
      detail: "要计算分类汇总的第一个范围。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "范围2",
      detail: "[可选] - 要计算分类汇总的其他范围。",
      example: "B2:B8",
      require: "o",
      repeat: "y",
      type: "range"
    }]
  }, {
    n: "ASIN",
    t: 0,
    d: "返回数值的反正弦值，以弧度表示。",
    a: "返回数值的反正弦值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其反正弦值的数值。必须介于-1和1之间，包括两端值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTIF",
    t: 1,
    d: "返回范围内满足某个条件的单元格的数量。",
    a: "返回范围内满足某个条件的单元格的数量。",
    m: [2, 2],
    p: [{
      name: "范围",
      detail: "要根据条件进行检测的范围。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "条件",
      detail: "要应用于范围的模式或测试条件。\n\n如果范围包含的是要检测的文本，则条件必须为字符串。条件可以包含通配符，包括用于匹配单个字符的?或用于匹配零个或连续多个字符的*。要匹配问号星号本身，请在该字符前面加上波浪号(~)前缀（即~?和~*）。字符串条件必须用引号括起来。函数会检查范围中的每个单元格与条件是否相等或匹配（如果使用了通配符）。\n\n如果范围包含的是要检测的数字，则条件可以是字符串也可以是数字。如果给定的条件是一个数字，则检查范围中的每个单元格是否等于条件。另外，条件也可能是包含数字的字符串（也将对其进行相等检测），或者带有以下前缀的数字：=、>、>=、<或<=，这些条件将分别用于检查范围中的单元格是否等于、大于、大于等于、小于、小于等于条件值。",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RADIANS",
    t: 0,
    d: "将以度表示的角度值转换为弧度。",
    a: "将以度表示的角度值转换为弧度。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要从度转换为弧度的角度。",
      example: "180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RAND",
    t: 0,
    d: "返回一个介于0和1之间（包括0但不包括1）的随机数。",
    a: "返回一个介于0和1之间（包括0但不包括1）的随机数。",
    m: [0, 0],
    p: []
  }, {
    n: "COUNTUNIQUE",
    t: 0,
    d: "计算一列指定值和范围中不重复数值的个数。",
    a: "计算一列指定值和范围中不重复数值的个数。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要检查其是否唯一的第一个值或范围。",
      example: "A1:C100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可选] - 要检查是否唯一的其他值或范围。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DEGREES",
    t: 0,
    d: "将以弧度表示的角度值转换为度。",
    a: "将以弧度表示的角度值转换为度。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要从弧度转换为度的角度。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ERFC",
    t: 9,
    d: "返回数值的互补高斯误差函数。",
    a: "返回数值的互补高斯误差函数。",
    m: [1, 1],
    p: [{
      name: "z",
      detail: "要为其计算互补高斯误差函数的数值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVEN",
    t: 0,
    d: "将数值向上取整为最接近的偶整数。",
    a: "将数值向上取整为最接近的偶整数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向上取整的数值，取整值为大于此值的最接近的偶数。\n\n如果值为负数，则将其取整为绝对值大于该值的相邻负偶数。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EXP",
    t: 0,
    d: "返回欧拉数 e (~2.718) 的指定次幂。",
    a: "返回欧拉数 e (~2.718) 的指定次幂。",
    m: [1, 1],
    p: [{
      name: "指数",
      detail: "指定e的自乘幂次值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACT",
    t: 0,
    d: "返回数值的阶乘。",
    a: "返回数值的阶乘。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算并返回其阶乘的数字或对数字（所在单元格）的引用。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACTDOUBLE",
    t: 0,
    d: "返回数值的“双阶乘”。",
    a: "返回数值的“双阶乘”。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算并返回其双阶乘的数字或对数字（所在单元格）的引用。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PI",
    t: 0,
    d: "返回带有14位小数的 PI 值。",
    a: "返回带有14位小数的 PI 值。",
    m: [0, 0],
    p: []
  }, {
    n: "FLOOR",
    t: 0,
    d: "将数值向下取整为指定因数的最接近的整数倍。",
    a: "将数值向下取整为指定因数的最接近的整数倍。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要向下舍入为因数的最接近整数倍的数值。",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因数",
      detail: "要将值舍入到此数的整数倍。\n\n因数不得为0。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GCD",
    t: 0,
    d: "返回一个或多个整数的最大公约数。",
    a: "返回一个或多个整数的最大公约数。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要在查找最大公约数的计算中检查其因数的第一项数值或范围。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可选] - 在求最大公约数时要考虑其因数的其他数值或范围。",
      example: "96",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANDBETWEEN",
    t: 0,
    d: "返回介于两个整数之间（包括这两个整数）的随机数。",
    a: "返回介于两个整数之间（包括这两个整数）的随机数。",
    m: [2, 2],
    p: [{
      name: "下界",
      detail: "随机值范围的下界。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "上界",
      detail: "随机值范围的上界。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUND",
    t: 0,
    d: "将数字四舍五入到指定的位数。",
    a: "将数字四舍五入到指定的位数。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要四舍五入的数字。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位数",
      detail: "要进行四舍五入运算的位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDDOWN",
    t: 0,
    d: "朝着零的方向将数字进行向下舍入。",
    a: "朝着零的方向将数字进行向下舍入。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "需要向下舍入的任意实数。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位数",
      detail: "要通过舍入达到的小数位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDUP",
    t: 0,
    d: "朝着远离 0（零）的方向将数字进行向上舍入。",
    a: "朝着远离 0（零）的方向将数字进行向上舍入。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要将其舍入为位数位数字的值，始终向上舍入。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位数",
      detail: "要通过舍入达到的小数位数。\n\n位数可以取负值，在这种情况下会将值的小数点左侧部分舍入到指定的位数。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SERIESSUM",
    t: 0,
    d: "给定参数 x、n、m 和 a，返回幂级数的和 a1xn + a2x(n+m) + ... + aix(n+(i-1)m)，其中 i 为范围 a 中的项数。",
    a: "给定参数 x、n、m 和 a",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "幂级数的输入值。随相应的近似类型而变，有可能为角度、指数或其他一些值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "在幂级数中x的初始自乘幂次。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "m",
      detail: "x的幂次中的附加增量。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "a",
      detail: "包含幂级数系数的数组或范围。",
      example: "{FACT(0)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIGN",
    t: 0,
    d: "给定输入数值，如果为负返回-1；如果为正返回1；如果为零则返回0。",
    a: "给定输入数值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要返回其符号的数值。",
      example: "-42",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIN",
    t: 0,
    d: "给定角度（以弧度表示），返回其正弦值。",
    a: "给定角度（以弧度表示）",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要返回其正弦值的角度，以弧度表示。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SINH",
    t: 0,
    d: "返回给定实数的双曲正弦值。",
    a: "返回给定实数的双曲正弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其双曲正弦值的实数值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRT",
    t: 0,
    d: "返回一个正数的正平方根。",
    a: "返回一个正数的正平方根。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要计算其正平方根的数值。\n\n值必须为正数；如果为负，SQRT 将返回 #NUM! 错误。",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRTPI",
    t: 0,
    d: "返回 PI 与给定正数乘积的正平方根。",
    a: "返回 PI 与给定正数乘积的正平方根。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要将其与 PI 相乘并返回该乘积的平方根的数值\n\n值必须为正数；如果为负数，SQRTPI 将返回 #NUM! 错误。",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GAMMALN",
    t: 1,
    d: "返回指定伽玛函数的以 e（欧拉数）为底的对数。",
    a: "返回指定伽玛函数的以 e（欧拉数）为底的对数。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "伽玛函数的输入值。返回的将是伽玛 (值) 的自然对数。\n\n值必须为正数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COS",
    t: 0,
    d: "返回给定角度的余弦值（角度以弧度表示）。",
    a: "返回给定角度的余弦值（角度以弧度表示）。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要取其余弦值的角度，以弧度表示。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRUNC",
    t: 0,
    d: "截除指定有效位之外的部分，取数据的指定有效位。",
    a: "截除指定有效位之外的部分",
    m: [1, 2],
    p: [{
      name: "值",
      detail: "要截取的数据。",
      example: "3.141592654",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位数",
      detail: "[可选 - 默认值为0] - 小数点右侧要保留的有效位数。\n\n如果位数大于值中的有效位数，则将“值”原样返回。\n\n位数可以取负值，在这种情况下会将小数点左侧指定位数的值更改为零。小数点右侧的所有位数都会被舍弃。如果值的所有位都被更改为零，则TRUNC会返回0。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUOTIENT",
    t: 0,
    d: "返回以一个数除以另一个数所得的结果，不包含余数。",
    a: "返回以一个数除以另一个数所得的结果",
    m: [2, 2],
    p: [{
      name: "被除数",
      detail: "要被除的数值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "除数",
      detail: "用于除其他数的数值。\n\n除数不得为0。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POWER",
    t: 0,
    d: "返回数值的指定次幂。",
    a: "返回数值的指定次幂。",
    m: [2, 2],
    p: [{
      name: "底数",
      detail: "要计算其指数次幂的数值。\n\n如果底数为负，则指数必须为整数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "指数",
      detail: "指定底数的自乘幂次值。",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMIFS",
    t: 0,
    d: "根据多项条件返回范围之和。",
    a: "根据多项条件返回范围之和。",
    m: [3, 257],
    p: [{
      name: "求和范围",
      detail: "要对其求和的范围。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "条件范围1",
      detail: "要在哪个范围内检查条件1。",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "条件1",
      detail: "要应用于条件范围1的模式或测试条件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "条件范围2, 条件2...",
      detail: "[ 可选 ] - 要检查的其他范围和条件。",
      example: " C1:C10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTIFS",
    t: 1,
    d: "根据多项条件返回范围中的单元格数量。",
    a: "根据多项条件返回范围中的单元格数量。",
    m: [2, 256],
    p: [{
      name: "条件范围1",
      detail: "要在哪个范围内检查条件1。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "条件1",
      detail: "要应用于条件范围1的模式或测试条件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "条件范围2, 条件2...",
      detail: "[ 可选 ] - 要检查的其他范围和条件，可重复。",
      example: " B1:B10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PRODUCT",
    t: 0,
    d: "返回将一组数相乘所得的结果。",
    a: "返回将一组数相乘所得的结果。",
    m: [1, 255],
    p: [{
      name: "乘数1",
      detail: "用于计算乘积的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "乘数2 ... 乘数30",
      detail: "[可选] - 要相乘的其他数值。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HARMEAN",
    t: 1,
    d: "计算数据集的调和平均值。",
    a: "计算数据集的调和平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HYPGEOMDIST",
    t: 1,
    d: "返回超几何分布。 如果已知样本量、总体成功次数和总体大小，则 HYPGEOM.DIST 返回样本取得已知成功次数的概率。",
    a: "返回超几何分布。",
    m: [5, 5],
    p: [{
      name: "Sample_s",
      detail: "样本中成功的次数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Number_sample",
      detail: "样本量。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Population_s",
      detail: "总体中成功的次数。",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Number_pop",
      detail: "总体大小。",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函数形式的逻辑值。\n\n如果 cumulative 为 TRUE()，则 HYPGEOM.DIST 返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INTERCEPT",
    t: 1,
    d: "计算数据集的线性回归方程直线与 Y 轴的相交点 (x=0) 的 y 值。",
    a: "计算数据集的线性回归方程直线与 Y 轴的相交点 (x=0) 的 y 值。",
    m: [2, 2],
    p: [{
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "KURT",
    t: 1,
    d: "计算数据集的峭度，该指标指示数据集（分布）的形态，尤其是该形态的陡峭程度。",
    a: "计算数据集的峭度",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "数据集中的第一个值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LARGE",
    t: 1,
    d: "返回数据集中第 n 个最大元素，n 由用户指定。",
    a: "返回数据集中第 n 个最大元素",
    m: [2, 2],
    p: [{
      name: "数据",
      detail: "包含相关数据集的数组或范围。",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "要返回的元素的排行位置（从大到小顺序）。\n\n例如，将n设为4将使LARGE返回数据中排名第4的最大元素。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVA",
    t: 1,
    d: "基于样本计算标准偏差，将文本取值为0。",
    a: "基于样本计算标准偏差",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2,…",
      detail: "[可选] - 样本中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVP",
    t: 1,
    d: "基于样本总体计算标准偏差。",
    a: "基于样本总体计算标准偏差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "数据集中的第一个值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "GEOMEAN",
    t: 1,
    d: "计算数据集的几何平均值。",
    a: "计算数据集的几何平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANK_EQ",
    t: 1,
    d: "返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回其中的最高排名。",
    a: "返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回其中的最高排名。",
    m: [2, 3],
    p: [{
      name: "number",
      detail: "要确定其排名的值。",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "ref",
      detail: "包含相关数据集的数组或范围。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "order",
      detail: "[可选 - 默认为按降序 (FALSE()) ] - 要按升序还是按降序考虑“data”中的值。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANK_AVG",
    t: 1,
    d: "返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回这些项排名的平均值。",
    a: "返回指定值在数据集中的排名。如果相同的值在数据集中存在多项，则返回这些项排名的平均值。",
    m: [2, 3],
    p: [{
      name: "number",
      detail: "要确定其排名的值。",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "ref",
      detail: "包含相关数据集的数组或范围。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "order",
      detail: "[可选 - 默认为按降序 (FALSE()) ] - 要按升序还是按降序考虑“data”中的值。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERCENTRANK_EXC",
    t: 1,
    d: "以百分数形式返回指定值在给定数据集中的百分比排名（介于0和1之间，不包括两端值）。",
    a: "以百分数形式返回指定值在给定数据集中的百分比排名（介于0和1之间，不包括两端值）。",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "包含相关数据集的数组或范围。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "x",
      detail: "要确定其百分比排位的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significance",
      detail: "[可选 - 默认值为 3] - 要在计算中使用的有效位数。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTRANK_INC",
    t: 1,
    d: "以百分比形式返回指定值在给定数据集中的百分比排名（介于0和1之间，包括两端值）。",
    a: "以百分比形式返回指定值在给定数据集中的百分比排名（介于0和1之间，包括两端值）。",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "包含相关数据集的数组或范围。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "x",
      detail: "要确定其百分比排位的值。",
      example: " A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significance",
      detail: "[可选 - 默认值为 3] - 要在计算中使用的有效位数。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FORECAST",
    t: 1,
    d: "基于数据集的线性回归，计算指定 x 的预期 y 值。",
    a: "基于数据集的线性回归",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "x轴上用于预测的值。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHERINV",
    t: 1,
    d: "返回指定数值的 Fisher 逆变换。",
    a: "返回指定数值的 Fisher 逆变换。",
    m: [1, 1],
    p: [{
      name: "y",
      detail: "要计算其Fisher逆变换的数值。",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHER",
    t: 1,
    d: "返回指定数值的 Fisher 变换。",
    a: "返回指定数值的 Fisher 变换。",
    m: [1, 1],
    p: [{
      name: "x",
      detail: "要计算其Fisher变换的数值。",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MODE_SNGL",
    t: 1,
    d: "返回数据集中出现次数最多的值。",
    a: "返回数据集中出现次数最多的值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算模式时要检查的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计算模式时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "WEIBULL_DIST",
    t: 1,
    d: "给定形状和尺度，返回韦伯分布函数（或韦伯累积分布函数）的值。",
    a: "给定形状和尺度",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "WEIBULL 分布函数的输入值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "alpha",
      detail: "Weibull 分布函数的形状参数。\n\nalpha 值必须大于 0。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "beta",
      detail: "Weibull 分布函数的尺度参数。\n\nbeta 值必须大于 0。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "TRUE() 表示使用累积分布函数，FALSE() 则表示使用概率密度函数。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COUNT",
    t: 1,
    d: "返回数据集中数值的个数。",
    a: "返回数据集中数值的个数。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计数时要检查的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计数时要检查的其他值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTA",
    t: 1,
    d: "返回数据集中值的数量。",
    a: "返回数据集中值的数量。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计数时要检查的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计数时要检查的其他值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVEDEV",
    t: 1,
    d: "计算数据与数据集均值之间的偏差大小的平均值。",
    a: "计算数据与数据集均值之间的偏差大小的平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 样本中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "AVERAGE",
    t: 1,
    d: "返回数据集的算术平均值，对文本忽略不计。",
    a: "返回数据集的算术平均值",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算平均值时用到的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计算平均值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEA",
    t: 1,
    d: "返回数据集的算术平均值。",
    a: "返回数据集的算术平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算平均值时用到的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计算平均值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_DIST",
    t: 1,
    d: "返回一元二项式分布的概率。",
    a: "返回一元二项式分布的概率。",
    m: [4, 4],
    p: [{
      name: "number_s",
      detail: "试验的成功次数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "trials",
      detail: "独立检验的次数。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一给定检验的成功概率。",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "是否使用二项式累积分布。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_INV",
    t: 1,
    d: "计算累积二项式分布大于或等于指定条件的最小值。",
    a: "计算累积二项式分布大于或等于指定条件的最小值。",
    m: [3, 3],
    p: [{
      name: "trials",
      detail: "贝努利试验次数。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一次给定检验的成功概率。",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "alpha",
      detail: "期望的临界概率。",
      example: "0.8",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONFIDENCE_NORM",
    t: 1,
    d: "计算正态分布的置信区间的一半宽度。",
    a: "计算正态分布的置信区间的一半宽度。",
    m: [3, 3],
    p: [{
      name: "alpha",
      detail: "用来计算置信水平的显著性水平。\n\n置信水平等于 100*(1 - alpha)%，亦即，如果 alpha 为 0.05，则置信水平为 95%。",
      example: "0.05",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "数据区域的总体标准偏差。",
      example: "1.6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "size",
      detail: "样本总量的大小。",
      example: "250",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CORREL",
    t: 1,
    d: "计算给定数据集的皮尔逊积矩相关系数 r。",
    a: "计算给定数据集的皮尔逊积矩相关系数 r。",
    m: [2, 2],
    p: [{
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_P",
    t: 1,
    d: "计算数据集的总体协方差。",
    a: "计算数据集的总体协方差。",
    m: [2, 2],
    p: [{
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_S",
    t: 1,
    d: "计算数据集的样本协方差。",
    a: "计算数据集的样本协方差。",
    m: [2, 2],
    p: [{
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEVSQ",
    t: 1,
    d: "基于样本计算其偏差的平方和。",
    a: "基于样本计算其偏差的平方和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 样本中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "EXPON_DIST",
    t: 1,
    d: "返回带有指定 Lambda 和指定值的指数分布函数的值。",
    a: "返回带有指定 Lambda 和指定值的指数分布函数的值。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "指数分布函数的输入值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "lambda",
      detail: "用于指定指数分布函数的 lambda 值。",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "是否使用指数累积分布。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIF",
    t: 1,
    d: "根据条件返回范围的平均值。",
    a: "根据条件返回范围的平均值。",
    m: [2, 3],
    p: [{
      name: "criteria_range",
      detail: "要对其检查 criterion 的范围。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion",
      detail: '要应用于 criteria_range 的模式或测试条件。\n\n等于："文本" 或 1 或 "=文本" 或 "=1"\n\n大于：">1"\n\n大于等于：">=1"\n\n小于："<1"\n\n小于等于："<=1"\n\n不等于："<>1"或"<>文本"',
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "average_range",
      detail: "[可选] - 要计算平均值的范围。如果未提供此参数，则改用 criteria_range 来计算平均值。",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIFS",
    t: 1,
    d: "根据多项条件返回范围的平均值。",
    a: "根据多项条件返回范围的平均值。",
    m: [2, 255],
    p: [{
      name: "average_range",
      detail: "要计算平均值的范围。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range1",
      detail: "要对其检查 criterion1 的范围。",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion1",
      detail: "要应用于 criteria_range1 的模式或测试条件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2, criterion2, ...",
      detail: "[可选] - 要检查的其他范围和条件。",
      example: " C1:C10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERMUT",
    t: 1,
    d: "返回可从数字对象中选择的给定数目对象的排列数。",
    a: "返回可从数字对象中选择的给定数目对象的排列数。",
    m: [2, 2],
    p: [{
      name: "number",
      detail: "表示对象个数的整数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_chosen",
      detail: "表示每个排列中对象个数的整数。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRIMMEAN",
    t: 1,
    d: "在排除数据集高低两端的部分数据之后计算所得的均值。",
    a: "在排除数据集高低两端的部分数据之后计算所得的均值。",
    m: [2, 2],
    p: [{
      name: "数据",
      detail: "包含相关数据集的数组或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "排除比例",
      detail: "要从数据集的极值部分排除的数据占数据集的比例。\n\n排除比例必须大于等于0且小于1。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_EXC",
    t: 1,
    d: "返回数组的 K 百分点值，K 介于 0 到 1 之间，不含 0 与 1。",
    a: "返回数组的 K 百分点值，K 介于 0 到 1 之间，不含 0 与 1。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "定义相对位置的数组或数据区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "0 到 1 之间的百分点值，不包含 0 和 1。",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_INC",
    t: 1,
    d: "返回数组的 K 百分点值，K 介于 0 到 1 之间，包含 0 与 1。",
    a: "返回数组的 K 百分点值，K 介于 0 到 1 之间，包含 0 与 1。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "定义相对位置的数组或数据区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "0 到 1 之间的百分点值，包含 0 和 1。",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PEARSON",
    t: 1,
    d: "返回皮尔生(Pearson)乘积矩相关系数 r。",
    a: "返回皮尔生(Pearson)乘积矩相关系数 r。",
    m: [2, 2],
    p: [{
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_INV",
    t: 1,
    d: "返回标准正态累积分布函数的反函数值。 该分布的平均值为 0，标准偏差为 1。",
    a: "返回标准正态累积分布函数的反函数值。 该分布的平均值为 0，标准偏差为 1。",
    m: [1, 1],
    p: [{
      name: "probability",
      detail: "对应于正态分布的概率。",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_DIST",
    t: 1,
    d: "返回标准正态分布函数（该分布的平均值为 0，标准偏差为 1）。",
    a: "返回标准正态分布函数（该分布的平均值为 0，标准偏差为 1）。",
    m: [2, 2],
    p: [{
      name: "z",
      detail: "需要计算其分布的数值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NORM_INV",
    t: 1,
    d: "返回指定平均值和标准偏差的正态累积分布函数的反函数值。",
    a: "返回指定平均值和标准偏差的正态累积分布函数的反函数值。",
    m: [3, 3],
    p: [{
      name: "probability",
      detail: "对应于正态分布的概率。",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分布的算术平均值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分布的标准偏差。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_DIST",
    t: 1,
    d: "返回指定平均值和标准偏差的正态分布函数。",
    a: "返回指定平均值和标准偏差的正态分布函数。",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "需要计算其分布的数值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分布的算术平均值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分布的标准偏差。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NEGBINOM_DIST",
    t: 1,
    d: "返回负二项式分布。",
    a: "返回负二项式分布。",
    m: [4, 4],
    p: [{
      name: "number_f",
      detail: "要模拟的失败次数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_s",
      detail: "要模拟的成功次数。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一次给定检验的成功概率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINA",
    t: 1,
    d: "返回数据集中的最小数值。",
    a: "返回数据集中的最小数值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算最小值时所用的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可选] - 在计算最小值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MIN",
    t: 1,
    d: "返回数值数据集中的最小值。",
    a: "返回数值数据集中的最小值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算最小值时所用的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可选] - 在计算最小值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MEDIAN",
    t: 1,
    d: "返回数值数据集中的中值。",
    a: "返回数值数据集中的中值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算中值时所用的第一个数值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可选] - 在计算中值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAXA",
    t: 1,
    d: "返回数据集中的最大数值。",
    a: "返回数据集中的最大数值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算最大值时所用的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 在计算最大值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAX",
    t: 1,
    d: "返回数值数据集中的最大值。",
    a: "返回数值数据集中的最大值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "计算最大值时所用的第一个值或范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可选] - 在计算最大值时要考虑的其他数值或范围。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_INV",
    t: 1,
    d: "返回 x 的对数累积分布函数的反函数值。",
    a: "返回 x 的对数累积分布函数的反函数值。",
    m: [3, 3],
    p: [{
      name: "probability",
      detail: "与对数分布相关的概率，介于 0 与 1 之间（不含 0 与 1）。",
      example: "0.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "ln(x) 的平均值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "ln(x) 的标准偏差，正数。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_DIST",
    t: 1,
    d: "返回 x 的对数分布函数。",
    a: "返回 x 的对数分布函数。",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "用来计算函数的值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "ln(x) 的平均值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "ln(x) 的标准偏差，正数。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函数形式的逻辑值。\n\n如果为 TRUE()，则返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "Z_TEST",
    t: 1,
    d: "返回 z 检验的单尾 P 值。",
    a: "返回 z 检验的单尾 P 值。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "用来检验 x 的数组或数据区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "x",
      detail: "要测试的值。",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sigma",
      detail: "[可选] - 总体（已知）标准偏差。 如果省略，则使用样本标准偏差。",
      example: "3",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PROB",
    t: 1,
    d: "返回区域中的数值落在指定区间内的概率。",
    a: "返回区域中的数值落在指定区间内的概率。",
    m: [3, 4],
    p: [{
      name: "x_range",
      detail: "具有各自相应概率值的 x 数值区域。",
      example: "A3:A6",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "prob_range",
      detail: "与 x_range 中的值相关联的一组概率值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "lower_limit",
      detail: "要计算其概率的数值下界。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "upper_limit",
      detail: "[可选 - 默认值为下界] - 要计算其概率的可选数值上界。\n\n如果省略上界，PROB则计算随机选取相应值的次数恰好等于下界的概率。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_EXC",
    t: 1,
    d: "基于 0 到 1 之间（不包括 0 和 1）的百分点值返回数据集的四分位数。",
    a: "基于 0 到 1 之间（不包括 0 和 1）的百分点值返回数据集的四分位数。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "要求得四分位数值的数组或数字型单元格区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quart",
      detail: "要返回第几个四分位值。\n\n1返回数据中最靠近第一个四分位值的值（25%标记）。\n\n2返回数据中最接近中值的值（50%标记）。\n\n3返回数据中最接近第三个四分位值的值（75%标记）。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_INC",
    t: 1,
    d: "根据 0 到 1 之间的百分点值（包含 0 和 1）返回数据集的四分位数。",
    a: "根据 0 到 1 之间的百分点值（包含 0 和 1）返回数据集的四分位数。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "要求得四分位数值的数组或数字型单元格区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quart",
      detail: "要返回第几个四分位值。\n\n0返回数据中的最小值（0%标记）。\n\n1返回数据中最靠近第一个四分位值的值（25%标记）。\n\n2返回数据中最接近中值的值（50%标记）。\n\n3返回数据中最接近第三个四分位值的值（75%标记）。\n\n4返回数据中的最大值（100%标记）。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POISSON_DIST",
    t: 1,
    d: "返回泊松分布。",
    a: "返回泊松分布。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "事件数。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "期望值。非负数",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "一逻辑值，确定所返回的概率分布的形式。\n\n如果为 TRUE()，则返回发生的随机事件数在零（含零）和 x（含 x）之间的累积泊松概率；\n\n如果为 FALSE()，则返回发生的事件数正好是 x 的泊松概率密度函数。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RSQ",
    t: 1,
    d: "返回皮尔生(Pearson)乘积矩相关系数 r 的平方。",
    a: "返回皮尔生(Pearson)乘积矩相关系数 r 的平方。",
    m: [2, 2],
    p: [{
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST",
    t: 1,
    d: "返回学生的左尾 t 分布。",
    a: "返回学生的左尾 t 分布。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "T-分布函数的输入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度数值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "决定函数形式的逻辑值。\n\n如果 cumulative 为 TRUE()，则 HYPGEOM.DIST 返回累积分布函数；\n\n如果为 FALSE()，则返回概率密度函数。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T_DIST_2T",
    t: 1,
    d: "返回学生的双尾 t 分布。",
    a: "返回学生的双尾 t 分布。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "T-分布函数的输入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度数值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST_RT",
    t: 1,
    d: "返回学生的右尾 t 分布。",
    a: "返回学生的右尾 t 分布。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "T-分布函数的输入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度数值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV",
    t: 1,
    d: "返回学生的 t 分布的左尾反函数。",
    a: "返回学生的 t 分布的左尾反函数。",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "与学生的 t 分布相关的概率。\n\n必须大于 0 且小于 1。",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "deg_freedom",
      detail: "自由度数值。\n\n如果所提供的参数不是整数，将截取其整数部分。\n\n必须大于等于 1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV_2T",
    t: 1,
    d: "返回学生 t 分布的双尾反函数。",
    a: "返回学生 t 分布的双尾反函数。",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "与学生的 t 分布相关的概率。\n\n必须大于 0 且小于1。",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "deg_freedom",
      detail: "自由度数值。\n\n如果所提供的参数不是整数，将截取其整数部分。\n\n必须大于等于 1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_TEST",
    t: 1,
    d: "返回与t-检验相关的概率。用于判断两个样本是否可能是出自平均值相同的两个样本总体。",
    a: "返回与t-检验相关的概率。用于判断两个样本是否可能是出自平均值相同的两个样本总体。",
    m: [4, 4],
    p: [{
      name: "array1",
      detail: "将用于 t 检验的第一个数据样本或第一组单元格。",
      example: "A1:A4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "将用于 t 检验的第二个数据样本或第二组单元格。",
      example: "B1:B4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "指定分布的尾数。\n\n如果为 1：使用单尾分布。\n\n如果为 2：使用双尾分布。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定 t 检验的类型。\n\n如果为 1：执行配对检验。\n\n如果为 2：执行双样本等方差（同方差）检验。\n\n如果为3：执行双样本不等方差（异方差）检验。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "F_DIST",
    t: 1,
    d: "给定输入值 x，计算两个数据集的左尾 F 概率分布（差异程度）。此分布也称为 Fisher-Snedecor 分布或 Snedecor F 分布。",
    a: "给定输入值 x",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "用来计算函数的值。",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "分子自由度。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "分母自由度。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "用于确定函数形式的逻辑值。默认值为 FALSE。\n\n如果为 TRUE()：F.DIST 将返回累积分布函数值。\n\n如果为 FALSE()：F.DIST 将返回概率密度函数值。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "F_DIST_RT",
    t: 1,
    d: "给定输入x，计算两个数据集的右尾F概率分布（差异程度）。 此分布也称为Fisher-Snedecor分布或Snedecor F分布。",
    a: "给定输入x",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "用来计算函数的值。",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "分子自由度。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "分母自由度。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_P",
    t: 1,
    d: "基于样本总体计算方差。",
    a: "基于样本总体计算方差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "数据集中的第一个值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, …",
      detail: "[可选] - 数据集中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_S",
    t: 1,
    d: "基于样本计算方差。",
    a: "基于样本计算方差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, …",
      detail: "[可选] - 样本中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARA",
    t: 1,
    d: "基于样本计算方差，将文本取值为0。",
    a: "基于样本计算方差",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2, ...",
      detail: "[可选] - 样本中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARPA",
    t: 1,
    d: "基于样本总体计算方差，将文本取值为0。",
    a: "基于样本总体计算方差",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "样本中的第一项值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他数值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STEYX",
    t: 1,
    d: "返回通过线性回归法预测每个 x 的 y 值时所产生的标准误差。",
    a: "返回通过线性回归法预测每个 x 的 y 值时所产生的标准误差。",
    m: [2, 2],
    p: [{
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STANDARDIZE",
    t: 1,
    d: "给定分布的均值和标准偏差，计算一个随机变量正态化的相应值。",
    a: "给定分布的均值和标准偏差，计算一个随机变量正态化的相应值。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "要正态化的随机变量值。",
      example: "96",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分布的均值。",
      example: "80",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分布的标准偏差。",
      example: "6.7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SMALL",
    t: 1,
    d: "返回数据集中的第 k 个最小值。",
    a: "返回数据集中的第 k 个最小值。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "需要找到第 k 个最小值的数组或数值数据区域。",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "k",
      detail: "要返回的数据在数组或数据区域里的位置（从小到大）。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLOPE",
    t: 1,
    d: "计算通过数据集的线性回归得到的直线的斜率。",
    a: "计算通过数据集的线性回归得到的直线的斜率。",
    m: [2, 2],
    p: [{
      name: "数据_y",
      detail: "代表因变量数据数组或矩阵的范围。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "数据_x",
      detail: "代表自变量数据数组或矩阵的范围。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SKEW",
    t: 1,
    d: "返回分布的偏斜度。 偏斜度表明分布相对于平均值的不对称程度。 正偏斜度表明分布的不对称尾部趋向于更多正值。 负偏斜度表明分布的不对称尾部趋向于更多负值。",
    a: "返回分布的偏斜度。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "数据集中的第一个值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SKEW_P",
    t: 1,
    d: "返回基于样本总体的分布不对称度：表明分布相对于平均值的不对称程度。",
    a: "返回基于样本总体的分布不对称度：表明分布相对于平均值的不对称程度。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "数据集中的第一个值或范围。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可选] - 数据集中包含的其他值或范围。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "VLOOKUP",
    t: 2,
    d: "纵向查找。在范围的第一列中自上而下搜索某个键值，并返回所找到的行中指定单元格的值。",
    a: "纵向查找。在范围的第一列中自上而下搜索某个键值",
    m: [3, 4],
    p: [{
      name: "搜索键值",
      detail: '要搜索的值，如 42、"Cats" 或 I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "范围",
      detail: "要进行搜索的范围。VLOOKUP 将在该范围的第一列中搜索搜索键值中指定的键值。",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "索引",
      detail: "要返回的值的列索引，范围中的第一列编号为 1。\n\n如果索引不是介于 1 和范围中的列数之间，将返回 #VALUE! 。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "已排序",
      detail: "[默认值为 TRUE() ] - 指示要搜索的列（指定范围的第一列）是否已排序。大多数情况下，建议设为 FALSE()。\n\n建议将已排序设为 FALSE。如果设为 FALSE，将返回完全匹配项。如果存在多个匹配值，将返回找到的第一个值对应的单元格的内容，如果找不到匹配值，则返回 #N/A。\n\n如果将已排序设为 TRUE 或省略，将返回（小于或等于搜索键值的）最接近的匹配项。如果搜索的列中所有的值均大于搜索键值，则返回 #N/A。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HLOOKUP",
    t: 2,
    d: "横向查找。在范围的第一行中搜索某个键值，并返回所找到的列中指定单元格的值。",
    a: "横向查找。在范围的第一行中搜索某个键值",
    m: [3, 4],
    p: [{
      name: "搜索键值",
      detail: '要搜索的值。例如，42、"Cats"或I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "范围",
      detail: "要进行搜索的范围。将在该范围的第一行中搜索在搜索键值中指定的键值。",
      example: "A2:Z6",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "索引",
      detail: "要返回的值的行索引，范围中的第一行编号为1。\n\n如果索引不是介于1和范围中的行数之间，将返回#VALUE!。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "已排序",
      detail: "[可选 - 默认值为TRUE()] - 指示要搜索的行（指定范围的第一行）是否已排序。\n\n如果将已排序设为TRUE或省略，将返回最接近的匹配值（小于或等于搜索键值）。如果在搜索的行中所有的值均大于搜索键值，则返回#N/A。\n\n如果将已排序设为TRUE或将其省略，而范围的首行并非处于已排序状态，则返回值可能会是错误的。\n\n如果将已排序设为FALSE，则仅返回完全匹配。如果存在多个匹配值，将返回与找到的第一个值对应的单元格的内容，如果找不到匹配值则返回#N/A。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOOKUP",
    t: 2,
    d: "在行或列中查找相应键，并将相应单元格的值返回到与搜索行或列所在位置相同的结果范围中。",
    a: "在行或列中查找相应键",
    m: [2, 3],
    p: [{
      name: "搜索键值",
      detail: '要在行或列中搜索的值。例如，42、"Cats" 或 I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "搜索范围 | 搜索结果数组",
      detail: "使用 LOOKUP 的一种方法是给定单行或单列形式的搜索范围进行搜索查找，这种方式要用到另一个参数结果范围。另一种方式是将这两个参数合并为一个搜索结果数组，其中第一行或第一列用于搜索，并将返回值放在该数组的最后一行或最后一列中。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "结果范围",
      detail: "[ 可选 ] - 用于存放返回结果的范围。返回值对应于在搜索范围中找到搜索键值的位置。此范围必须仅为单行或单列，而如果您使用的是搜索结果数组方式，则不应提供此参数。",
      example: "B1:B100",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADDRESS",
    t: 2,
    d: "返回字符串形式的单元格引用。",
    a: "返回字符串形式的单元格引用。",
    m: [2, 5],
    p: [{
      name: "row_num",
      detail: "一个数值，指定要在单元格引用中使用的行号。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column_num",
      detail: "一个数值，指定要在单元格引用中使用的列号（而非名称）。A列的编号为1。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "abs_num",
      detail: "[可选 - 默认值为1] - 一个数值，指定要返回的引用类型。\n\n1 表示行列均采用绝对值（例如$A$1）；\n\n2 表示采用绝对行号，相对列标（例如A$1）；\n\n3 表示采用相对行号，绝对列标（例如$A1）；\n\n4 表示行列均采用相对值（例如A1）。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "A1",
      detail: "[可选 - 默认值为TRUE()] - 一个布尔值，指示采用A1标记形式(TRUE)还是R1C1标记形式(FALSE)。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sheet_text",
      detail: "[可选 - 默认缺省] - 用于指定地址所指向的工作表名称。",
      example: '"Sheet2"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INDIRECT",
    t: 2,
    d: "返回以字符串指定的单元格引用。",
    a: "返回以字符串指定的单元格引用。",
    m: [1, 2],
    p: [{
      name: "ref_text",
      detail: "以带引号的字符串形式提供的单元格引用。",
      example: '"Sheet2!"&B10',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "A1",
      detail: "[可选 - 默认值为TRUE()] - 一个布尔值，指示采用A1标记形式(TRUE)还是R1C1标记形式(FALSE)。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROW",
    t: 2,
    d: "返回指定单元格的行号",
    a: "返回指定单元格的行号",
    m: [0, 1],
    p: [{
      name: "reference",
      detail: "[可选 - 默认为此公式所在的单元格] - 要返回其行号的单元格。\n\n如果单元格引用指向的范围其宽度大于一个单元格，而此公式不是用作数组公式的，这时会仅返回单元格引用中首行的编号值。",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROWS",
    t: 2,
    d: "返回指定数组或范围中的行数。",
    a: "返回指定数组或范围中的行数。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要返回其行数的范围。",
      example: "A9:A62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COLUMN",
    t: 2,
    d: "按照 `A=1` 的规则返回指定单元格的列号。",
    a: "按照 `A=1` 的规则返回指定单元格的列号。",
    m: [0, 1],
    p: [{
      name: "reference",
      detail: "[可选 - 默认为包含此公式的单元格] - 要返回其列号的单元格。A列对应的编号为1。\n\n如果单元格引用是宽度超过一个单元格的范围，而此公式不是作为数组公式来使用的，因此将返回单元格引用中的第一列的位置。",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNS",
    t: 2,
    d: "返回指定数组或范围中的列数。",
    a: "返回指定数组或范围中的列数。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要返回其列数的范围。",
      example: "A9:W62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OFFSET",
    t: 2,
    d: "给定某范围的起始单元格引用以及该范围涵盖的行列数量，返回该范围的引用。",
    a: "给定某范围的起始单元格引用以及该范围涵盖的行列数量，返回该范围的引用。",
    m: [3, 5],
    p: [{
      name: "reference",
      detail: "用于计算行列偏移量的起点。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rows",
      detail: "要偏移的行数。\n\n行偏移量必须是整数，但也可以是负数。如果提供的参数带有小数，小数部分将被截去。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "要偏移的列数。\n\n列偏移量必须是整数，但也可以是负数。如果提供的参数带有小数，小数部分将被截去。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "height",
      detail: "[可选] - 要从偏移目标开始返回的范围的高度。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "width",
      detail: "[可选] - 要从偏移目标开始返回的范围的宽度。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MATCH",
    t: 2,
    d: "在单元格中搜索指定项，然后返回该项在单元格区域中的相对位置。",
    a: "在单元格中搜索指定项，然后返回该项在单元格区域中的相对位置。",
    m: [2, 3],
    p: [{
      name: "lookup_value",
      detail: "要在 lookup_array 中匹配的值。",
      example: '"Sunday"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "lookup_array",
      detail: "要搜索的单元格区域。\n\n如果所用的范围的高度和宽度均大于1，MATCH将返回#N/A!。",
      example: "A2:A9",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "match_type",
      detail: "[可选 - 默认值为1] - 要采用的搜索方式。\n\n1为默认类型，此时MATCH会假设范围已按升序排序，并返回小于等于搜索键值的最大值。\n\n0表示完全匹配，在范围未排序的情况下需要使用此方式。\n\n-1让MATCH假设范围是按降序排序的，并返回大于等于搜索键值的最小值。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INDEX",
    t: 2,
    d: "返回表格或中的元素值，此元素由行号和列号的索引值给定。",
    a: "返回表格或中的元素值，此元素由行号和列号的索引值给定。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "单元格区域或数组常量。",
      example: "A1:C20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "row_num",
      detail: "选择数组中的某行，函数从该行返回数值。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column_num",
      detail: "选择数组中的某列，函数从该列返回数值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GETPIVOTDATA",
    t: 2,
    d: "从与指定行和列标题对应的数据透视表中提取汇总值。",
    a: "从与指定行和列标题对应的数据透视表中提取汇总值。",
    m: [2, 254],
    p: [{
      name: "data_field",
      detail: "您想从数据透视表中获取其数据的值名称。\n值名称必须括在引号中或是指向包含相关文本的任何单元格的引用。\n如果有多个值字段，则必须使用数据透视表中显示的确切名称（如“销售总额”）。",
      example: '"SUM of number of units"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pivot_table",
      detail: "目标数据透视表中的任何单元格的引用（推荐位于顶角的单元格）。",
      example: "'Pivot table'!A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "field1",
      detail: "[可选] - 源数据集（不是数据透视表）中列的名称。",
      example: '"division"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }, {
      name: "item1",
      detail: "[可选] - 数据透视表中显示的与您要检索的字段名称 1 相对应的行或列的名称。",
      example: '"east"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CHOOSE",
    t: 2,
    d: "基于索引返回选项列表中的元素。",
    a: "基于索引返回选项列表中的元素。",
    m: [2, 255],
    p: [{
      name: "index_num",
      detail: "指定要返回哪一项。\n\n如果索引为零、负值或大于提供的选择数量，将返回#VALUE!错误。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value1",
      detail: "一项可能的返回值。必须提供。可以是单元格引用或单独的值。",
      example: '"A"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "[可选] - 其他可以选择的值。选择",
      example: '"B"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "HYPERLINK",
    t: 2,
    d: "在单元格内创建一个超链接。",
    a: "在单元格内创建一个超链接。",
    p: [{
      name: "网址",
      detail: "以引号括住的链接位置的完整网址，或对包含这种网址的单元格的引用。\n\n仅允许某些链接类型。其中包括：http://、https://、mailto:、aim:、ftp://、gopher://、telnet://和news://，明确禁用使用其他协议。如果指定的是其他协议，将会在单元格中显示链接标签，但该标签不会以链接形式呈现。\n\n如果未指定协议，则假设使用http://，并将其作为网址的前缀。",
      example: '"http://www.google.com/"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "链接标签",
      detail: '[可选 - 默认为网址] - 要在单元格中作为链接显示的文本（用引号括起来的），或者指向包含这种标签的单元格的引用。\n\n如果链接标签是指向某个空单元格的引用，如果网址有效，就将其作为链接显示，否则作为纯文本显示。\n\n如果链接标签为空字符串常量("")，所在单元格显示的内容将为空白，但通过点击该单元格或转入该单元格仍然可以访问链接。',
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TIME",
    t: 6,
    d: "将给定的小时、分钟和秒转换为时间。",
    a: "将给定的小时、分钟和秒转换为时间。",
    m: [3, 3],
    p: [{
      name: "小时",
      detail: "0（零）到 32767 之间的数字，代表小时。\n\n任何大于 23 的值都会除以 24，余数将作为小时值。",
      example: "11",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "分钟",
      detail: "0（零）到 32767 之间的数字，代表分钟。\n\n任何大于 59 的值将转换为小时和分钟。",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "秒",
      detail: "0（零）到 32767 之间的数字，代表秒。\n\n任何大于 59 的值将转换为小时、分钟和秒。",
      example: "59",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TIMEVALUE",
    t: 6,
    d: "按一天24小时返回该时间的分数表示。",
    a: "按一天24小时返回该时间的分数表示。",
    m: [1, 1],
    p: [{
      name: "time_text",
      detail: "用于表示时间的字符串。",
      example: '"2:15 PM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EOMONTH",
    t: 6,
    d: "返回某个月份最后一天的序列号，该月份在另一个日期之前或之后的数个月（月数由参数指定）。",
    a: "返回某个月份最后一天的序列号",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "用于计算结果的参照日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "用于计算的起始日期之前（负）或之后（正）的月数。返回的是计算所得月份的最后那天。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EDATE",
    t: 6,
    d: "返回表示某个日期的序列号，该日期在另一个日期的数月之前/之后。",
    a: "返回表示某个日期的序列号",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "用于计算结果的参照日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "用于计算的起始日期之前（负）或之后（正）的月数。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SECOND",
    t: 6,
    d: "返回时间值的秒数。 秒数是 0（零）到 59 范围内的整数。",
    a: "返回时间值的秒数。 秒数是 0（零）到 59 范围内的整数。",
    m: [1, 1],
    p: [{
      name: "时间",
      detail: "用于计算秒钟部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINUTE",
    t: 6,
    d: "以数字格式返回特定时间的分钟部分。",
    a: "以数字格式返回特定时间的分钟部分。",
    m: [1, 1],
    p: [{
      name: "时间",
      detail: "用于计算分钟部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HOUR",
    t: 6,
    d: "以数字格式返回特定时间的小时部分。",
    a: "以数字格式返回特定时间的小时部分。",
    m: [1, 1],
    p: [{
      name: "时间",
      detail: "用于计算小时部分的时间。必须为以下值之一：指向包含日期/时间值的单元格的引用、返回日期/时间的函数或者数字。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOW",
    t: 6,
    d: "以日期值格式返回当前日期和时间。",
    a: "以日期值格式返回当前日期和时间。",
    m: [0, 0],
    p: []
  }, {
    n: "NETWORKDAYS",
    t: 6,
    d: "返回所提供的两个日期之间的净工作日天数。",
    a: "返回所提供的两个日期之间的净工作日天数。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "用于计算净工作日天数的时间段开始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "用于计算净工作日天数的时间段结束日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[可选] - 一个范围或数组常量，其中包含作为节假日的日期序号。\n\n在节假日数组中提供的值必须是日期序号值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由范围指定的值应该是标准的日期值或日期序数值。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NETWORKDAYS_INTL",
    t: 6,
    d: "返回给定的两个日期之间的净工作日天数（排除指定的周末和节假日）。",
    a: "返回给定的两个日期之间的净工作日天数（排除指定的周末和节假日）。",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "用于计算净工作日天数的时间段开始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "用于计算净工作日天数的时间段结束日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "weekend",
      detail: "[可选 - 默认值为1] - 用于表示哪些天为周末的数字或字符串。\n字符串方式：可以使用由0和1组成的字符串来指定周末，串中的第一个数字字符代表周一，最后一个则代表周日。零表示这一天是工作日，1表示这一天为周末。例如，“0000011”表示将周六和周日作为周末。\n数字方式：这种方式不使用上述字符串形式，而是使用一个数字。1 =周六/周日为周末，2 =周日/周一为周末，依此类推则7 =周五/周六。11 =周日为唯一周末，12 =周一为唯一周末，依此类推则17 =周六为唯一周末。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[ 可选 ] - 这是一个范围或数组常量，其中包含作为节假日的日期。\n在节假日数组内提供的值必须为日期序数值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由范围指定的值应该是标准的日期值或日期序数值。",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISOWEEKNUM",
    t: 6,
    d: "返回给定日期在全年中的 ISO 周数。",
    a: "返回给定日期在全年中的 ISO 周数。",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "用于日期和时间计算的日期-时间代码。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WEEKNUM",
    t: 6,
    d: "返回特定日期的周数。",
    a: "返回特定日期的周数。",
    m: [1, 2],
    p: [{
      name: "serial_number",
      detail: "要确定其位于第几周的日期，必须是对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "return_type",
      detail: "[可选 - 默认值为 1 ] - 代表一周起始日的数字，系统也使用该数字来确定一年的第一周（1=周日，2=周一）。",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "WEEKDAY",
    t: 6,
    d: "返回一个数字，对应于给定日期所在的星期几。",
    a: "返回一个数字，对应于给定日期所在的星期几。",
    m: [1, 2],
    p: [{
      name: "serial_number",
      detail: "要为其确定星期几的日期。必须是对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "return_type",
      detail: "[可选 - 默认值为 1] - 以数字指示使用哪种编号顺序来表示星期几。默认情况下，按星期日 (= 1) 开始计算。\n\n如果类型为 1，则星期值将从星期日开始算起，并且星期日的值为 1，因此星期六的值就是 7。\n\n如果类型为 2，则星期值将从星期一开始算起，并且星期一的值为 1，因此星期日的值就是 7。\n\n如果类型为 3，则星期值将从星期一算起，并且星期一的值为 0，因此星期日的值就是 6。",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DAY",
    t: 6,
    d: "以数字格式返回特定日期所在的当月几号。",
    a: "以数字格式返回特定日期所在的当月几号。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "要从中提取具体几号的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS",
    t: 6,
    d: "返回两个日期之间的天数。",
    a: "返回两个日期之间的天数。",
    m: [2, 2],
    p: [{
      name: "end_date",
      detail: "计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "2011-3-15",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_date",
      detail: "计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "2011-2-1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS360",
    t: 6,
    d: "按照每年360天，返回两个日期之间的差（用于计算利息）。",
    a: "按照每年360天，返回两个日期之间的差（用于计算利息）。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "method",
      detail: "[可选 - 默认为FALSE()] - 指示要使用哪种天数计算方法。\n\nFALSE - 采用美国 (NASD) 方法时，如果起始日期为某月的最后一天，为便于计算，会将起始日期的当月几号更改为30。此外，如果结束日期是所在月份的最后一天，而且起始日期在其所在月的30号之前，则将结束日期更改为结束日期之后那个月的第一天，否则将结束日期更改为该月的30号。\n\nTRUE - 采用欧洲方法时，会将所有日期在31号的起始日期或结束日期更改为当月的30号。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATE",
    t: 6,
    d: "将提供的年、月、日转换为日期。",
    a: "将提供的年、月、日转换为日期。",
    m: [3, 3],
    p: [{
      name: "year",
      detail: "日期的年份部分，包含一到四位数字。\n\n介于 0（零）到 1899 之间，会将该值与 1900 相加来计算年份；\n\n介于 1900 到 9999 之间，将使用该数值作为年份；\n\n小于 0 或大于等于 10000，返回 错误值 #NUM!。",
      example: "1969",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "日期的月份部分，一个正整数或负整数。\n\n如果 month 大于 12，则 month 会将该月份数与指定年中的第一个月相加。\n\n如果 month 小于 1，month 则从指定年份的一月份开始递减该月份数，然后再加上 1 个月。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day",
      detail: "日期的日部分，一个正整数或负整数。\n\n如果 day 大于月中指定的天数，则 day 会将天数与该月中的第一天相加。\n\n如果 day 小于 1，则 day 从指定月份的第一天开始递减该天数，然后再加上 1 天。",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATEVALUE",
    t: 6,
    d: "将提供的日期字符串转换为日期的序列号。",
    a: "将提供的日期字符串转换为日期的序列号。",
    m: [1, 1],
    p: [{
      name: "date_text",
      detail: "表示日期的字符串。",
      example: '"1969-7-20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATEDIF",
    t: 6,
    d: "计算两个日期之间的天数、月数或年数。",
    a: "计算两个日期之间的天数、月数或年数。",
    m: [3, 3],
    p: [{
      name: "起始日期",
      detail: "计算中要使用的开始日期。必须是对包含DATE值的单元格的引用、返回DATE类型的函数或数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "结束日期",
      detail: "计算中要使用的结束日期。必须是对包含DATE值的单元格的引用、返回DATE类型的函数或数字。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "单位",
      detail: '时间单位的缩写文字。例如 "M" 代表月。有效值包括："Y"、"M"、"D"、"MD"、"YM" 和 "YD"。\n\n"Y"：返回起始日期和结束日期之间的整年数。\n\n"M"：返回起始日期和结束日期之间的整月数。\n\n"D"：返回起始日期和结束日期之间的天数。\n\n"MD"：返回起始日期和结束日期之间的天数（不计整月数）。\n\n"YM"：返回起始日期和结束日期之间的整月数（不计整年数）。\n\n"YD"：返回起始日期和结束日期之间的天数（假设起始日期和结束日期的间隔不超过一年）。',
      example: "16)",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY",
    t: 6,
    d: "指定工作日天数，计算结束日期。",
    a: "指定工作日天数，计算结束日期。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "计算的开始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "days",
      detail: "start_date 之前或之后不含周末及节假日的天数。\n\n为正值将生成未来日期；\n\n为负值生成过去日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "holidays",
      detail: "[可选] - 一个范围或数组常量，其中包含作为节假日的日期序号。\n\n在节假日数组中提供的值必须是日期序号值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由范围指定的值应该是标准的日期值或日期序数值。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY_INTL",
    t: 6,
    d: "返回指定的若干个工作日之前或之后的日期的序列号（使用自定义周末参数）。 ",
    a: "返回指定的若干个工作日之前或之后的日期的序列号（使用自定义周末参数）。 ",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "开始日期（将被截尾取整）。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "days",
      detail: "start_date 之前或之后的工作日的天数。\n\n正值表示未来日期；\n\n负值表示过去日期；\n\n零值表示开始日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "weekend",
      detail: "[可选 - 默认值为1] - 用于表示哪些天为周末的数字或字符串。\n字符串方式：可以使用由0和1组成的字符串来指定周末，串中的第一个数字字符代表周一，最后一个则代表周日。零表示这一天是工作日，1表示这一天为周末。例如，“0000011”表示将周六和周日作为周末。\n数字方式：这种方式不使用上述字符串形式，而是使用一个数字。1 =周六/周日为周末，2 =周日/周一为周末，依此类推则7 =周五/周六。11 =周日为唯一周末，12 =周一为唯一周末，依此类推则17 =周六为唯一周末。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[ 可选 ] - 这是一个范围或数组常量，其中包含作为节假日的日期。\n在节假日数组内提供的值必须为日期序数值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由范围指定的值应该是标准的日期值或日期序数值。",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEAR",
    t: 6,
    d: "返回对应于某个日期的年份。 Year 作为 1900 - 9999 之间的整数返回。",
    a: "返回对应于某个日期的年份。 Year 作为 1900 - 9999 之间的整数返回。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "用于计算年份的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEARFRAC",
    t: 6,
    d: "返回 start_date 和 end_date 之间的天数占全年天数的百分比。",
    a: "返回 start_date 和 end_date 之间的天数占全年天数的百分比。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "计算中要使用的开始日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "计算中要使用的结束日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 要使用的日计数基准类型。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TODAY",
    t: 6,
    d: "以日期值格式返回当前日期。",
    a: "以日期值格式返回当前日期。",
    m: [0, 0],
    p: []
  }, {
    n: "MONTH",
    t: 6,
    d: "返回日期（以序列数表示）中的月份。 月份是介于 1（一月）到 12（十二月）之间的整数。",
    a: "返回日期（以序列数表示）中的月份。 月份是介于 1（一月）到 12（十二月）之间的整数。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "要从中提取月份的日期。必须是以下一种：对包含日期的单元格的引用、返回日期类型的函数或者数字。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EFFECT",
    t: 8,
    d: "根据名义利率及每年的复利计息期数来计算实际年利率。",
    a: "根据名义利率及每年的复利计息期数来计算实际年利率。",
    m: [2, 2],
    p: [{
      name: "nominal_rate",
      detail: "每年的名义利率。",
      example: "0.99",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "npery",
      detail: "每年的复利计算期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLAR",
    t: 12,
    d: "将数字格式设置为与语言区域相对应的货币格式。",
    a: "将数字格式设置为与语言区域相对应的货币格式。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: "要设置格式的值。",
      example: "1.2351",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "decimals",
      detail: "[可选 - 默认值为 2] - 要显示的小数位数。\n\n如果这是负数，则将数字四舍五入到小数点左侧。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARDE",
    t: 8,
    d: "将以整数部分和分数部分转换为以小数部分表示的金额数字",
    a: "将以整数部分和分数部分转换为以小数部分表示的金额数字",
    m: [2, 2],
    p: [{
      name: "fractional_dollar",
      detail: "以整数部份和分数部分表示的数字，用小数点隔开。",
      example: "100.10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fraction",
      detail: "用作分数中的分母的整数。",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARFR",
    t: 8,
    d: "将小数转换为分数表示的金额数字。",
    a: "将小数转换为分数表示的金额数字。",
    m: [2, 2],
    p: [{
      name: "decimal_dollar",
      detail: "小数。",
      example: "100.125",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fraction",
      detail: "用作分数中的分母的整数。",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DB",
    t: 8,
    d: "使用固定余额递减法，返回指定期间内某项固定资产的折旧值。",
    a: "使用固定余额递减法，返回指定期间内某项固定资产的折旧值。",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "资产原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折旧末尾时的值（有时也称为资产残值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "资产的折旧期数（有时也称作资产的使用寿命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限内要计算折旧的折旧期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "[可选 - 默认值为12] - 折旧第一年中的月数。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DDB",
    t: 8,
    d: "用双倍余额递减法，返回指定期间内某项固定资产的折旧值。",
    a: "用双倍余额递减法，返回指定期间内某项固定资产的折旧值。",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "资产原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折旧末尾时的值（有时也称为资产残值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "资产的折旧期数（有时也称作资产的使用寿命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限内要计算折旧的折旧期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "[可选 - 默认值为2] - 折旧的递减系数。",
      example: "2.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RATE",
    t: 8,
    d: "返回年金每期的利率。",
    a: "返回年金每期的利率。",
    m: [3, 6],
    p: [{
      name: "nper",
      detail: "年金的付款总期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "每期的付款金额，在年金周期内不能更改。",
      example: "-100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值即一系列未来付款当前值的总和。",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选 - 默认值为0] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "guess",
      detail: "[可选 - 默认值为0.1] - 预期利率。",
      example: "0.1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CUMPRINC",
    t: 8,
    d: "基于等额分期付款和固定利率，计算投资在多个付款期内的累计本金偿还额。",
    a: "基于等额分期付款和固定利率，计算投资在多个付款期内的累计本金偿还额。",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "总付款期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "年金的现值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_period",
      detail: "开始累计计算的付款期序号。\n\n首期必须大于等于1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_period",
      detail: "结束累计计算的付款期序号。\n\n末期必须大于首期。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNUM",
    t: 8,
    d: "返回在结算日和到期日之间的付息次数，向上舍入到最近的整数。",
    a: "返回在结算日和到期日之间的付息次数，向上舍入到最近的整数。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。到期日是有价证券有效期截止时的日期。",
      example: "02",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SYD",
    t: 8,
    d: "返回在指定期间内资产按年限总和折旧法计算的折旧。",
    a: "返回在指定期间内资产按年限总和折旧法计算的折旧。",
    m: [4, 4],
    p: [{
      name: "cost",
      detail: "资产原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折旧末尾时的值（有时也称为资产残值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "资产的折旧期数（有时也称作资产的使用寿命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限内要计算折旧的折旧期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLEQ",
    t: 8,
    d: "基于贴现率计算美国政府短期债券的等效年化收益率。",
    a: "基于贴现率计算美国政府短期债券的等效年化收益率。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "债券的结算日期，此日期为债券发行后交付给买家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "债券的到期或结束日期，届时可将其以面值或票面价值赎回。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "债券购买时的贴现率。",
      example: "2)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLYIELD",
    t: 8,
    d: "基于价格计算美国政府短期债券的收益率。",
    a: "基于价格计算美国政府短期债券的收益率。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "债券的结算日期，此日期为债券发行后交付给买家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "债券的到期或结束日期，届时可将其以面值或票面价值赎回。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "债券的购买价格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLPRICE",
    t: 8,
    d: "基于贴现率计算美国政府短期债券的价格。",
    a: "基于贴现率计算美国政府短期债券的价格。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "债券的结算日期，此日期为债券发行后交付给买家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "债券的到期或结束日期，届时可将其以面值或票面价值赎回。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "债券购买时的贴现率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PV",
    t: 8,
    d: "基于等额分期付款和固定利率，计算年金投资的现值。",
    a: "基于等额分期付款和固定利率，计算年金投资的现值。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款总期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "每期的付款金额，在年金周期内不能更改。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "D2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACCRINT",
    t: 8,
    d: "返回定期付息证券的应计利息。",
    a: "返回定期付息证券的应计利息。",
    m: [6, 8],
    p: [{
      name: "issue",
      detail: "有价证券的发行日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "first_interest",
      detail: "有价证券的首次计息日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有价证券的年息票利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "par",
      detail: "证券的票面值。",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示““欧洲30/360”方法” - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calc_method",
      detail: "[可选 - 默认为TRUE()] - 一个逻辑值，指定当结算日期晚于首次计息日期时用于计算总应计利息的方法。\n\n如果值为 TRUE，则返回从发行日到结算日的总应计利息。\n\n如果值为 FALSE，则返回从首次计息日到结算日的应计利息。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ACCRINTM",
    t: 8,
    d: "返回在到期日支付利息的有价证券的应计利息。",
    a: "返回在到期日支付利息的有价证券的应计利息。",
    m: [4, 5],
    p: [{
      name: "issue",
      detail: "有价证券的发行日。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "有价证券的到期日。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有价证券的年息票利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "par",
      detail: "证券的票面值。",
      example: "1000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYBS",
    t: 8,
    d: "返回从付息期开始到结算日的天数。",
    a: "返回从付息期开始到结算日的天数。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYS",
    t: 8,
    d: "返回结算日所在的付息期的天数。",
    a: "返回结算日所在的付息期的天数。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYSNC",
    t: 8,
    d: "返回从结算日到下一票息支付日之间的天数。",
    a: "返回从结算日到下一票息支付日之间的天数。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNCD",
    t: 8,
    d: "计算结算日之后的下一票息或利息派发日期。",
    a: "计算结算日之后的下一票息或利息派发日期。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPPCD",
    t: 8,
    d: "计算结算日之前的最后一个票息或利息支付日。",
    a: "计算结算日之前的最后一个票息或利息支付日。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FV",
    t: 8,
    d: "基于等额分期付款和固定利率，计算年金投资的未来价值。",
    a: "基于等额分期付款和固定利率，计算年金投资的未来价值。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款总期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "各期所应支付的金额，在整个年金期间保持不变。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "[可选 - 默认值为 0 ] - 现值，或一系列未来付款的当前值的累积和。",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为 0 ] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FVSCHEDULE",
    t: 8,
    d: "返回应用一系列复利率计算的初始本金的未来值。",
    a: "返回应用一系列复利率计算的初始本金的未来值。",
    m: [2, 2],
    p: [{
      name: "principal",
      detail: "现值。",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "schedule",
      detail: "用于计算本金复利的一组利率。\n\n利率表必须是范围或数组，其中包含要用于计算复利的一组利率。这些利率值应该以十进制小数形式表示，或者使用UNARY_PERCENT以百分比形式表示，即表示为0.09或UNARY_PERCENT(9)，而不要表示为9。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "YIELD",
    t: 8,
    d: "返回定期支付利息的债券的收益率。",
    a: "返回定期支付利息的债券的收益率。",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有价证券的年息票利率。",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pr",
      detail: "有价证券的价格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有价证券的清偿价值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "YIELDDISC",
    t: 8,
    d: "基于价格计算折价发行的（不带息）债券的年收益率。",
    a: "基于价格计算折价发行的（不带息）债券的年收益率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "有价证券的价格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有价证券的清偿价值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NOMINAL",
    t: 8,
    d: "基于给定的实际利率和年复利期数，返回名义年利率。",
    a: "基于给定的实际利率和年复利期数，返回名义年利率。",
    m: [2, 2],
    p: [{
      name: "effect_rate",
      detail: "每年的实际利率。",
      example: "0.85",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "npery",
      detail: "每年的复利期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "XIRR",
    t: 8,
    d: "返回一组不一定定期发生的现金流的内部收益率。",
    a: "返回一组不一定定期发生的现金流的内部收益率。",
    m: [2, 3],
    p: [{
      name: "values",
      detail: "其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "dates",
      detail: "与现金流数额参数中的现金流对应的日期数组或范围。",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "guess",
      detail: "[可选 - 默认值为0.1] - 对内部回报率的估算值。",
      example: "250",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MIRR",
    t: 8,
    d: "返回一系列定期现金流的修改后内部收益率。",
    a: "返回一系列定期现金流的修改后内部收益率。",
    m: [3, 3],
    p: [{
      name: "values",
      detail: "其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "finance_rate",
      detail: "现金流中使用的资金支付的利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "reinvest_rate",
      detail: "将现金流再投资的收益率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IRR",
    t: 8,
    d: "返回由值中的数字表示的一系列现金流的内部收益率。 ",
    a: "返回由值中的数字表示的一系列现金流的内部收益率。 ",
    m: [1, 2],
    p: [{
      name: "values",
      detail: "其中含有投资相关收益或支出的数组或范围。\n\n现金流数额中必须至少包含一项负的和一项正的现金流金额才能计算回报率。",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "guess",
      detail: "[可选 - 默认为 0.1] - 内部收益率的估值。",
      example: "200",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPV",
    t: 8,
    d: "使用贴现率和一系列未来支出（负值）和收益（正值）来计算一项投资的净现值。",
    a: "使用贴现率和一系列未来支出（负值）和收益（正值）来计算一项投资的净现值。",
    m: [2, 255],
    p: [{
      name: "rate",
      detail: "某一期间的贴现率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value1",
      detail: "第一笔支出（负值）和收益（正值）。",
      example: "200",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2, ...",
      detail: "[可选] - 其他支出（负值）和收益（正值）。",
      example: "250",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "XNPV",
    t: 8,
    d: "返回一组现金流的净现值，这些现金流不一定定期发生。",
    a: "返回一组现金流的净现值，这些现金流不一定定期发生。",
    m: [3, 3],
    p: [{
      name: "rate",
      detail: "应用于现金流的贴现率。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "values",
      detail: "与 dates 中的支付时间相对应的一系列现金流。",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "dates",
      detail: "与现金流支付相对应的支付日期表。",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CUMIPMT",
    t: 8,
    d: "基于等额分期付款和固定利率，计算投资在一系列付款期内的累计利息。",
    a: "基于等额分期付款和固定利率，计算投资在一系列付款期内的累计利息。",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "利息率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "总付款期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_period",
      detail: "开始累计计算的付款期序号。\n\n首期必须大于等于1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_period",
      detail: "结束累计计算的付款期序号。\n\n末期必须大于首期。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PMT",
    t: 8,
    d: "用于根据固定付款额和固定利率计算贷款的付款额。",
    a: "用于根据固定付款额和固定利率计算贷款的付款额。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "贷款利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "该项贷款的付款总数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值，或一系列未来付款额现在所值的总额，也叫本金。",
      example: " 100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "D2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IPMT",
    t: 8,
    d: "基于固定利率及等额分期付款方式，返回给定期数内对投资的利息偿还额。",
    a: "基于固定利率及等额分期付款方式，返回给定期数内对投资的利息偿还额。",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "per",
      detail: "用于计算其利息数额的期数，必须在 1 到 nper 之间。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款总期数。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值，或一系列未来付款的当前值的累积和。",
      example: "80000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "E2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PPMT",
    t: 8,
    d: "返回根据定期固定付款和固定利率而定的投资在已知期间内的本金偿付额。",
    a: "返回根据定期固定付款和固定利率而定的投资在已知期间内的本金偿付额。",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "per",
      detail: "指定期数，该值必须在 1 到 nper 范围内。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款总期数。",
      example: "3*12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值即一系列未来付款当前值的总和。",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选 - 默认值为 0] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为 0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INTRATE",
    t: 8,
    d: "返回完全投资型证券的利率。",
    a: "返回完全投资型证券的利率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "有价证券的投资额。",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有价证券到期时的兑换值。",
      example: "101200",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICE",
    t: 8,
    d: "返回定期付息的面值 ￥100 的有价证券的价格。",
    a: "返回定期付息的面值 ￥100 的有价证券的价格。",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有价证券的年息票利率。",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有价证券的年收益率。",
      example: "0.065",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值 ￥100 的有价证券的清偿价值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEDISC",
    t: 8,
    d: "返回折价发行的面值 ￥100 的有价证券的价格。",
    a: "返回折价发行的面值 ￥100 的有价证券的价格。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "有价证券的贴现率。",
      example: "0.0525",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值 ￥100 的有价证券的清偿价值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEMAT",
    t: 8,
    d: "返回到期付息的面值 ￥100 的有价证券的价格。",
    a: "返回到期付息的面值 ￥100 的有价证券的价格。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "issue",
      detail: "有价证券的发行日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有价证券在发行日的利率。",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有价证券的年收益率。",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RECEIVED",
    t: 8,
    d: "返回一次性付息的有价证券到期收回的金额。",
    a: "返回一次性付息的有价证券到期收回的金额。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "有价证券的投资额。",
      example: "10000000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "discount",
      detail: "有价证券的贴现率。",
      example: "0.0575",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DISC",
    t: 8,
    d: "返回有价证券的贴现率。",
    a: "返回有价证券的贴现率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "有价证券的价格（按面值为 ￥100 计算）。",
      example: "97.975",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值 ￥100 的有价证券的清偿价值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPER",
    t: 8,
    d: "基于固定利率及等额分期付款方式，返回某项投资的总期数。",
    a: "基于固定利率及等额分期付款方式，返回某项投资的总期数。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "各期所应支付的金额，在整个年金期间保持不变。",
      example: "500",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "现值，或一系列未来付款的当前值的累积和。",
      example: "40000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可选 - 默认值为0] - 未来值，或在最后一次付款后希望得到的现金余额。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可选 - 默认值为0] - 指定各期的付款时间是在期初还是期末。\n\n0 表示期末；\n\n1 表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLN",
    t: 8,
    d: "返回一个期间内的资产的直线折旧。",
    a: "返回一个期间内的资产的直线折旧。",
    m: [3, 3],
    p: [{
      name: "cost",
      detail: "资产原值。",
      example: "300000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折旧末尾时的值（有时也称为资产残值）。",
      example: "75000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "资产的折旧期数（有时也称作资产的使用寿命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DURATION",
    t: 8,
    d: "返回假设面值 ￥100 的定期付息有价证券的修正期限。",
    a: "返回假设面值 ￥100 的定期付息有价证券的修正期限。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "coupon",
      detail: "有价证券的年息票利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有价证券的年收益率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MDURATION",
    t: 8,
    d: "返回假设面值 ￥100 的有价证券的 Macauley 修正期限。",
    a: "返回假设面值 ￥100 的有价证券的 Macauley 修正期限。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有价证券的结算日。 有价证券结算日是在发行日之后，有价证券卖给购买者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有价证券的到期日。 到期日是有价证券有效期截止时的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "coupon",
      detail: "有价证券的年息票利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有价证券的年收益率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次数。\n\n如果按年支付，frequency = 1；\n\n按半年期支付，frequency = 2；\n\n按季支付，frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: "[可选 - 默认为0] - 指示要使用哪种天数计算方法。\n\n0表示“美国(NASD) 30/360”方法 - 此方法按照美国全国证券交易商协会标准，假设每月30天、每年360天，并对所输入的月末日期进行具体调整。\n\n1表示“实际/实际”方法 - 此方法计算基于指定日期之间的实际天数和所涉及的年份中的实际天数进行计算。此方法用于美国长期债券，也是在非财经用途方面使用最多的方法。\n\n2表示“实际/360”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为360天。\n\n3表示“实际/365”方法 - 此方法基于指定日期之间的实际天数进行计算，但假定每年为365天。\n\n4表示“欧洲30/360”方法 - 类似于0，此方法基于每月30天、每年360天进行计算，但按照欧洲金融惯例对月末日期进行调整。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2DEC",
    t: 9,
    d: "将二进制数转换为十进制数。",
    a: "将二进制数转换为十进制数。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要转换为十进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2DEC(100)和BIN2DEC("100")得出的结果相同，均为4。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIN2HEX",
    t: 9,
    d: "将二进制数转换为十六进制数。",
    a: "将二进制数转换为十六进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的十六进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2HEX(11111)和BIN2HEX("11111")得出 的结果相同，均为1F。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: '[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。例如，BIN2HEX("11111",8)所得的结果值为0000001F。\n\n如果带符号的二进制数的最高位为1，则忽略此值；即当提供的带符号的二进制数大于等于1000000000时忽略此值。',
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2OCT",
    t: 9,
    d: "将二进制数转换为八进制数。",
    a: "将二进制数转换为八进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的八进制数的带符号的10位二进制数值（以字符串形式提供）。\n\n带符号的二进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n对于此函数，最大的正数输入值为0111111111，最小的负数输入值为1000000000。\n\n如果所提供的带符号的二进制数是有效的二进制数，会自动将其转换为相应的字符串输入。例如，BIN2OCT(11111)和BIN2OCT("11111")得出的结果相同，均为37。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: '[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。例如，BIN2OCT("11111")得到的结果值为00000037。\n\n如果带符号的二进制数的最高位为1，则忽略此值；即当提供的带符号的二进制数大于等于1000000000时忽略此值。',
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2BIN",
    t: 9,
    d: "将十进制数转换为二进制数。",
    a: "将十进制数转换为二进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的二进制数的十进制数值（以字符串形式提供）。\n\n对于此函数，最大的正数输入值为511，最小的负数输入值为-512。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2BIN(199)和DEC2BIN("199")得出的结果相同，均为11000111。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2HEX",
    t: 9,
    d: "将十进制数转换为十六进制数。",
    a: "将十进制数转换为十六进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的十六进制数的十进制数值（以字符串形式提供）。\n\n此函数可接受的最大正数值为549755813887，最小负数值为-549755814888。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2HEX(100)和DEC2HEX("100")得出的结果相同，均为64。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2OCT",
    t: 9,
    d: "将十进制数转换为八进制数。",
    a: "将十进制数转换为八进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的八进制数的十进制数值（以字符串形式提供）。\n\n此函数可接受的最大正数值为536870911，最小负数值为-53687092。\n\n如果所提供的十进制数是有效的十进制数，会自动将其转换为相应的字符串输入。例如，DEC2OCT(199)和DEC2OCT("199")得出的结果相同，均为307。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果十进制数为负数，则忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2BIN",
    t: 9,
    d: "将十六进制数转换为二进制数。",
    a: "将十六进制数转换为二进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的二进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为1FF，最小负数值为FFFFFFFE00。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2BIN(199)和HEX2BIN("199")得出的结果相同，均为110011001。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的十六进制数的最高位为1，则忽略此值；即当提供的带符号的十六进制数大于等于8000000000时忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2DEC",
    t: 9,
    d: "将十六进制数转换为十进制数。",
    a: "将十六进制数转换为十进制数。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要转换为十进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为7fffffffff，最小负数值为8000000000。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2DEC(199)和HEX2DEC("199")得出的结果相同，均为409。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HEX2OCT",
    t: 9,
    d: "将十六进制数转换为八进制数。",
    a: "将十六进制数转换为八进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的八进制数的带符号的40位十六进制数值（以字符串形式提供）。\n\n带符号的十六进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为1FFFFFFF，最小负数值为FFE0000000。\n\n如果所提供的带符号的十六进制数是有效的十六进制数，函数会自动将其转换为相应的字符串输入。例如，HEX2OCT(199)和HEX2OCT("199")得出的结果相同，均为631。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的十六进制数的最高位为1，则忽略此值；即当给定的带符号的十六进制数大于等于8000000000时忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2BIN",
    t: 9,
    d: "将八进制数转换为二进制数。",
    a: "将八进制数转换为二进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的二进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的八进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为777，最小负数值为7777777000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2BIN(177)和OCT2BIN("177")得出的结果相同，均为1111111。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的八进制数的最高位为1，则忽略此值；即当给定的带符号的八进制数大于等于4000000000时忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2DEC",
    t: 9,
    d: "将八进制数转换为十进制数。",
    a: "将八进制数转换为十进制数。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要转换为十进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的ba进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为3777777777，最小负数值为4000000000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2DEC(177)和OCT2DEC("177")得出的结果相同，均为127。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OCT2HEX",
    t: 9,
    d: "将八进制数转换为十六进制数。",
    a: "将八进制数转换为十六进制数。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要转换为带符号的十六进制数的带符号的30位八进制数值（以字符串形式提供）。\n\n带符号的ba进制数的最高位是符号位；也就是说，负数是以二的补码形式表示的。\n\n此函数可接受的最大正数值为3777777777，最小负数值为4000000000。\n\n如果所提供的带符号的八进制数是有效的八进制数，函数会自动将其转换为相应的字符串输入。例如，OCT2HEX(177)和OCT2HEX("177")得出的结果相同，均为7F。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可选 ] - 结果中要确保的有效位数。\n\n如果设置的有效位数大于结果中的有效位数，则在结果的左侧填充0，使总有效位数达到有效位数。\n\n如果带符号的八进制数的最高位为1，则忽略此值；即当给定的带符号的八进制数大于等于4000000000时忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COMPLEX",
    t: 9,
    d: "将实系数及虚系数转换为 x+yi 或 x+yj 形式的复数。",
    a: "将实系数及虚系数转换为 x+yi 或 x+yj 形式的复数。",
    m: [2, 3],
    p: [{
      name: "real_num",
      detail: "复数的实系数。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "i_num",
      detail: "复数的虚系数。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suffix",
      detail: '[可选 - 默认为 "i"] - 复数中虚系数的后缀。',
      example: '"j"',
      require: "o",
      repeat: "n",
      type: "rangestring"
    }]
  }, {
    n: "IMREAL",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的复数的实系数。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的复数的实系数。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要计算其实系数的复数。",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMAGINARY",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的复数的虚系数。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的复数的虚系数。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要计算其虚系数的复数。",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMCONJUGATE",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的复数的共轭复数。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的复数的共轭复数。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要计算其共轭数的复数。",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMABS",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的复数的绝对值（模）。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的复数的绝对值（模）。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "要计算其绝对值的复数。",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DELTA",
    t: 9,
    d: "检验两个值是否相等。 如果 number1=number2，则返回 1；否则返回 0。",
    a: "检验两个值是否相等。 如果 number1=number2，则返回 1；否则返回 0。",
    m: [1, 2],
    p: [{
      name: "number1",
      detail: "第一个数字。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number2",
      detail: "[可选 - 默认为 0] - 第二个数字。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IMSUM",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的和。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的和。",
    m: [1, 255],
    p: [{
      name: "inumber1",
      detail: "要相加的第一个复数",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2, …",
      detail: "[可选] - 要与值1 相加的其他复数",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMSUB",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的两个复数的差。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的两个复数的差。",
    m: [2, 2],
    p: [{
      name: "inumber1",
      detail: "从（复）数中减去 inumber2。",
      example: '"6+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2",
      detail: "从 inumber1 中减（复）数。",
      example: '"2+3i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMPRODUCT",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的乘积。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 个复数的乘积。",
    m: [1, 255],
    p: [{
      name: "inumber1",
      detail: "用于计算乘积的第一个复数",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2, …",
      detail: "[可选] - 要相乘的其他复数。",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMDIV",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的两个复数的商。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的两个复数的商。",
    m: [2, 2],
    p: [{
      name: "inumber1",
      detail: "复数分子或被除数。",
      example: '"11+16i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2",
      detail: "复数分母或除数。",
      example: '"3+2i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOT",
    t: 10,
    d: "返回某个逻辑值的相反值 - “NOT(TRUE())”将返回 FALSE；“NOT(FALSE())”将返回 TRUE。",
    a: "返回某个逻辑值的相反值 - “NOT(TRUE())”将返回 FALSE；“NOT(FALSE())”将返回 TRUE。",
    m: [1, 1],
    p: [{
      name: "logical",
      detail: "计算结果为 TRUE 或 FALSE 的任何值或表达式。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRUE",
    t: 10,
    d: "返回逻辑值 TRUE。",
    a: "返回逻辑值 TRUE。",
    m: [0, 0],
    p: []
  }, {
    n: "FALSE",
    t: 10,
    d: "返回逻辑值 FALSE。",
    a: "返回逻辑值 FALSE。",
    m: [0, 0],
    p: []
  }, {
    n: "AND",
    t: 10,
    d: "所有参数的计算结果为 TRUE 时，返回 TRUE；只要有一个参数的计算结果为 FALSE，即返回 FALSE。",
    a: "所有参数的计算结果为 TRUE 时，返回 TRUE；只要有一个参数的计算结果为 FALSE，即返回 FALSE。",
    m: [1, 255],
    p: [{
      name: "logical1",
      detail: "要测试的第一个条件，其计算结果可以为 TRUE 或 FALSE。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical2,...",
      detail: "[可选] - 要测试的其他条件，其计算结果可以为 TRUE 或 FALSE，最多可包含 255 个条件。",
      example: 'A3 = "bar"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IFERROR",
    t: 10,
    d: "如果第一个参数不是错误值，就返回第一个参数；否则，返回第二个参数。",
    a: "如果第一个参数不是错误值",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "检查是否存在错误的参数。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_error",
      detail: "公式的计算结果错误时返回的值。 计算以下错误类型：#N/A、#VALUE!、#REF!、#DIV/0!、#NUM!、#NAME? 或 #NULL!。",
      example: '"Error in cell A1"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IF",
    t: 10,
    d: "当逻辑表达式的值为 TRUE 时返回一个值，而当其为 FALSE 时返回另一个值。",
    a: "当逻辑表达式的值为 TRUE 时返回一个值，而当其为 FALSE 时返回另一个值。",
    m: [2, 3],
    p: [{
      name: "logical_test",
      detail: "一个表达式或对包含表达式的单元格的引用，该表达式代表某种逻辑值（即TRUE或FALSE）。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_true",
      detail: "当逻辑表达式为TRUE时的返回值。",
      example: '"A2 is foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_false",
      detail: "[可选 - 默认为空白] - 当逻辑表达式等于FALSE时的函数返回值。",
      example: '"A2 was false"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OR",
    t: 10,
    d: "只要有一个参数的计算结果为 TRUE 时，返回 TRUE；所有参数的计算结果为 FALSE，即返回 FALSE。",
    a: "只要有一个参数的计算结果为 TRUE 时，返回 TRUE；所有参数的计算结果为 FALSE，即返回 FALSE。",
    m: [1, 255],
    p: [{
      name: "logical1",
      detail: "要测试的第一个条件，其计算结果可以为 TRUE 或 FALSE。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "逻辑表达式2",
      detail: "[可选] - 其他表达式或对包含表达式的单元格的引用，这些表达式代表某种逻辑值（即TRUE或FALSE）或者可以强制转换为逻辑值。",
      example: ' A3 = "bar"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NE",
    t: 11,
    d: "如果指定的值不相等，则返回“TRUE”；否则返回“FALSE”。相当于“<>”运算符。",
    a: "如果指定的值不相等，则返回“TRUE”；否则返回“FALSE”。相当于“<>”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一个值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要检查是否与 value1 不相等的值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EQ",
    t: 11,
    d: "如果指定的值相等，则返回“TRUE”；否则返回“FALSE”。相当于“=”运算符。",
    a: "如果指定的值相等，则返回“TRUE”；否则返回“FALSE”。相当于“=”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一个值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要检查是否与 value1 相等的值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GT",
    t: 11,
    d: "如果第一个参数严格大于第二个，则返回 TRUE；否则返回 FALSE。相当于“>”运算符。",
    a: "如果第一个参数严格大于第二个，则返回 TRUE；否则返回 FALSE。相当于“>”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否大于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二个值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GTE",
    t: 11,
    d: "如果第一个参数大于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“>=”运算符。",
    a: "如果第一个参数大于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“>=”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否大于等于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二个值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LT",
    t: 11,
    d: "如果第一个参数严格小于第二个，则返回 TRUE；否则返回 FALSE。相当于“<”运算符。",
    a: "如果第一个参数严格小于第二个，则返回 TRUE；否则返回 FALSE。相当于“<”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否小于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二个值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LTE",
    t: 11,
    d: "如果第一个参数小于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“<=”运算符。",
    a: "如果第一个参数小于或等于第二个，则返回 TRUE；否则返回 FALSE。相当于“<=”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否小于等于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二个值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADD",
    t: 11,
    d: "返回两个数值之和。相当于 `+` 运算符。",
    a: "返回两个数值之和。相当于 `+` 运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一个加数。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "第二个加数。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINUS",
    t: 11,
    d: "返回两个数值之差。相当于“-”运算符。",
    a: "返回两个数值之差。相当于“-”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "被减数，即要对其计减的数值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "减数，即要从 value1 中减除的数值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTIPLY",
    t: 11,
    d: "返回两个数的乘积。相当于“*”运算符。",
    a: "返回两个数的乘积。相当于“*”运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一个乘数。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "第二个乘数。",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DIVIDE",
    t: 11,
    d: "返回两个参数相除所得的结果。相当于 `/` 运算符。",
    a: "返回两个参数相除所得的结果。相当于 `/` 运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要被除的数值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "用于除其他数的数值。\n\n除数不得为0。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCAT",
    t: 11,
    d: "返回两个值的串联。相当于 `&` 运算符。",
    a: "返回两个值的串联。相当于 `&` 运算符。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "value2 将附于其后的值。",
      example: '"de"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要附于 value1 之后的值。",
      example: '"mystify"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNARY_PERCENT",
    t: 11,
    d: "返回按百分比解释的数值。例如，“UNARY_PERCENT(100)”等于1。",
    a: "返回按百分比解释的数值。例如，“UNARY_PERCENT(100)”等于1。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "要作为百分比解释的数值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCATENATE",
    t: 12,
    d: "将两个或多个文本字符串联接为一个字符串。",
    a: "将两个或多个文本字符串联接为一个字符串。",
    m: [1, 255],
    p: [{
      name: "text1",
      detail: "初始字符串。",
      example: '"Super"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text2 ...",
      detail: "[可选] - 要按顺序连接在一起的其他字符串。",
      example: '"calla"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CODE",
    t: 12,
    d: "返回所提供的字符串中首字符的 Unicode 映射值。",
    a: "返回所提供的字符串中首字符的 Unicode 映射值。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其首字符的Unicode映射值的字符串。",
      example: '"a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CHAR",
    t: 12,
    d: "按照当前 Unicode 编码表，将数字转换为对应的字符。",
    a: "按照当前 Unicode 编码表，将数字转换为对应的字符。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "介于 1 到 255 之间的数字。",
      example: "97",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ARABIC",
    t: 12,
    d: "将罗马数字转换为阿拉伯数字。",
    a: "将罗马数字转换为阿拉伯数字。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要转换格式的罗马数字",
      example: '"XIV"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROMAN",
    t: 12,
    d: "将数字格式设置为罗马数字形式。",
    a: "将数字格式设置为罗马数字形式。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "要设置格式的数字，介于1到3999之间（包括这两个数字）。",
      example: "499",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "REGEXEXTRACT",
    t: 12,
    d: "按照正则表达式提取匹配的子串。",
    a: "按照正则表达式提取匹配的子串。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "输入文本。",
      example: '"Needle in a haystack"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "此函数将返回文本中符合此表达式的第一个子串。",
      example: '".e{2}dle"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXMATCH",
    t: 12,
    d: "判断一段文本是否与正则表达式相匹配。",
    a: "判断一段文本是否与正则表达式相匹配。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "要用正则表达式测试的文本。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "用来测试文本的正则表达式。",
      example: '"S.r"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXREPLACE",
    t: 12,
    d: "使用正则表达式将文本字符串中的一部分替换为其他文本字符串。",
    a: "使用正则表达式将文本字符串中的一部分替换为其他文本字符串。",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "要对其局部进行替换操作的文本。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "正则表达式。 text 中所有匹配的实例都将被替换。",
      example: '"S.*d"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replacement",
      detail: "要插入到原有文本中的文本。",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T",
    t: 12,
    d: "返回文本格式的字符串参数。",
    a: "返回文本格式的字符串参数。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为文本的参数。\n\n如果值为文本，T将返回值本身。\n\n如果值为指向包含文本的单元格的引用，T将返回值中的内容。\n\n如果值为错误值或包含错误值的单元格，T将返回该错误值。\n\n对于所有其他情况，T将返回空串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIXED",
    t: 12,
    d: "以固定的小数位数设置数字的格式。",
    a: "以固定的小数位数设置数字的格式。",
    m: [1, 3],
    p: [{
      name: "number",
      detail: "要进行舍入并转换为文本的数字。",
      example: "3.141592653",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "decimals",
      detail: "[可选 - 默认值为2] - 结果中要显示的小数位数。\n\n如果数值的有效位数小于小数位数，将以零填充。如果数值的有效位数大于小数位数，则将其舍入到所需的小数位数而不是将其截断。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "no_commas",
      detail: "[可选 - 默认值为FALSE()] - 一个逻辑值，如果为 TRUE()，则会禁止 FIXED 在返回的文本中包含逗号。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIND",
    t: 12,
    d: "返回字符串在文本中首次出现的位置（区分大小写）。",
    a: "返回字符串在文本中首次出现的位置（区分大小写）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要搜索的文本中查找的字符串。",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中搜索搜索字符串的首次出现位置的文本。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[可选 - 默认值为1] - 要在要搜索的文本中开始搜索的字符位置。",
      example: "14",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FINDB",
    t: 12,
    d: "返回某个字符串在文本中首次出现的位置（每个双字节字符占两个位置）。",
    a: "返回某个字符串在文本中首次出现的位置（每个双字节字符占两个位置）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要搜索的文本中查找的字符串。",
      example: '"新"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中搜索搜索字符串的首次出现位置的文本。",
      example: '"农历新年"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[可选 - 默认值为 1] - 要在要搜索的文本中开始搜索的字符位置。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "JOIN",
    t: 12,
    d: "将一个或多个使用指定定界符的一维数组的元素连接到一起。",
    a: "将一个或多个使用指定定界符的一维数组的元素连接到一起。",
    m: [2, 255],
    p: [{
      name: "separator",
      detail: "置于相互连接的值之间的字符或字符串。\n\n定界符可以为空，例如JOIN(,{1,2,3})。",
      example: '" and-a "',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "array1",
      detail: "要使用定界符连接的一个或多个值。",
      example: "{1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "array2, ...",
      detail: "[可选] - 要使用定界符连接的其他值或数组。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LEFT",
    t: 12,
    d: "从文本字符串的第一个字符开始返回指定个数的字符。",
    a: "从文本字符串的第一个字符开始返回指定个数的字符。",
    m: [1, 2],
    p: [{
      name: "text",
      detail: "包含要提取的字符的文本字符串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_chars",
      detail: "[可选 - 默认值为1] - 指定要由 LEFT 提取的字符的数量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RIGHT",
    t: 12,
    d: "根据所指定的字符数返回文本字符串中最后一个或多个字符。",
    a: "根据所指定的字符数返回文本字符串中最后一个或多个字符。",
    m: [1, 2],
    p: [{
      name: "text",
      detail: "包含要提取的字符的文本字符串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_chars",
      detail: "[可选 - 默认值为1] - 指定要由 RIGHT 提取的字符的数量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MID",
    t: 12,
    d: "返回文本字符串中从指定位置开始的特定数目的字符。",
    a: "返回文本字符串中从指定位置开始的特定数目的字符。",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "包含要提取的字符的文本字符串。",
      example: '"get this"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "要从字符串中开始提取的位置。字符串中第一个字符的索引为1。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_chars",
      detail: "指定要由 MID 提取的字符的数量。\n\n如果提取的字符数尚不足提取长度个字符时就到达了字符串尾部，则MID返回从开始位置到字符串尾部的字符。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LEN",
    t: 12,
    d: "返回给定字符串的长度。",
    a: "返回给定字符串的长度。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其长度的字符串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LENB",
    t: 12,
    d: "返回文本中所包含的字符数。与双字节字符集(DBCS)一起使用。",
    a: "返回文本中所包含的字符数。与双字节字符集(DBCS)一起使用。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其字节数的字符串。（一个汉字为两个字节数）",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOWER",
    t: 12,
    d: "将指定字符串中的字母转换为小写。",
    a: "将指定字符串中的字母转换为小写。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要转换为小写的字符串。",
      example: '"LOREM IPSUM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UPPER",
    t: 12,
    d: "将指定字符串中的字母转换为大写。",
    a: "将指定字符串中的字母转换为大写。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要转换为大写的字符串。",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EXACT",
    t: 12,
    d: "比较两个字符串是否相同。",
    a: "比较两个字符串是否相同。",
    m: [2, 2],
    p: [{
      name: "text1",
      detail: "要比较的第一个字符串。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text2",
      detail: "要比较的第二个字符串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPLACE",
    t: 12,
    d: "将文本字符串的一部分替换为其他文本字符串。",
    a: "将文本字符串的一部分替换为其他文本字符串。",
    m: [4, 4],
    p: [{
      name: "old_text",
      detail: "要对其局部进行替换操作的文本。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "开始进行替换操作的位置（文本开头位置为 1）。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_chars",
      detail: "要在文本中替换的字符个数。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_text",
      detail: "要插入到原有文本中的文本。",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPT",
    t: 12,
    d: "返回指定文本的多次重复。",
    a: "返回指定文本的多次重复。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "要重复的字符或字符串。",
      example: '"ha"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_times",
      detail: "要重复的文本要在返回值中出现的次数。\n\n最大重复次数为100。即使重复次数大于100，REPT也仅将相应文本重复100次。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEARCH",
    t: 12,
    d: "返回字符串在文本中首次出现的位置（不区分大小写）。",
    a: "返回字符串在文本中首次出现的位置（不区分大小写）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要搜索的文本中查找的字符串。",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中搜索搜索字符串的首次出现位置的文本。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[ 可选 - 默认值为1 ] - 要在要搜索的文本中开始搜索的字符位置。",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUBSTITUTE",
    t: 12,
    d: "在文本字符串中用 new_text 替换 old_text。",
    a: "在文本字符串中用 new_text 替换 old_text。",
    m: [3, 4],
    p: [{
      name: "text",
      detail: "需要替换其中字符的文本，或对含有文本（需要替换其中字符）的单元格的引用。",
      example: '"search for it"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "old_text",
      detail: "需要替换的文本。",
      example: '"search for"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "new_text",
      detail: "用于替换 old_text 的文本。",
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "instance_num",
      detail: "[ 可选 ] - 指定要用 new_text 替换 old_text 的事件。 如果指定了 instance_num，则只有满足要求的 old_text 被替换。 否则，文本中出现的所有 old_text 都会更改为 new_text。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CLEAN",
    t: 12,
    d: "移除文本中的不可打印 ASCII 字符后将其返回。",
    a: "移除文本中的不可打印 ASCII 字符后将其返回。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要移除其中不可打印字符的文本。",
      example: '"AF"&CHAR(31)',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TEXT",
    t: 12,
    d: "按照指定格式将数字转换为文本。",
    a: "按照指定格式将数字转换为文本。",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "要设置格式的数字、日期或时间。",
      example: "1.23",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "format_text",
      detail: '以括号括起来的模式串，将按该模式设置数字的格式。\n\n0表示在数值位数少于格式指定的位数时必定以零填充。例如，TEXT(12.3,"000.00")将返回012.30。当数值的小数位数超过模式指定的小数位数时，四舍五入为指定的小数位数。例如，TEXT(12.305,"00.00")将返回12.31。\n\n#类似于0，但并不是在小数点的两侧都以零填充。例如，TEXT(12.3,"###.##")将返回12.3。',
      example: '"$0.00"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRIM",
    t: 12,
    d: "删除指定字符串前后的空格。",
    a: "删除指定字符串前后的空格。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要修剪的字符串或指向包含该字符串的单元格的引用。",
      example: '" lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "VALUE",
    t: 12,
    d: "将可识别的任何日期、时间或数字格式的字符串转换为数字。",
    a: "将可识别的任何日期、时间或数字格式的字符串转换为数字。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "包含要转换的值的字符串。",
      example: '"123"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROPER",
    t: 12,
    d: "将指定字符串中每个单词的首字母转为大写。",
    a: "将指定字符串中每个单词的首字母转为大写。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要转换的文本，其中每个单词的首字母都将转为大写，所有其他字母则转为小写。",
      example: '"united states"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CONVERT",
    t: 13,
    d: "将数字从一种度量系统转换为另一种度量系统。",
    a: "将数字从一种度量系统转换为另一种度量系统。",
    m: [3, 3],
    p: [{
      name: "number",
      detail: "是以 from_unit 为单位的需要进行转换的数值。",
      example: "5.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "from_unit",
      detail: "是数值的单位。",
      example: '"g"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "to_unit",
      detail: "是结果的单位。",
      example: '"kg"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "SUMX2MY2",
    t: 14,
    d: "返回两数组中对应数值的平方差之和。",
    a: "返回两数组中对应数值的平方差之和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一个数组或数值区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二个数组或数值区域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMX2PY2",
    t: 14,
    d: "返回两数组中对应数值的平方和之和。",
    a: "返回两数组中对应数值的平方和之和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一个数组或数值区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二个数组或数值区域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMXMY2",
    t: 14,
    d: "返回两数组中对应数值之差的平方和。",
    a: "返回两数组中对应数值之差的平方和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一个数组或数值区域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二个数组或数值区域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRANSPOSE",
    t: 14,
    d: "将数组或单元格范围的行列转置。",
    a: "将数组或单元格范围的行列转置。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要将其行列互换的数组或范围。",
      example: "{1,2}",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TREND",
    t: 14,
    d: "返回线性趋势值。",
    a: "返回线性趋势值。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_x",
      detail: "[可选 - 默认与 known_x 相同] -  需要函数 TREND 返回对应 y 值的新 x 值。",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FREQUENCY",
    t: 14,
    d: "计算数值在某个区域内的出现频率，然后返回一个垂直数组。",
    a: "计算数值在某个区域内的出现频率，然后返回一个垂直数组。",
    m: [2, 2],
    p: [{
      name: "data_array",
      detail: "要对其频率进行计数的一组数值或对这组数值的引用。",
      example: "A2:A40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "bins_array",
      detail: "要将 data_array 中的值插入到的间隔数组或对间隔的引用。\n\n为清晰起见，应将类别排序，但如果未排序，FREQUENCY会在内部对这些指定的值进行排序并返回正确结果。",
      example: "B2:B5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GROWTH",
    t: 14,
    d: "使用现有数据计算预测的指数等比。",
    a: "使用现有数据计算预测的指数等比。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "关系表达式 y = b*m^x 中已知的 y 值集合。\n\n如果已知数据_y为二维数组或范围，则已知数据_x的维数必须与之相同，或者省略此参数。\n\n如果已知数据_y为一维数组或范围，已知数据_x则可代表二维数组或范围中的多个自变量。也就是说，如果已知数据_y为单行，则将已知数据_x中的每行解释为各自独立的值，类似情况也适用于已知数据_y为单列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = b*m^x 中已知的可选 x 值集合。\n\n如果已知数据_y为一维数组或范围，已知数据_x则可代表二维数组或范围中的多个自变量。也就是说，如果已知数据_y为单行，则将已知数据_x中的每行解释为各自独立的值，类似情况也适用于已知数据_y为单列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_x",
      detail: "[可选 - 默认与 known_x 相同] - 需要函数 GROWTH 返回对应 y 值的新 x 值。",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可选 - 默认值为TRUE()] -一个逻辑值，用于指定是否将常量 b 强制设为 1。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 1，m 将被调整以使 y = m^x。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINEST",
    t: 14,
    d: "可通过使用最小二乘法计算与现有数据最佳拟合的直线，来计算某直线的统计值，然后返回描述此直线的数组。",
    a: "可通过使用最小二乘法计算与现有数据最佳拟合的直线，来计算某直线的统计值，然后返回描述此直线的数组。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "stats",
      detail: "[可选 - 默认值为FALSE()] - 一个逻辑值，用于指定是否返回附加回归统计值。\n\n如果详细为TRUE，除了对应于每个自变量的一组线性系数和y截距之外，LINEST还返回以下信息：\n\n每项系数和截距的标准误差、\n\n限定系数（介于0和1之间，1表示完全相关）、\n\n因变量值的标准误差、\n\nF统计或F观测值，指示所观测到的因变量和自变量变量之间的关系是随机的还是线性的、\n\n自由度，用于在参照表中查找F统计值以估算可信度、\n\n回归平方和，以及\n\n残差平方和。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOGEST",
    t: 14,
    d: "在回归分析中，计算最符合数据的指数回归拟合曲线，并返回描述该曲线的数值数组。",
    a: "在回归分析中，计算最符合数据的指数回归拟合曲线，并返回描述该曲线的数值数组。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "关系表达式 y = mx + b 中已知的 y 值集合。\n\n如果 known_y 为二维数组或范围，则 known_x 的维数必须与之相同，或者省略此参数。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可选 - 默认该数组为{1,2,3,...},其大小与 known_y 相同] - 关系表达式 y = mx + b 中已知的可选 x 值集合。\n\n如果 known_y 为一维数组或范围，known_x 则可代表二维数组或范围中的多个自变量。也就是说，如果 known_y 为单行，则将 known_x 中的每行解释为各自独立的值，类似情况也适用于 known_y 为单列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可选 - 默认值为TRUE()] - 一个逻辑值，用于指定是否将常量 b 强制设为 0。\n\nTRUE() 表示 b 将按正常计算；\n\nFALSE() 表示 b 将被设为 0（零），m 将被调整以使 y = mx。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "stats",
      detail: "[可选 - 默认值为FALSE()] - 一个逻辑值，用于指定是否返回附加回归统计值。\n\n如果详细为TRUE，则除了为每个自变量和系数 b 返回一组指数值之外，LOGEST 还将返回以下数据：\n\n每项指数和系数的标准误差、\n\n限定系数（介于 0 和 1 之间，1 表示完全相关）、\n\n因变量值的标准误差、\n\nF 统计或 F 观测值，指示所观测到的因变量和自变量之间的关系是随机的还是指数的、\n\n自由度 - 用于在参照表中查找 F 统计值以估算可信度、\n\n回归平方和，以及\n\n残差平方和。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MDETERM",
    t: 14,
    d: "返回一个数组的矩阵行列式的值。",
    a: "返回一个数组的矩阵行列式的值。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "行数和列数相等的数值数组。",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINVERSE",
    t: 14,
    d: "返回数组中存储的矩阵的逆矩阵。",
    a: "返回数组中存储的矩阵的逆矩阵。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "行数和列数相等的数值数组。",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MMULT",
    t: 14,
    d: "返回两个数组的矩阵乘积。结果矩阵的行数与 array1 的行数相同，矩阵的列数与 array2 的列数相同。",
    a: "返回两个数组的矩阵乘积。结果矩阵的行数与 array1 的行数相同，矩阵的列数与 array2 的列数相同。",
    m: [2, 2],
    p: [{
      name: "array1",
      detail: "要进行矩阵乘法运算的第一个矩阵数组。\n\narray1 列数必须与 array2 的行数相同",
      example: "A1:B3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "要进行矩阵乘法运算的第二个矩阵数组。\n\narray2 的行数必须与 array1 列数相同",
      example: "C1:F2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMPRODUCT",
    t: 14,
    d: "在给定的几组数组中，将数组间对应的元素相乘，并返回乘积之和。",
    a: "在给定的几组数组中，将数组间对应的元素相乘，并返回乘积之和。",
    m: [1, 255],
    p: [{
      name: "array1",
      detail: "其相应元素需要进行相乘并求和的第一个数组参数。",
      example: "A2:C5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "[可选] - 其相应元素需要进行相乘并求和的其它数组参数。",
      example: "D2:F5",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "ISFORMULA",
    t: 15,
    d: "检查公式是否位于引用的单元格中。",
    a: "检查公式是否位于引用的单元格中。",
    m: [1, 1],
    p: [{
      name: "cell",
      detail: "要检查是否存在公式的单元格。\n\n如果 cell 为包含公式的单元格，则 ISFORMULA 将返回 TRUE。如果 cell 为相应单元格范围，则当该范围内的首个单元格包含公式时，系统会返回 TRUE。如果是任何其他值，系统都将返回 FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CELL",
    t: 15,
    d: "返回有关单元格的格式、位置或内容的信息。",
    a: "返回有关单元格的格式、位置或内容的信息。",
    m: [2, 2],
    p: [{
      name: "info_type",
      detail: "一个文本值，指定要返回的单元格信息的类型。",
      example: '"type"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "reference",
      detail: "需要其相关信息的单元格。",
      example: "C2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "NA",
    t: 15,
    d: "返回错误值 #N/A。",
    a: "返回错误值 #N/A。",
    m: [0, 0],
    p: []
  }, {
    n: "ERROR_TYPE",
    t: 15,
    d: "返回与其他单元格中的错误值相对应的数字。",
    a: "返回与其他单元格中的错误值相对应的数字。",
    m: [1, 1],
    p: [{
      name: "error_val",
      detail: "用于查找错误号的单元格，虽然您也可以直接提供错误值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISBLANK",
    t: 15,
    d: "检查所引用的单元格是否为空。",
    a: "检查所引用的单元格是否为空。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "对要检查其是否为空的单元格的引用。\n\n如果是空单元格，则 TRUE；否则返回 FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISERR",
    t: 15,
    d: "检查某个值是否为 #N/A 以外的错误值。",
    a: "检查某个值是否为 #N/A 以外的错误值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其是否为#N/A以外的错误类型的值。\n\n如果值是除#N/A之外的任何错误（包括#DIV/0!、#NAME?、#NULL!、#NUM!、#VALUE!和#REF!），ISERR将返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISERROR",
    t: 15,
    d: "检查某个值是否为错误值。",
    a: "检查某个值是否为错误值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其是否为错误类型的值。\n\n只要值是某种错误值（包括#DIV/0!、#N/A、#NAME?、#NULL!、#NUM!、#VALUE!和#REF!），ISERROR就会返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISLOGICAL",
    t: 15,
    d: "检查某个值是 TRUE 还是 FALSE。",
    a: "检查某个值是 TRUE 还是 FALSE。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其为逻辑TRUE还是逻辑FALSE的值。\n\n*如果值为TRUE或FALSE，或为指向值为TRUE或FALSE的单元格的引用，ISLOGICAL将返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNA",
    t: 15,
    d: "检查某个值是否为错误值 #N/A。",
    a: "检查某个值是否为错误值 #N/A。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要与错误值#N/A进行比较的值。\n\n*如果值为#N/A或指向包含#N/A的单元格的引用，则ISNA将返回TRUE，否则返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNONTEXT",
    t: 15,
    d: "检查某个值是否为非文本。",
    a: "检查某个值是否为非文本。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要检查的文本。\n\n*如果参数为文本值或指向包含文本的单元格的引用，ISNONTEXT将返回FALSE，否则返回TRUE。\n\n当值为指向空单元格的引用时，ISNONTEXT会返回TRUE。\n\n当值为空字符串时，ISNONTEXT将返回FALSE，因为空串被视作文本。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNUMBER",
    t: 15,
    d: "检查某个值是否为数字。",
    a: "检查某个值是否为数字。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其是否为数字的值。\n\n*如果参数为数字或指向内容为数字值的单元格的引用，ISNUMBER将返回TRUE，否则返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISREF",
    t: 15,
    d: "检查某个值是否为有效的单元格引用。",
    a: "检查某个值是否为有效的单元格引用。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其是否为单元格引用的值。\n\n*如果参数是有效的单元格引用，ISREF将返回TRUE，否则返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISTEXT",
    t: 15,
    d: "检查某个值是否为文本。",
    a: "检查某个值是否为文本。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要验证其是否为文本的值。\n\n如果参数为文本值或指向包含文本值的单元格的引用，ISTEXT将返回TRUE，否则返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TYPE",
    t: 15,
    d: "返回数值的类型。",
    a: "返回数值的类型。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要确定其类型的数据。\n\n数字 返回 1;\n\n文本 返回 2;\n\n逻辑值 返回 4;\n\n错误值 返回 16;\n\n数组 返回 64;",
      example: "C4",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "N",
    t: 15,
    d: "返回转化为数值后的值。",
    a: "返回转化为数值后的值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为数字的参数。\n\n如果值为数字，则返回该数字。\n\n如果值为日期，则返回该日期的序列号。\n\n如果值为TRUE，则返回1。\n\n如果值为FALSE，则返回0。\n\n如果值为错误值，则返回错误值。\n\n如果值为其他值，则返回0。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DATE",
    t: 16,
    d: "将指定的数字转换为日期。",
    a: "将指定的数字转换为日期。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为日期的参数或其单元格引用。\n\n如果值为数字或指向内容为数值的单元格的引用，TO_DATE会将值转换为相应的日期并返回，值代表从十二月30日到对应的日期之间的天数，\n\n负值表示对应的日期在十二月30日之前，而小数值则代表一天中从午夜算起的时间。\n如果值不是数字或指向内容为数值的单元格的引用，则TO_DATE将在不做任何修改的情况下返回值。",
      example: "25405",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PURE_NUMBER",
    t: 16,
    d: "将给定的日期/时间、百分比、货币金额或其他格式的数值转换为不带格式的纯数字。",
    a: "将给定的日期/时间、百分比、货币金额或其他格式的数值转换为不带格式的纯数字。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为纯数字的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_PURE_NUMBER将以不带任何格式与解释的形式返回值。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_PERCENT将在不做任何修改的情况下返回值。",
      example: "50%",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_TEXT",
    t: 16,
    d: "将给定的数字值转换为文本格式。",
    a: "将给定的数字值转换为文本格式。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为文本的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_TEXT将返回字符串形式的值，并保持现有格式。即原为货币的仍为货币，原为十进制数的仍为十进制数，原为百分比的仍为百分比，原为日期的仍为日期。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_TEXT将在不做任何修改的情况下返回值。",
      example: "24",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DOLLARS",
    t: 16,
    d: "将指定的数字转换为美元金额。",
    a: "将指定的数字转换为美元金额。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为美元金额的参数或其单元格引用。\n\n如果值不是数字或指向内容为数值的单元格的引用，则 TO_DOLLARS 将在不做任何修改的情况下返回值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PERCENT",
    t: 16,
    d: "将指定的数字转换为百分比。",
    a: "将指定的数字转换为百分比。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要转换为百分比的参数或其单元格引用。\n\n如果值为数字或指向包含数值的单元格的引用，TO_PERCENT会以1 = 100%为标准，将值转换为百分比。\n\n如果值不是数字或指向内容为数值的单元格的引用，则TO_PERCENT将在不做任何修改的情况下返回值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DGET",
    t: 17,
    d: "使用 SQL 式查询，从列表或数据库的列中提取符合指定条件的单个值。",
    a: "使用 SQL 式查询，从列表或数据库的列中提取符合指定条件的单个值。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMAX",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最大数字。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最大数字。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMIN",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最小数字。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的最小数字。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DAVERAGE",
    t: 17,
    d: "使用 SQL 式查询，对列表或数据库中满足指定条件的记录字段（列）中的数值求平均值。",
    a: "使用 SQL 式查询，对列表或数据库中满足指定条件的记录字段（列）中的数值求平均值。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNT",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中包含数字的单元格的个数。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中包含数字的单元格的个数。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNTA",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的非空单元格的个数。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的非空单元格的个数。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DPRODUCT",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数值的乘积。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数值的乘积。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEV",
    t: 17,
    d: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体标准偏差。",
    a: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体标准偏差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEVP",
    t: 17,
    d: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为样本总体计算出的总体标准偏差。",
    a: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为样本总体计算出的总体标准偏差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSUM",
    t: 17,
    d: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数字之和。",
    a: "使用 SQL 式查询，返回列表或数据库中满足指定条件的记录字段（列）中的数字之和。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVAR",
    t: 17,
    d: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体方差。",
    a: "使用 SQL 式查询，返回利用列表或数据库中满足指定条件的记录字段（列）中的数字作为一个样本估算出的总体方差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVARP",
    t: 17,
    d: "使用 SQL 式查询，通过使用列表或数据库中满足指定条件的记录字段（列）中的数字计算样本总体的样本总体方差。",
    a: "使用 SQL 式查询，通过使用列表或数据库中满足指定条件的记录字段（列）中的数字计算样本总体的样本总体方差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "构成列表或数据库的单元格区域，列表的第一行包含每一列的标签。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定 database 中的哪一列包含要提取和用于计算的值。\n\nfield 可以是与 database 第一行中某个列标题对应的文本标签，也可以是指定相关列的数字索引，第一列的索引值为 1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定条件的单元格区域。计算之前将使用这些条件来过滤 database 中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "AGE_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出年龄。支持15位或18位身份证",
    a: "根据身份证号得到年龄。",
    m: [1, 2],
    p: [{
      name: "身份证号",
      example: "A1",
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "截止日期",
      example: '"2017-10-01"',
      detail: "年龄计算的截止日期或范围，默认为当日。",
      require: "o",
      repeat: "n",
      type: "rangedatetime"
    }]
  }, {
    n: "SEX_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出性别。支持15位或18位身份证",
    a: "根据身份证号得到性别。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIRTHDAY_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出生日。支持15位或18位身份证",
    a: "根据身份证号得到生日。",
    m: [1, 2],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "生日格式",
      example: "0",
      detail: "日期类型,默认0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROVINCE_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出籍贯的省份。支持15位或18位身份证",
    a: "根据身份证号得到籍贯的省份。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CITY_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出籍贯的城市。支持15位或18位身份证",
    a: "根据身份证号得到籍贯的城市。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "STAR_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出星座。支持15位或18位身份证",
    a: "根据身份证号得到星座。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ANIMAL_BY_IDCARD",
    t: "3",
    d: "根据中国身份证号计算出生肖（鼠、牛、虎、兔...）。支持15位或18位身份证",
    a: "根据身份证号得到生肖。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISIDCARD",
    t: "3",
    d: "验证身份证的格式是否正确。支持15位或18位身份证",
    a: "验证身份证格式正确性。",
    m: [1, 1],
    p: [{
      name: "身份证号",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份证号或范围。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DM_TEXT_CUTWORD",
    t: "4",
    d: "文本分词。把一连串文字拆分为一系列单独词语",
    a: "中文文本分词。",
    m: [1, 2],
    p: [{
      name: "文本",
      example: '"我来到北京清华大学"',
      detail: "任意需要分词的文本。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "分词模式",
      example: "0",
      detail: "默认为0[精确模式], 1[全模式], 2[搜索引擎模式]。",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TFIDF",
    t: "4",
    d: "采用tf-idf算法进行关键词提取。从一连串文字中识别关键词",
    a: "tf-idf关键词识别。",
    m: [1, 3],
    p: [{
      name: "文本",
      example: '"我来到北京清华大学"',
      detail: "任意需要分词的文本。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "关键词个数",
      example: "20",
      detail: "算法返回的关键词个数，默认20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "语料库",
      example: "1",
      detail: "选择特定领域的语料库，默认0[通用], 1[金融], 2[医疗]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TEXTRANK",
    t: "4",
    d: "采用TextRank算法进行关键词提取。从一连串文字中识别关键词",
    a: "TextRank关键词识别。",
    m: [1, 3],
    p: [{
      name: "文本",
      example: '"我来到北京清华大学"',
      detail: "任意需要分词的文本。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "关键词个数",
      example: "20",
      detail: "算法返回的关键词个数，默认20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "语料库",
      example: "1",
      detail: "选择特定领域的语料库，默认0[通用], 1[金融], 2[医疗]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_CLOSE",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票收盘价。",
    a: "返回A股对应股票收盘价。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_OPEN",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票开盘价。",
    a: "返回A股对应股票开盘价。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MAX",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票最高价。",
    a: "返回A股对应股票最高价。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MIN",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票最低价。",
    a: "返回A股对应股票最低价。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_VOLUMN",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票成交量。",
    a: "返回A股对应股票成交量。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_AMOUNT",
    t: "5",
    d: "根据股票代码和日期，返回A股对应股票成交额。",
    a: "返回A股对应股票成交额。",
    m: [1, 3],
    p: [{
      name: "股票代码",
      example: '"000001"',
      detail: "6位股票代码，必填项。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "复权除权",
      example: "0",
      detail: "选择股票的除权复权类型，默认0[前复权], 1[原始价格], 2[后复权]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISDATE",
    t: "6",
    d: "验证日期的格式是否正确。支持多种日期格式",
    a: "验证日期格式正确性。",
    m: [1, 1],
    p: [{
      name: "日期",
      example: '"1990-01-01"',
      detail: "日期值，例如1990/01/01, 1990年1月1日等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINESPLINES",
    t: "3",
    d: "生成嵌入在单元格内的折线图sparklines，用于描述数据的连续走势",
    a: "生成单元格折线图",
    m: [1, 8],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "线条颜色",
      example: "#2ec7c9",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "线条粗细",
      example: "1",
      detail: "折线图线段粗细，默认为1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "辅助线",
      example: "avg",
      detail: "一条横线，可以是min、max、avg、median、范围或自定义数值，默认0无",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "辅助线颜色",
      example: "#000",
      detail: "辅助线的颜色设置，同线条颜色配置，默认#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值标识",
      example: "#fc5c5c",
      detail: "标识线图最大值，同线条颜色配置，默认0不显示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最小值标识",
      example: "#fc5c5c",
      detail: "标识线图最小值，同线条颜色配置，默认0不显示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "标识大小",
      example: "1.5",
      detail: "最大值和最小值的标识大小设置，默认为1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AREASPLINES",
    t: "3",
    d: "生成嵌入在单元格内的面积图sparklines，一般用于描述数据的连续累积值走势",
    a: "生成单元格面积图",
    m: [1, 5],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "线条颜色",
      example: "#2ec7c9",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "填充颜色",
      example: "#CCF3F4",
      detail: "形成面积图，同线条颜色配置，默认0不显示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "线条粗细",
      example: "1",
      detail: "折线图线段粗细，默认为1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "辅助线",
      example: "avg",
      detail: "一条横线，可以是min、max、avg、median、范围或自定义数值，默认0无",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "辅助线颜色",
      example: "#000",
      detail: "辅助线的颜色设置，同线条颜色配置，默认#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的垂直柱状图sparklines，一般用于描述离散数据之间的大小情况",
    a: "生成单元格垂直柱状图",
    m: [1, 6],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条间隔",
      example: "1",
      detail: "柱条之间的间隔距离，默认为1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条颜色",
      example: "#fc5c5c",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "负向柱条颜色",
      example: "#97b552",
      detail: "负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0:5:#000表示数值0-5的柱为黑色，默认为空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKCOLUMNSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的累积垂直柱状图sparklines，一般用于描述离散数据多个维度的数值大小",
    a: "生成单元格累积垂直柱状图",
    m: [1, 5],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "按列堆积",
      example: "1",
      detail: "如果需要按行堆积则本项设为false或0，默认为是1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条间隔",
      example: "1",
      detail: "柱条之间的间隔距离，默认为1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "累积柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "累积色板",
      example: "#97b552",
      detail: "调色板可以单独设置每个维度的柱条颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BARSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的横向条形图sparklines，一般用于描述离散数据之间的大小情况",
    a: "生成单元格横向条形图",
    m: [1, 6],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条间隔",
      example: "1",
      detail: "柱条之间的间隔距离，默认为1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条颜色",
      example: "#fc5c5c",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "负向柱条颜色",
      example: "#97b552",
      detail: "负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0:5:#000表示数值0-5的柱为黑色，默认为空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKBARSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的累积横向条形图sparklines，一般用于描述离散数据多个维度的数值大小",
    a: "生成单元格累积横向条形图",
    m: [1, 5],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "按列堆积",
      example: "1",
      detail: "如果需要按行堆积则本项设为false或0，默认为是1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条间隔",
      example: "1",
      detail: "柱条之间的间隔距离，默认为1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "累积柱图最大值，用于规范柱图长度，默认为自动计算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "累积色板",
      example: "#97b552",
      detail: "调色板可以单独设置每个维度的柱条颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "DISCRETESPLINES",
    t: "3",
    d: "生成嵌入在单元格内的离散图sparklines，一般用于描述离散数据走势",
    a: "生成单元格离散图",
    m: [1, 4],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "分割阈值",
      example: "1",
      detail: "离散图柱形颜色的区分，例如：该值为0，则大于0为蓝色，小于0为红色，默认为0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "阈值以上颜色",
      example: "#2ec7c9",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "阈值以下颜色",
      example: "#fc5c5c",
      detail: "阈值以下柱条颜色设置，同阈值以上颜色，默认#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRISTATESPLINES",
    t: "3",
    d: "生成嵌入在单元格内的三态图sparklines，一般用于描述三种态势的走势例如胜负平",
    a: "生成单元格三态图",
    m: [1, 6],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条间隔",
      example: "1",
      detail: "柱条之间的间隔距离，默认为1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱条颜色",
      example: "#fc5c5c",
      detail: "线图的线条颜色，可以是否个范围A1、色表索引数值或者具体颜色值，设置为0或false则不显示，支持regx、rgb、rgba等。默认#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "负向柱条颜色",
      example: "#97b552",
      detail: "负向柱条颜色设置，代表负值的颜色，同柱条颜色配置，默认#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "零值柱条颜色",
      example: "#999",
      detail: "零值柱条颜色设置，代表0值颜色，同柱条颜色配置，默认#999",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "调色板可以单独设置每个柱条的颜色，可设置多个，支持两种格式：1颜色例如#000，代表第一个柱的颜色是黑色；2数值范围:颜色，例如-2:#000表示数值为-2的柱为黑色，0-5:#000表示数值0-5的柱为黑色，默认为空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PIESPLINES",
    t: "3",
    d: "生成嵌入在单元格内的饼图sparklines，一般用于描述数据占比",
    a: "生成单元格饼图",
    m: [1, 5],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "旋转角度",
      example: "0",
      detail: "饼图的旋转角度，默认为0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "饼图边框",
      example: "0",
      detail: "饼图边框大小，默认为无0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "边框颜色",
      example: "#000",
      detail: "饼图边框颜色，默认为#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "饼图色板",
      example: "#97b552",
      detail: "调色板可以设置切片的颜色，可设置为A1:A10等范围，默认为#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BOXSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的箱线图sparklines，一般用于描述数据集的统计分布",
    a: "生成单元格箱线图",
    m: [1, 4],
    p: [{
      name: "数据范围",
      example: "A1:A20",
      detail: "数据范围，数值才能被有效计算，例如A1:A20， {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "离群点比例",
      example: "1.5",
      detail: "离群点的阈值范围，如果为0或false则不显示，默认为1.5倍",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "目标点值",
      example: "10",
      detail: "箱线图上的目标值设置，默认为false不显示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "数据点大小",
      example: "1.5",
      detail: "目标点和离群点的半径大小设置，默认为1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BULLETSPLINES",
    t: "3",
    d: "生成嵌入在单元格内的子弹图sparklines，一般用于描述任务达成率",
    a: "生成单元格子弹图",
    m: [2, 3],
    p: [{
      name: "目标",
      example: "10",
      detail: "达成的目标值，数值才能被有效计算，例如A1， 100等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "实际完成",
      example: "8",
      detail: "目前完成值，数值才能被有效计算，例如A1， 100等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "对比值",
      example: "12",
      detail: "对比值，例如超额、最低、获奖底线等，数值才能被有效计算，例如A1， 100等。可以设置最多9个对比值",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMPOSESPLINES",
    t: "3",
    d: "支持多个类型的图画在同一个单元格,每个参数代表一个sparklines图",
    a: "组合sparklines图到一个单元格",
    m: [1, 1],
    p: [{
      name: "图设置",
      example: "PIESPLINES(A1:A20)",
      detail: "sparklines图设置，例如A1:A20， 一个完成的饼图、线图设置等。",
      require: "m",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SORT",
    t: "14",
    d: "返回数组中元素的排序数组。返回的数组与提供的数组参数形状相同。",
    a: "返回数组中元素的排序数组。返回的数组与提供的数组参数形状相同。",
    m: [1, 4],
    p: [{
      name: "array",
      detail: "要排序的范围或数组。",
      example: "A2:A17",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_index",
      detail: "[可选] - 表示要排序的行或列的数字。（默认row1/col1）",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_order",
      detail: "[可选] - 表示所需排序顺序的数字；1表示升序（默认），-1表示降序。",
      example: "-1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[可选] - 表示所需排序方向的逻辑值；按行排序为FALSE()（默认），按列排序为TRUE()。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FILTER",
    t: "14",
    d: "基于一个布尔（真/假）数组过滤一个数组。",
    a: "基于一个布尔（真/假）数组过滤一个数组。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "要筛选的数组或范围。",
      example: "A5:D20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "include",
      detail: "布尔数组，其高度或宽度与数组相同",
      example: "1",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "if_empty",
      detail: "[可选] - 如果包含数组中的所有值都为空(filter不返回任何值)，则返回的值。",
      example: '""',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNIQUE",
    t: "14",
    d: "返回列表或区域中的唯一值的列表。",
    a: "返回列表或区域中的唯一值的列表。",
    m: [1, 3],
    p: [{
      name: "array",
      detail: "从其返回唯一值的数组或区域。",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[可选] - 逻辑值，指示如何比较；按行 = FALSE() 或省略；按列 = TRUE()。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurs_once",
      detail: "[可选] - 逻辑值，仅返回唯一值中出现一次 = TRUE()；包括所有唯一值 = FALSE() 或省略。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANDARRAY",
    t: "14",
    d: "返回 0 到 1 之间的随机数字数组。",
    a: "返回 0 到 1 之间的随机数字数组。",
    m: [0, 2],
    p: [{
      name: "rows",
      detail: "[可选] - 要返回的行数。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "[可选] - 要返回的列数。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEQUENCE",
    t: "14",
    d: "生成数字序列的列表。",
    a: "生成数字序列的列表。",
    m: [1, 4],
    p: [{
      name: "rows",
      detail: "要返回的行数。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "[可选] - 要返回的列数。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start",
      detail: "[可选] - 序列中的第一个数字。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "step",
      detail: "[可选] - 序列中每个序列值的增量。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVALUATE",
    t: "3",
    d: "对以文字表示的公式或者表达式求值，并返回结果。",
    a: "根据文字公式或者表达式求值。",
    m: [1, 1],
    p: [{
      name: "公式",
      example: '"A1+5*2^2"',
      detail: "公式或表达式",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }],
  toolbar: {
    toolbar: "工具栏",
    undo: "撤销",
    redo: "重做",
    "clear-format": "清除格式",
    "format-painter": "格式刷",
    "currency-format": "货币格式",
    "percentage-format": "百分比格式",
    "number-decrease": "减少小数位数",
    "number-increase": "增加小数位数",
    moreFormats: "更多格式",
    "border-all": "所有边框",
    "merge-all": "全部合并单元格",
    font: "字体",
    "font-size": "字号",
    bold: "粗体 (Ctrl+B)",
    italic: "斜体 (Ctrl+I)",
    "strike-through": "删除线 (Alt+Shift+5)",
    underline: "下划线",
    "font-color": "文本颜色",
    "align-left": "左对齐",
    "align-center": "水平居中",
    "align-right": "右对齐",
    "align-top": "上对齐",
    "align-mid": "垂直居中",
    "align-bottom": "下对齐",
    chooseColor: "颜色选择",
    resetColor: "重置颜色",
    customColor: "自定义",
    alternatingColors: "交替颜色",
    confirmColor: "确定颜色",
    cancelColor: "取消",
    collapse: "收起",
    background: "背景色",
    border: "边框",
    borderStyle: "边框类型",
    "merge-cell": "合并单元格",
    chooseMergeType: "选择合并类型",
    horizontalAlign: "水平对齐",
    verticalAlign: "垂直对齐",
    alignment: "对齐方式",
    textWrap: "文本换行",
    textWrapMode: "换行方式",
    textRotate: "文本旋转",
    textRotateMode: "旋转方式",
    freeze: "冻结",
    sort: "排序",
    filter: "筛选",
    sortAndFilter: "排序和筛选",
    findAndReplace: "查找替换",
    "formula-sum": "求和",
    autoSum: "自动求和",
    moreFunction: "更多函数",
    conditionalFormat: "条件格式",
    comment: "批注",
    pivotTable: "数据透视表",
    chart: "图表",
    screenshot: "截图",
    splitColumn: "分列",
    insertImage: "插入图片",
    insertLink: "插入链接",
    dataVerification: "数据验证",
    protection: "保护工作表内容",
    clearText: "清除颜色选择",
    noColorSelectedText: "没有颜色被选择",
    toolMore: "更多",
    toolLess: "少于",
    toolClose: "收起",
    toolMoreTip: "更多功能",
    moreOptions: "更多选项",
    cellFormat: "设置单元格格式",
    print: "打印"
  },
  alternatingColors: {
    applyRange: "应用范围",
    selectRange: "选择应用范围",
    header: "页眉",
    footer: "页脚",
    errorInfo: "不能对多重选择区域执行此操作，请选择单个区域，然后再试",
    textTitle: "格式样式",
    custom: "自定义",
    close: "关闭",
    selectionTextColor: "选择文本颜色",
    selectionCellColor: "选择单元格颜色",
    removeColor: "移除交替颜色",
    colorShow: "颜色",
    currentColor: "当前颜色",
    tipSelectRange: "请选择交替颜色应用范围",
    errorNoRange: "您选择的应用范围不是选区！",
    errorExistColors: "您选择的应用范围已存在交替颜色且不属于你要编辑的应用范围！"
  },
  button: {
    confirm: "确定",
    cancel: "取消",
    close: "关闭",
    update: "Update",
    delete: "Delete",
    insert: "新建",
    prevPage: "上一页",
    nextPage: "下一页",
    total: "总共："
  },
  paint: {
    start: "格式刷开启",
    end: "ESC键退出",
    tipSelectRange: "请选择需要复制格式的区域",
    tipNotMulti: "无法对多重选择区域执行此操作"
  },
  format: {
    moreCurrency: "更多货币格式",
    moreDateTime: "更多日期与时间格式",
    moreNumber: "更多数字格式",
    titleCurrency: "货币格式",
    decimalPlaces: "小数位数",
    titleDateTime: "日期与时间格式",
    titleNumber: "数字格式",
    tipDecimalPlaces: "小数位数必须在0-9之间！",
    select: "选择",
    format: "格式",
    currency: "货币"
  },
  info: {
    detailUpdate: "新打开",
    detailSave: "已恢复本地缓存",
    row: "行",
    column: "列",
    loading: "加载中···",
    copy: "副本",
    return: "返回",
    rename: "重命名",
    tips: "表格重命名",
    noName: "无标题的电子表格",
    wait: "待更新",
    add: "添加",
    addLast: "在底部添加",
    backTop: "回到顶部",
    pageInfo: "共${total}条，${totalPage}页，当前已显示${currentPage}页",
    nextPage: "下一页",
    tipInputNumber: "请输入数字",
    tipInputNumberLimit: "增加范围限制在1-100",
    tipRowHeightLimit: "行高必须在0 ~ 545之间",
    tipColumnWidthLimit: "列宽必须在0 ~ 2038之间",
    pageInfoFull: "共${total}条，${totalPage}页，已显示全部数据"
  },
  currencyDetail: [{
    name: "人民币",
    pos: "before",
    value: "¥"
  }, {
    name: "美元",
    pos: "before",
    value: "$"
  }, {
    name: "欧元",
    pos: "before",
    value: "€"
  }, {
    name: "英镑",
    pos: "before",
    value: "￡"
  }, {
    name: "港元",
    pos: "before",
    value: "$"
  }, {
    name: "日元",
    pos: "before",
    value: "￥"
  }, {
    name: "阿尔巴尼亚列克",
    pos: "before",
    value: "Lek"
  }, {
    name: "阿尔及利亚第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "阿富汗尼",
    pos: "after",
    value: "Af"
  }, {
    name: "阿根廷比索",
    pos: "before",
    value: "$"
  }, {
    name: "阿拉伯联合酋长国迪拉姆",
    pos: "before",
    value: "dh"
  }, {
    name: "阿鲁巴弗罗林",
    pos: "before",
    value: "Afl"
  }, {
    name: "阿曼里亚尔",
    pos: "before",
    value: "Rial"
  }, {
    name: "阿塞拜疆马纳特",
    pos: "before",
    value: "?"
  }, {
    name: "埃及镑",
    pos: "before",
    value: "￡"
  }, {
    name: "埃塞俄比亚比尔",
    pos: "before",
    value: "Birr"
  }, {
    name: "安哥拉宽扎",
    pos: "before",
    value: "Kz"
  }, {
    name: "澳大利亚元",
    pos: "before",
    value: "$"
  }, {
    name: "澳门元",
    pos: "before",
    value: "MOP"
  }, {
    name: "巴巴多斯元",
    pos: "before",
    value: "$"
  }, {
    name: "巴布亚新几内亚基那",
    pos: "before",
    value: "PGK"
  }, {
    name: "巴哈马元",
    pos: "before",
    value: "$"
  }, {
    name: "巴基斯坦卢比",
    pos: "before",
    value: "Rs"
  }, {
    name: "巴拉圭瓜拉尼",
    pos: "after",
    value: "Gs"
  }, {
    name: "巴林第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "巴拿马巴波亚",
    pos: "before",
    value: "B/"
  }, {
    name: "巴西里亚伊",
    pos: "before",
    value: "R$"
  }, {
    name: "白俄罗斯卢布",
    pos: "after",
    value: "р"
  }, {
    name: "百慕大元",
    pos: "before",
    value: "$"
  }, {
    name: "保加利亚列弗",
    pos: "before",
    value: "lev"
  }, {
    name: "冰岛克朗",
    pos: "before",
    value: "kr"
  }, {
    name: "波黑可兑换马克",
    pos: "before",
    value: "KM"
  }, {
    name: "波兰兹罗提",
    pos: "after",
    value: "z?"
  }, {
    name: "玻利维亚诺",
    pos: "before",
    value: "Bs"
  }, {
    name: "伯利兹元",
    pos: "before",
    value: "$"
  }, {
    name: "博茨瓦纳普拉",
    pos: "before",
    value: "P"
  }, {
    name: "不丹努扎姆",
    pos: "before",
    value: "Nu"
  }, {
    name: "布隆迪法郎",
    pos: "before",
    value: "FBu"
  }, {
    name: "朝鲜圆",
    pos: "before",
    value: "?KP"
  }, {
    name: "丹麦克朗",
    pos: "after",
    value: "kr"
  }, {
    name: "东加勒比元",
    pos: "before",
    value: "$"
  }, {
    name: "多米尼加比索",
    pos: "before",
    value: "RD$"
  }, {
    name: "俄国卢布",
    pos: "after",
    value: "?"
  }, {
    name: "厄立特里亚纳克法",
    pos: "before",
    value: "Nfk"
  }, {
    name: "非洲金融共同体法郎",
    pos: "before",
    value: "CFA"
  }, {
    name: "菲律宾比索",
    pos: "before",
    value: "?"
  }, {
    name: "斐济元",
    pos: "before",
    value: "$"
  }, {
    name: "佛得角埃斯库多",
    pos: "before",
    value: "CVE"
  }, {
    name: "福克兰群岛镑",
    pos: "before",
    value: "￡"
  }, {
    name: "冈比亚达拉西",
    pos: "before",
    value: "GMD"
  }, {
    name: "刚果法郎",
    pos: "before",
    value: "FrCD"
  }, {
    name: "哥伦比亚比索",
    pos: "before",
    value: "$"
  }, {
    name: "哥斯达黎加科朗",
    pos: "before",
    value: "?"
  }, {
    name: "古巴比索",
    pos: "before",
    value: "$"
  }, {
    name: "古巴可兑换比索",
    pos: "before",
    value: "$"
  }, {
    name: "圭亚那元",
    pos: "before",
    value: "$"
  }, {
    name: "哈萨克斯坦坚戈",
    pos: "before",
    value: "?"
  }, {
    name: "海地古德",
    pos: "before",
    value: "HTG"
  }, {
    name: "韩元",
    pos: "before",
    value: "?"
  }, {
    name: "荷属安的列斯盾",
    pos: "before",
    value: "NAf."
  }, {
    name: "洪都拉斯拉伦皮拉",
    pos: "before",
    value: "L"
  }, {
    name: "吉布提法郎",
    pos: "before",
    value: "Fdj"
  }, {
    name: "吉尔吉斯斯坦索姆",
    pos: "before",
    value: "KGS"
  }, {
    name: "几内亚法郎",
    pos: "before",
    value: "FG"
  }, {
    name: "加拿大元",
    pos: "before",
    value: "$"
  }, {
    name: "加纳塞地",
    pos: "before",
    value: "GHS"
  }, {
    name: "柬埔寨瑞尔",
    pos: "before",
    value: "Riel"
  }, {
    name: "捷克克朗",
    pos: "after",
    value: "K?"
  }, {
    name: "津巴布韦元",
    pos: "before",
    value: "$"
  }, {
    name: "卡塔尔里亚尔",
    pos: "before",
    value: "Rial"
  }, {
    name: "开曼群岛元",
    pos: "before",
    value: "$"
  }, {
    name: "科摩罗法郎",
    pos: "before",
    value: "CF"
  }, {
    name: "科威特第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "克罗地亚库纳",
    pos: "before",
    value: "kn"
  }, {
    name: "肯尼亚先令",
    pos: "before",
    value: "Ksh"
  }, {
    name: "莱索托洛蒂",
    pos: "before",
    value: "LSL"
  }, {
    name: "老挝基普",
    pos: "before",
    value: "?"
  }, {
    name: "黎巴嫩镑",
    pos: "before",
    value: "L￡"
  }, {
    name: "立陶宛立特",
    pos: "before",
    value: "Lt"
  }, {
    name: "利比亚第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "利比亚元",
    pos: "before",
    value: "$"
  }, {
    name: "卢旺达法郎",
    pos: "before",
    value: "RF"
  }, {
    name: "罗马尼亚列伊",
    pos: "before",
    value: "RON"
  }, {
    name: "马达加斯加阿里亚里",
    pos: "before",
    value: "Ar"
  }, {
    name: "马尔代夫拉菲亚",
    pos: "before",
    value: "Rf"
  }, {
    name: "马拉维克瓦查",
    pos: "before",
    value: "MWK"
  }, {
    name: "马来西亚林吉特",
    pos: "before",
    value: "RM"
  }, {
    name: "马其顿戴第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "毛里求斯卢比",
    pos: "before",
    value: "MURs"
  }, {
    name: "毛里塔尼亚乌吉亚",
    pos: "before",
    value: "MRO"
  }, {
    name: "蒙古图格里克",
    pos: "before",
    value: "?"
  }, {
    name: "孟加拉塔卡",
    pos: "before",
    value: "?"
  }, {
    name: "秘鲁新索尔",
    pos: "before",
    value: "S/"
  }, {
    name: "缅甸开亚特",
    pos: "before",
    value: "K"
  }, {
    name: "摩尔多瓦列伊",
    pos: "before",
    value: "MDL"
  }, {
    name: "摩洛哥迪拉姆",
    pos: "before",
    value: "dh"
  }, {
    name: "莫桑比克梅蒂卡尔",
    pos: "before",
    value: "MTn"
  }, {
    name: "墨西哥比索",
    pos: "before",
    value: "$"
  }, {
    name: "纳米比亚元",
    pos: "before",
    value: "$"
  }, {
    name: "南非兰特",
    pos: "before",
    value: "R"
  }, {
    name: "南苏丹镑",
    pos: "before",
    value: "￡"
  }, {
    name: "尼加拉瓜科多巴",
    pos: "before",
    value: "C$"
  }, {
    name: "尼泊尔卢比",
    pos: "before",
    value: "Rs"
  }, {
    name: "尼日利亚奈拉",
    pos: "before",
    value: "?"
  }, {
    name: "挪威克朗",
    pos: "after",
    value: "kr"
  }, {
    name: "乔治亚拉瑞",
    pos: "before",
    value: "GEL"
  }, {
    name: "瑞典克朗",
    pos: "after",
    value: "kr"
  }, {
    name: "瑞士法郎",
    pos: "before",
    value: "CHF"
  }, {
    name: "塞尔维亚第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "塞拉利昂利昂",
    pos: "before",
    value: "SLL"
  }, {
    name: "塞舌尔卢比",
    pos: "before",
    value: "SCR"
  }, {
    name: "沙特里亚尔",
    pos: "before",
    value: "Rial"
  }, {
    name: "圣多美多布拉",
    pos: "before",
    value: "Db"
  }, {
    name: "圣赫勒拿群岛磅",
    pos: "before",
    value: "￡"
  }, {
    name: "斯里兰卡卢比",
    pos: "before",
    value: "Rs"
  }, {
    name: "斯威士兰里兰吉尼",
    pos: "before",
    value: "SZL"
  }, {
    name: "苏丹镑",
    pos: "before",
    value: "SDG"
  }, {
    name: "苏里南元",
    pos: "before",
    value: "$"
  }, {
    name: "所罗门群岛元",
    pos: "before",
    value: "$"
  }, {
    name: "索马里先令",
    pos: "before",
    value: "SOS"
  }, {
    name: "塔吉克斯坦索莫尼",
    pos: "before",
    value: "Som"
  }, {
    name: "太平洋法郎",
    pos: "after",
    value: "FCFP"
  }, {
    name: "泰国铢",
    pos: "before",
    value: "?"
  }, {
    name: "坦桑尼亚先令",
    pos: "before",
    value: "TSh"
  }, {
    name: "汤加潘加",
    pos: "before",
    value: "T$"
  }, {
    name: "特立尼达和多巴哥元",
    pos: "before",
    value: "$"
  }, {
    name: "突尼斯第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "土耳其里拉",
    pos: "before",
    value: "?"
  }, {
    name: "瓦努阿图瓦图",
    pos: "before",
    value: "VUV"
  }, {
    name: "危地马拉格查尔",
    pos: "before",
    value: "Q"
  }, {
    name: "委内瑞拉博利瓦",
    pos: "before",
    value: "Bs"
  }, {
    name: "文莱元",
    pos: "before",
    value: "$"
  }, {
    name: "乌干达先令",
    pos: "before",
    value: "UGX"
  }, {
    name: "乌克兰格里夫尼亚",
    pos: "before",
    value: "грн."
  }, {
    name: "乌拉圭比索",
    pos: "before",
    value: "$"
  }, {
    name: "乌兹别克斯坦苏姆",
    pos: "before",
    value: "so?m"
  }, {
    name: "西萨摩亚塔拉",
    pos: "before",
    value: "WST"
  }, {
    name: "新加坡元",
    pos: "before",
    value: "$"
  }, {
    name: "新台币",
    pos: "before",
    value: "NT$"
  }, {
    name: "新西兰元",
    pos: "before",
    value: "$"
  }, {
    name: "匈牙利福林",
    pos: "before",
    value: "Ft"
  }, {
    name: "叙利亚镑",
    pos: "before",
    value: "￡"
  }, {
    name: "牙买加元",
    pos: "before",
    value: "$"
  }, {
    name: "亚美尼亚德拉姆",
    pos: "before",
    value: "Dram"
  }, {
    name: "也门里亚尔",
    pos: "before",
    value: "Rial"
  }, {
    name: "伊拉克第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "伊朗里亚尔",
    pos: "before",
    value: "Rial"
  }, {
    name: "以色列新谢克尔",
    pos: "before",
    value: "?"
  }, {
    name: "印度卢比",
    pos: "before",
    value: "?"
  }, {
    name: "印度尼西亚卢比",
    pos: "before",
    value: "Rp"
  }, {
    name: "约旦第纳尔",
    pos: "before",
    value: "din"
  }, {
    name: "越南盾",
    pos: "after",
    value: "?"
  }, {
    name: "赞比亚克瓦查",
    pos: "before",
    value: "ZMW"
  }, {
    name: "直布罗陀镑",
    pos: "before",
    value: "￡"
  }, {
    name: "智利比索",
    pos: "before",
    value: "$"
  }, {
    name: "中非金融合作法郎",
    pos: "before",
    value: "FCFA"
  }],
  defaultFmt: function defaultFmt(currency) {
    return [{
      text: "自动",
      value: "General",
      example: ""
    }, {
      text: "纯文本",
      value: "@",
      example: ""
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "数字",
      value: "##0.00",
      example: "1000.12"
    }, {
      text: "百分比",
      value: "#0.00%",
      example: "12.21%"
    }, {
      text: "科学计数",
      value: "0.00E+00",
      example: "1.01E+5"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "会计",
      value: "".concat(currency, "(0.00)"),
      example: "".concat(currency, "(1200.09)")
    }, {
      text: "万元",
      value: "w",
      example: "1亿2000万2500"
    }, {
      text: "货币",
      value: "".concat(currency, "0.00"),
      example: "".concat(currency, "1200.09")
    }, {
      text: "万元2位小数",
      value: "w0.00",
      example: "2万2500.55"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "日期",
      value: "yyyy-MM-dd",
      example: "2017-11-29"
    }, {
      text: "时间",
      value: "hh:mm AM/PM",
      example: "3:00 PM"
    }, {
      text: "时间24H",
      value: "hh:mm",
      example: "15:00"
    }, {
      text: "日期时间",
      value: "yyyy-MM-dd hh:mm AM/PM",
      example: "2017-11-29 3:00 PM"
    }, {
      text: "日期时间24H",
      value: "yyyy-MM-dd hh:mm",
      example: "2017-11-29 15:00"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "自定义格式",
      value: "fmtOtherSelf",
      example: "",
      icon: "rightArrow"
    }];
  },
  dateFmtList: [{
    name: "1930-08-05",
    value: "yyyy-MM-dd"
  }, {
    name: "1930/8/5",
    value: "yyyy/MM/dd"
  }, {
    name: "1930年8月5日",
    value: 'yyyy"年"M"月"d"日"'
  }, {
    name: "08-05",
    value: "MM-dd"
  }, {
    name: "8-5",
    value: "M-d"
  }, {
    name: "8月5日",
    value: 'M"月"d"日"'
  }, {
    name: "13:30:30",
    value: "h:mm:ss"
  }, {
    name: "13:30",
    value: "h:mm"
  }, {
    name: "下午01:30",
    value: "上午/下午 hh:mm"
  }, {
    name: "下午1:30",
    value: "上午/下午 h:mm"
  }, {
    name: "下午1:30:30",
    value: "上午/下午 h:mm:ss"
  }, {
    name: "08-05 下午01:30",
    value: "MM-dd 上午/下午 hh:mm"
  }],
  fontFamily: {
    MicrosoftYaHei: "Microsoft YaHei"
  },
  fontarray: ["Times New Roman", "Arial", "Tahoma", "Verdana", "微软雅黑", "宋体", "黑体", "楷体", "仿宋", "新宋体", "华文新魏", "华文行楷", "华文隶书"],
  fontjson: {
    "times new roman": 0,
    arial: 1,
    tahoma: 2,
    verdana: 3,
    微软雅黑: 4,
    "microsoft yahei": 4,
    宋体: 5,
    simsun: 5,
    黑体: 6,
    simhei: 6,
    楷体: 7,
    kaiti: 7,
    仿宋: 8,
    fangsong: 8,
    新宋体: 9,
    nsimsun: 9,
    华文新魏: 10,
    stxinwei: 10,
    华文行楷: 11,
    stxingkai: 11,
    华文隶书: 12,
    stliti: 12
  },
  border: {
    borderTop: "上框线",
    borderBottom: "下框线",
    borderLeft: "左框线",
    borderRight: "右框线",
    borderNone: "无",
    borderAll: "所有",
    borderOutside: "外侧",
    borderInside: "内侧",
    borderHorizontal: "内侧横线",
    borderVertical: "内侧竖线",
    borderColor: "边框颜色",
    borderSize: "边框粗细",
    borderSlash: "边框斜线",
    borderDefault: "默认样式",
    borderStyle: "边框样式"
  },
  merge: {
    mergeAll: "全部合并",
    mergeV: "垂直合并",
    mergeH: "水平合并",
    mergeCancel: "取消合并",
    overlappingError: "不能合并重叠区域",
    partiallyError: "无法对部分合并单元格执行此操作"
  },
  align: {
    left: "左对齐",
    center: "中间对齐",
    right: "右对齐",
    top: "顶部对齐",
    middle: "居中对齐",
    bottom: "底部对齐"
  },
  textWrap: {
    overflow: "溢出",
    wrap: "自动换行",
    clip: "截断"
  },
  rotation: {
    none: "无旋转",
    angleup: "向上倾斜",
    angledown: "向下倾斜",
    vertical: "竖排文字",
    rotationUp: "向上90°",
    rotationDown: "向下90°"
  },
  freezen: {
    default: "冻结第一行",
    freezenRow: "冻结第一行",
    freezenColumn: "冻结第A列",
    freezenRC: "冻结第一行第A列",
    freezenRowRange: "冻结至当前行",
    freezenColumnRange: "冻结至当前列",
    freezenRCRange: "冻结至当前行列",
    freezenCancel: "取消冻结",
    noSeletionError: "没有选区",
    rangeRCOverErrorTitle: "冻结提醒",
    rangeRCOverError: "冻结窗格超过可见范围，会导致无法正常操作，请重新设置冻结区域。"
  },
  sort: {
    asc: "升序",
    desc: "降序",
    custom: "自定义排序",
    hasTitle: "数据具有标题行",
    sortBy: "排序依据",
    addOthers: "添加其他排序列",
    close: "关闭",
    confirm: "排序",
    columnOperation: "列",
    secondaryTitle: "次要排序",
    sortTitle: "排序范围",
    sortRangeTitle: "排序范围从",
    sortRangeTitleTo: "到",
    noRangeError: "不能对多重选择区域执行此操作，请选择单个区域，然后再试",
    mergeError: "选区有合并单元格，无法执行此操作！"
  },
  filter: {
    filter: "筛选",
    clearFilter: "清除筛选",
    sortByAsc: "升序排列",
    sortByDesc: "降序排列",
    filterByColor: "按颜色筛选",
    filterByCondition: "按条件过滤",
    filterByValues: "按值过滤",
    filiterInputNone: "无",
    filiterInputTip: "输入筛选值",
    filiterRangeStartTip: "范围开始",
    filiterRangeEndTip: "范围结束",
    filterValueByAllBtn: "全选",
    filterValueByClearBtn: "清除",
    filterValueByInverseBtn: "反选",
    filterValueByTip: "按照值进行筛选",
    filterConform: "确 认",
    filterCancel: "取 消",
    conditionNone: "无",
    conditionCellIsNull: "单元格为空",
    conditionCellNotNull: "单元格有数据",
    conditionCellTextContain: "文本包含",
    conditionCellTextNotContain: "文本不包含",
    conditionCellTextStart: "文本开头为",
    conditionCellTextEnd: "文本结尾为",
    conditionCellTextEqual: "文本等于",
    conditionCellDateEqual: "日期等于",
    conditionCellDateBefore: "日期早于",
    conditionCellDateAfter: "日期晚于",
    conditionCellGreater: "大于",
    conditionCellGreaterEqual: "大于等于",
    conditionCellLess: "小于",
    conditionCellLessEqual: "小于等于",
    conditionCellEqual: "等于",
    conditionCellNotEqual: "不等于",
    conditionCellBetween: "介于",
    conditionCellNotBetween: "不在其中",
    filiterMoreDataTip: "数据量大！请稍后",
    filiterMonthText: "月",
    filiterYearText: "年",
    filiterByColorTip: "按单元格颜色筛选",
    filiterByTextColorTip: "按单元格字体颜色筛选",
    filterContainerOneColorTip: "本列仅包含一种颜色",
    filterDateFormatTip: "日期格式",
    valueBlank: "(空白)",
    mergeError: "筛选选区有合并单元格，无法执行此操作！"
  },
  rightclick: {
    copy: "复制",
    copyAs: "复制为",
    paste: "粘贴",
    insert: "插入",
    image: "插入图片",
    link: "插入链接",
    delete: "删除",
    deleteCell: "删除单元格",
    deleteSelected: "删除选中",
    hide: "隐藏",
    hideSelected: "隐藏选中",
    showHide: "显示隐藏",
    to: "向",
    left: "左",
    right: "右",
    top: "上",
    bottom: "下",
    moveLeft: "左移",
    moveUp: "上移",
    add: "增加",
    row: "行",
    column: "列",
    width: "宽",
    height: "高",
    number: "数字",
    confirm: "确认",
    orderAZ: "升序排列",
    orderZA: "降序排列",
    clearContent: "清除内容",
    matrix: "矩阵操作选区",
    sortSelection: "排序选区",
    filterSelection: "筛选选区",
    chartGeneration: "图表生成",
    firstLineTitle: "首行为标题",
    untitled: "无标题",
    array1: "一维数组",
    array2: "二维数组",
    array3: "多维数组",
    diagonal: "对角线",
    antiDiagonal: "反对角线",
    diagonalOffset: "对角偏移",
    offset: "偏移量",
    boolean: "布尔值",
    flip: "翻转",
    upAndDown: "上下",
    leftAndRight: "左右",
    clockwise: "顺时针",
    counterclockwise: "逆时针",
    transpose: "转置",
    matrixCalculation: "矩阵计算",
    plus: "加",
    minus: "减",
    multiply: "乘",
    divided: "除",
    power: "次方",
    root: "次方根",
    log: "log",
    delete0: "删除两端0值",
    removeDuplicate: "删除重复值",
    byRow: "按行",
    byCol: "按列",
    generateNewMatrix: "生成新矩阵",
    noMulti: "无法对多重选择区域执行此操作,请选择单个区域",
    cannotDeleteAllRow: "无法删除所有行",
    cannotDeleteAllColumn: "无法删除所有列",
    cannotDeleteRowReadOnly: "无法删除只读行",
    cannotDeleteColumnReadOnly: "无法删除只读列",
    cannotInsertOnRowReadOnly: "无法对只读行插入",
    cannotInsertOnColumnReadOnly: "无法对只读列插入",
    rowOverLimit: "超出10000行限制",
    columnOverLimit: "超出1000列限制"
  },
  comment: {
    insert: "新建批注",
    edit: "编辑批注",
    delete: "删除",
    showOne: "显示/隐藏批注",
    showAll: "显示/隐藏所有批注"
  },
  screenshot: {
    screenshotTipNoSelection: "请框选需要截图的范围",
    screenshotTipTitle: "提示！",
    screenshotTipHasMerge: "无法对合并单元格执行此操作",
    screenshotTipHasMulti: "无法对多重选择区域执行此操作",
    screenshotTipSuccess: "截取成功",
    screenshotImageName: "截图",
    downLoadClose: "关闭",
    downLoadCopy: "复制到剪切板",
    downLoadBtn: "下载",
    browserNotTip: "下载功能IE浏览器不支持！",
    rightclickTip: "请在图片上右键点击'复制'",
    successTip: "已成功复制（如果粘贴失败，请在图片上右键点击'复制图片'）"
  },
  splitText: {
    splitDelimiters: "分割符号",
    splitOther: "其它",
    splitContinueSymbol: "连续分隔符号视为单个处理",
    splitDataPreview: "数据预览",
    splitTextTitle: "文本分列",
    splitConfirmToExe: "此处已有数据，是否替换它？",
    splitSymbols: [{
      name: "Tab键",
      value: "Tab"
    }, {
      name: "分号",
      value: "semicolon"
    }, {
      name: "逗号",
      value: "comma"
    }, {
      name: "空格",
      value: "space"
    }],
    tipNoMulti: "不能对多重选择区域执行此操作，请选择单个区域，然后再试",
    tipNoMultiColumn: "一次只能转换一列数据，选定区域可以有多行，但不能有多列，请在选定单列区域以后再试",
    tipNoSelect: "没有选择单元格不能进行分列"
  },
  imageText: {
    imageSetting: "图片设置",
    close: "关闭",
    conventional: "常规",
    moveCell1: "移动并调整单元格大小",
    moveCell2: "移动并且不调整单元格的大小",
    moveCell3: "不要移动单元格并调整其大小",
    fixedPos: "固定位置",
    border: "边框",
    width: "宽度",
    radius: "半径",
    style: "样式",
    solid: "实线",
    dashed: "虚线",
    dotted: "点状",
    double: "双线",
    color: "颜色"
  },
  punctuation: {
    tab: "Tab 键",
    semicolon: "分号",
    comma: "逗号",
    space: "空格"
  },
  findAndReplace: {
    find: "查找",
    replace: "替换",
    goto: "转到",
    location: "定位条件",
    formula: "公式",
    date: "日期",
    number: "数字",
    string: "字符",
    error: "错误",
    condition: "条件格式",
    rowSpan: "间隔行",
    columnSpan: "间隔列",
    locationExample: "定位",
    lessTwoRowTip: "请选择最少两行",
    lessTwoColumnTip: "请选择最少两行",
    findTextbox: "查找内容",
    replaceTextbox: "替换内容",
    regexTextbox: "正则表达式匹配",
    wholeTextbox: "整词匹配",
    distinguishTextbox: "区分大小写匹配",
    allReplaceBtn: "全部替换",
    replaceBtn: "替换",
    allFindBtn: "查找全部",
    findBtn: "查找下一个",
    noFindTip: "没有查找到该内容",
    modeTip: "该模式下不可进行此操作",
    searchTargetSheet: "工作表",
    searchTargetCell: "单元格",
    searchTargetValue: "值",
    searchInputTip: "请输入查找内容",
    noReplceTip: "没有可替换的内容",
    noMatchTip: "找不到匹配项",
    successTip: "已经帮您搜索并进行了${xlength}处替换",
    locationConstant: "常量",
    locationFormula: "公式",
    locationDate: "日期",
    locationDigital: "数字",
    locationString: "字符",
    locationBool: "逻辑值",
    locationError: "错误",
    locationNull: "空值",
    locationCondition: "条件格式",
    locationRowSpan: "间隔行",
    locationColumnSpan: "间隔列",
    locationTiplessTwoRow: "请选择最少两行",
    locationTiplessTwoColumn: "请选择最少两列",
    locationTipNotFindCell: "未找到单元格"
  },
  sheetconfig: {
    delete: "删除",
    copy: "复制",
    rename: "重命名",
    changeColor: "更改颜色",
    hide: "隐藏",
    unhide: "取消隐藏",
    moveLeft: "向左移",
    moveRight: "向右移",
    resetColor: "重置颜色",
    cancelText: "取消",
    chooseText: "确定颜色",
    focus: "聚焦",
    tipNameRepeat: "标签页的名称不能重复！请重新修改",
    noMoreSheet: "工作薄内至少含有一张可视工作表。若需删除选定的工作表，请先插入一张新工作表或显示一张隐藏的工作表。",
    confirmDelete: "是否删除",
    redoDelete: "可以通过Ctrl+Z撤销删除",
    noHide: "不能隐藏, 至少保留一个sheet标签",
    chartEditNoOpt: "图表编辑模式下不允许该操作！",
    sheetNameSpecCharError: "名称不能超过31个字符，首尾不能是' 且名称不能包含:\r\n[ ] : \\ ? * /",
    sheetNamecannotIsEmptyError: "名称不能为空!"
  },
  conditionformat: {
    conditionformat_greaterThan: "条件格式——大于",
    conditionformat_greaterThan_title: "为大于以下值的单元格设置格式",
    conditionformat_lessThan: "条件格式——小于",
    conditionformat_lessThan_title: "为小于以下值的单元格设置格式",
    conditionformat_between: "条件格式——介于",
    conditionformat_between_title: "为介于以下值的单元格设置格式",
    conditionformat_equal: "条件格式——等于",
    conditionformat_equal_title: "为等于以下值的单元格设置格式",
    conditionformat_textContains: "条件格式——文本包含",
    conditionformat_textContains_title: "为包含以下文本的单元格设置格式",
    conditionformat_occurrenceDate: "条件格式——发生日期",
    conditionformat_occurrenceDate_title: "为包含以下日期的单元格设置格式",
    conditionformat_duplicateValue: "条件格式——重复值",
    conditionformat_duplicateValue_title: "为包含以下类型值的单元格设置格式",
    conditionformat_top10: "条件格式——前 10 项",
    conditionformat_top10_percent: "条件格式——前 10%",
    conditionformat_top10_title: "为值最大的那些单元格设置格式",
    conditionformat_last10: "条件格式——最后 10 项",
    conditionformat_last10_percent: "条件格式——最后 10%",
    conditionformat_last10_title: "为值最小的那些单元格设置格式",
    conditionformat_aboveAverage: "条件格式——高于平均值",
    conditionformat_aboveAverage_title: "为高于平均值的单元格设置格式",
    conditionformat_belowAverage: "条件格式——低于平均值",
    conditionformat_belowAverage_title: "为低于平均值的单元格设置格式",
    rule: "规则",
    newRule: "新建规则",
    editRule: "编辑规则",
    deleteRule: "删除规则",
    deleteCellRule: "清除所选单元格的规则",
    deleteSheetRule: "清除整个工作表的规则",
    manageRules: "管理规则",
    showRules: "显示其格式规则",
    highlightCellRules: "突出显示单元格规则",
    itemSelectionRules: "项目选取规则",
    conditionformatManageRules: "条件格式规则管理器",
    format: "格式",
    setFormat: "设置格式",
    setAs: "设置为",
    setAsByArea: "针对选定区域，设置为",
    applyRange: "应用范围",
    selectRange: "点击选择应用范围",
    selectRange_percent: "所选范围的百分比",
    selectRange_average: "选定范围的平均值",
    selectRange_value: "选定范围中的数值",
    pleaseSelectRange: "请选择应用范围",
    selectDataRange: "点击选择数据范围",
    selectCell: "选择单元格",
    pleaseSelectCell: "请选择单元格",
    pleaseSelectADate: "请选择日期",
    pleaseEnterInteger: "请输入一个介于 1 和 1000 之间的整数",
    onlySingleCell: "只能对单个单元格进行引用",
    conditionValueCanOnly: "条件值只能是数字或者单个单元格",
    ruleTypeItem1: "基于各自值设置所有单元格的格式",
    ruleTypeItem2: "只为包含以下内容的单元格设置格式",
    ruleTypeItem2_title: "只为满足以下条件的单元格",
    ruleTypeItem3: "仅对排名靠前或靠后的数值设置格式",
    ruleTypeItem3_title: "为以下排名内的值",
    ruleTypeItem4: "仅对高于或低于平均值的数值设置格式",
    ruleTypeItem4_title: "为满足以下条件的值",
    ruleTypeItem5: "仅对唯一值或重复值设置格式",
    ruleTypeItem6: "使用公式确定要设置格式的单元格",
    formula: "公式",
    textColor: "文本颜色",
    cellColor: "单元格颜色",
    confirm: "确定",
    confirmColor: "确定颜色",
    cancel: "取消",
    close: "关闭",
    clearColorSelect: "清除颜色选择",
    sheet: "表",
    currentSheet: "当前工作表",
    dataBar: "数据条",
    dataBarColor: "数据条颜色",
    gradientDataBar_1: "蓝-白渐变数据条",
    gradientDataBar_2: "绿-白渐变数据条",
    gradientDataBar_3: "红-白渐变数据条",
    gradientDataBar_4: "橙-白渐变数据条",
    gradientDataBar_5: "浅蓝-白渐变数据条",
    gradientDataBar_6: "紫-白渐变数据条",
    solidColorDataBar_1: "蓝色数据条",
    solidColorDataBar_2: "绿色数据条",
    solidColorDataBar_3: "红色数据条",
    solidColorDataBar_4: "橙色数据条",
    solidColorDataBar_5: "浅蓝色数据条",
    solidColorDataBar_6: "紫色数据条",
    colorGradation: "色阶",
    colorGradation_1: "绿-黄-红色阶",
    colorGradation_2: "红-黄-绿色阶",
    colorGradation_3: "绿-白-红色阶",
    colorGradation_4: "红-白-绿色阶",
    colorGradation_5: "蓝-白-红色阶",
    colorGradation_6: "红-白-蓝色阶",
    colorGradation_7: "白-红色阶",
    colorGradation_8: "红-白色阶",
    colorGradation_9: "绿-白色阶",
    colorGradation_10: "白-绿色阶",
    colorGradation_11: "绿-黄色阶",
    colorGradation_12: "黄-绿色阶",
    icons: "图标集",
    pleaseSelectIcon: "请点击选择一组图标：",
    cellValue: "单元格值",
    specificText: "特定文本",
    occurrenceDate: "发生日期",
    greaterThan: "大于",
    lessThan: "小于",
    between: "介于",
    equal: "等于",
    in: "和",
    to: "到",
    between2: "之间",
    contain: "包含",
    textContains: "文本包含",
    duplicateValue: "重复值",
    uniqueValue: "唯一值",
    top: "前",
    top10: "前 10 项",
    top10_percent: "前 10%",
    last: "后",
    last10: "后 10 项",
    last10_percent: "后 10%",
    oneself: "个",
    above: "高于",
    aboveAverage: "高于平均值",
    below: "低于",
    belowAverage: "低于平均值",
    all: "全部",
    yesterday: "昨天",
    today: "今天",
    tomorrow: "明天",
    lastWeek: "上周",
    thisWeek: "本周",
    lastMonth: "上月",
    thisMonth: "本月",
    lastYear: "去年",
    thisYear: "本年",
    last7days: "最近7天",
    last30days: "最近30天",
    next7days: "未来7天",
    next30days: "未来30天",
    next60days: "未来60天",
    chooseRuleType: "选择规则类型",
    editRuleDescription: "编辑规则说明",
    newFormatRule: "新建格式规则",
    editFormatRule: "编辑格式规则",
    formatStyle: "格式样式",
    fillType: "填充类型",
    color: "颜色",
    twocolor: "双色",
    tricolor: "三色",
    multicolor: "彩色",
    grayColor: "灰色",
    gradient: "渐变",
    solid: "实心",
    maxValue: "最大值",
    medianValue: "中间值",
    minValue: "最小值",
    direction: "方向",
    threeWayArrow: "三向箭头",
    fourWayArrow: "四向箭头",
    fiveWayArrow: "五向箭头",
    threeTriangles: "3个三角形",
    shape: "形状",
    threeColorTrafficLight: "三色交通灯",
    fourColorTrafficLight: "四色交通灯",
    threeSigns: "三标志",
    greenRedBlackGradient: "绿-红-黑渐变",
    rimless: "无边框",
    bordered: "有边框",
    mark: "标记",
    threeSymbols: "三个符号",
    tricolorFlag: "三色旗",
    circled: "有圆圈",
    noCircle: "无圆圈",
    grade: "等级",
    grade4: "四等级",
    grade5: "五等级",
    threeStars: "3个星形",
    fiveQuadrantDiagram: "五象限图",
    fiveBoxes: "5个框"
  },
  insertLink: {
    linkText: "显示文本",
    linkType: "链接类型",
    linkAddress: "链接地址",
    linkSheet: "工作表",
    linkCell: "单元格范围",
    linkTooltip: "提示",
    selectCellRange: "选择单元格范围",
    cellRangePlaceholder: "可用鼠标框选单元格，或直接输入范围",
    placeholder1: "请输入网页链接地址",
    placeholder2: "请输入要引用的单元格，例A1",
    placeholder3: "请输入提示内容",
    tooltipInfo1: "请输入有效的链接",
    invalidCellRangeTip: "请输入正确的单元格范围，比如 工作表1!A1:C8",
    openLink: "打开链接",
    goTo: "跳转至 ${linkAddress}"
  },
  linkTypeList: [{
    text: "网页",
    value: "webpage"
  }, {
    text: "单元格范围",
    value: "cellrange"
  }, {
    text: "工作表",
    value: "sheet"
  }],
  dataVerification: {
    cellRange: "单元格范围",
    selectCellRange: "点击选择单元格范围",
    selectCellRange2: "请选择单元格范围",
    verificationCondition: "验证条件",
    allowMultiSelect: "是否允许多选",
    dropdown: "下拉列表",
    checkbox: "复选框",
    number: "数字",
    number_integer: "数字-整数",
    number_decimal: "数字-小数",
    text_content: "文本-内容",
    text_length: "文本-长度",
    date: "日期",
    validity: "有效性",
    placeholder1: "请输入选项，以英文逗号分隔，如1,2,3,4,5",
    placeholder2: "请输入内容",
    placeholder3: "数值，如10",
    placeholder4: "请输入指定的文本",
    placeholder5: "请输入选中单元格时显示的提示语",
    selected: "选择时",
    notSelected: "未选择",
    between: "介于",
    notBetween: "不介于",
    equal: "等于",
    notEqualTo: "不等于",
    moreThanThe: "大于",
    lessThan: "小于",
    greaterOrEqualTo: "大于等于",
    lessThanOrEqualTo: "小于等于",
    include: "包括",
    exclude: "不包括",
    earlierThan: "早于",
    noEarlierThan: "不早于",
    laterThan: "晚于",
    noLaterThan: "不晚于",
    identificationNumber: "身份证号码",
    phoneNumber: "手机号",
    remote: "自动远程获取选项",
    prohibitInput: "输入数据无效时禁止输入",
    hintShow: "选中单元格时显示提示语",
    deleteVerification: "删除验证",
    tooltipInfo1: "下拉列表选项不可为空",
    tooltipInfo2: "复选框内容不可为空",
    tooltipInfo3: "输入的值不是数值类型",
    tooltipInfo4: "数值2不能小于数值1",
    tooltipInfo5: "文本内容不能为空",
    tooltipInfo6: "输入的值不是日期类型",
    tooltipInfo7: "日期2不能小于日期1",
    textlengthInteger: "文本长度必须是大于等于0的整数"
  },
  formula: {
    sum: "求和",
    average: "平均值",
    count: "计数",
    max: "最大值",
    min: "最小值",
    ifGenerate: "if公式生成器",
    find: "更多函数",
    tipNotBelongToIf: "该单元格函数不属于if公式！",
    tipSelectCell: "请选择单元格插入函数",
    ifGenCompareValueTitle: "比较值",
    ifGenSelectCellTitle: "点击选择单元格",
    ifGenRangeTitle: "范围",
    ifGenRangeTo: "至",
    ifGenRangeEvaluate: "范围评估",
    ifGenSelectRangeTitle: "点击选择范围",
    ifGenCutWay: "划分方式",
    ifGenCutSame: "划分值相同",
    ifGenCutNpiece: "划分为N份",
    ifGenCutCustom: "自定义输入",
    ifGenCutConfirm: "生成",
    ifGenTipSelectCell: "选择单元格",
    ifGenTipSelectCellPlace: "请选择单元格",
    ifGenTipSelectRange: "选择单范围",
    ifGenTipSelectRangePlace: "请选择范围",
    ifGenTipNotNullValue: "比较值不能为空！",
    ifGenTipLableTitile: "标签",
    ifGenTipRangeNotforNull: "范围不能为空！",
    ifGenTipCutValueNotforNull: "划分值不能为空！",
    ifGenTipNotGenCondition: "没有生成可用的条件！"
  },
  formulaMore: {
    valueTitle: "值",
    tipSelectDataRange: "选取数据范围",
    tipDataRangeTile: "数据范围",
    findFunctionTitle: "查找函数",
    tipInputFunctionName: "请输入您要查找的函数名称或函数功能的简要描述",
    Array: "数组",
    Database: "数据源",
    Date: "日期",
    Engineering: "工程计算",
    Filter: "过滤器",
    Financial: "财务",
    luckysheet: "Luckysheet内置",
    other: "其它",
    Logical: "逻辑",
    Lookup: "查找",
    Math: "数学",
    Operator: "运算符",
    Parser: "转换工具",
    Statistical: "统计",
    Text: "文本",
    dataMining: "数据挖掘",
    selectFunctionTitle: "选择函数",
    calculationResult: "计算结果",
    tipSuccessText: "成功",
    tipParamErrorText: "参数类型错误",
    helpClose: "关闭",
    helpCollapse: "收起",
    helpExample: "示例",
    helpAbstract: "摘要",
    execfunctionError: '提示", "公式存在错误',
    execfunctionSelfError: "公式不可引用其本身的单元格",
    execfunctionSelfErrorResult: "公式不可引用其本身的单元格，会导致计算结果不准确",
    allowRepeatText: "可重复",
    allowOptionText: "可选",
    selectCategory: "或选择类别"
  },
  drag: {
    noMerge: "无法对合并单元格执行此操作",
    affectPivot: "无法对所选单元格进行此更改，因为它会影响数据透视表！",
    noMulti: "无法对多重选择区域执行此操作,请选择单个区域",
    noPaste: "无法在此处粘贴此内容，请选择粘贴区域的一个单元格，然后再次尝试粘贴",
    noPartMerge: "无法对部分合并单元格执行此操作",
    inputCorrect: "请输入正确的数值",
    notLessOne: "行列数不能小于1",
    offsetColumnLessZero: "偏移列不能为负数！",
    pasteMustKeybordAlert: "Copy and paste in the Sheet: Ctrl + C to copy, Ctrl + V to paste, Ctrl + X to cut",
    pasteMustKeybordAlertHTMLTitle: "Copy and paste in the Sheet",
    pasteMustKeybordAlertHTML: "<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;to copy<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;to paste<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;to cut"
  },
  pivotTable: {
    title: "数据透视表",
    closePannel: "关闭",
    editRange: "编辑范围",
    tipPivotFieldSelected: "选择需要添加到数据透视表的字段",
    tipClearSelectedField: "清除所有已选字段",
    btnClearSelectedField: "清除",
    btnFilter: "筛选",
    titleRow: "行",
    titleColumn: "列",
    titleValue: "数值",
    tipShowColumn: "统计字段显示为列",
    tipShowRow: "统计字段显示为行",
    titleSelectionDataRange: "选取数据范围",
    titleDataRange: "数据范围",
    valueSum: "总计",
    valueStatisticsSUM: "求和",
    valueStatisticsCOUNT: "数值计数",
    valueStatisticsCOUNTA: "计数",
    valueStatisticsCOUNTUNIQUE: "去重计数",
    valueStatisticsAVERAGE: "平均值",
    valueStatisticsMAX: "最大值",
    valueStatisticsMIN: "最小值",
    valueStatisticsMEDIAN: "中位数",
    valueStatisticsPRODUCT: "乘积",
    valueStatisticsSTDEV: "标准差",
    valueStatisticsSTDEVP: "整体标准差",
    valueStatisticslet: "方差",
    valueStatisticsVARP: "整体方差",
    errorNotAllowEdit: "非编辑模式下禁止该操作！",
    errorNotAllowMulti: "不能对多重选择区域执行此操作，请选择单个区域，然后再试",
    errorSelectRange: "请选择新建透视表的区域",
    errorIsDamage: "此数据透视表的源数据已损坏！",
    errorNotAllowPivotData: "不可选择数据透视表为源数据！",
    errorSelectionRange: "选择失败, 输入范围错误！",
    errorIncreaseRange: "请扩大选择的数据范围!",
    titleAddColumn: "添加列到数据透视表",
    titleMoveColumn: "移动该列到下方白框",
    titleClearColumnFilter: "清除该列的筛选条件",
    titleFilterColumn: "筛选该列",
    titleSort: "排序",
    titleNoSort: "无排序",
    titleSortAsc: "升序",
    titleSortDesc: "降序",
    titleSortBy: "排序依据",
    titleShowSum: "显示总计",
    titleStasticTrue: "是",
    titleStasticFalse: "否"
  },
  dropCell: {
    copyCell: "复制单元格",
    sequence: "填充序列",
    onlyFormat: "仅填充格式",
    noFormat: "不带格式填充",
    day: "以天数填充",
    workDay: "以工作日填充",
    month: "以月填充",
    year: "以年填充",
    chineseNumber: "以中文小写数字填充"
  },
  imageCtrl: {
    borderTile: "图片边框颜色选择",
    borderCur: "当前颜色"
  },
  protection: {
    protectiontTitle: "保护工作表",
    enterPassword: "请输入密码（可留空）",
    enterHint: "您试图更改的单元格或图表位于受保护的工作表中。若要更改，请取消工作表保护。您可能需要输入密码",
    swichProtectionTip: "保护工作表及锁定的单元格内容",
    authorityTitle: "允许此工作表的用户进行:",
    selectLockedCells: "选定锁定单元格",
    selectunLockedCells: "选定解除锁定的单元格",
    formatCells: "设置单元格格式",
    formatColumns: "设置列格式",
    formatRows: "设置行格式",
    insertColumns: "插入列",
    insertRows: "插入行",
    insertHyperlinks: "插入超链接",
    deleteColumns: "删除列",
    deleteRows: "删除行",
    sort: "排序",
    filter: "使用自动筛选",
    usePivotTablereports: "使用数据透视表和报表",
    editObjects: "编辑对象",
    editScenarios: "编辑方案",
    allowRangeTitle: "允许用户编辑区域",
    allowRangeAdd: "新建...",
    allowRangeAddTitle: "标题",
    allowRangeAddSqrf: "引用单元格",
    selectCellRange: "点击选择单元格范围",
    selectCellRangeHolder: "请输入单元格范围",
    allowRangeAddTitlePassword: "密码",
    allowRangeAddTitleHint: "提示",
    allowRangeAddTitleHintTitle: "设置密码后，提示用户输入密码(可留空)",
    allowRangeAddtitleDefault: "请输入区域名称",
    rangeItemDblclick: "双击进行编辑",
    rangeItemHasPassword: "已设置密码",
    rangeItemErrorTitleNull: "标题不能为空",
    rangeItemErrorRangeNull: "单元格范围不能为空",
    rangeItemErrorRange: "单元格范围格式错误",
    validationTitle: "验证提示",
    validationTips: "需要输入密码来撤销工作表的保护",
    validationInputHint: "请输入密码",
    checkPasswordNullalert: "密码不能为空！",
    checkPasswordWrongalert: "密码错误，请重试！",
    checkPasswordSucceedalert: "解锁成功，可以编辑该区域!",
    defaultRangeHintText: "该单元格正在受密码保护。",
    defaultSheetHintText: "该单元格或图表位于受保护的工作表中，若要进行更改，请取消工作表保护，您可能需要输入密码。"
  },
  cellFormat: {
    cellFormatTitle: "设置单元格格式",
    protection: "保护",
    locked: "锁定单元格",
    hidden: "隐藏公式",
    protectionTips: "只有保护工作表功能(在菜单栏点击保护工作表按钮进行设置)开启后，锁定单元格或隐藏公式才能生效",
    tipsPart: "部分选中",
    tipsAll: "全部选中",
    selectionIsNullAlert: "请选择一个范围！",
    sheetDataIsNullAlert: "数据为空无法设置！"
  },
  print: {
    normalBtn: "常规视图",
    layoutBtn: "页面布局",
    pageBtn: "分页预览",
    menuItemPrint: "打印(Ctrl+P)",
    menuItemAreas: "打印区域",
    menuItemRows: "打印标题行",
    menuItemColumns: "打印标题列"
  },
  edit: {
    typing: "正在输入"
  },
  websocket: {
    success: "WebSocket连接成功",
    refresh: "WebSocket连接发生错误, 请刷新页面！",
    wait: "WebSocket连接发生错误, 请耐心等待！",
    close: "WebSocket连接关闭",
    contact: "服务器通信发生错误，请刷新页面后再试，如若不行请联系管理员！",
    support: "当前浏览器不支持WebSocket"
  }
};

var es = {
  generalDialog: {
    partiallyError: "No se puede realizar esta operación en celdas parcialmente unidas",
    readOnlyError: "No se puede realizar esto en modo de solo lectura",
    dataNullError: "No se puede hacer esto con datos que no existen",
    noSeletionError: "The selection operation has not been performed yetLa operación de selección aún no se ha realizado",
    cannotSelectMultiple: "No se puede seleccionar la zona de selección múltiple"
  },
  functionlist: [{
    n: "SUMIF",
    t: 0,
    d: "Returns a conditional sum across a range.",
    a: "A conditional sum across a range.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The range which is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sum_range",
      detail: "The range to be summed, if different from `range`.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TAN",
    t: 0,
    d: "Returns the tangent of an angle provided in radians.",
    a: "Tangent of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the tangent of, in radians.",
      example: "45*PI()/180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TANH",
    t: 0,
    d: "Returns the hyperbolic tangent of any real number.",
    a: "Hyperbolic tangent of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic tangent of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CEILING",
    t: 0,
    d: "Rounds a number up to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number up to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round up to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN",
    t: 0,
    d: "Returns the inverse tangent of a value, in radians.",
    a: "Inverse tangent of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse tangent.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ASINH",
    t: 0,
    d: "Returns the inverse hyperbolic sine of a number.",
    a: "Inverse hyperbolic sine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic sine.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ABS",
    t: 0,
    d: "Returns the absolute value of a number.",
    a: "Absolute value of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number of which to return the absolute value.",
      example: "-2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOS",
    t: 0,
    d: "Returns the inverse cosine of a value, in radians.",
    a: "Inverse cosine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOSH",
    t: 0,
    d: "Returns the inverse hyperbolic cosine of a number.",
    a: "Inverse hyperbolic cosine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTINOMIAL",
    t: 0,
    d: "Returns the factorial of the sum of values divided by the product of the values' factorials.",
    a: "Multinomial distribution function.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "ATANH",
    t: 0,
    d: "Returns the inverse hyperbolic tangent of a number.",
    a: "Inverse hyperbolic tangent of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN2",
    t: 0,
    d: "Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",
    a: "Arctangent of a value.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "y",
      detail: "The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTBLANK",
    t: 1,
    d: "Returns the number of empty values in a list of values and ranges.",
    a: "Number of empty values.",
    m: [1, 1],
    p: [{
      name: "value1",
      detail: "The first value or range in which to count the number of blanks.",
      example: "A2:C100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "COSH",
    t: 0,
    d: "Returns the hyperbolic cosine of any real number.",
    a: "Hyperbolic cosine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic cosine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INT",
    t: 0,
    d: "Rounds a number down to the nearest integer that is less than or equal to it.",
    a: "Rounds number down to nearest integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISEVEN",
    t: 0,
    d: "Checks whether the provided value is even.",
    a: "Whether the provided value is even.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as even.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISODD",
    t: 0,
    d: "Checks whether the provided value is odd.",
    a: "Whether the provided value is odd.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as odd.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LCM",
    t: 0,
    d: "Returns the least common multiple of one or more integers.",
    a: "Least common multiple of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the least common multiple.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the least common multiple.",
      example: "3",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LN",
    t: 0,
    d: "Returns the logarithm of a number, base e (Euler's number).",
    a: "The logarithm of a number, base e (euler's number).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base e.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG",
    t: 0,
    d: "Returns the logarithm of a number with respect to a base.",
    a: "The logarithm of a number with respect to a base.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm.",
      example: "128",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "base",
      detail: "The base to use for calculation of the logarithm.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG10",
    t: 0,
    d: "Returns the logarithm of a number, base 10.",
    a: "The logarithm of a number, base 10.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base 10.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MOD",
    t: 0,
    d: "Returns the result of the modulo operator, the remainder after a division operation.",
    a: "Modulo (remainder) operator.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided to find the remainder.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MROUND",
    t: 0,
    d: "Rounds one number to the nearest integer multiple of another.",
    a: "Rounds a number to the nearest integer multiple.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The number to round to the nearest integer multiple of another.",
      example: "21",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ODD",
    t: 0,
    d: "Rounds a number up to the nearest odd integer.",
    a: "Rounds a number up to the nearest odd integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest odd number.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMSQ",
    t: 0,
    d: "Returns the sum of the squares of a series of numbers and/or cells.",
    a: "Sum of squares.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range whose squares to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges whose squares to add to the square(s) of `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMBIN",
    t: 0,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects.",
    a: "Number of combinations from a set of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUM",
    t: 0,
    d: "Returns the sum of a series of numbers and/or cells.",
    a: "Sum of a series of numbers and/or cells.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges to add to `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SUBTOTAL",
    t: 0,
    d: "Returns a subtotal for a vertical range of cells using a specified aggregation function.",
    a: "Subtotal for a range using a specific function.",
    m: [2, 256],
    p: [{
      name: "function_code",
      detail: "The function to use in subtotal aggregation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range1",
      detail: "The first range over which to calculate a subtotal.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "range2",
      detail: "Additional ranges over which to calculate subtotals.",
      example: "B2:B8",
      require: "o",
      repeat: "y",
      type: "range"
    }]
  }, {
    n: "ASIN",
    t: 0,
    d: "Returns the inverse sine of a value, in radians.",
    a: "Inverse sine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTIF",
    t: 1,
    d: "Returns a conditional count across a range.",
    a: "A conditional count across a range.",
    m: [2, 2],
    p: [{
      name: "range",
      detail: "The range that is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RADIANS",
    t: 0,
    d: "Converts an angle value in degrees to radians.",
    a: "Converts an angle value in degrees to radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from degrees to radians.",
      example: "180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RAND",
    t: 0,
    d: "Returns a random number between 0 inclusive and 1 exclusive.",
    a: "A random number between 0 inclusive and 1 exclusive.",
    m: [0, 0],
    p: []
  }, {
    n: "COUNTUNIQUE",
    t: 0,
    d: "Counts the number of unique values in a list of specified values and ranges.",
    a: "Counts number of unique values in a range.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider for uniqueness.",
      example: "A1:C100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider for uniqueness.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DEGREES",
    t: 0,
    d: "Converts an angle value in radians to degrees.",
    a: "Converts an angle value in radians to degrees.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from radians to degrees.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ERFC",
    t: 9,
    d: "Returns the complementary Gauss error function of a value.",
    a: "Complementary gauss error function of a value.",
    m: [1, 1],
    p: [{
      name: "z",
      detail: "The number for which to calculate the complementary Gauss error function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVEN",
    t: 0,
    d: "Rounds a number up to the nearest even integer.",
    a: "Rounds a number up to the nearest even integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest even number.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EXP",
    t: 0,
    d: "Returns Euler's number, e (~2.718) raised to a power.",
    a: "Euler's number, e (~2.718) raised to a power.",
    m: [1, 1],
    p: [{
      name: "exponent",
      detail: "The exponent to raise e to.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACT",
    t: 0,
    d: "Returns the factorial of a number.",
    a: "Factorial of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose factorial will be calculated and returned.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACTDOUBLE",
    t: 0,
    d: 'Returns the "double factorial" of a number.',
    a: '"double factorial" of a number.',
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose double factorial will be calculated and returned.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PI",
    t: 0,
    d: "Returns the value of Pi to 14 decimal places.",
    a: "The number pi.",
    m: [0, 0],
    p: []
  }, {
    n: "FLOOR",
    t: 0,
    d: "Rounds a number down to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number down to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GCD",
    t: 0,
    d: "Returns the greatest common divisor of one or more integers.",
    a: "Greatest common divisor of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the greatest common divisor.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the greatest common divisor.",
      example: "96",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANDBETWEEN",
    t: 0,
    d: "Returns a uniformly random integer between two values, inclusive.",
    a: "Random integer between two values, inclusive.",
    m: [2, 2],
    p: [{
      name: "low",
      detail: "The low end of the random range.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high",
      detail: "The high end of the random range.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUND",
    t: 0,
    d: "Rounds a number to a certain number of decimal places according to standard rules.",
    a: "Rounds a number according to standard rules.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDDOWN",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",
    a: "Rounds down a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding down.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDUP",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",
    a: "Rounds up a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding up.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SERIESSUM",
    t: 0,
    d: "Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",
    a: "Sum of a power series.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The initial power to which to raise `x` in the power series.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "m",
      detail: "The additive increment by which to increase `x`.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "a",
      detail: "The array or range containing the coefficients of the power series.",
      example: "{FACT(0)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIGN",
    t: 0,
    d: "Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",
    a: "Sign of a provided number (+/-/0).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose sign will be evaluated.",
      example: "-42",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIN",
    t: 0,
    d: "Returns the sine of an angle provided in radians.",
    a: "Sine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the sine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SINH",
    t: 0,
    d: "Returns the hyperbolic sine of any real number.",
    a: "Hyperbolic sine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic sine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRT",
    t: 0,
    d: "Returns the positive square root of a positive number.",
    a: "Positive square root of a positive number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number for which to calculate the positive square root.",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRTPI",
    t: 0,
    d: "Returns the positive square root of the product of Pi and the given positive number.",
    a: "Square root of the product of pi and number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number which will be multiplied by Pi and have the product's square root returned",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GAMMALN",
    t: 1,
    d: "Returns the logarithm of a specified Gamma function, base e (Euler's number).",
    a: "Logarithm of gamma function.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COS",
    t: 0,
    d: "Returns the cosine of an angle provided in radians.",
    a: "Cosine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the cosine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRUNC",
    t: 0,
    d: "Truncates a number to a certain number of significant digits by omitting less significant digits.",
    a: "Truncates a number.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value to be truncated.",
      example: "3.141592654",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of significant digits to the right of the decimal point to retain.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUOTIENT",
    t: 0,
    d: "Returns one number divided by another.",
    a: "One number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POWER",
    t: 0,
    d: "Returns a number raised to a power.",
    a: "A number raised to a power.",
    m: [2, 2],
    p: [{
      name: "base",
      detail: "The number to raise to the `exponent` power.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "exponent",
      detail: "The exponent to raise `base` to.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMIFS",
    t: 0,
    d: "Returns the sum of a range depending on multiple criteria.",
    a: "Sums a range depending on multiple criteria.",
    m: [3, 257],
    p: [{
      name: "sum_range",
      detail: "The range to sum.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criteria_range1",
      detail: "The range to check against criterion1.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to criteria_range1.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTIFS",
    t: 1,
    d: "Returns the count of a range depending on multiple criteria.",
    a: "Count values depending on multiple criteria.",
    m: [2, 256],
    p: [{
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " B1:B10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PRODUCT",
    t: 0,
    d: "Returns the result of multiplying a series of numbers together.",
    a: "Result of multiplying a series of numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "More numbers or ranges to calculate for the product.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HARMEAN",
    t: 1,
    d: "Calculates the harmonic mean of a dataset.",
    a: "The harmonic mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HYPGEOMDIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",
    a: "Hypergeometric distribution probability.",
    m: [5, 5],
    p: [{
      name: "num_successes",
      detail: "The desired number of successes.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_draws",
      detail: "The number of permitted draws.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "successes_in_pop",
      detail: "The total number of successes in the population.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The total size of the population",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INTERCEPT",
    t: 1,
    d: "Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",
    a: "Y-intercept of line derived via linear regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "KURT",
    t: 1,
    d: 'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',
    a: "Kurtosis of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LARGE",
    t: 1,
    d: "Returns the nth largest element from a data set, where n is user-defined.",
    a: "Nth largest element from a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The rank from largest to smallest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVA",
    t: 1,
    d: "Calculates the standard deviation based on a sample, setting text to the value `0`.",
    a: "Standard deviation of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVP",
    t: 1,
    d: "Calculates the standard deviation based on an entire population.",
    a: "Standard deviation of an entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "GEOMEAN",
    t: 1,
    d: "Calculates the geometric mean of a dataset.",
    a: "The geometric mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANK_EQ",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",
    a: "Top rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANK_AVG",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",
    a: "Average rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERCENTRANK_EXC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 exclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTRANK_INC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 inclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: " A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FORECAST",
    t: 1,
    d: "Calculates the expected y-value for a specified x based on a linear regression of a dataset.",
    a: "Expected y-value based of linear regression.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The value on the x-axis to forecast.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHERINV",
    t: 1,
    d: "Returns the inverse Fisher transformation of a specified value.",
    a: "Inverse fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHER",
    t: 1,
    d: "Returns the Fisher transformation of a specified value.",
    a: "Fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MODE_SNGL",
    t: 1,
    d: "Returns the most commonly occurring value in a dataset.",
    a: "Most commonly occurring value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating mode.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating mode.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "WEIBULL_DIST",
    t: 1,
    d: "Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",
    a: "Weibull distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the Weibull distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "shape",
      detail: "The shape parameter of the Weibull distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "scale",
      detail: "The scale parameter of the Weibull distribution function.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the cumulative distribution function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COUNT",
    t: 1,
    d: "Returns the number of numeric values in a dataset.",
    a: "The number of numeric values in dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTA",
    t: 1,
    d: "Returns the number of values in a dataset.",
    a: "The number of values in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVEDEV",
    t: 1,
    d: "Calculates the average of the magnitudes of deviations of data from a dataset's mean.",
    a: "Average magnitude of deviations from mean.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "AVERAGE",
    t: 1,
    d: "Returns the numerical average value in a dataset, ignoring text.",
    a: "Numerical average value in a dataset, ignoring text.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEA",
    t: 1,
    d: "Returns the numerical average value in a dataset.",
    a: "Numerical average value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",
    a: "Binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_successes",
      detail: "The number of successes for which to calculate the probability in `num_trials` trials.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the binomial cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_INV",
    t: 1,
    d: "Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",
    a: "Inverse cumulative binomial distribution function.",
    m: [3, 3],
    p: [{
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "target_prob",
      detail: "The desired threshold probability.",
      example: "0.8",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONFIDENCE_NORM",
    t: 1,
    d: "Calculates the width of half the confidence interval for a normal distribution.",
    a: "Confidence interval for a normal distribution.",
    m: [3, 3],
    p: [{
      name: "alpha",
      detail: "One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",
      example: "0.05",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the population.",
      example: "1.6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The size of the population.",
      example: "250",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CORREL",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_P",
    t: 1,
    d: "Calculates the covariance of a dataset.",
    a: "The covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_S",
    t: 1,
    d: "Calculates the sample covariance of a dataset.",
    a: "The sample covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEVSQ",
    t: 1,
    d: "Calculates the sum of squares of deviations based on a sample.",
    a: "The sum of squares of deviations based on a sample.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "EXPON_DIST",
    t: 1,
    d: "Returns the value of the exponential distribution function with a specified lambda at a specified value.",
    a: "Exponential distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the exponential distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "lambda",
      detail: "The lambda to specify the exponential distribution function.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the exponential cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIF",
    t: 1,
    d: "Returns the average of a range depending on criteria.",
    a: "Average of values depending on criteria.",
    m: [2, 3],
    p: [{
      name: "criteria_range",
      detail: "The range to check against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `criteria_range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "average_range",
      detail: "The range to average. If not included, `criteria_range` is used for the average instead.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIFS",
    t: 1,
    d: "Returns the average of a range depending on multiple criteria.",
    a: "Average of values depending on multiple criteria.",
    m: [2, 255],
    p: [{
      name: "average_range",
      detail: "The range to average.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERMUT",
    t: 1,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",
    a: "Number of permutations from a number of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRIMMEAN",
    t: 1,
    d: "Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",
    a: "Mean of a dataset excluding high/low ends.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "exclude_proportion",
      detail: "The proportion of the dataset to exclude, from the extremities of the set.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_EXC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset exclusive of 0 and 1.",
    a: "Value at a given percentile of a dataset exclusive of 0 and 1.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_INC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset.",
    a: "Value at a given percentile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile whose value within `data` will be calculated and returned.`",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PEARSON",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_INV",
    t: 1,
    d: "Returns the value of the inverse standard normal distribution function for a specified value.",
    a: "Inverse standard normal distribution function.",
    m: [1, 1],
    p: [{
      name: "x",
      detail: "The input to the inverse standard normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_DIST",
    t: 1,
    d: "Returns the value of the standard normal cumulative distribution function for a specified value.",
    a: "Standard normal cumulative distribution function.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the standard normal cumulative distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NORM_INV",
    t: 1,
    d: "Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",
    a: "Inverse normal distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_DIST",
    t: 1,
    d: "Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",
    a: "Normal distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the normal distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the normal cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NEGBINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",
    a: "Negative binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_failures",
      detail: "The number of failures to model.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_successes",
      detail: "The number of successes to model.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINA",
    t: 1,
    d: "Returns the minimum numeric value in a dataset.",
    a: "Minimum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MIN",
    t: 1,
    d: "Returns the minimum value in a numeric dataset.",
    a: "Minimum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MEDIAN",
    t: 1,
    d: "Returns the median value in a numeric dataset.",
    a: "Median value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the median value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the median value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAXA",
    t: 1,
    d: "Returns the maximum numeric value in a dataset.",
    a: "Maximum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAX",
    t: 1,
    d: "Returns the maximum value in a numeric dataset.",
    a: "Maximum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_INV",
    t: 1,
    d: "Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Inverse log-normal cumulative distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse log-normal cumulative distribution function.",
      example: "0.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the inverse log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_DIST",
    t: 1,
    d: "Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Log-normal cumulative distribution probability.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "Z_TEST",
    t: 1,
    d: "Returns the one-tailed p-value of a Z-test with standard distribution.",
    a: "One-tailed p-value of a z-test.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "value",
      detail: "The test statistic to use in the Z-test.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",
      example: "3",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PROB",
    t: 1,
    d: "Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",
    a: "Probability values lie in a range.",
    m: [3, 4],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A3:A6",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "probabilities",
      detail: "Array or range containing probabilities corresponding to `data`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "low_limit",
      detail: "The lower bound on the value range for which to calculate the probability.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high_limit",
      detail: "The upper bound on the value range for which to calculate the probability.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_EXC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",
    a: "Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_INC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset.",
    a: "Value nearest to a specific quartile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile value to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POISSON_DIST",
    t: 1,
    d: "Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",
    a: "Poisson distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the Poisson distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the Poisson distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the Poisson cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RSQ",
    t: 1,
    d: "Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Square of the correlation coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST",
    t: 1,
    d: "Calculates the left tail probability for a Student's t-distribution with a given input (x).",
    a: "The left-tailed Student's t-distribution",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T_DIST_2T",
    t: 1,
    d: "Calculates the probability for two tailed Student's t-distribution with a given input (x).",
    a: "The two tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST_RT",
    t: 1,
    d: "Calculates the right tail probability for a Student's t-distribution with a given input (x).",
    a: "The right-tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV",
    t: 1,
    d: "Calculates the negative inverse of the one-tailed TDIST function.",
    a: "T.INV",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV_2T",
    t: 1,
    d: "Calculates the inverse of the two-tailed TDIST function.",
    a: "T.INV.2T",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_TEST",
    t: 1,
    d: "t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",
    a: "Returns the probability associated with t-test.",
    m: [4, 4],
    p: [{
      name: "range1",
      detail: "The first sample of data or group of cells to consider for the t-test.",
      example: "A1:A4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range2",
      detail: "The second sample of data or group of cells to consider for the t-test.",
      example: "B1:B4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "Specifies the number of distribution tails.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "Specifies the type of t-test.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "F_DIST",
    t: 1,
    d: "Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution (left-tailed).",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Logical value that determines the form of the function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "F_DIST_RT",
    t: 1,
    d: "Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_P",
    t: 1,
    d: "Calculates the variance based on an entire population.",
    a: "Variance of entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_S",
    t: 1,
    d: "Calculates the variance based on a sample.",
    a: "Variance.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARA",
    t: 1,
    d: "Calculates the variance based on a sample, setting text to the value `0`.",
    a: "Variance of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARPA",
    t: 1,
    d: "Calculates the variance based on an entire population, setting text to the value `0`.",
    a: "Variance of entire population (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STEYX",
    t: 1,
    d: "Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",
    a: "Standard error of predicted y-values in regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STANDARDIZE",
    t: 1,
    d: "Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",
    a: "Normalized equivalent of a random variable.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The value of the random variable to normalize.",
      example: "96",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean of the distribution.",
      example: "80",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the distribution.",
      example: "6.7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SMALL",
    t: 1,
    d: "Returns the nth smallest element from a data set, where n is user-defined.",
    a: "Nth smallest element in a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "n",
      detail: "The rank from smallest to largest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLOPE",
    t: 1,
    d: "Calculates the slope of the line resulting from linear regression of a dataset.",
    a: "Slope of line from linear regression of data.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SKEW",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",
    a: "Skewness of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SKEW_P",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",
    a: "Skewness of a population's dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "VLOOKUP",
    t: 2,
    d: "Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",
    a: "Vertical lookup.",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The column index of the value to be returned, where the first column in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HLOOKUP",
    t: 2,
    d: "Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",
    a: "Horizontal lookup",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",
      example: "A2:Z6",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The row index of the value to be returned, where the first row in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the row to be searched (the first row of the specified range) is sorted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOOKUP",
    t: 2,
    d: "Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",
    a: "Look up a value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_range|search_result_array",
      detail: "One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "result_range",
      detail: "The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",
      example: "B1:B100",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADDRESS",
    t: 2,
    d: "Returns a cell reference as a string.",
    a: "Cell reference as a string.",
    m: [2, 5],
    p: [{
      name: "row",
      detail: "The row number of the cell reference",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The column number (not name) of the cell reference. `A` is column number `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "absolute_relative_mode",
      detail: "An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "use_a1_notation",
      detail: "A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sheet",
      detail: "Text indicating the name of the sheet into which the address points.",
      example: '"Sheet2"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INDIRECT",
    t: 2,
    d: "Returns a cell reference specified by a string.",
    a: "A cell reference specified by a string.",
    m: [1, 2],
    p: [{
      name: "cell_reference_as_string",
      detail: "A cell reference, written as a string with surrounding quotation marks.",
      example: '"Sheet2!"&B10',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "is_A1_notation",
      detail: "Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROW",
    t: 2,
    d: "Returns the row number of a specified cell.",
    a: "Row number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose row number will be returned.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROWS",
    t: 2,
    d: "Returns the number of rows in a specified array or range.",
    a: "Number of rows in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose row count will be returned.",
      example: "A9:A62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COLUMN",
    t: 2,
    d: "Returns the column number of a specified cell, with `A=1`.",
    a: "Column number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose column number will be returned. Column `A` corresponds to `1`.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNS",
    t: 2,
    d: "Returns the number of columns in a specified array or range.",
    a: "Number of columns in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose column count will be returned.",
      example: "A9:W62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OFFSET",
    t: 2,
    d: "Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",
    a: "A range reference offset relative to a cell.",
    m: [3, 5],
    p: [{
      name: "cell_reference",
      detail: "The starting point from which to count the offset rows and columns.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "offset_rows",
      detail: "The number of rows to offset by.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "offset_columns",
      detail: "The number of columns to offset by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "height",
      detail: "The height of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "width",
      detail: "The width of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MATCH",
    t: 2,
    d: "Returns the relative position of an item in a range that matches a specified value.",
    a: "Position of item in range that matches value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: '"Sunday"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The one-dimensional array to be searched.",
      example: "A2:A9",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "search_type",
      detail: "The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INDEX",
    t: 2,
    d: "Returns the content of a cell, specified by row and column offset.",
    a: "Content of cell specified by row and column offset.",
    m: [2, 3],
    p: [{
      name: "reference",
      detail: "The array of cells to be offset into.",
      example: "A1:C20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "row",
      detail: "The number of offset rows.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The number of offset columns.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GETPIVOTDATA",
    t: 2,
    d: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    a: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    m: [2, 254],
    p: [{
      name: "value_name",
      detail: "The name of the value in the pivot table for which you want to get data.",
      example: '"SUM of number of units"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "any_pivot_table_cell",
      detail: "Any reference to a cell in the desired pivot table (top corner recommended).",
      example: "'Pivot table'!A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "original_column",
      detail: "The name of the column in the original data set (not the pivot table).",
      example: '"division"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }, {
      name: "pivot_item",
      detail: "The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",
      example: '"east"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CHOOSE",
    t: 2,
    d: "Returns an element from a list of choices based on index.",
    a: "An element from a list of choices based on index.",
    m: [2, 255],
    p: [{
      name: "index",
      detail: "Which choice (of the up to 30 provided) to return.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "choice1",
      detail: "A potential value to return. Required. May be a reference to a cell or an individual value.",
      example: '"A"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "choice2",
      detail: "Additional values among which to choose.",
      example: '"B"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "HYPERLINK",
    t: 2,
    d: "Creates a hyperlink inside a cell.",
    a: "Creates a hyperlink inside a cell.",
    p: [{
      name: "url",
      detail: "The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",
      example: '"http://www.luckysheet.com/"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "link_label",
      detail: "The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",
      example: '"luckysheet"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TIME",
    t: 6,
    d: "Converts a provided hour, minute, and second into a time.",
    a: "Converts hour/minute/second into a time.",
    m: [3, 3],
    p: [{
      name: "hour",
      detail: "The hour component of the time.",
      example: "11",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "minute",
      detail: "The minute component of the time.",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "second",
      detail: "The second component of the time.",
      example: "59",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TIMEVALUE",
    t: 6,
    d: "Returns the fraction of a 24-hour day the time represents.",
    a: "Converts a time string into its serial number representation.",
    m: [1, 1],
    p: [{
      name: "time_string",
      detail: "The string that holds the time representation.",
      example: '"2:15 PM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EOMONTH",
    t: 6,
    d: "Returns a date on the last day of a month that falls a specified number of months before or after another date.",
    a: "Last day of a month before or after a date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to consider.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EDATE",
    t: 6,
    d: "Returns a date a specified number of months before or after another date.",
    a: "Date a number of months before/after another date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to calculate.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SECOND",
    t: 6,
    d: "Returns the second component of a specific time, in numeric format.",
    a: "Second component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the second component",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINUTE",
    t: 6,
    d: "Returns the minute component of a specific time, in numeric format.",
    a: "Minute component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the minute component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HOUR",
    t: 6,
    d: "Returns the hour component of a specific time, in numeric format.",
    a: "Hour component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the hour component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOW",
    t: 6,
    d: "Returns the current date and time as a date value.",
    a: "Current date and time as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "NETWORKDAYS",
    t: 6,
    d: "Returns the number of net working days between two provided days.",
    a: "Net working days between two provided days.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the date serial numbers to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NETWORKDAYS_INTL",
    t: 6,
    d: "Returns the number of net working days between two provided days excluding specified weekend days and holidays.",
    a: "Net working days between two dates (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider as holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISOWEEKNUM",
    t: 6,
    d: "Returns a number representing the ISO week of the year where the provided date falls.",
    a: "ISO week number of the year.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WEEKNUM",
    t: 6,
    d: "Returns a number representing the week of the year where the provided date falls.",
    a: "Week number of the year.",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number representing the day that a week starts on. Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "WEEKDAY",
    t: 6,
    d: "Returns a number representing the day of the week of the date provided.",
    a: "Day of the week of the date provided (as number).",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DAY",
    t: 6,
    d: "Returns the day of the month that a specific date falls on, in numeric format.",
    a: "Day of the month that a specific date falls on.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the day.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS",
    t: 6,
    d: "Returns the number of days between two dates.",
    a: "Number of days between two dates.",
    m: [2, 2],
    p: [{
      name: "end_date",
      detail: "The end of the date range.",
      example: "2011-3-15",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_date",
      detail: "The start of the date range.",
      example: "2011-2-1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS360",
    t: 6,
    d: "Returns the difference between two days based on the 360 day year used in some financial interest calculations.",
    a: "Days between two dates on a 360-day year.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "method",
      detail: "An indicator of what day count method to use.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATE",
    t: 6,
    d: "Converts a provided year, month, and day into a date.",
    a: "Converts year/month/day into a date.",
    m: [3, 3],
    p: [{
      name: "year",
      detail: "The year component of the date.",
      example: "1969",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The month component of the date.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day",
      detail: "The day component of the date.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATEVALUE",
    t: 6,
    d: "Converts a provided date string in a known format to a date value.",
    a: "Converts a date string to a date value.",
    m: [1, 1],
    p: [{
      name: "date_string",
      detail: "The string representing the date.",
      example: '"1969-7-20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATEDIF",
    t: 6,
    d: "Calculates the number of days, months, or years between two dates.",
    a: "Date Difference.",
    m: [3, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "unit",
      detail: 'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',
      example: "16)",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY",
    t: 6,
    d: "Calculates the date after a number of working days from a specified start date.",
    a: "Number of working days from start date.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY_INTL",
    t: 6,
    d: "Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",
    a: "Date after a number of workdays (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEAR",
    t: 6,
    d: "Returns the year specified by a given date.",
    a: "Year specified by a given date.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the year.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEARFRAC",
    t: 6,
    d: "Returns the number of years, including fractional years, between two dates using a specified day count convention.",
    a: "Exact number of years between two dates.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TODAY",
    t: 6,
    d: "Returns the current date as a date value.",
    a: "Current date as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "MONTH",
    t: 6,
    d: "Returns the month of the year a specific date falls in, in numeric format.",
    a: "Month of the year a specific date falls in.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the month.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EFFECT",
    t: 8,
    d: "Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",
    a: "Annual effective interest rate.",
    m: [2, 2],
    p: [{
      name: "nominal_rate",
      detail: "The nominal interest rate per year.",
      example: "0.99",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLAR",
    t: 12,
    d: "Formats a number into the currency specific to your spreadsheet locale.",
    a: "Formats a number as currency specific to your spreadsheet locale.",
    m: [1, 2],
    p: [{
      name: "number",
      detail: "The value to be formatted.",
      example: "1.2351",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARDE",
    t: 8,
    d: "Converts a price quotation given as a decimal fraction into a decimal value.",
    a: "Converts a decimal fraction to decimal value.",
    m: [2, 2],
    p: [{
      name: "fractional_price",
      detail: "The price quotation given using fractional decimal conventions.",
      example: "100.10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARFR",
    t: 8,
    d: "Converts a price quotation given as a decimal value into a decimal fraction.",
    a: "Converts a decimal value to decimal fraction.",
    m: [2, 2],
    p: [{
      name: "decimal_price",
      detail: "The price quotation given as a decimal value.",
      example: "100.125",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",
    a: "Depreciation via declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The number of months in the first year of depreciation.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DDB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the double-declining balance method.",
    a: "Depreciation via double-declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The factor by which depreciation decreases.",
      example: "2.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RATE",
    t: 8,
    d: "Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",
    a: "Interest rate of an annuity investment.",
    m: [3, 6],
    p: [{
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_per_period",
      detail: "The amount per period to be paid.",
      example: "-100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the interest rate will be.",
      example: "0.1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CUMPRINC",
    t: 8,
    d: "Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative principal paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNUM",
    t: 8,
    d: "Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",
    a: "Number of coupons between settlement and maturity.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "02",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SYD",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the sum of years digits method.",
    a: "Depreciation via sum of years digits method.",
    m: [4, 4],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLEQ",
    t: 8,
    d: "Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",
    a: "Equivalent rate of return for a Treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "2)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLYIELD",
    t: 8,
    d: "Calculates the yield of a US Treasury Bill based on price.",
    a: "The yield of a us treasury bill based on price.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLPRICE",
    t: 8,
    d: "Calculates the price of a US Treasury Bill based on discount rate.",
    a: "Price of US treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PV",
    t: 8,
    d: "Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Present value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACCRINT",
    t: 8,
    d: "Calculates the accrued interest of a security that has periodic payments.",
    a: "Accrued interest of security with periodic payments.",
    m: [6, 8],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "first_payment",
      detail: "The first date interest will be paid.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calc_method",
      detail: "[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ACCRINTM",
    t: 8,
    d: "Calculates the accrued interest of a security that pays interest at maturity.",
    a: "Accrued interest of security paying at maturity.",
    m: [4, 5],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity date of the security.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "1000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYBS",
    t: 8,
    d: "Calculates the number of days from the first coupon, or interest payment, until settlement.",
    a: "Number of days from first coupon to settlement.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYS",
    t: 8,
    d: "Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",
    a: "Days in coupon period containing settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYSNC",
    t: 8,
    d: "Calculates the number of days from the settlement date until the next coupon, or interest payment.",
    a: "Days from settlement until next coupon.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNCD",
    t: 8,
    d: "Calculates next coupon, or interest payment, date after the settlement date.",
    a: "Next coupon date after the settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPPCD",
    t: 8,
    d: "Calculates last coupon, or interest payment, date before the settlement date.",
    a: "Last coupon date before settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FV",
    t: 8,
    d: "Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Future value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FVSCHEDULE",
    t: 8,
    d: "Calculates the future value of some principal based on a specified series of potentially varying interest rates.",
    a: "Future value of principal from series of rates.",
    m: [2, 2],
    p: [{
      name: "principal",
      detail: "The amount of initial capital or value to compound against.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_schedule",
      detail: "A series of interest rates to compound against the `principal`.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "YIELD",
    t: 8,
    d: "Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",
    a: "Annual yield of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "YIELDDISC",
    t: 8,
    d: "Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",
    a: "Annual yield of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NOMINAL",
    t: 8,
    d: "Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",
    a: "Annual nominal interest rate.",
    m: [2, 2],
    p: [{
      name: "effective_rate",
      detail: "The effective interest rate per year.",
      example: "0.85",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "XIRR",
    t: 8,
    d: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    a: "Internal rate of return given non-periodic cashflows.",
    m: [2, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "250",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MIRR",
    t: 8,
    d: "Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",
    a: "Modified internal rate of return.",
    m: [3, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "financing_rate",
      detail: "The interest rate paid on funds invested.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "reinvestment_return_rate",
      detail: "The return (as a percentage) earned on reinvestment of income received from the investment.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IRR",
    t: 8,
    d: "Calculates the internal rate of return on an investment based on a series of periodic cash flows.",
    a: "Internal rate of return given periodic cashflows.",
    m: [1, 2],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "200",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",
    a: "The net present value of an investment based on a series of periodic cash flows and a discount rate.",
    m: [2, 255],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow1",
      detail: "The first future cash flow.",
      example: "200",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "cashflow2",
      detail: "Additional future cash flows.",
      example: "250",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "XNPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",
    a: "Net present value given non-periodic cashflows.",
    m: [3, 3],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow_amounts",
      detail: "A range of cells containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CUMIPMT",
    t: 8,
    d: "Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative interest paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PMT",
    t: 8,
    d: "Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Periodic payment for an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: " 100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IPMT",
    t: 8,
    d: "Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on interest for an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "80000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "E2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PPMT",
    t: 8,
    d: "Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on the principal of an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "3*12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INTRATE",
    t: 8,
    d: "Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",
    a: "Calculates effective interest rate.",
    m: [4, 5],
    p: [{
      name: "buy_date",
      detail: "The date of purchase of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sell_date",
      detail: "The date of sale of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "buy_price",
      detail: "The price at which the investment was purchased.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sell_price",
      detail: "The price at which the investment was sold.",
      example: "101200",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICE",
    t: 8,
    d: "Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Price of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.065",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEDISC",
    t: 8,
    d: "Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",
    a: "Price of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the security at time of purchase.",
      example: "0.0525",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEMAT",
    t: 8,
    d: "Calculates the price of a security paying interest at maturity, based on expected yield.",
    a: "Price of security paying interest at maturity.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RECEIVED",
    t: 8,
    d: "Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",
    a: "Amount received at maturity for a security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "The amount invested (irrespective of face value of each security).",
      example: "10000000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "discount",
      detail: "The discount rate of the security invested in.",
      example: "0.0575",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DISC",
    t: 8,
    d: "Calculates the discount rate of a security based on price.",
    a: "The discount rate of a security based on price.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "97.975",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPER",
    t: 8,
    d: "Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Number of payment periods for an investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount of each payment made.",
      example: "500",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "40000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLN",
    t: 8,
    d: "Calculates the depreciation of an asset for one period using the straight-line method.",
    a: "Depreciation of asset using the straight-line method.",
    m: [3, 3],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "300000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "75000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DURATION",
    t: 8,
    d: "Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",
    a: "Number of periods for an investment to reach a value.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MDURATION",
    t: 8,
    d: "Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Modified Macaulay duration.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2DEC",
    t: 9,
    d: "Converts a signed binary number to decimal format.",
    a: "Converts a signed binary number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to decimal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIN2HEX",
    t: 9,
    d: "Converts a signed binary number to signed hexadecimal format.",
    a: "Converts a binary number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2OCT",
    t: 9,
    d: "Converts a signed binary number to signed octal format.",
    a: "Converts a binary number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed octal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2BIN",
    t: 9,
    d: "Converts a decimal number to signed binary format.",
    a: "Converts a decimal number to signed binary format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed binary, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2HEX",
    t: 9,
    d: "Converts a decimal number to signed hexadecimal format.",
    a: "Converts a decimal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed hexadecimal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2OCT",
    t: 9,
    d: "Converts a decimal number to signed octal format.",
    a: "Converts a decimal number to signed octal format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed octal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2BIN",
    t: 9,
    d: "Converts a signed hexadecimal number to signed binary format.",
    a: "Converts a hexadecimal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2DEC",
    t: 9,
    d: "Converts a signed hexadecimal number to decimal format.",
    a: "Converts a hexadecimal number to decimal.",
    m: [1, 1],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HEX2OCT",
    t: 9,
    d: "Converts a signed hexadecimal number to signed octal format.",
    a: "Converts a hexadecimal number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2BIN",
    t: 9,
    d: "Converts a signed octal number to signed binary format.",
    a: "Converts an octal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed binary, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2DEC",
    t: 9,
    d: "Converts a signed octal number to decimal format.",
    a: "Converts a signed octal number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to decimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OCT2HEX",
    t: 9,
    d: "Converts a signed octal number to signed hexadecimal format.",
    a: "Converts an octal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COMPLEX",
    t: 9,
    d: "Creates a complex number given real and imaginary coefficients.",
    a: "Creates a complex number.",
    m: [2, 3],
    p: [{
      name: "real_part",
      detail: "The real coefficient.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "imaginary_part",
      detail: "The imaginary coefficient.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suffix",
      detail: "The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",
      example: '"j"',
      require: "o",
      repeat: "n",
      type: "rangestring"
    }]
  }, {
    n: "IMREAL",
    t: 9,
    d: "Returns the real coefficient of a complex number.",
    a: "The real coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMAGINARY",
    t: 9,
    d: "Returns the imaginary coefficient of a complex number.",
    a: "The imaginary coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMCONJUGATE",
    t: 9,
    d: "Returns the complex conjugate of a number.",
    a: "The complex conjugate of a number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the conjugate for.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMABS",
    t: 9,
    d: "Returns absolute value (or modulus) of a complex number.",
    a: "The absolute value of a complex number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the absolute value of.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DELTA",
    t: 9,
    d: "Compare two numeric values, returning 1 if they're equal.",
    a: "Compare two numeric values.",
    m: [1, 2],
    p: [{
      name: "number1",
      detail: "The first number to compare.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number2",
      detail: "The second number to compare.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IMSUM",
    t: 9,
    d: "Returns the sum of a series of complex numbers.",
    a: "Sum of a series of complex numbers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first complex number or range to add together.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional complex numbers or ranges to add to `value1`.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMSUB",
    t: 9,
    d: "Returns the difference between two complex numbers.",
    a: "The difference between two complex numbers.",
    m: [2, 2],
    p: [{
      name: "first_number",
      detail: "The complex number to subtract second_number from.",
      example: '"6+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "second_number",
      detail: "The complex number to subtract from first_number.",
      example: '"2+3i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMPRODUCT",
    t: 9,
    d: "Returns the result of multiplying a series of complex numbers together.",
    a: "Result of multiplying a series of complex numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "factor2",
      detail: "Additional complex numbers or ranges to calculate for the product.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMDIV",
    t: 9,
    d: "Returns one complex number divided by another.",
    a: "One complex number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The complex number to be divided.",
      example: '"11+16i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "divisor",
      detail: "The complex number to divide by.",
      example: '"3+2i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOT",
    t: 10,
    d: "Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",
    a: "Returns opposite of provided logical value.",
    m: [1, 1],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell holding an expression that represents some logical value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRUE",
    t: 10,
    d: "Returns the logical value `TRUE`.",
    a: "Logical value `true`.",
    m: [0, 0],
    p: []
  }, {
    n: "FALSE",
    t: 10,
    d: "Returns the logical value `FALSE`.",
    a: "Logical value `false`.",
    m: [0, 0],
    p: []
  }, {
    n: "AND",
    t: 10,
    d: "Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",
    a: "Logical `and` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that represent logical values.",
      example: 'A3 = "bar"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IFERROR",
    t: 10,
    d: "Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",
    a: "Value if it is not an error, otherwise 2nd argument.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to return if `value` itself is not an error.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_error",
      detail: "The value the function returns if `value` is an error.",
      example: '"Error in cell A1"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IF",
    t: 10,
    d: "Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",
    a: "Returns value depending on logical expression.",
    m: [2, 3],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_true",
      detail: "The value the function returns if `logical_expression` is `TRUE`.",
      example: '"A2 is foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_false",
      detail: "The value the function returns if `logical_expression` is `FALSE`.",
      example: '"A2 was false"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OR",
    t: 10,
    d: "Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",
    a: "Logical `or` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that evaluate to logical values.",
      example: ' A3 = "bar"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NE",
    t: 11,
    d: "Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",
    a: "Not equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for inequality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EQ",
    t: 11,
    d: "Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",
    a: "Equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for equality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",
    a: "Strictly greater than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",
    a: "Greater than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",
    a: "Less than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",
    a: "Less than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADD",
    t: 11,
    d: "Returns the sum of two numbers. Equivalent to the `+` operator.",
    a: "Sum of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first addend.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The second addend.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINUS",
    t: 11,
    d: "Returns the difference of two numbers. Equivalent to the `-` operator.",
    a: "Difference of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The minuend, or number to be subtracted from.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The subtrahend, or number to subtract from `value1`.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTIPLY",
    t: 11,
    d: "Returns the product of two numbers. Equivalent to the `*` operator.",
    a: "Product of two numbers",
    m: [2, 2],
    p: [{
      name: "factor1",
      detail: "The first multiplicand.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "The second multiplicand.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DIVIDE",
    t: 11,
    d: "Returns one number divided by another. Equivalent to the `/` operator.",
    a: "One number divided by another",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCAT",
    t: 11,
    d: "Returns the concatenation of two values. Equivalent to the `&` operator.",
    a: "Concatenation of two values",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to which `value2` will be appended.",
      example: '"de"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to append to `value1`.",
      example: '"mystify"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNARY_PERCENT",
    t: 11,
    d: "Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",
    a: "Value interpreted as a percentage.",
    m: [1, 1],
    p: [{
      name: "percentage",
      detail: "The value to interpret as a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCATENATE",
    t: 12,
    d: "Appends strings to one another.",
    a: "Appends strings to one another.",
    m: [1, 255],
    p: [{
      name: "string1",
      detail: "The initial string.",
      example: '"Super"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "More strings to append in sequence.",
      example: '"calla"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CODE",
    t: 12,
    d: "Returns the numeric Unicode map value of the first character in the string provided.",
    a: "Numeric unicode map value of character.",
    m: [1, 1],
    p: [{
      name: "string",
      detail: "The string whose first character's Unicode map value will be returned.",
      example: '"a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CHAR",
    t: 12,
    d: "Convert a number into a character according to the current Unicode table.",
    a: "Gets character associated with number.",
    m: [1, 1],
    p: [{
      name: "table_number",
      detail: "The number of the character to look up from the current Unicode table in decimal format.",
      example: "97",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ARABIC",
    t: 12,
    d: "Computes the value of a Roman numeral.",
    a: "Computes the value of a roman numeral.",
    m: [1, 1],
    p: [{
      name: "roman_numeral",
      detail: "The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",
      example: '"XIV"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROMAN",
    t: 12,
    d: "Formats a number in Roman numerals.",
    a: "Formats a number in Roman numerals.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The number to format, between 1 and 3999, inclusive.",
      example: "499",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "REGEXEXTRACT",
    t: 12,
    d: "Extracts matching substrings according to a regular expression.",
    a: "Extracts matching substrings with regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The input text.",
      example: '"Needle in a haystack"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The first part of `text` that matches this expression will be returned.",
      example: '".e{2}dle"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXMATCH",
    t: 12,
    d: "Whether a piece of text matches a regular expression.",
    a: "Whether a piece of text matches regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The text to be tested against the regular expression.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression to test the text against.",
      example: '"S.r"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXREPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string using regular expressions.",
    a: "Replaces text with regular expressions.",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression.  All matching instances in `text` will be replaced.",
      example: '"S.*d"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replacement",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T",
    t: 12,
    d: "Returns string arguments as text, or the empty string if the value is not text.",
    a: "String arguments as text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIXED",
    t: 12,
    d: "Formats a number with a fixed number of decimal places.",
    a: "Formats number with fixed number of decimal places.",
    m: [1, 3],
    p: [{
      name: "number",
      detail: "The number to format.",
      example: "3.141592653",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display in the result.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suppress_separator",
      detail: "Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIND",
    t: 12,
    d: "Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, case-sensitive.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FINDB",
    t: 12,
    d: "Returns the position at which a string is first found within text counting each double-character as 2.",
    a: "Position at which a string is first found within text (binary).",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"new"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: '"new year"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "JOIN",
    t: 12,
    d: "Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",
    a: "Concatenates elements of arrays with delimiter.",
    m: [2, 255],
    p: [{
      name: "delimiter",
      detail: "The character or string to place between each concatenated value.",
      example: '" and-a "',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array1",
      detail: "The value or values to be appended using `delimiter`.",
      example: "{1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array2",
      detail: "More values to be appended using `delimiter`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LEFT",
    t: 12,
    d: "Returns a substring from the beginning of a specified string.",
    a: "Substring from beginning of specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the left portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the left side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RIGHT",
    t: 12,
    d: "Returns a substring from the end of a specified string.",
    a: "A substring from the end of a specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the right portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the right side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MID",
    t: 12,
    d: "Returns a segment of a string.",
    a: "A segment of a string.",
    m: [3, 3],
    p: [{
      name: "string",
      detail: "The string to extract a segment from.",
      example: '"get this"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "extract_length",
      detail: "The length of the segment to extract.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LEN",
    t: 12,
    d: "Returns the length of a string.",
    a: "Length of a string.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LENB",
    t: 12,
    d: "Returns the length of a string in bytes.",
    a: "Length of a string in bytes.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOWER",
    t: 12,
    d: "Converts a specified string to lowercase.",
    a: "Converts a specified string to lowercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to lowercase.",
      example: '"LOREM IPSUM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UPPER",
    t: 12,
    d: "Converts a specified string to uppercase.",
    a: "Converts a specified string to uppercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to uppercase.",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EXACT",
    t: 12,
    d: "Tests whether two strings are identical.",
    a: "Tests whether two strings are identical.",
    m: [2, 2],
    p: [{
      name: "string1",
      detail: "The first string to compare",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "The second string to compare",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string.",
    a: "Replaces part of a text string with different text.",
    m: [4, 4],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "position",
      detail: "The position where the replacement will begin (starting from 1).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "length",
      detail: "The number of characters in the text to be replaced.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_text",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPT",
    t: 12,
    d: "Returns specified text repeated a number of times.",
    a: "Specified text repeated a number of times.",
    m: [2, 2],
    p: [{
      name: "text_to_repeat",
      detail: "The character or string to repeat.",
      example: '"ha"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_repetitions",
      detail: "The number of times `text_to_repeat` should appear in the value returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEARCH",
    t: 12,
    d: "Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, ignoring case.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUBSTITUTE",
    t: 12,
    d: "Replaces existing text with new text in a string.",
    a: "Replaces existing text with new text in a string.",
    m: [3, 4],
    p: [{
      name: "text_to_search",
      detail: "The text within which to search and replace.",
      example: '"search for it"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_for",
      detail: "The string to search for within `text_to_search`.",
      example: '"search for"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replace_with",
      detail: "The string that will replace `search_for`.",
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurrence_number",
      detail: "The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CLEAN",
    t: 12,
    d: "Returns the text with the non-printable ASCII characters removed.",
    a: "Removes non-printable characters from a piece of text.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text whose non-printable characters are to be removed.",
      example: '"AF"&CHAR(31)',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TEXT",
    t: 12,
    d: "Converts a number into text according to a specified format.",
    a: "Formats a number into text.",
    m: [2, 2],
    p: [{
      name: "number",
      detail: "The number, date, or time to format.",
      example: "1.23",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "format",
      detail: "The pattern by which to format the number, enclosed in quotation marks.",
      example: '"$0.00"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRIM",
    t: 12,
    d: "Removes leading, trailing, and repeated spaces in text.",
    a: "Removes space characters.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text or reference to a cell containing text to be trimmed.",
      example: '" lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "VALUE",
    t: 12,
    d: "Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",
    a: "Converts a date/time/number string into a number.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string containing the value to be converted.",
      example: '"123"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROPER",
    t: 12,
    d: "Capitalizes each word in a specified string.",
    a: "Capitalizes each word in a specified string.",
    m: [1, 1],
    p: [{
      name: "text_to_capitalize",
      detail: "The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",
      example: '"united states"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CONVERT",
    t: 13,
    d: "Converts a numeric value to a different unit of measure.",
    a: "Unit conversion for numbers.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The numeric value in `start_unit` to convert to `end_unit`.",
      example: "5.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_unit",
      detail: "The starting unit, the unit currently assigned to `value`.",
      example: '"g"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_unit",
      detail: "The unit of measure into which to convert the argument, `value`.",
      example: '"kg"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "SUMX2MY2",
    t: 14,
    d: "Calculates the sum of the differences of the squares of values in two arrays.",
    a: "Sum of the differences of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMX2PY2",
    t: 14,
    d: "Calculates the sum of the sums of the squares of values in two arrays.",
    a: "Sum of the sums of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMXMY2",
    t: 14,
    d: "Calculates the sum of the squares of differences of values in two arrays.",
    a: "Sum of the squares of differences.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRANSPOSE",
    t: 14,
    d: "Transposes the rows and columns of an array or range of cells.",
    a: "Transposes the rows and columns of an array.",
    m: [1, 1],
    p: [{
      name: "array_or_range",
      detail: "The array or range whose rows and columns will be swapped.",
      example: "{1,2}",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TREND",
    t: 14,
    d: "Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",
    a: "Fits points to linear trend derived via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FREQUENCY",
    t: 14,
    d: "Calculates the frequency distribution of a one-column array into specified classes.",
    a: "The frequency distribution of array.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the values to be counted.",
      example: "A2:A40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "classes",
      detail: "The array or range containing the set of classes.",
      example: "B2:B5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GROWTH",
    t: 14,
    d: "Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",
    a: "Fits points to exponential growth trend.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINEST",
    t: 14,
    d: "Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",
    a: "Best-fit linear trend via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calculate_b",
      detail: "Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOGEST",
    t: 14,
    d: "Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",
    a: "Best-fit exponential growth curve.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MDETERM",
    t: 14,
    d: "Returns the matrix determinant of a square matrix specified as an array or range.",
    a: "Matrix determinant of a square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINVERSE",
    t: 14,
    d: "Returns the multiplicative inverse of a square matrix specified as an array or range.",
    a: "Multiplicative inverse of square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MMULT",
    t: 14,
    d: "Calculates the matrix product of two matrices specified as arrays or ranges.",
    a: "The matrix product of two matrices.",
    m: [2, 2],
    p: [{
      name: "matrix1",
      detail: "The first matrix in the matrix multiplication operation, represented as an array or range.",
      example: "A1:B3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "matrix2",
      detail: "The second matrix in the matrix multiplication operation, represented as an array or range.",
      example: "C1:F2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMPRODUCT",
    t: 14,
    d: "Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",
    a: "Sum of products of elements in two arrays.",
    m: [1, 255],
    p: [{
      name: "array1",
      detail: "The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",
      example: "A2:C5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",
      example: "D2:F5",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "ISFORMULA",
    t: 15,
    d: "Checks whether a value is a formula.",
    a: "Whether a value is a formula.",
    m: [1, 1],
    p: [{
      name: "cell",
      detail: "The cell to be verified as containing a formula.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CELL",
    t: 15,
    d: "Returns the requested information about the specified cell.",
    a: "Gets information about a cell.",
    m: [2, 2],
    p: [{
      name: "info_type",
      detail: "The type of information requested (see article for available types)",
      example: '"type"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "reference",
      detail: "The reference to the cell.",
      example: "C2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "NA",
    t: 15,
    d: 'Returns the "value not available" error, `#N/A`.',
    a: "The `#N/A` error.",
    m: [0, 0],
    p: []
  }, {
    n: "ERROR_TYPE",
    t: 15,
    d: "Returns a number corresponding to the error value in a different cell.",
    a: "Error value of cell (as number).",
    m: [1, 1],
    p: [{
      name: "reference",
      detail: "The cell to find the error number for although you can also provide the error value directly.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISBLANK",
    t: 15,
    d: "Checks whether the referenced cell is empty.",
    a: "Whether the referenced cell is empty.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Reference to the cell that will be checked for emptiness.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISERR",
    t: 15,
    d: "Checks whether a value is an error other than `#N/A`.",
    a: "Whether a value is an error other than `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type other than `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISERROR",
    t: 15,
    d: "Checks whether a value is an error.",
    a: "Whether a value is an error.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISLOGICAL",
    t: 15,
    d: "Checks whether a value is `TRUE` or `FALSE`.",
    a: "Whether a value is `true` or `false`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a logical `TRUE` or `FALSE`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNA",
    t: 15,
    d: "Checks whether a value is the error `#N/A`.",
    a: "Whether a value is the error `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be compared with the error value `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNONTEXT",
    t: 15,
    d: "Checks whether a value is non-textual.",
    a: "Whether a value is non-textual.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be checked.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNUMBER",
    t: 15,
    d: "Checks whether a value is a number.",
    a: "Whether a value is a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISREF",
    t: 15,
    d: "Checks whether a value is a valid cell reference.",
    a: "Whether a value is a valid cell reference.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a cell reference.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISTEXT",
    t: 15,
    d: "Checks whether a value is text.",
    a: "Whether a value is text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TYPE",
    t: 15,
    d: "Returns a number associated with the type of data passed into the function.",
    a: "Get the type of a value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose type is to be determined.",
      example: "C4",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "N",
    t: 15,
    d: "Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",
    a: "Argument provided as a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DATE",
    t: 16,
    d: "Converts a provided number to a date.",
    a: "Converts a provided number to a date.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a date.",
      example: "25405",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PURE_NUMBER",
    t: 16,
    d: "Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",
    a: "Converts any numeric value to a pure number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a pure number.",
      example: "50%",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_TEXT",
    t: 16,
    d: "Converts a provided numeric value to a text value.",
    a: "Converts a provided numeric value to a text value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to text.",
      example: "24",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DOLLARS",
    t: 16,
    d: "Converts a provided number to a dollar value.",
    a: "Converts a provided number to a dollar value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a dollar value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PERCENT",
    t: 16,
    d: "Converts a provided number to a percentage.",
    a: "Converts a provided number to a percentage.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DGET",
    t: 17,
    d: "Returns a single value from a database table-like array or range using a SQL-like query.",
    a: "Single value from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMAX",
    t: 17,
    d: "Returns the maximum value selected from a database table-like array or range using a SQL-like query.",
    a: "Maximum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMIN",
    t: 17,
    d: "Returns the minimum value selected from a database table-like array or range using a SQL-like query.",
    a: "Minimum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DAVERAGE",
    t: 17,
    d: "Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",
    a: "Average of a set of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNT",
    t: 17,
    d: "Counts numeric values selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNTA",
    t: 17,
    d: "Counts values, including text, selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values and text from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DPRODUCT",
    t: 17,
    d: "Returns the product of values selected from a database table-like array or range using a SQL-like query.",
    a: "Product of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEV",
    t: 17,
    d: "Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of population sample from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEVP",
    t: 17,
    d: "Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of entire population from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSUM",
    t: 17,
    d: "Returns the sum of values selected from a database table-like array or range using a SQL-like query.",
    a: "Sum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVAR",
    t: 17,
    d: "Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of population sample from table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVARP",
    t: 17,
    d: "Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of a population from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "AGE_BY_IDCARD",
    t: "3",
    d: "Calculate the age based on the Chinese ID number. Support 15 or 18",
    a: "Get age based on ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: "A1",
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Deadline",
      example: '"2017-10-01"',
      detail: "The deadline or range of age calculation. The default is the current day.",
      require: "o",
      repeat: "n",
      type: "rangedatetime"
    }]
  }, {
    n: "SEX_BY_IDCARD",
    t: "3",
    d: "Calculate gender based on Chinese ID number. Support 15 or 18",
    a: "Get gender based on ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIRTHDAY_BY_IDCARD",
    t: "3",
    d: "Calculate the birthday based on the Chinese ID number. Support 15 or 18",
    a: "Get the birthday based on the ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Birthday format",
      example: "0",
      detail: "Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROVINCE_BY_IDCARD",
    t: "3",
    d: "Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the province of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CITY_BY_IDCARD",
    t: "3",
    d: "Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the city of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "STAR_BY_IDCARD",
    t: "3",
    d: "Calculate the constellation based on the Chinese ID number. Support 15 or 18",
    a: "Get the constellation based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ANIMAL_BY_IDCARD",
    t: "3",
    d: "Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",
    a: "Get the zodiac according to the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISIDCARD",
    t: "3",
    d: "Verify that the format of the ID card is correct. Support 15 or 18",
    a: "Verify the correctness of the ID card format.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DM_TEXT_CUTWORD",
    t: "4",
    d: "Text segmentation. Split a series of words into a series of individual words",
    a: "Chinese text segmentation.",
    m: [1, 2],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Word segmentation mode",
      example: "0",
      detail: "The default is 0[precision mode], 1[full mode], 2[search engine mode].",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TFIDF",
    t: "4",
    d: "Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",
    a: "tf-idf keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TEXTRANK",
    t: "4",
    d: "Use TextRank algorithm to extract keywords. Identify keywords from a series of text",
    a: "TextRank keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_CLOSE",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock closing price of A shares.",
    a: "Returns the closing price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_OPEN",
    t: "5",
    d: "According to the stock code and date, return the opening price of stock.",
    a: "Return the opening price of a shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MAX",
    t: "5",
    d: "According to the stock code and date, return the highest price of stock.",
    a: "Return the highest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MIN",
    t: "5",
    d: "According to the stock code and date, return the lowest price of stock.",
    a: "Returns the lowest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_VOLUMN",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock trading volume of A shares.",
    a: "Returns the corresponding stock trading volume of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_AMOUNT",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock turnover of A shares.",
    a: "Returns the corresponding stock turnover of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISDATE",
    t: "6",
    d: "Returns whether a value is a date.",
    a: "Whether a value is a date.",
    m: [1, 1],
    p: [{
      name: "value",
      example: '"1990-01-01"',
      detail: "The value to be verified as a date.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell to describe the continuous trend of data",
    a: "Generate sparklines line chart",
    m: [1, 8],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Maximum mark",
      example: "#fc5c5c",
      detail: "Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Minimum mark",
      example: "#fc5c5c",
      detail: "Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Mark size",
      example: "1.5",
      detail: "The maximum and minimum mark size settings, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AREASPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",
    a: "Generate sparklines area chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Fill color",
      example: "#CCF3F4",
      detail: "Form an area chart, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",
    a: "Generate sparklines vertical histogram",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKCOLUMNSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative vertical histogram",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BARSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the size of discrete data",
    a: "Generate sparklines horizontal bar graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKBARSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative horizontal bar graph",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "DISCRETESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",
    a: "Generate sparklines discrete graph",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Segmentation threshold",
      example: "1",
      detail: "Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Above threshold color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Below threshold color",
      example: "#fc5c5c",
      detail: "The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRISTATESPLINES",
    t: "3",
    d: "Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",
    a: "Generate sparklines three-state graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Zero value bar color",
      example: "#999",
      detail: "Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PIESPLINES",
    t: "3",
    d: "Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",
    a: "Generate sparklines pie chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Rotation angle",
      example: "0",
      detail: "The rotation angle of the pie chart, the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "border",
      example: "0",
      detail: "Pie chart border size, default is none 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Border color",
      example: "#000",
      detail: "The border color of the pie chart, the default is #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BOXSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",
    a: "Generate sparklines box plot",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Outlier ratio",
      example: "1.5",
      detail: "The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Target value",
      example: "10",
      detail: "The target value setting on the box plot, the default is false and does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Point size",
      example: "1.5",
      detail: "The radius of the target point and outlier is set, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BULLETSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the task achievement rate",
    a: "Generating sparklines bullets",
    m: [2, 3],
    p: [{
      name: "Target",
      example: "10",
      detail: "The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "achieved",
      example: "8",
      detail: "Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Contrast",
      example: "12",
      detail: "Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMPOSESPLINES",
    t: "3",
    d: "Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",
    a: "Combine sparklines graphs into one cell",
    m: [1, 1],
    p: [{
      name: "config",
      example: "PIESPLINES(A1:A20)",
      detail: "Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",
      require: "m",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SORT",
    t: "14",
    d: "Sorts the rows of a given array or range by the values in one or more columns.",
    a: "Sorts rows of range by specified column.",
    m: [1, 4],
    p: [{
      name: "range",
      detail: "The data to be sorted.",
      example: "A2:A17",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column",
      detail: "The index of the column in `range` or a range outside of `range` containing the values by which to sort.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_ascending",
      detail: "`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",
      example: "-1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column2",
      detail: "Additional columns.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FILTER",
    t: "14",
    d: "Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",
    a: "Filters a range based off provided conditions.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The data to be filtered.",
      example: "A5:D20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition1",
      detail: "A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition2",
      detail: "Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",
      example: '""',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNIQUE",
    t: "14",
    d: "Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",
    a: "Unique rows in the provided source range.",
    m: [1, 3],
    p: [{
      name: "range",
      detail: "The data to filter by unique entries.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurs_once",
      detail: "[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANDARRAY",
    t: "14",
    d: "Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",
    a: "Returns a grid of random numbers.",
    m: [0, 2],
    p: [{
      name: "rows",
      detail: "The number of rows to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEQUENCE",
    t: "14",
    d: "Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",
    a: "Returns a grid of sequential numbers.",
    m: [1, 4],
    p: [{
      name: "rows",
      detail: "The number of rows in the function's resulting grid.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start",
      detail: "The number, at which to start the sequence. If omitted, the sequence will start at 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "step",
      detail: "The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVALUATE",
    t: "3",
    d: "Evaluate a formula or expression expressed in words and return the result",
    a: "Evaluate according to literal formula or expression.",
    m: [1, 1],
    p: [{
      name: "expression",
      example: '"A1+5*2^2"',
      detail: "Formula or expression",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }],
  toolbar: {
    toolbar: "Barra de herramientas",
    undo: "Deshacer",
    redo: "Rehacer",
    paintFormat: "Clonar formato",
    currencyFormat: "Formato de moneda",
    percentageFormat: "Formato de porcentaje",
    numberDecrease: "Menos decimales",
    numberIncrease: "Más decimales",
    moreFormats: "Más formatos",
    font: "Fuente",
    "font-size": "Tamaño Fuente",
    bold: "Negrita (Ctrl+B)",
    italic: "Itálica (Ctrl+I)",
    strikethrough: "Tachar (Alt+Shift+5)",
    underline: "Guion bajo",
    "font-color": "Color texto",
    chooseColor: "elegir color",
    resetColor: "Reinicializar",
    customColor: "PERSONALIZADO",
    alternatingColors: "Colores alternos",
    confirmColor: "Vale",
    cancelColor: "Cancelar",
    collapse: "Recoger",
    background: "Color de relleno",
    border: "Borde",
    borderStyle: "Estilo Borde",
    "merge-cell": "Juntar celdas",
    chooseMergeType: "Elegir tipo de unión",
    horizontalAlign: "Alineación Horizontal",
    verticalAlign: "Alineación Vertical",
    alignment: "Alineación",
    textWrap: "Ajuste de texto",
    textWrapMode: "Modo de ajuste de texto",
    textRotate: "Rotar texto",
    textRotateMode: "Modo de rotar texto",
    freeze: "Fijar fila superior",
    sort: "Ordenar",
    filter: "Filtrar",
    findAndReplace: "Buscar y reemplazar",
    "formula-sum": "SUMA",
    autoSum: "SUMA automática",
    moreFunction: "Más funciones",
    conditionalFormat: "Formato condicional",
    comment: "Comentario",
    pivotTable: "Tabla Dinámica",
    chart: "Gráfica",
    screenshot: "Captura de pantalla",
    splitColumn: "Separar texto",
    insertImage: "Insertar imagen",
    dataVerification: "Verificación de datos",
    protection: "Proteger la hoja",
    clearText: "Limpiar color",
    noColorSelectedText: "Ningún color seleccionado",
    toolMore: "Más",
    toolLess: "Menos",
    toolClose: "Cerrar",
    toolMoreTip: "Más funcionalidades",
    moreOptions: "Más opciones",
    cellFormat: "Configuración formato de celda",
    print: "Imprimir"
  },
  alternatingColors: {
    applyRange: "Aplicar a rango",
    selectRange: "Seleccionar un rango de datos",
    header: "Cabecera",
    footer: "Pie",
    errorInfo: "No se puede realizar esta operación en varias áreas de selección, selecciona una sola área y vuelve a intentarlo",
    textTitle: "Estilo Formato",
    custom: "PERSONALIZADO",
    close: "cerrar",
    selectionTextColor: "Haz clic para seleccionar el color del texto",
    selectionCellColor: "Haz clic para seleccionar el color de la celda",
    removeColor: "Eliminar colores alternos",
    colorShow: "color",
    currentColor: "Actual",
    tipSelectRange: "Selecciona la gama de colores alternos",
    errorNoRange: "No hay ningún rango seleccionado",
    errorExistColors: "Los colores alternos ya existen y no se pueden editar"
  },
  button: {
    confirm: "Vale",
    cancel: "Cancelar",
    close: "Cerrar",
    update: "Actualizar",
    delete: "Eliminar",
    insert: "Insertar",
    prevPage: "Previous",
    nextPage: "Next",
    total: "total:"
  },
  paint: {
    start: "Inicio clonar formato",
    end: "ESC",
    tipSelectRange: "Selecciona el rango que quieres copiar",
    tipNotMulti: "No se puede realizar esta operación en un rango de selección múltiple"
  },
  format: {
    moreCurrency: "Más formatos de moneda",
    moreDateTime: "Más formatos de fecha y hora",
    moreNumber: "Más formatos de número",
    titleCurrency: "Formatos de moneda",
    decimalPlaces: "Decimales",
    titleDateTime: "Formatos de fecha y hora",
    titleNumber: "Formatos de números"
  },
  info: {
    detailUpdate: "Nuevo abierto",
    detailSave: "Cache local restaurado",
    row: "",
    column: "",
    loading: "Cargando...",
    copy: "Copiar",
    return: "Salir",
    rename: "Renombrar",
    tips: "Renombrar Libro",
    noName: "Hoja sin título",
    wait: "esperando actualización",
    add: "Añadir",
    addLast: "más filas al final",
    backTop: "Volver arriba",
    pageInfo: "Total ${total}，página ${totalPage}，actual ${currentPage}",
    nextPage: "Siguiente",
    tipInputNumber: "Introduce el número",
    tipInputNumberLimit: "El rango de aumento está limitado a 1-100",
    tipRowHeightLimit: "La altura de la fila debe estar entre 0 ~ 545",
    tipColumnWidthLimit: "El ancho de la columna debe estar entre 0 ~ 2038",
    pageInfoFull: "Total ${total}，página ${totalPage}，Se muestran todos los datos"
  },
  currencyDetail: {
    RMB: "RMB",
    USdollar: "Dólar US",
    EUR: "EUR",
    GBP: "GBP",
    HK: "HK",
    JPY: "JPY",
    AlbanianLek: "Albanian Lek",
    AlgerianDinar: "Algerian Dinar",
    Afghani: "Afghani",
    ArgentinePeso: "Argentine Peso",
    UnitedArabEmiratesDirham: "United Arab Emirates Dirham",
    ArubanFlorin: "Aruban Florin",
    OmaniRial: "Omani Rial",
    Azerbaijanimanat: "Azerbaijani manat",
    EgyptianPound: "Egyptian Pound",
    EthiopianBirr: "Ethiopian Birr",
    AngolaKwanza: "Angola Kwanza",
    AustralianDollar: "Australian Dollar",
    Patacas: "Patacas",
    BarbadosDollar: "Barbados Dollar",
    PapuaNewGuineaKina: "Papua New Guinea Kina",
    BahamianDollar: "Bahamian Dollar",
    PakistanRupee: "Pakistan Rupee",
    ParaguayanGuarani: "Paraguayan Guarani",
    BahrainiDinar: "Bahraini Dinar",
    PanamanianBalboa: "Panamanian Balboa",
    Brazilianreal: "Brazilian real",
    Belarusianruble: "Belarusian ruble",
    BermudianDollar: "Bermudian Dollar",
    BulgarianLev: "Bulgarian Lev",
    IcelandKrona: "Iceland Krona",
    BosniaHerzegovinaConvertibleMark: "Bosnia-Herzegovina Convertible Mark",
    PolishZloty: "Polish Zloty",
    Boliviano: "Boliviano",
    BelizeDollar: "Belize Dollar",
    BotswanaPula: "Botswana Pula",
    NotDannuzhamu: "Not Dannuzhamu",
    BurundiFranc: "Burundi Franc",
    NorthKoreanWon: "North Korean Won",
    DanishKrone: "Danish Krone",
    EastCaribbeanDollar: "East Caribbean Dollar",
    DominicaPeso: "Dominica Peso",
    RussianRuble: "Russian Ruble",
    EritreanNakfa: "Eritrean Nakfa",
    CFAfranc: "CFA franc",
    PhilippinePeso: "Philippine Peso",
    FijiDollar: "Fiji Dollar",
    CapeVerdeEscudo: "Cape Verde Escudo",
    FalklandIslandsPound: "Falkland Islands Pound",
    GambianDalasi: "Gambian Dalasi",
    Congolesefranc: "Congolese franc",
    ColombianPeso: "Colombian Peso",
    CostaRicanColon: "Costa Rican Colon",
    CubanPeso: "Cuban Peso",
    Cubanconvertiblepeso: "Cuban convertible peso",
    GuyanaDollar: "Guyana Dollar",
    KazakhstanTenge: "Kazakhstan Tenge",
    Haitiangourde: "Haitian gourde",
    won: "won",
    NetherlandsAntillesGuilder: "Netherlands Antilles Guilder",
    Honduraslempiras: "Honduras lempiras",
    DjiboutiFranc: "Djibouti Franc",
    KyrgyzstanSom: "Kyrgyzstan Som",
    GuineaFranc: "Guinea Franc",
    CanadianDollar: "Canadian Dollar",
    GhanaianCedi: "Ghanaian Cedi",
    Cambodianriel: "Cambodian riel",
    CzechKoruna: "Czech Koruna",
    ZimbabweDollar: "Zimbabwe Dollar",
    QatariRiyal: "Qatari Riyal",
    CaymanIslandsDollar: "Cayman Islands Dollar",
    Comorianfranc: "Comorian franc",
    KuwaitiDinar: "Kuwaiti Dinar",
    CroatianKuna: "Croatian Kuna",
    KenyanShilling: "Kenyan Shilling",
    LesothoLoti: "Lesotho Loti",
    LaoKip: "Lao Kip",
    LebanesePound: "Lebanese Pound",
    Lithuanianlitas: "Lithuanian litas",
    LibyanDinar: "Libyan Dinar",
    LiberianDollar: "Liberian Dollar",
    RwandaFranc: "Rwanda Franc",
    RomanianLeu: "Romanian Leu",
    MalagasyAriary: "Malagasy Ariary",
    MaldivianRufiyaa: "Maldivian Rufiyaa",
    MalawiKwacha: "Malawi Kwacha",
    MalaysianRinggit: "Malaysian Ringgit",
    MacedoniawearingDinar: "Macedonia wearing Dinar",
    MauritiusRupee: "Mauritius Rupee",
    MauritanianOuguiya: "Mauritanian Ouguiya",
    MongolianTugrik: "Mongolian Tugrik",
    BangladeshiTaka: "Bangladeshi Taka",
    PeruvianNuevoSol: "Peruvian Nuevo Sol",
    MyanmarKyat: "Myanmar Kyat",
    MoldovanLeu: "Moldovan Leu",
    MoroccanDirham: "Moroccan Dirham",
    MozambiqueMetical: "Mozambique Metical",
    MexicanPeso: "Mexican Peso",
    NamibianDollar: "Namibian Dollar",
    SouthAfricanRand: "South African Rand",
    SouthSudanesePound: "South Sudanese Pound",
    NicaraguaCordoba: "Nicaragua Cordoba",
    NepaleseRupee: "Nepalese Rupee",
    NigerianNaira: "Nigerian Naira",
    NorwegianKrone: "Norwegian Krone",
    GeorgianLari: "Georgian Lari",
    RMBOffshore: "RMB (Offshore)",
    SwedishKrona: "Swedish Krona",
    SwissFranc: "Swiss Franc",
    SerbianDinar: "Serbian Dinar",
    SierraLeone: "Sierra Leone",
    SeychellesRupee: "Seychelles Rupee",
    SaudiRiyal: "Saudi Riyal",
    SaoTomeDobra: "Sao Tome Dobra",
    SaintHelenapound: "Saint Helena pound",
    SriLankaRupee: "Sri Lanka Rupee",
    SwazilandLilangeni: "Swaziland Lilangeni",
    SudanesePound: "Sudanese Pound",
    Surinamesedollar: "Surinamese dollar",
    SolomonIslandsDollar: "Solomon Islands Dollar",
    SomaliShilling: "Somali Shilling",
    TajikistanSomoni: "Tajikistan Somoni",
    PacificFranc: "Pacific Franc",
    ThaiBaht: "Thai Baht",
    TanzanianShilling: "Tanzanian Shilling",
    TonganPaanga: "Tongan Pa'anga",
    TrinidadandTobagoDollar: "Trinidad and Tobago Dollar",
    TunisianDinar: "Tunisian Dinar",
    TurkishLira: "Turkish Lira",
    VanuatuVatu: "Vanuatu Vatu",
    GuatemalanQuetzal: "Guatemalan Quetzal",
    CommissionBolivar: "Commission Bolivar",
    BruneiDollar: "Brunei Dollar",
    UgandanShilling: "Ugandan Shilling",
    UkrainianHryvnia: "Ukrainian Hryvnia",
    UruguayanPeso: "Uruguayan Peso",
    Uzbekistansom: "Uzbekistan som",
    WesternSamoaTala: "Western Samoa Tala",
    SingaporeDollar: "Singapore Dollar",
    NT: "NT",
    NewZealandDollar: "New Zealand Dollar",
    HungarianForint: "Hungarian Forint",
    SyrianPound: "Syrian Pound",
    JamaicanDollar: "Jamaican Dollar",
    ArmenianDram: "Armenian Dram",
    YemeniRial: "Yemeni Rial",
    IraqiDinar: "Iraqi Dinar",
    IranianRial: "Iranian Rial",
    NewIsraeliShekel: "New Israeli Shekel",
    IndianRupee: "Indian Rupee",
    IndonesianRupiah: "Indonesian Rupiah",
    JordanianDinar: "Jordanian Dinar",
    VND: "VND",
    ZambianKwacha: "Zambian Kwacha",
    GibraltarPound: "Gibraltar Pound",
    ChileanPeso: "Chilean Peso",
    CFAFrancBEAC: "CFA Franc BEAC"
  },
  defaultFmt: function defaultFmt(currency) {
    return [{
      text: "Automático",
      value: "General",
      example: ""
    }, {
      text: "Texto",
      value: "@",
      example: ""
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Número",
      value: "##0.00",
      example: "1000.12"
    }, {
      text: "Porcentaje",
      value: "#0.00%",
      example: "12.21%"
    }, {
      text: "Científico",
      value: "0.00E+00",
      example: "1.01E+5"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Contabilidad",
      value: "".concat(currency, "(0.00)"),
      example: "".concat(currency, "(1200.09)")
    }, {
      text: "Moneda",
      value: "".concat(currency, "0.00"),
      example: "".concat(currency, "1200.09")
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Fecha",
      value: "yyyy-MM-dd",
      example: "2017-11-29"
    }, {
      text: "Hora",
      value: "hh:mm AM/PM",
      example: "3:00 PM"
    }, {
      text: "Hora 24H",
      value: "hh:mm",
      example: "15:00"
    }, {
      text: "Fecha Hora",
      value: "yyyy-MM-dd hh:mm AM/PM",
      example: "2017-11-29 3:00 PM"
    }, {
      text: "Fecha Hora 24 H",
      value: "yyyy-MM-dd hh:mm",
      example: "2017-11-29 15:00"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "Formatos personalizados",
      value: "fmtOtherSelf",
      example: "más"
    }];
  },
  dateFmtList: [{
    name: "1930-08-05",
    value: "yyyy-MM-dd"
  }, {
    name: "1930/8/5",
    value: "yyyy/MM/dd"
  }, {
    name: "08-05",
    value: "MM-dd"
  }, {
    name: "8-5",
    value: "M-d"
  }, {
    name: "13:30:30",
    value: "h:mm:ss"
  }, {
    name: "13:30",
    value: "h:mm"
  }, {
    name: "PM 01:30",
    value: "AM/PM hh:mm"
  }, {
    name: "PM 1:30",
    value: "AM/PM h:mm"
  }, {
    name: "PM 1:30:30",
    value: "AM/PM h:mm:ss"
  }, {
    name: "08-05 PM 01:30",
    value: "MM-dd AM/PM hh:mm"
  }],
  fontFamily: {
    MicrosoftYaHei: "YaHei"
  },
  fontarray: ["Times New Roman", "Arial", "Tahoma", "Verdana"],
  fontjson: {
    "times new roman": 0,
    arial: 1,
    tahoma: 2,
    verdana: 3
  },
  border: {
    borderTop: "borderTop",
    borderBottom: "borderBottom",
    borderLeft: "borderLeft",
    borderRight: "borderRight",
    borderNone: "borderNone",
    borderAll: "borderAll",
    borderOutside: "borderOutside",
    borderInside: "borderInside",
    borderHorizontal: "borderHorizontal",
    borderVertical: "borderVertical",
    borderColor: "borderColor",
    borderSize: "borderSize",
    borderSlash: "borderSlash"
  },
  merge: {
    mergeAll: "Unir todo",
    mergeV: "Verticalmente",
    mergeH: "Horizontalmente",
    mergeCancel: "Separar",
    overlappingError: "No se pueden fusionar áreas superpuestas",
    partiallyError: "No se puede realizar esta operación en celdas parcialmente unidas"
  },
  align: {
    left: "izquierda",
    center: "centro",
    right: "derecha",
    top: "Arriba",
    middle: "Centro",
    bottom: "Abajo"
  },
  textWrap: {
    overflow: "Desbordar",
    wrap: "Ajustar",
    clip: "Cortar"
  },
  rotation: {
    none: "Ninguno",
    angleup: "Ladear Arriba",
    angledown: "Ladear Abajo",
    vertical: "Apilar Verticalmente",
    rotationUp: "Rotar Arriba",
    rotationDown: "Rotar Abajo"
  },
  freezen: {
    default: "Fijar",
    freezenRow: "Primera Fila",
    freezenColumn: "Primera Columna",
    freezenRC: "Ambas",
    freezenRowRange: "Fijar rango filas",
    freezenColumnRange: "Fijar rango columnas",
    freezenRCRange: "Fijar ambos rangos",
    freezenCancel: "Cancelar",
    noSeletionError: "No hay rango para seleccionar",
    rangeRCOverErrorTitle: "Recordatorio de congelación",
    rangeRCOverError: "El panel de congelación excede el rango visible y puede causar que no funcione correctamente. Reinicie el área de congelación."
  },
  sort: {
    asc: "Ascendente ",
    desc: "Descendente ",
    custom: "Ordenación personalizada",
    hasTitle: "Los datos tienen una fila de encabezado",
    sortBy: "Ordenar por",
    addOthers: "Añadir otra columna de ordenación",
    close: "cerrar",
    confirm: "ordenar",
    columnOperation: "Columna",
    secondaryTitle: "y después por",
    sortTitle: "Ordenar rango",
    sortRangeTitle: "Ordenar rango de",
    sortRangeTitleTo: "a",
    noRangeError: "No se puede realizar esta operación en múltiples áreas de selección, selecciona un solo rango e intenta nuevamente",
    mergeError: "Hay celdas combinadas en la selección, ¡esta operación no se puede realizar!"
  },
  filter: {
    filter: "crear filtro",
    sortByAsc: "Ordenar A-Z",
    sortByDesc: "Ordenar Z-A",
    filterByColor: "Filtrar por color",
    filterByCondition: "Filtrar por condición",
    filterByValues: "Filtrar por valores",
    filiterInputNone: "Ninguno",
    filiterInputTip: "Introduce valor de filtro",
    filiterRangeStartTip: "Valor para fórmula",
    filiterRangeEndTip: "Valor para fórmula",
    filterValueByAllBtn: "Seleccionar todos",
    filterValueByClearBtn: "Limpiar",
    filterValueByInverseBtn: "Invertir",
    filterValueByTip: "filtrar por valores",
    filterConform: "Confirmar",
    filterCancel: "Cancelar",
    clearFilter: "Quitar filtro",
    conditionNone: "Ninguno",
    conditionCellIsNull: "Está vacío",
    conditionCellNotNull: "No está vacío",
    conditionCellTextContain: "El texto contiene",
    conditionCellTextNotContain: "El texto no contiene",
    conditionCellTextStart: "El texto empieza con",
    conditionCellTextEnd: "El texto termina con",
    conditionCellTextEqual: "El texto es exactamente",
    conditionCellDateEqual: "La fecha es",
    conditionCellDateBefore: "La fecha es anterior",
    conditionCellDateAfter: "La fecha es posterior",
    conditionCellGreater: "Mayor que",
    conditionCellGreaterEqual: "Mayor o igual que",
    conditionCellLess: "Menor que",
    conditionCellLessEqual: "Menor o igual que",
    conditionCellEqual: "Es igual a",
    conditionCellNotEqual: "No es igual a",
    conditionCellBetween: "Está entre",
    conditionCellNotBetween: "No está entre",
    filiterMoreDataTip: "¡Gran cantidad de datos! por favor espera",
    filiterMonthText: "Mes",
    filiterYearText: "Año",
    filiterByColorTip: "Filtrar por color de celda",
    filiterByTextColorTip: "Filtrar por color de fuente",
    filterContainerOneColorTip: "Esta columna contiene solo un color",
    filterDateFormatTip: "Format fecha",
    valueBlank: "(Nulo)",
    mergeError: "Hay celdas combinadas en la selección del filtro, ¡esta operación no se puede realizar!"
  },
  rightclick: {
    copy: "Copiar",
    copyAs: "Copiar como",
    paste: "Pegar",
    insert: "Insertar",
    image: "Insertar imágenes",
    link: "Insertar enlace",
    delete: "Eliminar",
    deleteCell: "Eliminar celda",
    deleteSelected: "Eliminar seleccionado ",
    hide: "Esconder",
    hideSelected: "Esconder seleccionado ",
    showHide: "Mostrar ocultos ",
    to: "Hacia",
    left: "Izquierda",
    right: "Derecha",
    top: "Arriba",
    bottom: "Abajo",
    moveLeft: "Mover izquierda",
    moveUp: "Mover arriba",
    add: "Añadir",
    row: "Fila",
    column: "Columna",
    width: "Ancho",
    height: "Alto",
    number: "Número",
    confirm: "Confirmar",
    orderAZ: "Ordenar A-Z",
    orderZA: "Ordenar Z-A",
    clearContent: "Limpiar contenido",
    matrix: "Operación de Matriz",
    sortSelection: "Ordenar",
    filterSelection: "Filtrar",
    chartGeneration: "Crear gráfico",
    firstLineTitle: "título primera línea",
    untitled: "sin título",
    array1: "Matriz unidimensional",
    array2: "Matriz bidimensional",
    array3: "Matrices multidimensionales",
    diagonal: "Diagonal",
    antiDiagonal: "Anti-diagonal",
    diagonalOffset: "Desplazamiento Diagonal",
    offset: "Desplazamiento",
    boolean: "Booleana",
    flip: "Voltear",
    upAndDown: "Arriba y abajo",
    leftAndRight: "Izquierda y derecha",
    clockwise: "Sentido horario",
    counterclockwise: "Sentido anti-horario",
    transpose: "Transponer",
    matrixCalculation: "Cálculo de matrices",
    plus: "Suma",
    minus: "Resta",
    multiply: "Multiplicación",
    divided: "División",
    power: "Exponenciación",
    root: "Raíz Cuadrada",
    log: "Logaritmo",
    delete0: "Eliminar valores nulos en ambos extremos",
    removeDuplicate: "Eliminar valores duplicados",
    byRow: "Por fila",
    byCol: "Por columna",
    generateNewMatrix: "Generar nueva matriz",
    noMulti: "No se puede realizar esta operación en varias áreas de selección, selecciona una sola área",
    cannotDeleteAllRow: "No se pueden eliminar todas las filas",
    cannotDeleteAllColumn: "No se pueden eliminar todas las columnas",
    cannotDeleteRowReadOnly: "No se puede eliminar la fila de solo lectura",
    cannotDeleteColumnReadOnly: "No se puede eliminar la columna de solo lectura",
    cannotInsertOnRowReadOnly: "No se puede insertar en una fila de solo lectura",
    cannotInsertOnColumnReadOnly: "No se puede insertar en la columna de solo lectura",
    rowOverLimit: "Límite de 10000 filas excedido",
    columnOverLimit: "Límite de 1000 columnas excedido"
  },
  comment: {
    insert: "Insertar",
    edit: "Editar",
    delete: "Elimiar",
    showOne: "Mostrar/Ocular",
    showAll: "Mostrar/Ocular Todo"
  },
  screenshot: {
    screenshotTipNoSelection: "Selecciona el alcance de la captura de pantalla",
    screenshotTipTitle: "¡Advertencia!",
    screenshotTipHasMerge: "Esta operación no se puede realizar en celdas combinadas",
    screenshotTipHasMulti: "Esta operación no se puede realizar en varios rangos de selección",
    screenshotTipSuccess: "Exitoso",
    screenshotImageName: "Captura de pantalla",
    downLoadClose: "Cerrar",
    downLoadCopy: "Copiar al portapapeles",
    downLoadBtn: "Descargar",
    browserNotTip: "no es compatible con el navegador IE.",
    rightclickTip: 'Haz clic con el botón derecho en la imagen y selecciona "copiar"',
    successTip: 'Con éxito (si falla el pegado, haz clic con el botón derecho en la imagen para "copiar imagen")'
  },
  splitText: {
    splitDelimiters: "Delimitadores",
    splitOther: "Otros",
    splitContinueSymbol: "Los separadores consecutivos se tratan como uno solo",
    splitDataPreview: "Previsualizar",
    splitTextTitle: "Partir texto",
    splitConfirmToExe: "Ya hay datos aquí, ¿quieres reemplazarlos?",
    tipNoMulti: "No se puede realizar esta operación en varias áreas de selección, selecciona una única área y vuelve a intentarlo",
    tipNoMultiColumn: "Solo se puede convertir una columna de datos a la vez. El área seleccionado puede tener varias filas, pero no varias columnas. Vuelve a intentarlo después de seleccionar un solo rango de columnas"
  },
  imageText: {
    imageSetting: "Configuración de imagen",
    close: "Cerrar",
    conventional: "Convencional",
    moveCell1: "Mover y cambiar el tamaño de las celdas",
    moveCell2: "Mover y no cambiar el tamaño de la celda",
    moveCell3: "No mover ni cambiar el tamaño de la celda",
    fixedPos: "Posición fija",
    border: "Borde",
    width: "Ancho",
    radius: "Radio",
    style: "Estilo",
    solid: "Sólido",
    dashed: "Discontinua",
    dotted: "Punteado",
    double: "Doble",
    color: "Color"
  },
  punctuation: {
    tab: "Tabulación",
    semicolon: "punto y coma",
    comma: "coma",
    space: "espacio"
  },
  findAndReplace: {
    find: "Encontrar",
    replace: "Reemplazar",
    goto: "Ir a",
    location: "Ubicación",
    formula: "Fórmula",
    date: "Fecha",
    number: "Número",
    string: "Texto",
    error: "Error",
    condition: "Condición",
    rowSpan: "Intervalo de filas",
    columnSpan: "Intervalo de columnas",
    locationExample: "Ubicación",
    lessTwoRowTip: "Selecciona al menos dos filas",
    lessTwoColumnTip: "Selecciona al menos dos columnas",
    findTextbox: "Encontrar Contenido",
    replaceTextbox: "Reemplazar Contenido",
    regexTextbox: "Expresión Regular",
    wholeTextbox: "Palabra entera",
    distinguishTextbox: "Distingue mayúsculas y minúsculas",
    allReplaceBtn: "Reemplazar Todo",
    replaceBtn: "Reemplazar",
    allFindBtn: "Encontrar Todo",
    findBtn: "Encontrar siguiente",
    noFindTip: "No se encontró el contenido",
    modeTip: "Esta operación no está disponible en este modo",
    searchTargetSheet: "Hoja",
    searchTargetCell: "Celda",
    searchTargetValue: "Valor",
    searchInputTip: "Introduce el contenido de la búsqueda",
    noReplceTip: "No hay nada que reemplazar",
    noMatchTip: "No se encontraron coincidencias",
    successTip: "${xlength} elementos encontrados",
    locationConstant: "Constante",
    locationFormula: "Fórmula",
    locationDate: "Fecha",
    locationDigital: "Número",
    locationString: "Texto",
    locationBool: "Lógicos",
    locationError: "Error",
    locationNull: "Nulo",
    locationCondition: "Formato condicional",
    locationRowSpan: "Intervalo fila",
    locationColumnSpan: "Intervalo columna",
    locationTiplessTwoRow: "Selecciona al menos dos filas",
    locationTiplessTwoColumn: "Selecciona al menos dos columnas",
    locationTipNotFindCell: "Celda no encontrada"
  },
  sheetconfig: {
    delete: "Eliminar",
    copy: "Copiar",
    rename: "Renombrar",
    changeColor: "Cambiar color",
    hide: "Ocultar",
    unhide: "Mostrar",
    moveLeft: "Mover izquierda",
    moveRight: "Mover derecja",
    resetColor: "Reiniciar color",
    cancelText: "Cancelar",
    chooseText: "Confirmar color",
    focus: "Enfocar",
    tipNameRepeat: "¡El nombre de la página de la pestaña no se puede repetir! Revísalo",
    noMoreSheet: "El libro de trabajo contiene al menos una hoja de trabajo visual. Para eliminar la hoja de trabajo seleccionada, inserta una nueva hoja de trabajo o muestra una hoja de trabajo oculta",
    confirmDelete: "¿Estás seguro de eliminar",
    redoDelete: "Se puede deshacer con Ctrl+Z",
    noHide: "No se puede ocultar, al menos conserva una etiqueta de hoja",
    chartEditNoOpt: "¡Esta operación no está permitida en el modo de edición de gráficos!",
    sheetNameSpecCharError: "El nombre no puede contener:[ ] :  ? * / ' \"",
    sheetNamecannotIsEmptyError: "El nombre de la hoja no puede estar vacío"
  },
  conditionformat: {
    conditionformat_greaterThan: "Conditionformat-GreaterThan",
    conditionformat_greaterThan_title: "Dar formato a celdas mayores que",
    conditionformat_lessThan: "Conditionformat-LessThan",
    conditionformat_lessThan_title: "Dar formato a celdas más pequeñas que",
    conditionformat_between: "Conditionformat-Betweenness",
    conditionformat_between_title: "Dar formato a celdas con valores entre",
    conditionformat_equal: "Conditionformat-Equal",
    conditionformat_equal_title: "Dar formato a celdas iguales a",
    conditionformat_textContains: "Conditionformat-TextContains",
    conditionformat_textContains_title: "Dar formato a las celdas que contienen el siguiente texto",
    conditionformat_occurrenceDate: "Conditionformat-OccurrenceDate",
    conditionformat_occurrenceDate_title: "Dar formato a celdas que contienen las siguientes fechas",
    conditionformat_duplicateValue: "Conditionformat-DuplicateValue",
    conditionformat_duplicateValue_title: "Dar formato a celdas que contienen los siguientes tipos de valores",
    conditionformat_top10: "Conditionformat-Top10",
    conditionformat_top10_percent: "Conditionformat-Top10%",
    conditionformat_top10_title: "Formatea las celdas con el valor más alto",
    conditionformat_last10: "Conditionformat-Last10",
    conditionformat_last10_percent: "Conditionformat-Last10%",
    conditionformat_last10_title: "Formatea las celdas con el valor más pequeño",
    conditionformat_aboveAverage: "Conditionformat-AboveAverage",
    conditionformat_aboveAverage_title: "Dar formato a celdas por encima del promedio",
    conditionformat_belowAverage: "Conditionformat-SubAverage",
    conditionformat_belowAverage_title: "Dar formato a celdas por debajo del promedio",
    rule: "Regla",
    newRule: "Nueva regla",
    editRule: "Editar regla",
    deleteRule: "Eliminar regla",
    deleteCellRule: "Eliminar regla de celda",
    deleteSheetRule: "Eliminar regla de hoja",
    manageRules: "Reglas administración",
    showRules: "Muestra sus reglas de formato",
    highlightCellRules: "Resaltar reglas de celda",
    itemSelectionRules: "Reglas de selección de elementos",
    conditionformatManageRules: "Administrador de reglas de formato condicional",
    format: "Formatear",
    setFormat: "Establecer formato",
    setAs: "Establecer como",
    setAsByArea: "Para el área seleccionada, establecer",
    applyRange: "Aplicar rango",
    selectRange: "Seleccionar rango de aplicación",
    selectRange_percent: "Porcentaje del rango seleccionado",
    selectRange_average: "Valor promedio del rango seleccionado",
    selectRange_value: "Valor en el rango seleccionado",
    pleaseSelectRange: "Selecciona el rango de aplicación",
    selectDataRange: "Seleccionar rango de datos",
    selectCell: "seleccionar celda",
    pleaseSelectCell: "Selecciona una celda",
    pleaseSelectADate: "Selecciona una fecha",
    pleaseEnterInteger: "Introduzca un número entero entre 1 y 1000",
    onlySingleCell: "Solo se puede hacer referencia a una sola celda",
    conditionValueCanOnly: "El valor de la condición solo puede ser un número o una sola celda",
    ruleTypeItem1: "Aplicar formato a todas las celdas según sus valores respectivos",
    ruleTypeItem2: "Solo formatear celdas que contengan",
    ruleTypeItem2_title: "Solo para celdas que cumplan las siguientes condiciones",
    ruleTypeItem3: "Aplicar formato solo a los números superiores o inferiores",
    ruleTypeItem3_title: "Es el valor en la siguiente clasificación",
    ruleTypeItem4: "Aplicar formato solo a los valores superiores o inferiores al promedio",
    ruleTypeItem4_title: "Es un valor que cumple las siguientes condiciones",
    ruleTypeItem5: "Aplicar formato solo a valores únicos o repetidos",
    ruleTypeItem6: "Use fórmulas para determinar qué celdas formatear",
    formula: "fórmula",
    textColor: "Color Texto",
    cellColor: "Color Celda",
    confirm: "Confirma",
    confirmColor: "Confirma color",
    cancel: "Cancela",
    close: "Cierra",
    clearColorSelect: "Limpiar selección de color",
    sheet: "Hoja",
    currentSheet: "Hoja actual",
    dataBar: "Barra de datos",
    dataBarColor: "Color barra de datos",
    gradientDataBar_1: "Barra de datos de degradado azul-blanco",
    gradientDataBar_2: "Barra de datos de degradado verde-blanco",
    gradientDataBar_3: "Barra de datos de degradado rojo-blanco",
    gradientDataBar_4: "Rayas de degradado de color naranja-blanco",
    gradientDataBar_5: "Rayas de degradado azul claro-blancas",
    gradientDataBar_6: "Barra de datos de degradado púrpura-blanco",
    solidColorDataBar_1: "Barra de datos azul",
    solidColorDataBar_2: "Barra de datos verde",
    solidColorDataBar_3: "Barra de datos roja",
    solidColorDataBar_4: "Barra de datos naranja",
    solidColorDataBar_5: "Barra de datos azul claro",
    solidColorDataBar_6: "Barra de datos púrpura",
    colorGradation: "Degradado de color",
    colorGradation_1: "Gradación de color verde-amarillo-rojo",
    colorGradation_2: "Gradación de color rojo-amarillo-verde",
    colorGradation_3: "Gradación de color verde-blanco-rojo",
    colorGradation_4: "Gradación de color rojo-blanco-verde",
    colorGradation_5: "Gradación de color azul-blanco-rojo",
    colorGradation_6: "Gradación de color rojo-blanco-azul",
    colorGradation_7: "Gradación de color blanco-rojo",
    colorGradation_8: "Gradación de color rojo-blanco",
    colorGradation_9: "Gradación de color verde-blanco",
    colorGradation_10: "Gradación de color blanco-verde",
    colorGradation_11: "Gradación de color verde-amarillo",
    colorGradation_12: "Gradación de color amarillo-verde",
    icons: "iconos",
    pleaseSelectIcon: "Haz clic para seleccionar un grupo de iconos:",
    cellValue: "Valor de celda",
    specificText: "Texto específico",
    occurrenceDate: "Fecha",
    greaterThan: "Mayor que",
    lessThan: "Menor que",
    between: "Entre",
    equal: "Igual",
    in: "En",
    between2: "",
    contain: "Contiene",
    textContains: "Texto contiene",
    duplicateValue: "Valor duplicado",
    uniqueValue: "Valor Unico",
    top: "Mejor",
    top10: "10 mejores",
    top10_percent: "10% mejores",
    last: "Ultimo",
    last10: "Ultimos 10",
    last10_percent: "Ultimos 10%",
    oneself: "",
    above: "Encima",
    aboveAverage: "Encima media",
    below: "Debajo",
    belowAverage: "Debajo media",
    all: "Todos",
    yesterday: "Año a fecha",
    today: "Hoy",
    tomorrow: "Mañana",
    lastWeek: "Ultima semana",
    thisWeek: "Esta semana",
    lastMonth: "Ultimo mes",
    thisMonth: "Este mes",
    lastYear: "Ultimo año",
    thisYear: "Este año",
    last7days: "Ultimos 7 días",
    last30days: "Ultimos 30 días",
    next7days: "Siguientes 7 días",
    next30days: "Siguientes 30 días",
    next60days: "Siguientes 60 días",
    chooseRuleType: "Elige el tipo de regla",
    editRuleDescription: "Editar descripción de regla",
    newFormatRule: "Nueva regla de formato",
    editFormatRule: "Editar regla de formato",
    formatStyle: "Estilo",
    fillType: "Rellenar",
    color: "Color",
    twocolor: "Dos colores",
    tricolor: "Tricolor",
    multicolor: "Multi color",
    grayColor: "Color gris",
    gradient: "Gradiente",
    solid: "Sólido",
    maxValue: "Valor máximo",
    medianValue: "Valor mediano",
    minValue: "Valor mínimo",
    direction: "Dirección",
    threeWayArrow: "Flecha de tres direcciones",
    fourWayArrow: "Flecha de cuatro direcciones",
    fiveWayArrow: "Flecha de cinco direcciones",
    threeTriangles: "Tres triángulos",
    shape: "Forma",
    threeColorTrafficLight: "Semáforo de tres colores",
    fourColorTrafficLight: "Semáforo de cuatro colores",
    threeSigns: "Tres signos",
    greenRedBlackGradient: "Gradiente verde-rojo-negro",
    rimless: "Sin aros",
    bordered: "Bordeado",
    mark: "Marcar",
    threeSymbols: "Tres símbolos",
    tricolorFlag: "Bandera tricolor",
    circled: "Rodeado",
    noCircle: "Sin círculo",
    grade: "Grado",
    grade4: "4 Grado",
    grade5: "5 Grado",
    threeStars: "3 Estrellas",
    fiveQuadrantDiagram: "Diagrama de cinco cuadrantes",
    fiveBoxes: "5 Cajas"
  },
  dataVerification: {
    cellRange: "Rango celdas",
    selectCellRange: "Haz clic para seleccionar un rango de celdas",
    selectCellRange2: "Selecciona un rango de celdas",
    verificationCondition: "Condición de verificación",
    allowMultiSelect: "Permitir selección múltiple",
    dropdown: "lista desplegable",
    checkbox: "Casilla de verificación",
    number: "Número",
    number_integer: "Número entero",
    number_decimal: "Número decimal",
    text_content: "Contenido texto",
    text_length: "Longitud texto",
    date: "Fecha",
    validity: "Eficacia",
    placeholder1: "Introduce las opciones, separadas por comas, como 1,2,3,4,5",
    placeholder2: "Introduce contenido",
    placeholder3: "Valor numérico, como 10",
    placeholder4: "Introduce el texto especificado",
    placeholder5: "Introduce el mensaje que se muestra cuando se selecciona la celda",
    selected: "Seleccionado",
    notSelected: "No seleccionado",
    between: "Entre",
    notBetween: "No entre",
    equal: "Iqual",
    notEqualTo: "No iqual a",
    moreThanThe: "Más que el",
    lessThan: "Menos que",
    greaterOrEqualTo: "Mayor o igual a",
    lessThanOrEqualTo: "Menor o igual a",
    include: "Incluir",
    exclude: "Excluir",
    earlierThan: "Antes de",
    noEarlierThan: "No antes de",
    laterThan: "Después de",
    noLaterThan: "No después de",
    identificationNumber: "Número de identificación",
    phoneNumber: "Número de teléfono",
    remote: "Opción de adquisición remota automática",
    prohibitInput: "Prohibir la entrada cuando los datos de entrada no son válidos",
    hintShow: "Mostrar mensaje cuando se selecciona la celda",
    deleteVerification: "Eliminar verificación",
    tooltipInfo1: "La opción de la lista desplegable no puede estar vacía",
    tooltipInfo2: "El contenido de la casilla de verificación no puede estar vacío",
    tooltipInfo3: "El valor ingresado no es un tipo numérico",
    tooltipInfo4: "El segundo valor no puede ser menor que el primero",
    tooltipInfo5: "El contenido del texto no puede estar vacío",
    tooltipInfo6: "El valor ingresado no es una fecha",
    tooltipInfo7: "La segunda fecha no puede ser menor que la primera",
    textlengthInteger: "La longitud del texto debe ser un entero mayor o igual a 0"
  },
  formula: {
    sum: "Suma",
    average: "Media",
    count: "Contar",
    max: "Máx",
    min: "Mín",
    ifGenerate: "Generador de fórmula SI",
    find: "Aprender más",
    tipNotBelongToIf: "¡Esta función de celda no pertenece a la fórmula SI!",
    tipSelectCell: "Selecciona la celda para insertar la función",
    ifGenCompareValueTitle: "Valor de comparación",
    ifGenSelectCellTitle: "Haz click para seleccionar una celda",
    ifGenRangeTitle: "Rango",
    ifGenRangeTo: "a",
    ifGenRangeEvaluate: "Evaluar rango",
    ifGenSelectRangeTitle: "Haz click para seleccionar rango",
    ifGenCutWay: "Forma particionado",
    ifGenCutSame: "Mismo valor de particionado",
    ifGenCutNpiece: "Particionar por N",
    ifGenCutCustom: "Personalizado",
    ifGenCutConfirm: "Confirma",
    ifGenTipSelectCell: "Selecciona celdas",
    ifGenTipSelectCellPlace: "Por favor selecciona celdas",
    ifGenTipSelectRange: "Selecciona rango",
    ifGenTipSelectRangePlace: "Por favor selecciona rango",
    ifGenTipNotNullValue: "El valor de comparación no puede ser vacío!",
    ifGenTipLableTitile: "Etiqueta",
    ifGenTipRangeNotforNull: "El rango no puede quedar vacío!",
    ifGenTipCutValueNotforNull: "El valor de partición no puede ser vacío!",
    ifGenTipNotGenCondition: "No hay condiciones disponibles para la generación!"
  },
  formulaMore: {
    valueTitle: "Valor",
    tipSelectDataRange: "Selecciona rango de datos",
    tipDataRangeTile: "Rango de datos",
    findFunctionTitle: "Función de búsqueda",
    tipInputFunctionName: "Nombre o breve descripción de la función",
    Array: "Vector",
    Database: "Base de datos",
    Date: "Fecha",
    Engineering: "Ingeniería",
    Filter: "Filtro",
    Financial: "Financiero",
    luckysheet: "Luckysheet",
    other: "Otro",
    Logical: "Lógica",
    Lookup: "Búsqueda",
    Math: "Matemático",
    Operator: "Operadores",
    Parser: "Compilador",
    Statistical: "Estadístico",
    Text: "Texto",
    dataMining: "Minería de datos",
    selectFunctionTitle: "Selecciona una función",
    calculationResult: "Resultado",
    tipSuccessText: "Exito",
    tipParamErrorText: "Parámetro erróneo",
    helpClose: "Cerrar",
    helpCollapse: "Recoger",
    helpExample: "Ejemplo",
    helpAbstract: "Resumen",
    execfunctionError: "Error en la fórmula",
    execfunctionSelfError: "La fórmula no puede hacer referencia a su propia celda",
    execfunctionSelfErrorResult: "La fórmula no puede hacer referencia a su propia celda, lo que dará lugar a resultados de cálculo inexactos",
    allowRepeatText: "Repetir",
    allowOptionText: "Opción",
    selectCategory: "O selecciona una categoría"
  },
  drag: {
    noMerge: "No se puede realizar esta operación en celdas combinadas",
    afectarPivot: "¡Este cambio no se puede realizar en la celda seleccionada porque afectará a la tabla dinámica!",
    noMulti: "No se puede realizar esta operación en varias áreas de selección, selecciona una sola área",
    noPaste: "No se puede pegar este contenido aquí, selecciona una celda en el área de pegado e intenta pegar nuevamente",
    noPartMerge: "No se puede realizar esta operación en celdas parcialmente fusionadas",
    inputCorrect: "Introduce el valor correcto",
    notLessOne: "El número de filas y columnas no puede ser inferior a 1",
    offsetColumnLessZero: "¡La columna de desplazamiento no puede ser negativa!",
    pasteMustKeybordAlert: "在表格中进行复制粘贴: Ctrl + C 进行复制, Ctrl + V 进行粘贴, Ctrl + X 进行剪切",
    pasteMustKeybordAlertHTMLTitle: "在表格中进行复制粘贴",
    pasteMustKeybordAlertHTML: "<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;进行复制<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;进行粘贴<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;进行剪切"
  },
  pivotTable: {
    title: "Tabla Dinámica",
    closePannel: "Cerrar",
    editRange: "Rango",
    tipPivotFieldSelected: "Selecciona los campos",
    tipClearSelectedField: "Limpiar todos los campos",
    btnClearSelectedField: "Limpiar",
    btnFilter: "Filtrar",
    titleRow: "Fila",
    titleColumn: "Columna",
    titleValue: "Valor",
    tipShowColumn: "Los campos de estadísticas se muestran como columnas",
    tipShowRow: "Los campos de estadísticas se muestran como filas",
    titleSelectionDataRange: "Selecciona rango",
    titleDataRange: "Rango de datos",
    valueSum: "SUMA",
    valueStatisticsSUM: "Suma",
    valueStatisticsCOUNT: "Contar",
    valueStatisticsCOUNTA: "Contar A",
    valueStatisticsCOUNTUNIQUE: "Contar Distintos",
    valueStatisticsAVERAGE: "Media",
    valueStatisticsMAX: "Máx",
    valueStatisticsMIN: "Mín",
    valueStatisticsMEDIAN: "Mediana",
    valueStatisticsPRODUCT: "Producto",
    valueStatisticsSTDEV: "Desviación Estándar",
    valueStatisticsSTDEVP: "Stdevp",
    valueStatisticslet: "Varianza",
    valueStatisticsVARP: "VarP",
    errorNotAllowEdit: "¡Esta operación está prohibida en el modo sin edición!",
    errorNotAllowMulti: "No se puede realizar esta operación en varias áreas de selección, selecciona un solo rango y vuelve a intentarlo",
    errorSelectRange: "Seleccione el rango de la nueva tabla dinámica",
    errorIsDamage: "¡Los datos de origen de esta tabla dinámica están dañados!",
    errorNotAllowPivotData: "¡No se puede seleccionar la tabla dinámica como datos de origen!",
    errorSelectionRange: "¡La selección falló, rango de entrada incorrecto!",
    errorIncreaseRange: "¡Por favor, expande el rango seleccionado!",
    titleAddColumn: "Añadir columna a la tabla dinámica",
    titleMoveColumn: "Muever la columna a la celda en blanco de abajo",
    titleClearColumnFilter: "Quitar el filtro de esta columna",
    titleFilterColumn: "Filtro",
    titleSort: "Ordenar",
    titleNoSort: "No Ordenar",
    titleSortAsc: "ASC",
    titleSortDesc: "DESC",
    titleSortBy: "Ordenar por",
    titleShowSum: "Mostrar total",
    titleStasticTrue: "Sí",
    titleStasticFalse: "No"
  },
  dropCell: {
    copyCell: "Copiar",
    sequence: "Secuencia",
    onlyFormat: "Solo formato",
    noFormat: "Sin formato",
    day: "Día",
    workDay: "Día Laborable",
    month: "Mes",
    year: "Año",
    chineseNumber: "Números Chinos"
  },
  imageCtrl: {
    borderTile: "Color de borde de imagen",
    borderCur: "Color"
  },
  protection: {
    protectiontTitle: "Protección",
    enterPassword: "Introduce una contraseña (opcional)",
    enterHintTitle: "Preguntar cuando la edición está prohibida (opcional)",
    enterHint: "La celda o el gráfico que estás intentando cambiar se encuentra en una hoja de trabajo protegida. Si quieres cambiarlo, desprotege la hoja de trabajo. Es posible que tengas que ingresar una contraseña",
    swichProtectionTip: "Protege la hoja y el contenido de las celdas bloqueadas",
    authorityTitle: "Permitir a los usuarios de esta hoja:",
    selectLockedCells: "Selecciona celdas bloqueadas",
    selectunLockedCells: "Selecciona celdas desbloqueadas",
    formatCells: "Formatear celdas",
    formatColumns: "Formatear columnas",
    formatRows: "Formatear filas",
    insertColumns: "Insertar columnas",
    insertRows: "Insertar filas",
    insertHyperlinks: "Insertar enlaces",
    deleteColumns: "Eliminar columnas",
    deleteRows: "Eliminar filas",
    sort: "Ordenar",
    filter: "Filtrar",
    usePivotTablereports: "Usar informes de tabla dinámica",
    editObjects: "Editar objetos",
    editScenarios: "Editar escenarios",
    allowRangeTitle: "Permitir a los usuarios del rango:",
    allowRangeAdd: "Nuevo...",
    allowRangeAddTitle: "Título",
    allowRangeAddSqrf: "Referencia",
    selectCellRange: "Haz clic para seleccionar un rango de celdas",
    selectCellRangeHolder: "Rango de celdas",
    allowRangeAddTitlePassword: "Contraseña",
    allowRangeAddTitleHint: "Pregunta",
    allowRangeAddTitleHintTitle: "Preguntar cuando hay una contraseña (opcional)",
    allowRangeAddtitleDefault: "Nombre del rango de entrada",
    rangeItemDblclick: "Haz doble clic para editar",
    rangeItemHasPassword: "Tiene contraseña",
    rangeItemErrorTitleNull: "El título es nulo",
    rangeItemErrorRangeNull: "La referencia es nula",
    rangeItemErrorRange: "La reference tiene un error",
    validationTitle: "Validación de contraseña",
    validationTips: "Hay que ingresar una contraseña para desbloquear la protección de la hoja de trabajo",
    validationInputHint: "Introduce una contraseña",
    checkPasswordNullalert: "Contraseña requerida!",
    checkPasswordWrongalert: "¡Contraseña incorrecta. Por favor, prueba de nuevo!",
    checkPasswordSucceedalert: "Desbloqueo conseguido!",
    defaultRangeHintText: "La celda está protegida con contraseña.",
    defaultSheetHintText: "La celda o el gráfico están en una hoja de trabajo protegida. Para realizar cambios, desprotege la hoja de trabajo. Es posible que tengas que ingresar una contraseña"
  },
  cellFormat: {
    cellFormatTitle: "Formatear celdas",
    protection: "Protección",
    locked: "Bloqueado",
    hidden: "Escondido",
    protectionTips: "Para bloquear celdas u ocultar fórmulas, protege la hoja de trabajo. En la barra de herramientas, haz clic en el botón Proteger hoja",
    tipsPart: "Comprobado parcial",
    tipsAll: "Todo seleccionado",
    selectionIsNullAlert: "Se requiere una selección!",
    sheetDataIsNullAlert: "error, no hay datos!"
  },
  print: {
    normalBtn: "Normal",
    layoutBtn: "Disposición de página",
    pageBtn: "Previsualización de saltos de página",
    menuItemPrint: "Imprimir (Ctrl+P)",
    menuItemAreas: "Imprimir áreas",
    menuItemRows: "Imprimir títulos de filas",
    menuItemColumns: "Imprimir títulos de columnas"
  },
  edit: {
    typing: "mecanografía"
  },
  websocket: {
    success: "Éxito de la conexión de WebSocket",
    refresh: "Se produjo un error en la conexión de WebSocket, ¡actualice la página!",
    wait: "Se produjo un error en la conexión de WebSocket, ¡tenga paciencia!",
    close: "Conexión WebSocket cerrada",
    contact: "Ocurrió un error de comunicación con el servidor, actualice la página y vuelva a intentarlo; de lo contrario, comuníquese con el administrador.",
    support: "El navegador actual no es compatible con WebSocket"
  }
};

var hi = {
  generalDialog: {
    partiallyError: "आंशिक रूप से विलय किए गए सेल पर यह कार्य नहीं किया जा सकता",
    readOnlyError: "पठन मोड में यह कार्य नहीं किया जा सकता",
    dataNullError: "डेटा जो मौजूद नहीं है उस पर यह कार्य नहीं किया जा सकता",
    noSeletionError: "चयन कार्य अभी तक नहीं किया गया है",
    cannotSelectMultiple: "एकाधिक चयन नहीं किया जा सकता"
  },
  functionlist: [{
    n: "SUMIF",
    t: 0,
    d: "Returns a conditional sum across a range.",
    a: "A conditional sum across a range.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The range which is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sum_range",
      detail: "The range to be summed, if different from `range`.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TAN",
    t: 0,
    d: "Returns the tangent of an angle provided in radians.",
    a: "Tangent of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the tangent of, in radians.",
      example: "45*PI()/180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TANH",
    t: 0,
    d: "Returns the hyperbolic tangent of any real number.",
    a: "Hyperbolic tangent of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic tangent of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CEILING",
    t: 0,
    d: "Rounds a number up to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number up to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round up to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN",
    t: 0,
    d: "Returns the inverse tangent of a value, in radians.",
    a: "Inverse tangent of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse tangent.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ASINH",
    t: 0,
    d: "Returns the inverse hyperbolic sine of a number.",
    a: "Inverse hyperbolic sine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic sine.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ABS",
    t: 0,
    d: "Returns the absolute value of a number.",
    a: "Absolute value of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number of which to return the absolute value.",
      example: "-2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOS",
    t: 0,
    d: "Returns the inverse cosine of a value, in radians.",
    a: "Inverse cosine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse cosine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOSH",
    t: 0,
    d: "Returns the inverse hyperbolic cosine of a number.",
    a: "Inverse hyperbolic cosine of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTINOMIAL",
    t: 0,
    d: "Returns the factorial of the sum of values divided by the product of the values' factorials.",
    a: "Multinomial distribution function.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "ATANH",
    t: 0,
    d: "Returns the inverse hyperbolic tangent of a number.",
    a: "Inverse hyperbolic tangent of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN2",
    t: 0,
    d: "Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (`x`,`y`), in radians.",
    a: "Arctangent of a value.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "y",
      detail: "The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTBLANK",
    t: 1,
    d: "Returns the number of empty values in a list of values and ranges.",
    a: "Number of empty values.",
    m: [1, 1],
    p: [{
      name: "value1",
      detail: "The first value or range in which to count the number of blanks.",
      example: "A2:C100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "COSH",
    t: 0,
    d: "Returns the hyperbolic cosine of any real number.",
    a: "Hyperbolic cosine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic cosine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INT",
    t: 0,
    d: "Rounds a number down to the nearest integer that is less than or equal to it.",
    a: "Rounds number down to nearest integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISEVEN",
    t: 0,
    d: "Checks whether the provided value is even.",
    a: "Whether the provided value is even.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as even.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISODD",
    t: 0,
    d: "Checks whether the provided value is odd.",
    a: "Whether the provided value is odd.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as odd.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LCM",
    t: 0,
    d: "Returns the least common multiple of one or more integers.",
    a: "Least common multiple of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the least common multiple.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the least common multiple.",
      example: "3",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LN",
    t: 0,
    d: "Returns the logarithm of a number, base e (Euler's number).",
    a: "The logarithm of a number, base e (euler's number).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base e.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG",
    t: 0,
    d: "Returns the logarithm of a number with respect to a base.",
    a: "The logarithm of a number with respect to a base.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm.",
      example: "128",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "base",
      detail: "The base to use for calculation of the logarithm.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG10",
    t: 0,
    d: "Returns the logarithm of a number, base 10.",
    a: "The logarithm of a number, base 10.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the logarithm, base 10.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MOD",
    t: 0,
    d: "Returns the result of the modulo operator, the remainder after a division operation.",
    a: "Modulo (remainder) operator.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided to find the remainder.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MROUND",
    t: 0,
    d: "Rounds one number to the nearest integer multiple of another.",
    a: "Rounds a number to the nearest integer multiple.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The number to round to the nearest integer multiple of another.",
      example: "21",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ODD",
    t: 0,
    d: "Rounds a number up to the nearest odd integer.",
    a: "Rounds a number up to the nearest odd integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest odd number.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMSQ",
    t: 0,
    d: "Returns the sum of the squares of a series of numbers and/or cells.",
    a: "Sum of squares.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range whose squares to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges whose squares to add to the square(s) of `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMBIN",
    t: 0,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects.",
    a: "Number of combinations from a set of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUM",
    t: 0,
    d: "Returns the sum of a series of numbers and/or cells.",
    a: "Sum of a series of numbers and/or cells.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first number or range to add together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional numbers or ranges to add to `value1`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SUBTOTAL",
    t: 0,
    d: "Returns a subtotal for a vertical range of cells using a specified aggregation function.",
    a: "Subtotal for a range using a specific function.",
    m: [2, 256],
    p: [{
      name: "function_code",
      detail: "The function to use in subtotal aggregation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range1",
      detail: "The first range over which to calculate a subtotal.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "range2",
      detail: "Additional ranges over which to calculate subtotals.",
      example: "B2:B8",
      require: "o",
      repeat: "y",
      type: "range"
    }]
  }, {
    n: "ASIN",
    t: 0,
    d: "Returns the inverse sine of a value, in radians.",
    a: "Inverse sine of a value, in radians.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse sine. Must be between `-1` and `1`, inclusive.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTIF",
    t: 1,
    d: "Returns a conditional count across a range.",
    a: "A conditional count across a range.",
    m: [2, 2],
    p: [{
      name: "range",
      detail: "The range that is tested against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RADIANS",
    t: 0,
    d: "Converts an angle value in degrees to radians.",
    a: "Converts an angle value in degrees to radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from degrees to radians.",
      example: "180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RAND",
    t: 0,
    d: "Returns a random number between 0 inclusive and 1 exclusive.",
    a: "A random number between 0 inclusive and 1 exclusive.",
    m: [0, 0],
    p: []
  }, {
    n: "COUNTUNIQUE",
    t: 0,
    d: "Counts the number of unique values in a list of specified values and ranges.",
    a: "Counts number of unique values in a range.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider for uniqueness.",
      example: "A1:C100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider for uniqueness.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DEGREES",
    t: 0,
    d: "Converts an angle value in radians to degrees.",
    a: "Converts an angle value in radians to degrees.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to convert from radians to degrees.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ERFC",
    t: 9,
    d: "Returns the complementary Gauss error function of a value.",
    a: "Complementary gauss error function of a value.",
    m: [1, 1],
    p: [{
      name: "z",
      detail: "The number for which to calculate the complementary Gauss error function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVEN",
    t: 0,
    d: "Rounds a number up to the nearest even integer.",
    a: "Rounds a number up to the nearest even integer.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to round to the next greatest even number.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EXP",
    t: 0,
    d: "Returns Euler's number, e (~2.718) raised to a power.",
    a: "Euler's number, e (~2.718) raised to a power.",
    m: [1, 1],
    p: [{
      name: "exponent",
      detail: "The exponent to raise e to.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACT",
    t: 0,
    d: "Returns the factorial of a number.",
    a: "Factorial of a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose factorial will be calculated and returned.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACTDOUBLE",
    t: 0,
    d: 'Returns the "double factorial" of a number.',
    a: '"double factorial" of a number.',
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number or reference to a number whose double factorial will be calculated and returned.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PI",
    t: 0,
    d: "Returns the value of Pi to 14 decimal places.",
    a: "The number pi.",
    m: [0, 0],
    p: []
  }, {
    n: "FLOOR",
    t: 0,
    d: "Rounds a number down to the nearest integer multiple of specified significance `factor`.",
    a: "Rounds number down to nearest multiple of a factor.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round down to the nearest integer multiple of `factor`.",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The number to whose multiples `value` will be rounded.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GCD",
    t: 0,
    d: "Returns the greatest common divisor of one or more integers.",
    a: "Greatest common divisor of one or more integers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range whose factors to consider in a calculation to find the greatest common divisor.",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges whose factors to consider to find the greatest common divisor.",
      example: "96",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANDBETWEEN",
    t: 0,
    d: "Returns a uniformly random integer between two values, inclusive.",
    a: "Random integer between two values, inclusive.",
    m: [2, 2],
    p: [{
      name: "low",
      detail: "The low end of the random range.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high",
      detail: "The high end of the random range.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUND",
    t: 0,
    d: "Rounds a number to a certain number of decimal places according to standard rules.",
    a: "Rounds a number according to standard rules.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDDOWN",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding down to the next valid increment.",
    a: "Rounds down a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding down.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDUP",
    t: 0,
    d: "Rounds a number to a certain number of decimal places, always rounding up to the next valid increment.",
    a: "Rounds up a number.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to round to `places` number of places, always rounding up.",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of decimal places to which to round.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SERIESSUM",
    t: 0,
    d: "Given parameters `x`, `n`, `m`, and `a`, returns the power series sum a",
    a: "Sum of a power series.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the power series. Varies depending on the type of approximation, may be angle, exponent, or some other value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The initial power to which to raise `x` in the power series.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "m",
      detail: "The additive increment by which to increase `x`.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "a",
      detail: "The array or range containing the coefficients of the power series.",
      example: "{FACT(0)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIGN",
    t: 0,
    d: "Given an input number, returns `-1` if it is negative, `1` if positive, and `0` if it is zero.",
    a: "Sign of a provided number (+/-/0).",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose sign will be evaluated.",
      example: "-42",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIN",
    t: 0,
    d: "Returns the sine of an angle provided in radians.",
    a: "Sine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the sine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SINH",
    t: 0,
    d: "Returns the hyperbolic sine of any real number.",
    a: "Hyperbolic sine of any real number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Any real value to calculate the hyperbolic sine of.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRT",
    t: 0,
    d: "Returns the positive square root of a positive number.",
    a: "Positive square root of a positive number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number for which to calculate the positive square root.",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRTPI",
    t: 0,
    d: "Returns the positive square root of the product of Pi and the given positive number.",
    a: "Square root of the product of pi and number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The number which will be multiplied by Pi and have the product's square root returned",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GAMMALN",
    t: 1,
    d: "Returns the logarithm of a specified Gamma function, base e (Euler's number).",
    a: "Logarithm of gamma function.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The input to the Gamma function. The natural logarithm of Gamma(`value`) will be returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COS",
    t: 0,
    d: "Returns the cosine of an angle provided in radians.",
    a: "Cosine of an angle provided in radians.",
    m: [1, 1],
    p: [{
      name: "angle",
      detail: "The angle to find the cosine of, in radians.",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRUNC",
    t: 0,
    d: "Truncates a number to a certain number of significant digits by omitting less significant digits.",
    a: "Truncates a number.",
    m: [1, 2],
    p: [{
      name: "value",
      detail: "The value to be truncated.",
      example: "3.141592654",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "The number of significant digits to the right of the decimal point to retain.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUOTIENT",
    t: 0,
    d: "Returns one number divided by another.",
    a: "One number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POWER",
    t: 0,
    d: "Returns a number raised to a power.",
    a: "A number raised to a power.",
    m: [2, 2],
    p: [{
      name: "base",
      detail: "The number to raise to the `exponent` power.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "exponent",
      detail: "The exponent to raise `base` to.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMIFS",
    t: 0,
    d: "Returns the sum of a range depending on multiple criteria.",
    a: "Sums a range depending on multiple criteria.",
    m: [3, 257],
    p: [{
      name: "sum_range",
      detail: "The range to sum.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criteria_range1",
      detail: "The range to check against criterion1.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to criteria_range1.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTIFS",
    t: 1,
    d: "Returns the count of a range depending on multiple criteria.",
    a: "Count values depending on multiple criteria.",
    m: [2, 256],
    p: [{
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " B1:B10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PRODUCT",
    t: 0,
    d: "Returns the result of multiplying a series of numbers together.",
    a: "Result of multiplying a series of numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "More numbers or ranges to calculate for the product.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HARMEAN",
    t: 1,
    d: "Calculates the harmonic mean of a dataset.",
    a: "The harmonic mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HYPGEOMDIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes in a certain number of tries given a population of a certain size containing a certain number of successes, without replacement of draws.",
    a: "Hypergeometric distribution probability.",
    m: [5, 5],
    p: [{
      name: "num_successes",
      detail: "The desired number of successes.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_draws",
      detail: "The number of permitted draws.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "successes_in_pop",
      detail: "The total number of successes in the population.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The total size of the population",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf cumulative is TRUE(), HYPGEOM.DIST returns the cumulative distribution function;\n\nif FALSE(), it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INTERCEPT",
    t: 1,
    d: "Calculates the y-value at which the line resulting from linear regression of a dataset will intersect the y-axis (x=0).",
    a: "Y-intercept of line derived via linear regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "KURT",
    t: 1,
    d: 'Calculates the kurtosis of a dataset, which describes the shape, and in particular the "peakedness" of that dataset.',
    a: "Kurtosis of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LARGE",
    t: 1,
    d: "Returns the nth largest element from a data set, where n is user-defined.",
    a: "Nth largest element from a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "The rank from largest to smallest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVA",
    t: 1,
    d: "Calculates the standard deviation based on a sample, setting text to the value `0`.",
    a: "Standard deviation of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVP",
    t: 1,
    d: "Calculates the standard deviation based on an entire population.",
    a: "Standard deviation of an entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "GEOMEAN",
    t: 1,
    d: "Calculates the geometric mean of a dataset.",
    a: "The geometric mean of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANK_EQ",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the top rank of the entries will be returned.",
    a: "Top rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANK_AVG",
    t: 1,
    d: "Returns the rank of a specified value in a dataset. If there is more than one entry of the same value in the dataset, the average rank of the entries will be returned.",
    a: "Average rank of a specified value in a dataset.",
    m: [2, 3],
    p: [{
      name: "value",
      detail: "The value whose rank will be determined.",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "is_ascending",
      detail: "Whether to consider the values in `data` in descending or ascending order. If omitted, the default is descending (FALSE).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERCENTRANK_EXC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 exclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 exclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTRANK_INC",
    t: 1,
    d: "Returns the percentage rank (percentile) from 0 to 1 inclusive of a specified value in a dataset.",
    a: "Percentage rank (percentile) from 0 to 1 inclusive.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value",
      detail: "The value whose percentage rank will be determined.",
      example: " A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant figures to use in the calculation. Default is 3.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FORECAST",
    t: 1,
    d: "Calculates the expected y-value for a specified x based on a linear regression of a dataset.",
    a: "Expected y-value based of linear regression.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The value on the x-axis to forecast.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHERINV",
    t: 1,
    d: "Returns the inverse Fisher transformation of a specified value.",
    a: "Inverse fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the inverse Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHER",
    t: 1,
    d: "Returns the Fisher transformation of a specified value.",
    a: "Fisher transformation of a specified value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value for which to calculate the Fisher transformation.",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MODE_SNGL",
    t: 1,
    d: "Returns the most commonly occurring value in a dataset.",
    a: "Most commonly occurring value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating mode.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating mode.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "WEIBULL_DIST",
    t: 1,
    d: "Returns the value of the Weibull distribution function (or Weibull cumulative distribution function) for a specified shape and scale.",
    a: "Weibull distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the Weibull distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "shape",
      detail: "The shape parameter of the Weibull distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "scale",
      detail: "The scale parameter of the Weibull distribution function.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the cumulative distribution function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COUNT",
    t: 1,
    d: "Returns the number of numeric values in a dataset.",
    a: "The number of numeric values in dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTA",
    t: 1,
    d: "Returns the number of values in a dataset.",
    a: "The number of values in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when counting.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when counting.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVEDEV",
    t: 1,
    d: "Calculates the average of the magnitudes of deviations of data from a dataset's mean.",
    a: "Average magnitude of deviations from mean.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "AVERAGE",
    t: 1,
    d: "Returns the numerical average value in a dataset, ignoring text.",
    a: "Numerical average value in a dataset, ignoring text.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEA",
    t: 1,
    d: "Returns the numerical average value in a dataset.",
    a: "Numerical average value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the average value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the average value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of successes (or a maximum number of successes) in a certain number of tries given a population of a certain size containing a certain number of successes, with replacement of draws.",
    a: "Binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_successes",
      detail: "The number of successes for which to calculate the probability in `num_trials` trials.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the binomial cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_INV",
    t: 1,
    d: "Calculates the smallest value for which the cumulative binomial distribution is greater than or equal to a specified criteria.",
    a: "Inverse cumulative binomial distribution function.",
    m: [3, 3],
    p: [{
      name: "num_trials",
      detail: "The number of independent trials.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "target_prob",
      detail: "The desired threshold probability.",
      example: "0.8",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONFIDENCE_NORM",
    t: 1,
    d: "Calculates the width of half the confidence interval for a normal distribution.",
    a: "Confidence interval for a normal distribution.",
    m: [3, 3],
    p: [{
      name: "alpha",
      detail: "One minus the desired confidence level. E.g. `0.1` for `0.9`, or 90%, confidence.",
      example: "0.05",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the population.",
      example: "1.6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pop_size",
      detail: "The size of the population.",
      example: "250",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CORREL",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_P",
    t: 1,
    d: "Calculates the covariance of a dataset.",
    a: "The covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_S",
    t: 1,
    d: "Calculates the sample covariance of a dataset.",
    a: "The sample covariance of a dataset.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEVSQ",
    t: 1,
    d: "Calculates the sum of squares of deviations based on a sample.",
    a: "The sum of squares of deviations based on a sample.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "EXPON_DIST",
    t: 1,
    d: "Returns the value of the exponential distribution function with a specified lambda at a specified value.",
    a: "Exponential distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the exponential distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "lambda",
      detail: "The lambda to specify the exponential distribution function.",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the exponential cumulative distribution.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIF",
    t: 1,
    d: "Returns the average of a range depending on criteria.",
    a: "Average of values depending on criteria.",
    m: [2, 3],
    p: [{
      name: "criteria_range",
      detail: "The range to check against `criterion`.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion",
      detail: "The pattern or test to apply to `criteria_range`.",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "average_range",
      detail: "The range to average. If not included, `criteria_range` is used for the average instead.",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIFS",
    t: 1,
    d: "Returns the average of a range depending on multiple criteria.",
    a: "Average of values depending on multiple criteria.",
    m: [2, 255],
    p: [{
      name: "average_range",
      detail: "The range to average.",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range1",
      detail: "The range to check against `criterion1`.",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion1",
      detail: "The pattern or test to apply to `criteria_range1`.",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2",
      detail: "Additional ranges to check.",
      example: " C1:C10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERMUT",
    t: 1,
    d: "Returns the number of ways to choose some number of objects from a pool of a given size of objects, considering order.",
    a: "Number of permutations from a number of objects.",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "The size of the pool of objects to choose from.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "The number of objects to choose.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRIMMEAN",
    t: 1,
    d: "Calculates the mean of a dataset excluding some proportion of data from the high and low ends of the dataset.",
    a: "Mean of a dataset excluding high/low ends.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "exclude_proportion",
      detail: "The proportion of the dataset to exclude, from the extremities of the set.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_EXC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset exclusive of 0 and 1.",
    a: "Value at a given percentile of a dataset exclusive of 0 and 1.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile, exclusive of 0 and 1, whose value within 'data' will be calculated and returned.",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_INC",
    t: 1,
    d: "Returns the value at a given percentile of a dataset.",
    a: "Value at a given percentile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "percentile",
      detail: "The percentile whose value within `data` will be calculated and returned.`",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PEARSON",
    t: 1,
    d: "Calculates r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Pearson Product-Moment Correlation Coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_INV",
    t: 1,
    d: "Returns the value of the inverse standard normal distribution function for a specified value.",
    a: "Inverse standard normal distribution function.",
    m: [1, 1],
    p: [{
      name: "x",
      detail: "The input to the inverse standard normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_DIST",
    t: 1,
    d: "Returns the value of the standard normal cumulative distribution function for a specified value.",
    a: "Standard normal cumulative distribution function.",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the standard normal cumulative distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NORM_INV",
    t: 1,
    d: "Returns the value of the inverse normal distribution function for a specified value, mean, and standard deviation.",
    a: "Inverse normal distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse normal distribution function.",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_DIST",
    t: 1,
    d: "Returns the value of the normal distribution function (or normal cumulative distribution function) for a specified value, mean, and standard deviation.",
    a: "Normal distribution function.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the normal distribution function.",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the normal distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the normal distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the normal cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NEGBINOM_DIST",
    t: 1,
    d: "Calculates the probability of drawing a certain number of failures before a certain number of successes given a probability of success in independent trials.",
    a: "Negative binomial distribution probability.",
    m: [4, 4],
    p: [{
      name: "num_failures",
      detail: "The number of failures to model.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_successes",
      detail: "The number of successes to model.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "prob_success",
      detail: "The probability of success in any given trial.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINA",
    t: 1,
    d: "Returns the minimum numeric value in a dataset.",
    a: "Minimum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MIN",
    t: 1,
    d: "Returns the minimum value in a numeric dataset.",
    a: "Minimum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the minimum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the minimum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MEDIAN",
    t: 1,
    d: "Returns the median value in a numeric dataset.",
    a: "Median value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the median value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the median value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAXA",
    t: 1,
    d: "Returns the maximum numeric value in a dataset.",
    a: "Maximum numeric value in a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAX",
    t: 1,
    d: "Returns the maximum value in a numeric dataset.",
    a: "Maximum value in a numeric dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range to consider when calculating the maximum value.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to consider when calculating the maximum value.",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_INV",
    t: 1,
    d: "Returns the value of the inverse log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Inverse log-normal cumulative distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the inverse log-normal cumulative distribution function.",
      example: "0.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the inverse log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the inverse log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_DIST",
    t: 1,
    d: "Returns the value of the log-normal cumulative distribution with given mean and standard deviation at a specified value.",
    a: "Log-normal cumulative distribution probability.",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the log-normal cumulative distribution function.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation (sigma) of the log-normal cumulative distribution function.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Determine the logical value of the function form. \n\nIf TRUE(), it returns the cumulative distribution function;\n\nIf it is FALSE(), it returns the probability density function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "Z_TEST",
    t: 1,
    d: "Returns the one-tailed p-value of a Z-test with standard distribution.",
    a: "One-tailed p-value of a z-test.",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "value",
      detail: "The test statistic to use in the Z-test.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation to assume for the Z-test. If this is not provided, the standard deviation of the data will be used.",
      example: "3",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PROB",
    t: 1,
    d: "Given a set of values and corresponding probabilities, calculates the probability that a value chosen at random falls between two limits.",
    a: "Probability values lie in a range.",
    m: [3, 4],
    p: [{
      name: "data",
      detail: "Array or range containing the dataset to consider.",
      example: "A3:A6",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "probabilities",
      detail: "Array or range containing probabilities corresponding to `data`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "low_limit",
      detail: "The lower bound on the value range for which to calculate the probability.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "high_limit",
      detail: "The upper bound on the value range for which to calculate the probability.",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_EXC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset exclusive of 0 and 4.",
    a: "Value nearest to a specific quartile of a dataset exclusive of 0 and 4.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_INC",
    t: 1,
    d: "Returns a value nearest to a specified quartile of a dataset.",
    a: "Value nearest to a specific quartile of a dataset.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quartile_number",
      detail: "Which quartile value to return.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POISSON_DIST",
    t: 1,
    d: "Returns the value of the Poisson distribution function (or Poisson cumulative distribution function) for a specified value and mean.",
    a: "Poisson distribution function.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the Poisson distribution function.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean (mu) of the Poisson distribution function.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Whether to use the Poisson cumulative distribution function rather than the distribution function.",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RSQ",
    t: 1,
    d: "Calculates the square of r, the Pearson product-moment correlation coefficient of a dataset.",
    a: "Square of the correlation coefficient.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST",
    t: 1,
    d: "Calculates the left tail probability for a Student's t-distribution with a given input (x).",
    a: "The left-tailed Student's t-distribution",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T_DIST_2T",
    t: 1,
    d: "Calculates the probability for two tailed Student's t-distribution with a given input (x).",
    a: "The two tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST_RT",
    t: 1,
    d: "Calculates the right tail probability for a Student's t-distribution with a given input (x).",
    a: "The right-tailed Student's t-distribution",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "The input to the t-distribution function.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV",
    t: 1,
    d: "Calculates the negative inverse of the one-tailed TDIST function.",
    a: "T.INV",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV_2T",
    t: 1,
    d: "Calculates the inverse of the two-tailed TDIST function.",
    a: "T.INV.2T",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "The probability associated with the two-tailed t-distribution.",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "The number of degrees of freedom.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_TEST",
    t: 1,
    d: "t-test. Returns the probability associated with Student's t-test. Determines whether two samples are likely to have come from the same two underlying populations that have the same mean.",
    a: "Returns the probability associated with t-test.",
    m: [4, 4],
    p: [{
      name: "range1",
      detail: "The first sample of data or group of cells to consider for the t-test.",
      example: "A1:A4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "range2",
      detail: "The second sample of data or group of cells to consider for the t-test.",
      example: "B1:B4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "Specifies the number of distribution tails.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "Specifies the type of t-test.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "F_DIST",
    t: 1,
    d: "Calculates the left-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution (left-tailed).",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "Logical value that determines the form of the function.",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "F_DIST_RT",
    t: 1,
    d: "Calculates the right-tailed F probability distribution (degree of diversity) for two data sets with given input x. Alternately called Fisher-Snedecor distribution or Snedecor's F distribution.",
    a: "F probability distribution.",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "The input to the F probability distribution function. The value at which to evaluate the function.",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "The numerator of the number of degrees of freedom.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "The denominator of the number of degrees of freedom.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_P",
    t: 1,
    d: "Calculates the variance based on an entire population.",
    a: "Variance of entire population.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_S",
    t: 1,
    d: "Calculates the variance based on a sample.",
    a: "Variance.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARA",
    t: 1,
    d: "Calculates the variance based on a sample, setting text to the value `0`.",
    a: "Variance of sample (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the sample.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the sample.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARPA",
    t: 1,
    d: "Calculates the variance based on an entire population, setting text to the value `0`.",
    a: "Variance of entire population (text as 0).",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the population.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the population.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STEYX",
    t: 1,
    d: "Calculates the standard error of the predicted y-value for each x in the regression of a dataset.",
    a: "Standard error of predicted y-values in regression.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STANDARDIZE",
    t: 1,
    d: "Calculates the normalized equivalent of a random variable given mean and standard deviation of the distribution.",
    a: "Normalized equivalent of a random variable.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The value of the random variable to normalize.",
      example: "96",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "The mean of the distribution.",
      example: "80",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_deviation",
      detail: "The standard deviation of the distribution.",
      example: "6.7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SMALL",
    t: 1,
    d: "Returns the nth smallest element from a data set, where n is user-defined.",
    a: "Nth smallest element in a data set.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the dataset to consider.",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "n",
      detail: "The rank from smallest to largest of the element to return.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLOPE",
    t: 1,
    d: "Calculates the slope of the line resulting from linear regression of a dataset.",
    a: "Slope of line from linear regression of data.",
    m: [2, 2],
    p: [{
      name: "data_y",
      detail: "The range representing the array or matrix of dependent data.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "data_x",
      detail: "The range representing the array or matrix of independent data.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SKEW",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean.",
    a: "Skewness of a dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SKEW_P",
    t: 1,
    d: "Calculates the skewness of a dataset, which describes the symmetry of that dataset about the mean. This assumes the dataset is for the population.",
    a: "Skewness of a population's dataset.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first value or range of the dataset.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional values or ranges to include in the dataset.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "VLOOKUP",
    t: 2,
    d: "Vertical lookup. Searches down the first column of a range for a key and returns the value of a specified cell in the row found.",
    a: "Vertical lookup.",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first column in the range is searched for the key specified in `search_key`.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The column index of the value to be returned, where the first column in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the column to be searched (the first column of the specified range) is sorted, in which case the closest match for `search_key` will be returned.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HLOOKUP",
    t: 2,
    d: "Horizontal lookup. Searches across the first row of a range for a key and returns the value of a specified cell in the column found.",
    a: "Horizontal lookup",
    m: [3, 4],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The range to consider for the search. The first row in the range is searched for the key specified in `search_key`.",
      example: "A2:Z6",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "index",
      detail: "The row index of the value to be returned, where the first row in `range` is numbered 1.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_sorted",
      detail: "Indicates whether the row to be searched (the first row of the specified range) is sorted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOOKUP",
    t: 2,
    d: "Looks through a sorted row or column for a key and returns the value of the cell in a result range located in the same position as the search row or column.",
    a: "Look up a value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for in the row or column. For example, `42`, `"Cats"`, or `I24`.',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_range|search_result_array",
      detail: "One method of using this function is to provide a single sorted row or column `search_range` to look through for the `search_key` with a second argument `result_range`. The other way is to combine these two arguments into one `search_result_array` where the first row or column is searched and a value is returned from the last row or column in the array. If `search_key` is not found, a non-exact match may be returned.",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "result_range",
      detail: "The range from which to return a result. The value returned corresponds to the location where `search_key` is found in `search_range`. This range must be only a single row or column and should not be used if using the `search_result_array` method.",
      example: "B1:B100",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADDRESS",
    t: 2,
    d: "Returns a cell reference as a string.",
    a: "Cell reference as a string.",
    m: [2, 5],
    p: [{
      name: "row",
      detail: "The row number of the cell reference",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The column number (not name) of the cell reference. `A` is column number `1`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "absolute_relative_mode",
      detail: "An indicator of whether the reference is row/column absolute. `1` is row and column absolute (e.g. $A$1), `2` is row absolute and column relative (e.g. A$1), `3` is row relative and column absolute (e.g. $A1), and `4` is row and column relative (e.g. A1).",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "use_a1_notation",
      detail: "A boolean indicating whether to use `A1` style notation (TRUE) or `R1C1` style notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sheet",
      detail: "Text indicating the name of the sheet into which the address points.",
      example: '"Sheet2"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INDIRECT",
    t: 2,
    d: "Returns a cell reference specified by a string.",
    a: "A cell reference specified by a string.",
    m: [1, 2],
    p: [{
      name: "cell_reference_as_string",
      detail: "A cell reference, written as a string with surrounding quotation marks.",
      example: '"Sheet2!"&B10',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "is_A1_notation",
      detail: "Indicates if the cell reference is in A1 notation (TRUE) or R1C1 notation (FALSE).",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROW",
    t: 2,
    d: "Returns the row number of a specified cell.",
    a: "Row number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose row number will be returned.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROWS",
    t: 2,
    d: "Returns the number of rows in a specified array or range.",
    a: "Number of rows in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose row count will be returned.",
      example: "A9:A62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COLUMN",
    t: 2,
    d: "Returns the column number of a specified cell, with `A=1`.",
    a: "Column number of a specified cell.",
    m: [0, 1],
    p: [{
      name: "cell_reference",
      detail: "The cell whose column number will be returned. Column `A` corresponds to `1`.",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNS",
    t: 2,
    d: "Returns the number of columns in a specified array or range.",
    a: "Number of columns in a specified array or range.",
    m: [1, 1],
    p: [{
      name: "range",
      detail: "The range whose column count will be returned.",
      example: "A9:W62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OFFSET",
    t: 2,
    d: "Returns a range reference shifted a specified number of rows and columns from a starting cell reference.",
    a: "A range reference offset relative to a cell.",
    m: [3, 5],
    p: [{
      name: "cell_reference",
      detail: "The starting point from which to count the offset rows and columns.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "offset_rows",
      detail: "The number of rows to offset by.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "offset_columns",
      detail: "The number of columns to offset by.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "height",
      detail: "The height of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "width",
      detail: "The width of the range to return starting at the offset target.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MATCH",
    t: 2,
    d: "Returns the relative position of an item in a range that matches a specified value.",
    a: "Position of item in range that matches value.",
    m: [2, 3],
    p: [{
      name: "search_key",
      detail: 'The value to search for. For example, `42`, `"Cats"`, or `I24`.',
      example: '"Sunday"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "range",
      detail: "The one-dimensional array to be searched.",
      example: "A2:A9",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "search_type",
      detail: "The search method. `1` (default) finds the largest value less than or equal to `search_key` when `range` is sorted in ascending order. `0` finds the exact value when `range` is unsorted. `-1` finds the smallest value greater than or equal to `search_key` when `range` is sorted in descending order.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INDEX",
    t: 2,
    d: "Returns the content of a cell, specified by row and column offset.",
    a: "Content of cell specified by row and column offset.",
    m: [2, 3],
    p: [{
      name: "reference",
      detail: "The array of cells to be offset into.",
      example: "A1:C20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "row",
      detail: "The number of offset rows.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column",
      detail: "The number of offset columns.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GETPIVOTDATA",
    t: 2,
    d: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    a: "Extracts an aggregated value from a pivot table that corresponds to the specified row and column headings.",
    m: [2, 254],
    p: [{
      name: "value_name",
      detail: "The name of the value in the pivot table for which you want to get data.",
      example: '"SUM of number of units"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "any_pivot_table_cell",
      detail: "Any reference to a cell in the desired pivot table (top corner recommended).",
      example: "'Pivot table'!A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "original_column",
      detail: "The name of the column in the original data set (not the pivot table).",
      example: '"division"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }, {
      name: "pivot_item",
      detail: "The name of the row or column shown in the pivot table corresponding to *original_column* that you want to retrieve.",
      example: '"east"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CHOOSE",
    t: 2,
    d: "Returns an element from a list of choices based on index.",
    a: "An element from a list of choices based on index.",
    m: [2, 255],
    p: [{
      name: "index",
      detail: "Which choice (of the up to 30 provided) to return.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "choice1",
      detail: "A potential value to return. Required. May be a reference to a cell or an individual value.",
      example: '"A"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "choice2",
      detail: "Additional values among which to choose.",
      example: '"B"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "HYPERLINK",
    t: 2,
    d: "Creates a hyperlink inside a cell.",
    a: "Creates a hyperlink inside a cell.",
    p: [{
      name: "url",
      detail: "The full URL of the link location enclosed in quotation marks, or a reference to a cell containing such a URL.",
      example: '"http://www.luckysheet.com/"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "link_label",
      detail: "The text to display in the cell as the link, enclosed in quotation marks, or a reference to a cell containing such a label.",
      example: '"luckysheet"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TIME",
    t: 6,
    d: "Converts a provided hour, minute, and second into a time.",
    a: "Converts hour/minute/second into a time.",
    m: [3, 3],
    p: [{
      name: "hour",
      detail: "The hour component of the time.",
      example: "11",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "minute",
      detail: "The minute component of the time.",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "second",
      detail: "The second component of the time.",
      example: "59",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TIMEVALUE",
    t: 6,
    d: "Returns the fraction of a 24-hour day the time represents.",
    a: "Converts a time string into its serial number representation.",
    m: [1, 1],
    p: [{
      name: "time_string",
      detail: "The string that holds the time representation.",
      example: '"2:15 PM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EOMONTH",
    t: 6,
    d: "Returns a date on the last day of a month that falls a specified number of months before or after another date.",
    a: "Last day of a month before or after a date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to consider.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EDATE",
    t: 6,
    d: "Returns a date a specified number of months before or after another date.",
    a: "Date a number of months before/after another date.",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "The date from which to calculate the result.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "The number of months before (negative) or after (positive) 'start_date' to calculate.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SECOND",
    t: 6,
    d: "Returns the second component of a specific time, in numeric format.",
    a: "Second component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the second component",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINUTE",
    t: 6,
    d: "Returns the minute component of a specific time, in numeric format.",
    a: "Minute component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the minute component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HOUR",
    t: 6,
    d: "Returns the hour component of a specific time, in numeric format.",
    a: "Hour component of a specific time.",
    m: [1, 1],
    p: [{
      name: "time",
      detail: "The time from which to calculate the hour component.",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOW",
    t: 6,
    d: "Returns the current date and time as a date value.",
    a: "Current date and time as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "NETWORKDAYS",
    t: 6,
    d: "Returns the number of net working days between two provided days.",
    a: "Net working days between two provided days.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the date serial numbers to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NETWORKDAYS_INTL",
    t: 6,
    d: "Returns the number of net working days between two provided days excluding specified weekend days and holidays.",
    a: "Net working days between two dates (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The start date of the period from which to calculate the number of net working days.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date of the period from which to calculate the number of net working days.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider as holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISOWEEKNUM",
    t: 6,
    d: "Returns a number representing the ISO week of the year where the provided date falls.",
    a: "ISO week number of the year.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date for which to determine the ISO week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WEEKNUM",
    t: 6,
    d: "Returns a number representing the week of the year where the provided date falls.",
    a: "Week number of the year.",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the week number. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number representing the day that a week starts on. Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "WEEKDAY",
    t: 6,
    d: "Returns a number representing the day of the week of the date provided.",
    a: "Day of the week of the date provided (as number).",
    m: [1, 2],
    p: [{
      name: "date",
      detail: "The date for which to determine the day of the week. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "type",
      detail: "A number indicating which numbering system to use to represent weekdays. By default, counts starting with Sunday = 1.",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DAY",
    t: 6,
    d: "Returns the day of the month that a specific date falls on, in numeric format.",
    a: "Day of the month that a specific date falls on.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the day.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS",
    t: 6,
    d: "Returns the number of days between two dates.",
    a: "Number of days between two dates.",
    m: [2, 2],
    p: [{
      name: "end_date",
      detail: "The end of the date range.",
      example: "2011-3-15",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_date",
      detail: "The start of the date range.",
      example: "2011-2-1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS360",
    t: 6,
    d: "Returns the difference between two days based on the 360 day year used in some financial interest calculations.",
    a: "Days between two dates on a 360-day year.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "method",
      detail: "An indicator of what day count method to use.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATE",
    t: 6,
    d: "Converts a provided year, month, and day into a date.",
    a: "Converts year/month/day into a date.",
    m: [3, 3],
    p: [{
      name: "year",
      detail: "The year component of the date.",
      example: "1969",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The month component of the date.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day",
      detail: "The day component of the date.",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATEVALUE",
    t: 6,
    d: "Converts a provided date string in a known format to a date value.",
    a: "Converts a date string to a date value.",
    m: [1, 1],
    p: [{
      name: "date_string",
      detail: "The string representing the date.",
      example: '"1969-7-20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATEDIF",
    t: 6,
    d: "Calculates the number of days, months, or years between two dates.",
    a: "Date Difference.",
    m: [3, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "unit",
      detail: 'A string abbreviation for unit of time. For example, "M" for month. Accepted values are "Y","M","D","MD","YM","YD".',
      example: "16)",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY",
    t: 6,
    d: "Calculates the date after a number of working days from a specified start date.",
    a: "Number of working days from start date.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY_INTL",
    t: 6,
    d: "Calculates the date after a specified number of workdays excluding specified weekend days and holidays.",
    a: "Date after a number of workdays (specifying weekends).",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "The date from which to begin counting.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_days",
      detail: "The number of working days to advance from `start_date`. If negative, counts backwards.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "weekend",
      detail: "A number or string representing which days of the week are considered weekends.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "A range or array constant containing the dates to consider holidays.",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEAR",
    t: 6,
    d: "Returns the year specified by a given date.",
    a: "Year specified by a given date.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the year.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEARFRAC",
    t: 6,
    d: "Returns the number of years, including fractional years, between two dates using a specified day count convention.",
    a: "Exact number of years between two dates.",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "The start date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "The end date to consider in the calculation. Must be a reference to a cell containing a date, a function returning a date type, or a number.",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TODAY",
    t: 6,
    d: "Returns the current date as a date value.",
    a: "Current date as a date value.",
    m: [0, 0],
    p: []
  }, {
    n: "MONTH",
    t: 6,
    d: "Returns the month of the year a specific date falls in, in numeric format.",
    a: "Month of the year a specific date falls in.",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "The date from which to extract the month.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EFFECT",
    t: 8,
    d: "Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",
    a: "Annual effective interest rate.",
    m: [2, 2],
    p: [{
      name: "nominal_rate",
      detail: "The nominal interest rate per year.",
      example: "0.99",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLAR",
    t: 12,
    d: "Formats a number into the currency specific to your spreadsheet locale.",
    a: "Formats a number as currency specific to your spreadsheet locale.",
    m: [1, 2],
    p: [{
      name: "number",
      detail: "The value to be formatted.",
      example: "1.2351",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARDE",
    t: 8,
    d: "Converts a price quotation given as a decimal fraction into a decimal value.",
    a: "Converts a decimal fraction to decimal value.",
    m: [2, 2],
    p: [{
      name: "fractional_price",
      detail: "The price quotation given using fractional decimal conventions.",
      example: "100.10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARFR",
    t: 8,
    d: "Converts a price quotation given as a decimal value into a decimal fraction.",
    a: "Converts a decimal value to decimal fraction.",
    m: [2, 2],
    p: [{
      name: "decimal_price",
      detail: "The price quotation given as a decimal value.",
      example: "100.125",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "unit",
      detail: "The units of the desired fraction, e.g. `8` for 1/8ths or `32` for 1/32nds.",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",
    a: "Depreciation via declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "The number of months in the first year of depreciation.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DDB",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the double-declining balance method.",
    a: "Depreciation via double-declining balance method.",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "The factor by which depreciation decreases.",
      example: "2.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RATE",
    t: 8,
    d: "Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",
    a: "Interest rate of an annuity investment.",
    m: [3, 6],
    p: [{
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_per_period",
      detail: "The amount per period to be paid.",
      example: "-100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the interest rate will be.",
      example: "0.1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CUMPRINC",
    t: 8,
    d: "Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative principal paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNUM",
    t: 8,
    d: "Calculates the number of coupons, or interest payments, between the settlement date and the maturity date of the investment.",
    a: "Number of coupons between settlement and maturity.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "02",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SYD",
    t: 8,
    d: "Calculates the depreciation of an asset for a specified period using the sum of years digits method.",
    a: "Depreciation via sum of years digits method.",
    m: [4, 4],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The single period within `life` for which to calculate depreciation.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLEQ",
    t: 8,
    d: "Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",
    a: "Equivalent rate of return for a Treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "2)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLYIELD",
    t: 8,
    d: "Calculates the yield of a US Treasury Bill based on price.",
    a: "The yield of a us treasury bill based on price.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLPRICE",
    t: 8,
    d: "Calculates the price of a US Treasury Bill based on discount rate.",
    a: "Price of US treasury bill.",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the bill at time of purchase.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PV",
    t: 8,
    d: "Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Present value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACCRINT",
    t: 8,
    d: "Calculates the accrued interest of a security that has periodic payments.",
    a: "Accrued interest of security with periodic payments.",
    m: [6, 8],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "first_payment",
      detail: "The first date interest will be paid.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calc_method",
      detail: "[Optional-defaults to TRUE()] - A logical value that specifies the method used to calculate the total accrued interest when the settlement date is later than the first interest accrual date. \n\nIf the value is TRUE, the total accrued interest from the issue date to the settlement date is returned. \n\nIf the value is FALSE, return the accrued interest from the first interest accrual date to the settlement date.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ACCRINTM",
    t: 8,
    d: "Calculates the accrued interest of a security that pays interest at maturity.",
    a: "Accrued interest of security paying at maturity.",
    m: [4, 5],
    p: [{
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity date of the security.",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "1000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYBS",
    t: 8,
    d: "Calculates the number of days from the first coupon, or interest payment, until settlement.",
    a: "Number of days from first coupon to settlement.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYS",
    t: 8,
    d: "Calculates the number of days in the coupon, or interest payment, period that contains the specified settlement date.",
    a: "Days in coupon period containing settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYSNC",
    t: 8,
    d: "Calculates the number of days from the settlement date until the next coupon, or interest payment.",
    a: "Days from settlement until next coupon.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNCD",
    t: 8,
    d: "Calculates next coupon, or interest payment, date after the settlement date.",
    a: "Next coupon date after the settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPPCD",
    t: 8,
    d: "Calculates last coupon, or interest payment, date before the settlement date.",
    a: "Last coupon date before settlement date.",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FV",
    t: 8,
    d: "Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Future value of an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount per period to be paid.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FVSCHEDULE",
    t: 8,
    d: "Calculates the future value of some principal based on a specified series of potentially varying interest rates.",
    a: "Future value of principal from series of rates.",
    m: [2, 2],
    p: [{
      name: "principal",
      detail: "The amount of initial capital or value to compound against.",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "rate_schedule",
      detail: "A series of interest rates to compound against the `principal`.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "YIELD",
    t: 8,
    d: "Calculates the annual yield of a security paying periodic interest, such as a US Treasury Bond, based on price.",
    a: "Annual yield of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "YIELDDISC",
    t: 8,
    d: "Calculates the annual yield of a discount (non-interest-bearing) security, based on price.",
    a: "Annual yield of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NOMINAL",
    t: 8,
    d: "Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",
    a: "Annual nominal interest rate.",
    m: [2, 2],
    p: [{
      name: "effective_rate",
      detail: "The effective interest rate per year.",
      example: "0.85",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "periods_per_year",
      detail: "The number of compounding periods per year.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "XIRR",
    t: 8,
    d: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    a: "Internal rate of return given non-periodic cashflows.",
    m: [2, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "An array or range with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "250",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MIRR",
    t: 8,
    d: "Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",
    a: "Modified internal rate of return.",
    m: [3, 3],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "financing_rate",
      detail: "The interest rate paid on funds invested.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "reinvestment_return_rate",
      detail: "The return (as a percentage) earned on reinvestment of income received from the investment.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IRR",
    t: 8,
    d: "Calculates the internal rate of return on an investment based on a series of periodic cash flows.",
    a: "Internal rate of return given periodic cashflows.",
    m: [1, 2],
    p: [{
      name: "cashflow_amounts",
      detail: "An array or range containing the income or payments associated with the investment.",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rate_guess",
      detail: "An estimate for what the internal rate of return will be.",
      example: "200",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",
    a: "The net present value of an investment based on a series of periodic cash flows and a discount rate.",
    m: [2, 255],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow1",
      detail: "The first future cash flow.",
      example: "200",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "cashflow2",
      detail: "Additional future cash flows.",
      example: "250",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "XNPV",
    t: 8,
    d: "Calculates the net present value of an investment based on a specified series of potentially irregularly spaced cash flows and a discount rate.",
    a: "Net present value given non-periodic cashflows.",
    m: [3, 3],
    p: [{
      name: "discount",
      detail: "The discount rate of the investment over one period.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cashflow_amounts",
      detail: "A range of cells containing the income or payments associated with the investment.",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "cashflow_dates",
      detail: "A range of cells with dates corresponding to the cash flows in `cashflow_amounts`.",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CUMIPMT",
    t: 8,
    d: "Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Cumulative interest paid over a set of periods.",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "first_period",
      detail: "The number of the payment period to begin the cumulative calculation.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "last_period",
      detail: "The number of the payment period to end the cumulative calculation.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PMT",
    t: 8,
    d: "Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Periodic payment for an annuity investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: " 100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "D2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IPMT",
    t: 8,
    d: "Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on interest for an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "80000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "E2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PPMT",
    t: 8,
    d: "Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Payment on the principal of an investment.",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "The amortization period, in terms of number of periods.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_periods",
      detail: "The number of payments to be made.",
      example: "3*12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INTRATE",
    t: 8,
    d: "Calculates the effective interest rate generated when an investment is purchased at one price and sold at another with no interest or dividends generated by the investment itself.",
    a: "Calculates effective interest rate.",
    m: [4, 5],
    p: [{
      name: "buy_date",
      detail: "The date of purchase of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sell_date",
      detail: "The date of sale of the investment.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "buy_price",
      detail: "The price at which the investment was purchased.",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sell_price",
      detail: "The price at which the investment was sold.",
      example: "101200",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICE",
    t: 8,
    d: "Calculates the price of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Price of a security paying periodic interest.",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.065",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEDISC",
    t: 8,
    d: "Calculates the price of a discount (non-interest-bearing) security, based on expected yield.",
    a: "Price of a discount security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "The discount rate of the security at time of purchase.",
      example: "0.0525",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEMAT",
    t: 8,
    d: "Calculates the price of a security paying interest at maturity, based on expected yield.",
    a: "Price of security paying interest at maturity.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "issue",
      detail: "The date the security was initially issued.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RECEIVED",
    t: 8,
    d: "Calculates the amount received at maturity for an investment in fixed-income securities purchased on a given date.",
    a: "Amount received at maturity for a security.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "The amount invested (irrespective of face value of each security).",
      example: "10000000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "discount",
      detail: "The discount rate of the security invested in.",
      example: "0.0575",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DISC",
    t: 8,
    d: "Calculates the discount rate of a security based on price.",
    a: "The discount rate of a security based on price.",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "price",
      detail: "The price at which the security is bought per 100 face value.",
      example: "97.975",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "The redemption amount per 100 face value, or par.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPER",
    t: 8,
    d: "Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    a: "Number of payment periods for an investment.",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "The interest rate.",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "payment_amount",
      detail: "The amount of each payment made.",
      example: "500",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "present_value",
      detail: "The current value of the annuity.",
      example: "40000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "future_value",
      detail: "The future value remaining after the final payment has been made.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_or_beginning",
      detail: "Whether payments are due at the end (`0`) or beginning (`1`) of each period.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLN",
    t: 8,
    d: "Calculates the depreciation of an asset for one period using the straight-line method.",
    a: "Depreciation of asset using the straight-line method.",
    m: [3, 3],
    p: [{
      name: "cost",
      detail: "The initial cost of the asset.",
      example: "300000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "The value of the asset at the end of depreciation.",
      example: "75000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "The number of periods over which the asset is depreciated.",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DURATION",
    t: 8,
    d: "Calculates the number of compounding periods required for an investment of a specified present value appreciating at a given rate to reach a target value.",
    a: "Number of periods for an investment to reach a value.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MDURATION",
    t: 8,
    d: "Calculates the modified Macaulay duration of a security paying periodic interest, such as a US Treasury Bond, based on expected yield.",
    a: "Modified Macaulay duration.",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "The maturity or end date of the security, when it can be redeemed at face, or par value.",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "The annualized rate of interest.",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yield",
      detail: "The expected annual yield of the security.",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "The number of interest or coupon payments per year (1, 2, or 4).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day_count_convention",
      detail: "An indicator of what day count method to use.",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2DEC",
    t: 9,
    d: "Converts a signed binary number to decimal format.",
    a: "Converts a signed binary number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to decimal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIN2HEX",
    t: 9,
    d: "Converts a signed binary number to signed hexadecimal format.",
    a: "Converts a binary number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed hexademical, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2OCT",
    t: 9,
    d: "Converts a signed binary number to signed octal format.",
    a: "Converts a binary number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_binary_number",
      detail: "The signed 10-bit binary value to be converted to signed octal, provided as a string.",
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2BIN",
    t: 9,
    d: "Converts a decimal number to signed binary format.",
    a: "Converts a decimal number to signed binary format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed binary, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2HEX",
    t: 9,
    d: "Converts a decimal number to signed hexadecimal format.",
    a: "Converts a decimal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed hexadecimal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2OCT",
    t: 9,
    d: "Converts a decimal number to signed octal format.",
    a: "Converts a decimal number to signed octal format.",
    m: [1, 2],
    p: [{
      name: "decimal_number",
      detail: "The decimal value to be converted to signed octal, provided as a string.",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2BIN",
    t: 9,
    d: "Converts a signed hexadecimal number to signed binary format.",
    a: "Converts a hexadecimal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed binary, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2DEC",
    t: 9,
    d: "Converts a signed hexadecimal number to decimal format.",
    a: "Converts a hexadecimal number to decimal.",
    m: [1, 1],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to decimal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HEX2OCT",
    t: 9,
    d: "Converts a signed hexadecimal number to signed octal format.",
    a: "Converts a hexadecimal number to octal.",
    m: [1, 2],
    p: [{
      name: "signed_hexadecimal_number",
      detail: "The signed 40-bit hexadecimal value to be converted to signed octal, provided as a string.",
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2BIN",
    t: 9,
    d: "Converts a signed octal number to signed binary format.",
    a: "Converts an octal number to binary.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed binary, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2DEC",
    t: 9,
    d: "Converts a signed octal number to decimal format.",
    a: "Converts a signed octal number to decimal format.",
    m: [1, 1],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to decimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OCT2HEX",
    t: 9,
    d: "Converts a signed octal number to signed hexadecimal format.",
    a: "Converts an octal number to hexadecimal.",
    m: [1, 2],
    p: [{
      name: "signed_octal_number",
      detail: "The signed 30-bit octal value to be converted to signed hexadecimal, provided as a string.",
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "significant_digits",
      detail: "The number of significant digits to ensure in the result.",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COMPLEX",
    t: 9,
    d: "Creates a complex number given real and imaginary coefficients.",
    a: "Creates a complex number.",
    m: [2, 3],
    p: [{
      name: "real_part",
      detail: "The real coefficient.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "imaginary_part",
      detail: "The imaginary coefficient.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suffix",
      detail: "The suffix for the imaginary coefficient, can only be 'i' or 'j'. If omitted, 'i' will be used.",
      example: '"j"',
      require: "o",
      repeat: "n",
      type: "rangestring"
    }]
  }, {
    n: "IMREAL",
    t: 9,
    d: "Returns the real coefficient of a complex number.",
    a: "The real coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMAGINARY",
    t: 9,
    d: "Returns the imaginary coefficient of a complex number.",
    a: "The imaginary coefficient of a complex number.",
    m: [1, 1],
    p: [{
      name: "complex_number",
      detail: "The complex number, in the a+bi or a+bj format.",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMCONJUGATE",
    t: 9,
    d: "Returns the complex conjugate of a number.",
    a: "The complex conjugate of a number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the conjugate for.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMABS",
    t: 9,
    d: "Returns absolute value (or modulus) of a complex number.",
    a: "The absolute value of a complex number.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The complex number to calculate the absolute value of.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DELTA",
    t: 9,
    d: "Compare two numeric values, returning 1 if they're equal.",
    a: "Compare two numeric values.",
    m: [1, 2],
    p: [{
      name: "number1",
      detail: "The first number to compare.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number2",
      detail: "The second number to compare.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IMSUM",
    t: 9,
    d: "Returns the sum of a series of complex numbers.",
    a: "Sum of a series of complex numbers.",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "The first complex number or range to add together.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "Additional complex numbers or ranges to add to `value1`.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMSUB",
    t: 9,
    d: "Returns the difference between two complex numbers.",
    a: "The difference between two complex numbers.",
    m: [2, 2],
    p: [{
      name: "first_number",
      detail: "The complex number to subtract second_number from.",
      example: '"6+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "second_number",
      detail: "The complex number to subtract from first_number.",
      example: '"2+3i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMPRODUCT",
    t: 9,
    d: "Returns the result of multiplying a series of complex numbers together.",
    a: "Result of multiplying a series of complex numbers together.",
    m: [1, 255],
    p: [{
      name: "factor1",
      detail: "The first number or range to calculate for the product.",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "factor2",
      detail: "Additional complex numbers or ranges to calculate for the product.",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMDIV",
    t: 9,
    d: "Returns one complex number divided by another.",
    a: "One complex number divided by another.",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The complex number to be divided.",
      example: '"11+16i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "divisor",
      detail: "The complex number to divide by.",
      example: '"3+2i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOT",
    t: 10,
    d: "Returns the opposite of a logical value - `NOT(TRUE)` returns `FALSE`; `NOT(FALSE)` returns `TRUE`.",
    a: "Returns opposite of provided logical value.",
    m: [1, 1],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell holding an expression that represents some logical value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRUE",
    t: 10,
    d: "Returns the logical value `TRUE`.",
    a: "Logical value `true`.",
    m: [0, 0],
    p: []
  }, {
    n: "FALSE",
    t: 10,
    d: "Returns the logical value `FALSE`.",
    a: "Logical value `false`.",
    m: [0, 0],
    p: []
  }, {
    n: "AND",
    t: 10,
    d: "Returns true if all of the provided arguments are logically true, and false if any of the provided arguments are logically false.",
    a: "Logical `and` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that represent logical values.",
      example: 'A3 = "bar"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IFERROR",
    t: 10,
    d: "Returns the first argument if it is not an error value, otherwise returns the second argument if present, or a blank if the second argument is absent.",
    a: "Value if it is not an error, otherwise 2nd argument.",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "The value to return if `value` itself is not an error.",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_error",
      detail: "The value the function returns if `value` is an error.",
      example: '"Error in cell A1"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IF",
    t: 10,
    d: "Returns one value if a logical expression is `TRUE` and another if it is `FALSE`.",
    a: "Returns value depending on logical expression.",
    m: [2, 3],
    p: [{
      name: "logical_expression",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_true",
      detail: "The value the function returns if `logical_expression` is `TRUE`.",
      example: '"A2 is foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_false",
      detail: "The value the function returns if `logical_expression` is `FALSE`.",
      example: '"A2 was false"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OR",
    t: 10,
    d: "Returns true if any of the provided arguments are logically true, and false if all of the provided arguments are logically false.",
    a: "Logical `or` operator.",
    m: [1, 255],
    p: [{
      name: "logical_expression1",
      detail: "An expression or reference to a cell containing an expression that represents some logical value, i.e. `TRUE` or `FALSE`, or an expression that can be coerced to a logical value.",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical_expression2",
      detail: "More expressions that evaluate to logical values.",
      example: ' A3 = "bar"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NE",
    t: 11,
    d: "Returns `TRUE` if two specified values are not equal and `FALSE` otherwise. Equivalent to the `!=` operator.",
    a: "Not equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for inequality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EQ",
    t: 11,
    d: "Returns `TRUE` if two specified values are equal and `FALSE` otherwise. Equivalent to the `==` operator.",
    a: "Equal.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to test against `value1` for equality.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly greater than the second, and `FALSE` otherwise. Equivalent to the `>` operator.",
    a: "Strictly greater than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is greater than or equal to the second, and `FALSE` otherwise. Equivalent to the `>=` operator.",
    a: "Greater than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being greater than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LT",
    t: 11,
    d: "Returns `TRUE` if the first argument is strictly less than the second, and `FALSE` otherwise. Equivalent to the `<` operator.",
    a: "Less than.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LTE",
    t: 11,
    d: "Returns `TRUE` if the first argument is less than or equal to the second, and `FALSE` otherwise. Equivalent to the `<=` operator.",
    a: "Less than or equal to.",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to test as being less than or equal to `value2`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The second value.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADD",
    t: 11,
    d: "Returns the sum of two numbers. Equivalent to the `+` operator.",
    a: "Sum of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The first addend.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The second addend.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINUS",
    t: 11,
    d: "Returns the difference of two numbers. Equivalent to the `-` operator.",
    a: "Difference of two numbers",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The minuend, or number to be subtracted from.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "The subtrahend, or number to subtract from `value1`.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTIPLY",
    t: 11,
    d: "Returns the product of two numbers. Equivalent to the `*` operator.",
    a: "Product of two numbers",
    m: [2, 2],
    p: [{
      name: "factor1",
      detail: "The first multiplicand.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor2",
      detail: "The second multiplicand.",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DIVIDE",
    t: 11,
    d: "Returns one number divided by another. Equivalent to the `/` operator.",
    a: "One number divided by another",
    m: [2, 2],
    p: [{
      name: "dividend",
      detail: "The number to be divided.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "divisor",
      detail: "The number to divide by.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCAT",
    t: 11,
    d: "Returns the concatenation of two values. Equivalent to the `&` operator.",
    a: "Concatenation of two values",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "The value to which `value2` will be appended.",
      example: '"de"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "The value to append to `value1`.",
      example: '"mystify"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNARY_PERCENT",
    t: 11,
    d: "Returns a value interpreted as a percentage; that is, `UNARY_PERCENT(100)` equals `1`.",
    a: "Value interpreted as a percentage.",
    m: [1, 1],
    p: [{
      name: "percentage",
      detail: "The value to interpret as a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCATENATE",
    t: 12,
    d: "Appends strings to one another.",
    a: "Appends strings to one another.",
    m: [1, 255],
    p: [{
      name: "string1",
      detail: "The initial string.",
      example: '"Super"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "More strings to append in sequence.",
      example: '"calla"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CODE",
    t: 12,
    d: "Returns the numeric Unicode map value of the first character in the string provided.",
    a: "Numeric unicode map value of character.",
    m: [1, 1],
    p: [{
      name: "string",
      detail: "The string whose first character's Unicode map value will be returned.",
      example: '"a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CHAR",
    t: 12,
    d: "Convert a number into a character according to the current Unicode table.",
    a: "Gets character associated with number.",
    m: [1, 1],
    p: [{
      name: "table_number",
      detail: "The number of the character to look up from the current Unicode table in decimal format.",
      example: "97",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ARABIC",
    t: 12,
    d: "Computes the value of a Roman numeral.",
    a: "Computes the value of a roman numeral.",
    m: [1, 1],
    p: [{
      name: "roman_numeral",
      detail: "The Roman numeral to format, whose value must be between 1 and 3999, inclusive.",
      example: '"XIV"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROMAN",
    t: 12,
    d: "Formats a number in Roman numerals.",
    a: "Formats a number in Roman numerals.",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "The number to format, between 1 and 3999, inclusive.",
      example: "499",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "REGEXEXTRACT",
    t: 12,
    d: "Extracts matching substrings according to a regular expression.",
    a: "Extracts matching substrings with regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The input text.",
      example: '"Needle in a haystack"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The first part of `text` that matches this expression will be returned.",
      example: '".e{2}dle"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXMATCH",
    t: 12,
    d: "Whether a piece of text matches a regular expression.",
    a: "Whether a piece of text matches regular expression.",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "The text to be tested against the regular expression.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression to test the text against.",
      example: '"S.r"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXREPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string using regular expressions.",
    a: "Replaces text with regular expressions.",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "The regular expression.  All matching instances in `text` will be replaced.",
      example: '"S.*d"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replacement",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T",
    t: 12,
    d: "Returns string arguments as text, or the empty string if the value is not text.",
    a: "String arguments as text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIXED",
    t: 12,
    d: "Formats a number with a fixed number of decimal places.",
    a: "Formats number with fixed number of decimal places.",
    m: [1, 3],
    p: [{
      name: "number",
      detail: "The number to format.",
      example: "3.141592653",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_of_places",
      detail: "The number of decimal places to display in the result.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suppress_separator",
      detail: "Whether or not to suppress the thousands separator used in some locales (e.g. `1,000` becomes `1000`). Separators will be present if this value is 0 or omitted, and absent otherwise.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIND",
    t: 12,
    d: "Returns the position at which a string is first found within text where the capitalization of letters matters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, case-sensitive.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FINDB",
    t: 12,
    d: "Returns the position at which a string is first found within text counting each double-character as 2.",
    a: "Position at which a string is first found within text (binary).",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"new"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: '"new year"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "JOIN",
    t: 12,
    d: "Concatenates the elements of one or more one-dimensional arrays using a specified delimiter.",
    a: "Concatenates elements of arrays with delimiter.",
    m: [2, 255],
    p: [{
      name: "delimiter",
      detail: "The character or string to place between each concatenated value.",
      example: '" and-a "',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array1",
      detail: "The value or values to be appended using `delimiter`.",
      example: "{1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_or_array2",
      detail: "More values to be appended using `delimiter`.",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LEFT",
    t: 12,
    d: "Returns a substring from the beginning of a specified string.",
    a: "Substring from beginning of specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the left portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the left side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RIGHT",
    t: 12,
    d: "Returns a substring from the end of a specified string.",
    a: "A substring from the end of a specified string.",
    m: [1, 2],
    p: [{
      name: "string",
      detail: "The string from which the right portion will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_characters",
      detail: "The number of characters to return from the right side of `string`.",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MID",
    t: 12,
    d: "Returns a segment of a string.",
    a: "A segment of a string.",
    m: [3, 3],
    p: [{
      name: "string",
      detail: "The string to extract a segment from.",
      example: '"get this"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The index from the left of `string` from which to begin extracting. The first character in `string` has the index 1.",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "extract_length",
      detail: "The length of the segment to extract.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LEN",
    t: 12,
    d: "Returns the length of a string.",
    a: "Length of a string.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LENB",
    t: 12,
    d: "Returns the length of a string in bytes.",
    a: "Length of a string in bytes.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string whose length will be returned.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOWER",
    t: 12,
    d: "Converts a specified string to lowercase.",
    a: "Converts a specified string to lowercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to lowercase.",
      example: '"LOREM IPSUM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UPPER",
    t: 12,
    d: "Converts a specified string to uppercase.",
    a: "Converts a specified string to uppercase.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string to convert to uppercase.",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EXACT",
    t: 12,
    d: "Tests whether two strings are identical.",
    a: "Tests whether two strings are identical.",
    m: [2, 2],
    p: [{
      name: "string1",
      detail: "The first string to compare",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "string2",
      detail: "The second string to compare",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPLACE",
    t: 12,
    d: "Replaces part of a text string with a different text string.",
    a: "Replaces part of a text string with different text.",
    m: [4, 4],
    p: [{
      name: "text",
      detail: "The text, a part of which will be replaced.",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "position",
      detail: "The position where the replacement will begin (starting from 1).",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "length",
      detail: "The number of characters in the text to be replaced.",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_text",
      detail: "The text which will be inserted into the original text.",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPT",
    t: 12,
    d: "Returns specified text repeated a number of times.",
    a: "Specified text repeated a number of times.",
    m: [2, 2],
    p: [{
      name: "text_to_repeat",
      detail: "The character or string to repeat.",
      example: '"ha"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_of_repetitions",
      detail: "The number of times `text_to_repeat` should appear in the value returned.",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEARCH",
    t: 12,
    d: "Returns the position at which a string is first found within text and ignores capitalization of letters. Returns `#VALUE!` if the string is not found.",
    a: "First position of string found in text, ignoring case.",
    m: [2, 3],
    p: [{
      name: "search_for",
      detail: "The string to look for within `text_to_search`.",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text_to_search",
      detail: "The text to search for the first occurrence of `search_for`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "starting_at",
      detail: "The character within `text_to_search` at which to start the search.",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUBSTITUTE",
    t: 12,
    d: "Replaces existing text with new text in a string.",
    a: "Replaces existing text with new text in a string.",
    m: [3, 4],
    p: [{
      name: "text_to_search",
      detail: "The text within which to search and replace.",
      example: '"search for it"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "search_for",
      detail: "The string to search for within `text_to_search`.",
      example: '"search for"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replace_with",
      detail: "The string that will replace `search_for`.",
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurrence_number",
      detail: "The instance of `search_for` within `text_to_search` to replace with `replace_with`. By default, all occurrences of `search_for` are replaced; however, if `occurrence_number` is specified, only the indicated instance of `search_for` is replaced.",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CLEAN",
    t: 12,
    d: "Returns the text with the non-printable ASCII characters removed.",
    a: "Removes non-printable characters from a piece of text.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text whose non-printable characters are to be removed.",
      example: '"AF"&CHAR(31)',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TEXT",
    t: 12,
    d: "Converts a number into text according to a specified format.",
    a: "Formats a number into text.",
    m: [2, 2],
    p: [{
      name: "number",
      detail: "The number, date, or time to format.",
      example: "1.23",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "format",
      detail: "The pattern by which to format the number, enclosed in quotation marks.",
      example: '"$0.00"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRIM",
    t: 12,
    d: "Removes leading, trailing, and repeated spaces in text.",
    a: "Removes space characters.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The text or reference to a cell containing text to be trimmed.",
      example: '" lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "VALUE",
    t: 12,
    d: "Converts a string in any of the date, time or number formats that Google Sheets understands into a number.",
    a: "Converts a date/time/number string into a number.",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "The string containing the value to be converted.",
      example: '"123"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROPER",
    t: 12,
    d: "Capitalizes each word in a specified string.",
    a: "Capitalizes each word in a specified string.",
    m: [1, 1],
    p: [{
      name: "text_to_capitalize",
      detail: "The text which will be returned with the first letter of each word in uppercase and all other letters in lowercase.",
      example: '"united states"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CONVERT",
    t: 13,
    d: "Converts a numeric value to a different unit of measure.",
    a: "Unit conversion for numbers.",
    m: [3, 3],
    p: [{
      name: "value",
      detail: "The numeric value in `start_unit` to convert to `end_unit`.",
      example: "5.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_unit",
      detail: "The starting unit, the unit currently assigned to `value`.",
      example: '"g"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_unit",
      detail: "The unit of measure into which to convert the argument, `value`.",
      example: '"kg"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "SUMX2MY2",
    t: 14,
    d: "Calculates the sum of the differences of the squares of values in two arrays.",
    a: "Sum of the differences of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be reduced by the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be subtracted from the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMX2PY2",
    t: 14,
    d: "Calculates the sum of the sums of the squares of values in two arrays.",
    a: "Sum of the sums of squares.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_y` and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values whose squares will be added to the squares of corresponding entries in `array_x` and added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMXMY2",
    t: 14,
    d: "Calculates the sum of the squares of differences of values in two arrays.",
    a: "Sum of the squares of differences.",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "The array or range of values that will be reduced by corresponding entries in `array_y`, squared, and added together.",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "The array or range of values that will be subtracted from corresponding entries in `array_x`, the result squared, and all such results added together.",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRANSPOSE",
    t: 14,
    d: "Transposes the rows and columns of an array or range of cells.",
    a: "Transposes the rows and columns of an array.",
    m: [1, 1],
    p: [{
      name: "array_or_range",
      detail: "The array or range whose rows and columns will be swapped.",
      example: "{1,2}",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TREND",
    t: 14,
    d: "Given partial data about a linear trend, fits an ideal linear trend using the least squares method and/or predicts further values.",
    a: "Fits points to linear trend derived via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general linear form of `y = m*x+b` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FREQUENCY",
    t: 14,
    d: "Calculates the frequency distribution of a one-column array into specified classes.",
    a: "The frequency distribution of array.",
    m: [2, 2],
    p: [{
      name: "data",
      detail: "The array or range containing the values to be counted.",
      example: "A2:A40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "classes",
      detail: "The array or range containing the set of classes.",
      example: "B2:B5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GROWTH",
    t: 14,
    d: "Given partial data about an exponential growth trend, fits an ideal exponential growth trend and/or predicts further values.",
    a: "Fits points to exponential growth trend.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_data_x",
      detail: "The data points to return the `y` values for on the ideal curve fit.",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINEST",
    t: 14,
    d: "Given partial data about a linear trend, calculates various parameters about the ideal linear trend using the least-squares method.",
    a: "Best-fit linear trend via least-squares.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal linear trend.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calculate_b",
      detail: "Given a linear form of `y = m*x+b`, calculates the y-intercept (`b`) if `TRUE`. Otherwise, forces `b` to be `0` and only calculates the `m` values if `FALSE`, i.e. forces the curve fit to pass through the origin.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the linear coefficients and the y-intercept (default).",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOGEST",
    t: 14,
    d: "Given partial data about an exponential growth curve, calculates various parameters about the best fit ideal exponential growth curve.",
    a: "Best-fit exponential growth curve.",
    m: [1, 4],
    p: [{
      name: "known_data_y",
      detail: "The array or range containing dependent (y) values that are already known, used to curve fit an ideal exponential growth curve.",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_data_x",
      detail: "The values of the independent variable(s) corresponding with `known_data_y`.",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "b",
      detail: "Given a general exponential form of `y = b*m^x` for a curve fit, calculates `b` if `TRUE` or forces `b` to be `1` and only calculates the `m` values if `FALSE`.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "verbose",
      detail: "A flag specifying whether to return additional regression statistics or only the calculated coefficient and exponents.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MDETERM",
    t: 14,
    d: "Returns the matrix determinant of a square matrix specified as an array or range.",
    a: "Matrix determinant of a square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose determinant will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINVERSE",
    t: 14,
    d: "Returns the multiplicative inverse of a square matrix specified as an array or range.",
    a: "Multiplicative inverse of square matrix.",
    m: [1, 1],
    p: [{
      name: "square_matrix",
      detail: "An array or range with an equal number of rows and columns representing a matrix whose multiplicative inverse will be calculated.",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MMULT",
    t: 14,
    d: "Calculates the matrix product of two matrices specified as arrays or ranges.",
    a: "The matrix product of two matrices.",
    m: [2, 2],
    p: [{
      name: "matrix1",
      detail: "The first matrix in the matrix multiplication operation, represented as an array or range.",
      example: "A1:B3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "matrix2",
      detail: "The second matrix in the matrix multiplication operation, represented as an array or range.",
      example: "C1:F2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMPRODUCT",
    t: 14,
    d: "Calculates the sum of the products of corresponding entries in two equal-sized arrays or ranges.",
    a: "Sum of products of elements in two arrays.",
    m: [1, 255],
    p: [{
      name: "array1",
      detail: "The first array or range whose entries will be multiplied with corresponding entries in the second such array or range.",
      example: "A2:C5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "The second array or range whose entries will be multiplied with corresponding entries in the first such array or range.",
      example: "D2:F5",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "ISFORMULA",
    t: 15,
    d: "Checks whether a value is a formula.",
    a: "Whether a value is a formula.",
    m: [1, 1],
    p: [{
      name: "cell",
      detail: "The cell to be verified as containing a formula.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CELL",
    t: 15,
    d: "Returns the requested information about the specified cell.",
    a: "Gets information about a cell.",
    m: [2, 2],
    p: [{
      name: "info_type",
      detail: "The type of information requested (see article for available types)",
      example: '"type"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "reference",
      detail: "The reference to the cell.",
      example: "C2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "NA",
    t: 15,
    d: 'Returns the "value not available" error, `#N/A`.',
    a: "The `#N/A` error.",
    m: [0, 0],
    p: []
  }, {
    n: "ERROR_TYPE",
    t: 15,
    d: "Returns a number corresponding to the error value in a different cell.",
    a: "Error value of cell (as number).",
    m: [1, 1],
    p: [{
      name: "reference",
      detail: "The cell to find the error number for although you can also provide the error value directly.",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISBLANK",
    t: 15,
    d: "Checks whether the referenced cell is empty.",
    a: "Whether the referenced cell is empty.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "Reference to the cell that will be checked for emptiness.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISERR",
    t: 15,
    d: "Checks whether a value is an error other than `#N/A`.",
    a: "Whether a value is an error other than `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type other than `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISERROR",
    t: 15,
    d: "Checks whether a value is an error.",
    a: "Whether a value is an error.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as an error type.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISLOGICAL",
    t: 15,
    d: "Checks whether a value is `TRUE` or `FALSE`.",
    a: "Whether a value is `true` or `false`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a logical `TRUE` or `FALSE`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNA",
    t: 15,
    d: "Checks whether a value is the error `#N/A`.",
    a: "Whether a value is the error `#n/a`.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be compared with the error value `#N/A`.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNONTEXT",
    t: 15,
    d: "Checks whether a value is non-textual.",
    a: "Whether a value is non-textual.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be checked.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNUMBER",
    t: 15,
    d: "Checks whether a value is a number.",
    a: "Whether a value is a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISREF",
    t: 15,
    d: "Checks whether a value is a valid cell reference.",
    a: "Whether a value is a valid cell reference.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as a cell reference.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISTEXT",
    t: 15,
    d: "Checks whether a value is text.",
    a: "Whether a value is text.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value to be verified as text.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TYPE",
    t: 15,
    d: "Returns a number associated with the type of data passed into the function.",
    a: "Get the type of a value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The value whose type is to be determined.",
      example: "C4",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "N",
    t: 15,
    d: "Returns the argument provided as a number. Text is converted to 0 and errors are returned as-is.",
    a: "Argument provided as a number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument to be converted to a number.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DATE",
    t: 16,
    d: "Converts a provided number to a date.",
    a: "Converts a provided number to a date.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a date.",
      example: "25405",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PURE_NUMBER",
    t: 16,
    d: "Converts a provided date/time, percentage, currency or other formatted numeric value to a pure number without formatting.",
    a: "Converts any numeric value to a pure number.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a pure number.",
      example: "50%",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_TEXT",
    t: 16,
    d: "Converts a provided numeric value to a text value.",
    a: "Converts a provided numeric value to a text value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to text.",
      example: "24",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DOLLARS",
    t: 16,
    d: "Converts a provided number to a dollar value.",
    a: "Converts a provided number to a dollar value.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a dollar value.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PERCENT",
    t: 16,
    d: "Converts a provided number to a percentage.",
    a: "Converts a provided number to a percentage.",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "The argument or reference to a cell to be converted to a percentage.",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DGET",
    t: 17,
    d: "Returns a single value from a database table-like array or range using a SQL-like query.",
    a: "Single value from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMAX",
    t: 17,
    d: "Returns the maximum value selected from a database table-like array or range using a SQL-like query.",
    a: "Maximum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMIN",
    t: 17,
    d: "Returns the minimum value selected from a database table-like array or range using a SQL-like query.",
    a: "Minimum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DAVERAGE",
    t: 17,
    d: "Returns the average of a set of values selected from a database table-like array or range using a SQL-like query.",
    a: "Average of a set of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNT",
    t: 17,
    d: "Counts numeric values selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNTA",
    t: 17,
    d: "Counts values, including text, selected from a database table-like array or range using a SQL-like query.",
    a: "Counts values and text from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DPRODUCT",
    t: 17,
    d: "Returns the product of values selected from a database table-like array or range using a SQL-like query.",
    a: "Product of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEV",
    t: 17,
    d: "Returns the standard deviation of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of population sample from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEVP",
    t: 17,
    d: "Returns the standard deviation of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Standard deviation of entire population from table.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSUM",
    t: 17,
    d: "Returns the sum of values selected from a database table-like array or range using a SQL-like query.",
    a: "Sum of values from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVAR",
    t: 17,
    d: "Returns the variance of a population sample selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of population sample from table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVARP",
    t: 17,
    d: "Returns the variance of an entire population selected from a database table-like array or range using a SQL-like query.",
    a: "Variance of a population from a table-like range.",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "The array or range containing the data to consider, structured in such a way that the first row contains the labels for each column's values.",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "Indicates which column in `database` contains the values to be extracted and operated on.",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "An array or range containing zero or more criteria to filter the `database` values by before operating.",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "AGE_BY_IDCARD",
    t: "3",
    d: "Calculate the age based on the Chinese ID number. Support 15 or 18",
    a: "Get age based on ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: "A1",
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Deadline",
      example: '"2017-10-01"',
      detail: "The deadline or range of age calculation. The default is the current day.",
      require: "o",
      repeat: "n",
      type: "rangedatetime"
    }]
  }, {
    n: "SEX_BY_IDCARD",
    t: "3",
    d: "Calculate gender based on Chinese ID number. Support 15 or 18",
    a: "Get gender based on ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIRTHDAY_BY_IDCARD",
    t: "3",
    d: "Calculate the birthday based on the Chinese ID number. Support 15 or 18",
    a: "Get the birthday based on the ID number.",
    m: [1, 2],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Birthday format",
      example: "0",
      detail: "Date type, default:0:[1900/01/01], 1:[1900-01-01], 2:[1900年1月1日]",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROVINCE_BY_IDCARD",
    t: "3",
    d: "Calculate the province of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the province of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CITY_BY_IDCARD",
    t: "3",
    d: "Calculate the city of birthplace based on the Chinese ID number. Support 15 or 18",
    a: "Get the city of birthplace based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "STAR_BY_IDCARD",
    t: "3",
    d: "Calculate the constellation based on the Chinese ID number. Support 15 or 18",
    a: "Get the constellation based on the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ANIMAL_BY_IDCARD",
    t: "3",
    d: "Calculate the zodiac (rat, ox, tiger, rabbit...) based on the Chinese ID number. Support 15 or 18",
    a: "Get the zodiac according to the ID number.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISIDCARD",
    t: "3",
    d: "Verify that the format of the ID card is correct. Support 15 or 18",
    a: "Verify the correctness of the ID card format.",
    m: [1, 1],
    p: [{
      name: "ID number",
      example: '"31033519900101XXXX"',
      detail: "15-digit or 18-digit ID number or range.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DM_TEXT_CUTWORD",
    t: "4",
    d: "Text segmentation. Split a series of words into a series of individual words",
    a: "Chinese text segmentation.",
    m: [1, 2],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Word segmentation mode",
      example: "0",
      detail: "The default is 0[precision mode], 1[full mode], 2[search engine mode].",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TFIDF",
    t: "4",
    d: "Use tf-idf algorithm for keyword extraction. Identify keywords from a series of text",
    a: "tf-idf keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TEXTRANK",
    t: "4",
    d: "Use TextRank algorithm to extract keywords. Identify keywords from a series of text",
    a: "TextRank keyword recognition.",
    m: [1, 3],
    p: [{
      name: "Text",
      example: '"I came to Beijing Tsinghua University"',
      detail: "Any text that needs word segmentation.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Number of keywords",
      example: "20",
      detail: "The number of keywords returned by the algorithm, the default is 20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Corpus",
      example: "1",
      detail: "Select a corpus in a specific field, the default is 0[General], 1[Finance], 2[Medical]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_CLOSE",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock closing price of A shares.",
    a: "Returns the closing price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_OPEN",
    t: "5",
    d: "According to the stock code and date, return the opening price of stock.",
    a: "Return the opening price of a shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MAX",
    t: "5",
    d: "According to the stock code and date, return the highest price of stock.",
    a: "Return the highest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MIN",
    t: "5",
    d: "According to the stock code and date, return the lowest price of stock.",
    a: "Returns the lowest price of stock.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_VOLUMN",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock trading volume of A shares.",
    a: "Returns the corresponding stock trading volume of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_AMOUNT",
    t: "5",
    d: "According to the stock code and date, return the corresponding stock turnover of A shares.",
    a: "Returns the corresponding stock turnover of A shares.",
    m: [1, 3],
    p: [{
      name: "Stock code",
      example: '"000001"',
      detail: "6-digit stock code, required.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Date",
      example: "2015-01-08",
      detail: "The trading day of the stock, the default is the latest trading day",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "Reversion and exclusion",
      example: "0",
      detail: "Select the ex right restoration type of the stock, default to 0 [former reversion], 1 [original price], 2 [post reversion]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISDATE",
    t: "6",
    d: "Returns whether a value is a date.",
    a: "Whether a value is a date.",
    m: [1, 1],
    p: [{
      name: "value",
      example: '"1990-01-01"',
      detail: "The value to be verified as a date.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell to describe the continuous trend of data",
    a: "Generate sparklines line chart",
    m: [1, 8],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Maximum mark",
      example: "#fc5c5c",
      detail: "Identifies the maximum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Minimum mark",
      example: "#fc5c5c",
      detail: "Identify the minimum value of the line graph, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Mark size",
      example: "1.5",
      detail: "The maximum and minimum mark size settings, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AREASPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell area chart, generally used to describe the continuous cumulative value trend of the data",
    a: "Generate sparklines area chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Fill color",
      example: "#CCF3F4",
      detail: "Form an area chart, the same line color configuration, default 0 does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Line thickness",
      example: "1",
      detail: "Line thickness of the line graph, the default is 1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line",
      example: "avg",
      detail: "A horizontal line, which can be min, max, avg, median, range or custom value, default 0 none",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Auxiliary line color",
      example: "#000",
      detail: "Color setting of auxiliary line, same as line color configuration, default #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the vertical histogram of cells, generally used to describe the size of discrete data",
    a: "Generate sparklines vertical histogram",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKCOLUMNSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative vertical histogram embedded in a cell, generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative vertical histogram",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BARSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the size of discrete data",
    a: "Generate sparklines horizontal bar graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the bar chart, used to standardize the length of the bar chart, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKBARSPLINES",
    t: "3",
    d: "Generate sparklines, a cumulative horizontal bar graph embedded in a cell, which is generally used to describe the numerical size of multiple dimensions of discrete data",
    a: "Generate sparklines cumulative horizontal bar graph",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Stack by column",
      example: "1",
      detail: "If you need to stack by row, set this item to false or 0, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Max",
      example: "100",
      detail: "The maximum value of the cumulative bar, used to regulate the length of the bar, the default is to automatically calculate false, auto, null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can individually set the bar color of each dimension, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "DISCRETESPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the trend of discrete data",
    a: "Generate sparklines discrete graph",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Segmentation threshold",
      example: "1",
      detail: "Discrete graph column color distinction, for example: if the value is 0, blue is greater than 0, red is less than 0, and the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Above threshold color",
      example: "#2ec7c9",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Below threshold color",
      example: "#fc5c5c",
      detail: "The color setting of the bar below the threshold, the same as the color above the threshold, default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRISTATESPLINES",
    t: "3",
    d: "Generate sparklines, a three-state graph embedded in the cell, which is generally used to describe the trend of three situations, such as winning, losing, or drawing.",
    a: "Generate sparklines three-state graph",
    m: [1, 6],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar interval",
      example: "1",
      detail: "The distance between bars, the default is 1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Bar color",
      example: "#fc5c5c",
      detail: "The line color of the line graph can be range A1, color table index value or specific color value. Set it to 0 or false to not display it. It supports regx, rgb, rgba, etc. Default #fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Negative bar color",
      example: "#97b552",
      detail: "Negative bar color setting, representing the color of negative value, same as the bar color configuration, default #97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Zero value bar color",
      example: "#999",
      detail: "Zero value bar color setting, representing 0 value color, the same color configuration of the bar, default #999",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color palette can set the color of each bar individually, multiple settings can be set, and two formats are supported: 1 color such as #000, which means that the color of the first bar is black; 2 value range: color, such as -2:# 000 indicates that the bar with a value of -2 is black, 0:5:#000 indicates that the bar with a value of 0-5 is black, and the default is empty",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PIESPLINES",
    t: "3",
    d: "Generate sparklines pie chart embedded in the cell, generally used to describe the proportion of data",
    a: "Generate sparklines pie chart",
    m: [1, 5],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Rotation angle",
      example: "0",
      detail: "The rotation angle of the pie chart, the default is 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "border",
      example: "0",
      detail: "Pie chart border size, default is none 0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Border color",
      example: "#000",
      detail: "The border color of the pie chart, the default is #000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Color palette",
      example: "#97b552",
      detail: "The color of the slice can be set in the palette, which can be set to the range of A1:A10, etc. The default is #2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BOXSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell box plot, generally used to describe the statistical distribution of the data set",
    a: "Generate sparklines box plot",
    m: [1, 4],
    p: [{
      name: "Range",
      example: "A1:A20",
      detail: "Range，Values can be calculated effectively, such as A1:A20, {1,2,3,4,5}, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Outlier ratio",
      example: "1.5",
      detail: "The threshold range of outliers, if it is 0 or false, it will not be displayed, the default is 1.5 times",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Target value",
      example: "10",
      detail: "The target value setting on the box plot, the default is false and does not display",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Point size",
      example: "1.5",
      detail: "The radius of the target point and outlier is set, the default is 1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BULLETSPLINES",
    t: "3",
    d: "Generate sparklines embedded in the cell, generally used to describe the task achievement rate",
    a: "Generating sparklines bullets",
    m: [2, 3],
    p: [{
      name: "Target",
      example: "10",
      detail: "The numerical value can be calculated effectively for the achieved target value, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "achieved",
      example: "8",
      detail: "Only when the value is completed can the value be calculated effectively, such as A1, 100, etc.",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "Contrast",
      example: "12",
      detail: "Comparative values, such as excess, minimum, and bottom line for awards, can be effectively calculated, such as A1, 100, etc. You can set up to 9 comparison values",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMPOSESPLINES",
    t: "3",
    d: "Support multiple types of pictures in the same cell, each parameter represents a sparklines diagram",
    a: "Combine sparklines graphs into one cell",
    m: [1, 1],
    p: [{
      name: "config",
      example: "PIESPLINES(A1:A20)",
      detail: "Sparklines chart settings, such as A1:A20, a completed pie chart, line chart settings, etc.",
      require: "m",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SORT",
    t: "14",
    d: "Sorts the rows of a given array or range by the values in one or more columns.",
    a: "Sorts rows of range by specified column.",
    m: [1, 4],
    p: [{
      name: "range",
      detail: "The data to be sorted.",
      example: "A2:A17",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column",
      detail: "The index of the column in `range` or a range outside of `range` containing the values by which to sort.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "is_ascending",
      detail: "`TRUE` or `FALSE` indicating whether to sort `sort_column` in ascending order. `FALSE` sorts in descending order.",
      example: "-1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_column2",
      detail: "Additional columns.",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FILTER",
    t: "14",
    d: "Returns a filtered version of the source range, returning only rows or columns which meet the specified conditions.",
    a: "Filters a range based off provided conditions.",
    m: [2, 3],
    p: [{
      name: "range",
      detail: "The data to be filtered.",
      example: "A5:D20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition1",
      detail: "A column or row containing true or false values corresponding to the first column or row of `range`, or an array formula evaluating to true or false.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "condition2",
      detail: "Additional rows or columns containing boolean values `TRUE` or `FALSE` indicating whether the corresponding row or column in `range` should pass through `FILTER`. Can also contain array formula expressions which evaluate to such rows or columns. All conditions must be of the same type (row or column). Mixing row conditions and column conditions is not permitted.",
      example: '""',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNIQUE",
    t: "14",
    d: "Returns unique rows in the provided source range, discarding duplicates. Rows are returned in the order in which they first appear in the source range.",
    a: "Unique rows in the provided source range.",
    m: [1, 3],
    p: [{
      name: "range",
      detail: "The data to filter by unique entries.",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[Option] - Logical value, indicating how to compare; by row = FALSE() or omitted; by column = TRUE().",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurs_once",
      detail: "[Option] - Logical value, only one occurrence in the unique value is returned = TRUE(); including all unique values = FALSE() or omitted.",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANDARRAY",
    t: "14",
    d: "Returns a grid of random numbers between 0 inclusive and 1 exclusive. The grid size will match the provided rows and columns arguments. If neither rows nor columns are provided, then the grid will be size 1 x 1.",
    a: "Returns a grid of random numbers.",
    m: [0, 2],
    p: [{
      name: "rows",
      detail: "The number of rows to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns to populate with a random number.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEQUENCE",
    t: "14",
    d: "Returns a grid of sequential numbers starting at a specified start value and  increasing by a specified step size. By default, the sequence starts at and  increases by 1.",
    a: "Returns a grid of sequential numbers.",
    m: [1, 4],
    p: [{
      name: "rows",
      detail: "The number of rows in the function's resulting grid.",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "columns",
      detail: "The number of columns in the function's resulting grid. If omitted, the result grid will have 1 column.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start",
      detail: "The number, at which to start the sequence. If omitted, the sequence will start at 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "step",
      detail: "The amount each value in the sequence will differ by. If omitted, each value will differ by 1.",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVALUATE",
    t: "3",
    d: "Evaluate a formula or expression expressed in words and return the result",
    a: "Evaluate according to literal formula or expression.",
    m: [1, 1],
    p: [{
      name: "expression",
      example: '"A1+5*2^2"',
      detail: "Formula or expression",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REMOTE",
    t: "5",
    d: "Calls a function on a remote server",
    a: "Calls a function on a remote back end server/API.",
    m: [1, 1],
    p: [{
      name: "remote_expression",
      example: "SUM(A1:A10000000)",
      detail: "Formula",
      require: "m",
      repeat: "n",
      type: "string"
    }]
  }],
  toolbar: {
    toolbar: "उपकरण पट्टी",
    undo: "पूर्ववत करें",
    redo: "फिर से करें",
    "clear-format": "फॉर्मेट साफ़ करें",
    "format-painter": "फॉर्मेट पेंटर",
    paintFormat: "फॉर्मेट पेंट करें",
    "currency-format": "मुद्रा के रूप में फॉर्मेट करें",
    "percentage-format": "प्रतिशत के रूप में फॉर्मेट करें",
    "number-decrease": "दशमलव स्थान घटाएँ",
    "number-increase": "दशमलव स्थान बढ़ाएँ",
    moreFormats: "अधिक फॉर्मेट",
    "border-all": "सभी सीमाएँ",
    "merge-all": "सभी सेल मिलाएँ",
    font: "फ़ॉन्ट",
    "font-size": "फ़ॉन्ट साइज़",
    bold: "बोल्ड (Ctrl+B)",
    italic: "इटैलिक (Ctrl+I)",
    "strike-through": "स्ट्राइकथ्रू (Alt+Shift+5)",
    underline: "अंडरलाइन",
    "font-color": "फ़ॉन्ट रंग",
    "align-left": "बाएँ अलाइन",
    "align-center": "क्षैतिज सेंटर",
    "align-right": "दाएँ अलाइन",
    "align-top": "ऊपर अलाइन",
    "align-mid": "लंबवत सेंटर",
    "align-bottom": "नीचे अलाइन",
    chooseColor: "रंग चुनें",
    resetColor: "रीसेट करें",
    customColor: "कस्टम",
    alternatingColors: "वैकल्पिक रंग",
    confirmColor: "ठीक है",
    cancelColor: "रद्द करें",
    collapse: "संकुचित करें",
    background: "बैकग्राउंड",
    border: "सीमा",
    borderStyle: "सीमा शैली",
    "merge-cell": "सेल मिलाएँ",
    chooseMergeType: "मिलाने का प्रकार चुनें",
    horizontalAlign: "क्षैतिज अलाइनमेंट",
    verticalAlign: "लंबवत अलाइनमेंट",
    alignment: "अलाइनमेंट",
    textWrap: "टेक्स्ट रैप",
    textWrapMode: "टेक्स्ट रैप मोड",
    textRotate: "टेक्स्ट घुमाएँ",
    textRotateMode: "टेक्स्ट घुमाने का मोड",
    freeze: "फ्रीज़ करें",
    sort: "छाँटें",
    filter: "फ़िल्टर करें",
    sortAndFilter: "छाँटें और फ़िल्टर करें",
    findAndReplace: "खोजें और बदलें",
    "formula-sum": "फॉर्मूला-सम",
    autoSum: "स्वचालित-सम",
    moreFunction: "अधिक फ़ंक्शन",
    conditionalFormat: "सशर्त फॉर्मेट",
    comment: "टिप्पणी",
    pivotTable: "पिवट तालिका",
    chart: "चार्ट",
    screenshot: "स्क्रीनशॉट",
    splitColumn: "टेक्स्ट विभाजित करें",
    insertImage: "छवि डालें",
    insertLink: "लिंक डालें",
    dataVerification: "डेटा वेरिफिकेशन",
    protection: "प्रोटेक्शन",
    clearText: "रंग साफ़ करें",
    noColorSelectedText: "कोई रंग चयनित नहीं है",
    toolMore: "अधिक",
    toolLess: "कम",
    toolClose: "बंद करें",
    toolMoreTip: "अधिक सुविधाएँ",
    moreOptions: "अधिक विकल्प",
    cellFormat: "सेल फॉर्मेट कॉन्फ़िगरेशन",
    print: "प्रिंट करें"
  },
  alternatingColors: {
    applyRange: "रेंज पर लागू करें",
    selectRange: "डेटा रेंज चुनें",
    header: "हेडर",
    footer: "फुटर",
    errorInfo: "एकाधिक चयन क्षेत्रों पर यह कार्य नहीं किया जा सकता, कृपया एक क्षेत्र चुनें और फिर से प्रयास करें",
    textTitle: "फॉर्मेट स्टाइल",
    custom: "कस्टम",
    close: "बंद करें",
    selectionTextColor: "टेक्स्ट रंग चुनने के लिए क्लिक करें",
    selectionCellColor: "सेल रंग चुनने के लिए क्लिक करें",
    removeColor: "वैकल्पिक रंग हटाएँ",
    colorShow: "रंग",
    currentColor: "वर्तमान",
    tipSelectRange: "कृपया वैकल्पिक रंगों की रेंज चुनें",
    errorNoRange: "कोई रेंज चयनित नहीं है",
    errorExistColors: "वैकल्पिक रंग पहले से मौजूद हैं और संपादित नहीं किए जा सकते"
  },
  button: {
    confirm: "ठीक है",
    cancel: "रद्द करें",
    close: "बंद करें",
    update: "अपडेट करें",
    delete: "हटाएँ",
    insert: "डालें",
    prevPage: "पिछला",
    nextPage: "अगला",
    total: "कुल:"
  },
  paint: {
    start: "फॉर्मेट पेंट शुरू",
    end: "ESC",
    tipSelectRange: "कृपया कॉपी किए जाने वाले रेंज का चयन करें",
    tipNotMulti: "एकाधिक चयन रेंज पर यह कार्य नहीं किया जा सकता"
  },
  format: {
    moreCurrency: "अधिक मुद्रा फॉर्मेट",
    moreDateTime: "अधिक दिनांक और समय फॉर्मेट",
    moreNumber: "अधिक संख्या फॉर्मेट",
    titleCurrency: "मुद्रा फॉर्मेट",
    decimalPlaces: "दशमलव स्थान",
    titleDateTime: "दिनांक और समय फॉर्मेट",
    titleNumber: "संख्या फॉर्मेट",
    tipDecimalPlaces: "दशमलव स्थान 0-9 के बीच होना चाहिए!",
    select: "चुनें",
    format: "फॉर्मेट",
    currency: "मुद्रा"
  },
  info: {
    detailUpdate: "नया खुला",
    detailSave: "स्थानीय कैश पुनर्स्थापित",
    row: "",
    column: "",
    loading: "लोड हो रहा है...",
    copy: "कॉपी करें",
    return: "बाहर निकलें",
    rename: "नाम बदलें",
    tips: "वर्कबुक का नाम बदलें",
    noName: "अनाम स्प्रेडशीट",
    wait: "अपडेट की प्रतीक्षा में",
    add: "जोड़ें",
    addLast: "नीचे और पंक्तियाँ",
    backTop: "शीर्ष पर वापस जाएँ",
    pageInfo: "कुल ${total}，${totalPage} पृष्ठ，वर्तमान ${currentPage}",
    nextPage: "अगला",
    tipInputNumber: "कृपया संख्या दर्ज करें",
    tipInputNumberLimit: "वृद्धि सीमा 1-100 तक सीमित है",
    tipRowHeightLimit: "पंक्ति की ऊँचाई 0 ~ 545 के बीच होनी चाहिए",
    tipColumnWidthLimit: "कॉलम की चौड़ाई 0 ~ 2038 के बीच होनी चाहिए",
    pageInfoFull: "कुल ${total}，${totalPage} पृष्ठ，सभी डेटा प्रदर्शित"
  },
  currencyDetail: [{
    name: "चीनी युआन",
    pos: "before",
    value: "¥"
  }, {
    name: "अमेरिकी डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "यूरो",
    pos: "before",
    value: "€"
  }, {
    name: "ब्रिटिश पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "हांगकांग डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "जापानी येन",
    pos: "before",
    value: "￥"
  }, {
    name: "अल्बानियाई लेक",
    pos: "before",
    value: "Lek"
  }, {
    name: "अल्जीरियाई दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "अफगानी",
    pos: "after",
    value: "Af"
  }, {
    name: "अर्जेंटीना पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "संयुक्त अरब अमीरात दिरहम",
    pos: "before",
    value: "dh"
  }, {
    name: "अरूबियन फ्लोरिन",
    pos: "before",
    value: "Afl"
  }, {
    name: "ओमानी रियाल",
    pos: "before",
    value: "Rial"
  }, {
    name: "अज़रबैजानी मनात",
    pos: "before",
    value: "?"
  }, {
    name: "मिस्र पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "इथियोपियाई बिर",
    pos: "before",
    value: "Birr"
  }, {
    name: "अंगोलन क्वांज़ा",
    pos: "before",
    value: "Kz"
  }, {
    name: "ऑस्ट्रेलियाई डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "पाटाका",
    pos: "before",
    value: "MOP"
  }, {
    name: "बारबाडोस डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "पापुआ न्यू गिनी किना",
    pos: "before",
    value: "PGK"
  }, {
    name: "बहामी डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "पाकिस्तानी रुपया",
    pos: "before",
    value: "Rs"
  }, {
    name: "परागुआयन गुआरानी",
    pos: "after",
    value: "Gs"
  }, {
    name: "बहरीनी दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "पनामियन बाल्बोआ",
    pos: "before",
    value: "B/"
  }, {
    name: "ब्राज़ीली रियल",
    pos: "before",
    value: "R$"
  }, {
    name: "बेलारूसी रूबल",
    pos: "after",
    value: "р"
  }, {
    name: "बरमूडा डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "बुल्गारियाई लेव",
    pos: "before",
    value: "lev"
  }, {
    name: "आइसलैंड क्रोना",
    pos: "before",
    value: "kr"
  }, {
    name: "बोस्निया-हर्जेगोविना परिवर्तनीय मार्क",
    pos: "before",
    value: "KM"
  }, {
    name: "पोलिश ज़्लॉटी",
    pos: "after",
    value: "z?"
  }, {
    name: "बोलिवियानो",
    pos: "before",
    value: "Bs"
  }, {
    name: "बेलीज़ डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "बोत्सवाना पुला",
    pos: "before",
    value: "P"
  }, {
    name: "नॉट डान्नुज़्हामू",
    pos: "before",
    value: "Nu"
  }, {
    name: "बुरुंडी फ्रैंक",
    pos: "before",
    value: "FBu"
  }, {
    name: "उत्तर कोरियाई वॉन",
    pos: "before",
    value: "?KP"
  }, {
    name: "डेनिश क्रोन",
    pos: "after",
    value: "kr"
  }, {
    name: "पूर्व कैरेबियन डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "डोमिनिका पेसो",
    pos: "before",
    value: "RD$"
  }, {
    name: "रूसी रूबल",
    pos: "after",
    value: "?"
  }, {
    name: "एरिट्रियन नाक्फा",
    pos: "before",
    value: "Nfk"
  }, {
    name: "सीएफए फ्रैंक",
    pos: "before",
    value: "CFA"
  }, {
    name: "फिलिपिनो पेसो",
    pos: "before",
    value: "?"
  }, {
    name: "फिजी डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "केप वर्ड एस्कूडो",
    pos: "before",
    value: "CVE"
  }, {
    name: "फ़ॉकलैंड द्वीप पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "गैंबियन डालासी",
    pos: "before",
    value: "GMD"
  }, {
    name: "कांगोलीज फ्रैंक",
    pos: "before",
    value: "FrCD"
  }, {
    name: "कोलम्बियाई पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "कोस्टा रिकी कोलोन",
    pos: "before",
    value: "?"
  }, {
    name: "क्यूबा पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "क्यूबा परिवर्तनीय पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "गयाना डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "कजाखस्तानी टेंगे",
    pos: "before",
    value: "?"
  }, {
    name: "हैती गॉर्ड",
    pos: "before",
    value: "HTG"
  }, {
    name: "वॉन",
    pos: "before",
    value: "?"
  }, {
    name: "नीदरलैंड एंटीलिज गिल्डर",
    pos: "before",
    value: "NAf."
  }, {
    name: "होंडुरास लेम्पिरास",
    pos: "before",
    value: "L"
  }, {
    name: "जिबूती फ्रैंक",
    pos: "before",
    value: "Fdj"
  }, {
    name: "किर्गिस्तान सोम",
    pos: "before",
    value: "KGS"
  }, {
    name: "गिनी फ्रैंक",
    pos: "before",
    value: "FG"
  }, {
    name: "कनाडाई डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "घनियन सेडी",
    pos: "before",
    value: "GHS"
  }, {
    name: "कंबोडियन रील",
    pos: "before",
    value: "Riel"
  }, {
    name: "चेक कोरुना",
    pos: "after",
    value: "K?"
  }, {
    name: "जिम्बाब्वे डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "कतर रियाल",
    pos: "before",
    value: "Rial"
  }, {
    name: "केमैन द्वीप डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "कोमोरियन फ्रैंक",
    pos: "before",
    value: "CF"
  }, {
    name: "कुवैती दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "क्रोएशियाई कुना",
    pos: "before",
    value: "kn"
  }, {
    name: "केन्याई शिलिंग",
    pos: "before",
    value: "Ksh"
  }, {
    name: "लेसोथो लोटी",
    pos: "before",
    value: "LSL"
  }, {
    name: "लाओ किप",
    pos: "before",
    value: "?"
  }, {
    name: "लेबनानी पाउंड",
    pos: "before",
    value: "L￡"
  }, {
    name: "लिथुआनियाई लितास",
    pos: "before",
    value: "Lt"
  }, {
    name: "लिबियाई दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "लाइबेरियाई डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "रवांडा फ्रैंक",
    pos: "before",
    value: "RF"
  }, {
    name: "रोमानियाई ल्यू",
    pos: "before",
    value: "RON"
  }, {
    name: "मेडागास्कर अरियारी",
    pos: "before",
    value: "Ar"
  }, {
    name: "मालदीवियन रूफिया",
    pos: "before",
    value: "Rf"
  }, {
    name: "मलावी क्वाचा",
    pos: "before",
    value: "MWK"
  }, {
    name: "मलेशियाई रिंगित",
    pos: "before",
    value: "RM"
  }, {
    name: "मैसिडोनिया पहनने वाला दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "मॉरीशस रुपया",
    pos: "before",
    value: "MURs"
  }, {
    name: "मॉरीतानियाई औगुइया",
    pos: "before",
    value: "MRO"
  }, {
    name: "मंगोलियाई टुग्रिक",
    pos: "before",
    value: "?"
  }, {
    name: "बांग्लादेशी टाका",
    pos: "before",
    value: "?"
  }, {
    name: "पेरूवियन न्यूवो सोल",
    pos: "before",
    value: "S/"
  }, {
    name: "म्यांमार क्यात",
    pos: "before",
    value: "K"
  }, {
    name: "मोल्दोवान लेउ",
    pos: "before",
    value: "MDL"
  }, {
    name: "मोरक्को दिरहम",
    pos: "before",
    value: "dh"
  }, {
    name: "मोज़ाम्बिक मेटिकल",
    pos: "before",
    value: "MTn"
  }, {
    name: "मेक्सिकन पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "नामीबियाई डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "दक्षिण अफ्रीकी रैंड",
    pos: "before",
    value: "R"
  }, {
    name: "दक्षिण सूडानी पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "निकारागुआ कोरडोबा",
    pos: "before",
    value: "C$"
  }, {
    name: "नेपाली रुपया",
    pos: "before",
    value: "Rs"
  }, {
    name: "नाइजीरियाई नैरा",
    pos: "before",
    value: "?"
  }, {
    name: "नॉर्वेजियन क्रोन",
    pos: "after",
    value: "kr"
  }, {
    name: "जॉर्जियन लारी",
    pos: "before",
    value: "GEL"
  }, {
    name: "स्वीडिश क्रोना",
    pos: "after",
    value: "kr"
  }, {
    name: "स्विस फ्रैंक",
    pos: "before",
    value: "CHF"
  }, {
    name: "सर्बियाई दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "सिएरा लियोन",
    pos: "before",
    value: "SLL"
  }, {
    name: "सेशेल्स रुपया",
    pos: "before",
    value: "SCR"
  }, {
    name: "सऊदी रियाल",
    pos: "before",
    value: "Rial"
  }, {
    name: "साओ टोम डोबरा",
    pos: "before",
    value: "Db"
  }, {
    name: "सेंट हेलेना पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "श्रीलंकाई रुपया",
    pos: "before",
    value: "Rs"
  }, {
    name: "स्वाज़ीलैंड लिलांगेनी",
    pos: "before",
    value: "SZL"
  }, {
    name: "सूडानी पाउंड",
    pos: "before",
    value: "SDG"
  }, {
    name: "सूरीनामी डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "सोलोमन द्वीप डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "सोमाली शिलिंग",
    pos: "before",
    value: "SOS"
  }, {
    name: "ताजिकिस्तान सोमोनी",
    pos: "before",
    value: "Som"
  }, {
    name: "प्रशांत फ्रैंक",
    pos: "after",
    value: "FCFP"
  }, {
    name: "थाई बहत",
    pos: "before",
    value: "?"
  }, {
    name: "तंजानियाई शिलिंग",
    pos: "before",
    value: "TSh"
  }, {
    name: "टोंगन पाआंगा",
    pos: "before",
    value: "T$"
  }, {
    name: "त्रिनिदाद और टोबैगो डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "ट्यूनीशियाई दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "तुर्की लिरा",
    pos: "before",
    value: "?"
  }, {
    name: "वानुअतु वतू",
    pos: "before",
    value: "VUV"
  }, {
    name: "ग्वाटेमाला क्वेत्ज़ल",
    pos: "before",
    value: "Q"
  }, {
    name: "कमीशन बोलिवर",
    pos: "before",
    value: "Bs"
  }, {
    name: "ब्रुनेई डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "युगांडा शिलिंग",
    pos: "before",
    value: "UGX"
  }, {
    name: "यूक्रेनी रिव्निया",
    pos: "before",
    value: "грн."
  }, {
    name: "उरुग्वियन पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "उज़्बेकिस्तान सोम",
    pos: "before",
    value: "so?m"
  }, {
    name: "पश्चिमी समोआ ताला",
    pos: "before",
    value: "WST"
  }, {
    name: "सिंगापुर डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "एनटी",
    pos: "before",
    value: "NT$"
  }, {
    name: "न्यूजीलैंड डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "हंगेरियन फोरिंट",
    pos: "before",
    value: "Ft"
  }, {
    name: "सीरियाई पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "जमैका डॉलर",
    pos: "before",
    value: "$"
  }, {
    name: "आर्मेनियाई द्राम",
    pos: "before",
    value: "Dram"
  }, {
    name: "येमनी रियाल",
    pos: "before",
    value: "Rial"
  }, {
    name: "इराकी दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "ईरानी रियाल",
    pos: "before",
    value: "Rial"
  }, {
    name: "नया इज़राइली शेकेल",
    pos: "before",
    value: "?"
  }, {
    name: "भारतीय रुपया",
    pos: "before",
    value: "₹"
  }, {
    name: "इंडोनेशियाई रुपिया",
    pos: "before",
    value: "Rp"
  }, {
    name: "जॉर्डनियन दिनार",
    pos: "before",
    value: "din"
  }, {
    name: "वीएनडी",
    pos: "after",
    value: "?"
  }, {
    name: "ज़ाम्बियन क्वाचा",
    pos: "before",
    value: "ZMW"
  }, {
    name: "जिब्राल्टर पाउंड",
    pos: "before",
    value: "￡"
  }, {
    name: "चिली पेसो",
    pos: "before",
    value: "$"
  }, {
    name: "सीएफए फ्रैंक बीईएसी",
    pos: "before",
    value: "FCFA"
  }],
  defaultFmt: function defaultFmt(currency) {
    return [{
      text: "स्वचालित",
      value: "General",
      example: ""
    }, {
      text: "सादा टेक्स्ट",
      value: "@",
      example: ""
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "संख्या",
      value: "##0.00",
      example: "1000.12"
    }, {
      text: "प्रतिशत",
      value: "#0.00%",
      example: "12.21%"
    }, {
      text: "वैज्ञानिक",
      value: "0.00E+00",
      example: "1.01E+5"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "लेखांकन",
      value: "".concat(currency, "(0.00)"),
      example: "".concat(currency, "(1200.09)")
    }, {
      text: "मुद्रा",
      value: "".concat(currency, "0.00"),
      example: "".concat(currency, "1200.09")
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "दिनांक",
      value: "yyyy-MM-dd",
      example: "2017-11-29"
    }, {
      text: "समय",
      value: "hh:mm AM/PM",
      example: "3:00 PM"
    }, {
      text: "24 घंटे का समय",
      value: "hh:mm",
      example: "15:00"
    }, {
      text: "दिनांक समय",
      value: "yyyy-MM-dd hh:mm AM/PM",
      example: "2017-11-29 3:00 PM"
    }, {
      text: "दिनांक समय 24 घंटे",
      value: "yyyy-MM-dd hh:mm",
      example: "2017-11-29 15:00"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "कस्टम फॉर्मेट",
      value: "fmtOtherSelf",
      example: "",
      icon: "rightArrow"
    }];
  },
  dateFmtList: [{
    name: "1930-08-05",
    value: "yyyy-MM-dd"
  }, {
    name: "1930/8/5",
    value: "yyyy/MM/dd"
  }, {
    name: "08-05",
    value: "MM-dd"
  }, {
    name: "8-5",
    value: "M-d"
  }, {
    name: "13:30:30",
    value: "h:mm:ss"
  }, {
    name: "13:30",
    value: "h:mm"
  }, {
    name: "PM 01:30",
    value: "AM/PM hh:mm"
  }, {
    name: "PM 1:30",
    value: "AM/PM h:mm"
  }, {
    name: "PM 1:30:30",
    value: "AM/PM h:mm:ss"
  }, {
    name: "08-05 PM 01:30",
    value: "MM-dd AM/PM hh:mm"
  }],
  fontFamily: {
    MicrosoftYaHei: "YaHei"
  },
  fontarray: ["Times New Roman", "Arial", "Tahoma", "Verdana"],
  fontjson: {
    "times new roman": 0,
    arial: 1,
    tahoma: 2,
    verdana: 3
  },
  border: {
    borderTop: "ऊपरी सीमा",
    borderBottom: "निचली सीमा",
    borderLeft: "बाईं सीमा",
    borderRight: "दाईं सीमा",
    borderNone: "कोई सीमा नहीं",
    borderAll: "सभी सीमाएँ",
    borderOutside: "बाहरी सीमा",
    borderInside: "भीतरी सीमा",
    borderHorizontal: "क्षैतिज सीमाएँ",
    borderVertical: "लंबवत सीमाएँ",
    borderColor: "सीमा का रंग",
    borderSize: "सीमा का आकार",
    borderSlash: "तिरछी सीमा",
    borderDefault: "डिफ़ॉल्ट",
    borderStyle: "सीमा की शैली"
  },
  merge: {
    mergeAll: "सभी को मिलाएँ",
    mergeV: "लंबवत मिलाएँ",
    mergeH: "क्षैतिज मिलाएँ",
    mergeCancel: "मिलाना रद्द करें",
    overlappingError: "ओवरलैपिंग क्षेत्रों को मिला नहीं सकते",
    partiallyError: "आंशिक रूप से मिले हुए सेल पर यह कार्य नहीं किया जा सकता"
  },
  align: {
    left: "बाएँ",
    center: "मध्य",
    right: "दाएँ",
    top: "ऊपर",
    middle: "मध्य",
    bottom: "नीचे"
  },
  textWrap: {
    overflow: "ओवरफ्लो",
    wrap: "रैप",
    clip: "क्लिप"
  },
  rotation: {
    none: "कोई नहीं",
    angleup: "ऊपर की ओर झुकाएँ",
    angledown: "नीचे की ओर झुकाएँ",
    vertical: "लंबवत स्टैक करें",
    rotationUp: "ऊपर की ओर घुमाएँ",
    rotationDown: "नीचे की ओर घुमाएँ"
  },
  freezen: {
    default: "फ्रीज़ करें",
    freezenRow: "पहली पंक्ति",
    freezenColumn: "पहला कॉलम",
    freezenRC: "दोनों",
    freezenRowRange: "वर्तमान पंक्ति तक फ्रीज़ करें",
    freezenColumnRange: "वर्तमान कॉलम तक फ्रीज़ करें",
    freezenRCRange: "वर्तमान सेल तक फ्रीज़ करें",
    freezenCancel: "फ्रीज़िंग रद्द करें",
    noSeletionError: "कोई रेंज चयनित नहीं है",
    rangeRCOverErrorTitle: "फ्रीज़ अनुस्मारक",
    rangeRCOverError: "फ्रोज़न पेन दृश्यमान सीमा से परे है, जो असामान्य संचालन का कारण बनेगा। कृपया फ्रोज़न क्षेत्र को रीसेट करें।"
  },
  sort: {
    asc: "आरोही क्रम ",
    desc: "अवरोही क्रम ",
    custom: "कस्टम सॉर्ट",
    hasTitle: "डेटा में शीर्षक पंक्ति है",
    sortBy: "इसके अनुसार सॉर्ट करें",
    addOthers: "एक और सॉर्ट कॉलम जोड़ें",
    close: "बंद करें",
    confirm: "सॉर्ट करें",
    columnOperation: "कॉलम",
    secondaryTitle: "फिर इसके अनुसार",
    sortTitle: "रेंज सॉर्ट करें",
    sortRangeTitle: "इससे रेंज सॉर्ट करें",
    sortRangeTitleTo: "इस तक",
    noRangeError: "एकाधिक चयन क्षेत्रों पर यह कार्य नहीं किया जा सकता, कृपया एक रेंज चुनें और फिर से प्रयास करें",
    mergeError: "चयन में मर्ज किए गए सेल हैं, यह कार्य नहीं किया जा सकता!"
  },
  filter: {
    filter: "फ़िल्टर बनाएँ",
    sortByAsc: "आरोही क्रम में छाँटें",
    sortByDesc: "अवरोही क्रम में छाँटें",
    filterByColor: "रंग के आधार पर फ़िल्टर करें",
    filterByCondition: "शर्त के आधार पर फ़िल्टर करें",
    filterByValues: "मान के आधार पर फ़िल्टर करें",
    filiterInputNone: "कोई नहीं",
    filiterInputTip: "फ़िल्टर मान दर्ज करें",
    filiterRangeStartTip: "सूत्र के लिए मान",
    filiterRangeEndTip: "सूत्र के लिए मान",
    filterValueByAllBtn: "सभी को चुनें",
    filterValueByClearBtn: "साफ़ करें",
    filterValueByInverseBtn: "विपरीत",
    filterValueByTip: "मान के आधार पर फ़िल्टर करें",
    filterConform: "पुष्टि करें",
    filterCancel: "रद्द करें",
    clearFilter: "फ़िल्टर साफ़ करें",
    conditionNone: "कोई नहीं",
    conditionCellIsNull: "खाली है",
    conditionCellNotNull: "खाली नहीं है",
    conditionCellTextContain: "टेक्स्ट में शामिल है",
    conditionCellTextNotContain: "टेक्स्ट में शामिल नहीं है",
    conditionCellTextStart: "टेक्स्ट इससे शुरू होता है",
    conditionCellTextEnd: "टेक्स्ट इस पर समाप्त होता है",
    conditionCellTextEqual: "टेक्स्ट बिल्कुल यही है",
    conditionCellDateEqual: "तिथि है",
    conditionCellDateBefore: "तिथि इससे पहले है",
    conditionCellDateAfter: "तिथि इसके बाद है",
    conditionCellGreater: "इससे बड़ा",
    conditionCellGreaterEqual: "इससे बड़ा या बराबर",
    conditionCellLess: "इससे छोटा",
    conditionCellLessEqual: "इससे छोटा या बराबर",
    conditionCellEqual: "इसके बराबर है",
    conditionCellNotEqual: "इसके बराबर नहीं है",
    conditionCellBetween: "इसके बीच में है",
    conditionCellNotBetween: "इसके बीच में नहीं है",
    filiterMoreDataTip: "बड़ी मात्रा में डेटा! कृपया प्रतीक्षा करें",
    filiterMonthText: "महीना",
    filiterYearText: "वर्ष",
    filiterByColorTip: "सेल के रंग के आधार पर फ़िल्टर करें",
    filiterByTextColorTip: "फ़ॉन्ट के रंग के आधार पर फ़िल्टर करें",
    filterContainerOneColorTip: "इस कॉलम में केवल एक रंग है",
    filterDateFormatTip: "दिनांक प्रारूप",
    valueBlank: "(रिक्त)",
    mergeError: "फ़िल्टर चयन में मर्ज किए गए सेल हैं, यह कार्य नहीं किया जा सकता!"
  },
  rightclick: {
    copy: "कॉपी",
    copyAs: "के रूप में कॉपी करें",
    paste: "पेस्ट",
    insert: "डालें",
    image: "चित्र डालें",
    link: "लिंक डालें",
    delete: "हटाएं",
    deleteCell: "सेल हटाएं",
    deleteSelected: "चयनित हटाएं",
    hide: "छुपाएं",
    hideSelected: "चयनित छुपाएं",
    showHide: "छुपाए हुए दिखाएं",
    to: "की ओर",
    left: "बाएं",
    right: "दाएं",
    top: "ऊपर",
    bottom: "नीचे",
    moveLeft: "बाएं जाएं",
    moveUp: "ऊपर जाएं",
    add: "जोड़ें",
    row: "पंक्ति",
    column: "स्तंभ",
    width: "चौड़ाई",
    height: "ऊंचाई",
    number: "संख्या",
    confirm: "पुष्टि करें",
    orderAZ: "आरोही क्रम में",
    orderZA: "अवरोही क्रम में",
    clearContent: "कॉन्टेंट साफ करें",
    matrix: "मैट्रिक्स ऑपरेशन",
    sortSelection: "सॉर्ट करें",
    filterSelection: "फिल्टर करें",
    chartGeneration: "चार्ट बनाएं",
    firstLineTitle: "पहली पंक्ति शीर्षक",
    untitled: "शीर्षक रहित",
    array1: "एक आयामी ऐरे",
    array2: "दो आयामी ऐरे",
    array3: "बहुआयामी ऐरे",
    diagonal: "तिरछा",
    antiDiagonal: "विपरीत तिरछा",
    diagonalOffset: "तिरछा ऑफसेट",
    offset: "ऑफसेट",
    boolean: "बूलियन",
    flip: "फ्लिप करें",
    upAndDown: "ऊपर और नीचे",
    leftAndRight: "बाएं और दाएं",
    clockwise: "घड़ी की दिशा में",
    counterclockwise: "घड़ी की विपरीत दिशा में",
    transpose: "ट्रांसपोज़ करें",
    matrixCalculation: "मैट्रिक्स गणना",
    plus: "जोड़ें",
    minus: "घटाएं",
    multiply: "गुणा",
    divided: "विभाजित",
    power: "पावर",
    root: "रूट",
    log: "लॉग",
    delete0: "दोनों सिरों पर 0 मान हटाएं",
    removeDuplicate: "डुप्लिकेट मान हटाएं",
    byRow: "पंक्ति द्वारा",
    byCol: "स्तंभ द्वारा",
    generateNewMatrix: "नया मैट्रिक्स बनाएं",
    noMulti: "कई चयन क्षेत्रों पर यह ऑपरेशन नहीं कर सकते, कृपया एकल क्षेत्र का चयन करें",
    cannotDeleteAllRow: "सभी पंक्तियाँ नहीं हटा सकते",
    cannotDeleteAllColumn: "सभी स्तंभ नहीं हटा सकते",
    cannotDeleteRowReadOnly: "पंक्ति केवल-पढ़ने के लिए हटाई नहीं जा सकती",
    cannotDeleteColumnReadOnly: "स्तंभ केवल-पढ़ने के लिए हटाई नहीं जा सकती",
    cannotInsertOnRowReadOnly: "केवल-पढ़ने की पंक्ति पर सम्मिलित नहीं कर सकते",
    cannotInsertOnColumnReadOnly: "केवल-पढ़ने के स्तंभ पर सम्मिलित नहीं कर सकते",
    rowOverLimit: "10000 पंक्ति सीमा पार हो गई",
    columnOverLimit: "1000 स्तंभ सीमा पार हो गई"
  },
  comment: {
    insert: "डालें",
    edit: "संपादित करें",
    delete: "हटाएं",
    showOne: "दिखाएं/छुपाएं",
    showAll: "सभी दिखाएं/छुपाएं"
  },
  screenshot: {
    screenshotTipNoSelection: "कृपया स्क्रीनशॉट का दायरा चुनें",
    screenshotTipTitle: "चेतावनी!",
    screenshotTipHasMerge: "यह ऑपरेशन मर्ज किए गए सेल्स पर नहीं किया जा सकता",
    screenshotTipHasMulti: "यह ऑपरेशन कई चयन क्षेत्रों पर नहीं किया जा सकता",
    screenshotTipSuccess: "सफल",
    screenshotImageName: "स्क्रीनशॉट",
    downLoadClose: "बंद करें",
    downLoadCopy: "क्लिपबोर्ड पर कॉपी करें",
    downLoadBtn: "डाउनलोड",
    browserNotTip: "IE ब्राउज़र द्वारा समर्थित नहीं!",
    rightclickTip: 'कृपया चित्र पर राइट-क्लिक "कॉपी" करें',
    successTip: 'सफलतापूर्वक (यदि पेस्ट करना विफल हो जाए, तो कृपया चित्र पर राइट-क्लिक करें और "कॉपी इमेज" चुनें)'
  },
  splitText: {
    splitDelimiters: "डिलिमिटर्स",
    splitOther: "अन्य",
    splitContinueSymbol: "लगातार विभाजक एकल के रूप में माने जाते हैं",
    splitDataPreview: "पूर्वावलोकन",
    splitTextTitle: "पाठ विभाजित करें",
    splitConfirmToExe: "यहां पहले से डेटा है, क्या आप इसे बदलना चाहते हैं?",
    splitSymbols: [{
      name: "टैब",
      value: "Tab"
    }, {
      name: "अर्धविराम",
      value: "semicolon"
    }, {
      name: "अल्पविराम",
      value: "comma"
    }, {
      name: "स्थान",
      value: "space"
    }],
    tipNoMulti: "कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल क्षेत्र का चयन करें और पुनः प्रयास करें",
    tipNoMultiColumn: "एक समय में केवल एक ही कॉलम के डेटा को परिवर्तित किया जा सकता है। चयनित क्षेत्र में कई पंक्तियाँ हो सकती हैं लेकिन कई कॉलम नहीं। कृपया एकल कॉलम सीमा का चयन करने के बाद पुनः प्रयास करें",
    tipNoSelect: "चयन किए बिना आप एक सेल को अलग नहीं कर सकते"
  },
  imageText: {
    imageSetting: "छवि सेटिंग",
    close: "बंद करें",
    conventional: "पारंपरिक",
    moveCell1: "सेल्स को स्थानांतरित और आकार बदलें",
    moveCell2: "सेल्स को स्थानांतरित करें और आकार न बदलें",
    moveCell3: "सेल्स को न स्थानांतरित करें और आकार बदलें",
    fixedPos: "स्थिर स्थिति",
    border: "सीमा",
    width: "चौड़ाई",
    radius: "त्रिज्या",
    style: "शैली",
    solid: "ठोस",
    dashed: "डैश्ड",
    dotted: "डॉटेड",
    double: "डबल",
    color: "रंग"
  },
  punctuation: {
    tab: "टैब",
    semicolon: "अर्धविराम",
    comma: "अल्पविराम",
    space: "स्थान"
  },
  findAndReplace: {
    find: "खोजें",
    replace: "बदलें",
    goto: "जाएं",
    location: "स्थान",
    formula: "सूत्र",
    date: "तिथि",
    number: "संख्या",
    string: "स्ट्रिंग",
    error: "त्रुटि",
    condition: "शर्त",
    rowSpan: "पंक्ति विस्तार",
    columnSpan: "स्तंभ विस्तार",
    locationExample: "स्थान",
    lessTwoRowTip: "कृपया कम से कम दो पंक्तियाँ चुनें",
    lessTwoColumnTip: "कृपया कम से कम दो स्तंभ चुनें",
    findTextbox: "खोज सामग्री",
    replaceTextbox: "सामग्री बदलें",
    regexTextbox: "नियमित अभिव्यक्ति",
    wholeTextbox: "पूरा शब्द",
    distinguishTextbox: "केस संवेदनशील",
    allReplaceBtn: "सभी बदलें",
    replaceBtn: "बदलें",
    allFindBtn: "सभी खोजें",
    findBtn: "अगला खोजें",
    noFindTip: "सामग्री नहीं मिली",
    modeTip: "यह ऑपरेशन इस मोड में उपलब्ध नहीं है",
    searchTargetSheet: "शीट",
    searchTargetCell: "सेल",
    searchTargetValue: "मूल्य",
    searchInputTip: "कृपया खोज सामग्री दर्ज करें",
    noReplceTip: "बदलने के लिए कुछ नहीं है",
    noMatchTip: "कोई मेल नहीं मिला",
    successTip: "${xlength} आइटम मिले",
    locationConstant: "स्थिरांक",
    locationFormula: "सूत्र",
    locationDate: "तिथि",
    locationDigital: "संख्या",
    locationString: "स्ट्रिंग",
    locationBool: "लॉजिकल",
    locationError: "त्रुटि",
    locationNull: "शून्य",
    locationCondition: "शर्तीय प्रारूप",
    locationRowSpan: "पंक्ति विस्तार",
    locationColumnSpan: "स्तंभ विस्तार",
    locationTiplessTwoRow: "कृपया कम से कम दो पंक्तियाँ चुनें",
    locationTiplessTwoColumn: "कृपया कम से कम दो स्तंभ चुनें",
    locationTipNotFindCell: "सेल नहीं मिला"
  },
  sheetconfig: {
    delete: "हटाएं",
    copy: "कॉपी करें",
    rename: "नाम बदलें",
    changeColor: "रंग बदलें",
    hide: "छुपाएं",
    unhide: "छुपा हुआ दिखाएं",
    moveLeft: "बाएं जाएं",
    moveRight: "दाएं जाएं",
    resetColor: "रंग रीसेट करें",
    cancelText: "रद्द करें",
    chooseText: "रंग की पुष्टि करें",
    focus: "फोकस करें",
    tipNameRepeat: "टैब पृष्ठ का नाम दोहराया नहीं जा सकता! कृपया संशोधित करें",
    noMoreSheet: "वर्कबुक में कम से कम एक दृश्य वर्कशीट होनी चाहिए। चयनित वर्कशीट को हटाने के लिए, कृपया एक नई वर्कशीट जोड़ें या एक छुपी हुई वर्कशीट दिखाएं।",
    confirmDelete: "क्या आप वाकई हटाना चाहते हैं",
    redoDelete: "Ctrl+Z द्वारा पूर्ववत किया जा सकता है",
    noHide: "छुपा नहीं सकते, कम से कम एक शीट टैग रखना आवश्यक है",
    chartEditNoOpt: "चार्ट संपादन मोड में यह ऑपरेशन अनुमत नहीं है!",
    sheetNameSpecCharError: "नाम में यह नहीं हो सकता: [ ] :  ? * / ' \"",
    sheetNamecannotIsEmptyError: "शीट का नाम खाली नहीं हो सकता"
  },
  conditionformat: {
    conditionformat_greaterThan: "Conditionformat-GreaterThan",
    conditionformat_greaterThan_title: "से बड़ी कोशिकाओं को प्रारूपित करें",
    conditionformat_lessThan: "Conditionformat-LessThan",
    conditionformat_lessThan_title: "से छोटी कोशिकाओं को प्रारूपित करें",
    conditionformat_between: "Conditionformat-Betweenness",
    conditionformat_between_title: "के बीच में मान वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_equal: "Conditionformat-Equal",
    conditionformat_equal_title: "के बराबर कोशिकाओं को प्रारूपित करें",
    conditionformat_textContains: "Conditionformat-TextContains",
    conditionformat_textContains_title: "निम्नलिखित पाठ वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_occurrenceDate: "Conditionformat-OccurrenceDate",
    conditionformat_occurrenceDate_title: "निम्नलिखित तिथियों वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_duplicateValue: "Conditionformat-DuplicateValue",
    conditionformat_duplicateValue_title: "निम्नलिखित प्रकार के मान वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_top10: "Conditionformat-Top10",
    conditionformat_top10_percent: "Conditionformat-Top10%",
    conditionformat_top10_title: "सबसे ऊंचे मान वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_last10: "Conditionformat-Last10",
    conditionformat_last10_percent: "Conditionformat-Last10%",
    conditionformat_last10_title: "सबसे छोटे मान वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_aboveAverage: "Conditionformat-AboveAverage",
    conditionformat_aboveAverage_title: "औसत से ऊपर वाली कोशिकाओं को प्रारूपित करें",
    conditionformat_belowAverage: "Conditionformat-SubAverage",
    conditionformat_belowAverage_title: "औसत से नीचे वाली कोशिकाओं को प्रारूपित करें",
    rule: "नियम",
    newRule: "नया नियम",
    editRule: "नियम संपादित करें",
    deleteRule: "नियम हटाएं",
    deleteCellRule: "कोशिका का नियम हटाएं",
    deleteSheetRule: "शीट का नियम हटाएं",
    manageRules: "प्रबंधन नियम",
    showRules: "इसके प्रारूपण नियम दिखाएं",
    highlightCellRules: "कोशिका नियम हाइलाइट करें",
    itemSelectionRules: "आइटम चयन नियम",
    conditionformatManageRules: "शर्तीय प्रारूपण नियम प्रबंधक",
    format: "प्रारूप",
    setFormat: "प्रारूप सेट करें",
    setAs: "के रूप में सेट करें",
    setAsByArea: "चयनित क्षेत्र के लिए, सेट करें",
    applyRange: "लागू सीमा",
    selectRange: "आवेदन सीमा का चयन करें",
    selectRange_percent: "चयनित सीमा का प्रतिशत",
    selectRange_average: "चयनित सीमा का औसत मान",
    selectRange_value: "चयनित सीमा में मान",
    pleaseSelectRange: "कृपया आवेदन सीमा का चयन करें",
    selectDataRange: "डेटा सीमा का चयन करें",
    selectCell: "कोशिका का चयन करें",
    pleaseSelectCell: "कृपया कोशिका का चयन करें",
    pleaseSelectADate: "कृपया एक तिथि चुनें",
    pleaseEnterInteger: "कृपया 1 और 1000 के बीच एक पूर्णांक दर्ज करें",
    onlySingleCell: "केवल एकल कोशिका संदर्भित की जा सकती है",
    conditionValueCanOnly: "शर्त मान केवल एक संख्या या एकल कोशिका हो सकता है",
    ruleTypeItem1: "उनके संबंधित मूल्यों के आधार पर सभी कोशिकाओं को प्रारूपित करें",
    ruleTypeItem2: "केवल उन कोशिकाओं को प्रारूपित करें जिनमें",
    ruleTypeItem2_title: "केवल उन कोशिकाओं के लिए जो निम्नलिखित शर्तों को पूरा करती हैं",
    ruleTypeItem3: "केवल शीर्ष या निचले नंबरों को प्रारूपित करें",
    ruleTypeItem3_title: "निम्न रैंकिंग में मान है",
    ruleTypeItem4: "केवल औसत से ऊपर या नीचे के मानों को प्रारूपित करें",
    ruleTypeItem4_title: "एक मान है जो निम्नलिखित शर्तों को पूरा करता है",
    ruleTypeItem5: "केवल अद्वितीय या दोहराए गए मानों को प्रारूपित करें",
    ruleTypeItem6: "उन कोशिकाओं को प्रारूपित करने के लिए सूत्रों का उपयोग करें जो प्रारूपित की जानी चाहिए",
    formula: "सूत्र",
    textColor: "पाठ का रंग",
    cellColor: "कोशिका का रंग",
    confirm: "पुष्टि करें",
    confirmColor: "रंग की पुष्टि करें",
    cancel: "रद्द करें",
    close: "बंद करें",
    clearColorSelect: "रंग चयन साफ करें",
    sheet: "शीट",
    currentSheet: "वर्तमान शीट",
    dataBar: "डेटा बार",
    dataBarColor: "डेटा बार का रंग",
    gradientDataBar_1: "नीला-सफेद ग्रेडिएंट डेटा बार",
    gradientDataBar_2: "हरा-सफेद ग्रेडिएंट डेटा बार",
    gradientDataBar_3: "लाल-सफेद ग्रेडिएंट डेटा बार",
    gradientDataBar_4: "नारंगी-सफेद ग्रेडिएंट स्ट्राइप्स",
    gradientDataBar_5: "हल्का नीला-सफेद ग्रेडिएंट स्ट्राइप्स",
    gradientDataBar_6: "बैंगनी-सफेद ग्रेडिएंट डेटा बार",
    solidColorDataBar_1: "नीला डेटा बार",
    solidColorDataBar_2: "हरा डेटा बार",
    solidColorDataBar_3: "लाल डेटा बार",
    solidColorDataBar_4: "नारंगी डेटा बार",
    solidColorDataBar_5: "हल्का नीला डेटा बार",
    solidColorDataBar_6: "बैंगनी डेटा बार",
    colorGradation: "रंग ग्रेडिएशन",
    colorGradation_1: "हरा-पीला-लाल रंग ग्रेडिएशन",
    colorGradation_2: "लाल-पीला-हरा रंग ग्रेडिएशन",
    colorGradation_3: "हरा-सफेद-लाल रंग ग्रेडिएशन",
    colorGradation_4: "लाल-सफेद-हरा रंग ग्रेडिएशन",
    colorGradation_5: "नीला-सफेद-लाल रंग ग्रेडिएशन",
    colorGradation_6: "लाल-सफेद-नीला रंग ग्रेडिएशन",
    colorGradation_7: "सफेद-लाल रंग ग्रेडिएशन",
    colorGradation_8: "लाल-सफेद रंग ग्रेडिएशन",
    colorGradation_9: "हरा-सफेद रंग ग्रेडिएशन",
    colorGradation_10: "सफेद-हरा रंग ग्रेडिएशन",
    colorGradation_11: "हरा-पीला रंग ग्रेडिएशन",
    colorGradation_12: "पीला-हरा रंग ग्रेडिएशन",
    icons: "आइकन",
    pleaseSelectIcon: "कृपया आइकनों के एक समूह का चयन करने के लिए क्लिक करें:",
    cellValue: "कोशिका मान",
    specificText: "विशिष्ट पाठ",
    occurrenceDate: "तिथि",
    greaterThan: "से बड़ा",
    lessThan: "से छोटा",
    between: "के बीच",
    equal: "बराबर",
    in: "में",
    between2: "",
    contain: "शामिल",
    textContains: "पाठ शामिल है",
    duplicateValue: "डुप्लिकेट मान",
    uniqueValue: "अद्वितीय मान",
    top: "शीर्ष",
    top10: "शीर्ष 10",
    top10_percent: "शीर्ष 10%",
    last: "अंतिम",
    last10: "अंतिम 10",
    last10_percent: "अंतिम 10%",
    oneself: "",
    above: "ऊपर",
    aboveAverage: "औसत से ऊपर",
    below: "नीचे",
    belowAverage: "औसत से नीचे",
    all: "सभी",
    yesterday: "YTD",
    today: "आज",
    tomorrow: "कल",
    lastWeek: "पिछला सप्ताह",
    thisWeek: "इस सप्ताह",
    lastMonth: "पिछला महीना",
    thisMonth: "इस महीने",
    lastYear: "पिछले साल",
    thisYear: "इस साल",
    last7days: "पिछले 7 दिन",
    last30days: "पिछले 30 दिन",
    next7days: "अगले 7 दिन",
    next30days: "अगले 30 दिन",
    next60days: "अगले 60 दिन",
    chooseRuleType: "नियम प्रकार चुनें",
    editRuleDescription: "नियम विवरण संपादित करें",
    newFormatRule: "नया प्रारूप नियम",
    editFormatRule: "प्रारूप नियम संपादित करें",
    formatStyle: "शैली",
    fillType: "भरें",
    color: "रंग",
    twocolor: "दो रंग",
    tricolor: "तीन रंग",
    multicolor: "अनेक रंग",
    grayColor: "धूसर रंग",
    gradient: "ग्रेडिएंट",
    solid: "ठोस",
    maxValue: "अधिकतम मान",
    medianValue: "मध्य मान",
    minValue: "न्यूनतम मान",
    direction: "दिशा",
    threeWayArrow: "तीन-तरफा तीर",
    fourWayArrow: "चार-तरफा तीर",
    fiveWayArrow: "पांच-तरफा तीर",
    threeTriangles: "तीन त्रिकोण",
    shape: "आकार",
    threeColorTrafficLight: "तीन-रंग ट्रैफिक लाइट",
    fourColorTrafficLight: "चार-रंग ट्रैफिक लाइट",
    threeSigns: "तीन संकेत",
    greenRedBlackGradient: "हरा-लाल-काला ग्रेडिएंट",
    rimless: "बिना किनारे वाला",
    bordered: "किनारे वाला",
    mark: "चिह्न",
    threeSymbols: "तीन प्रतीक",
    tricolorFlag: "तीन-रंग का ध्वज",
    circled: "वृत्ताकार",
    noCircle: "कोई वृत्त नहीं",
    grade: "ग्रेड",
    grade4: "4 ग्रेड",
    grade5: "5 ग्रेड",
    threeStars: "3 सितारे",
    fiveQuadrantDiagram: "पांच-खंड आरेख",
    fiveBoxes: "5 बॉक्स"
  },
  insertLink: {
    linkText: "प्रदर्शित पाठ",
    linkType: "लिंक प्रकार",
    linkAddress: "लिंक पता",
    linkSheet: "वर्कशीट",
    linkCell: "सेल रेंज",
    linkTooltip: "टूलटिप",
    selectCellRange: "सेल रेंज चुनें",
    cellRangePlaceholder: "कर्सर का उपयोग करके या सीधे दर्ज करके कोशिकाएँ चुनें",
    placeholder1: "कृपया वेब लिंक पता दर्ज करें",
    placeholder2: "कृपया उद्धृत करने के लिए सेल दर्ज करें, उदाहरण A1",
    placeholder3: "कृपया संकेत सामग्री दर्ज करें",
    tooltipInfo1: "कृपया एक मान्य लिंक दर्ज करें",
    invalidCellRangeTip: "कृपया सही सेल रेंज दर्ज करें, जैसे Sheet1!A1:C8",
    openLink: "लिंक खोलें",
    goTo: "${linkAddress} पर जाएं"
  },
  linkTypeList: [{
    text: "वेबसाइट",
    value: "webpage"
  }, {
    text: "सेल रेंज",
    value: "cellrange"
  }, {
    text: "शीट",
    value: "sheet"
  }],
  dataVerification: {
    cellRange: "सेल रेंज",
    selectCellRange: "सेल रेंज चुनने के लिए क्लिक करें",
    selectCellRange2: "कृपया सेल की रेंज चुनें",
    verificationCondition: "सत्यापन शर्त",
    allowMultiSelect: "कई चयन की अनुमति दें",
    dropdown: "ड्रॉप-डाउन सूची",
    checkbox: "चेकबॉक्स",
    number: "संख्या",
    number_integer: "संख्या-पूर्णांक",
    number_decimal: "संख्या-दशमलव",
    text_content: "पाठ-सामग्री",
    text_length: "पाठ-लंबाई",
    date: "तिथि",
    validity: "प्रभावशीलता",
    placeholder1: "कृपया विकल्प दर्ज करें, अल्पविराम से अलग करें, जैसे 1,2,3,4,5",
    placeholder2: "कृपया सामग्री दर्ज करें",
    placeholder3: "संख्यात्मक मान, जैसे 10",
    placeholder4: "कृपया निर्दिष्ट पाठ दर्ज करें",
    placeholder5: "कृपया वह संकेत दर्ज करें जो सेल चुने जाने पर प्रदर्शित होता है",
    selected: "चयनित",
    notSelected: "चयनित नहीं",
    between: "के बीच",
    notBetween: "के बीच नहीं",
    equal: "बराबर",
    notEqualTo: "के बराबर नहीं",
    moreThanThe: "से अधिक",
    lessThan: "से कम",
    greaterOrEqualTo: "के बराबर या अधिक",
    lessThanOrEqualTo: "के बराबर या कम",
    include: "शामिल",
    exclude: "बहिष्कृत",
    earlierThan: "से पहले",
    noEarlierThan: "से पहले नहीं",
    laterThan: "के बाद",
    noLaterThan: "के बाद नहीं",
    identificationNumber: "पहचान संख्या",
    phoneNumber: "फोन नंबर",
    remote: "स्वचालित दूरस्थ अधिग्रहण विकल्प",
    prohibitInput: "डेटा अमान्य होने पर इनपुट निषिद्ध करें",
    hintShow: "सेल चुने जाने पर संकेत दिखाएं",
    deleteVerification: "सत्यापन हटाएं",
    tooltipInfo1: "ड्रॉप-डाउन सूची विकल्प खाली नहीं हो सकता",
    tooltipInfo2: "चेकबॉक्स सामग्री खाली नहीं हो सकती",
    tooltipInfo3: "दर्ज किया गया मान संख्यात्मक प्रकार का नहीं है",
    tooltipInfo4: "मान 2 मान 1 से कम नहीं हो सकता",
    tooltipInfo5: "पाठ सामग्री खाली नहीं हो सकती",
    tooltipInfo6: "दर्ज किया गया मान तिथि प्रकार का नहीं है",
    tooltipInfo7: "तिथि 2 तिथि 1 से कम नहीं हो सकती",
    textlengthInteger: "पाठ की लंबाई 0 या उससे अधिक का पूर्णांक होना चाहिए"
  },
  formula: {
    sum: "योग",
    average: "औसत",
    count: "गिनती",
    max: "अधिकतम",
    min: "न्यूनतम",
    ifGenerate: "If सूत्र जेनरेटर",
    find: "और जानें",
    tipNotBelongToIf: "यह सेल फंक्शन If सूत्र से संबंधित नहीं है!",
    tipSelectCell: "कृपया फंक्शन डालने के लिए सेल का चयन करें",
    ifGenCompareValueTitle: "तुलना मूल्य",
    ifGenSelectCellTitle: "सेल का चयन करने के लिए क्लिक करें",
    ifGenRangeTitle: "रेंज",
    ifGenRangeTo: "से",
    ifGenRangeEvaluate: "रेंज का मूल्यांकन करें",
    ifGenSelectRangeTitle: "रेंज का चयन करने के लिए क्लिक करें",
    ifGenCutWay: "विभाजन का तरीका",
    ifGenCutSame: "समान विभाजन मूल्य",
    ifGenCutNpiece: "N द्वारा विभाजन",
    ifGenCutCustom: "कस्टम",
    ifGenCutConfirm: "पुष्टि करें",
    ifGenTipSelectCell: "सेल चुनें",
    ifGenTipSelectCellPlace: "कृपया सेल चुनें",
    ifGenTipSelectRange: "रेंज चुनें",
    ifGenTipSelectRangePlace: "कृपया रेंज चुनें",
    ifGenTipNotNullValue: "तुलना मूल्य खाली नहीं हो सकता!",
    ifGenTipLableTitile: "लेबल",
    ifGenTipRangeNotforNull: "रेंज खाली नहीं हो सकती!",
    ifGenTipCutValueNotforNull: "विभाजन मूल्य खाली नहीं हो सकता!",
    ifGenTipNotGenCondition: "उत्पादन के लिए कोई शर्तें उपलब्ध नहीं हैं!"
  },
  formulaMore: {
    valueTitle: "मान",
    tipSelectDataRange: "डेटा रेंज चुनें",
    tipDataRangeTile: "डेटा रेंज",
    findFunctionTitle: "फंक्शन खोजें",
    tipInputFunctionName: "फंक्शन का नाम या फंक्शन का संक्षिप्त विवरण",
    Array: "ऐरे",
    Database: "डेटाबेस",
    Date: "तिथि",
    Engineering: "इंजीनियरिंग",
    Filter: "फिल्टर",
    Financial: "वित्तीय",
    luckysheet: "लकीशीट",
    other: "अन्य",
    Logical: "लॉजिकल",
    Lookup: "लुकअप",
    Math: "गणित",
    Operator: "ऑपरेटर",
    Parser: "पार्सर",
    Statistical: "सांख्यिकीय",
    Text: "पाठ",
    dataMining: "डेटा माइनिंग",
    selectFunctionTitle: "फंक्शन का चयन करें",
    calculationResult: "परिणाम",
    tipSuccessText: "सफल",
    tipParamErrorText: "पैरामीटर प्रकार त्रुटि",
    helpClose: "बंद करें",
    helpCollapse: "संक्षिप्त करें",
    helpExample: "उदाहरण",
    helpAbstract: "सारांश",
    execfunctionError: "सूत्र में त्रुटि",
    execfunctionSelfError: "सूत्र अपने ही सेल को संदर्भित नहीं कर सकता",
    execfunctionSelfErrorResult: "सूत्र अपने ही सेल को संदर्भित नहीं कर सकता, जो सटीक गणना परिणाम की ओर ले जाएगा",
    allowRepeatText: "पुनरावृत्ति की अनुमति",
    allowOptionText: "विकल्प",
    selectCategory: "या श्रेणी चुनें"
  },
  drag: {
    noMerge: "मर्ज किए गए सेल्स पर यह ऑपरेशन नहीं किया जा सकता",
    affectPivot: "इस चयनित सेल पर यह परिवर्तन नहीं किया जा सकता क्योंकि यह पिवट तालिका को प्रभावित करेगा!",
    noMulti: "कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल क्षेत्र चुनें",
    noPaste: "यह सामग्री यहाँ चिपकाई नहीं जा सकती, कृपया पेस्ट क्षेत्र में एक सेल चुनें और पुनः प्रयास करें",
    noPartMerge: "आंशिक रूप से मर्ज किए गए सेल्स पर यह ऑपरेशन नहीं किया जा सकता",
    inputCorrect: "कृपया सही मान दर्ज करें",
    notLessOne: "पंक्तियों और स्तंभों की संख्या 1 से कम नहीं हो सकती",
    offsetColumnLessZero: "ऑफसेट कॉलम नकारात्मक नहीं हो सकता!",
    pasteMustKeybordAlert: "टेबल में कॉपी पेस्ट करने के लिए: Ctrl + C कॉपी करने के लिए, Ctrl + V पेस्ट करने के लिए, Ctrl + X कट करने के लिए",
    pasteMustKeybordAlertHTMLTitle: "टेबल में कॉपी पेस्ट",
    pasteMustKeybordAlertHTML: "<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;कॉपी करें<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;पेस्ट करें<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;कट करें"
  },
  pivotTable: {
    title: "पिवट टेबल",
    closePannel: "बंद करें",
    editRange: "रेंज",
    tipPivotFieldSelected: "फ़ील्ड का चयन करें",
    tipClearSelectedField: "सभी फ़ील्ड साफ करें",
    btnClearSelectedField: "साफ करें",
    btnFilter: "फिल्टर",
    titleRow: "पंक्ति",
    titleColumn: "स्तंभ",
    titleValue: "मान",
    tipShowColumn: "सांख्यिकीय फ़ील्ड कॉलम के रूप में प्रदर्शित होते हैं",
    tipShowRow: "सांख्यिकीय फ़ील्ड पंक्तियों के रूप में प्रदर्शित होते हैं",
    titleSelectionDataRange: "रेंज का चयन करें",
    titleDataRange: "डेटा रेंज",
    valueSum: "योग",
    valueStatisticsSUM: "योग",
    valueStatisticsCOUNT: "गिनती",
    valueStatisticsCOUNTA: "गिनती A",
    valueStatisticsCOUNTUNIQUE: "अद्वितीय गिनती",
    valueStatisticsAVERAGE: "औसत",
    valueStatisticsMAX: "अधिकतम",
    valueStatisticsMIN: "न्यूनतम",
    valueStatisticsMEDIAN: "मध्य",
    valueStatisticsPRODUCT: "गुणनफल",
    valueStatisticsSTDEV: "सांख्यिकीय विचलन",
    valueStatisticsSTDEVP: "सांख्यिकीय विचलन P",
    valueStatisticslet: "वैर",
    valueStatisticsVARP: "वैर P",
    errorNotAllowEdit: "गैर-संपादन मोड में यह ऑपरेशन निषिद्ध है!",
    errorNotAllowMulti: "कई चयन क्षेत्रों पर यह ऑपरेशन नहीं किया जा सकता, कृपया एकल रेंज चुनें और पुनः प्रयास करें",
    errorSelectRange: "कृपया नई पिवट टेबल की रेंज का चयन करें",
    errorIsDamage: "इस पिवट टेबल का स्रोत डेटा क्षतिग्रस्त है!",
    errorNotAllowPivotData: "स्रोत डेटा के रूप में पिवट टेबल का चयन नहीं कर सकते!",
    errorSelectionRange: "चयन विफल, गलत इनपुट रेंज!",
    errorIncreaseRange: "कृपया चयनित रेंज का विस्तार करें!",
    titleAddColumn: "पिवट टेबल में स्तंभ जोड़ें",
    titleMoveColumn: "स्तंभ को नीचे के सफेद बॉक्स में ले जाएं",
    titleClearColumnFilter: "इस स्तंभ का फिल्टर साफ करें",
    titleFilterColumn: "फिल्टर",
    titleSort: "सॉर्ट",
    titleNoSort: "कोई सॉर्ट नहीं",
    titleSortAsc: "ASC",
    titleSortDesc: "DESC",
    titleSortBy: "के अनुसार सॉर्ट करें",
    titleShowSum: "कुल दिखाएं",
    titleStasticTrue: "हाँ",
    titleStasticFalse: "नहीं"
  },
  dropCell: {
    copyCell: "कॉपी",
    sequence: "अनुक्रम",
    onlyFormat: "केवल प्रारूप",
    noFormat: "कोई प्रारूप नहीं",
    day: "दिन",
    workDay: "काम का दिन",
    month: "महीना",
    year: "साल",
    chineseNumber: "चीनी नंबर"
  },
  imageCtrl: {
    borderTile: "चित्र सीमा का रंग",
    borderCur: "रंग"
  },
  protection: {
    protectiontTitle: "संरक्षण",
    enterPassword: "पासवर्ड दर्ज करें (वैकल्पिक)",
    enterHintTitle: "संपादन निषिद्ध होने पर संकेत (वैकल्पिक)",
    enterHint: "जिस सेल या चार्ट को आप बदलने की कोशिश कर रहे हैं वह संरक्षित वर्कशीट में है। यदि आप इसे बदलना चाहते हैं, तो कृपया वर्कशीट को अनप्रोटेक्ट करें। आपको पासवर्ड दर्ज करने की आवश्यकता हो सकती है",
    swichProtectionTip: "शीट और लॉक किए गए सेल्स की सामग्री की सुरक्षा करें",
    authorityTitle: "इस शीट के उपयोगकर्ताओं को अनुमति दें:",
    selectLockedCells: "लॉक किए गए सेल्स का चयन करें",
    selectunLockedCells: "अनलॉक किए गए सेल्स का चयन करें",
    formatCells: "सेल्स को प्रारूपित करें",
    formatColumns: "स्तंभों को प्रारूपित करें",
    formatRows: "पंक्तियों को प्रारूपित करें",
    insertColumns: "स्तंभ जोड़ें",
    insertRows: "पंक्तियाँ जोड़ें",
    insertHyperlinks: "हाइपरलिंक्स जोड़ें",
    deleteColumns: "स्तंभ हटाएं",
    deleteRows: "पंक्तियाँ हटाएं",
    sort: "सॉर्ट",
    filter: "फिल्टर",
    usePivotTablereports: "पिवट टेबल रिपोर्ट का उपयोग करें",
    editObjects: "ऑब्जेक्ट्स संपादित करें",
    editScenarios: "परिदृश्य संपादित करें",
    allowRangeTitle: "रेंज के उपयोगकर्ताओं को अनुमति दें:",
    allowRangeAdd: "नया...",
    allowRangeAddTitle: "शीर्षक",
    allowRangeAddSqrf: "संदर्भ",
    selectCellRange: "सेल रेंज चुनने के लिए क्लिक करें",
    selectCellRangeHolder: "सेल रेंज",
    allowRangeAddTitlePassword: "पासवर्ड",
    allowRangeAddTitleHint: "संकेत",
    allowRangeAddTitleHintTitle: "पासवर्ड सेट होने पर संकेत (वैकल्पिक)",
    allowRangeAddtitleDefault: "इनपुट रेंज का नाम",
    rangeItemDblclick: "संपादित करने के लिए डबल क्लिक करें",
    rangeItemHasPassword: "पासवर्ड है",
    rangeItemErrorTitleNull: "शीर्षक रिक्त है",
    rangeItemErrorRangeNull: "संदर्भ रिक्त है",
    rangeItemErrorRange: "संदर्भ त्रुटिपूर्ण है",
    validationTitle: "पासवर्ड सत्यापन",
    validationTips: "वर्कशीट की सुरक्षा को अनलॉक करने के लिए पासवर्ड दर्ज करना आवश्यक है",
    validationInputHint: "पासवर्ड दर्ज करें",
    checkPasswordNullalert: "पासवर्ड आवश्यक है!",
    checkPasswordWrongalert: "गलत पासवर्ड, कृपया पुनः प्रयास करें!",
    checkPasswordSucceedalert: "अनलॉक सफल!",
    defaultRangeHintText: "सेल पासवर्ड द्वारा संरक्षित किया जा रहा है।",
    defaultSheetHintText: "सेल या चार्ट एक संरक्षित वर्कशीट में है। परिवर्तन करने के लिए, कृपया वर्कशीट को अनप्रोटेक्ट करें। आपको पासवर्ड दर्ज करने की आवश्यकता हो सकती है"
  },
  cellFormat: {
    cellFormatTitle: "सेल्स प्रारूपित करें",
    protection: "संरक्षण",
    locked: "लॉक किया हुआ",
    hidden: "छुपा हुआ",
    protectionTips: "सेल्स को लॉक करने या सूत्रों को छुपाने के लिए, वर्कशीट की सुरक्षा करें। टूलबार पर, शीट सुरक्षा बटन पर क्लिक करें",
    tipsPart: "आंशिक जाँच",
    tipsAll: "सभी जाँच",
    selectionIsNullAlert: "चयन आवश्यक है!",
    sheetDataIsNullAlert: "त्रुटि, डेटा नहीं है!"
  },
  print: {
    normalBtn: "सामान्य",
    layoutBtn: "पृष्ठ लेआउट",
    pageBtn: "पृष्ठ विराम पूर्वावलोकन",
    menuItemPrint: "प्रिंट करें (Ctrl+P)",
    menuItemAreas: "प्रिंट क्षेत्र",
    menuItemRows: "शीर्षक पंक्तियाँ प्रिंट करें",
    menuItemColumns: "शीर्षक स्तंभ प्रिंट करें"
  },
  edit: {
    typing: "टाइपिंग"
  },
  websocket: {
    success: "WebSocket कनेक्शन सफल",
    refresh: "WebSocket कनेक्शन में त्रुटि हुई, कृपया पृष्ठ को रीफ्रेश करें!",
    wait: "WebSocket कनेक्शन में त्रुटि हुई, कृपया प्रतीक्षा करें!",
    close: "WebSocket कनेक्शन बंद",
    contact: "सर्वर संचार त्रुटि हुई, कृपया पृष्ठ को रीफ्रेश करें और पुनः प्रयास करें, यदि नहीं, तो कृपया व्यवस्थापक से संपर्क करें!",
    support: "वर्तमान ब्राउज़र WebSocket का समर्थन नहीं करता"
  }
};

var zh_tw = {
  generalDialog: {
    partiallyError: "無法對部分合併儲存格執行此操作",
    readOnlyError: "無法對只讀模式執行此操作",
    dataNullError: "無法對不存在的數據執行此操作",
    noSeletionError: "還未進行選區操作",
    cannotSelectMultiple: "無法選擇多選區"
  },
  functionlist: [{
    n: "SUMIF",
    t: 0,
    d: "對範圍中符合指定條件的值求和。",
    a: "對範圍中符合指定條件的值求和。",
    m: [2, 3],
    p: [{
      name: "範圍",
      detail: "要根據條件進行檢測的範圍。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "條件",
      detail: "要應用於範圍的模式或測試條件。\n\n如果範圍包含的是要檢測的文字,則條件必須為字串。條件可以包含萬用字元,包括用於匹配單個字元的？或用於匹配零個或連續多個字元的*。要匹配問號星號本身,請在該字元前面加上波浪號（~）首碼（即~？和~*）。字串條件必須用引號括起來。函數會檢查範圍中的每個儲存格與條件是否相等或匹配（如果使用了萬用字元）。\n\n如果範圍包含的是要檢測的數位,則條件可以是字串也可以是數位。如果給定的條件是一個數位,則檢查範圍中的每個儲存格是否等於條件。另外,條件也可能是包含數位的字串（也將對其進行相等檢測）,或者帶有以下首碼的數位:=（檢查是否相等）、>（檢查範圍儲存格的值是否大於條件值）或<（檢查範圍儲存格的值是否小於條件值）",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "求和範圍",
      detail: "要求和的範圍（如果與範圍不同）。",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TAN",
    t: 0,
    d: "返回已知角度的正切值。",
    a: "返回已知角度的正切值。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要求其正切值的角度,以弧度表示。",
      example: "45*PI()/180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TANH",
    t: 0,
    d: "返回給定實數的雙曲正切值。",
    a: "返回給定實數的雙曲正切值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其雙曲正切值的實數。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CEILING",
    t: 0,
    d: "將數值向上取整為最接近的指定因數的倍數。",
    a: "將數值向上取整為最接近的指定因數的倍數。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要向上舍入的數值。",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因數",
      detail: "要將值舍入到此數的整數倍。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN",
    t: 0,
    d: "返回數值的反正切值,以弧度表示。",
    a: "返回數值的反正切值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反正切值的數值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ASINH",
    t: 0,
    d: "返回數值的反雙曲正弦值。",
    a: "返回數值的反雙曲正弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反雙曲正弦值的數值。",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ABS",
    t: 0,
    d: "返回數值的絕對值。",
    a: "返回數值的絕對值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要返回其絕對值的數。",
      example: "-2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOS",
    t: 0,
    d: "返回數值的反余弦值,以弧度表示。",
    a: "返回數值的反余弦值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反余弦值的數值。必須介於-1和1之間,包括兩端值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACOSH",
    t: 0,
    d: "返回數值的反雙曲余弦值。",
    a: "返回數值的反雙曲余弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反雙曲余弦值的數值。必須大於等於1。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTINOMIAL",
    t: 0,
    d: "返回參數和的階乘除以各參數階乘的乘積後得到的值。",
    a: "返回參數和的階乘除以各參數階乘的乘積後得到的值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "用於計算的第一項數值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "用於計算的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "ATANH",
    t: 0,
    d: "返回數值的反雙曲正切值。",
    a: "返回數值的反雙曲正切值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反雙曲正切值的數值。必須介於-1和1之間（不包括-1和1）。",
      example: "0.9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ATAN2",
    t: 0,
    d: "以弧度為組織返回x軸與從原點（0,0）到指定座標點（`x`,`y`）之間連線的夾角。",
    a: "以弧度為組織返回x軸與從原點（0,0）到指定座標點（`x`,`y`）之間連線的夾角。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "要計算其與x軸夾角大小的線段的終點x座標。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "y",
      detail: "要計算其與x軸夾角大小的線段的終點y座標。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTBLANK",
    t: 1,
    d: "返回給定範圍內的空儲存格數。",
    a: "返回給定範圍內的空儲存格數。",
    m: [1, 1],
    p: [{
      name: "範圍",
      detail: "要統計空白儲存格數量的範圍。",
      example: "A2:C100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "COSH",
    t: 0,
    d: "返回給定實數的雙曲余弦值。",
    a: "返回給定實數的雙曲余弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其雙曲余弦值的實數值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INT",
    t: 0,
    d: "數值向下取整為小於或等於該數的最接近的整數。",
    a: "數值向下取整為小於或等於該數的最接近的整數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向下取整為最接近的整數的數值。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISEVEN",
    t: 0,
    d: "檢查所提供的數值是否為偶數。",
    a: "檢查所提供的數值是否為偶數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要驗證其是否為偶數的數值。\n\n如果值為偶數或指向包含偶數的儲存格的引用,ISEVEN將返回TRUE,否則返回FALSE。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISODD",
    t: 0,
    d: "檢查所提供的數值是否為奇數。",
    a: "檢查所提供的數值是否為奇數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要驗證其是否為奇數的數值。\n\n如果值為奇數或指向包含奇數的儲存格,ISODD將返回TRUE,否則返回FALSE。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LCM",
    t: 0,
    d: "返回一個或多個整數的最小公倍數。",
    a: "返回一個或多個整數的最小公倍數。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要在求最小公倍數數的計算中檢查其因數的第一項數值或範圍。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可選] - 在求最小公倍數時要考慮其因數的其他數值或範圍。",
      example: "3",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LN",
    t: 0,
    d: "返回數值以e（歐拉數）為底的對數。",
    a: "返回數值以e（歐拉數）為底的對數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要以e為底數計算其對數的值。\n\n值必須為正數。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG",
    t: 0,
    d: "根據指定底數返回數位的對數。",
    a: "根據指定底數返回數位的對數。",
    m: [1, 2],
    p: [{
      name: "值",
      detail: "想要計算其對數的正實數。",
      example: "128",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "底數",
      detail: "[可選] - 對數的底數。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOG10",
    t: 0,
    d: "返回數值以10為底的對數。",
    a: "返回數值以10為底的對數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其以10為底的對數的數值。\n\n值必須為正值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MOD",
    t: 0,
    d: "返回兩數相除的餘數,結果的符號與除數相同。",
    a: "返回兩數相除的餘數。",
    m: [2, 2],
    p: [{
      name: "被除數",
      detail: "要將其相除以得到餘數的數值。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "除數",
      detail: "用於除其他數的數值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MROUND",
    t: 0,
    d: "將數值取整為另一整數最接近的整數倍。",
    a: "將數值取整為另一整數最接近的整數倍。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要取整為另一整數最接近的整數倍的數值。",
      example: "21",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因數",
      detail: "值將取此因數的整數倍。",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ODD",
    t: 0,
    d: "將數值向上取整為最接近的奇整數。",
    a: "將數值向上取整為最接近的奇整數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向上取整的數值,取整值為大於此值的最接近的奇數。\n\n如果值為負數,則將其取整為絕對值大於該值的相鄰負奇數",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMSQ",
    t: 0,
    d: "返回一組數值和/或儲存格的平方總和。",
    a: "返回一組數值和/或儲存格的平方總和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要將其平方相加的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 要將其平方與值1的平方相加的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMBIN",
    t: 0,
    d: "給定集合中的對象總數和要選擇的對象數量,返回共有多少種不同選擇管道。",
    a: "給定集合中的對象總數和要選擇的對象數量",
    m: [2, 2],
    p: [{
      name: "n",
      detail: "要從中進行選擇的對象集合的大小。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "要選擇的對象數量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUM",
    t: 0,
    d: "返回一組數值和/或儲存格的總和。",
    a: "返回一組數值和/或儲存格的總和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要相加的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可選] - 要相加的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SUBTOTAL",
    t: 0,
    d: "使用指定的匯總函數,返回一系列縱向儲存格的分類匯總。",
    a: "使用指定的匯總函數",
    m: [2, 256],
    p: [{
      name: "函數程式碼",
      detail: "用於計算分類匯總的函數。\n\n1代表AVERAGE\n\n2代表COUNT\n\n3代表COUNTA\n\n4代表MAX\n\n5代表MIN\n\n6代表PRODUCT\n\n7代表STDEV\n\n8代表STDEVP\n\n9代表SUM\n\n10代表VAR\n\n11代表VARP\n\n通過在這些2位程式碼前附加10（對於1位程式碼）或1（對於2位程式碼）,可以將隱藏值忽略。例如,102代表忽略隱藏儲存格的COUNT,而110則代表忽略隱藏值的VAR。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "範圍1",
      detail: "要計算分類匯總的第一個範圍。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "範圍2",
      detail: "[可選] - 要計算分類匯總的其他範圍。",
      example: "B2:B8",
      require: "o",
      repeat: "y",
      type: "range"
    }]
  }, {
    n: "ASIN",
    t: 0,
    d: "返回數值的反正弦值,以弧度表示。",
    a: "返回數值的反正弦值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其反正弦值的數值。必須介於-1和1之間,包括兩端值。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUNTIF",
    t: 1,
    d: "返回範圍內滿足某個條件的儲存格的數量。",
    a: "返回範圍內滿足某個條件的儲存格的數量。",
    m: [2, 2],
    p: [{
      name: "範圍",
      detail: "要根據條件進行檢測的範圍。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "條件",
      detail: "要應用於範圍的模式或測試條件。\n\n如果範圍包含的是要檢測的文字,則條件必須為字串。條件可以包含萬用字元,包括用於匹配單個字元的？或用於匹配零個或連續多個字元的*。要匹配問號星號本身,請在該字元前面加上波浪號（~）首碼（即~？和~*）。字串條件必須用引號括起來。函數會檢查範圍中的每個儲存格與條件是否相等或匹配（如果使用了萬用字元）。\n\n如果範圍包含的是要檢測的數位,則條件可以是字串也可以是數位。如果給定的條件是一個數位,則檢查範圍中的每個儲存格是否等於條件。另外,條件也可能是包含數位的字串（也將對其進行相等檢測）,或者帶有以下首碼的數位:=、>、>=、<或<=,這些條件將分別用於檢查範圍中的儲存格是否等於、大於、大於等於、小於、小於等於條件值。",
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RADIANS",
    t: 0,
    d: "將以度表示的角度值轉換為弧度。",
    a: "將以度表示的角度值轉換為弧度。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要從度轉換為弧度的角度。",
      example: "180",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RAND",
    t: 0,
    d: "返回一個介於0和1之間（包括0但不包括1）的亂數。",
    a: "返回一個介於0和1之間（包括0但不包括1）的亂數。",
    m: [0, 0],
    p: []
  }, {
    n: "COUNTUNIQUE",
    t: 0,
    d: "計算一列指定值和範圍中不重複數值的個數。",
    a: "計算一列指定值和範圍中不重複數值的個數。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要檢查其是否唯一的第一個值或範圍。",
      example: "A1:C100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可選] - 要檢查是否唯一的其他值或範圍。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DEGREES",
    t: 0,
    d: "將以弧度表示的角度值轉換為度。",
    a: "將以弧度表示的角度值轉換為度。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要從弧度轉換為度的角度。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ERFC",
    t: 9,
    d: "返回數值的互補高斯誤差函數。",
    a: "返回數值的互補高斯誤差函數。",
    m: [1, 1],
    p: [{
      name: "z",
      detail: "要為其計算互補高斯誤差函數的數值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVEN",
    t: 0,
    d: "將數值向上取整為最接近的偶整數。",
    a: "將數值向上取整為最接近的偶整數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要向上取整的數值,取整值為大於此值的最接近的偶數。\n\n如果值為負數,則將其取整為絕對值大於該值的相鄰負偶數。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EXP",
    t: 0,
    d: "返回歐拉數e（~2.718）的指定次幂。",
    a: "返回歐拉數e（~2.718）的指定次幂。",
    m: [1, 1],
    p: [{
      name: "指數",
      detail: "指定e的自乘幂次值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACT",
    t: 0,
    d: "返回數值的階乘。",
    a: "返回數值的階乘。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算並返回其階乘的數位或對數位（所在儲存格）的引用。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FACTDOUBLE",
    t: 0,
    d: '返回數值的"雙階乘"。',
    a: '返回數值的"雙階乘"。',
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算並返回其雙階乘的數位或對數位（所在儲存格）的引用。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PI",
    t: 0,
    d: "返回帶有14位小數的PI值。",
    a: "返回帶有14位小數的PI值。",
    m: [0, 0],
    p: []
  }, {
    n: "FLOOR",
    t: 0,
    d: "將數值向下取整為指定因數的最接近的整數倍。",
    a: "將數值向下取整為指定因數的最接近的整數倍。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要向下舍入為因數的最接近整數倍的數值。",
      example: "23.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "因數",
      detail: "要將值舍入到此數的整數倍。\n\n因數不得為0。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GCD",
    t: 0,
    d: "返回一個或多個整數的最大公約數。",
    a: "返回一個或多個整數的最大公約數。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "要在查找最大公約數的計算中檢查其因數的第一項數值或範圍。",
      example: "A2:A5",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2",
      detail: "[可選] - 在求最大公約數時要考慮其因數的其他數值或範圍。",
      example: "96",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANDBETWEEN",
    t: 0,
    d: "返回介於兩個整數之間（包括這兩個整數）的亂數。",
    a: "返回介於兩個整數之間（包括這兩個整數）的亂數。",
    m: [2, 2],
    p: [{
      name: "下界",
      detail: "隨機值範圍的下界。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "上界",
      detail: "隨機值範圍的上界。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUND",
    t: 0,
    d: "將數位四捨五入到指定的位數。",
    a: "將數位四捨五入到指定的位數。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要四捨五入的數位。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位數",
      detail: "要進行四捨五入運算的位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDDOWN",
    t: 0,
    d: "朝著零的方向將數位進行向下舍入。",
    a: "朝著零的方向將數位進行向下舍入。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "需要向下舍入的任意實數。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位數",
      detail: "要通過舍入達到的小數位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ROUNDUP",
    t: 0,
    d: "朝著遠離0（零）的方向將數位進行向上舍入。",
    a: "朝著遠離0（零）的方向將數位進行向上舍入。",
    m: [2, 2],
    p: [{
      name: "值",
      detail: "要將其舍入為位數位數位的值,始終向上舍入。",
      example: "99.44",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位數",
      detail: "要通過舍入達到的小數位數。\n\n位數可以取負值,在這種情況下會將值的小數點左側部分舍入到指定的位數。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SERIESSUM",
    t: 0,
    d: "給定參數x、n、m和a,返回幂級數的和a1xn + a2x（n+m）+…+ aix（n+（i-1）m）,其中i為範圍a中的項數。",
    a: "給定參數x、n、m和a",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "幂級數的輸入值。隨相應的近似類型而變,有可能為角度、指數或其他一些值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "在幂級數中x的初始自乘幂次。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "m",
      detail: "x的幂次中的附加增量。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "a",
      detail: "包含幂級數係數的數組或範圍。",
      example: "{FACT(0)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIGN",
    t: 0,
    d: "給定輸入數值,如果為負返回-1；如果為正返回1；如果為零則返回0。",
    a: "給定輸入數值",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要返回其符號的數值。",
      example: "-42",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SIN",
    t: 0,
    d: "給定角度（以弧度表示）,返回其正弦值。",
    a: "給定角度（以弧度表示）",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要返回其正弦值的角度,以弧度表示。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SINH",
    t: 0,
    d: "返回給定實數的雙曲正弦值。",
    a: "返回給定實數的雙曲正弦值。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其雙曲正弦值的實數值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRT",
    t: 0,
    d: "返回一個正數的正平方根。",
    a: "返回一個正數的正平方根。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要計算其正平方根的數值。\n\n值必須為正數；如果為負,SQRT將返回#NUM！錯誤。",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SQRTPI",
    t: 0,
    d: "返回PI與給定正數乘積的正平方根。",
    a: "返回PI與給定正數乘積的正平方根。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "要將其與PI相乘並返回該乘積的平方根的數值\n\n值必須為正數；如果為負數,SQRTPI將返回#NUM！錯誤。",
      example: "9",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GAMMALN",
    t: 1,
    d: "返回指定伽瑪函數的以e（歐拉數）為底的對數。",
    a: "返回指定伽瑪函數的以e（歐拉數）為底的對數。",
    m: [1, 1],
    p: [{
      name: "值",
      detail: "伽瑪函數的輸入值。返回的將是伽瑪（值）的自然對數。\n\n值必須為正數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COS",
    t: 0,
    d: "返回給定角度的余弦值（角度以弧度表示）。",
    a: "返回給定角度的余弦值（角度以弧度表示）。",
    m: [1, 1],
    p: [{
      name: "角度",
      detail: "要取其余弦值的角度,以弧度表示。",
      example: "PI()",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRUNC",
    t: 0,
    d: "除指定有效位之外的部分,取數據的指定有效位。",
    a: "除指定有效位之外的部分",
    m: [1, 2],
    p: [{
      name: "值",
      detail: "要截取的數據。",
      example: "3.141592654",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "位數",
      detail: '[可選 - 預設值為0] - 小數點右側要保留的有效位數。\n\n如果位數大於值中的有效位數,則將"值"原樣返回。\n\n位數可以取負值,在這種情況下會將小數點左側指定位數的值更改為零。小數點右側的所有位數都會被捨棄。如果值的所有位都被更改為零,則TRUNC會返回0。',
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUOTIENT",
    t: 0,
    d: "返回以一個數除以另一個數所得的結果,不包含餘數。",
    a: "返回以一個數除以另一個數所得的結果",
    m: [2, 2],
    p: [{
      name: "被除數",
      detail: "要被除的數值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "除數",
      detail: "用於除其他數的數值。\n\n除數不得為0",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POWER",
    t: 0,
    d: "返回數值的指定次幂。",
    a: "返回數值的指定次幂。",
    m: [2, 2],
    p: [{
      name: "底數",
      detail: "要計算其指數次幂的數值。\n\n如果底數為負,則指數必須為整數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "指數",
      detail: "指定底數的自乘幂次值。",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMIFS",
    t: 0,
    d: "根據多項條件返回範圍之和。",
    a: "根據多項條件返回範圍之和。",
    m: [3, 257],
    p: [{
      name: "求和範圍",
      detail: "要對其求和的範圍。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "條件範圍1",
      detail: "要在哪個範圍內檢查條件1。",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "條件1",
      detail: "要應用於條件範圍1的模式或測試條件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "條件範圍2,條件2…",
      detail: "[ 可選 ] - 要檢查的其他範圍和條件。",
      example: " C1:C10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTIFS",
    t: 1,
    d: "根據多項條件返回範圍中的儲存格數量。",
    a: "根據多項條件返回範圍中的儲存格數量。",
    m: [2, 256],
    p: [{
      name: "條件範圍1",
      detail: "要在哪個範圍內檢查條件1。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "條件1",
      detail: "要應用於條件範圍1的模式或測試條件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "條件範圍2,條件2…",
      detail: "[ 可選 ] - 要檢查的其他範圍和條件,可重複。",
      example: " B1:B10",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PRODUCT",
    t: 0,
    d: "返回將一組數相乘所得的結果。",
    a: "返回將一組數相乘所得的結果。",
    m: [1, 255],
    p: [{
      name: "乘數1",
      detail: "用於計算乘積的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "乘數2 ... 乘數30",
      detail: "[可選] - 要相乘的其他數值",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HARMEAN",
    t: 1,
    d: "計算數據集的調和平均值。",
    a: "計算數據集的調和平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "HYPGEOMDIST",
    t: 1,
    d: "返回超幾何分佈。如果已知樣本量、總體成功次數和總體大小,則 HYPGEOM.DIST 返回樣本取得已知成功次數的概率。",
    a: "返回超幾何分佈。",
    m: [5, 5],
    p: [{
      name: "Sample_s",
      detail: "樣本中成功的次數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Number_sample",
      detail: "樣本量。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Population_s",
      detail: "總體中成功的次數。",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "Number_pop",
      detail: "總體大小。",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函數形式的邏輯值。\n\n如果cumulative為TRUE（）,則HYPGEOM.DIST返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INTERCEPT",
    t: 1,
    d: "計算數據集的線性回歸方程直線與 Y 軸的相交點（x=0）的y值。",
    a: "計算數據集的線性回歸方程直線與 Y 軸的相交點（x=0）的y值。",
    m: [2, 2],
    p: [{
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "KURT",
    t: 1,
    d: "計算數據集的峭度,該名額訓示數據集（分佈）的形態,尤其是該形態的陡峭程度。",
    a: "計算數據集的峭度",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "數據集中的第一個值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LARGE",
    t: 1,
    d: "返回數據集中第 n 個最大元素,n 由用戶指定。",
    a: "返回數據集中第 n 個最大元素",
    m: [2, 2],
    p: [{
      name: "數據",
      detail: "包含相關數據集的數組或範圍。",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "n",
      detail: "要返回的元素的排行位置（從大到小順序）。\n\n例如,將n設為4將使LARGE返回數據中排名第4的最大元素。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVA",
    t: 1,
    d: "基於樣本計算標準差,將文字取值為0。",
    a: "基於樣本計算標準差",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2,…",
      detail: "[可選] - 樣本中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STDEVP",
    t: 1,
    d: "基於樣本總體計算標準差。",
    a: "基於樣本總體計算標準差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "數據集中的第一個值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "GEOMEAN",
    t: 1,
    d: "計算數據集的幾何平均值。",
    a: "計算數據集的幾何平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "RANK_EQ",
    t: 1,
    d: "返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回其中的最高排名。",
    a: "返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回其中的最高排名。",
    m: [2, 3],
    p: [{
      name: "number",
      detail: "要確定其排名的值。",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "ref",
      detail: "包含相關數據集的數組或範圍。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "order",
      detail: '[可選-默認為按降序（FALSE（））] - 要按昇冪還是按降序考慮"data"中的值。',
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANK_AVG",
    t: 1,
    d: "返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回這些項排名的平均值。",
    a: "返回指定值在數據集中的排名。如果相同的值在數據集中存在多項,則返回這些項排名的平均值。",
    m: [2, 3],
    p: [{
      name: "number",
      detail: "要確定其排名的值。",
      example: "A10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "ref",
      detail: "包含相關數據集的數組或範圍。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "order",
      detail: '[可選-默認為按降序（FALSE（））] - 要按昇冪還是按降序考慮"data"中的值。',
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERCENTRANK_EXC",
    t: 1,
    d: "以百分數形式返回指定值在給定數據集中的百分比排名（介於0和1之間,不包括兩端值）。",
    a: "以百分數形式返回指定值在給定數據集中的百分比排名（介於0和1之間,不包括兩端值）。",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "包含相關數據集的數組或範圍。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "x",
      detail: "要確定其百分比排位的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significance",
      detail: "[可選-預設值為3] - 要在計算中使用的有效位數。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTRANK_INC",
    t: 1,
    d: "以百分比形式返回指定值在給定數據集中的百分比排名（介於0和1之間,包括兩端值）。",
    a: "以百分比形式返回指定值在給定數據集中的百分比排名（介於0和1之間,包括兩端值）。",
    m: [2, 3],
    p: [{
      name: "data",
      detail: "包含相關數據集的數組或範圍。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "x",
      detail: "要確定其百分比排位的值。",
      example: " A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "significance",
      detail: "[可選-預設值為3] - 要在計算中使用的有效位數。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FORECAST",
    t: 1,
    d: "基於數據集的線性回歸,計算指定 x 的預期 y 值。",
    a: "基於數據集的線性回歸",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "x軸上用於預測的值。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHERINV",
    t: 1,
    d: "返回指定數值的 Fisher 逆變換。",
    a: "返回指定數值的 Fisher 逆變換。",
    m: [1, 1],
    p: [{
      name: "y",
      detail: "要計算其Fisher逆變換的數值。",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FISHER",
    t: 1,
    d: "返回指定數值的 Fisher 變換。",
    a: "返回指定數值的 Fisher 變換。",
    m: [1, 1],
    p: [{
      name: "x",
      detail: "要計算其Fisher變換的數值。",
      example: "0.962",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MODE_SNGL",
    t: 1,
    d: "返回數據集中出現次數最多的值。",
    a: "返回數據集中出現次數最多的值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算模式時要檢查的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計算模式時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "WEIBULL_DIST",
    t: 1,
    d: "給定形狀和尺度,返回韋伯分佈函數（或韋伯累積分佈函數）的值。",
    a: "給定形狀和尺度",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "WEIBULL 分佈函數的輸入值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "alpha",
      detail: "Weibull 分佈函數的形狀參數。\n\n alpha值必須大於0。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "beta",
      detail: "Weibull 分佈函數的尺度參數。\n\n beta值必須大於0。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "TRUE（）表示使用累積分佈函數,FALSE（）則表示使用概率密度函數。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COUNT",
    t: 1,
    d: "返回數據集中數值的個數。",
    a: "返回數據集中數值的個數。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計數時要檢查的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計數時要檢查的其他值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COUNTA",
    t: 1,
    d: "返回數據集中值的數量。",
    a: "返回數據集中值的數量。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計數時要檢查的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計數時要檢查的其他值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVEDEV",
    t: 1,
    d: "計算數據與數據集平均值之間的偏差大小的平均值。",
    a: "計算數據與數據集平均值之間的偏差大小的平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 樣本中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "AVERAGE",
    t: 1,
    d: "返回數據集的算術平均值,對文字忽略不計。",
    a: "返回數據集的算術平均值",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算平均值時用到的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計算平均值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEA",
    t: 1,
    d: "返回數據集的算術平均值。",
    a: "返回數據集的算術平均值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算平均值時用到的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計算平均值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_DIST",
    t: 1,
    d: "返回一元二項式分佈的概率。",
    a: "返回一元二項式分佈的概率。",
    m: [4, 4],
    p: [{
      name: "number_s",
      detail: "試驗的成功次數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "trials",
      detail: "獨立檢驗的次數。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一給定檢驗的成功概率。",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "是否使用二項式累積分佈。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BINOM_INV",
    t: 1,
    d: "計算累積二項式分佈大於或等於指定條件的最小值。",
    a: "計算累積二項式分佈大於或等於指定條件的最小值。",
    m: [3, 3],
    p: [{
      name: "trials",
      detail: "貝努利試驗次數。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一次給定檢驗的成功概率。",
      example: "0.005",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "alpha",
      detail: "期望的臨界概率。",
      example: "0.8",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONFIDENCE_NORM",
    t: 1,
    d: "計算常态分配的置信區間的一半寬度。",
    a: "計算常态分配的置信區間的一半寬度。",
    m: [3, 3],
    p: [{
      name: "alpha",
      detail: "用來計算置信水准的顯著性水准。\n\n置信水准等於100*（1 - alpha）%,亦即,如果 alpha 為0.05,則置信水准為 95%。",
      example: "0.05",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "數據區域的總體標準差。",
      example: "1.6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "size",
      detail: "樣本總量的大小。",
      example: "250",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CORREL",
    t: 1,
    d: "計算給定數據集的皮爾遜積矩相關係數 r。",
    a: "計算給定數據集的皮爾遜積矩相關係數 r。",
    m: [2, 2],
    p: [{
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_P",
    t: 1,
    d: "計算數據集的總體協方差。",
    a: "計算數據集的總體協方差。",
    m: [2, 2],
    p: [{
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COVARIANCE_S",
    t: 1,
    d: "計算數據集的樣本協方差。",
    a: "計算數據集的樣本協方差。",
    m: [2, 2],
    p: [{
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEVSQ",
    t: 1,
    d: "基於樣本計算其偏差的平方和。",
    a: "基於樣本計算其偏差的平方和。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 樣本中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "EXPON_DIST",
    t: 1,
    d: "返回帶有指定 Lambda 和指定值的指數分佈函數的值。",
    a: "返回帶有指定 Lambda 和指定值的指數分佈函數的值。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "指數分佈函數的輸入值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "lambda",
      detail: "用於指定指數分佈函數的 lambda 值。",
      example: "0.5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "是否使用指數累積分佈。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIF",
    t: 1,
    d: "根據條件返回範圍的平均值。",
    a: "根據條件返回範圍的平均值。",
    m: [2, 3],
    p: [{
      name: "criteria_range",
      detail: "要對其檢查 criterion 的範圍。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion",
      detail: '要應用於criteria_range的模式或測試條件。\n\n等於:"文字" 或 1 或 "=文字" 或 "=1"\n\n大於:">1"\n\n大於等於:">=1"\n\n小於:"<1"\n\n小於等於:"<=1"\n\n不等於:"<>1"或"<>文字"',
      example: '">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "average_range",
      detail: "[可選] - 要計算平均值的範圍。如果未提供此參數,則改用criteria_range來計算平均值。",
      example: "B1:B10",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AVERAGEIFS",
    t: 1,
    d: "根據多項條件返回範圍的平均值。",
    a: "根據多項條件返回範圍的平均值。",
    m: [2, 255],
    p: [{
      name: "average_range",
      detail: "要計算平均值的範圍。",
      example: "A1:A10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range1",
      detail: "要對其檢查 criterion1 的範圍。",
      example: " B1:B10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criterion1",
      detail: "要應用於criteria_range1的模式或測試條件。",
      example: ' ">20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria_range2, criterion2, ...",
      detail: "[可選] - 要檢查的其他範圍和條件。",
      example: " C1:C10",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PERMUT",
    t: 1,
    d: "返回可從數位對象中選擇的給定數目對象的排列數。",
    a: "返回可從數位對象中選擇的給定數目對象的排列數。",
    m: [2, 2],
    p: [{
      name: "number",
      detail: "表示對象個數的整數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_chosen",
      detail: "表示每個排列中對象個數的整數。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRIMMEAN",
    t: 1,
    d: "在排除數據集高低兩端的部分數據之後計算所得的平均值。",
    a: "在排除數據集高低兩端的部分數據之後計算所得的平均值。",
    m: [2, 2],
    p: [{
      name: "數據",
      detail: "包含相關數據集的數組或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "排除比例",
      detail: "要從數據集的極值部分排除的數據占數據集的比例。\n\n排除比例必須大於等於0且小於1。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_EXC",
    t: 1,
    d: "返回數組的 K 百分點值,K 介於0到1之間,不含0與1。",
    a: "返回數組的 K 百分點值,K 介於0到1之間,不含0與1。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "定義相對位置的數組或數據區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "0 到 1 之間的百分點值,不包含 0 和 1。",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PERCENTILE_INC",
    t: 1,
    d: "返回數組的 K 百分點值,K 介於 0 到 1 之間,包含 0 與 1。",
    a: "返回數組的 K 百分點值,K 介於 0 到 1 之間,包含 0 與 1。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "定義相對位置的數組或數據區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "k",
      detail: "0 到 1 之間的百分點值,包含 0 和 1。",
      example: "0.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PEARSON",
    t: 1,
    d: "回皮爾生（Pearson）乘積矩相關係數 r。",
    a: "回皮爾生（Pearson）乘積矩相關係數 r。",
    m: [2, 2],
    p: [{
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_INV",
    t: 1,
    d: "返回標準正態累積分佈函數的反函數值。該分佈的平均值為0,標準差為1。",
    a: "返回標準正態累積分佈函數的反函數值。該分佈的平均值為0,標準差為1。",
    m: [1, 1],
    p: [{
      name: "probability",
      detail: "對應於常态分配的概率。",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_S_DIST",
    t: 1,
    d: "返回標準常态分配函數（該分佈的平均值為0,標準差為1）。",
    a: "返回標準常态分配函數（該分佈的平均值為0,標準差為1）。",
    m: [2, 2],
    p: [{
      name: "z",
      detail: "需要計算其分佈的數值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NORM_INV",
    t: 1,
    d: "返回指定平均值和標準差的正態累積分佈函數的反函數值。",
    a: "返回指定平均值和標準差的正態累積分佈函數的反函數值。",
    m: [3, 3],
    p: [{
      name: "probability",
      detail: "對應於常态分配的概率。",
      example: "0.75",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分佈的算術平均值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分佈的標準差。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NORM_DIST",
    t: 1,
    d: "返回指定平均值和標準差的常态分配函數。",
    a: "返回指定平均值和標準差的常态分配函數。",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "需要計算其分佈的數值。",
      example: "2.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分佈的算術平均值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分佈的標準差。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NEGBINOM_DIST",
    t: 1,
    d: "返回負二項式分佈。",
    a: "返回負二項式分佈。",
    m: [4, 4],
    p: [{
      name: "number_f",
      detail: "要類比的失敗次數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number_s",
      detail: "要類比的成功次數。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "probability_s",
      detail: "任一次給定檢驗的成功概率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINA",
    t: 1,
    d: "返回數據集中的最小數值。",
    a: "返回數據集中的最小數值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算最小值時所用的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可選] - 在計算最小值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MIN",
    t: 1,
    d: "返回數值數據集中的最小值。",
    a: "返回數值數據集中的最小值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算最小值時所用的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可選] - 在計算最小值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MEDIAN",
    t: 1,
    d: "返回數值數據集中的中值。",
    a: "返回數值數據集中的中值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算中值時所用的第一個數值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可選] - 在計算中值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAXA",
    t: 1,
    d: "返回數據集中的最大數值。",
    a: "返回數據集中的最大數值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算最大值時所用的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 在計算最大值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "MAX",
    t: 1,
    d: "返回數值數據集中的最大值。",
    a: "返回數值數據集中的最大值。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "計算最大值時所用的第一個值或範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2",
      detail: "[可選] - 在計算最大值時要考慮的其他數值或範圍。",
      example: "B2:B100",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_INV",
    t: 1,
    d: "返回 x 的對數累積分佈函數的反函數值。",
    a: "返回 x 的對數累積分佈函數的反函數值。",
    m: [3, 3],
    p: [{
      name: "probability",
      detail: "與對數分佈相關的概率,介於0與1之間（不含0與1）。",
      example: "0.4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "ln(x) 的平均值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "ln(x) 的標準差,正數。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LOGNORM_DIST",
    t: 1,
    d: "返回 x 的對數分佈函數。",
    a: "返回 x 的對數分佈函數。",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "用來計算函數的值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "ln(x) 的平均值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "ln(x) 的標準差,正數。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "决定函數形式的邏輯值。\n\n如果為TRUE（）,則返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "Z_TEST",
    t: 1,
    d: "返回 z 檢驗的單尾 P 值。",
    a: "返回 z 檢驗的單尾 P 值。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "用來檢驗 x 的數組或數據區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "x",
      detail: "要測試的值。",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sigma",
      detail: "[可選] - 總體（已知）標準差。如果省略,則使用樣本標準差。",
      example: "3",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PROB",
    t: 1,
    d: "返回區域中的數值落在指定區間內的概率。",
    a: "返回區域中的數值落在指定區間內的概率。",
    m: [3, 4],
    p: [{
      name: "x_range",
      detail: "具有各自相應概率值的 x 數值區域。",
      example: "A3:A6",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "prob_range",
      detail: "與 x_range 中的值相關聯的一組概率值。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "lower_limit",
      detail: "要計算其概率的數值下界。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "upper_limit",
      detail: "[可選 - 預設值為下界] - 要計算其概率的可選數值上界。\n\n如果省略上界,PROB則計算隨機選取相應值的次數恰好等於下界的概率。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_EXC",
    t: 1,
    d: "基於 0 到 1 之間（不包括 0 和 1）的百分點值返回數據集的四分位數。",
    a: "基於 0 到 1 之間（不包括 0 和 1）的百分點值返回數據集的四分位數。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "要求得四分位數值的數組或數字型儲存格區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quart",
      detail: "要返回第幾個四分位值。\n\n1返回數據中最靠近第一個四分位值的值（25%標記）。\n\n2返回數據中最接近中值的值（50%標記）。\n\n3返回數據中最接近第三個四分位值的值（75%標記）。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "QUARTILE_INC",
    t: 1,
    d: "根據 0 到 1 之間的百分點值（包含 0 和 1）返回數據集的四分位數。",
    a: "根據 0 到 1 之間的百分點值（包含 0 和 1）返回數據集的四分位數。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "要求得四分位數值的數組或數字型儲存格區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "quart",
      detail: "要返回第幾個四分位值。\n\n0返回數據中的最小值（0%標記）。\n\n1返回數據中最靠近第一個四分位值的值（25%標記）。\n\n2返回數據中最接近中值的值（50%標記）。\n\n3返回數據中最接近第三個四分位值的值（75%標記）。\n\n4返回數據中的最大值（100%標記）。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "POISSON_DIST",
    t: 1,
    d: "返回泊松分布。",
    a: "返回泊松分布。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "事件數。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "期望值。非負數",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "一 邏輯值,確定所返回的概率分佈的形式。\n\n如果為TRUE（）,則返回發生的隨機事件數在零（含零）和x（含x）之間的累積泊松概率；\n\n如果為FALSE（）,則返回發生的事件數正好是x的泊松概率密度函數。",
      example: "FALSE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RSQ",
    t: 1,
    d: "返回皮爾生(Pearson)乘積矩相關係數r的平方。",
    a: "返回皮爾生(Pearson)乘積矩相關係數r的平方。",
    m: [2, 2],
    p: [{
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST",
    t: 1,
    d: "返回學生的左尾 t 分佈。",
    a: "返回學生的左尾 t 分佈。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "T-分佈函數的輸入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度數值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "决定函數形式的邏輯值。\n\n如果cumulative為TRUE（）,則HYPGEOM.DIST返回累積分佈函數；\n\n如果為FALSE（）,則返回概率密度函數。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T_DIST_2T",
    t: 1,
    d: "返回學生的雙尾 t 分佈。",
    a: "返回學生的雙尾 t 分佈。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "T-分佈函數的輸入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度數值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_DIST_RT",
    t: 1,
    d: "返回學生的右尾 t 分佈。",
    a: "返回學生的右尾 t 分佈。",
    m: [2, 2],
    p: [{
      name: "x",
      detail: "T-分佈函數的輸入。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom",
      detail: "自由度數值。",
      example: "30",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV",
    t: 1,
    d: "返回學生的 t 分佈的左尾反函數。",
    a: "返回學生的 t 分佈的左尾反函數。",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "與學生的 t 分佈相關的概率。\n\n必須大於 0 且小於 1。",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "deg_freedom",
      detail: "自由度數值。\n\n如果所提供的參數不是整數,將截取其整數部分。\n\n必須大於等於1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_INV_2T",
    t: 1,
    d: "返回學生 t 分佈的雙尾反函數。",
    a: "返回學生 t 分佈的雙尾反函數。",
    m: [2, 2],
    p: [{
      name: "probability",
      detail: "與學生的t分佈相關的概率。\n\n必須大於 0 且小於 1。",
      example: "0.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "deg_freedom",
      detail: "自由度數值。\n\n如果所提供的參數不是整數,將截取其整數部分。\n\n必須大於等於1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "T_TEST",
    t: 1,
    d: "返回與t-檢驗相關的概率。用於判斷兩個樣本是否可能是出自平均值相同的兩個樣本總體。",
    a: "返回與t-檢驗相關的概率。用於判斷兩個樣本是否可能是出自平均值相同的兩個樣本總體。",
    m: [4, 4],
    p: [{
      name: "array1",
      detail: "將用於t檢驗的第一個數據樣本或第一組儲存格。",
      example: "A1:A4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "將用於t檢驗的第二個數據樣本或第二組儲存格。",
      example: "B1:B4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "tails",
      detail: "指定分佈的尾數。\n\n如果為 1:使用單尾分佈。\n\n如果為 2:使用雙尾分佈。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定t檢驗的類型。\n\n如果為 1:執行配對檢驗。\n\n如果為 2:執行雙樣本等方差（同方差）檢驗。\n\n如果為 3:執行雙樣本不等方差（异方差）檢驗。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "F_DIST",
    t: 1,
    d: "給定輸入值 x,計算兩個數據集的左尾 F 概率分佈（差异程度）。此分佈也稱為 Fisher-Snedecor 分佈或Snedecor F 分佈。",
    a: "給定輸入值 x",
    m: [4, 4],
    p: [{
      name: "x",
      detail: "用來計算函數的值。",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "分子自由度。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "分母自由度。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cumulative",
      detail: "用於確定函數形式的邏輯值。預設值為 FALSE。\n\n如果為 TRUE（）:F.DIST將返回累積分佈函數值。\n\n如果為FALSE（）:F.DIST將返回概率密度函數值。",
      example: "TRUE()",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "F_DIST_RT",
    t: 1,
    d: "給定輸入x,計算兩個數據集的右尾F概率分佈（差异程度）。此分佈也稱為Fisher-Snedecor分佈或Snedecor F分佈。",
    a: "給定輸入 x",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "用來計算函數的值。",
      example: "15.35",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom1",
      detail: "分子自由度。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "degrees_freedom2",
      detail: "分母自由度。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_P",
    t: 1,
    d: "基於樣本總體計算方差。",
    a: "基於樣本總體計算方差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "數據集中的第一個值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, …",
      detail: "[可選] - 數據集中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VAR_S",
    t: 1,
    d: "基於樣本計算方差。",
    a: "基於樣本計算方差。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, …",
      detail: "[可選] - 樣本中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARA",
    t: 1,
    d: "基于样本计算方差,将文本取值为0。",
    a: "基于样本计算方差",
    m: [1, 255],
    p: [{
      name: "value1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2, ...",
      detail: "[可選] - 樣本中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "VARPA",
    t: 1,
    d: "基於樣本總體計算方差,將文字取值為0。",
    a: "基於樣本總體計算方差",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "樣本中的第一項值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他數值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "STEYX",
    t: 1,
    d: "返回通過線性回歸法預測每個 x 的 y 值時所產生的標準誤差。",
    a: "返回通過線性回歸法預測每個 x 的 y 值時所產生的標準誤差。",
    m: [2, 2],
    p: [{
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "STANDARDIZE",
    t: 1,
    d: "給定分佈的平均值和標準差,計算一個隨機變數正態化的相應值。",
    a: "給定分佈的平均值和標準差,計算一個隨機變數正態化的相應值。",
    m: [3, 3],
    p: [{
      name: "x",
      detail: "要正態化的隨機變數值。",
      example: "96",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "mean",
      detail: "分佈的平均值。",
      example: "80",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "standard_dev",
      detail: "分佈的標準差。",
      example: "6.7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SMALL",
    t: 1,
    d: "返回數據集中的第k個最小值。",
    a: "返回數據集中的第k個最小值。",
    m: [2, 2],
    p: [{
      name: "array",
      detail: "需要找到第k個最小值的數組或數值數據區域。",
      example: "A2:B100",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "k",
      detail: "要返回的數據在數組或數據區域裏的位置（從小到大）。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLOPE",
    t: 1,
    d: "計算通過數據集的線性回歸得到的直線的斜率。",
    a: "計算通過數據集的線性回歸得到的直線的斜率。",
    m: [2, 2],
    p: [{
      name: "數據_y",
      detail: "代表因變數數據數組或矩陣的範圍。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "數據_x",
      detail: "代表引數數據數組或矩陣的範圍。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SKEW",
    t: 1,
    d: "返回分佈的偏斜度。偏斜度表明分佈相對於平均值的不對稱程度。正偏斜度表明分佈的不對稱尾部趨向於更多正值。負偏斜度表明分佈的不對稱尾部趨向於更多負值。",
    a: "返回分佈的偏斜度。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "數據集中的第一個值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SKEW_P",
    t: 1,
    d: "返回基於樣本總體的分佈不對稱度:表明分佈相對於平均值的不對稱程度。",
    a: "返回基於樣本總體的分佈不對稱度:表明分佈相對於平均值的不對稱程度。",
    m: [1, 255],
    p: [{
      name: "值1",
      detail: "數據集中的第一個值或範圍。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "值2, ...",
      detail: "[可選] - 數據集中包含的其他值或範圍。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "VLOOKUP",
    t: 2,
    d: "縱向查找。在範圍的第一列中自上而下蒐索某個鍵值,並返回所找到的行中指定儲存格的值。",
    a: "縱向查找。在範圍的第一列中自上而下蒐索某個鍵值",
    m: [3, 4],
    p: [{
      name: "蒐索鍵值",
      detail: '要蒐索的值,如 42、"Cats" 或 I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "範圍",
      detail: "要進行蒐索的範圍。VLOOKUP 將在該範圍的第一列中蒐索蒐索鍵值中指定的鍵值。",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "索引",
      detail: "要返回的值的列索引,範圍中的第一列編號為1。\n\n如果索引不是介於1和範圍中的列數之間,將返回#VALUE！。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "已排序",
      detail: "[預設值為TRUE()] -訓示要蒐索的列（指定範圍的第一列）是否已排序。大多數情况下,建議設為FALSE（）。\n\n建議將已排序設為FALSE。如果設為FALSE,將返回完全匹配項。如果存在多個匹配值,將返回找到的第一個值對應的儲存格的內容,如果找不到匹配值,則返回#N/A。\n\n如果將已排序設為TRUE或省略,將返回（小於或等於蒐索鍵值的）最接近的匹配項。如果蒐索的列中所有的值均大於蒐索鍵值,則返回#N/A。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HLOOKUP",
    t: 2,
    d: "橫向查找。在範圍的第一行中蒐索某個鍵值,並返回所找到的列中指定儲存格的值。",
    a: "橫向查找。在範圍的第一行中蒐索某個鍵值",
    m: [3, 4],
    p: [{
      name: "蒐索鍵值",
      detail: '要蒐索的值。例如,42、"Cats"或I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "範圍",
      detail: "要進行蒐索的範圍。將在該範圍的第一行中蒐索在蒐索鍵值中指定的鍵值。",
      example: "A2:Z6",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "索引",
      detail: "要返回的值的行索引,範圍中的第一行編號為1。\n\n如果索引不是介於1和範圍中的行數之間,將返回#VALUE！。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "已排序",
      detail: "[可選 - 預設值為TRUE()] - 訓示要蒐索的行（指定範圍的第一行）是否已排序。\n\n如果將已排序設為TRUE或省略,將返回最接近的匹配值（小於或等於蒐索鍵值）。如果在蒐索的行中所有的值均大於蒐索鍵值,則返回#N/A。\n\n如果將已排序設為TRUE或將其省略,而範圍的首行並非處於已排序狀態,則返回值可能會是錯誤的。\n\n如果將已排序設為FALSE,則僅返回完全匹配。如果存在多個匹配值,將返回與找到的第一個值對應的儲存格的內容,如果找不到匹配值則返回#N/A。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOOKUP",
    t: 2,
    d: "在行或列中查找相應鍵,並將相應儲存格的值返回到與蒐索行或列所在位置相同的結果範圍中。",
    a: "在行或列中查找相應鍵",
    m: [2, 3],
    p: [{
      name: "蒐索鍵值",
      detail: '要在行或列中蒐索的值。例如,42、"Cats" 或 I24。',
      example: "10003",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "搜索範圍 | 搜索結果數組",
      detail: "使用LOOKUP的一種方法是給定單行或單列形式的搜索範圍進行蒐索查找,這種管道要用到另一個參數結果範圍。另一種管道是將這兩個參數合併為一個搜索結果數組,其中第一行或第一列用於蒐索,並將返回值放在該數組的最後一行或最後一列中。",
      example: "A1:A100",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "結果範圍",
      detail: "[ 可選 ] - 用於存放返回結果的範圍。返回值對應於在搜索範圍中找到蒐索鍵值的位置。此範圍必須僅為單行或單列,而如果您使用的是搜索結果數組管道,則不應提供此參數。",
      example: "B1:B100",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADDRESS",
    t: 2,
    d: "返回字串形式的儲存格引用。",
    a: "返回字串形式的儲存格引用。",
    m: [2, 5],
    p: [{
      name: "row_num",
      detail: "一個數值,指定要在儲存格引用中使用的行號。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column_num",
      detail: "一個數值,指定要在儲存格引用中使用的列號（而非名稱）。A列的編號為1。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "abs_num",
      detail: "[可選 - 預設值為1] - 一個數值,指定要返回的參考類型。\n\n1表示行列均採用絕對值（例如$A$1）；\n\n2表示採用絕對行號,相對列標（例如A$1）；\n\n3表示採用相對行號,絕對列標（例如$A1）；\n\n4表示行列均採用相對值（例如A1）。",
      example: "4",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "A1",
      detail: "[可選 - 預設值為TRUE（）] - 一個布林值,訓示採用A1標記形式（TRUE）還是R1C1標記形式（FALSE）。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "sheet_text",
      detail: "[可選 - 默認預設] - 用於指定地址所指向的工作表名稱。",
      example: '"Sheet2"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "INDIRECT",
    t: 2,
    d: "返回以字串指定的儲存格引用。",
    a: "返回以字串指定的儲存格引用。",
    m: [1, 2],
    p: [{
      name: "ref_text",
      detail: "以帶引號的字串形式提供的儲存格引用。",
      example: '"Sheet2!"&B10',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "A1",
      detail: "[可選 - 預設值為TRUE（）] - 一個布林值,訓示採用A1標記形式（TRUE）還是R1C1標記形式（FALSE）。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROW",
    t: 2,
    d: "返回指定儲存格的行號",
    a: "返回指定儲存格的行號",
    m: [0, 1],
    p: [{
      name: "reference",
      detail: "[可選 - 默認為此公式所在的儲存格] - 要返回其行號的儲存格。\n\n如果儲存格引用指向的範圍其寬度大於一個儲存格,而此公式不是用作數組公式的,這時會僅返回儲存格引用中首行的編號值。",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROWS",
    t: 2,
    d: "返回指定數組或範圍中的行數。",
    a: "返回指定數組或範圍中的行數。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要返回其行數的範圍。",
      example: "A9:A62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COLUMN",
    t: 2,
    d: "按照 `A=1` 的規則返回指定儲存格的列號。",
    a: "按照 `A=1` 的規則返回指定儲存格的列號。",
    m: [0, 1],
    p: [{
      name: "reference",
      detail: "[可選 - 默認為包含此公式的儲存格] - 要返回其列號的儲存格。A列對應的編號為1。\n\n如果儲存格引用是寬度超過一個儲存格的範圍,而此公式不是作為數組公式來使用的,囙此將返回儲存格引用中的第一列的位置。",
      example: "A9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNS",
    t: 2,
    d: "返回指定數組或範圍中的列數。",
    a: "返回指定數組或範圍中的列數。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要返回其列數的範圍。",
      example: "A9:W62",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OFFSET",
    t: 2,
    d: "給定某範圍的起始儲存格引用以及該範圍涵蓋的行列數量,返回該範圍的引用。",
    a: "給定某範圍的起始儲存格引用以及該範圍涵蓋的行列數量,返回該範圍的引用。",
    m: [3, 5],
    p: [{
      name: "reference",
      detail: "用於計算行列偏移量的起點。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "rows",
      detail: "要偏移的行數。\n\n行偏移量必須是整數,但也可以是負數。如果提供的參數帶有小數,小數部分將被截去。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "要偏移的列數。\n\n列偏移量必須是整數,但也可以是負數。如果提供的參數帶有小數,小數部分將被截去。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "height",
      detail: "[可選] - 要從偏移目標開始返回的範圍的高度。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "width",
      detail: "[可選] - 要從偏移目標開始返回的範圍的寬度。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MATCH",
    t: 2,
    d: "在儲存格中蒐索指定項,然後返回該項在儲存格區域中的相對位置。",
    a: "在儲存格中蒐索指定項,然後返回該項在儲存格區域中的相對位置。",
    m: [2, 3],
    p: [{
      name: "lookup_value",
      detail: "要在 lookup_array 中匹配的值。",
      example: '"Sunday"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "lookup_array",
      detail: "要蒐索的儲存格區域。\n\n如果所用的範圍的高度和寬度均大於1,MATCH將返回#N/A！。",
      example: "A2:A9",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "match_type",
      detail: "[可選 - 預設值為1] - 要採用的蒐索管道。\n\n1為默認類型,此時MATCH會假設範圍已按昇冪排序,並返回小於等於蒐索鍵值的最大值。\n\n0表示完全匹配,在範圍未排序的情况下需要使用此管道。\n\n-1讓MATCH假設範圍是按降序排序的,並返回大於等於蒐索鍵值的最小值。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INDEX",
    t: 2,
    d: "返回表格或中的元素值,此元素由行號和列號的索引值給定。",
    a: "返回表格或中的元素值,此元素由行號和列號的索引值給定。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "儲存格區域或數組常數。",
      example: "A1:C20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "row_num",
      detail: "選擇數組中的某行,函數從該行返回數值。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "column_num",
      detail: "選擇數組中的某列,函數從該列返回數值。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GETPIVOTDATA",
    t: 2,
    d: "從與指定行和列標題對應的數據透視錶中選取匯總值。",
    a: "從與指定行和列標題對應的數據透視錶中選取匯總值。",
    m: [2, 254],
    p: [{
      name: "data_field",
      detail: '您想從數據透視錶中獲取其數據的值名稱。\n值名稱必須括在引號中或是指向包含相關文字的任何儲存格的引用。\n如果有多個值欄位,則必須使用數據透視錶中顯示的確切名稱（如"銷售總額"）。',
      example: '"SUM of number of units"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pivot_table",
      detail: "目標數據透視錶中的任何儲存格的引用（推薦位於頂角的儲存格）。",
      example: "'Pivot table'!A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "field1",
      detail: "[可選] - 源數據集（不是數據透視錶）中列的名稱。",
      example: '"division"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }, {
      name: "item1",
      detail: "[可選] - 數據透視錶中顯示的與您要檢索的欄位名稱1相對應的行或列的名稱。",
      example: '"east"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CHOOSE",
    t: 2,
    d: "基於索引返回選項清單中的元素。",
    a: "基於索引返回選項清單中的元素。",
    m: [2, 255],
    p: [{
      name: "index_num",
      detail: "指定要返回哪一項。\n\n如果索引為零、負值或大於提供的選擇數量,將返回#VALUE！錯誤。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value1",
      detail: "一項可能的返回值。必須提供。可以是儲存格引用或單獨的值。",
      example: '"A"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "[可選] - 其他可以選擇的值。選擇",
      example: '"B"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "HYPERLINK",
    t: 2,
    d: "在儲存格內創建一個超連結。",
    a: "在儲存格內創建一個超連結。",
    p: [{
      name: "網址",
      detail: "以引號括住的連結位置的完整網址,或對包含這種網址的儲存格的引用。\n\n僅允許某些連結類型。其中包括:http://、https://、mailto:、aim:、ftp://、gopher://、telnet://和news://,明確禁用使用其他協定。如果指定的是其他協定,將會在儲存格中顯示連結標籤,但該標籤不會以連結形式呈現。\n\n如果未指定協定,則假設使用http://,並將其作為網址的首碼。",
      example: '"http://www.google.com/"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "連結標籤",
      detail: '[可選-默認為網址] - 要在儲存格中作為連結顯示的文字（用引號括起來的）,或者指向包含這種標籤的儲存格的引用。\n\n如果連結標籤是指向某個空儲存格的引用,如果網址有效,就將其作為連結顯示,否則作為純文字顯示。\n\n如果連結標籤為空字串常數（""）,所在儲存格顯示的內容將為空白,但通過點擊該儲存格或轉入該儲存格仍然可以訪問連結。',
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TIME",
    t: 6,
    d: "將給定的小時、分鐘和秒轉換為時間。",
    a: "將給定的小時、分鐘和秒轉換為時間。",
    m: [3, 3],
    p: [{
      name: "小時",
      detail: "0（零）到 32767 之間的數位,代表小時。\n\n任何大於 23 的值都會除以24,餘數將作為小時值。",
      example: "11",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "分鐘",
      detail: "0（零）到 32767 之間的數位,代表分鐘。\n\n任何大於 59 的值將轉換為小時和分鐘。",
      example: "40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "秒",
      detail: "0（零）到 32767 之間的數位,代表秒。\n\n任何大於 59 的值將轉換為小時、分鐘和秒。",
      example: "59",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TIMEVALUE",
    t: 6,
    d: "按一天24小時返回該時間的分數表示。",
    a: "按一天24小時返回該時間的分數表示。",
    m: [1, 1],
    p: [{
      name: "time_text",
      detail: "用於表示時間的字串。",
      example: '"2:15 PM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EOMONTH",
    t: 6,
    d: "返回某個月份最後一天的序號,該月份在另一個日期之前或之後的數個月（月數由參數指定）。",
    a: "返回某個月份最後一天的序號",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "用於計算結果的參照日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "用於計算的起始日期之前（負）或之後（正）的月數。返回的是計算所得月份的最後那天。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EDATE",
    t: 6,
    d: "返回表示某個日期的序號,該日期在另一個日期的數月之前/之後。",
    a: "返回表示某個日期的序號",
    m: [2, 2],
    p: [{
      name: "start_date",
      detail: "用於計算結果的參照日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "months",
      detail: "用於計算的起始日期之前（負）或之後（正）的月數。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SECOND",
    t: 6,
    d: "返回時間值的秒數。秒數是0（零）到59範圍內的整數。",
    a: "返回時間值的秒數。秒數是0（零）到59範圍內的整數。",
    m: [1, 1],
    p: [{
      name: "時間",
      detail: "用於計算秒鐘部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MINUTE",
    t: 6,
    d: "以數位格式返回特定時間的分鐘部分。",
    a: "以數位格式返回特定時間的分鐘部分。",
    m: [1, 1],
    p: [{
      name: "時間",
      detail: "用於計算分鐘部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HOUR",
    t: 6,
    d: "以數位格式返回特定時間的小時部分。",
    a: "以數位格式返回特定時間的小時部分。",
    m: [1, 1],
    p: [{
      name: "時間",
      detail: "用於計算小時部分的時間。必須為以下值之一:指向包含日期/時間值的儲存格的引用、返回日期/時間的函數或者數位。",
      example: "TIME(11",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOW",
    t: 6,
    d: "以日期值格式返回當前日期和時間。",
    a: "以日期值格式返回當前日期和時間。",
    m: [0, 0],
    p: []
  }, {
    n: "NETWORKDAYS",
    t: 6,
    d: "返回所提供的兩個日期之間的淨工作日天數。",
    a: "返回所提供的兩個日期之間的淨工作日天數。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "用於計算淨工作日天數的時間段開始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "用於計算淨工作日天數的時間段結束日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[可選] - 一個範圍或數組常數,其中包含作為節假日的日期序號。\n\n在節假日數組中提供的值必須是日期序號值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由範圍指定的值應該是標準的日期值或日期序數值。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NETWORKDAYS_INTL",
    t: 6,
    d: "返回給定的兩個日期之間的淨工作日天數（排除指定的週末和節假日）。",
    a: "返回給定的兩個日期之間的淨工作日天數（排除指定的週末和節假日）。",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "用於計算淨工作日天數的時間段開始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "用於計算淨工作日天數的時間段結束日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "weekend",
      detail: '[可選-預設值為1] - 用於表示哪些天為週末的數位或字串。\n字串管道:可以使用由0和1組成的字串來指定週末,串中的第一個數位字元代表週一,最後一個則代表周日。零表示這一天是工作日,1 表示這一天為週末。例如,"0000011"表示將週六和周日作為週末。\n數位管道:這種管道不使用上述字串形式,而是使用一個數位。1 =週六/周日為週末,2 =周日/週一為週末,依此類推則7 =週五/週六。11 =周日為唯一週末,12 =週一為唯一週末,依此類推則17 =週六為唯一週末。',
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[可選] - 這是一個範圍或數組常數,其中包含作為節假日的日期。\n在節假日數組內提供的值必須為日期序數值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由範圍指定的值應該是標準的日期值或日期序數值。",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISOWEEKNUM",
    t: 6,
    d: "返回給定日期在全年中的 ISO 周數。",
    a: "返回給定日期在全年中的 ISO 周數。",
    m: [1, 1],
    p: [{
      name: "date",
      detail: "用於日期和時間計算的日期-時間程式碼。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WEEKNUM",
    t: 6,
    d: "返回特定日期的周數。",
    a: "返回特定日期的周數。",
    m: [1, 2],
    p: [{
      name: "serial_number",
      detail: "要確定其位於第幾周的日期,必須是對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "return_type",
      detail: "[可選-預設值為1 ] - 代表一周起始日的數位,系統也使用該數位來確定一年的第一周（1=周日,2=週一）。",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "WEEKDAY",
    t: 6,
    d: "返回一個數位,對應於給定日期所在的星期幾。",
    a: "返回一個數位,對應於給定日期所在的星期幾。",
    m: [1, 2],
    p: [{
      name: "serial_number",
      detail: "要為其確定星期幾的日期。必須是對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "return_type",
      detail: "[可選-預設值為1] -以數位訓示使用哪種編號順序來表示星期幾。默認情况下,按星期日（= 1）開始計算。\n\n如果類型為1,則星期值將從星期日開始算起,並且星期日的值為1,囙此星期六的值就是7。\n\n如果類型為2,則星期值將從星期一開始算起,並且星期一的值為1,囙此星期日的值就是7。\n\n如果類型為3,則星期值將從星期一算起,並且星期一的值為0,囙此星期日的值就是6。",
      example: "7",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DAY",
    t: 6,
    d: "以數位格式返回特定日期所在的當月幾號。",
    a: "以數位格式返回特定日期所在的當月幾號。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "要從中選取具體幾號的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS",
    t: 6,
    d: "返回兩個日期之間的天數。",
    a: "返回兩個日期之間的天數。",
    m: [2, 2],
    p: [{
      name: "end_date",
      detail: "計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "2011-3-15",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_date",
      detail: "計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "2011-2-1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DAYS360",
    t: 6,
    d: "按照每年360天,返回兩個日期之間的差（用於計算利息）。",
    a: "按照每年360天,返回兩個日期之間的差（用於計算利息）。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "method",
      detail: "[可選 - 默認為FALSE（）] - 訓示要使用哪種天數計算方法。\n\nFALSE -採用美國（NASD）方法時,如果起始日期為某月的最後一天,為便於計算,會將起始日期的當月幾號更改為30。此外,如果結束日期是所在月份的最後一天,而且起始日期在其所在月的30號之前,則將結束日期更改為結束日期之後那個月的第一天,否則將結束日期更改為該月的30號。\n\nTRUE -採用歐洲方法時,會將所有日期在31號的起始日期或結束日期更改為當月的30號。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATE",
    t: 6,
    d: "將提供的年、月、日轉換為日期。",
    a: "將提供的年、月、日轉換為日期。",
    m: [3, 3],
    p: [{
      name: "year",
      detail: "日期的年份部分,包含一到四位數位。\n\n介於0（零）到 1899 之間,會將該值與 1900 相加來計算年份；\n\n介於 1900 到 9999 之間,將使用該數值作為年份；\n\n小於0或大於等於 10000,返回錯誤值#NUM！。",
      example: "1969",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "日期的月份部分,一個正整數或負整數。\n\n如果 month 大於 12,則 month 會將該月份數與指定年中的第一個月相加。\n\n如果 month 小於 1,month 則從指定年份的一月份開始遞減該月份數,然後再加上 1 個月。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "day",
      detail: "日期的日部分,一個正整數或負整數。\n\n如果 day 大於月中指定的天數,則 day 會將天數與該月中的第一天相加。\n\n如果 day 小於1,則 day 從指定月份的第一天開始遞減該天數,然後再加上 1 天。",
      example: "20",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATEVALUE",
    t: 6,
    d: "將提供的日期字串轉換為日期的序號。",
    a: "將提供的日期字串轉換為日期的序號。",
    m: [1, 1],
    p: [{
      name: "date_text",
      detail: "表示日期的字串。",
      example: '"1969-7-20"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DATEDIF",
    t: 6,
    d: "計算兩個日期之間的天數、月數或年數。",
    a: "計算兩個日期之間的天數、月數或年數。",
    m: [3, 3],
    p: [{
      name: "起始日期",
      detail: "計算中要使用的開始日期。必須是對包含DATE值的儲存格的引用、返回DATE類型的函數或數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "結束日期",
      detail: "計算中要使用的結束日期。必須是對包含DATE值的儲存格的引用、返回DATE類型的函數或數位。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "組織",
      detail: '時間組織的縮寫文字。例如"M"代表月。有效值包括:"Y"、"M"、"D"、"MD"、"YM"和"YD"。\n\n"Y":返回起始日期和結束日期之間的整年數。\n\n"M":返回起始日期和結束日期之間的整月數。\n\n"D":返回起始日期和結束日期之間的天數。\n\n"MD":返回起始日期和結束日期之間的天數（不計整月數）。\n\n"YM":返回起始日期和結束日期之間的整月數（不計整年數）。\n\n"YD":返回起始日期和結束日期之間的天數（假設起始日期和結束日期的間隔不超過一年）。',
      example: "16)",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY",
    t: 6,
    d: "指定工作日天數,計算結束日期。",
    a: "指定工作日天數,計算結束日期。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "計算的開始日期。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "days",
      detail: "start_date之前或之後不含週末及節假日的天數。\n\n為正值將生成未來日期；\n\n為負值生成過去日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "holidays",
      detail: "[可選] - 一個範圍或數組常數,其中包含作為節假日的日期序號。\n\n在節假日數組中提供的值必須是日期序號值（例如由N所返回的值）或日期值（例如由DATE、DATEVALUE或TO_DATE返回的值）。由範圍指定的值應該是標準的日期值或日期序數值。",
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "WORKDAY_INTL",
    t: 6,
    d: "返回指定的若干個工作日之前或之後的日期的序號（使用自定義週末參數）。 ",
    a: "返回指定的若干個工作日之前或之後的日期的序號（使用自定義週末參數）。 ",
    m: [2, 4],
    p: [{
      name: "start_date",
      detail: "開始日期（將被截尾取整）。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "days",
      detail: "start_date之前或之後的工作日的天數。\n\n正值表示未來日期；\n\n負值表示過去日期；\n\n零值表示開始日期。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "weekend",
      detail: '[可選 - 預設值為1] - 用於表示哪些天為週末的數位或字串。\n字串管道:可以使用由0和1組成的字串來指定週末,串中的第一個數位字元代表週一,最後一個則代表周日。零表示這一天是工作日,1表示這一天為週末。例如,"0000011"表示將週六和周日作為週末。\n數位管道:這種管道不使用上述字串形式,而是使用一個數位。1 =週六/周日為週末,2 =周日/週一為週末,依此類推則7 =週五/週六。11 =周日為唯一週末,12 =週一為唯一週末,依此類推則17 =週六為唯一週末。',
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "holidays",
      detail: "[可選] - 這是一個範圍或數組常數,其中包含作為節假日的日期。\n在節假日數組內提供的值必須為日期序數值（例如N的返回值）或日期值（例如DATE、DATEVALUE或TO_DATE的返回值）。由範圍指定的值應該是標準的日期值或日期序數值。",
      example: "DATE(1969",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEAR",
    t: 6,
    d: "返回對應於某個日期的年份。Year作為 1900 - 9999 之間的整數返回。",
    a: "返回對應於某個日期的年份。Year作為 1900 - 9999 之間的整數返回。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "用於計算年份的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "YEARFRAC",
    t: 6,
    d: "返回 start_date 和 end_date 之間的天數占全年天數的百分比。",
    a: "返回 start_date 和 end_date 之間的天數占全年天數的百分比。",
    m: [2, 3],
    p: [{
      name: "start_date",
      detail: "計算中要使用的開始日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "end_date",
      detail: "計算中要使用的結束日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "7",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 要使用的日計數基準類型。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "16)",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TODAY",
    t: 6,
    d: "以日期值格式返回當前日期。",
    a: "以日期值格式返回當前日期。",
    m: [0, 0],
    p: []
  }, {
    n: "MONTH",
    t: 6,
    d: "返回日期（以序列數表示）中的月份。月份是介於1（一月）到12（十二月）之間的整數。",
    a: "返回日期（以序列數表示）中的月份。月份是介於1（一月）到12（十二月）之間的整數。",
    m: [1, 1],
    p: [{
      name: "serial_number",
      detail: "要從中選取月份的日期。必須是以下一種:對包含日期的儲存格的引用、返回日期類型的函數或者數位。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EFFECT",
    t: 8,
    d: "根據名義利率及每年的複利計息期數來計算實際年利率。",
    a: "根據名義利率及每年的複利計息期數來計算實際年利率。",
    m: [2, 2],
    p: [{
      name: "nominal_rate",
      detail: "每年的名義利率。",
      example: "0.99",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "npery",
      detail: "每年的複利計算期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLAR",
    t: 12,
    d: "將數位格式設定為與語言區域相對應的貨幣格式。",
    a: "將數位格式設定為與語言區域相對應的貨幣格式。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: "要設定格式的值。",
      example: "1.2351",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "decimals",
      detail: "[可選 - 預設值為2] - 要顯示的小數位數。\n\n如果這是負數,則將數位四捨五入到小數點左側。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARDE",
    t: 8,
    d: "將以整數部分和分數部分轉換為以小數部分表示的金額數位",
    a: "將以整數部分和分數部分轉換為以小數部分表示的金額數位",
    m: [2, 2],
    p: [{
      name: "fractional_dollar",
      detail: "以整數部份和分數部分表示的數位,用小數點隔開。",
      example: "100.10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fraction",
      detail: "用作分數中的分母的整數。",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DOLLARFR",
    t: 8,
    d: "將小數轉換為分數表示的金額數位。",
    a: "將小數轉換為分數表示的金額數位。",
    m: [2, 2],
    p: [{
      name: "decimal_dollar",
      detail: "小數。",
      example: "100.125",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fraction",
      detail: "用作分數中的分母的整數。",
      example: "32",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DB",
    t: 8,
    d: "使用固定餘額遞減法,返回指定期間內某項固定資產的折舊值。",
    a: "使用固定餘額遞減法,返回指定期間內某項固定資產的折舊值。",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "資產原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折舊末尾時的值（有時也稱為資產殘值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "資產的折舊期數（有時也稱作資產的使用壽命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限內要計算折舊的折舊期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "month",
      detail: "[可選 - 預設值為12] - 折舊第一年中的月數。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DDB",
    t: 8,
    d: "用雙倍餘額遞減法,返回指定期間內某項固定資產的折舊值。",
    a: "用雙倍餘額遞減法,返回指定期間內某項固定資產的折舊值。",
    m: [4, 5],
    p: [{
      name: "cost",
      detail: "资产原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折舊末尾時的值（有時也稱為資產殘值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "資產的折舊期數（有時也稱作資產的使用壽命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限內要計算折舊的折舊期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "factor",
      detail: "[可選 - 預設值為2] - 折舊的遞減係數。",
      example: "2.25",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RATE",
    t: 8,
    d: "返回年金每期的利率。",
    a: "返回年金每期的利率。",
    m: [3, 6],
    p: [{
      name: "nper",
      detail: "年金的付款總期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "每期的付款金額,在年金週期內不能更改。",
      example: "-100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值即一系列未來付款當前值的總和。",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "guess",
      detail: "[可選 - 預設值為0.1] - 預期利率。",
      example: "0.1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CUMPRINC",
    t: 8,
    d: "基於等額分期付款和固定利率,計算投資在多個付款期內的累計本金償還額。",
    a: "基於等額分期付款和固定利率,計算投資在多個付款期內的累計本金償還額。",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "總付款期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "年金的現值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_period",
      detail: "開始累計計算的付款期序號。\n\n首期必須大於等於1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_period",
      detail: "結束累計計算的付款期序號。\n\n末期必須大於首期。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNUM",
    t: 8,
    d: "返回在結算日和到期日之間的付息次數，向上舍入到最近的整數",
    a: "返回在結算日和到期日之間的付息次數，向上舍入到最近的整數",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "02",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SYD",
    t: 8,
    d: "返回在指定期間內資產按年限總和折舊法計算的折舊。",
    a: "返回在指定期間內資產按年限總和折舊法計算的折舊。",
    m: [4, 4],
    p: [{
      name: "cost",
      detail: "資產原值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折舊末尾時的值（有時也稱為資產殘值）。",
      example: "50",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "資產的折舊期數（有時也稱作資產的使用壽命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "period",
      detail: "在使用期限內要計算折舊的折舊期。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLEQ",
    t: 8,
    d: "基於貼現率計算美國政府短期債券的等效年化收益率。",
    a: "基於貼現率計算美國政府短期債券的等效年化收益率。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "債券的結算日期,此日期為債券發行後交付給買家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "債券的到期或結束日期,届時可將其以面值或票面價值贖回。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "債券購買時的貼現率。",
      example: "2)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLYIELD",
    t: 8,
    d: "基於價格計算美國政府短期債券的收益率。",
    a: "基於價格計算美國政府短期債券的收益率。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "債券的結算日期,此日期為債券發行後交付給買家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "債券的到期或結束日期,届時可將其以面值或票面價值贖回。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "債券的購買價格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TBILLPRICE",
    t: 8,
    d: "基於貼現率計算美國政府短期債券的價格。",
    a: "基於貼現率計算美國政府短期債券的價格。",
    m: [3, 3],
    p: [{
      name: "settlement",
      detail: "債券的結算日期,此日期為債券發行後交付給買家的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "債券的到期或結束日期,届時可將其以面值或票面價值贖回。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "債券購買時的貼現率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PV",
    t: 8,
    d: "基於等額分期付款和固定利率,計算年金投資的現值。",
    a: "基於等額分期付款和固定利率,計算年金投資的現值。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款總期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "每期的付款金額,在年金週期內不能更改。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "D2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ACCRINT",
    t: 8,
    d: "返回定期付息證券的應計利息。",
    a: "返回定期付息證券的應計利息。",
    m: [6, 8],
    p: [{
      name: "issue",
      detail: "有價證券的發行日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "first_interest",
      detail: "有價證券的首次計息日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有價證券的年息票利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "par",
      detail: "證券的票面值。",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示""歐洲30/360"方法"-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "calc_method",
      detail: "[可選 - 默認為TRUE（）] - 一個邏輯值,指定當結算日期晚於首次計息日期時用於計算總應計利息的方法。\n\n如果值為TRUE,則返回從發行日到結算日的總應計利息。\n\n如果值為FALSE,則返回從首次計息日到結算日的應計利息。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ACCRINTM",
    t: 8,
    d: "返回在到期日支付利息的有價證券的應計利息。",
    a: "返回在到期日支付利息的有價證券的應計利息。",
    m: [4, 5],
    p: [{
      name: "issue",
      detail: "有價證券的發行日。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "settlement",
      detail: "有價證券的到期日。",
      example: "DATE(1969",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有價證券的年息票利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "par",
      detail: "證券的票面值。",
      example: "1000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYBS",
    t: 8,
    d: "返回從付息期開始到結算日的天數。",
    a: "返回從付息期開始到結算日的天數。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYS",
    t: 8,
    d: "返回結算日所在的付息期的天數。",
    a: "返回結算日所在的付息期的天數。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] -訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPDAYSNC",
    t: 8,
    d: "返回從結算日到下一票息支付日之間的天數。",
    a: "返回從結算日到下一票息支付日之間的天數。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法  - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPNCD",
    t: 8,
    d: "計算結算日之後的下一票息或利息派發日期。",
    a: "計算結算日之後的下一票息或利息派發日期。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COUPPCD",
    t: 8,
    d: "計算結算日之前的最後一個票息或利息支付日。",
    a: "計算結算日之前的最後一個票息或利息支付日。",
    m: [3, 4],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4 。",
      example: "01)",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "DATE(2019",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FV",
    t: 8,
    d: "基於等額分期付款和固定利率,計算年金投資的未來價值。",
    a: "基於等額分期付款和固定利率,計算年金投資的未來價值。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款總期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "各期所應支付的金額,在整個年金期間保持不變。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "[可選 - 預設值為0 ] - 現值,或一系列未來付款的當前值的累積和。",
      example: "400",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0 ] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FVSCHEDULE",
    t: 8,
    d: "返回應用一系列複利率計算的初始本金的未來值。",
    a: "返回應用一系列複利率計算的初始本金的未來值。",
    m: [2, 2],
    p: [{
      name: "principal",
      detail: "現值。",
      example: "10000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "schedule",
      detail: "用於計算本金複利的一組利率。\n\n利率錶必須是範圍或數組,其中包含要用於計算複利的一組利率。這些利率值應該以十進位小數形式表示,或者使用UNARY_PERCENT以百分比形式表示,即表示為0.09或UNARY_PERCENT（9）,而不要表示為9。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "YIELD",
    t: 8,
    d: "返回定期支付利息的債券的收益率。",
    a: "返回定期支付利息的債券的收益率。",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有價證券的年息票利率。",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pr",
      detail: "有價證券的價格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有價證券的清償價值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "YIELDDISC",
    t: 8,
    d: "基於價格計算折價發行的（不帶息）債券的年收益率。",
    a: "基於價格計算折價發行的（不帶息）債券的年收益率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "有價證券的價格。",
      example: "95",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有價證券的清償價值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NOMINAL",
    t: 8,
    d: "基於給定的實際利率和年複利期數,返回名義年利率。",
    a: "基於給定的實際利率和年複利期數,返回名義年利率。",
    m: [2, 2],
    p: [{
      name: "effect_rate",
      detail: "每年的實際利率。",
      example: "0.85",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "npery",
      detail: "每年的複利期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "XIRR",
    t: 8,
    d: "返回一組不一定定期發生的現金流的內部收益率。",
    a: "返回一組不一定定期發生的現金流的內部收益率。",
    m: [2, 3],
    p: [{
      name: "values",
      detail: "其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "dates",
      detail: "與現金流數額參數中的現金流對應的日期數組或範圍。",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "guess",
      detail: "[可選 - 預設值為0.1] - 對內部回報率的估算值。",
      example: "250",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MIRR",
    t: 8,
    d: "返回一系列定期現金流的修改後內部收益率。",
    a: "返回一系列定期現金流的修改後內部收益率。",
    m: [3, 3],
    p: [{
      name: "values",
      detail: "其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "finance_rate",
      detail: "現金流中使用的資金支付的利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "reinvest_rate",
      detail: "將現金流再投資的收益率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IRR",
    t: 8,
    d: "返回由值中的數位表示的一系列現金流的內部收益率。 ",
    a: "返回由值中的數位表示的一系列現金流的內部收益率。 ",
    m: [1, 2],
    p: [{
      name: "values",
      detail: "其中含有投資相關收益或支出的數組或範圍。\n\n現金流數額中必須至少包含一項負的和一項正的現金流金額才能計算回報率。",
      example: "A2:A25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "guess",
      detail: "[可選 - 默認為0.1] - 內部收益率的估值。",
      example: "200",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPV",
    t: 8,
    d: "使用貼現率和一系列未來支出（負值）和收益（正值）來計算一項投資的淨現值。",
    a: "使用貼現率和一系列未來支出（負值）和收益（正值）來計算一項投資的淨現值。",
    m: [2, 255],
    p: [{
      name: "rate",
      detail: "某一期間的貼現率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value1",
      detail: "第一筆支出（負值）和收益（正值）。",
      example: "200",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2, ...",
      detail: "[可選] - 其他支出（負值）和收益（正值）。",
      example: "250",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "XNPV",
    t: 8,
    d: "返回一組現金流的淨現值,這些現金流不一定定期發生。",
    a: "返回一組現金流的淨現值,這些現金流不一定定期發生。",
    m: [3, 3],
    p: [{
      name: "rate",
      detail: "應用於現金流的貼現率。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "values",
      detail: "與dates中的支付時間相對應的一系列現金流。",
      example: "B2:B25",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "dates",
      detail: "與現金流支付相對應的支付日期錶。",
      example: "C2:C25",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CUMIPMT",
    t: 8,
    d: "基於等額分期付款和固定利率,計算投資在一系列付款期內的累計利息。",
    a: "基於等額分期付款和固定利率,計算投資在一系列付款期內的累計利息。",
    m: [6, 6],
    p: [{
      name: "rate",
      detail: "利息率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "總付款期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start_period",
      detail: "開始累計計算的付款期序號。\n\n首期必須大於等於1。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "end_period",
      detail: "結束累計計算的付款期序號。\n\n末期必須大於首期。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "0",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PMT",
    t: 8,
    d: "用於根據固定付款額和固定利率計算貸款的付款額。",
    a: "用於根據固定付款額和固定利率計算貸款的付款額。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "貸款利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "該項貸款的付款總數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值,或一系列未來付款額現在所值的總額,也叫本金。",
      example: " 100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "D2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IPMT",
    t: 8,
    d: "基於固定利率及等額分期付款管道,返回給定期數內對投資的利息償還額。",
    a: "基於固定利率及等額分期付款管道,返回給定期數內對投資的利息償還額。",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "per",
      detail: "用於計算其利息數額的期數,必須在1到nper之間。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款總期數。",
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值,或一系列未來付款的當前值的累積和。",
      example: "80000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "E2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PPMT",
    t: 8,
    d: "返回根據定期固定付款和固定利率而定的投資在已知期間內的本金償付額。",
    a: "返回根據定期固定付款和固定利率而定的投資在已知期間內的本金償付額。",
    m: [4, 6],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "per",
      detail: "指定期數,該值必須在 1 到 nper 範圍內。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "nper",
      detail: "年金的付款總期數。",
      example: "3*12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值即一系列未來付款當前值的總和。",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "INTRATE",
    t: 8,
    d: "返回完全投資型證券的利率。",
    a: "返回完全投資型證券的利率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "有價證券的投資額。",
      example: "100000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "有價證券到期時的兌換值。",
      example: "101200",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法-此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法 - 此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法-此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICE",
    t: 8,
    d: "返回定期付息的面值￥100的有價證券的價格。",
    a: "返回定期付息的面值￥100的有價證券的價格。",
    m: [6, 7],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有價證券的年息票利率。",
      example: "0.057",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有價證券的年收益率。",
      example: "0.065",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值￥100的有價證券的清償價值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEDISC",
    t: 8,
    d: "返回折價發行的面值￥100的有價證券的價格。",
    a: "返回折價發行的面值￥100的有價證券的價格。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "discount",
      detail: "有价证券的贴现率。",
      example: "0.0525",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值￥100的有價證券的清償價值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "PRICEMAT",
    t: 8,
    d: "返回到期付息的面值￥100的有價證券的價格。",
    a: "返回到期付息的面值￥100的有價證券的價格。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "issue",
      detail: "有價證券的發行日。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "rate",
      detail: "有價證券在發行日的利率。",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有價證券的年收益率。",
      example: "0.061",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RECEIVED",
    t: 8,
    d: "返回一次性付息的有價證券到期收回的金額。",
    a: "返回一次性付息的有價證券到期收回的金額。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "investment",
      detail: "有價證券的投資額。",
      example: "10000000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "discount",
      detail: "有價證券的貼現率。",
      example: "0.0575",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DISC",
    t: 8,
    d: "返回有價證券的貼現率。",
    a: "返回有價證券的貼現率。",
    m: [4, 5],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "pr",
      detail: "有價證券的價格（按面值為￥100計算）。",
      example: "97.975",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "redemption",
      detail: "面值￥100的有價證券的清償價值。",
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "12",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "NPER",
    t: 8,
    d: "基於固定利率及等額分期付款管道,返回某項投資的總期數。",
    a: "基於固定利率及等額分期付款管道,返回某項投資的總期數。",
    m: [3, 5],
    p: [{
      name: "rate",
      detail: "各期利率。",
      example: "0.12",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pmt",
      detail: "各期所應支付的金額,在整個年金期間保持不變。",
      example: "500",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "pv",
      detail: "現值,或一系列未來付款的當前值的累積和。",
      example: "40000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "fv",
      detail: "[可選 - 預設值為0] - 未來值,或在最後一次付款後希望得到的現金餘額。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "type",
      detail: "[可選 - 預設值為0] - 指定各期的付款時間是在期初還是期末。\n\n0表示期末；\n\n1表示期初。",
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SLN",
    t: 8,
    d: "返回一個期間內的資產的直線折舊。",
    a: "返回一個期間內的資產的直線折舊。",
    m: [3, 3],
    p: [{
      name: "cost",
      detail: "資產原值。",
      example: "300000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "salvage",
      detail: "折舊末尾時的值（有時也稱為資產殘值）。",
      example: "75000",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "life",
      detail: "資產的折舊期數（有時也稱作資產的使用壽命）。",
      example: "10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DURATION",
    t: 8,
    d: "返回假設面值￥100的定期付息有價證券的修正期限。",
    a: "返回假設面值￥100的定期付息有價證券的修正期限。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "coupon",
      detail: "有價證券的年息票利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有價證券的年收益率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MDURATION",
    t: 8,
    d: "返回假設面值￥100的有價證券的Macauley修正期限。",
    a: "返回假設面值￥100的有價證券的Macauley修正期限。",
    m: [5, 6],
    p: [{
      name: "settlement",
      detail: "有價證券的結算日。有價證券結算日是在發行日之後,有價證券賣給購買者的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "maturity",
      detail: "有價證券的到期日。到期日是有價證券有效期截止時的日期。",
      example: "DATE(2010",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "coupon",
      detail: "有價證券的年息票利率。",
      example: "0.08",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "yld",
      detail: "有價證券的年收益率。",
      example: "0.09",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "frequency",
      detail: "年付息次數。\n\n如果按年支付,frequency = 1；\n\n按半年期支付,frequency = 2；\n\n按季支付,frequency = 4。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "basis",
      detail: '[可選 - 默認為0] - 訓示要使用哪種天數計算方法。\n\n0表示"美國（NASD）30/360"方法 - 此方法按照美國全國證券交易商協會標準,假設每月30天、每年360天,並對所輸入的月末日期進行具體調整。\n\n1表示"實際/實際"方法-此方法計算基於指定日期之間的實際天數和所涉及的年份中的實際天數進行計算。此方法用於美國長期債券,也是在非財經用途方面使用最多的方法。\n\n2表示"實際/360"方法 - 此方法基於指定日期之間的實際天數進行計算, 但假定每年為360天。\n\n3表示"實際/365"方法 - 此方法基於指定日期之間的實際天數進行計算,但假定每年為365天。\n\n4表示"歐洲30 / 360"方法-類似於0,此方法基於每月30天、每年360天進行計算,但按照歐洲金融慣例對月末日期進行調整。',
      example: "0",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2DEC",
    t: 9,
    d: "將二進位數轉換為十進位數。",
    a: "將二進位數轉換為十進位數。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要轉換為十進位數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2DEC（100）和BIN2DEC（"100"）得出的結果相同,均為4。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIN2HEX",
    t: 9,
    d: "將二進位數轉換為十六進位數。",
    a: "將二進位數轉換為十六進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的十六進位數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2HEX（11111）和BIN2HEX（"11111"）得出的結果相同,均為1F。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: '[ 可選 ] -結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。例如,BIN2HEX（"11111",8）所得的結果值為0000001F。\n\n如果帶符號的二進位數的最高位為1,則忽略此值；即當提供的帶符號的二進位數大於等於1000000000時忽略此值。',
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "BIN2OCT",
    t: 9,
    d: "二進位數轉換為八進制數。",
    a: "二進位數轉換為八進制數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的八進制數的帶符號的10位二進位數值（以字串形式提供）。\n\n帶符號的二進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n對於此函數,最大的正數輸入值為0111111111,最小的負數輸入值為1000000000。\n\n如果所提供的帶符號的二進位數是有效的二進位數,會自動將其轉換為相應的字串輸入。例如,BIN2OCT（11111）和BIN2OCT（"11111"）得出的結果相同,均為37。',
      example: "101",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: '[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。例如,BIN2OCT（"11111"）得到的結果值為00000037。\n\n如果帶符號的二進位數的最高位為1,則忽略此值；即當提供的帶符號的二進位數大於等於1000000000時忽略此值。',
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2BIN",
    t: 9,
    d: "將十進位數轉換為二進位數。",
    a: "將十進位數轉換為二進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的二進位數的十進位數值（以字串形式提供）。\n\n對於此函數,最大的正數輸入值為511,最小的負數輸入值為-512。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2BIN（199）和DEC2BIN（"199"）得出的結果相同,均為11000111。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2HEX",
    t: 9,
    d: "將十進位數轉換為十六進位數。",
    a: "將十進位數轉換為十六進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的十六進位數的十進位數值（以字串形式提供）。\n\n此函數可接受的最大正數值為549755813887,最小負數值為-549755814888。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2HEX（100）和DEC2HEX（"100"）得出的結果相同,均為64。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DEC2OCT",
    t: 9,
    d: "將十進位數轉換為八進制數。",
    a: "將十進位數轉換為八進制數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的八進制數的十進位數值（以字串形式提供）。\n\n此函數可接受的最大正數值為536870911,最小負數值為-53687092。\n\n如果所提供的十進位數是有效的十進位數,會自動將其轉換為相應的字串輸入。例如,DEC2OCT（199）和DEC2OCT（"199"）得出的結果相同,均為307。',
      example: "100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "places",
      detail: "[ 可選 ] -結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果十進位數為負數,則忽略此值 。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2BIN",
    t: 9,
    d: "將十六進位數轉換為二進位數。",
    a: "將十六進位數轉換為二進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的二進位數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為1FF,最小負數值為FFFFFFFE00。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2BIN（199）和HEX2BIN（"199"）得出的結果相同,均為110011001。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的十六進位數的最高位為1,則忽略此值；即當提供的帶符號的十六進位數大於等於8000000000時忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "HEX2DEC",
    t: 9,
    d: "將十六進位數轉換為十進位數。",
    a: "將十六進位數轉換為十進位數。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要轉換為十進位數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為7fffffffff,最小負數值為8000000000。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2DEC（199）和HEX2DEC（"199"）得出的結果相同,均為409 。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "HEX2OCT",
    t: 9,
    d: "將十六進位數轉換為八進制數。",
    a: "將十六進位數轉換為八進制數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的八進制數的帶符號的40位十六進位數值（以字串形式提供）。\n\n帶符號的十六進位數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為1FFFFFFF,最小負數值為FFE0000000。\n\n如果所提供的帶符號的十六進位數是有效的十六進位數,函數會自動將其轉換為相應的字串輸入。例如,HEX2OCT（199）和HEX2OCT（"199"）得出的結果相同,均為631。',
      example: '"f3"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的十六進位數的最高位為1,則忽略此值；即當給定的帶符號的十六進位數大於等於8000000000時忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2BIN",
    t: 9,
    d: "將八進制數轉換為二進位數。",
    a: "將八進制數轉換為二進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的二進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的八進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為777,最小負數值為7777777000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2BIN（177）和OCT2BIN（"177"）得出的結果相同,均為1111111。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的八進制數的最高位為1,則忽略此值；即當給定的帶符號的八進制數大於等於4000000000時忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "OCT2DEC",
    t: 9,
    d: "將八進制數轉換為十進位數。",
    a: "將八進制數轉換為十進位數。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: '要轉換為十進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的ba進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為3777777777,最小負數值為4000000000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2DEC（177）和OCT2DEC（"177"）得出的結果相同,均為127。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OCT2HEX",
    t: 9,
    d: "將八進制數轉換為十六進位數。",
    a: "將八進制數轉換為十六進位數。",
    m: [1, 2],
    p: [{
      name: "number",
      detail: '要轉換為帶符號的十六進位數的帶符號的30位八進制數值（以字串形式提供）。\n\n帶符號的ba進制數的最高位是符號位；也就是說,負數是以二的補數形式表示的。\n\n此函數可接受的最大正數值為3777777777,最小負數值為4000000000。\n\n如果所提供的帶符號的八進制數是有效的八進制數,函數會自動將其轉換為相應的字串輸入。例如,OCT2HEX（177）和OCT2HEX（"177"）得出的結果相同,均為7F。',
      example: "37",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "places",
      detail: "[ 可選 ] - 結果中要確保的有效位數。\n\n如果設定的有效位數大於結果中的有效位數,則在結果的左側填充0,使總有效位數達到有效位數。\n\n如果帶符號的八進制數的最高位為1,則忽略此值；即當給定的帶符號的八進制數大於等於4000000000時忽略此值。",
      example: "8",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "COMPLEX",
    t: 9,
    d: "將實係數及虛係數轉換為 x+yi 或 x+yj 形式的複數。",
    a: "將實係數及虛係數轉換為 x+yi 或 x+yj 形式的複數。",
    m: [2, 3],
    p: [{
      name: "real_num",
      detail: "複數的實係數。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "i_num",
      detail: "複數的虛係數。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "suffix",
      detail: '[可選 - 默認為"i"] - 複數中虛係數的尾碼。',
      example: '"j"',
      require: "o",
      repeat: "n",
      type: "rangestring"
    }]
  }, {
    n: "IMREAL",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的複數的實係數。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的複數的實係數。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要計算其實係數的複數。",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMAGINARY",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的複數的虛係數。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的複數的虛係數。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要計算其虛係數的複數。",
      example: '"4+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMCONJUGATE",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的複數的共軛複數。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的複數的共軛複數。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "需要計算其共軛數的複數。",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMABS",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的複數的絕對值（模）。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的複數的絕對值（模）。",
    m: [1, 1],
    p: [{
      name: "inumber",
      detail: "要計算其絕對值的複數。",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DELTA",
    t: 9,
    d: "檢驗兩個值是否相等。如果 number1=number2,則返回1；否則返回0。",
    a: "檢驗兩個值是否相等。如果 number1=number2,則返回1；否則返回0。",
    m: [1, 2],
    p: [{
      name: "number1",
      detail: "第一個數位。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "number2",
      detail: "[可選 - 默認為0] - 第二個數位。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "IMSUM",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的和。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的和。",
    m: [1, 255],
    p: [{
      name: "inumber1",
      detail: "要相加的第一個複數",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2, …",
      detail: "[可選] -要與值1相加的其他複數",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMSUB",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的兩個複數的差。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的兩個複數的差。",
    m: [2, 2],
    p: [{
      name: "inumber1",
      detail: "從（複）數中减去 inumber2。",
      example: '"6+5i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2",
      detail: "從 inumber1 中减（複）數。",
      example: '"2+3i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IMPRODUCT",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的乘積。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的 1 至 255 個複數的乘積。",
    m: [1, 255],
    p: [{
      name: "inumber1",
      detail: "用於計算乘積的第一個複數",
      example: '"3+4i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2, …",
      detail: "[可選] -要相乘的其他複數。",
      example: '"5-3i"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IMDIV",
    t: 9,
    d: "返回以 x+yi 或 x+yj 文本格式表示的兩個複數的商。",
    a: "返回以 x+yi 或 x+yj 文本格式表示的兩個複數的商。",
    m: [2, 2],
    p: [{
      name: "inumber1",
      detail: "複數分子或被除數。",
      example: '"11+16i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "inumber2",
      detail: "複數分母或除數。",
      example: '"3+2i"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NOT",
    t: 10,
    d: '返回某個邏輯值的相反值-"NOT（TRUE（））"將返回FALSE；"NOT（FALSE（））"將返回TRUE。',
    a: '返回某個邏輯值的相反值-"NOT（TRUE（））"將返回FALSE；"NOT（FALSE（））"將返回TRUE。',
    m: [1, 1],
    p: [{
      name: "logical",
      detail: "計算結果為TRUE或FALSE的任何值或運算式。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRUE",
    t: 10,
    d: "返回邏輯值 TRUE。",
    a: "返回邏輯值 TRUE。",
    m: [0, 0],
    p: []
  }, {
    n: "FALSE",
    t: 10,
    d: "返回邏輯值 FALSE。",
    a: "返回邏輯值 FALSE。",
    m: [0, 0],
    p: []
  }, {
    n: "AND",
    t: 10,
    d: "所有參數的計算結果為TRUE時,返回TRUE；只要有一個參數的計算結果為FALSE,即返回FALSE。",
    a: "所有參數的計算結果為TRUE時,返回TRUE；只要有一個參數的計算結果為FALSE,即返回FALSE。",
    m: [1, 255],
    p: [{
      name: "logical1",
      detail: "要測試的第一個條件,其計算結果可以為TRUE或FALSE。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "logical2,...",
      detail: "[可選] - 要測試的其他條件,其計算結果可以為TRUE或FALSE,最多可包含255個條件。",
      example: 'A3 = "bar"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "IFERROR",
    t: 10,
    d: "如果第一個參數不是錯誤值,就返回第一個參數；否則,返回第二個參數。",
    a: "如果第一個參數不是錯誤值",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "檢查是否存在錯誤的參數。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_error",
      detail: "公式的計算結果錯誤時返回的值。計算以下錯誤類型:#N/A、#VALUE！、#REF！、#DIV/0！、#NUM！、#NAME？或#NULL！。",
      example: '"Error in cell A1"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "IF",
    t: 10,
    d: "當邏輯運算式的值為TRUE時返回一個值,而當其為FALSE時返回另一個值。",
    a: "當邏輯運算式的值為TRUE時返回一個值,而當其為FALSE時返回另一個值。",
    m: [2, 3],
    p: [{
      name: "logical_test",
      detail: "一個運算式或對包含運算式的儲存格的引用,該運算式代表某種邏輯值（即TRUE或FALSE）。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_true",
      detail: "當邏輯運算式為TRUE時的返回值。",
      example: '"A2 is foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value_if_false",
      detail: "[可選 - 默認為空白] - 當邏輯運算式等於FALSE時的函數返回值。",
      example: '"A2 was false"',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "OR",
    t: 10,
    d: "只要有一個參數的計算結果為TRUE時,返回TRUE；所有參數的計算結果為FALSE,即返回FALSE。",
    a: "只要有一個參數的計算結果為TRUE時,返回TRUE；所有參數的計算結果為FALSE,即返回FALSE。",
    m: [1, 255],
    p: [{
      name: "logical1",
      detail: "要測試的第一個條件,其計算結果可以為TRUE或FALSE。",
      example: 'A2 = "foo"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "邏輯運算式2",
      detail: "[可選] - 其他運算式或對包含運算式的儲存格的引用,這些運算式代表某種邏輯值（即TRUE或FALSE）或者可以強制轉換為邏輯值。",
      example: ' A3 = "bar"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "NE",
    t: 11,
    d: '如果指定的值不相等,則返回"TRUE"；否則返回"FALSE"。相當於"<>"運算子。',
    a: '如果指定的值不相等,則返回"TRUE"；否則返回"FALSE"。相當於"<>"運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一個值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要檢查是否與 value1 不相等的值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EQ",
    t: 11,
    d: '如果指定的值相等,則返回"TRUE"；否則返回"FALSE"。相當於"="運算子。',
    a: '如果指定的值相等,則返回"TRUE"；否則返回"FALSE"。相當於"="運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一個值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要檢查是否與value1相等的值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GT",
    t: 11,
    d: "如果第一個參數嚴格大於第二個，則返回TRUE；否則返回FALSE。相當於" > "運算子。",
    a: "如果第一個參數嚴格大於第二個，則返回TRUE；否則返回FALSE。相當於" > "運算子。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要測試其是否大於 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二個值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "GTE",
    t: 11,
    d: '如果第一個參數大於或等於第二個，則返回TRUE；否則返回FALSE。相當於">="運算子。',
    a: '如果第一個參數大於或等於第二個，則返回TRUE；否則返回FALSE。相當於">="運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否大于等于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二個值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LT",
    t: 11,
    d: '如果第一個參數嚴格小於第二個，則返回TRUE；否則返回FALSE。相當於"<"運算子。',
    a: '如果第一個參數嚴格小於第二個，則返回TRUE；否則返回FALSE。相當於"<"運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否小于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二個值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LTE",
    t: 11,
    d: '如果第一個參數小於或等於第二個，則返回TRUE；否則返回FALSE。相當於"<="運算子。',
    a: '如果第一個參數小於或等於第二個，則返回TRUE；否則返回FALSE。相當於"<="運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要测试其是否小于等于 value2 的值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "第二個值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ADD",
    t: 11,
    d: '返回兩個數值之和。相當於"+"運算子。',
    a: '返回兩個數值之和。相當於"+"運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一個加數。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "第二個加數。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINUS",
    t: 11,
    d: '返回兩個數值之差。相當於"-"運算子。',
    a: '返回兩個數值之差。相當於"-"運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "被減數,即要對其計减的數值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "減數,即要從value1中减除的數值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MULTIPLY",
    t: 11,
    d: '返回兩個數的乘積。相當於"*"運算子。',
    a: '返回兩個數的乘積。相當於"*"運算子。',
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "第一個乘數。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "第二個乘數。",
      example: "B2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DIVIDE",
    t: 11,
    d: "返回兩個參數相除所得的結果。相當於`/`運算子。",
    a: "返回兩個參數相除所得的結果。相當於`/`運算子。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "要被除的數值。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "value2",
      detail: "用於除其他數的數值。\n\n除數不得為0。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCAT",
    t: 11,
    d: "返回兩個值的串聯。相當於`&`運算子。",
    a: "返回兩個值的串聯。相當於`&`運算子。",
    m: [2, 2],
    p: [{
      name: "value1",
      detail: "value2 將附於其後的值。",
      example: '"de"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "value2",
      detail: "要附於 value1 之後的值。",
      example: '"mystify"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNARY_PERCENT",
    t: 11,
    d: '返回按百分比解釋的數值。例如,"UNARY_PERCENT（100）"等於1。',
    a: '返回按百分比解釋的數值。例如,"UNARY_PERCENT（100）"等於1。',
    m: [1, 1],
    p: [{
      name: "number",
      detail: "要作為百分比解釋的數值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CONCATENATE",
    t: 12,
    d: "將兩個或多個文字字串聯接為一個字串。",
    a: "將兩個或多個文字字串聯接為一個字串。",
    m: [1, 255],
    p: [{
      name: "text1",
      detail: "初始字串。",
      example: '"Super"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text2…",
      detail: "[可選] - 要按順序連接在一起的其他字串。",
      example: '"calla"',
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "CODE",
    t: 12,
    d: "返回所提供的字串中首字元的Unicode映射值。",
    a: "返回所提供的字串中首字元的Unicode映射值。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其首字元的Unicode映射值的字串。",
      example: '"a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CHAR",
    t: 12,
    d: "按照當前Unicode編碼表,將數位轉換為對應的字元。",
    a: "按照當前Unicode編碼表,將數位轉換為對應的字元。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "介於1到255之間的數位。",
      example: "97",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ARABIC",
    t: 12,
    d: "將羅馬數字轉換為阿拉伯數字。",
    a: "將羅馬數字轉換為阿拉伯數字。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要轉換格式的羅馬數字",
      example: '"XIV"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ROMAN",
    t: 12,
    d: "將數位格式設定為羅馬數字形式。",
    a: "將數位格式設定為羅馬數字形式。",
    m: [1, 1],
    p: [{
      name: "number",
      detail: "要設定格式的數位,介於1到3999之間（包括這兩個數位）。",
      example: "499",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "REGEXEXTRACT",
    t: 12,
    d: "按照規則運算式選取匹配的子串。",
    a: "按照規則運算式選取匹配的子串。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "輸入文字。",
      example: '"Needle in a haystack"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "此函數將返回文字中符合此運算式的第一個子串。",
      example: '".e{2}dle"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXMATCH",
    t: 12,
    d: "判斷一段文字是否與規則運算式相匹配。",
    a: "判斷一段文字是否與規則運算式相匹配。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "要用規則運算式測試的文字。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "用來測試文字的規則運算式。",
      example: '"S.r"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REGEXREPLACE",
    t: 12,
    d: "使用規則運算式將文字字串中的一部分替換為其他文字字串。",
    a: "使用規則運算式將文字字串中的一部分替換為其他文字字串。",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "要對其局部進行替換操作的文字。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "regular_expression",
      detail: "規則運算式。text中所有匹配的實例都將被替換。",
      example: '"S.*d"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "replacement",
      detail: "要插入到原有文字中的文字。",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "T",
    t: 12,
    d: "返回文本格式的字串參數。",
    a: "返回文本格式的字串參數。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為文字的參數。\n\n如果值為文字,T將返回值本身。\n\n如果值為指向包含文字的儲存格的引用,T將返回值中的內容。\n\n如果值為錯誤值或包含錯誤值的儲存格,T將返回該錯誤值。\n\n對於所有其他情况,T將返回空串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIXED",
    t: 12,
    d: "以固定的小數位數設定數位的格式。",
    a: "以固定的小數位數設定數位的格式。",
    m: [1, 3],
    p: [{
      name: "number",
      detail: "要進行舍入並轉換為文字的數位。",
      example: "3.141592653",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "decimals",
      detail: "[可選-預設值為2] - 結果中要顯示的小數位數。\n\n如果數值的有效位數小於小數位數,將以零填充。如果數值的有效位數大於小數位數,則將其舍入到所需的小數位數而不是將其截斷。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "no_commas",
      detail: "[可選-預設值為FALSE（）] - 一個邏輯值,如果為TRUE（）,則會禁止FIXED在返回的文字中包含逗號。",
      example: "FALSE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FIND",
    t: 12,
    d: "返回字串在文字中首次出現的位置（區分大小寫）。",
    a: "返回字串在文字中首次出現的位置（區分大小寫）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要蒐索的文字中查找的字串。",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中蒐索蒐索字串的首次出現位置的文字。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[可選-預設值為1] - 要在要蒐索的文字中開始蒐索的字元位置。",
      example: "14",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "FINDB",
    t: 12,
    d: "返回某個字串在文字中首次出現的位置（每個雙位元組字元占兩個位置）。",
    a: "返回某個字串在文字中首次出現的位置（每個雙位元組字元占兩個位置）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要蒐索的文字中查找的字串。",
      example: '"新"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中蒐索蒐索字串的首次出現位置的文字。",
      example: '"農曆新年"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[可選-預設值為1] - 要在要蒐索的文字中開始蒐索的字元位置。",
      example: "2",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "JOIN",
    t: 12,
    d: "將一個或多個使用指定定界符的一維數組的元素連接到一起。",
    a: "將一個或多個使用指定定界符的一維數組的元素連接到一起。",
    m: [2, 255],
    p: [{
      name: "separator",
      detail: "置於相互連接的值之間的字元或字串。\n\n定界符可以為空,例如JOIN（,{1,2,3}）。",
      example: '"and-a"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "array1",
      detail: "要使用定界符連接的一個或多個值。",
      example: "{1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "array2,…",
      detail: "[可選] - 要使用定界符連接的其他值或數組。",
      example: "2",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "LEFT",
    t: 12,
    d: "從文字字串的第一個字元開始返回指定個數的字元。",
    a: "從文字字串的第一個字元開始返回指定個數的字元。",
    m: [1, 2],
    p: [{
      name: "text",
      detail: "包含要選取的字元的文字字串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_chars",
      detail: "[可選-預設值為1] - 指定要由LEFT選取的字元的數量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "RIGHT",
    t: 12,
    d: "根據所指定的字元數返回文字字串中最後一個或多個字元。",
    a: "根據所指定的字元數返回文字字串中最後一個或多個字元。",
    m: [1, 2],
    p: [{
      name: "text",
      detail: "包含要選取的字元的文字字串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "num_chars",
      detail: "[可選-預設值為1] - 指定要由RIGHT選取的字元的數量。",
      example: "2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MID",
    t: 12,
    d: "返回文字字串中從指定位置開始的特定數目的字元。",
    a: "返回文字字串中從指定位置開始的特定數目的字元。",
    m: [3, 3],
    p: [{
      name: "text",
      detail: "包含要選取的字元的文字字串。",
      example: '"get this"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "要從字串中開始選取的位置。字串中第一個字元的索引為1。",
      example: "5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_chars",
      detail: "指定要由MID選取的字元的數量。\n\n如果選取的字元數尚不足選取長度個字元時就到達了字串尾部,則MID返回從開始位置到字串尾部的字元。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "LEN",
    t: 12,
    d: "返回給定字串的長度。",
    a: "返回給定字串的長度。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其長度的字串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LENB",
    t: 12,
    d: "返回文字中所包含的字元數。與雙位元組字元集（DBCS）一起使用。",
    a: "返回文字中所包含的字元數。與雙位元組字元集（DBCS）一起使用。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要返回其位元組數的字串。（一個漢字為兩個位元組數）",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOWER",
    t: 12,
    d: "將指定字串中的字母轉換為小寫。",
    a: "將指定字串中的字母轉換為小寫。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要轉換為小寫的字串。",
      example: '"LOREM IPSUM"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UPPER",
    t: 12,
    d: "將指定字串中的字母轉換為大寫。",
    a: "將指定字串中的字母轉換為大寫。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要轉換為大寫的字串。",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "EXACT",
    t: 12,
    d: "比較兩個字串是否相同。",
    a: "比較兩個字串是否相同。",
    m: [2, 2],
    p: [{
      name: "text1",
      detail: "要比較的第一個字串。",
      example: "A1",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "text2",
      detail: "要比較的第二個字串。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPLACE",
    t: 12,
    d: "將文字字串的一部分替換為其他文字字串。",
    a: "將文字字串的一部分替換為其他文字字串。",
    m: [4, 4],
    p: [{
      name: "old_text",
      detail: "要對其局部進行替換操作的文字。",
      example: '"Spreadsheets"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "開始進行替換操作的位置（文字開頭位置為1）。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "num_chars",
      detail: "要在文字中替換的字元個數。",
      example: "6",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_text",
      detail: "要插入到原有文字中的文字。",
      example: '"Bed"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "REPT",
    t: 12,
    d: "返回指定文字的多次重複。",
    a: "返回指定文字的多次重複。",
    m: [2, 2],
    p: [{
      name: "text",
      detail: "要重複的字元或字串。",
      example: '"ha"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "number_times",
      detail: "要重複的文字要在返回值中出現的次數。\n\n最大重複次數為100。即使重複次數大於100,REPT也僅將相應文字重複100次。",
      example: "4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEARCH",
    t: 12,
    d: "返回字串在文字中首次出現的位置（不區分大小寫）。",
    a: "返回字串在文字中首次出現的位置（不區分大小寫）。",
    m: [2, 3],
    p: [{
      name: "find_text",
      detail: "要在要蒐索的文字中查找的字串。",
      example: '"n"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "within_text",
      detail: "要在其中蒐索蒐索字串的首次出現位置的文字。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "start_num",
      detail: "[可選-預設值為1 ] - 要在要蒐索的文字中開始蒐索的字元位置。",
      example: "14",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUBSTITUTE",
    t: 12,
    d: "在文字字串中用new_text替換old_text。",
    a: "在文字字串中用new_text替換old_text。",
    m: [3, 4],
    p: [{
      name: "text",
      detail: "需要替換其中字元的文字,或對含有文字（需要替換其中字元）的儲存格的引用。",
      example: '"search for it"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "old_text",
      detail: "需要替換的文字。",
      example: '"search for"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "new_text",
      detail: "用於替換old_text的文字。",
      example: '"Google"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "instance_num",
      detail: "[可選] - 指定要用new_text替換old_text的事件。如果指定了instance_num,則只有滿足要求的old_text被替換。否則,文字中出現的所有old_text都會更改為new_text。",
      example: "3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "CLEAN",
    t: 12,
    d: "移除文字中的不可列印ASCII字元後將其返回。",
    a: "移除文字中的不可列印ASCII字元後將其返回。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要移除其中不可列印字元的文字。",
      example: '"AF"&amp;CHAR（31）',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TEXT",
    t: 12,
    d: "按照指定格式將數位轉換為文字。",
    a: "按照指定格式將數位轉換為文字。",
    m: [2, 2],
    p: [{
      name: "value",
      detail: "要設定格式的數位、日期或時間。",
      example: "1.23",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "format_text",
      detail: '以括弧括起來的模式串,將按該模式設定數位的格式。\n\n0表示在數值位數少於格式指定的位數時必定以零填充。例如,TEXT（12.3,“000.00"）將返回012.30。當數值的小數位數超過模式指定的小數位數時,四捨五入為指定的小數位數。例如,TEXT（12.305,“00.00"）將返回12.31。\n\n#類似於0,但並不是在小數點的兩側都以零填充。例如,TEXT（12.3,“###.##"）將返回12.3。',
      example: '"$0.00"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRIM",
    t: 12,
    d: "删除指定字串前後的空格。",
    a: "删除指定字串前後的空格。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要修剪的字串或指向包含該字串的儲存格的引用。",
      example: '"lorem ipsum"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "VALUE",
    t: 12,
    d: "將可識別的任何日期、時間或數位格式的字串轉換為數位。",
    a: "將可識別的任何日期、時間或數位格式的字串轉換為數位。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "包含要轉換的值的字串。",
      example: '"123"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROPER",
    t: 12,
    d: "將指定字串中每個單詞的首字母轉為大寫。",
    a: "將指定字串中每個單詞的首字母轉為大寫。",
    m: [1, 1],
    p: [{
      name: "text",
      detail: "要轉換的文字,其中每個單詞的首字母都將轉為大寫,所有其他字母則轉為小寫。",
      example: '"united states"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CONVERT",
    t: 13,
    d: "將數位從一種度量系統轉換為另一種度量系統。",
    a: "將數位從一種度量系統轉換為另一種度量系統。",
    m: [3, 3],
    p: [{
      name: "number",
      detail: "是以from_unit為組織的需要進行轉換的數值。",
      example: "5.1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "from_unit",
      detail: "是數值的組織。",
      example: '"g"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "to_unit",
      detail: "是結果的組織。",
      example: '"kg"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "SUMX2MY2",
    t: 14,
    d: "返回兩數組中對應數值的平方差之和。",
    a: "返回兩數組中對應數值的平方差之和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一個數組或數值區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二個數組或數值區域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMX2PY2",
    t: 14,
    d: "返回兩數組中對應數值的平方和之和。",
    a: "返回兩數組中對應數值的平方和之和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一個數組或數值區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二個數組或數值區域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMXMY2",
    t: 14,
    d: "返回兩數組中對應數值之差的平方和。",
    a: "返回兩數組中對應數值之差的平方和。",
    m: [2, 2],
    p: [{
      name: "array_x",
      detail: "第一個數組或數值區域。",
      example: "A2:A100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array_y",
      detail: "第二個數組或數值區域。",
      example: "B2:B100",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TRANSPOSE",
    t: 14,
    d: "將數組或儲存格範圍的行列轉置。",
    a: "將數組或儲存格範圍的行列轉置。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "要將其行列互換的數組或範圍。",
      example: "{1,2}",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "TREND",
    t: 14,
    d: "返回線性趨勢值。",
    a: "返回線性趨勢值。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可選-默認該數組為{1,2,3,…},其大小與known_y相同] -關係運算式y = mx + b 中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_x",
      detail: "[可選 - 默認與known_x相同] - 需要函數TREND返回對應y值的新x值。",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m 將被調整以使y = mx。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FREQUENCY",
    t: 14,
    d: "計算數值在某個區域內的出現頻率,然後返回一個垂直數組。",
    a: "計算數值在某個區域內的出現頻率,然後返回一個垂直數組。",
    m: [2, 2],
    p: [{
      name: "data_array",
      detail: "要對其頻率進行計數的一組數值或對這組數值的引用。",
      example: "A2:A40",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "bins_array",
      detail: "要將data_array中的值插入到的間隔數組或對間隔的引用。\n\n為清晰起見,應將類別排序,但如果未排序,FREQUENCY會在內部對這些指定的值進行排序並返回正確結果。",
      example: "B2:B5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "GROWTH",
    t: 14,
    d: "使用現有數據計算預測的指數等比。",
    a: "使用現有數據計算預測的指數等比。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "關係運算式y = b*m^x 中已知的y值集合。\n\n如果已知數據_y為二維陣列或範圍,則已知數據_x的維數必須與之相同,或者省略此參數。\n\n如果已知數據_y為一維數組或範圍,已知數據_x則可代表二維陣列或範圍中的多個引數。也就是說,如果已知數據_y為單行,則將已知數據_x中的每行解釋為各自獨立的值,類似情况也適用於已知數據_y為單列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = b*m^x 中已知的可選x值集合。\n\n如果已知數據_y為一維數組或範圍,已知數據_x則可代表二維陣列或範圍中的多個引數。也就是說,如果已知數據_y為單行,則將已知數據_x中的每行解釋為各自獨立的值,類似情况也適用於已知數據_y為單列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "new_x",
      detail: "[可選 - 默認與known_x相同] - 需要函數GROWTH返回對應y值的新x值。",
      example: "A11:A13",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為1。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為1,m將被調整以使y = m^x。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINEST",
    t: 14,
    d: "可通過使用最小二乘法計算與現有數據最佳擬合的直線,來計算某直線的統計值,然後返回描述此直線的數組。",
    a: "可通過使用最小二乘法計算與現有數據最佳擬合的直線,來計算某直線的統計值,然後返回描述此直線的數組。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = mx + b中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m將被調整以使y = mx。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "stats",
      detail: "[可選 - 預設值為FALSE（）] - 一個邏輯值,用於指定是否返回附加回歸統計值。\n\n如果詳細為TRUE,除了對應於每個引數的一組線性係數和y截距之外,LINEST還返回以下資訊:\n\n每項係數和截距的標準誤差、\n\n限定係數（介於0和1之間,1表示完全相關）、\n\n因變數值的標准誤差、\n\nF統計或F觀測值,訓示所觀測到的因變數和引數變數之間的關係是隨機的還是線性的、\n\n自由度,用於在參照錶中查找F統計值以估算可信度、\n\n回歸平方和,以及\n\n殘差平方和。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LOGEST",
    t: 14,
    d: "在回歸分析中,計算最符合數據的指數回歸擬合曲線,並返回描述該曲線的數值數組。",
    a: "在回歸分析中,計算最符合數據的指數回歸擬合曲線,並返回描述該曲線的數值數組。",
    m: [1, 4],
    p: [{
      name: "known_y",
      detail: "關係運算式y = mx + b 中已知的y值集合。\n\n如果known_y為二維陣列或範圍,則known_x的維數必須與之相同,或者省略此參數。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "B2:B10",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "known_x",
      detail: "[可選 - 默認該數組為{1,2,3,…},其大小與known_y相同] - 關係運算式y = mx + b中已知的可選x值集合。\n\n如果known_y為一維數組或範圍,known_x則可代表二維陣列或範圍中的多個引數。也就是說,如果known_y為單行,則將known_x中的每行解釋為各自獨立的值,類似情况也適用於known_y為單列的情况。",
      example: "A2:A10",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "const",
      detail: "[可選 - 預設值為TRUE（）] - 一個邏輯值,用於指定是否將常數b強制設為0。\n\nTRUE（）表示b將按正常計算；\n\nFALSE（）表示b將被設為0（零）,m將被調整以使y = mx。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "stats",
      detail: "[可選 - 預設值為FALSE（）] - 一個邏輯值,用於指定是否返回附加回歸統計值。\n\n如果詳細為TRUE,則除了為每個引數和係數b返回一組指數值之外,LOGEST還將返回以下數據:\n\n每項指數和係數的標準誤差、\n\n限定係數（介於0和1之間,1表示完全相關）、\n\n因變數值的標准誤差、\n\nF統計或F觀測值,訓示所觀測到的因變數和引數之間的關係是隨機的還是指數的、\n\n自由度-用於在參照錶中查找F統計值以估算可信度、\n\n回歸平方和,以及\n\n殘差平方和。",
      example: "TRUE（）",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "MDETERM",
    t: 14,
    d: "返回一個數組的矩陣行列式的值。",
    a: "返回一個數組的矩陣行列式的值。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "行數和列數相等的數值數組。",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MINVERSE",
    t: 14,
    d: "返回數組中存儲的矩陣的逆矩陣。",
    a: "返回數組中存儲的矩陣的逆矩陣。",
    m: [1, 1],
    p: [{
      name: "array",
      detail: "行數和列數相等的數值數組。",
      example: "A1:D4",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "MMULT",
    t: 14,
    d: "返回兩個數組的矩陣乘積。結果矩陣的行數與array1的行數相同,矩陣的列數與array2的列數相同。",
    a: "返回兩個數組的矩陣乘積。結果矩陣的行數與array1的行數相同,矩陣的列數與array2的列數相同。",
    m: [2, 2],
    p: [{
      name: "array1",
      detail: "要進行矩陣乘法運算的第一個矩陣數組。\n\narray1列數必須與array2的行數相同",
      example: "A1:B3",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "要進行矩陣乘法運算的第二個矩陣數組。\n\narray2的行數必須與array1列數相同",
      example: "C1:F2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SUMPRODUCT",
    t: 14,
    d: "在給定的幾組數組中,將數組間對應的元素相乘,並返回乘積之和。",
    a: "在給定的幾組數組中,將數組間對應的元素相乘,並返回乘積之和。",
    m: [1, 255],
    p: [{
      name: "array1",
      detail: "其相應元素需要進行相乘並求和的第一個數組參數。",
      example: "A2:C5",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "array2",
      detail: "[可選] - 其相應元素需要進行相乘並求和的其它數組參數。",
      example: "D2:F5",
      require: "o",
      repeat: "y",
      type: "rangenumber"
    }]
  }, {
    n: "ISFORMULA",
    t: 15,
    d: "檢查公式是否位於引用的儲存格中。",
    a: "檢查公式是否位於引用的儲存格中。",
    m: [1, 1],
    p: [{
      name: "cell",
      detail: "要檢查是否存在公式的儲存格。\n\n如果 cell 為包含公式的儲存格,則 ISFORMULA 將返回TRUE。如果 cell 為相應儲存格範圍,則當該範圍內的首個儲存格包含公式時,系統會返回TRUE。如果是任何其他值,系統都將返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "CELL",
    t: 15,
    d: "返回有關儲存格的格式、位置或內容的資訊。",
    a: "返回有關儲存格的格式、位置或內容的資訊。",
    m: [2, 2],
    p: [{
      name: "info_type",
      detail: "一個文字值,指定要返回的儲存格資訊的類型。",
      example: '"type"',
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "reference",
      detail: "需要其相關資訊的儲存格。",
      example: "C2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "NA",
    t: 15,
    d: "返回錯誤值#N/A。",
    a: "返回錯誤值#N/A。",
    m: [0, 0],
    p: []
  }, {
    n: "ERROR_TYPE",
    t: 15,
    d: "返回與其他儲存格中的錯誤值相對應的數位。",
    a: "返回與其他儲存格中的錯誤值相對應的數位。",
    m: [1, 1],
    p: [{
      name: "error_val",
      detail: "用於查找錯誤號的儲存格,雖然您也可以直接提供錯誤值。",
      example: "A3",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISBLANK",
    t: 15,
    d: "檢查所引用的儲存格是否為空。",
    a: "檢查所引用的儲存格是否為空。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "對要檢查其是否為空的儲存格的引用。\n\n如果是空儲存格,則TRUE；否則返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISERR",
    t: 15,
    d: "檢查某個值是否為#N/A以外的錯誤值。",
    a: "檢查某個值是否為#N/A以外的錯誤值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其是否為#N/A以外的錯誤類型的值。\n\n如果值是除#N/A之外的任何錯誤（包括#DIV/0！、#NAME？、#NULL！、#NUM！、#VALUE！和#REF！）,ISERR將返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISERROR",
    t: 15,
    d: "檢查某個值是否為錯誤值。",
    a: "檢查某個值是否為錯誤值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其是否為錯誤類型的值。\n\n只要值是某種錯誤值（包括#DIV/0！、#N/A、#NAME？、#NULL！、#NUM！、#VALUE！和#REF！）,ISERROR就會返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISLOGICAL",
    t: 15,
    d: "檢查某個值是TRUE還是FALSE。",
    a: "檢查某個值是TRUE還是FALSE。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其為邏輯 TRUE 還是邏輯 FALSE 的值。\n\n*如果值為TRUE或FALSE,或為指向值為TRUE或FALSE的儲存格的引用,ISLOGICAL將返回TRUE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNA",
    t: 15,
    d: "檢查某個值是否為錯誤值#N/A。",
    a: "檢查某個值是否為錯誤值#N/A。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要與錯誤值#N/A進行比較的值。\n\n*如果值為#N/A或指向包含#N/A的儲存格的引用,則ISNA將返回TRUE,否則返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNONTEXT",
    t: 15,
    d: "檢查某個值是否為非文字。",
    a: "檢查某個值是否為非文字。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要檢查的文字。\n\n*如果參數為文字值或指向包含文字的儲存格的引用,ISNONTEXT將返回FALSE,否則返回TRUE。\n\n當值為指向空儲存格的引用時,ISNONTEXT會返回TRUE。\n\n當值為空字串時,ISNONTEXT將返回FALSE,因為空串被視作文字。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISNUMBER",
    t: 15,
    d: "檢查某個值是否為數位。",
    a: "檢查某個值是否為數位。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其是否為數位的值。\n\n*如果參數為數位或指向內容為數位值的儲存格的引用,ISNUMBER將返回TRUE,否則返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISREF",
    t: 15,
    d: "檢查某個值是否為有效的儲存格引用。",
    a: "檢查某個值是否為有效的儲存格引用。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其是否為儲存格引用的值。\n\n*如果參數是有效的儲存格引用,ISREF將返回TRUE,否則返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "ISTEXT",
    t: 15,
    d: "檢查某個值是否為文字。",
    a: "檢查某個值是否為文字。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要驗證其是否為文字的值。\n\n如果參數為文字值或指向包含文字值的儲存格的引用,ISTEXT將返回TRUE,否則返回FALSE。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TYPE",
    t: 15,
    d: "返回數值的類型。",
    a: "返回數值的類型。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要確定其類型的數據。\n\n數位返回1；\n\n文字返回2；\n\n邏輯值返回4；\n\n錯誤值返回16；\n\n數組返回64；",
      example: "C4",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "N",
    t: 15,
    d: "返回轉化為數值後的值。",
    a: "返回轉化為數值後的值。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為數位的參數。\n\n如果值為數位,則返回該數位。\n\n如果值為日期,則返回該日期的序號。\n\n如果值為TRUE,則返回1。\n\n如果值為FALSE,則返回0。\n\n如果值為錯誤值,則返回錯誤值。\n\n如果值為其他值,則返回0。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DATE",
    t: 16,
    d: "將指定的數位轉換為日期。",
    a: "將指定的數位轉換為日期。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為日期的參數或其儲存格引用。\n\n如果值為數位或指向內容為數值的儲存格的引用,TO_DATE會將值轉換為相應的日期並返回,值代表從十二月30日到對應的日期之間的天數,\n\n負值表示對應的日期在十二月30日之前,而小數值則代表一天中從午夜算起的時間。\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_DATE將在不做任何修改的情况下返回值。",
      example: "25405",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PURE_NUMBER",
    t: 16,
    d: "將給定的日期/時間、百分比、貨幣金額或其他格式的數值轉換為不帶格式的純數位。",
    a: "將給定的日期/時間、百分比、貨幣金額或其他格式的數值轉換為不帶格式的純數位。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為純數位的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_PURE_NUMBER將以不帶任何格式與解釋的形式返回值。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_PERCENT將在不做任何修改的情况下返回值。",
      example: "50%",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_TEXT",
    t: 16,
    d: "將給定的數位值轉換為文本格式。",
    a: "將給定的數位值轉換為文本格式。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為文字的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_TEXT將返回字串形式的值,並保持現有格式。即原為貨幣的仍為貨幣,原為十進位數的仍為十進位數,原為百分比的仍為百分比,原為日期的仍為日期。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_TEXT將在不做任何修改的情况下返回值。",
      example: "24",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TO_DOLLARS",
    t: 16,
    d: "將指定的數位轉換為美元金額。",
    a: "將指定的數位轉換為美元金額。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為美元金額的參數或其儲存格引用。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_DOLLARS將在不做任何修改的情况下返回值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "TO_PERCENT",
    t: 16,
    d: "將指定的數位轉換為百分比。",
    a: "將指定的數位轉換為百分比。",
    m: [1, 1],
    p: [{
      name: "value",
      detail: "要轉換為百分比的參數或其儲存格引用。\n\n如果值為數位或指向包含數值的儲存格的引用,TO_PERCENT會以1 = 100%為標準,將值轉換為百分比。\n\n如果值不是數位或指向內容為數值的儲存格的引用,則TO_PERCENT將在不做任何修改的情况下返回值。",
      example: "A2",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DGET",
    t: 17,
    d: "使用SQL式査詢,從清單或資料庫的列中選取符合指定條件的單個值。",
    a: "使用SQL式査詢,從清單或資料庫的列中選取符合指定條件的單個值。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMAX",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最大數位。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最大數位。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DMIN",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最小數位。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的最小數位。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DAVERAGE",
    t: 17,
    d: "使用SQL式査詢,對清單或資料庫中滿足指定條件的記錄欄位（列）中的數值求平均值。",
    a: "使用SQL式査詢,對清單或資料庫中滿足指定條件的記錄欄位（列）中的數值求平均值。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNT",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中包含數位的儲存格的個數。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中包含數位的儲存格的個數。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DCOUNTA",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的非空儲存格的個數。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的非空儲存格的個數。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DPRODUCT",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數值的乘積。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數值的乘積。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEV",
    t: 17,
    d: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體標準差。",
    a: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體標準差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSTDEVP",
    t: 17,
    d: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為樣本總體計算出的總體標準差。",
    a: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為樣本總體計算出的總體標準差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DSUM",
    t: 17,
    d: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數位之和。",
    a: "使用SQL式査詢,返回列表或資料庫中滿足指定條件的記錄欄位（列）中的數位之和。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVAR",
    t: 17,
    d: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體方差。",
    a: "使用SQL式査詢,返回利用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位作為一個樣本估算出的總體方差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "DVARP",
    t: 17,
    d: "使用SQL式査詢,通過使用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位計算樣本總體的樣本總體方差。",
    a: "使用SQL式査詢,通過使用清單或資料庫中滿足指定條件的記錄欄位（列）中的數位計算樣本總體的樣本總體方差。",
    m: [3, 3],
    p: [{
      name: "database",
      detail: "構成清單或資料庫的儲存格區域,清單的第一行包含每一列的標籤。",
      example: "A2:F20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "field",
      detail: "指定database中的哪一列包含要選取和用於計算的值。\n\nfield可以是與database第一行中某個列標題對應的文字標籤,也可以是指定相關列的數位索引,第一列的索引值為1。",
      example: "G2",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "criteria",
      detail: "包含所指定條件的儲存格區域。計算之前將使用這些條件來過濾database中的值。",
      example: "A22:D23",
      require: "m",
      repeat: "n",
      type: "range"
    }]
  }, {
    n: "AGE_BY_IDCARD",
    t: "3",
    d: "據中國身份證號計算出年齡。支持15位或18位身份證",
    a: "據中國身份證號計算出年齡",
    m: [1, 2],
    p: [{
      name: "身份證號",
      example: "A1",
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "截止日期",
      example: '"2017-10-01"',
      detail: "年齡計算的截止日期或範圍,默認為當日。",
      require: "o",
      repeat: "n",
      type: "rangedatetime"
    }]
  }, {
    n: "SEX_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出性別。支持15位或18位身份證",
    a: "根據身份證號得到性別。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BIRTHDAY_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出生日。支持15位或18位身份證",
    a: "根據身份證號得到生日。",
    m: [1, 2],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "生日格式",
      example: "0",
      detail: "日期類型,默認0:[1900/01/01],1:[1900-01-01],2:[1900年1月1日]",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "PROVINCE_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出籍貫的省份。支持15位或18位身份證",
    a: "根據身份證號得到籍貫的省份。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "CITY_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出籍貫的都市。支持15位或18位身份證",
    a: "根據身份證號得到籍貫的都市。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "STAR_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出星座。支持15位或18位身份證",
    a: "根據身份證號得到星座。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ANIMAL_BY_IDCARD",
    t: "3",
    d: "根據中國身份證號計算出生肖（鼠、牛、虎、兔…）。支持15位或18位身份證",
    a: "根據身份證號得到生肖。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "ISIDCARD",
    t: "3",
    d: "驗證身份證的格式是否正確。支持15位或18位身份證",
    a: "驗證身份證格式正確性。",
    m: [1, 1],
    p: [{
      name: "身份證號",
      example: '"31033519900101XXXX"',
      detail: "15位或者18位的身份證號或範圍。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "DM_TEXT_CUTWORD",
    t: "4",
    d: "文字分詞。把一連串文字折開為一系列單獨詞語",
    a: "中文文字分詞。",
    m: [1, 2],
    p: [{
      name: "文字",
      example: '"我來到北京清華大學"',
      detail: "任意需要分詞的文字。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "分詞模式",
      example: "0",
      detail: "默認為0[精確模式]，1[全模式]，2[搜尋引擎模式]。",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TFIDF",
    t: "4",
    d: "採用tf-idf算灋進行關鍵字選取。從一連串文字中識別關鍵字",
    a: "tf-idf關鍵字識別。",
    m: [1, 3],
    p: [{
      name: "文字",
      example: '"我來到北京清華大學"',
      detail: "任意需要分詞的文字。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "關鍵字個數",
      example: "20",
      detail: "算灋返回的關鍵字個數，默認20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "語料庫",
      example: "1",
      detail: "選擇特定領域的語料庫，默認0[通用]，1[金融]，2[醫療]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DM_TEXT_TEXTRANK",
    t: "4",
    d: "採用TextRank算灋進行關鍵字選取。從一連串文字中識別關鍵字",
    a: "TextRank關鍵字識別。",
    m: [1, 3],
    p: [{
      name: "文字",
      example: '"我來到北京清華大學"',
      detail: "任意需要分詞的文字。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "關鍵字個數",
      example: "20",
      detail: "算灋返回的關鍵字個數，默認20",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "語料庫",
      example: "1",
      detail: "選擇特定領域的語料庫，默認0[通用]，1[金融]，2[醫療]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_CLOSE",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票收盤價。",
    a: "返回A股對應股票收盤價。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默認為最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_OPEN",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票開盤價。",
    a: "返回A股對應股票開盤價。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默認為最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MAX",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票最高價。",
    a: "返回A股對應股票最高價。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默認為最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_MIN",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票最低價。",
    a: "返回A股對應股票最低價。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日,默认为最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_VOLUMN",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票成交量。",
    a: "返回A股對應股票成交量。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默認為最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "DATA_CN_STOCK_AMOUNT",
    t: "5",
    d: "根據股票代碼和日期，返回A股對應股票成交額。",
    a: "返回A股對應股票成交額。",
    m: [1, 3],
    p: [{
      name: "股票代碼",
      example: '"000001"',
      detail: "6位股票代碼，必填項。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "日期",
      example: "2015-01-08",
      detail: "股票的交易日，默認為最新交易日",
      require: "o",
      repeat: "n",
      type: "rangedate"
    }, {
      name: "複權除權",
      example: "0",
      detail: "選擇股票的除權複權類型，默認0[前複權]，1[原始價格]，2[後複權]",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "ISDATE",
    t: "6",
    d: "驗證日期的格式是否正確。支持多種日期格式",
    a: "驗證日期格式正確性。",
    m: [1, 1],
    p: [{
      name: "日期",
      example: '"1990-01-01"',
      detail: "日期值,例如1990/01/01, 1990年1月1日等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "LINESPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的折線圖sparklines，用於描述數據的連續走勢",
    a: "生成儲存格折線圖",
    m: [1, 8],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "線條顏色",
      example: "#2ec7c9",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "線條粗細",
      example: "1",
      detail: "折線圖線段粗細，默認為1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "輔助線",
      example: "avg",
      detail: "一條橫線，可以是min、max、avg、median、範圍或自定義數值，默認0無",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "輔助線顏色",
      example: "#000",
      detail: "輔助線的顏色設定，同線條顏色配寘，默認#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值標識",
      example: "#fc5c5c",
      detail: "標識線圖最大值，同線條顏色配寘，默認0不顯示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最小值標識",
      example: "#fc5c5c",
      detail: "標識線圖最小值，同線條顏色配寘，默認0不顯示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "標識大小",
      example: "1.5",
      detail: "最大值和最小值的標識大小設定，默認為1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "AREASPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的面積圖sparklines，一般用於描述數據的連續累積值走勢",
    a: "生成儲存格面積圖",
    m: [1, 5],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "線條顏色",
      example: "#2ec7c9",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "填充顏色",
      example: "#CCF3F4",
      detail: "形成面積圖，同線條顏色配寘，默認0不顯示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "線條粗細",
      example: "1",
      detail: "折線圖線段粗細，默認為1px",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "輔助線",
      example: "avg",
      detail: "一條橫線，可以是min、max、avg、median、範圍或自定義數值，默認0無",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "輔助線顏色",
      example: "#000",
      detail: "輔助線的顏色設定，同線條顏色配寘，默認#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "COLUMNSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的垂直柱狀圖sparklines，一般用於描述離散數據之間的大小情况",
    a: "生成儲存格垂直柱狀圖",
    m: [1, 6],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條間隔",
      example: "1",
      detail: "柱條之間的間隔距離，默認為1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條顏色",
      example: "#fc5c5c",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "負向柱條顏色",
      example: "#97b552",
      detail: "負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0:5:#000表示數值0-5的柱為黑色，默認為空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKCOLUMNSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的累積垂直柱狀圖sparklines，一般用於描述離散數據多個維度的數值大小",
    a: "生成儲存格累積垂直柱狀圖",
    m: [1, 5],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍，數值才能被有效計算，例如A1:A20，{1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "按列堆積",
      example: "1",
      detail: "如果需要按行堆積則本項設為false或0，默認為是1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條間隔",
      example: "1",
      detail: "柱條之間的間隔距離，默認為1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "累積柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "累積色板",
      example: "#97b552",
      detail: "調色板可以單獨設定每個維度的柱條顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BARSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的橫向條形圖sparklines，一般用於描述離散數據之間的大小情况",
    a: "生成儲存格橫向條形圖",
    m: [1, 6],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條間隔",
      example: "1",
      detail: "柱條之間的間隔距離，默認為1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條顏色",
      example: "#fc5c5c",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "負向柱條顏色",
      example: "#97b552",
      detail: "負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0:5:#000表示數值0-5的柱為黑色，默認為空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "STACKBARSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的累積橫向條形圖sparklines，一般用於描述離散數據多個維度的數值大小",
    a: "生成儲存格累積橫向條形圖",
    m: [1, 5],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "按列堆積",
      example: "1",
      detail: "如果需要按行堆積則本項設為false或0，默認為是1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條間隔",
      example: "1",
      detail: "柱條之間的間隔距離，默認為1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "最大值",
      example: "100",
      detail: "累積柱圖最大值，用於規範柱圖長度，默認為自動計算false、auto、null",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "累積色板",
      example: "#97b552",
      detail: "調色板可以單獨設定每個維度的柱條顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "DISCRETESPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的離散圖sparklines，一般用於描述離散數據走勢",
    a: "生成儲存格離散圖",
    m: [1, 4],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "分割閾值",
      example: "1",
      detail: "離散圖柱形顏色的區分，例如:該值為0，則大於0為藍色，小於0為紅色，默認為0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "閾值以上顏色",
      example: "#2ec7c9",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#2ec7c9",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "閾值以下顏色",
      example: "#fc5c5c",
      detail: "閾值以下柱條顏色設定，同閾值以上顏色，默認#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "TRISTATESPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的三態圖sparklines，一般用於描述三種態勢的走勢例如勝負平",
    a: "生成儲存格三態圖",
    m: [1, 6],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條間隔",
      example: "1",
      detail: "柱條之間的間隔距離，默認為1",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "柱條顏色",
      example: "#fc5c5c",
      detail: "線圖的線條顏色，可以是否個範圍A1、色錶索引數值或者具體顏色值，設定為0或false則不顯示，支持regx、rgb、rgba等。默認#fc5c5c",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "负向柱條顏色",
      example: "#97b552",
      detail: "負向柱條顏色設定，代表負值的顏色，同柱條顏色配寘，默認#97b552",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "零值柱條顏色",
      example: "#999",
      detail: "零值柱條顏色設定，代表0值顏色，同柱條顏色配寘，默認#999",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "色板",
      example: "#97b552",
      detail: "調色板可以單獨設定每個柱條的顏色，可設定多個，支持兩種格式:1顏色例如#000，代表第一個柱的顏色是黑色；2數值範圍:顏色，例如-2:#000表示數值為-2的柱為黑色，0-5:#000表示數值0-5的柱為黑色，默認為空",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "PIESPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的餅圖sparklines，一般用於描述數據占比",
    a: "生成儲存格餅圖",
    m: [1, 5],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "旋轉角度",
      example: "0",
      detail: "餅圖的旋轉角度，默認為0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "餅圖邊框",
      example: "0",
      detail: "餅圖邊框大小，默認為無0",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "邊框顏色",
      example: "#000",
      detail: "餅圖邊框顏色，默認為#000",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "餅圖色板",
      example: "#97b552",
      detail: "調色板可以設定切片的顏色，可設定為A1:A10等範圍，默認為#2ec7c9, #fc5c5c, #5ab1ef, #ffb980...",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "BOXSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的箱線圖sparklines，一般用於描述數據集的統計分佈",
    a: "生成儲存格箱線圖",
    m: [1, 4],
    p: [{
      name: "數據範圍",
      example: "A1:A20",
      detail: "數據範圍,數值才能被有效計算，例如A1:A20, {1,2,3,4,5}等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "離群點比例",
      example: "1.5",
      detail: "離群點的閾值範圍，如果為0或false則不顯示，默認為1.5倍",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "目標點值",
      example: "10",
      detail: "箱線圖上的目標值設定，默認為false不顯示",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "數據點大小",
      example: "1.5",
      detail: "目標點和離群點的半徑大小設定，默認為1.5",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "BULLETSPLINES",
    t: "3",
    d: "生成嵌入在儲存格內的子彈圖sparklines，一般用於描述任務達成率",
    a: "生成儲存格子彈圖",
    m: [2, 3],
    p: [{
      name: "目標",
      example: "10",
      detail: "達成的目標值，數值才能被有效計算，例如A1，100等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "實際完成",
      example: "8",
      detail: "現時完成值，數值才能被有效計算，例如A1，100等。",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "對比值",
      example: "12",
      detail: "對比值，例如超額、最低、獲獎底線等，數值才能被有效計算，例如A1，100等。可以設定最多9個對比值",
      require: "o",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "COMPOSESPLINES",
    t: "3",
    d: "支持多個類型的圖畫在同一個儲存格，每個參數代表一個sparklines圖",
    a: "組合sparklines圖到一個儲存格",
    m: [1, 1],
    p: [{
      name: "圖設定",
      example: "PIESPLINES(A1:A20)",
      detail: "sparklines圖設定，例如A1:A20，一個完成的餅圖、線圖設定等。",
      require: "m",
      repeat: "y",
      type: "rangeall"
    }]
  }, {
    n: "SORT",
    t: "14",
    d: "返回數組中元素的排序數組。返回的數組與提供的數組參數形狀相同。",
    a: "返回數組中元素的排序數組。返回的數組與提供的數組參數形狀相同。",
    m: [1, 4],
    p: [{
      name: "array",
      detail: "要排序的範圍或數組。",
      example: "A2:A17",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_index",
      detail: "[可選] - 表示要排序的行或列的數位。（默認row1/col1）",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "sort_order",
      detail: "[可選] - 表示所需排序順序的數位；1表示昇冪（默認），-1表示降序。",
      example: "-1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[可選] - 表示所需排序方向的邏輯值；按行排序為FALSE（）（默認），按列排序為TRUE（）。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "FILTER",
    t: "14",
    d: "基於一個布林（真/假）數組過濾一個數組。",
    a: "基於一個布林（真/假）數組過濾一個數組。",
    m: [2, 3],
    p: [{
      name: "array",
      detail: "要篩選的數組或範圍。",
      example: "A5:D20",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "include",
      detail: "布林數組，其高度或寬度與數組相同",
      example: "1",
      require: "m",
      repeat: "n",
      type: "range"
    }, {
      name: "if_empty",
      detail: "[可選] - 如果包含數組中的所有值都為空（filter不返回任何值），則返回的值。",
      example: '""',
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "UNIQUE",
    t: "14",
    d: "返回列表或區域中的唯一值的清單。",
    a: "返回列表或區域中的唯一值的清單。",
    m: [1, 3],
    p: [{
      name: "array",
      detail: "從其返回唯一值的數組或區域。",
      example: "A2:B26",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "by_col",
      detail: "[可選] - 邏輯值，訓示如何比較；按行= FALSE（）或省略；按列= TRUE（）。",
      example: "TRUE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }, {
      name: "occurs_once",
      detail: "[可選] - 邏輯值，僅返回唯一值中出現一次= TRUE（）；包括所有唯一值= FALSE（）或省略。",
      example: "FALSE()",
      require: "o",
      repeat: "n",
      type: "rangeall"
    }]
  }, {
    n: "RANDARRAY",
    t: "14",
    d: "返回0到1之間的隨機數位數組。",
    a: "返回0到1之間的隨機數位數組",
    m: [0, 2],
    p: [{
      name: "rows",
      detail: "[可選] - 要返回的行數。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "[可選] - 要返回的列數。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "SEQUENCE",
    t: "14",
    d: "生成數位序列的清單。",
    a: "生成數位序列的清單。",
    m: [1, 4],
    p: [{
      name: "rows",
      detail: "要返回的行數。",
      example: "1",
      require: "m",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "cols",
      detail: "[可選] - 要返回的列數。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "start",
      detail: "[可選] - 序列中的第一個數位。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }, {
      name: "step",
      detail: "[可選] -序列中每個序列值的增量。",
      example: "1",
      require: "o",
      repeat: "n",
      type: "rangenumber"
    }]
  }, {
    n: "EVALUATE",
    t: "3",
    d: "對以文字表示的公式或者表達式求值，並返回結果。",
    a: "根據文字公式或者表達式求值。",
    m: [1, 1],
    p: [{
      name: "公式",
      example: '"A1+5*2^2"',
      detail: "公式或表達式",
      require: "m",
      repeat: "n",
      type: "rangeall"
    }]
  }],
  toolbar: {
    toolbar: "工具栏",
    undo: "撤銷",
    redo: "重做",
    paintFormat: "格式刷",
    currencyFormat: "貨幣格式",
    percentageFormat: "百分比格式",
    numberDecrease: "减少小數位數",
    numberIncrease: "新增小數位數",
    moreFormats: "更多格式",
    font: "字體",
    "font-size": "字型大小",
    bold: "粗體（Ctrl+B）",
    italic: "斜體（Ctrl+I）",
    strikethrough: "删除線（Alt+Shift+5）",
    underline: "底線",
    "font-color": "文字顏色",
    chooseColor: "顏色選擇",
    resetColor: "重置顏色",
    customColor: "自定義",
    alternatingColors: "交替顏色",
    confirmColor: "確定顏色",
    cancelColor: "取消",
    collapse: "收起",
    background: "儲存格顏色",
    border: "邊框",
    borderStyle: "邊框類型",
    "merge-cell": "合併儲存格",
    chooseMergeType: "選擇合併類型",
    horizontalAlign: "水准對齊",
    verticalAlign: "垂直對齊",
    alignment: "對齊管道",
    textWrap: "文字換行",
    textWrapMode: "換行管道",
    textRotate: "文字旋轉",
    textRotateMode: "旋轉管道",
    freeze: "凍結",
    sort: "排序",
    filter: "篩選",
    findAndReplace: "查找替換",
    "formula-sum": "求和",
    autoSum: "自動求和",
    moreFunction: "更多函數",
    conditionalFormat: "條件格式",
    comment: "批註",
    pivotTable: "數據透視錶",
    chart: "圖表",
    screenshot: "截圖",
    splitColumn: "分列",
    insertImage: "插入圖片",
    insertLink: "插入連結",
    dataVerification: "數據驗證",
    protection: "保護工作表內容",
    clearText: "清除顏色選擇",
    noColorSelectedText: "沒有顏色被選擇",
    toolMore: "更多",
    toolLess: "少於",
    toolClose: "收起",
    toolMoreTip: "更多功能",
    moreOptions: "更多選項",
    cellFormat: "設定儲存格格式",
    print: "列印"
  },
  alternatingColors: {
    applyRange: "應用範圍",
    selectRange: "選擇應用範圍",
    header: "頁眉",
    footer: "頁腳",
    errorInfo: "不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",
    textTitle: "格式樣式",
    custom: "自定義",
    close: "關閉",
    selectionTextColor: "選擇文字顏色",
    selectionCellColor: "選擇儲存格顏色",
    removeColor: "移除交替顏色",
    colorShow: "顏色",
    currentColor: "當前顏色",
    tipSelectRange: "請選擇交替顏色應用範圍",
    errorNoRange: "您選擇的應用範圍不是選區！",
    errorExistColors: "您選擇的應用範圍已存在交替顏色且不屬於你要編輯的應用範圍！"
  },
  button: {
    confirm: "確定",
    cancel: "取消",
    close: "關閉",
    update: "Update",
    delete: "Delete",
    insert: "新建",
    prevPage: "上一頁",
    nextPage: "下一頁",
    total: "總共："
  },
  paint: {
    start: "格式刷開啟",
    end: "ESC鍵退出",
    tipSelectRange: "請選擇需要複製格式的區域",
    tipNotMulti: "無法對多重選擇區域執行此操作"
  },
  format: {
    moreCurrency: "更多貨幣格式",
    moreDateTime: "更多日期與時間格式",
    moreNumber: "更多數位格式",
    titleCurrency: "貨幣格式",
    decimalPlaces: "小數位數",
    titleDateTime: "日期與時間格式",
    titleNumber: "數位格式"
  },
  info: {
    detailUpdate: "新打開",
    detailSave: "已恢復本地緩存",
    row: "行",
    column: "列",
    loading: "加载中···",
    copy: "副本",
    return: "返回",
    rename: "重命名",
    tips: "表格重命名",
    noName: "無標題的試算表",
    wait: "待更新",
    add: "添加",
    addLast: "在底部添加",
    backTop: "回到頂部",
    pageInfo: "共${total}條,${totalPage}頁,當前已顯示${currentPage}頁",
    nextPage: "下一頁",
    tipInputNumber: "請輸入數位",
    tipInputNumberLimit: "新增範圍限制在1-100",
    tipRowHeightLimit: "行高必須在0 ~ 545之間",
    tipColumnWidthLimit: "列寬必須在0 ~ 2038之間",
    pageInfoFull: "共${total}條,${totalPage}頁,已顯示全部數據"
  },
  currencyDetail: {
    RMB: "人民幣",
    USdollar: "美元",
    EUR: "歐元",
    GBP: "英鎊",
    HK: "港元",
    JPY: "日元",
    AlbanianLek: "阿爾巴尼亞列克",
    AlgerianDinar: "阿爾及利亞第納爾",
    Afghani: "阿富汗尼",
    ArgentinePeso: "阿根廷比索",
    UnitedArabEmiratesDirham: "阿拉伯聯合大公國迪拉姆",
    ArubanFlorin: "阿魯巴弗羅林",
    OmaniRial: "阿曼裡亞爾",
    Azerbaijanimanat: "阿塞拜疆馬納特",
    EgyptianPound: "埃及鎊",
    EthiopianBirr: "衣索比亞比爾",
    AngolaKwanza: "安哥拉寬紮",
    AustralianDollar: "澳大利亞元",
    Patacas: "澳門元",
    BarbadosDollar: "巴巴多斯元",
    PapuaNewGuineaKina: "巴布亞新幾內亞基那",
    BahamianDollar: "巴哈馬元",
    PakistanRupee: "巴基斯坦盧比",
    ParaguayanGuarani: "巴拉圭瓜拉尼",
    BahrainiDinar: "巴林第納爾",
    PanamanianBalboa: "巴拿馬巴波亞",
    Brazilianreal: "巴西裏亞伊",
    Belarusianruble: "白俄羅斯盧布",
    BermudianDollar: "百慕大元",
    BulgarianLev: "保加利亞列弗",
    IcelandKrona: "冰島克朗",
    BosniaHerzegovinaConvertibleMark: "波黑可兌換馬克",
    PolishZloty: "波蘭茲羅提",
    Boliviano: "玻利維亞諾",
    BelizeDollar: "貝裡斯元",
    BotswanaPula: "波劄那普拉",
    NotDannuzhamu: "不丹努紮姆",
    BurundiFranc: "布隆迪法郎",
    NorthKoreanWon: "朝鮮圓",
    DanishKrone: "丹麥克朗",
    EastCaribbeanDollar: "東加勒比元",
    DominicaPeso: "多明尼加比索",
    RussianRuble: "俄國盧布",
    EritreanNakfa: "厄利垂亞納克法",
    CFAfranc: "非洲金融共同體法郎",
    PhilippinePeso: "菲律賓比索",
    FijiDollar: "斐濟元",
    CapeVerdeEscudo: "佛得角埃斯庫多",
    FalklandIslandsPound: "福克蘭群島鎊",
    GambianDalasi: "岡比亞達拉西",
    Congolesefranc: "剛果法郎",
    ColombianPeso: "哥倫比亞比索",
    CostaRicanColon: "哥斯大黎加科朗",
    CubanPeso: "古巴比索",
    Cubanconvertiblepeso: "古巴可兌換比索",
    GuyanaDollar: "蓋亞那元",
    KazakhstanTenge: "哈薩克共和國堅戈",
    Haitiangourde: "海地古德",
    won: "韓元",
    NetherlandsAntillesGuilder: "荷屬安的列斯盾",
    Honduraslempiras: "洪都拉斯拉倫皮拉",
    DjiboutiFranc: "吉布提法郎",
    KyrgyzstanSom: "吉爾吉斯斯坦索姆",
    GuineaFranc: "幾內亞法郎",
    CanadianDollar: "加拿大元",
    GhanaianCedi: "加納塞地",
    Cambodianriel: "高棉瑞爾",
    CzechKoruna: "捷克克朗",
    ZimbabweDollar: "辛巴威元",
    QatariRiyal: "卡塔爾裡亞爾",
    CaymanIslandsDollar: "開曼群島元",
    Comorianfranc: "科摩羅法郎",
    KuwaitiDinar: "科威特第納爾",
    CroatianKuna: "克羅地亞庫納",
    KenyanShilling: "肯雅先令",
    LesothoLoti: "萊索托洛蒂",
    LaoKip: "老撾基普",
    LebanesePound: "黎巴嫩鎊",
    Lithuanianlitas: "立陶宛立特",
    LibyanDinar: "利比亞第納爾",
    LiberianDollar: "利比亞元",
    RwandaFranc: "盧安達法郎",
    RomanianLeu: "羅馬尼亞列伊",
    MalagasyAriary: "馬拉加西阿裏亞裏",
    MaldivianRufiyaa: "瑪律地夫拉菲亞",
    MalawiKwacha: "馬拉威克瓦查",
    MalaysianRinggit: "馬來西亞林吉特",
    MacedoniawearingDinar: "馬其頓戴第納爾",
    MauritiusRupee: "模裡西斯盧比",
    MauritanianOuguiya: "茅利塔尼亞烏吉亞",
    MongolianTugrik: "蒙古圖格裡克",
    BangladeshiTaka: "孟加拉塔卡",
    PeruvianNuevoSol: "秘魯新索爾",
    MyanmarKyat: "緬甸開亞特",
    MoldovanLeu: "莫爾達瓦列伊",
    MoroccanDirham: "摩洛哥迪拉姆",
    MozambiqueMetical: "莫三比克梅蒂卡爾",
    MexicanPeso: "墨西哥比索",
    NamibianDollar: "納米比亞元",
    SouthAfricanRand: "南非蘭特",
    SouthSudanesePound: "南蘇丹鎊",
    NicaraguaCordoba: "尼加拉瓜科多巴",
    NepaleseRupee: "尼泊爾盧比",
    NigerianNaira: "奈及利亞奈拉",
    NorwegianKrone: "挪威克朗",
    GeorgianLari: "喬治亞拉瑞",
    RMBOffshore: "人民幣（離岸）",
    SwedishKrona: "瑞典克朗",
    SwissFranc: "瑞士法郎",
    SerbianDinar: "塞爾維亞第納爾",
    SierraLeone: "塞拉里昂利昂",
    SeychellesRupee: "塞舌耳盧比",
    SaudiRiyal: "沙特裡亞爾",
    SaoTomeDobra: "聖多美多布拉",
    SaintHelenapound: "聖赫倫那群島磅",
    SriLankaRupee: "斯里蘭卡盧比",
    SwazilandLilangeni: "史瓦濟蘭裏蘭吉尼",
    SudanesePound: "蘇丹鎊",
    Surinamesedollar: "蘇利南元",
    SolomonIslandsDollar: "所羅門群島元",
    SomaliShilling: "索馬利亞先令",
    TajikistanSomoni: "塔吉克共和國索莫尼",
    PacificFranc: "太平洋法郎",
    ThaiBaht: "泰國銖",
    TanzanianShilling: "坦尚尼亞先令",
    TonganPaanga: "東加潘加",
    TrinidadandTobagoDollar: "千裡達托貝哥元",
    TunisianDinar: "突尼斯第納爾",
    TurkishLira: "土耳其里拉",
    VanuatuVatu: "瓦努阿圖瓦圖",
    GuatemalanQuetzal: "瓜地馬拉格查爾",
    CommissionBolivar: "委內瑞拉博利瓦",
    BruneiDollar: "汶萊元",
    UgandanShilling: "烏干達先令",
    UkrainianHryvnia: "烏克蘭格裡夫尼亞",
    UruguayanPeso: "烏拉圭比索",
    Uzbekistansom: "烏茲別克蘇姆",
    WesternSamoaTala: "薩摩亞塔拉",
    SingaporeDollar: "新加坡元",
    NT: "新臺幣",
    NewZealandDollar: "新西蘭元",
    HungarianForint: "匈牙利福林",
    SyrianPound: "敘利亞鎊",
    JamaicanDollar: "牙買加元",
    ArmenianDram: "亞美尼亞德拉姆",
    YemeniRial: "葉門裡亞爾",
    IraqiDinar: "伊拉克第納爾",
    IranianRial: "伊朗裡亞爾",
    NewIsraeliShekel: "以色列新謝克爾",
    IndianRupee: "印度盧比",
    IndonesianRupiah: "印尼盧比",
    JordanianDinar: "約旦第納爾",
    VND: "越南盾",
    ZambianKwacha: "尚比亞克瓦查",
    GibraltarPound: "直布羅陀鎊",
    ChileanPeso: "智利比索",
    CFAFrancBEAC: "中非金融合作法郎"
  },
  defaultFmt: function defaultFmt(currency) {
    return [{
      text: "自動",
      value: "General",
      example: ""
    }, {
      text: "純文字",
      value: "@",
      example: ""
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "數位",
      value: "##0.00",
      example: "1000.12"
    }, {
      text: "百分比",
      value: "#0.00%",
      example: "12.21%"
    }, {
      text: "科學計數",
      value: "0.00E+00",
      example: "1.01E+5"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "會計",
      value: "".concat(currency, "(0.00)"),
      example: "".concat(currency, "(1200.09)")
    }, {
      text: "萬元",
      value: "w",
      example: "1亿2000万2500"
    }, {
      text: "貨幣",
      value: "".concat(currency, "0.00"),
      example: "".concat(currency, "1200.09")
    }, {
      text: "萬元2位小數",
      value: "w0.00",
      example: "2万2500.55"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "日期",
      value: "yyyy-MM-dd",
      example: "2017-11-29"
    }, {
      text: "時間",
      value: "hh:mm AM/PM",
      example: "3:00 PM"
    }, {
      text: "時間24H",
      value: "hh:mm",
      example: "15:00"
    }, {
      text: "日期時間",
      value: "yyyy-MM-dd hh:mm AM/PM",
      example: "2017-11-29 3:00 PM"
    }, {
      text: "日期時間24H",
      value: "yyyy-MM-dd hh:mm",
      example: "2017-11-29 15:00"
    }, {
      text: "",
      value: "split",
      example: ""
    }, {
      text: "自定義格式",
      value: "fmtOtherSelf",
      example: "more"
    }];
  },
  dateFmtList: [{
    name: "1930-08-05",
    value: "yyyy-MM-dd"
  }, {
    name: "1930/8/5",
    value: "yyyy/MM/dd"
  }, {
    name: "1930年8月5日",
    value: 'yyyy"年"M"月"d"日"'
  }, {
    name: "08-05",
    value: "MM-dd"
  }, {
    name: "8-5",
    value: "M-d"
  }, {
    name: "8月5日",
    value: 'M"月"d"日"'
  }, {
    name: "13:30:30",
    value: "h:mm:ss"
  }, {
    name: "13:30",
    value: "h:mm"
  }, {
    name: "下午01:30",
    value: "上午/下午 hh:mm"
  }, {
    name: "下午1:30",
    value: "上午/下午 h:mm"
  }, {
    name: "下午1:30:30",
    value: "上午/下午 h:mm:ss"
  }, {
    name: "08-05 下午01:30",
    value: "MM-dd 上午/下午 hh:mm"
  }],
  fontFamily: {
    MicrosoftYaHei: "Microsoft YaHei"
  },
  fontarray: ["Times New Roman", "Arial", "Tahoma", "Verdana", "微軟雅黑", "宋體", "黑體", "楷體", "仿宋", "新宋體", "華文新魏", "華文行楷", "華文隸書"],
  fontjson: {
    "times new roman": 0,
    arial: 1,
    tahoma: 2,
    verdana: 3,
    微軟雅黑: 4,
    "microsoft yahei": 4,
    宋體: 5,
    simsun: 5,
    黑體: 6,
    simhei: 6,
    楷體: 7,
    kaiti: 7,
    仿宋: 8,
    fangsong: 8,
    新宋體: 9,
    nsimsun: 9,
    華文新魏: 10,
    stxinwei: 10,
    華文行楷: 11,
    stxingkai: 11,
    華文隸書: 12,
    stliti: 12
  },
  border: {
    borderTop: "上框線",
    borderBottom: "下框線",
    borderLeft: "左框線",
    borderRight: "右框線",
    borderNone: "無",
    borderAll: "所有",
    borderOutside: "外側",
    borderInside: "內側",
    borderHorizontal: "內側橫線",
    borderVertical: "內側分隔號",
    borderColor: "邊框顏色",
    borderSize: "邊框粗細",
    borderSlash: "邊框斜線"
  },
  merge: {
    mergeAll: "全部合併",
    mergeV: "垂直合併",
    mergeH: "水平合併",
    mergeCancel: "取消合併",
    overlappingError: "不能合併重疊區域",
    partiallyError: "無法對部分合併儲存格執行此操作"
  },
  align: {
    left: "左對齊",
    center: "中間對齊",
    right: "右對齊",
    top: "頂部對齊",
    middle: "居中對齊",
    bottom: "底部對齊"
  },
  textWrap: {
    overflow: "溢出",
    wrap: "自動換行",
    clip: "截斷"
  },
  rotation: {
    none: "無旋轉",
    angleup: "向上傾斜",
    angledown: "向下傾斜",
    vertical: "豎排文字",
    rotationUp: "向上90°",
    rotationDown: "向下90°"
  },
  freezen: {
    default: "凍結第一行",
    freezenRow: "凍結第一行",
    freezenColumn: "凍結第A列",
    freezenRC: "凍結行列",
    freezenRowRange: "凍結至當前行",
    freezenColumnRange: "凍結至當前列",
    freezenRCRange: "凍結至當前行列",
    freezenCancel: "取消凍結",
    noSeletionError: "没有選區",
    rangeRCOverErrorTitle: "凍結提醒",
    rangeRCOverError: "凍結窗格超過可見範圍，會導致無法正常操作，請重新設定凍結區域。"
  },
  sort: {
    asc: "昇冪",
    desc: "降序",
    custom: "自定義排序",
    hasTitle: "數據具有標題行",
    sortBy: "排序依據",
    addOthers: "添加其他排序列",
    close: "關閉",
    confirm: "排序",
    columnOperation: "列",
    secondaryTitle: "次要排序",
    sortTitle: "排序範圍",
    sortRangeTitle: "排序範圍從",
    sortRangeTitleTo: "到",
    noRangeError: "不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",
    mergeError: "選區有合併儲存格,無法執行此操作！"
  },
  filter: {
    filter: "篩選",
    clearFilter: "清除篩選",
    sortByAsc: "升序排列",
    sortByDesc: "降序排列",
    filterByColor: "按顏色篩選",
    filterByCondition: "按條件過濾",
    filterByValues: "按值過濾",
    filiterInputNone: "無",
    filiterInputTip: "輸入篩選值",
    filiterRangeStartTip: "範圍開始",
    filiterRangeEndTip: "範圍结束",
    filterValueByAllBtn: "全選",
    filterValueByClearBtn: "清除",
    filterValueByInverseBtn: "反選",
    filterValueByTip: "按照值進行篩選",
    filterConform: "確 認",
    filterCancel: "取 消",
    conditionNone: "無",
    conditionCellIsNull: "儲存格為空",
    conditionCellNotNull: "儲存格有數據",
    conditionCellTextContain: "文字包含",
    conditionCellTextNotContain: "文字不包含",
    conditionCellTextStart: "文字開頭為",
    conditionCellTextEnd: "文字結尾為",
    conditionCellTextEqual: "文字等於",
    conditionCellDateEqual: "日期等於",
    conditionCellDateBefore: "日期早於",
    conditionCellDateAfter: "日期晚於",
    conditionCellGreater: "大於",
    conditionCellGreaterEqual: "大於等於",
    conditionCellLess: "小於",
    conditionCellLessEqual: "小于等於",
    conditionCellEqual: "等於",
    conditionCellNotEqual: "不等於",
    conditionCellBetween: "介於",
    conditionCellNotBetween: "不在其中",
    filiterMoreDataTip: "數據量大！請稍後",
    filiterMonthText: "月",
    filiterYearText: "年",
    filiterByColorTip: "按儲存格顏色篩選",
    filiterByTextColorTip: "按儲存格字體顏色篩選",
    filterContainerOneColorTip: "本列僅包含一種顏色",
    filterDateFormatTip: "日期格式",
    valueBlank: "(空白)",
    mergeError: "篩選選區有合併儲存格,無法執行此操作！"
  },
  rightclick: {
    copy: "複製",
    copyAs: "複製為",
    paste: "粘貼",
    insert: "插入",
    image: "插入圖片",
    link: "插入連結",
    delete: "删除",
    deleteCell: "删除儲存格",
    deleteSelected: "删除選中",
    hide: "隱藏",
    hideSelected: "隱藏選中",
    showHide: "顯示隱藏",
    to: "向",
    left: "左",
    right: "右",
    top: "上",
    bottom: "下",
    moveLeft: "左移",
    moveUp: "上移",
    add: "新增",
    row: "行",
    column: "列",
    width: "寬",
    height: "高",
    number: "數位",
    confirm: "確認",
    orderAZ: "升序排列",
    orderZA: "降序排列",
    clearContent: "清除內容",
    matrix: "矩陣操作選區",
    sortSelection: "排序選區",
    filterSelection: "篩選選區",
    chartGeneration: "圖表生成",
    firstLineTitle: "首行為標題",
    untitled: "無標題",
    array1: "一維數組",
    array2: "二維陣列",
    array3: "多元數組",
    diagonal: "對角線",
    antiDiagonal: "反對角線",
    diagonalOffset: "對角偏移",
    offset: "偏移量",
    boolean: "布林值",
    flip: "翻轉",
    upAndDown: "上下",
    leftAndRight: "左右",
    clockwise: "順時針",
    counterclockwise: "逆時針",
    transpose: "轉置",
    matrixCalculation: "矩陣計算",
    plus: "加",
    minus: "减",
    multiply: "乘",
    divided: "除",
    power: "次方",
    root: "次方根",
    log: "log",
    delete0: "删除兩端0值",
    removeDuplicate: "删除重複值",
    byRow: "按行",
    byCol: "按列",
    generateNewMatrix: "生成新矩陣",
    noMulti: "無法對多重選擇區域執行此操作,請選擇單個區域",
    cannotDeleteAllRow: "無法刪除所有行",
    cannotDeleteAllColumn: "無法刪除所有列",
    cannotDeleteRowReadOnly: "無法刪除只讀行",
    cannotDeleteColumnReadOnly: "無法刪除只讀列",
    cannotInsertOnRowReadOnly: "無法對只讀行插入",
    cannotInsertOnColumnReadOnly: "無法對只讀列插入",
    rowOverLimit: "超出10000行限制",
    columnOverLimit: "超出1000列限制"
  },
  comment: {
    insert: "新建批註",
    edit: "編輯批註",
    delete: "删除",
    showOne: "顯示/隱藏批註",
    showAll: "顯示/隱藏所有批註"
  },
  screenshot: {
    screenshotTipNoSelection: "請框選需要截圖的範圍",
    screenshotTipTitle: "提示！",
    screenshotTipHasMerge: "無法對合併儲存格執行此操作",
    screenshotTipHasMulti: "無法對多重選擇區域執行此操作",
    screenshotTipSuccess: "截取成功",
    screenshotImageName: "截圖",
    downLoadClose: "關閉",
    downLoadCopy: "複製到剪切板",
    downLoadBtn: "下載",
    browserNotTip: "下載功能IE瀏覽器不支持！",
    rightclickTip: "請在圖片上右鍵點擊'複製'",
    successTip: "已成功複製（如果粘貼失敗,請在圖片上右鍵點擊'複製圖片'）"
  },
  splitText: {
    splitDelimiters: "分割符號",
    splitOther: "其它",
    splitContinueSymbol: "連續分隔符號視為單個處理",
    splitDataPreview: "數據預覽",
    splitTextTitle: "文字分列",
    splitConfirmToExe: "此處已有數據,是否替換它？",
    splitSymbols: [{
      name: "Tab鍵",
      value: "Tab"
    }, {
      name: "分號",
      value: "semicolon"
    }, {
      name: "逗號",
      value: "comma"
    }, {
      name: "空格",
      value: "space"
    }],
    tipNoMulti: "能對多重選擇區域執行此操作,請選擇單個區域,然後再試",
    tipNoMultiColumn: "一次只能轉換一列數據,選定區域可以有多行,但不能有多列,請在選定單列區域以後再試",
    tipNoSelect: "沒有選擇儲存格不能進行分列"
  },
  imageText: {
    imageSetting: "圖片設定",
    close: "關閉",
    conventional: "常規",
    moveCell1: "移動並調整儲存格大小",
    moveCell2: "移動並且不調整儲存格的大小",
    moveCell3: "不要移動儲存格並調整其大小",
    fixedPos: "固定位置",
    border: "邊框",
    width: "寬度",
    radius: "半徑",
    style: "樣式",
    solid: "實線",
    dashed: "虛線",
    dotted: "點狀",
    double: "雙線",
    color: "顏色"
  },
  punctuation: {
    tab: "Tab 鍵",
    semicolon: "分號",
    comma: "逗號",
    space: "空格"
  },
  findAndReplace: {
    find: "查找",
    replace: "替換",
    goto: "轉到",
    location: "定位條件",
    formula: "公式",
    date: "日期",
    number: "數位",
    string: "字元",
    error: "錯誤",
    condition: "條件格式",
    rowSpan: "間隔行",
    columnSpan: "間隔列",
    locationExample: "定位",
    lessTwoRowTip: "請選擇最少兩行",
    lessTwoColumnTip: "請選擇最少兩行",
    findTextbox: "查找内容",
    replaceTextbox: "替換內容",
    regexTextbox: "規則運算式匹配",
    wholeTextbox: "整詞匹配",
    distinguishTextbox: "區分大小寫匹配",
    allReplaceBtn: "全部替換",
    replaceBtn: "替換",
    allFindBtn: "查找全部",
    findBtn: "查找下一個",
    noFindTip: "沒有查找到該內容",
    modeTip: "該模式下不可進行此操作",
    searchTargetSheet: "工作表",
    searchTargetCell: "儲存格",
    searchTargetValue: "值",
    searchInputTip: "請輸入查找內容",
    noReplceTip: "沒有可替換的內容",
    noMatchTip: "找不到匹配項",
    successTip: "已經幫您蒐索並進行了${xlength}處替換",
    locationConstant: "常數",
    locationFormula: "公式",
    locationDate: "日期",
    locationDigital: "數位",
    locationString: "字元",
    locationBool: "邏輯值",
    locationError: "錯誤",
    locationNull: "空值",
    locationCondition: "條件格式",
    locationRowSpan: "間隔行",
    locationColumnSpan: "間隔列",
    locationTiplessTwoRow: "請選擇最少兩行",
    locationTiplessTwoColumn: "請選擇最少兩列",
    locationTipNotFindCell: "未找到儲存格"
  },
  sheetconfig: {
    delete: "删除",
    copy: "複製",
    rename: "重命名",
    changeColor: "更改顏色",
    hide: "隱藏",
    unhide: "取消隱藏",
    moveLeft: "向左移",
    moveRight: "向右移",
    resetColor: "重置顏色",
    cancelText: "取消",
    chooseText: "確定顏色",
    focus: "聚焦",
    tipNameRepeat: "籤頁的名稱不能重複！請重新修改",
    noMoreSheet: "工作薄內至少含有一張可視工作表。若需删除選定的工作表,請先插入一張新工作表或顯示一張隱藏的工作表。。",
    confirmDelete: "是否删除",
    redoDelete: "可以通過Ctrl+Z撤銷删除",
    noHide: "不能隱藏,至少保留一個sheet標籤",
    chartEditNoOpt: "圖表編輯模式下不允許該操作！",
    sheetNameSpecCharError: "名稱不能包含:[ ] :  ? * / ' \"",
    sheetNamecannotIsEmptyError: "名稱不能為空"
  },
  conditionformat: {
    conditionformat_greaterThan: "條件格式——大於",
    conditionformat_greaterThan_title: "為大於以下值的儲存格設定格式",
    conditionformat_lessThan: "條件格式——小於",
    conditionformat_lessThan_title: "為小於以下值的儲存格設定格式",
    conditionformat_between: "條件格式——介於",
    conditionformat_between_title: "為介於以下值的儲存格設定格式",
    conditionformat_equal: "條件格式——等於",
    conditionformat_equal_title: "為等於以下值的儲存格設定格式",
    conditionformat_textContains: "條件格式——文字包含",
    conditionformat_textContains_title: "為包含以下文字的儲存格設定格式",
    conditionformat_occurrenceDate: "條件格式——發生日期",
    conditionformat_occurrenceDate_title: "為包含以下日期的儲存格設定格式",
    conditionformat_duplicateValue: "條件格式——重複值",
    conditionformat_duplicateValue_title: "為包含以下類型值的儲存格設定格式",
    conditionformat_top10: "條件格式——前10項",
    conditionformat_top10_percent: "條件格式——前10%",
    conditionformat_top10_title: "為值最大的那些儲存格設定格式",
    conditionformat_last10: "條件格式——最後10項",
    conditionformat_last10_percent: "條件格式——最後10%",
    conditionformat_last10_title: "為值最小的那些儲存格設定格式",
    conditionformat_aboveAverage: "條件格式——高於平均值",
    conditionformat_aboveAverage_title: "為高於平均值的儲存格設定格式",
    conditionformat_belowAverage: "條件格式——低於平均值",
    conditionformat_belowAverage_title: "為低於平均值的儲存格設定格式",
    rule: "規則",
    newRule: "新建規則",
    editRule: "編輯規則",
    deleteRule: "删除規則",
    deleteCellRule: "清除所選儲存格的規則",
    deleteSheetRule: "清除整個工作表的規則",
    manageRules: "管理規則",
    showRules: "顯示其格式規則",
    highlightCellRules: "突出顯示儲存格規則",
    itemSelectionRules: "項目選取規則",
    conditionformatManageRules: "條件格式規則管理器",
    format: "格式",
    setFormat: "設定格式",
    setAs: "設定為",
    setAsByArea: "針對選定區域,設定為",
    applyRange: "應用範圍",
    selectRange: "點擊選擇應用範圍",
    selectRange_percent: "所選範圍的百分比",
    selectRange_average: "選定範圍的平均值",
    selectRange_value: "選定範圍中的數值",
    pleaseSelectRange: "請選擇應用範圍",
    selectDataRange: "點擊選擇數據範圍",
    selectCell: "選擇儲存格",
    pleaseSelectCell: "請選擇儲存格",
    pleaseSelectADate: "請選擇日期",
    pleaseEnterInteger: "請輸入一個介於1和1000之間的整數",
    onlySingleCell: "只能對單個儲存格進行引用",
    conditionValueCanOnly: "條件值只能是數位或者單個儲存格",
    ruleTypeItem1: "基於各自值設定所有儲存格的格式",
    ruleTypeItem2: "只為包含以下內容的儲存格設定格式",
    ruleTypeItem2_title: "只為滿足以下條件的儲存格",
    ruleTypeItem3: "僅對排名靠前或靠後的數值設定格式",
    ruleTypeItem3_title: "為以下排名內的值",
    ruleTypeItem4: "僅對高於或低於平均值的數值設定格式",
    ruleTypeItem4_title: "為滿足以下條件的值",
    ruleTypeItem5: "僅對唯一值或重複值設定格式",
    ruleTypeItem6: "使用公式確定要設置格式的單元格",
    formula: "公式",
    textColor: "文字顏色",
    cellColor: "儲存格顏色",
    confirm: "確定",
    confirmColor: "確定顏色",
    cancel: "取消",
    close: "關閉",
    clearColorSelect: "清除顏色選擇",
    sheet: "錶",
    currentSheet: "當前工作表",
    dataBar: "數據條",
    dataBarColor: "數據條顏色",
    gradientDataBar_1: "藍-白漸變數據條",
    gradientDataBar_2: "綠-白漸變數據條",
    gradientDataBar_3: "紅-白漸變數據條",
    gradientDataBar_4: "柳丁-白漸變數據條",
    gradientDataBar_5: "淺藍-白漸變數據條",
    gradientDataBar_6: "紫-白漸變數據條",
    solidColorDataBar_1: "藍色數據條",
    solidColorDataBar_2: "綠色數據條",
    solidColorDataBar_3: "紅色數據條",
    solidColorDataBar_4: "橙色數據條",
    solidColorDataBar_5: "淺藍色數據條",
    solidColorDataBar_6: "紫色數據條",
    colorGradation: "色階",
    colorGradation_1: "綠-黃-紅色階",
    colorGradation_2: "紅-黃-綠色階",
    colorGradation_3: "綠-白-紅色階",
    colorGradation_4: "紅-白-綠色階",
    colorGradation_5: "藍-白-紅色階",
    colorGradation_6: "紅-白-藍色階",
    colorGradation_7: "白-紅色階",
    colorGradation_8: "紅-白色階",
    colorGradation_9: "綠-白色階",
    colorGradation_10: "白-綠色階",
    colorGradation_11: "綠-黃色階",
    colorGradation_12: "黃-綠色階",
    icons: "圖標集",
    pleaseSelectIcon: "請點擊選擇一組圖標:",
    cellValue: "儲存格值",
    specificText: "特定文字",
    occurrenceDate: "發生日期",
    greaterThan: "大於",
    lessThan: "小於",
    between: "介於",
    equal: "等於",
    in: "和",
    to: "到",
    between2: "之間",
    contain: "包含",
    textContains: "文字包含",
    duplicateValue: "重複值",
    uniqueValue: "唯一值",
    top: "前",
    top10: "前10項",
    top10_percent: "前10%",
    last: "後",
    last10: "後10項",
    last10_percent: "後10%",
    oneself: "個",
    above: "高於",
    aboveAverage: "高於平均值",
    below: "低於",
    belowAverage: "低於平均值",
    all: "全部",
    yesterday: "昨天",
    today: "今天",
    tomorrow: "明天",
    lastWeek: "上周",
    thisWeek: "本周",
    lastMonth: "上月",
    thisMonth: "本月",
    lastYear: "去年",
    thisYear: "本年",
    last7days: "最近7天",
    last30days: "最近30天",
    next7days: "未來7天",
    next30days: "未來30天",
    next60days: "未來60天",
    chooseRuleType: "選擇規則類型",
    editRuleDescription: "編輯規則說明",
    newFormatRule: "新建格式規則",
    editFormatRule: "編輯格式規則",
    formatStyle: "格式樣式",
    fillType: "填充類型",
    color: "顏色",
    twocolor: "雙色",
    tricolor: "三色",
    multicolor: "彩色",
    grayColor: "灰色",
    gradient: "漸變",
    solid: "實心",
    maxValue: "最大值",
    medianValue: "中間值",
    minValue: "最小值",
    direction: "方向",
    threeWayArrow: "三向箭頭",
    fourWayArrow: "四向箭頭",
    fiveWayArrow: "五向箭頭",
    threeTriangles: "3個三角形",
    shape: "形狀",
    threeColorTrafficLight: "三色交通燈",
    fourColorTrafficLight: "四色交通燈",
    threeSigns: "三標誌",
    greenRedBlackGradient: "綠-紅-黑漸變",
    rimless: "無邊框",
    bordered: "有邊框",
    mark: "標記",
    threeSymbols: "三個符號",
    tricolorFlag: "三色旗",
    circled: "有圓圈",
    noCircle: "無圓圈",
    grade: "等級",
    grade4: "四等級",
    grade5: "五等級",
    threeStars: "3個星形",
    fiveQuadrantDiagram: "五象限圖",
    fiveBoxes: "5個框"
  },
  insertLink: {
    linkText: "文字",
    linkType: "連結類型",
    external: "外部連結",
    internal: "内部連結",
    linkAddress: "連結地址",
    linkSheet: "工作表",
    linkCell: "儲存格引用",
    linkTooltip: "提示",
    placeholder1: "請輸入網頁連結位址",
    placeholder2: "請輸入要引用的儲存格,例A1",
    placeholder3: "請輸入提示內容",
    tooltipInfo1: "請輸入有效的連結",
    tooltipInfo2: "請輸入正確的儲存格引用"
  },
  dataVerification: {
    cellRange: "儲存格範圍",
    selectCellRange: "點擊選擇儲存格範圍",
    selectCellRange2: "請選擇儲存格範圍",
    verificationCondition: "驗證條件",
    allowMultiSelect: "是否允許多選",
    dropdown: "下拉清單",
    checkbox: "核取方塊",
    number: "數位",
    number_integer: "數位-整數",
    number_decimal: "數位-小數",
    text_content: "文字-內容",
    text_length: "文字-長度",
    date: "日期",
    validity: "有效性",
    placeholder1: "請輸入選項,以英文逗號分隔,如1,2,3,4,5",
    placeholder2: "請輸入內容",
    placeholder3: "數值,如10",
    placeholder4: "請輸入指定的文字",
    placeholder5: "請輸入選中儲存格時顯示的提示語",
    selected: "選擇時",
    notSelected: "未選擇",
    between: "介於",
    notBetween: "不介於",
    equal: "等於",
    notEqualTo: "不等於",
    moreThanThe: "大於",
    lessThan: "小於",
    greaterOrEqualTo: "大於等於",
    lessThanOrEqualTo: "小於等於",
    include: "包括",
    exclude: "不包括",
    earlierThan: "早於",
    noEarlierThan: "不早於",
    laterThan: "晚於",
    noLaterThan: "不晚於",
    identificationNumber: "身份證號碼",
    phoneNumber: "手機號",
    remote: "自動遠程獲取選項",
    prohibitInput: "輸入數據無效時禁止輸入",
    hintShow: "選中儲存格時顯示提示語",
    deleteVerification: "删除驗證",
    tooltipInfo1: "下拉清單選項不可為空",
    tooltipInfo2: "核取方塊內容不可為空",
    tooltipInfo3: "輸入的值不是數值類型",
    tooltipInfo4: "數值2不能小於數值1",
    tooltipInfo5: "文字內容不能為空",
    tooltipInfo6: "輸入的值不是日期類型",
    tooltipInfo7: "日期2不能小於日期1",
    textlengthInteger: "文字長度必須是大於等於0的整數"
  },
  formula: {
    sum: "求和",
    average: "平均值",
    count: "計數",
    max: "最大值",
    min: "最小值",
    ifGenerate: "if公式生成器",
    find: "更多函數",
    tipNotBelongToIf: "該儲存格函數不屬於if公式!",
    tipSelectCell: "請選擇儲存格插入函數",
    ifGenCompareValueTitle: "比较值",
    ifGenSelectCellTitle: "點擊選擇儲存格",
    ifGenRangeTitle: "範圍",
    ifGenRangeTo: "至",
    ifGenRangeEvaluate: "範圍評估",
    ifGenSelectRangeTitle: "點擊選擇範圍",
    ifGenCutWay: "劃分管道",
    ifGenCutSame: "劃分值相同",
    ifGenCutNpiece: "劃分为N份",
    ifGenCutCustom: "自定義輸入",
    ifGenCutConfirm: "生成",
    ifGenTipSelectCell: "選擇儲存格",
    ifGenTipSelectCellPlace: "請選擇儲存格",
    ifGenTipSelectRange: "選擇單範圍",
    ifGenTipSelectRangePlace: "請選擇範圍",
    ifGenTipNotNullValue: "比較值不能為空!",
    ifGenTipLableTitile: "標籤",
    ifGenTipRangeNotforNull: "範圍不能為空!",
    ifGenTipCutValueNotforNull: "劃分值不能為空！",
    ifGenTipNotGenCondition: "沒有生成可用的條件！"
  },
  formulaMore: {
    valueTitle: "值",
    tipSelectDataRange: "選取數據範圍",
    tipDataRangeTile: "數據範圍",
    findFunctionTitle: "查找函數",
    tipInputFunctionName: "請輸入您要查找的函數名稱或函數功能的簡要描述",
    Array: "數組",
    Database: "資料來源",
    Date: "日期",
    Engineering: "工程計算",
    Filter: "篩檢程式",
    Financial: "財務",
    luckysheet: "Luckysheet內寘",
    other: "其它",
    Logical: "邏輯",
    Lookup: "查找",
    Math: "數學",
    Operator: "運算子",
    Parser: "轉換工具",
    Statistical: "統計",
    Text: "文字",
    dataMining: "資料挖掘",
    selectFunctionTitle: "選擇函數",
    calculationResult: "計算結果",
    tipSuccessText: "成功",
    tipParamErrorText: "參數類型錯誤",
    helpClose: "關閉",
    helpCollapse: "收起",
    helpExample: "示例",
    helpAbstract: "摘要",
    execfunctionError: '提示", "公式存在錯誤',
    execfunctionSelfError: "公式不可引用其本身的儲存格",
    execfunctionSelfErrorResult: "公式不可引用其本身的儲存格,會導致計算結果不準確",
    allowRepeatText: "可重複",
    allowOptionText: "可選",
    selectCategory: "或選擇類別"
  },
  drag: {
    noMerge: "無法對合併儲存格執行此操作",
    affectPivot: "無法對所選儲存格進行此更改,因為它會影響數據透視錶！",
    noMulti: "無法對多重選擇區域執行此操作,請選擇單個區域",
    noPaste: "無法在此處粘貼此內容,請選擇粘貼區域的一個儲存格,然後再次嘗試粘貼",
    noPartMerge: "無法對部分合併儲存格執行此操作",
    inputCorrect: "請輸入正確的數值",
    notLessOne: "行列數不能小於1",
    offsetColumnLessZero: "偏移列不能為負數！",
    pasteMustKeybordAlert: "Copy and paste in the Sheet: Ctrl + C to copy, Ctrl + V to paste, Ctrl + X to cut",
    pasteMustKeybordAlertHTMLTitle: "Copy and paste in the Sheet",
    pasteMustKeybordAlertHTML: "<span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + C</span>&nbsp;&nbsp;to copy<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + V</span>&nbsp;&nbsp;to paste<br/><span style='line-height: 1.0;font-size:36px;font-weight: bold;color:#666;'>Ctrl + X</span>&nbsp;&nbsp;to cut"
  },
  pivotTable: {
    title: "數據透視錶",
    closePannel: "關閉",
    editRange: "編輯範圍",
    tipPivotFieldSelected: "選擇需要添加到數據透視錶的欄位",
    tipClearSelectedField: "清除所有已選欄位",
    btnClearSelectedField: "清除",
    btnFilter: "篩選",
    titleRow: "行",
    titleColumn: "列",
    titleValue: "數值",
    tipShowColumn: "統計欄位顯示為列",
    tipShowRow: "統計欄位顯示為行",
    titleSelectionDataRange: "選取數據範圍",
    titleDataRange: "數據範圍",
    valueSum: "總計",
    valueStatisticsSUM: "求和",
    valueStatisticsCOUNT: "數值計數",
    valueStatisticsCOUNTA: "計數",
    valueStatisticsCOUNTUNIQUE: "去重計數",
    valueStatisticsAVERAGE: "平均值",
    valueStatisticsMAX: "最大值",
    valueStatisticsMIN: "最小值",
    valueStatisticsMEDIAN: "中位數",
    valueStatisticsPRODUCT: "乘積",
    valueStatisticsSTDEV: "標準差",
    valueStatisticsSTDEVP: "整體標準差",
    valueStatisticslet: "方差",
    valueStatisticsVARP: "整體方差",
    errorNotAllowEdit: "非編輯模式下禁止該操作!",
    errorNotAllowMulti: "不能對多重選擇區域執行此操作,請選擇單個區域,然後再試",
    errorSelectRange: "請選擇新建透視錶的區域",
    errorIsDamage: "此數據透視錶的源數據已損壞！",
    errorNotAllowPivotData: "不可選擇數據透視錶為源數據!",
    errorSelectionRange: "選擇失敗,輸入範圍錯誤！",
    errorIncreaseRange: "請擴大選擇的數據範圍!",
    titleAddColumn: "添加列到數據透視錶",
    titleMoveColumn: "移動該列到下方白框",
    titleClearColumnFilter: "清除該列的篩選條件",
    titleFilterColumn: "篩選該列",
    titleSort: "排序",
    titleNoSort: "無排序",
    titleSortAsc: "昇冪",
    titleSortDesc: "降序",
    titleSortBy: "排序依據",
    titleShowSum: "顯示總計",
    titleStasticTrue: "是",
    titleStasticFalse: "否"
  },
  dropCell: {
    copyCell: "複製儲存格",
    sequence: "填充序列",
    onlyFormat: "僅填充格式",
    noFormat: "不帶格式填充",
    day: "以天數填充",
    workDay: "以工作日填充",
    month: "以月填充",
    year: "以年填充",
    chineseNumber: "以中文小寫數位填充"
  },
  imageCtrl: {
    borderTile: "圖片邊框顏色選擇",
    borderCur: "當前顏色"
  },
  protection: {
    protectiontTitle: "保護工作表",
    enterPassword: "請輸入密碼（可留空）",
    enterHint: "您試圖更改的儲存格或圖表位於受保護的工作表中。若要更改,請取消工作表保護。您可能需要輸入密碼",
    swichProtectionTip: "保護工作表及鎖定的儲存格內容",
    authorityTitle: "允許此工作表的用戶進行:",
    selectLockedCells: "定鎖定儲存格",
    selectunLockedCells: "選定解除鎖定的儲存格",
    formatCells: "設定儲存格格式",
    formatColumns: "設定列格式",
    formatRows: "設定行格式",
    insertColumns: "插入列",
    insertRows: "插入行",
    insertHyperlinks: "插入超連結",
    deleteColumns: "删除列",
    deleteRows: "删除行",
    sort: "排序",
    filter: "使用自動篩選",
    usePivotTablereports: "使用數據透視錶和報表",
    editObjects: "編輯對象",
    editScenarios: "編輯方案",
    allowRangeTitle: "允許用戶編輯區域",
    allowRangeAdd: "新建...",
    allowRangeAddTitle: "標題",
    allowRangeAddSqrf: "引用儲存格",
    selectCellRange: "點擊選擇儲存格範圍",
    selectCellRangeHolder: "請輸入儲存格範圍",
    allowRangeAddTitlePassword: "密碼",
    allowRangeAddTitleHint: "提示",
    allowRangeAddTitleHintTitle: "設置密碼後,提示用戶輸入密碼（可留空）",
    allowRangeAddtitleDefault: "請輸入區域名稱",
    rangeItemDblclick: "按兩下進行編輯",
    rangeItemHasPassword: "已設置密碼",
    rangeItemErrorTitleNull: "標題不能為空",
    rangeItemErrorRangeNull: "儲存格範圍不能為空",
    rangeItemErrorRange: "儲存格範圍格式錯誤",
    validationTitle: "驗證提示",
    validationTips: "需要輸入密碼來撤銷工作表的保護",
    validationInputHint: "請輸入密碼",
    checkPasswordNullalert: "密碼不能為空!",
    checkPasswordWrongalert: "密碼錯誤,請重試！",
    checkPasswordSucceedalert: "解鎖成功,可以編輯該區域!",
    defaultRangeHintText: "該儲存格正在受密碼保護",
    defaultSheetHintText: "該儲存格或圖表位於受保護的工作表中,若要進行更改,請取消工作表保護,您可能需要輸入密碼。"
  },
  cellFormat: {
    cellFormatTitle: "設定儲存格格式",
    protection: "保護",
    locked: "鎖定儲存格",
    hidden: "隱藏公式",
    protectionTips: "只有保護工作表功能（在功能表列點擊保護工作表按鈕進行設定）開啟後,鎖定儲存格或隱藏公式才能生效",
    tipsPart: "部分選中",
    tipsAll: "全部選中",
    selectionIsNullAlert: "請選擇一個範圍！",
    sheetDataIsNullAlert: "數據為空無法設定！"
  },
  print: {
    normalBtn: "常規視圖",
    layoutBtn: "頁面佈局",
    pageBtn: "分頁預覽",
    menuItemPrint: "列印(Ctrl+P)",
    menuItemAreas: "列印區域",
    menuItemRows: "列印標題行",
    menuItemColumns: "列印標題列"
  },
  edit: {
    typing: "正在輸入"
  },
  websocket: {
    success: "WebSocket連接成功",
    refresh: "WebSocket連接發生錯誤,請刷新頁面！",
    wait: "WebSocket連接發生錯誤,請耐心等待！",
    close: "WebSocket連接關閉",
    contact: "服務器通信發生錯誤,請刷新頁面後再試,如若不行請聯系管理員！",
    support: "當前瀏覽器不支持WebSocket"
  }
};

var localeObj = {
  en: en,
  zh: zh,
  es: es,
  "zh-TW": zh_tw,
  hi: hi
};

function locale(ctx) {
  var _ctx$lang;

  var langsToTry = [ctx.lang || "", ((_ctx$lang = ctx.lang) === null || _ctx$lang === void 0 ? void 0 : _ctx$lang.split("-")[0]) || ""];

  for (var i = 0; i < langsToTry.length; i += 1) {
    if (langsToTry[i] in localeObj) {
      return localeObj[langsToTry[i]];
    }
  }

  return localeObj.en;
}

function moveToEnd(obj) {
  if (document.createRange) {
    if (obj.innerHTML !== obj.innerText || obj.innerHTML === "") {
      obj.focus();
      var range = window.getSelection();
      range === null || range === void 0 ? void 0 : range.selectAllChildren(obj);
      range === null || range === void 0 ? void 0 : range.collapseToEnd();
    } else {
      var len = obj.innerText.length;

      var _range = document.createRange();

      _range.selectNodeContents(obj);

      _range.setStart(obj.childNodes[0], len);

      _range.collapse(true);

      var selection = window.getSelection();
      selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
      selection === null || selection === void 0 ? void 0 : selection.addRange(_range);
    }
  } else if (document.selection) {
    var _range2 = document.body.createTextRange();

    _range2.moveToElementText(obj);

    _range2.collapse(false);

    _range2.select();
  }
}

function isInPage(node) {
  return node === document.body ? false : document.body.contains(node);
}

function selectTextContent(ele) {
  if (window.getSelection) {
    var range = document.createRange();
    var content = ele.firstChild;

    if (content) {
      range.setStart(content, 0);
      range.setEnd(content, content.length);

      if (range.startContainer && isInPage(range.startContainer)) {
        var _window$getSelection, _window$getSelection2;

        (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.removeAllRanges();
        (_window$getSelection2 = window.getSelection()) === null || _window$getSelection2 === void 0 ? void 0 : _window$getSelection2.addRange(range);
      }
    }
  } else if (document.selection) {
    var _range3 = document.body.createTextRange();

    _range3.moveToElementText(ele);

    _range3.select();
  }
}
function selectTextContentCross(sEle, eEle) {
  if (window.getSelection) {
    var range = document.createRange();
    var sContent = sEle.firstChild;
    var eContent = eEle.firstChild;

    if (sContent && eContent) {
      range.setStart(sContent, 0);
      range.setEnd(eContent, eContent.length);

      if (range.startContainer && isInPage(range.startContainer)) {
        var _window$getSelection3, _window$getSelection4;

        (_window$getSelection3 = window.getSelection()) === null || _window$getSelection3 === void 0 ? void 0 : _window$getSelection3.removeAllRanges();
        (_window$getSelection4 = window.getSelection()) === null || _window$getSelection4 === void 0 ? void 0 : _window$getSelection4.addRange(range);
      }
    }
  }
}

var attrToCssName = {
  bl: "font-weight",
  it: "font-style",
  ff: "font-family",
  fs: "font-size",
  fc: "color",
  cl: "text-decoration",
  un: "border-bottom"
};
var inlineStyleAffectAttribute = {
  bl: 1,
  it: 1,
  ff: 1,
  cl: 1,
  un: 1,
  fs: 1,
  fc: 1
};
var inlineStyleAffectCssName = {
  "font-weight": 1,
  "font-style": 1,
  "font-family": 1,
  "text-decoration": 1,
  "border-bottom": 1,
  "font-size": 1,
  color: 1
};
function isInlineStringCell(cell) {
  var _cell$ct, _cell$ct$s$length, _cell$ct2, _cell$ct2$s;

  return (cell === null || cell === void 0 ? void 0 : (_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : _cell$ct.t) === "inlineStr" && ((_cell$ct$s$length = cell === null || cell === void 0 ? void 0 : (_cell$ct2 = cell.ct) === null || _cell$ct2 === void 0 ? void 0 : (_cell$ct2$s = _cell$ct2.s) === null || _cell$ct2$s === void 0 ? void 0 : _cell$ct2$s.length) !== null && _cell$ct$s$length !== void 0 ? _cell$ct$s$length : 0) > 0;
}
function isInlineStringCT(ct) {
  var _ct$s$length, _ct$s;

  return (ct === null || ct === void 0 ? void 0 : ct.t) === "inlineStr" && ((_ct$s$length = ct === null || ct === void 0 ? void 0 : (_ct$s = ct.s) === null || _ct$s === void 0 ? void 0 : _ct$s.length) !== null && _ct$s$length !== void 0 ? _ct$s$length : 0) > 0;
}
function getInlineStringNoStyle(r, c, data) {
  var ct = getCellValue(r, c, data, "ct");

  if (isInlineStringCT(ct)) {
    var strings = ct.s;
    var value = "";

    for (var i = 0; i < strings.length; i += 1) {
      var strObj = strings[i];

      if (strObj.v) {
        value += strObj.v;
      }
    }

    return value;
  }

  return "";
}
function convertCssToStyleList(cssText, originCell) {
  if (_.isEmpty(cssText)) {
    return {};
  }

  var cssTextArray = cssText.split(";");
  var styleList = {
    fc: originCell.fc || "#000000",
    fs: originCell.fs || 10,
    cl: originCell.cl || 0,
    un: originCell.un || 0,
    bl: originCell.bl || 0,
    it: originCell.it || 0,
    ff: originCell.ff || 0
  };
  cssTextArray.forEach(function (s) {
    s = s.toLowerCase();

    var key = _.trim(s.substring(0, s.indexOf(":")));

    var value = _.trim(s.substring(s.indexOf(":") + 1));

    if (key === "font-weight") {
      if (value === "bold") {
        styleList.bl = 1;
      }
    }

    if (key === "font-style") {
      if (value === "italic") {
        styleList.it = 1;
      }
    }

    if (key === "font-size") {
      styleList.fs = parseInt(value, 10);
    }

    if (key === "color") {
      styleList.fc = value;
    }

    if (key === "text-decoration") {
      styleList.cl = 1;
    }

    if (key === "border-bottom") {
      styleList.un = 1;
    }

    if (key === "lucky-strike") {
      styleList.cl = Number(value);
    }

    if (key === "lucky-underline") {
      styleList.un = Number(value);
    }
  });
  return styleList;
}
function convertSpanToShareString($dom, originCell) {
  var styles = [];
  var preStyleList;
  var preStyleListString = null;

  for (var i = 0; i < $dom.length; i += 1) {
    var span = $dom[i];
    var styleList = convertCssToStyleList(span.style.cssText, originCell);
    var curStyleListString = JSON.stringify(styleList);
    var v = span.innerText;
    v = v.replace(/\n/g, "\r\n");

    if (i === $dom.length - 1) {
      if (v.endsWith("\r\n") && !v.endsWith("\r\n\r\n")) {
        v = v.slice(0, v.length - 2);
      }
    }

    if (curStyleListString === preStyleListString) {
      preStyleList.v += v;
    } else {
      styleList.v = v;
      styles.push(styleList);
      preStyleListString = curStyleListString;
      preStyleList = styleList;
    }
  }

  return styles;
}
function updateInlineStringFormatOutside(cell, key, value) {
  if (_.isNil(cell.ct)) {
    return;
  }

  var s = cell.ct.s;

  if (_.isNil(s)) {
    return;
  }

  for (var i = 0; i < s.length; i += 1) {
    var item = s[i];
    item[key] = value;
  }
}

function getClassWithcss(cssText, ukey) {
  var cssTextArray = cssText.split(";");

  if (ukey == null || ukey.length === 0) {
    return cssText;
  }

  if (cssText.indexOf(ukey) > -1) {
    for (var i = 0; i < cssTextArray.length; i += 1) {
      var s = cssTextArray[i];
      s = s.toLowerCase();

      var key = _.trim(s.substring(0, s.indexOf(":")));

      var value = _.trim(s.substring(s.indexOf(":") + 1));

      if (key === ukey) {
        return value;
      }
    }
  }

  return "";
}

function upsetClassWithCss(cssText, ukey, uvalue) {
  var cssTextArray = cssText.split(";");
  var newCss = "";

  if (ukey == null || ukey.length === 0) {
    return cssText;
  }

  if (cssText.indexOf(ukey) > -1) {
    for (var i = 0; i < cssTextArray.length; i += 1) {
      var s = cssTextArray[i];
      s = s.toLowerCase();

      var key = _.trim(s.substring(0, s.indexOf(":")));

      var value = _.trim(s.substring(s.indexOf(":") + 1));

      if (key === ukey) {
        newCss += "".concat(key, ":").concat(uvalue, ";");
      } else if (key.length > 0) {
        newCss += "".concat(key, ":").concat(value, ";");
      }
    }
  } else if (ukey.length > 0) {
    cssText += "".concat(ukey, ":").concat(uvalue, ";");
    newCss = cssText;
  }

  return newCss;
}

function removeClassWidthCss(cssText, ukey) {
  var cssTextArray = cssText.split(";");
  var newCss = "";
  var oUkey = ukey;

  if (ukey == null || ukey.length === 0) {
    return cssText;
  }

  if (ukey in attrToCssName) {
    ukey = attrToCssName[ukey];
  }

  if (cssText.indexOf(ukey) > -1) {
    for (var i = 0; i < cssTextArray.length; i += 1) {
      var s = cssTextArray[i];
      s = s.toLowerCase();

      var key = _.trim(s.substring(0, s.indexOf(":")));

      var value = _.trim(s.substring(s.indexOf(":") + 1));

      if (key === ukey || oUkey === "cl" && key === "lucky-strike" || oUkey === "un" && key === "lucky-underline") {
        continue;
      } else if (key.length > 0) {
        newCss += "".concat(key, ":").concat(value, ";");
      }
    }
  } else {
    newCss = cssText;
  }

  return newCss;
}

function getCssText(cssText, attr, value) {
  var styleObj = {};
  styleObj[attr] = value;

  if (attr === "un") {
    var fontColor = getClassWithcss(cssText, "color");

    if (fontColor === "") {
      fontColor = "#000000";
    }

    var fs = getClassWithcss(cssText, "font-size");

    if (fs === "") {
      fs = "11";
    }

    styleObj._fontSize = Number(fs);
    styleObj._color = fontColor;
  }

  var s = getFontStyleByCell(styleObj, undefined, undefined, false);

  var ukey = _.kebabCase(Object.keys(s)[0]);

  var uvalue = Object.values(s)[0];
  cssText = removeClassWidthCss(cssText, attr);
  cssText = upsetClassWithCss(cssText, ukey, uvalue);
  return cssText;
}

function extendCssText(origin, cover) {
  var isLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var originArray = origin.split(";");
  var coverArray = cover.split(";");
  var newCss = "";
  var addKeyList = {};

  for (var i = 0; i < originArray.length; i += 1) {
    var so = originArray[i];
    var isAdd = true;
    so = so.toLowerCase();

    var okey = _.trim(so.substring(0, so.indexOf(":")));

    if (okey === "font-size") {
      continue;
    }

    var ovalue = _.trim(so.substring(so.indexOf(":") + 1));

    if (isLimit) {
      if (!(okey in inlineStyleAffectCssName)) {
        continue;
      }
    }

    for (var a = 0; a < coverArray.length; a += 1) {
      var sc = coverArray[a];
      sc = sc.toLowerCase();

      var ckey = _.trim(sc.substring(0, sc.indexOf(":")));

      var cvalue = _.trim(sc.substring(sc.indexOf(":") + 1));

      if (okey === ckey) {
        newCss += "".concat(ckey, ":").concat(cvalue, ";");
        isAdd = false;
        continue;
      }
    }

    if (isAdd) {
      newCss += "".concat(okey, ":").concat(ovalue, ";");
    }

    addKeyList[okey] = 1;
  }

  for (var _a = 0; _a < coverArray.length; _a += 1) {
    var _sc = coverArray[_a];
    _sc = _sc.toLowerCase();

    var _ckey = _.trim(_sc.substring(0, _sc.indexOf(":")));

    var _cvalue = _.trim(_sc.substring(_sc.indexOf(":") + 1));

    if (isLimit) {
      if (!(_ckey in inlineStyleAffectCssName)) {
        continue;
      }
    }

    if (!(_ckey in addKeyList)) {
      newCss += "".concat(_ckey, ":").concat(_cvalue, ";");
    }
  }

  return newCss;
}

function updateInlineStringFormat(ctx, cell, attr, value, cellInput) {
  var w = window.getSelection();
  if (!w) return;
  if (w.rangeCount === 0) return;
  var range = w.getRangeAt(0);
  var $textEditor = cellInput;

  if (range.collapsed === true) {
    return;
  }

  var endContainer = range.endContainer;
  var startContainer = range.startContainer;
  var endOffset = range.endOffset;
  var startOffset = range.startOffset;

  if ($textEditor) {
    if (startContainer === endContainer) {
      var span = startContainer.parentNode;
      var spanIndex;
      var inherit = false;
      var content = (span === null || span === void 0 ? void 0 : span.innerHTML) || "";
      var fullContent = $textEditor.innerHTML;

      if (fullContent.substring(0, 5) !== "<span") {
        inherit = true;
      }

      if (span) {
        var _startContainer$paren;

        var left = "";
        var mid = "";
        var right = "";
        var s1 = 0;
        var s2 = startOffset;
        var s3 = endOffset;
        var s4 = content.length;
        left = content.substring(s1, s2);
        mid = content.substring(s2, s3);
        right = content.substring(s3, s4);
        var cont = "";

        if (left !== "") {
          var cssText = span.style.cssText;

          if (inherit) {
            var box = span.closest("#luckysheet-input-box");

            if (box != null) {
              cssText = extendCssText(box.style.cssText, cssText);
            }
          }

          cont += "<span style='".concat(cssText, "'>").concat(left, "</span>");
        }

        if (mid !== "") {
          var _cssText = getCssText(span.style.cssText, attr, value);

          if (inherit) {
            var _box = span.closest("#luckysheet-input-box");

            if (_box != null) {
              _cssText = extendCssText(_box.style.cssText, _cssText);
            }
          }

          cont += "<span style='".concat(_cssText, "'>").concat(mid, "</span>");
        }

        if (right !== "") {
          var _cssText2 = span.style.cssText;

          if (inherit) {
            var _box2 = span.closest("#luckysheet-input-box");

            if (_box2 != null) {
              _cssText2 = extendCssText(_box2.style.cssText, _cssText2);
            }
          }

          cont += "<span style='".concat(_cssText2, "'>").concat(right, "</span>");
        }

        if (((_startContainer$paren = startContainer.parentElement) === null || _startContainer$paren === void 0 ? void 0 : _startContainer$paren.tagName) === "SPAN") {
          spanIndex = _.indexOf($textEditor.querySelectorAll("span"), span);
          span.outerHTML = cont;
        } else {
          spanIndex = 0;
          span.innerHTML = cont;
        }

        var seletedNodeIndex = 0;

        if (s1 === s2) {
          seletedNodeIndex = spanIndex;
        } else {
          seletedNodeIndex = spanIndex + 1;
        }

        selectTextContent($textEditor.querySelectorAll("span")[seletedNodeIndex]);
      }
    } else {
      var _startContainer$paren2, _endContainer$parentE;

      if (((_startContainer$paren2 = startContainer.parentElement) === null || _startContainer$paren2 === void 0 ? void 0 : _startContainer$paren2.tagName) === "SPAN" && ((_endContainer$parentE = endContainer.parentElement) === null || _endContainer$parentE === void 0 ? void 0 : _endContainer$parentE.tagName) === "SPAN") {
        var startSpan = startContainer.parentNode;
        var endSpan = endContainer.parentNode;
        var allSpans = $textEditor.querySelectorAll("span");

        var startSpanIndex = _.indexOf(allSpans, startSpan);

        var endSpanIndex = _.indexOf(allSpans, endSpan);

        var startContent = (startSpan === null || startSpan === void 0 ? void 0 : startSpan.innerHTML) || "";
        var endContent = (endSpan === null || endSpan === void 0 ? void 0 : endSpan.innerHTML) || "";
        var sleft = "";
        var sright = "";
        var eleft = "";
        var eright = "";
        var _s = 0;
        var _s2 = startOffset;
        var _s3 = endOffset;
        var _s4 = endContent.length;
        sleft = startContent.substring(_s, _s2);
        sright = startContent.substring(_s2, startContent.length);
        eleft = endContent.substring(0, _s3);
        eright = endContent.substring(_s3, _s4);
        var spans = $textEditor.querySelectorAll("span");
        var _cont = "";

        for (var i = 0; i < startSpanIndex; i += 1) {
          var _span = spans[i];
          var _content = _span.innerHTML;
          _cont += "<span style='".concat(_span.style.cssText, "'>").concat(_content, "</span>");
        }

        if (sleft !== "") {
          _cont += "<span style='".concat(startSpan.style.cssText, "'>").concat(sleft, "</span>");
        }

        if (sright !== "") {
          var _cssText3 = getCssText(startSpan.style.cssText, attr, value);

          _cont += "<span style='".concat(_cssText3, "'>").concat(sright, "</span>");
        }

        if (startSpanIndex < endSpanIndex) {
          for (var _i = startSpanIndex + 1; _i < endSpanIndex; _i += 1) {
            var _span2 = spans[_i];
            var _content2 = _span2.innerHTML;
            _cont += "<span style='".concat(_span2.style.cssText, "'>").concat(_content2, "</span>");
          }
        }

        if (eleft !== "") {
          var _cssText4 = getCssText(endSpan.style.cssText, attr, value);

          _cont += "<span style='".concat(_cssText4, "'>").concat(eleft, "</span>");
        }

        if (eright !== "") {
          _cont += "<span style='".concat(endSpan.style.cssText, "'>").concat(eright, "</span>");
        }

        for (var _i2 = endSpanIndex + 1; _i2 < spans.length; _i2 += 1) {
          var _span3 = spans[_i2];
          var _content3 = _span3.innerHTML;
          _cont += "<span style='".concat(_span3.style.cssText, "'>").concat(_content3, "</span>");
        }

        $textEditor.innerHTML = _cont;
        var startSeletedNodeIndex;
        var endSeletedNodeIndex;

        if (_s === _s2) {
          startSeletedNodeIndex = startSpanIndex;
          endSeletedNodeIndex = endSpanIndex;
        } else {
          startSeletedNodeIndex = startSpanIndex + 1;
          endSeletedNodeIndex = endSpanIndex + 1;
        }

        spans = $textEditor.querySelectorAll("span");
        selectTextContentCross(spans[startSeletedNodeIndex], spans[endSeletedNodeIndex]);
      }
    }
  }
}

function checkWordByteLength(value) {
  return Math.ceil(value.charCodeAt(0).toString(2).length / 8);
}

function hasChinaword(s) {
  var patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;

  if (!patrn.exec(s)) {
    return false;
  }

  return true;
}
var textHeightCache = {};
var measureTextCache = {};
var measureTextCellInfoCache = {};
function clearMeasureTextCache() {
  measureTextCache = {};
  measureTextCellInfoCache = {};
}

function getTextSize(text, font) {
  if (font in textHeightCache) {
    return textHeightCache[font];
  }

  var ele = document.createElement("span");
  ele.style.float = "left";
  ele.style.whiteSpace = "nowrap";
  ele.style.visibility = "hidden";
  ele.style.margin = "0";
  ele.style.padding = "0";
  ele.innerHTML = text;
  document.body.append(ele);
  var w = Math.max(ele.scrollWidth, ele.offsetWidth, ele.clientWidth);
  var h = Math.max(ele.scrollHeight, ele.offsetHeight, ele.clientHeight);
  textHeightCache[font] = [w, h];
  ele.remove();
  return [w, h];
}

function defaultFont(defaultFontSize) {
  return "normal normal normal ".concat(defaultFontSize, "pt \"Helvetica Neue\", Helvetica, Arial, \"PingFang SC\", \"Hiragino Sans GB\", \"Heiti SC\",  \"WenQuanYi Micro Hei\", sans-serif");
}
function getFontSet(format, defaultFontSize, ctx) {
  if (_.isPlainObject(format)) {
    var fontAttr = [];

    if (format.it === "0" || format.it === 0 || _.isNil(format.it)) {
      fontAttr.push("normal");
    } else {
      fontAttr.push("italic");
    }

    fontAttr.push("normal");

    if (format.bl === "0" || format.bl === 0 || _.isNil(format.bl)) {
      fontAttr.push("normal");
    } else {
      fontAttr.push("bold");
    }

    if (!format.fs) {
      fontAttr.push("".concat(defaultFontSize, "pt"));
    } else {
      fontAttr.push("".concat(Math.ceil(format.fs), "pt"));
    }

    var fontSet = "\"Helvetica Neue\", Helvetica, Arial, \"PingFang SC\", \"Hiragino Sans GB\", \"Heiti SC\", \"Microsoft YaHei\", \"WenQuanYi Micro Hei\", sans-serif";

    if (ctx) {
      var _locale = locale(ctx),
          fontarray = _locale.fontarray;

      if (!format.ff) {
        fontSet = "".concat(fontarray[0], ",").concat(fontSet);
      } else {
        var fontfamily = null;

        if (ctx) {
          if (isdatatypemulti(format.ff).num) {
            fontfamily = fontarray[parseInt(format.ff, 10)];
          } else {
            fontfamily = format.ff;
            fontfamily = fontfamily.replace(/"/g, "").replace(/'/g, "");

            if (fontfamily.indexOf(" ") > -1) {
              fontfamily = "\"".concat(fontfamily, "\"");
            }
          }
        }

        fontSet = "".concat(fontfamily, ",").concat(fontSet);
      }
    }

    return "".concat(fontAttr.join(" "), " ").concat(fontSet);
  }

  return defaultFont(defaultFontSize);
}
function getMeasureText(value, renderCtx, sheetCtx, fontset) {
  var mtc = measureTextCache["".concat(value, "_").concat(renderCtx.font)];

  if (fontset) {
    mtc = measureTextCache["".concat(value, "_").concat(fontset)];
  }

  if (mtc != null) {
    return mtc;
  }

  if (fontset) {
    renderCtx.font = fontset;
  }

  var measureText = renderCtx.measureText(value);
  var cache = {};
  cache.width = measureText.width;

  if (fontset) {
    renderCtx.font = fontset;
  }

  cache.actualBoundingBoxDescent = measureText.actualBoundingBoxDescent;
  cache.actualBoundingBoxAscent = measureText.actualBoundingBoxAscent;

  if (cache.actualBoundingBoxDescent == null || cache.actualBoundingBoxAscent == null || Number.isNaN(cache.actualBoundingBoxDescent) || Number.isNaN(cache.actualBoundingBoxAscent)) {
    var commonWord = "M";

    if (hasChinaword(value)) {
      commonWord = "田";
    }

    var oneLineTextHeight = getTextSize(commonWord, renderCtx.font)[1] * 0.8;

    if (renderCtx.textBaseline === "top") {
      cache.actualBoundingBoxDescent = oneLineTextHeight;
      cache.actualBoundingBoxAscent = 0;
    } else if (renderCtx.textBaseline === "middle") {
      cache.actualBoundingBoxDescent = oneLineTextHeight / 2;
      cache.actualBoundingBoxAscent = oneLineTextHeight / 2;
    } else {
      cache.actualBoundingBoxDescent = 0;
      cache.actualBoundingBoxAscent = oneLineTextHeight;
    }
  }

  if (renderCtx.textBaseline === "alphabetic") {
    var descText = "gjpqy";
    var matchText = "abcdABCD";
    var descTextMeasure = measureTextCache["".concat(descText, "_").concat(renderCtx.font)];

    if (fontset) {
      descTextMeasure = measureTextCache["".concat(descText, "_").concat(fontset)];
    }

    var matchTextMeasure = measureTextCache["".concat(matchText, "_").concat(renderCtx.font)];

    if (fontset) {
      matchTextMeasure = measureTextCache["".concat(matchText, "_").concat(fontset)];
    }

    if (descTextMeasure == null) {
      descTextMeasure = renderCtx.measureText(descText);
    }

    if (matchTextMeasure == null) {
      matchTextMeasure = renderCtx.measureText(matchText);
    }

    if (cache.actualBoundingBoxDescent <= matchTextMeasure.actualBoundingBoxDescent) {
      cache.actualBoundingBoxDescent = descTextMeasure.actualBoundingBoxDescent;

      if (!cache.actualBoundingBoxDescent) {
        cache.actualBoundingBoxDescent = 0;
      }
    }
  }

  cache.width *= sheetCtx.zoomRatio;
  cache.actualBoundingBoxDescent *= sheetCtx.zoomRatio;
  cache.actualBoundingBoxAscent *= sheetCtx.zoomRatio;
  measureTextCache["".concat(value, "_").concat(sheetCtx.zoomRatio, "_").concat(renderCtx.font)] = cache;
  return cache;
}
function isSupportBoundingBox(ctx) {
  var measureText = ctx.measureText("田");

  if (_.isNil(measureText.actualBoundingBoxAscent)) {
    return false;
  }

  return true;
}
function drawLineInfo(wordGroup, cancelLine, underLine, option) {
  var left = option.left;
  var top = option.top;
  var width = option.width;
  var asc = option.asc;
  var desc = option.desc;
  var fs = option.fs;

  if (wordGroup.wrap === true) {
    return;
  }

  if (wordGroup.inline === true && !_.isNil(wordGroup.style)) {
    cancelLine = wordGroup.style.cl;
    underLine = wordGroup.style.un;
  }

  if (Number(cancelLine) !== 0) {
    wordGroup.cancelLine = {};
    wordGroup.cancelLine.startX = left;
    wordGroup.cancelLine.startY = top - asc / 2 + 1;
    wordGroup.cancelLine.endX = left + width;
    wordGroup.cancelLine.endY = top - asc / 2 + 1;
    wordGroup.cancelLine.fs = fs;
  }

  var nUnderline = Number(underLine);

  if (nUnderline !== 0) {
    wordGroup.underLine = [];

    if (nUnderline === 1 || nUnderline === 2) {
      var item = {};
      item.startX = left;
      item.startY = top + 3;
      item.endX = left + width;
      item.endY = top + 3;
      item.fs = fs;
      wordGroup.underLine.push(item);
    }

    if (nUnderline === 2) {
      var _item = {};
      _item.startX = left;
      _item.startY = top + desc;
      _item.endX = left + width;
      _item.endY = top + desc;
      _item.fs = fs;
      wordGroup.underLine.push(_item);
    }

    if (nUnderline === 3 || nUnderline === 4) {
      var _item2 = {};
      _item2.startX = left;
      _item2.startY = top + desc;
      _item2.endX = left + width;
      _item2.endY = top + desc;
      _item2.fs = fs;
      wordGroup.underLine.push(_item2);
    }

    if (nUnderline === 4) {
      var _item3 = {};
      _item3.startX = left;
      _item3.startY = top + desc + 2;
      _item3.endX = left + width;
      _item3.endY = top + desc + 2;
      _item3.fs = fs;
      wordGroup.underLine.push(_item3);
    }
  }
}
function getCellTextInfo(cell, renderCtx, sheetCtx, option, ctx) {
  var cellWidth = option.cellWidth;
  var cellHeight = option.cellHeight;
  var isMode = "";
  var isModeSplit = "";

  if (cellWidth == null) {
    isMode = "onlyWidth";
    isModeSplit = "_";
  }

  var textInfo = measureTextCellInfoCache["".concat(option.r, "_").concat(option.c).concat(isModeSplit).concat(isMode)];

  if (textInfo) {
    return textInfo;
  }

  var space_width = option.space_width;
  var space_height = option.space_height;

  if (space_width === undefined) {
    space_width = 2;
  }

  if (space_height === undefined) {
    space_height = 2;
  }

  var horizonAlign = normalizedCellAttr(cell, "ht");
  var verticalAlign = normalizedCellAttr(cell, "vt");
  var tb = normalizedCellAttr(cell, "tb");
  var tr = normalizedCellAttr(cell, "tr");
  var rt = normalizedCellAttr(cell, "rt");
  var isRotateUp = 1;

  if (_.isNil(rt)) {
    if (tr === "0") {
      rt = 0;
    } else if (tr === "1") {
      rt = 45;
    } else if (tr === "4") {
      rt = 90;
    } else if (tr === "2") {
      rt = 135;
    } else if (tr === "5") {
      rt = 180;
    }

    if (_.isNil(rt)) {
      rt = 0;
    }
  }

  if (rt > 180 || rt < 0) {
    rt = 0;
  }

  rt = parseInt(rt, 10);

  if (rt > 90) {
    rt = 90 - rt;
    isRotateUp = 0;
  }

  renderCtx.textAlign = "start";
  var textContent = {};
  textContent.values = [];
  var fontset;
  var cancelLine = "0";
  var underLine = "0";
  var fontSize = 11;
  var isInline = false;
  var value;
  var inlineStringArr = [];

  if (isInlineStringCell(cell)) {
    var sharedStrings = cell.ct.s;
    var similarIndex = 0;

    for (var i = 0; i < sharedStrings.length; i += 1) {
      var shareCell = sharedStrings[i];
      var scfontset = getFontSet(shareCell, sheetCtx.defaultFontSize, ctx);
      var fc = shareCell.fc;
      var cl = shareCell.cl;
      var un = shareCell.un;
      var v = shareCell.v;
      var fs = shareCell.fs;
      v = v.replace(/\r\n/g, "_x000D_").replace(/&#13;&#10;/g, "_x000D_").replace(/\r/g, "_x000D_").replace(/\n/g, "_x000D_");
      var splitArr = v.split("_x000D_");

      for (var x = 0; x < splitArr.length; x += 1) {
        var newValue = splitArr[x];

        if (newValue === "" && x !== splitArr.length - 1) {
          inlineStringArr.push({
            fontset: scfontset,
            fc: !fc ? "#000" : fc,
            cl: !cl ? 0 : cl,
            un: !un ? 0 : un,
            wrap: true,
            fs: !fs ? 11 : fs
          });
          similarIndex += 1;
        } else {
          inlineStringArr.push({
            fontset: scfontset,
            fc: !fc ? "#000" : fc,
            cl: !cl ? 0 : cl,
            un: !un ? 0 : un,
            v: newValue,
            si: similarIndex,
            fs: !fs ? 11 : fs
          });

          if (x !== splitArr.length - 1) {
            inlineStringArr.push({
              fontset: scfontset,
              fc: !fc ? "#000" : fc,
              cl: !cl ? 0 : cl,
              un: !un ? 0 : un,
              wrap: true,
              fs: !fs ? 11 : fs
            });
            similarIndex += 1;
          }
        }
      }

      similarIndex += 1;
    }

    isInline = true;
  } else {
    fontset = getFontSet(cell, sheetCtx.defaultFontSize, ctx);
    renderCtx.font = fontset;
    cancelLine = normalizedCellAttr(cell, "cl");
    underLine = normalizedCellAttr(cell, "un");
    fontSize = normalizedCellAttr(cell, "fs");

    if (cell instanceof Object) {
      value = cell.m;

      if (_.isNil(value)) {
        value = cell.v;
      }
    } else {
      value = cell;
    }

    if (_.isEmpty(value)) {
      return null;
    }
  }

  if (tr === "3") {
    renderCtx.textBaseline = "top";
    var textW_all = 0;
    var textH_all = 0;
    var colIndex = 0;
    var textH_all_cache = 0;
    var textH_all_Column = {};
    var textH_all_ColumnHeight = [];

    if (isInline) {
      var preShareCell = null;

      for (var _i = 0; _i < inlineStringArr.length; _i += 1) {
        var _shareCell = inlineStringArr[_i];
        var value1 = _shareCell.v;
        var showValue = _shareCell.v;

        if (_shareCell.wrap === true) {
          value1 = "M";
          showValue = "";

          if (!_.isNil(preShareCell) && preShareCell.wrap !== true && _i < inlineStringArr.length - 1) {
            textH_all_ColumnHeight.push(textH_all_cache);
            textH_all_cache = 0;
            colIndex += 1;
            preShareCell = _shareCell;
            continue;
          }
        }

        var measureText = getMeasureText(value1, renderCtx, sheetCtx, _shareCell.fontset);
        var textW = measureText.width + space_width;
        var textH = measureText.actualBoundingBoxAscent + measureText.actualBoundingBoxDescent + space_height;
        textH_all_cache += textH;

        if (tb === "2" && !_shareCell.wrap) {
          if (textH_all_cache > cellHeight && !_.isNil(textH_all_Column[colIndex])) {
            textH_all_ColumnHeight.push(textH_all_cache - textH);
            textH_all_cache = textH;
            colIndex += 1;
          }
        }

        if (_i === inlineStringArr.length - 1) {
          textH_all_ColumnHeight.push(textH_all_cache);
        }

        if (_.isNil(textH_all_Column[colIndex])) {
          textH_all_Column[colIndex] = [];
        }

        var item = {
          content: showValue,
          style: _shareCell,
          width: textW,
          height: textH,
          left: 0,
          top: 0,
          colIndex: colIndex,
          asc: measureText.actualBoundingBoxAscent,
          desc: measureText.actualBoundingBoxDescent,
          inline: true,
          wrap: false
        };

        if (_shareCell.wrap === true) {
          item.wrap = true;
        }

        textH_all_Column[colIndex].push(item);
        preShareCell = _shareCell;
      }
    } else {
      var _measureText = getMeasureText(value, renderCtx, sheetCtx);

      var textHeight = _measureText.actualBoundingBoxDescent + _measureText.actualBoundingBoxAscent;
      value = value.toString();
      var vArr = [];

      if (value.length > 1) {
        vArr = value.split("");
      } else {
        vArr.push(value);
      }

      var oneWordWidth = getMeasureText(vArr[0], renderCtx, sheetCtx).width;

      for (var _i2 = 0; _i2 < vArr.length; _i2 += 1) {
        var _textW = oneWordWidth + space_width;

        var _textH = textHeight + space_height;

        textH_all_cache += _textH;

        if (tb === "2") {
          if (textH_all_cache > cellHeight && !_.isNil(textH_all_Column[colIndex])) {
            textH_all_ColumnHeight.push(textH_all_cache - _textH);
            textH_all_cache = _textH;
            colIndex += 1;
          }
        }

        if (_i2 === vArr.length - 1) {
          textH_all_ColumnHeight.push(textH_all_cache);
        }

        if (_.isNil(textH_all_Column[colIndex])) {
          textH_all_Column[colIndex] = [];
        }

        textH_all_Column[colIndex].push({
          content: vArr[_i2],
          style: fontset,
          width: _textW,
          height: _textH,
          left: 0,
          top: 0,
          colIndex: colIndex,
          asc: _measureText.actualBoundingBoxAscent,
          desc: _measureText.actualBoundingBoxDescent
        });
      }
    }

    var textH_all_ColumWidth = [];

    for (var _i3 = 0; _i3 < textH_all_ColumnHeight.length; _i3 += 1) {
      var columnHeight = textH_all_ColumnHeight[_i3];
      var col = textH_all_Column[_i3];
      var colMaxW = 0;

      for (var c = 0; c < col.length; c += 1) {
        var word = col[c];
        colMaxW = Math.max(colMaxW, word.width);
      }

      textH_all_ColumWidth.push(colMaxW);
      textW_all += colMaxW;
      textH_all = Math.max(textH_all, columnHeight);
    }

    textContent.type = "verticalWrap";
    textContent.textWidthAll = textW_all;
    textContent.textHeightAll = textH_all;

    if (isMode === "onlyWidth") {
      return textContent;
    }

    var cumColumnWidth = 0;

    for (var _i4 = 0; _i4 < textH_all_ColumnHeight.length; _i4 += 1) {
      var _columnHeight = textH_all_ColumnHeight[_i4];
      var columnWidth = textH_all_ColumWidth[_i4];
      var _col = textH_all_Column[_i4];
      var cumWordHeight = 0;

      for (var _c = 0; _c < _col.length; _c += 1) {
        var _word = _col[_c];
        var left = space_width + cumColumnWidth;

        if (horizonAlign === "0") {
          left = cellWidth / 2 + cumColumnWidth - textW_all / 2 + space_width * textH_all_ColumnHeight.length;
        } else if (horizonAlign === "2") {
          left = cellWidth + cumColumnWidth - textW_all + space_width;
        }

        var top = cellHeight - space_height + cumWordHeight - _columnHeight;

        if (verticalAlign === "0") {
          top = cellHeight / 2 + cumWordHeight - _columnHeight / 2;
        } else if (verticalAlign === "1") {
          top = space_height + cumWordHeight;
        }

        cumWordHeight += _word.height;
        _word.left = left;
        _word.top = top;
        drawLineInfo(_word, cancelLine, underLine, {
          width: columnWidth,
          height: _word.height,
          left: left,
          top: top + _word.height - space_height,
          asc: _word.height,
          desc: 0,
          fs: fontSize
        });
        textContent.values.push(_word);
      }

      cumColumnWidth += columnWidth;
    }
  } else {
    var supportBoundBox = isSupportBoundingBox(renderCtx);

    if (supportBoundBox) {
      renderCtx.textBaseline = "alphabetic";
    } else {
      renderCtx.textBaseline = "bottom";
    }

    if (tb === "2" || isInline) {
      var _textW_all = 0;
      var _textH_all = 0;
      var textW_all_inner = 0;
      var splitIndex = 0;
      var text_all_split = {};
      textContent.rotate = rt;
      rt = Math.abs(rt);
      var anchor = 0;
      var preStr;
      var preTextHeight;
      var preTextWidth;
      var preMeasureText;
      var _i5 = 1;
      var spaceOrTwoByte = null;
      var spaceOrTwoByteIndex = null;

      if (isInline) {
        while (_i5 <= inlineStringArr.length) {
          var shareCells = inlineStringArr.slice(anchor, _i5);

          if (shareCells[shareCells.length - 1].wrap === true) {
            anchor = _i5;

            if (shareCells.length > 1) {
              for (var s = 0; s < shareCells.length - 1; s += 1) {
                var sc = shareCells[s];
                var _item4 = {
                  content: sc.v,
                  style: sc,
                  width: sc.measureText.width,
                  height: sc.measureText.actualBoundingBoxAscent + sc.measureText.actualBoundingBoxDescent,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: sc.measureText.actualBoundingBoxAscent,
                  desc: sc.measureText.actualBoundingBoxDescent,
                  inline: true,
                  fs: sc.fs
                };
                text_all_split[splitIndex].push(_item4);
              }
            }

            if (shareCells.length === 1) {
              var _sc = shareCells[0];

              var _measureText2 = getMeasureText("M", renderCtx, sheetCtx, _sc.fontset);

              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              text_all_split[splitIndex].push({
                content: "",
                style: _sc,
                width: _measureText2.width,
                height: _measureText2.actualBoundingBoxAscent + _measureText2.actualBoundingBoxDescent,
                left: 0,
                top: 0,
                splitIndex: splitIndex,
                asc: _measureText2.actualBoundingBoxAscent,
                desc: _measureText2.actualBoundingBoxDescent,
                inline: true,
                wrap: true,
                fs: _sc.fs
              });
            }

            splitIndex += 1;
            _i5 += 1;
            continue;
          }

          var textWidth = 0;
          var _textHeight = 0;

          for (var _s = 0; _s < shareCells.length; _s += 1) {
            var _sc2 = shareCells[_s];

            if (_.isNil(_sc2.measureText)) {
              _sc2.measureText = getMeasureText(_sc2.v, renderCtx, sheetCtx, _sc2.fontset);
            }

            textWidth += _sc2.measureText.width;
            _textHeight = Math.max(_sc2.measureText.actualBoundingBoxAscent + _sc2.measureText.actualBoundingBoxDescent);
          }

          var width = textWidth * Math.cos(rt * Math.PI / 180) + _textHeight * Math.sin(rt * Math.PI / 180);

          var height = textWidth * Math.sin(rt * Math.PI / 180) + _textHeight * Math.cos(rt * Math.PI / 180);

          var lastWord = shareCells[shareCells.length - 1];

          if (lastWord.v === " " || checkWordByteLength(lastWord.v) === 2) {
            spaceOrTwoByteIndex = _i5;
          }

          if (rt !== 0) {
            if (height + space_height > cellHeight && !_.isNil(text_all_split[splitIndex]) && tb === "2") {
              if (!_.isNil(spaceOrTwoByteIndex) && spaceOrTwoByteIndex < _i5) {
                for (var _s2 = 0; _s2 < spaceOrTwoByteIndex - anchor; _s2 += 1) {
                  var _sc3 = shareCells[_s2];
                  text_all_split[splitIndex].push({
                    content: _sc3.v,
                    style: _sc3,
                    width: _sc3.measureText.width,
                    height: _sc3.measureText.actualBoundingBoxAscent + _sc3.measureText.actualBoundingBoxDescent,
                    left: 0,
                    top: 0,
                    splitIndex: splitIndex,
                    asc: _sc3.measureText.actualBoundingBoxAscent,
                    desc: _sc3.measureText.actualBoundingBoxDescent,
                    inline: true,
                    fs: _sc3.fs
                  });
                }

                anchor = spaceOrTwoByteIndex;
                _i5 = spaceOrTwoByteIndex + 1;
                splitIndex += 1;
                spaceOrTwoByteIndex = null;
              } else {
                anchor = _i5 - 1;

                for (var _s3 = 0; _s3 < shareCells.length - 1; _s3 += 1) {
                  var _sc4 = shareCells[_s3];
                  text_all_split[splitIndex].push({
                    content: _sc4.v,
                    style: _sc4,
                    width: _sc4.measureText.width,
                    height: _sc4.measureText.actualBoundingBoxAscent + _sc4.measureText.actualBoundingBoxDescent,
                    left: 0,
                    top: 0,
                    splitIndex: splitIndex,
                    asc: _sc4.measureText.actualBoundingBoxAscent,
                    desc: _sc4.measureText.actualBoundingBoxDescent,
                    inline: true,
                    fs: _sc4.fs
                  });
                }

                splitIndex += 1;
              }
            } else if (_i5 === inlineStringArr.length) {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              for (var _s4 = 0; _s4 < shareCells.length; _s4 += 1) {
                var _sc5 = shareCells[_s4];
                text_all_split[splitIndex].push({
                  content: _sc5.v,
                  style: _sc5,
                  width: _sc5.measureText.width,
                  height: _sc5.measureText.actualBoundingBoxAscent + _sc5.measureText.actualBoundingBoxDescent,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: _sc5.measureText.actualBoundingBoxAscent,
                  desc: _sc5.measureText.actualBoundingBoxDescent,
                  inline: true,
                  fs: _sc5.fs
                });
              }

              break;
            } else {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              _i5 += 1;
            }
          } else {
            if (width + space_width > cellWidth && !_.isNil(text_all_split[splitIndex]) && tb === "2") {
              if (!_.isNil(spaceOrTwoByteIndex) && spaceOrTwoByteIndex < _i5) {
                for (var _s5 = 0; _s5 < spaceOrTwoByteIndex - anchor; _s5 += 1) {
                  var _sc6 = shareCells[_s5];
                  text_all_split[splitIndex].push({
                    content: _sc6.v,
                    style: _sc6,
                    width: _sc6.measureText.width,
                    height: _sc6.measureText.actualBoundingBoxAscent + _sc6.measureText.actualBoundingBoxDescent,
                    left: 0,
                    top: 0,
                    splitIndex: splitIndex,
                    asc: _sc6.measureText.actualBoundingBoxAscent,
                    desc: _sc6.measureText.actualBoundingBoxDescent,
                    inline: true,
                    fs: _sc6.fs
                  });
                }

                anchor = spaceOrTwoByteIndex;
                _i5 = spaceOrTwoByteIndex + 1;
                splitIndex += 1;
                spaceOrTwoByteIndex = null;
              } else {
                anchor = _i5 - 1;

                for (var _s6 = 0; _s6 < shareCells.length - 1; _s6 += 1) {
                  var _sc7 = shareCells[_s6];
                  text_all_split[splitIndex].push({
                    content: _sc7.v,
                    style: _sc7,
                    width: _sc7.measureText.width,
                    height: _sc7.measureText.actualBoundingBoxAscent + _sc7.measureText.actualBoundingBoxDescent,
                    left: 0,
                    top: 0,
                    splitIndex: splitIndex,
                    asc: _sc7.measureText.actualBoundingBoxAscent,
                    desc: _sc7.measureText.actualBoundingBoxDescent,
                    inline: true,
                    fs: _sc7.fs
                  });
                }

                splitIndex += 1;
              }
            } else if (_i5 === inlineStringArr.length) {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              for (var _s7 = 0; _s7 < shareCells.length; _s7 += 1) {
                var _sc8 = shareCells[_s7];
                text_all_split[splitIndex].push({
                  content: _sc8.v,
                  style: _sc8,
                  width: _sc8.measureText.width,
                  height: _sc8.measureText.actualBoundingBoxAscent + _sc8.measureText.actualBoundingBoxDescent,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: _sc8.measureText.actualBoundingBoxAscent,
                  desc: _sc8.measureText.actualBoundingBoxDescent,
                  inline: true,
                  fs: _sc8.fs
                });
              }

              break;
            } else {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              _i5 += 1;
            }
          }
        }
      } else {
        value = value.toString();

        while (_i5 <= value.length) {
          var str = value.substring(anchor, _i5);

          var _measureText3 = getMeasureText(str, renderCtx, sheetCtx);

          var _textWidth = _measureText3.width;

          var _textHeight2 = _measureText3.actualBoundingBoxAscent + _measureText3.actualBoundingBoxDescent;

          var _width = _textWidth * Math.cos(rt * Math.PI / 180) + _textHeight2 * Math.sin(rt * Math.PI / 180);

          var _height = _textWidth * Math.sin(rt * Math.PI / 180) + _textHeight2 * Math.cos(rt * Math.PI / 180);

          var _lastWord = str.substr(str.length - 1, 1);

          if (_lastWord === " " || checkWordByteLength(_lastWord) === 2) {
            spaceOrTwoByte = {
              index: _i5,
              str: str,
              width: _width,
              height: _height,
              asc: _measureText3.actualBoundingBoxAscent,
              desc: _measureText3.actualBoundingBoxDescent
            };
          }

          if (rt !== 0) {
            if (_height + space_height > cellHeight && !_.isNil(text_all_split[splitIndex])) {
              if (!_.isNil(spaceOrTwoByte) && spaceOrTwoByte.index < _i5) {
                anchor = spaceOrTwoByte.index;
                _i5 = spaceOrTwoByte.index + 1;
                text_all_split[splitIndex].push({
                  content: spaceOrTwoByte.str,
                  style: fontset,
                  width: spaceOrTwoByte.width,
                  height: spaceOrTwoByte.height,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: spaceOrTwoByte.asc,
                  desc: spaceOrTwoByte.desc,
                  fs: fontSize
                });
                splitIndex += 1;
                spaceOrTwoByte = null;
              } else {
                anchor = _i5 - 1;
                text_all_split[splitIndex].push({
                  content: preStr,
                  style: fontset,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  height: preTextHeight,
                  width: preTextWidth,
                  asc: _measureText3.actualBoundingBoxAscent,
                  desc: _measureText3.actualBoundingBoxDescent,
                  fs: fontSize
                });
                splitIndex += 1;
              }
            } else if (_i5 === value.length) {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              text_all_split[splitIndex].push({
                content: str,
                style: fontset,
                left: 0,
                top: 0,
                splitIndex: splitIndex,
                height: _textHeight2,
                width: _textWidth,
                asc: _measureText3.actualBoundingBoxAscent,
                desc: _measureText3.actualBoundingBoxDescent,
                fs: fontSize
              });
              break;
            } else {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              _i5 += 1;
            }
          } else {
            if (_width + space_width > cellWidth && !_.isNil(text_all_split[splitIndex])) {
              if (!_.isNil(spaceOrTwoByte) && spaceOrTwoByte.index < _i5) {
                anchor = spaceOrTwoByte.index;
                _i5 = spaceOrTwoByte.index + 1;
                text_all_split[splitIndex].push({
                  content: spaceOrTwoByte.str,
                  style: fontset,
                  width: spaceOrTwoByte.width,
                  height: spaceOrTwoByte.height,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: spaceOrTwoByte.asc,
                  desc: spaceOrTwoByte.desc,
                  fs: fontSize
                });
                splitIndex += 1;
                spaceOrTwoByte = null;
              } else {
                spaceOrTwoByte = null;
                anchor = _i5 - 1;
                text_all_split[splitIndex].push({
                  content: preStr,
                  style: fontset,
                  width: preTextWidth,
                  height: preTextHeight,
                  left: 0,
                  top: 0,
                  splitIndex: splitIndex,
                  asc: preMeasureText.actualBoundingBoxAscent,
                  desc: preMeasureText.actualBoundingBoxDescent,
                  fs: fontSize
                });
                splitIndex += 1;
              }
            } else if (_i5 === value.length) {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              text_all_split[splitIndex].push({
                content: str,
                style: fontset,
                width: _textWidth,
                height: _textHeight2,
                left: 0,
                top: 0,
                splitIndex: splitIndex,
                asc: _measureText3.actualBoundingBoxAscent,
                desc: _measureText3.actualBoundingBoxDescent,
                fs: fontSize
              });
              break;
            } else {
              if (_.isNil(text_all_split[splitIndex])) {
                text_all_split[splitIndex] = [];
              }

              _i5 += 1;
            }
          }

          preStr = str;
          preTextHeight = _textHeight2;
          preTextWidth = _textWidth;
          preMeasureText = _measureText3;
        }
      }

      var split_all_size = [];
      var splitLen = Object.keys(text_all_split).length;
      if (splitLen === 0) return textContent;

      for (var j = 0; j < splitLen; j += 1) {
        var splitLists = text_all_split[j];

        if (_.isNil(splitLists)) {
          continue;
        }

        var sWidth = 0;
        var sHeight = 0;
        var maxDesc = 0;
        var maxAsc = 0;
        var lineHeight = 0;
        var maxWordCount = 0;

        for (var _s8 = 0; _s8 < splitLists.length; _s8 += 1) {
          var sp = splitLists[_s8];

          if (rt !== 0) {
            sWidth += sp.width;
            sHeight = Math.max(sHeight, sp.height - (supportBoundBox ? sp.desc : 0));
          } else {
            sWidth += sp.width;
            sHeight = Math.max(sHeight, sp.height - (supportBoundBox ? sp.desc : 0));
          }

          maxDesc = Math.max(maxDesc, supportBoundBox ? sp.desc : 0);
          maxAsc = Math.max(maxAsc, sp.asc);
          maxWordCount += 1;
        }

        lineHeight = sHeight / 2;

        if (rt !== 0) {
          sHeight += lineHeight;
          textW_all_inner = Math.max(textW_all_inner, sWidth);
          _textH_all += sHeight;
        } else {
          sHeight += lineHeight;
          _textW_all = Math.max(_textW_all, sWidth);
          _textH_all += sHeight;
        }

        split_all_size.push({
          width: sWidth,
          height: sHeight,
          desc: maxDesc,
          asc: maxAsc,
          lineHeight: lineHeight,
          wordCount: maxWordCount
        });
      }

      var _cumWordHeight = 0;
      var _cumColumnWidth = 0;
      var rtPI = rt * Math.PI / 180;
      var lastLine = split_all_size[splitLen - 1];
      var lastLineSpaceHeight = lastLine.lineHeight;
      _textH_all = _textH_all - lastLineSpaceHeight + lastLine.desc;
      var rw = _textH_all / Math.sin(rtPI) + textW_all_inner * Math.cos(rtPI);
      var rh = textW_all_inner * Math.sin(rtPI);
      var fixOneLineLeft = 0;

      if (rt !== 0) {
        if (splitLen === 1) {
          _textW_all = textW_all_inner + 2 * (_textH_all / Math.tan(rtPI));
          fixOneLineLeft = _textH_all / Math.tan(rtPI);
        } else {
          _textW_all = textW_all_inner + _textH_all / Math.tan(rtPI);
        }

        textContent.textWidthAll = rw;
        textContent.textHeightAll = rh;
      } else {
        textContent.textWidthAll = _textW_all;
        textContent.textHeightAll = _textH_all;
      }

      if (isMode === "onlyWidth") {
        return textContent;
      }

      if (rt !== 0 && Number(isRotateUp) === 1) {
        renderCtx.textAlign = "end";

        for (var _j = 0; _j < splitLen; _j += 1) {
          var _splitLists = text_all_split[_j];

          if (_.isNil(_splitLists)) {
            continue;
          }

          var size = split_all_size[_j];
          _cumColumnWidth = 0;

          for (var _c2 = _splitLists.length - 1; _c2 >= 0; _c2 -= 1) {
            var wordGroup = _splitLists[_c2];

            var _left = void 0;

            var _top = void 0;

            if (rt !== 0) {
              var y = _cumWordHeight + size.asc;

              var _x = _cumWordHeight / Math.tan(rtPI) - _cumColumnWidth + textW_all_inner;

              if (horizonAlign === "0") {
                if (verticalAlign === "0") {
                  _left = _x + cellWidth / 2 - _textW_all / 2 + lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top = y + cellHeight / 2 - _textH_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left = _x + cellWidth / 2 - _textW_all / 2;
                  _top = y - (_textH_all / 2 - rh / 2);
                } else if (verticalAlign === "2") {
                  _left = _x + cellWidth / 2 - _textW_all / 2 + lastLineSpaceHeight * Math.cos(rtPI);
                  _top = y + cellHeight - rh / 2 - _textH_all / 2 - lastLineSpaceHeight * Math.cos(rtPI);
                }
              } else if (horizonAlign === "1") {
                if (verticalAlign === "0") {
                  _left = _x - rh * Math.sin(rtPI) / 2 + lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top = y + cellHeight / 2 + rh * Math.cos(rtPI) / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left = _x - rh * Math.sin(rtPI);
                  _top = y + rh * Math.cos(rtPI);
                } else if (verticalAlign === "2") {
                  _left = _x + lastLineSpaceHeight * Math.cos(rtPI);
                  _top = y + cellHeight - lastLineSpaceHeight * Math.cos(rtPI);
                }
              } else if (horizonAlign === "2") {
                if (verticalAlign === "0") {
                  _left = _x + cellWidth - rw / 2 - (textW_all_inner / 2 + _textH_all / 2 / Math.tan(rtPI)) + lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top = y + cellHeight / 2 - _textH_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left = _x + cellWidth - _textW_all + fixOneLineLeft;
                  _top = y - _textH_all;
                } else if (verticalAlign === "2") {
                  _left = _x + cellWidth - rw * Math.cos(rtPI) + lastLineSpaceHeight * Math.cos(rtPI);
                  _top = y + cellHeight - rw * Math.sin(rtPI) - lastLineSpaceHeight * Math.cos(rtPI);
                }
              }
            }

            wordGroup.left = _left;
            wordGroup.top = _top;
            drawLineInfo(wordGroup, cancelLine, underLine, {
              width: wordGroup.width,
              height: wordGroup.height,
              left: (_left || 0) - wordGroup.width,
              top: _top,
              asc: size.asc,
              desc: size.desc,
              fs: wordGroup.fs
            });
            textContent.values.push(wordGroup);
            _cumColumnWidth += wordGroup.width;
          }

          _cumWordHeight += size.height;
        }
      } else {
        for (var _j2 = 0; _j2 < splitLen; _j2 += 1) {
          var _splitLists2 = text_all_split[_j2];

          if (_.isNil(_splitLists2)) {
            continue;
          }

          var _size = split_all_size[_j2];
          _cumColumnWidth = 0;

          for (var _c3 = 0; _c3 < _splitLists2.length; _c3 += 1) {
            var _wordGroup = _splitLists2[_c3];

            var _left2 = void 0;

            var _top2 = void 0;

            if (rt !== 0) {
              var _y = _cumWordHeight + _size.asc;

              var _x2 = (_textH_all - _cumWordHeight) / Math.tan(rtPI) + _cumColumnWidth;

              if (horizonAlign === "0") {
                if (verticalAlign === "0") {
                  _left2 = _x2 + cellWidth / 2 - _textW_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top2 = _y + cellHeight / 2 - _textH_all / 2 + lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left2 = _x2 + cellWidth / 2 - _textW_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top2 = _y - (_textH_all / 2 - rh / 2) + lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "2") {
                  _left2 = _x2 + cellWidth / 2 - _textW_all / 2 - lastLineSpaceHeight * Math.cos(rtPI);
                  _top2 = _y + cellHeight - rh / 2 - _textH_all / 2 - lastLineSpaceHeight * Math.cos(rtPI);
                }
              } else if (horizonAlign === "1") {
                if (verticalAlign === "0") {
                  _left2 = _x2 - rh * Math.sin(rtPI) / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top2 = _y - _textH_all + cellHeight / 2 - rh * Math.cos(rtPI) / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left2 = _x2;
                  _top2 = _y - _textH_all;
                } else if (verticalAlign === "2") {
                  _left2 = _x2 - rh * Math.sin(rtPI) - lastLineSpaceHeight * Math.cos(rtPI);
                  _top2 = _y - _textH_all + cellHeight - rh * Math.cos(rtPI) - lastLineSpaceHeight * Math.cos(rtPI);
                }
              } else if (horizonAlign === "2") {
                if (verticalAlign === "0") {
                  _left2 = _x2 + cellWidth - rw / 2 - _textW_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                  _top2 = _y + cellHeight / 2 - _textH_all / 2 - lastLineSpaceHeight * Math.cos(rtPI) / 2;
                } else if (verticalAlign === "1") {
                  _left2 = _x2 + cellWidth - rw * Math.cos(rtPI);
                  _top2 = _y + rh * Math.cos(rtPI);
                } else if (verticalAlign === "2") {
                  _left2 = _x2 + cellWidth - _textW_all - lastLineSpaceHeight * Math.cos(rtPI) + fixOneLineLeft;
                  _top2 = _y + cellHeight - lastLineSpaceHeight * Math.cos(rtPI);
                }
              }

              drawLineInfo(_wordGroup, cancelLine, underLine, {
                width: _wordGroup.width,
                height: _wordGroup.height,
                left: _left2,
                top: _top2,
                asc: _size.asc,
                desc: _size.desc,
                fs: _wordGroup.fs
              });
            } else {
              _left2 = space_width + _cumColumnWidth;

              if (horizonAlign === "0") {
                _left2 = cellWidth / 2 + _cumColumnWidth - _size.width / 2;
              } else if (horizonAlign === "2") {
                _left2 = cellWidth + _cumColumnWidth - _size.width;
              }

              _top2 = cellHeight - space_height + _cumWordHeight + _size.asc - _textH_all;

              if (verticalAlign === "0") {
                _top2 = cellHeight / 2 + _cumWordHeight - _textH_all / 2 + _size.asc;
              } else if (verticalAlign === "1") {
                _top2 = space_height + _cumWordHeight + _size.asc;
              }

              drawLineInfo(_wordGroup, cancelLine, underLine, {
                width: _wordGroup.width,
                height: _wordGroup.height,
                left: _left2,
                top: _top2,
                asc: _size.asc,
                desc: _size.desc,
                fs: _wordGroup.fs
              });
            }

            _wordGroup.left = _left2;
            _wordGroup.top = _top2;
            textContent.values.push(_wordGroup);
            _cumColumnWidth += _wordGroup.width;
          }

          _cumWordHeight += _size.height;
        }
      }

      textContent.type = "plainWrap";

      if (rt !== 0) {
        if (horizonAlign === "0") {
          textContent.textLeftAll = cellWidth / 2;

          if (verticalAlign === "0") {
            textContent.textTopAll = cellHeight / 2;
          } else if (verticalAlign === "1") {
            textContent.textTopAll = rh / 2;
          } else if (verticalAlign === "2") {
            textContent.textTopAll = cellHeight - rh / 2;
          }
        } else if (horizonAlign === "1") {
          if (verticalAlign === "0") {
            textContent.textLeftAll = 0;
            textContent.textTopAll = cellHeight / 2;
          } else if (verticalAlign === "1") {
            textContent.textLeftAll = 0;
            textContent.textTopAll = 0;
          } else if (verticalAlign === "2") {
            textContent.textLeftAll = 0;
            textContent.textTopAll = cellHeight;
          }
        } else if (horizonAlign === "2") {
          if (verticalAlign === "0") {
            textContent.textLeftAll = cellWidth - rw / 2;
            textContent.textTopAll = cellHeight / 2;
          } else if (verticalAlign === "1") {
            textContent.textLeftAll = cellWidth;
            textContent.textTopAll = 0;
          } else if (verticalAlign === "2") {
            textContent.textLeftAll = cellWidth;
            textContent.textTopAll = cellHeight;
          }
        }
      }
    } else {
      var _measureText4 = getMeasureText(value, renderCtx, sheetCtx);

      var _textWidth2 = _measureText4.width;

      var _textHeight3 = _measureText4.actualBoundingBoxDescent + _measureText4.actualBoundingBoxAscent;

      textContent.rotate = rt;
      rt = Math.abs(rt);

      var _rtPI = rt * Math.PI / 180;

      var textWidthAll = _textWidth2 * Math.cos(_rtPI) + _textHeight3 * Math.sin(_rtPI);

      var textHeightAll = _textWidth2 * Math.sin(_rtPI) + _textHeight3 * Math.cos(_rtPI);

      if (rt !== 0) {
        textContent.textHeightAll = textHeightAll;
      } else {
        textContent.textHeightAll = textHeightAll + _textHeight3 / 2 - _measureText4.actualBoundingBoxDescent - space_height;
      }

      textContent.textWidthAll = textWidthAll;

      if (isMode === "onlyWidth") {
        return textContent;
      }

      var _width2 = textWidthAll;
      var _height2 = textHeightAll;

      var _left3 = space_width + _textHeight3 * Math.sin(_rtPI) * isRotateUp;

      if (horizonAlign === "0") {
        _left3 = cellWidth / 2 - _width2 / 2 + _textHeight3 * Math.sin(_rtPI) * isRotateUp;
      } else if (horizonAlign === "2") {
        _left3 = cellWidth - space_width - _width2 + _textHeight3 * Math.sin(_rtPI) * isRotateUp;
      }

      var _top3 = cellHeight - space_height - _height2 + _measureText4.actualBoundingBoxAscent * Math.cos(_rtPI) + _textWidth2 * Math.sin(_rtPI) * isRotateUp;

      if (verticalAlign === "0") {
        _top3 = cellHeight / 2 - _height2 / 2 + _measureText4.actualBoundingBoxAscent * Math.cos(_rtPI) + _textWidth2 * Math.sin(_rtPI) * isRotateUp;
      } else if (verticalAlign === "1") {
        _top3 = space_height + _measureText4.actualBoundingBoxAscent * Math.cos(_rtPI) + _textWidth2 * Math.sin(_rtPI) * isRotateUp;
      }

      textContent.type = "plain";
      var _wordGroup2 = {
        content: value,
        style: fontset,
        width: _width2,
        height: _height2,
        left: _left3,
        top: _top3
      };
      drawLineInfo(_wordGroup2, cancelLine, underLine, {
        width: _textWidth2,
        height: _textHeight3,
        left: _left3,
        top: _top3,
        asc: _measureText4.actualBoundingBoxAscent,
        desc: _measureText4.actualBoundingBoxDescent,
        fs: fontSize
      });
      textContent.values.push(_wordGroup2);
      textContent.textLeftAll = _left3;
      textContent.textTopAll = _top3;
      textContent.asc = _measureText4.actualBoundingBoxAscent;
      textContent.desc = _measureText4.actualBoundingBoxDescent;
    }
  }

  return textContent;
}

var error = {
  v: "#VALUE!",
  n: "#NAME?",
  na: "#N/A",
  r: "#REF!",
  d: "#DIV/0!",
  nm: "#NUM!",
  nl: "#NULL!",
  sp: "#SPILL!"
};
var errorValues = Object.values(error);
function valueIsError(value) {
  return errorValues.includes(value);
}
function isRealNull(val) {
  return _.isNil(val) || val.toString().replace(/\s/g, "") === "";
}
function isRealNum(val) {
  if (_.isNil(val) || val.toString().replace(/\s/g, "") === "") {
    return false;
  }

  if (typeof val === "boolean") {
    return false;
  }

  return !Number.isNaN(Number(val));
}

function checkDateTime(str) {
  var reg1 = /^(\d{4})-(\d{1,2})-(\d{1,2})(\s(\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?$/;
  var reg2 = /^(\d{4})\/(\d{1,2})\/(\d{1,2})(\s(\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?$/;

  if (!reg1.test(str) && !reg2.test(str)) {
    return false;
  }

  var year = Number(RegExp.$1);
  var month = Number(RegExp.$2);
  var day = Number(RegExp.$3);

  if (year < 1900) {
    return false;
  }

  if (month > 12) {
    return false;
  }

  if (day > 31) {
    return false;
  }

  if (month === 2) {
    if (new Date(year, 1, 29).getDate() === 29 && day > 29) {
      return false;
    }

    if (new Date(year, 1, 29).getDate() !== 29 && day > 28) {
      return false;
    }
  }

  return true;
}

function isdatetime(s) {
  if (s === null || s.toString().length < 5) {
    return false;
  }

  if (checkDateTime(s)) {
    return true;
  }

  return false;
}
function diff(now, then) {
  return dayjs(now).diff(dayjs(then));
}
function isdatatypemulti(s) {
  var type = {};

  if (isdatetime(s)) {
    type.date = true;
  }

  if (!Number.isNaN(parseFloat(s)) && !hasChinaword(s)) {
    type.num = true;
  }

  return type;
}
function isdatatype(s) {
  var type = "string";

  if (isdatetime(s)) {
    type = "date";
  } else if (!Number.isNaN(parseFloat(s)) && !hasChinaword(s)) {
    type = "num";
  }

  return type;
}
function hasPartMC(ctx, cfg, r1, r2, c1, c2) {
  var ret = false;

  _.forEach(ctx.config.merge, function (mc) {
    if (r1 < mc.r) {
      if (r2 >= mc.r && r2 < mc.r + mc.rs - 1) {
        if (c1 >= mc.c && c1 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c2 >= mc.c && c2 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 < mc.c && c2 > mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }
      } else if (r2 >= mc.r && r2 === mc.r + mc.rs - 1) {
        if (c1 > mc.c && c1 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c2 > mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 === mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 > mc.c && c2 === mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }
      } else if (r2 > mc.r + mc.rs - 1) {
        if (c1 > mc.c && c1 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c2 >= mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 === mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 > mc.c && c2 === mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }
      }
    } else if (r1 === mc.r) {
      if (r2 < mc.r + mc.rs - 1) {
        if (c1 >= mc.c && c1 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c2 >= mc.c && c2 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 < mc.c && c2 > mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }
      } else if (r2 >= mc.r + mc.rs - 1) {
        if (c1 > mc.c && c1 <= mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c2 >= mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 === mc.c && c2 < mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }

        if (c1 > mc.c && c2 === mc.c + mc.cs - 1) {
          ret = true;
          return false;
        }
      }
    } else if (r1 <= mc.r + mc.rs - 1) {
      if (c1 >= mc.c && c1 <= mc.c + mc.cs - 1) {
        ret = true;
        return false;
      }

      if (c2 >= mc.c && c2 <= mc.c + mc.cs - 1) {
        ret = true;
        return false;
      }

      if (c1 < mc.c && c2 > mc.c + mc.cs - 1) {
        ret = true;
        return false;
      }
    }

    return true;
  });

  return ret;
}

var SSF = {};

var make_ssf = function make_ssf(SSF) {
  SSF.version = "0.11.2";

  function _strrev(x) {
    var o = "",
        i = x.length - 1;

    while (i >= 0) {
      o += x.charAt(i--);
    }

    return o;
  }

  function fill(c, l) {
    var o = "";

    while (o.length < l) {
      o += c;
    }

    return o;
  }

  function pad0(v, d) {
    var t = "" + v;
    return t.length >= d ? t : fill("0", d - t.length) + t;
  }

  function pad_(v, d) {
    var t = "" + v;
    return t.length >= d ? t : fill(" ", d - t.length) + t;
  }

  function rpad_(v, d) {
    var t = "" + v;
    return t.length >= d ? t : t + fill(" ", d - t.length);
  }

  function pad0r1(v, d) {
    var t = "" + Math.round(v);
    return t.length >= d ? t : fill("0", d - t.length) + t;
  }

  function pad0r2(v, d) {
    var t = "" + v;
    return t.length >= d ? t : fill("0", d - t.length) + t;
  }

  var p2_32 = Math.pow(2, 32);

  function pad0r(v, d) {
    if (v > p2_32 || v < -p2_32) return pad0r1(v, d);
    var i = Math.round(v);
    return pad0r2(i, d);
  }

  function isgeneral(s, i) {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
  }

  var days = [["Sun", "Sunday"], ["Mon", "Monday"], ["Tue", "Tuesday"], ["Wed", "Wednesday"], ["Thu", "Thursday"], ["Fri", "Friday"], ["Sat", "Saturday"]];
  var months = [["J", "Jan", "January"], ["F", "Feb", "February"], ["M", "Mar", "March"], ["A", "Apr", "April"], ["M", "May", "May"], ["J", "Jun", "June"], ["J", "Jul", "July"], ["A", "Aug", "August"], ["S", "Sep", "September"], ["O", "Oct", "October"], ["N", "Nov", "November"], ["D", "Dec", "December"]];

  function init_table(t) {
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "';
    t[65535] = "General";
  }

  var table_fmt = {};
  init_table(table_fmt);
  /* Defaults determined by systematically testing in Excel 2019 */

  /* These formats appear to default to other formats in the table */

  var default_map = [];
  var defi = 0; //  5 -> 37 ...  8 -> 40

  for (defi = 5; defi <= 8; ++defi) {
    default_map[defi] = 32 + defi;
  } // 23 ->  0 ... 26 ->  0


  for (defi = 23; defi <= 26; ++defi) {
    default_map[defi] = 0;
  } // 27 -> 14 ... 31 -> 14


  for (defi = 27; defi <= 31; ++defi) {
    default_map[defi] = 14;
  } // 50 -> 14 ... 58 -> 14


  for (defi = 50; defi <= 58; ++defi) {
    default_map[defi] = 14;
  } // 59 ->  1 ... 62 ->  4


  for (defi = 59; defi <= 62; ++defi) {
    default_map[defi] = defi - 58;
  } // 67 ->  9 ... 68 -> 10


  for (defi = 67; defi <= 68; ++defi) {
    default_map[defi] = defi - 58;
  } // 72 -> 14 ... 75 -> 17


  for (defi = 72; defi <= 75; ++defi) {
    default_map[defi] = defi - 58;
  } // 69 -> 12 ... 71 -> 14


  for (defi = 67; defi <= 68; ++defi) {
    default_map[defi] = defi - 57;
  } // 76 -> 20 ... 78 -> 22


  for (defi = 76; defi <= 78; ++defi) {
    default_map[defi] = defi - 56;
  } // 79 -> 45 ... 81 -> 47


  for (defi = 79; defi <= 81; ++defi) {
    default_map[defi] = defi - 34;
  } // 82 ->  0 ... 65536 -> 0 (omitted)

  /* These formats technically refer to Accounting formats with no equivalent */


  var default_str = []; //  5 -- Currency,   0 decimal, black negative

  default_str[5] = default_str[63] = '"$"#,##0_);\\("$"#,##0\\)'; //  6 -- Currency,   0 decimal, red   negative

  default_str[6] = default_str[64] = '"$"#,##0_);[Red]\\("$"#,##0\\)'; //  7 -- Currency,   2 decimal, black negative

  default_str[7] = default_str[65] = '"$"#,##0.00_);\\("$"#,##0.00\\)'; //  8 -- Currency,   2 decimal, red   negative

  default_str[8] = default_str[66] = '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)'; // 41 -- Accounting, 0 decimal, No Symbol

  default_str[41] = '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)'; // 42 -- Accounting, 0 decimal, $  Symbol

  default_str[42] = '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)'; // 43 -- Accounting, 2 decimal, No Symbol

  default_str[43] = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)'; // 44 -- Accounting, 2 decimal, $  Symbol

  default_str[44] = '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';

  function frac(x, D, mixed) {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0,
        P_1 = 1,
        P = 0;
    var Q_2 = 1,
        Q_1 = 0,
        Q = 0;
    var A = Math.floor(B);

    while (Q_1 < D) {
      A = Math.floor(B);
      P = A * P_1 + P_2;
      Q = A * Q_1 + Q_2;
      if (B - A < 0.00000005) break;
      B = 1 / (B - A);
      P_2 = P_1;
      P_1 = P;
      Q_2 = Q_1;
      Q_1 = Q;
    }

    if (Q > D) {
      if (Q_1 > D) {
        Q = Q_2;
        P = P_2;
      } else {
        Q = Q_1;
        P = P_1;
      }
    }

    if (!mixed) return [0, sgn * P, Q];
    var q = Math.floor(sgn * P / Q);
    return [q, sgn * P - q * Q, Q];
  }

  function parse_date_code(v, opts, b2) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0,
        time = Math.floor(86400 * (v - date)),
        dow = 0;
    var dout = [];
    var out = {
      D: date,
      T: time,
      u: 86400 * (v - date) - time,
      y: 0,
      m: 0,
      d: 0,
      H: 0,
      M: 0,
      S: 0,
      q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;

    if (out.u > 0.9999) {
      out.u = 0;

      if (++time == 86400) {
        out.T = time = 0;
        ++date;
        ++out.D;
      }
    }

    if (date === 60) {
      dout = b2 ? [1317, 10, 29] : [1900, 2, 29];
      dow = 3;
    } else if (date === 0) {
      dout = b2 ? [1317, 8, 29] : [1900, 1, 0];
      dow = 6;
    } else {
      if (date > 60) --date;
      /* 1 = Jan 1 1900 in Gregorian */

      var d = new Date(1900, 0, 1);
      d.setDate(d.getDate() + date - 1);
      dout = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
      dow = d.getDay();
      if (date < 60) dow = (dow + 6) % 7;
      if (b2) dow = fix_hijri(d, dout);
    }

    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
  }

  SSF.parse_date_code = parse_date_code;
  var basedate = new Date(1899, 11, 31, 0, 0, 0);
  var dnthresh = basedate.getTime();
  var base1904 = new Date(1900, 2, 1, 0, 0, 0);

  function datenum_local(v, date1904) {
    var epoch = v.getTime();
    if (date1904) epoch -= 1461 * 24 * 60 * 60 * 1000;else if (v >= base1904) epoch += 24 * 60 * 60 * 1000;
    return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
  }
  /* The longest 32-bit integer text is "-4294967296", exactly 11 chars */


  function general_fmt_int(v) {
    return v.toString(10);
  }

  SSF._general_int = general_fmt_int;
  /* ECMA-376 18.8.30 numFmt*/

  /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */

  var general_fmt_num = function make_general_fmt_num() {
    var trailing_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)$/;

    function strip_decimal(o) {
      return o.indexOf(".") == -1 ? o : o.replace(trailing_zeroes_and_decimal, "$1");
    }
    /* General Exponential always shows 2 digits exp and trims the mantissa */


    var mantissa_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)[Ee]/;
    var exp_with_single_digit = /(E[+-])(\d)$/;

    function normalize_exp(o) {
      if (o.indexOf("E") == -1) return o;
      return o.replace(mantissa_zeroes_and_decimal, "$1E").replace(exp_with_single_digit, "$10$2");
    }
    /* exponent >= -9 and <= 9 */


    function small_exp(v) {
      var w = v < 0 ? 12 : 11;
      var o = strip_decimal(v.toFixed(12));
      if (o.length <= w) return o;
      o = v.toPrecision(10);
      if (o.length <= w) return o;
      return Number(v).toExponential(5);
    }
    /* exponent >= 11 or <= -10 likely exponential */


    function large_exp(v) {
      var o = strip_decimal(v.toFixed(11));
      return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
    }

    function general_fmt_num_base(v) {
      var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E),
          o;
      if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);else if (Math.abs(V) <= 9) o = small_exp(v);else if (V === 10) o = v.toFixed(10).substr(0, 12);else o = large_exp(v);
      return strip_decimal(normalize_exp(o.toUpperCase()));
    }

    return general_fmt_num_base;
  }();

  SSF._general_num = general_fmt_num;
  /*
        "General" rules:
        - text is passed through ("@")
        - booleans are rendered as TRUE/FALSE
        - "up to 11 characters" displayed for numbers
        - Default date format (code 14) used for Dates
        TODO: technically the display depends on the width of the cell
    */

  function general_fmt(v, opts) {
    switch (_typeof(v)) {
      case "string":
        return v;

      case "boolean":
        return v ? "TRUE" : "FALSE";

      case "number":
        return (v | 0) === v ? v.toString(10) : general_fmt_num(v);

      case "undefined":
        return "";

      case "object":
        if (v == null) return "";
        if (v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
    }

    throw new Error("unsupported value in General format: " + v);
  }

  SSF._general = general_fmt;

  function fix_hijri(date, o) {
    /* TODO: properly adjust y/m/d and  */
    o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
  }
  /*jshint -W086 */

  function write_date(type, fmt, val, ss0) {
    var o = "",
        ss = 0,
        tt = 0,
        y = val.y,
        out,
        outl = 0;

    switch (type) {
      case 98:
        /* 'b' buddhist year */
        y = val.y + 543;

      /* falls through */

      case 121:
        /* 'y' year */
        switch (fmt.length) {
          case 1:
          case 2:
            out = y % 100;
            outl = 2;
            break;

          default:
            out = y % 10000;
            outl = 4;
            break;
        }

        break;

      case 109:
        /* 'm' month */
        switch (fmt.length) {
          case 1:
          case 2:
            out = val.m;
            outl = fmt.length;
            break;

          case 3:
            return months[val.m - 1][1];

          case 5:
            return months[val.m - 1][0];

          default:
            return months[val.m - 1][2];
        }

        break;

      case 100:
        /* 'd' day */
        switch (fmt.length) {
          case 1:
          case 2:
            out = val.d;
            outl = fmt.length;
            break;

          case 3:
            return days[val.q][0];

          default:
            return days[val.q][1];
        }

        break;

      case 104:
        /* 'h' 12-hour */
        switch (fmt.length) {
          case 1:
          case 2:
            out = 1 + (val.H + 11) % 12;
            outl = fmt.length;
            break;

          default:
            throw "bad hour format: " + fmt;
        }

        break;

      case 72:
        /* 'H' 24-hour */
        switch (fmt.length) {
          case 1:
          case 2:
            out = val.H;
            outl = fmt.length;
            break;

          default:
            throw "bad hour format: " + fmt;
        }

        break;

      case 77:
        /* 'M' minutes */
        switch (fmt.length) {
          case 1:
          case 2:
            out = val.M;
            outl = fmt.length;
            break;

          default:
            throw "bad minute format: " + fmt;
        }

        break;

      case 115:
        /* 's' seconds */
        if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
        if (val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
        if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;else tt = ss0 === 1 ? 10 : 1;
        ss = Math.round(tt * (val.S + val.u));
        if (ss >= 60 * tt) ss = 0;
        if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
        o = pad0(ss, 2 + ss0);
        if (fmt === "ss") return o.substr(0, 2);
        return "." + o.substr(2, fmt.length - 1);

      case 90:
        /* 'Z' absolute time */
        switch (fmt) {
          case "[h]":
          case "[hh]":
            out = val.D * 24 + val.H;
            break;

          case "[m]":
          case "[mm]":
            out = (val.D * 24 + val.H) * 60 + val.M;
            break;

          case "[s]":
          case "[ss]":
            out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
            break;

          default:
            throw "bad abstime format: " + fmt;
        }

        outl = fmt.length === 3 ? 1 : 2;
        break;

      case 101:
        /* 'e' era */
        out = y;
        outl = 1;
        break;
    }

    var outstr = outl > 0 ? pad0(out, outl) : "";
    return outstr;
  }
  /*jshint +W086 */


  function commaify(s) {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w,
        o = s.substr(0, j);

    for (; j != s.length; j += w) {
      o += (o.length > 0 ? "," : "") + s.substr(j, w);
    }

    return o;
  }

  var write_num = function make_write_num() {
    var pct1 = /%/g;

    function write_num_pct(type, fmt, val) {
      var sfmt = fmt.replace(pct1, ""),
          mul = fmt.length - sfmt.length;
      return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
    }

    function write_num_cm(type, fmt, val) {
      var idx = fmt.length - 1;

      while (fmt.charCodeAt(idx - 1) === 44) {
        --idx;
      }

      return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
    }

    function write_num_exp(fmt, val) {
      var o;
      var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;

      if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";else if (val < 0) return "-" + write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);

        if (o.indexOf("e") === -1) {
          var fakee = Math.floor(Math.log(val) * Math.LOG10E);
          if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);else o += "E+" + (fakee - ee);

          while (o.substr(0, 2) === "0.") {
            o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
            o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
          }

          o = o.replace(/\+-/, "-");
        }

        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) {
          return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
      } else o = Number(val).toExponential(idx);

      if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
      if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
      return o.replace("e", "E");
    }

    var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;

    function write_num_f1(r, aval, sign) {
      var den = parseInt(r[4], 10),
          rr = Math.round(aval * den),
          base = Math.floor(rr / den);
      var myn = rr - base * den,
          myd = den;
      return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn, r[1].length) + r[2] + "/" + r[3] + pad0(myd, r[4].length));
    }

    function write_num_f2(r, aval, sign) {
      return sign + (aval === 0 ? "" : "" + aval) + fill(" ", r[1].length + 2 + r[4].length);
    }

    var dec1 = /^#*0*\.([0#]+)/;
    var closeparen = /\).*[0#]/;
    var phone = /\(###\) ###\\?-####/;

    function hashq(str) {
      var o = "",
          cc;

      for (var i = 0; i != str.length; ++i) {
        switch (cc = str.charCodeAt(i)) {
          case 35:
            break;

          case 63:
            o += " ";
            break;

          case 48:
            o += "0";
            break;

          default:
            o += String.fromCharCode(cc);
        }
      }

      return o;
    }

    function rnd(val, d) {
      var dd = Math.pow(10, d);
      return "" + Math.round(val * dd) / dd;
    }

    function dec(val, d) {
      var _frac = val - Math.floor(val),
          dd = Math.pow(10, d);

      if (d < ("" + Math.round(_frac * dd)).length) return 0;
      return Math.round(_frac * dd);
    }

    function carry(val, d) {
      if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) {
        return 1;
      }

      return 0;
    }

    function flr(val) {
      if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
      return "" + Math.floor(val);
    }

    function write_num_flt(type, fmt, val) {
      if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return write_num_flt("n", ffmt, val);
        return "(" + write_num_flt("n", ffmt, -val) + ")";
      }

      if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
      if (fmt.indexOf("%") !== -1) return write_num_pct(type, fmt, val);
      if (fmt.indexOf("E") !== -1) return write_num_exp(fmt, val);
      if (fmt.charCodeAt(0) === 36) return "$" + write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
      var o;
      var r,
          ri,
          ff,
          aval = Math.abs(val),
          sign = val < 0 ? "-" : "";
      if (fmt.match(/^00+$/)) return sign + pad0r(aval, fmt.length);

      if (fmt.match(/^[#?]+$/)) {
        o = pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
      }

      if (r = fmt.match(frac1)) return write_num_f1(r, aval, sign);
      if (fmt.match(/^#+0+$/)) return sign + pad0r(aval, fmt.length - fmt.indexOf("0"));

      if (r = fmt.match(dec1)) {
        o = rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1])).replace(/\.(\d*)$/, function ($$, $1) {
          return "." + $1 + fill("0", hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
      }

      fmt = fmt.replace(/^#+([0.])/, "$1");

      if (r = fmt.match(/^(0*)\.(#*)$/)) {
        return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
      }

      if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify(pad0r(aval, 0));

      if (r = fmt.match(/^#,##0\.([#0]*0)$/)) {
        return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify("" + (Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length), r[1].length);
      }

      if (r = fmt.match(/^#,#*,#0/)) return write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);

      if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) {
          return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
      }

      if (fmt.match(phone)) {
        o = write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
      }

      var oa = "";

      if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(r[4].length, 7);
        ff = frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = write_num("n", r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + r[2] + "/" + r[3];
        oa = rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
      }

      if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
      }

      if (r = fmt.match(/^[#0?]+$/)) {
        o = pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return hashq(fmt.substr(0, fmt.length - o.length)) + o;
      }

      if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri,
            rres = fmt.length - o.length - lres;
        return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
      }

      if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = dec(val, r[1].length);
        return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function ($$) {
          return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + pad0(ri, r[1].length);
      }

      switch (fmt) {
        case "###,##0.00":
          return write_num_flt(type, "#,##0.00", val);

        case "###,###":
        case "##,###":
        case "#,###":
          var x = commaify(pad0r(aval, 0));
          return x !== "0" ? sign + x : "";

        case "###,###.00":
          return write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");

        case "#,###.00":
          return write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
      }

      throw new Error("unsupported format |" + fmt + "|");
    }

    function write_num_cm2(type, fmt, val) {
      var idx = fmt.length - 1;

      while (fmt.charCodeAt(idx - 1) === 44) {
        --idx;
      }

      return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
    }

    function write_num_pct2(type, fmt, val) {
      var sfmt = fmt.replace(pct1, ""),
          mul = fmt.length - sfmt.length;
      return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
    }

    function write_num_exp2(fmt, val) {
      var o;
      var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;

      if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";else if (val < 0) return "-" + write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);

        if (!o.match(/[Ee]/)) {
          var fakee = Math.floor(Math.log(val) * Math.LOG10E);
          if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);else o += "E+" + (fakee - ee);
          o = o.replace(/\+-/, "-");
        }

        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) {
          return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
      } else o = Number(val).toExponential(idx);

      if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
      if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
      return o.replace("e", "E");
    }

    function write_num_int(type, fmt, val) {
      if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return write_num_int("n", ffmt, val);
        return "(" + write_num_int("n", ffmt, -val) + ")";
      }

      if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
      if (fmt.indexOf("%") !== -1) return write_num_pct2(type, fmt, val);
      if (fmt.indexOf("E") !== -1) return write_num_exp2(fmt, val);
      if (fmt.charCodeAt(0) === 36) return "$" + write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
      var o;
      var r,
          ri,
          ff,
          aval = Math.abs(val),
          sign = val < 0 ? "-" : "";
      if (fmt.match(/^00+$/)) return sign + pad0(aval, fmt.length);

      if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
      }

      if (r = fmt.match(frac1)) return write_num_f2(r, aval, sign);
      if (fmt.match(/^#+0+$/)) return sign + pad0(aval, fmt.length - fmt.indexOf("0"));

      if (r = fmt.match(dec1)) {
        o = ("" + val).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function ($$, $1) {
          return "." + $1 + fill("0", hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
      }

      fmt = fmt.replace(/^#+([0.])/, "$1");

      if (r = fmt.match(/^(0*)\.(#*)$/)) {
        return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
      }

      if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify("" + aval);

      if (r = fmt.match(/^#,##0\.([#0]*0)$/)) {
        return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val) + "." + fill("0", r[1].length);
      }

      if (r = fmt.match(/^#,#*,#0/)) return write_num_int(type, fmt.replace(/^#,#*,/, ""), val);

      if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) {
          return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
      }

      if (fmt.match(phone)) {
        o = write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
      }

      var oa = "";

      if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(r[4].length, 7);
        ff = frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = write_num("n", r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + r[2] + "/" + r[3];
        oa = rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
      }

      if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
      }

      if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return hashq(fmt.substr(0, fmt.length - o.length)) + o;
      }

      if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri,
            rres = fmt.length - o.length - lres;
        return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
      }

      if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function ($$) {
          return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + pad0(0, r[1].length);
      }

      switch (fmt) {
        case "###,###":
        case "##,###":
        case "#,###":
          var x = commaify("" + aval);
          return x !== "0" ? sign + x : "";

        default:
          if (fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
      }

      throw new Error("unsupported format |" + fmt + "|");
    }

    return function write_num(type, fmt, val) {
      return (val | 0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
    };
  }();

  function split_fmt(fmt) {
    var out = [];
    var in_str = false;
    /*, cc*/

    for (var i = 0, j = 0; i < fmt.length; ++i) {
      switch (
      /*cc=*/
      fmt.charCodeAt(i)) {
        case 34:
          /* '"' */
          in_str = !in_str;
          break;

        case 95:
        case 42:
        case 92:
          /* '_' '*' '\\' */
          ++i;
          break;

        case 59:
          /* ';' */
          out[out.length] = fmt.substr(j, i - j);
          j = i + 1;
      }
    }

    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
  }

  SSF._split = split_fmt;
  var abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;

  function fmt_is_date(fmt) {
    var i = 0,

    /*cc = 0,*/
    c = "",
        o = "";

    while (i < fmt.length) {
      switch (c = fmt.charAt(i)) {
        case "G":
          if (isgeneral(fmt, i)) i += 6;
          i++;
          break;

        case '"':
          for (;
          /*cc=*/
          fmt.charCodeAt(++i) !== 34 && i < fmt.length;) {
            /*empty*/
          }

          ++i;
          break;

        case "\\":
          i += 2;
          break;

        case "_":
          i += 2;
          break;

        case "@":
          ++i;
          break;

        case "B":
        case "b":
          if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;

        /* falls through */

        case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */

        case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
          return true;

        case "A":
        case "a":
        case "上":
          if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
          if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
          if (fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
          ++i;
          break;

        case "[":
          o = c;

          while (fmt.charAt(i++) !== "]" && i < fmt.length) {
            o += fmt.charAt(i);
          }

          if (o.match(abstime)) return true;
          break;

        case ".":
        /* falls through */

        case "0":
        case "#":
          while (i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1)) {
            /* empty */
          }

          break;

        case "?":
          while (fmt.charAt(++i) === c) {
            /* empty */
          }

          break;

        case "*":
          ++i;
          if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
          break;

        case "(":
        case ")":
          ++i;
          break;

        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          while (i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) {
            /* empty */
          }

          break;

        case " ":
          ++i;
          break;

        default:
          ++i;
          break;
      }
    }

    return false;
  }

  SSF.is_date = fmt_is_date;

  function eval_fmt(fmt, v, opts, flen) {
    var out = [],
        o = "",
        i = 0,
        c = "",
        lst = "t",
        dt,
        j,
        cc;
    var hr = "H";
    /* Tokenize */

    while (i < fmt.length) {
      switch (c = fmt.charAt(i)) {
        case "G":
          /* General */
          if (!isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
          out[out.length] = {
            t: "G",
            v: "General"
          };
          i += 7;
          break;

        case '"':
          /* Literal text */
          for (o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) {
            o += String.fromCharCode(cc);
          }

          out[out.length] = {
            t: "t",
            v: o
          };
          ++i;
          break;

        case "\\":
          var w = fmt.charAt(++i),
              t = w === "(" || w === ")" ? w : "t";
          out[out.length] = {
            t: t,
            v: w
          };
          ++i;
          break;

        case "_":
          out[out.length] = {
            t: "t",
            v: " "
          };
          i += 2;
          break;

        case "@":
          /* Text Placeholder */
          out[out.length] = {
            t: "T",
            v: v
          };
          ++i;
          break;

        case "B":
        case "b":
          if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
            if (dt == null) {
              dt = parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
              if (dt == null) return "";
            }

            out[out.length] = {
              t: "X",
              v: fmt.substr(i, 2)
            };
            lst = c;
            i += 2;
            break;
          }

        /* falls through */

        case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
          c = c.toLowerCase();

        /* falls through */

        case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
          if (v < 0) return "";

          if (dt == null) {
            dt = parse_date_code(v, opts);
            if (dt == null) return "#####";
          }

          o = c;

          while (++i < fmt.length && fmt.charAt(i).toLowerCase() === c) {
            o += c;
          }

          if (c === "m" && lst.toLowerCase() === "h") c = "M";
          if (c === "h") c = hr;
          out[out.length] = {
            t: c,
            v: o
          };
          lst = c;
          break;

        case "A":
        case "a":
        case "上":
          var q = {
            t: c,
            v: c
          };
          if (dt == null) dt = parse_date_code(v, opts);

          if (fmt.substr(i, 3).toUpperCase() === "A/P") {
            if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
            q.t = "T";
            hr = "h";
            i += 3;
          } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
            if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
            q.t = "T";
            i += 5;
            hr = "h";
          } else if (fmt.substr(i, 5).toUpperCase() === "上午/下午") {
            if (dt != null) q.v = dt.H >= 12 ? "下午" : "上午";
            q.t = "T";
            i += 5;
            hr = "h";
          } else {
            q.t = "t";
            ++i;
          }

          if (dt == null && q.t === "T") return "";
          out[out.length] = q;
          lst = c;
          break;

        case "[":
          o = c;

          while (fmt.charAt(i++) !== "]" && i < fmt.length) {
            o += fmt.charAt(i);
          }

          if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";

          if (o.match(abstime)) {
            if (dt == null) {
              dt = parse_date_code(v, opts);
              if (dt == null) return "";
            }

            out[out.length] = {
              t: "Z",
              v: o.toLowerCase()
            };
            lst = o.charAt(1);
          } else if (o.indexOf("$") > -1) {
            o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
            if (!fmt_is_date(fmt)) out[out.length] = {
              t: "t",
              v: o
            };
          }

          break;

        /* Numbers */

        case ".":
          if (dt != null) {
            o = c;

            while (++i < fmt.length && (c = fmt.charAt(i)) === "0") {
              o += c;
            }

            out[out.length] = {
              t: "s",
              v: o
            };
            break;
          }

        /* falls through */

        case "0":
        case "#":
          o = c;

          while (++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1) {
            o += c;
          }

          out[out.length] = {
            t: "n",
            v: o
          };
          break;

        case "?":
          o = c;

          while (fmt.charAt(++i) === c) {
            o += c;
          }

          out[out.length] = {
            t: c,
            v: o
          };
          lst = c;
          break;

        case "*":
          ++i;
          if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
          break;
        // **

        case "(":
        case ")":
          out[out.length] = {
            t: flen === 1 ? "t" : c,
            v: c
          };
          ++i;
          break;

        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          o = c;

          while (i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) {
            o += fmt.charAt(i);
          }

          out[out.length] = {
            t: "D",
            v: o
          };
          break;

        case " ":
          out[out.length] = {
            t: c,
            v: c
          };
          ++i;
          break;

        case "$":
          out[out.length] = {
            t: "t",
            v: "$"
          };
          ++i;
          break;

        default:
          // if ("¤฿BsBr₵₡₫ƒFtRs.₭kr£₤Lm₥₦₱PQRSkRp৲৳R$S/.〒₮₩¥NT￥zł₴₪៛руб€＄,$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
          if ("¤฿BsBr₵₡₫ƒFtRs.₭kr£₤Lm₥₦₱PQRSkRp৲৳R$S/.〒₮₩¥NT￥zł₴₪៛руб€₹＄,$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP$￥LekdinAf$dhAflRial?￡BirrKzMOPPGKRsGsB/R$ррlevkrKMzBsPNuFBuKPkrRD$NfkCFA?CVEGMDFrCDHTGNAfLFdjKGSFGGHSRielKCFknKshLSLL￡LtRFRONArRfMWKRMMURsMROS/KMDLMTnRC$kr€GELCHFSLLSCRDbSZLSDGSOSSomFCFPTShT$VUVQUGXгрнsomWSTNT$FtDramRpZMWFCFA".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
          out[out.length] = {
            t: "t",
            v: c
          };
          ++i;
          break;
      }
    }
    /* Scan for date/time parts */


    var bt = 0,
        ss0 = 0,
        ssm;

    for (i = out.length - 1, lst = "t"; i >= 0; --i) {
      switch (out[i].t) {
        case "h":
        case "H":
          out[i].t = hr;
          lst = "h";
          if (bt < 1) bt = 1;
          break;

        case "s":
          if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
          if (bt < 3) bt = 3;

        /* falls through */

        case "d":
        case "y":
        case "M":
        case "e":
          lst = out[i].t;
          break;

        case "m":
          if (lst === "s") {
            out[i].t = "M";
            if (bt < 2) bt = 2;
          }

          break;

        case "X":
          /*if(out[i].v === "B2");*/
          break;

        case "Z":
          if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
          if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
          if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
      }
    }
    /* time rounding depends on presence of minute / second / usec fields */


    switch (bt) {
      case 0:
        break;

      case 1:
        if (dt.u >= 0.5) {
          dt.u = 0;
          ++dt.S;
        }

        if (dt.S >= 60) {
          dt.S = 0;
          ++dt.M;
        }

        if (dt.M >= 60) {
          dt.M = 0;
          ++dt.H;
        }

        break;

      case 2:
        if (dt.u >= 0.5) {
          dt.u = 0;
          ++dt.S;
        }

        if (dt.S >= 60) {
          dt.S = 0;
          ++dt.M;
        }

        break;
    }
    /* replace fields */


    var nstr = "",
        jj;

    for (i = 0; i < out.length; ++i) {
      switch (out[i].t) {
        case "t":
        case "T":
        case " ":
        case "D":
          break;

        case "X":
          out[i].v = "";
          out[i].t = ";";
          break;

        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
          out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
          out[i].t = "t";
          break;

        case "n":
        case "?":
          jj = i + 1;

          while (out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))) {
            out[i].v += out[jj].v;
            out[jj] = {
              v: "",
              t: ";"
            };
            ++jj;
          }

          nstr += out[i].v;
          i = jj - 1;
          break;

        case "G":
          out[i].t = "t";
          out[i].v = general_fmt(v, opts);
          break;
      }
    }

    var vv = "",
        myv,
        ostr;

    if (nstr.length > 0) {
      if (nstr.charCodeAt(0) == 40) {
        /* '(' */
        myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
        ostr = write_num("n", nstr, myv);
      } else {
        myv = v < 0 && flen > 1 ? -v : v;
        ostr = write_num("n", nstr, myv);

        if (myv < 0 && out[0] && out[0].t == "t") {
          ostr = ostr.substr(1);
          out[0].v = "-" + out[0].v;
        }
      }

      jj = ostr.length - 1;
      var decpt = out.length;

      for (i = 0; i < out.length; ++i) {
        if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
          decpt = i;
          break;
        }
      }

      var lasti = out.length;

      if (decpt === out.length && ostr.indexOf("E") === -1) {
        for (i = out.length - 1; i >= 0; --i) {
          if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;

          if (jj >= out[i].v.length - 1) {
            jj -= out[i].v.length;
            out[i].v = ostr.substr(jj + 1, out[i].v.length);
          } else if (jj < 0) out[i].v = "";else {
            out[i].v = ostr.substr(0, jj + 1);
            jj = -1;
          }

          out[i].t = "t";
          lasti = i;
        }

        if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
      } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
        jj = ostr.indexOf(".") - 1;

        for (i = decpt; i >= 0; --i) {
          if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
          j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
          vv = out[i].v.substr(j + 1);

          for (; j >= 0; --j) {
            if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
          }

          out[i].v = vv;
          out[i].t = "t";
          lasti = i;
        }

        if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        jj = ostr.indexOf(".") + 1;

        for (i = decpt; i < out.length; ++i) {
          if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
          j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
          vv = out[i].v.substr(0, j);

          for (; j < out[i].v.length; ++j) {
            if (jj < ostr.length) vv += ostr.charAt(jj++);
          }

          out[i].v = vv;
          out[i].t = "t";
          lasti = i;
        }
      }
    }

    for (i = 0; i < out.length; ++i) {
      if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
      }
    }

    var retval = "";

    for (i = 0; i !== out.length; ++i) {
      if (out[i] != null) retval += out[i].v;
    }

    return retval;
  }

  SSF._eval = eval_fmt;
  var cfregex = /\[[=<>]/;
  var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;

  function chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);

    switch (rr[1]) {
      case "=":
        if (v == thresh) return true;
        break;

      case ">":
        if (v > thresh) return true;
        break;

      case "<":
        if (v < thresh) return true;
        break;

      case "<>":
        if (v != thresh) return true;
        break;

      case ">=":
        if (v >= thresh) return true;
        break;

      case "<=":
        if (v <= thresh) return true;
        break;
    }

    return false;
  }

  function choose_fmt(f, v) {
    var fmt = split_fmt(f);
    var l = fmt.length,
        lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|"); // 这行代码弃用，有可能v会有"1"的情况出现，并且需要排查true，false，‘ ’这些值所以需要使用parseFloat(v).toString()去判断是不是Number类型
    // if (typeof v !== "number")

    if (parseFloat(v).toString() == "NaN") return [4, fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"];

    switch (fmt.length) {
      case 1:
        fmt = lat > -1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"];
        break;

      case 2:
        fmt = lat > -1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"];
        break;

      case 3:
        fmt = lat > -1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"];
        break;
    }

    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];

    if (fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
      var m1 = fmt[0].match(cfregex2);
      var m2 = fmt[1].match(cfregex2);
      return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
    }

    return [l, ff];
  }

  function format(fmt, v, o) {
    if (o == null) o = {};
    var sfmt = "";

    switch (_typeof(fmt)) {
      case "string":
        if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;else sfmt = fmt;
        break;

      case "number":
        if (fmt == 14 && o.dateNF) sfmt = o.dateNF;else sfmt = (o.table != null ? o.table : table_fmt)[fmt];
        if (sfmt == null) sfmt = o.table && o.table[default_map[fmt]] || table_fmt[default_map[fmt]];
        if (sfmt == null) sfmt = default_str[fmt] || "General";
        break;
    } //new runze 增加万 亿 格式
    //注："w":2万2500  "w0":2万2500  "w0.0":2万2500.2  "w0.00":2万2500.23......自定义精确度


    var reg = /^(w|W)((0?)|(0\.0+))$/;

    if (!!sfmt.match(reg)) {
      if (isNaN(v)) {
        return v;
      } //var v =300101886.436;


      var acc = sfmt.slice(1); //取得0/0.0/0.00

      var isNegative = false;

      if (!isNaN(v) && Number(v) < 0) {
        isNegative = true;
        v = Math.abs(v);
      }

      var vInt = parseInt(v);
      var vlength = vInt.toString().length;

      if (vlength > 4) {
        if (vlength > 8) {
          var y = parseInt(v / 100000000); //亿

          var w = parseInt(parseFloat(v) - y * 100000000 / 10000); //万

          var q = parseFloat(v) - (y * 100000000 + w * 10000); //千以后

          if (acc != "") {
            q = numeral(q).format(acc); //处理精确度
          }

          v = y + "亿" + w + "万" + q;
        } else {
          var w = parseInt(v / 10000); //万

          var q = parseFloat(v) - w * 10000; //千以后

          if (acc != "") {
            q = numeral(q).format(acc); //处理精确度
          }

          v = w + "万" + q;
        }

        if (v.indexOf("亿0万0") != -1) {
          v = v.replace("0万0", "");
        } else if (v.indexOf("亿0万") != -1) {
          v = v.replace("0万", "");
        } else if (v.indexOf("万0") != -1) {
          v = v.replace("万0", "万");
        } //舍弃正则后顾断言写法，旧浏览器不识别（360 V9）


        if (v.indexOf("亿") != -1 && v.indexOf("万") == -1) {
          //1亿/1亿111 => 1亿/1亿0111
          var afterYi = v.substring(v.indexOf("亿") + 1);

          if (afterYi.substring(0, 1) !== "." && afterYi != "") {
            switch ((parseInt(afterYi) + "").length) {
              case 1:
                afterYi = "000" + afterYi;
                break;

              case 2:
                afterYi = "00" + afterYi;
                break;

              case 3:
                afterYi = "0" + afterYi;
                break;
            }

            v = v.substring(0, v.indexOf("亿") + 1) + afterYi;
          }
        } else if (v.indexOf("亿") == -1 && v.indexOf("万") != -1) {
          //3万0011
          var afterWan = v.substring(v.indexOf("万") + 1);

          if (afterWan.substring(0, 1) !== "." && afterWan != "") {
            switch ((parseInt(afterWan) + "").length) {
              case 1:
                afterWan = "000" + afterWan;
                break;

              case 2:
                afterWan = "00" + afterWan;
                break;

              case 3:
                afterWan = "0" + afterWan;
                break;
            }

            v = v.substring(0, v.indexOf("万") + 1) + afterWan;
          }
        } else if (v.indexOf("亿") != -1 && v.indexOf("万") != -1) {
          //1亿0053万0611
          var afterYi = v.substring(v.indexOf("亿") + 1, v.indexOf("万")),
              afterWan = v.substring(v.indexOf("万") + 1);

          switch ((parseInt(afterYi) + "").length) {
            case 1:
              afterYi = "000" + afterYi;
              break;

            case 2:
              afterYi = "00" + afterYi;
              break;

            case 3:
              afterYi = "0" + afterYi;
              break;
          }

          v = v.substring(0, v.indexOf("亿") + 1) + afterYi + v.substring(v.indexOf("万"));

          if (afterWan.substring(0, 1) !== "." && afterWan != "") {
            switch ((parseInt(afterWan) + "").length) {
              case 1:
                afterWan = "000" + afterWan;
                break;

              case 2:
                afterWan = "00" + afterWan;
                break;

              case 3:
                afterWan = "0" + afterWan;
                break;
            }

            v = v.substring(0, v.indexOf("万") + 1) + afterWan;
          }
        }
      } else {
        if (acc != "") {
          v = numeral(v).format(acc); //处理精确度
        }
      }

      if (isNegative) {
        return "-" + v;
      } else {
        return v;
      }
    }

    if (isgeneral(sfmt, 0)) return general_fmt(v, o);
    if (v instanceof Date) v = datenum_local(v, o.date1904);
    var f = choose_fmt(sfmt, v);
    if (isgeneral(f[1])) return general_fmt(v, o);
    if (v === true) v = "TRUE";else if (v === false) v = "FALSE";else if (v === "" || v == null) return "";
    return eval_fmt(f[1], v, o, f[0]);
  }

  function load_entry(fmt, idx) {
    if (typeof idx != "number") {
      idx = +idx || -1;

      for (var i = 0; i < 0x0188; ++i) {
        if (table_fmt[i] == undefined) {
          if (idx < 0) idx = i;
          continue;
        }

        if (table_fmt[i] == fmt) {
          idx = i;
          break;
        }
      }

      if (idx < 0) idx = 0x187;
    }

    table_fmt[idx] = fmt;
    return idx;
  }

  SSF.load = load_entry;
  SSF._table = table_fmt;

  SSF.get_table = function get_table() {
    return table_fmt;
  };

  SSF.load_table = function load_table(tbl) {
    for (var i = 0; i != 0x0188; ++i) {
      if (tbl[i] !== undefined) load_entry(tbl[i], i);
    }
  };

  SSF.init_table = init_table;
  SSF.format = format;
};

make_ssf(SSF);

var base1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v, date1904) {
  var epoch = Date.UTC(v.getFullYear(), v.getMonth(), v.getDate(), v.getHours(), v.getMinutes(), v.getSeconds());
  var dnthresh_utc = Date.UTC(1899, 11, 31, 0, 0, 0);
  if (date1904) epoch -= 1461 * 24 * 60 * 60 * 1000;else if (v >= base1904) epoch += 24 * 60 * 60 * 1000;
  return (epoch - dnthresh_utc) / (24 * 60 * 60 * 1000);
}
var good_pd_date = new Date("2017-02-19T19:06:09.000Z");
if (Number.isNaN(good_pd_date.getFullYear())) good_pd_date = new Date("2/19/17");
var good_pd = good_pd_date.getFullYear() === 2017;

function parseDate(str, fixdate) {
  var d = new Date(str);

  if (good_pd) {
    if (!_.isNil(fixdate)) {
      if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
    }

    return d;
  }

  if (str instanceof Date) return str;

  if (good_pd_date.getFullYear() === 1917 && !Number.isNaN(d.getFullYear())) {
    var s = d.getFullYear();
    if (str.indexOf("".concat(s)) > -1) return d;
    d.setFullYear(d.getFullYear() + 100);
    return d;
  }

  var n = str.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"];
  var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
  if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
  return out;
}

function genarate(value) {
  var m = null;
  var ct = {};
  var v = value;

  if (_.isNil(value)) {
    return null;
  }

  if (/^-?[0-9]{1,}[,][0-9]{3}(.[0-9]{1,2})?$/.test(value)) {
    value = value;
    m = value;
    v = Number(value.split(".")[0].replace(",", ""));
    var fa = "#,##0";

    if (value.split(".")[1]) {
      fa = "#,##0.";

      for (var i = 0; i < value.split(".")[1].length; i += 1) {
        fa += 0;
      }
    }

    ct = {
      fa: fa,
      t: "n"
    };
  } else if (value.toString().substring(0, 1) === "'") {
    m = value.toString().substring(1);
    ct = {
      fa: "@",
      t: "s"
    };
  } else if (value.toString().toUpperCase() === "TRUE") {
    m = "TRUE";
    ct = {
      fa: "General",
      t: "b"
    };
    v = true;
  } else if (value.toString().toUpperCase() === "FALSE") {
    m = "FALSE";
    ct = {
      fa: "General",
      t: "b"
    };
    v = false;
  } else if (valueIsError(value.toString())) {
    m = value.toString();
    ct = {
      fa: "General",
      t: "e"
    };
  } else if (/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(value)) {
    m = value.toString();
    ct = {
      fa: "@",
      t: "s"
    };
  } else if (isRealNum(value) && Math.abs(parseFloat(value)) > 0 && (Math.abs(parseFloat(value)) >= 1e11 || Math.abs(parseFloat(value)) < 1e-9)) {
    v = parseFloat(value);
    var str = v.toExponential();

    if (str.indexOf(".") > -1) {
      var strlen = str.split(".")[1].split("e")[0].length;

      if (strlen > 5) {
        strlen = 5;
      }

      ct = {
        fa: "#0.".concat(new Array(strlen + 1).join("0"), "E+00"),
        t: "n"
      };
    } else {
      ct = {
        fa: "#0.E+00",
        t: "n"
      };
    }

    m = SSF.format(ct.fa, v);
  } else if (value.toString().indexOf("%") > -1) {
    var index = value.toString().indexOf("%");
    var value2 = value.toString().substring(0, index);
    var value3 = value2.replace(/,/g, "");

    if (index === value.toString().length - 1 && isRealNum(value3)) {
      if (value2.indexOf(".") > -1) {
        if (value2.indexOf(".") === value2.lastIndexOf(".")) {
          var value4 = value2.split(".")[0];
          var value5 = value2.split(".")[1];
          var len = value5.length;

          if (len > 9) {
            len = 9;
          }

          if (value4.indexOf(",") > -1) {
            var isThousands = true;
            var ThousandsArr = value4.split(",");

            for (var _i = 1; _i < ThousandsArr.length; _i += 1) {
              if (ThousandsArr[_i].length < 3) {
                isThousands = false;
                break;
              }
            }

            if (isThousands) {
              ct = {
                fa: "#,##0.".concat(new Array(len + 1).join("0"), "%"),
                t: "n"
              };
              v = numeral(value).value();
              m = SSF.format(ct.fa, v);
            } else {
              m = value.toString();
              ct = {
                fa: "@",
                t: "s"
              };
            }
          } else {
            ct = {
              fa: "0.".concat(new Array(len + 1).join("0"), "%"),
              t: "n"
            };
            v = numeral(value).value();
            m = SSF.format(ct.fa, v);
          }
        } else {
          m = value.toString();
          ct = {
            fa: "@",
            t: "s"
          };
        }
      } else if (value2.indexOf(",") > -1) {
        var _isThousands = true;

        var _ThousandsArr = value2.split(",");

        for (var _i2 = 1; _i2 < _ThousandsArr.length; _i2 += 1) {
          if (_ThousandsArr[_i2].length < 3) {
            _isThousands = false;
            break;
          }
        }

        if (_isThousands) {
          ct = {
            fa: "#,##0%",
            t: "n"
          };
          v = numeral(value).value();
          m = SSF.format(ct.fa, v);
        } else {
          m = value.toString();
          ct = {
            fa: "@",
            t: "s"
          };
        }
      } else {
        ct = {
          fa: "0%",
          t: "n"
        };
        v = numeral(value).value();
        m = SSF.format(ct.fa, v);
      }
    } else {
      m = value.toString();
      ct = {
        fa: "@",
        t: "s"
      };
    }
  } else if (value.toString().indexOf(".") > -1) {
    if (value.toString().indexOf(".") === value.toString().lastIndexOf(".")) {
      var value1 = value.toString().split(".")[0];
      var _value = value.toString().split(".")[1];
      var _len = _value.length;

      if (_len > 9) {
        _len = 9;
      }

      if (value1.indexOf(",") > -1) {
        var _isThousands2 = true;

        var _ThousandsArr2 = value1.split(",");

        for (var _i3 = 1; _i3 < _ThousandsArr2.length; _i3 += 1) {
          if (!isRealNum(_ThousandsArr2[_i3]) || _ThousandsArr2[_i3].length < 3) {
            _isThousands2 = false;
            break;
          }
        }

        if (_isThousands2) {
          ct = {
            fa: "#,##0.".concat(new Array(_len + 1).join("0")),
            t: "n"
          };
          v = numeral(value).value();
          m = SSF.format(ct.fa, v);
        } else {
          m = value.toString();
          ct = {
            fa: "@",
            t: "s"
          };
        }
      } else {
        if (isRealNum(value1) && isRealNum(_value)) {
          ct = {
            fa: "0.".concat(new Array(_len + 1).join("0")),
            t: "n"
          };
          v = numeral(value).value();
          m = SSF.format(ct.fa, v);
        } else {
          m = value.toString();
          ct = {
            fa: "@",
            t: "s"
          };
        }
      }
    } else {
      m = value.toString();
      ct = {
        fa: "@",
        t: "s"
      };
    }
  } else if (isRealNum(value)) {
    m = parseFloat(value).toString();
    ct = {
      fa: "General",
      t: "n"
    };
    v = parseFloat(value);
  } else if (isdatetime(value) && (value.toString().indexOf(".") > -1 || value.toString().indexOf(":") > -1 || value.toString().length < 16)) {
    v = datenum_local(parseDate(value.toString().replace(/-/g, "/")));

    if (v.toString().indexOf(".") > -1) {
      if (value.toString().length > 18) {
        ct.fa = "yyyy-MM-dd hh:mm:ss";
      } else if (value.toString().length > 11) {
        ct.fa = "yyyy-MM-dd hh:mm";
      } else {
        ct.fa = "yyyy-MM-dd";
      }
    } else {
      ct.fa = "yyyy-MM-dd";
    }

    ct.t = "d";
    m = SSF.format(ct.fa, v);
  } else {
    m = value;
    ct.fa = "General";
    ct.t = "g";
  }

  return [m, ct, v];
}
function update(fmt, v) {
  return SSF.format(fmt, v);
}
function is_date(fmt, v) {
  return SSF.is_date(fmt, v);
}

function fuzzynum(s) {
  var v = Number(s);

  if (typeof s === "number") {
    return s;
  }

  if (!Number.isNaN(v)) return v;
  var wt = 1;
  var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function () {
    wt *= 100;
    return "";
  });
  v = Number(ss);
  if (!Number.isNaN(v)) return v / wt;
  ss = ss.replace(/[(](.*)[)]/, function ($$, $1) {
    wt = -wt;
    return $1;
  });
  v = Number(ss);
  if (!Number.isNaN(v)) return v / wt;
  return v;
}

function valueShowEs(r, c, d) {
  var value = getCellValue(r, c, d, "m");

  if (value == null) {
    value = getCellValue(r, c, d, "v");
  } else {
    var _d$r, _d$r$c, _d$r$c$ct, _d$r2, _d$r2$c, _d$r2$c$ct;

    if (!Number.isNaN(fuzzynum(value))) {
      if (_.isString(value) && value.indexOf("%") > -1) ; else {
        value = getCellValue(r, c, d, "v");
      }
    } else if (((_d$r = d[r]) === null || _d$r === void 0 ? void 0 : (_d$r$c = _d$r[c]) === null || _d$r$c === void 0 ? void 0 : (_d$r$c$ct = _d$r$c.ct) === null || _d$r$c$ct === void 0 ? void 0 : _d$r$c$ct.t) === "d") ; else if (((_d$r2 = d[r]) === null || _d$r2 === void 0 ? void 0 : (_d$r2$c = _d$r2[c]) === null || _d$r2$c === void 0 ? void 0 : (_d$r2$c$ct = _d$r2$c.ct) === null || _d$r2$c$ct === void 0 ? void 0 : _d$r2$c$ct.t) === "b") ; else {
      value = getCellValue(r, c, d, "v");
    }
  }

  return value;
}

var colors = ["#c1232b", "#27727b", "#fcce10", "#e87c25", "#b5c334", "#fe8463", "#9bca63", "#fad860", "#f3a43b", "#60c0dd", "#d7504b", "#c6e579", "#f4e001", "#f0805a", "#26c0c0", "#c12e34", "#e6b600", "#0098d9", "#2b821d", "#005eaa", "#339ca8", "#cda819", "#32a487", "#3fb1e3", "#6be6c1", "#626c91", "#a0a7e6", "#c4ebad", "#96dee8"];

function mousePosition(x, y, ctx) {
  var newX = x - ctx.rowHeaderWidth;
  var newY = y - ctx.toolbarHeight - ctx.calculatebarHeight - ctx.columnHeaderHeight;
  return [newX, newY];
}
function rowLocationByIndex(row_index, visibleRow) {
  var row = 0;
  var row_pre = 0;
  row = visibleRow[row_index];

  if (row_index === 0) {
    row_pre = 0;
  } else {
    row_pre = visibleRow[row_index - 1];
  }

  return [row_pre, row, row_index];
}
function rowLocation(y, visibleRow) {
  var row_index = _.sortedIndex(visibleRow, y);

  if (row_index >= visibleRow.length && y > 0) {
    row_index = visibleRow.length - 1;
  } else if (row_index === -1 && y <= 0) {
    row_index = 0;
  }

  return rowLocationByIndex(row_index, visibleRow);
}
function colLocationByIndex(col_index, visibleCol) {
  var col = 0;
  var col_pre = 0;
  col = visibleCol[col_index];

  if (col_index === 0) {
    col_pre = 0;
  } else {
    col_pre = visibleCol[col_index - 1];
  }

  return [col_pre, col, col_index];
}
function colLocation(x, visibleCol) {
  var col_index = _.sortedIndex(visibleCol, x);

  if (col_index >= visibleCol.length && x > 0) {
    col_index = visibleCol.length - 1;
  } else if (col_index === -1 && x <= 0) {
    col_index = 0;
  }

  return colLocationByIndex(col_index, visibleCol);
}

var functionHTMLIndex = 0;
var rangeIndexes = [];
var operatorPriority = {
  "^": 0,
  "%": 1,
  "*": 1,
  "/": 1,
  "+": 2,
  "-": 2
};
var operatorArr = "==|!=|<>|<=|>=|=|+|-|>|<|/|*|%|&|^".split("|");
var operatorjson = {};

for (var i = 0; i < operatorArr.length; i += 1) {
  operatorjson[operatorArr[i].toString()] = 1;
}

var simpleSheetName = "[A-Za-z0-9_\xC0-\u02AF]+";
var quotedSheetName = "'(?:(?!').|'')*'";
var sheetNameRegexp = "(".concat(simpleSheetName, "|").concat(quotedSheetName, ")!");
var rowColumnRegexp = "[$]?[A-Za-z]+[$]?[0-9]+";
var rowColumnWithSheetName = "(?:".concat(sheetNameRegexp, ")?(").concat(rowColumnRegexp, ")");
var LABEL_EXTRACT_REGEXP = new RegExp("^".concat(rowColumnWithSheetName, "(?:[:]").concat(rowColumnWithSheetName, ")?$"));
var FormulaCache = /*#__PURE__*/function () {
  function FormulaCache() {
    _classCallCheck(this, FormulaCache);

    this.parser = void 0;
    this.func_selectedrange = void 0;
    this.data_parm_index = void 0;
    this.cellTextToIndexList = void 0;
    this.rangechangeindex = void 0;
    this.selectingRangeIndex = void 0;
    this.rangeResizeObj = void 0;
    this.rangeResize = void 0;
    this.rangeResizeIndex = void 0;
    this.rangeResizexy = void 0;
    this.rangeResizeWinH = void 0;
    this.rangeResizeWinW = void 0;
    this.rangeResizeTo = void 0;
    this.rangeSetValueTo = void 0;
    this.rangeIndex = void 0;
    this.rangestart = void 0;
    this.rangetosheet = void 0;
    this.rangedrag_column_start = void 0;
    this.rangedrag_row_start = void 0;
    this.functionRangeIndex = void 0;
    this.functionlistMap = void 0;
    this.execFunctionExist = void 0;
    this.execFunctionGlobalData = void 0;
    var that = this;
    this.data_parm_index = 0;
    this.selectingRangeIndex = -1;
    this.functionlistMap = {};
    this.execFunctionGlobalData = {};
    this.cellTextToIndexList = {};
    this.parser = new Parser();
    this.parser.on("callCellValue", function (cellCoord, options, done) {
      var _context$formulaCache, _flowdata$cellCoord$r;

      var context = that.parser.context;
      var id = cellCoord.sheetName == null ? options.sheetId : getSheetIdByName(context, cellCoord.sheetName);
      if (id == null) throw Error(ERROR_REF);
      var flowdata = getFlowdata(context, id);
      var cell = (context === null || context === void 0 ? void 0 : (_context$formulaCache = context.formulaCache.execFunctionGlobalData) === null || _context$formulaCache === void 0 ? void 0 : _context$formulaCache["".concat(cellCoord.row.index, "_").concat(cellCoord.column.index, "_").concat(id)]) || (flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$cellCoord$r = flowdata[cellCoord.row.index]) === null || _flowdata$cellCoord$r === void 0 ? void 0 : _flowdata$cellCoord$r[cellCoord.column.index]);
      var v = that.tryGetCellAsNumber(cell);
      done(v);
    });
    this.parser.on("callRangeValue", function (startCellCoord, endCellCoord, options, done) {
      var context = that.parser.context;
      var id = startCellCoord.sheetName == null ? options.sheetId : getSheetIdByName(context, startCellCoord.sheetName);
      if (id == null) throw Error(ERROR_REF);
      var flowdata = getFlowdata(context, id);
      var fragment = [];
      var startRow = startCellCoord.row.index;
      var endRow = endCellCoord.row.index;
      var startCol = startCellCoord.column.index;
      var endCol = endCellCoord.column.index;
      var emptyRow = startRow === -1 || endRow === -1;
      var emptyCol = startCol === -1 || endCol === -1;

      if (emptyRow) {
        var _flowdata$length;

        startRow = 0;
        endRow = (_flowdata$length = flowdata === null || flowdata === void 0 ? void 0 : flowdata.length) !== null && _flowdata$length !== void 0 ? _flowdata$length : 0;
      }

      if (emptyCol) {
        var _flowdata$0$length;

        startCol = 0;
        endCol = (_flowdata$0$length = flowdata === null || flowdata === void 0 ? void 0 : flowdata[0].length) !== null && _flowdata$0$length !== void 0 ? _flowdata$0$length : 0;
      }

      if (emptyRow && emptyCol) throw Error(ERROR_REF);

      for (var row = startRow; row <= endRow; row += 1) {
        var colFragment = [];

        for (var col = startCol; col <= endCol; col += 1) {
          var _context$formulaCache2, _flowdata$row;

          var cell = (context === null || context === void 0 ? void 0 : (_context$formulaCache2 = context.formulaCache.execFunctionGlobalData) === null || _context$formulaCache2 === void 0 ? void 0 : _context$formulaCache2["".concat(row, "_").concat(col, "_").concat(id)]) || (flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$row = flowdata[row]) === null || _flowdata$row === void 0 ? void 0 : _flowdata$row[col]);
          var v = that.tryGetCellAsNumber(cell);
          colFragment.push(v);
        }

        fragment.push(colFragment);
      }

      if (fragment) {
        done(fragment);
      }
    });
  }

  _createClass(FormulaCache, [{
    key: "tryGetCellAsNumber",
    value: function tryGetCellAsNumber(cell) {
      var _cell$ct;

      if ((cell === null || cell === void 0 ? void 0 : (_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : _cell$ct.t) === "n") {
        var n = Number(cell === null || cell === void 0 ? void 0 : cell.v);
        return Number.isNaN(n) ? cell.v : n;
      }

      return cell === null || cell === void 0 ? void 0 : cell.v;
    }
  }]);

  return FormulaCache;
}();

function parseElement(eleString) {
  return new DOMParser().parseFromString(eleString, "text/html").body.childNodes[0];
}

function iscelldata(txt) {
  var val = txt.split("!");
  var rangetxt;

  if (val.length > 1) {
    var _val = _slicedToArray(val, 2);

    rangetxt = _val[1];
  } else {
    var _val2 = _slicedToArray(val, 1);

    rangetxt = _val2[0];
  }

  var reg_cell = /^(([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+))$/g;
  var reg_cellRange = /^(((([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+)))|((([a-zA-Z]+)|([$][a-zA-Z]+))))$/g;

  if (rangetxt.indexOf(":") === -1) {
    var _row = parseInt(rangetxt.replace(/[^0-9]/g, ""), 10) - 1;

    var _col = columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g, ""));

    if (!Number.isNaN(_row) && !Number.isNaN(_col) && rangetxt.toString().match(reg_cell)) {
      return true;
    }

    if (!Number.isNaN(_row)) {
      return false;
    }

    if (!Number.isNaN(_col)) {
      return false;
    }

    return false;
  }

  reg_cellRange = /^(((([a-zA-Z]+)|([$][a-zA-Z]+))(([0-9]+)|([$][0-9]+)))|((([a-zA-Z]+)|([$][a-zA-Z]+)))|((([0-9]+)|([$][0-9]+s))))$/g;
  var rangetxtArr = rangetxt.split(":");
  var row = [];
  var col = [];
  row[0] = parseInt(rangetxtArr[0].replace(/[^0-9]/g, ""), 10) - 1;
  row[1] = parseInt(rangetxtArr[1].replace(/[^0-9]/g, ""), 10) - 1;

  if (row[0] > row[1]) {
    return false;
  }

  col[0] = columnCharToIndex(rangetxtArr[0].replace(/[^A-Za-z]/g, ""));
  col[1] = columnCharToIndex(rangetxtArr[1].replace(/[^A-Za-z]/g, ""));

  if (col[0] > col[1]) {
    return false;
  }

  if (rangetxtArr[0].toString().match(reg_cellRange) && rangetxtArr[1].toString().match(reg_cellRange)) {
    return true;
  }

  return false;
}

function addToCellIndexList(ctx, txt, infoObj) {
  if (_.isNil(txt) || txt.length === 0 || _.isNil(infoObj)) {
    return;
  }

  if (_.isNil(ctx.formulaCache.cellTextToIndexList)) {
    ctx.formulaCache.cellTextToIndexList = {};
  }

  if (txt.indexOf("!") > -1) {
    txt = txt.replace(/\\'/g, "'").replace(/''/g, "'");
    ctx.formulaCache.cellTextToIndexList[txt] = infoObj;
  } else {
    ctx.formulaCache.cellTextToIndexList["".concat(txt, "_").concat(infoObj.sheetId)] = infoObj;
  }
}

function getcellrange(ctx, txt, formulaId) {
  if (_.isNil(txt) || txt.length === 0) {
    return null;
  }

  var flowdata = getFlowdata(ctx, formulaId);
  var sheettxt = "";
  var rangetxt = "";
  var sheetId = null;
  var sheetdata = null;
  var luckysheetfile = ctx.luckysheetfile;

  if (txt.indexOf("!") > -1) {
    if (txt in ctx.formulaCache.cellTextToIndexList) {
      return ctx.formulaCache.cellTextToIndexList[txt];
    }

    var matchRes = txt.match(LABEL_EXTRACT_REGEXP);

    if (matchRes == null) {
      return null;
    }

    var _matchRes = _slicedToArray(matchRes, 5),
        sheettxt1 = _matchRes[1],
        starttxt1 = _matchRes[2],
        sheettxt2 = _matchRes[3],
        starttxt2 = _matchRes[4];

    if (sheettxt2 != null && sheettxt1 !== sheettxt2) {
      return null;
    }

    rangetxt = starttxt2 ? "".concat(starttxt1, ":").concat(starttxt2) : starttxt1;
    sheettxt = sheettxt1.replace(/^'|'$/g, "").replace(/\\'/g, "'").replace(/''/g, "'");

    _.forEach(luckysheetfile, function (f) {
      if (sheettxt === f.name) {
        sheetId = f.id;
        sheetdata = f.data;
        return false;
      }

      return true;
    });
  } else {
    var _i = formulaId;

    if (_.isNil(_i)) {
      _i = ctx.currentSheetId;
    }

    if ("".concat(txt, "_").concat(_i) in ctx.formulaCache.cellTextToIndexList) {
      return ctx.formulaCache.cellTextToIndexList["".concat(txt, "_").concat(_i)];
    }

    var index = getSheetIndex(ctx, _i);

    if (_.isNil(index)) {
      return null;
    }

    sheettxt = luckysheetfile[index].name;
    sheetId = luckysheetfile[index].id;
    sheetdata = flowdata;
    rangetxt = txt;
  }

  if (_.isNil(sheetdata)) {
    return null;
  }

  if (rangetxt.indexOf(":") === -1) {
    var _row2 = parseInt(rangetxt.replace(/[^0-9]/g, ""), 10) - 1;

    var _col2 = columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g, ""));

    if (!Number.isNaN(_row2) && !Number.isNaN(_col2)) {
      var _item = {
        row: [_row2, _row2],
        column: [_col2, _col2],
        sheetId: sheetId
      };
      addToCellIndexList(ctx, txt, _item);
      return _item;
    }

    return null;
  }

  var rangetxtArr = rangetxt.split(":");
  var row = [];
  var col = [];
  row[0] = parseInt(rangetxtArr[0].replace(/[^0-9]/g, ""), 10) - 1;
  row[1] = parseInt(rangetxtArr[1].replace(/[^0-9]/g, ""), 10) - 1;

  if (Number.isNaN(row[0])) {
    row[0] = 0;
  }

  if (Number.isNaN(row[1])) {
    row[1] = sheetdata.length - 1;
  }

  if (row[0] > row[1]) {
    return null;
  }

  col[0] = columnCharToIndex(rangetxtArr[0].replace(/[^A-Za-z]/g, ""));
  col[1] = columnCharToIndex(rangetxtArr[1].replace(/[^A-Za-z]/g, ""));

  if (Number.isNaN(col[0])) {
    col[0] = 0;
  }

  if (Number.isNaN(col[1])) {
    col[1] = sheetdata[0].length - 1;
  }

  if (col[0] > col[1]) {
    return null;
  }

  var item = {
    row: row,
    column: col,
    sheetId: sheetId
  };
  addToCellIndexList(ctx, txt, item);
  return item;
}

function calPostfixExpression(cal) {
  if (cal.length === 0) {
    return "";
  }

  var stack = [];

  for (var _i2 = cal.length - 1; _i2 >= 0; _i2 -= 1) {
    var c = cal[_i2];

    if (c in operatorjson) {
      var s2 = stack.pop();
      var s1 = stack.pop();
      var str = "luckysheet_compareWith(".concat(s1, ",'").concat(c, "', ").concat(s2, ")");
      stack.push(str);
    } else {
      stack.push(c);
    }
  }

  if (stack.length > 0) {
    return stack[0];
  }

  return "";
}

function checkSpecialFunctionRange(ctx, function_str, r, c, id, dynamicArray_compute, cellRangeFunction) {
  if (function_str.substring(0, 30) === "luckysheet_getSpecialReference" || function_str.substring(0, 20) === "luckysheet_function.") {
    if (function_str.substring(0, 20) === "luckysheet_function.") {
      var funcName = function_str.split(".")[1];

      if (!_.isNil(funcName)) {
        funcName = funcName.toUpperCase();

        if (funcName !== "INDIRECT" && funcName !== "OFFSET" && funcName !== "INDEX") {
          return;
        }
      }
    }

    try {
      ctx.calculateSheetId = id;
      var str = function_str.split(",")[function_str.split(",").length - 1].split("'")[1].split("'")[0];

      var str_nb = _.trim(str);

      if (iscelldata(str_nb)) {
        if (typeof cellRangeFunction === "function") {
          cellRangeFunction(str_nb);
        }
      }
    } catch (_unused) {}
  }
}

function isFunctionRange(ctx, txt, r, c, id, dynamicArray_compute, cellRangeFunction) {
  if (txt.substring(0, 1) === "=") {
    txt = txt.substring(1);
  }

  var funcstack = txt.split("");
  var i = 0;
  var str = "";
  var function_str = "";
  var matchConfig = {
    bracket: 0,
    comma: 0,
    squote: 0,
    dquote: 0,
    compare: 0,
    braces: 0
  };
  var cal1 = [];
  var cal2 = [];
  var bracket = [];

  while (i < funcstack.length) {
    var s = funcstack[i];

    if (s === "(" && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      if (str.length > 0 && bracket.length === 0) {
        str = str.toUpperCase();

        if (str.indexOf(":") > -1) {
          var funcArray = str.split(":");
          function_str += "luckysheet_getSpecialReference(true,'".concat(_.trim(funcArray[0]).replace(/'/g, "\\'"), "', luckysheet_function.").concat(funcArray[1], ".f(#lucky#");
        } else {
          function_str += "luckysheet_function.".concat(str, ".f(");
        }

        bracket.push(1);
        str = "";
      } else if (bracket.length === 0) {
        function_str += "(";
        bracket.push(0);
        str = "";
      } else {
        bracket.push(0);
        str += s;
      }
    } else if (s === ")" && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      bracket.pop();

      if (bracket.length === 0) {
        var functionS = isFunctionRange(ctx, str, r, c, id, dynamicArray_compute, cellRangeFunction);

        if (functionS.indexOf("#lucky#") > -1) {
          functionS = "".concat(functionS.replace(/#lucky#/g, ""), ")");
        }

        function_str += "".concat(functionS, ")");
        str = "";
      } else {
        str += s;
      }
    } else if (s === "{" && matchConfig.squote === 0 && matchConfig.dquote === 0) {
      str += "{";
      matchConfig.braces += 1;
    } else if (s === "}" && matchConfig.squote === 0 && matchConfig.dquote === 0) {
      str += "}";
      matchConfig.braces -= 1;
    } else if (s === '"' && matchConfig.squote === 0) {
      if (matchConfig.dquote > 0) {
        if (i < funcstack.length - 1 && funcstack[i + 1] === '"') {
          i += 1;
          str += "\x7F";
        } else {
          matchConfig.dquote -= 1;
          str += '"';
        }
      } else {
        matchConfig.dquote += 1;
        str += '"';
      }
    } else if (s === "'" && matchConfig.dquote === 0) {
      str += "'";

      if (matchConfig.squote > 0) {
        if (i < funcstack.length - 1 && funcstack[i + 1] === "'") {
          i += 1;
          str += "'";
        } else {
          matchConfig.squote -= 1;
        }
      } else {
        matchConfig.squote += 1;
      }
    } else if (s === "," && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      if (bracket.length <= 1) {
        var _functionS = isFunctionRange(ctx, str, r, c, id, dynamicArray_compute, cellRangeFunction);

        if (_functionS.indexOf("#lucky#") > -1) {
          _functionS = "".concat(_functionS.replace(/#lucky#/g, ""), ")");
        }

        function_str += "".concat(_functionS, ",");
        str = "";
      } else {
        str += ",";
      }
    } else if (s in operatorjson && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      var s_next = "";
      var op = operatorPriority;

      if (i + 1 < funcstack.length) {
        s_next = funcstack[i + 1];
      }

      if (s + s_next in operatorjson) {
        if (bracket.length === 0) {
          if (_.trim(str).length > 0) {
            cal2.unshift(isFunctionRange(ctx, _.trim(str), r, c, id, dynamicArray_compute, cellRangeFunction));
          } else if (_.trim(function_str).length > 0) {
            cal2.unshift(_.trim(function_str));
          }

          if (cal1[0] in operatorjson) {
            var stackCeilPri = op[cal1[0]];

            while (cal1.length > 0 && !_.isNil(stackCeilPri)) {
              cal2.unshift(cal1.shift());
              stackCeilPri = op[cal1[0]];
            }
          }

          cal1.unshift(s + s_next);
          function_str = "";
          str = "";
        } else {
          str += s + s_next;
        }

        i += 1;
      } else {
        if (bracket.length === 0) {
          if (_.trim(str).length > 0) {
            cal2.unshift(isFunctionRange(ctx, _.trim(str), r, c, id, dynamicArray_compute, cellRangeFunction));
          } else if (_.trim(function_str).length > 0) {
            cal2.unshift(_.trim(function_str));
          }

          if (cal1[0] in operatorjson) {
            var _stackCeilPri = op[cal1[0]];
            _stackCeilPri = _.isNil(_stackCeilPri) ? 1000 : _stackCeilPri;
            var sPri = op[s];
            sPri = _.isNil(sPri) ? 1000 : sPri;

            while (cal1.length > 0 && sPri >= _stackCeilPri) {
              cal2.unshift(cal1.shift());
              _stackCeilPri = op[cal1[0]];
              _stackCeilPri = _.isNil(_stackCeilPri) ? 1000 : _stackCeilPri;
            }
          }

          cal1.unshift(s);
          function_str = "";
          str = "";
        } else {
          str += s;
        }
      }
    } else {
      if (matchConfig.dquote === 0 && matchConfig.squote === 0) {
        str += _.trim(s);
      } else {
        str += s;
      }
    }

    if (i === funcstack.length - 1) {
      var endstr = "";

      var str_nb = _.trim(str).replace(/'/g, "\\'");

      if (iscelldata(str_nb) && str_nb.substring(0, 1) !== ":") {
        endstr = "luckysheet_getcelldata('".concat(str_nb, "')");
      } else if (str_nb.substring(0, 1) === ":") {
        str_nb = str_nb.substring(1);

        if (iscelldata(str_nb)) {
          endstr = "luckysheet_getSpecialReference(false,".concat(function_str, ",'").concat(str_nb, "')");
        }
      } else {
        str = _.trim(str);
        var regx = /{.*?}/;

        if (regx.test(str) && str.substring(0, 1) !== '"' && str.substring(str.length - 1, 1) !== '"') {
          var _regx$exec;

          var arraytxt = (_regx$exec = regx.exec(str)) === null || _regx$exec === void 0 ? void 0 : _regx$exec[0];
          var arraystart = str.search(regx);

          if (arraystart > 0) {
            endstr += str.substring(0, arraystart);
          }

          endstr += "luckysheet_getarraydata('".concat(arraytxt, "')");

          if (arraystart + arraytxt.length < str.length) {
            endstr += str.substring(arraystart + arraytxt.length, str.length);
          }
        } else {
          endstr = str;
        }
      }

      if (endstr.length > 0) {
        cal2.unshift(endstr);
      }

      if (cal1.length > 0) {
        if (function_str.length > 0) {
          cal2.unshift(function_str);
          function_str = "";
        }

        while (cal1.length > 0) {
          cal2.unshift(cal1.shift());
        }
      }

      if (cal2.length > 0) {
        function_str = calPostfixExpression(cal2);
      } else {
        function_str += endstr;
      }
    }

    i += 1;
  }

  checkSpecialFunctionRange(ctx, function_str, r, c, id, dynamicArray_compute, cellRangeFunction);
  return function_str;
}

function getAllFunctionGroup(ctx) {
  var luckysheetfile = ctx.luckysheetfile;
  var ret = [];

  for (var _i3 = 0; _i3 < luckysheetfile.length; _i3 += 1) {
    var file = luckysheetfile[_i3];
    var calcChain = file.calcChain;
    var dynamicArray_compute = file.dynamicArray_compute;

    if (_.isNil(calcChain)) {
      calcChain = [];
    }

    if (_.isNil(dynamicArray_compute)) {
      dynamicArray_compute = [];
    }

    ret = ret.concat(calcChain);

    for (var j = 0; j < dynamicArray_compute.length; j += 1) {
      var d = dynamicArray_compute[0];
      ret.push({
        r: d.r,
        c: d.c,
        id: d.id
      });
    }
  }

  return ret;
}
function delFunctionGroup(ctx, r, c, id) {
  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  var file = ctx.luckysheetfile[getSheetIndex(ctx, id)];
  var calcChain = file.calcChain;

  if (!_.isNil(calcChain)) {
    var modified = false;

    var calcChainClone = _.cloneDeep(calcChain);

    for (var _i4 = 0; _i4 < calcChainClone.length; _i4 += 1) {
      var calc = calcChainClone[_i4];

      if (calc.r === r && calc.c === c && calc.id === id) {
        calcChainClone.splice(_i4, 1);
        modified = true;
        break;
      }
    }

    if (modified) {
      file.calcChain = calcChainClone;
    }
  }

  var dynamicArray = file.dynamicArray;

  if (!_.isNil(dynamicArray)) {
    var _modified = false;

    var dynamicArrayClone = _.cloneDeep(dynamicArray);

    for (var _i5 = 0; _i5 < dynamicArrayClone.length; _i5 += 1) {
      var _calc = dynamicArrayClone[_i5];

      if (_calc.r === r && _calc.c === c && (_.isNil(_calc.id) || _calc.id === id)) {
        dynamicArrayClone.splice(_i5, 1);
        _modified = true;
        break;
      }
    }

    if (_modified) {
      file.dynamicArray = dynamicArrayClone;
    }
  }
}

function checkBracketNum(fp) {
  var bra_l = fp.match(/\(/g);
  var bra_r = fp.match(/\)/g);
  var bra_tl_txt = fp.match(/(['"])(?:(?!\1).)*?\1/g);
  var bra_tr_txt = fp.match(/(['"])(?:(?!\1).)*?\1/g);
  var bra_l_len = 0;
  var bra_r_len = 0;

  if (!_.isNil(bra_l)) {
    bra_l_len += bra_l.length;
  }

  if (!_.isNil(bra_r)) {
    bra_r_len += bra_r.length;
  }

  var bra_tl_len = 0;
  var bra_tr_len = 0;

  if (!_.isNil(bra_tl_txt)) {
    for (var _i6 = 0; _i6 < bra_tl_txt.length; _i6 += 1) {
      var bra_tl = bra_tl_txt[_i6].match(/\(/g);

      if (!_.isNil(bra_tl)) {
        bra_tl_len += bra_tl.length;
      }
    }
  }

  if (!_.isNil(bra_tr_txt)) {
    for (var _i7 = 0; _i7 < bra_tr_txt.length; _i7 += 1) {
      var bra_tr = bra_tr_txt[_i7].match(/\)/g);

      if (!_.isNil(bra_tr)) {
        bra_tr_len += bra_tr.length;
      }
    }
  }

  bra_l_len -= bra_tl_len;
  bra_r_len -= bra_tr_len;

  if (bra_l_len !== bra_r_len) {
    return false;
  }

  return true;
}

function insertUpdateFunctionGroup(ctx, r, c, id, calcChainSet) {
  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  var luckysheetfile = ctx.luckysheetfile;
  var idx = getSheetIndex(ctx, id);

  if (_.isNil(idx)) {
    return;
  }

  var file = luckysheetfile[idx];
  var calcChain = file.calcChain;

  if (_.isNil(calcChain)) {
    calcChain = [];
  }

  if (calcChainSet) {
    if (calcChainSet.has("".concat(r, "_").concat(c, "_").concat(id))) return;
  } else {
    for (var _i8 = 0; _i8 < calcChain.length; _i8 += 1) {
      var calc = calcChain[_i8];

      if (calc.r === r && calc.c === c && calc.id === id) {
        return;
      }
    }
  }

  var cc = {
    r: r,
    c: c,
    id: id
  };
  calcChain.push(cc);
  file.calcChain = calcChain;
  ctx.luckysheetfile = luckysheetfile;
}
function execfunction(ctx, txt, r, c, id, calcChainSet, isrefresh, notInsertFunc) {
  if (txt.indexOf(error.r) > -1) {
    return [false, error.r, txt];
  }

  if (!checkBracketNum(txt)) {
    txt += ")";
  }

  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  ctx.calculateSheetId = id;
  ctx.formulaCache.parser.context = ctx;
  var parsedResponse = ctx.formulaCache.parser.parse(txt.substring(1), {
    sheetId: id || ctx.currentSheetId
  });
  var formulaError = parsedResponse.error;
  var result = parsedResponse.result;

  if (Object.prototype.toString.call(result) === "[object Date]" && !_.isNil(result)) {
    result = result.toString();
  }

  if (!_.isNil(r) && !_.isNil(c)) {
    if (isrefresh) {
      execFunctionGroup(ctx, r, c, _.isNil(formulaError) ? result : formulaError, id);
    }

    if (!notInsertFunc) {
      insertUpdateFunctionGroup(ctx, r, c, id, calcChainSet);
    }
  }

  return [true, _.isNil(formulaError) ? result : formulaError, txt];
}

function insertUpdateDynamicArray(ctx, dynamicArrayItem) {
  var r = dynamicArrayItem.r,
      c = dynamicArrayItem.c;
  var id = dynamicArrayItem.id;

  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  var luckysheetfile = ctx.luckysheetfile;
  var idx = getSheetIndex(ctx, id);
  if (idx == null) return [];
  var file = luckysheetfile[idx];
  var dynamicArray = file.dynamicArray;

  if (_.isNil(dynamicArray)) {
    dynamicArray = [];
  }

  for (var _i9 = 0; _i9 < dynamicArray.length; _i9 += 1) {
    var calc = dynamicArray[_i9];

    if (calc.r === r && calc.c === c && calc.id === id) {
      calc.data = dynamicArrayItem.data;
      calc.f = dynamicArrayItem.f;
      return dynamicArray;
    }
  }

  dynamicArray.push(dynamicArrayItem);
  return dynamicArray;
}

function groupValuesRefresh(ctx) {
  var luckysheetfile = ctx.luckysheetfile;

  if (ctx.groupValuesRefreshData.length > 0) {
    for (var _i10 = 0; _i10 < ctx.groupValuesRefreshData.length; _i10 += 1) {
      var item = ctx.groupValuesRefreshData[_i10];
      var idx = getSheetIndex(ctx, item.id);
      if (idx == null) continue;
      var file = luckysheetfile[idx];
      var data = file.data;

      if (_.isNil(data)) {
        continue;
      }

      var updateValue = {};

      if (!_.isNil(item.spe)) {
        if (item.spe.type === "sparklines") {
          updateValue.spl = item.spe.data;
        } else if (item.spe.type === "dynamicArrayItem") {
          file.dynamicArray = insertUpdateDynamicArray(ctx, item.spe.data);
        }
      }

      updateValue.v = item.v;
      updateValue.f = item.f;
      setCellValue(ctx, item.r, item.c, data, updateValue);
    }

    ctx.groupValuesRefreshData = [];
  }
}
function execFunctionGroup(ctx, origin_r, origin_c, value, id, data) {
  var isForce = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  if (_.isNil(data)) {
    data = getFlowdata(ctx);
  }

  if (_.isNil(ctx.formulaCache.execFunctionGlobalData)) {
    ctx.formulaCache.execFunctionGlobalData = {};
  }

  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  if (!_.isNil(value)) {
    var cellCache = [[{
      v: undefined
    }]];
    setCellValue(ctx, 0, 0, cellCache, value);

    var _cellCache$ = _slicedToArray(cellCache[0], 1);

    ctx.formulaCache.execFunctionGlobalData["".concat(origin_r, "_").concat(origin_c, "_").concat(id)] = _cellCache$[0];
  }

  var calcChains = getAllFunctionGroup(ctx);
  var formulaObjects = {};
  var sheets = ctx.luckysheetfile;
  var sheetData = {};

  for (var _i11 = 0; _i11 < sheets.length; _i11 += 1) {
    var sheet = sheets[_i11];
    sheetData[sheet.id] = sheet.data;
  }

  var updateValueOjects = {};
  var updateValueArray = [];

  if (_.isNil(ctx.formulaCache.execFunctionExist)) {
    var key = "r".concat(origin_r, "c").concat(origin_c, "i").concat(id);
    updateValueOjects[key] = 1;
  } else {
    for (var x = 0; x < ctx.formulaCache.execFunctionExist.length; x += 1) {
      var cell = ctx.formulaCache.execFunctionExist[x];

      var _key = "r".concat(cell.r, "c").concat(cell.c, "i").concat(cell.i);

      updateValueOjects[_key] = 1;
    }
  }

  var arrayMatchCache = {};

  var arrayMatch = function arrayMatch(formulaArray, _formulaObjects, _updateValueOjects, func) {
    for (var a = 0; a < formulaArray.length; a += 1) {
      var range = formulaArray[a];
      var cacheKey = "r".concat(range.row[0]).concat(range.row[1], "c").concat(range.column[0]).concat(range.column[1], "id").concat(range.sheetId);

      if (cacheKey in arrayMatchCache) {
        var amc = arrayMatchCache[cacheKey];
        amc.forEach(function (item) {
          func(item.key, item.r, item.c, item.sheetId);
        });
      } else {
        var functionArr = [];

        for (var r = range.row[0]; r <= range.row[1]; r += 1) {
          for (var c = range.column[0]; c <= range.column[1]; c += 1) {
            var _key2 = "r".concat(r, "c").concat(c, "i").concat(range.sheetId);

            func(_key2, r, c, range.sheetId);

            if (_formulaObjects && _key2 in _formulaObjects || _updateValueOjects && _key2 in _updateValueOjects) {
              functionArr.push({
                key: _key2,
                r: r,
                c: c,
                sheetId: range.sheetId
              });
            }
          }
        }

        if (_formulaObjects || _updateValueOjects) {
          arrayMatchCache[cacheKey] = functionArr;
        }
      }
    }
  };

  var _loop = function _loop(_i12) {
    var formulaCell = calcChains[_i12];
    var key = "r".concat(formulaCell.r, "c").concat(formulaCell.c, "i").concat(formulaCell.id);
    var calc_funcStr = getcellFormula(ctx, formulaCell.r, formulaCell.c, formulaCell.id);

    if (_.isNil(calc_funcStr)) {
      return "continue";
    }

    var txt1 = calc_funcStr.toUpperCase();
    var isOffsetFunc = txt1.indexOf("INDIRECT(") > -1 || txt1.indexOf("OFFSET(") > -1 || txt1.indexOf("INDEX(") > -1;
    var formulaArray = [];

    if (isOffsetFunc) {
      isFunctionRange(ctx, calc_funcStr, null, null, formulaCell.id, null, function (str_nb) {
        var range = getcellrange(ctx, _.trim(str_nb), formulaCell.id);

        if (!_.isNil(range)) {
          formulaArray.push(range);
        }
      });
    } else if (!(calc_funcStr.substring(0, 2) === '="' && calc_funcStr.substring(calc_funcStr.length - 1, 1) === '"')) {
      var point = 0;
      var squote = -1;
      var dquote = -1;
      var formulaTextArray = [];
      var sq_end_array = [];
      var calc_funcStr_length = calc_funcStr.length;

      for (var j = 0; j < calc_funcStr_length; j += 1) {
        var char = calc_funcStr.charAt(j);

        if (char === "'" && dquote === -1) {
          if (squote === -1) {
            if (point !== j) {
              formulaTextArray.push.apply(formulaTextArray, _toConsumableArray(calc_funcStr.substring(point, j).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));
            }

            squote = j;
            point = j;
          } else {
            if (j < calc_funcStr_length - 1 && calc_funcStr.charAt(j + 1) === "'") {
              j += 1;
            } else {
              point = j + 1;
              formulaTextArray.push(calc_funcStr.substring(squote, point));
              sq_end_array.push(formulaTextArray.length - 1);
              squote = -1;
            }
          }
        }

        if (char === '"' && squote === -1) {
          if (dquote === -1) {
            if (point !== j) {
              formulaTextArray.push.apply(formulaTextArray, _toConsumableArray(calc_funcStr.substring(point, j).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));
            }

            dquote = j;
            point = j;
          } else {
            if (j < calc_funcStr_length - 1 && calc_funcStr.charAt(j + 1) === '"') {
              j += 1;
            } else {
              point = j + 1;
              formulaTextArray.push(calc_funcStr.substring(dquote, point));
              dquote = -1;
            }
          }
        }
      }

      if (point !== calc_funcStr_length) {
        formulaTextArray.push.apply(formulaTextArray, _toConsumableArray(calc_funcStr.substring(point, calc_funcStr_length).split(/==|!=|<>|<=|>=|[,()=+-/*%&^><]/)));
      }

      for (var _j = sq_end_array.length - 1; _j >= 0; _j -= 1) {
        if (sq_end_array[_j] !== formulaTextArray.length - 1) {
          formulaTextArray[sq_end_array[_j]] += formulaTextArray[sq_end_array[_j] + 1];
          formulaTextArray.splice(sq_end_array[_j] + 1, 1);
        }
      }

      for (var _j2 = 0; _j2 < formulaTextArray.length; _j2 += 1) {
        var t = formulaTextArray[_j2];

        if (t.length <= 1) {
          continue;
        }

        if (t.substring(0, 1) === '"' && t.substring(t.length - 1, 1) === '"' || !iscelldata(t)) {
          continue;
        }

        var range = getcellrange(ctx, _.trim(t), formulaCell.id);

        if (_.isNil(range)) {
          continue;
        }

        formulaArray.push(range);
      }
    }

    var item = {
      formulaArray: formulaArray,
      calc_funcStr: calc_funcStr,
      key: key,
      r: formulaCell.r,
      c: formulaCell.c,
      id: formulaCell.id,
      parents: {},
      chidren: {},
      color: "w"
    };
    formulaObjects[key] = item;
  };

  for (var _i12 = 0; _i12 < calcChains.length; _i12 += 1) {
    var _ret = _loop(_i12);

    if (_ret === "continue") continue;
  }

  Object.keys(formulaObjects).forEach(function (key) {
    var formulaObject = formulaObjects[key];
    arrayMatch(formulaObject.formulaArray, formulaObjects, updateValueOjects, function (childKey) {
      if (childKey in formulaObjects) {
        var childFormulaObject = formulaObjects[childKey];
        formulaObject.chidren[childKey] = 1;
        childFormulaObject.parents[key] = 1;
      }

      if (!isForce && childKey in updateValueOjects) {
        updateValueArray.push(formulaObject);
      }
    });

    if (isForce) {
      updateValueArray.push(formulaObject);
    }
  });
  var formulaRunList = [];
  var stack = updateValueArray;
  var existsFormulaRunList = {};

  var _loop2 = function _loop2() {
    var formulaObject = stack.pop();

    if (_.isNil(formulaObject) || formulaObject.key in existsFormulaRunList) {
      return "continue";
    }

    if (formulaObject.color === "b") {
      formulaRunList.push(formulaObject);
      existsFormulaRunList[formulaObject.key] = 1;
      return "continue";
    }

    var cacheStack = [];
    Object.keys(formulaObject.parents).forEach(function (parentKey) {
      var parentFormulaObject = formulaObjects[parentKey];

      if (!_.isNil(parentFormulaObject)) {
        cacheStack.push(parentFormulaObject);
      }
    });

    if (cacheStack.length === 0) {
      formulaRunList.push(formulaObject);
      existsFormulaRunList[formulaObject.key] = 1;
    } else {
      formulaObject.color = "b";
      stack.push(formulaObject);
      stack = stack.concat(cacheStack);
    }
  };

  while (stack.length > 0) {
    var _ret2 = _loop2();

    if (_ret2 === "continue") continue;
  }

  formulaRunList.reverse();
  var calcChainSet = new Set();
  calcChains.forEach(function (item) {
    calcChainSet.add("".concat(item.r, "_").concat(item.c, "_").concat(item.id));
  });

  for (var _i13 = 0; _i13 < formulaRunList.length; _i13 += 1) {
    var formulaCell = formulaRunList[_i13];

    if (formulaCell.level === Math.max) {
      continue;
    }

    var calc_funcStr = formulaCell.calc_funcStr;
    var v = execfunction(ctx, calc_funcStr, formulaCell.r, formulaCell.c, formulaCell.id, calcChainSet);
    ctx.groupValuesRefreshData.push({
      r: formulaCell.r,
      c: formulaCell.c,
      v: v[1],
      f: v[2],
      spe: v[3],
      id: formulaCell.id
    });
    ctx.formulaCache.execFunctionGlobalData["".concat(formulaCell.r, "_").concat(formulaCell.c, "_").concat(formulaCell.id)] = {
      v: v[1],
      f: v[2]
    };
  }

  ctx.formulaCache.execFunctionExist = undefined;
}

function findrangeindex(ctx, v, vp) {
  var re = /<span.*?>/g;
  var v_a = v.replace(re, "").split("</span>");
  var vp_a = vp.replace(re, "").split("</span>");
  v_a.pop();
  if (vp_a[vp_a.length - 1] === "") vp_a.pop();
  var pfri = ctx.formulaCache.functionRangeIndex;
  if (pfri == null) return [];
  var vplen = vp_a.length;
  var vlen = v_a.length;

  if (vplen === vlen) {
    var _i14 = pfri[0];
    var p = vp_a[_i14];
    var n = v_a[_i14];

    if (_.isNil(p)) {
      if (vp_a.length <= _i14) {
        pfri = [vp_a.length - 1, vp_a.length - 1];
      } else if (v_a.length <= _i14) {
        pfri = [v_a.length - 1, v_a.length - 1];
      }

      return pfri;
    }

    if (p.length === n.length) {
      if (!_.isNil(vp_a[_i14 + 1]) && !_.isNil(v_a[_i14 + 1]) && vp_a[_i14 + 1].length < v_a[_i14 + 1].length) {
        pfri[0] += 1;
        pfri[1] = 1;
      }

      return pfri;
    }

    if (p.length > n.length) {
      if (!_.isNil(p) && !_.isNil(v_a[_i14 + 1]) && v_a[_i14 + 1].substring(0, 1) === '"' && (p.indexOf("{") > -1 || p.indexOf("}") > -1)) {
        pfri[0] += 1;
        pfri[1] = 1;
      }

      return pfri;
    }

    if (p.length < n.length) {
      if (pfri[1] > n.length) {
        pfri[1] = n.length;
      }

      return pfri;
    }
  } else if (vplen > vlen) {
    var _i15 = pfri[0];
    var _p = vp_a[_i15];
    var _n = v_a[_i15];

    if (_.isNil(_n)) {
      if (v_a[_i15 - 1].indexOf("{") > -1) {
        pfri[0] -= 1;

        var start = v_a[_i15 - 1].search("{");

        pfri[1] += start;
      } else {
        pfri[0] = 0;
        pfri[1] = 0;
      }
    } else if (_p.length === _n.length) {
      if (!_.isNil(v_a[_i15 + 1]) && (v_a[_i15 + 1].substring(0, 1) === '"' || v_a[_i15 + 1].substring(0, 1) === "{" || v_a[_i15 + 1].substring(0, 1) === "}")) {
        pfri[0] += 1;
        pfri[1] = 1;
      } else if (!_.isNil(_p) && _p.length > 2 && _p.substring(0, 1) === '"' && _p.substring(_p.length - 1, 1) === '"') ; else if (!_.isNil(v_a[_i15]) && v_a[_i15] === '")') {
        pfri[1] = 1;
      } else if (!_.isNil(v_a[_i15]) && v_a[_i15] === '"}') {
        pfri[1] = 1;
      } else if (!_.isNil(v_a[_i15]) && v_a[_i15] === "{)") {
        pfri[1] = 1;
      } else {
        pfri[1] = _n.length;
      }

      return pfri;
    } else if (_p.length > _n.length) {
      if (!_.isNil(v_a[_i15 + 1]) && (v_a[_i15 + 1].substring(0, 1) === '"' || v_a[_i15 + 1].substring(0, 1) === "{" || v_a[_i15 + 1].substring(0, 1) === "}")) {
        pfri[0] += 1;
        pfri[1] = 1;
      }

      return pfri;
    } else if (_p.length < _n.length) {
      return pfri;
    }

    return pfri;
  } else if (vplen < vlen) {
    var _i16 = pfri[0];
    var _p2 = vp_a[_i16];
    var _n2 = v_a[_i16];

    if (_.isNil(_p2)) {
      pfri[0] = v_a.length - 1;

      if (!_.isNil(_n2)) {
        pfri[1] = _n2.length;
      } else {
        pfri[1] = 1;
      }
    } else if (_p2.length === _n2.length) {
      if (vp_a[_i16 + 1] != null && (vp_a[_i16 + 1].substring(0, 1) === '"' || vp_a[_i16 + 1].substring(0, 1) === "{" || vp_a[_i16 + 1].substring(0, 1) === "}")) {
        pfri[1] = _n2.length;
      } else if (!_.isNil(v_a[_i16 + 1]) && v_a[_i16 + 1].substring(0, 1) === '"' && (v_a[_i16 + 1].substring(0, 1) === "{" || v_a[_i16 + 1].substring(0, 1) === "}")) {
        pfri[0] += 1;
        pfri[1] = 1;
      } else if (!_.isNil(_n2) && _n2.substring(0, 1) === '"' && _n2.substring(_n2.length - 1, 1) === '"' && _p2.substring(0, 1) === '"' && _p2.substring(_p2.length - 1, 1) === ")") {
        pfri[1] = _n2.length;
      } else if (!_.isNil(_n2) && _n2.substring(0, 1) === "{" && _n2.substring(_n2.length - 1, 1) === "}" && _p2.substring(0, 1) === "{" && _p2.substring(_p2.length - 1, 1) === ")") {
        pfri[1] = _n2.length;
      } else {
        pfri[0] = pfri[0] + vlen - vplen;

        if (v_a.length > vp_a.length) {
          pfri[1] = v_a[_i16 + 1].length;
        } else {
          pfri[1] = 1;
        }
      }

      return pfri;
    } else if (_p2.length > _n2.length) {
      if (!_.isNil(_p2) && _p2.substring(0, 1) === '"') {
        pfri[1] = _n2.length;
      } else if (_.isNil(v_a[_i16 + 1]) && /{.*?}/.test(v_a[_i16 + 1])) {
        pfri[0] += 1;
        pfri[1] = v_a[_i16 + 1].length;
      } else if (!_.isNil(_p2) && v_a[_i16 + 1].substring(0, 1) === '"' && (_p2.indexOf("{") > -1 || _p2.indexOf("}") > -1)) {
        pfri[0] += 1;
        pfri[1] = 1;
      } else if (!_.isNil(_p2) && (_p2.indexOf("{") > -1 || _p2.indexOf("}") > -1)) ; else if (!_.isNil(_p2) && !_.startsWith(_p2[0], "=") && _.startsWith(_n2, "=")) {
        return [vlen - 1, v_a[vlen - 1].length];
      } else {
        pfri[0] = pfri[0] + vlen - vplen - 1;
        pfri[1] = v_a[(_i16 || 1) - 1].length;
      }

      return pfri;
    } else if (_p2.length < _n2.length) {
      return pfri;
    }

    return pfri;
  }

  return null;
}

function createFormulaRangeSelect(ctx, select) {
  ctx.formulaRangeSelect = select;
}
function createRangeHightlight(ctx, inputInnerHtmlStr) {
  var ignoreRangeIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var $span = parseElement("<div>".concat(inputInnerHtmlStr, "</div>"));
  var formulaRanges = [];
  $span.querySelectorAll("span.fortune-formula-functionrange-cell").forEach(function (ele) {
    var rangeIndex = parseInt(ele.getAttribute("rangeindex") || "0", 10);
    if (rangeIndex === ignoreRangeIndex) return;
    var cellrange = getcellrange(ctx, ele.textContent || "");
    if (rangeIndex === ctx.formulaCache.selectingRangeIndex || cellrange == null) return;

    if (cellrange.sheetId === ctx.currentSheetId || cellrange.sheetId === -1 && ctx.formulaCache.rangetosheet === ctx.currentSheetId) {
      var rect = seletedHighlistByindex(ctx, cellrange.row[0], cellrange.row[1], cellrange.column[0], cellrange.column[1]);

      if (rect) {
        formulaRanges.push(_objectSpread2(_objectSpread2({
          rangeIndex: rangeIndex
        }, rect), {}, {
          backgroundColor: colors[rangeIndex]
        }));
      }
    }
  });
  ctx.formulaRangeHighlight = formulaRanges;
}
function setCaretPosition(ctx, textDom, children, pos) {
  try {
    var el = textDom;
    var range = document.createRange();
    var sel = window.getSelection();
    range.setStart(el.childNodes[children], pos);
    range.collapse(true);
    sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
    sel === null || sel === void 0 ? void 0 : sel.addRange(range);
    el.focus();
  } catch (err) {
    console.error(err);
    moveToEnd(ctx.formulaCache.rangeResizeTo[0]);
  }
}

function functionRange(ctx, obj, v, vp) {
  if (window.getSelection) {
    var currSelection = window.getSelection();
    if (!currSelection) return;
    var fri = findrangeindex(ctx, v, vp);

    if (_.isNil(fri)) {
      currSelection.selectAllChildren(obj);
      currSelection.collapseToEnd();
    } else {
      setCaretPosition(ctx, obj.querySelectorAll("span")[fri[0]], 0, fri[1]);
    }
  } else if (document.selection) {
    ctx.formulaCache.functionRangeIndex.moveToElementText(obj);
    ctx.formulaCache.functionRangeIndex.collapse(false);
    ctx.formulaCache.functionRangeIndex.select();
  }
}

function searchFunction(ctx, searchtxt) {
  var _locale = locale(ctx),
      functionlist = _locale.functionlist;

  var f = [];
  var s = [];
  var t = [];
  var result_i = 0;

  for (var _i17 = 0; _i17 < functionlist.length; _i17 += 1) {
    var item = functionlist[_i17];
    var n = item.n;

    if (n === searchtxt) {
      f.unshift(item);
      result_i += 1;
    } else if (_.startsWith(n, searchtxt)) {
      s.unshift(item);
      result_i += 1;
    } else if (n.indexOf(searchtxt) > -1) {
      t.unshift(item);
      result_i += 1;
    }

    if (result_i >= 10) {
      break;
    }
  }

  var list = [].concat(f, s, t);

  if (list.length <= 0) {
    return;
  }

  ctx.functionCandidates = list;
}

function getrangeseleciton() {
  var _anchorNode$parentNod, _anchorNode$parentNod2, _anchorNode$parentEle, _anchorNode$parentEle2;

  var currSelection = window.getSelection();
  if (!currSelection) return null;
  var anchorNode = currSelection.anchorNode,
      anchorOffset = currSelection.anchorOffset;
  if (!anchorNode) return null;

  if (((_anchorNode$parentNod = anchorNode.parentNode) === null || _anchorNode$parentNod === void 0 ? void 0 : (_anchorNode$parentNod2 = _anchorNode$parentNod.nodeName) === null || _anchorNode$parentNod2 === void 0 ? void 0 : _anchorNode$parentNod2.toLowerCase()) === "span" && anchorOffset !== 0) {
    var txt = _.trim(anchorNode.textContent || "");

    if (txt.length === 0 && anchorNode.parentNode.previousSibling) {
      var ahr = anchorNode.parentNode.previousSibling;
      txt = _.trim(ahr.textContent || "");
      return ahr;
    }

    return anchorNode.parentNode;
  }

  var anchorElement = anchorNode;

  if (anchorElement.id === "luckysheet-rich-text-editor" || anchorElement.id === "luckysheet-functionbox-cell") {
    var _$last;

    var _txt = _.trim((_$last = _.last(anchorElement.querySelectorAll("span"))) === null || _$last === void 0 ? void 0 : _$last.innerText);

    if (_txt.length === 0 && anchorElement.querySelectorAll("span").length > 1) {
      var _ahr = anchorElement.querySelectorAll("span");

      _txt = _.trim(_ahr[_ahr.length - 2].innerText);
      return _ahr === null || _ahr === void 0 ? void 0 : _ahr[0];
    }

    return _.last(anchorElement.querySelectorAll("span"));
  }

  if ((anchorNode === null || anchorNode === void 0 ? void 0 : (_anchorNode$parentEle = anchorNode.parentElement) === null || _anchorNode$parentEle === void 0 ? void 0 : _anchorNode$parentEle.id) === "luckysheet-rich-text-editor" || (anchorNode === null || anchorNode === void 0 ? void 0 : (_anchorNode$parentEle2 = anchorNode.parentElement) === null || _anchorNode$parentEle2 === void 0 ? void 0 : _anchorNode$parentEle2.id) === "luckysheet-functionbox-cell" || anchorOffset === 0) {
    var newAnchorNode = anchorOffset === 0 ? anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.parentNode : anchorNode;

    if (newAnchorNode === null || newAnchorNode === void 0 ? void 0 : newAnchorNode.previousSibling) {
      return newAnchorNode === null || newAnchorNode === void 0 ? void 0 : newAnchorNode.previousSibling;
    }
  }

  return null;
}

function helpFunctionExe($editer, currSelection, ctx) {
  var _currSelection$parent;

  var _locale2 = locale(ctx),
      functionlist = _locale2.functionlist;

  if (_.isEmpty(ctx.formulaCache.functionlistMap)) {
    for (var _i18 = 0; _i18 < functionlist.length; _i18 += 1) {
      ctx.formulaCache.functionlistMap[functionlist[_i18].n] = functionlist[_i18];
    }
  }

  if (!currSelection) {
    return null;
  }

  var $prev = currSelection;
  var $span = $editer.querySelectorAll("span");

  var currentIndex = _.indexOf((_currSelection$parent = currSelection.parentNode) === null || _currSelection$parent === void 0 ? void 0 : _currSelection$parent.childNodes, currSelection);

  var i = currentIndex;

  if ($prev == null) {
    return null;
  }

  var funcName = null;

  if ($span[i].classList.contains("luckysheet-formula-text-func")) {
    funcName = $span[i].textContent;
  } else {
    var $cur = null;
    var exceptIndex = [-1, -1];

    while (--i > 0) {
      $cur = $span[i];

      if ($cur.classList.contains("luckysheet-formula-text-func") || _.trim($cur.textContent || "").toUpperCase() in ctx.formulaCache.functionlistMap) {
        funcName = $cur.textContent;
        var endstate = true;

        for (var a = i; a <= currentIndex; a += 1) {

          if (a >= exceptIndex[0] && a <= exceptIndex[1]) {
            continue;
          }

          $cur = $span[a];

          if ($cur.classList.contains("luckysheet-formula-text-rpar")) {
            exceptIndex = [i, a];
            funcName = null;
            endstate = false;
            break;
          }

          if ($cur.classList.contains("luckysheet-formula-text-comma")) ;
        }

        if (endstate) {
          break;
        }
      }
    }
  }

  return funcName;
}

function rangeHightlightselected(ctx, $editor) {
  var currSelection = getrangeseleciton();
  if (!currSelection) return;

  var currText = _.trim(currSelection.textContent || "");

  if (currText === null || currText === void 0 ? void 0 : currText.match(/^[a-zA-Z_]+$/)) {
    searchFunction(ctx, currText.toUpperCase());
    ctx.functionHint = null;
  } else {
    var funcName = helpFunctionExe($editor, currSelection, ctx);
    ctx.functionHint = funcName === null || funcName === void 0 ? void 0 : funcName.toUpperCase();
    ctx.functionCandidates = [];
  }
}

function functionHTML(txt) {
  if (txt.substr(0, 1) === "=") {
    txt = txt.substr(1);
  }

  var funcstack = txt.split("");
  var i = 0;
  var str = "";
  var function_str = "";
  var matchConfig = {
    bracket: 0,
    comma: 0,
    squote: 0,
    dquote: 0,
    braces: 0
  };

  while (i < funcstack.length) {
    var s = funcstack[i];

    if (s === "(" && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      matchConfig.bracket += 1;

      if (str.length > 0) {
        function_str += "<span dir=\"auto\" class=\"luckysheet-formula-text-func\">".concat(str, "</span><span dir=\"auto\" class=\"luckysheet-formula-text-lpar\">(</span>");
      } else {
        function_str += '<span dir="auto" class="luckysheet-formula-text-lpar">(</span>';
      }

      str = "";
    } else if (s === ")" && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      matchConfig.bracket -= 1;
      function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-rpar\">)</span>");
      str = "";
    } else if (s === "{" && matchConfig.squote === 0 && matchConfig.dquote === 0) {
      str += "{";
      matchConfig.braces += 1;
    } else if (s === "}" && matchConfig.squote === 0 && matchConfig.dquote === 0) {
      str += "}";
      matchConfig.braces -= 1;
    } else if (s === '"' && matchConfig.squote === 0) {
      if (matchConfig.dquote > 0) {
        if (str.length > 0) {
          function_str += "".concat(str, "\"</span>");
        } else {
          function_str += '"</span>';
        }

        matchConfig.dquote -= 1;
        str = "";
      } else {
        matchConfig.dquote += 1;

        if (str.length > 0) {
          function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-string\">\"");
        } else {
          function_str += '<span dir="auto" class="luckysheet-formula-text-string">"';
        }

        str = "";
      }
    } else if (s === "'" && matchConfig.dquote === 0) {
      str += "'";
      matchConfig.squote = matchConfig.squote === 0 ? 1 : 0;
    } else if (s === "," && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-comma\">,</span>");
      str = "";
    } else if (s === "&" && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      if (str.length > 0) {
        function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">") + "&" + "</span>";
        str = "";
      } else {
        function_str += '<span dir="auto" class="luckysheet-formula-text-calc">' + "&" + "</span>";
      }
    } else if (s in operatorjson && matchConfig.squote === 0 && matchConfig.dquote === 0 && matchConfig.braces === 0) {
      var s_next = "";

      if (i + 1 < funcstack.length) {
        s_next = funcstack[i + 1];
      }

      var p = i - 1;
      var s_pre = null;

      if (p >= 0) {
        do {
          s_pre = funcstack[p];
          p -= 1;
        } while (p >= 0 && s_pre === " ");
      }

      if (s + s_next in operatorjson) {
        if (str.length > 0) {
          function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">").concat(s).concat(s_next, "</span>");
          str = "";
        } else {
          function_str += "<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">".concat(s).concat(s_next, "</span>");
        }

        i += 1;
      } else if (!/[^0-9]/.test(s_next) && s === "-" && (s_pre === "(" || _.isNil(s_pre) || s_pre === "," || s_pre === " " || s_pre in operatorjson)) {
        str += s;
      } else {
        if (str.length > 0) {
          function_str += "".concat(functionHTML(str), "<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">").concat(s, "</span>");
          str = "";
        } else {
          function_str += "<span dir=\"auto\" class=\"luckysheet-formula-text-calc\">".concat(s, "</span>");
        }
      }
    } else {
      str += s;
    }

    if (i === funcstack.length - 1) {
      if (iscelldata(_.trim(str))) {
        var rangeIndex = rangeIndexes.length > functionHTMLIndex ? rangeIndexes[functionHTMLIndex] : functionHTMLIndex;
        function_str += "<span class=\"fortune-formula-functionrange-cell\" rangeindex=\"".concat(rangeIndex, "\" dir=\"auto\" style=\"color:").concat(colors[rangeIndex], ";\">").concat(str, "</span>");
        functionHTMLIndex += 1;
      } else if (matchConfig.dquote > 0) {
        function_str += "".concat(str, "</span>");
      } else if (str.indexOf("</span>") === -1 && str.length > 0) {
        var regx = /{.*?}/;

        if (regx.test(_.trim(str))) {
          var arraytxt = regx.exec(str)[0];
          var arraystart = str.search(regx);
          var alltxt = "";

          if (arraystart > 0) {
            alltxt += "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str.substr(0, arraystart), "</span>");
          }

          alltxt += "<span dir=\"auto\" style=\"color:#959a05\" class=\"luckysheet-formula-text-array\">".concat(arraytxt, "</span>");

          if (arraystart + arraytxt.length < str.length) {
            alltxt += "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str.substr(arraystart + arraytxt.length, str.length), "</span>");
          }

          function_str += alltxt;
        } else {
          function_str += "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(str, "</span>");
        }
      }
    }

    i += 1;
  }

  return function_str;
}

function functionHTMLGenerate(txt) {
  if (txt.length === 0 || txt.substring(0, 1) !== "=") {
    return txt;
  }

  functionHTMLIndex = 0;
  return "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span>".concat(functionHTML(txt));
}

function getRangeIndexes($editor) {
  var res = [];
  $editor.querySelectorAll("span.fortune-formula-functionrange-cell").forEach(function (ele) {
    var indexStr = ele.getAttribute("rangeindex");

    if (indexStr) {
      var rangeIndex = parseInt(indexStr, 10);
      res.push(rangeIndex);
    }
  });
  return res;
}

function handleFormulaInput(ctx, $copyTo, $editor, kcode, preText) {
  var refreshRangeSelect = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var value1;
  var value1txt = preText !== null && preText !== void 0 ? preText : $editor.innerText;
  var value = $editor.innerText;
  value = escapeScriptTag(value);

  if (value.length > 0 && value.substring(0, 1) === "=" && (kcode !== 229 || value.length === 1)) {
    if (!refreshRangeSelect) rangeIndexes = getRangeIndexes($editor);
    value = functionHTMLGenerate(value);
    if (!refreshRangeSelect && functionHTMLIndex < rangeIndexes.length) refreshRangeSelect = true;
    value1 = functionHTMLGenerate(value1txt);
    rangeIndexes = [];

    if (window.getSelection) {
      var _currSelection$anchor;

      var currSelection = window.getSelection();
      if (!currSelection) return;

      if (((_currSelection$anchor = currSelection.anchorNode) === null || _currSelection$anchor === void 0 ? void 0 : _currSelection$anchor.nodeName.toLowerCase()) === "div") {
        var _$editor$querySelecto;

        var editorlen = $editor.querySelectorAll("span").length;
        if (editorlen > 0) ctx.formulaCache.functionRangeIndex = [editorlen - 1, (_$editor$querySelecto = $editor.querySelectorAll("span").item(editorlen - 1).textContent) === null || _$editor$querySelecto === void 0 ? void 0 : _$editor$querySelecto.length];
      } else {
        var _currSelection$anchor2, _currSelection$anchor3, _currSelection$anchor4, _currSelection$anchor5;

        ctx.formulaCache.functionRangeIndex = [_.indexOf((_currSelection$anchor2 = currSelection.anchorNode) === null || _currSelection$anchor2 === void 0 ? void 0 : (_currSelection$anchor3 = _currSelection$anchor2.parentNode) === null || _currSelection$anchor3 === void 0 ? void 0 : (_currSelection$anchor4 = _currSelection$anchor3.parentNode) === null || _currSelection$anchor4 === void 0 ? void 0 : _currSelection$anchor4.childNodes, (_currSelection$anchor5 = currSelection.anchorNode) === null || _currSelection$anchor5 === void 0 ? void 0 : _currSelection$anchor5.parentNode), currSelection.anchorOffset];
      }
    } else {
      var textRange = document.selection.createRange();
      ctx.formulaCache.functionRangeIndex = textRange;
    }

    $editor.innerHTML = value;
    if ($copyTo) $copyTo.innerHTML = value;
    functionRange(ctx, $editor, value, value1);

    if (refreshRangeSelect) {
      cancelFunctionrangeSelected(ctx);

      if (kcode !== 46) {
        createRangeHightlight(ctx, value);
      }

      ctx.formulaCache.rangestart = false;
      ctx.formulaCache.rangedrag_column_start = false;
      ctx.formulaCache.rangedrag_row_start = false;
      rangeHightlightselected(ctx, $editor);
    }
  } else if (_.startsWith(value1txt, "=") && !_.startsWith(value, "=")) {
    if ($copyTo) $copyTo.innerHTML = value;
    $editor.innerHTML = escapeHTMLTag(value);
  } else if (!_.startsWith(value1txt, "=")) {
    if (!$copyTo) return;

    if ($copyTo.id === "luckysheet-rich-text-editor") {
      if (!_.startsWith($copyTo.innerHTML, "<span")) {
        $copyTo.innerHTML = escapeHTMLTag(value);
      }
    } else {
      $copyTo.innerHTML = escapeHTMLTag(value);
    }
  }
}

function isfreezonFuc(txt) {
  var row = txt.replace(/[^0-9]/g, "");
  var col = txt.replace(/[^A-Za-z]/g, "");
  var row$ = txt.substr(txt.indexOf(row) - 1, 1);
  var col$ = txt.substr(txt.indexOf(col) - 1, 1);
  var ret = [false, false];

  if (row$ === "$") {
    ret[0] = true;
  }

  if (col$ === "$") {
    ret[1] = true;
  }

  return ret;
}

function functionStrChange_range(txt, type, rc, orient, stindex, step) {
  var val = txt.split("!");
  var rangetxt;
  var prefix = "";

  if (val.length > 1) {
    var _val3 = _slicedToArray(val, 2);

    rangetxt = _val3[1];
    prefix = "".concat(val[0], "!");
  } else {
    var _val4 = _slicedToArray(val, 1);

    rangetxt = _val4[0];
  }

  var r1;
  var r2;
  var c1;
  var c2;
  var $row0;
  var $row1;
  var $col0;
  var $col1;

  if (rangetxt.indexOf(":") === -1) {
    r1 = parseInt(rangetxt.replace(/[^0-9]/g, ""), 10) - 1;
    r2 = r1;
    c1 = columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g, ""));
    c2 = c1;
    var freezonFuc = isfreezonFuc(rangetxt);
    $row0 = freezonFuc[0] ? "$" : "";
    $row1 = $row0;
    $col0 = freezonFuc[1] ? "$" : "";
    $col1 = $col0;
  } else {
    rangetxt = rangetxt.split(":");
    r1 = parseInt(rangetxt[0].replace(/[^0-9]/g, ""), 10) - 1;
    r2 = parseInt(rangetxt[1].replace(/[^0-9]/g, ""), 10) - 1;

    if (r1 > r2) {
      return txt;
    }

    c1 = columnCharToIndex(rangetxt[0].replace(/[^A-Za-z]/g, ""));
    c2 = columnCharToIndex(rangetxt[1].replace(/[^A-Za-z]/g, ""));

    if (c1 > c2) {
      return txt;
    }

    var freezonFuc0 = isfreezonFuc(rangetxt[0]);
    $row0 = freezonFuc0[0] ? "$" : "";
    $col0 = freezonFuc0[1] ? "$" : "";
    var freezonFuc1 = isfreezonFuc(rangetxt[1]);
    $row1 = freezonFuc1[0] ? "$" : "";
    $col1 = freezonFuc1[1] ? "$" : "";
  }

  if (type === "del") {
    if (rc === "row") {
      if (r1 >= stindex && r2 <= stindex + step - 1) {
        return error.r;
      }

      if (r1 > stindex + step - 1) {
        r1 -= step;
      } else if (r1 >= stindex) {
        r1 = stindex;
      }

      if (r2 > stindex + step - 1) {
        r2 -= step;
      } else if (r2 >= stindex) {
        r2 = stindex - 1;
      }

      if (r1 < 0) {
        r1 = 0;
      }

      if (r2 < r1) {
        r2 = r1;
      }
    } else if (rc === "col") {
      if (c1 >= stindex && c2 <= stindex + step - 1) {
        return error.r;
      }

      if (c1 > stindex + step - 1) {
        c1 -= step;
      } else if (c1 >= stindex) {
        c1 = stindex;
      }

      if (c2 > stindex + step - 1) {
        c2 -= step;
      } else if (c2 >= stindex) {
        c2 = stindex - 1;
      }

      if (c1 < 0) {
        c1 = 0;
      }

      if (c2 < c1) {
        c2 = c1;
      }
    }

    if (r1 === r2 && c1 === c2) {
      if (!Number.isNaN(r1) && !Number.isNaN(c1)) {
        return prefix + $col0 + indexToColumnChar(c1) + $row0 + (r1 + 1);
      }

      if (!Number.isNaN(r1)) {
        return prefix + $row0 + (r1 + 1);
      }

      if (!Number.isNaN(c1)) {
        return prefix + $col0 + indexToColumnChar(c1);
      }

      return txt;
    }

    if (Number.isNaN(c1) && Number.isNaN(c2)) {
      return "".concat(prefix + $row0 + (r1 + 1), ":").concat($row1).concat(r2 + 1);
    }

    if (Number.isNaN(r1) && Number.isNaN(r2)) {
      return "".concat(prefix + $col0 + indexToColumnChar(c1), ":").concat($col1).concat(indexToColumnChar(c2));
    }

    return "".concat(prefix + $col0 + indexToColumnChar(c1) + $row0 + (r1 + 1), ":").concat($col1).concat(indexToColumnChar(c2)).concat($row1).concat(r2 + 1);
  }

  if (type === "add") {
    if (rc === "row") {
      if (orient === "lefttop") {
        if (r1 >= stindex) {
          r1 += step;
        }

        if (r2 >= stindex) {
          r2 += step;
        }
      } else if (orient === "rightbottom") {
        if (r1 > stindex) {
          r1 += step;
        }

        if (r2 > stindex) {
          r2 += step;
        }
      }
    } else if (rc === "col") {
      if (orient === "lefttop") {
        if (c1 >= stindex) {
          c1 += step;
        }

        if (c2 >= stindex) {
          c2 += step;
        }
      } else if (orient === "rightbottom") {
        if (c1 > stindex) {
          c1 += step;
        }

        if (c2 > stindex) {
          c2 += step;
        }
      }
    }

    if (r1 === r2 && c1 === c2) {
      if (!Number.isNaN(r1) && !Number.isNaN(c1)) {
        return prefix + $col0 + indexToColumnChar(c1) + $row0 + (r1 + 1);
      }

      if (!Number.isNaN(r1)) {
        return prefix + $row0 + (r1 + 1);
      }

      if (!Number.isNaN(c1)) {
        return prefix + $col0 + indexToColumnChar(c1);
      }

      return txt;
    }

    if (Number.isNaN(c1) && Number.isNaN(c2)) {
      return "".concat(prefix + $row0 + (r1 + 1), ":").concat($row1).concat(r2 + 1);
    }

    if (Number.isNaN(r1) && Number.isNaN(r2)) {
      return "".concat(prefix + $col0 + indexToColumnChar(c1), ":").concat($col1).concat(indexToColumnChar(c2));
    }

    return "".concat(prefix + $col0 + indexToColumnChar(c1) + $row0 + (r1 + 1), ":").concat($col1).concat(indexToColumnChar(c2)).concat($row1).concat(r2 + 1);
  }

  return "";
}

function israngeseleciton(ctx, istooltip) {
  var _anchor, _anchor2, _anchor2$parentNode;

  if (istooltip == null) {
    istooltip = false;
  }

  var currSelection = window.getSelection();
  if (currSelection == null) return false;
  var anchor = currSelection.anchorNode;
  if (!((_anchor = anchor) === null || _anchor === void 0 ? void 0 : _anchor.textContent)) return false;
  var anchorOffset = currSelection.anchorOffset;
  var anchorElement = anchor;
  var parentElement = anchor.parentNode;

  if (((_anchor2 = anchor) === null || _anchor2 === void 0 ? void 0 : (_anchor2$parentNode = _anchor2.parentNode) === null || _anchor2$parentNode === void 0 ? void 0 : _anchor2$parentNode.nodeName.toLowerCase()) === "span" && anchorOffset !== 0) {
    var txt = _.trim(anchor.textContent);

    var lasttxt = "";

    if (txt.length === 0 && anchor.parentNode.previousSibling) {
      var ahr = anchor.parentNode.previousSibling;
      txt = _.trim(ahr.textContent || "");
      lasttxt = txt.substring(txt.length - 1, 1);
      ctx.formulaCache.rangeSetValueTo = anchor.parentNode;
    } else {
      lasttxt = txt.substring(anchorOffset - 1, 1);
      ctx.formulaCache.rangeSetValueTo = anchor.parentNode;
    }

    if (istooltip && (lasttxt === "(" || lasttxt === ",") || !istooltip && (lasttxt === "(" || lasttxt === "," || lasttxt === "=" || lasttxt in operatorjson || lasttxt === "&")) {
      return true;
    }
  } else if (anchorElement.id === "luckysheet-rich-text-editor" || anchorElement.id === "luckysheet-functionbox-cell") {
    var _$last2;

    var _txt2 = _.trim((_$last2 = _.last(anchorElement.querySelectorAll("span"))) === null || _$last2 === void 0 ? void 0 : _$last2.innerText);

    ctx.formulaCache.rangeSetValueTo = _.last(anchorElement.querySelectorAll("span"));

    if (_txt2.length === 0 && anchorElement.querySelectorAll("span").length > 1) {
      var _ahr2 = anchorElement.querySelectorAll("span");

      _txt2 = _.trim(_ahr2[_ahr2.length - 2].innerText);
      _txt2 = _.trim(_ahr2[_ahr2.length - 2].innerText);
      ctx.formulaCache.rangeSetValueTo = _ahr2;
    }

    var _lasttxt = _txt2.substring(_txt2.length - 1, 1);

    if (istooltip && (_lasttxt === "(" || _lasttxt === ",") || !istooltip && (_lasttxt === "(" || _lasttxt === "," || _lasttxt === "=" || _lasttxt in operatorjson || _lasttxt === "&")) {
      return true;
    }
  } else if (parentElement.id === "luckysheet-rich-text-editor" || parentElement.id === "luckysheet-functionbox-cell" || anchorOffset === 0) {
    var _anchor$previousSibli;

    if (anchorOffset === 0) {
      anchor = anchor.parentNode;
    }

    if (!anchor) return false;
    if (((_anchor$previousSibli = anchor.previousSibling) === null || _anchor$previousSibli === void 0 ? void 0 : _anchor$previousSibli.textContent) == null) return false;

    if (anchor.previousSibling) {
      var _txt3 = _.trim(anchor.previousSibling.textContent);

      var _lasttxt2 = _txt3.substring(_txt3.length - 1, 1);

      ctx.formulaCache.rangeSetValueTo = anchor.previousSibling;

      if (istooltip && (_lasttxt2 === "(" || _lasttxt2 === ",") || !istooltip && (_lasttxt2 === "(" || _lasttxt2 === "," || _lasttxt2 === "=" || _lasttxt2 in operatorjson || _lasttxt2 === "&")) {
        return true;
      }
    }
  }

  return false;
}
function functionStrChange(txt, type, rc, orient, stindex, step) {
  if (!txt) {
    return "";
  }

  if (txt.substring(0, 1) === "=") {
    txt = txt.substring(1);
  }

  var funcstack = txt.split("");
  var i = 0;
  var str = "";
  var function_str = "";
  var matchConfig = {
    bracket: 0,
    comma: 0,
    squote: 0,
    dquote: 0
  };

  while (i < funcstack.length) {
    var s = funcstack[i];

    if (s === "(" && matchConfig.dquote === 0) {
      matchConfig.bracket += 1;

      if (str.length > 0) {
        function_str += "".concat(str, "(");
      } else {
        function_str += "(";
      }

      str = "";
    } else if (s === ")" && matchConfig.dquote === 0) {
      matchConfig.bracket -= 1;
      function_str += "".concat(functionStrChange(str, type, rc, orient, stindex, step), ")");
      str = "";
    } else if (s === '"' && matchConfig.squote === 0) {
      if (matchConfig.dquote > 0) {
        function_str += "".concat(str, "\"");
        matchConfig.dquote -= 1;
        str = "";
      } else {
        matchConfig.dquote += 1;
        str += '"';
      }
    } else if (s === "," && matchConfig.dquote === 0) {
      function_str += "".concat(functionStrChange(str, type, rc, orient, stindex, step), ",");
      str = "";
    } else if (s === "&" && matchConfig.dquote === 0) {
      if (str.length > 0) {
        function_str += "".concat(functionStrChange(str, type, rc, orient, stindex, step), "&");
        str = "";
      } else {
        function_str += "&";
      }
    } else if (s in operatorjson && matchConfig.dquote === 0) {
      var s_next = "";

      if (i + 1 < funcstack.length) {
        s_next = funcstack[i + 1];
      }

      var p = i - 1;
      var s_pre = null;

      if (p >= 0) {
        do {
          s_pre = funcstack[p -= 1];
        } while (p >= 0 && s_pre === " ");
      }

      if (s + s_next in operatorjson) {
        if (str.length > 0) {
          function_str += functionStrChange(str, type, rc, orient, stindex, step) + s + s_next;
          str = "";
        } else {
          function_str += s + s_next;
        }

        i += 1;
      } else if (!/[^0-9]/.test(s_next) && s === "-" && (s_pre === "(" || s_pre == null || s_pre === "," || s_pre === " " || s_pre in operatorjson)) {
        str += s;
      } else {
        if (str.length > 0) {
          function_str += functionStrChange(str, type, rc, orient, stindex, step) + s;
          str = "";
        } else {
          function_str += s;
        }
      }
    } else {
      str += s;
    }

    if (i === funcstack.length - 1) {
      if (iscelldata(_.trim(str))) {
        function_str += functionStrChange_range(_.trim(str), type, rc, orient, stindex, step);
      } else {
        function_str += _.trim(str);
      }
    }

    i += 1;
  }

  return function_str;
}
function rangeSetValue(ctx, cellInput, selected, fxInput) {
  var _document$activeEleme;

  var $editor = cellInput;
  var $copyTo = fxInput;

  if (((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.id) === "luckysheet-functionbox-cell") {
    $editor = fxInput;
    $copyTo = cellInput;
  }

  var range = "";
  var rf = selected.row[0];
  var cf = selected.column[0];

  if (ctx.config.merge != null && "".concat(rf, "_").concat(cf) in ctx.config.merge) {
    range = getRangetxt(ctx, ctx.currentSheetId, {
      column: [cf, cf],
      row: [rf, rf]
    }, ctx.formulaCache.rangetosheet);
  } else {
    range = getRangetxt(ctx, ctx.currentSheetId, selected, ctx.formulaCache.rangetosheet);
  }

  if (!israngeseleciton(ctx) && (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start)) {
    var span = $editor.querySelector("span[rangeindex='".concat(ctx.formulaCache.rangechangeindex, "']"));

    if (span) {
      span.innerHTML = range;
      setCaretPosition(ctx, span, 0, range.length);
    }
  } else {
    var function_str = "<span class=\"fortune-formula-functionrange-cell\" rangeindex=\"".concat(functionHTMLIndex, "\" dir=\"auto\" style=\"color:").concat(colors[functionHTMLIndex], ";\">").concat(range, "</span>");
    var newEle = parseElement(function_str);
    var refEle = ctx.formulaCache.rangeSetValueTo;

    if (refEle && refEle.parentNode) {
      var _document$getElements, _leftPar$parentElemen;

      var leftPar = (_document$getElements = document.getElementsByClassName("luckysheet-formula-text-lpar")) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];

      if (leftPar === null || leftPar === void 0 ? void 0 : (_leftPar$parentElemen = leftPar.parentElement) === null || _leftPar$parentElemen === void 0 ? void 0 : _leftPar$parentElemen.classList.contains("luckysheet-formula-text-color")) {
        var _document$getElements2, _document$getElements3;

        (_document$getElements2 = document.getElementsByClassName("luckysheet-formula-text-lpar")) === null || _document$getElements2 === void 0 ? void 0 : (_document$getElements3 = _document$getElements2[0].parentNode) === null || _document$getElements3 === void 0 ? void 0 : _document$getElements3.appendChild(newEle);
      } else {
        refEle.parentNode.insertBefore(newEle, refEle.nextSibling);
      }
    } else {
      $editor.appendChild(newEle);
    }

    ctx.formulaCache.rangechangeindex = functionHTMLIndex;

    var _span = $editor.querySelector("span[rangeindex='".concat(ctx.formulaCache.rangechangeindex, "']"));

    setCaretPosition(ctx, _span, 0, range.length);
    functionHTMLIndex += 1;
  }

  if ($copyTo) $copyTo.innerHTML = $editor.innerHTML;
}
function onFormulaRangeDragEnd(ctx) {
  if (ctx.formulaCache.func_selectedrange) {
    var _ctx$formulaCache$fun = ctx.formulaCache.func_selectedrange,
        left = _ctx$formulaCache$fun.left_move,
        top = _ctx$formulaCache$fun.top_move,
        width = _ctx$formulaCache$fun.width_move,
        height = _ctx$formulaCache$fun.height_move;
    if (left != null && top != null && width != null && height != null && (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start)) ctx.formulaRangeSelect = {
      rangeIndex: ctx.formulaCache.rangeIndex || 0,
      left: left,
      top: top,
      width: width,
      height: height
    };
  }

  ctx.formulaCache.selectingRangeIndex = -1;
}

function setRangeSelect(container, left, top, height, width) {
  var rangeElement = container.querySelector(".fortune-formula-functionrange-select");
  if (rangeElement == null) return;
  rangeElement.style.left = "".concat(left, "px");
  rangeElement.style.top = "".concat(top, "px");
  rangeElement.style.height = "".concat(height, "px");
  rangeElement.style.width = "".concat(width, "px");
}

function rangeDrag(ctx, e, cellInput, scrollLeft, scrollTop, container, fxInput) {
  var func_selectedrange = ctx.formulaCache.func_selectedrange;
  if (!func_selectedrange || func_selectedrange.left == null || func_selectedrange.height == null || func_selectedrange.top == null || func_selectedrange.width == null) return;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollLeft;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollTop;

  var _rowLocation = rowLocation(y, ctx.visibledatarow),
      _rowLocation2 = _slicedToArray(_rowLocation, 3),
      row_pre = _rowLocation2[0],
      row = _rowLocation2[1],
      row_index = _rowLocation2[2];

  var _colLocation = colLocation(x, ctx.visibledatacolumn),
      _colLocation2 = _slicedToArray(_colLocation, 3),
      col_pre = _colLocation2[0],
      col = _colLocation2[1],
      col_index = _colLocation2[2];

  var top = 0;
  var height = 0;
  var rowseleted = [];

  if (func_selectedrange.top > row_pre) {
    top = row_pre;
    height = func_selectedrange.top + func_selectedrange.height - row_pre;
    rowseleted = [row_index, func_selectedrange.row[1]];
  } else if (func_selectedrange.top === row_pre) {
    top = row_pre;
    height = func_selectedrange.top + func_selectedrange.height - row_pre;
    rowseleted = [row_index, func_selectedrange.row[0]];
  } else {
    top = func_selectedrange.top;
    height = row - func_selectedrange.top - 1;
    rowseleted = [func_selectedrange.row[0], row_index];
  }

  var left = 0;
  var width = 0;
  var columnseleted = [];

  if (func_selectedrange.left > col_pre) {
    left = col_pre;
    width = func_selectedrange.left + func_selectedrange.width - col_pre;
    columnseleted = [col_index, func_selectedrange.column[1]];
  } else if (func_selectedrange.left === col_pre) {
    left = col_pre;
    width = func_selectedrange.left + func_selectedrange.width - col_pre;
    columnseleted = [col_index, func_selectedrange.column[0]];
  } else {
    left = func_selectedrange.left;
    width = col - func_selectedrange.left - 1;
    columnseleted = [func_selectedrange.column[0], col_index];
  }

  var changeparam = mergeMoveMain(ctx, columnseleted, rowseleted, func_selectedrange, top, height, left, width);

  if (changeparam != null) {
    var _changeparam = _slicedToArray(changeparam, 6);

    columnseleted = _changeparam[0];
    rowseleted = _changeparam[1];
    top = _changeparam[2];
    height = _changeparam[3];
    left = _changeparam[4];
    width = _changeparam[5];
  }

  func_selectedrange.row = rowseleted;
  func_selectedrange.column = columnseleted;
  func_selectedrange.left_move = left;
  func_selectedrange.width_move = width;
  func_selectedrange.top_move = top;
  func_selectedrange.height_move = height;
  rangeSetValue(ctx, cellInput, {
    row: rowseleted,
    column: columnseleted
  }, fxInput);
  setRangeSelect(container, left, top, height, width);
  e.preventDefault();
}
function rangeDragColumn(ctx, e, cellInput, scrollLeft, scrollTop, container, fxInput) {
  var func_selectedrange = ctx.formulaCache.func_selectedrange;
  if (!func_selectedrange || func_selectedrange.left == null || func_selectedrange.height == null || func_selectedrange.top == null || func_selectedrange.width == null) return;
  var mouse = mousePosition(e.pageX, e.pageY, ctx);
  var x = mouse[0] + scrollLeft;
  var visibledatarow = ctx.visibledatarow;
  var row_index = visibledatarow.length - 1;
  var row = visibledatarow[row_index];
  var row_pre = 0;

  var _colLocation3 = colLocation(x, ctx.visibledatacolumn),
      _colLocation4 = _slicedToArray(_colLocation3, 3),
      col_pre = _colLocation4[0],
      col = _colLocation4[1],
      col_index = _colLocation4[2];

  var left = 0;
  var width = 0;
  var columnseleted = [];

  if (func_selectedrange.left > col_pre) {
    left = col_pre;
    width = func_selectedrange.left + func_selectedrange.width - col_pre;
    columnseleted = [col_index, func_selectedrange.column[1]];
  } else if (func_selectedrange.left === col_pre) {
    left = col_pre;
    width = func_selectedrange.left + func_selectedrange.width - col_pre;
    columnseleted = [col_index, func_selectedrange.column[0]];
  } else {
    left = func_selectedrange.left;
    width = col - func_selectedrange.left - 1;
    columnseleted = [func_selectedrange.column[0], col_index];
  }

  var changeparam = mergeMoveMain(ctx, columnseleted, [0, row_index], func_selectedrange, row_pre, row - row_pre - 1, left, width);

  if (changeparam != null) {
    var _changeparam2 = _slicedToArray(changeparam, 6);

    columnseleted = _changeparam2[0];
    left = _changeparam2[4];
    width = _changeparam2[5];
  }

  func_selectedrange.column = columnseleted;
  func_selectedrange.left_move = left;
  func_selectedrange.width_move = width;
  rangeSetValue(ctx, cellInput, {
    row: [null, null],
    column: columnseleted
  }, fxInput);
  setRangeSelect(container, left, row_pre, row - row_pre - 1, width);
}
function rangeDragRow(ctx, e, cellInput, scrollLeft, scrollTop, container, fxInput) {
  var func_selectedrange = ctx.formulaCache.func_selectedrange;
  if (!func_selectedrange || func_selectedrange.left == null || func_selectedrange.height == null || func_selectedrange.top == null || func_selectedrange.width == null) return;
  var mouse = mousePosition(e.pageX, e.pageY, ctx);
  var y = mouse[1] + scrollTop;

  var _rowLocation3 = rowLocation(y, ctx.visibledatarow),
      _rowLocation4 = _slicedToArray(_rowLocation3, 3),
      row_pre = _rowLocation4[0],
      row = _rowLocation4[1],
      row_index = _rowLocation4[2];

  var visibledatacolumn = ctx.visibledatacolumn;
  var col_index = visibledatacolumn.length - 1;
  var col = visibledatacolumn[col_index];
  var col_pre = 0;
  var top = 0;
  var height = 0;
  var rowseleted = [];

  if (func_selectedrange.top > row_pre) {
    top = row_pre;
    height = func_selectedrange.top + func_selectedrange.height - row_pre;
    rowseleted = [row_index, func_selectedrange.row[1]];
  } else if (func_selectedrange.top === row_pre) {
    top = row_pre;
    height = func_selectedrange.top + func_selectedrange.height - row_pre;
    rowseleted = [row_index, func_selectedrange.row[0]];
  } else {
    top = func_selectedrange.top;
    height = row - func_selectedrange.top - 1;
    rowseleted = [func_selectedrange.row[0], row_index];
  }

  var changeparam = mergeMoveMain(ctx, [0, col_index], rowseleted, func_selectedrange, top, height, col_pre, col - col_pre - 1);

  if (changeparam != null) {
    var _changeparam3 = _slicedToArray(changeparam, 4);

    rowseleted = _changeparam3[1];
    top = _changeparam3[2];
    height = _changeparam3[3];
  }

  func_selectedrange.row = rowseleted;
  func_selectedrange.top_move = top;
  func_selectedrange.height_move = height;
  rangeSetValue(ctx, cellInput, {
    row: rowseleted,
    column: [null, null]
  }, fxInput);
  setRangeSelect(container, col_pre, top, height, col - col_pre - 1);
}

function updateparam(orient, txt, step) {
  var val = txt.split("!");
  var rangetxt;
  var prefix = "";

  if (val.length > 1) {
    var _val5 = _slicedToArray(val, 2);

    rangetxt = _val5[1];
    prefix = "".concat(val[0], "!");
  } else {
    var _val6 = _slicedToArray(val, 1);

    rangetxt = _val6[0];
  }

  if (rangetxt.indexOf(":") === -1) {
    var _row3 = parseInt(rangetxt.replace(/[^0-9]/g, ""), 10);

    var _col3 = columnCharToIndex(rangetxt.replace(/[^A-Za-z]/g, ""));

    var freezonFuc = isfreezonFuc(rangetxt);
    var $row = freezonFuc[0] ? "$" : "";
    var $col = freezonFuc[1] ? "$" : "";

    if (orient === "u" && !freezonFuc[0]) {
      _row3 -= step;
    } else if (orient === "r" && !freezonFuc[1]) {
      _col3 += step;
    } else if (orient === "l" && !freezonFuc[1]) {
      _col3 -= step;
    } else if (orient === "d" && !freezonFuc[0]) {
      _row3 += step;
    }

    if (!Number.isNaN(_row3) && !Number.isNaN(_col3)) {
      return prefix + $col + indexToColumnChar(_col3) + $row + _row3;
    }

    if (!Number.isNaN(_row3)) {
      return prefix + $row + _row3;
    }

    if (!Number.isNaN(_col3)) {
      return prefix + $col + indexToColumnChar(_col3);
    }

    return txt;
  }

  rangetxt = rangetxt.split(":");
  var row = [];
  var col = [];
  row[0] = parseInt(rangetxt[0].replace(/[^0-9]/g, ""), 10);
  row[1] = parseInt(rangetxt[1].replace(/[^0-9]/g, ""), 10);

  if (row[0] > row[1]) {
    return txt;
  }

  col[0] = columnCharToIndex(rangetxt[0].replace(/[^A-Za-z]/g, ""));
  col[1] = columnCharToIndex(rangetxt[1].replace(/[^A-Za-z]/g, ""));

  if (col[0] > col[1]) {
    return txt;
  }

  var freezonFuc0 = isfreezonFuc(rangetxt[0]);
  var freezonFuc1 = isfreezonFuc(rangetxt[1]);
  var $row0 = freezonFuc0[0] ? "$" : "";
  var $col0 = freezonFuc0[1] ? "$" : "";
  var $row1 = freezonFuc1[0] ? "$" : "";
  var $col1 = freezonFuc1[1] ? "$" : "";

  if (orient === "u") {
    if (!freezonFuc0[0]) {
      row[0] -= step;
    }

    if (!freezonFuc1[0]) {
      row[1] -= step;
    }
  } else if (orient === "r") {
    if (!freezonFuc0[1]) {
      col[0] += step;
    }

    if (!freezonFuc1[1]) {
      col[1] += step;
    }
  } else if (orient === "l") {
    if (!freezonFuc0[1]) {
      col[0] -= step;
    }

    if (!freezonFuc1[1]) {
      col[1] -= step;
    }
  } else if (orient === "d") {
    if (!freezonFuc0[0]) {
      row[0] += step;
    }

    if (!freezonFuc1[0]) {
      row[1] += step;
    }
  }

  if (row[0] < 0 || col[0] < 0) {
    return error.r;
  }

  if (Number.isNaN(col[0]) && Number.isNaN(col[1])) {
    return "".concat(prefix + $row0 + row[0], ":").concat($row1).concat(row[1]);
  }

  if (Number.isNaN(row[0]) && Number.isNaN(row[1])) {
    return "".concat(prefix + $col0 + indexToColumnChar(col[0]), ":").concat($col1).concat(indexToColumnChar(col[1]));
  }

  return "".concat(prefix + $col0 + indexToColumnChar(col[0]) + $row0 + row[0], ":").concat($col1).concat(indexToColumnChar(col[1])).concat($row1).concat(row[1]);
}

function downparam(txt, step) {
  return updateparam("d", txt, step);
}

function upparam(txt, step) {
  return updateparam("u", txt, step);
}

function leftparam(txt, step) {
  return updateparam("l", txt, step);
}

function rightparam(txt, step) {
  return updateparam("r", txt, step);
}

function functionCopy(ctx, txt, mode, step) {
  if (mode == null) {
    mode = "down";
  }

  if (step == null) {
    step = 1;
  }

  if (txt.substring(0, 1) === "=") {
    txt = txt.substring(1);
  }

  var funcstack = txt.split("");
  var i = 0;
  var str = "";
  var function_str = "";
  var matchConfig = {
    bracket: 0,
    comma: 0,
    squote: 0,
    dquote: 0
  };

  while (i < funcstack.length) {
    var s = funcstack[i];

    if (s === "(" && matchConfig.dquote === 0) {
      matchConfig.bracket += 1;

      if (str.length > 0) {
        function_str += "".concat(str, "(");
      } else {
        function_str += "(";
      }

      str = "";
    } else if (s === ")" && matchConfig.dquote === 0) {
      matchConfig.bracket -= 1;
      function_str += "".concat(functionCopy(ctx, str, mode, step), ")");
      str = "";
    } else if (s === '"' && matchConfig.squote === 0) {
      if (matchConfig.dquote > 0) {
        function_str += "".concat(str, "\"");
        matchConfig.dquote -= 1;
        str = "";
      } else {
        matchConfig.dquote += 1;
        str += '"';
      }
    } else if (s === "," && matchConfig.dquote === 0) {
      function_str += "".concat(functionCopy(ctx, str, mode, step), ",");
      str = "";
    } else if (s === "&" && matchConfig.dquote === 0) {
      if (str.length > 0) {
        function_str += "".concat(functionCopy(ctx, str, mode, step), "&");
        str = "";
      } else {
        function_str += "&";
      }
    } else if (s in operatorjson && matchConfig.dquote === 0) {
      var s_next = "";

      if (i + 1 < funcstack.length) {
        s_next = funcstack[i + 1];
      }

      var p = i - 1;
      var s_pre = null;

      if (p >= 0) {
        do {
          s_pre = funcstack[p];
          p -= 1;
        } while (p >= 0 && s_pre === " ");
      }

      if (s + s_next in operatorjson) {
        if (str.length > 0) {
          function_str += functionCopy(ctx, str, mode, step) + s + s_next;
          str = "";
        } else {
          function_str += s + s_next;
        }

        i += 1;
      } else if (!/[^0-9]/.test(s_next) && s === "-" && (s_pre === "(" || s_pre == null || s_pre === "," || s_pre === " " || s_pre in operatorjson)) {
        str += s;
      } else {
        if (str.length > 0) {
          function_str += functionCopy(ctx, str, mode, step) + s;
          str = "";
        } else {
          function_str += s;
        }
      }
    } else {
      str += s;
    }

    if (i === funcstack.length - 1) {
      if (iscelldata(_.trim(str))) {
        if (mode === "down") {
          function_str += downparam(_.trim(str), step);
        } else if (mode === "up") {
          function_str += upparam(_.trim(str), step);
        } else if (mode === "left") {
          function_str += leftparam(_.trim(str), step);
        } else if (mode === "right") {
          function_str += rightparam(_.trim(str), step);
        }
      } else {
        function_str += _.trim(str);
      }
    }

    i += 1;
  }

  return function_str;
}

function checkCellIsLocked(ctx, r, c, sheetId) {
  var _data$r, _sheetFile$config;

  var sheetFile = getSheetByIndex(ctx, sheetId);

  if (_.isNil(sheetFile)) {
    return false;
  }

  var data = sheetFile.data;
  var cell = data === null || data === void 0 ? void 0 : (_data$r = data[r]) === null || _data$r === void 0 ? void 0 : _data$r[c];

  if (!_.isNil(cell === null || cell === void 0 ? void 0 : cell.lo)) {
    return !!(cell === null || cell === void 0 ? void 0 : cell.lo);
  }

  var aut = (_sheetFile$config = sheetFile.config) === null || _sheetFile$config === void 0 ? void 0 : _sheetFile$config.authority;
  var sheetInEditable = _.isNil(aut) || _.isNil(aut.sheet) || aut.sheet === 0;
  return !sheetInEditable;
}
function checkProtectionSelectLockedOrUnLockedCells(ctx, r, c, sheetId) {
  var _data$r2;

  var sheetFile = getSheetByIndex(ctx, sheetId);

  if (_.isNil(sheetFile)) {
    return true;
  }

  if (_.isNil(sheetFile.config) || _.isNil(sheetFile.config.authority)) {
    return true;
  }

  var aut = sheetFile.config.authority;

  if (_.isNil(aut) || _.isNil(aut.sheet) || aut.sheet === 0) {
    return true;
  }

  var data = sheetFile.data;
  var cell = data === null || data === void 0 ? void 0 : (_data$r2 = data[r]) === null || _data$r2 === void 0 ? void 0 : _data$r2[c];

  if (cell && cell.lo === 0) {
    if (aut.selectunLockedCells === 1 || _.isNil(aut.selectunLockedCells)) {
      return true;
    }

    return false;
  }

  if (aut.selectLockedCells === 1 || _.isNil(aut.selectLockedCells)) {
    return true;
  }

  return false;
}
function checkProtectionAllSelected(ctx, sheetId) {
  var sheetFile = getSheetByIndex(ctx, sheetId);

  if (_.isNil(sheetFile)) {
    return true;
  }

  if (_.isNil(sheetFile.config) || _.isNil(sheetFile.config.authority)) {
    return true;
  }

  var aut = sheetFile.config.authority;

  if (_.isNil(aut) || _.isNil(aut.sheet) || aut.sheet === 0) {
    return true;
  }

  var selectunLockedCells = false;

  if (aut.selectunLockedCells === 1 || _.isNil(aut.selectunLockedCells)) {
    selectunLockedCells = true;
  }

  var selectLockedCells = false;

  if (aut.selectLockedCells === 1 || _.isNil(aut.selectLockedCells)) {
    selectLockedCells = true;
  }

  if (selectunLockedCells && selectLockedCells) {
    return true;
  }

  return false;
}
function checkProtectionFormatCells(ctx) {
  var sheetFile = getSheetByIndex(ctx, ctx.currentSheetId);

  if (_.isNil(sheetFile)) {
    return true;
  }

  if (_.isNil(sheetFile.config) || _.isNil(sheetFile.config.authority)) {
    return true;
  }

  var aut = sheetFile.config.authority;

  if (_.isNil(aut) || _.isNil(aut.sheet) || aut.sheet === 0) {
    return true;
  }

  var ht = "";

  if (!_.isNil(aut.hintText) && aut.hintText.length > 0) {
    ht = aut.hintText;
  } else {
    ht = aut.defaultSheetHintText;
  }

  ctx.warnDialog = ht;
  return false;
}

function getHistoryRules(fileH) {
  var historyRules = [];

  for (var h = 0; h < fileH.length; h += 1) {
    historyRules.push({
      sheetIndex: h,
      luckysheet_conditionformat_save: fileH[h].luckysheet_conditionformat_save
    });
  }

  return historyRules;
}
function getCurrentRules(fileC) {
  var currentRules = [];

  for (var c = 0; c < fileC.length; c += 1) {
    currentRules.push({
      sheetIndex: c,
      luckysheet_conditionformat_save: fileC[c].luckysheet_conditionformat_save
    });
  }

  return currentRules;
}
function setConditionRules(ctx, protection, generalDialog, conditionformat, rules) {
  var _ctx$luckysheet_selec, _ctx$luckysheetfile$i;

  if (!checkProtectionFormatCells(ctx)) {
    return;
  }

  var conditionName = rules.rulesType;
  var conditionRange = [];
  var conditionValue = [];

  if (conditionName === "greaterThan" || conditionName === "lessThan" || conditionName === "equal" || conditionName === "textContains") {
    var v = rules.rulesValue;
    var rangeArr = getRangeByTxt(ctx, v);

    if (rangeArr.length > 1) {
      var r1 = rangeArr[0].row[0];
      var r2 = rangeArr[0].row[1];
      var c1 = rangeArr[0].column[0];
      var c2 = rangeArr[0].column[1];

      if (r1 === r2 && c1 === c2) {
        var d = getFlowdata(ctx);
        if (!d) return;
        v = getCellValue(r1, c1, d);
        conditionRange.push({
          row: rangeArr[0].row,
          column: rangeArr[0].column
        });
        conditionValue.push(v);
      } else {
        ctx.warnDialog = conditionformat.onlySingleCell;
      }
    } else if (rangeArr.length === 0) {
      if (_.isNaN(v) || v === "") {
        ctx.warnDialog = conditionformat.conditionValueCanOnly;
        return;
      }

      conditionValue.push(v);
    }
  } else if (conditionName === "between") {
    var v1 = rules.betweenValue.value1;
    var v2 = rules.betweenValue.value2;
    var rangeArr1 = getRangeByTxt(ctx, v1);

    if (rangeArr1.length > 1) {
      ctx.warnDialog = conditionformat.onlySingleCell;
      return;
    }

    if (rangeArr1.length === 1) {
      var _r = rangeArr1[0].row[0];
      var _r2 = rangeArr1[0].row[1];
      var _c = rangeArr1[0].column[0];
      var _c2 = rangeArr1[0].column[1];

      if (_r === _r2 && _c === _c2) {
        var _d = getFlowdata(ctx);

        if (!_d) return;
        v1 = getCellValue(_r, _c, _d);
        conditionRange.push({
          row: rangeArr1[0].row,
          column: rangeArr1[0].column
        });
        conditionValue.push(v1);
      } else {
        ctx.warnDialog = conditionformat.onlySingleCell;
        return;
      }
    } else if (rangeArr1.length === 0) {
      if (_.isNaN(v1) || v1 === "") {
        ctx.warnDialog = conditionformat.conditionValueCanOnly;
        return;
      }

      conditionValue.push(v1);
    }

    var rangeArr2 = getRangeByTxt(ctx, v2);

    if (rangeArr2.length > 1) {
      ctx.warnDialog = conditionformat.onlySingleCell;
      return;
    }

    if (rangeArr2.length === 1) {
      var _r3 = rangeArr2[0].row[0];
      var _r4 = rangeArr2[0].row[1];
      var _c3 = rangeArr2[0].column[0];
      var _c4 = rangeArr2[0].column[1];

      if (_r3 === _r4 && _c3 === _c4) {
        var _d2 = getFlowdata(ctx);

        if (!_d2) return;
        v2 = getCellValue(_r3, _c3, _d2);
        conditionRange.push({
          row: rangeArr2[0].row,
          column: rangeArr2[0].column
        });
      } else {
        ctx.warnDialog = conditionformat.onlySingleCell;
        return;
      }
    } else if (rangeArr2.length === 0) {
      if (_.isNaN(v2) || v2 === "") {
        ctx.warnDialog = conditionformat.conditionValueCanOnly;
      } else {
        conditionValue.push(v2);
      }
    }
  } else if (conditionName === "occurrenceDate") {
    var _v = rules.dateValue;

    if (!_v) {
      ctx.warnDialog = conditionformat.pleaseSelectADate;
      return;
    }

    conditionValue.push(_v);
  } else if (conditionName === "duplicateValue") {
    conditionValue.push(rules.repeatValue);
  } else if (conditionName === "top10" || conditionName === "top10_percent" || conditionName === "last10" || conditionName === "last10_percent") {
    var _v2 = rules.projectValue;

    if (parseInt(_v2, 10).toString() !== _v2 || parseInt(_v2, 10) < 1 || parseInt(_v2, 10) > 1000) {
      ctx.warnDialog = conditionformat.pleaseEnterInteger;
      return;
    }

    conditionValue.push(_v2);
  } else {
    conditionValue.push(conditionName);
  }

  var textColor = null;

  if (rules.textColor.check) {
    textColor = rules.textColor.color;
  }

  var cellColor = null;

  if (rules.cellColor.check) {
    cellColor = rules.cellColor.color;
  }

  var rule = {
    type: "default",
    cellrange: (_ctx$luckysheet_selec = ctx.luckysheet_select_save) !== null && _ctx$luckysheet_selec !== void 0 ? _ctx$luckysheet_selec : [],
    format: {
      textColor: textColor,
      cellColor: cellColor
    },
    conditionName: conditionName,
    conditionRange: conditionRange,
    conditionValue: conditionValue
  };
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var ruleArr = (_ctx$luckysheetfile$i = ctx.luckysheetfile[index].luckysheet_conditionformat_save) !== null && _ctx$luckysheetfile$i !== void 0 ? _ctx$luckysheetfile$i : [];
  ruleArr === null || ruleArr === void 0 ? void 0 : ruleArr.push(rule);
  ctx.luckysheetfile[index].luckysheet_conditionformat_save = ruleArr;
}
function getColorGradation(color1, color2, value1, value2, value) {
  var rgb1 = color1.split(",");
  var r1 = parseInt(rgb1[0].split("(")[1], 10);
  var g1 = parseInt(rgb1[1], 10);
  var b1 = parseInt(rgb1[2].split(")")[0], 10);
  var rgb2 = color2.split(",");
  var r2 = parseInt(rgb2[0].split("(")[1], 10);
  var g2 = parseInt(rgb2[1], 10);
  var b2 = parseInt(rgb2[2].split(")")[0], 10);
  var v12 = value1 - value2;
  var v10 = value1 - value;
  var r = Math.round(r1 - (r1 - r2) / v12 * v10);
  var g = Math.round(g1 - (g1 - g2) / v12 * v10);
  var b = Math.round(b1 - (b1 - b2) / v12 * v10);
  return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function compute(ctx, ruleArr, d) {
  if (_.isNil(ruleArr)) {
    ruleArr = [];
  }

  var computeMap = {};

  if (ruleArr.length > 0) {
    for (var i = 0; i < ruleArr.length; i += 1) {
      var _ruleArr$i = ruleArr[i],
          type = _ruleArr$i.type,
          cellrange = _ruleArr$i.cellrange,
          format = _ruleArr$i.format;

      if (type === "dataBar") {
        var max = null;
        var min = null;

        for (var s = 0; s < cellrange.length; s += 1) {
          for (var r = cellrange[s].row[0]; r <= cellrange[s].row[1]; r += 1) {
            for (var c = cellrange[s].column[0]; c <= cellrange[s].column[1]; c += 1) {
              if (_.isNil(d[r]) || _.isNil(d[r][c])) {
                continue;
              }

              var cell = d[r][c];

              if (!_.isNil(cell) && !_.isNil(cell.ct) && cell.ct.t === "n" && _.isNil(cell.v)) {
                if (_.isNil(max) || parseInt("".concat(cell.v), 10) > max) {
                  max = parseInt("".concat(cell.v), 10);
                }

                if (_.isNil(min) || parseInt("".concat(cell.v), 10) < min) {
                  min = parseInt("".concat(cell.v), 10);
                }
              }
            }
          }
        }

        if (!_.isNil(max) && !_.isNil(min)) {
          if (min < 0) {
            var plusLen = Math.round(max / (max - min) * 10) / 10;
            var minusLen = Math.round(Math.abs(min) / (max - min) * 10) / 10;

            for (var _s = 0; _s < cellrange.length; _s += 1) {
              for (var _r5 = cellrange[_s].row[0]; _r5 <= cellrange[_s].row[1]; _r5 += 1) {
                for (var _c5 = cellrange[_s].column[0]; _c5 <= cellrange[_s].column[1]; _c5 += 1) {
                  if (_.isNil(d[_r5]) || _.isNil(d[_r5][_c5])) {
                    continue;
                  }

                  var _cell = d[_r5][_c5];

                  if (!_.isNil(_cell) && !_.isNil(_cell.ct) && _cell.ct.t === "n" && !_.isNil(_cell.v)) {
                    if (parseInt("".concat(_cell.v), 10) < 0) {
                      var valueLen = Math.round(Math.abs(parseInt("".concat(_cell.v), 10)) / Math.abs(min) * 100) / 100;

                      if ("".concat(_r5, "_").concat(_c5) in computeMap) {
                        computeMap["".concat(_r5, "_").concat(_c5)].dataBar = {
                          valueType: "minus",
                          minusLen: minusLen,
                          valueLen: valueLen,
                          format: format
                        };
                      } else {
                        computeMap["".concat(_r5, "_").concat(_c5)] = {
                          dataBar: {
                            valueType: "minus",
                            minusLen: minusLen,
                            valueLen: valueLen,
                            format: format
                          }
                        };
                      }
                    }

                    if (parseInt("".concat(_cell.v), 10) > 0) {
                      var _valueLen = Math.round(parseInt("".concat(_cell.v), 10) / max * 100) / 100;

                      if ("".concat(_r5, "_").concat(_c5) in computeMap) {
                        computeMap["".concat(_r5, "_").concat(_c5)].dataBar = {
                          valueType: "plus",
                          plusLen: plusLen,
                          minusLen: minusLen,
                          valueLen: _valueLen,
                          format: format
                        };
                      } else {
                        computeMap["".concat(_r5, "_").concat(_c5)] = {
                          dataBar: {
                            valueType: "plus",
                            plusLen: plusLen,
                            minusLen: minusLen,
                            valueLen: _valueLen,
                            format: format
                          }
                        };
                      }
                    }
                  }
                }
              }
            }
          } else {
            var _plusLen = 1;

            for (var _s2 = 0; _s2 < cellrange.length; _s2 += 1) {
              for (var _r6 = cellrange[_s2].row[0]; _r6 <= cellrange[_s2].row[1]; _r6 += 1) {
                for (var _c6 = cellrange[_s2].column[0]; _c6 <= cellrange[_s2].column[1]; _c6 += 1) {
                  if (_.isNil(d[_r6]) || _.isNil(d[_r6][_c6])) {
                    continue;
                  }

                  var _cell2 = d[_r6][_c6];

                  if (!_.isNil(_cell2) && !_.isNil(_cell2.ct) && _cell2.ct.t === "n" && !_.isNil(_cell2.v)) {
                    var _valueLen2 = void 0;

                    if (max === 0) {
                      _valueLen2 = 1;
                    } else {
                      _valueLen2 = Math.round(parseInt("".concat(_cell2.v), 10) / max * 100) / 100;
                    }

                    if ("".concat(_r6, "_").concat(_c6) in computeMap) {
                      computeMap["".concat(_r6, "_").concat(_c6)].dataBar = {
                        valueType: "plus",
                        plusLen: _plusLen,
                        valueLen: _valueLen2,
                        format: format
                      };
                    } else {
                      computeMap["".concat(_r6, "_").concat(_c6)] = {
                        dataBar: {
                          valueType: "plus",
                          plusLen: _plusLen,
                          valueLen: _valueLen2,
                          format: format
                        }
                      };
                    }
                  }
                }
              }
            }
          }
        }
      } else if (type === "colorGradation") {
        var _max = null;
        var _min = null;
        var sum = 0;
        var count = 0;

        for (var _s3 = 0; _s3 < cellrange.length; _s3 += 1) {
          for (var _r7 = cellrange[_s3].row[0]; _r7 <= cellrange[_s3].row[1]; _r7 += 1) {
            for (var _c7 = cellrange[_s3].column[0]; _c7 <= cellrange[_s3].column[1]; _c7 += 1) {
              if (_.isNil(d[_r7]) || _.isNil(d[_r7][_c7])) {
                continue;
              }

              var _cell3 = d[_r7][_c7];

              if (!_.isNil(_cell3) && !_.isNil(_cell3.ct) && _cell3.ct.t === "n" && !_.isNil(_cell3.v)) {
                count += 1;
                sum += parseInt("".concat(_cell3.v), 10);

                if (_.isNil(_max) || parseInt("".concat(_cell3.v), 10) > _max) {
                  _max = parseInt("".concat(_cell3.v), 10);
                }

                if (_.isNil(_min) || parseInt("".concat(_cell3.v), 10) < _min) {
                  _min = parseInt("".concat(_cell3.v), 10);
                }
              }
            }
          }
        }

        if (!_.isNil(_max) && !_.isNil(_min)) {
          if (format.length === 3) {
            var avg = Math.floor(sum / count);

            for (var _s4 = 0; _s4 < cellrange.length; _s4 += 1) {
              for (var _r8 = cellrange[_s4].row[0]; _r8 <= cellrange[_s4].row[1]; _r8 += 1) {
                for (var _c8 = cellrange[_s4].column[0]; _c8 <= cellrange[_s4].column[1]; _c8 += 1) {
                  if (_.isNil(d[_r8]) || _.isNil(d[_r8][_c8])) {
                    continue;
                  }

                  var _cell4 = d[_r8][_c8];

                  if (!_.isNil(_cell4) && !_.isNil(_cell4.ct) && _cell4.ct.t === "n" && !_.isNil(_cell4.v)) {
                    if (parseInt("".concat(_cell4.v), 10) === _min) {
                      if ("".concat(_r8, "_").concat(_c8) in computeMap) {
                        computeMap["".concat(_r8, "_").concat(_c8)].cellColor = format.cellColor;
                      } else {
                        computeMap["".concat(_r8, "_").concat(_c8)] = {
                          cellColor: format.cellColor
                        };
                      }
                    } else if (parseInt("".concat(_cell4.v), 10) > _min && parseInt("".concat(_cell4.v), 10) < avg) {
                      if ("".concat(_r8, "_").concat(_c8) in computeMap) {
                        computeMap["".concat(_r8, "_").concat(_c8)].cellColor = getColorGradation(format.cellColor, format.textColor, _min, avg, parseInt("".concat(_cell4.v), 10));
                      } else {
                        computeMap["".concat(_r8, "_").concat(_c8)] = {
                          cellColor: getColorGradation(format[2], format[1], _min, avg, parseInt("".concat(_cell4.v), 10))
                        };
                      }
                    } else if (parseInt("".concat(_cell4.v), 10) === avg) {
                      if ("".concat(_r8, "_").concat(_c8) in computeMap) {
                        computeMap["".concat(_r8, "_").concat(_c8)].cellColor = format.cellColor;
                      } else {
                        computeMap["".concat(_r8, "_").concat(_c8)] = {
                          cellColor: format[1]
                        };
                      }
                    } else if (parseInt("".concat(_cell4.v), 10) > avg && parseInt("".concat(_cell4.v), 10) < _max) {
                      if ("".concat(_r8, "_").concat(_c8) in computeMap) {
                        computeMap["".concat(_r8, "_").concat(_c8)].cellColor = getColorGradation(format[1], format[0], avg, _max, parseInt("".concat(_cell4.v), 10));
                      } else {
                        computeMap["".concat(_r8, "_").concat(_c8)] = {
                          cellColor: getColorGradation(format[1], format[0], avg, _max, parseInt("".concat(_cell4.v), 10))
                        };
                      }
                    } else if (parseInt("".concat(_cell4.v), 10) === _max) {
                      if ("".concat(_r8, "_").concat(_c8) in computeMap) {
                        computeMap["".concat(_r8, "_").concat(_c8)].cellColor = format.cellColor;
                      } else {
                        computeMap["".concat(_r8, "_").concat(_c8)] = {
                          cellColor: format[0]
                        };
                      }
                    }
                  }
                }
              }
            }
          } else if (format.length === 2) {
            for (var _s5 = 0; _s5 < cellrange.length; _s5 += 1) {
              for (var _r9 = cellrange[_s5].row[0]; _r9 <= cellrange[_s5].row[1]; _r9 += 1) {
                for (var _c9 = cellrange[_s5].column[0]; _c9 <= cellrange[_s5].column[1]; _c9 += 1) {
                  if (_.isNil(d[_r9]) || _.isNil(d[_r9][_c9])) {
                    continue;
                  }

                  var _cell5 = d[_r9][_c9];

                  if (!_.isNil(_cell5) && !_.isNil(_cell5.ct) && _cell5.ct.t === "n" && !_.isNil(_cell5.v)) {
                    if (parseInt("".concat(_cell5.v), 10) === _min) {
                      if ("".concat(_r9, "_").concat(_c9) in computeMap) {
                        computeMap["".concat(_r9, "_").concat(_c9)].cellColor = format.cellColor;
                      } else {
                        computeMap["".concat(_r9, "_").concat(_c9)] = {
                          cellColor: format[1]
                        };
                      }
                    } else if (parseInt("".concat(_cell5.v), 10) > _min && parseInt("".concat(_cell5.v), 10) < _max) {
                      if ("".concat(_r9, "_").concat(_c9) in computeMap) {
                        computeMap["".concat(_r9, "_").concat(_c9)].cellColor = getColorGradation(format[1], format[0], _min, _max, parseInt("".concat(_cell5.v), 10));
                      } else {
                        computeMap["".concat(_r9, "_").concat(_c9)] = {
                          cellColor: getColorGradation(format[1], format[0], _min, _max, parseInt("".concat(_cell5.v), 10))
                        };
                      }
                    } else if (parseInt("".concat(_cell5.v), 10) === _max) {
                      if ("".concat(_r9, "_").concat(_c9) in computeMap) {
                        computeMap["".concat(_r9, "_").concat(_c9)].cellColor = format.textColor;
                      } else {
                        computeMap["".concat(_r9, "_").concat(_c9)] = {
                          cellColor: format[0]
                        };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else if (type === "icons") ; else {
        (function () {
          var conditionName = ruleArr[i].conditionName;
          var conditionValue0 = ruleArr[i].conditionValue[0];
          var conditionValue1 = ruleArr[i].conditionValue[1];
          var textColor = format.textColor,
              cellColor = format.cellColor;

          for (var _s6 = 0; _s6 < cellrange.length; _s6 += 1) {
            if (conditionName === "greaterThan" || conditionName === "lessThan" || conditionName === "equal" || conditionName === "textContains") {
              for (var _r10 = cellrange[_s6].row[0]; _r10 <= cellrange[_s6].row[1]; _r10 += 1) {
                for (var _c10 = cellrange[_s6].column[0]; _c10 <= cellrange[_s6].column[1]; _c10 += 1) {
                  if (_.isNil(d[_r10]) || _.isNil(d[_r10][_c10])) {
                    continue;
                  }

                  var _cell6 = d[_r10][_c10];

                  if (_.isNil(_cell6) || _.isNil(_cell6.v) || isRealNull(_cell6.v)) {
                    continue;
                  }

                  if (conditionName === "greaterThan" && _cell6.v > conditionValue0) {
                    if ("".concat(_r10, "_").concat(_c10) in computeMap) {
                      computeMap["".concat(_r10, "_").concat(_c10)].textColor = textColor;
                      computeMap["".concat(_r10, "_").concat(_c10)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(_r10, "_").concat(_c10)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  } else if (conditionName === "lessThan" && _cell6.v < conditionValue0) {
                    if ("".concat(_r10, "_").concat(_c10) in computeMap) {
                      computeMap["".concat(_r10, "_").concat(_c10)].textColor = textColor;
                      computeMap["".concat(_r10, "_").concat(_c10)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(_r10, "_").concat(_c10)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  } else if (conditionName === "equal" && _cell6.v.toString() === conditionValue0) {
                    if ("".concat(_r10, "_").concat(_c10) in computeMap) {
                      computeMap["".concat(_r10, "_").concat(_c10)].textColor = textColor;
                      computeMap["".concat(_r10, "_").concat(_c10)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(_r10, "_").concat(_c10)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  } else if (conditionName === "textContains" && _cell6.v.toString().indexOf(conditionValue0) !== -1) {
                    if ("".concat(_r10, "_").concat(_c10) in computeMap) {
                      computeMap["".concat(_r10, "_").concat(_c10)].textColor = textColor;
                      computeMap["".concat(_r10, "_").concat(_c10)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(_r10, "_").concat(_c10)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  }
                }
              }
            } else if (conditionName === "between") {
              var vBig = 0;
              var vSmall = 0;

              if (conditionValue0 > conditionValue1) {
                vBig = conditionValue0;
                vSmall = conditionValue1;
              } else {
                vBig = conditionValue1;
                vSmall = conditionValue0;
              }

              for (var _r11 = cellrange[_s6].row[0]; _r11 <= cellrange[_s6].row[1]; _r11 += 1) {
                for (var _c11 = cellrange[_s6].column[0]; _c11 <= cellrange[_s6].column[1]; _c11 += 1) {
                  if (_.isNil(d[_r11]) || _.isNil(d[_r11][_c11])) {
                    continue;
                  }

                  var _cell7 = d[_r11][_c11];

                  if (_.isNil(_cell7) || _.isNil(_cell7.v) || isRealNull(_cell7.v)) {
                    continue;
                  }

                  if (_cell7.v >= vSmall && _cell7.v <= vBig) {
                    if ("".concat(_r11, "_").concat(_c11) in computeMap) {
                      computeMap["".concat(_r11, "_").concat(_c11)].textColor = textColor;
                      computeMap["".concat(_r11, "_").concat(_c11)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(_r11, "_").concat(_c11)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  }
                }
              }
            } else if (conditionName === "occurrenceDate") {
              var dBig = void 0;
              var dSmall = void 0;

              if (conditionValue0.toString().indexOf("-") === -1) {
                dBig = genarate(conditionValue0)[2].toString();
                dSmall = genarate(conditionValue0)[2].toString();
              } else {
                var str = conditionValue0.toString().split("-");
                dBig = genarate(str[1].trim())[2].toString();
                dSmall = genarate(str[0].trim()[2].toString());
              }

              for (var _r12 = cellrange[_s6].row[0]; _r12 <= cellrange[_s6].row[1]; _r12 += 1) {
                for (var _c12 = cellrange[_s6].column[0]; _c12 <= cellrange[_s6].column[1]; _c12 += 1) {
                  if (_.isNil(d[_r12]) || _.isNil(d[_r12][_c12])) {
                    continue;
                  }

                  if (!_.isNil(d[_r12][_c12]) && !_.isNil(d[_r12][_c12].ct) && d[_r12][_c12].ct.t === "d") {
                    var cellVal = getCellValue(_r12, _c12, d);

                    if (cellVal >= dSmall && cellVal <= dBig) {
                      if ("".concat(_r12, "_").concat(_c12) in computeMap) {
                        computeMap["".concat(_r12, "_").concat(_c12)].textColor = textColor;
                        computeMap["".concat(_r12, "_").concat(_c12)].cellColor = cellColor;
                      } else {
                        computeMap["".concat(_r12, "_").concat(_c12)] = {
                          textColor: textColor,
                          cellColor: cellColor
                        };
                      }
                    }
                  }
                }
              }
            } else if (conditionName === "duplicateValue") {
              var dmap = {};

              for (var _r13 = cellrange[_s6].row[0]; _r13 <= cellrange[_s6].row[1]; _r13 += 1) {
                for (var _c13 = cellrange[_s6].column[0]; _c13 <= cellrange[_s6].column[1]; _c13 += 1) {
                  var item = getCellValue(_r13, _c13, d);

                  if (!(item in dmap)) {
                    dmap[item] = [];
                  }

                  dmap[item].push({
                    r: _r13,
                    c: _c13
                  });
                }
              }

              if (conditionValue0 === "0") {
                _.forEach(dmap, function (x) {
                  if (x.length > 1) {
                    for (var j = 0; j < x.length; j += 1) {
                      if ("".concat(x[j].r, "_").concat(x[j].c) in computeMap) {
                        computeMap["".concat(x[j].r, "_").concat(x[j].c)].textColor = textColor;
                        computeMap["".concat(x[j].r, "_").concat(x[j].c)].cellColor = cellColor;
                      } else {
                        computeMap["".concat(x[j].r, "_").concat(x[j].c)] = {
                          textColor: textColor,
                          cellColor: cellColor
                        };
                      }
                    }
                  }
                });
              } else if (conditionValue0 === "1") {
                _.forEach(dmap, function (x) {
                  if (x.length === 1) {
                    if ("".concat(x[0].r, "_").concat(x[0].c) in computeMap) {
                      computeMap["".concat(x[0].r, "_").concat(x[0].c)].textColor = textColor;
                      computeMap["".concat(x[0].r, "_").concat(x[0].c)].cellColor = cellColor;
                    } else {
                      computeMap["".concat(x[0].r, "_").concat(x[0].c)] = {
                        textColor: textColor,
                        cellColor: cellColor
                      };
                    }
                  }
                });
              }
            } else if (conditionName === "top10" || conditionName === "top10_percent" || conditionName === "last10" || conditionName === "last10_percent" || conditionName === "aboveAverage" || conditionName === "belowAverage") {
              var dArr = [];

              for (var _r14 = cellrange[_s6].row[0]; _r14 <= cellrange[_s6].row[1]; _r14 += 1) {
                for (var _c14 = cellrange[_s6].column[0]; _c14 <= cellrange[_s6].column[1]; _c14 += 1) {
                  if (_.isNil(d[_r14]) || _.isNil(d[_r14][_c14])) {
                    continue;
                  }

                  if (!_.isNil(d[_r14][_c14]) && !_.isNil(d[_r14][_c14].ct) && d[_r14][_c14].ct.t === "n") {
                    dArr.push(getCellValue(_r14, _c14, d));
                  }
                }
              }

              if (conditionName === "top10" || conditionName === "top10_percent" || conditionName === "last10" || conditionName === "last10_percent") {
                for (var j = 0; j < dArr.length; j += 1) {
                  for (var k = 0; k < dArr.length - 1 - j; k += 1) {
                    if (dArr[k] < dArr[k + 1]) {
                      var temp = dArr[k];
                      dArr[k] = dArr[k + 1];
                      dArr[k + 1] = temp;
                    }
                  }
                }

                var cArr = void 0;

                if (conditionName === "top10") {
                  cArr = dArr.slice(0, conditionValue0);
                } else if (conditionName === "top10_percent") {
                  cArr = dArr.slice(0, Math.floor(conditionValue0 * dArr.length / 100));
                } else if (conditionName === "last10") {
                  cArr = dArr.slice(dArr.length - conditionValue0, dArr.length);
                } else if (conditionName === "last10_percent") {
                  cArr = dArr.slice(dArr.length - Math.floor(conditionValue0 * dArr.length / 100), dArr.length);
                }

                for (var _r15 = cellrange[_s6].row[0]; _r15 <= cellrange[_s6].row[1]; _r15 += 1) {
                  for (var _c15 = cellrange[_s6].column[0]; _c15 <= cellrange[_s6].column[1]; _c15 += 1) {
                    if (_.isNil(d[_r15]) || _.isNil(d[_r15][_c15])) {
                      continue;
                    }

                    var _cellVal = getCellValue(_r15, _c15, d);

                    if (!_.isNil(cArr) && cArr.indexOf(_cellVal) !== -1) {
                      if ("".concat(_r15, "_").concat(_c15) in computeMap) {
                        computeMap["".concat(_r15, "_").concat(_c15)].textColor = textColor;
                        computeMap["".concat(_r15, "_").concat(_c15)].cellColor = cellColor;
                      } else {
                        computeMap["".concat(_r15, "_").concat(_c15)] = {
                          textColor: textColor,
                          cellColor: cellColor
                        };
                      }
                    }
                  }
                }
              } else if (conditionName === "aboveAverage" || conditionName === "belowAverage") {
                var _sum = 0;

                for (var _j = 0; _j < dArr.length; _j += 1) {
                  _sum += dArr[_j];
                }

                var averageNum = _sum / dArr.length;

                if (conditionName === "aboveAverage") {
                  for (var _r16 = cellrange[_s6].row[0]; _r16 <= cellrange[_s6].row[1]; _r16 += 1) {
                    for (var _c16 = cellrange[_s6].column[0]; _c16 <= cellrange[_s6].column[1]; _c16 += 1) {
                      if (_.isNil(d[_r16]) || _.isNil(d[_r16][_c16])) {
                        continue;
                      }

                      var _cellVal2 = getCellValue(_r16, _c16, d);

                      if (_cellVal2 > averageNum) {
                        if ("".concat(_r16, "_").concat(_c16) in computeMap) {
                          computeMap["".concat(_r16, "_").concat(_c16)].textColor = textColor;
                          computeMap["".concat(_r16, "_").concat(_c16)].cellColor = cellColor;
                        } else {
                          computeMap["".concat(_r16, "_").concat(_c16)] = {
                            textColor: textColor,
                            cellColor: cellColor
                          };
                        }
                      }
                    }
                  }
                } else if (conditionName === "belowAverage") {
                  for (var _r17 = cellrange[_s6].row[0]; _r17 <= cellrange[_s6].row[1]; _r17 += 1) {
                    for (var _c17 = cellrange[_s6].column[0]; _c17 <= cellrange[_s6].column[1]; _c17 += 1) {
                      if (_.isNil(d[_r17]) || _.isNil(d[_r17][_c17])) {
                        continue;
                      }

                      var _cellVal3 = getCellValue(_r17, _c17, d);

                      if (_cellVal3 < averageNum) {
                        if ("".concat(_r17, "_").concat(_c17) in computeMap) {
                          computeMap["".concat(_r17, "_").concat(_c17)].textColor = textColor;
                          computeMap["".concat(_r17, "_").concat(_c17)].cellColor = cellColor;
                        } else {
                          computeMap["".concat(_r17, "_").concat(_c17)] = {
                            textColor: textColor,
                            cellColor: cellColor
                          };
                        }
                      }
                    }
                  }
                }
              }
            } else if (conditionName === "formula") {
              var _str = cellrange[_s6].row[0];
              var edr = cellrange[_s6].row[1];
              var stc = cellrange[_s6].column[0];
              var edc = cellrange[_s6].column[1];
              var formulaTxt = conditionValue0;

              if (conditionValue0.toString().slice(0, 1) !== "=") {
                formulaTxt = "=".concat(conditionValue0);
              }

              for (var _r18 = _str; _r18 <= edr; _r18 += 1) {
                for (var _c18 = stc; _c18 <= edc; _c18 += 1) {
                  var func = formulaTxt;
                  var offsetRow = _r18 - _str;
                  var offsetCol = _c18 - stc;

                  if (offsetRow > 0) {
                    func = "=".concat(functionCopy(ctx, func, "down", offsetRow));
                  }

                  if (offsetCol > 0) {
                    func = "=".concat(functionCopy(ctx, func, "right", offsetCol));
                  }

                  var funcV = execfunction(ctx, func, _r18, _c18);
                  var v = funcV[1];

                  if (typeof v !== "boolean") {
                    v = !!Number(v);
                  }

                  if (!v) {
                    continue;
                  }

                  if ("".concat(_r18, "_").concat(_c18) in computeMap) {
                    computeMap["".concat(_r18, "_").concat(_c18)].textColor = textColor;
                    computeMap["".concat(_r18, "_").concat(_c18)].cellColor = cellColor;
                  } else {
                    computeMap["".concat(_r18, "_").concat(_c18)] = {
                      textColor: textColor,
                      cellColor: cellColor
                    };
                  }
                }
              }
            }
          }
        })();
      }
    }
  }

  return computeMap;
}
function getComputeMap(ctx) {
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var ruleArr = ctx.luckysheetfile[index].luckysheet_conditionformat_save;
  var data = ctx.luckysheetfile[index].data;
  if (_.isNil(data)) return null;
  var computeMap = compute(ctx, ruleArr, data);
  return computeMap;
}
function checkCF(r, c, computeMap) {
  if (!_.isNil(computeMap) && "".concat(r, "_").concat(c) in computeMap) {
    return computeMap["".concat(r, "_").concat(c)];
  }

  return null;
}
function updateItem(ctx, type) {
  if (!checkProtectionFormatCells(ctx)) {
    return;
  }

  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var ruleArr = [];

  if (type === "delSheet") {
    ruleArr = [];
  } else {
    var _ctx$luckysheet_selec2, _ctx$luckysheetfile$i2;

    var rule = {
      type: type,
      cellrange: (_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) !== null && _ctx$luckysheet_selec2 !== void 0 ? _ctx$luckysheet_selec2 : [],
      format: {
        textColor: ctx.conditionRules.textColor,
        cellColor: ctx.conditionRules.cellColor
      }
    };
    ruleArr = (_ctx$luckysheetfile$i2 = ctx.luckysheetfile[index].luckysheet_conditionformat_save) !== null && _ctx$luckysheetfile$i2 !== void 0 ? _ctx$luckysheetfile$i2 : [];
    ruleArr.push(rule);
  }

  ctx.luckysheetfile[index].luckysheet_conditionformat_save = ruleArr;
}
function CFSplitRange(range1, range2, range3, type) {
  var range = [];
  var offset_r = range3.row[0] - range2.row[0];
  var offset_c = range3.column[0] - range2.column[0];
  var r1 = range1.row[0];
  var r2 = range1.row[1];
  var c1 = range1.column[0];
  var c2 = range1.column[1];

  if (r1 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 >= range2.column[0] && c1 <= range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (c2 >= range2.column[0] && c2 <= range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r1 >= range2.row[0] && r1 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r2 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 < range2.column[0] && c2 > range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, c2]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [];
    }
  }

  return range;
}

function dataRangeSelection(ctx, cache, rangT, type, value) {
  ctx.rangeDialog.show = true;
  ctx.rangeDialog.type = type;
  ctx.rangeDialog.rangeTxt = value;

  if (ctx.luckysheet_select_save && !!rangT) {
    var _ctx$formulaRangeSele, _ctx$formulaRangeSele2;

    var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
    var row_index = last.row_focus;
    var col_index = last.column_focus;
    ctx.luckysheetCellUpdate = [row_index, col_index];
    var range = getRangeByTxt(ctx, rangT);
    var r = range[0].row;
    var c = range[0].column;
    var row_pre = rowLocationByIndex(r[0], ctx.visibledatarow)[0];
    var row = rowLocationByIndex(r[1], ctx.visibledatarow)[1];
    var col_pre = colLocationByIndex(c[0], ctx.visibledatacolumn)[0];
    var col = colLocationByIndex(c[1], ctx.visibledatacolumn)[1];
    ctx.formulaRangeSelect = {
      height: row - row_pre - 1,
      left: col_pre,
      rangeIndex: (_ctx$formulaRangeSele = (_ctx$formulaRangeSele2 = ctx.formulaRangeSelect) === null || _ctx$formulaRangeSele2 === void 0 ? void 0 : _ctx$formulaRangeSele2.rangeIndex) !== null && _ctx$formulaRangeSele !== void 0 ? _ctx$formulaRangeSele : 0,
      top: row_pre,
      width: col - col_pre - 1
    };
  } else {
    ctx.luckysheetCellUpdate = [0, 0];
  }
}
function getDropdownList(ctx, txt) {
  var list = [];

  if (iscelldata(txt)) {
    var range = getcellrange(ctx, txt);
    var index = getSheetIndex(ctx, range.sheetId);
    var d = ctx.luckysheetfile[index].data;
    if (!d) return [];

    for (var r = range.row[0]; r <= range.row[1]; r += 1) {
      for (var c = range.column[0]; c <= range.column[1]; c += 1) {
        if (!d[r]) {
          continue;
        }

        var cell = d[r][c];

        if (!cell || !cell.v) {
          continue;
        }

        var v = cell.m || cell.v;

        if (!list.includes(v)) {
          list.push(v);
        }
      }
    }
  } else {
    var arr = txt.split(",");

    for (var i = 0; i < arr.length; i += 1) {
      var _v = arr[i];

      if (_v.length === 0) {
        continue;
      }

      if (!list.includes(_v)) {
        list.push(_v);
      }
    }
  }

  return list;
}
function validateIdCard(ctx, idCard) {
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

  if (regIdCard.test(idCard)) {
    if (idCard.length === 18) {
      var idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
      var idCardWiSum = 0;

      for (var i = 0; i < 17; i += 1) {
        idCardWiSum += Number(idCard.substring(i, i + 1)) * idCardWi[i];
      }

      var idCardMod = idCardWiSum % 11;
      var idCardLast = idCard.substring(17);

      if (idCardMod === 2) {
        if (idCardLast === "X" || idCardLast === "x") {
          return true;
        }

        return false;
      }

      if (idCardLast === idCardY[idCardMod].toString()) {
        return true;
      }

      return false;
    }
  } else {
    return false;
  }

  return false;
}
function validateCellData(ctx, item, cellValue) {
  var value1 = item.value1,
      value2 = item.value2;
  var type = item.type,
      type2 = item.type2;

  if (type === "dropdown") {
    var list = getDropdownList(ctx, value1);

    if (type2 && cellValue) {
      return cellValue.toString().split(",").every(function (i) {
        return list.indexOf(i) !== -1;
      });
    }

    var result = false;

    for (var i = 0; i < list.length; i += 1) {
      if (list[i] === cellValue) {
        result = true;
        break;
      }
    }

    return result;
  }

  if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
    if (!isRealNum(cellValue)) {
      return false;
    }

    cellValue = Number(cellValue);

    if (type === "number_integer" && cellValue % 1 !== 0) {
      return false;
    }

    if (type === "number_decimal" && cellValue % 1 === 0) {
      return false;
    }

    value1 = Number(value1);
    value2 = Number(value2);

    if (type2 === "between" && (cellValue < value1 || cellValue > value2)) {
      return false;
    }

    if (type2 === "notBetween" && cellValue >= value1 && cellValue <= value2) {
      return false;
    }

    if (type2 === "equal" && cellValue !== value1) {
      return false;
    }

    if (type2 === "notEqualTo" && cellValue === value1) {
      return false;
    }

    if (type2 === "moreThanThe" && cellValue <= value1) {
      return false;
    }

    if (type2 === "lessThan" && cellValue >= value1) {
      return false;
    }

    if (type2 === "greaterOrEqualTo" && cellValue < value1) {
      return false;
    }

    if (type2 === "lessThanOrEqualTo" && cellValue > value1) {
      return false;
    }
  } else if (type === "text_content") {
    cellValue = cellValue.toString();
    value1 = value1.toString();

    if (type2 === "include" && cellValue.indexOf(value1) === -1) {
      return false;
    }

    if (type2 === "exclude" && cellValue.indexOf(value1) > -1) {
      return false;
    }

    if (type2 === "equal" && cellValue !== value1) {
      return false;
    }
  } else if (type === "text_length") {
    cellValue = cellValue.toString().length;
    value1 = Number(value1);
    value2 = Number(value2);

    if (type2 === "between" && (cellValue < value1 || cellValue > value2)) {
      return false;
    }

    if (type2 === "notBetween" && cellValue >= value1 && cellValue <= value2) {
      return false;
    }

    if (type2 === "equal" && cellValue !== value1) {
      return false;
    }

    if (type2 === "notEqualTo" && cellValue === value1) {
      return false;
    }

    if (type2 === "moreThanThe" && cellValue <= value1) {
      return false;
    }

    if (type2 === "lessThan" && cellValue >= value1) {
      return false;
    }

    if (type2 === "greaterOrEqualTo" && cellValue < value1) {
      return false;
    }

    if (type2 === "lessThanOrEqualTo" && cellValue > value1) {
      return false;
    }
  } else if (type === "date") {
    if (!isdatetime(cellValue)) {
      return false;
    }

    if (type2 === "between" && (diff(cellValue, value1) < 0 || diff(cellValue, value2) > 0)) {
      return false;
    }

    if (type2 === "notBetween" && diff(cellValue, value1) >= 0 && diff(cellValue, value2) <= 0) {
      return false;
    }

    if (type2 === "equal" && diff(cellValue, value1) !== 0) {
      return false;
    }

    if (type2 === "notEqualTo" && diff(cellValue, value1) === 0) {
      return false;
    }

    if (type2 === "earlierThan" && diff(cellValue, value1) >= 0) {
      return false;
    }

    if (type2 === "noEarlierThan" && diff(cellValue, value1) < 0) {
      return false;
    }

    if (type2 === "laterThan" && diff(cellValue, value1) <= 0) {
      return false;
    }

    if (type2 === "noLaterThan" && diff(cellValue, value1) > 0) {
      return false;
    }
  } else if (type === "validity") {
    if (type2 === "identificationNumber" && !validateIdCard(ctx, cellValue)) {
      return false;
    }

    if (type2 === "phoneNumber" && !/^1[3456789]\d{9}$/.test(cellValue)) {
      return false;
    }
  }

  return true;
}
function checkboxChange(ctx, r, c) {
  var _ctx$luckysheetfile$i;

  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var currentDataVerification = (_ctx$luckysheetfile$i = ctx.luckysheetfile[index].dataVerification) !== null && _ctx$luckysheetfile$i !== void 0 ? _ctx$luckysheetfile$i : {};
  var item = currentDataVerification["".concat(r, "_").concat(c)];
  item.checked = !item.checked;
  var value = item.value2;

  if (item.checked) {
    value = item.value1;
  }

  var d = getFlowdata(ctx);
  setCellValue(ctx, r, c, d, value);
}
function getFailureText(ctx, item) {
  var failureText = "";
  var lang = ctx.lang;
  var type = item.type,
      type2 = item.type2,
      value1 = item.value1,
      value2 = item.value2;

  if (lang === "zh" || lang === "zh-CN") {
    var _ctx$dataVerification;

    var optionLabel_zh = (_ctx$dataVerification = ctx.dataVerification) === null || _ctx$dataVerification === void 0 ? void 0 : _ctx$dataVerification.optionLabel_zh;

    if (type === "dropdown") {
      failureText += "你选择的不是下拉列表中的选项";
    } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
      failureText += "\u4F60\u8F93\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u95F4");
      }

      failureText += "\u7684".concat(optionLabel_zh[type]);
    } else if (type === "text_content") {
      failureText += "\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u5185\u5BB9".concat(optionLabel_zh[type2]).concat(value1, "\u7684\u6587\u672C");
    } else if (type === "text_length") {
      failureText += "\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u957F\u5EA6".concat(optionLabel_zh[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u95F4");
      }

      failureText += "的文本";
    } else if (type === "date") {
      failureText += "\u4F60\u8F93\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u95F4");
      }

      failureText += "的日期";
    } else if (type === "validity") {
      failureText += "\u4F60\u8F93\u5165\u7684\u4E0D\u662F\u4E00\u4E2A\u6B63\u786E\u7684".concat(optionLabel_zh[type2]);
    }
  } else if (lang === "zh-TW") {
    var _ctx$dataVerification2;

    var optionLabel_zh_tw = (_ctx$dataVerification2 = ctx.dataVerification) === null || _ctx$dataVerification2 === void 0 ? void 0 : _ctx$dataVerification2.optionLabel_zh_tw;

    if (type === "dropdown") {
      failureText += "你選擇的不是下拉清單中的選項";
    } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
      failureText += "\u4F60\u8F38\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh_tw[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u9593");
      }

      failureText += "\u7684".concat(optionLabel_zh_tw[type]);
    } else if (type === "text_content") {
      failureText += "\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u5167\u5BB9".concat(optionLabel_zh_tw[type2]).concat(value1, "\u7684\u6587\u672C");
    } else if (type === "text_length") {
      failureText += "\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u9577\u5EA6".concat(optionLabel_zh_tw[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u95F4");
      }

      failureText += "的文本";
    } else if (type === "date") {
      failureText += "\u4F60\u8F38\u5165\u7684\u4E0D\u662F".concat(optionLabel_zh_tw[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "\u548C".concat(value2, "\u4E4B\u95F4");
      }

      failureText += "的日期";
    } else if (type === "validity") {
      failureText += "\u4F60\u8F38\u5165\u7684\u4E0D\u662F\u4E00\u500B\u6B63\u78BA\u7684".concat(optionLabel_zh_tw[type2]);
    }
  } else if (lang === "es") {
    var _ctx$dataVerification3;

    var optionLabel_es = (_ctx$dataVerification3 = ctx.dataVerification) === null || _ctx$dataVerification3 === void 0 ? void 0 : _ctx$dataVerification3.optionLabel_es;

    if (type === "dropdown") {
      failureText += "No elegiste una opción en la lista desplegable";
    } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
      failureText += "Lo que introduciste no es".concat(optionLabel_es[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "Y".concat(value2, "Entre");
      }

      failureText += "De".concat(optionLabel_es[type]);
    } else if (type === "text_content") {
      failureText += "Lo que introduciste no fue contenido".concat(optionLabel_es[type2]).concat(value1, "Texto");
    } else if (type === "text_length") {
      failureText += "No introduciste la longitud".concat(optionLabel_es[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "Y".concat(value2, "Entre");
      }

      failureText += "Texto";
    } else if (type === "date") {
      failureText += "Lo que introduciste no es".concat(optionLabel_es[type2]).concat(value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += "Y".concat(value2, "Entre");
      }

      failureText += "Fecha";
    } else if (type === "validity") {
      failureText += "Lo que ingresas no es correcto".concat(optionLabel_es[type2]);
    }
  } else if (lang === "hi") {
    var _ctx$dataVerification4;

    var optionLabel_hi = (_ctx$dataVerification4 = ctx.dataVerification) === null || _ctx$dataVerification4 === void 0 ? void 0 : _ctx$dataVerification4.optionLabel_hi;

    if (type === "dropdown") {
      failureText += "आपने जो चयन किया है वह ड्रॉप-डाउन सूची में एक विकल्प नहीं है";
    } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
      failureText += "\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 ".concat(optionLabel_hi[item.type], " ").concat(optionLabel_hi[item.type2], " ").concat(item.value1, " \u0928\u0939\u0940\u0902 \u0939\u0948");

      if (item.type2 === "between" || item.type2 === "notBetween") {
        failureText += " and ".concat(item.value2);
      }
    } else if (type === "text_content") {
      failureText += "\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 \u092A\u093E\u0920 \u0928\u0939\u0940\u0902 \u0939\u0948 \u091C\u094B ".concat(optionLabel_hi[item.type2], " ").concat(item.value1, " \u0939\u0948");
    } else if (type === "text_length") {
      failureText += "\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092A\u093E\u0920 \u0915\u0940 \u0932\u0902\u092C\u093E\u0908 ".concat(optionLabel_hi[item.type2], " ").concat(item.value1, " \u0928\u0939\u0940\u0902 \u0939\u0948");

      if (item.type2 === "between" || item.type2 === "notBetween") {
        failureText += " \u0914\u0930 ".concat(item.value2);
      }
    } else if (type === "date") {
      failureText += "\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u0930\u094D\u091C \u0915\u0940 \u0917\u0908 \u0924\u093F\u0925\u093F ".concat(optionLabel_hi[item.type2], " ").concat(item.value1, " \u0928\u0939\u0940\u0902 \u0939\u0948\u0964");

      if (type2 === "between" || type2 === "notBetween") {
        failureText += " \u0914\u0930 ".concat(item.value2);
      }
    } else if (type === "validity") {
      failureText += "\u0906\u092A\u0928\u0947 \u091C\u094B \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948 \u0935\u0939 \u0938\u0939\u0940 ".concat(optionLabel_hi[item.type2], " \u0928\u0939\u0940\u0902 \u0939\u0948\u0964");
    }
  } else {
    var _ctx$dataVerification5;

    var optionLabel_en = (_ctx$dataVerification5 = ctx.dataVerification) === null || _ctx$dataVerification5 === void 0 ? void 0 : _ctx$dataVerification5.optionLabel_en;

    if (type === "dropdown") {
      failureText += "what you selected is not an option in the drop-down list";
    } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
      failureText += "what you entered is not a ".concat(optionLabel_en[item.type], " ").concat(optionLabel_en[item.type2], " ").concat(item.value1);

      if (item.type2 === "between" || item.type2 === "notBetween") {
        failureText += " and ".concat(item.value2);
      }
    } else if (type === "text_content") {
      failureText += "what you entered is not text that ".concat(optionLabel_en[item.type2], " ").concat(item.value1);
    } else if (type === "text_length") {
      failureText += "the text you entered is not length ".concat(optionLabel_en[item.type2], " ").concat(item.value1);

      if (item.type2 === "between" || item.type2 === "notBetween") {
        failureText += " and ".concat(item.value2);
      }
    } else if (type === "date") {
      failureText += "the date you entered is not ".concat(optionLabel_en[item.type2], " ").concat(item.value1);

      if (type2 === "between" || type2 === "notBetween") {
        failureText += " and ".concat(item.value2);
      }
    } else if (type === "validity") {
      failureText += "what you entered is not a correct ".concat(optionLabel_en[item.type2]);
    }
  }

  return failureText;
}
function getHintText(ctx, item) {
  var hintValue = item.hintValue || "";
  var type = item.type,
      type2 = item.type2,
      value1 = item.value1,
      value2 = item.value2;
  var lang = ctx.lang;

  if (!hintValue) {
    if (lang === "en") {
      var _ctx$dataVerification6;

      var optionLabel_en = (_ctx$dataVerification6 = ctx.dataVerification) === null || _ctx$dataVerification6 === void 0 ? void 0 : _ctx$dataVerification6.optionLabel_en;

      if (type === "dropdown") {
        hintValue += "please select an option in the drop-down list";
      } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
        hintValue += "please enter a ".concat(optionLabel_en[type], " ").concat(optionLabel_en[type2], " ").concat(item.value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += " and ".concat(value2);
        }
      } else if (type === "text_content") {
        hintValue += "please enter text ".concat(optionLabel_en[type2], " ").concat(value1);
      } else if (type === "date") {
        hintValue += "please enter a date ".concat(optionLabel_en[type2], " ").concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += " and ".concat(value2);
        }
      } else if (type === "validity") {
        hintValue += "please enter the correct ".concat(optionLabel_en[type2]);
      }
    } else if (lang === "zh" || lang === "zh-CN") {
      var _ctx$dataVerification7;

      var optionLabel_zh = (_ctx$dataVerification7 = ctx.dataVerification) === null || _ctx$dataVerification7 === void 0 ? void 0 : _ctx$dataVerification7.optionLabel_zh;

      if (type === "dropdown") {
        hintValue += "请选择下拉列表中的选项";
      } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
        hintValue += "\u8BF7\u8F93\u5165".concat(optionLabel_zh[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u95F4");
        }

        hintValue += "\u7684".concat(optionLabel_zh[type]);
      } else if (type === "text_content") {
        hintValue += "\u8BF7\u8F93\u5165\u5185\u5BB9".concat(optionLabel_zh[type2]).concat(value1, "\u7684\u6587\u672C");
      } else if (type === "text_length") {
        hintValue += "\u8BF7\u8F93\u5165\u957F\u5EA6".concat(optionLabel_zh[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u95F4");
        }

        hintValue += "的文本";
      } else if (type === "date") {
        hintValue += "\u8BF7\u8F93\u5165".concat(optionLabel_zh[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u95F4");
        }

        hintValue += "的日期";
      } else if (type === "validity") {
        hintValue += "\u8BF7\u8F93\u5165\u6B63\u786E\u7684".concat(optionLabel_zh[type2]);
      }
    } else if (lang === "zh-TW") {
      var _ctx$dataVerification8;

      var optionLabel_zh_tw = (_ctx$dataVerification8 = ctx.dataVerification) === null || _ctx$dataVerification8 === void 0 ? void 0 : _ctx$dataVerification8.optionLabel_zh_tw;

      if (type === "dropdown") {
        hintValue += "請選擇下拉清單中的選項";
      } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
        hintValue += "\u8ACB\u8F38\u5165".concat(optionLabel_zh_tw[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u9593");
        }

        hintValue += "\u7684".concat(optionLabel_zh_tw[type]);
      } else if (type === "text_content") {
        hintValue += "\u8ACB\u8F38\u5165\u5167\u5BB9".concat(optionLabel_zh_tw[type2]).concat(value1, "\u7684\u6587\u672C");
      } else if (type === "text_length") {
        hintValue += "\u8ACB\u8F38\u5165\u9577\u5EA6".concat(optionLabel_zh_tw[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u9593");
        }

        hintValue += "的文本";
      } else if (type === "date") {
        hintValue += "\u8ACB\u8F38\u5165".concat(optionLabel_zh_tw[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "\u548C".concat(value2, "\u4E4B\u9593");
        }

        hintValue += "的日期";
      } else if (type === "validity") {
        hintValue += "\u8ACB\u8F38\u5165\u6B63\u78BA\u7684".concat(optionLabel_zh_tw[type2]);
      }
    } else if (lang === "es") {
      var _ctx$dataVerification9;

      var optionLabel_es = (_ctx$dataVerification9 = ctx.dataVerification) === null || _ctx$dataVerification9 === void 0 ? void 0 : _ctx$dataVerification9.optionLabel_es;

      if (type === "dropdown") {
        hintValue += "Por favor, elija una opción en la lista desplegable";
      } else if (type === "checkbox") ; else if (type === "number" || type === "number_integer" || type === "number_decimal") {
        hintValue += "Por favor, introduzca".concat(optionLabel_es[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "Y".concat(value2, "Entre");
        }

        hintValue += "De".concat(optionLabel_es[type]);
      } else if (type === "text_content") {
        hintValue += "Por favor, introduzca el contenido".concat(optionLabel_es[type2]).concat(value1, "Texto");
      } else if (type === "text_length") {
        hintValue += "Por favor, introduzca la longitud".concat(optionLabel_es[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "Y".concat(value2, "Entre");
        }

        hintValue += "Texto";
      } else if (type === "date") {
        hintValue += "Por favor, introduzca".concat(optionLabel_es[type2]).concat(value1);

        if (type2 === "between" || type2 === "notBetween") {
          hintValue += "Y".concat(value2, "Entre");
        }

        hintValue += "Fecha";
      } else if (type === "validity") {
        hintValue += "Por favor, introduzca lo correcto.".concat(optionLabel_es[type2]);
      }
    }
  }

  return hintValue;
}
function cellFocus(ctx, r, c, clickMode) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var showHintBox = document.getElementById("luckysheet-dataVerification-showHintBox");
  var dropDownBtn = document.getElementById("luckysheet-dataVerification-dropdown-btn");
  ctx.dataVerificationDropDownList = false;
  if (!showHintBox || !dropDownBtn) return;
  showHintBox.style.display = "none";
  dropDownBtn.style.display = "none";
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var dataVerification = ctx.luckysheetfile[index].dataVerification;
  ctx.dataVerificationDropDownList = false;
  if (!dataVerification) return;
  var row = ctx.visibledatarow[r];
  var row_pre = r === 0 ? 0 : ctx.visibledatarow[r - 1];
  var col = ctx.visibledatacolumn[c];
  var col_pre = c === 0 ? 0 : ctx.visibledatacolumn[c - 1];
  var d = getFlowdata(ctx);
  if (!d) return;
  var margeSet = mergeBorder(ctx, d, r, c);

  if (margeSet) {
    var _margeSet$row = _slicedToArray(margeSet.row, 2);

    row_pre = _margeSet$row[0];
    row = _margeSet$row[1];

    var _margeSet$column = _slicedToArray(margeSet.column, 2);

    col_pre = _margeSet$column[0];
    col = _margeSet$column[1];
  }

  var item = dataVerification["".concat(r, "_").concat(c)];
  if (!item) return;

  if (clickMode && item.type === "checkbox") {
    checkboxChange(ctx, r, c);
  }

  if (item.type === "dropdown") {
    dropDownBtn.style.display = "block";
    dropDownBtn.style.maxWidth = "".concat(col - col_pre, "px");
    dropDownBtn.style.maxHeight = "".concat(row - row_pre, "px");
    dropDownBtn.style.left = "".concat(col - 20, "px");
    dropDownBtn.style.top = "".concat(row_pre + (row - row_pre - 20) / 2 - 2, "px");
  }

  if (item.hintShow) {
    var hintText = "";
    var lang = ctx.lang;

    if (lang === "en") {
      hintText = '<span style="color:#f5a623;">Hint: </span>';
    } else if (lang === "zh" || lang === "zh-CN") {
      hintText = '<span style="color:#f5a623;">提示：</span>';
    } else if (lang === "zh-TW") {
      hintText = '<span style="color:#f5a623;">提示：</span>';
    } else if (lang === "es") {
      hintText = '<span style="color:#f5a623;">Consejos：</span>';
    } else if (lang === "hi") {
      hintText = '<span style="color:#f5a623;">सुझाव: </span>';
    }

    hintText += getHintText(ctx, item);
    showHintBox.innerHTML = hintText;
    showHintBox.style.display = "block";
    showHintBox.style.left = "".concat(col_pre, "px");
    showHintBox.style.top = "".concat(row, "px");
  }

  var cellValue = getCellValue(r, c, d);

  if (isRealNull(cellValue)) {
    return;
  }

  var validate = validateCellData(ctx, item, cellValue);

  if (!validate) {
    var failureText = "";
    var _lang = ctx.lang;

    if (_lang === "en") {
      failureText = '<span style="color:#f72626;">Failure: </span>';
    } else if (_lang === "zh" || _lang === "zh-CN") {
      failureText = '<span style="color:#f72626;">失效：</span>';
    } else if (_lang === "zh-TW") {
      failureText = '<span style="color:#f72626;">失效：</span>';
    } else if (_lang === "es") {
      failureText = '<span style="color:#f72626;">Caducidad: </span>';
    } else if (_lang === "hi") {
      failureText = '<span style="color:#f72626;">असफलता: </span>';
    }

    failureText += getFailureText(ctx, item);
    showHintBox.innerHTML = failureText;
    showHintBox.style.display = "block";
    showHintBox.style.left = "".concat(col_pre, "px");
    showHintBox.style.top = "".concat(row, "px");
  }
}
function setDropcownValue(ctx, value, arr) {
  if (!ctx.luckysheet_select_save) return;
  var d = getFlowdata(ctx);
  if (!d) return;
  var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
  var rowIndex = last.row_focus;
  var colIndex = last.column_focus;
  if (rowIndex == null || colIndex == null) return;
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var item = ctx.luckysheetfile[index].dataVerification["".concat(rowIndex, "_").concat(colIndex)];

  if (item.type2 === "true") {
    value = item.value1.split(",").filter(function (v) {
      return arr.indexOf(v) >= 0;
    }).join(",");
  } else {
    ctx.dataVerificationDropDownList = false;
  }

  setCellValue(ctx, rowIndex, colIndex, d, value);
  jfrefreshgrid(ctx, null, undefined);
}
function confirmMessage(ctx, generalDialog, dataVerification) {
  var _ctx$dataVerification10, _ctx$dataVerification11;

  var range = getRangeByTxt(ctx, (_ctx$dataVerification10 = ctx.dataVerification) === null || _ctx$dataVerification10 === void 0 ? void 0 : (_ctx$dataVerification11 = _ctx$dataVerification10.dataRegulation) === null || _ctx$dataVerification11 === void 0 ? void 0 : _ctx$dataVerification11.rangeTxt);

  if (range.length === 0) {
    ctx.warnDialog = generalDialog.noSeletionError;
    return false;
  }

  var str = range[range.length - 1].row[0];
  var edr = range[range.length - 1].row[1];
  var stc = range[range.length - 1].column[0];
  var edc = range[range.length - 1].column[1];
  var d = getFlowdata(ctx);
  if (!d) return false;

  if (str < 0) {
    str = 0;
  }

  if (edr > d.length - 1) {
    edr = d.length - 1;
  }

  if (stc < 0) {
    stc = 0;
  }

  if (edc > d[0].length - 1) {
    edc = d[0].length - 1;
  }

  var regulation = ctx.dataVerification.dataRegulation;
  var verifacationT = regulation === null || regulation === void 0 ? void 0 : regulation.type;
  var value1 = regulation.value1,
      value2 = regulation.value2,
      type2 = regulation.type2;
  var v1 = parseFloat(value1).toString() !== "NaN";
  var v2 = parseFloat(value2).toString() !== "NaN";

  if (verifacationT === "dropdown") {
    if (!value1) {
      ctx.warnDialog = dataVerification.tooltipInfo1;
    }
  } else if (verifacationT === "checkbox") {
    if (!value1 || !value2) {
      ctx.warnDialog = dataVerification.tooltipInfo2;
    }
  } else if (verifacationT === "number" || verifacationT === "number_integer" || verifacationT === "number_decimal") {
    if (!v1) {
      ctx.warnDialog = dataVerification.tooltipInfo3;
      return false;
    }

    if (type2 === "between" || type2 === "notBetween") {
      if (!v2) {
        ctx.warnDialog = dataVerification.tooltipInfo3;
        return false;
      }

      if (Number(value2) < Number(value1)) {
        ctx.warnDialog = dataVerification.tooltipInfo4;
        return false;
      }
    }
  } else if (verifacationT === "text_content") {
    if (!value1) {
      ctx.warnDialog = dataVerification.tooltipInfo5;
      return false;
    }
  } else if (verifacationT === "text_length") {
    if (!v1) {
      ctx.warnDialog = dataVerification.tooltipInfo3;
      return false;
    }

    if (!Number.isInteger(Number(value1)) || Number(value1) < 0) {
      ctx.warnDialog = dataVerification.textlengthInteger;
      return false;
    }

    if (type2 === "between" || type2 === "notBetween") {
      if (!v2) {
        ctx.warnDialog = dataVerification.tooltipInfo3;
        return false;
      }

      if (!Number.isInteger(Number(value2)) || Number(value2) < 0) {
        ctx.warnDialog = dataVerification.textlengthInteger;
        return false;
      }

      if (Number(value2) < Number(value1)) {
        ctx.warnDialog = dataVerification.tooltipInfo4;
        return false;
      }
    }
  } else if (verifacationT === "date") {
    if (!isdatetime(value1)) {
      ctx.warnDialog = dataVerification.tooltipInfo6;
      return false;
    }

    if (type2 === "between" || type2 === "notBetween") {
      if (!isdatetime(value2)) {
        ctx.warnDialog = dataVerification.tooltipInfo6;
        return false;
      }

      if (diff(value1, value2) > 0) {
        ctx.warnDialog = dataVerification.tooltipInfo7;
        return false;
      }
    }
  }

  return true;
}

function normalizedCellAttr(cell, attr) {
  var defaultFontSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var tf = {
    bl: 1,
    it: 1,
    ff: 1,
    cl: 1,
    un: 1
  };
  var value = cell === null || cell === void 0 ? void 0 : cell[attr];

  if (attr in tf || attr === "fs" && isInlineStringCell(cell)) {
    value || (value = "0");
  } else if (["fc", "bg", "bc"].includes(attr)) {
    var _value;

    if (["fc", "bc"].includes(attr)) {
      value || (value = "#000000");
    }

    if (((_value = value) === null || _value === void 0 ? void 0 : _value.indexOf("rgba")) > -1) {
      value = rgbToHex(value);
    }
  } else if (attr.substring(0, 2) === "bs") {
    value || (value = "none");
  } else if (attr === "ht" || attr === "vt") {
    var defaultValue = attr === "ht" ? "1" : "0";
    value = !_.isNil(value) ? value.toString() : defaultValue;

    if (["0", "1", "2"].indexOf(value.toString()) === -1) {
      value = defaultValue;
    }
  } else if (attr === "fs") {
    value || (value = defaultFontSize.toString());
  } else if (attr === "tb" || attr === "tr") {
    value || (value = "0");
  }

  return value;
}
function normalizedAttr(data, r, c, attr) {
  if (!data || !data[r]) {
    console.warn("cell (%d, %d) is null", r, c);
    return null;
  }

  var cell = data[r][c];
  if (!cell) return undefined;
  return normalizedCellAttr(cell, attr);
}
function getCellValue(r, c, data, attr) {
  if (!attr) {
    attr = "v";
  }

  var d_value;

  if (!_.isNil(r) && !_.isNil(c)) {
    d_value = data[r][c];
  } else if (!_.isNil(r)) {
    d_value = data[r];
  } else if (!_.isNil(c)) {
    var newData = data[0].map(function (col, i) {
      return data.map(function (row) {
        return row[i];
      });
    });
    d_value = newData[c];
  } else {
    return data;
  }

  var retv = d_value;

  if (_.isPlainObject(d_value)) {
    var d = d_value;
    retv = d[attr];

    if (attr === "f" && !_.isNil(retv)) {
      retv = functionHTMLGenerate(retv);
    } else if (attr === "f") {
      retv = d.v;
    } else if (d && d.ct && d.ct.t === "d") {
      retv = d.m;
    }
  }

  if (retv === undefined) {
    retv = null;
  }

  return retv;
}
function setCellValue(ctx, r, c, d, v) {
  var _cell$ct, _cell$ct2, _cell$ct3, _cell$ct4, _cell$ct5, _cell$ct6;

  if (_.isNil(d)) {
    d = getFlowdata(ctx);
  }

  if (!d) return;
  var cell = d[r][c];
  var vupdate;

  if (_.isPlainObject(v)) {
    if (_.isNil(cell)) {
      cell = v;
    } else {
      if (!_.isNil(v.f)) {
        cell.f = v.f;
      } else if ("f" in cell) {
        delete cell.f;
      }

      if (!_.isNil(v.ct)) {
        cell.ct = v.ct;
      }
    }

    if (_.isPlainObject(v.v)) {
      vupdate = v.v.v;
    } else {
      vupdate = v.v;
    }
  } else {
    vupdate = v;
  }

  if (isRealNull(vupdate)) {
    if (_.isPlainObject(cell)) {
      delete cell.m;
      delete cell.v;
    } else {
      cell = null;
    }

    d[r][c] = cell;
    return;
  }

  if (isRealNull(cell) || (_.isString(cell) || _.isNumber(cell)) && cell === v) {
    cell = {};
  }

  if (!cell) return;
  var vupdateStr = vupdate.toString();

  if (vupdateStr.substr(0, 1) === "'") {
    cell.m = vupdateStr.substr(1);
    cell.ct = {
      fa: "@",
      t: "s"
    };
    cell.v = vupdateStr.substr(1);
    cell.qp = 1;
  } else if (cell.qp === 1) {
    cell.m = vupdateStr;
    cell.ct = {
      fa: "@",
      t: "s"
    };
    cell.v = vupdateStr;
  } else if (vupdateStr.toUpperCase() === "TRUE" && (_.isNil((_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : _cell$ct.fa) || ((_cell$ct2 = cell.ct) === null || _cell$ct2 === void 0 ? void 0 : _cell$ct2.fa) !== "@")) {
    cell.m = "TRUE";
    cell.ct = {
      fa: "General",
      t: "b"
    };
    cell.v = true;
  } else if (vupdateStr.toUpperCase() === "FALSE" && (_.isNil((_cell$ct3 = cell.ct) === null || _cell$ct3 === void 0 ? void 0 : _cell$ct3.fa) || ((_cell$ct4 = cell.ct) === null || _cell$ct4 === void 0 ? void 0 : _cell$ct4.fa) !== "@")) {
    cell.m = "FALSE";
    cell.ct = {
      fa: "General",
      t: "b"
    };
    cell.v = false;
  } else if (vupdateStr.substr(-1) === "%" && isRealNum(vupdateStr.substring(0, vupdateStr.length - 1)) && (_.isNil((_cell$ct5 = cell.ct) === null || _cell$ct5 === void 0 ? void 0 : _cell$ct5.fa) || ((_cell$ct6 = cell.ct) === null || _cell$ct6 === void 0 ? void 0 : _cell$ct6.fa) !== "@")) {
    cell.ct = {
      fa: "0%",
      t: "n"
    };
    cell.v = vupdateStr.substring(0, vupdateStr.length - 1) / 100;
    cell.m = vupdate;
  } else if (valueIsError(vupdate)) {
    cell.m = vupdateStr;

    if (!_.isNil(cell.ct)) {
      cell.ct.t = "e";
    } else {
      cell.ct = {
        fa: "General",
        t: "e"
      };
    }

    cell.v = vupdate;
  } else {
    if (!_.isNil(cell.f) && isRealNum(vupdate) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(vupdate)) {
      cell.v = parseFloat(vupdate);

      if (_.isNil(cell.ct)) {
        cell.ct = {
          fa: "General",
          t: "n"
        };
      }

      if (cell.v === Infinity || cell.v === -Infinity) {
        cell.m = cell.v.toString();
      } else {
        if (cell.v.toString().indexOf("e") > -1) {
          var len;

          if (cell.v.toString().split(".").length === 1) {
            len = 0;
          } else {
            len = cell.v.toString().split(".")[1].split("e")[0].length;
          }

          if (len > 5) {
            len = 5;
          }

          cell.m = cell.v.toExponential(len).toString();
        } else {
          var v_p = Math.round(cell.v * 1000000000) / 1000000000;

          if (_.isNil(cell.ct)) {
            var mask = genarate(v_p);

            if (mask != null) {
              cell.m = mask[0].toString();
            }
          } else {
            var _mask = update(cell.ct.fa, v_p);

            cell.m = _mask.toString();
          }
        }
      }
    } else if (!_.isNil(cell.ct) && cell.ct.fa === "@") {
      cell.m = vupdateStr;
      cell.v = vupdate;
    } else if (cell.ct != null && cell.ct.t === "d" && _.isString(vupdate)) {
      var _mask2 = genarate(vupdate);

      if (_mask2[1].t !== "d" || _mask2[1].fa === cell.ct.fa) {
        var _mask3 = _slicedToArray(_mask2, 3);

        cell.m = _mask3[0];
        cell.ct = _mask3[1];
        cell.v = _mask3[2];
      } else {
        var _mask4 = _slicedToArray(_mask2, 3);

        cell.v = _mask4[2];
        cell.m = update(cell.ct.fa, cell.v);
      }
    } else if (!_.isNil(cell.ct) && !_.isNil(cell.ct.fa) && cell.ct.fa !== "General") {
      if (isRealNum(vupdate)) {
        vupdate = parseFloat(vupdate);
      }

      var _mask5 = update(cell.ct.fa, vupdate);

      if (_mask5 === vupdate) {
        _mask5 = genarate(vupdate);
        cell.m = _mask5[0].toString();
        var _mask6 = _mask5;

        var _mask7 = _slicedToArray(_mask6, 3);

        cell.ct = _mask7[1];
        cell.v = _mask7[2];
      } else {
        cell.m = _mask5.toString();
        cell.v = vupdate;
      }
    } else {
      if (isRealNum(vupdate) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(vupdate)) {
        if (typeof vupdate === "string") {
          var flag = vupdate.split("").every(function (ele) {
            return ele === "0" || ele === ".";
          });

          if (flag) {
            vupdate = parseFloat(vupdate);
          }
        }

        cell.v = vupdate;
        cell.ct = {
          fa: "General",
          t: "n"
        };

        if (cell.v === Infinity || cell.v === -Infinity) {
          cell.m = cell.v.toString();
        } else if (cell.v != null) {
          var _mask8 = genarate(cell.v);

          if (_mask8) {
            cell.m = _mask8[0].toString();
          }
        }
      } else {
        var _mask9 = genarate(vupdate);

        if (_mask9) {
          cell.m = _mask9[0].toString();

          var _mask10 = _slicedToArray(_mask9, 3);

          cell.ct = _mask10[1];
          cell.v = _mask10[2];
        }
      }
    }
  }

  d[r][c] = cell;
}
function getRealCellValue(r, c, data, attr) {
  var value = getCellValue(r, c, data, "m");

  if (_.isNil(value)) {
    value = getCellValue(r, c, data, attr);

    if (_.isNil(value)) {
      var ct = getCellValue(r, c, data, "ct");

      if (isInlineStringCT(ct)) {
        value = ct.s;
      }
    }
  }

  return value;
}
function mergeBorder(ctx, d, row_index, col_index) {
  if (!d || !d[row_index]) {
    console.warn("Merge info is null", row_index, col_index);
    return null;
  }

  var value = d[row_index][col_index];
  if (!value) return null;

  if (value === null || value === void 0 ? void 0 : value.mc) {
    var _d$row_index, _d$row_index2, _d$row_index2$col_ind, _d$row_index2$col_ind2, _d$row_index3, _d$row_index3$col_ind, _d$row_index3$col_ind2, _d$row_index4, _d$row_index4$col_ind;

    var margeMaindata = value.mc;

    if (!margeMaindata) {
      console.warn("Merge info is null", row_index, col_index);
      return null;
    }

    col_index = margeMaindata.c;
    row_index = margeMaindata.r;

    if (_.isNil(d === null || d === void 0 ? void 0 : (_d$row_index = d[row_index]) === null || _d$row_index === void 0 ? void 0 : _d$row_index[col_index])) {
      console.warn("Main merge Cell info is null", row_index, col_index);
      return null;
    }

    var col_rs = (_d$row_index2 = d[row_index]) === null || _d$row_index2 === void 0 ? void 0 : (_d$row_index2$col_ind = _d$row_index2[col_index]) === null || _d$row_index2$col_ind === void 0 ? void 0 : (_d$row_index2$col_ind2 = _d$row_index2$col_ind.mc) === null || _d$row_index2$col_ind2 === void 0 ? void 0 : _d$row_index2$col_ind2.cs;
    var row_rs = (_d$row_index3 = d[row_index]) === null || _d$row_index3 === void 0 ? void 0 : (_d$row_index3$col_ind = _d$row_index3[col_index]) === null || _d$row_index3$col_ind === void 0 ? void 0 : (_d$row_index3$col_ind2 = _d$row_index3$col_ind.mc) === null || _d$row_index3$col_ind2 === void 0 ? void 0 : _d$row_index3$col_ind2.rs;
    var mergeMain = (_d$row_index4 = d[row_index]) === null || _d$row_index4 === void 0 ? void 0 : (_d$row_index4$col_ind = _d$row_index4[col_index]) === null || _d$row_index4$col_ind === void 0 ? void 0 : _d$row_index4$col_ind.mc;

    if (!mergeMain || _.isNil(mergeMain === null || mergeMain === void 0 ? void 0 : mergeMain.rs) || _.isNil(mergeMain === null || mergeMain === void 0 ? void 0 : mergeMain.cs) || _.isNil(col_rs) || _.isNil(row_rs)) {
      console.warn("Main merge info is null", mergeMain);
      return null;
    }

    var start_r;
    var end_r;
    var row;
    var row_pre;

    for (var r = row_index; r < mergeMain.rs + row_index; r += 1) {
      if (r === 0) {
        start_r = -1;
      } else {
        start_r = ctx.visibledatarow[r - 1] - 1;
      }

      end_r = ctx.visibledatarow[r];

      if (row_pre === undefined) {
        row_pre = start_r;
        row = end_r;
      } else if (row !== undefined) {
        row += end_r - start_r - 1;
      }
    }

    var start_c;
    var end_c;
    var col;
    var col_pre;

    for (var c = col_index; c < mergeMain.cs + col_index; c += 1) {
      if (c === 0) {
        start_c = 0;
      } else {
        start_c = ctx.visibledatacolumn[c - 1];
      }

      end_c = ctx.visibledatacolumn[c];

      if (col_pre === undefined) {
        col_pre = start_c;
        col = end_c;
      } else if (col !== undefined) {
        col += end_c - start_c;
      }
    }

    if (_.isNil(row_pre) || _.isNil(col_pre) || _.isNil(row) || _.isNil(col)) {
      console.warn("Main merge info row_pre or col_pre or row or col is null", mergeMain);
      return null;
    }

    return {
      row: [row_pre, row, row_index, row_index + row_rs - 1],
      column: [col_pre, col, col_index, col_index + col_rs - 1]
    };
  }

  return null;
}

function mergeMove(ctx, mc, columnseleted, rowseleted, s, top, height, left, width) {
  var row_st = mc.r;
  var row_ed = mc.r + mc.rs - 1;
  var col_st = mc.c;
  var col_ed = mc.c + mc.cs - 1;
  var ismatch = false;
  columnseleted[0] = Math.min(columnseleted[0], columnseleted[1]);
  rowseleted[0] = Math.min(rowseleted[0], rowseleted[1]);

  if (columnseleted[0] <= col_st && columnseleted[1] >= col_ed && rowseleted[0] <= row_st && rowseleted[1] >= row_ed || !(columnseleted[1] < col_st || columnseleted[0] > col_ed) && !(rowseleted[1] < row_st || rowseleted[0] > row_ed)) {
    var flowdata = getFlowdata(ctx);
    if (!flowdata) return null;
    var margeset = mergeBorder(ctx, flowdata, mc.r, mc.c);

    if (margeset) {
      var row = margeset.row[1];
      var row_pre = margeset.row[0];
      var col = margeset.column[1];
      var col_pre = margeset.column[0];

      if (!(columnseleted[1] < col_st || columnseleted[0] > col_ed)) {
        if (rowseleted[0] <= row_ed && rowseleted[0] >= row_st) {
          height += top - row_pre;
          top = row_pre;
          rowseleted[0] = row_st;
        }

        if (rowseleted[1] >= row_st && rowseleted[1] <= row_ed) {
          if (s.row_focus >= row_st && s.row_focus <= row_ed) {
            height = row - top;
          } else {
            height = row - top;
          }

          rowseleted[1] = row_ed;
        }
      }

      if (!(rowseleted[1] < row_st || rowseleted[0] > row_ed)) {
        if (columnseleted[0] <= col_ed && columnseleted[0] >= col_st) {
          width += left - col_pre;
          left = col_pre;
          columnseleted[0] = col_st;
        }

        if (columnseleted[1] >= col_st && columnseleted[1] <= col_ed) {
          if (s.column_focus >= col_st && s.column_focus <= col_ed) {
            width = col - left;
          } else {
            width = col - left;
          }

          columnseleted[1] = col_ed;
        }
      }

      ismatch = true;
    }
  }

  if (ismatch) {
    return [columnseleted, rowseleted, top, height, left, width];
  }

  return null;
}

function mergeMoveMain(ctx, columnseleted, rowseleted, s, top, height, left, width) {
  var mergesetting = ctx.config.merge;

  if (!mergesetting) {
    return null;
  }

  var mcset = Object.keys(mergesetting);
  rowseleted[1] = Math.max(rowseleted[0], rowseleted[1]);
  columnseleted[1] = Math.max(columnseleted[0], columnseleted[1]);
  var offloop = true;
  var mergeMoveData = {};

  while (offloop) {
    offloop = false;

    for (var i = 0; i < mcset.length; i += 1) {
      var key = mcset[i];
      var mc = mergesetting[key];

      if (key in mergeMoveData) {
        continue;
      }

      var changeparam = mergeMove(ctx, mc, columnseleted, rowseleted, s, top, height, left, width);

      if (changeparam != null) {
        mergeMoveData[key] = mc;

        var _changeparam = _slicedToArray(changeparam, 6);

        columnseleted = _changeparam[0];
        rowseleted = _changeparam[1];
        top = _changeparam[2];
        height = _changeparam[3];
        left = _changeparam[4];
        width = _changeparam[5];
        offloop = true;
      } else {
        delete mergeMoveData[key];
      }
    }
  }

  return [columnseleted, rowseleted, top, height, left, width];
}
function cancelFunctionrangeSelected(ctx) {
  if (ctx.formulaCache.selectingRangeIndex === -1) {
    ctx.formulaRangeSelect = undefined;
  }
}
function cancelNormalSelected(ctx) {
  cancelFunctionrangeSelected(ctx);
  ctx.luckysheetCellUpdate = [];
  ctx.formulaRangeHighlight = [];
  ctx.functionHint = null;
  ctx.formulaCache.rangestart = false;
  ctx.formulaCache.rangedrag_column_start = false;
  ctx.formulaCache.rangedrag_row_start = false;
}
function updateCell(ctx, r, c, $input, value, canvas) {
  var _inputText, _curv, _ctx$hooks$beforeUpda, _ctx$hooks, _curv2;

  var inputText = $input === null || $input === void 0 ? void 0 : $input.innerText;
  var inputHtml = $input === null || $input === void 0 ? void 0 : $input.innerHTML;
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var dataVerification = ctx.luckysheetfile[index].dataVerification;

  if (!_.isNil(dataVerification)) {
    var dvItem = dataVerification["".concat(r, "_").concat(c)];

    if (!_.isNil(dvItem) && dvItem.prohibitInput && !validateCellData(ctx, dvItem, inputText)) {
      var failureText = getFailureText(ctx, dvItem);
      cancelNormalSelected(ctx);
      ctx.warnDialog = failureText;
      return;
    }
  }

  var curv = flowdata[r][c];

  var oldValue = _.cloneDeep(curv);

  var isPrevInline = isInlineStringCell(curv);
  var isCurInline = ((_inputText = inputText) === null || _inputText === void 0 ? void 0 : _inputText.slice(0, 1)) !== "=" && (inputHtml === null || inputHtml === void 0 ? void 0 : inputHtml.substring(0, 5)) === "<span";
  var isCopyVal = false;

  if (!isCurInline && inputText && inputText.length > 0) {
    var splitArr = inputText.replace(/\r\n/g, "_x000D_").replace(/&#13;&#10;/g, "_x000D_").replace(/\r/g, "_x000D_").replace(/\n/g, "_x000D_").split("_x000D_");

    if (splitArr.length > 1 && inputHtml !== "<br>") {
      isCopyVal = true;
      isCurInline = true;
      inputText = splitArr.join("\r\n");
    }
  }

  if (((_curv = curv) === null || _curv === void 0 ? void 0 : _curv.ct) && !value && !isCurInline && isPrevInline) {
    delete curv.ct.s;
    curv.ct.t = "g";
    curv.ct.fa = "General";
    value = "";
  } else if (isCurInline) {
    if (!_.isPlainObject(curv)) {
      curv = {};
    }

    curv || (curv = {});
    var fontSize = curv.fs || 10;

    if (!curv.ct) {
      curv.ct = {};
      curv.ct.fa = "General";
    }

    curv.ct.t = "inlineStr";
    curv.ct.s = convertSpanToShareString($input.querySelectorAll("span"), curv);
    delete curv.fs;
    delete curv.f;
    delete curv.v;
    delete curv.m;
    curv.fs = fontSize;

    if (isCopyVal) {
      curv.ct.s = [{
        v: inputText,
        fs: fontSize
      }];
    }
  }

  value = value || ($input === null || $input === void 0 ? void 0 : $input.innerText);

  if (((_ctx$hooks$beforeUpda = (_ctx$hooks = ctx.hooks).beforeUpdateCell) === null || _ctx$hooks$beforeUpda === void 0 ? void 0 : _ctx$hooks$beforeUpda.call(_ctx$hooks, r, c, value)) === false) {
    cancelNormalSelected(ctx);
    return;
  }

  if (!isCurInline) {
    if (isRealNull(value) && !isPrevInline) {
      if (!curv || isRealNull(curv.v) && !curv.spl && !curv.f) {
        cancelNormalSelected(ctx);
        return;
      }
    } else if (curv && curv.qp !== 1) {
      if (_.isPlainObject(curv) && (value === curv.f || value === curv.v || value === curv.m)) {
        cancelNormalSelected(ctx);
        return;
      }

      if (value === curv) {
        cancelNormalSelected(ctx);
        return;
      }
    }

    if (_.isString(value) && value.slice(0, 1) === "=" && value.length > 1) ; else if (_.isPlainObject(curv) && curv && curv.ct && curv.ct.fa && curv.ct.fa !== "@" && !isRealNull(value)) {
      delete curv.m;

      if (curv.f) {
        delete curv.f;
        delete curv.spl;
      }
    }
  }
  var d = flowdata;
  var dynamicArrayItem = null;

  if (_.isPlainObject(curv)) {
    if (!isCurInline) {
      if (_.isString(value) && value.slice(0, 1) === "=" && value.length > 1) {
        var _d$r;

        var v = execfunction(ctx, value, r, c, undefined, undefined, true);
        curv = _.cloneDeep((d === null || d === void 0 ? void 0 : (_d$r = d[r]) === null || _d$r === void 0 ? void 0 : _d$r[c]) || {});

        var _v = _slicedToArray(v, 3);

        curv.v = _v[1];
        curv.f = _v[2];

        if (v.length === 4 && v[3].type === "sparklines") {
          delete curv.m;
          delete curv.v;
          var curCalv = v[3].data;

          if (_.isArray(curCalv) && !_.isPlainObject(curCalv[0])) {
            var _curCalv = _slicedToArray(curCalv, 1);

            curv.v = _curCalv[0];
          } else {
            curv.spl = v[3].data;
          }
        } else if (v.length === 4 && v[3].type === "dynamicArrayItem") {
          dynamicArrayItem = v[3].data;
        }
      } else if (_.isPlainObject(value)) {
        var valueFunction = value.f;

        if (_.isString(valueFunction) && valueFunction.slice(0, 1) === "=" && valueFunction.length > 1) {
          var _d$r2;

          var _v2 = execfunction(ctx, valueFunction, r, c, undefined, undefined, true);
          curv = _.cloneDeep((d === null || d === void 0 ? void 0 : (_d$r2 = d[r]) === null || _d$r2 === void 0 ? void 0 : _d$r2[c]) || {});

          var _v3 = _slicedToArray(_v2, 3);

          curv.v = _v3[1];
          curv.f = _v3[2];

          if (_v2.length === 4 && _v2[3].type === "sparklines") {
            delete curv.m;
            delete curv.v;
            var _curCalv2 = _v2[3].data;

            if (_.isArray(_curCalv2) && !_.isPlainObject(_curCalv2[0])) {
              var _curCalv3 = _slicedToArray(_curCalv2, 1);

              curv.v = _curCalv3[0];
            } else {
              curv.spl = _v2[3].data;
            }
          } else if (_v2.length === 4 && _v2[3].type === "dynamicArrayItem") {
            dynamicArrayItem = _v2[3].data;
          }
        } else {
          Object.keys(value).forEach(function (attr) {
            curv[attr] = value[attr];
          });
        }
      } else {
        var _d$r3;

        delFunctionGroup(ctx, r, c);
        execFunctionGroup(ctx, r, c, value);
        curv = _.cloneDeep((d === null || d === void 0 ? void 0 : (_d$r3 = d[r]) === null || _d$r3 === void 0 ? void 0 : _d$r3[c]) || {});
        curv.v = value;
        delete curv.f;
        delete curv.spl;

        if (curv.qp === 1 && "".concat(value).substring(0, 1) !== "'") {
          curv.qp = 0;

          if (curv.ct) {
            curv.ct.fa = "General";
            curv.ct.t = "n";
          }
        }
      }
    }

    value = curv;
  } else {
    if (_.isString(value) && value.slice(0, 1) === "=" && value.length > 1) {
      var _v4 = execfunction(ctx, value, r, c, undefined, undefined, true);
      value = {
        v: _v4[1],
        f: _v4[2]
      };

      if (_v4.length === 4 && _v4[3].type === "sparklines") {
        var _curCalv4 = _v4[3].data;

        if (_.isArray(_curCalv4) && !_.isPlainObject(_curCalv4[0])) {
          var _curCalv5 = _slicedToArray(_curCalv4, 1);

          value.v = _curCalv5[0];
        } else {
          value.spl = _v4[3].data;
        }
      } else if (_v4.length === 4 && _v4[3].type === "dynamicArrayItem") {
        dynamicArrayItem = _v4[3].data;
      }
    } else if (_.isPlainObject(value)) {
      var _valueFunction = value.f;

      if (_.isString(_valueFunction) && _valueFunction.slice(0, 1) === "=" && _valueFunction.length > 1) {
        var _v5 = execfunction(ctx, _valueFunction, r, c, undefined, undefined, true);

        var _v6 = _slicedToArray(_v5, 3);

        value.v = _v6[1];
        value.f = _v6[2];

        if (_v5.length === 4 && _v5[3].type === "sparklines") {
          var _curCalv6 = _v5[3].data;

          if (_.isArray(_curCalv6) && !_.isPlainObject(_curCalv6[0])) {
            var _curCalv7 = _slicedToArray(_curCalv6, 1);

            value.v = _curCalv7[0];
          } else {
            value.spl = _v5[3].data;
          }
        } else if (_v5.length === 4 && _v5[3].type === "dynamicArrayItem") {
          dynamicArrayItem = _v5[3].data;
        }
      } else {
        var _v7 = curv;

        if (_.isNil(value.v)) {
          value.v = _v7;
        }
      }
    } else {
      delFunctionGroup(ctx, r, c);
      execFunctionGroup(ctx, r, c, value);
    }
  }

  setCellValue(ctx, r, c, d, value);
  cancelNormalSelected(ctx);

  if (((_curv2 = curv) === null || _curv2 === void 0 ? void 0 : _curv2.tb) === "2" && curv.v || isInlineStringCell(d[r][c])) {
    var _cfg$columnlen, _cfg$rowlen;

    var defaultrowlen = ctx.defaultrowlen;
    var cfg = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].config || {};

    if (!(((_cfg$columnlen = cfg.columnlen) === null || _cfg$columnlen === void 0 ? void 0 : _cfg$columnlen[c]) && ((_cfg$rowlen = cfg.rowlen) === null || _cfg$rowlen === void 0 ? void 0 : _cfg$rowlen[r]))) {
      var _cfg$columnlen2, _cfg$customHeight;

      var cellWidth = ((_cfg$columnlen2 = cfg.columnlen) === null || _cfg$columnlen2 === void 0 ? void 0 : _cfg$columnlen2[c]) || ctx.defaultcollen;
      var textInfo = canvas ? getCellTextInfo(d[r][c], canvas, ctx, {
        r: r,
        c: c,
        cellWidth: cellWidth
      }) : null;
      var currentRowLen = defaultrowlen;

      if (textInfo) {
        currentRowLen = textInfo.textHeightAll + 2;
      }

      if (currentRowLen > defaultrowlen && !((_cfg$customHeight = cfg.customHeight) === null || _cfg$customHeight === void 0 ? void 0 : _cfg$customHeight[r])) {
        if (_.isNil(cfg.rowlen)) cfg.rowlen = {};
        cfg.rowlen[r] = currentRowLen;
      }
    }
  }

  if (ctx.hooks.afterUpdateCell) {
    var newValue = _.cloneDeep(flowdata[r][c]);

    var afterUpdateCell = ctx.hooks.afterUpdateCell;
    setTimeout(function () {
      afterUpdateCell === null || afterUpdateCell === void 0 ? void 0 : afterUpdateCell(r, c, oldValue, newValue);
    });
  }

  ctx.formulaCache.execFunctionGlobalData = null;
}
function getOrigincell(ctx, r, c, i) {
  var data = getFlowdata(ctx, i);

  if (_.isNil(r) || _.isNil(c)) {
    return null;
  }

  if (!data || !data[r] || !data[r][c]) {
    return null;
  }

  return data[r][c];
}
function getcellFormula(ctx, r, c, i, data) {
  var cell;

  if (_.isNil(data)) {
    cell = getOrigincell(ctx, r, c, i);
  } else {
    cell = data[r][c];
  }

  if (_.isNil(cell)) {
    return null;
  }

  return cell.f;
}
function getRange(ctx) {
  var rangeArr = _.cloneDeep(ctx.luckysheet_select_save);

  var result = [];
  if (!rangeArr) return result;

  for (var i = 0; i < rangeArr.length; i += 1) {
    var rangeItem = rangeArr[i];
    var temp = {
      row: rangeItem.row,
      column: rangeItem.column
    };
    result.push(temp);
  }

  return result;
}
function getFlattenedRange(ctx, range) {
  range = range || getRange(ctx);
  var result = [];
  range.forEach(function (ele) {
    var rs = ele.row;
    var cs = ele.column;

    for (var r = rs[0]; r <= rs[1]; r += 1) {
      for (var c = cs[0]; c <= cs[1]; c += 1) {
        result.push({
          r: r,
          c: c
        });
      }
    }
  });
  return result;
}
function getRangetxt(ctx, sheetId, range, currentId) {
  var sheettxt = "";

  if (currentId == null) {
    currentId = ctx.currentSheetId;
  }

  if (sheetId !== currentId) {
    var index = getSheetIndex(ctx, sheetId);
    if (index == null) return "";
    sheettxt = ctx.luckysheetfile[index].name.replace(/'/g, "''");

    if (/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/.test(sheettxt)) {
      sheettxt += "!";
    } else {
      sheettxt = "'".concat(sheettxt, "'!");
    }
  }

  var row0 = range.row[0];
  var row1 = range.row[1];
  var column0 = range.column[0];
  var column1 = range.column[1];

  if (row0 == null && row1 == null) {
    return "".concat(sheettxt + indexToColumnChar(column0), ":").concat(indexToColumnChar(column1));
  }

  if (column0 == null && column1 == null) {
    return "".concat(sheettxt + (row0 + 1), ":").concat(row1 + 1);
  }

  if (column0 === column1 && row0 === row1) {
    return sheettxt + indexToColumnChar(column0) + (row0 + 1);
  }

  return "".concat(sheettxt + indexToColumnChar(column0) + (row0 + 1), ":").concat(indexToColumnChar(column1)).concat(row1 + 1);
}
function getRangeByTxt(ctx, txt) {
  var range = [];

  if (txt.indexOf(",") !== -1) {
    var arr = txt.split(",");

    for (var i = 0; i < arr.length; i += 1) {
      if (iscelldata(arr[i])) {
        range.push(getcellrange(ctx, arr[i]));
      } else {
        range = [];
        break;
      }
    }
  } else {
    if (iscelldata(txt)) {
      range.push(getcellrange(ctx, txt));
    }
  }

  return range;
}
function isAllSelectedCellsInStatus(ctx, attr, status) {
  if (!_.isEmpty(ctx.luckysheetCellUpdate)) {
    var _startContainer$paren2, _endContainer$parentE;

    var w = window.getSelection();
    if (!w) return false;
    if (w.rangeCount === 0) return false;
    var range = w.getRangeAt(0);

    if (range.collapsed === true) {
      return false;
    }

    var endContainer = range.endContainer;
    var startContainer = range.startContainer;

    var cssField = _.camelCase(attrToCssName[attr]);

    if (startContainer === endContainer) {
      var _startContainer$paren;

      return !_.isEmpty((_startContainer$paren = startContainer.parentElement) === null || _startContainer$paren === void 0 ? void 0 : _startContainer$paren.style[cssField]);
    }

    if (((_startContainer$paren2 = startContainer.parentElement) === null || _startContainer$paren2 === void 0 ? void 0 : _startContainer$paren2.tagName) === "SPAN" && ((_endContainer$parentE = endContainer.parentElement) === null || _endContainer$parentE === void 0 ? void 0 : _endContainer$parentE.tagName) === "SPAN") {
      var _startSpan$parentNode;

      var startSpan = startContainer.parentNode;
      var endSpan = endContainer.parentNode;
      var allSpans = startSpan === null || startSpan === void 0 ? void 0 : (_startSpan$parentNode = startSpan.parentNode) === null || _startSpan$parentNode === void 0 ? void 0 : _startSpan$parentNode.querySelectorAll("span");

      if (allSpans) {
        var startSpanIndex = _.indexOf(allSpans, startSpan);

        var endSpanIndex = _.indexOf(allSpans, endSpan);

        var rangeSpans = [];

        for (var i = startSpanIndex; i <= endSpanIndex; i += 1) {
          rangeSpans.push(allSpans[i]);
        }

        return _.every(rangeSpans, function (s) {
          return !_.isEmpty(s.style[cssField]);
        });
      }
    }
  }

  var cells = getFlattenedRange(ctx);
  var flowdata = getFlowdata(ctx);
  return cells.every(function (_ref) {
    var _flowdata$r;

    var r = _ref.r,
        c = _ref.c;
    var cell = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$r = flowdata[r]) === null || _flowdata$r === void 0 ? void 0 : _flowdata$r[c];

    if (_.isNil(cell)) {
      return false;
    }

    return cell[attr] === status;
  });
}
function getFontStyleByCell(cell, checksAF, checksCF) {
  var isCheck = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var style = {};

  if (!cell) {
    return style;
  }

  _.forEach(cell, function (v, key) {
    var _checksAF$length;

    var value = cell[key];

    if (isCheck) {
      value = normalizedCellAttr(cell, key);
    }

    var valueNum = Number(value);

    if (key === "bl" && valueNum !== 0) {
      style.fontWeight = "bold";
    }

    if (key === "it" && valueNum !== 0) {
      style.fontStyle = "italic";
    }

    if (key === "fs" && valueNum !== 10) {
      style.fontSize = "".concat(valueNum, "pt");
    }

    if (key === "fc" && value !== "#000000" || ((_checksAF$length = checksAF === null || checksAF === void 0 ? void 0 : checksAF.length) !== null && _checksAF$length !== void 0 ? _checksAF$length : 0) > 0 || (checksCF === null || checksCF === void 0 ? void 0 : checksCF.textColor)) {
      var _checksAF$length2;

      if (checksCF === null || checksCF === void 0 ? void 0 : checksCF.textColor) {
        style.color = checksCF.textColor;
      } else if (((_checksAF$length2 = checksAF === null || checksAF === void 0 ? void 0 : checksAF.length) !== null && _checksAF$length2 !== void 0 ? _checksAF$length2 : 0) > 0) {
        var _checksAF = _slicedToArray(checksAF, 1);

        style.color = _checksAF[0];
      } else {
        style.color = value;
      }
    }

    if (key === "cl" && valueNum !== 0) {
      style.textDecoration = "line-through";
    }

    if (key === "un" && (valueNum === 1 || valueNum === 3)) {
      var _cell$_color, _cell$_fontSize;

      var color = (_cell$_color = cell._color) !== null && _cell$_color !== void 0 ? _cell$_color : cell.fc;
      var fs = (_cell$_fontSize = cell._fontSize) !== null && _cell$_fontSize !== void 0 ? _cell$_fontSize : cell.fs;
      style.borderBottom = "".concat(Math.floor(fs / 9), "px solid ").concat(color);
    }
  });

  return style;
}
function getStyleByCell(ctx, d, r, c) {
  var _d$r4;

  var style = {};
  var checksAF = [];
  var cf_compute = getComputeMap(ctx);
  var checksCF = checkCF(r, c, cf_compute);
  var cell = d === null || d === void 0 ? void 0 : (_d$r4 = d[r]) === null || _d$r4 === void 0 ? void 0 : _d$r4[c];
  if (!cell) return {};
  var isInline = isInlineStringCell(cell);

  if ("bg" in cell) {
    var value = normalizedCellAttr(cell, "bg");

    if (checksCF === null || checksCF === void 0 ? void 0 : checksCF.cellColor) {
      if (checksCF === null || checksCF === void 0 ? void 0 : checksCF.cellColor) {
        style.background = "".concat(checksCF.cellColor);
      } else if (checksAF.length > 1) {
        style.background = "".concat(checksAF[1]);
      } else {
        style.background = "".concat(value);
      }
    }
  }

  if ("ht" in cell) {
    var _value2 = normalizedCellAttr(cell, "ht");

    if (Number(_value2) === 0) {
      style.textAlign = "center";
    } else if (Number(_value2) === 2) {
      style.textAlign = "right";
    }
  }

  if ("vt" in cell) {
    var _value3 = normalizedCellAttr(cell, "vt");

    if (Number(_value3) === 0) {
      style.alignItems = "center";
    } else if (Number(_value3) === 2) {
      style.alignItems = "flex-end";
    }
  }

  if (!isInline) {
    style = _.assign(style, getFontStyleByCell(cell, checksAF, checksCF));
  }

  return style;
}
function getInlineStringHTML(r, c, data) {
  var ct = getCellValue(r, c, data, "ct");

  if (isInlineStringCT(ct)) {
    var strings = ct.s;
    var value = "";

    for (var i = 0; i < strings.length; i += 1) {
      var strObj = strings[i];

      if (strObj.v) {
        var style = getFontStyleByCell(strObj);

        var styleStr = _.map(style, function (v, key) {
          return "".concat(_.kebabCase(key), ":").concat(_.isNumber(v) ? "".concat(v, "px") : v, ";");
        }).join("");

        value += "<span class=\"luckysheet-input-span\" index='".concat(i, "' style='").concat(styleStr, "'>").concat(strObj.v, "</span>");
      }
    }

    return value;
  }

  return "";
}
function getQKBorder(width, type, color) {
  var bordertype = "";

  if (width.toString().indexOf("pt") > -1) {
    var nWidth = parseFloat(width);

    if (nWidth < 1) ; else if (nWidth < 1.5) {
      bordertype = "Medium";
    } else {
      bordertype = "Thick";
    }
  } else {
    var _nWidth = parseFloat(width);

    if (_nWidth < 2) ; else if (_nWidth < 3) {
      bordertype = "Medium";
    } else {
      bordertype = "Thick";
    }
  }

  var style = 0;
  type = type.toLowerCase();

  if (type === "double") {
    style = 2;
  } else if (type === "dotted") {
    if (bordertype === "Medium" || bordertype === "Thick") {
      style = 3;
    } else {
      style = 10;
    }
  } else if (type === "dashed") {
    if (bordertype === "Medium" || bordertype === "Thick") {
      style = 4;
    } else {
      style = 9;
    }
  } else if (type === "solid") {
    if (bordertype === "Medium") {
      style = 8;
    } else if (bordertype === "Thick") {
      style = 13;
    } else {
      style = 1;
    }
  }

  return [style, color];
}
function getdatabyselection(ctx, range, sheetId) {
  if (range == null && ctx.luckysheet_select_save) {
    var _ctx$luckysheet_selec = _slicedToArray(ctx.luckysheet_select_save, 1);

    range = _ctx$luckysheet_selec[0];
  }

  if (!range) return [];

  if (range.row == null || range.row.length === 0) {
    return [];
  }

  var d;
  var cfg;

  if (sheetId != null && sheetId !== ctx.currentSheetId) {
    d = ctx.luckysheetfile[getSheetIndex(ctx, sheetId)].data;
    cfg = ctx.luckysheetfile[getSheetIndex(ctx, sheetId)].config;
  } else {
    d = getFlowdata(ctx);
    cfg = ctx.config;
  }

  var data = [];

  for (var r = range.row[0]; r <= range.row[1]; r += 1) {
    var _d, _cfg;

    if (((_d = d) === null || _d === void 0 ? void 0 : _d[r]) == null) {
      continue;
    }

    if (((_cfg = cfg) === null || _cfg === void 0 ? void 0 : _cfg.rowhidden) != null && cfg.rowhidden[r] != null) {
      continue;
    }

    var row = [];

    for (var c = range.column[0]; c <= range.column[1]; c += 1) {
      var _cfg2;

      if (((_cfg2 = cfg) === null || _cfg2 === void 0 ? void 0 : _cfg2.colhidden) != null && cfg.colhidden[c] != null) {
        continue;
      }

      row.push(d[r][c]);
    }

    data.push(row);
  }

  return data;
}
function luckysheetUpdateCell(ctx, row_index, col_index) {
  ctx.luckysheetCellUpdate = [row_index, col_index];
}
function getDataBySelectionNoCopy(ctx, range) {
  if (!range || !range.row || range.row.length === 0) return [];
  var data = [];
  var flowData = getFlowdata(ctx);
  if (!flowData) return [];

  for (var r = range.row[0]; r <= range.row[1]; r += 1) {
    var row = [];

    if (ctx.config.rowhidden != null && ctx.config.rowhidden[r] != null) {
      continue;
    }

    for (var c = range.column[0]; c <= range.column[1]; c += 1) {
      var value = null;

      if (ctx.config.colhidden != null && ctx.config.colhidden[c] != null) {
        continue;
      }

      if (flowData[r] != null && flowData[r][c] != null) {
        value = flowData[r][c];
      }

      row.push(value);
    }

    data.push(row);
  }

  return data;
}

var clipboard = /*#__PURE__*/function () {
  function clipboard() {
    _classCallCheck(this, clipboard);
  }

  _createClass(clipboard, null, [{
    key: "writeHtml",
    value: function writeHtml(str) {
      try {
        var ele = document.getElementById("fortune-copy-content");

        if (!ele) {
          var _document$querySelect;

          ele = document.createElement("div");
          ele.setAttribute("contentEditable", "true");
          ele.id = "fortune-copy-content";
          ele.style.position = "fixed";
          ele.style.height = "0";
          ele.style.width = "0";
          ele.style.left = "-10000px";
          (_document$querySelect = document.querySelector(".fortune-container")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.append(ele);
        }

        var previouslyFocusedElement = document.activeElement;
        ele.style.display = "block";
        ele.innerHTML = str;
        ele.focus({
          preventScroll: true
        });
        document.execCommand("selectAll");
        document.execCommand("copy");
        setTimeout(function () {
          var _ele, _previouslyFocusedEle;

          (_ele = ele) === null || _ele === void 0 ? void 0 : _ele.blur();
          previouslyFocusedElement === null || previouslyFocusedElement === void 0 ? void 0 : (_previouslyFocusedEle = previouslyFocusedElement.focus) === null || _previouslyFocusedEle === void 0 ? void 0 : _previouslyFocusedEle.call(previouslyFocusedElement);
        }, 10);
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return clipboard;
}();

var selectionCache = {
  isPasteAction: false
};
function scrollToHighlightCell(ctx, r, c) {
  var scrollLeft = ctx.scrollLeft,
      scrollTop = ctx.scrollTop;
  var winH = ctx.cellmainHeight;
  var winW = ctx.cellmainWidth;
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
  var sheet = sheetIndex == null ? null : ctx.luckysheetfile[sheetIndex];
  if (!sheet) return;
  var frozen = sheet === null || sheet === void 0 ? void 0 : sheet.frozen;

  if (r >= 0) {
    var _sheet$frozen, _sheet$frozen$range;

    var row_focus = (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen = sheet.frozen) === null || _sheet$frozen === void 0 ? void 0 : (_sheet$frozen$range = _sheet$frozen.range) === null || _sheet$frozen$range === void 0 ? void 0 : _sheet$frozen$range.row_focus) || 0;
    var freezeH = frozen && r > row_focus ? ctx.visibledatarow[row_focus] : 0;
    var row = ctx.visibledatarow[r];
    var row_pre = r - 1 === -1 ? 0 : ctx.visibledatarow[r - 1];

    if (row - scrollTop - winH + 20 > 0) {
      ctx.scrollTop = row - winH + 20;
    } else if (row_pre - scrollTop - freezeH < 0) {
      var scrollAmount = Math.max(20, freezeH);
      ctx.scrollTop = row_pre - scrollAmount;
    }
  }

  if (c >= 0) {
    var _sheet$frozen2, _sheet$frozen2$range;

    var column_focus = (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen2 = sheet.frozen) === null || _sheet$frozen2 === void 0 ? void 0 : (_sheet$frozen2$range = _sheet$frozen2.range) === null || _sheet$frozen2$range === void 0 ? void 0 : _sheet$frozen2$range.column_focus) || 0;
    var freezeW = frozen && c > column_focus ? ctx.visibledatacolumn[column_focus] : 0;
    var col = ctx.visibledatacolumn[c];
    var col_pre = c - 1 === -1 ? 0 : ctx.visibledatacolumn[c - 1];

    if (col - scrollLeft - winW + 20 > 0) {
      ctx.scrollLeft = col - winW + 20;
    } else if (col_pre - scrollLeft - freezeW < 0) {
      var _scrollAmount = Math.max(20, freezeW);

      ctx.scrollLeft = col_pre - _scrollAmount;
    }
  }
}
function seletedHighlistByindex(ctx, r1, r2, c1, c2) {
  var row = ctx.visibledatarow[r2];
  var row_pre = r1 - 1 === -1 ? 0 : ctx.visibledatarow[r1 - 1];
  var col = ctx.visibledatacolumn[c2];
  var col_pre = c1 - 1 === -1 ? 0 : ctx.visibledatacolumn[c1 - 1];

  if (_.isNumber(row) && _.isNumber(row_pre) && _.isNumber(col) && _.isNumber(col_pre)) {
    return {
      left: col_pre,
      width: col - col_pre - 1,
      top: row_pre,
      height: row - row_pre - 1
    };
  }

  return null;
}
function normalizeSelection(ctx, selection) {
  if (!selection) return selection;
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return selection;

  for (var i = 0; i < selection.length; i += 1) {
    var r1 = selection[i].row[0];
    var r2 = selection[i].row[1];
    var c1 = selection[i].column[0];
    var c2 = selection[i].column[1];
    var rf = void 0;
    var cf = void 0;

    if (_.isNil(selection[i].row_focus)) {
      rf = r1;
    } else {
      rf = selection[i].row_focus;
    }

    if (_.isNil(selection[i].column_focus)) {
      cf = c1;
    } else {
      cf = selection[i].column_focus;
    }

    if (_.isNil(rf) || _.isNil(cf)) {
      console.error("normalizeSelection: rf and cf is nil");
      return selection;
    }

    var row = ctx.visibledatarow[r2];
    var row_pre = r1 - 1 === -1 ? 0 : ctx.visibledatarow[r1 - 1];
    var col = ctx.visibledatacolumn[c2];
    var col_pre = c1 - 1 === -1 ? 0 : ctx.visibledatacolumn[c1 - 1];
    var row_f = ctx.visibledatarow[rf];
    var row_pre_f = rf - 1 === -1 ? 0 : ctx.visibledatarow[rf - 1];
    var col_f = ctx.visibledatacolumn[cf];
    var col_pre_f = cf - 1 === -1 ? 0 : ctx.visibledatacolumn[cf - 1];
    var margeset = mergeBorder(ctx, flowdata, rf, cf);

    if (margeset) {
      var _margeset$row = _slicedToArray(margeset.row, 2);

      row_pre_f = _margeset$row[0];
      row_f = _margeset$row[1];

      var _margeset$column = _slicedToArray(margeset.column, 2);

      col_pre_f = _margeset$column[0];
      col_f = _margeset$column[1];
    }

    selection[i].row = [r1, r2];
    selection[i].column = [c1, c2];
    selection[i].row_focus = rf;
    selection[i].column_focus = cf;
    selection[i].left = col_pre_f;
    selection[i].width = col_f - col_pre_f <= 0 ? 0 : col_f - col_pre_f - 1;
    selection[i].top = row_pre_f;
    selection[i].height = row_f - row_pre_f <= 0 ? 0 : row_f - row_pre_f - 1;
    selection[i].left_move = col_pre;
    selection[i].width_move = col - col_pre <= 0 ? 0 : col - col_pre - 1;
    selection[i].top_move = row_pre;
    selection[i].height_move = row - row_pre <= 0 ? 0 : row - row_pre - 1;
  }

  return selection;
}
function selectTitlesMap(rangeMap, range1, range2) {
  var map = rangeMap || {};

  for (var i = range1; i <= range2; i += 1) {
    if (i in map) {
      continue;
    }

    map[i] = 0;
  }

  return map;
}
function selectTitlesRange(map) {
  var mapArr = Object.keys(map).map(Number);
  mapArr.sort(function (a, b) {
    return a - b;
  });
  var rangeArr;
  var item = [];

  if (mapArr.length > 1) {
    rangeArr = [];

    for (var j = 1; j < mapArr.length; j += 1) {
      if (mapArr[j] - mapArr[j - 1] === 1) {
        item.push(mapArr[j - 1]);

        if (j === mapArr.length - 1) {
          item.push(mapArr[j]);
          rangeArr.push(item);
        }
      } else {
        if (j === 1) {
          if (j === mapArr.length - 1) {
            item.push(mapArr[j - 1]);
            rangeArr.push(item);
            rangeArr.push([mapArr[j]]);
          } else {
            rangeArr.push([mapArr[0]]);
          }
        } else if (j === mapArr.length - 1) {
          item.push(mapArr[j - 1]);
          rangeArr.push(item);
          rangeArr.push([mapArr[j]]);
        } else {
          item.push(mapArr[j - 1]);
          rangeArr.push(item);
          item = [];
        }
      }
    }
  } else {
    rangeArr = [];
    rangeArr.push([mapArr[0]]);
  }

  return rangeArr;
}
function pasteHandlerOfPaintModel(ctx, copyRange) {
  var cfg = ctx.config;

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  if (!copyRange) return;
  var copyHasMC = copyRange.HasMC;
  var copySheetIndex = copyRange.dataSheetId;
  var c_r1 = copyRange.copyRange[0].row[0];
  var c_r2 = copyRange.copyRange[0].row[1];
  var c_c1 = copyRange.copyRange[0].column[0];
  var c_c2 = copyRange.copyRange[0].column[1];

  var copyData = _.cloneDeep(getdatabyselection(ctx, {
    row: [c_r1, c_r2],
    column: [c_c1, c_c2]
  }, copySheetIndex));

  if (!ctx.luckysheet_select_save) return;
  var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
  var minh = last.row[0];
  var maxh = last.row[1];
  var minc = last.column[0];
  var maxc = last.column[1];
  var copyh = copyData.length;
  var copyc = copyData[0].length;

  if (minh === maxh && minc === maxc) {
    var has_PartMC = false;

    if (cfg.merge != null) {
      has_PartMC = hasPartMC(ctx, cfg, minh, minh + copyh - 1, minc, minc + copyc - 1);
    }

    if (has_PartMC) {
      return;
    }

    maxh = minh + copyh - 1;
    maxc = minc + copyc - 1;
  }

  var timesH = Math.ceil((maxh - minh + 1) / copyh);
  var timesC = Math.ceil((maxc - minc + 1) / copyc);
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return;
  var cellMaxLength = flowdata[0].length;
  var rowMaxLength = flowdata.length;
  var borderInfoCompute = getBorderInfoCompute(ctx, copySheetIndex);
  var c_dataVerification = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetIndex)].dataVerification) || {};
  var dataVerification = null;
  var mth = 0;
  var mtc = 0;
  var maxcellCahe = 0;
  var maxrowCache = 0;

  for (var th = 1; th <= timesH; th += 1) {
    for (var tc = 1; tc <= timesC; tc += 1) {
      mth = minh + (th - 1) * copyh;
      mtc = minc + (tc - 1) * copyc;
      maxrowCache = minh + th * copyh > rowMaxLength ? rowMaxLength : minh + th * copyh;

      if (maxrowCache > maxh + 1) {
        maxrowCache = maxh + 1;
      }

      maxcellCahe = minc + tc * copyc > cellMaxLength ? cellMaxLength : minc + tc * copyc;

      if (maxcellCahe > maxc + 1) {
        maxcellCahe = maxc + 1;
      }

      var offsetMC = {};

      var _loop = function _loop(h) {
        if (h == null) return {
          v: void 0
        };
        if (flowdata[h] == null) return {
          v: void 0
        };
        var x = [];
        x = flowdata[h];

        var _loop2 = function _loop2(c) {
          if (borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)]) {
            var bd_obj = {
              rangeType: "cell",
              value: {
                row_index: h,
                col_index: c,
                l: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].l,
                r: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].r,
                t: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].t,
                b: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].b
              }
            };

            if (cfg.borderInfo == null) {
              cfg.borderInfo = [];
            }

            cfg.borderInfo.push(bd_obj);
          } else if (borderInfoCompute["".concat(h, "_").concat(c)]) {
            var _bd_obj = {
              rangeType: "cell",
              value: {
                row_index: h,
                col_index: c,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };

            if (cfg.borderInfo == null) {
              cfg.borderInfo = [];
            }

            cfg.borderInfo.push(_bd_obj);
          }

          if (c_dataVerification["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)]) {
            if (dataVerification == null) {
              dataVerification = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification);
            }

            dataVerification["".concat(h, "_").concat(c)] = c_dataVerification["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)];
          }

          if (isPlainObject(x[c]) && x[c].mc) {
            if (x[c].mc.rs) {
              delete cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)];
            }

            delete x[c].mc;
          }

          var value = null;

          if (copyData[h - mth] != null && copyData[h - mth][c - mtc] != null) {
            value = copyData[h - mth][c - mtc];
          }

          if (isPlainObject(x[c])) {
            if (x[c].ct && x[c].ct.t === "inlineStr" && value) {
              delete value.ct;
            } else {
              var format = ["bg", "fc", "ct", "ht", "vt", "bl", "it", "cl", "un", "fs", "ff", "tb"];
              format.forEach(function (item) {
                Reflect.deleteProperty(x[c], item);
              });
            }
          } else {
            x[c] = {
              v: x[c]
            };
          }

          if (value != null) {
            delete value.v;
            delete value.m;
            delete value.f;
            delete value.spl;

            if (value.ct && value.ct.t === "inlineStr") {
              delete value.ct;
            }

            x[c] = _.assign(x[c], _.cloneDeep(value));

            if (x[c].ct && x[c].ct.t === "inlineStr") {
              x[c].ct.s.forEach(function (item) {
                return _.assign(item, value);
              });
            }

            if (copyHasMC && x[c].mc) {
              if (x[c].mc.rs != null) {
                x[c].mc.r = h;

                if (x[c].mc.rs + h >= maxrowCache) {
                  x[c].mc.rs = maxrowCache - h;
                }

                x[c].mc.c = c;

                if (x[c].mc.cs + c >= maxcellCahe) {
                  x[c].mc.cs = maxcellCahe - c;
                }

                cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)] = x[c].mc;
                offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)] = [x[c].mc.r, x[c].mc.c];
              } else {
                x[c] = {
                  mc: {
                    r: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][0],
                    c: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][1]
                  }
                };
              }
            }

            if (x[c].v != null) {
              if (value.ct != null && value.ct.fa != null) {
                var mask = update(value.ct.fa, x[c].v);
                x[c].m = mask;
              }
            }
          }
        };

        for (var c = mtc; c < maxcellCahe; c += 1) {
          _loop2(c);
        }

        flowdata[h] = x;
      };

      for (var h = mth; h < maxrowCache; h += 1) {
        var _ret = _loop(h);

        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }

  var currFile = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)];
  currFile.config = cfg;
  currFile.dataVerification = dataVerification;
  var cdformat = null;
  var copyIndex = getSheetIndex(ctx, copySheetIndex);
  if (!copyIndex) return;

  var ruleArr = _.cloneDeep(ctx.luckysheetfile[copyIndex].luckysheet_conditionformat_save);

  if (!_.isNil(ruleArr) && ruleArr.length > 0) {
    var currentIndex = getSheetIndex(ctx, ctx.currentSheetId);
    cdformat = _.cloneDeep(ctx.luckysheetfile[currentIndex].luckysheet_conditionformat_save);

    for (var i = 0; i < ruleArr.length; i += 1) {
      var cdformat_cellrange = ruleArr[i].cellrange;
      var emptyRange = [];

      for (var j = 0; j < cdformat_cellrange.length; j += 1) {
        var range = CFSplitRange(cdformat_cellrange[j], {
          row: [c_r1, c_r2],
          column: [c_c1, c_c2]
        }, {
          row: [minh, maxh],
          column: [minc, maxc]
        }, "operatePart");

        if (range.length > 0) {
          emptyRange = emptyRange.concat(range);
        }
      }

      if (emptyRange.length > 0) {
        ruleArr[i].cellrange = [{
          row: [minh, maxh],
          column: [minc, maxc]
        }];
        cdformat.push(ruleArr[i]);
      }
    }
  }
}
function selectionCopyShow(range, ctx) {
  if (range == null) {
    range = ctx.luckysheet_selection_range;
  }

  range = JSON.parse(JSON.stringify(range));
}
function rowHasMerged(ctx, r, c1, c2) {
  var hasMerged = false;
  var flowData = getFlowdata(ctx);
  if (_.isNil(flowData) || _.isNil(flowData[r])) return false;

  for (var c = c1; c <= c2; c += 1) {
    var cell = flowData[r][c];

    if (!_.isNil(cell) && "mc" in cell) {
      hasMerged = true;
      break;
    }
  }

  return hasMerged;
}
function colHasMerged(ctx, c, r1, r2) {
  var hasMerged = false;
  var flowData = getFlowdata(ctx);
  if (_.isNil(flowData)) return false;

  for (var r = r1; r <= r2; r += 1) {
    var _flowData$r;

    var cell = (_flowData$r = flowData[r]) === null || _flowData$r === void 0 ? void 0 : _flowData$r[c];

    if (!_.isNil(ctx.config.merge) && !_.isNil(cell) && "mc" in cell && !_.isNil(cell.mc)) {
      hasMerged = true;
      break;
    }
  }

  return hasMerged;
}
function getRowMerge(ctx, rIndex, c1, c2) {
  var flowData = getFlowdata(ctx);
  if (_.isNil(flowData)) return [null, null];
  var r2 = flowData.length - 1;
  var str = null;

  if (rIndex > 0) {
    for (var r = rIndex; r >= 0; r -= 1) {
      for (var c = c1; c <= c2; c += 1) {
        var cell = flowData[r][c];

        if (!_.isNil(cell) && !_.isNil(cell.mc) && "mc" in cell && !_.isNil(ctx.config.merge)) {
          var mc = ctx.config.merge["".concat(cell.mc.r, "_").concat(cell.mc.c)];

          if (_.isNil(str) || mc.r < str) {
            str = mc.r;
          }
        }
      }

      if (!_.isNil(str) && rowHasMerged(ctx, str - 1, c1, c2) && str > 0) {
        r = str;
      } else {
        break;
      }
    }
  } else {
    str = 0;
  }

  var end = null;

  if (rIndex < r2) {
    for (var _r = rIndex; _r <= r2; _r += 1) {
      for (var _c = c1; _c <= c2; _c += 1) {
        var _cell = flowData[_r][_c];

        if (!_.isNil(_cell) && !_.isNil(_cell.mc) && "mc" in _cell && !_.isNil(ctx.config.merge)) {
          var _mc = ctx.config.merge["".concat(_cell.mc.r, "_").concat(_cell.mc.c)];

          if (_.isNil(end) || _mc.r + _mc.rs - 1 > end) {
            end = _mc.r + _mc.rs - 1;
          }
        }
      }

      if (!_.isNil(end) && rowHasMerged(ctx, end + 1, c1, c2) && end < r2) {
        _r = end;
      } else {
        break;
      }
    }
  } else {
    end = r2;
  }

  return [str, end];
}
function getColMerge(ctx, cIndex, r1, r2) {
  var flowData = getFlowdata(ctx);

  if (_.isNil(flowData)) {
    return [null, null];
  }

  var c2 = flowData[0].length - 1;
  var str = null;

  if (cIndex > 0) {
    for (var c = cIndex; c >= 0; c -= 1) {
      for (var r = r1; r <= r2; r += 1) {
        var cell = flowData[r][c];

        if (!_.isNil(ctx.config.merge) && !_.isNil(cell) && "mc" in cell && !_.isNil(cell.mc)) {
          var mc = ctx.config.merge["".concat(cell.mc.r, "_").concat(cell.mc.c)];

          if (_.isNil(str) || mc.c < str) {
            str = mc.c;
          }
        }
      }

      if (!_.isNil(str) && colHasMerged(ctx, str - 1, r1, r2) && str > 0) {
        c = str;
      } else {
        break;
      }
    }
  } else {
    str = 0;
  }

  var end = null;

  if (cIndex < c2) {
    for (var _c2 = cIndex; _c2 <= c2; _c2 += 1) {
      for (var _r2 = r1; _r2 <= r2; _r2 += 1) {
        var _cell2 = flowData[_r2][_c2];

        if (!_.isNil(ctx.config.merge) && !_.isNil(_cell2) && "mc" in _cell2 && !_.isNil(_cell2.mc)) {
          var _mc2 = ctx.config.merge["".concat(_cell2.mc.r, "_").concat(_cell2.mc.c)];

          if (_.isNil(end) || _mc2.c + _mc2.cs - 1 > end) {
            end = _mc2.c + _mc2.cs - 1;
          }
        }
      }

      if (!_.isNil(end) && colHasMerged(ctx, end + 1, r1, r2) && end < c2) {
        _c2 = end;
      } else {
        break;
      }
    }
  } else {
    end = c2;
  }

  return [str, end];
}
function moveHighlightCell(ctx, postion, index, type) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var datarowlen = flowdata.length;
  var datacolumnlen = flowdata[0].length;
  var row;
  var row_pre;
  var row_index;
  var row_index_ed;
  var col;
  var col_pre;
  var col_index;
  var col_index_ed;

  if (type === "rangeOfSelect") {
    var _ctx$luckysheet_selec;

    var last = (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec[ctx.luckysheet_select_save.length - 1];

    if (!last) {
      console.error("moveHighlightCell: no selection found");
      return;
    }

    var curR;

    if (_.isNil(last.row_focus)) {
      var _last$row = _slicedToArray(last.row, 1);

      curR = _last$row[0];
    } else {
      curR = last.row_focus;
    }

    var curC;

    if (_.isNil(last.column_focus)) {
      var _last$column = _slicedToArray(last.column, 1);

      curC = _last$column[0];
    } else {
      curC = last.column_focus;
    }

    var margeset = mergeBorder(ctx, flowdata, curR, curC);

    if (margeset) {
      var str_r = margeset.row[2];
      var end_r = margeset.row[3];
      var str_c = margeset.column[2];
      var end_c = margeset.column[3];

      if (index > 0) {
        if (postion === "down") {
          curR = end_r;
          curC = str_c;
        } else if (postion === "right") {
          curR = str_r;
          curC = end_c;
        }
      } else {
        curR = str_r;
        curC = str_c;
      }
    }

    if (_.isNil(curR) || _.isNil(curC)) {
      console.error("moveHighlightCell: curR or curC is nil");
      return;
    }

    var moveX = _.isNil(last.moveXY) ? curR : last.moveXY.x;
    var moveY = _.isNil(last.moveXY) ? curC : last.moveXY.y;

    if (postion === "down") {
      curR += index;
      moveX = curR;
    } else if (postion === "right") {
      curC += index;
      moveY = curC;
    }

    if (curR >= datarowlen) {
      curR = datarowlen - 1;
      moveX = curR;
    }

    if (curR < 0) {
      curR = 0;
      moveX = curR;
    }

    if (curC >= datacolumnlen) {
      curC = datacolumnlen - 1;
      moveY = curC;
    }

    if (curC < 0) {
      curC = 0;
      moveY = curC;
    }

    var margeset2 = mergeBorder(ctx, flowdata, curR, curC);

    if (margeset2) {
      var _margeset2$row = _slicedToArray(margeset2.row, 4);

      row_pre = _margeset2$row[0];
      row = _margeset2$row[1];
      row_index = _margeset2$row[2];
      row_index_ed = _margeset2$row[3];

      var _margeset2$column = _slicedToArray(margeset2.column, 4);

      col_pre = _margeset2$column[0];
      col = _margeset2$column[1];
      col_index = _margeset2$column[2];
      col_index_ed = _margeset2$column[3];
    } else {
      row = ctx.visibledatarow[moveX];
      row_pre = moveX - 1 === -1 ? 0 : ctx.visibledatarow[moveX - 1];
      col = ctx.visibledatacolumn[moveY];
      col_pre = moveY - 1 === -1 ? 0 : ctx.visibledatacolumn[moveY - 1];
      row_index = curR;
      row_index_ed = curR;
      col_index = curC;
      col_index_ed = curC;
    }

    if (_.isNil(row_index) || _.isNil(row_index_ed) || _.isNil(col_index) || _.isNil(col_index_ed)) {
      console.error("moveHighlightCell: row_index or row_index_ed or col_index or col_index_ed is nil");
      return;
    }

    last.row = [row_index, row_index_ed];
    last.column = [col_index, col_index_ed];
    last.row_focus = row_index;
    last.column_focus = col_index;
    last.moveXY = {
      x: moveX,
      y: moveY
    };
    normalizeSelection(ctx, ctx.luckysheet_select_save);
    scrollToHighlightCell(ctx, row_index, col_index);
  } else if (type === "rangeOfFormula") {
    var _last = ctx.formulaCache.func_selectedrange;
    if (!_last) return;

    var _curR;

    if (_.isNil(_last.row_focus)) {
      var _last$row2 = _slicedToArray(_last.row, 1);

      _curR = _last$row2[0];
    } else {
      _curR = _last.row_focus;
    }

    var _curC;

    if (_.isNil(_last.column_focus)) {
      var _last$column2 = _slicedToArray(_last.column, 1);

      _curC = _last$column2[0];
    } else {
      _curC = _last.column_focus;
    }

    var _margeset = mergeBorder(ctx, flowdata, _curR, _curC);

    if (_margeset) {
      var _str_r = _margeset.row[2];
      var _end_r = _margeset.row[3];
      var _str_c = _margeset.column[2];
      var _end_c = _margeset.column[3];

      if (index > 0) {
        if (postion === "down") {
          _curR = _end_r;
          _curC = _str_c;
        } else if (postion === "right") {
          _curR = _str_r;
          _curC = _end_c;
        }
      } else {
        _curR = _str_r;
        _curC = _str_c;
      }
    }

    if (_.isNil(_curR) || _.isNil(_curC)) {
      console.error("moveHighlightCell: curR or curC is nil");
      return;
    }

    var _moveX = _.isNil(_last.moveXY) ? _curR : _last.moveXY.x;

    var _moveY = _.isNil(_last.moveXY) ? _curC : _last.moveXY.y;

    if (postion === "down") {
      _curR += index;
      _moveX = _curR;
    } else if (postion === "right") {
      _curC += index;
      _moveY = _curC;
    }

    if (_curR >= datarowlen) {
      _curR = datarowlen - 1;
      _moveX = _curR;
    }

    if (_curR < 0) {
      _curR = 0;
      _moveX = _curR;
    }

    if (_curC >= datacolumnlen) {
      _curC = datacolumnlen - 1;
      _moveY = _curC;
    }

    if (_curC < 0) {
      _curC = 0;
      _moveY = _curC;
    }

    var _margeset2 = mergeBorder(ctx, flowdata, _curR, _curC);

    if (_margeset2) {
      var _margeset2$row2 = _slicedToArray(_margeset2.row, 4);

      row_pre = _margeset2$row2[0];
      row = _margeset2$row2[1];
      row_index = _margeset2$row2[2];
      row_index_ed = _margeset2$row2[3];

      var _margeset2$column2 = _slicedToArray(_margeset2.column, 4);

      col_pre = _margeset2$column2[0];
      col = _margeset2$column2[1];
      col_index = _margeset2$column2[2];
      col_index_ed = _margeset2$column2[3];
    } else {
      row = ctx.visibledatarow[_moveX];
      row_pre = _moveX - 1 === -1 ? 0 : ctx.visibledatarow[_moveX - 1];
      row_index = _moveX;
      row_index_ed = _moveX;
      col = ctx.visibledatacolumn[_moveY];
      col_pre = _moveY - 1 === -1 ? 0 : ctx.visibledatacolumn[_moveY - 1];
      col_index = _moveY;
      col_index_ed = _moveY;
    }

    if (_.isNil(col) || _.isNil(col_pre) || _.isNil(row) || _.isNil(row_pre) || _.isNil(row_index) || _.isNil(row_index_ed) || _.isNil(col_index) || _.isNil(col_index_ed)) {
      console.error("moveHighlightCell: some values of func_selectedrange is nil");
      return;
    }

    ctx.formulaCache.func_selectedrange = {
      left: col_pre,
      width: col - col_pre - 1,
      top: row_pre,
      height: row - row_pre - 1,
      left_move: col_pre,
      width_move: col - col_pre - 1,
      top_move: row_pre,
      height_move: row - row_pre - 1,
      row: [row_index, row_index_ed],
      column: [col_index, col_index_ed],
      row_focus: row_index,
      column_focus: col_index,
      moveXY: {
        x: _moveX,
        y: _moveY
      }
    };
  }
}
function moveHighlightRange(ctx, postion, index, type) {
  var row;
  var row_pre;
  var col;
  var col_pre;
  var flowData = getFlowdata(ctx);
  if (_.isNil(flowData)) return;
  if (_.isNil(ctx.luckysheet_select_save)) return;

  if (type === "rangeOfSelect") {
    var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
    var curR = last.row[0];
    var endR = last.row[1];
    var curC = last.column[0];
    var endC = last.column[1];
    var rf = last.row_focus;
    var cf = last.column_focus;
    if (_.isNil(rf) || _.isNil(cf)) return;
    var datarowlen = flowData.length;
    var datacolumnlen = flowData[0].length;

    if (postion === "down") {
      if (rowHasMerged(ctx, rf, curC, endC)) {
        var rfMerge = getRowMerge(ctx, rf, curC, endC);
        var rf_str = rfMerge[0];
        var rf_end = rfMerge[1];

        if (!_.isNil(rf_str) && rf_str > curR && rf_end === endR) {
          if (index > 0 && rowHasMerged(ctx, curR, curC, endC)) {
            var v = getRowMerge(ctx, curR, curC, endC)[1];

            if (!_.isNil(v)) {
              curR = v;
            }
          }

          curR += index;
        } else if (!_.isNil(rf_end) && rf_end < endR && rf_str === curR) {
          if (index < 0 && rowHasMerged(ctx, endR, curC, endC)) {
            var _v = getRowMerge(ctx, curR, curC, endC)[0];

            if (!_.isNil(_v)) {
              endR = _v;
            }
          }

          endR += index;
        } else {
          if (index > 0) {
            endR += index;
          } else {
            curR += index;
          }
        }
      } else {
        if (rf > curR && rf === endR) {
          if (index > 0 && rowHasMerged(ctx, curR, curC, endC)) {
            var _v2 = getRowMerge(ctx, curR, curC, endC)[1];

            if (!_.isNil(_v2)) {
              curR = _v2;
            }
          }

          curR += index;
        } else if (rf < endR && rf === curR) {
          if (index < 0 && rowHasMerged(ctx, endR, curC, endC)) {
            var _v3 = getRowMerge(ctx, endR, curC, endC)[0];

            if (!_.isNil(_v3)) {
              endR = _v3;
            }
          }

          endR += index;
        } else if (rf === curR && rf === endR) {
          if (index > 0) {
            endR += index;
          } else {
            curR += index;
          }
        }
      }

      if (endR >= datarowlen) {
        endR = datarowlen - 1;
      }

      if (endR < 0) {
        endR = 0;
      }

      if (curR >= datarowlen) {
        curR = datarowlen - 1;
      }

      if (curR < 0) {
        curR = 0;
      }
    } else {
      if (colHasMerged(ctx, cf, curR, endR)) {
        var cfMerge = getColMerge(ctx, cf, curR, endR);
        var cf_str = cfMerge[0];
        var cf_end = cfMerge[1];

        if (!_.isNil(cf_str) && cf_str > curC && cf_end === endC) {
          if (index > 0 && colHasMerged(ctx, curC, curR, endR)) {
            var _v4 = getColMerge(ctx, curC, curR, endR)[1];

            if (!_.isNil(_v4)) {
              curC = _v4;
            }

            curC += index;
          }

          curC += index;
        } else if (!_.isNil(cf_end) && cf_end < endC && cf_str === curC) {
          if (index < 0 && colHasMerged(ctx, endC, curR, endR)) {
            var _v5 = getColMerge(ctx, endC, curR, endR)[0];

            if (!_.isNil(_v5)) {
              endC = _v5;
            }
          }

          endC += index;
        } else {
          if (index > 0) {
            endC += index;
          } else {
            curC += index;
          }
        }
      } else {
        if (cf > curC && cf === endC) {
          if (index > 0 && colHasMerged(ctx, curC, curR, endR)) {
            var _v6 = getColMerge(ctx, curC, curR, endR)[1];

            if (!_.isNil(_v6)) {
              curC = _v6;
            }

            curC += index;
          }

          curC += index;
        } else if (cf < endC && cf === curC) {
          if (index < 0 && colHasMerged(ctx, endC, curR, endR)) {
            var _v7 = getColMerge(ctx, endC, curR, endR)[0];

            if (!_.isNil(_v7)) {
              endC = _v7;
            }
          }

          endC += index;
        } else if (cf === curC && cf === endC) {
          if (index > 0) {
            endC += index;
          } else {
            curC += index;
          }
        }
      }

      if (endC >= datacolumnlen) {
        endC = datacolumnlen - 1;
      }

      if (endC < 0) {
        endC = 0;
      }

      if (curC >= datacolumnlen) {
        curC = datacolumnlen - 1;
      }

      if (curC < 0) {
        curC = 0;
      }
    }

    var rowseleted = [curR, endR];
    var columnseleted = [curC, endC];
    row = ctx.visibledatarow[endR];
    row_pre = curR - 1 === -1 ? 0 : ctx.visibledatarow[curR - 1];
    col = ctx.visibledatacolumn[endC];
    col_pre = curC - 1 === -1 ? 0 : ctx.visibledatacolumn[curC - 1];
    var changeparam = mergeMoveMain(ctx, columnseleted, rowseleted, last, row_pre, row - row_pre - 1, col_pre, col - col_pre - 1);

    if (!_.isNil(changeparam)) {
      var _changeparam = _slicedToArray(changeparam, 2);

      columnseleted = _changeparam[0];
      rowseleted = _changeparam[1];
    }

    last.row = rowseleted;
    last.column = columnseleted;
    normalizeSelection(ctx, ctx.luckysheet_select_save);

    if (postion === "down") {
      var rowToScroll = last.row_focus === last.row[0] ? last.row[1] : last.row[0];
      scrollToHighlightCell(ctx, rowToScroll, -1);
    } else {
      var columnToScroll = last.column_focus === last.column[0] ? last.column[1] : last.column[0];
      scrollToHighlightCell(ctx, -1, columnToScroll);
    }
  } else if (type === "rangeOfFormula") {
    var _last2 = ctx.formulaCache.func_selectedrange;
    if (_.isNil(_last2)) return;
    var _curR2 = _last2.row[0];
    var _endR = _last2.row[1];
    var _curC2 = _last2.column[0];
    var _endC = _last2.column[1];
    var _rf = _last2.row_focus;
    var _cf = _last2.column_focus;
    var _datarowlen = flowData.length;
    var _datacolumnlen = flowData[0].length;

    if (postion === "down") {
      if (!_.isNil(_rf) && rowHasMerged(ctx, _rf, _curC2, _endC)) {
        var _rfMerge = getRowMerge(ctx, _rf, _curC2, _endC);

        var _rf_str = _rfMerge[0];
        var _rf_end = _rfMerge[1];

        if (!_.isNil(_rf_str) && _rf_str > _curR2 && _rf_end === _endR) {
          if (index > 0 && rowHasMerged(ctx, _curR2, _curC2, _endC)) {
            var _v8 = getRowMerge(ctx, _curR2, _curC2, _endC)[1];

            if (!_.isNil(_v8)) {
              _curR2 = _v8;
            }
          }

          _curR2 += index;
        } else if (!_.isNil(_rf_end) && _rf_end < _endR && _rf_str === _curR2) {
          if (index < 0 && rowHasMerged(ctx, _endR, _curC2, _endC)) {
            var _v9 = getRowMerge(ctx, _endR, _curC2, _endC)[0];

            if (!_.isNil(_v9)) {
              _endR = _v9;
            }

            _endR += index;
          }
        } else {
          if (index > 0) {
            _endR += index;
          } else {
            _curR2 += index;
          }
        }
      } else {
        if (!_.isNil(_rf) && _rf > _curR2 && _rf === _endR) {
          if (index > 0 && rowHasMerged(ctx, _curR2, _curC2, _endC)) {
            var _v10 = getRowMerge(ctx, _curR2, _curC2, _endC)[1];

            if (!_.isNil(_v10)) {
              _curR2 = _v10;
            }
          }

          _curR2 += index;
        } else if (!_.isNil(_rf) && _rf < _endR && _rf === _curR2) {
          if (index < 0 && rowHasMerged(ctx, _endR, _curC2, _endC)) {
            var _v11 = getRowMerge(ctx, _endR, _curC2, _endC)[0];

            if (!_.isNil(_v11)) {
              _endR = _v11;
            }
          }

          _endR += index;
        } else if (_rf === _curR2 && _rf === _endR) {
          if (index > 0) {
            _endR += index;
          } else {
            _curR2 += index;
          }
        }
      }

      if (_endR >= _datarowlen) {
        _endR = _datarowlen - 1;
      }

      if (_endR < 0) {
        _endR = 0;
      }

      if (_curR2 >= _datarowlen) {
        _curR2 = _datarowlen - 1;
      }

      if (_curR2 < 0) {
        _curR2 = 0;
      }
    } else {
      if (!_.isNil(_cf) && colHasMerged(ctx, _cf, _curR2, _endR)) {
        var _cfMerge = getColMerge(ctx, _cf, _curR2, _endR);

        var _cf_str = _cfMerge[0];
        var _cf_end = _cfMerge[1];

        if (!_.isNil(_cf_str) && _cf_str > _curC2 && _cf_end === _endC) {
          if (index > 0 && colHasMerged(ctx, _curC2, _curR2, _endR)) {
            var _v12 = getColMerge(ctx, _curC2, _curR2, _endR)[1];

            if (!_.isNil(_v12)) {
              _curC2 = _v12;
            }
          }

          _curC2 += index;
        } else if (!_.isNil(_cf_end) && _cf_end < _endC && _cf_str === _curC2) {
          if (index < 0 && colHasMerged(ctx, _endC, _curR2, _endR)) {
            var _v13 = getColMerge(ctx, _endC, _curR2, _endR)[0];

            if (!_.isNil(_v13)) {
              _endC = _v13;
            }
          }

          _endC += index;
        } else {
          if (index > 0) {
            _endC += index;
          } else {
            _curC2 += index;
          }
        }
      } else {
        if (!_.isNil(_cf) && _cf > _curC2 && _cf === _endC) {
          if (index > 0 && colHasMerged(ctx, _curC2, _curR2, _endR)) {
            var _v14 = getColMerge(ctx, _curC2, _curR2, _endR)[1];

            if (!_.isNil(_v14)) {
              _curC2 = _v14;
            }
          }

          _curC2 += index;
        } else if (!_.isNil(_cf) && _cf < _endC && _cf === _curC2) {
          if (index < 0 && colHasMerged(ctx, _endC, _curR2, _endR)) {
            var _v15 = getColMerge(ctx, _endC, _curR2, _endR)[0];

            if (!_.isNil(_v15)) {
              _endC = _v15;
            }
          }

          _endC += index;
        } else if (_cf === _curC2 && _cf === _endC) {
          if (index > 0) {
            _endC += index;
          } else {
            _curC2 += index;
          }
        }
      }

      if (_endC >= _datacolumnlen) {
        _endC = _datacolumnlen - 1;
      }

      if (_endC < 0) {
        _endC = 0;
      }

      if (_curC2 >= _datacolumnlen) {
        _curC2 = _datacolumnlen - 1;
      }

      if (_curC2 < 0) {
        _curC2 = 0;
      }
    }

    var _rowseleted = [_curR2, _endR];
    var _columnseleted = [_curC2, _endC];
    row = ctx.visibledatarow[_endR];
    row_pre = _curR2 - 1 === -1 ? 0 : ctx.visibledatarow[_curR2 - 1];
    col = ctx.visibledatacolumn[_endC];
    col_pre = _curC2 - 1 === -1 ? 0 : ctx.visibledatacolumn[_curC2 - 1];
    var top = row_pre;
    var height = row - row_pre - 1;
    var left = col_pre;
    var width = col - col_pre - 1;

    var _changeparam2 = mergeMoveMain(ctx, _columnseleted, _rowseleted, _last2, top, height, left, width);

    if (!_.isNil(_changeparam2)) {
      var _changeparam3 = _slicedToArray(_changeparam2, 6);

      _columnseleted = _changeparam3[0];
      _rowseleted = _changeparam3[1];
      top = _changeparam3[2];
      height = _changeparam3[3];
      left = _changeparam3[4];
      width = _changeparam3[5];
    }

    ctx.formulaCache.func_selectedrange = {
      left: left,
      width: width,
      top: top,
      height: height,
      left_move: left,
      width_move: width,
      top_move: top,
      height_move: height,
      row: _rowseleted,
      column: _columnseleted,
      row_focus: _rf,
      column_focus: _cf
    };
  }
}

function getHtmlBorderStyle(type, color) {
  var style = "";
  var borderType = {
    "0": "none",
    "1": "Thin",
    "2": "Hair",
    "3": "Dotted",
    "4": "Dashed",
    "5": "DashDot",
    "6": "DashDotDot",
    "7": "Double",
    "8": "Medium",
    "9": "MediumDashed",
    "10": "MediumDashDot",
    "11": "MediumDashDotDot",
    "12": "SlantedDashDot",
    "13": "Thick"
  };
  type = borderType[type.toString()];

  if (type.indexOf("Medium") > -1) {
    style += "1pt ";
  } else if (type === "Thick") {
    style += "1.5pt ";
  } else {
    style += "0.5pt ";
  }

  if (type === "Hair") {
    style += "double ";
  } else if (type.indexOf("DashDotDot") > -1) {
    style += "dotted ";
  } else if (type.indexOf("DashDot") > -1) {
    style += "dashed ";
  } else if (type.indexOf("Dotted") > -1) {
    style += "dotted ";
  } else if (type.indexOf("Dashed") > -1) {
    style += "dashed ";
  } else {
    style += "solid ";
  }

  return "".concat(style + color, ";");
}

function rangeValueToHtml(ctx, sheetId, ranges) {
  var _sheet$config;

  var idx = getSheetIndex(ctx, sheetId);
  if (idx == null) return "";
  var sheet = ctx.luckysheetfile[idx];
  var rowIndexArr = [];
  var colIndexArr = [];

  for (var s = 0; s < ((_ranges$length = ranges === null || ranges === void 0 ? void 0 : ranges.length) !== null && _ranges$length !== void 0 ? _ranges$length : 0); s += 1) {
    var _ranges$length;

    var range = ranges[s];
    var r1 = range.row[0];
    var r2 = range.row[1];
    var c1 = range.column[0];
    var c2 = range.column[1];

    for (var copyR = r1; copyR <= r2; copyR += 1) {
      if (!rowIndexArr.includes(copyR)) {
        rowIndexArr.push(copyR);
      }

      for (var copyC = c1; copyC <= c2; copyC += 1) {
        if (!colIndexArr.includes(copyC)) {
          colIndexArr.push(copyC);
        }
      }
    }
  }

  var borderInfoCompute;

  if (((_sheet$config = sheet.config) === null || _sheet$config === void 0 ? void 0 : _sheet$config.borderInfo) && sheet.config.borderInfo.length > 0) {
    borderInfoCompute = getBorderInfoCompute(ctx, sheetId);
  }

  var cpdata = "";
  var d = sheet.data;
  if (!d) return null;
  var colgroup = "";

  for (var i = 0; i < rowIndexArr.length; i += 1) {
    var r = rowIndexArr[i];
    cpdata += "<tr>";

    for (var j = 0; j < colIndexArr.length; j += 1) {
      var _d$r;

      var c = colIndexArr[j];
      var column = '<td ${span} style="${style}">';
      var cell = (_d$r = d[r]) === null || _d$r === void 0 ? void 0 : _d$r[c];

      if (cell != null) {
        var style = "";
        var span = "";

        if (r === rowIndexArr[0]) {
          if (_.isNil(sheet.config) || _.isNil(sheet.config.columnlen) || _.isNil(sheet.config.columnlen[c.toString()])) {
            colgroup += '<colgroup width="72px"></colgroup>';
          } else {
            colgroup += "<colgroup width=\"".concat(sheet.config.columnlen[c.toString()], "px\"></colgroup>");
          }
        }

        if (c === colIndexArr[0]) {
          if (_.isNil(sheet.config) || _.isNil(sheet.config.rowlen) || _.isNil(sheet.config.rowlen[r.toString()])) {
            style += "height:19px;";
          } else {
            style += "height:".concat(sheet.config.rowlen[r.toString()], "px;");
          }
        }

        var reg = /^(w|W)((0?)|(0\.0+))$/;
        var c_value = void 0;

        if (!_.isNil(cell.ct) && !_.isNil(cell.ct.fa) && cell.ct.fa.match(reg)) {
          c_value = getCellValue(r, c, d);
        } else {
          c_value = getCellValue(r, c, d, "m");
        }

        var styleObj = getStyleByCell(ctx, d, r, c);
        style += _.map(styleObj, function (v, key) {
          return "".concat(_.kebabCase(key), ":").concat(_.isNumber(v) ? "".concat(v, "px") : v, ";");
        }).join("");

        if (cell.mc) {
          if ("rs" in cell.mc) {
            span = "rowspan=\"".concat(cell.mc.rs, "\" colspan=\"").concat(cell.mc.cs, "\"");

            if (borderInfoCompute && borderInfoCompute["".concat(r, "_").concat(c)]) {
              (function () {
                var bl_obj = {
                  color: {},
                  style: {}
                };
                var br_obj = {
                  color: {},
                  style: {}
                };
                var bt_obj = {
                  color: {},
                  style: {}
                };
                var bb_obj = {
                  color: {},
                  style: {}
                };

                for (var bd_r = r; bd_r < r + cell.mc.rs; bd_r += 1) {
                  for (var bd_c = c; bd_c < c + cell.mc.cs; bd_c += 1) {
                    if (bd_r === r && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t) {
                      var linetype = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t.style;
                      var bcolor = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t.color;

                      if (_.isNil(bt_obj.style[linetype])) {
                        bt_obj.style[linetype] = 1;
                      } else {
                        bt_obj.style[linetype] += 1;
                      }

                      if (_.isNil(bt_obj.color[bcolor])) {
                        bt_obj.color[bcolor] = 1;
                      } else {
                        bt_obj.color[bcolor] += 1;
                      }
                    }

                    if (bd_r === r + cell.mc.rs - 1 && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b) {
                      var _linetype = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b.style;
                      var _bcolor = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b.color;

                      if (_.isNil(bb_obj.style[_linetype])) {
                        bb_obj.style[_linetype] = 1;
                      } else {
                        bb_obj.style[_linetype] += 1;
                      }

                      if (_.isNil(bb_obj.color[_bcolor])) {
                        bb_obj.color[_bcolor] = 1;
                      } else {
                        bb_obj.color[_bcolor] += 1;
                      }
                    }

                    if (bd_c === c && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l) {
                      var _linetype2 = borderInfoCompute["".concat(r, "_").concat(c)].l.style;
                      var _bcolor2 = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l.color;

                      if (_.isNil(bl_obj.style[_linetype2])) {
                        bl_obj.style[_linetype2] = 1;
                      } else {
                        bl_obj.style[_linetype2] += 1;
                      }

                      if (_.isNil(bl_obj.color[_bcolor2])) {
                        bl_obj.color[_bcolor2] = 1;
                      } else {
                        bl_obj.color[_bcolor2] += 1;
                      }
                    }

                    if (bd_c === c + cell.mc.cs - 1 && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] && borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r) {
                      var _linetype3 = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r.style;
                      var _bcolor3 = borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r.color;

                      if (_.isNil(br_obj.style[_linetype3])) {
                        br_obj.style[_linetype3] = 1;
                      } else {
                        br_obj.style[_linetype3] += 1;
                      }

                      if (_.isNil(br_obj.color[_bcolor3])) {
                        br_obj.color[_bcolor3] = 1;
                      } else {
                        br_obj.color[_bcolor3] += 1;
                      }
                    }
                  }
                }

                var rowlen = cell.mc.rs;
                var collen = cell.mc.cs;

                if (JSON.stringify(bl_obj).length > 23) {
                  var bl_color = null;
                  var bl_style = null;
                  Object.keys(bl_obj.color).forEach(function (x) {
                    if (bl_obj.color[x] >= rowlen / 2) {
                      bl_color = x;
                    }
                  });
                  Object.keys(bl_obj.style).forEach(function (x) {
                    if (bl_obj.style[x] >= rowlen / 2) {
                      bl_style = x;
                    }
                  });

                  if (!_.isNil(bl_color) && !_.isNil(bl_style)) {
                    style += "border-left:".concat(getHtmlBorderStyle(bl_style, bl_color));
                  }
                }

                if (JSON.stringify(br_obj).length > 23) {
                  var br_color = null;
                  var br_style = null;
                  Object.keys(br_obj.color).forEach(function (x) {
                    if (br_obj.color[x] >= rowlen / 2) {
                      br_color = x;
                    }
                  });
                  Object.keys(br_obj.style).forEach(function (x) {
                    if (br_obj.style[x] >= rowlen / 2) {
                      br_style = x;
                    }
                  });

                  if (!_.isNil(br_color) && !_.isNil(br_style)) {
                    style += "border-right:".concat(getHtmlBorderStyle(br_style, br_color));
                  }
                }

                if (JSON.stringify(bt_obj).length > 23) {
                  var bt_color = null;
                  var bt_style = null;
                  Object.keys(bt_obj.color).forEach(function (x) {
                    if (bt_obj.color[x] >= collen / 2) {
                      bt_color = x;
                    }
                  });
                  Object.keys(bt_obj.style).forEach(function (x) {
                    if (bt_obj.style[x] >= collen / 2) {
                      bt_style = x;
                    }
                  });

                  if (!_.isNil(bt_color) && !_.isNil(bt_style)) {
                    style += "border-top:".concat(getHtmlBorderStyle(bt_style, bt_color));
                  }
                }

                if (JSON.stringify(bb_obj).length > 23) {
                  var bb_color = null;
                  var bb_style = null;
                  Object.keys(bb_obj.color).forEach(function (x) {
                    if (bb_obj.color[x] >= collen / 2) {
                      bb_color = x;
                    }
                  });
                  Object.keys(bb_obj.style).forEach(function (x) {
                    if (bb_obj.style[x] >= collen / 2) {
                      bb_style = x;
                    }
                  });

                  if (!_.isNil(bb_color) && !_.isNil(bb_style)) {
                    style += "border-bottom:".concat(getHtmlBorderStyle(bb_style, bb_color));
                  }
                }
              })();
            }
          } else {
            continue;
          }
        } else {
          if (borderInfoCompute && borderInfoCompute["".concat(r, "_").concat(c)]) {
            if (borderInfoCompute["".concat(r, "_").concat(c)].l) {
              var linetype = borderInfoCompute["".concat(r, "_").concat(c)].l.style;
              var bcolor = borderInfoCompute["".concat(r, "_").concat(c)].l.color;
              style += "border-left:".concat(getHtmlBorderStyle(linetype, bcolor));
            }

            if (borderInfoCompute["".concat(r, "_").concat(c)].r) {
              var _linetype4 = borderInfoCompute["".concat(r, "_").concat(c)].r.style;
              var _bcolor4 = borderInfoCompute["".concat(r, "_").concat(c)].r.color;
              style += "border-right:".concat(getHtmlBorderStyle(_linetype4, _bcolor4));
            }

            if (borderInfoCompute["".concat(r, "_").concat(c)].b) {
              var _linetype5 = borderInfoCompute["".concat(r, "_").concat(c)].b.style;
              var _bcolor5 = borderInfoCompute["".concat(r, "_").concat(c)].b.color;
              style += "border-bottom:".concat(getHtmlBorderStyle(_linetype5, _bcolor5));
            }

            if (borderInfoCompute["".concat(r, "_").concat(c)].t) {
              var _linetype6 = borderInfoCompute["".concat(r, "_").concat(c)].t.style;
              var _bcolor6 = borderInfoCompute["".concat(r, "_").concat(c)].t.color;
              style += "border-top:".concat(getHtmlBorderStyle(_linetype6, _bcolor6));
            }
          }
        }

        column = replaceHtml(column, {
          style: style,
          span: span
        });

        if (_.isNil(c_value)) {
          c_value = getCellValue(r, c, d);
        }

        if (_.isNil(c_value)) {
          c_value = "";
        }

        column += escapeHTMLTag(c_value);
      } else {
        var _style = "";

        if (borderInfoCompute && borderInfoCompute["".concat(r, "_").concat(c)]) {
          if (borderInfoCompute["".concat(r, "_").concat(c)].l) {
            var _linetype7 = borderInfoCompute["".concat(r, "_").concat(c)].l.style;
            var _bcolor7 = borderInfoCompute["".concat(r, "_").concat(c)].l.color;
            _style += "border-left:".concat(getHtmlBorderStyle(_linetype7, _bcolor7));
          }

          if (borderInfoCompute["".concat(r, "_").concat(c)].r) {
            var _linetype8 = borderInfoCompute["".concat(r, "_").concat(c)].r.style;
            var _bcolor8 = borderInfoCompute["".concat(r, "_").concat(c)].r.color;
            _style += "border-right:".concat(getHtmlBorderStyle(_linetype8, _bcolor8));
          }

          if (borderInfoCompute["".concat(r, "_").concat(c)].b) {
            var _linetype9 = borderInfoCompute["".concat(r, "_").concat(c)].b.style;
            var _bcolor9 = borderInfoCompute["".concat(r, "_").concat(c)].b.color;
            _style += "border-bottom:".concat(getHtmlBorderStyle(_linetype9, _bcolor9));
          }

          if (borderInfoCompute["".concat(r, "_").concat(c)].t) {
            var _linetype10 = borderInfoCompute["".concat(r, "_").concat(c)].t.style;
            var _bcolor10 = borderInfoCompute["".concat(r, "_").concat(c)].t.color;
            _style += "border-top:".concat(getHtmlBorderStyle(_linetype10, _bcolor10));
          }
        }

        column += "";

        if (r === rowIndexArr[0]) {
          if (_.isNil(sheet.config) || _.isNil(sheet.config.columnlen) || _.isNil(sheet.config.columnlen[c.toString()])) {
            colgroup += '<colgroup width="72px"></colgroup>';
          } else {
            colgroup += "<colgroup width=\"".concat(sheet.config.columnlen[c.toString()], "px\"></colgroup>");
          }
        }

        if (c === colIndexArr[0]) {
          if (_.isNil(sheet.config) || _.isNil(sheet.config.rowlen) || _.isNil(sheet.config.rowlen[r.toString()])) {
            _style += "height:19px;";
          } else {
            _style += "height:".concat(sheet.config.rowlen[r.toString()], "px;");
          }
        }

        column = replaceHtml(column, {
          style: _style,
          span: ""
        });
        column += "";
      }

      column += "</td>";
      cpdata += column;
    }

    cpdata += "</tr>";
  }

  return "<table data-type=\"fortune-copy-action-table\">".concat(colgroup).concat(cpdata, "</table>");
}
function copy(ctx) {
  var flowdata = getFlowdata(ctx);
  ctx.luckysheet_selection_range = [];
  var copyRange = [];
  var RowlChange = false;
  var HasMC = false;

  for (var s = 0; s < ((_ctx$luckysheet_selec2 = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3.length) !== null && _ctx$luckysheet_selec2 !== void 0 ? _ctx$luckysheet_selec2 : 0); s += 1) {
    var _ctx$luckysheet_selec2, _ctx$luckysheet_selec3;

    var range = ctx.luckysheet_select_save[s];
    var r1 = range.row[0];
    var r2 = range.row[1];
    var c1 = range.column[0];
    var c2 = range.column[1];

    for (var copyR = r1; copyR <= r2; copyR += 1) {
      if (!_.isNil(ctx.config.rowhidden) && !_.isNil(ctx.config.rowhidden[copyR])) {
        continue;
      }

      if (!_.isNil(ctx.config.rowlen) && copyR in ctx.config.rowlen) {
        RowlChange = true;
      }

      for (var copyC = c1; copyC <= c2; copyC += 1) {
        var _flowdata$copyR, _cell$mc;

        if (!_.isNil(ctx.config.colhidden) && !_.isNil(ctx.config.colhidden[copyC])) {
          continue;
        }

        var cell = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$copyR = flowdata[copyR]) === null || _flowdata$copyR === void 0 ? void 0 : _flowdata$copyR[copyC];

        if (!_.isNil(cell === null || cell === void 0 ? void 0 : (_cell$mc = cell.mc) === null || _cell$mc === void 0 ? void 0 : _cell$mc.rs)) {
          HasMC = true;
        }
      }
    }

    ctx.luckysheet_selection_range.push({
      row: range.row,
      column: range.column
    });
    copyRange.push({
      row: range.row,
      column: range.column
    });
  }

  ctx.luckysheet_copy_save = {
    dataSheetId: ctx.currentSheetId,
    copyRange: copyRange,
    RowlChange: RowlChange,
    HasMC: HasMC
  };
  var cpdata = rangeValueToHtml(ctx, ctx.currentSheetId, ctx.luckysheet_select_save);

  if (cpdata) {
    ctx.iscopyself = true;
    clipboard.writeHtml(cpdata);
  }
}
function deleteSelectedCellText(ctx) {
  var allowEdit = isAllowEdit(ctx);

  if (allowEdit === false) {
    return "allowEdit";
  }

  var selection = ctx.luckysheet_select_save;

  if (selection && !_.isEmpty(selection)) {
    var d = getFlowdata(ctx);
    if (!d) return "dataNullError";
    var has_PartMC = false;

    for (var s = 0; s < selection.length; s += 1) {
      var r1 = selection[s].row[0];
      var r2 = selection[s].row[1];
      var c1 = selection[s].column[0];
      var c2 = selection[s].column[1];

      if (hasPartMC(ctx, ctx.config, r1, r2, c1, c2)) {
        has_PartMC = true;
        break;
      }
    }

    if (has_PartMC) {
      return "partMC";
    }

    var hyperlinkMap = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].hyperlink;

    for (var _s = 0; _s < selection.length; _s += 1) {
      var _r3 = selection[_s].row[0];
      var _r4 = selection[_s].row[1];
      var _c3 = selection[_s].column[0];
      var _c4 = selection[_s].column[1];

      for (var r = _r3; r <= _r4; r += 1) {
        for (var c = _c3; c <= _c4; c += 1) {
          if (_.isPlainObject(d[r][c])) {
            var cell = d[r][c];
            delete cell.m;
            delete cell.v;

            if (cell.f != null) {
              delete cell.f;
              delFunctionGroup(ctx, r, c, ctx.currentSheetId);
              delete cell.spl;
            }

            if (cell.ct != null && cell.ct.t === "inlineStr") {
              delete cell.ct;
            }
          } else {
            d[r][c] = null;
          }

          if (hyperlinkMap && hyperlinkMap["".concat(r, "_").concat(c)]) {
            delete hyperlinkMap["".concat(r, "_").concat(c)];
          }
        }
      }
    }
  }

  return "success";
}
function selectIsOverlap(ctx, range) {
  if (range == null) {
    range = ctx.luckysheet_select_save;
  }

  range = _.cloneDeep(range);
  var overlap = false;
  var map = {};

  for (var s = 0; s < range.length; s += 1) {
    var str_r = range[s].row[0];
    var end_r = range[s].row[1];
    var str_c = range[s].column[0];
    var end_c = range[s].column[1];

    for (var r = str_r; r <= end_r; r += 1) {
      for (var c = str_c; c <= end_c; c += 1) {
        if ("".concat(r, "_").concat(c) in map) {
          overlap = true;
          break;
        } else {
          map["".concat(r, "_").concat(c)] = 0;
        }
      }
    }
  }

  return overlap;
}
function selectAll(ctx) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  ctx.luckysheet_select_status = false;
  ctx.luckysheet_select_save = [{
    row: [0, flowdata.length - 1],
    column: [0, flowdata[0].length - 1],
    row_focus: 0,
    column_focus: 0,
    row_select: true,
    column_select: true
  }];
  normalizeSelection(ctx, ctx.luckysheet_select_save);
}
function fixRowStyleOverflowInFreeze(ctx, r1, r2, freeze) {
  var _freeze$horizontal;

  if (!freeze) return {};
  var ret = {};
  var scrollTop = ctx.scrollTop;
  var freezenhorizontaldata = (_freeze$horizontal = freeze.horizontal) === null || _freeze$horizontal === void 0 ? void 0 : _freeze$horizontal.freezenhorizontaldata;
  var rangeshow = true;

  if (freezenhorizontaldata != null) {
    var freezenTop = freezenhorizontaldata[0];
    var freezen_rowindex = freezenhorizontaldata[1];
    var offTop = scrollTop - freezenhorizontaldata[2];
    var row = ctx.visibledatarow[r2];
    var row_pre = r1 - 1 === -1 ? 0 : ctx.visibledatarow[r1 - 1];
    var top_move = row_pre;
    var height_move = row - row_pre - 1;

    if (r1 >= freezen_rowindex) {
      if (top_move + height_move < freezenTop + offTop) {
        rangeshow = false;
      } else if (top_move < freezenTop + offTop) {
        ret.top = freezenTop + offTop;
        ret.height = height_move - (freezenTop + offTop - top_move);
      } else ;
    } else if (r2 >= freezen_rowindex) {
      if (top_move + height_move < freezenTop + offTop) {
        ret.top = top_move + offTop;
        ret.height = freezenTop - top_move;
      } else {
        ret.top = top_move + offTop;
        ret.height = height_move - offTop;
      }
    } else {
      ret.top = top_move + offTop;
    }
  }

  if (!rangeshow) {
    ret.display = "none";
  }

  return ret;
}
function fixColumnStyleOverflowInFreeze(ctx, c1, c2, freeze) {
  var _freeze$vertical;

  if (!freeze) return {};
  var ret = {};
  var scrollLeft = ctx.scrollLeft;
  var freezenverticaldata = (_freeze$vertical = freeze.vertical) === null || _freeze$vertical === void 0 ? void 0 : _freeze$vertical.freezenverticaldata;
  var rangeshow = true;

  if (freezenverticaldata != null) {
    var freezenLeft = freezenverticaldata[0];
    var freezen_colindex = freezenverticaldata[1];
    var offLeft = scrollLeft - freezenverticaldata[2];
    var col = ctx.visibledatacolumn[c2];
    var col_pre = c1 - 1 === -1 ? 0 : ctx.visibledatacolumn[c1 - 1];
    var left_move = col_pre;
    var width_move = col - col_pre - 1;

    if (c1 >= freezen_colindex) {
      if (left_move + width_move < freezenLeft + offLeft) {
        rangeshow = false;
      } else if (left_move < freezenLeft + offLeft) {
        ret.left = freezenLeft + offLeft;
        ret.width = width_move - (freezenLeft + offLeft - left_move);
      } else ;
    } else if (c2 >= freezen_colindex) {
      if (left_move + width_move < freezenLeft + offLeft) {
        ret.left = left_move + offLeft;
        ret.width = freezenLeft - left_move;
      } else {
        ret.left = left_move + offLeft;
        ret.width = width_move - offLeft;
      }
    } else {
      ret.left = left_move + offLeft;
    }
  }

  if (!rangeshow) {
    ret.display = "none";
  }

  return ret;
}
function calcSelectionInfo(ctx, lang) {
  var selection = ctx.luckysheet_select_save;
  var numberC = 0;
  var count = 0;
  var sum = 0;
  var max = -Infinity;
  var min = Infinity;

  for (var s = 0; s < selection.length; s += 1) {
    var data = getDataBySelectionNoCopy(ctx, selection[s]);

    for (var r = 0; r < data.length; r += 1) {
      for (var c = 0; c < data[0].length; c += 1) {
        var _data$r$c, _data$r$c$ct, _data$r$c2;

        if (r >= data.length || c >= data[0].length) break;
        var ct = (_data$r$c = data[r][c]) === null || _data$r$c === void 0 ? void 0 : (_data$r$c$ct = _data$r$c.ct) === null || _data$r$c$ct === void 0 ? void 0 : _data$r$c$ct.t;
        var value = (_data$r$c2 = data[r][c]) === null || _data$r$c2 === void 0 ? void 0 : _data$r$c2.m;

        if (ct === "n" || ct === "g" && parseFloat(value).toString() !== "NaN") {
          var valueNumber = parseFloat(value);
          count += 1;
          sum += valueNumber;
          max = Math.max(valueNumber, max);
          min = Math.min(valueNumber, min);
          numberC += 1;
        } else if (value != null) {
          count += 1;
        }
      }
    }
  }

  var formatString = lang && !["zh", "zh_tw"].includes(lang) ? "0.00" : "w0.00";
  var average = SSF.format(formatString, sum / numberC);
  sum = SSF.format(formatString, sum);
  max = SSF.format(formatString, max);
  min = SSF.format(formatString, min);
  return {
    numberC: numberC,
    count: count,
    sum: sum,
    max: max,
    min: min,
    average: average
  };
}

function defaultContext(refs) {
  return {
    luckysheetfile: [],
    defaultcolumnNum: 60,
    defaultrowNum: 84,
    addDefaultRows: 50,
    fullscreenmode: true,
    devicePixelRatio: (globalThis || window).devicePixelRatio,
    contextMenu: {},
    sheetTabContextMenu: {},
    currentSheetId: "",
    calculateSheetId: "",
    config: {},
    warnDialog: undefined,
    currency: "¥",
    rangeDialog: {
      show: false,
      rangeTxt: "",
      type: "",
      singleSelect: false
    },
    dataVerification: {
      selectStatus: false,
      selectRange: [],
      optionLabel_en: {
        number: "numeric",
        number_integer: "integer",
        number_decimal: "decimal",
        between: "between",
        notBetween: "not between",
        equal: "equal to",
        notEqualTo: "not equal to",
        moreThanThe: "greater",
        lessThan: "less than",
        greaterOrEqualTo: "greater or equal to",
        lessThanOrEqualTo: "less than or equal to",
        include: "include",
        exclude: "not include",
        earlierThan: "earlier than",
        noEarlierThan: "not earlier than",
        laterThan: "later than",
        noLaterThan: "not later than",
        identificationNumber: "identification number",
        phoneNumber: "phone number"
      },
      optionLabel_hi: {
        number: "संख्यात्मक",
        number_integer: "पूर्णांक",
        number_decimal: "दशमलव",
        between: "के बीच",
        notBetween: "के बीच नहीं",
        equal: "के बराबर",
        notEqualTo: "के बराबर नहीं",
        moreThanThe: "से अधिक",
        lessThan: "से कम",
        greaterOrEqualTo: "के बराबर या अधिक",
        lessThanOrEqualTo: "के बराबर या कम",
        include: "शामिल",
        exclude: "शामिल नहीं",
        earlierThan: "से पहले",
        noEarlierThan: "से पहले नहीं",
        laterThan: "के बाद",
        noLaterThan: "के बाद नहीं",
        identificationNumber: "पहचान संख्या",
        phoneNumber: "फोन नंबर"
      },
      optionLabel_zh: {
        number: "数值",
        number_integer: "整数",
        number_decimal: "小数",
        between: "介于",
        notBetween: "不介于",
        equal: "等于",
        notEqualTo: "不等于",
        moreThanThe: "大于",
        lessThan: "小于",
        greaterOrEqualTo: "大于等于",
        lessThanOrEqualTo: "小于等于",
        include: "包括",
        exclude: "不包括",
        earlierThan: "早于",
        noEarlierThan: "不早于",
        laterThan: "晚于",
        noLaterThan: "不晚于",
        identificationNumber: "身份证号码",
        phoneNumber: "手机号"
      },
      optionLabel_zh_tw: {
        number: "數位",
        number_integer: "數位-整數",
        number_decimal: "數位-小數",
        between: "介於",
        notBetween: "不介於",
        equal: "等於",
        notEqualTo: "不等於",
        moreThanThe: "大於",
        lessThan: "小於",
        greaterOrEqualTo: "大於等於",
        lessThanOrEqualTo: "小於等於",
        include: "包括",
        exclude: "不包括",
        earlierThan: "早於",
        noEarlierThan: "不早於",
        laterThan: "晚於",
        noLaterThan: "不晚於",
        identificationNumber: "身份證號碼",
        phoneNumber: "手機號"
      },
      optionLabel_es: {
        number: "Número",
        number_integer: "Número entero",
        number_decimal: "Número decimal",
        between: "Entre",
        notBetween: "No entre",
        equal: "Iqual",
        notEqualTo: "No iqual a",
        moreThanThe: "Más que el",
        lessThan: "Menos que",
        greaterOrEqualTo: "Mayor o igual a",
        lessThanOrEqualTo: "Menor o igual a",
        include: "Incluir",
        exclude: "Excluir",
        earlierThan: "Antes de",
        noEarlierThan: "No antes de",
        laterThan: "Después de",
        noLaterThan: "No después de",
        identificationNumber: "Número de identificación",
        phoneNumber: "Número de teléfono"
      },
      dataRegulation: {
        type: "",
        type2: "",
        rangeTxt: "",
        value1: "",
        value2: "",
        validity: "",
        remote: false,
        prohibitInput: false,
        hintShow: false,
        hintValue: ""
      }
    },
    dataVerificationDropDownList: false,
    conditionRules: {
      rulesType: "",
      rulesValue: "",
      textColor: {
        check: true,
        color: "#000000"
      },
      cellColor: {
        check: true,
        color: "#000000"
      },
      betweenValue: {
        value1: "",
        value2: ""
      },
      dateValue: "",
      repeatValue: "0",
      projectValue: "10"
    },
    visibledatarow: [],
    visibledatacolumn: [],
    ch_width: 0,
    rh_height: 0,
    cellmainWidth: 0,
    cellmainHeight: 0,
    toolbarHeight: 41,
    infobarHeight: 57,
    calculatebarHeight: 29,
    rowHeaderWidth: 46,
    columnHeaderHeight: 20,
    cellMainSrollBarSize: 12,
    sheetBarHeight: 31,
    statisticBarHeight: 23,
    luckysheetTableContentHW: [0, 0],
    defaultcollen: 73,
    defaultrowlen: 19,
    scrollLeft: 0,
    scrollTop: 0,
    sheetScrollRecord: {},
    luckysheet_select_status: false,
    luckysheet_select_save: undefined,
    luckysheet_selection_range: [],
    formulaRangeHighlight: [],
    formulaRangeSelect: undefined,
    functionCandidates: [],
    functionHint: null,
    luckysheet_copy_save: undefined,
    luckysheet_paste_iscut: false,
    filterchage: true,
    filter: {},
    luckysheet_sheet_move_status: false,
    luckysheet_sheet_move_data: [],
    luckysheet_scroll_status: false,
    luckysheetcurrentisPivotTable: false,
    luckysheet_rows_selected_status: false,
    luckysheet_cols_selected_status: false,
    luckysheet_rows_change_size: false,
    luckysheet_rows_change_size_start: [],
    luckysheet_cols_change_size: false,
    luckysheet_cols_change_size_start: [],
    luckysheet_cols_freeze_drag: false,
    luckysheet_rows_freeze_drag: false,
    luckysheetCellUpdate: [],
    luckysheet_shiftkeydown: false,
    luckysheet_shiftpositon: undefined,
    iscopyself: true,
    activeImg: undefined,
    orderbyindex: 0,
    luckysheet_model_move_state: false,
    luckysheet_model_xy: [0, 0],
    luckysheet_model_move_obj: null,
    luckysheet_cell_selected_move: false,
    luckysheet_cell_selected_move_index: [],
    luckysheet_cell_selected_extend: false,
    luckysheet_cell_selected_extend_index: [],
    lang: null,
    chart_selection: {},
    zoomRatio: 1,
    showGridLines: true,
    allowEdit: true,
    fontList: [],
    defaultFontSize: 10,
    luckysheetPaintModelOn: false,
    luckysheetPaintSingle: false,
    defaultCell: {
      bl: 0,
      ct: {
        fa: "General",
        t: "n"
      },
      fc: "rgb(51, 51, 51)",
      ff: 0,
      fs: 11,
      ht: 1,
      it: 0,
      vt: 1,
      m: "",
      v: ""
    },
    groupValuesRefreshData: [],
    formulaCache: new FormulaCache(),
    hooks: {},
    getRefs: function getRefs() {
      return refs;
    }
  };
}
function getFlowdata(ctx, id) {
  var _ctx$luckysheetfile, _ctx$luckysheetfile$i;

  if (!ctx) return null;
  var i = getSheetIndex(ctx, id || ctx.currentSheetId);

  if (_.isNil(i)) {
    return null;
  }

  return (_ctx$luckysheetfile = ctx.luckysheetfile) === null || _ctx$luckysheetfile === void 0 ? void 0 : (_ctx$luckysheetfile$i = _ctx$luckysheetfile[i]) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i.data;
}

function calcRowColSize(ctx, rowCount, colCount) {
  ctx.visibledatarow = [];
  ctx.rh_height = 0;

  for (var r = 0; r < rowCount; r += 1) {
    var _ctx$config$rowlen, _ctx$config2, _ctx$config2$rowhidde;

    var rowlen = ctx.defaultrowlen;

    if ((_ctx$config$rowlen = ctx.config.rowlen) === null || _ctx$config$rowlen === void 0 ? void 0 : _ctx$config$rowlen[r]) {
      var _ctx$config, _ctx$config$rowlen2;

      rowlen = (_ctx$config = ctx.config) === null || _ctx$config === void 0 ? void 0 : (_ctx$config$rowlen2 = _ctx$config.rowlen) === null || _ctx$config$rowlen2 === void 0 ? void 0 : _ctx$config$rowlen2[r];
    }

    if (((_ctx$config2 = ctx.config) === null || _ctx$config2 === void 0 ? void 0 : (_ctx$config2$rowhidde = _ctx$config2.rowhidden) === null || _ctx$config2$rowhidde === void 0 ? void 0 : _ctx$config2$rowhidde[r]) != null) {
      ctx.visibledatarow.push(ctx.rh_height);
      continue;
    }

    ctx.rh_height += Math.round((rowlen + 1) * ctx.zoomRatio);
    ctx.visibledatarow.push(ctx.rh_height);
  }

  ctx.rh_height += 80;
  ctx.visibledatacolumn = [];
  ctx.ch_width = 0;
  var maxColumnlen = 120;
  var flowdata = getFlowdata(ctx);

  for (var c = 0; c < colCount; c += 1) {
    var _ctx$config3, _ctx$config3$columnle, _ctx$config5, _ctx$config5$colhidde;

    var firstcolumnlen = ctx.defaultcollen;

    if ((_ctx$config3 = ctx.config) === null || _ctx$config3 === void 0 ? void 0 : (_ctx$config3$columnle = _ctx$config3.columnlen) === null || _ctx$config3$columnle === void 0 ? void 0 : _ctx$config3$columnle[c]) {
      firstcolumnlen = ctx.config.columnlen[c];
    } else {
      var _flowdata$;

      if (flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$ = flowdata[0]) === null || _flowdata$ === void 0 ? void 0 : _flowdata$[c]) {
        if (firstcolumnlen > 300) {
          firstcolumnlen = 300;
        } else if (firstcolumnlen < ctx.defaultcollen) {
          firstcolumnlen = ctx.defaultcollen;
        }

        if (firstcolumnlen !== ctx.defaultcollen) {
          var _ctx$config4;

          if (!((_ctx$config4 = ctx.config) === null || _ctx$config4 === void 0 ? void 0 : _ctx$config4.columnlen)) {
            ctx.config.columnlen = {};
          }

          ctx.config.columnlen[c] = firstcolumnlen;
        }
      }
    }

    if (((_ctx$config5 = ctx.config) === null || _ctx$config5 === void 0 ? void 0 : (_ctx$config5$colhidde = _ctx$config5.colhidden) === null || _ctx$config5$colhidde === void 0 ? void 0 : _ctx$config5$colhidde[c]) != null) {
      ctx.visibledatacolumn.push(ctx.ch_width);
      continue;
    }

    ctx.ch_width += Math.round((firstcolumnlen + 1) * ctx.zoomRatio);
    ctx.visibledatacolumn.push(ctx.ch_width);
  }

  ctx.ch_width += maxColumnlen;
}

function ensureSheetIndex(data, generateSheetId) {
  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    var hasActive = false;
    var indexs = [];
    data.forEach(function (item) {
      if (item.id == null) {
        item.id = generateSheetId();
      }

      if (indexs.includes(item.id)) {
        item.id = generateSheetId();
      } else {
        indexs.push(item.id);
      }

      if (item.status == null) {
        item.status = 0;
      }

      if (item.status === 1) {
        if (hasActive) {
          item.status = 0;
        } else {
          hasActive = true;
        }
      }
    });

    if (!hasActive) {
      data[0].status = 1;
    }
  }
}
function initSheetIndex(ctx) {
  var shownSheets = ctx.luckysheetfile.filter(function (singleSheet) {
    return _.isUndefined(singleSheet.hide) || singleSheet.hide !== 1;
  });
  ctx.currentSheetId = _.sortBy(shownSheets, function (sheet) {
    return sheet.order;
  })[0].id;

  for (var i = 0; i < ctx.luckysheetfile.length; i += 1) {
    if (ctx.luckysheetfile[i].status === 1 && ctx.luckysheetfile[i].hide !== 1) {
      ctx.currentSheetId = ctx.luckysheetfile[i].id;
      break;
    }
  }
}
function updateContextWithSheetData(ctx, data) {
  var rowCount = data.length;
  var colCount = rowCount === 0 ? 0 : data[0].length;
  calcRowColSize(ctx, rowCount, colCount);
  normalizeSelection(ctx, ctx.luckysheet_select_save);
}
function updateContextWithCanvas(ctx, canvas, placeholder) {
  ctx.luckysheetTableContentHW = [placeholder.clientWidth, placeholder.clientHeight];
  ctx.cellmainHeight = placeholder.clientHeight - ctx.columnHeaderHeight;
  ctx.cellmainWidth = placeholder.clientWidth - ctx.rowHeaderWidth;
  canvas.style.width = "".concat(ctx.luckysheetTableContentHW[0], "px");
  canvas.style.height = "".concat(ctx.luckysheetTableContentHW[1], "px");
  canvas.width = Math.ceil(ctx.luckysheetTableContentHW[0] * ctx.devicePixelRatio);
  canvas.height = Math.ceil(ctx.luckysheetTableContentHW[1] * ctx.devicePixelRatio);
}

function getBorderInfoComputeRange(ctx, dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed, sheetId) {
  var borderInfoCompute = {};
  var flowdata = getFlowdata(ctx);
  var cfg;
  var data;

  if (!sheetId) {
    cfg = ctx.config;
    data = flowdata;
  } else {
    var index = getSheetIndex(ctx, sheetId);

    if (!_.isNil(index)) {
      cfg = ctx.luckysheetfile[index].config;
      data = ctx.luckysheetfile[index].data;
    } else {
      return borderInfoCompute;
    }
  }

  if (!data || !cfg) return borderInfoCompute;
  var _cfg = cfg,
      borderInfo = _cfg.borderInfo;
  if (!borderInfo || _.isEmpty(borderInfo)) return borderInfoCompute;

  for (var i = 0; i < borderInfo.length; i += 1) {
    var rangeType = borderInfo[i].rangeType;

    if (rangeType === "range") {
      var borderType = borderInfo[i].borderType;
      var borderColor = borderInfo[i].color;
      var borderStyle = borderInfo[i].style;
      var borderRange = borderInfo[i].range;

      var _loop = function _loop(j) {
        var bd_r1 = borderRange[j].row[0];
        var bd_r2 = borderRange[j].row[1];
        var bd_c1 = borderRange[j].column[0];
        var bd_c2 = borderRange[j].column[1];

        if (bd_r1 < dataset_row_st) {
          bd_r1 = dataset_row_st;
        }

        if (bd_r2 > dataset_row_ed) {
          bd_r2 = dataset_row_ed;
        }

        if (bd_c1 < dataset_col_st) {
          bd_c1 = dataset_col_st;
        }

        if (bd_c2 > dataset_col_ed) {
          bd_c2 = dataset_col_ed;
        }

        if (borderType === "border-slash") {
          var bd_r = borderRange[0].row_focus;
          var bd_c = borderRange[0].column_focus;

          if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[bd_r])) {
            return "continue";
          }

          if (bd_c < dataset_col_st || bd_c > dataset_col_ed) return "continue";
          if (bd_r < dataset_row_st || bd_r > dataset_row_ed) return "continue";

          if (borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] === undefined) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] = {};
          }

          borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].s = {
            color: borderColor,
            style: borderStyle
          };
        }

        if (borderType === "border-left") {
          var _loop2 = function _loop2(_bd_r) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r])) {
              return "continue";
            }

            if (borderInfoCompute["".concat(_bd_r, "_").concat(bd_c1)] === undefined) {
              borderInfoCompute["".concat(_bd_r, "_").concat(bd_c1)] = {};
            }

            borderInfoCompute["".concat(_bd_r, "_").concat(bd_c1)].l = {
              color: borderColor,
              style: borderStyle
            };
            var bd_c_left = bd_c1 - 1;

            if (bd_c_left >= 0 && borderInfoCompute["".concat(_bd_r, "_").concat(bd_c_left)]) {
              var _data$_bd_r, _data$_bd_r$bd_c_left;

              if (!_.isNil((_data$_bd_r = data[_bd_r]) === null || _data$_bd_r === void 0 ? void 0 : (_data$_bd_r$bd_c_left = _data$_bd_r[bd_c_left]) === null || _data$_bd_r$bd_c_left === void 0 ? void 0 : _data$_bd_r$bd_c_left.mc)) {
                var _cfg$merge, _cell_left$mc, _cell_left$mc2;

                var cell_left = data[_bd_r][bd_c_left];

                var _mc = (_cfg$merge = cfg.merge) === null || _cfg$merge === void 0 ? void 0 : _cfg$merge["".concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc = cell_left.mc) === null || _cell_left$mc === void 0 ? void 0 : _cell_left$mc.r, "_").concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc2 = cell_left.mc) === null || _cell_left$mc2 === void 0 ? void 0 : _cell_left$mc2.c)];

                if (_mc && _mc.c + _mc.cs - 1 === bd_c_left) {
                  borderInfoCompute["".concat(_bd_r, "_").concat(bd_c_left)].r = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                borderInfoCompute["".concat(_bd_r, "_").concat(bd_c_left)].r = {
                  color: borderColor,
                  style: borderStyle
                };
              }
            }

            var mc = cfg.merge || {};
            Object.keys(mc).forEach(function (key) {
              var _mc$key = mc[key],
                  c = _mc$key.c,
                  r = _mc$key.r,
                  cs = _mc$key.cs,
                  rs = _mc$key.rs;

              if (bd_c1 <= c + cs - 1 && bd_c1 > c && _bd_r >= r && _bd_r <= r + rs - 1) {
                borderInfoCompute["".concat(_bd_r, "_").concat(bd_c1)].l = null;
              }
            });
          };

          for (var _bd_r = bd_r1; _bd_r <= bd_r2; _bd_r += 1) {
            var _ret2 = _loop2(_bd_r);

            if (_ret2 === "continue") continue;
          }
        } else if (borderType === "border-right") {
          var _loop3 = function _loop3(_bd_r2) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r2])) {
              return "continue";
            }

            if (borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c2)] === undefined) {
              borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c2)] = {};
            }

            borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c2)].r = {
              color: borderColor,
              style: borderStyle
            };
            var bd_c_right = bd_c2 + 1;

            if (bd_c_right < data[0].length && borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c_right)]) {
              var _data$_bd_r2, _data$_bd_r2$bd_c_rig;

              if (!_.isNil((_data$_bd_r2 = data[_bd_r2]) === null || _data$_bd_r2 === void 0 ? void 0 : (_data$_bd_r2$bd_c_rig = _data$_bd_r2[bd_c_right]) === null || _data$_bd_r2$bd_c_rig === void 0 ? void 0 : _data$_bd_r2$bd_c_rig.mc)) {
                var _cfg$merge2, _cell_right$mc, _cell_right$mc2;

                var cell_right = data[_bd_r2][bd_c_right];

                var _mc2 = (_cfg$merge2 = cfg.merge) === null || _cfg$merge2 === void 0 ? void 0 : _cfg$merge2["".concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc = cell_right.mc) === null || _cell_right$mc === void 0 ? void 0 : _cell_right$mc.r, "_").concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc2 = cell_right.mc) === null || _cell_right$mc2 === void 0 ? void 0 : _cell_right$mc2.c)];

                if (_mc2 && _mc2.c === bd_c_right) {
                  borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c_right)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c_right)].l = {
                  color: borderColor,
                  style: borderStyle
                };
              }
            }

            var mc = cfg.merge || {};
            Object.keys(mc).forEach(function (key) {
              var _mc$key2 = mc[key],
                  c = _mc$key2.c,
                  r = _mc$key2.r,
                  cs = _mc$key2.cs,
                  rs = _mc$key2.rs;

              if (bd_c2 < c + cs - 1 && bd_c2 >= c && _bd_r2 >= r && _bd_r2 <= r + rs - 1) {
                borderInfoCompute["".concat(_bd_r2, "_").concat(bd_c2)].r = null;
              }
            });
          };

          for (var _bd_r2 = bd_r1; _bd_r2 <= bd_r2; _bd_r2 += 1) {
            var _ret3 = _loop3(_bd_r2);

            if (_ret3 === "continue") continue;
          }
        } else if (borderType === "border-top") {
          if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[bd_r1])) {
            return "continue";
          }

          var _loop4 = function _loop4(_bd_c) {
            if (borderInfoCompute["".concat(bd_r1, "_").concat(_bd_c)] === undefined) {
              borderInfoCompute["".concat(bd_r1, "_").concat(_bd_c)] = {};
            }

            borderInfoCompute["".concat(bd_r1, "_").concat(_bd_c)].t = {
              color: borderColor,
              style: borderStyle
            };
            var bd_r_top = bd_r1 - 1;

            if (bd_r_top >= 0 && borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c)]) {
              var _data$bd_r_top, _data$bd_r_top$_bd_c;

              if (!_.isNil((_data$bd_r_top = data[bd_r_top]) === null || _data$bd_r_top === void 0 ? void 0 : (_data$bd_r_top$_bd_c = _data$bd_r_top[_bd_c]) === null || _data$bd_r_top$_bd_c === void 0 ? void 0 : _data$bd_r_top$_bd_c.mc)) {
                var _cfg$merge3, _cell_top$mc, _cell_top$mc2;

                var cell_top = data[bd_r_top][_bd_c];

                var _mc3 = (_cfg$merge3 = cfg.merge) === null || _cfg$merge3 === void 0 ? void 0 : _cfg$merge3["".concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc = cell_top.mc) === null || _cell_top$mc === void 0 ? void 0 : _cell_top$mc.r, "_").concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc2 = cell_top.mc) === null || _cell_top$mc2 === void 0 ? void 0 : _cell_top$mc2.c)];

                if (_mc3 && _mc3.r + _mc3.rs - 1 === bd_r_top) {
                  borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c)].b = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c)].b = {
                  color: borderColor,
                  style: borderStyle
                };
              }
            }

            var mc = cfg.merge || {};
            Object.keys(mc).forEach(function (key) {
              var _mc$key3 = mc[key],
                  c = _mc$key3.c,
                  r = _mc$key3.r,
                  cs = _mc$key3.cs,
                  rs = _mc$key3.rs;

              if (bd_r1 <= r + rs - 1 && bd_r1 > r && _bd_c >= c && _bd_c <= c + cs - 1) {
                borderInfoCompute["".concat(bd_r1, "_").concat(_bd_c)].t = null;
              }
            });
          };

          for (var _bd_c = bd_c1; _bd_c <= bd_c2; _bd_c += 1) {
            _loop4(_bd_c);
          }
        } else if (borderType === "border-bottom") {
          if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[bd_r2])) {
            return "continue";
          }

          var _loop5 = function _loop5(_bd_c2) {
            if (borderInfoCompute["".concat(bd_r2, "_").concat(_bd_c2)] === undefined) {
              borderInfoCompute["".concat(bd_r2, "_").concat(_bd_c2)] = {};
            }

            borderInfoCompute["".concat(bd_r2, "_").concat(_bd_c2)].b = {
              color: borderColor,
              style: borderStyle
            };
            var bd_r_bottom = bd_r2 + 1;

            if (bd_r_bottom < data.length && borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c2)]) {
              var _data$bd_r_bottom, _data$bd_r_bottom$_bd;

              if (!_.isNil((_data$bd_r_bottom = data[bd_r_bottom]) === null || _data$bd_r_bottom === void 0 ? void 0 : (_data$bd_r_bottom$_bd = _data$bd_r_bottom[_bd_c2]) === null || _data$bd_r_bottom$_bd === void 0 ? void 0 : _data$bd_r_bottom$_bd.mc)) {
                var _cfg$merge4, _cell_bottom$mc, _cell_bottom$mc2;

                var cell_bottom = data[bd_r_bottom][_bd_c2];

                var _mc4 = (_cfg$merge4 = cfg.merge) === null || _cfg$merge4 === void 0 ? void 0 : _cfg$merge4["".concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc = cell_bottom.mc) === null || _cell_bottom$mc === void 0 ? void 0 : _cell_bottom$mc.r, "_").concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc2 = cell_bottom.mc) === null || _cell_bottom$mc2 === void 0 ? void 0 : _cell_bottom$mc2.c)];

                if ((_mc4 === null || _mc4 === void 0 ? void 0 : _mc4.r) === bd_r_bottom) {
                  borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c2)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c2)].t = {
                  color: borderColor,
                  style: borderStyle
                };
              }
            }

            var mc = cfg.merge || {};
            Object.keys(mc).forEach(function (key) {
              var _mc$key4 = mc[key],
                  c = _mc$key4.c,
                  r = _mc$key4.r,
                  cs = _mc$key4.cs,
                  rs = _mc$key4.rs;

              if (bd_r2 < r + rs - 1 && bd_r2 >= r && _bd_c2 >= c && _bd_c2 <= c + cs - 1) {
                borderInfoCompute["".concat(bd_r2, "_").concat(_bd_c2)].b = null;
              }
            });
          };

          for (var _bd_c2 = bd_c1; _bd_c2 <= bd_c2; _bd_c2 += 1) {
            _loop5(_bd_c2);
          }
        } else if (borderType === "border-all") {
          for (var _bd_r3 = bd_r1; _bd_r3 <= bd_r2; _bd_r3 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r3])) {
              continue;
            }

            for (var _bd_c3 = bd_c1; _bd_c3 <= bd_c2; _bd_c3 += 1) {
              var _data$_bd_r3, _data$_bd_r3$_bd_c;

              if (!_.isNil((_data$_bd_r3 = data[_bd_r3]) === null || _data$_bd_r3 === void 0 ? void 0 : (_data$_bd_r3$_bd_c = _data$_bd_r3[_bd_c3]) === null || _data$_bd_r3$_bd_c === void 0 ? void 0 : _data$_bd_r3$_bd_c.mc)) {
                var _cfg$merge5, _cell$mc, _cell$mc2;

                var cell = data[_bd_r3][_bd_c3];
                var mc = (_cfg$merge5 = cfg.merge) === null || _cfg$merge5 === void 0 ? void 0 : _cfg$merge5["".concat(cell === null || cell === void 0 ? void 0 : (_cell$mc = cell.mc) === null || _cell$mc === void 0 ? void 0 : _cell$mc.r, "_").concat(cell === null || cell === void 0 ? void 0 : (_cell$mc2 = cell.mc) === null || _cell$mc2 === void 0 ? void 0 : _cell$mc2.c)];

                if ((mc === null || mc === void 0 ? void 0 : mc.r) === _bd_r3) {
                  if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] === undefined) {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }

                if (mc && mc.r + mc.rs - 1 === _bd_r3) {
                  if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] === undefined) {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].b = {
                    color: borderColor,
                    style: borderStyle
                  };
                }

                if ((mc === null || mc === void 0 ? void 0 : mc.c) === _bd_c3) {
                  if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] === undefined) {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                }

                if (mc && mc.c + mc.cs - 1 === _bd_c3) {
                  if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] === undefined) {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].r = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] === undefined) {
                  borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)] = {};
                }

                borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].l = {
                  color: borderColor,
                  style: borderStyle
                };
                borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].r = {
                  color: borderColor,
                  style: borderStyle
                };
                borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].t = {
                  color: borderColor,
                  style: borderStyle
                };
                borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].b = {
                  color: borderColor,
                  style: borderStyle
                };
              }

              if (_bd_r3 === bd_r1) {
                var bd_r_top = bd_r1 - 1;

                if (bd_r_top >= 0 && borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c3)]) {
                  var _data$bd_r_top2, _data$bd_r_top2$_bd_c;

                  if (!_.isNil((_data$bd_r_top2 = data[bd_r_top]) === null || _data$bd_r_top2 === void 0 ? void 0 : (_data$bd_r_top2$_bd_c = _data$bd_r_top2[_bd_c3]) === null || _data$bd_r_top2$_bd_c === void 0 ? void 0 : _data$bd_r_top2$_bd_c.mc)) {
                    var _cfg$merge6, _cell_top$mc3, _cell_top$mc4;

                    var cell_top = data[bd_r_top][_bd_c3];

                    var _mc5 = (_cfg$merge6 = cfg.merge) === null || _cfg$merge6 === void 0 ? void 0 : _cfg$merge6["".concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc3 = cell_top.mc) === null || _cell_top$mc3 === void 0 ? void 0 : _cell_top$mc3.r, "_").concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc4 = cell_top.mc) === null || _cell_top$mc4 === void 0 ? void 0 : _cell_top$mc4.c)];

                    if (_mc5 && _mc5.r + _mc5.rs - 1 === bd_r_top) {
                      borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c3)].b = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(bd_r_top, "_").concat(_bd_c3)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_r3 === bd_r2) {
                var bd_r_bottom = bd_r2 + 1;

                if (bd_r_bottom < data.length && borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c3)]) {
                  var _data$bd_r_bottom2, _data$bd_r_bottom2$_b;

                  if (!_.isNil((_data$bd_r_bottom2 = data[bd_r_bottom]) === null || _data$bd_r_bottom2 === void 0 ? void 0 : (_data$bd_r_bottom2$_b = _data$bd_r_bottom2[_bd_c3]) === null || _data$bd_r_bottom2$_b === void 0 ? void 0 : _data$bd_r_bottom2$_b.mc)) {
                    var _cfg$merge7, _cell_bottom$mc3, _cell_bottom$mc4;

                    var cell_bottom = data[bd_r_bottom][_bd_c3];

                    var _mc6 = (_cfg$merge7 = cfg.merge) === null || _cfg$merge7 === void 0 ? void 0 : _cfg$merge7["".concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc3 = cell_bottom.mc) === null || _cell_bottom$mc3 === void 0 ? void 0 : _cell_bottom$mc3.r, "_").concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc4 = cell_bottom.mc) === null || _cell_bottom$mc4 === void 0 ? void 0 : _cell_bottom$mc4.c)];

                    if ((_mc6 === null || _mc6 === void 0 ? void 0 : _mc6.r) === bd_r_bottom) {
                      borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c3)].t = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(bd_r_bottom, "_").concat(_bd_c3)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_c3 === bd_c1) {
                var bd_c_left = bd_c1 - 1;

                if (bd_c_left >= 0 && borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_left)]) {
                  var _data$_bd_r4, _data$_bd_r4$bd_c_lef;

                  if (!_.isNil((_data$_bd_r4 = data[_bd_r3]) === null || _data$_bd_r4 === void 0 ? void 0 : (_data$_bd_r4$bd_c_lef = _data$_bd_r4[bd_c_left]) === null || _data$_bd_r4$bd_c_lef === void 0 ? void 0 : _data$_bd_r4$bd_c_lef.mc)) {
                    var _cfg$merge8, _cell_left$mc3, _cell_left$mc4;

                    var cell_left = data[_bd_r3][bd_c_left];

                    var _mc7 = (_cfg$merge8 = cfg.merge) === null || _cfg$merge8 === void 0 ? void 0 : _cfg$merge8["".concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc3 = cell_left.mc) === null || _cell_left$mc3 === void 0 ? void 0 : _cell_left$mc3.r, "_").concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc4 = cell_left.mc) === null || _cell_left$mc4 === void 0 ? void 0 : _cell_left$mc4.c)];

                    if (_mc7 && _mc7.c + _mc7.cs - 1 === bd_c_left) {
                      borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_left)].r = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_left)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_c3 === bd_c2) {
                var bd_c_right = bd_c2 + 1;

                if (bd_c_right < data[0].length && borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_right)]) {
                  var _data$_bd_r5, _data$_bd_r5$bd_c_rig;

                  if (!_.isNil((_data$_bd_r5 = data[_bd_r3]) === null || _data$_bd_r5 === void 0 ? void 0 : (_data$_bd_r5$bd_c_rig = _data$_bd_r5[bd_c_right]) === null || _data$_bd_r5$bd_c_rig === void 0 ? void 0 : _data$_bd_r5$bd_c_rig.mc)) {
                    var _cfg$merge9, _cell_right$mc3, _cell_right$mc4;

                    var cell_right = data[_bd_r3][bd_c_right];

                    var _mc8 = (_cfg$merge9 = cfg.merge) === null || _cfg$merge9 === void 0 ? void 0 : _cfg$merge9["".concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc3 = cell_right.mc) === null || _cell_right$mc3 === void 0 ? void 0 : _cell_right$mc3.r, "_").concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc4 = cell_right.mc) === null || _cell_right$mc4 === void 0 ? void 0 : _cell_right$mc4.c)];

                    if ((_mc8 === null || _mc8 === void 0 ? void 0 : _mc8.c) === bd_c_right) {
                      borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_right)].l = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r3, "_").concat(bd_c_right)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }
            }
          }
        } else if (borderType === "border-outside") {
          for (var _bd_r4 = bd_r1; _bd_r4 <= bd_r2; _bd_r4 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r4])) {
              continue;
            }

            for (var _bd_c4 = bd_c1; _bd_c4 <= bd_c2; _bd_c4 += 1) {
              if (!(_bd_r4 === bd_r1 || _bd_r4 === bd_r2 || _bd_c4 === bd_c1 || _bd_c4 === bd_c2)) {
                continue;
              }

              if (_bd_r4 === bd_r1) {
                if (borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] === undefined) {
                  borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] = {};
                }

                borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)].t = {
                  color: borderColor,
                  style: borderStyle
                };

                var _bd_r_top = bd_r1 - 1;

                if (_bd_r_top >= 0 && borderInfoCompute["".concat(_bd_r_top, "_").concat(_bd_c4)]) {
                  var _data$_bd_r_top, _data$_bd_r_top$_bd_c;

                  if (!_.isNil((_data$_bd_r_top = data[_bd_r_top]) === null || _data$_bd_r_top === void 0 ? void 0 : (_data$_bd_r_top$_bd_c = _data$_bd_r_top[_bd_c4]) === null || _data$_bd_r_top$_bd_c === void 0 ? void 0 : _data$_bd_r_top$_bd_c.mc)) {
                    var _cfg$merge10, _cell_top$mc5, _cell_top$mc6;

                    var _cell_top = data[_bd_r_top][_bd_c4];

                    var _mc9 = (_cfg$merge10 = cfg.merge) === null || _cfg$merge10 === void 0 ? void 0 : _cfg$merge10["".concat(_cell_top === null || _cell_top === void 0 ? void 0 : (_cell_top$mc5 = _cell_top.mc) === null || _cell_top$mc5 === void 0 ? void 0 : _cell_top$mc5.r, "_").concat(_cell_top === null || _cell_top === void 0 ? void 0 : (_cell_top$mc6 = _cell_top.mc) === null || _cell_top$mc6 === void 0 ? void 0 : _cell_top$mc6.c)];

                    if (_mc9 && _mc9.r + _mc9.rs - 1 === _bd_r_top) {
                      borderInfoCompute["".concat(_bd_r_top, "_").concat(_bd_c4)].b = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r_top, "_").concat(_bd_c4)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_r4 === bd_r2) {
                if (borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] === undefined) {
                  borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] = {};
                }

                borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)].b = {
                  color: borderColor,
                  style: borderStyle
                };

                var _bd_r_bottom = bd_r2 + 1;

                if (_bd_r_bottom < data.length && borderInfoCompute["".concat(_bd_r_bottom, "_").concat(_bd_c4)]) {
                  var _data$_bd_r_bottom, _data$_bd_r_bottom$_b;

                  if (!_.isNil((_data$_bd_r_bottom = data[_bd_r_bottom]) === null || _data$_bd_r_bottom === void 0 ? void 0 : (_data$_bd_r_bottom$_b = _data$_bd_r_bottom[_bd_c4]) === null || _data$_bd_r_bottom$_b === void 0 ? void 0 : _data$_bd_r_bottom$_b.mc)) {
                    var _cfg$merge11, _cell_bottom$mc5, _cell_bottom$mc6;

                    var _cell_bottom = data[_bd_r_bottom][_bd_c4];

                    var _mc10 = (_cfg$merge11 = cfg.merge) === null || _cfg$merge11 === void 0 ? void 0 : _cfg$merge11["".concat(_cell_bottom === null || _cell_bottom === void 0 ? void 0 : (_cell_bottom$mc5 = _cell_bottom.mc) === null || _cell_bottom$mc5 === void 0 ? void 0 : _cell_bottom$mc5.r, "_").concat(_cell_bottom === null || _cell_bottom === void 0 ? void 0 : (_cell_bottom$mc6 = _cell_bottom.mc) === null || _cell_bottom$mc6 === void 0 ? void 0 : _cell_bottom$mc6.c)];

                    if ((_mc10 === null || _mc10 === void 0 ? void 0 : _mc10.r) === _bd_r_bottom) {
                      borderInfoCompute["".concat(_bd_r_bottom, "_").concat(_bd_c4)].t = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r_bottom, "_").concat(_bd_c4)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_c4 === bd_c1) {
                if (borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] === undefined) {
                  borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] = {};
                }

                borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)].l = {
                  color: borderColor,
                  style: borderStyle
                };

                var _bd_c_left = bd_c1 - 1;

                if (_bd_c_left >= 0 && borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_left)]) {
                  var _data$_bd_r6, _data$_bd_r6$_bd_c_le;

                  if (!_.isNil((_data$_bd_r6 = data[_bd_r4]) === null || _data$_bd_r6 === void 0 ? void 0 : (_data$_bd_r6$_bd_c_le = _data$_bd_r6[_bd_c_left]) === null || _data$_bd_r6$_bd_c_le === void 0 ? void 0 : _data$_bd_r6$_bd_c_le.mc)) {
                    var _cfg$merge12, _cell_left$mc5, _cell_left$mc6;

                    var _cell_left = data[_bd_r4][_bd_c_left];

                    var _mc11 = (_cfg$merge12 = cfg.merge) === null || _cfg$merge12 === void 0 ? void 0 : _cfg$merge12["".concat(_cell_left === null || _cell_left === void 0 ? void 0 : (_cell_left$mc5 = _cell_left.mc) === null || _cell_left$mc5 === void 0 ? void 0 : _cell_left$mc5.r, "_").concat(_cell_left === null || _cell_left === void 0 ? void 0 : (_cell_left$mc6 = _cell_left.mc) === null || _cell_left$mc6 === void 0 ? void 0 : _cell_left$mc6.c)];

                    if (_mc11 && _mc11.c + _mc11.cs - 1 === _bd_c_left) {
                      borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_left)].r = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_left)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }

              if (_bd_c4 === bd_c2) {
                if (borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] === undefined) {
                  borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)] = {};
                }

                borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c4)].r = {
                  color: borderColor,
                  style: borderStyle
                };

                var _bd_c_right = bd_c2 + 1;

                if (_bd_c_right < data[0].length && borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_right)]) {
                  var _data$_bd_r7, _data$_bd_r7$_bd_c_ri;

                  if (!_.isNil((_data$_bd_r7 = data[_bd_r4]) === null || _data$_bd_r7 === void 0 ? void 0 : (_data$_bd_r7$_bd_c_ri = _data$_bd_r7[_bd_c_right]) === null || _data$_bd_r7$_bd_c_ri === void 0 ? void 0 : _data$_bd_r7$_bd_c_ri.mc)) {
                    var _cfg$merge13, _cell_right$mc5, _cell_right$mc6;

                    var _cell_right = data[_bd_r4][_bd_c_right];

                    var _mc12 = (_cfg$merge13 = cfg.merge) === null || _cfg$merge13 === void 0 ? void 0 : _cfg$merge13["".concat(_cell_right === null || _cell_right === void 0 ? void 0 : (_cell_right$mc5 = _cell_right.mc) === null || _cell_right$mc5 === void 0 ? void 0 : _cell_right$mc5.r, "_").concat(_cell_right === null || _cell_right === void 0 ? void 0 : (_cell_right$mc6 = _cell_right.mc) === null || _cell_right$mc6 === void 0 ? void 0 : _cell_right$mc6.c)];

                    if ((_mc12 === null || _mc12 === void 0 ? void 0 : _mc12.c) === _bd_c_right) {
                      borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_right)].l = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  } else {
                    borderInfoCompute["".concat(_bd_r4, "_").concat(_bd_c_right)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }
            }
          }
        } else if (borderType === "border-inside") {
          for (var _bd_r5 = bd_r1; _bd_r5 <= bd_r2; _bd_r5 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r5])) {
              continue;
            }

            for (var _bd_c5 = bd_c1; _bd_c5 <= bd_c2; _bd_c5 += 1) {
              if (_bd_r5 === bd_r1 && _bd_c5 === bd_c1) {
                var _data$_bd_r8, _data$_bd_r8$_bd_c;

                if (!_.isNil((_data$_bd_r8 = data[_bd_r5]) === null || _data$_bd_r8 === void 0 ? void 0 : (_data$_bd_r8$_bd_c = _data$_bd_r8[_bd_c5]) === null || _data$_bd_r8$_bd_c === void 0 ? void 0 : _data$_bd_r8$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              } else if (_bd_r5 === bd_r2 && _bd_c5 === bd_c1) {
                var _data$_bd_r9, _data$_bd_r9$_bd_c;

                if (!_.isNil((_data$_bd_r9 = data[_bd_r5]) === null || _data$_bd_r9 === void 0 ? void 0 : (_data$_bd_r9$_bd_c = _data$_bd_r9[_bd_c5]) === null || _data$_bd_r9$_bd_c === void 0 ? void 0 : _data$_bd_r9$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else if (_bd_r5 === bd_r1 && _bd_c5 === bd_c2) {
                var _data$_bd_r10, _data$_bd_r10$_bd_c;

                if (!_.isNil((_data$_bd_r10 = data[_bd_r5]) === null || _data$_bd_r10 === void 0 ? void 0 : (_data$_bd_r10$_bd_c = _data$_bd_r10[_bd_c5]) === null || _data$_bd_r10$_bd_c === void 0 ? void 0 : _data$_bd_r10$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              } else if (_bd_r5 === bd_r2 && _bd_c5 === bd_c2) {
                var _data$_bd_r11, _data$_bd_r11$_bd_c;

                if (!_.isNil((_data$_bd_r11 = data[_bd_r5]) === null || _data$_bd_r11 === void 0 ? void 0 : (_data$_bd_r11$_bd_c = _data$_bd_r11[_bd_c5]) === null || _data$_bd_r11$_bd_c === void 0 ? void 0 : _data$_bd_r11$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else if (_bd_r5 === bd_r1) {
                var _data$_bd_r12, _data$_bd_r12$_bd_c;

                if (!_.isNil((_data$_bd_r12 = data[_bd_r5]) === null || _data$_bd_r12 === void 0 ? void 0 : (_data$_bd_r12$_bd_c = _data$_bd_r12[_bd_c5]) === null || _data$_bd_r12$_bd_c === void 0 ? void 0 : _data$_bd_r12$_bd_c.mc)) {
                  var _cfg$merge14, _cell$mc3, _cell$mc4;

                  var _cell = data[_bd_r5][_bd_c5];

                  var _mc13 = (_cfg$merge14 = cfg.merge) === null || _cfg$merge14 === void 0 ? void 0 : _cfg$merge14["".concat(_cell === null || _cell === void 0 ? void 0 : (_cell$mc3 = _cell.mc) === null || _cell$mc3 === void 0 ? void 0 : _cell$mc3.r, "_").concat(_cell === null || _cell === void 0 ? void 0 : (_cell$mc4 = _cell.mc) === null || _cell$mc4 === void 0 ? void 0 : _cell$mc4.c)];

                  if ((_mc13 === null || _mc13 === void 0 ? void 0 : _mc13.c) === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc13 && _mc13.c + _mc13.cs - 1 === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_r5 === bd_r2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              } else if (_bd_r5 === bd_r2) {
                var _data$_bd_r13, _data$_bd_r13$_bd_c;

                if (!_.isNil((_data$_bd_r13 = data[_bd_r5]) === null || _data$_bd_r13 === void 0 ? void 0 : (_data$_bd_r13$_bd_c = _data$_bd_r13[_bd_c5]) === null || _data$_bd_r13$_bd_c === void 0 ? void 0 : _data$_bd_r13$_bd_c.mc)) {
                  var _cfg$merge15, _cell2$mc, _cell2$mc2;

                  var _cell2 = data[_bd_r5][_bd_c5];

                  var _mc14 = (_cfg$merge15 = cfg.merge) === null || _cfg$merge15 === void 0 ? void 0 : _cfg$merge15["".concat(_cell2 === null || _cell2 === void 0 ? void 0 : (_cell2$mc = _cell2.mc) === null || _cell2$mc === void 0 ? void 0 : _cell2$mc.r, "_").concat(_cell2 === null || _cell2 === void 0 ? void 0 : (_cell2$mc2 = _cell2.mc) === null || _cell2$mc2 === void 0 ? void 0 : _cell2$mc2.c)];

                  if ((_mc14 === null || _mc14 === void 0 ? void 0 : _mc14.c) === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc14 && _mc14.c + _mc14.cs - 1 === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_r5 === bd_r2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else if (_bd_c5 === bd_c1) {
                var _data$_bd_r14, _data$_bd_r14$_bd_c;

                if (!_.isNil((_data$_bd_r14 = data[_bd_r5]) === null || _data$_bd_r14 === void 0 ? void 0 : (_data$_bd_r14$_bd_c = _data$_bd_r14[_bd_c5]) === null || _data$_bd_r14$_bd_c === void 0 ? void 0 : _data$_bd_r14$_bd_c.mc)) {
                  var _cfg$merge16, _cell3$mc, _cell3$mc2;

                  var _cell3 = data[_bd_r5][_bd_c5];

                  var _mc15 = (_cfg$merge16 = cfg.merge) === null || _cfg$merge16 === void 0 ? void 0 : _cfg$merge16["".concat(_cell3 === null || _cell3 === void 0 ? void 0 : (_cell3$mc = _cell3.mc) === null || _cell3$mc === void 0 ? void 0 : _cell3$mc.r, "_").concat(_cell3 === null || _cell3 === void 0 ? void 0 : (_cell3$mc2 = _cell3.mc) === null || _cell3$mc2 === void 0 ? void 0 : _cell3$mc2.c)];

                  if ((_mc15 === null || _mc15 === void 0 ? void 0 : _mc15.r) === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc15 && _mc15.r + _mc15.rs - 1 === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_c5 === bd_c2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              } else if (_bd_c5 === bd_c2) {
                var _data$_bd_r15, _data$_bd_r15$_bd_c;

                if (!_.isNil((_data$_bd_r15 = data[_bd_r5]) === null || _data$_bd_r15 === void 0 ? void 0 : (_data$_bd_r15$_bd_c = _data$_bd_r15[_bd_c5]) === null || _data$_bd_r15$_bd_c === void 0 ? void 0 : _data$_bd_r15$_bd_c.mc)) {
                  var _cfg$merge17, _cell4$mc, _cell4$mc2;

                  var _cell4 = data[_bd_r5][_bd_c5];

                  var _mc16 = (_cfg$merge17 = cfg.merge) === null || _cfg$merge17 === void 0 ? void 0 : _cfg$merge17["".concat(_cell4 === null || _cell4 === void 0 ? void 0 : (_cell4$mc = _cell4.mc) === null || _cell4$mc === void 0 ? void 0 : _cell4$mc.r, "_").concat(_cell4 === null || _cell4 === void 0 ? void 0 : (_cell4$mc2 = _cell4.mc) === null || _cell4$mc2 === void 0 ? void 0 : _cell4$mc2.c)];

                  if ((_mc16 === null || _mc16 === void 0 ? void 0 : _mc16.r) === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc16 && _mc16.r + _mc16.rs - 1 === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_c5 === bd_c2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              } else {
                var _data$_bd_r16, _data$_bd_r16$_bd_c;

                if (!_.isNil((_data$_bd_r16 = data[_bd_r5]) === null || _data$_bd_r16 === void 0 ? void 0 : (_data$_bd_r16$_bd_c = _data$_bd_r16[_bd_c5]) === null || _data$_bd_r16$_bd_c === void 0 ? void 0 : _data$_bd_r16$_bd_c.mc)) {
                  var _cfg$merge18, _cell5$mc, _cell5$mc2;

                  var _cell5 = data[_bd_r5][_bd_c5];

                  var _mc17 = (_cfg$merge18 = cfg.merge) === null || _cfg$merge18 === void 0 ? void 0 : _cfg$merge18["".concat(_cell5 === null || _cell5 === void 0 ? void 0 : (_cell5$mc = _cell5.mc) === null || _cell5$mc === void 0 ? void 0 : _cell5$mc.r, "_").concat(_cell5 === null || _cell5 === void 0 ? void 0 : (_cell5$mc2 = _cell5.mc) === null || _cell5$mc2 === void 0 ? void 0 : _cell5$mc2.c)];

                  if ((_mc17 === null || _mc17 === void 0 ? void 0 : _mc17.r) === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc17 && _mc17.r + _mc17.rs - 1 === _bd_r5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_c5 === bd_c2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }

                  if ((_mc17 === null || _mc17 === void 0 ? void 0 : _mc17.c) === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc17 && _mc17.c + _mc17.cs - 1 === _bd_c5) {
                    if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                    }

                    if (!_bd_r5 === bd_r2) {
                      borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                        color: borderColor,
                        style: borderStyle
                      };
                    }
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] === undefined) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].l = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_r5 === bd_r2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }

                  borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].t = {
                    color: borderColor,
                    style: borderStyle
                  };

                  if (!_bd_c5 === bd_c2) {
                    borderInfoCompute["".concat(_bd_r5, "_").concat(_bd_c5)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                }
              }
            }
          }
        } else if (borderType === "border-horizontal") {
          for (var _bd_r6 = bd_r1; _bd_r6 <= bd_r2; _bd_r6 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r6])) {
              continue;
            }

            for (var _bd_c6 = bd_c1; _bd_c6 <= bd_c2; _bd_c6 += 1) {
              if (_bd_r6 === bd_r1) {
                var _data$_bd_r17, _data$_bd_r17$_bd_c;

                if (!_.isNil((_data$_bd_r17 = data[_bd_r6]) === null || _data$_bd_r17 === void 0 ? void 0 : (_data$_bd_r17$_bd_c = _data$_bd_r17[_bd_c6]) === null || _data$_bd_r17$_bd_c === void 0 ? void 0 : _data$_bd_r17$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] === undefined) {
                    borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].b = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else if (_bd_r6 === bd_r2) {
                var _data$_bd_r18, _data$_bd_r18$_bd_c;

                if (!_.isNil((_data$_bd_r18 = data[_bd_r6]) === null || _data$_bd_r18 === void 0 ? void 0 : (_data$_bd_r18$_bd_c = _data$_bd_r18[_bd_c6]) === null || _data$_bd_r18$_bd_c === void 0 ? void 0 : _data$_bd_r18$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] === undefined) {
                    borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                var _data$_bd_r19, _data$_bd_r19$_bd_c;

                if (!_.isNil((_data$_bd_r19 = data[_bd_r6]) === null || _data$_bd_r19 === void 0 ? void 0 : (_data$_bd_r19$_bd_c = _data$_bd_r19[_bd_c6]) === null || _data$_bd_r19$_bd_c === void 0 ? void 0 : _data$_bd_r19$_bd_c.mc)) {
                  var _cfg$merge19, _cell6$mc, _cell6$mc2;

                  var _cell6 = data[_bd_r6][_bd_c6];

                  var _mc18 = (_cfg$merge19 = cfg.merge) === null || _cfg$merge19 === void 0 ? void 0 : _cfg$merge19["".concat(_cell6 === null || _cell6 === void 0 ? void 0 : (_cell6$mc = _cell6.mc) === null || _cell6$mc === void 0 ? void 0 : _cell6$mc.r, "_").concat(_cell6 === null || _cell6 === void 0 ? void 0 : (_cell6$mc2 = _cell6.mc) === null || _cell6$mc2 === void 0 ? void 0 : _cell6$mc2.c)];

                  if ((_mc18 === null || _mc18 === void 0 ? void 0 : _mc18.r) === _bd_r6) {
                    if (borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] === undefined) {
                      borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].t = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc18 && _mc18.r + _mc18.rs - 1 === _bd_r6) {
                    if (borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] === undefined) {
                      borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].b = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] === undefined) {
                    borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].t = {
                    color: borderColor,
                    style: borderStyle
                  };
                  borderInfoCompute["".concat(_bd_r6, "_").concat(_bd_c6)].b = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              }
            }
          }
        } else if (borderType === "border-vertical") {
          for (var _bd_r7 = bd_r1; _bd_r7 <= bd_r2; _bd_r7 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r7])) {
              continue;
            }

            for (var _bd_c7 = bd_c1; _bd_c7 <= bd_c2; _bd_c7 += 1) {
              if (_bd_c7 === bd_c1) {
                var _data$_bd_r20, _data$_bd_r20$_bd_c;

                if (!_.isNil((_data$_bd_r20 = data[_bd_r7]) === null || _data$_bd_r20 === void 0 ? void 0 : (_data$_bd_r20$_bd_c = _data$_bd_r20[_bd_c7]) === null || _data$_bd_r20$_bd_c === void 0 ? void 0 : _data$_bd_r20$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] === undefined) {
                    borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].r = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else if (_bd_c7 === bd_c2) {
                var _data$_bd_r21, _data$_bd_r21$_bd_c;

                if (!_.isNil((_data$_bd_r21 = data[_bd_r7]) === null || _data$_bd_r21 === void 0 ? void 0 : (_data$_bd_r21$_bd_c = _data$_bd_r21[_bd_c7]) === null || _data$_bd_r21$_bd_c === void 0 ? void 0 : _data$_bd_r21$_bd_c.mc)) ; else {
                  if (borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] === undefined) {
                    borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              } else {
                var _data$_bd_r22, _data$_bd_r22$_bd_c;

                if (!_.isNil((_data$_bd_r22 = data[_bd_r7]) === null || _data$_bd_r22 === void 0 ? void 0 : (_data$_bd_r22$_bd_c = _data$_bd_r22[_bd_c7]) === null || _data$_bd_r22$_bd_c === void 0 ? void 0 : _data$_bd_r22$_bd_c.mc)) {
                  var _cfg$merge20, _cell7$mc, _cell7$mc2;

                  var _cell7 = data[_bd_r7][_bd_c7];

                  var _mc19 = (_cfg$merge20 = cfg.merge) === null || _cfg$merge20 === void 0 ? void 0 : _cfg$merge20["".concat(_cell7 === null || _cell7 === void 0 ? void 0 : (_cell7$mc = _cell7.mc) === null || _cell7$mc === void 0 ? void 0 : _cell7$mc.r, "_").concat(_cell7 === null || _cell7 === void 0 ? void 0 : (_cell7$mc2 = _cell7.mc) === null || _cell7$mc2 === void 0 ? void 0 : _cell7$mc2.c)];

                  if ((_mc19 === null || _mc19 === void 0 ? void 0 : _mc19.c) === _bd_c7) {
                    if (borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] === undefined) {
                      borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].l = {
                      color: borderColor,
                      style: borderStyle
                    };
                  } else if (_mc19 && _mc19.c + _mc19.cs - 1 === _bd_c7) {
                    if (borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] === undefined) {
                      borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] = {};
                    }

                    borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].r = {
                      color: borderColor,
                      style: borderStyle
                    };
                  }
                } else {
                  if (borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] === undefined) {
                    borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)] = {};
                  }

                  borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].l = {
                    color: borderColor,
                    style: borderStyle
                  };
                  borderInfoCompute["".concat(_bd_r7, "_").concat(_bd_c7)].r = {
                    color: borderColor,
                    style: borderStyle
                  };
                }
              }
            }
          }
        } else if (borderType === "border-none") {
          for (var _bd_r8 = bd_r1; _bd_r8 <= bd_r2; _bd_r8 += 1) {
            if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[_bd_r8])) {
              continue;
            }

            for (var _bd_c8 = bd_c1; _bd_c8 <= bd_c2; _bd_c8 += 1) {
              if (!_.isNil(borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c8)])) {
                delete borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c8)];
              }

              if (_bd_r8 === bd_r1) {
                var _bd_r_top2 = bd_r1 - 1;

                if (_bd_r_top2 >= 0 && borderInfoCompute["".concat(_bd_r_top2, "_").concat(_bd_c8)]) {
                  delete borderInfoCompute["".concat(_bd_r_top2, "_").concat(_bd_c8)].b;
                }
              }

              if (_bd_r8 === bd_r2) {
                var _bd_r_bottom2 = bd_r2 + 1;

                if (_bd_r_bottom2 < data.length && borderInfoCompute["".concat(_bd_r_bottom2, "_").concat(_bd_c8)]) {
                  delete borderInfoCompute["".concat(_bd_r_bottom2, "_").concat(_bd_c8)].t;
                }
              }

              if (_bd_c8 === bd_c1) {
                var _bd_c_left2 = bd_c1 - 1;

                if (_bd_c_left2 >= 0 && borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c_left2)]) {
                  delete borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c_left2)].r;
                }
              }

              if (_bd_c8 === bd_c2) {
                var _bd_c_right2 = bd_c2 + 1;

                if (_bd_c_right2 < data[0].length && borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c_right2)]) {
                  delete borderInfoCompute["".concat(_bd_r8, "_").concat(_bd_c_right2)].l;
                }
              }
            }
          }
        }
      };

      for (var j = 0; j < borderRange.length; j += 1) {
        var _ret = _loop(j);

        if (_ret === "continue") continue;
      }
    } else if (rangeType === "cell") {
      var value = borderInfo[i].value;
      var bd_r = value.row_index;
      var bd_c = value.col_index;

      if (bd_r < dataset_row_st || bd_r > dataset_row_ed || bd_c < dataset_col_st || bd_c > dataset_col_ed) {
        continue;
      }

      if (!_.isNil(cfg.rowhidden) && !_.isNil(cfg.rowhidden[bd_r])) {
        continue;
      }

      if (!_.isNil(value.l) || !_.isNil(value.r) || !_.isNil(value.t) || !_.isNil(value.b)) {
        var _data$bd_r, _data$bd_r$bd_c;

        if (borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] === undefined) {
          borderInfoCompute["".concat(bd_r, "_").concat(bd_c)] = {};
        }

        if (!_.isNil((_data$bd_r = data[bd_r]) === null || _data$bd_r === void 0 ? void 0 : (_data$bd_r$bd_c = _data$bd_r[bd_c]) === null || _data$bd_r$bd_c === void 0 ? void 0 : _data$bd_r$bd_c.mc)) {
          var _cfg$merge21, _cell$mc5, _cell$mc6;

          var cell = data[bd_r][bd_c];
          var mc = (_cfg$merge21 = cfg.merge) === null || _cfg$merge21 === void 0 ? void 0 : _cfg$merge21["".concat(cell === null || cell === void 0 ? void 0 : (_cell$mc5 = cell.mc) === null || _cell$mc5 === void 0 ? void 0 : _cell$mc5.r, "_").concat(cell === null || cell === void 0 ? void 0 : (_cell$mc6 = cell.mc) === null || _cell$mc6 === void 0 ? void 0 : _cell$mc6.c)];

          if (!_.isNil(value.l) && bd_c === (mc === null || mc === void 0 ? void 0 : mc.c)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l = {
              color: value.l.color,
              style: value.l.style
            };
            var bd_c_left = bd_c - 1;

            if (bd_c_left >= 0 && borderInfoCompute["".concat(bd_r, "_").concat(bd_c_left)]) {
              var _data$bd_r2, _data$bd_r2$bd_c_left;

              if (!_.isNil((_data$bd_r2 = data[bd_r]) === null || _data$bd_r2 === void 0 ? void 0 : (_data$bd_r2$bd_c_left = _data$bd_r2[bd_c_left]) === null || _data$bd_r2$bd_c_left === void 0 ? void 0 : _data$bd_r2$bd_c_left.mc)) {
                var _cfg$merge22, _cell_left$mc7, _cell_left$mc8;

                var cell_left = data[bd_r][bd_c_left];
                var mc_l = (_cfg$merge22 = cfg.merge) === null || _cfg$merge22 === void 0 ? void 0 : _cfg$merge22["".concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc7 = cell_left.mc) === null || _cell_left$mc7 === void 0 ? void 0 : _cell_left$mc7.r, "_").concat(cell_left === null || cell_left === void 0 ? void 0 : (_cell_left$mc8 = cell_left.mc) === null || _cell_left$mc8 === void 0 ? void 0 : _cell_left$mc8.c)];

                if (mc_l && mc_l.c + mc_l.cs - 1 === bd_c_left) {
                  borderInfoCompute["".concat(bd_r, "_").concat(bd_c_left)].r = {
                    color: value.l.color,
                    style: value.l.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r, "_").concat(bd_c_left)].r = {
                  color: value.l.color,
                  style: value.l.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l = null;
          }

          if (!_.isNil(value.r) && mc && bd_c === mc.c + mc.cs - 1) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r = {
              color: value.r.color,
              style: value.r.style
            };
            var bd_c_right = bd_c + 1;

            if (bd_c_right < data[0].length && borderInfoCompute["".concat(bd_r, "_").concat(bd_c_right)]) {
              var _data$bd_r3, _data$bd_r3$bd_c_righ;

              if (!_.isNil((_data$bd_r3 = data[bd_r]) === null || _data$bd_r3 === void 0 ? void 0 : (_data$bd_r3$bd_c_righ = _data$bd_r3[bd_c_right]) === null || _data$bd_r3$bd_c_righ === void 0 ? void 0 : _data$bd_r3$bd_c_righ.mc)) {
                var _cfg$merge23, _cell_right$mc7, _cell_right$mc8;

                var cell_right = data[bd_r][bd_c_right];
                var mc_r = (_cfg$merge23 = cfg.merge) === null || _cfg$merge23 === void 0 ? void 0 : _cfg$merge23["".concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc7 = cell_right.mc) === null || _cell_right$mc7 === void 0 ? void 0 : _cell_right$mc7.r, "_").concat(cell_right === null || cell_right === void 0 ? void 0 : (_cell_right$mc8 = cell_right.mc) === null || _cell_right$mc8 === void 0 ? void 0 : _cell_right$mc8.c)];

                if ((mc_r === null || mc_r === void 0 ? void 0 : mc_r.c) === bd_c_right) {
                  borderInfoCompute["".concat(bd_r, "_").concat(bd_c_right)].l = {
                    color: value.r.color,
                    style: value.r.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r, "_").concat(bd_c_right)].l = {
                  color: value.r.color,
                  style: value.r.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r = null;
          }

          if (!_.isNil(value.t) && bd_r === (mc === null || mc === void 0 ? void 0 : mc.r)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t = {
              color: value.t.color,
              style: value.t.style
            };
            var bd_r_top = bd_r - 1;

            if (bd_r_top >= 0 && borderInfoCompute["".concat(bd_r_top, "_").concat(bd_c)]) {
              var _data$bd_r_top3, _data$bd_r_top3$bd_c;

              if (!_.isNil((_data$bd_r_top3 = data[bd_r_top]) === null || _data$bd_r_top3 === void 0 ? void 0 : (_data$bd_r_top3$bd_c = _data$bd_r_top3[bd_c]) === null || _data$bd_r_top3$bd_c === void 0 ? void 0 : _data$bd_r_top3$bd_c.mc)) {
                var _cfg$merge24, _cell_top$mc7, _cell_top$mc8;

                var cell_top = data[bd_r_top][bd_c];
                var mc_t = (_cfg$merge24 = cfg.merge) === null || _cfg$merge24 === void 0 ? void 0 : _cfg$merge24["".concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc7 = cell_top.mc) === null || _cell_top$mc7 === void 0 ? void 0 : _cell_top$mc7.r, "_").concat(cell_top === null || cell_top === void 0 ? void 0 : (_cell_top$mc8 = cell_top.mc) === null || _cell_top$mc8 === void 0 ? void 0 : _cell_top$mc8.c)];

                if (mc_t && mc_t.r + mc_t.rs - 1 === bd_r_top) {
                  borderInfoCompute["".concat(bd_r_top, "_").concat(bd_c)].b = {
                    color: value.t.color,
                    style: value.t.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r_top, "_").concat(bd_c)].b = {
                  color: value.t.color,
                  style: value.t.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t = null;
          }

          if (!_.isNil(value.b) && mc && bd_r === mc.r + mc.rs - 1) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b = {
              color: value.b.color,
              style: value.b.style
            };
            var bd_r_bottom = bd_r + 1;

            if (bd_r_bottom < data.length && borderInfoCompute["".concat(bd_r_bottom, "_").concat(bd_c)]) {
              var _data$bd_r_bottom3, _data$bd_r_bottom3$bd;

              if (!_.isNil((_data$bd_r_bottom3 = data[bd_r_bottom]) === null || _data$bd_r_bottom3 === void 0 ? void 0 : (_data$bd_r_bottom3$bd = _data$bd_r_bottom3[bd_c]) === null || _data$bd_r_bottom3$bd === void 0 ? void 0 : _data$bd_r_bottom3$bd.mc)) {
                var _cfg$merge25, _cell_bottom$mc7, _cell_bottom$mc8;

                var cell_bottom = data[bd_r_bottom][bd_c];
                var mc_b = (_cfg$merge25 = cfg.merge) === null || _cfg$merge25 === void 0 ? void 0 : _cfg$merge25["".concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc7 = cell_bottom.mc) === null || _cell_bottom$mc7 === void 0 ? void 0 : _cell_bottom$mc7.r, "_").concat(cell_bottom === null || cell_bottom === void 0 ? void 0 : (_cell_bottom$mc8 = cell_bottom.mc) === null || _cell_bottom$mc8 === void 0 ? void 0 : _cell_bottom$mc8.c)];

                if ((mc_b === null || mc_b === void 0 ? void 0 : mc_b.r) === bd_r_bottom) {
                  borderInfoCompute["".concat(bd_r_bottom, "_").concat(bd_c)].t = {
                    color: value.b.color,
                    style: value.b.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r_bottom, "_").concat(bd_c)].t = {
                  color: value.b.color,
                  style: value.b.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b = null;
          }
        } else {
          if (!_.isNil(value.l)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l = {
              color: value.l.color,
              style: value.l.style
            };

            var _bd_c_left3 = bd_c - 1;

            if (_bd_c_left3 >= 0 && borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_left3)]) {
              var _data$bd_r4, _data$bd_r4$_bd_c_lef;

              if (!_.isNil((_data$bd_r4 = data[bd_r]) === null || _data$bd_r4 === void 0 ? void 0 : (_data$bd_r4$_bd_c_lef = _data$bd_r4[_bd_c_left3]) === null || _data$bd_r4$_bd_c_lef === void 0 ? void 0 : _data$bd_r4$_bd_c_lef.mc)) {
                var _cfg$merge26, _cell_left2$mc, _cell_left2$mc2;

                var _cell_left2 = data[bd_r][_bd_c_left3];

                var _mc_l = (_cfg$merge26 = cfg.merge) === null || _cfg$merge26 === void 0 ? void 0 : _cfg$merge26["".concat(_cell_left2 === null || _cell_left2 === void 0 ? void 0 : (_cell_left2$mc = _cell_left2.mc) === null || _cell_left2$mc === void 0 ? void 0 : _cell_left2$mc.r, "_").concat(_cell_left2 === null || _cell_left2 === void 0 ? void 0 : (_cell_left2$mc2 = _cell_left2.mc) === null || _cell_left2$mc2 === void 0 ? void 0 : _cell_left2$mc2.c)];

                if (_mc_l && _mc_l.c + _mc_l.cs - 1 === _bd_c_left3) {
                  borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_left3)].r = {
                    color: value.l.color,
                    style: value.l.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_left3)].r = {
                  color: value.l.color,
                  style: value.l.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l = null;
          }

          if (!_.isNil(value.r)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r = {
              color: value.r.color,
              style: value.r.style
            };

            var _bd_c_right3 = bd_c + 1;

            if (_bd_c_right3 < data[0].length && borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_right3)]) {
              var _data$bd_r5, _data$bd_r5$_bd_c_rig;

              if (!_.isNil(data[bd_r]) && _.isPlainObject(data[bd_r][_bd_c_right3]) && !_.isNil((_data$bd_r5 = data[bd_r]) === null || _data$bd_r5 === void 0 ? void 0 : (_data$bd_r5$_bd_c_rig = _data$bd_r5[_bd_c_right3]) === null || _data$bd_r5$_bd_c_rig === void 0 ? void 0 : _data$bd_r5$_bd_c_rig.mc)) {
                var _cfg$merge27, _cell_right2$mc, _cell_right2$mc2;

                var _cell_right2 = data[bd_r][_bd_c_right3];

                var _mc_r = (_cfg$merge27 = cfg.merge) === null || _cfg$merge27 === void 0 ? void 0 : _cfg$merge27["".concat(_cell_right2 === null || _cell_right2 === void 0 ? void 0 : (_cell_right2$mc = _cell_right2.mc) === null || _cell_right2$mc === void 0 ? void 0 : _cell_right2$mc.r, "_").concat(_cell_right2 === null || _cell_right2 === void 0 ? void 0 : (_cell_right2$mc2 = _cell_right2.mc) === null || _cell_right2$mc2 === void 0 ? void 0 : _cell_right2$mc2.c)];

                if ((_mc_r === null || _mc_r === void 0 ? void 0 : _mc_r.c) === _bd_c_right3) {
                  borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_right3)].l = {
                    color: value.r.color,
                    style: value.r.style
                  };
                }
              } else {
                borderInfoCompute["".concat(bd_r, "_").concat(_bd_c_right3)].l = {
                  color: value.r.color,
                  style: value.r.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r = null;
          }

          if (!_.isNil(value.t)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t = {
              color: value.t.color,
              style: value.t.style
            };

            var _bd_r_top3 = bd_r - 1;

            if (_bd_r_top3 >= 0 && borderInfoCompute["".concat(_bd_r_top3, "_").concat(bd_c)]) {
              var _data$_bd_r_top2, _data$_bd_r_top2$bd_c;

              if (!_.isNil((_data$_bd_r_top2 = data[_bd_r_top3]) === null || _data$_bd_r_top2 === void 0 ? void 0 : (_data$_bd_r_top2$bd_c = _data$_bd_r_top2[bd_c]) === null || _data$_bd_r_top2$bd_c === void 0 ? void 0 : _data$_bd_r_top2$bd_c.mc)) {
                var _cfg$merge28, _cell_top2$mc, _cell_top2$mc2;

                var _cell_top2 = data[_bd_r_top3][bd_c];

                var _mc_t = (_cfg$merge28 = cfg.merge) === null || _cfg$merge28 === void 0 ? void 0 : _cfg$merge28["".concat(_cell_top2 === null || _cell_top2 === void 0 ? void 0 : (_cell_top2$mc = _cell_top2.mc) === null || _cell_top2$mc === void 0 ? void 0 : _cell_top2$mc.r, "_").concat(_cell_top2 === null || _cell_top2 === void 0 ? void 0 : (_cell_top2$mc2 = _cell_top2.mc) === null || _cell_top2$mc2 === void 0 ? void 0 : _cell_top2$mc2.c)];

                if (_mc_t && _mc_t.r + _mc_t.rs - 1 === _bd_r_top3) {
                  borderInfoCompute["".concat(_bd_r_top3, "_").concat(bd_c)].b = {
                    color: value.t.color,
                    style: value.t.style
                  };
                }
              } else {
                borderInfoCompute["".concat(_bd_r_top3, "_").concat(bd_c)].b = {
                  color: value.t.color,
                  style: value.t.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t = null;
          }

          if (!_.isNil(value.b)) {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b = {
              color: value.b.color,
              style: value.b.style
            };

            var _bd_r_bottom3 = bd_r + 1;

            if (_bd_r_bottom3 < data.length && borderInfoCompute["".concat(_bd_r_bottom3, "_").concat(bd_c)]) {
              var _data$_bd_r_bottom2, _data$_bd_r_bottom2$b;

              if (!_.isNil((_data$_bd_r_bottom2 = data[_bd_r_bottom3]) === null || _data$_bd_r_bottom2 === void 0 ? void 0 : (_data$_bd_r_bottom2$b = _data$_bd_r_bottom2[bd_c]) === null || _data$_bd_r_bottom2$b === void 0 ? void 0 : _data$_bd_r_bottom2$b.mc)) {
                var _cfg$merge29, _cell_bottom2$mc, _cell_bottom2$mc2;

                var _cell_bottom2 = data[_bd_r_bottom3][bd_c];

                var _mc_b = (_cfg$merge29 = cfg.merge) === null || _cfg$merge29 === void 0 ? void 0 : _cfg$merge29["".concat(_cell_bottom2 === null || _cell_bottom2 === void 0 ? void 0 : (_cell_bottom2$mc = _cell_bottom2.mc) === null || _cell_bottom2$mc === void 0 ? void 0 : _cell_bottom2$mc.r, "_").concat(_cell_bottom2 === null || _cell_bottom2 === void 0 ? void 0 : (_cell_bottom2$mc2 = _cell_bottom2.mc) === null || _cell_bottom2$mc2 === void 0 ? void 0 : _cell_bottom2$mc2.c)];

                if ((_mc_b === null || _mc_b === void 0 ? void 0 : _mc_b.r) === _bd_r_bottom3) {
                  borderInfoCompute["".concat(_bd_r_bottom3, "_").concat(bd_c)].t = {
                    color: value.b.color,
                    style: value.b.style
                  };
                }
              } else {
                borderInfoCompute["".concat(_bd_r_bottom3, "_").concat(bd_c)].t = {
                  color: value.b.color,
                  style: value.b.style
                };
              }
            }
          } else {
            borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b = null;
          }
        }
      } else {
        delete borderInfoCompute["".concat(bd_r, "_").concat(bd_c)];
      }
    }
  }

  return borderInfoCompute;
}
function getBorderInfoCompute(ctx, sheetId) {
  var borderInfoCompute = {};
  var flowdata = getFlowdata(ctx);
  var data = {};

  if (sheetId === undefined) {
    data = flowdata;
  } else {
    var index = getSheetIndex(ctx, sheetId);

    if (!_.isNil(index)) {
      data = ctx.luckysheetfile[index].data;
    } else {
      return borderInfoCompute;
    }
  }

  borderInfoCompute = getBorderInfoComputeRange(ctx, 0, data.length, 0, data[0].length, sheetId);
  return borderInfoCompute;
}

function cutVolumn(arr, cutindex) {
  if (cutindex <= 0) {
    return arr;
  }

  var ret = arr.slice(cutindex);
  return ret;
}

function frozenTofreezen(ctx, cache, sheetId) {
  var file = ctx.luckysheetfile[getSheetIndex(ctx, sheetId)];
  var frozen = file.frozen;

  if (frozen == null) {
    delete cache.freezen;
    return;
  }

  var freezen = {};
  var range = frozen.range;

  if (!range) {
    range = {
      row_focus: 0,
      column_focus: 0
    };
  }

  var type = frozen.type;

  if (type === "row") {
    type = "rangeRow";
  } else if (type === "column") {
    type = "rangeColumn";
  } else if (type === "both") {
    type = "rangeBoth";
  }

  if (type === "rangeRow" || type === "rangeBoth") {
    var scrollTop = 0;

    var row_st = _.sortedIndex(ctx.visibledatarow, scrollTop);

    var _range = range,
        row_focus = _range.row_focus;

    if (row_focus > row_st) {
      row_st = row_focus;
    }

    if (row_st === -1) {
      row_st = 0;
    }

    var top = ctx.visibledatarow[row_st] - 2 - scrollTop + ctx.columnHeaderHeight;
    var freezenhorizontaldata = [ctx.visibledatarow[row_st], row_st + 1, scrollTop, cutVolumn(ctx.visibledatarow, row_st + 1), top];
    freezen.horizontal = {
      freezenhorizontaldata: freezenhorizontaldata,
      top: top
    };
  }

  if (type === "rangeColumn" || type === "rangeBoth") {
    var scrollLeft = 0;

    var col_st = _.sortedIndex(ctx.visibledatacolumn, scrollLeft);

    var _range2 = range,
        column_focus = _range2.column_focus;

    if (column_focus > col_st) {
      col_st = column_focus;
    }

    if (col_st === -1) {
      col_st = 0;
    }

    var left = ctx.visibledatacolumn[col_st] - 2 - scrollLeft + ctx.rowHeaderWidth;
    var freezenverticaldata = [ctx.visibledatacolumn[col_st], col_st + 1, scrollLeft, cutVolumn(ctx.visibledatacolumn, col_st + 1), left];
    freezen.vertical = {
      freezenverticaldata: freezenverticaldata,
      left: left
    };
  }

  cache.freezen || (cache.freezen = {});
  cache.freezen[ctx.currentSheetId] = freezen;
}

function initFreeze(ctx, cache, sheetId) {
  frozenTofreezen(ctx, cache, sheetId);
}
function scrollToFrozenRowCol(ctx, freeze) {
  var _freeze$vertical, _freeze$horizontal;

  var select_save = ctx.luckysheet_select_save;
  if (!select_save) return;
  var row;
  var row_focus = select_save[0].row_focus;

  if (row_focus === select_save[0].row[0]) {
    var _select_save$0$row = _slicedToArray(select_save[0].row, 2);

    row = _select_save$0$row[1];
  } else if (row_focus === select_save[0].row[1]) {
    var _select_save$0$row2 = _slicedToArray(select_save[0].row, 1);

    row = _select_save$0$row2[0];
  }

  var column;
  var column_focus = select_save[0].column_focus;

  if (column_focus === select_save[0].column[0]) {
    var _select_save$0$column = _slicedToArray(select_save[0].column, 2);

    column = _select_save$0$column[1];
  } else if (column_focus === select_save[0].column[1]) {
    var _select_save$0$column2 = _slicedToArray(select_save[0].column, 1);

    column = _select_save$0$column2[0];
  }

  var freezenverticaldata = freeze === null || freeze === void 0 ? void 0 : (_freeze$vertical = freeze.vertical) === null || _freeze$vertical === void 0 ? void 0 : _freeze$vertical.freezenverticaldata;
  var freezenhorizontaldata = freeze === null || freeze === void 0 ? void 0 : (_freeze$horizontal = freeze.horizontal) === null || _freeze$horizontal === void 0 ? void 0 : _freeze$horizontal.freezenhorizontaldata;

  if (freezenverticaldata != null && column != null) {
    var freezen_colindex = freezenverticaldata[1];

    var offset = _.sortedIndex(freezenverticaldata[3], ctx.scrollLeft);

    var top = freezenverticaldata[4];
    freezen_colindex += offset;

    if (column >= ctx.visibledatacolumn.length) {
      column = ctx.visibledatacolumn.length - 1;
    }

    if (freezen_colindex >= ctx.visibledatacolumn.length) {
      freezen_colindex = ctx.visibledatacolumn.length - 1;
    }

    var column_px = ctx.visibledatacolumn[column];
    var freezen_px = ctx.visibledatacolumn[freezen_colindex];

    if (column_px <= freezen_px + top) {
      ctx.scrollLeft = 0;
    }
  }

  if (freezenhorizontaldata != null && row != null) {
    var freezen_rowindex = freezenhorizontaldata[1];

    var _offset = _.sortedIndex(freezenhorizontaldata[3], ctx.scrollTop);

    var left = freezenhorizontaldata[4];
    freezen_rowindex += _offset;

    if (row >= ctx.visibledatarow.length) {
      row = ctx.visibledatarow.length - 1;
    }

    if (freezen_rowindex >= ctx.visibledatarow.length) {
      freezen_rowindex = ctx.visibledatarow.length - 1;
    }

    var row_px = ctx.visibledatarow[row];
    var _freezen_px = ctx.visibledatarow[freezen_rowindex];

    if (row_px <= _freezen_px + left) {
      ctx.scrollTop = 0;
    }
  }
}
function getFrozenHandleTop(ctx) {
  var _sheet$frozen, _sheet$frozen2, _sheet$frozen3, _sheet$frozen4;

  var idx = getSheetIndex(ctx, ctx.currentSheetId);
  if (idx == null) return ctx.scrollTop;
  var sheet = ctx.luckysheetfile[idx];

  if ((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen = sheet.frozen) === null || _sheet$frozen === void 0 ? void 0 : _sheet$frozen.type) === "row" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen2 = sheet.frozen) === null || _sheet$frozen2 === void 0 ? void 0 : _sheet$frozen2.type) === "rangeRow" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen3 = sheet.frozen) === null || _sheet$frozen3 === void 0 ? void 0 : _sheet$frozen3.type) === "rangeBoth" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen4 = sheet.frozen) === null || _sheet$frozen4 === void 0 ? void 0 : _sheet$frozen4.type) === "both") {
    var _sheet$frozen5, _sheet$frozen5$range;

    return rowLocationByIndex((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen5 = sheet.frozen) === null || _sheet$frozen5 === void 0 ? void 0 : (_sheet$frozen5$range = _sheet$frozen5.range) === null || _sheet$frozen5$range === void 0 ? void 0 : _sheet$frozen5$range.row_focus) || 0, ctx.visibledatarow)[1] + ctx.scrollTop;
  }

  return ctx.scrollTop;
}
function getFrozenHandleLeft(ctx) {
  var _sheet$frozen6, _sheet$frozen7, _sheet$frozen8, _sheet$frozen9;

  var idx = getSheetIndex(ctx, ctx.currentSheetId);
  if (idx == null) return ctx.scrollLeft;
  var sheet = ctx.luckysheetfile[idx];

  if ((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen6 = sheet.frozen) === null || _sheet$frozen6 === void 0 ? void 0 : _sheet$frozen6.type) === "column" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen7 = sheet.frozen) === null || _sheet$frozen7 === void 0 ? void 0 : _sheet$frozen7.type) === "rangeColumn" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen8 = sheet.frozen) === null || _sheet$frozen8 === void 0 ? void 0 : _sheet$frozen8.type) === "rangeBoth" || (sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen9 = sheet.frozen) === null || _sheet$frozen9 === void 0 ? void 0 : _sheet$frozen9.type) === "both") {
    var _sheet$frozen10, _sheet$frozen10$range;

    return colLocationByIndex((sheet === null || sheet === void 0 ? void 0 : (_sheet$frozen10 = sheet.frozen) === null || _sheet$frozen10 === void 0 ? void 0 : (_sheet$frozen10$range = _sheet$frozen10.range) === null || _sheet$frozen10$range === void 0 ? void 0 : _sheet$frozen10$range.column_focus) || 0, ctx.visibledatacolumn)[1] - 2 + ctx.scrollLeft;
  }

  return ctx.scrollLeft;
}

var refreshLocalMergeData = function refreshLocalMergeData(merge_new, file) {
  Object.entries(merge_new).forEach(function (_ref) {
    var _file$data2, _file$data2$r;

    var _ref2 = _slicedToArray(_ref, 2),
        v = _ref2[1];

    var r = v.r,
        c = v.c,
        rs = v.rs,
        cs = v.cs;

    for (var i = r; i < r + rs; i += 1) {
      for (var j = c; j < c + cs; j += 1) {
        var _file$data, _file$data$i;

        if (file === null || file === void 0 ? void 0 : (_file$data = file.data) === null || _file$data === void 0 ? void 0 : (_file$data$i = _file$data[i]) === null || _file$data$i === void 0 ? void 0 : _file$data$i[j]) {
          file.data[i][j] = _objectSpread2(_objectSpread2({}, file.data[i][j]), {}, {
            mc: {
              r: r,
              c: c
            }
          });
        }
      }
    }

    if (file === null || file === void 0 ? void 0 : (_file$data2 = file.data) === null || _file$data2 === void 0 ? void 0 : (_file$data2$r = _file$data2[r]) === null || _file$data2$r === void 0 ? void 0 : _file$data2$r[c]) {
      file.data[r][c] = _objectSpread2(_objectSpread2({}, file.data[r][c]), {}, {
        mc: {
          r: r,
          c: c,
          rs: rs,
          cs: cs
        }
      });
    }
  });
};

function insertRowCol(ctx, op) {
  var changeSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var count = op.count,
      id = op.id;
  var type = op.type,
      index = op.index,
      direction = op.direction;
  id = id || ctx.currentSheetId;
  var curOrder = getSheetIndex(ctx, id);
  if (curOrder == null) return;
  var file = ctx.luckysheetfile[curOrder];
  if (!file) return;
  var d = file.data;
  if (!d) return;
  var cfg = file.config || {};

  if (changeSelection) {
    if (type === "row") {
      var _cfg$rowReadOnly;

      if ((_cfg$rowReadOnly = cfg.rowReadOnly) === null || _cfg$rowReadOnly === void 0 ? void 0 : _cfg$rowReadOnly[index]) {
        throw new Error("readOnly");
      }
    } else {
      var _cfg$colReadOnly;

      if ((_cfg$colReadOnly = cfg.colReadOnly) === null || _cfg$colReadOnly === void 0 ? void 0 : _cfg$colReadOnly[index]) {
        throw new Error("readOnly");
      }
    }
  }

  if (type === "row" && d.length + count >= 10000) {
    throw new Error("maxExceeded");
  }

  if (type === "column" && d[0] && d[0].length + count >= 1000) {
    throw new Error("maxExceeded");
  }

  count = Math.floor(count);

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  var merge_new = {};

  _.forEach(cfg.merge, function (mc) {
    var r = mc.r,
        c = mc.c,
        rs = mc.rs,
        cs = mc.cs;

    if (type === "row") {
      if (index < r) {
        merge_new["".concat(r + count, "_").concat(c)] = {
          r: r + count,
          c: c,
          rs: rs,
          cs: cs
        };
      } else if (index === r) {
        if (direction === "lefttop") {
          merge_new["".concat(r + count, "_").concat(c)] = {
            r: r + count,
            c: c,
            rs: rs,
            cs: cs
          };
        } else {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs + count,
            cs: cs
          };
        }
      } else if (index < r + rs - 1) {
        merge_new["".concat(r, "_").concat(c)] = {
          r: r,
          c: c,
          rs: rs + count,
          cs: cs
        };
      } else if (index === r + rs - 1) {
        if (direction === "lefttop") {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs + count,
            cs: cs
          };
        } else {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs
          };
        }
      } else {
        merge_new["".concat(r, "_").concat(c)] = {
          r: r,
          c: c,
          rs: rs,
          cs: cs
        };
      }
    } else if (type === "column") {
      if (index < c) {
        merge_new["".concat(r, "_").concat(c + count)] = {
          r: r,
          c: c + count,
          rs: rs,
          cs: cs
        };
      } else if (index === c) {
        if (direction === "lefttop") {
          merge_new["".concat(r, "_").concat(c + count)] = {
            r: r,
            c: c + count,
            rs: rs,
            cs: cs
          };
        } else {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs + count
          };
        }
      } else if (index < c + cs - 1) {
        merge_new["".concat(r, "_").concat(c)] = {
          r: r,
          c: c,
          rs: rs,
          cs: cs + count
        };
      } else if (index === c + cs - 1) {
        if (direction === "lefttop") {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs + count
          };
        } else {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs
          };
        }
      } else {
        merge_new["".concat(r, "_").concat(c)] = {
          r: r,
          c: c,
          rs: rs,
          cs: cs
        };
      }
    }
  });

  cfg.merge = merge_new;
  var newCalcChain = [];

  for (var SheetIndex = 0; SheetIndex < ctx.luckysheetfile.length; SheetIndex += 1) {
    if (_.isNil(ctx.luckysheetfile[SheetIndex].calcChain) || ctx.luckysheetfile.length === 0) {
      continue;
    }

    var calcChain = ctx.luckysheetfile[SheetIndex].calcChain;
    var data = ctx.luckysheetfile[SheetIndex].data;

    for (var i = 0; i < calcChain.length; i += 1) {
      var calc = _.cloneDeep(calcChain[i]);

      var calc_r = calc.r;
      var calc_c = calc.c;
      var calc_i = calc.id;
      var calc_funcStr = getcellFormula(ctx, calc_r, calc_c, calc_i);

      if (type === "row" && SheetIndex === curOrder) {
        var _d$calc_r, _d$calc_r$calc_c;

        var functionStr = "=".concat(functionStrChange(calc_funcStr, "add", "row", direction, index, count));

        if (((_d$calc_r = d[calc_r]) === null || _d$calc_r === void 0 ? void 0 : (_d$calc_r$calc_c = _d$calc_r[calc_c]) === null || _d$calc_r$calc_c === void 0 ? void 0 : _d$calc_r$calc_c.f) === calc_funcStr) {
          d[calc_r][calc_c].f = functionStr;
        }

        if (direction === "lefttop") {
          if (calc_r >= index) {
            calc.r += count;
          }
        } else if (direction === "rightbottom") {
          if (calc_r > index) {
            calc.r += count;
          }
        }

        newCalcChain.push(calc);
      } else if (type === "row") {
        var _data$calc_r, _data$calc_r$calc_c;

        var _functionStr = "=".concat(functionStrChange(calc_funcStr, "add", "row", direction, index, count));

        if (((_data$calc_r = data[calc_r]) === null || _data$calc_r === void 0 ? void 0 : (_data$calc_r$calc_c = _data$calc_r[calc_c]) === null || _data$calc_r$calc_c === void 0 ? void 0 : _data$calc_r$calc_c.f) === calc_funcStr) {
          data[calc_r][calc_c].f = _functionStr;
        }
      } else if (type === "column" && SheetIndex === curOrder) {
        var _d$calc_r2, _d$calc_r2$calc_c;

        var _functionStr2 = "=".concat(functionStrChange(calc_funcStr, "add", "col", direction, index, count));

        if (((_d$calc_r2 = d[calc_r]) === null || _d$calc_r2 === void 0 ? void 0 : (_d$calc_r2$calc_c = _d$calc_r2[calc_c]) === null || _d$calc_r2$calc_c === void 0 ? void 0 : _d$calc_r2$calc_c.f) === calc_funcStr) {
          d[calc_r][calc_c].f = _functionStr2;
        }

        if (direction === "lefttop") {
          if (calc_c >= index) {
            calc.c += count;
          }
        } else if (direction === "rightbottom") {
          if (calc_c > index) {
            calc.c += count;
          }
        }

        newCalcChain.push(calc);
      } else if (type === "column") {
        var _data$calc_r2, _data$calc_r2$calc_c;

        var _functionStr3 = "=".concat(functionStrChange(calc_funcStr, "add", "col", direction, index, count));

        if (((_data$calc_r2 = data[calc_r]) === null || _data$calc_r2 === void 0 ? void 0 : (_data$calc_r2$calc_c = _data$calc_r2[calc_c]) === null || _data$calc_r2$calc_c === void 0 ? void 0 : _data$calc_r2$calc_c.f) === calc_funcStr) {
          data[calc_r][calc_c].f = _functionStr3;
        }
      }
    }
  }

  var filter_select = file.filter_select;
  var filter = file.filter;
  var newFilterObj = null;

  if (!_.isEmpty(filter_select) && filter_select != null) {
    newFilterObj = {
      filter_select: null,
      filter: null
    };
    var f_r1 = filter_select.row[0];
    var f_r2 = filter_select.row[1];
    var f_c1 = filter_select.column[0];
    var f_c2 = filter_select.column[1];

    if (type === "row") {
      if (f_r1 < index) {
        if (f_r2 === index && direction === "lefttop") {
          f_r2 += count;
        } else if (f_r2 > index) {
          f_r2 += count;
        }
      } else if (f_r1 === index) {
        if (direction === "lefttop") {
          f_r1 += count;
          f_r2 += count;
        } else if (direction === "rightbottom" && f_r2 > index) {
          f_r2 += count;
        }
      } else {
        f_r1 += count;
        f_r2 += count;
      }

      if (filter != null) {
        newFilterObj.filter = {};

        _.forEach(filter, function (v, k) {
          var f_rowhidden = filter[k].rowhidden;
          var f_rowhidden_new = {};

          _.forEach(f_rowhidden, function (v1, nstr) {
            var n = parseFloat(nstr);

            if (n < index) {
              f_rowhidden_new[n] = 0;
            } else if (n === index) {
              if (direction === "lefttop") {
                f_rowhidden_new[n + count] = 0;
              } else if (direction === "rightbottom") {
                f_rowhidden_new[n] = 0;
              }
            } else {
              f_rowhidden_new[n + count] = 0;
            }
          });

          newFilterObj.filter[k] = _.cloneDeep(filter[k]);
          newFilterObj.filter[k].rowhidden = f_rowhidden_new;
          newFilterObj.filter[k].str = f_r1;
          newFilterObj.filter[k].edr = f_r2;
        });
      }
    } else if (type === "column") {
      if (f_c1 < index) {
        if (f_c2 === index && direction === "lefttop") {
          f_c2 += count;
        } else if (f_c2 > index) {
          f_c2 += count;
        }
      } else if (f_c1 === index) {
        if (direction === "lefttop") {
          f_c1 += count;
          f_c2 += count;
        } else if (direction === "rightbottom" && f_c2 > index) {
          f_c2 += count;
        }
      } else {
        f_c1 += count;
        f_c2 += count;
      }

      if (filter != null) {
        newFilterObj.filter = {};

        _.forEach(filter, function (v, k) {
          var f_cindex = filter[k].cindex;

          if (f_cindex === index && direction === "lefttop") {
            f_cindex += count;
          } else if (f_cindex > index) {
            f_cindex += count;
          }

          newFilterObj.filter[f_cindex - f_c1] = _.cloneDeep(filter[k]);
          newFilterObj.filter[f_cindex - f_c1].cindex = f_cindex;
          newFilterObj.filter[f_cindex - f_c1].stc = f_c1;
          newFilterObj.filter[f_cindex - f_c1].edc = f_c2;
        });
      }
    }

    newFilterObj.filter_select = {
      row: [f_r1, f_r2],
      column: [f_c1, f_c2]
    };
  }

  if (newFilterObj != null && newFilterObj.filter != null) {
    if (cfg.rowhidden == null) {
      cfg.rowhidden = {};
    }

    _.forEach(newFilterObj.filter, function (v, k) {
      var f_rowhidden = newFilterObj.filter[k].rowhidden;

      _.forEach(f_rowhidden, function (v1, n) {
        cfg.rowhidden[n] = 0;
      });
    });
  }

  var CFarr = file.luckysheet_conditionformat_save;
  var newCFarr = [];

  if (CFarr != null && CFarr.length > 0) {
    for (var _i = 0; _i < CFarr.length; _i += 1) {
      var cf_range = CFarr[_i].cellrange;
      var cf_new_range = [];

      for (var j = 0; j < cf_range.length; j += 1) {
        var CFr1 = cf_range[j].row[0];
        var CFr2 = cf_range[j].row[1];
        var CFc1 = cf_range[j].column[0];
        var CFc2 = cf_range[j].column[1];

        if (type === "row") {
          if (CFr1 < index) {
            if (CFr2 === index && direction === "lefttop") {
              CFr2 += count;
            } else if (CFr2 > index) {
              CFr2 += count;
            }
          } else if (CFr1 === index) {
            if (direction === "lefttop") {
              CFr1 += count;
              CFr2 += count;
            } else if (direction === "rightbottom" && CFr2 > index) {
              CFr2 += count;
            }
          } else {
            CFr1 += count;
            CFr2 += count;
          }
        } else if (type === "column") {
          if (CFc1 < index) {
            if (CFc2 === index && direction === "lefttop") {
              CFc2 += count;
            } else if (CFc2 > index) {
              CFc2 += count;
            }
          } else if (CFc1 === index) {
            if (direction === "lefttop") {
              CFc1 += count;
              CFc2 += count;
            } else if (direction === "rightbottom" && CFc2 > index) {
              CFc2 += count;
            }
          } else {
            CFc1 += count;
            CFc2 += count;
          }
        }

        cf_new_range.push({
          row: [CFr1, CFr2],
          column: [CFc1, CFc2]
        });
      }

      var cf = _.clone(CFarr[_i]);

      cf.cellrange = cf_new_range;
      newCFarr.push(cf);
    }
  }

  var AFarr = file.luckysheet_alternateformat_save;
  var newAFarr = [];

  if (AFarr != null && AFarr.length > 0) {
    for (var _i2 = 0; _i2 < AFarr.length; _i2 += 1) {
      var AFr1 = AFarr[_i2].cellrange.row[0];
      var AFr2 = AFarr[_i2].cellrange.row[1];
      var AFc1 = AFarr[_i2].cellrange.column[0];
      var AFc2 = AFarr[_i2].cellrange.column[1];

      var af = _.clone(AFarr[_i2]);

      if (type === "row") {
        if (AFr1 < index) {
          if (AFr2 === index && direction === "lefttop") {
            AFr2 += count;
          } else if (AFr2 > index) {
            AFr2 += count;
          }
        } else if (AFr1 === index) {
          if (direction === "lefttop") {
            AFr1 += count;
            AFr2 += count;
          } else if (direction === "rightbottom" && AFr2 > index) {
            AFr2 += count;
          }
        } else {
          AFr1 += count;
          AFr2 += count;
        }
      } else if (type === "column") {
        if (AFc1 < index) {
          if (AFc2 === index && direction === "lefttop") {
            AFc2 += count;
          } else if (AFc2 > index) {
            AFc2 += count;
          }
        } else if (AFc1 === index) {
          if (direction === "lefttop") {
            AFc1 += count;
            AFc2 += count;
          } else if (direction === "rightbottom" && AFc2 > index) {
            AFc2 += count;
          }
        } else {
          AFc1 += count;
          AFc2 += count;
        }
      }

      af.cellrange = {
        row: [AFr1, AFr2],
        column: [AFc1, AFc2]
      };
      newAFarr.push(af);
    }
  }

  var frozen = file.frozen;

  if (frozen) {
    var normalizedIndex = direction === "lefttop" ? index - 1 : index;

    if (type === "row" && (frozen.type === "rangeRow" || frozen.type === "rangeBoth")) {
      var _frozen$range$row_foc, _frozen$range;

      if (((_frozen$range$row_foc = (_frozen$range = frozen.range) === null || _frozen$range === void 0 ? void 0 : _frozen$range.row_focus) !== null && _frozen$range$row_foc !== void 0 ? _frozen$range$row_foc : -1) > normalizedIndex) {
        frozen.range.row_focus += count;
      }
    }

    if (type === "column" && (frozen.type === "rangeColumn" || frozen.type === "rangeBoth")) {
      var _frozen$range$column_, _frozen$range2;

      if (((_frozen$range$column_ = (_frozen$range2 = frozen.range) === null || _frozen$range2 === void 0 ? void 0 : _frozen$range2.column_focus) !== null && _frozen$range$column_ !== void 0 ? _frozen$range$column_ : -1) > normalizedIndex) {
        frozen.range.column_focus += count;
      }
    }
  }

  var dataVerification = file.dataVerification;
  var newDataVerification = {};

  if (dataVerification != null) {
    _.forEach(dataVerification, function (v, key) {
      var r = Number(key.split("_")[0]);
      var c = Number(key.split("_")[1]);
      var item = dataVerification[key];

      if (type === "row") {
        if (index < r) {
          newDataVerification["".concat(r + count, "_").concat(c)] = item;
        } else if (index === r) {
          if (direction === "lefttop") {
            newDataVerification["".concat(r + count, "_").concat(c)] = item;

            for (var _i3 = 0; _i3 < count; _i3 += 1) {
              newDataVerification["".concat(r + _i3, "_").concat(c)] = item;
            }
          } else {
            newDataVerification["".concat(r, "_").concat(c)] = item;

            for (var _i4 = 0; _i4 < count; _i4 += 1) {
              newDataVerification["".concat(r + _i4 + 1, "_").concat(c)] = item;
            }
          }
        } else {
          newDataVerification["".concat(r, "_").concat(c)] = item;
        }
      } else if (type === "column") {
        if (index < c) {
          newDataVerification["".concat(r, "_").concat(c + count)] = item;
        } else if (index === c) {
          if (direction === "lefttop") {
            newDataVerification["".concat(r, "_").concat(c + count)] = item;

            for (var _i5 = 0; _i5 < count; _i5 += 1) {
              newDataVerification["".concat(r, "_").concat(c + _i5)] = item;
            }
          } else {
            newDataVerification["".concat(r, "_").concat(c)] = item;

            for (var _i6 = 0; _i6 < count; _i6 += 1) {
              newDataVerification["".concat(r, "_").concat(c + _i6 + 1)] = item;
            }
          }
        } else {
          newDataVerification["".concat(r, "_").concat(c)] = item;
        }
      }
    });
  }

  var hyperlink = file.hyperlink;
  var newHyperlink = {};

  if (hyperlink != null) {
    _.forEach(hyperlink, function (v, key) {
      var r = Number(key.split("_")[0]);
      var c = Number(key.split("_")[1]);
      var item = hyperlink[key];

      if (type === "row") {
        if (index < r) {
          newHyperlink["".concat(r + count, "_").concat(c)] = item;
        } else if (index === r) {
          if (direction === "lefttop") {
            newHyperlink["".concat(r + count, "_").concat(c)] = item;
          } else {
            newHyperlink["".concat(r, "_").concat(c)] = item;
          }
        } else {
          newHyperlink["".concat(r, "_").concat(c)] = item;
        }
      } else if (type === "column") {
        if (index < c) {
          newHyperlink["".concat(r, "_").concat(c + count)] = item;
        } else if (index === c) {
          if (direction === "lefttop") {
            newHyperlink["".concat(r, "_").concat(c + count)] = item;
          } else {
            newHyperlink["".concat(r, "_").concat(c)] = item;
          }
        } else {
          newHyperlink["".concat(r, "_").concat(c)] = item;
        }
      }
    });
  }

  if (type === "row") {

    if (cfg.rowlen != null) {
      var rowlen_new = {};
      var rowReadOnly_new = {};

      _.forEach(cfg.rowlen, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < index) {
          rowlen_new[r] = cfg.rowlen[r];
        } else if (r === index) {
          if (direction === "lefttop") {
            rowlen_new[r + count] = cfg.rowlen[r];
          } else if (direction === "rightbottom") {
            rowlen_new[r] = cfg.rowlen[r];
          }
        } else {
          rowlen_new[r + count] = cfg.rowlen[r];
        }
      });

      _.forEach(cfg.rowReadOnly, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < index) {
          rowReadOnly_new[r] = cfg.rowReadOnly[r];
        } else if (r > index) {
          rowReadOnly_new[r + count] = cfg.rowReadOnly[r];
        }
      });

      cfg.rowlen = rowlen_new;
      cfg.rowReadOnly = rowReadOnly_new;
    }

    if (cfg.customHeight != null) {
      var customHeight_new = {};

      _.forEach(cfg.customHeight, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < index) {
          customHeight_new[r] = cfg.customHeight[r];
        } else if (r === index) {
          if (direction === "lefttop") {
            customHeight_new[r + count] = cfg.customHeight[r];
          } else if (direction === "rightbottom") {
            customHeight_new[r] = cfg.customHeight[r];
          }
        } else {
          customHeight_new[r + count] = cfg.customHeight[r];
        }
      });

      cfg.customHeight = customHeight_new;
    }

    if (cfg.customHeight != null) {
      var _customHeight_new = {};

      _.forEach(cfg.customHeight, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < index) {
          _customHeight_new[r] = cfg.customHeight[r];
        } else if (r === index) {
          if (direction === "lefttop") {
            _customHeight_new[r + count] = cfg.customHeight[r];
          } else if (direction === "rightbottom") {
            _customHeight_new[r] = cfg.customHeight[r];
          }
        } else {
          _customHeight_new[r + count] = cfg.customHeight[r];
        }
      });

      cfg.customHeight = _customHeight_new;
    }

    if (cfg.rowhidden != null) {
      var rowhidden_new = {};

      _.forEach(cfg.rowhidden, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < index) {
          rowhidden_new[r] = cfg.rowhidden[r];
        } else if (r === index) {
          if (direction === "lefttop") {
            rowhidden_new[r + count] = cfg.rowhidden[r];
          } else if (direction === "rightbottom") {
            rowhidden_new[r] = cfg.rowhidden[r];
          }
        } else {
          rowhidden_new[r + count] = cfg.rowhidden[r];
        }
      });

      cfg.rowhidden = rowhidden_new;
    }

    var row = [];

    var curRow = _toConsumableArray(d)[index];

    for (var c = 0; c < d[0].length; c += 1) {
      var cell = curRow[c];
      var templateCell = null;

      if ((cell === null || cell === void 0 ? void 0 : cell.mc) && (direction === "rightbottom" || index !== cell.mc.r)) {
        var _d, _d$c;

        if (cell.mc.rs) {
          cell.mc.rs += count;
        }

        templateCell = _objectSpread2({}, cell);

        if (!(d === null || d === void 0 ? void 0 : (_d = d[index + 1]) === null || _d === void 0 ? void 0 : (_d$c = _d[c]) === null || _d$c === void 0 ? void 0 : _d$c.mc)) {
          templateCell.mc = undefined;
        }

        delete templateCell.v;
        delete templateCell.m;
        delete templateCell.ps;
        delete templateCell.f;
      }

      row.push(templateCell);
    }

    var cellBorderConfig = [];

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var borderInfo = [];

      for (var _i7 = 0; _i7 < cfg.borderInfo.length; _i7 += 1) {
        var rangeType = cfg.borderInfo[_i7].rangeType;

        if (rangeType === "range") {
          var borderRange = cfg.borderInfo[_i7].range;
          var emptyRange = [];

          for (var _j = 0; _j < borderRange.length; _j += 1) {
            var bd_r1 = borderRange[_j].row[0];
            var bd_r2 = borderRange[_j].row[1];

            if (direction === "lefttop") {
              if (index <= bd_r1) {
                bd_r1 += count;
                bd_r2 += count;
              } else if (index <= bd_r2) {
                bd_r2 += count;
              }
            } else {
              if (index < bd_r1) {
                bd_r1 += count;
                bd_r2 += count;
              } else if (index < bd_r2) {
                bd_r2 += count;
              }
            }

            if (bd_r2 >= bd_r1) {
              emptyRange.push({
                row: [bd_r1, bd_r2],
                column: borderRange[_j].column
              });
            }
          }

          if (emptyRange.length > 0) {
            var bd_obj = {
              rangeType: "range",
              borderType: cfg.borderInfo[_i7].borderType,
              style: cfg.borderInfo[_i7].style,
              color: cfg.borderInfo[_i7].color,
              range: emptyRange
            };
            borderInfo.push(bd_obj);
          }
        } else if (rangeType === "cell") {
          var row_index = cfg.borderInfo[_i7].value.row_index;

          if (row_index === index) {
            cellBorderConfig.push(JSON.parse(JSON.stringify(cfg.borderInfo[_i7])));
          }

          if (direction === "lefttop") {
            if (index <= row_index) {
              row_index += count;
            }
          } else {
            if (index < row_index) {
              row_index += count;
            }
          }

          cfg.borderInfo[_i7].value.row_index = row_index;
          borderInfo.push(cfg.borderInfo[_i7]);
        }
      }

      cfg.borderInfo = borderInfo;
    }

    var arr = [];

    var _loop = function _loop(r) {
      arr.push(JSON.stringify(row));

      if (cellBorderConfig.length) {
        var _cfg$borderInfo;

        var cellBorderConfigCopy = _.cloneDeep(cellBorderConfig);

        cellBorderConfigCopy.forEach(function (item) {
          if (direction === "rightbottom") {
            item.value.row_index += r + 1;
          } else if (direction === "lefttop") {
            item.value.row_index += r;
          }
        });
        (_cfg$borderInfo = cfg.borderInfo) === null || _cfg$borderInfo === void 0 ? void 0 : _cfg$borderInfo.push.apply(_cfg$borderInfo, _toConsumableArray(cellBorderConfigCopy));
      }
    };

    for (var r = 0; r < count; r += 1) {
      _loop(r);
    }

    if (direction === "lefttop") {
      if (index === 0) {
        new Function("d", "return d.unshift(".concat(arr.join(","), ")"))(d);
      } else {
        new Function("d", "return d.splice(".concat(index, ", 0, ").concat(arr.join(","), ")"))(d);
      }
    } else {
      new Function("d", "return d.splice(".concat(index + 1, ", 0, ").concat(arr.join(","), ")"))(d);
    }
  } else {

    if (cfg.columnlen != null) {
      var columnlen_new = {};
      var columnReadOnly_new = {};

      _.forEach(cfg.columnlen, function (v, cstr) {
        var c = parseFloat(cstr);

        if (c < index) {
          columnlen_new[c] = cfg.columnlen[c];
        } else if (c === index) {
          if (direction === "lefttop") {
            columnlen_new[c + count] = cfg.columnlen[c];
          } else if (direction === "rightbottom") {
            columnlen_new[c] = cfg.columnlen[c];
          }
        } else {
          columnlen_new[c + count] = cfg.columnlen[c];
        }
      });

      _.forEach(cfg.colReadOnly, function (v, cstr) {
        var c = parseFloat(cstr);

        if (c < index) {
          columnReadOnly_new[c] = cfg.colReadOnly[c];
        } else if (c > index) {
          columnReadOnly_new[c + count] = cfg.colReadOnly[c];
        }
      });

      cfg.columnlen = columnlen_new;
      cfg.colReadOnly = columnReadOnly_new;
    }

    if (cfg.customWidth != null) {
      var customWidth_new = {};

      _.forEach(cfg.customWidth, function (v, cstr) {
        var c = parseFloat(cstr);

        if (c < index) {
          customWidth_new[c] = cfg.customWidth[c];
        } else if (c === index) {
          if (direction === "lefttop") {
            customWidth_new[c + count] = cfg.customWidth[c];
          } else if (direction === "rightbottom") {
            customWidth_new[c] = cfg.customWidth[c];
          }
        } else {
          customWidth_new[c + count] = cfg.customWidth[c];
        }
      });

      cfg.customWidth = customWidth_new;
    }

    if (cfg.customWidth != null) {
      var _customWidth_new = {};

      _.forEach(cfg.customWidth, function (v, cstr) {
        var c = parseFloat(cstr);

        if (c < index) {
          _customWidth_new[c] = cfg.customWidth[c];
        } else if (c === index) {
          if (direction === "lefttop") {
            _customWidth_new[c + count] = cfg.customWidth[c];
          } else if (direction === "rightbottom") {
            _customWidth_new[c] = cfg.customWidth[c];
          }
        } else {
          _customWidth_new[c + count] = cfg.customWidth[c];
        }
      });

      cfg.customWidth = _customWidth_new;
    }

    if (cfg.colhidden != null) {
      var colhidden_new = {};

      _.forEach(cfg.colhidden, function (v, cstr) {
        var c = parseFloat(cstr);

        if (c < index) {
          colhidden_new[c] = cfg.colhidden[c];
        } else if (c === index) {
          if (direction === "lefttop") {
            colhidden_new[c + count] = cfg.colhidden[c];
          } else if (direction === "rightbottom") {
            colhidden_new[c] = cfg.colhidden[c];
          }
        } else {
          colhidden_new[c + count] = cfg.colhidden[c];
        }
      });

      cfg.colhidden = colhidden_new;
    }

    var col = [];

    var curd = _toConsumableArray(d);

    for (var _r = 0; _r < d.length; _r += 1) {
      var _cell = curd[_r][index];
      var _templateCell = null;

      if ((_cell === null || _cell === void 0 ? void 0 : _cell.mc) && (direction === "rightbottom" || index !== _cell.mc.c)) {
        var _curd$_r, _curd$_r2;

        if (_cell.mc.cs) {
          _cell.mc.cs += count;
        }

        _templateCell = _objectSpread2({}, _cell);

        if (!(curd === null || curd === void 0 ? void 0 : (_curd$_r = curd[_r]) === null || _curd$_r === void 0 ? void 0 : (_curd$_r2 = _curd$_r[index + 1]) === null || _curd$_r2 === void 0 ? void 0 : _curd$_r2.mc)) {
          _templateCell.mc = undefined;
        }

        delete _templateCell.v;
        delete _templateCell.m;
        delete _templateCell.ps;
        delete _templateCell.f;
      }

      col.push(_templateCell);
    }

    var _cellBorderConfig = [];

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var _borderInfo = [];

      for (var _i8 = 0; _i8 < cfg.borderInfo.length; _i8 += 1) {
        var _rangeType = cfg.borderInfo[_i8].rangeType;

        if (_rangeType === "range") {
          var _borderRange = cfg.borderInfo[_i8].range;
          var _emptyRange = [];

          for (var _j2 = 0; _j2 < _borderRange.length; _j2 += 1) {
            var bd_c1 = _borderRange[_j2].column[0];
            var bd_c2 = _borderRange[_j2].column[1];

            if (direction === "lefttop") {
              if (index <= bd_c1) {
                bd_c1 += count;
                bd_c2 += count;
              } else if (index <= bd_c2) {
                bd_c2 += count;
              }
            } else {
              if (index < bd_c1) {
                bd_c1 += count;
                bd_c2 += count;
              } else if (index < bd_c2) {
                bd_c2 += count;
              }
            }

            if (bd_c2 >= bd_c1) {
              _emptyRange.push({
                row: _borderRange[_j2].row,
                column: [bd_c1, bd_c2]
              });
            }
          }

          if (_emptyRange.length > 0) {
            var _bd_obj = {
              rangeType: "range",
              borderType: cfg.borderInfo[_i8].borderType,
              style: cfg.borderInfo[_i8].style,
              color: cfg.borderInfo[_i8].color,
              range: _emptyRange
            };

            _borderInfo.push(_bd_obj);
          }
        } else if (_rangeType === "cell") {
          var col_index = cfg.borderInfo[_i8].value.col_index;

          if (col_index === index) {
            _cellBorderConfig.push(JSON.parse(JSON.stringify(cfg.borderInfo[_i8])));
          }

          if (direction === "lefttop") {
            if (index <= col_index) {
              col_index += count;
            }
          } else {
            if (index < col_index) {
              col_index += count;
            }
          }

          cfg.borderInfo[_i8].value.col_index = col_index;

          _borderInfo.push(cfg.borderInfo[_i8]);
        }
      }

      cfg.borderInfo = _borderInfo;
    }

    if (_cellBorderConfig.length) {
      var _loop2 = function _loop2(_i9) {
        var _cfg$borderInfo2;

        var cellBorderConfigCopy = _.cloneDeep(_cellBorderConfig);

        cellBorderConfigCopy.forEach(function (item) {
          if (direction === "rightbottom") {
            item.value.col_index += _i9 + 1;
          } else if (direction === "lefttop") {
            item.value.col_index += _i9;
          }
        });
        (_cfg$borderInfo2 = cfg.borderInfo) === null || _cfg$borderInfo2 === void 0 ? void 0 : _cfg$borderInfo2.push.apply(_cfg$borderInfo2, _toConsumableArray(cellBorderConfigCopy));
      };

      for (var _i9 = 0; _i9 < count; _i9 += 1) {
        _loop2(_i9);
      }
    }

    for (var _r2 = 0; _r2 < d.length; _r2 += 1) {
      var _row = d[_r2];

      for (var _i10 = 0; _i10 < count; _i10 += 1) {
        if (direction === "lefttop") {
          if (index === 0) {
            _row.unshift(col[_r2]);
          } else {
            _row.splice(index, 0, col[_r2]);
          }
        } else {
          _row.splice(index + 1, 0, col[_r2]);
        }
      }
    }
  }

  file.data = d;
  file.config = cfg;
  file.calcChain = newCalcChain;

  if (newFilterObj != null) {
    file.filter = newFilterObj.filter;
    file.filter_select = newFilterObj.filter_select;
  }

  file.luckysheet_conditionformat_save = newCFarr;
  file.luckysheet_alternateformat_save = newAFarr;
  file.dataVerification = newDataVerification;
  file.hyperlink = newHyperlink;

  if (file.id === ctx.currentSheetId) {
    ctx.config = cfg;
  }

  var range = null;

  if (type === "row") {
    if (direction === "lefttop") {
      range = [{
        row: [index, index + count - 1],
        column: [0, d[0].length - 1]
      }];
    } else {
      range = [{
        row: [index + 1, index + count],
        column: [0, d[0].length - 1]
      }];
    }

    file.row = file.data.length;
  } else {
    var _file$data$;

    if (direction === "lefttop") {
      range = [{
        row: [0, d.length - 1],
        column: [index, index + count - 1]
      }];
    } else {
      range = [{
        row: [0, d.length - 1],
        column: [index + 1, index + count]
      }];
    }

    file.column = (_file$data$ = file.data[0]) === null || _file$data$ === void 0 ? void 0 : _file$data$.length;
  }

  if (changeSelection) {
    file.luckysheet_select_save = range;

    if (file.id === ctx.currentSheetId) {
      ctx.luckysheet_select_save = range;
    }
  }

  refreshLocalMergeData(merge_new, file);
}
function deleteRowCol(ctx, op) {
  var type = op.type;
  var start = op.start,
      end = op.end,
      id = op.id;
  id = id || ctx.currentSheetId;
  var curOrder = getSheetIndex(ctx, id);
  if (curOrder == null) return;
  var file = ctx.luckysheetfile[curOrder];
  if (!file) return;
  var cfg = file.config || {};

  if (type === "row") {
    for (var r = start; r <= end; r += 1) {
      var _cfg$rowReadOnly2;

      if ((_cfg$rowReadOnly2 = cfg.rowReadOnly) === null || _cfg$rowReadOnly2 === void 0 ? void 0 : _cfg$rowReadOnly2[r]) {
        throw new Error("readOnly");
      }
    }
  } else {
    for (var c = start; c <= end; c += 1) {
      var _cfg$colReadOnly2;

      if ((_cfg$colReadOnly2 = cfg.colReadOnly) === null || _cfg$colReadOnly2 === void 0 ? void 0 : _cfg$colReadOnly2[c]) {
        throw new Error("readOnly");
      }
    }
  }

  var d = file.data;
  if (!d) return;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  if (type === "row") {
    if (start > d.length - 1) {
      start = d.length - 1;
    }

    if (end > d.length - 1) {
      end = d.length - 1;
    }
  } else {
    if (start > d[0].length - 1) {
      start = d[0].length - 1;
    }

    if (end > d[0].length - 1) {
      end = d[0].length - 1;
    }
  }

  if (start > end) {
    return;
  }

  var slen = end - start + 1;

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  var merge_new = {};

  _.forEach(cfg.merge, function (mc) {
    var r = mc.r;
    var c = mc.c;
    var rs = mc.rs;
    var cs = mc.cs;

    if (type === "row") {
      if (r < start) {
        if (r + rs - 1 < start) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs
          };
        } else if (r + rs - 1 >= start && r + rs - 1 < end) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: start - r,
            cs: cs
          };
        } else if (r + rs - 1 >= end) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs - slen,
            cs: cs
          };
        }
      } else if (r >= start && r <= end) {
        if (r + rs - 1 > end) {
          merge_new["".concat(start, "_").concat(c)] = {
            r: start,
            c: c,
            rs: r + rs - 1 - end,
            cs: cs
          };
        }
      } else if (r > end) {
        merge_new["".concat(r - slen, "_").concat(c)] = {
          r: r - slen,
          c: c,
          rs: rs,
          cs: cs
        };
      }
    } else if (type === "column") {
      if (c < start) {
        if (c + cs - 1 < start) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs
          };
        } else if (c + cs - 1 >= start && c + cs - 1 < end) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: start - c
          };
        } else if (c + cs - 1 >= end) {
          merge_new["".concat(r, "_").concat(c)] = {
            r: r,
            c: c,
            rs: rs,
            cs: cs - slen
          };
        }
      } else if (c >= start && c <= end) {
        if (c + cs - 1 > end) {
          merge_new["".concat(r, "_").concat(start)] = {
            r: r,
            c: start,
            rs: rs,
            cs: c + cs - 1 - end
          };
        }
      } else if (c > end) {
        merge_new["".concat(r, "_").concat(c - slen)] = {
          r: r,
          c: c - slen,
          rs: rs,
          cs: cs
        };
      }
    }
  });

  cfg.merge = merge_new;
  var newCalcChain = [];

  for (var SheetIndex = 0; SheetIndex < ctx.luckysheetfile.length; SheetIndex += 1) {
    if (_.isNil(ctx.luckysheetfile[SheetIndex].calcChain) || ctx.luckysheetfile.length === 0) {
      continue;
    }

    var calcChain = ctx.luckysheetfile[SheetIndex].calcChain;
    var data = ctx.luckysheetfile[SheetIndex].data;

    for (var i = 0; i < calcChain.length; i += 1) {
      var calc = _.cloneDeep(calcChain[i]);

      var calc_r = calc.r;
      var calc_c = calc.c;
      var calc_i = calc.id;
      var calc_funcStr = getcellFormula(ctx, calc_r, calc_c, calc_i);

      if (type === "row" && SheetIndex === curOrder) {
        if (calc_r < start || calc_r > end) {
          var _data$calc_r3, _data$calc_r3$calc_c;

          var functionStr = "=".concat(functionStrChange(calc_funcStr, "del", "row", null, start, slen));

          if (((_data$calc_r3 = data[calc_r]) === null || _data$calc_r3 === void 0 ? void 0 : (_data$calc_r3$calc_c = _data$calc_r3[calc_c]) === null || _data$calc_r3$calc_c === void 0 ? void 0 : _data$calc_r3$calc_c.f) === calc_funcStr) {
            data[calc_r][calc_c].f = functionStr;
          }

          if (calc_r > end) {
            calc.r = calc_r - slen;
          }

          newCalcChain.push(calc);
        }
      } else if (type === "row") {
        var _data$calc_r4, _data$calc_r4$calc_c;

        var _functionStr4 = "=".concat(functionStrChange(calc_funcStr, "del", "row", null, start, slen));

        if (((_data$calc_r4 = data[calc_r]) === null || _data$calc_r4 === void 0 ? void 0 : (_data$calc_r4$calc_c = _data$calc_r4[calc_c]) === null || _data$calc_r4$calc_c === void 0 ? void 0 : _data$calc_r4$calc_c.f) === calc_funcStr) {
          data[calc_r][calc_c].f = _functionStr4;
        }
      } else if (type === "column" && SheetIndex === curOrder) {
        if (calc_c < start || calc_c > end) {
          var _data$calc_r5, _data$calc_r5$calc_c;

          var _functionStr5 = "=".concat(functionStrChange(calc_funcStr, "del", "col", null, start, slen));

          if (((_data$calc_r5 = data[calc_r]) === null || _data$calc_r5 === void 0 ? void 0 : (_data$calc_r5$calc_c = _data$calc_r5[calc_c]) === null || _data$calc_r5$calc_c === void 0 ? void 0 : _data$calc_r5$calc_c.f) === calc_funcStr) {
            data[calc_r][calc_c].f = _functionStr5;
          }

          if (calc_c > end) {
            calc.c = calc_c - slen;
          }

          newCalcChain.push(calc);
        }
      } else if (type === "column") {
        var _data$calc_r6, _data$calc_r6$calc_c;

        var _functionStr6 = "=".concat(functionStrChange(calc_funcStr, "del", "col", null, start, slen));

        if (((_data$calc_r6 = data[calc_r]) === null || _data$calc_r6 === void 0 ? void 0 : (_data$calc_r6$calc_c = _data$calc_r6[calc_c]) === null || _data$calc_r6$calc_c === void 0 ? void 0 : _data$calc_r6$calc_c.f) === calc_funcStr) {
          data[calc_r][calc_c].f = _functionStr6;
        }
      }
    }
  }

  var filter_select = file.filter_select;
  var filter = file.filter;
  var newFilterObj = null;

  if (!_.isEmpty(filter_select) && filter_select != null) {
    newFilterObj = {
      filter_select: null,
      filter: null
    };
    var f_r1 = filter_select.row[0];
    var f_r2 = filter_select.row[1];
    var f_c1 = filter_select.column[0];
    var f_c2 = filter_select.column[1];

    if (type === "row") {
      if (f_r1 > end) {
        f_r1 -= slen;
        f_r2 -= slen;
        newFilterObj.filter_select = {
          row: [f_r1, f_r2],
          column: [f_c1, f_c2]
        };
      } else if (f_r1 < start) {
        if (f_r2 < start) ; else if (f_r2 <= end) {
          f_r2 = start - 1;
        } else {
          f_r2 -= slen;
        }

        newFilterObj.filter_select = {
          row: [f_r1, f_r2],
          column: [f_c1, f_c2]
        };
      }

      if (newFilterObj.filter_select != null && filter != null) {
        _.forEach(filter, function (v, k) {
          var f_rowhidden = filter[k].rowhidden;
          var f_rowhidden_new = {};

          _.forEach(f_rowhidden, function (v1, nstr) {
            var n = parseFloat(nstr);

            if (n < start) {
              f_rowhidden_new[n] = 0;
            } else if (n > end) {
              f_rowhidden_new[n - slen] = 0;
            }
          });

          if (!_.isEmpty(f_rowhidden_new)) {
            if (newFilterObj.filter == null) {
              newFilterObj.filter = {};
            }

            newFilterObj.filter[k] = _.cloneDeep(filter[k]);
            newFilterObj.filter[k].rowhidden = f_rowhidden_new;
            newFilterObj.filter[k].str = f_r1;
            newFilterObj.filter[k].edr = f_r2;
          }
        });
      }
    } else if (type === "column") {
      if (f_c1 > end) {
        f_c1 -= slen;
        f_c2 -= slen;
        newFilterObj.filter_select = {
          row: [f_r1, f_r2],
          column: [f_c1, f_c2]
        };
      } else if (f_c1 < start) {
        if (f_c2 < start) ; else if (f_c2 <= end) {
          f_c2 = start - 1;
        } else {
          f_c2 -= slen;
        }

        newFilterObj.filter_select = {
          row: [f_r1, f_r2],
          column: [f_c1, f_c2]
        };
      } else {
        if (f_c2 > end) {
          f_c1 = start;
          f_c2 -= slen;
          newFilterObj.filter_select = {
            row: [f_r1, f_r2],
            column: [f_c1, f_c2]
          };
        }
      }

      if (newFilterObj.filter_select != null && filter != null) {
        _.forEach(filter, function (v, k) {
          var f_cindex = filter[k].cindex;

          if (f_cindex < start) {
            if (newFilterObj.filter == null) {
              newFilterObj.filter = {};
            }

            newFilterObj.filter[f_cindex - f_c1] = _.cloneDeep(filter[k]);
            newFilterObj.filter[f_cindex - f_c1].edc = f_c2;
          } else if (f_cindex > end) {
            f_cindex -= slen;

            if (newFilterObj.filter == null) {
              newFilterObj.filter = {};
            }

            newFilterObj.filter[f_cindex - f_c1] = _.cloneDeep(filter[k]);
            newFilterObj.filter[f_cindex - f_c1].cindex = f_cindex;
            newFilterObj.filter[f_cindex - f_c1].stc = f_c1;
            newFilterObj.filter[f_cindex - f_c1].edc = f_c2;
          }
        });
      }
    }
  }

  if (newFilterObj != null && newFilterObj.filter != null) {
    if (cfg.rowhidden == null) {
      cfg.rowhidden = {};
    }

    _.forEach(newFilterObj.filter, function (v, k) {
      var f_rowhidden = newFilterObj.filter[k].rowhidden;

      _.forEach(f_rowhidden, function (v1, n) {
        cfg.rowhidden[n] = 0;
      });
    });
  }

  var CFarr = file.luckysheet_conditionformat_save;
  var newCFarr = [];

  if (CFarr != null && CFarr.length > 0) {
    for (var _i11 = 0; _i11 < CFarr.length; _i11 += 1) {
      var cf_range = CFarr[_i11].cellrange;
      var cf_new_range = [];

      for (var j = 0; j < cf_range.length; j += 1) {
        var CFr1 = cf_range[j].row[0];
        var CFr2 = cf_range[j].row[1];
        var CFc1 = cf_range[j].column[0];
        var CFc2 = cf_range[j].column[1];

        if (type === "row") {
          if (!(CFr1 >= start && CFr2 <= end)) {
            if (CFr1 > end) {
              CFr1 -= slen;
              CFr2 -= slen;
            } else if (CFr1 < start) {
              if (CFr2 < start) ; else if (CFr2 <= end) {
                CFr2 = start - 1;
              } else {
                CFr2 -= slen;
              }
            } else {
              if (CFr2 > end) {
                CFr1 = start;
                CFr2 -= slen;
              }
            }

            cf_new_range.push({
              row: [CFr1, CFr2],
              column: [CFc1, CFc2]
            });
          }
        } else if (type === "column") {
          if (!(CFc1 >= start && CFc2 <= end)) {
            if (CFc1 > end) {
              CFc1 -= slen;
              CFc2 -= slen;
            } else if (CFc1 < start) {
              if (CFc2 < start) ; else if (CFc2 <= end) {
                CFc2 = start - 1;
              } else {
                CFc2 -= slen;
              }
            } else {
              if (CFc2 > end) {
                CFc1 = start;
                CFc2 -= slen;
              }
            }

            cf_new_range.push({
              row: [CFr1, CFr2],
              column: [CFc1, CFc2]
            });
          }
        }
      }

      if (cf_new_range.length > 0) {
        var cf = _.clone(CFarr[_i11]);

        cf.cellrange = cf_new_range;
        newCFarr.push(cf);
      }
    }
  }

  var AFarr = file.luckysheet_alternateformat_save;
  var newAFarr = [];

  if (AFarr != null && AFarr.length > 0) {
    for (var _i12 = 0; _i12 < AFarr.length; _i12 += 1) {
      var AFr1 = AFarr[_i12].cellrange.row[0];
      var AFr2 = AFarr[_i12].cellrange.row[1];
      var AFc1 = AFarr[_i12].cellrange.column[0];
      var AFc2 = AFarr[_i12].cellrange.column[1];

      if (type === "row") {
        if (!(AFr1 >= start && AFr2 <= end)) {
          var af = _.clone(AFarr[_i12]);

          if (AFr1 > end) {
            AFr1 -= slen;
            AFr2 -= slen;
          } else if (AFr1 < start) {
            if (AFr2 < start) ; else if (AFr2 <= end) {
              AFr2 = start - 1;
            } else {
              AFr2 -= slen;
            }
          } else {
            if (AFr2 > end) {
              AFr1 = start;
              AFr2 -= slen;
            }
          }

          af.cellrange = {
            row: [AFr1, AFr2],
            column: [AFc1, AFc2]
          };
          newAFarr.push(af);
        }
      } else if (type === "column") {
        if (!(AFc1 >= start && AFc2 <= end)) {
          var _af = _.clone(AFarr[_i12]);

          if (AFc1 > end) {
            AFc1 -= slen;
            AFc2 -= slen;
          } else if (AFc1 < start) {
            if (AFc2 < start) ; else if (AFc2 <= end) {
              AFc2 = start - 1;
            } else {
              AFc2 -= slen;
            }
          } else {
            if (AFc2 > end) {
              AFc1 = start;
              AFc2 -= slen;
            }
          }

          _af.cellrange = {
            row: [AFr1, AFr2],
            column: [AFc1, AFc2]
          };
          newAFarr.push(_af);
        }
      }
    }
  }

  var frozen = file.frozen;

  if (frozen) {
    if (type === "row" && (frozen.type === "rangeRow" || frozen.type === "rangeBoth")) {
      var _frozen$range$row_foc2, _frozen$range3;

      if (((_frozen$range$row_foc2 = (_frozen$range3 = frozen.range) === null || _frozen$range3 === void 0 ? void 0 : _frozen$range3.row_focus) !== null && _frozen$range$row_foc2 !== void 0 ? _frozen$range$row_foc2 : -1) >= start) {
        frozen.range.row_focus -= Math.min(end, frozen.range.row_focus) - start + 1;
      }
    }

    if (type === "column" && (frozen.type === "rangeColumn" || frozen.type === "rangeBoth")) {
      var _frozen$range$column_2, _frozen$range4;

      if (((_frozen$range$column_2 = (_frozen$range4 = frozen.range) === null || _frozen$range4 === void 0 ? void 0 : _frozen$range4.column_focus) !== null && _frozen$range$column_2 !== void 0 ? _frozen$range$column_2 : -1) >= start) {
        frozen.range.column_focus -= Math.min(end, frozen.range.column_focus) - start + 1;
      }
    }
  }

  var dataVerification = file.dataVerification;
  var newDataVerification = {};

  if (dataVerification != null) {
    _.forEach(dataVerification, function (v, key) {
      var r = Number(key.split("_")[0]);
      var c = Number(key.split("_")[1]);
      var item = dataVerification[key];

      if (type === "row") {
        if (r < start) {
          newDataVerification["".concat(r, "_").concat(c)] = item;
        } else if (r > end) {
          newDataVerification["".concat(r - slen, "_").concat(c)] = item;
        }
      } else if (type === "column") {
        if (c < start) {
          newDataVerification["".concat(r, "_").concat(c)] = item;
        } else if (c > end) {
          newDataVerification["".concat(r, "_").concat(c - slen)] = item;
        }
      }
    });
  }

  var hyperlink = file.hyperlink;
  var newHyperlink = {};

  if (hyperlink != null) {
    _.forEach(hyperlink, function (v, key) {
      var r = Number(key.split("_")[0]);
      var c = Number(key.split("_")[1]);
      var item = hyperlink[key];

      if (type === "row") {
        if (r < start) {
          newHyperlink["".concat(r, "_").concat(c)] = item;
        } else if (r > end) {
          newHyperlink["".concat(r - slen, "_").concat(c)] = item;
        }
      } else if (type === "column") {
        if (c < start) {
          newHyperlink["".concat(r, "_").concat(c)] = item;
        } else if (c > end) {
          newHyperlink["".concat(r, "_").concat(c - slen)] = item;
        }
      }
    });
  }

  if (type === "row") {

    if (cfg.rowlen == null) {
      cfg.rowlen = {};
    }

    var rowlen_new = {};
    var rowReadOnly_new = {};

    _.forEach(cfg.rowlen, function (v, rstr) {
      var r = parseFloat(rstr);

      if (r < start) {
        rowlen_new[r] = cfg.rowlen[r];
      } else if (r > end) {
        rowlen_new[r - slen] = cfg.rowlen[r];
      }
    });

    _.forEach(cfg.rowReadOnly, function (v, rstr) {
      var r = parseFloat(rstr);

      if (r < start) {
        rowReadOnly_new[r] = cfg.rowReadOnly[r];
      } else if (r > end) {
        rowReadOnly_new[r - slen] = cfg.rowReadOnly[r];
      }
    });

    cfg.rowlen = rowlen_new;
    cfg.rowReadOnly = rowReadOnly_new;

    if (cfg.rowhidden == null) {
      cfg.rowhidden = {};
    }

    var rowhidden_new = {};

    _.forEach(cfg.rowhidden, function (v, rstr) {
      var r = parseFloat(rstr);

      if (r < start) {
        rowhidden_new[r] = cfg.rowhidden[r];
      } else if (r > end) {
        rowhidden_new[r - slen] = cfg.rowhidden[r];
      }
    });

    if (cfg.customHeight == null) {
      cfg.customHeight = {};
      var customHeight_new = {};

      _.forEach(cfg.customHeight, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < start) {
          customHeight_new[r] = cfg.customHeight[r];
        } else if (r > end) {
          customHeight_new[r - slen] = cfg.customHeight[r];
        }
      });

      cfg.customHeight = customHeight_new;
    }

    if (cfg.customHeight == null) {
      cfg.customHeight = {};
      var _customHeight_new2 = {};

      _.forEach(cfg.customHeight, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < start) {
          _customHeight_new2[r] = cfg.customHeight[r];
        } else if (r > end) {
          _customHeight_new2[r - slen] = cfg.customHeight[r];
        }
      });

      cfg.customHeight = _customHeight_new2;
    }

    cfg.rowhidden = rowhidden_new;

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var borderInfo = [];

      for (var _i13 = 0; _i13 < cfg.borderInfo.length; _i13 += 1) {
        var rangeType = cfg.borderInfo[_i13].rangeType;

        if (rangeType === "range") {
          var borderRange = cfg.borderInfo[_i13].range;
          var emptyRange = [];

          for (var _j3 = 0; _j3 < borderRange.length; _j3 += 1) {
            var bd_r1 = borderRange[_j3].row[0];
            var bd_r2 = borderRange[_j3].row[1];

            for (var _r3 = start; _r3 <= end; _r3 += 1) {
              if (_r3 < borderRange[_j3].row[0]) {
                bd_r1 -= 1;
                bd_r2 -= 1;
              } else if (_r3 <= borderRange[_j3].row[1]) {
                bd_r2 -= 1;
              }
            }

            if (bd_r2 >= bd_r1) {
              emptyRange.push({
                row: [bd_r1, bd_r2],
                column: borderRange[_j3].column
              });
            }
          }

          if (emptyRange.length > 0) {
            var bd_obj = {
              rangeType: "range",
              borderType: cfg.borderInfo[_i13].borderType,
              style: cfg.borderInfo[_i13].style,
              color: cfg.borderInfo[_i13].color,
              range: emptyRange
            };
            borderInfo.push(bd_obj);
          }
        } else if (rangeType === "cell") {
          var row_index = cfg.borderInfo[_i13].value.row_index;

          if (row_index < start) {
            borderInfo.push(cfg.borderInfo[_i13]);
          } else if (row_index > end) {
            cfg.borderInfo[_i13].value.row_index = row_index - (end - start + 1);
            borderInfo.push(cfg.borderInfo[_i13]);
          }
        }
      }

      cfg.borderInfo = borderInfo;
    }

    d.splice(start, slen);
    file.row = d.length;
  } else {
    var _d$;

    if (cfg.columnlen == null) {
      cfg.columnlen = {};
    }

    var columnlen_new = {};
    var columnReadOnly_new = {};

    _.forEach(cfg.columnlen, function (v, cstr) {
      var c = parseFloat(cstr);

      if (c < start) {
        columnlen_new[c] = cfg.columnlen[c];
      } else if (c > end) {
        columnlen_new[c - slen] = cfg.columnlen[c];
      }
    });

    _.forEach(cfg.colReadOnly, function (v, cstr) {
      var c = parseFloat(cstr);

      if (c < start) {
        columnReadOnly_new[c] = cfg.colReadOnly[c];
      } else if (c > end) {
        columnReadOnly_new[c - slen] = cfg.colReadOnly[c];
      }
    });

    cfg.columnlen = columnlen_new;
    cfg.colReadOnly = columnReadOnly_new;

    if (cfg.customWidth == null) {
      cfg.customWidth = {};
      var customWidth_new = {};

      _.forEach(cfg.customWidth, function (v, rstr) {
        var r = parseFloat(rstr);

        if (r < start) {
          customWidth_new[r] = cfg.customWidth[r];
        } else if (r > end) {
          customWidth_new[r - slen] = cfg.customWidth[r];
        }
      });

      cfg.customWidth = customWidth_new;
    }

    cfg.colReadOnly = columnReadOnly_new;

    if (cfg.colhidden == null) {
      cfg.colhidden = {};
    }

    var colhidden_new = {};

    _.forEach(cfg.colhidden, function (v, cstr) {
      var c = parseFloat(cstr);

      if (c < start) {
        colhidden_new[c] = cfg.colhidden[c];
      } else if (c > end) {
        colhidden_new[c - slen] = cfg.colhidden[c];
      }
    });

    cfg.colhidden = colhidden_new;

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var _borderInfo2 = [];

      for (var _i14 = 0; _i14 < cfg.borderInfo.length; _i14 += 1) {
        var _rangeType2 = cfg.borderInfo[_i14].rangeType;

        if (_rangeType2 === "range") {
          var _borderRange2 = cfg.borderInfo[_i14].range;
          var _emptyRange2 = [];

          for (var _j4 = 0; _j4 < _borderRange2.length; _j4 += 1) {
            var bd_c1 = _borderRange2[_j4].column[0];
            var bd_c2 = _borderRange2[_j4].column[1];

            for (var _c = start; _c <= end; _c += 1) {
              if (_c < _borderRange2[_j4].column[0]) {
                bd_c1 -= 1;
                bd_c2 -= 1;
              } else if (_c <= _borderRange2[_j4].column[1]) {
                bd_c2 -= 1;
              }
            }

            if (bd_c2 >= bd_c1) {
              _emptyRange2.push({
                row: _borderRange2[_j4].row,
                column: [bd_c1, bd_c2]
              });
            }
          }

          if (_emptyRange2.length > 0) {
            var _bd_obj2 = {
              rangeType: "range",
              borderType: cfg.borderInfo[_i14].borderType,
              style: cfg.borderInfo[_i14].style,
              color: cfg.borderInfo[_i14].color,
              range: _emptyRange2
            };

            _borderInfo2.push(_bd_obj2);
          }
        } else if (_rangeType2 === "cell") {
          var col_index = cfg.borderInfo[_i14].value.col_index;

          if (col_index < start) {
            _borderInfo2.push(cfg.borderInfo[_i14]);
          } else if (col_index > end) {
            cfg.borderInfo[_i14].value.col_index = col_index - (end - start + 1);

            _borderInfo2.push(cfg.borderInfo[_i14]);
          }
        }
      }

      cfg.borderInfo = _borderInfo2;
    }

    for (var _r4 = 0; _r4 < d.length; _r4 += 1) {
      d[_r4].splice(start, slen);
    }

    file.column = (_d$ = d[0]) === null || _d$ === void 0 ? void 0 : _d$.length;
  }

  ctx.luckysheet_select_save = undefined;
  file.data = d;
  file.config = cfg;
  file.calcChain = newCalcChain;

  if (newFilterObj != null) {
    file.filter = newFilterObj.filter;
    file.filter_select = newFilterObj.filter_select;
  }

  file.luckysheet_conditionformat_save = newCFarr;
  file.luckysheet_alternateformat_save = newAFarr;
  file.dataVerification = newDataVerification;
  file.hyperlink = newHyperlink;
  refreshLocalMergeData(merge_new, file);

  if (file.id === ctx.currentSheetId) {
    ctx.config = cfg;
  }
}
function computeRowlenArr(ctx, rowHeight, cfg) {
  var rowlenArr = [];
  var rh_height = 0;

  for (var i = 0; i < rowHeight; i += 1) {
    var rowlen = ctx.defaultrowlen;

    if (cfg.rowlen != null && cfg.rowlen[i] != null) {
      rowlen = cfg.rowlen[i];
    }

    if (cfg.rowhidden != null && cfg.rowhidden[i] != null) {
      rowlen = cfg.rowhidden[i];
      rowlenArr.push(rh_height);
      continue;
    } else {
      rh_height += rowlen + 1;
    }

    rowlenArr.push(rh_height);
  }

  return rowlenArr;
}
function hideSelected(ctx, type) {
  if (!ctx.luckysheet_select_save || ctx.luckysheet_select_save.length > 1) return "noMulti";
  var index = getSheetIndex(ctx, ctx.currentSheetId);

  if (type === "row") {
    var _ctx$config$rowhidden;

    var rowhidden = (_ctx$config$rowhidden = ctx.config.rowhidden) !== null && _ctx$config$rowhidden !== void 0 ? _ctx$config$rowhidden : {};
    var r1 = ctx.luckysheet_select_save[0].row[0];
    var r2 = ctx.luckysheet_select_save[0].row[1];
    var rowhiddenNumber = r2;

    for (var r = r1; r <= r2; r += 1) {
      rowhidden[r] = 0;
    }

    ctx.config.rowhidden = rowhidden;
    var rowLen = ctx.luckysheetfile[index].data.length;
    var isEndRow = rowLen - 1 === rowhiddenNumber || Object.keys(rowhidden).findIndex(function (o) {
      return parseInt(o, 10) - 1 === rowhiddenNumber;
    }) >= 0;

    if (isEndRow) {
      ctx.luckysheet_select_save[0].row[0] -= 1;
      ctx.luckysheet_select_save[0].row[1] -= 1;
    } else {
      ctx.luckysheet_select_save[0].row[0] += 1;
      ctx.luckysheet_select_save[0].row[1] += 1;
    }
  } else if (type === "column") {
    var _ctx$config$colhidden;

    var colhidden = (_ctx$config$colhidden = ctx.config.colhidden) !== null && _ctx$config$colhidden !== void 0 ? _ctx$config$colhidden : {};
    var c1 = ctx.luckysheet_select_save[0].column[0];
    var c2 = ctx.luckysheet_select_save[0].column[1];
    var colhiddenNumber = c2;

    for (var c = c1; c <= c2; c += 1) {
      colhidden[c] = 0;
    }

    ctx.config.colhidden = colhidden;
    var columnLen = ctx.luckysheetfile[index].data[0].length;
    var isEndColumn = columnLen - 1 === colhiddenNumber || Object.keys(colhidden).findIndex(function (o) {
      return parseInt(o, 10) - 1 === colhiddenNumber;
    }) >= 0;

    if (isEndColumn) {
      ctx.luckysheet_select_save[0].column[0] -= 1;
      ctx.luckysheet_select_save[0].column[1] -= 1;
    } else {
      ctx.luckysheet_select_save[0].column[0] += 1;
      ctx.luckysheet_select_save[0].column[1] += 1;
    }
  }

  ctx.luckysheetfile[index].config = ctx.config;
  return "";
}
function showSelected(ctx, type) {
  if (!ctx.luckysheet_select_save || ctx.luckysheet_select_save.length > 1) return "noMulti";
  var index = getSheetIndex(ctx, ctx.currentSheetId);

  if (type === "row") {
    var _ctx$config$rowhidden2;

    var rowhidden = (_ctx$config$rowhidden2 = ctx.config.rowhidden) !== null && _ctx$config$rowhidden2 !== void 0 ? _ctx$config$rowhidden2 : {};
    var r1 = ctx.luckysheet_select_save[0].row[0];
    var r2 = ctx.luckysheet_select_save[0].row[1];

    for (var r = r1; r <= r2; r += 1) {
      delete rowhidden[r];
    }

    ctx.config.rowhidden = rowhidden;
  } else if (type === "column") {
    var _ctx$config$colhidden2;

    var colhidden = (_ctx$config$colhidden2 = ctx.config.colhidden) !== null && _ctx$config$colhidden2 !== void 0 ? _ctx$config$colhidden2 : {};
    var c1 = ctx.luckysheet_select_save[0].column[0];
    var c2 = ctx.luckysheet_select_save[0].column[1];

    for (var c = c1; c <= c2; c += 1) {
      delete colhidden[c];
    }

    ctx.config.colhidden = colhidden;
  }

  ctx.luckysheetfile[index].config = ctx.config;
  return "";
}
function isShowHidenCR(ctx) {
  if (!ctx.luckysheet_select_save || !ctx.config.colhidden && !ctx.config.rowhidden) return false;

  if (!!ctx.config.colhidden && _.size(ctx.config.colhidden) >= 1) {
    var _ctx$luckysheet_selec, _ctx$luckysheet_selec2;

    var ctxColumn = (_ctx$luckysheet_selec = ctx.luckysheet_select_save[0]) === null || _ctx$luckysheet_selec === void 0 ? void 0 : (_ctx$luckysheet_selec2 = _ctx$luckysheet_selec.column) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2[0];
    var isHidenColumn = Object.keys(ctx.config.colhidden).findIndex(function (o) {
      return ctxColumn === parseInt(o, 10);
    }) >= 0;

    if (isHidenColumn) {
      return true;
    }
  }

  if (!!ctx.config.rowhidden && _.size(ctx.config.rowhidden) >= 1) {
    var _ctx$luckysheet_selec3, _ctx$luckysheet_selec4;

    var ctxRow = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save[0]) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : (_ctx$luckysheet_selec4 = _ctx$luckysheet_selec3.row) === null || _ctx$luckysheet_selec4 === void 0 ? void 0 : _ctx$luckysheet_selec4[0];
    var isHidenRow = Object.keys(ctx.config.rowhidden).findIndex(function (o) {
      return ctxRow === parseInt(o, 10);
    }) >= 0;

    if (isHidenRow) {
      return true;
    }
  }

  return false;
}
function hideCRCount(ctx, type) {
  var _ctx$config$rowhidden3, _ctx$config$colhidden3;

  var count = 1;
  if (!ctx.luckysheet_select_save) return 0;
  var section = ctx.luckysheet_select_save[0];
  var rowhidden = (_ctx$config$rowhidden3 = ctx.config.rowhidden) !== null && _ctx$config$rowhidden3 !== void 0 ? _ctx$config$rowhidden3 : {};
  var colhidden = (_ctx$config$colhidden3 = ctx.config.colhidden) !== null && _ctx$config$colhidden3 !== void 0 ? _ctx$config$colhidden3 : {};

  if (type === "ArrowUp" || type === "ArrowDown") {
    var rowArr = Object.keys(rowhidden);

    if (type === "ArrowUp") {
      var row = section.row[0] - 1;
      var rowIndex = rowArr.indexOf(row.toString());

      for (var i = rowIndex; i >= 0; i -= 1) {
        if (parseInt(rowArr[i], 10) === row) {
          count += 1;
          row -= 1;
        } else {
          return count;
        }
      }
    } else {
      var _row2 = section.row[0] + 1;

      var _rowIndex = rowArr.indexOf("".concat(_row2));

      for (var _i15 = _rowIndex; _i15 < rowArr.length; _i15 += 1) {
        if (parseInt(rowArr[_i15], 10) === _row2) {
          count += 1;
          _row2 += 1;
        } else {
          return count;
        }
      }
    }
  } else if (type === "ArrowLeft" || type === "ArrowRight") {
    var columnArr = Object.keys(colhidden);

    if (type === "ArrowLeft") {
      var column = section.column[0] - 1;
      var columnIndex = columnArr.indexOf(column.toString());

      for (var _i16 = columnIndex; _i16 >= 0; _i16 -= 1) {
        if (parseInt(columnArr[_i16], 10) === column) {
          count += 1;
          column -= 1;
        } else {
          return count;
        }
      }
    } else {
      var _column = section.column[0] + 1;

      var _columnIndex = columnArr.indexOf("".concat(_column));

      for (var _i17 = _columnIndex; _i17 < columnArr.length; _i17 += 1) {
        if (parseInt(columnArr[_i17], 10) === _column) {
          count += 1;
          _column += 1;
        } else {
          return count;
        }
      }
    }
  }

  return count;
}

function getAllSheets(ctx) {
  return ctx.luckysheetfile;
}
function initSheetData(draftCtx, index, newData) {
  var _lastRow$r, _lastCol$c;

  var celldata = newData.celldata,
      row = newData.row,
      column = newData.column;

  var lastRow = _.maxBy(celldata, "r");

  var lastCol = _.maxBy(celldata, "c");

  var lastRowNum = ((_lastRow$r = lastRow === null || lastRow === void 0 ? void 0 : lastRow.r) !== null && _lastRow$r !== void 0 ? _lastRow$r : 0) + 1;
  var lastColNum = ((_lastCol$c = lastCol === null || lastCol === void 0 ? void 0 : lastCol.c) !== null && _lastCol$c !== void 0 ? _lastCol$c : 0) + 1;

  if (row != null && column != null && row > 0 && column > 0) {
    lastRowNum = Math.max(lastRowNum, row);
    lastColNum = Math.max(lastColNum, column);
  } else {
    lastRowNum = Math.max(lastRowNum, draftCtx.defaultrowNum);
    lastColNum = Math.max(lastColNum, draftCtx.defaultcolumnNum);
  }

  if (lastRowNum && lastColNum) {
    var expandedData = _.times(lastRowNum, function () {
      return _.times(lastColNum, function () {
        return null;
      });
    });

    celldata === null || celldata === void 0 ? void 0 : celldata.forEach(function (d) {
      expandedData[d.r][d.c] = d.v;
    });

    if (draftCtx.luckysheetfile[index] == null) {
      newData.data = expandedData;
      delete newData.celldata;
      draftCtx.luckysheetfile.push(newData);
    } else {
      draftCtx.luckysheetfile[index].data = expandedData;
      delete draftCtx.luckysheetfile[index].celldata;
    }

    return expandedData;
  }

  return null;
}
function hideSheet(ctx, sheetId) {
  var index = getSheetIndex(ctx, sheetId);
  ctx.luckysheetfile[index].hide = 1;
  ctx.luckysheetfile[index].status = 0;
  var shownSheets = ctx.luckysheetfile.filter(function (sheet) {
    return _.isUndefined(sheet.hide) || (sheet === null || sheet === void 0 ? void 0 : sheet.hide) !== 1;
  });
  ctx.currentSheetId = shownSheets[0].id;
}
function showSheet(ctx, sheetId) {
  var index = getSheetIndex(ctx, sheetId);
  ctx.luckysheetfile[index].hide = undefined;
}

function generateCopySheetName(ctx, sheetId) {
  var _locale = locale(ctx),
      info = _locale.info;

  var copyWord = "(".concat(info.copy);
  var SheetIndex = getSheetIndex(ctx, sheetId);
  var sheetName = ctx.luckysheetfile[SheetIndex].name;
  var copy_i = sheetName.indexOf(copyWord);
  var index = 0;

  if (copy_i !== -1) {
    sheetName = sheetName.toString().substring(0, copy_i);
  }

  var nameCopy = sheetName + copyWord;
  var sheetNames = [];

  for (var i = 0; i < ctx.luckysheetfile.length; i += 1) {
    var fileName = ctx.luckysheetfile[i].name;
    sheetNames.push(fileName);
    var st_i = fileName.indexOf(nameCopy);

    if (st_i === 0) {
      index = index || 2;
      var ed_i = fileName.indexOf(")", st_i + nameCopy.length);
      var num = fileName.substring(st_i + nameCopy.length, ed_i);

      if (_.isNumber(num)) {
        if (Number.parseInt(num, 10) >= index) {
          index = Number.parseInt(num, 10) + 1;
        }
      }
    }
  }

  var sheetCopyName;

  do {
    var postfix = "".concat(copyWord + (index || ""), ")");
    var lengthLimit = 31 - postfix.length;
    sheetCopyName = sheetName;

    if (sheetCopyName.length > lengthLimit) {
      sheetCopyName = "".concat(sheetCopyName.slice(0, lengthLimit - 1), "\u2026");
    }

    sheetCopyName += postfix;
    index = (index || 1) + 1;
  } while (sheetNames.indexOf(sheetCopyName) !== -1);

  return sheetCopyName;
}

function copySheet(ctx, sheetId) {
  var index$1 = getSheetIndex(ctx, sheetId);
  var order = ctx.luckysheetfile[index$1].order + 1;
  var sheetName = generateCopySheetName(ctx, sheetId);

  var sheetData = _.cloneDeep(ctx.luckysheetfile[index$1]);

  delete sheetData.id;
  delete sheetData.status;
  sheetData.celldata = dataToCelldata(sheetData.data);
  delete sheetData.data;
  addSheet$1(ctx, undefined, v4(), ctx.luckysheetfile[index$1].isPivotTable, sheetName, sheetData);
  var sheetOrderList = {};
  sheetOrderList[ctx.luckysheetfile[ctx.luckysheetfile.length - 1].id] = order;
  setSheetOrder(ctx, sheetOrderList);
}
function calculateSheetFromula(ctx, id) {
  var index$1 = getSheetIndex(ctx, id);
  if (!ctx.luckysheetfile[index$1].data) return;

  for (var r = 0; r < ctx.luckysheetfile[index$1].data.length; r += 1) {
    for (var c = 0; c < ctx.luckysheetfile[index$1].data[r].length; c += 1) {
      var _ctx$luckysheetfile$i, _ctx$luckysheetfile$i2;

      if (!((_ctx$luckysheetfile$i = ctx.luckysheetfile[index$1].data[r][c]) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i.f)) {
        continue;
      }

      var result = execfunction(ctx, (_ctx$luckysheetfile$i2 = ctx.luckysheetfile[index$1].data[r][c]) === null || _ctx$luckysheetfile$i2 === void 0 ? void 0 : _ctx$luckysheetfile$i2.f, r, c, id);
      setCellValue$1(ctx, r, c, result[1], null);
      insertUpdateFunctionGroup(ctx, r, c, id);
    }
  }
}

function storeSheetParam(ctx) {
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  if (index == null) return;
  var file = ctx.luckysheetfile[index];
  file.config = ctx.config;
  file.luckysheet_select_save = ctx.luckysheet_select_save;
  file.luckysheet_selection_range = ctx.luckysheet_selection_range;
  file.zoomRatio = ctx.zoomRatio;
}

function storeSheetParamALL(ctx) {
  storeSheetParam(ctx);
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  if (index == null) return;
  ctx.luckysheetfile[index].config = ctx.config;
}
function changeSheet(ctx, id, isPivotInitial, isNewSheet, isCopySheet) {
  var _ctx$hooks$beforeActi, _ctx$hooks;

  if (id === ctx.currentSheetId) {
    return;
  }

  var file = ctx.luckysheetfile[getSheetIndex(ctx, id)];

  if (((_ctx$hooks$beforeActi = (_ctx$hooks = ctx.hooks).beforeActivateSheet) === null || _ctx$hooks$beforeActi === void 0 ? void 0 : _ctx$hooks$beforeActi.call(_ctx$hooks, id)) === false) {
    return;
  }

  storeSheetParamALL(ctx);
  ctx.currentSheetId = id;

  if (file.isPivotTable) {
    ctx.luckysheetcurrentisPivotTable = true;
  } else {
    ctx.luckysheetcurrentisPivotTable = false;
  }

  if (ctx.hooks.afterActivateSheet) {
    setTimeout(function () {
      var _ctx$hooks$afterActiv, _ctx$hooks2;

      (_ctx$hooks$afterActiv = (_ctx$hooks2 = ctx.hooks).afterActivateSheet) === null || _ctx$hooks$afterActiv === void 0 ? void 0 : _ctx$hooks$afterActiv.call(_ctx$hooks2, id);
    });
  }
}
function addSheet(ctx, settings) {
  var _ctx$hooks$beforeAddS, _ctx$hooks3;

  var newSheetID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var isPivotTable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sheetName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var sheetData = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

  if (ctx.allowEdit === false) {
    return;
  }

  var order = ctx.luckysheetfile.length;
  var id = newSheetID !== null && newSheetID !== void 0 ? newSheetID : settings === null || settings === void 0 ? void 0 : settings.generateSheetId();
  var sheetname = sheetName || generateRandomSheetName(ctx.luckysheetfile, isPivotTable, ctx);

  if (!_.isNil(sheetData)) {
    delete sheetData.data;
    ctx.luckysheetfile.forEach(function (sheet) {
      sheet.order = sheet.order < sheetData.order ? sheet.order : sheet.order + 1;
      return sheet;
    });
  }

  var sheetconfig = _.isNil(sheetData) ? {
    name: sheetName === undefined ? sheetname : sheetName,
    status: 0,
    order: order,
    id: id,
    row: ctx.defaultrowNum,
    column: ctx.defaultcolumnNum,
    config: {},
    pivotTable: null,
    isPivotTable: !!isPivotTable,
    zoomRatio: 1
  } : sheetData;
  if (sheetName !== undefined) sheetconfig.name = sheetName;
  if (sheetconfig.id === undefined) sheetconfig.id = v4();

  if (((_ctx$hooks$beforeAddS = (_ctx$hooks3 = ctx.hooks).beforeAddSheet) === null || _ctx$hooks$beforeAddS === void 0 ? void 0 : _ctx$hooks$beforeAddS.call(_ctx$hooks3, sheetconfig)) === false) {
    return;
  }

  ctx.luckysheetfile.push(sheetconfig);

  if (!newSheetID) {
    changeSheet(ctx, id);
  }

  if (ctx.hooks.afterAddSheet) {
    setTimeout(function () {
      var _ctx$hooks$afterAddSh, _ctx$hooks4;

      (_ctx$hooks$afterAddSh = (_ctx$hooks4 = ctx.hooks).afterAddSheet) === null || _ctx$hooks$afterAddSh === void 0 ? void 0 : _ctx$hooks$afterAddSh.call(_ctx$hooks4, sheetconfig);
    });
  }
}
function deleteSheet(ctx, id) {
  var _ctx$hooks$beforeDele, _ctx$hooks5;

  if (ctx.allowEdit === false) {
    return;
  }

  var arrIndex = getSheetIndex(ctx, id);

  if (arrIndex == null) {
    return;
  }

  if (((_ctx$hooks$beforeDele = (_ctx$hooks5 = ctx.hooks).beforeDeleteSheet) === null || _ctx$hooks$beforeDele === void 0 ? void 0 : _ctx$hooks$beforeDele.call(_ctx$hooks5, id)) === false) {
    return;
  }

  ctx.luckysheetfile = ctx.luckysheetfile.map(function (sheet) {
    sheet.order = sheet.order < ctx.luckysheetfile[arrIndex].order ? sheet.order : sheet.order - 1;
    return sheet;
  });
  ctx.luckysheetfile.splice(arrIndex, 1);

  if (id === ctx.currentSheetId) {
    var _orderSheets$;

    var shownSheets = _.cloneDeep(ctx.luckysheetfile).filter(function (singleSheet) {
      return _.isUndefined(singleSheet.hide) || singleSheet.hide !== 1;
    });

    var orderSheets = _.sortBy(shownSheets, function (sheet) {
      return sheet.order;
    });

    ctx.currentSheetId = orderSheets === null || orderSheets === void 0 ? void 0 : (_orderSheets$ = orderSheets[0]) === null || _orderSheets$ === void 0 ? void 0 : _orderSheets$.id;
  }

  if (ctx.hooks.afterDeleteSheet) {
    setTimeout(function () {
      var _ctx$hooks$afterDelet, _ctx$hooks6;

      (_ctx$hooks$afterDelet = (_ctx$hooks6 = ctx.hooks).afterDeleteSheet) === null || _ctx$hooks$afterDelet === void 0 ? void 0 : _ctx$hooks$afterDelet.call(_ctx$hooks6, id);
    });
  }
}
function updateSheet(ctx, newData) {
  newData.forEach(function (newDatum) {
    var data = newDatum.data,
        row = newDatum.row,
        column = newDatum.column;
    var index = getSheetIndex(ctx, newDatum.id);

    if (data != null) {
      var lastRowNum = data.length;
      var lastColNum = data[0].length;

      if (row != null && column != null && row > 0 && column > 0) {
        lastRowNum = Math.max(lastRowNum, row);
        lastColNum = Math.max(lastColNum, column);
      } else {
        lastRowNum = Math.max(lastRowNum, ctx.defaultrowNum);
        lastColNum = Math.max(lastColNum, ctx.defaultcolumnNum);
      }

      var expandedData = _.times(lastRowNum, function () {
        return _.times(lastColNum, function () {
          return null;
        });
      });

      for (var i = 0; i < data.length; i += 1) {
        for (var j = 0; j < data[i].length; j += 1) {
          expandedData[i][j] = data[i][j];
        }
      }

      newDatum.data = expandedData;

      if (ctx.luckysheetfile[index] == null) {
        ctx.luckysheetfile.push(newDatum);
      } else {
        ctx.luckysheetfile[index] = newDatum;
      }
    } else if (newDatum.celldata != null) {
      initSheetData(ctx, index, newDatum);
    }
  });
}
function editSheetName(ctx, editable) {
  var _ctx$hooks$beforeUpda, _ctx$hooks7;

  var index = getSheetIndex(ctx, ctx.currentSheetId);

  if (ctx.allowEdit === false) {
    if (index == null) return;
    editable.innerText = ctx.luckysheetfile[index].name;
    return;
  }

  var _locale = locale(ctx),
      sheetconfig = _locale.sheetconfig;

  var oldtxt = editable.dataset.oldText || "";
  var txt = editable.innerText;

  if (((_ctx$hooks$beforeUpda = (_ctx$hooks7 = ctx.hooks).beforeUpdateSheetName) === null || _ctx$hooks$beforeUpda === void 0 ? void 0 : _ctx$hooks$beforeUpda.call(_ctx$hooks7, ctx.currentSheetId, oldtxt, txt)) === false) {
    return;
  }

  if (txt.length === 0) {
    editable.innerText = oldtxt;
    throw new Error(sheetconfig.sheetNamecannotIsEmptyError);
  }

  if (txt.length > 31 || txt.charAt(0) === "'" || txt.charAt(txt.length - 1) === "'" || /[：:\\/？?*[\]]+/.test(txt)) {
    editable.innerText = oldtxt;
    throw new Error(sheetconfig.sheetNameSpecCharError);
  }

  if (index == null) return;

  for (var i = 0; i < ctx.luckysheetfile.length; i += 1) {
    if (index !== i && ctx.luckysheetfile[i].name === txt) {
      editable.innerText = oldtxt;
      return;
    }
  }

  ctx.luckysheetfile[index].name = txt;

  if (ctx.hooks.afterUpdateSheetName) {
    setTimeout(function () {
      var _ctx$hooks$afterUpdat, _ctx$hooks8;

      (_ctx$hooks$afterUpdat = (_ctx$hooks8 = ctx.hooks).afterUpdateSheetName) === null || _ctx$hooks$afterUpdat === void 0 ? void 0 : _ctx$hooks$afterUpdat.call(_ctx$hooks8, ctx.currentSheetId, oldtxt, txt);
    });
  }
}
function expandRowsAndColumns(data, rowsToAdd, columnsToAdd) {
  if (rowsToAdd <= 0 && columnsToAdd <= 0) {
    return data;
  }

  if (data.length + rowsToAdd >= 10000) {
    throw new Error("This action would increase the number of rows in the workbook above the limit of 10000.");
  }

  if (data[0].length + columnsToAdd >= 1000) {
    throw new Error("This action would increase the number of columns in the workbook above the limit of 1000.");
  }

  if (rowsToAdd <= 0) {
    rowsToAdd = 0;
  }

  if (columnsToAdd <= 0) {
    columnsToAdd = 0;
  }

  var currentColLen = 0;

  if (data.length > 0) {
    currentColLen = data[0].length;
  }

  for (var r = 0; r < data.length; r += 1) {
    for (var i = 0; i < columnsToAdd; i += 1) {
      data[r].push(null);
    }
  }

  for (var _r = 0; _r < rowsToAdd; _r += 1) {
    data.push(_.times(currentColLen + columnsToAdd, function () {
      return null;
    }));
  }

  return data;
}

function mergeCells(ctx, sheetId, ranges, type) {
  var idx = getSheetIndex(ctx, sheetId);
  if (idx == null) return;
  var sheet = ctx.luckysheetfile[idx];
  var cfg = sheet.config || {};

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  var d = sheet.data;

  if (type === "merge-cancel") {
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i];
      var r1 = range.row[0];
      var r2 = range.row[1];
      var c1 = range.column[0];
      var c2 = range.column[1];

      if (r1 === r2 && c1 === c2) {
        continue;
      }

      var fv = {};

      for (var r = r1; r <= r2; r += 1) {
        for (var c = c1; c <= c2; c += 1) {
          var cell = d[r][c];

          if (cell != null && cell.mc != null) {
            var mc_r = cell.mc.r;
            var mc_c = cell.mc.c;

            if ("rs" in cell.mc) {
              delete cell.mc;
              delete cfg.merge["".concat(mc_r, "_").concat(mc_c)];
              fv["".concat(mc_r, "_").concat(mc_c)] = _.cloneDeep(cell) || {};
            } else {
              var cell_clone = _.cloneDeep(fv["".concat(mc_r, "_").concat(mc_c)]);

              delete cell_clone.v;
              delete cell_clone.m;
              delete cell_clone.ct;
              delete cell_clone.f;
              delete cell_clone.spl;
              d[r][c] = cell_clone;
            }
          }
        }
      }
    }
  } else {
    var isHasMc = false;

    for (var _i = 0; _i < ranges.length; _i += 1) {
      var _range = ranges[_i];
      var _r = _range.row[0];
      var _r2 = _range.row[1];
      var _c = _range.column[0];
      var _c2 = _range.column[1];

      for (var _r3 = _r; _r3 <= _r2; _r3 += 1) {
        for (var _c3 = _c; _c3 <= _c2; _c3 += 1) {
          var _cell = d[_r3][_c3];

          if (_cell === null || _cell === void 0 ? void 0 : _cell.mc) {
            isHasMc = true;
            break;
          }
        }
      }
    }

    if (isHasMc) {
      for (var _i2 = 0; _i2 < ranges.length; _i2 += 1) {
        var _range2 = ranges[_i2];
        var _r4 = _range2.row[0];
        var _r5 = _range2.row[1];
        var _c4 = _range2.column[0];
        var _c5 = _range2.column[1];

        if (_r4 === _r5 && _c4 === _c5) {
          continue;
        }

        var _fv = {};

        for (var _r6 = _r4; _r6 <= _r5; _r6 += 1) {
          for (var _c6 = _c4; _c6 <= _c5; _c6 += 1) {
            var _cell2 = d[_r6][_c6];

            if (_cell2 != null && _cell2.mc != null) {
              var _mc_r = _cell2.mc.r;
              var _mc_c = _cell2.mc.c;

              if ("rs" in _cell2.mc) {
                delete _cell2.mc;
                delete cfg.merge["".concat(_mc_r, "_").concat(_mc_c)];
                _fv["".concat(_mc_r, "_").concat(_mc_c)] = _.cloneDeep(_cell2) || {};
              } else {
                var _cell_clone = _.cloneDeep(_fv["".concat(_mc_r, "_").concat(_mc_c)]);

                delete _cell_clone.v;
                delete _cell_clone.m;
                delete _cell_clone.ct;
                delete _cell_clone.f;
                delete _cell_clone.spl;
                d[_r6][_c6] = _cell_clone;
              }
            }
          }
        }
      }
    } else {
      for (var _i3 = 0; _i3 < ranges.length; _i3 += 1) {
        var _range3 = ranges[_i3];
        var _r7 = _range3.row[0];
        var _r8 = _range3.row[1];
        var _c7 = _range3.column[0];
        var _c8 = _range3.column[1];

        if (_r7 === _r8 && _c7 === _c8) {
          continue;
        }

        if (type === "merge-all") {
          var _fv2 = {};
          var isfirst = false;

          for (var _r9 = _r7; _r9 <= _r8; _r9 += 1) {
            for (var _c9 = _c7; _c9 <= _c8; _c9 += 1) {
              var _cell3 = d[_r9][_c9];

              if (_cell3 != null && (isInlineStringCT(_cell3.ct) || !_.isEmpty(_cell3.v) || _cell3.f != null) && !isfirst) {
                _fv2 = _.cloneDeep(_cell3) || {};
                isfirst = true;
              }

              d[_r9][_c9] = {
                mc: {
                  r: _r7,
                  c: _c7
                }
              };
            }
          }

          d[_r7][_c7] = _fv2;
          var a = d[_r7][_c7];
          if (!a) return;
          a.mc = {
            r: _r7,
            c: _c7,
            rs: _r8 - _r7 + 1,
            cs: _c8 - _c7 + 1
          };
          cfg.merge["".concat(_r7, "_").concat(_c7)] = {
            r: _r7,
            c: _c7,
            rs: _r8 - _r7 + 1,
            cs: _c8 - _c7 + 1
          };
        } else if (type === "merge-vertical") {
          for (var _c10 = _c7; _c10 <= _c8; _c10 += 1) {
            var _fv3 = {};
            var _isfirst = false;

            for (var _r10 = _r7; _r10 <= _r8; _r10 += 1) {
              var _cell4 = d[_r10][_c10];

              if (_cell4 != null && (!_.isEmpty(_cell4.v) || _cell4.f != null) && !_isfirst) {
                _fv3 = _.cloneDeep(_cell4) || {};
                _isfirst = true;
              }

              d[_r10][_c10] = {
                mc: {
                  r: _r7,
                  c: _c10
                }
              };
            }

            d[_r7][_c10] = _fv3;
            var _a = d[_r7][_c10];
            if (!_a) return;
            _a.mc = {
              r: _r7,
              c: _c10,
              rs: _r8 - _r7 + 1,
              cs: 1
            };
            cfg.merge["".concat(_r7, "_").concat(_c10)] = {
              r: _r7,
              c: _c10,
              rs: _r8 - _r7 + 1,
              cs: 1
            };
          }
        } else if (type === "merge-horizontal") {
          for (var _r11 = _r7; _r11 <= _r8; _r11 += 1) {
            var _fv4 = {};
            var _isfirst2 = false;

            for (var _c11 = _c7; _c11 <= _c8; _c11 += 1) {
              var _cell5 = d[_r11][_c11];

              if (_cell5 != null && (!_.isEmpty(_cell5.v) || _cell5.f != null) && !_isfirst2) {
                _fv4 = _.cloneDeep(_cell5) || {};
                _isfirst2 = true;
              }

              d[_r11][_c11] = {
                mc: {
                  r: _r11,
                  c: _c7
                }
              };
            }

            d[_r11][_c7] = _fv4;
            var _a2 = d[_r11][_c7];
            if (!_a2) return;
            _a2.mc = {
              r: _r11,
              c: _c7,
              rs: 1,
              cs: _c8 - _c7 + 1
            };
            cfg.merge["".concat(_r11, "_").concat(_c7)] = {
              r: _r11,
              c: _c7,
              rs: 1,
              cs: _c8 - _c7 + 1
            };
          }
        }
      }
    }
  }

  sheet.config = cfg;

  if (sheet.id === ctx.currentSheetId) {
    ctx.config = cfg;
  }
}

function runExecFunction(ctx, range, index, data) {
  ctx.formulaCache.execFunctionExist = [];

  for (var s = 0; s < range.length; s += 1) {
    for (var r = range[s].row[0]; r <= range[s].row[1]; r += 1) {
      for (var c = range[s].column[0]; c <= range[s].column[1]; c += 1) {
        ctx.formulaCache.execFunctionExist.push({
          r: r,
          c: c,
          i: index
        });
      }
    }
  }

  ctx.formulaCache.execFunctionExist.reverse();
  execFunctionGroup(ctx, null, null, null, null, data);
  ctx.formulaCache.execFunctionGlobalData = null;
}

function jfrefreshgrid(ctx, data, range) {
  var isRunExecFunction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (data == null) {
    data = getFlowdata(ctx);
  }

  if (range == null) {
    range = ctx.luckysheet_select_save;
    if (range == null) return;
  }

  if (isRunExecFunction) {
    runExecFunction(ctx, range, ctx.currentSheetId, data);
  }
}

function orderbydata(isAsc, index, data) {
  if (isAsc == null) {
    isAsc = true;
  }

  var a = function a(x, y) {
    var x1 = x[index];
    var y1 = y[index];

    if (x[index] != null) {
      x1 = x[index].v;
    }

    if (y[index] != null) {
      y1 = y[index].v;
    }

    if (isRealNull(x1)) {
      return isAsc ? 1 : -1;
    }

    if (isRealNull(y1)) {
      return isAsc ? -1 : 1;
    }

    if (isdatetime(x1) && isdatetime(y1)) {
      return diff(x1, y1);
    }

    if (isRealNum(x1) && isRealNum(y1)) {
      var y1Value = numeral(y1).value();
      var x1Value = numeral(x1).value();
      if (y1Value == null || x1Value == null) return null;
      return x1Value - y1Value;
    }

    if (!isRealNum(x1) && !isRealNum(y1)) {
      return x1.localeCompare(y1, "zh");
    }

    if (!isRealNum(x1)) {
      return 1;
    }

    if (!isRealNum(y1)) {
      return -1;
    }

    return 0;
  };

  var d = function d(x, y) {
    return a(y, x);
  };

  var sortedData = _.clone(data);

  sortedData.sort(isAsc ? a : d);
  var rowOffsets = sortedData.map(function (r, i) {
    var origIndex = _.findIndex(data, function (origR) {
      return origR === r;
    });

    return i - origIndex;
  });
  return {
    sortedData: sortedData,
    rowOffsets: rowOffsets
  };
}
function sortDataRange(ctx, sheetData, dataRange, index, isAsc, str, edr, stc, edc) {
  var _orderbydata = orderbydata(isAsc, index, dataRange),
      sortedData = _orderbydata.sortedData,
      rowOffsets = _orderbydata.rowOffsets;

  for (var r = str; r <= edr; r += 1) {
    for (var c = stc; c <= edc; c += 1) {
      var cell = sortedData[r - str][c - stc];

      if (cell === null || cell === void 0 ? void 0 : cell.f) {
        var _cell$ct;

        var moveOffset = rowOffsets[r - str];
        var func = cell === null || cell === void 0 ? void 0 : cell.f;

        if (moveOffset > 0) {
          func = "=".concat(functionCopy(ctx, func, "down", moveOffset));
        } else if (moveOffset < 0) {
          func = "=".concat(functionCopy(ctx, func, "up", -moveOffset));
        }

        var funcV = execfunction(ctx, func, r, c, undefined, undefined, true);

        var _funcV = _slicedToArray(funcV, 3);

        cell.v = _funcV[1];
        cell.f = _funcV[2];
        cell.m = update(((_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : _cell$ct.fa) || "General", cell.v);
      }

      sheetData[r][c] = cell;
    }
  }

  jfrefreshgrid(ctx, sheetData, [{
    row: [str, edr],
    column: [stc, edc]
  }]);
}
function sortSelection(ctx, isAsc) {
  var colIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (ctx.allowEdit === false) return;
  if (ctx.luckysheet_select_save == null) return;

  if (ctx.luckysheet_select_save.length > 1) {
    return;
  }

  if (isAsc == null) {
    isAsc = true;
  }

  var flowdata = getFlowdata(ctx);
  var d = flowdata;
  if (d == null) return;
  var r1 = ctx.luckysheet_select_save[0].row[0];
  var r2 = ctx.luckysheet_select_save[0].row[1];
  var c1 = ctx.luckysheet_select_save[0].column[0];
  var c2 = ctx.luckysheet_select_save[0].column[1];
  var str = null;
  var edr;

  for (var r = r1; r <= r2; r += 1) {
    if (d[r] != null && d[r][c1] != null) {
      var cell = d[r][c1];
      if (cell == null) return;

      if (cell.mc != null || isRealNull(cell.v)) {
        continue;
      }

      if (str == null && /[\u4e00-\u9fa5]+/g.test("".concat(cell.v))) {
        str = r + 1;
        edr = r + 1;
        continue;
      }

      if (str == null) {
        str = r;
      }

      edr = r;
    }
  }

  if (str == null || str > r2) {
    return;
  }

  var hasMc = false;
  var data = [];
  if (edr == null) return;

  for (var _r = str; _r <= edr; _r += 1) {
    var data_row = [];

    for (var c = c1; c <= c2; c += 1) {
      var _d$_r$c;

      if (d[_r][c] != null && ((_d$_r$c = d[_r][c]) === null || _d$_r$c === void 0 ? void 0 : _d$_r$c.mc) != null) {
        hasMc = true;
        break;
      }

      data_row.push(d[_r][c]);
    }

    data.push(data_row);
  }

  if (hasMc) {
    return;
  }

  sortDataRange(ctx, d, data, colIndex, isAsc, str, edr, c1, c2);
}

function getCellRowColumn(ctx, e, container, scrollX, scrollY) {
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return undefined;
  var scrollLeft = scrollX.scrollLeft;
  var scrollTop = scrollY.scrollTop;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight;
  x += scrollLeft;
  y += scrollTop;
  var r = rowLocation(y, ctx.visibledatarow)[2];
  var c = colLocation(x, ctx.visibledatacolumn)[2];
  var margeset = mergeBorder(ctx, flowdata, r, c);

  if (margeset) {
    var _margeset$row = _slicedToArray(margeset.row, 3);

    r = _margeset$row[2];

    var _margeset$column = _slicedToArray(margeset.column, 3);

    c = _margeset$column[2];
  }

  return {
    r: r,
    c: c
  };
}
function getCellHyperlink(ctx, r, c) {
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

  if (sheetIndex != null) {
    var _ctx$luckysheetfile$s;

    return (_ctx$luckysheetfile$s = ctx.luckysheetfile[sheetIndex].hyperlink) === null || _ctx$luckysheetfile$s === void 0 ? void 0 : _ctx$luckysheetfile$s["".concat(r, "_").concat(c)];
  }

  return undefined;
}
function saveHyperlink(ctx, r, c, linkText, linkType, linkAddress) {
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
  var flowdata = getFlowdata(ctx);

  if (sheetIndex != null && flowdata != null && linkType && linkAddress) {
    var cell = flowdata[r][c];
    if (cell == null) cell = {};

    _.set(ctx.luckysheetfile[sheetIndex], ["hyperlink", "".concat(r, "_").concat(c)], {
      linkType: linkType,
      linkAddress: linkAddress
    });

    cell.fc = "rgb(0, 0, 255)";
    cell.un = 1;
    cell.v = linkText || linkAddress;
    cell.m = linkText || linkAddress;
    cell.hl = {
      r: r,
      c: c,
      id: ctx.currentSheetId
    };
    flowdata[r][c] = cell;
    ctx.linkCard = undefined;
  }
}
function removeHyperlink(ctx, r, c) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
  var flowdata = getFlowdata(ctx);

  if (flowdata != null && sheetIndex != null) {
    var hyperlink = _.omit(ctx.luckysheetfile[sheetIndex].hyperlink, "".concat(r, "_").concat(c));

    _.set(ctx.luckysheetfile[sheetIndex], "hyperlink", hyperlink);

    var cell = flowdata[r][c];

    if (cell != null) {
      flowdata[r][c] = {
        v: cell.v,
        m: cell.m
      };
    }
  }

  ctx.linkCard = undefined;
}
function showLinkCard(ctx, r, c) {
  var _ctx$linkCard, _ctx$linkCard2, _getFlowdata, _getFlowdata$r, _ctx$linkCard3, _ctx$linkCard4, _ctx$linkCard5;

  var isEditing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isMouseDown = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if ((_ctx$linkCard = ctx.linkCard) === null || _ctx$linkCard === void 0 ? void 0 : _ctx$linkCard.selectingCellRange) return;
  if ("".concat(r, "_").concat(c) === ((_ctx$linkCard2 = ctx.linkCard) === null || _ctx$linkCard2 === void 0 ? void 0 : _ctx$linkCard2.rc)) return;
  var link = getCellHyperlink(ctx, r, c);
  var cell = (_getFlowdata = getFlowdata(ctx)) === null || _getFlowdata === void 0 ? void 0 : (_getFlowdata$r = _getFlowdata[r]) === null || _getFlowdata$r === void 0 ? void 0 : _getFlowdata$r[c];

  if (!isEditing && link == null && (isMouseDown || !((_ctx$linkCard3 = ctx.linkCard) === null || _ctx$linkCard3 === void 0 ? void 0 : _ctx$linkCard3.isEditing) || ctx.linkCard.sheetId !== ctx.currentSheetId)) {
    ctx.linkCard = undefined;
    return;
  }

  if (isEditing || link != null && (!((_ctx$linkCard4 = ctx.linkCard) === null || _ctx$linkCard4 === void 0 ? void 0 : _ctx$linkCard4.isEditing) || isMouseDown) || ((_ctx$linkCard5 = ctx.linkCard) === null || _ctx$linkCard5 === void 0 ? void 0 : _ctx$linkCard5.sheetId) !== ctx.currentSheetId) {
    var col_pre = c - 1 === -1 ? 0 : ctx.visibledatacolumn[c - 1];
    var row = ctx.visibledatarow[r];
    ctx.linkCard = {
      sheetId: ctx.currentSheetId,
      r: r,
      c: c,
      rc: "".concat(r, "_").concat(c),
      originText: (cell === null || cell === void 0 ? void 0 : cell.v) == null ? "" : "".concat(cell.v),
      originType: (link === null || link === void 0 ? void 0 : link.linkType) || "webpage",
      originAddress: (link === null || link === void 0 ? void 0 : link.linkAddress) || "",
      position: {
        cellLeft: col_pre,
        cellBottom: row
      },
      isEditing: isEditing
    };
  }
}
function goToLink(ctx, r, c, linkType, linkAddress, scrollbarX, scrollbarY) {
  var _ctx$luckysheetfile$c;

  var currSheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
  if (currSheetIndex == null) return;

  if (((_ctx$luckysheetfile$c = ctx.luckysheetfile[currSheetIndex].hyperlink) === null || _ctx$luckysheetfile$c === void 0 ? void 0 : _ctx$luckysheetfile$c["".concat(r, "_").concat(c)]) == null) {
    return;
  }

  if (linkType === "webpage") {
    if (!/^http[s]?:\/\//.test(linkAddress)) {
      linkAddress = "https://".concat(linkAddress);
    }

    window.open(linkAddress);
  } else if (linkType === "sheet") {
    var sheetId;

    _.forEach(ctx.luckysheetfile, function (f) {
      if (linkAddress === f.name) {
        sheetId = f.id;
      }
    });

    if (sheetId != null) changeSheet(ctx, sheetId);
  } else {
    var range = _.cloneDeep(getcellrange(ctx, linkAddress));

    if (range == null) return;
    var row_pre = range.row[0] - 1 === -1 ? 0 : ctx.visibledatarow[range.row[0] - 1];
    var col_pre = range.column[0] - 1 === -1 ? 0 : ctx.visibledatacolumn[range.column[0] - 1];
    scrollbarX.scrollLeft = col_pre;
    scrollbarY.scrollLeft = row_pre;
    ctx.luckysheet_select_save = normalizeSelection(ctx, [range]);
    changeSheet(ctx, range.sheetId);
  }

  ctx.linkCard = undefined;
}
function isLinkValid(ctx, linkType, linkAddress) {
  if (!linkAddress) return {
    isValid: false,
    tooltip: ""
  };

  var _locale = locale(ctx),
      insertLink = _locale.insertLink;

  if (linkType === "webpage") {
    if (!/^http[s]?:\/\//.test(linkAddress)) {
      linkAddress = "https://".concat(linkAddress);
    }

    if (!/^http[s]?:\/\/([\w\-\.]+)+[\w-]*([\w\-\.\/\?%&=]+)?$/gi.test(linkAddress)) return {
      isValid: false,
      tooltip: insertLink.tooltipInfo1
    };
  }

  if (linkType === "cellrange" && !iscelldata(linkAddress)) {
    return {
      isValid: false,
      tooltip: insertLink.invalidCellRangeTip
    };
  }

  return {
    isValid: true,
    tooltip: ""
  };
}
function onRangeSelectionModalMoveStart(ctx, globalCache, e) {
  var box = document.querySelector("div.fortune-link-modify-modal.range-selection-modal");
  if (!box) return;

  var _box$getBoundingClien = box.getBoundingClientRect(),
      width = _box$getBoundingClien.width,
      height = _box$getBoundingClien.height;

  var left = box.offsetLeft;
  var top = box.offsetTop;
  var initialPosition = {
    left: left,
    top: top,
    width: width,
    height: height
  };

  _.set(globalCache, "linkCard.rangeSelectionModal", {
    cursorMoveStartPosition: {
      x: e.pageX,
      y: e.pageY
    },
    initialPosition: initialPosition
  });
}
function onRangeSelectionModalMove(globalCache, e) {
  var _globalCache$linkCard;

  var moveProps = (_globalCache$linkCard = globalCache.linkCard) === null || _globalCache$linkCard === void 0 ? void 0 : _globalCache$linkCard.rangeSelectionModal;
  if (moveProps == null) return;
  var modal = document.querySelector("div.fortune-link-modify-modal.range-selection-modal");
  var _moveProps$cursorMove = moveProps.cursorMoveStartPosition,
      startX = _moveProps$cursorMove.x,
      startY = _moveProps$cursorMove.y;
  var _moveProps$initialPos = moveProps.initialPosition,
      top = _moveProps$initialPos.top,
      left = _moveProps$initialPos.left;
  left += e.pageX - startX;
  top += e.pageY - startY;
  if (top < 0) top = 0;
  modal.style.left = "".concat(left, "px");
  modal.style.top = "".concat(top, "px");
}
function onRangeSelectionModalMoveEnd(globalCache) {
  _.set(globalCache, "linkCard.rangeSelectionModal", undefined);
}

function cfSplitRange(range1, range2, range3, type) {
  var range = [];
  var offset_r = range3.row[0] - range2.row[0];
  var offset_c = range3.column[0] - range2.column[0];
  var r1 = range1.row[0];
  var r2 = range1.row[1];
  var c1 = range1.column[0];
  var c2 = range1.column[1];

  if (r1 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 >= range2.column[0] && c1 <= range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (c2 >= range2.column[0] && c2 <= range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r1 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 >= range2.row[0] && r1 <= range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r2 >= range2.row[0] && r2 <= range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 >= range2.column[0] && c1 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [c1 + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c2 >= range2.column[0] && c2 <= range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, c2 + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r1 >= range2.row[0] && r1 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [r1, range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [r1 + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (c1 < range2.column[0] && c2 > range2.column[1] && r2 >= range2.row[0] && r2 <= range2.row[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], r2],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], r2],
        column: [range2.column[1] + 1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, r2 + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else if (r1 < range2.row[0] && r2 > range2.row[1] && c1 < range2.column[0] && c2 > range2.column[1]) {
    if (type === "allPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }, {
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, range2.row[0] - 1],
        column: [c1, c2]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [c1, range2.column[0] - 1]
      }, {
        row: [range2.row[0], range2.row[1]],
        column: [range2.column[1] + 1, c2]
      }, {
        row: [range2.row[1] + 1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [{
        row: [range2.row[0] + offset_r, range2.row[1] + offset_r],
        column: [range2.column[0] + offset_c, range2.column[1] + offset_c]
      }];
    }
  } else {
    if (type === "allPart") {
      range = [{
        row: [r1, r2],
        column: [c1, c2]
      }];
    } else if (type === "restPart") {
      range = [{
        row: [r1, r2],
        column: [c1, c2]
      }];
    } else if (type === "operatePart") {
      range = [];
    }
  }

  return range;
}

function updateFormatCell(ctx, d, attr, foucsStatus, row_st, row_ed, col_st, col_ed, canvas) {
  if (_.isNil(d) || _.isNil(attr)) {
    return;
  }

  if (attr === "ct") {
    for (var r = row_st; r <= row_ed; r += 1) {
      if (!_.isNil(ctx.config.rowhidden) && !_.isNil(ctx.config.rowhidden[r])) {
        continue;
      }

      for (var c = col_st; c <= col_ed; c += 1) {
        var cell = d[r][c];
        var value = void 0;

        if (_.isPlainObject(cell)) {
          value = cell === null || cell === void 0 ? void 0 : cell.v;
        } else {
          value = cell;
        }

        if (foucsStatus !== "@" && isRealNum(value)) {
          value = Number(value);
        }

        var mask = update(foucsStatus, value);
        var type = "n";

        if (is_date(foucsStatus) || foucsStatus === 14 || foucsStatus === 15 || foucsStatus === 16 || foucsStatus === 17 || foucsStatus === 18 || foucsStatus === 19 || foucsStatus === 20 || foucsStatus === 21 || foucsStatus === 22 || foucsStatus === 45 || foucsStatus === 46 || foucsStatus === 47) {
          type = "d";
        } else if (foucsStatus === "@" || foucsStatus === 49) {
          type = "s";
        } else if (foucsStatus === "General" || foucsStatus === 0) {
          type = isRealNum(value) ? "n" : "g";
        }

        if (cell && _.isPlainObject(cell)) {
          cell.m = "".concat(mask);

          if (_.isNil(cell.ct)) {
            cell.ct = {};
          }

          cell.ct.fa = foucsStatus;
          cell.ct.t = type;
        } else {
          d[r][c] = {
            ct: {
              fa: foucsStatus,
              t: type
            },
            v: value,
            m: mask
          };
        }
      }
    }
  } else {
    if (attr === "ht") {
      if (foucsStatus === "left") {
        foucsStatus = "1";
      } else if (foucsStatus === "center") {
        foucsStatus = "0";
      } else if (foucsStatus === "right") {
        foucsStatus = "2";
      }
    } else if (attr === "vt") {
      if (foucsStatus === "top") {
        foucsStatus = "1";
      } else if (foucsStatus === "middle") {
        foucsStatus = "0";
      } else if (foucsStatus === "bottom") {
        foucsStatus = "2";
      }
    } else if (attr === "tb") {
      if (foucsStatus === "overflow") {
        foucsStatus = "1";
      } else if (foucsStatus === "clip") {
        foucsStatus = "0";
      } else if (foucsStatus === "wrap") {
        foucsStatus = "2";
      }
    } else if (attr === "tr") {
      if (foucsStatus === "none") {
        foucsStatus = "0";
      } else if (foucsStatus === "angleup") {
        foucsStatus = "1";
      } else if (foucsStatus === "angledown") {
        foucsStatus = "2";
      } else if (foucsStatus === "vertical") {
        foucsStatus = "3";
      } else if (foucsStatus === "rotation-up") {
        foucsStatus = "4";
      } else if (foucsStatus === "rotation-down") {
        foucsStatus = "5";
      }
    }

    var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

    if (sheetIndex == null) {
      return;
    }

    for (var _r = row_st; _r <= row_ed; _r += 1) {
      if (!_.isNil(ctx.config.rowhidden) && !_.isNil(ctx.config.rowhidden[_r])) {
        continue;
      }

      for (var _c = col_st; _c <= col_ed; _c += 1) {
        var _value = d[_r][_c];

        if (_value && _.isPlainObject(_value)) {
          var _ctx$luckysheetfile$s, _cfg$columnlen;

          updateInlineStringFormatOutside(_value, attr, foucsStatus);
          _value[attr] = foucsStatus;
          (_ctx$luckysheetfile$s = ctx.luckysheetfile[sheetIndex]).config || (_ctx$luckysheetfile$s.config = {});
          var cfg = ctx.luckysheetfile[sheetIndex].config;
          var cellWidth = ((_cfg$columnlen = cfg.columnlen) === null || _cfg$columnlen === void 0 ? void 0 : _cfg$columnlen[_c]) || ctx.luckysheetfile[sheetIndex].defaultColWidth;

          if (attr === "fs" && canvas) {
            var _cfg$rowlen;

            var textInfo = getCellTextInfo(d[_r][_c], canvas, ctx, {
              r: _r,
              c: _c,
              cellWidth: cellWidth
            });
            if (!textInfo) continue;

            var rowHeight = _.round(textInfo.textHeightAll);

            var currentRowHeight = ((_cfg$rowlen = cfg.rowlen) === null || _cfg$rowlen === void 0 ? void 0 : _cfg$rowlen[_r]) || ctx.luckysheetfile[sheetIndex].defaultRowHeight || 19;

            if (!_.isUndefined(rowHeight) && rowHeight > currentRowHeight && (!cfg.customHeight || cfg.customHeight[_r] !== 1)) {
              if (_.isUndefined(cfg.rowlen)) cfg.rowlen = {};

              _.set(cfg, "rowlen.".concat(_r), rowHeight);
            }
          }
        } else {
          d[_r][_c] = {
            v: _value
          };
          d[_r][_c][attr] = foucsStatus;
        }
      }
    }
  }
}
function updateFormat(ctx, $input, d, attr, foucsStatus, canvas) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (attr in inlineStyleAffectAttribute) {
    if (ctx.luckysheetCellUpdate.length > 0) {
      var value = $input.innerText;

      if (value.substring(0, 1) !== "=") {
        var cell = d[ctx.luckysheetCellUpdate[0]][ctx.luckysheetCellUpdate[1]];

        if (cell) {
          updateInlineStringFormat(ctx, cell, attr, foucsStatus, $input);
        }

        return;
      }
    }
  }

  var cfg = _.cloneDeep(ctx.config);

  if (_.isNil(cfg.rowlen)) {
    cfg.rowlen = {};
  }

  _.forEach(ctx.luckysheet_select_save, function (selection) {
    var _selection$row = _slicedToArray(selection.row, 2),
        row_st = _selection$row[0],
        row_ed = _selection$row[1];

    var _selection$column = _slicedToArray(selection.column, 2),
        col_st = _selection$column[0],
        col_ed = _selection$column[1];

    updateFormatCell(ctx, d, attr, foucsStatus, row_st, row_ed, col_st, col_ed, canvas);
  });
}

function toggleAttr(ctx, cellInput, attr) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var flag = isAllSelectedCellsInStatus(ctx, attr, 1);
  var foucsStatus = flag ? 0 : 1;
  updateFormat(ctx, cellInput, flowdata, attr, foucsStatus);
}

function setAttr(ctx, cellInput, attr, value, canvas) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  updateFormat(ctx, cellInput, flowdata, attr, value, canvas);
}

function checkNoNullValue(cell) {
  var v = cell;

  if (_.isPlainObject(v)) {
    v = v.v;
  }

  if (!isRealNull(v) && isdatatypemulti(v).num && (cell.ct == null || cell.ct.t == null || cell.ct.t === "n" || cell.ct.t === "g")) {
    return true;
  }

  return false;
}

function checkNoNullValueAll(cell) {
  var v = cell;

  if (_.isPlainObject(v)) {
    v = v.v;
  }

  if (!isRealNull(v)) {
    return true;
  }

  return false;
}

function getNoNullValue(d, st_x, ed, type) {
  var hasValueStart = null;
  var nullNum = 0;
  var nullTime = 0;

  for (var r = ed - 1; r >= 0; r -= 1) {
    var cell = void 0;

    if (type === "c") {
      cell = d[st_x][r];
    } else {
      cell = d[r][st_x];
    }

    if (checkNoNullValue(cell)) {
      hasValueStart = r;
    } else if (cell == null || cell.v == null || cell.v === "") {
      nullNum += 1;

      if (nullNum >= 40) {
        if (nullTime <= 0) {
          nullTime = 1;
        } else {
          break;
        }
      }
    } else {
      break;
    }
  }

  return hasValueStart;
}

function activeFormulaInput(cellInput, fxInput, ctx, row_index, col_index, rowh, columnh, formula, cache, isnull) {
  if (isnull == null) {
    isnull = false;
  }

  ctx.luckysheetCellUpdate = [row_index, col_index];
  cache.doNotUpdateCell = true;

  if (isnull) {
    var _formulaTxt = "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(formula.toUpperCase(), "</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">(</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">)</span>");

    cellInput.innerHTML = _formulaTxt;
    var spanList = cellInput.querySelectorAll("span");
    setCaretPosition(ctx, spanList[spanList.length - 2], 0, 1);
    return;
  }

  var row_pre = rowLocationByIndex(rowh[0], ctx.visibledatarow)[0];
  var row = rowLocationByIndex(rowh[1], ctx.visibledatarow)[1];
  var col_pre = colLocationByIndex(columnh[0], ctx.visibledatacolumn)[0];
  var col = colLocationByIndex(columnh[1], ctx.visibledatacolumn)[1];
  var formulaTxt = "<span dir=\"auto\" class=\"luckysheet-formula-text-color\">=</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">".concat(formula.toUpperCase(), "</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">(</span><span class=\"fortune-formula-functionrange-cell\" rangeindex=\"0\" dir=\"auto\" style=\"color:").concat(colors[0], ";\">").concat(getRangetxt(ctx, ctx.currentSheetId, {
    row: rowh,
    column: columnh
  }, ctx.currentSheetId), "</span><span dir=\"auto\" class=\"luckysheet-formula-text-color\">)</span>");
  cellInput.innerHTML = formulaTxt;
  israngeseleciton(ctx);
  ctx.formulaCache.rangestart = true;
  ctx.formulaCache.rangedrag_column_start = false;
  ctx.formulaCache.rangedrag_row_start = false;
  ctx.formulaCache.rangechangeindex = 0;
  rangeSetValue(ctx, cellInput, {
    row: rowh,
    column: columnh
  }, fxInput);
  ctx.formulaCache.func_selectedrange = {
    left: col_pre,
    width: col - col_pre - 1,
    top: row_pre,
    height: row - row_pre - 1,
    left_move: col_pre,
    width_move: col - col_pre - 1,
    top_move: row_pre,
    height_move: row - row_pre - 1,
    row: [row_index, row_index],
    column: [col_index, col_index]
  };
  createFormulaRangeSelect(ctx, {
    rangeIndex: ctx.formulaCache.rangeIndex || 0,
    left: col_pre,
    width: col - col_pre - 1,
    top: row_pre,
    height: row - row_pre - 1
  });
}

function backFormulaInput(d, r, c, rowh, columnh, formula, ctx) {
  var _ctx$formulaCache;

  var f = "=".concat(formula.toUpperCase(), "(").concat(getRangetxt(ctx, ctx.currentSheetId, {
    row: rowh,
    column: columnh
  }, ctx.currentSheetId), ")");
  var v = execfunction(ctx, f, r, c);
  var value = {
    v: v[1],
    f: v[2]
  };
  setCellValue(ctx, r, c, d, value);
  (_ctx$formulaCache = ctx.formulaCache).execFunctionExist || (_ctx$formulaCache.execFunctionExist = []);
  ctx.formulaCache.execFunctionExist.push({
    r: r,
    c: c,
    i: ctx.currentSheetId
  });
}

function singleFormulaInput(cellInput, fxInput, ctx, d, _index, fix, st_m, ed_m, formula, type, cache, noNum, noNull) {
  if (type == null) {
    type = "r";
  }

  if (noNum == null) {
    noNum = true;
  }

  if (noNull == null) {
    noNull = true;
  }

  var isNull = true;
  var isNum = false;

  for (var c = st_m; c <= ed_m; c += 1) {
    var cell = null;

    if (type === "c") {
      cell = d[c][fix];
    } else {
      cell = d[fix][c];
    }

    if (checkNoNullValue(cell)) {
      isNull = false;
      isNum = true;
    } else if (checkNoNullValueAll(cell)) {
      isNull = false;
    }
  }

  if (isNull && noNull) {
    var st_r_r = getNoNullValue(d, _index, fix, type);

    if (st_r_r == null) {
      if (type === "c") {
        activeFormulaInput(cellInput, fxInput, ctx, _index, fix, null, null, formula, cache, true);
      } else {
        activeFormulaInput(cellInput, fxInput, ctx, fix, _index, null, null, formula, cache, true);
      }
    } else {
      if (_index === st_m) {
        for (var _c2 = st_m; _c2 <= ed_m; _c2 += 1) {
          st_r_r = getNoNullValue(d, _c2, fix, type);

          if (st_r_r == null) {
            break;
          }

          if (type === "c") {
            backFormulaInput(d, _c2, fix, [_c2, _c2], [st_r_r, fix - 1], formula, ctx);
          } else {
            backFormulaInput(d, fix, _c2, [st_r_r, fix - 1], [_c2, _c2], formula, ctx);
          }
        }
      } else {
        for (var _c3 = ed_m; _c3 >= st_m; _c3 -= 1) {
          st_r_r = getNoNullValue(d, _c3, fix, type);

          if (st_r_r == null) {
            break;
          }

          if (type === "c") {
            backFormulaInput(d, _c3, fix, [_c3, _c3], [st_r_r, fix - 1], formula, ctx);
          } else {
            backFormulaInput(d, fix, _c3, [st_r_r, fix - 1], [_c3, _c3], formula, ctx);
          }
        }
      }
    }

    return false;
  }

  if (isNum && noNum) {
    var _cell = null;

    if (type === "c") {
      _cell = d[ed_m + 1][fix];
    } else {
      _cell = d[fix][ed_m + 1];
    }

    if (_cell != null && _cell.v != null && _cell.v.toString().length > 0) {
      var _c4 = ed_m + 1;

      if (type === "c") {
        _cell = d[ed_m + 1][fix];
      } else {
        _cell = d[fix][ed_m + 1];
      }

      while (_cell != null && _cell.v != null && _cell.v.toString().length > 0) {
        _c4 += 1;
        var len = null;

        if (type === "c") {
          len = d.length;
        } else {
          len = d[0].length;
        }

        if (_c4 >= len) {
          return false;
        }

        if (type === "c") {
          _cell = d[_c4][fix];
        } else {
          _cell = d[fix][_c4];
        }
      }

      if (type === "c") {
        backFormulaInput(d, _c4, fix, [st_m, ed_m], [fix, fix], formula, ctx);
      } else {
        backFormulaInput(d, fix, _c4, [fix, fix], [st_m, ed_m], formula, ctx);
      }
    } else {
      if (type === "c") {
        backFormulaInput(d, ed_m + 1, fix, [st_m, ed_m], [fix, fix], formula, ctx);
      } else {
        backFormulaInput(d, fix, ed_m + 1, [fix, fix], [st_m, ed_m], formula, ctx);
      }
    }

    return false;
  }

  return true;
}

function autoSelectionFormula(ctx, cellInput, fxInput, formula, cache) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return;
  var isfalse = true;
  ctx.formulaCache.execFunctionExist = [];

  function execFormulaInput_c(d, st_r, ed_r, st_c, ed_c, _formula) {
    var st_c_c = getNoNullValue(d, st_r, ed_c, "c");

    if (st_c_c == null) {
      activeFormulaInput(cellInput, fxInput, ctx, st_r, st_c, null, null, _formula, cache, true);
    } else {
      activeFormulaInput(cellInput, fxInput, ctx, st_r, st_c, [st_r, ed_r], [st_c_c, ed_c - 1], _formula, cache);
    }
  }

  function execFormulaInput(d, st_r, ed_r, st_c, ed_c, _formula) {
    var st_r_c = getNoNullValue(d, st_c, ed_r, "r");

    if (st_r_c == null) {
      execFormulaInput_c(d, st_r, ed_r, st_c, ed_c, _formula);
    } else {
      activeFormulaInput(cellInput, fxInput, ctx, st_r, st_c, [st_r_c, ed_r - 1], [st_c, ed_c], _formula, cache);
    }
  }

  if (!ctx.luckysheet_select_save) return;

  _.forEach(ctx.luckysheet_select_save, function (selection) {
    var _selection$row2 = _slicedToArray(selection.row, 2),
        st_r = _selection$row2[0],
        ed_r = _selection$row2[1];

    var _selection$column2 = _slicedToArray(selection.column, 2),
        st_c = _selection$column2[0],
        ed_c = _selection$column2[1];

    var row_index = selection.row_focus;
    var col_index = selection.column_focus;

    if (st_r === ed_r && st_c === ed_c) {
      if (ed_r - 1 < 0 && ed_c - 1 < 0) {
        activeFormulaInput(cellInput, fxInput, ctx, st_r, st_c, null, null, formula, cache, true);
        return;
      }

      if (ed_r - 1 >= 0 && checkNoNullValue(flowdata[ed_r - 1][st_c])) {
        execFormulaInput(flowdata, st_r, ed_r, st_c, ed_c, formula);
      } else if (ed_c - 1 >= 0 && checkNoNullValue(flowdata[st_r][ed_c - 1])) {
        execFormulaInput_c(flowdata, st_r, ed_r, st_c, ed_c, formula);
      } else {
        execFormulaInput(flowdata, st_r, ed_r, st_c, ed_c, formula);
      }
    } else if (st_r === ed_r) {
      isfalse = singleFormulaInput(cellInput, fxInput, ctx, flowdata, col_index, st_r, st_c, ed_c, formula, "r", cache);
    } else if (st_c === ed_c) {
      isfalse = singleFormulaInput(cellInput, fxInput, ctx, flowdata, row_index, st_c, st_r, ed_r, formula, "c", cache);
    } else {
      var r_false = true;

      for (var r = st_r; r <= ed_r; r += 1) {
        r_false = singleFormulaInput(cellInput, fxInput, ctx, flowdata, col_index, r, st_c, ed_c, formula, "r", cache, true, false) && r_false;
      }

      var c_false = true;

      for (var c = st_c; c <= ed_c; c += 1) {
        c_false = singleFormulaInput(cellInput, fxInput, ctx, flowdata, row_index, c, st_r, ed_r, formula, "c", cache, true, false) && c_false;
      }

      isfalse = !!r_false && !!c_false;
    }

    isfalse = isfalse && isfalse;
  });

  if (!isfalse) {
    ctx.formulaCache.execFunctionExist.reverse();
    execFunctionGroup(ctx, null, null, null, null, flowdata);
    ctx.formulaCache.execFunctionGlobalData = null;
  }
}
function cancelPaintModel(ctx) {
  var _ctx$luckysheet_copy_;

  if (ctx.luckysheet_copy_save === null) return;

  if (((_ctx$luckysheet_copy_ = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_ === void 0 ? void 0 : _ctx$luckysheet_copy_.dataSheetId) === ctx.currentSheetId) {
    ctx.luckysheet_selection_range = [];
    selectionCopyShow(ctx.luckysheet_selection_range, ctx);
  } else {
    if (!ctx.luckysheet_copy_save) return;
    var index = getSheetIndex(ctx, ctx.luckysheet_copy_save.dataSheetId);
    if (!index) return;
    ctx.luckysheetfile[index].luckysheet_selection_range = [];
  }

  ctx.luckysheet_copy_save = {
    dataSheetId: "",
    copyRange: [{
      row: [0],
      column: [0]
    }],
    RowlChange: false,
    HasMC: false
  };
  ctx.luckysheetPaintModelOn = false;
}
function handleCurrencyFormat(ctx, cellInput) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var currency = ctx.currency || "¥";
  updateFormat(ctx, cellInput, flowdata, "ct", "".concat(currency, " #.00"));
}
function handlePercentageFormat(ctx, cellInput) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  updateFormat(ctx, cellInput, flowdata, "ct", "0.00%");
}
function handleNumberDecrease(ctx, cellInput) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata || !ctx.luckysheet_select_save) return;
  var row_index = ctx.luckysheet_select_save[0].row_focus;
  var col_index = ctx.luckysheet_select_save[0].column_focus;
  if (row_index === undefined || col_index === undefined) return;
  var foucsStatus = normalizedAttr(flowdata, row_index, col_index, "ct");
  var cell = flowdata[row_index][col_index];

  if (foucsStatus == null || foucsStatus.t !== "n") {
    return;
  }

  if (foucsStatus.fa === "General") {
    if (!cell || !cell.v) return;
    var mask = genarate(cell.v);
    if (!mask || mask.length < 2) return;

    var _mask = _slicedToArray(mask, 2);

    foucsStatus = _mask[1];
  }

  var reg = /^(w|W)((0?)|(0\.0+))$/;

  if (reg.test(foucsStatus.fa)) {
    if (foucsStatus.fa.indexOf(".") > -1) {
      if (foucsStatus.fa.substr(-2) === ".0") {
        updateFormat(ctx, cellInput, flowdata, "ct", foucsStatus.fa.split(".")[0]);
      } else {
        updateFormat(ctx, cellInput, flowdata, "ct", foucsStatus.fa.substr(0, foucsStatus.fa.length - 1));
      }
    } else {
      updateFormat(ctx, cellInput, flowdata, "ct", foucsStatus.fa);
    }

    return;
  }

  var prefix = "";
  var main = "";
  var fa = [];

  if (foucsStatus.fa.indexOf(".") > -1) {
    fa = foucsStatus.fa.split(".");
    var _fa = fa;

    var _fa2 = _slicedToArray(_fa, 2);

    prefix = _fa2[0];
    main = _fa2[1];
  } else {
    return;
  }

  fa = main.split("");
  var tail = "";

  for (var i = fa.length - 1; i >= 0; i -= 1) {
    var c = fa[i];

    if (c !== "#" && c !== "0" && c !== "," && Number.isNaN(parseInt(c, 10))) {
      tail = c + tail;
    } else {
      break;
    }
  }

  var fmt = "";

  if (foucsStatus.fa.indexOf(".") > -1) {
    var suffix = main;

    if (tail.length > 0) {
      suffix = main.replace(tail, "");
    }

    var pos = suffix.replace(/#/g, "0");
    pos = pos.substr(0, pos.length - 1);

    if (pos === "") {
      fmt = prefix + tail;
    } else {
      fmt = "".concat(prefix, ".").concat(pos).concat(tail);
    }
  }

  updateFormat(ctx, cellInput, flowdata, "ct", fmt);
}
function handleNumberIncrease(ctx, cellInput) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  if (!ctx.luckysheet_select_save) return;
  var row_index = ctx.luckysheet_select_save[0].row_focus;
  var col_index = ctx.luckysheet_select_save[0].column_focus;
  if (row_index === undefined || col_index === undefined) return;
  var foucsStatus = normalizedAttr(flowdata, row_index, col_index, "ct");
  var cell = flowdata[row_index][col_index];

  if (foucsStatus == null || foucsStatus.t !== "n") {
    return;
  }

  if (foucsStatus.fa === "General") {
    if (!cell || !cell.v) return;
    var mask = genarate(cell.v);
    if (!mask || mask.length < 2) return;

    var _mask2 = _slicedToArray(mask, 2);

    foucsStatus = _mask2[1];
  }

  if (foucsStatus.fa === "General") {
    updateFormat(ctx, cellInput, flowdata, "ct", "#.0");
    return;
  }

  var reg = /^(w|W)((0?)|(0\.0+))$/;

  if (reg.test(foucsStatus.fa)) {
    if (foucsStatus.fa.indexOf(".") > -1) {
      updateFormat(ctx, cellInput, flowdata, "ct", "".concat(foucsStatus.fa, "0"));
    } else {
      if (foucsStatus.fa.substr(-1) === "0") {
        updateFormat(ctx, cellInput, flowdata, "ct", "".concat(foucsStatus.fa, ".0"));
      } else {
        updateFormat(ctx, cellInput, flowdata, "ct", "".concat(foucsStatus.fa, "0.0"));
      }
    }

    return;
  }

  var prefix = "";
  var main = "";
  var fa = [];

  if (foucsStatus.fa.indexOf(".") > -1) {
    fa = foucsStatus.fa.split(".");
    var _fa3 = fa;

    var _fa4 = _slicedToArray(_fa3, 2);

    prefix = _fa4[0];
    main = _fa4[1];
  } else {
    main = foucsStatus.fa;
  }

  fa = main.split("");
  var tail = "";

  for (var i = fa.length - 1; i >= 0; i -= 1) {
    var c = fa[i];

    if (c !== "#" && c !== "0" && c !== "," && Number.isNaN(parseInt(c, 10))) {
      tail = c + tail;
    } else {
      break;
    }
  }

  var fmt = "";

  if (foucsStatus.fa.indexOf(".") > -1) {
    var suffix = main;

    if (tail.length > 0) {
      suffix = main.replace(tail, "");
    }

    var pos = suffix.replace(/#/g, "0");
    pos += "0";
    fmt = "".concat(prefix, ".").concat(pos).concat(tail);
  } else {
    if (tail.length > 0) {
      fmt = "".concat(main.replace(tail, ""), ".0").concat(tail);
    } else {
      fmt = "".concat(main, ".0").concat(tail);
    }
  }

  updateFormat(ctx, cellInput, flowdata, "ct", fmt);
}
function handleBold(ctx, cellInput) {
  toggleAttr(ctx, cellInput, "bl");
}
function handleItalic(ctx, cellInput) {
  toggleAttr(ctx, cellInput, "it");
}
function handleStrikeThrough(ctx, cellInput) {
  toggleAttr(ctx, cellInput, "cl");
}
function handleUnderline(ctx, cellInput) {
  toggleAttr(ctx, cellInput, "un");
}
function handleHorizontalAlign(ctx, cellInput, value) {
  setAttr(ctx, cellInput, "ht", value);
}
function handleVerticalAlign(ctx, cellInput, value) {
  setAttr(ctx, cellInput, "vt", value);
}
function handleFormatPainter(ctx) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (ctx.luckysheet_select_save == null || ctx.luckysheet_select_save.length === 0) {
    return;
  }

  if (ctx.luckysheet_select_save.length > 1) {
    return;
  }

  var has_PartMC = false;
  var r1 = ctx.luckysheet_select_save[0].row[0];
  var r2 = ctx.luckysheet_select_save[0].row[1];
  var c1 = ctx.luckysheet_select_save[0].column[0];
  var c2 = ctx.luckysheet_select_save[0].column[1];
  has_PartMC = hasPartMC(ctx, ctx.config, r1, r2, c1, c2);

  if (has_PartMC) {
    return;
  }

  cancelPaintModel(ctx);
  ctx.luckysheet_selection_range = [{
    row: ctx.luckysheet_select_save[0].row,
    column: ctx.luckysheet_select_save[0].column
  }];
  selectionCopyShow(ctx.luckysheet_selection_range, ctx);
  var RowlChange = false;
  var HasMC = false;

  for (var r = ctx.luckysheet_select_save[0].row[0]; r <= ctx.luckysheet_select_save[0].row[1]; r += 1) {
    if (ctx.config.rowhidden != null && ctx.config.rowhidden[r] != null) {
      continue;
    }

    if (ctx.config.rowlen != null && r in ctx.config.rowlen) {
      RowlChange = true;
    }

    for (var c = ctx.luckysheet_select_save[0].column[0]; c <= ctx.luckysheet_select_save[0].column[1]; c += 1) {
      var flowdata = getFlowdata(ctx);
      if (!flowdata) return;
      var cell = flowdata[r][c];

      if (cell != null && cell.mc != null && cell.mc.rs != null) {
        HasMC = true;
      }
    }
  }

  ctx.luckysheet_copy_save = {
    dataSheetId: ctx.currentSheetId,
    copyRange: [{
      row: ctx.luckysheet_select_save[0].row,
      column: ctx.luckysheet_select_save[0].column
    }],
    RowlChange: RowlChange,
    HasMC: HasMC
  };
  ctx.luckysheetPaintModelOn = true;
  ctx.luckysheetPaintSingle = true;
}
function handleClearFormat(ctx) {
  var _ctx$luckysheet_selec;

  if (ctx.allowEdit === false) return;
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec.every(function (selection) {
    var _selection$row3 = _slicedToArray(selection.row, 2),
        rowSt = _selection$row3[0],
        rowEd = _selection$row3[1];

    var _selection$column3 = _slicedToArray(selection.column, 2),
        colSt = _selection$column3[0],
        colEd = _selection$column3[1];

    for (var r = rowSt; r <= rowEd; r += 1) {
      if (!_.isNil(ctx.config.rowhidden) && !_.isNil(ctx.config.rowhidden[r])) {
        continue;
      }

      for (var c = colSt; c <= colEd; c += 1) {
        var cell = flowdata[r][c];
        if (!cell) continue;
        flowdata[r][c] = _.pick(cell, "v", "m", "mc", "f", "ct");
      }
    }

    var index = getSheetIndex(ctx, ctx.currentSheetId);
    if (index == null) return false;
    if (ctx.config.borderInfo == null) return false;
    var cfg = ctx.config || {};

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var source_borderInfo = [];

      for (var i = 0; i < cfg.borderInfo.length; i += 1) {
        var bd_rangeType = cfg.borderInfo[i].rangeType;

        if (bd_rangeType === "range" && cfg.borderInfo[i].borderType !== "border-slash") {
          var bd_range = cfg.borderInfo[i].range;
          var bd_emptyRange = [];

          for (var j = 0; j < bd_range.length; j += 1) {
            bd_emptyRange = bd_emptyRange.concat(cfSplitRange(bd_range[j], {
              row: [rowSt, rowEd],
              column: [colSt, colEd]
            }, {
              row: [rowSt, rowEd],
              column: [colSt, colEd]
            }, "restPart"));
          }

          cfg.borderInfo[i].range = bd_emptyRange;
          source_borderInfo.push(cfg.borderInfo[i]);
        } else if (bd_rangeType === "cell") {
          var bd_r = cfg.borderInfo[i].value.row_index;
          var bd_c = cfg.borderInfo[i].value.col_index;

          if (!(bd_r >= rowSt && bd_r <= rowEd && bd_c >= colSt && bd_c <= colEd)) {
            source_borderInfo.push(cfg.borderInfo[i]);
          }
        } else if (bd_rangeType === "range" && cfg.borderInfo[i].borderType === "border-slash" && !(cfg.borderInfo[i].range[0].row[0] >= rowSt && cfg.borderInfo[i].range[0].row[0] <= rowEd && cfg.borderInfo[i].range[0].column[0] >= colSt && cfg.borderInfo[i].range[0].column[0] <= colEd)) {
          source_borderInfo.push(cfg.borderInfo[i]);
        }
      }

      ctx.luckysheetfile[index].config.borderInfo = source_borderInfo;
    }

    return true;
  });
}
function handleTextColor(ctx, cellInput, color) {
  setAttr(ctx, cellInput, "fc", color);
}
function handleTextBackground(ctx, cellInput, color) {
  setAttr(ctx, cellInput, "bg", color);
}
function handleBorder(ctx, type, borderColor, borderStyle) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (type == null) {
    type = "border-all";
  }

  var color = borderColor;
  var style = borderStyle;

  if (color == null || color === "") {
    color = "#000";
  }

  if (style == null || style === "") {
    style = "1";
  }

  var cfg = ctx.config;

  if (cfg.borderInfo == null) {
    cfg.borderInfo = [];
  }

  if (type !== "border-slash") {
    var borderInfo = {
      rangeType: "range",
      borderType: type,
      color: color,
      style: style,
      range: _.cloneDeep(ctx.luckysheet_select_save) || []
    };
    cfg.borderInfo.push(borderInfo);
  } else {
    var rangeList = [];

    _.forEach(ctx.luckysheet_select_save, function (selection) {
      for (var r = selection.row[0]; r <= selection.row[1]; r += 1) {
        for (var c = selection.column[0]; c <= selection.column[1]; c += 1) {
          var range = "".concat(r, "_").concat(c);
          if (_.includes(rangeList, range)) continue;
          var _borderInfo = {
            rangeType: "range",
            borderType: type,
            color: color,
            style: style,
            range: normalizeSelection(ctx, [{
              row: [r, r],
              column: [c, c]
            }])
          };
          cfg.borderInfo.push(_borderInfo);
          rangeList.push(range);
        }
      }
    });
  }

  var index = getSheetIndex(ctx, ctx.currentSheetId);
  if (index == null) return;
  ctx.luckysheetfile[index].config = ctx.config;
}
function handleMerge(ctx, type) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (selectIsOverlap(ctx)) {
    return;
  }

  if (ctx.config.merge != null) {
    var has_PartMC = false;
    if (!ctx.luckysheet_select_save) return;

    for (var s = 0; s < ctx.luckysheet_select_save.length; s += 1) {
      var r1 = ctx.luckysheet_select_save[s].row[0];
      var r2 = ctx.luckysheet_select_save[s].row[1];
      var c1 = ctx.luckysheet_select_save[s].column[0];
      var c2 = ctx.luckysheet_select_save[s].column[1];
      has_PartMC = hasPartMC(ctx, ctx.config, r1, r2, c1, c2);

      if (has_PartMC) {
        break;
      }
    }

    if (has_PartMC) {
      return;
    }
  }

  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  if (!ctx.luckysheet_select_save) return;
  mergeCells(ctx, ctx.currentSheetId, ctx.luckysheet_select_save, type);
}
function handleSort(ctx, isAsc) {
  sortSelection(ctx, isAsc);
}
function handleFreeze(ctx, type) {
  var _ctx$luckysheet_selec2, _ctx$config$merge;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var file = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)];
  if (!file) return;

  if (type === "freeze-cancel") {
    delete file.frozen;
    return;
  }

  var firstSelection = (_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2[0];
  if (!firstSelection) return;
  var row_focus = firstSelection.row_focus,
      column_focus = firstSelection.column_focus;
  if (row_focus == null || column_focus == null) return;
  var m = (_ctx$config$merge = ctx.config.merge) === null || _ctx$config$merge === void 0 ? void 0 : _ctx$config$merge["".concat(row_focus, "_").concat(column_focus)];

  if (m) {
    row_focus = m.r + m.rs - 1;
    column_focus = m.c + m.cs - 1;
  }

  file.frozen = {
    type: "both",
    range: {
      row_focus: row_focus,
      column_focus: column_focus
    }
  };

  if (type === "freeze-row") {
    file.frozen.type = "rangeRow";
  } else if (type === "freeze-col") {
    file.frozen.type = "rangeColumn";
  }
}
function handleTextSize(ctx, cellInput, size, canvas) {
  setAttr(ctx, cellInput, "fs", size, canvas);
}
function handleSum(ctx, cellInput, fxInput, cache) {
  autoSelectionFormula(ctx, cellInput, fxInput, "SUM", cache);
}
function handleLink(ctx) {
  var _ctx$luckysheet_selec3;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var selection = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3[0];
  var flowdata = getFlowdata(ctx);

  if (flowdata != null && selection != null) {
    showLinkCard(ctx, selection.row[0], selection.column[0], true);
  }
}
var handlerMap = {
  "currency-format": handleCurrencyFormat,
  "percentage-format": handlePercentageFormat,
  "number-decrease": handleNumberDecrease,
  "number-increase": handleNumberIncrease,
  "sort-cell": function sortCell(ctx) {
    return handleSort(ctx, true);
  },
  "merge-all": function mergeAll(ctx) {
    return handleMerge(ctx, "mergeAll");
  },
  "border-all": function borderAll(ctx) {
    return handleBorder(ctx, "border-all");
  },
  bold: handleBold,
  italic: handleItalic,
  "strike-through": handleStrikeThrough,
  underline: handleUnderline,
  "clear-format": handleClearFormat,
  "format-painter": handleFormatPainter,
  search: function search(ctx) {
    ctx.showSearch = true;
  },
  link: handleLink
};
var selectedMap = {
  bold: function bold(cell) {
    return (cell === null || cell === void 0 ? void 0 : cell.bl) === 1;
  },
  italic: function italic(cell) {
    return (cell === null || cell === void 0 ? void 0 : cell.it) === 1;
  },
  "strike-through": function strikeThrough(cell) {
    return (cell === null || cell === void 0 ? void 0 : cell.cl) === 1;
  },
  underline: function underline(cell) {
    return (cell === null || cell === void 0 ? void 0 : cell.un) === 1;
  }
};
function toolbarItemClickHandler(name) {
  return handlerMap[name];
}
function toolbarItemSelectedFunc(name) {
  return selectedMap[name];
}

function getArrowCanvasSize(fromX, fromY, toX, toY) {
  var left = toX - 5;

  if (fromX < toX) {
    left = fromX - 5;
  }

  var top = toY - 5;

  if (fromY < toY) {
    top = fromY - 5;
  }

  var width = Math.abs(fromX - toX) + 10;
  var height = Math.abs(fromY - toY) + 10;
  var x1 = width - 5;
  var x2 = 5;

  if (fromX < toX) {
    x1 = 5;
    x2 = width - 5;
  }

  var y1 = height - 5;
  var y2 = 5;

  if (fromY < toY) {
    y1 = 5;
    y2 = height - 5;
  }

  return {
    left: left,
    top: top,
    width: width,
    height: height,
    fromX: x1,
    fromY: y1,
    toX: x2,
    toY: y2
  };
}
function drawArrow(rc, _ref, color, theta, headlen) {
  var left = _ref.left,
      top = _ref.top,
      width = _ref.width,
      height = _ref.height,
      fromX = _ref.fromX,
      fromY = _ref.fromY,
      toX = _ref.toX,
      toY = _ref.toY;
  var canvas = document.getElementById("arrowCanvas-".concat(rc));
  var ctx = canvas.getContext("2d");
  if (!canvas || !ctx) return;
  canvas.style.width = "".concat(width, "px");
  canvas.style.height = "".concat(height, "px");
  canvas.width = width;
  canvas.height = height;
  canvas.style.left = "".concat(left, "px");
  canvas.style.top = "".concat(top, "px");

  var _canvas$getBoundingCl = canvas.getBoundingClientRect(),
      canvasWidth = _canvas$getBoundingCl.width,
      canvasHeight = _canvas$getBoundingCl.height;

  ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  theta = theta || 30;
  headlen = headlen || 6;
  var arrowWidth = 1;
  color = color || "#000";
  var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI;
  var angle1 = (angle + theta) * Math.PI / 180;
  var angle2 = (angle - theta) * Math.PI / 180;
  var topX = headlen * Math.cos(angle1);
  var topY = headlen * Math.sin(angle1);
  var botX = headlen * Math.cos(angle2);
  var botY = headlen * Math.sin(angle2);
  ctx.save();
  ctx.beginPath();
  var arrowX = fromX - topX;
  var arrowY = fromY - topY;
  ctx.moveTo(arrowX, arrowY);
  ctx.moveTo(fromX, fromY);
  ctx.lineTo(toX, toY);
  ctx.lineWidth = arrowWidth;
  ctx.strokeStyle = color;
  ctx.stroke();
  arrowX = toX + topX;
  arrowY = toY + topY;
  ctx.moveTo(arrowX, arrowY);
  ctx.lineTo(toX, toY);
  arrowX = toX + botX;
  arrowY = toY + botY;
  ctx.lineTo(arrowX, arrowY);
  ctx.fillStyle = color;
  ctx.fill();
  ctx.restore();
}
var commentBoxProps = {
  defaultWidth: 144,
  defaultHeight: 84,
  currentObj: null,
  currentWinW: null,
  currentWinH: null,
  resize: null,
  resizeXY: null,
  move: false,
  moveXY: null,
  cursorStartPosition: null
};
function getCellTopRightPostion(ctx, flowdata, r, c) {
  var row_pre = r - 1 === -1 ? 0 : ctx.visibledatarow[r - 1];
  var col = ctx.visibledatacolumn[c];
  var margeset = mergeBorder(ctx, flowdata, r, c);

  if (margeset) {
    var _margeset$row = _slicedToArray(margeset.row, 1);

    row_pre = _margeset$row[0];

    var _margeset$column = _slicedToArray(margeset.column, 2);

    col = _margeset$column[1];
  }

  var toX = col;
  var toY = row_pre;
  return {
    toX: toX,
    toY: toY
  };
}
function getCommentBoxByRC(ctx, flowdata, r, c) {
  var _flowdata$r$c;

  var comment = (_flowdata$r$c = flowdata[r][c]) === null || _flowdata$r$c === void 0 ? void 0 : _flowdata$r$c.ps;

  var _getCellTopRightPosti = getCellTopRightPostion(ctx, flowdata, r, c),
      toX = _getCellTopRightPosti.toX,
      toY = _getCellTopRightPosti.toY;

  var left = (comment === null || comment === void 0 ? void 0 : comment.left) == null ? toX + 18 * ctx.zoomRatio : comment.left * ctx.zoomRatio;
  var top = (comment === null || comment === void 0 ? void 0 : comment.top) == null ? toY - 18 * ctx.zoomRatio : comment.top * ctx.zoomRatio;
  var width = (comment === null || comment === void 0 ? void 0 : comment.width) == null ? commentBoxProps.defaultWidth * ctx.zoomRatio : comment.width * ctx.zoomRatio;
  var height = (comment === null || comment === void 0 ? void 0 : comment.height) == null ? commentBoxProps.defaultHeight * ctx.zoomRatio : comment.height * ctx.zoomRatio;
  var value = (comment === null || comment === void 0 ? void 0 : comment.value) == null ? "" : comment.value;

  if (top < 0) {
    top = 2;
  }

  var size = getArrowCanvasSize(left, top, toX, toY);
  var rc = "".concat(r, "_").concat(c);
  return {
    r: r,
    c: c,
    rc: rc,
    left: left,
    top: top,
    width: width,
    height: height,
    value: value,
    size: size,
    autoFocus: false
  };
}
function setEditingComment(ctx, flowdata, r, c) {
  ctx.editingCommentBox = getCommentBoxByRC(ctx, flowdata, r, c);
}
function removeEditingComment(ctx, globalCache) {
  var _ctx$hooks$beforeUpda, _ctx$hooks;

  var editingCommentBoxEle = globalCache.editingCommentBoxEle;
  ctx.editingCommentBox = undefined;
  var r = editingCommentBoxEle === null || editingCommentBoxEle === void 0 ? void 0 : editingCommentBoxEle.dataset.r;
  var c = editingCommentBoxEle === null || editingCommentBoxEle === void 0 ? void 0 : editingCommentBoxEle.dataset.c;
  if (!r || !c || !editingCommentBoxEle) return;
  r = parseInt(r, 10);
  c = parseInt(c, 10);
  var value = editingCommentBoxEle.innerHTML || "";
  var flowdata = getFlowdata(ctx);
  globalCache.editingCommentBoxEle = undefined;
  if (!flowdata) return;

  if (((_ctx$hooks$beforeUpda = (_ctx$hooks = ctx.hooks).beforeUpdateComment) === null || _ctx$hooks$beforeUpda === void 0 ? void 0 : _ctx$hooks$beforeUpda.call(_ctx$hooks, r, c, value)) === false) {
    return;
  }

  var cell = flowdata === null || flowdata === void 0 ? void 0 : flowdata[r][c];
  if (!(cell === null || cell === void 0 ? void 0 : cell.ps)) return;
  var oldValue = cell.ps.value;
  cell.ps.value = value;

  if (!cell.ps.isShow) {
    ctx.commentBoxes = _.filter(ctx.commentBoxes, function (v) {
      return v.rc !== "".concat(r, "_").concat(c);
    });
  }

  if (ctx.hooks.afterUpdateComment) {
    setTimeout(function () {
      var _ctx$hooks$afterUpdat, _ctx$hooks2;

      (_ctx$hooks$afterUpdat = (_ctx$hooks2 = ctx.hooks).afterUpdateComment) === null || _ctx$hooks$afterUpdat === void 0 ? void 0 : _ctx$hooks$afterUpdat.call(_ctx$hooks2, r, c, oldValue, value);
    });
  }
}
function newComment(ctx, globalCache, r, c) {
  var _ctx$hooks$beforeInse, _ctx$hooks3;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (((_ctx$hooks$beforeInse = (_ctx$hooks3 = ctx.hooks).beforeInsertComment) === null || _ctx$hooks$beforeInse === void 0 ? void 0 : _ctx$hooks$beforeInse.call(_ctx$hooks3, r, c)) === false) {
    return;
  }

  removeEditingComment(ctx, globalCache);
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var cell = flowdata[r][c];

  if (cell == null) {
    cell = {};
    flowdata[r][c] = cell;
  }

  cell.ps = {
    left: null,
    top: null,
    width: null,
    height: null,
    value: "",
    isShow: false
  };
  ctx.editingCommentBox = _objectSpread2(_objectSpread2({}, getCommentBoxByRC(ctx, flowdata, r, c)), {}, {
    autoFocus: true
  });

  if (ctx.hooks.afterInsertComment) {
    setTimeout(function () {
      var _ctx$hooks$afterInser, _ctx$hooks4;

      (_ctx$hooks$afterInser = (_ctx$hooks4 = ctx.hooks).afterInsertComment) === null || _ctx$hooks$afterInser === void 0 ? void 0 : _ctx$hooks$afterInser.call(_ctx$hooks4, r, c);
    });
  }
}
function editComment(ctx, globalCache, r, c) {
  var _flowdata$r$c2;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var flowdata = getFlowdata(ctx);
  removeEditingComment(ctx, globalCache);
  var comment = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$r$c2 = flowdata[r][c]) === null || _flowdata$r$c2 === void 0 ? void 0 : _flowdata$r$c2.ps;

  var commentBoxes = _.concat(ctx.commentBoxes, ctx.editingCommentBox);

  if (_.findIndex(commentBoxes, function (v) {
    return (v === null || v === void 0 ? void 0 : v.rc) === "".concat(r, "_").concat(c);
  }) !== -1) {
    var editCommentBox = document.getElementById("comment-editor-".concat(r, "_").concat(c));
    editCommentBox === null || editCommentBox === void 0 ? void 0 : editCommentBox.focus();
  }

  if (comment) {
    ctx.editingCommentBox = _objectSpread2(_objectSpread2({}, getCommentBoxByRC(ctx, flowdata, r, c)), {}, {
      autoFocus: true
    });
  }
}
function deleteComment(ctx, globalCache, r, c) {
  var _ctx$hooks$beforeDele, _ctx$hooks5;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (((_ctx$hooks$beforeDele = (_ctx$hooks5 = ctx.hooks).beforeDeleteComment) === null || _ctx$hooks$beforeDele === void 0 ? void 0 : _ctx$hooks$beforeDele.call(_ctx$hooks5, r, c)) === false) {
    return;
  }

  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var cell = flowdata[r][c];
  if (!cell) return;
  cell.ps = undefined;

  if (ctx.hooks.afterDeleteComment) {
    setTimeout(function () {
      var _ctx$hooks$afterDelet, _ctx$hooks6;

      (_ctx$hooks$afterDelet = (_ctx$hooks6 = ctx.hooks).afterDeleteComment) === null || _ctx$hooks$afterDelet === void 0 ? void 0 : _ctx$hooks$afterDelet.call(_ctx$hooks6, r, c);
    });
  }
}
function showComments(ctx, commentShowCells) {
  var flowdata = getFlowdata(ctx);

  if (flowdata) {
    var commentBoxes = commentShowCells.map(function (_ref2) {
      var r = _ref2.r,
          c = _ref2.c;
      return getCommentBoxByRC(ctx, flowdata, r, c);
    });
    ctx.commentBoxes = commentBoxes;
  }
}
function showHideComment(ctx, globalCache, r, c) {
  var _flowdata$r$c3;

  var flowdata = getFlowdata(ctx);
  var comment = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$r$c3 = flowdata[r][c]) === null || _flowdata$r$c3 === void 0 ? void 0 : _flowdata$r$c3.ps;
  if (!comment) return;
  var isShow = comment.isShow;
  var rc = "".concat(r, "_").concat(c);

  if (isShow) {
    comment.isShow = false;
    ctx.commentBoxes = _.filter(ctx.commentBoxes, function (v) {
      return v.rc !== rc;
    });
  } else {
    comment.isShow = true;
  }
}
function showHideAllComments(ctx) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var isAllShow = true;
  var allComments = [];

  for (var r = 0; r < flowdata.length; r += 1) {
    for (var c = 0; c < flowdata[0].length; c += 1) {
      var cell = flowdata[r][c];

      if (cell === null || cell === void 0 ? void 0 : cell.ps) {
        allComments.push({
          r: r,
          c: c
        });

        if (!cell.ps.isShow) {
          isAllShow = false;
        }
      }
    }
  }

  if (allComments.length > 0) {
    if (isAllShow) {
      for (var i = 0; i < allComments.length; i += 1) {
        var _flowdata$_r$_c;

        var _allComments$i = allComments[i],
            _r = _allComments$i.r,
            _c = _allComments$i.c;
        var comment = (_flowdata$_r$_c = flowdata[_r][_c]) === null || _flowdata$_r$_c === void 0 ? void 0 : _flowdata$_r$_c.ps;

        if (comment === null || comment === void 0 ? void 0 : comment.isShow) {
          comment.isShow = false;
        }
      }

      ctx.commentBoxes = [];
    } else {
      for (var _i = 0; _i < allComments.length; _i += 1) {
        var _flowdata$_r2$_c;

        var _allComments$_i = allComments[_i],
            _r2 = _allComments$_i.r,
            _c2 = _allComments$_i.c;

        var _comment = (_flowdata$_r2$_c = flowdata[_r2][_c2]) === null || _flowdata$_r2$_c === void 0 ? void 0 : _flowdata$_r2$_c.ps;

        if (_comment && !_comment.isShow) {
          _comment.isShow = true;
        }
      }
    }
  }
}
function overShowComment(ctx, e, scrollX, scrollY, container) {
  var _flowdata$r, _flowdata$r$c4, _ctx$editingCommentBo, _ctx$hoveredCommentBo;

  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var scrollLeft = scrollX.scrollLeft;
  var scrollTop = scrollY.scrollTop;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight;
  var offsetX = 0;
  var offsetY = 0;
  x += scrollLeft;
  y += scrollTop;
  var r = rowLocation(y, ctx.visibledatarow)[2];
  var c = colLocation(x, ctx.visibledatacolumn)[2];
  var margeset = mergeBorder(ctx, flowdata, r, c);

  if (margeset) {
    var _margeset$row2 = _slicedToArray(margeset.row, 3);

    r = _margeset$row2[2];

    var _margeset$column2 = _slicedToArray(margeset.column, 3);

    c = _margeset$column2[2];
  }

  var rc = "".concat(r, "_").concat(c);
  var comment = (_flowdata$r = flowdata[r]) === null || _flowdata$r === void 0 ? void 0 : (_flowdata$r$c4 = _flowdata$r[c]) === null || _flowdata$r$c4 === void 0 ? void 0 : _flowdata$r$c4.ps;

  if (comment == null || comment.isShow || _.findIndex(ctx.commentBoxes, function (v) {
    return v.rc === rc;
  }) !== -1 || ((_ctx$editingCommentBo = ctx.editingCommentBox) === null || _ctx$editingCommentBo === void 0 ? void 0 : _ctx$editingCommentBo.rc) === rc) {
    ctx.hoveredCommentBox = undefined;
    return;
  }

  if (((_ctx$hoveredCommentBo = ctx.hoveredCommentBox) === null || _ctx$hoveredCommentBo === void 0 ? void 0 : _ctx$hoveredCommentBo.rc) === rc) return;
  var row_pre = r - 1 === -1 ? 0 : ctx.visibledatarow[r - 1];
  var col = ctx.visibledatacolumn[c];

  if (margeset) {
    var _margeset$row3 = _slicedToArray(margeset.row, 1);

    row_pre = _margeset$row3[0];

    var _margeset$column3 = _slicedToArray(margeset.column, 2);

    col = _margeset$column3[1];
  }

  var toX = col + offsetX;
  var toY = row_pre + offsetY;
  var left = comment.left == null ? toX + 18 * ctx.zoomRatio : comment.left * ctx.zoomRatio;
  var top = comment.top == null ? toY - 18 * ctx.zoomRatio : comment.top * ctx.zoomRatio;

  if (top < 0) {
    top = 2;
  }

  var width = comment.width == null ? commentBoxProps.defaultWidth * ctx.zoomRatio : comment.width * ctx.zoomRatio;
  var height = comment.height == null ? commentBoxProps.defaultHeight * ctx.zoomRatio : comment.height * ctx.zoomRatio;
  var size = getArrowCanvasSize(left, top, toX, toY);
  var value = comment.value == null ? "" : comment.value;
  ctx.hoveredCommentBox = {
    r: r,
    c: c,
    rc: rc,
    left: left,
    top: top,
    width: width,
    height: height,
    size: size,
    value: value,
    autoFocus: false
  };
}
function getCommentBoxPosition(commentId) {
  var box = document.getElementById(commentId);
  if (!box) return undefined;

  var _box$getBoundingClien = box.getBoundingClientRect(),
      width = _box$getBoundingClien.width,
      height = _box$getBoundingClien.height;

  var left = box.offsetLeft;
  var top = box.offsetTop;
  return {
    left: left,
    top: top,
    width: width,
    height: height
  };
}
function onCommentBoxResizeStart(ctx, globalCache, e, _ref3, resizingId, resizingSide) {
  var r = _ref3.r,
      c = _ref3.c,
      rc = _ref3.rc;
  var position = getCommentBoxPosition(resizingId);

  if (position) {
    _.set(globalCache, "commentBox", {
      cursorMoveStartPosition: {
        x: e.pageX,
        y: e.pageY
      },
      resizingId: resizingId,
      resizingSide: resizingSide,
      commentRC: {
        r: r,
        c: c,
        rc: rc
      },
      boxInitialPosition: position
    });
  }
}
function onCommentBoxResize(ctx, globalCache, e) {
  if (ctx.allowEdit === false) return false;
  var commentBox = globalCache === null || globalCache === void 0 ? void 0 : globalCache.commentBox;

  if ((commentBox === null || commentBox === void 0 ? void 0 : commentBox.resizingId) && commentBox.resizingSide) {
    var box = document.getElementById(commentBox.resizingId);
    var _commentBox$cursorMov = commentBox.cursorMoveStartPosition,
        startX = _commentBox$cursorMov.x,
        startY = _commentBox$cursorMov.y;
    var _commentBox$boxInitia = commentBox.boxInitialPosition,
        top = _commentBox$boxInitia.top,
        left = _commentBox$boxInitia.left,
        width = _commentBox$boxInitia.width,
        height = _commentBox$boxInitia.height;
    var dx = e.pageX - startX;
    var dy = e.pageY - startY;
    var minHeight = 60 * ctx.zoomRatio;
    var minWidth = 1.5 * 60 * ctx.zoomRatio;

    if (["lm", "lt", "lb"].includes(commentBox.resizingSide)) {
      if (width - dx < minWidth) {
        left += width - minWidth;
        width = minWidth;
      } else {
        left += dx;
        width -= dx;
      }

      if (left < 0) left = 0;
      box.style.left = "".concat(left, "px");
    }

    if (["rm", "rt", "rb"].includes(commentBox.resizingSide)) {
      width = width + dx < minWidth ? minWidth : width + dx;
    }

    if (["mt", "lt", "rt"].includes(commentBox.resizingSide)) {
      if (height - dy < minHeight) {
        top += height - minHeight;
        height = minHeight;
      } else {
        top += dy;
        height -= dy;
      }

      if (top < 0) top = 0;
      box.style.top = "".concat(top, "px");
    }

    if (["mb", "lb", "rb"].includes(commentBox.resizingSide)) {
      height = height + dy < minHeight ? minHeight : height + dy;
    }

    box.style.width = "".concat(width, "px");
    box.style.height = "".concat(height, "px");
    return true;
  }

  return false;
}
function onCommentBoxResizeEnd(ctx, globalCache) {
  var _globalCache$commentB;

  if ((_globalCache$commentB = globalCache.commentBox) === null || _globalCache$commentB === void 0 ? void 0 : _globalCache$commentB.resizingId) {
    var _globalCache$commentB2 = globalCache.commentBox,
        resizingId = _globalCache$commentB2.resizingId,
        _globalCache$commentB3 = _globalCache$commentB2.commentRC,
        r = _globalCache$commentB3.r,
        c = _globalCache$commentB3.c;
    globalCache.commentBox.resizingId = undefined;
    var position = getCommentBoxPosition(resizingId);

    if (position) {
      var top = position.top,
          left = position.left,
          width = position.width,
          height = position.height;
      var flowdata = getFlowdata(ctx);
      var cell = flowdata === null || flowdata === void 0 ? void 0 : flowdata[r][c];
      if (!flowdata || !(cell === null || cell === void 0 ? void 0 : cell.ps)) return;
      cell.ps.left = left / ctx.zoomRatio;
      cell.ps.top = top / ctx.zoomRatio;
      cell.ps.width = width / ctx.zoomRatio;
      cell.ps.height = height / ctx.zoomRatio;
      setEditingComment(ctx, flowdata, r, c);
    }
  }
}
function onCommentBoxMoveStart(ctx, globalCache, e, _ref4, movingId) {
  var r = _ref4.r,
      c = _ref4.c,
      rc = _ref4.rc;
  var position = getCommentBoxPosition(movingId);

  if (position) {
    var top = position.top,
        left = position.left;

    _.set(globalCache, "commentBox", {
      cursorMoveStartPosition: {
        x: e.pageX,
        y: e.pageY
      },
      movingId: movingId,
      commentRC: {
        r: r,
        c: c,
        rc: rc
      },
      boxInitialPosition: {
        left: left,
        top: top
      }
    });
  }
}
function onCommentBoxMove(ctx, globalCache, e) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return false;
  var commentBox = globalCache === null || globalCache === void 0 ? void 0 : globalCache.commentBox;

  if (commentBox === null || commentBox === void 0 ? void 0 : commentBox.movingId) {
    var box = document.getElementById(commentBox.movingId);
    var _commentBox$cursorMov2 = commentBox.cursorMoveStartPosition,
        startX = _commentBox$cursorMov2.x,
        startY = _commentBox$cursorMov2.y;
    var _commentBox$boxInitia2 = commentBox.boxInitialPosition,
        top = _commentBox$boxInitia2.top,
        left = _commentBox$boxInitia2.left;
    left += e.pageX - startX;
    top += e.pageY - startY;
    if (top < 0) top = 0;
    box.style.left = "".concat(left, "px");
    box.style.top = "".concat(top, "px");
    return true;
  }

  return false;
}
function onCommentBoxMoveEnd(ctx, globalCache) {
  var _globalCache$commentB4;

  if ((_globalCache$commentB4 = globalCache.commentBox) === null || _globalCache$commentB4 === void 0 ? void 0 : _globalCache$commentB4.movingId) {
    var _globalCache$commentB5 = globalCache.commentBox,
        movingId = _globalCache$commentB5.movingId,
        _globalCache$commentB6 = _globalCache$commentB5.commentRC,
        r = _globalCache$commentB6.r,
        c = _globalCache$commentB6.c;
    globalCache.commentBox.movingId = undefined;
    var position = getCommentBoxPosition(movingId);

    if (position) {
      var top = position.top,
          left = position.left;
      var flowdata = getFlowdata(ctx);
      var cell = flowdata === null || flowdata === void 0 ? void 0 : flowdata[r][c];
      if (!flowdata || !(cell === null || cell === void 0 ? void 0 : cell.ps)) return;
      cell.ps.left = left / ctx.zoomRatio;
      cell.ps.top = top / ctx.zoomRatio;
      setEditingComment(ctx, flowdata, r, c);
    }
  }
}

var imageProps = {
  defaultWidth: 144,
  defaultHeight: 84,
  currentObj: null,
  currentWinW: null,
  currentWinH: null,
  resize: null,
  resizeXY: null,
  move: false,
  moveXY: null,
  cursorStartPosition: null
};
function generateRandomId(prefix) {
  if (prefix == null) {
    prefix = "img";
  }

  var userAgent = window.navigator.userAgent.replace(/[^a-zA-Z0-9]/g, "").split("");
  var mid = "";

  for (var i = 0; i < 12; i += 1) {
    mid += userAgent[Math.round(Math.random() * (userAgent.length - 1))];
  }

  var time = new Date().getTime();
  return "".concat(prefix, "_").concat(mid, "_").concat(time);
}
function showImgChooser() {
  var chooser = document.getElementById("fortune-img-upload");
  if (chooser) chooser.click();
}
function saveImage(ctx) {
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  if (index == null) return;
  var file = ctx.luckysheetfile[index];
  file.images = ctx.insertedImgs;
}
function removeActiveImage(ctx) {
  ctx.insertedImgs = _.filter(ctx.insertedImgs, function (image) {
    return image.id !== ctx.activeImg;
  });
  ctx.activeImg = undefined;
  saveImage(ctx);
}
function insertImage(ctx, image) {
  try {
    var _ctx$luckysheet_selec;

    var last = (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec[ctx.luckysheet_select_save.length - 1];
    var rowIndex = last === null || last === void 0 ? void 0 : last.row_focus;
    var colIndex = last === null || last === void 0 ? void 0 : last.column_focus;

    if (!last) {
      rowIndex = 0;
      colIndex = 0;
    } else {
      if (rowIndex == null) {
        var _last$row = _slicedToArray(last.row, 1);

        rowIndex = _last$row[0];
      }

      if (colIndex == null) {
        var _last$column = _slicedToArray(last.column, 1);

        colIndex = _last$column[0];
      }
    }

    var flowdata = getFlowdata(ctx);
    var left = colIndex === 0 ? 0 : ctx.visibledatacolumn[colIndex - 1];
    var top = rowIndex === 0 ? 0 : ctx.visibledatarow[rowIndex - 1];

    if (flowdata) {
      var margeset = mergeBorder(ctx, flowdata, rowIndex, colIndex);

      if (margeset) {
        var _margeset$row = _slicedToArray(margeset.row, 1);

        top = _margeset$row[0];

        var _margeset$column = _slicedToArray(margeset.column, 1);

        left = _margeset$column[0];
      }
    }

    var width = image.width;
    var height = image.height;
    var img = {
      id: generateRandomId("img"),
      src: image.src,
      left: left,
      top: top,
      width: width * 0.5,
      height: height * 0.5,
      originWidth: width,
      originHeight: height
    };
    ctx.insertedImgs = (ctx.insertedImgs || []).concat(img);
    saveImage(ctx);
  } catch (err) {
    console.info(err);
  }
}

function getImagePosition() {
  var box = document.getElementById("luckysheet-modal-dialog-activeImage");
  if (!box) return undefined;

  var _box$getBoundingClien = box.getBoundingClientRect(),
      width = _box$getBoundingClien.width,
      height = _box$getBoundingClien.height;

  var left = box.offsetLeft;
  var top = box.offsetTop;
  return {
    left: left,
    top: top,
    width: width,
    height: height
  };
}

function cancelActiveImgItem(ctx, globalCache) {
  ctx.activeImg = undefined;
  globalCache.image = undefined;
}
function onImageMoveStart(ctx, globalCache, e) {
  var position = getImagePosition();

  if (position) {
    var top = position.top,
        left = position.left;

    _.set(globalCache, "image", {
      cursorMoveStartPosition: {
        x: e.pageX,
        y: e.pageY
      },
      imgInitialPosition: {
        left: left,
        top: top
      }
    });
  }
}
function onImageMove(ctx, globalCache, e) {
  if (ctx.allowEdit === false) return false;
  var image = globalCache === null || globalCache === void 0 ? void 0 : globalCache.image;
  var img = document.getElementById("luckysheet-modal-dialog-activeImage");

  if (img && image && !image.resizingSide) {
    var _image$cursorMoveStar = image.cursorMoveStartPosition,
        startX = _image$cursorMoveStar.x,
        startY = _image$cursorMoveStar.y;
    var _image$imgInitialPosi = image.imgInitialPosition,
        top = _image$imgInitialPosi.top,
        left = _image$imgInitialPosi.left;
    left += e.pageX - startX;
    top += e.pageY - startY;
    if (top < 0) top = 0;
    img.style.left = "".concat(left, "px");
    img.style.top = "".concat(top, "px");
    return true;
  }

  return false;
}
function onImageMoveEnd(ctx, globalCache) {
  var _globalCache$image;

  var position = getImagePosition();

  if (!((_globalCache$image = globalCache.image) === null || _globalCache$image === void 0 ? void 0 : _globalCache$image.resizingSide)) {
    globalCache.image = undefined;

    if (position) {
      var img = _.find(ctx.insertedImgs, function (v) {
        return v.id === ctx.activeImg;
      });

      if (img) {
        img.left = position.left / ctx.zoomRatio;
        img.top = position.top / ctx.zoomRatio;
        saveImage(ctx);
      }
    }
  }
}
function onImageResizeStart(globalCache, e, resizingSide) {
  var position = getImagePosition();

  if (position) {
    _.set(globalCache, "image", {
      cursorMoveStartPosition: {
        x: e.pageX,
        y: e.pageY
      },
      resizingSide: resizingSide,
      imgInitialPosition: position
    });
  }
}
function onImageResize(ctx, globalCache, e) {
  if (ctx.allowEdit === false) return false;
  var image = globalCache === null || globalCache === void 0 ? void 0 : globalCache.image;

  if (image === null || image === void 0 ? void 0 : image.resizingSide) {
    var imgContainer = document.getElementById("luckysheet-modal-dialog-activeImage");
    var img = imgContainer === null || imgContainer === void 0 ? void 0 : imgContainer.querySelector(".luckysheet-modal-dialog-content");
    if (img == null) return false;
    var _image$cursorMoveStar2 = image.cursorMoveStartPosition,
        startX = _image$cursorMoveStar2.x,
        startY = _image$cursorMoveStar2.y;
    var _image$imgInitialPosi2 = image.imgInitialPosition,
        top = _image$imgInitialPosi2.top,
        left = _image$imgInitialPosi2.left,
        width = _image$imgInitialPosi2.width,
        height = _image$imgInitialPosi2.height;
    var dx = e.pageX - startX;
    var dy = e.pageY - startY;
    var minHeight = 60 * ctx.zoomRatio;
    var minWidth = 1.5 * 60 * ctx.zoomRatio;

    if (["lm", "lt", "lb"].includes(image.resizingSide)) {
      if (width - dx < minWidth) {
        left += width - minWidth;
        width = minWidth;
      } else {
        left += dx;
        width -= dx;
      }

      if (left < 0) left = 0;
      img.style.left = "".concat(left, "px");
      imgContainer.style.left = "".concat(left, "px");
    }

    if (["rm", "rt", "rb"].includes(image.resizingSide)) {
      width = width + dx < minWidth ? minWidth : width + dx;
    }

    if (["mt", "lt", "rt"].includes(image.resizingSide)) {
      if (height - dy < minHeight) {
        top += height - minHeight;
        height = minHeight;
      } else {
        top += dy;
        height -= dy;
      }

      if (top < 0) top = 0;
      img.style.top = "".concat(top, "px");
      imgContainer.style.top = "".concat(top, "px");
    }

    if (["mb", "lb", "rb"].includes(image.resizingSide)) {
      height = height + dy < minHeight ? minHeight : height + dy;
    }

    img.style.width = "".concat(width, "px");
    imgContainer.style.width = "".concat(width, "px");
    img.style.height = "".concat(height, "px");
    imgContainer.style.height = "".concat(height, "px");
    img.style.backgroundSize = "".concat(width, "px ").concat(height, "px");
    return true;
  }

  return false;
}
function onImageResizeEnd(ctx, globalCache) {
  var _globalCache$image2;

  if ((_globalCache$image2 = globalCache.image) === null || _globalCache$image2 === void 0 ? void 0 : _globalCache$image2.resizingSide) {
    globalCache.image = undefined;
    var position = getImagePosition();

    if (position) {
      var img = _.find(ctx.insertedImgs, function (v) {
        return v.id === ctx.activeImg;
      });

      if (img) {
        img.left = position.left / ctx.zoomRatio;
        img.top = position.top / ctx.zoomRatio;
        img.width = position.width / ctx.zoomRatio;
        img.height = position.height / ctx.zoomRatio;
        saveImage(ctx);
      }
    }
  }
}

function handleOverlayTouchStart(ctx, e, globalCache) {
  globalCache.touchMoveStatus = true;
  var touch = e.targetTouches[0];
  globalCache.touchMoveStartPos = {
    x: touch.pageX,
    y: touch.pageY,
    vy: 0,
    moveType: "y"
  };
}
function handleOverlayTouchMove(ctx, e, globalCache, scrollbarX, scrollbarY) {
  if (e.targetTouches.length > 1) return;
  var touch = e.targetTouches[0];

  if (globalCache.touchMoveStatus) {
    if (!globalCache.touchMoveStartPos) return;
    var slideX = touch.pageX - globalCache.touchMoveStartPos.x;
    var slideY = touch.pageY - globalCache.touchMoveStartPos.y;
    var scrollLeft = ctx.scrollLeft;
    var scrollTop = ctx.scrollTop;
    scrollLeft -= slideX;
    scrollTop -= slideY;
    scrollbarY.scrollTop = scrollTop;
    globalCache.touchMoveStartPos.vy_y = slideY;
    globalCache.touchMoveStartPos.scrollTop = scrollTop;
    scrollbarX.scrollLeft = scrollLeft;
    globalCache.touchMoveStartPos.vy_x = slideX;
    globalCache.touchMoveStartPos.scrollLeft = scrollLeft;
  }
}
function handleOverlayTouchEnd(globalCache) {
  globalCache.touchMoveStatus = false;
  globalCache.touchHandleStatus = false;
}

function toPx(v) {
  return "".concat(v, "px");
}

var dropCellCache = {
  copyRange: {},
  applyRange: {},
  applyType: null,
  direction: null,
  chnNumChar: {
    零: 0,
    一: 1,
    二: 2,
    三: 3,
    四: 4,
    五: 5,
    六: 6,
    七: 7,
    八: 8,
    九: 9
  },
  chnNameValue: {
    十: {
      value: 10,
      secUnit: false
    },
    百: {
      value: 100,
      secUnit: false
    },
    千: {
      value: 1000,
      secUnit: false
    },
    万: {
      value: 10000,
      secUnit: true
    },
    亿: {
      value: 100000000,
      secUnit: true
    }
  },
  chnNumChar2: ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
  chnUnitSection: ["", "万", "亿", "万亿", "亿亿"],
  chnUnitChar: ["", "十", "百", "千"]
};

function chineseToNumber(chnStr) {
  var rtn = 0;
  var section = 0;
  var number = 0;
  var secUnit = false;
  var str = chnStr.split("");

  for (var i = 0; i < str.length; i += 1) {
    var num = dropCellCache.chnNumChar[str[i]];

    if (typeof num !== "undefined") {
      number = num;

      if (i === str.length - 1) {
        section += number;
      }
    } else {
      var unit = dropCellCache.chnNameValue[str[i]].value;
      secUnit = dropCellCache.chnNameValue[str[i]].secUnit;

      if (secUnit) {
        section = (section + number) * unit;
        rtn += section;
        section = 0;
      } else {
        section += number * unit;
      }

      number = 0;
    }
  }

  return rtn + section;
}

function sectionToChinese(section) {
  var strIns = "";
  var chnStr = "";
  var unitPos = 0;
  var zero = true;

  while (section > 0) {
    var v = section % 10;

    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = dropCellCache.chnNumChar2[v] + chnStr;
      }
    } else {
      zero = false;
      strIns = dropCellCache.chnNumChar2[v];
      strIns += dropCellCache.chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
    }

    unitPos += 1;
    section = Math.floor(section / 10);
  }

  return chnStr;
}

function numberToChinese(num) {
  var strIns = "";
  var chnStr = "";
  var unitPos = 0;
  var needZero = false;

  if (num === 0) {
    return dropCellCache.chnNumChar2[0];
  }

  while (num > 0) {
    var section = num % 10000;

    if (needZero) {
      chnStr = dropCellCache.chnNumChar2[0] + chnStr;
    }

    strIns = sectionToChinese(section);
    strIns += section !== 0 ? dropCellCache.chnUnitSection[unitPos] : dropCellCache.chnUnitSection[0];
    chnStr = strIns + chnStr;
    needZero = section < 1000 && section > 0;
    num = Math.floor(num / 10000);
    unitPos += 1;
  }

  return chnStr;
}

function isChnNumber(txt) {
  if (typeof txt === "number") {
    txt = "".concat(txt);
  }

  var result = true;

  if (txt == null) {
    result = false;
  } else if (txt.length === 1) {
    if (txt === "日" || txt in dropCellCache.chnNumChar) {
      result = true;
    } else {
      result = false;
    }
  } else {
    var str = txt.split("");

    for (var i = 0; i < str.length; i += 1) {
      if (!(str[i] in dropCellCache.chnNumChar || str[i] in dropCellCache.chnNameValue)) {
        result = false;
        break;
      }
    }
  }

  return result;
}

function isExtendNumber(txt) {
  if (txt == null) return [false];

  if (typeof txt === "number") {
    txt = "".concat(txt);
  }

  var reg = /0|([1-9]+[0-9]*)/g;
  var result = reg.test(txt);

  if (result) {
    var match = txt.match(reg);

    if (match) {
      var matchTxt = match[match.length - 1];
      var matchIndex = txt.lastIndexOf(matchTxt);
      var beforeTxt = txt.slice(0, matchIndex);
      var afterTxt = txt.slice(matchIndex + matchTxt.length);
      return [result, Number(matchTxt), beforeTxt, afterTxt];
    }
  }

  return [result];
}

function isChnWeek2(txt) {
  var result = false;

  if (typeof txt === "number") {
    txt = "".concat(txt);
  }

  if (txt !== undefined && txt.length === 2) {
    if (txt === "周一" || txt === "周二" || txt === "周三" || txt === "周四" || txt === "周五" || txt === "周六" || txt === "周日") {
      result = true;
    }
  }

  return result;
}

function isChnWeek3(txt) {
  if (typeof txt === "number") {
    txt = "".concat(txt);
  }

  var result = false;

  if (txt !== undefined && txt.length === 3) {
    if (txt === "星期一" || txt === "星期二" || txt === "星期三" || txt === "星期四" || txt === "星期五" || txt === "星期六" || txt === "星期日") {
      result = true;
    }
  }

  return result;
}

function isEqualDiff(arr) {
  var diff = true;
  var step = arr[1] - arr[0];

  for (var i = 1; i < arr.length; i += 1) {
    if (arr[i] - arr[i - 1] !== step) {
      diff = false;
      break;
    }
  }

  return diff;
}

function isEqualRatio(arr) {
  var ratio = true;
  var step = arr[1] / arr[0];

  for (var i = 1; i < arr.length; i += 1) {
    if (arr[i] / arr[i - 1] !== step) {
      ratio = false;
      break;
    }
  }

  return ratio;
}

function getXArr(len) {
  var xArr = [];

  for (var i = 1; i <= len; i += 1) {
    xArr.push(i);
  }

  return xArr;
}

function forecast(x, yArr, xArr) {
  function getAverage(arr) {
    var sum = 0;

    for (var i = 0; i < arr.length; i += 1) {
      sum += arr[i];
    }

    return sum / arr.length;
  }

  var ax = getAverage(xArr);
  var ay = getAverage(yArr);
  var sum_d = 0;
  var sum_n = 0;

  for (var j = 0; j < xArr.length; j += 1) {
    sum_d += (xArr[j] - ax) * (yArr[j] - ay);
    sum_n += (xArr[j] - ax) * (xArr[j] - ax);
  }

  var b;

  if (sum_n === 0) {
    b = 1;
  } else {
    b = sum_d / sum_n;
  }

  var a = ay - b * ax;
  return Math.round((a + b * x) * 100000) / 100000;
}

function judgeDate(data) {
  var isSameDay = true;
  var isSameMonth = true;
  var isEqualDiffDays = true;
  var isEqualDiffMonths = true;
  var isEqualDiffYears = true;
  if (data[0] == null || data[1] == null) return [false, false, false, false, false];
  var sameDay = dayjs(data[0].m).date();
  var sameMonth = dayjs(data[0].m).month();
  var equalDiffDays = dayjs(data[1].m).diff(dayjs(data[0].m), "days");
  var equalDiffMonths = dayjs(data[1].m).diff(dayjs(data[0].m), "months");
  var equalDiffYears = dayjs(data[1].m).diff(dayjs(data[0].m), "years");

  for (var i = 1; i < data.length; i += 1) {
    var _data$i, _data$i2, _data$i3, _data, _data$i4, _data2, _data$i5, _data3;

    if (dayjs((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.m).date() !== sameDay) {
      isSameDay = false;
    }

    if (dayjs((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.m).month() !== sameMonth) {
      isSameMonth = false;
    }

    if (dayjs((_data$i3 = data[i]) === null || _data$i3 === void 0 ? void 0 : _data$i3.m).diff(dayjs((_data = data[i - 1]) === null || _data === void 0 ? void 0 : _data.m), "days") !== equalDiffDays) {
      isEqualDiffDays = false;
    }

    if (dayjs((_data$i4 = data[i]) === null || _data$i4 === void 0 ? void 0 : _data$i4.m).diff(dayjs((_data2 = data[i - 1]) === null || _data2 === void 0 ? void 0 : _data2.m), "months") !== equalDiffMonths) {
      isEqualDiffMonths = false;
    }

    if (dayjs((_data$i5 = data[i]) === null || _data$i5 === void 0 ? void 0 : _data$i5.m).diff(dayjs((_data3 = data[i - 1]) === null || _data3 === void 0 ? void 0 : _data3.m), "years") !== equalDiffYears) {
      isEqualDiffYears = false;
    }
  }

  if (equalDiffDays === 0) {
    isEqualDiffDays = false;
  }

  if (equalDiffMonths === 0) {
    isEqualDiffMonths = false;
  }

  if (equalDiffYears === 0) {
    isEqualDiffYears = false;
  }

  return [isSameDay, isSameMonth, isEqualDiffDays, isEqualDiffMonths, isEqualDiffYears];
}

function showDropCellSelection(_ref, container) {
  var width = _ref.width,
      height = _ref.height,
      top = _ref.top,
      left = _ref.left;
  var selectedExtend = container.querySelector(".fortune-cell-selected-extend");

  if (selectedExtend) {
    selectedExtend.style.left = toPx(left);
    selectedExtend.style.width = toPx(width);
    selectedExtend.style.top = toPx(top);
    selectedExtend.style.height = toPx(height);
    selectedExtend.style.display = "block";
  }
}
function hideDropCellSelection(container) {
  var selectedExtend = container.querySelector(".fortune-cell-selected-extend");

  if (selectedExtend) {
    selectedExtend.style.display = "none";
  }
}
function createDropCellRange(ctx, e, container) {
  ctx.luckysheet_cell_selected_extend = true;
  ctx.luckysheet_scroll_status = true;
  var scrollLeft = ctx.scrollLeft,
      scrollTop = ctx.scrollTop;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollLeft;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollTop;
  var row_location = rowLocation(y, ctx.visibledatarow);
  var row_pre = row_location[0];
  var row = row_location[1];
  var row_index = row_location[2];
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col_pre = col_location[0];
  var col = col_location[1];
  var col_index = col_location[2];
  ctx.luckysheet_cell_selected_extend_index = [row_index, col_index];
  showDropCellSelection({
    left: col_pre,
    width: col - col_pre - 1,
    top: row_pre,
    height: row - row_pre - 1
  }, container);
}
function onDropCellSelect(ctx, e, scrollX, scrollY, container) {
  var scrollLeft = scrollX.scrollLeft;
  var scrollTop = scrollY.scrollTop;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollLeft;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollTop;
  var row_location = rowLocation(y, ctx.visibledatarow);
  var row = row_location[1];
  var row_pre = row_location[0];
  var row_index = row_location[2];
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col = col_location[1];
  var col_pre = col_location[0];
  var col_index = col_location[2];
  var row_index_original = ctx.luckysheet_cell_selected_extend_index[0];
  var col_index_original = ctx.luckysheet_cell_selected_extend_index[1];
  if (!ctx.luckysheet_select_save) return;
  var row_s = ctx.luckysheet_select_save[0].row[0];
  var row_e = ctx.luckysheet_select_save[0].row[1];
  var col_s = ctx.luckysheet_select_save[0].column[0];
  var col_e = ctx.luckysheet_select_save[0].column[1];
  var top = ctx.luckysheet_select_save[0].top_move;
  var height = ctx.luckysheet_select_save[0].height_move;
  var left = ctx.luckysheet_select_save[0].left_move;
  var width = ctx.luckysheet_select_save[0].width_move;
  if (top == null || height == null || left == null || width == null) return;

  if (Math.abs(row_index_original - row_index) > Math.abs(col_index_original - col_index)) {
    if (!(row_index >= row_s && row_index <= row_e)) {
      if (top >= row_pre) {
        height += top - row_pre;
        top = row_pre;
      } else {
        height = row - top - 1;
      }
    }
  } else {
    if (!(col_index >= col_s && col_index <= col_e)) {
      if (left >= col_pre) {
        width += left - col_pre;
        left = col_pre;
      } else {
        width = col - left - 1;
      }
    }
  }

  if (y < 0) {
    row_s = 0;

    var _ctx$luckysheet_selec = _slicedToArray(ctx.luckysheet_select_save[0].row, 1);

    row_e = _ctx$luckysheet_selec[0];
  }

  if (x < 0) {
    col_s = 0;

    var _ctx$luckysheet_selec2 = _slicedToArray(ctx.luckysheet_select_save[0].column, 1);

    col_e = _ctx$luckysheet_selec2[0];
  }

  showDropCellSelection({
    left: left,
    width: width,
    top: top,
    height: height
  }, container);
}

function fillCopy(data, len) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    if (!_.isUndefined(d)) {
      applyData.push(d);
    }
  }

  return applyData;
}

function fillSeries(data, len, direction) {
  var applyData = [];
  var dataNumArr = [];

  for (var j = 0; j < data.length; j += 1) {
    var d = _.cloneDeep(data[j]);

    if (d != null) {
      dataNumArr.push(Number(d.v));
    }
  }

  if (data.length > 2 && isEqualRatio(dataNumArr) && data[0] != null && data[1] != null) {
    for (var i = 1; i <= len; i += 1) {
      var index = (i - 1) % data.length;

      var _d = _.cloneDeep(data[index]);

      if (_d != null) {
        var num = void 0;

        if (direction === "down" || direction === "right") {
          num = Number(data[data.length - 1].v) * Math.pow(Number(data[1].v) / Number(data[0].v), i);
        } else {
          num = Number(data[0].v) / Math.pow(Number(data[1].v) / Number(data[0].v), i);
        }

        _d.v = num;

        if (_d.ct != null && _d.ct.fa != null) {
          _d.m = update(_d.ct.fa, num);
        }

        applyData.push(_d);
      }
    }
  } else {
    var xArr = getXArr(data.length);

    for (var _i = 1; _i <= len; _i += 1) {
      var _index = (_i - 1) % data.length;

      var _d2 = _.cloneDeep(data[_index]);

      if (_d2 != null) {
        var y = void 0;

        if (direction === "down" || direction === "right") {
          y = forecast(data.length + _i, dataNumArr, xArr);
        } else if (direction === "up" || direction === "left") {
          y = forecast(1 - _i, dataNumArr, xArr);
        }

        _d2.v = y;

        if (_d2.ct != null && _d2.ct.fa != null) {
          _d2.m = update(_d2.ct.fa, y);
        }

        applyData.push(_d2);
      }
    }
  }

  return applyData;
}

function fillExtendNumber(data, len, step) {
  var applyData = [];
  var reg = /0|([1-9]+[0-9]*)/g;

  for (var i = 1; i <= len; i += 1) {
    var _data4;

    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    var last = (_data4 = data[data.length - 1]) === null || _data4 === void 0 ? void 0 : _data4.m;

    if (d != null && last != null) {
      last = "".concat(last);
      var match = last.match(reg) || "";
      var lastTxt = match[match.length - 1];
      var num = Math.abs(Number(lastTxt) + step * i);
      var lastIndex = last.lastIndexOf(lastTxt);
      var valueTxt = last.slice(0, lastIndex) + num.toString() + last.slice(lastIndex + lastTxt.length);
      d.v = valueTxt;
      d.m = valueTxt;
      applyData.push(d);
    }
  }

  return applyData;
}

function fillDays(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var d = _.cloneDeep(data[data.length - 1]);

    if (d != null) {
      var _genarate;

      var date = update("yyyy-MM-dd", d.v);
      date = dayjs(date).add(step * i, "days").format("YYYY-MM-DD");
      d.v = (_genarate = genarate(date)) === null || _genarate === void 0 ? void 0 : _genarate[2];

      if (d.ct != null && d.ct.fa != null) {
        d.m = update(d.ct.fa, d.v);
      }

      applyData.push(d);
    }
  }

  return applyData;
}

function fillMonths(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var d = _.cloneDeep(data[data.length - 1]);

    if (d != null) {
      var _genarate2;

      var date = update("yyyy-MM-dd", d.v);
      date = dayjs(date).add(step * i, "months").format("YYYY-MM-DD");
      d.v = (_genarate2 = genarate(date)) === null || _genarate2 === void 0 ? void 0 : _genarate2[2];

      if (d.ct != null && d.ct.fa != null) {
        d.m = update(d.ct.fa, d.v);
      }

      applyData.push(d);
    }
  }

  return applyData;
}

function fillYears(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var d = _.cloneDeep(data[data.length - 1]);

    if (d != null) {
      var _genarate3;

      var date = update("yyyy-MM-dd", d.v);
      date = dayjs(date).add(step * i, "years").format("YYYY-MM-DD");
      d.v = (_genarate3 = genarate(date)) === null || _genarate3 === void 0 ? void 0 : _genarate3[2];

      if (d.ct != null && d.ct.fa != null) {
        d.m = update(d.ct.fa, d.v);
      }
    }

    applyData.push(d);
  }

  return applyData;
}

function fillChnWeek(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var _data5;

    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    var num = void 0;
    var m = (_data5 = data[data.length - 1]) === null || _data5 === void 0 ? void 0 : _data5.m;

    if (m != null && d != null) {
      if (m === "日") {
        num = 7 + step * i;
      } else {
        num = chineseToNumber("".concat(m)) + step * i;
      }

      if (num < 0) {
        num = Math.ceil(Math.abs(num) / 7) * 7 + num;
      }

      var rsd = num % 7;

      if (rsd === 0) {
        d.m = "日";
        d.v = "日";
      } else if (rsd === 1) {
        d.m = "一";
        d.v = "一";
      } else if (rsd === 2) {
        d.m = "二";
        d.v = "二";
      } else if (rsd === 3) {
        d.m = "三";
        d.v = "三";
      } else if (rsd === 4) {
        d.m = "四";
        d.v = "四";
      } else if (rsd === 5) {
        d.m = "五";
        d.v = "五";
      } else if (rsd === 6) {
        d.m = "六";
        d.v = "六";
      }

      applyData.push(d);
    }
  }

  return applyData;
}

function fillChnWeek2(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var _data6;

    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    var num = void 0;
    var m = (_data6 = data[data.length - 1]) === null || _data6 === void 0 ? void 0 : _data6.m;

    if (m != null && d != null) {
      if (m === "周日") {
        num = 7 + step * i;
      } else {
        var last = "".concat(m);
        var txt = last.slice(last.length - 1, 1);
        num = chineseToNumber(txt) + step * i;
      }

      if (num < 0) {
        num = Math.ceil(Math.abs(num) / 7) * 7 + num;
      }

      var rsd = num % 7;

      if (rsd === 0) {
        d.m = "周日";
        d.v = "周日";
      } else if (rsd === 1) {
        d.m = "周一";
        d.v = "周一";
      } else if (rsd === 2) {
        d.m = "周二";
        d.v = "周二";
      } else if (rsd === 3) {
        d.m = "周三";
        d.v = "周三";
      } else if (rsd === 4) {
        d.m = "周四";
        d.v = "周四";
      } else if (rsd === 5) {
        d.m = "周五";
        d.v = "周五";
      } else if (rsd === 6) {
        d.m = "周六";
        d.v = "周六";
      }
    }

    applyData.push(d);
  }

  return applyData;
}

function fillChnWeek3(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var _data7;

    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    var num = void 0;
    var m = (_data7 = data[data.length - 1]) === null || _data7 === void 0 ? void 0 : _data7.m;

    if (m != null && d != null) {
      if (m === "星期日") {
        num = 7 + step * i;
      } else {
        var last = "".concat(m);
        var txt = last.slice(last.length - 1, 1);
        num = chineseToNumber(txt) + step * i;
      }

      if (num < 0) {
        num = Math.ceil(Math.abs(num) / 7) * 7 + num;
      }

      var rsd = num % 7;

      if (rsd === 0) {
        d.m = "星期日";
        d.v = "星期日";
      } else if (rsd === 1) {
        d.m = "星期一";
        d.v = "星期一";
      } else if (rsd === 2) {
        d.m = "星期二";
        d.v = "星期二";
      } else if (rsd === 3) {
        d.m = "星期三";
        d.v = "星期三";
      } else if (rsd === 4) {
        d.m = "星期四";
        d.v = "星期四";
      } else if (rsd === 5) {
        d.m = "星期五";
        d.v = "星期五";
      } else if (rsd === 6) {
        d.m = "星期六";
        d.v = "星期六";
      }
    }

    applyData.push(d);
  }

  return applyData;
}

function fillChnNumber(data, len, step) {
  var applyData = [];

  for (var i = 1; i <= len; i += 1) {
    var _data8;

    var index = (i - 1) % data.length;

    var d = _.cloneDeep(data[index]);

    var m = (_data8 = data[data.length - 1]) === null || _data8 === void 0 ? void 0 : _data8.m;

    if (m != null && d != null) {
      var num = chineseToNumber("".concat(m)) + step * i;
      var txt = void 0;

      if (num <= 0) {
        txt = "零";
      } else {
        txt = numberToChinese(num);
      }

      d.v = txt;
      d.m = txt.toString();
      applyData.push(d);
    }
  }

  return applyData;
}

function getTypeItemHide(ctx) {
  var copyRange = dropCellCache.copyRange;
  var str_r = copyRange.row[0];
  var end_r = copyRange.row[1];
  var str_c = copyRange.column[0];
  var end_c = copyRange.column[1];
  var hasNumber = false;
  var hasExtendNumber = false;
  var hasDate = false;
  var hasChn = false;
  var hasChnWeek1 = false;
  var hasChnWeek2 = false;
  var hasChnWeek3 = false;
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return [];

  for (var r = str_r; r <= end_r; r += 1) {
    for (var c = str_c; c <= end_c; c += 1) {
      if (flowdata[r][c]) {
        var cell = flowdata[r][c];

        if (cell !== null && cell.v != null && cell.f == null) {
          if (cell.ct != null && cell.ct.t === "n") {
            hasNumber = true;
          } else if (cell.ct != null && cell.ct.t === "d") {
            hasDate = true;
          } else if (isExtendNumber(cell.m)[0]) {
            hasExtendNumber = true;
          } else if (isChnNumber(cell.m) && cell.m !== "日") {
            hasChn = true;
          } else if (cell.m != null && cell.m === "日") {
            hasChnWeek1 = true;
          } else if (isChnWeek2(cell.m)) {
            hasChnWeek2 = true;
          } else if (isChnWeek3(cell.m)) {
            hasChnWeek3 = true;
          }
        }
      }
    }
  }

  return [hasNumber, hasExtendNumber, hasDate, hasChn, hasChnWeek1, hasChnWeek2, hasChnWeek3];
}

function getLenS(indexArr, rsd) {
  var s = 0;

  for (var j = 0; j < indexArr.length; j += 1) {
    if (indexArr[j] <= rsd) {
      s += 1;
    } else {
      break;
    }
  }

  return s;
}

function getDataIndex(csLen, asLen, indexArr) {
  var obj = {};
  var num = Math.floor(asLen / csLen);
  var rsd = asLen % csLen;
  var sum = 0;

  if (num > 0) {
    for (var i = 1; i <= num; i += 1) {
      for (var j = 0; j < indexArr.length; j += 1) {
        obj[indexArr[j] + (i - 1) * csLen] = sum;
        sum += 1;
      }
    }

    for (var a = 0; a < indexArr.length; a += 1) {
      if (indexArr[a] <= rsd) {
        obj[indexArr[a] + csLen * num] = sum;
        sum += 1;
      } else {
        break;
      }
    }
  } else {
    for (var _a = 0; _a < indexArr.length; _a += 1) {
      if (indexArr[_a] <= rsd) {
        obj[indexArr[_a]] = sum;
        sum += 1;
      } else {
        break;
      }
    }
  }

  return obj;
}

function getDataByType(data, len, direction, type, dataType) {
  data = _.cloneDeep(data);
  var applyData = [];

  if (type === "0" || data.length === 1) {
    if (direction === "up" || direction === "left") {
      data.reverse();
    }

    applyData = fillCopy(data, len);
  } else if (type === "1") {
    var _data$5;

    if (dataType === "number") {
      applyData = fillSeries(data, len, direction);
    } else if (dataType === "extendNumber") {
      var dataNumArr = [];

      for (var i = 0; i < data.length; i += 1) {
        var _data$i6;

        var txt = (_data$i6 = data[i]) === null || _data$i6 === void 0 ? void 0 : _data$i6.m;

        var _isExtendNumber = isExtendNumber(txt);

        if (_isExtendNumber[0]) {
          dataNumArr.push(_isExtendNumber[1]);
        }
      }

      if (direction === "up" || direction === "left") {
        data.reverse();
        dataNumArr.reverse();
      }

      if (isEqualDiff(dataNumArr)) {
        var step = dataNumArr[1] - dataNumArr[0];
        applyData = fillExtendNumber(data, len, step);
      } else {
        applyData = fillCopy(data, len);
      }
    } else if (dataType === "date") {
      if (direction === "up" || direction === "left") {
        data.reverse();
      }

      var _judgeDate = judgeDate(data);

      if (_judgeDate[0] && _judgeDate[3]) {
        var _data$, _data$2;

        var _step = dayjs((_data$ = data[1]) === null || _data$ === void 0 ? void 0 : _data$.m).diff(dayjs((_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.m), "months");

        applyData = fillMonths(data, len, _step);
      } else if (!_judgeDate[0] && _judgeDate[2]) {
        var _data$3, _data$4;

        var _step2 = dayjs((_data$3 = data[1]) === null || _data$3 === void 0 ? void 0 : _data$3.m).diff(dayjs((_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.m), "days");

        applyData = fillDays(data, len, _step2);
      } else {
        applyData = fillCopy(data, len);
      }
    } else if (dataType === "chnNumber" && ((_data$5 = data[0]) === null || _data$5 === void 0 ? void 0 : _data$5.m) != null) {
      var hasweek = false;

      for (var _i2 = 0; _i2 < data.length; _i2 += 1) {
        var _data$_i;

        if (((_data$_i = data[_i2]) === null || _data$_i === void 0 ? void 0 : _data$_i.m) === "日") {
          hasweek = true;
          break;
        }
      }

      var _dataNumArr = [];
      var weekIndex = 0;

      for (var _i3 = 0; _i3 < data.length; _i3 += 1) {
        var _data$_i2;

        var m = (_data$_i2 = data[_i3]) === null || _data$_i2 === void 0 ? void 0 : _data$_i2.m;

        if (m != null) {
          m = "".concat(m);

          if (m === "日") {
            if (_i3 === 0) {
              _dataNumArr.push(0);
            } else {
              weekIndex += 1;

              _dataNumArr.push(weekIndex * 7);
            }
          } else if (hasweek && chineseToNumber(m) > 0 && chineseToNumber(m) < 7) {
            _dataNumArr.push(chineseToNumber(m) + weekIndex * 7);
          } else {
            _dataNumArr.push(chineseToNumber(m));
          }
        }
      }

      if (direction === "up" || direction === "left") {
        data.reverse();

        _dataNumArr.reverse();
      }

      if (isEqualDiff(_dataNumArr)) {
        if (hasweek || _dataNumArr[_dataNumArr.length - 1] < 6 && _dataNumArr[0] > 0 || _dataNumArr[0] < 6 && _dataNumArr[_dataNumArr.length - 1] > 0) {
          var _step3 = _dataNumArr[1] - _dataNumArr[0];

          applyData = fillChnWeek(data, len, _step3);
        } else {
          var _step4 = _dataNumArr[1] - _dataNumArr[0];

          applyData = fillChnNumber(data, len, _step4);
        }
      } else {
        applyData = fillCopy(data, len);
      }
    } else if (dataType === "chnWeek2") {
      var _dataNumArr2 = [];
      var _weekIndex = 0;

      for (var _i4 = 0; _i4 < data.length; _i4 += 1) {
        var _data$_i3;

        var _m = (_data$_i3 = data[_i4]) === null || _data$_i3 === void 0 ? void 0 : _data$_i3.m;

        if (_m != null) {
          _m = "".concat(_m);

          var lastTxt = _m.slice(_m.length - 1, 1);

          if (_m === "周日") {
            if (_i4 === 0) {
              _dataNumArr2.push(0);
            } else {
              _weekIndex += 1;

              _dataNumArr2.push(_weekIndex * 7);
            }
          } else {
            _dataNumArr2.push(chineseToNumber(lastTxt) + _weekIndex * 7);
          }
        }
      }

      if (direction === "up" || direction === "left") {
        data.reverse();

        _dataNumArr2.reverse();
      }

      if (isEqualDiff(_dataNumArr2)) {
        var _step5 = _dataNumArr2[1] - _dataNumArr2[0];

        applyData = fillChnWeek2(data, len, _step5);
      } else {
        applyData = fillCopy(data, len);
      }
    } else if (dataType === "chnWeek3") {
      var _dataNumArr3 = [];
      var _weekIndex2 = 0;

      for (var _i5 = 0; _i5 < data.length; _i5 += 1) {
        var _data$_i4;

        var _m2 = (_data$_i4 = data[_i5]) === null || _data$_i4 === void 0 ? void 0 : _data$_i4.m;

        if (_m2 != null) {
          _m2 = "".concat(_m2);

          var _lastTxt = _m2.slice(_m2.length - 1, 1);

          if (_m2 === "星期日") {
            if (_i5 === 0) {
              _dataNumArr3.push(0);
            } else {
              _weekIndex2 += 1;

              _dataNumArr3.push(_weekIndex2 * 7);
            }
          } else {
            _dataNumArr3.push(chineseToNumber(_lastTxt) + _weekIndex2 * 7);
          }
        }
      }

      if (direction === "up" || direction === "left") {
        data.reverse();

        _dataNumArr3.reverse();
      }

      if (isEqualDiff(_dataNumArr3)) {
        var _step6 = _dataNumArr3[1] - _dataNumArr3[0];

        applyData = fillChnWeek3(data, len, _step6);
      } else {
        applyData = fillCopy(data, len);
      }
    } else {
      if (direction === "up" || direction === "left") {
        data.reverse();
      }

      applyData = fillCopy(data, len);
    }
  } else if (type === "4") {
    if (data.length === 2) {
      var _data$6, _data$7;

      if (direction === "up" || direction === "left") {
        data.reverse();
      }

      var _step7 = dayjs((_data$6 = data[1]) === null || _data$6 === void 0 ? void 0 : _data$6.m).diff(dayjs((_data$7 = data[0]) === null || _data$7 === void 0 ? void 0 : _data$7.m), "days");

      applyData = fillDays(data, len, _step7);
    } else {
      if (direction === "up" || direction === "left") {
        data.reverse();
      }

      var _judgeDate2 = judgeDate(data);

      if (_judgeDate2[0] && _judgeDate2[3]) {
        var _data$8, _data$9;

        var _step8 = dayjs((_data$8 = data[1]) === null || _data$8 === void 0 ? void 0 : _data$8.m).diff(dayjs((_data$9 = data[0]) === null || _data$9 === void 0 ? void 0 : _data$9.m), "months");

        applyData = fillMonths(data, len, _step8);
      } else if (!_judgeDate2[0] && _judgeDate2[2]) {
        var _data$10, _data$11;

        var _step9 = dayjs((_data$10 = data[1]) === null || _data$10 === void 0 ? void 0 : _data$10.m).diff(dayjs((_data$11 = data[0]) === null || _data$11 === void 0 ? void 0 : _data$11.m), "days");

        applyData = fillDays(data, len, _step9);
      } else {
        applyData = fillCopy(data, len);
      }
    }
  } else if (type === "5") {
    if (data.length === 2) {
      var _data$12, _data$13, _data$14, _data$15;

      if (dayjs((_data$12 = data[1]) === null || _data$12 === void 0 ? void 0 : _data$12.m).date() === dayjs((_data$13 = data[0]) === null || _data$13 === void 0 ? void 0 : _data$13.m).date() && dayjs((_data$14 = data[1]) === null || _data$14 === void 0 ? void 0 : _data$14.m).diff(dayjs((_data$15 = data[0]) === null || _data$15 === void 0 ? void 0 : _data$15.m), "months") !== 0) {
        var _data$16, _data$17;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step10 = dayjs((_data$16 = data[1]) === null || _data$16 === void 0 ? void 0 : _data$16.m).diff(dayjs((_data$17 = data[0]) === null || _data$17 === void 0 ? void 0 : _data$17.m), "months");

        for (var _i6 = 1; _i6 <= len; _i6 += 1) {
          var _data9;

          var index = (_i6 - 1) % data.length;

          var d = _.cloneDeep(data[index]);

          var last = (_data9 = data[data.length - 1]) === null || _data9 === void 0 ? void 0 : _data9.m;

          if (d != null && last != null) {
            var _genarate4;

            var day = dayjs(last).add(_step10 * _i6, "months").day();
            var date = void 0;

            if (day === 0) {
              date = dayjs(last).add(_step10 * _i6, "months").subtract(2, "days").format("YYYY-MM-DD");
            } else if (day === 6) {
              date = dayjs(last).add(_step10 * _i6, "months").subtract(1, "days").format("YYYY-MM-DD");
            } else {
              date = dayjs(last).add(_step10 * _i6, "months").format("YYYY-MM-DD");
            }

            d.m = date;
            d.v = (_genarate4 = genarate(date)) === null || _genarate4 === void 0 ? void 0 : _genarate4[2];
            applyData.push(d);
          }
        }
      } else {
        var _data$18, _data$19;

        if (Math.abs(dayjs((_data$18 = data[1]) === null || _data$18 === void 0 ? void 0 : _data$18.m).diff(dayjs((_data$19 = data[0]) === null || _data$19 === void 0 ? void 0 : _data$19.m))) > 7) {
          var step_month;

          if (direction === "down" || direction === "right") {
            step_month = 1;
          } else {
            step_month = -1;
            data.reverse();
          }

          var _step11;

          for (var _i7 = 1; _i7 <= len; _i7 += 1) {
            var _index2 = (_i7 - 1) % data.length;

            var _d3 = _.cloneDeep(data[_index2]);

            if (_d3 != null) {
              var _genarate5;

              var num = Math.ceil(_i7 / data.length);

              if (_index2 === 0) {
                _step11 = dayjs(_d3.m).add(step_month * num, "months").diff(dayjs(_d3.m), "days");
              }

              var _day = dayjs(_d3.m).add(_step11, "days").day();

              var _date = void 0;

              if (_day === 0) {
                _date = dayjs(_d3.m).add(_step11, "days").subtract(2, "days").format("YYYY-MM-DD");
              } else if (_day === 6) {
                _date = dayjs(_d3.m).add(_step11, "days").subtract(1, "days").format("YYYY-MM-DD");
              } else {
                _date = dayjs(_d3.m).add(_step11, "days").format("YYYY-MM-DD");
              }

              _d3.m = _date;
              _d3.v = (_genarate5 = genarate(_date)) === null || _genarate5 === void 0 ? void 0 : _genarate5[2];
              applyData.push(_d3);
            }
          }
        } else {
          var step_day;

          if (direction === "down" || direction === "right") {
            step_day = 7;
          } else {
            step_day = -7;
            data.reverse();
          }

          var _step12;

          for (var _i8 = 1; _i8 <= len; _i8 += 1) {
            var _index3 = (_i8 - 1) % data.length;

            var _d4 = _.cloneDeep(data[_index3]);

            if (_d4 != null) {
              var _genarate6;

              var _num = Math.ceil(_i8 / data.length);

              if (_index3 === 0) {
                _step12 = dayjs(_d4.m).add(step_day * _num, "days").diff(dayjs(_d4.m), "days");
              }

              var _day2 = dayjs(_d4.m).add(_step12, "days").day();

              var _date2 = void 0;

              if (_day2 === 0) {
                _date2 = dayjs(_d4.m).add(_step12, "days").subtract(2, "days").format("YYYY-MM-DD");
              } else if (_day2 === 6) {
                _date2 = dayjs(_d4.m).add(_step12, "days").subtract(1, "days").format("YYYY-MM-DD");
              } else {
                _date2 = dayjs(_d4.m).add(_step12, "days").format("YYYY-MM-DD");
              }

              _d4.m = _date2;
              _d4.v = (_genarate6 = genarate(_date2)) === null || _genarate6 === void 0 ? void 0 : _genarate6[2];
              applyData.push(_d4);
            }
          }
        }
      }
    } else {
      var _judgeDate3 = judgeDate(data);

      if (_judgeDate3[0] && _judgeDate3[3]) {
        var _data$20, _data$21;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step13 = dayjs((_data$20 = data[1]) === null || _data$20 === void 0 ? void 0 : _data$20.m).diff(dayjs((_data$21 = data[0]) === null || _data$21 === void 0 ? void 0 : _data$21.m), "months");

        for (var _i9 = 1; _i9 <= len; _i9 += 1) {
          var _data10;

          var _index4 = (_i9 - 1) % data.length;

          var _d5 = _.cloneDeep(data[_index4]);

          var _last = (_data10 = data[data.length - 1]) === null || _data10 === void 0 ? void 0 : _data10.m;

          if (_d5 != null) {
            var _genarate7;

            var _day3 = dayjs(_last).add(_step13 * _i9, "months").day();

            var _date3 = void 0;

            if (_day3 === 0) {
              _date3 = dayjs(_last).add(_step13 * _i9, "months").subtract(2, "days").format("YYYY-MM-DD");
            } else if (_day3 === 6) {
              _date3 = dayjs(_last).add(_step13 * _i9, "months").subtract(1, "days").format("YYYY-MM-DD");
            } else {
              _date3 = dayjs(_last).add(_step13 * _i9, "months").format("YYYY-MM-DD");
            }

            _d5.m = _date3;
            _d5.v = (_genarate7 = genarate(_date3)) === null || _genarate7 === void 0 ? void 0 : _genarate7[2];
            applyData.push(_d5);
          }
        }
      } else if (!_judgeDate3[0] && _judgeDate3[2]) {
        var _data$22, _data$23;

        if (Math.abs(dayjs((_data$22 = data[1]) === null || _data$22 === void 0 ? void 0 : _data$22.m).diff(dayjs((_data$23 = data[0]) === null || _data$23 === void 0 ? void 0 : _data$23.m))) > 7) {
          var _step_month;

          if (direction === "down" || direction === "right") {
            _step_month = 1;
          } else {
            _step_month = -1;
            data.reverse();
          }

          var _step14;

          for (var _i10 = 1; _i10 <= len; _i10 += 1) {
            var _index5 = (_i10 - 1) % data.length;

            var _d6 = _.cloneDeep(data[_index5]);

            if (_d6 != null) {
              var _genarate8;

              var _num2 = Math.ceil(_i10 / data.length);

              if (_index5 === 0) {
                _step14 = dayjs(_d6.m).add(_step_month * _num2, "months").diff(dayjs(_d6.m), "days");
              }

              var _day4 = dayjs(_d6.m).add(_step14, "days").day();

              var _date4 = void 0;

              if (_day4 === 0) {
                _date4 = dayjs(_d6.m).add(_step14, "days").subtract(2, "days").format("YYYY-MM-DD");
              } else if (_day4 === 6) {
                _date4 = dayjs(_d6.m).add(_step14, "days").subtract(1, "days").format("YYYY-MM-DD");
              } else {
                _date4 = dayjs(_d6.m).add(_step14, "days").format("YYYY-MM-DD");
              }

              _d6.m = _date4;
              _d6.v = (_genarate8 = genarate(_date4)) === null || _genarate8 === void 0 ? void 0 : _genarate8[2];
              applyData.push(_d6);
            }
          }
        } else {
          var _step_day;

          if (direction === "down" || direction === "right") {
            _step_day = 7;
          } else {
            _step_day = -7;
            data.reverse();
          }

          var _step15;

          for (var _i11 = 1; _i11 <= len; _i11 += 1) {
            var _index6 = (_i11 - 1) % data.length;

            var _d7 = _.cloneDeep(data[_index6]);

            if (_d7 != null) {
              var _genarate9;

              var _num3 = Math.ceil(_i11 / data.length);

              if (_index6 === 0) {
                _step15 = dayjs(_d7.m).add(_step_day * _num3, "days").diff(dayjs(_d7.m), "days");
              }

              var _day5 = dayjs(_d7.m).add(_step15, "days").day();

              var _date5 = void 0;

              if (_day5 === 0) {
                _date5 = dayjs(_d7.m).add(_step15, "days").subtract(2, "days").format("YYYY-MM-DD");
              } else if (_day5 === 6) {
                _date5 = dayjs(_d7.m).add(_step15, "days").subtract(1, "days").format("YYYY-MM-DD");
              } else {
                _date5 = dayjs(_d7.m).add(_step15, "days").format("YYYY-MM-DD");
              }

              _d7.m = _date5;
              _d7.v = (_genarate9 = genarate(_date5)) === null || _genarate9 === void 0 ? void 0 : _genarate9[2];
              applyData.push(_d7);
            }
          }
        }
      } else {
        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        applyData = fillCopy(data, len);
      }
    }
  } else if (type === "6") {
    if (data.length === 2) {
      var _data$24, _data$25, _data$26, _data$27;

      if (dayjs((_data$24 = data[1]) === null || _data$24 === void 0 ? void 0 : _data$24.m).date() === dayjs((_data$25 = data[0]) === null || _data$25 === void 0 ? void 0 : _data$25.m).date() && dayjs((_data$26 = data[1]) === null || _data$26 === void 0 ? void 0 : _data$26.m).diff(dayjs((_data$27 = data[0]) === null || _data$27 === void 0 ? void 0 : _data$27.m), "months") !== 0) {
        var _data$28, _data$29;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step16 = dayjs((_data$28 = data[1]) === null || _data$28 === void 0 ? void 0 : _data$28.m).diff(dayjs((_data$29 = data[0]) === null || _data$29 === void 0 ? void 0 : _data$29.m), "months");

        applyData = fillMonths(data, len, _step16);
      } else {
        var _step_month2;

        if (direction === "down" || direction === "right") {
          _step_month2 = 1;
        } else {
          _step_month2 = -1;
          data.reverse();
        }

        var _step17;

        for (var _i12 = 1; _i12 <= len; _i12 += 1) {
          var _index7 = (_i12 - 1) % data.length;

          var _d8 = _.cloneDeep(data[_index7]);

          if (_d8 != null) {
            var _genarate10;

            var _num4 = Math.ceil(_i12 / data.length);

            if (_index7 === 0) {
              _step17 = dayjs(_d8.m).add(_step_month2 * _num4, "months").diff(dayjs(_d8.m), "days");
            }

            var _date6 = dayjs(_d8.m).add(_step17, "days").format("YYYY-MM-DD");

            _d8.m = _date6;
            _d8.v = (_genarate10 = genarate(_date6)) === null || _genarate10 === void 0 ? void 0 : _genarate10[2];
            applyData.push(_d8);
          }
        }
      }
    } else {
      var _judgeDate4 = judgeDate(data);

      if (_judgeDate4[0] && _judgeDate4[3]) {
        var _data$30, _data$31;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step18 = dayjs((_data$30 = data[1]) === null || _data$30 === void 0 ? void 0 : _data$30.m).diff(dayjs((_data$31 = data[0]) === null || _data$31 === void 0 ? void 0 : _data$31.m), "months");

        applyData = fillMonths(data, len, _step18);
      } else if (!_judgeDate4[0] && _judgeDate4[2]) {
        var _step_month3;

        if (direction === "down" || direction === "right") {
          _step_month3 = 1;
        } else {
          _step_month3 = -1;
          data.reverse();
        }

        var _step19;

        for (var _i13 = 1; _i13 <= len; _i13 += 1) {
          var _index8 = (_i13 - 1) % data.length;

          var _d9 = _.cloneDeep(data[_index8]);

          if (_d9 != null) {
            var _genarate11;

            var _num5 = Math.ceil(_i13 / data.length);

            if (_index8 === 0) {
              _step19 = dayjs(_d9.m).add(_step_month3 * _num5, "months").diff(dayjs(_d9.m), "days");
            }

            var _date7 = dayjs(_d9.m).add(_step19, "days").format("YYYY-MM-DD");

            _d9.m = _date7;
            _d9.v = (_genarate11 = genarate(_date7)) === null || _genarate11 === void 0 ? void 0 : _genarate11[2];
            applyData.push(_d9);
          }
        }
      } else {
        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        applyData = fillCopy(data, len);
      }
    }
  } else if (type === "7") {
    if (data.length === 2) {
      var _data$32, _data$33, _data$34, _data$35, _data$36, _data$37;

      if (dayjs((_data$32 = data[1]) === null || _data$32 === void 0 ? void 0 : _data$32.m).date() === dayjs((_data$33 = data[0]) === null || _data$33 === void 0 ? void 0 : _data$33.m).date() && dayjs((_data$34 = data[1]) === null || _data$34 === void 0 ? void 0 : _data$34.m).month() === dayjs((_data$35 = data[0]) === null || _data$35 === void 0 ? void 0 : _data$35.m).month() && dayjs((_data$36 = data[1]) === null || _data$36 === void 0 ? void 0 : _data$36.m).diff(dayjs((_data$37 = data[0]) === null || _data$37 === void 0 ? void 0 : _data$37.m), "years") !== 0) {
        var _data$38, _data$39;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step20 = dayjs((_data$38 = data[1]) === null || _data$38 === void 0 ? void 0 : _data$38.m).diff(dayjs((_data$39 = data[0]) === null || _data$39 === void 0 ? void 0 : _data$39.m), "years");

        applyData = fillYears(data, len, _step20);
      } else {
        var step_year;

        if (direction === "down" || direction === "right") {
          step_year = 1;
        } else {
          step_year = -1;
          data.reverse();
        }

        var _step21;

        for (var _i14 = 1; _i14 <= len; _i14 += 1) {
          var _index9 = (_i14 - 1) % data.length;

          var _d10 = _.cloneDeep(data[_index9]);

          if (_d10 != null) {
            var _genarate12;

            var _num6 = Math.ceil(_i14 / data.length);

            if (_index9 === 0) {
              _step21 = dayjs(_d10.m).add(step_year * _num6, "years").diff(dayjs(_d10.m), "days");
            }

            var _date8 = dayjs(_d10.m).add(_step21, "days").format("YYYY-MM-DD");

            _d10.m = _date8;
            _d10.v = (_genarate12 = genarate(_date8)) === null || _genarate12 === void 0 ? void 0 : _genarate12[2];
            applyData.push(_d10);
          }
        }
      }
    } else {
      var _judgeDate5 = judgeDate(data);

      if (_judgeDate5[0] && _judgeDate5[1] && _judgeDate5[4]) {
        var _data$40, _data$41;

        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        var _step22 = dayjs((_data$40 = data[1]) === null || _data$40 === void 0 ? void 0 : _data$40.m).diff(dayjs((_data$41 = data[0]) === null || _data$41 === void 0 ? void 0 : _data$41.m), "years");

        applyData = fillYears(data, len, _step22);
      } else if (_judgeDate5[0] && _judgeDate5[3] || _judgeDate5[2]) {
        var _step_year;

        if (direction === "down" || direction === "right") {
          _step_year = 1;
        } else {
          _step_year = -1;
          data.reverse();
        }

        var _step23;

        for (var _i15 = 1; _i15 <= len; _i15 += 1) {
          var _index10 = (_i15 - 1) % data.length;

          var _d11 = _.cloneDeep(data[_index10]);

          var _num7 = Math.ceil(_i15 / data.length);

          if (_d11 != null) {
            var _genarate13;

            if (_index10 === 0) {
              _step23 = dayjs(_d11.m).add(_step_year * _num7, "years").diff(dayjs(_d11.m), "days");
            }

            var _date9 = dayjs(_d11.m).add(_step23, "days").format("YYYY-MM-DD");

            _d11.m = _date9;
            _d11.v = (_genarate13 = genarate(_date9)) === null || _genarate13 === void 0 ? void 0 : _genarate13[2];
            applyData.push(_d11);
          }
        }
      } else {
        if (direction === "up" || direction === "left") {
          data.reverse();
        }

        applyData = fillCopy(data, len);
      }
    }
  } else if (type === "8") {
    var _dataNumArr4 = [];

    for (var _i16 = 0; _i16 < data.length; _i16 += 1) {
      var _data$_i5;

      var _m3 = (_data$_i5 = data[_i16]) === null || _data$_i5 === void 0 ? void 0 : _data$_i5.m;

      if (_m3 != null) {
        _m3 = "".concat(_m3);

        _dataNumArr4.push(chineseToNumber(_m3));
      }
    }

    if (direction === "up" || direction === "left") {
      data.reverse();

      _dataNumArr4.reverse();
    }

    if (isEqualDiff(_dataNumArr4)) {
      var _step24 = _dataNumArr4[1] - _dataNumArr4[0];

      applyData = fillChnNumber(data, len, _step24);
    } else {
      applyData = fillCopy(data, len);
    }
  }

  return applyData;
}

function getCopyData(d, r1, r2, c1, c2, direction) {
  var copyData = [];
  var a1;
  var a2;
  var b1;
  var b2;

  if (direction === "down" || direction === "up") {
    a1 = c1;
    a2 = c2;
    b1 = r1;
    b2 = r2;
  } else {
    a1 = r1;
    a2 = r2;
    b1 = c1;
    b2 = c2;
  }

  for (var a = a1; a <= a2; a += 1) {
    var obj = {};
    var arrData = [];
    var arrIndex = [];
    var text = "";
    var extendNumberBeforeStr = null;
    var extendNumberAfterStr = null;
    var isSameStr = true;

    for (var b = b1; b <= b2; b += 1) {
      var _data11;

      var data = void 0;

      if (direction === "down" || direction === "up") {
        data = d[b][a];
      } else if (direction === "right" || direction === "left") {
        data = d[a][b];
      }

      var str = void 0;

      if (((_data11 = data) === null || _data11 === void 0 ? void 0 : _data11.v) != null && data.f == null) {
        if (!!data.ct && data.ct.t === "n") {
          str = "number";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        } else if (!!data.ct && data.ct.t === "d") {
          str = "date";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        } else if (isExtendNumber(data.m)[0]) {
          str = "extendNumber";

          var _isExtendNumber = isExtendNumber(data.m);

          if (extendNumberBeforeStr == null || extendNumberAfterStr == null) {
            isSameStr = true;

            var _isExtendNumber2 = _slicedToArray(_isExtendNumber, 4);

            extendNumberBeforeStr = _isExtendNumber2[2];
            extendNumberAfterStr = _isExtendNumber2[3];
          } else {
            if (_isExtendNumber[2] !== extendNumberBeforeStr || _isExtendNumber[3] !== extendNumberAfterStr) {
              isSameStr = false;

              var _isExtendNumber3 = _slicedToArray(_isExtendNumber, 4);

              extendNumberBeforeStr = _isExtendNumber3[2];
              extendNumberAfterStr = _isExtendNumber3[3];
            } else {
              isSameStr = true;
            }
          }
        } else if (isChnNumber(data.m)) {
          str = "chnNumber";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        } else if (isChnWeek2(data.m)) {
          str = "chnWeek2";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        } else if (isChnWeek3(data.m)) {
          str = "chnWeek3";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        } else {
          str = "other";
          extendNumberBeforeStr = null;
          extendNumberAfterStr = null;
        }
      } else {
        str = "other";
        extendNumberBeforeStr = null;
        extendNumberAfterStr = null;
      }

      if (str === "extendNumber") {
        if (b === b1) {
          if (b1 === b2) {
            text = str;
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
            obj[text] = [];
            obj[text].push({
              data: arrData,
              index: arrIndex
            });
          } else {
            text = str;
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
          }
        } else if (b === b2) {
          if (text === str && isSameStr) {
            arrData.push(data);
            arrIndex.push(b - b1 + 1);

            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }
          } else {
            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }

            text = str;
            arrData = [];
            arrData.push(data);
            arrIndex = [];
            arrIndex.push(b - b1 + 1);

            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }
          }
        } else {
          if (text === str && isSameStr) {
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
          } else {
            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }

            text = str;
            arrData = [];
            arrData.push(data);
            arrIndex = [];
            arrIndex.push(b - b1 + 1);
          }
        }
      } else {
        if (b === b1) {
          if (b1 === b2) {
            text = str;
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
            obj[text] = [];
            obj[text].push({
              data: arrData,
              index: arrIndex
            });
          } else {
            text = str;
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
          }
        } else if (b === b2) {
          if (text === str) {
            arrData.push(data);
            arrIndex.push(b - b1 + 1);

            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }
          } else {
            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }

            text = str;
            arrData = [];
            arrData.push(data);
            arrIndex = [];
            arrIndex.push(b - b1 + 1);

            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }
          }
        } else {
          if (text === str) {
            arrData.push(data);
            arrIndex.push(b - b1 + 1);
          } else {
            if (text in obj) {
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            } else {
              obj[text] = [];
              obj[text].push({
                data: arrData,
                index: arrIndex
              });
            }

            text = str;
            arrData = [];
            arrData.push(data);
            arrIndex = [];
            arrIndex.push(b - b1 + 1);
          }
        }
      }
    }

    copyData.push(obj);
  }

  return copyData;
}

function getApplyData(copyD, csLen, asLen) {
  var applyData = [];
  var direction = dropCellCache.direction;
  var type = dropCellCache.applyType;
  var num = Math.floor(asLen / csLen);
  var rsd = asLen % csLen;
  var copyD_number = copyD.number;
  var applyD_number = [];

  if (copyD_number) {
    for (var i = 0; i < copyD_number.length; i += 1) {
      var s = getLenS(copyD_number[i].index, rsd);
      var len = copyD_number[i].index.length * num + s;
      var arrData = void 0;

      if (type === "1" || type === "3") {
        arrData = getDataByType(copyD_number[i].data, len, direction, type, "number");
      } else if (type === "2") {
        arrData = getDataByType(copyD_number[i].data, len, direction, type);
      } else {
        arrData = getDataByType(copyD_number[i].data, len, direction, "0");
      }

      var arrIndex = getDataIndex(csLen, asLen, copyD_number[i].index);
      applyD_number.push({
        data: arrData,
        index: arrIndex
      });
    }
  }

  var copyD_extendNumber = copyD.extendNumber;
  var applyD_extendNumber = [];

  if (copyD_extendNumber) {
    for (var _i17 = 0; _i17 < copyD_extendNumber.length; _i17 += 1) {
      var _s = getLenS(copyD_extendNumber[_i17].index, rsd);

      var _len = copyD_extendNumber[_i17].index.length * num + _s;

      var _arrData = void 0;

      if (type === "1" || type === "3") {
        _arrData = getDataByType(copyD_extendNumber[_i17].data, _len, direction, type, "extendNumber");
      } else if (type === "2") {
        _arrData = getDataByType(copyD_extendNumber[_i17].data, _len, direction, type);
      } else {
        _arrData = getDataByType(copyD_extendNumber[_i17].data, _len, direction, "0");
      }

      var _arrIndex = getDataIndex(csLen, asLen, copyD_extendNumber[_i17].index);

      applyD_extendNumber.push({
        data: _arrData,
        index: _arrIndex
      });
    }
  }

  var copyD_date = copyD.date;
  var applyD_date = [];

  if (copyD_date) {
    for (var _i18 = 0; _i18 < copyD_date.length; _i18 += 1) {
      var _s2 = getLenS(copyD_date[_i18].index, rsd);

      var _len2 = copyD_date[_i18].index.length * num + _s2;

      var _arrData2 = void 0;

      if (type === "1" || type === "3") {
        _arrData2 = getDataByType(copyD_date[_i18].data, _len2, direction, type, "date");
      } else if (type === "8") {
        _arrData2 = getDataByType(copyD_date[_i18].data, _len2, direction, "0");
      } else {
        _arrData2 = getDataByType(copyD_date[_i18].data, _len2, direction, type);
      }

      var _arrIndex2 = getDataIndex(csLen, asLen, copyD_date[_i18].index);

      applyD_date.push({
        data: _arrData2,
        index: _arrIndex2
      });
    }
  }

  var copyD_chnNumber = copyD.chnNumber;
  var applyD_chnNumber = [];

  if (copyD_chnNumber) {
    for (var _i19 = 0; _i19 < copyD_chnNumber.length; _i19 += 1) {
      var _s3 = getLenS(copyD_chnNumber[_i19].index, rsd);

      var _len3 = copyD_chnNumber[_i19].index.length * num + _s3;

      var _arrData3 = void 0;

      if (type === "1" || type === "3") {
        _arrData3 = getDataByType(copyD_chnNumber[_i19].data, _len3, direction, type, "chnNumber");
      } else if (type === "2" || type === "8") {
        _arrData3 = getDataByType(copyD_chnNumber[_i19].data, _len3, direction, type);
      } else {
        _arrData3 = getDataByType(copyD_chnNumber[_i19].data, _len3, direction, "0");
      }

      var _arrIndex3 = getDataIndex(csLen, asLen, copyD_chnNumber[_i19].index);

      applyD_chnNumber.push({
        data: _arrData3,
        index: _arrIndex3
      });
    }
  }

  var copyD_chnWeek2 = copyD.chnWeek2;
  var applyD_chnWeek2 = [];

  if (copyD_chnWeek2) {
    for (var _i20 = 0; _i20 < copyD_chnWeek2.length; _i20 += 1) {
      var _s4 = getLenS(copyD_chnWeek2[_i20].index, rsd);

      var _len4 = copyD_chnWeek2[_i20].index.length * num + _s4;

      var _arrData4 = void 0;

      if (type === "1" || type === "3") {
        _arrData4 = getDataByType(copyD_chnWeek2[_i20].data, _len4, direction, type, "chnWeek2");
      } else if (type === "2") {
        _arrData4 = getDataByType(copyD_chnWeek2[_i20].data, _len4, direction, type);
      } else {
        _arrData4 = getDataByType(copyD_chnWeek2[_i20].data, _len4, direction, "0");
      }

      var _arrIndex4 = getDataIndex(csLen, asLen, copyD_chnWeek2[_i20].index);

      applyD_chnWeek2.push({
        data: _arrData4,
        index: _arrIndex4
      });
    }
  }

  var copyD_chnWeek3 = copyD.chnWeek3;
  var applyD_chnWeek3 = [];

  if (copyD_chnWeek3) {
    for (var _i21 = 0; _i21 < copyD_chnWeek3.length; _i21 += 1) {
      var _s5 = getLenS(copyD_chnWeek3[_i21].index, rsd);

      var _len5 = copyD_chnWeek3[_i21].index.length * num + _s5;

      var _arrData5 = void 0;

      if (type === "1" || type === "3") {
        _arrData5 = getDataByType(copyD_chnWeek3[_i21].data, _len5, direction, type, "chnWeek3");
      } else if (type === "2") {
        _arrData5 = getDataByType(copyD_chnWeek3[_i21].data, _len5, direction, type);
      } else {
        _arrData5 = getDataByType(copyD_chnWeek3[_i21].data, _len5, direction, "0");
      }

      var _arrIndex5 = getDataIndex(csLen, asLen, copyD_chnWeek3[_i21].index);

      applyD_chnWeek3.push({
        data: _arrData5,
        index: _arrIndex5
      });
    }
  }

  var copyD_other = copyD.other;
  var applyD_other = [];

  if (copyD_other) {
    for (var _i22 = 0; _i22 < copyD_other.length; _i22 += 1) {
      var _s6 = getLenS(copyD_other[_i22].index, rsd);

      var _len6 = copyD_other[_i22].index.length * num + _s6;

      var _arrData6 = void 0;

      if (type === "2" || type === "3") {
        _arrData6 = getDataByType(copyD_other[_i22].data, _len6, direction, type);
      } else {
        _arrData6 = getDataByType(copyD_other[_i22].data, _len6, direction, "0");
      }

      var _arrIndex6 = getDataIndex(csLen, asLen, copyD_other[_i22].index);

      applyD_other.push({
        data: _arrData6,
        index: _arrIndex6
      });
    }
  }

  for (var x = 1; x <= asLen; x += 1) {
    if (applyD_number.length > 0) {
      for (var y = 0; y < applyD_number.length; y += 1) {
        if (x in applyD_number[y].index) {
          applyData.push(applyD_number[y].data[applyD_number[y].index[x]]);
        }
      }
    }

    if (applyD_extendNumber.length > 0) {
      for (var _y = 0; _y < applyD_extendNumber.length; _y += 1) {
        if (x in applyD_extendNumber[_y].index) {
          applyData.push(applyD_extendNumber[_y].data[applyD_extendNumber[_y].index[x]]);
        }
      }
    }

    if (applyD_date.length > 0) {
      for (var _y2 = 0; _y2 < applyD_date.length; _y2 += 1) {
        if (x in applyD_date[_y2].index) {
          applyData.push(applyD_date[_y2].data[applyD_date[_y2].index[x]]);
        }
      }
    }

    if (applyD_chnNumber.length > 0) {
      for (var _y3 = 0; _y3 < applyD_chnNumber.length; _y3 += 1) {
        if (x in applyD_chnNumber[_y3].index) {
          applyData.push(applyD_chnNumber[_y3].data[applyD_chnNumber[_y3].index[x]]);
        }
      }
    }

    if (applyD_chnWeek2.length > 0) {
      for (var _y4 = 0; _y4 < applyD_chnWeek2.length; _y4 += 1) {
        if (x in applyD_chnWeek2[_y4].index) {
          applyData.push(applyD_chnWeek2[_y4].data[applyD_chnWeek2[_y4].index[x]]);
        }
      }
    }

    if (applyD_chnWeek3.length > 0) {
      for (var _y5 = 0; _y5 < applyD_chnWeek3.length; _y5 += 1) {
        if (x in applyD_chnWeek3[_y5].index) {
          applyData.push(applyD_chnWeek3[_y5].data[applyD_chnWeek3[_y5].index[x]]);
        }
      }
    }

    if (applyD_other.length > 0) {
      for (var _y6 = 0; _y6 < applyD_other.length; _y6 += 1) {
        if (x in applyD_other[_y6].index) {
          applyData.push(applyD_other[_y6].data[applyD_other[_y6].index[x]]);
        }
      }
    }
  }

  return applyData;
}

function updateDropCell(ctx) {
  var _file$config, _file$config2;

  var d = getFlowdata(ctx);
  var allowEdit = isAllowEdit(ctx);

  if (allowEdit === false || d == null) {
    return;
  }

  var index = getSheetIndex(ctx, ctx.currentSheetId);
  if (index == null) return;
  var file = ctx.luckysheetfile[index];
  var hiddenRows = new Set(Object.keys(((_file$config = file.config) === null || _file$config === void 0 ? void 0 : _file$config.rowhidden) || {}));
  var hiddenCols = new Set(Object.keys(((_file$config2 = file.config) === null || _file$config2 === void 0 ? void 0 : _file$config2.colhidden) || {}));

  var cfg = _.cloneDeep(ctx.config);

  if (cfg.borderInfo == null) {
    cfg.borderInfo = [];
  }

  var borderInfoCompute = getBorderInfoCompute(ctx, ctx.currentSheetId);

  var dataVerification = _.cloneDeep(file.dataVerification);

  var direction = dropCellCache.direction;
  var copyRange = dropCellCache.copyRange;
  var copy_str_r = copyRange.row[0];
  var copy_end_r = copyRange.row[1];
  var copy_str_c = copyRange.column[0];
  var copy_end_c = copyRange.column[1];
  var copyData = getCopyData(d, copy_str_r, copy_end_r, copy_str_c, copy_end_c, direction);
  var csLen;

  if (direction === "down" || direction === "up") {
    csLen = copy_end_r - copy_str_r + 1;
  } else {
    csLen = copy_end_c - copy_str_c + 1;
  }

  var applyRange = dropCellCache.applyRange;
  var apply_str_r = applyRange.row[0];
  var apply_end_r = applyRange.row[1];
  var apply_str_c = applyRange.column[0];
  var apply_end_c = applyRange.column[1];

  if (direction === "down" || direction === "up") {
    var asLen = apply_end_r - apply_str_r + 1;

    for (var i = apply_str_c; i <= apply_end_c; i += 1) {
      if (hiddenCols.has("".concat(i))) continue;
      var copyD = copyData[i - apply_str_c];
      var applyData = getApplyData(copyD, csLen, asLen);

      if (direction === "down") {
        for (var j = apply_str_r; j <= apply_end_r; j += 1) {
          if (hiddenRows.has("".concat(j))) continue;
          var cell = applyData[j - apply_str_r];

          if ((cell === null || cell === void 0 ? void 0 : cell.f) != null) {
            var f = "=".concat(functionCopy(ctx, cell.f, "down", j - apply_str_r + 1));
            var v = execfunction(ctx, f, j, i);
            execFunctionGroup(ctx, j, i, v[1], undefined, d);

            var _v = _slicedToArray(v, 3);

            cell.v = _v[1];
            cell.f = _v[2];

            if (cell.spl != null) {
              cell.spl = v[3].data;
            } else if (cell.v != null) {
              if (isRealNum(cell.v) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(cell.v))) {
                if (cell.v === Infinity || cell.v === -Infinity) {
                  cell.m = cell.v.toString();
                } else {
                  if (cell.v.toString().indexOf("e") > -1) {
                    var len = cell.v.toString().split(".")[1].split("e")[0].length;

                    if (len > 5) {
                      len = 5;
                    }

                    cell.m = cell.v.toExponential(len).toString();
                  } else {
                    var _cell$ct;

                    var mask = void 0;

                    if (((_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : _cell$ct.fa) === "##0.00") {
                      mask = genarate("".concat(Math.round(cell.v * 1000000000) / 1000000000, ".00"));
                      cell.m = mask[0].toString();
                    } else {
                      mask = genarate(Math.round(cell.v * 1000000000) / 1000000000);
                      cell.m = mask[0].toString();
                    }
                  }
                }

                cell.ct = cell.ct || {
                  fa: "General",
                  t: "n"
                };
              } else {
                var _mask = genarate(cell.v);

                cell.m = _mask[0].toString();

                var _mask2 = _slicedToArray(_mask, 2);

                cell.ct = _mask2[1];
              }
            }
          }

          d[j][i] = cell || null;
          var bd_r = copy_str_r + (j - apply_str_r) % csLen;
          var bd_c = i;

          if (borderInfoCompute["".concat(bd_r, "_").concat(bd_c)]) {
            var bd_obj = {
              rangeType: "cell",
              value: {
                row_index: j,
                col_index: i,
                l: borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].l,
                r: borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].r,
                t: borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].t,
                b: borderInfoCompute["".concat(bd_r, "_").concat(bd_c)].b
              }
            };
            cfg.borderInfo.push(bd_obj);
          } else if (borderInfoCompute["".concat(j, "_").concat(i)]) {
            var _bd_obj = {
              rangeType: "cell",
              value: {
                row_index: j,
                col_index: i,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };
            cfg.borderInfo.push(_bd_obj);
          }

          if (dataVerification != null && dataVerification["".concat(bd_r, "_").concat(bd_c)]) {
            dataVerification["".concat(j, "_").concat(i)] = dataVerification["".concat(bd_r, "_").concat(bd_c)];
          }
        }
      }

      if (direction === "up") {
        for (var _j = apply_end_r; _j >= apply_str_r; _j -= 1) {
          if (hiddenRows.has("".concat(_j))) continue;
          var _cell = applyData[apply_end_r - _j];

          if ((_cell === null || _cell === void 0 ? void 0 : _cell.f) != null) {
            var _f = "=".concat(functionCopy(ctx, _cell.f, "up", apply_end_r - _j + 1));

            var _v2 = execfunction(ctx, _f, _j, i);

            execFunctionGroup(ctx, _j, i, _v2[1], undefined, d);

            var _v3 = _slicedToArray(_v2, 3);

            _cell.v = _v3[1];
            _cell.f = _v3[2];

            if (_cell.spl != null) {
              _cell.spl = _v2[3].data;
            } else if (_cell.v != null) {
              if (isRealNum(_cell.v) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell.v))) {
                if (_cell.v === Infinity || _cell.v === -Infinity) {
                  _cell.m = _cell.v.toString();
                } else {
                  if (_cell.v.toString().indexOf("e") > -1) {
                    var _len7 = _cell.v.toString().split(".")[1].split("e")[0].length;

                    if (_len7 > 5) {
                      _len7 = 5;
                    }

                    _cell.m = _cell.v.toExponential(_len7).toString();
                  } else {
                    var _mask3 = genarate(Math.round(_cell.v * 1000000000) / 1000000000);

                    _cell.m = _mask3[0].toString();
                  }
                }

                _cell.ct = {
                  fa: "General",
                  t: "n"
                };
              } else {
                var _mask4 = genarate(_cell.v);

                _cell.m = _mask4[0].toString();

                var _mask5 = _slicedToArray(_mask4, 2);

                _cell.ct = _mask5[1];
              }
            }
          }

          d[_j][i] = _cell || null;

          var _bd_r = copy_end_r - (apply_end_r - _j) % csLen;

          var _bd_c = i;

          if (borderInfoCompute["".concat(_bd_r, "_").concat(_bd_c)]) {
            var _bd_obj2 = {
              rangeType: "cell",
              value: {
                row_index: _j,
                col_index: i,
                l: borderInfoCompute["".concat(_bd_r, "_").concat(_bd_c)].l,
                r: borderInfoCompute["".concat(_bd_r, "_").concat(_bd_c)].r,
                t: borderInfoCompute["".concat(_bd_r, "_").concat(_bd_c)].t,
                b: borderInfoCompute["".concat(_bd_r, "_").concat(_bd_c)].b
              }
            };
            cfg.borderInfo.push(_bd_obj2);
          } else if (borderInfoCompute["".concat(_j, "_").concat(i)]) {
            var _bd_obj3 = {
              rangeType: "cell",
              value: {
                row_index: _j,
                col_index: i,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };
            cfg.borderInfo.push(_bd_obj3);
          }

          if (dataVerification != null && dataVerification["".concat(_bd_r, "_").concat(_bd_c)]) {
            dataVerification["".concat(_j, "_").concat(i)] = dataVerification["".concat(_bd_r, "_").concat(_bd_c)];
          }
        }
      }
    }
  } else if (direction === "right" || direction === "left") {
    var _asLen = apply_end_c - apply_str_c + 1;

    for (var _i23 = apply_str_r; _i23 <= apply_end_r; _i23 += 1) {
      if (hiddenRows.has("".concat(_i23))) continue;
      var _copyD = copyData[_i23 - apply_str_r];

      var _applyData = getApplyData(_copyD, csLen, _asLen);

      if (direction === "right") {
        for (var _j2 = apply_str_c; _j2 <= apply_end_c; _j2 += 1) {
          if (hiddenCols.has("".concat(_j2))) continue;
          var _cell2 = _applyData[_j2 - apply_str_c];

          if ((_cell2 === null || _cell2 === void 0 ? void 0 : _cell2.f) != null) {
            var _f2 = "=".concat(functionCopy(ctx, _cell2.f, "right", _j2 - apply_str_c + 1));

            var _v4 = execfunction(ctx, _f2, _i23, _j2);

            execFunctionGroup(ctx, _j2, _i23, _v4[1], undefined, d);

            var _v5 = _slicedToArray(_v4, 3);

            _cell2.v = _v5[1];
            _cell2.f = _v5[2];

            if (_cell2.spl != null) {
              _cell2.spl = _v4[3].data;
            } else if (_cell2.v != null) {
              if (isRealNum(_cell2.v) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell2.v))) {
                if (_cell2.v === Infinity || _cell2.v === -Infinity) {
                  _cell2.m = _cell2.v.toString();
                } else {
                  if (_cell2.v.toString().indexOf("e") > -1) {
                    var _len8 = _cell2.v.toString().split(".")[1].split("e")[0].length;

                    if (_len8 > 5) {
                      _len8 = 5;
                    }

                    _cell2.m = _cell2.v.toExponential(_len8).toString();
                  } else {
                    var _mask6 = genarate(Math.round(_cell2.v * 1000000000) / 1000000000);

                    _cell2.m = _mask6[0].toString();
                  }
                }

                _cell2.ct = {
                  fa: "General",
                  t: "n"
                };
              } else {
                var _mask7 = genarate(_cell2.v);

                _cell2.m = _mask7[0].toString();

                var _mask8 = _slicedToArray(_mask7, 2);

                _cell2.ct = _mask8[1];
              }
            }
          }

          d[_i23][_j2] = _cell2 || null;
          var _bd_r2 = _i23;

          var _bd_c2 = copy_str_c + (_j2 - apply_str_c) % csLen;

          if (borderInfoCompute["".concat(_bd_r2, "_").concat(_bd_c2)]) {
            var _bd_obj4 = {
              rangeType: "cell",
              value: {
                row_index: _i23,
                col_index: _j2,
                l: borderInfoCompute["".concat(_bd_r2, "_").concat(_bd_c2)].l,
                r: borderInfoCompute["".concat(_bd_r2, "_").concat(_bd_c2)].r,
                t: borderInfoCompute["".concat(_bd_r2, "_").concat(_bd_c2)].t,
                b: borderInfoCompute["".concat(_bd_r2, "_").concat(_bd_c2)].b
              }
            };
            cfg.borderInfo.push(_bd_obj4);
          } else if (borderInfoCompute["".concat(_i23, "_").concat(_j2)]) {
            var _bd_obj5 = {
              rangeType: "cell",
              value: {
                row_index: _i23,
                col_index: _j2,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };
            cfg.borderInfo.push(_bd_obj5);
          }

          if (dataVerification != null && dataVerification["".concat(_bd_r2, "_").concat(_bd_c2)]) {
            dataVerification["".concat(_i23, "_").concat(_j2)] = dataVerification["".concat(_bd_r2, "_").concat(_bd_c2)];
          }
        }
      }

      if (direction === "left") {
        for (var _j3 = apply_end_c; _j3 >= apply_str_c; _j3 -= 1) {
          if (hiddenCols.has("".concat(_j3))) continue;
          var _cell3 = _applyData[apply_end_c - _j3];

          if ((_cell3 === null || _cell3 === void 0 ? void 0 : _cell3.f) != null) {
            var _f3 = "=".concat(functionCopy(ctx, _cell3.f, "left", apply_end_c - _j3 + 1));

            var _v6 = execfunction(ctx, _f3, _i23, _j3);

            execFunctionGroup(ctx, _j3, _i23, _v6[1], undefined, d);

            var _v7 = _slicedToArray(_v6, 3);

            _cell3.v = _v7[1];
            _cell3.f = _v7[2];

            if (_cell3.spl != null) {
              _cell3.spl = _v6[3].data;
            } else if (_cell3.v != null) {
              if (isRealNum(_cell3.v) && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test("".concat(_cell3.v))) {
                if (_cell3.v === Infinity || _cell3.v === -Infinity) {
                  _cell3.m = _cell3.v.toString();
                } else {
                  if (_cell3.v.toString().indexOf("e") > -1) {
                    var _len9 = _cell3.v.toString().split(".")[1].split("e")[0].length;

                    if (_len9 > 5) {
                      _len9 = 5;
                    }

                    _cell3.m = _cell3.v.toExponential(_len9).toString();
                  } else {
                    var _mask9 = genarate(Math.round(_cell3.v * 1000000000) / 1000000000);

                    _cell3.m = _mask9[0].toString();
                  }
                }

                _cell3.ct = {
                  fa: "General",
                  t: "n"
                };
              } else {
                var _mask10 = genarate(_cell3.v);

                _cell3.m = _mask10[0].toString();

                var _mask11 = _slicedToArray(_mask10, 2);

                _cell3.ct = _mask11[1];
              }
            }
          }

          d[_i23][_j3] = _cell3 || null;
          var _bd_r3 = _i23;

          var _bd_c3 = copy_end_c - (apply_end_c - _j3) % csLen;

          if (borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)]) {
            var _bd_obj6 = {
              rangeType: "cell",
              value: {
                row_index: _i23,
                col_index: _j3,
                l: borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].l,
                r: borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].r,
                t: borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].t,
                b: borderInfoCompute["".concat(_bd_r3, "_").concat(_bd_c3)].b
              }
            };
            cfg.borderInfo.push(_bd_obj6);
          } else if (borderInfoCompute["".concat(_i23, "_").concat(_j3)]) {
            var _bd_obj7 = {
              rangeType: "cell",
              value: {
                row_index: _i23,
                col_index: _j3,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };
            cfg.borderInfo.push(_bd_obj7);
          }

          if (dataVerification != null && dataVerification["".concat(_bd_r3, "_").concat(_bd_c3)]) {
            dataVerification["".concat(_i23, "_").concat(_j3)] = dataVerification["".concat(_bd_r3, "_").concat(_bd_c3)];
          }
        }
      }
    }
  }

  var cdformat = file.luckysheet_conditionformat_save;

  if (cdformat != null && cdformat.length > 0) {
    for (var _i24 = 0; _i24 < cdformat.length; _i24 += 1) {
      var cdformat_cellrange = cdformat[_i24].cellrange;
      var emptyRange = [];

      for (var _j4 = 0; _j4 < cdformat_cellrange.length; _j4 += 1) {
        var range = CFSplitRange(cdformat_cellrange[_j4], {
          row: copyRange.row,
          column: copyRange.column
        }, {
          row: applyRange.row,
          column: applyRange.column
        }, "operatePart");

        if (range.length > 0) {
          emptyRange = emptyRange.concat(range);
        }
      }

      if (emptyRange.length > 0) {
        cdformat[_i24].cellrange.push(applyRange);
      }
    }
  }

  jfrefreshgrid(ctx, d, ctx.luckysheet_select_save);
}
function onDropCellSelectEnd(ctx, e, container) {
  var _ctx$luckysheet_selec3;

  ctx.luckysheet_cell_selected_extend = false;
  hideDropCellSelection(container);
  var scrollLeft = ctx.scrollLeft,
      scrollTop = ctx.scrollTop;
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollLeft;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollTop;
  var row_location = rowLocation(y, ctx.visibledatarow);
  var row_pre = row_location[0];
  var row_index = row_location[2];
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col_pre = col_location[0];
  var col_index = col_location[2];
  var row_index_original = ctx.luckysheet_cell_selected_extend_index[0];
  var col_index_original = ctx.luckysheet_cell_selected_extend_index[1];
  var last = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3[ctx.luckysheet_select_save.length - 1];

  if (last && last.top != null && last.left != null && last.height != null && last.width != null && last.row_focus != null && last.column_focus != null) {
    var row_s = last.row[0];
    var row_e = last.row[1];
    var col_s = last.column[0];
    var col_e = last.column[1];
    dropCellCache.copyRange = _.cloneDeep(_.pick(last, ["row", "column"]));
    var typeItemHide = getTypeItemHide(ctx);

    if (!typeItemHide[0] && !typeItemHide[1] && !typeItemHide[2] && !typeItemHide[3] && !typeItemHide[4] && !typeItemHide[5] && !typeItemHide[6]) {
      dropCellCache.applyType = "0";
    } else {
      dropCellCache.applyType = "1";
    }

    if (ctx.luckysheet_select_save == null) return;
    var _ctx$luckysheet_selec4 = ctx.luckysheet_select_save[0],
        top_move = _ctx$luckysheet_selec4.top_move,
        left_move = _ctx$luckysheet_selec4.left_move;

    if (Math.abs(row_index_original - row_index) > Math.abs(col_index_original - col_index)) {
      if (!(row_index >= row_s && row_index <= row_e)) {
        if (top_move != null && top_move >= row_pre) {
          dropCellCache.applyRange = {
            row: [row_index, last.row[0] - 1],
            column: last.column
          };
          dropCellCache.direction = "up";
          row_s -= last.row[0] - row_index;
        } else {
          dropCellCache.applyRange = {
            row: [last.row[1] + 1, row_index],
            column: last.column
          };
          dropCellCache.direction = "down";
          row_e += row_index - last.row[1];
        }
      } else {
        return;
      }
    } else {
      if (!(col_index >= col_s && col_index <= col_e)) {
        if (left_move != null && left_move >= col_pre) {
          dropCellCache.applyRange = {
            row: last.row,
            column: [col_index, last.column[0] - 1]
          };
          dropCellCache.direction = "left";
          col_s -= last.column[0] - col_index;
        } else {
          dropCellCache.applyRange = {
            row: last.row,
            column: [last.column[1] + 1, col_index]
          };
          dropCellCache.direction = "right";
          col_e += col_index - last.column[1];
        }
      } else {
        return;
      }
    }

    if (y < 0) {
      row_s = 0;

      var _last$row = _slicedToArray(last.row, 1);

      row_e = _last$row[0];
    }

    if (x < 0) {
      col_s = 0;

      var _last$column = _slicedToArray(last.column, 1);

      col_e = _last$column[0];
    }

    var flowdata = getFlowdata(ctx);
    if (flowdata == null) return;

    if (ctx.config.merge != null) {
      var HasMC = false;

      for (var r = last.row[0]; r <= last.row[1]; r += 1) {
        for (var c = last.column[0]; c <= last.column[1]; c += 1) {
          var _flowdata$r;

          var cell = (_flowdata$r = flowdata[r]) === null || _flowdata$r === void 0 ? void 0 : _flowdata$r[c];

          if (cell != null && cell.mc != null) {
            HasMC = true;
            break;
          }
        }
      }

      if (HasMC) {
        return;
      }

      for (var _r = row_s; _r <= row_e; _r += 1) {
        for (var _c = col_s; _c <= col_e; _c += 1) {
          var _flowdata$_r;

          var _cell4 = (_flowdata$_r = flowdata[_r]) === null || _flowdata$_r === void 0 ? void 0 : _flowdata$_r[_c];

          if (_cell4 != null && _cell4.mc != null) {
            HasMC = true;
            break;
          }
        }
      }

      if (HasMC) {
        return;
      }
    }

    last.row = [row_s, row_e];
    last.column = [col_s, col_e];
    ctx.luckysheet_select_save = normalizeSelection(ctx, [{
      row: [row_s, row_e],
      column: [col_s, col_e]
    }]);

    try {
      updateDropCell(ctx);
    } catch (err) {
      console.error(err);
    }

    var selectedMoveEle = container.querySelector(".fortune-cell-selected-move");

    if (selectedMoveEle) {
      selectedMoveEle.style.display = "none";
    }
  }
}

var defaultStyle = {
  fillStyle: "#000000",
  textBaseline: "middle",
  strokeStyle: "#dfdfdf",
  rowFillStyle: "#5e5e5e",
  textAlign: "center"
};

function isRealNum$1(val) {
  return !Number.isNaN(Number(val));
}

var cfIconsImg;

function getCfIconsImg() {
  if (cfIconsImg) return cfIconsImg;
  cfIconsImg = new Image();
  cfIconsImg.src = "data:image/png;base64,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";
  return cfIconsImg;
}

function getBorderFix() {
  return [-1, 0, 0, -1];
}

function setLineDash(canvasborder, type, hv, moveX, moveY, toX, toY) {
  var borderType = {
    "0": "none",
    "1": "Thin",
    "2": "Hair",
    "3": "Dotted",
    "4": "Dashed",
    "5": "DashDot",
    "6": "DashDotDot",
    "7": "Double",
    "8": "Medium",
    "9": "MediumDashed",
    "10": "MediumDashDot",
    "11": "MediumDashDotDot",
    "12": "SlantedDashDot",
    "13": "Thick"
  };
  type = borderType[type.toString()];

  try {
    if (type === "Hair") {
      canvasborder.setLineDash([1, 2]);
    } else if (type.indexOf("DashDotDot") > -1) {
      canvasborder.setLineDash([2, 2, 5, 2, 2]);
    } else if (type.indexOf("DashDot") > -1) {
      canvasborder.setLineDash([2, 5, 2]);
    } else if (type.indexOf("Dotted") > -1) {
      canvasborder.setLineDash([2]);
    } else if (type.indexOf("Dashed") > -1) {
      canvasborder.setLineDash([3]);
    } else {
      canvasborder.setLineDash([0]);
    }
  } catch (e) {
    console.error(e);
  }

  canvasborder.beginPath();

  if (type.indexOf("Medium") > -1) {
    if (hv === "h") {
      canvasborder.moveTo(moveX, moveY - 0.5);
      canvasborder.lineTo(toX, toY - 0.5);
    } else {
      canvasborder.moveTo(moveX - 0.5, moveY);
      canvasborder.lineTo(toX - 0.5, toY);
    }

    canvasborder.lineWidth = 2;
  } else if (type === "Thick") {
    canvasborder.moveTo(moveX, moveY);
    canvasborder.lineTo(toX, toY);
    canvasborder.lineWidth = 3;
  } else {
    canvasborder.moveTo(moveX, moveY);
    canvasborder.lineTo(toX, toY);
    canvasborder.lineWidth = 1;
  }
}

var Canvas = /*#__PURE__*/function () {
  function Canvas(canvasElement, ctx) {
    _classCallCheck(this, Canvas);

    this.canvasElement = void 0;
    this.sheetCtx = void 0;
    this.measureTextCacheTimeOut = void 0;
    this.cellOverflowMapCache = void 0;
    this.canvasElement = canvasElement;
    this.sheetCtx = ctx;
    this.cellOverflowMapCache = {};
  }

  _createClass(Canvas, [{
    key: "drawRowHeader",
    value: function drawRowHeader(scrollHeight, drawHeight, offsetTop) {
      if (_.isNil(drawHeight)) {
        var _this$sheetCtx$luckys = _slicedToArray(this.sheetCtx.luckysheetTableContentHW, 2);

        drawHeight = _this$sheetCtx$luckys[1];
      }

      if (_.isNil(offsetTop)) {
        offsetTop = this.sheetCtx.columnHeaderHeight;
      }

      var renderCtx = this.canvasElement.getContext("2d");
      if (!renderCtx) return;
      renderCtx.save();
      renderCtx.scale(this.sheetCtx.devicePixelRatio, this.sheetCtx.devicePixelRatio);
      renderCtx.clearRect(0, offsetTop, this.sheetCtx.rowHeaderWidth - 1, drawHeight);
      renderCtx.font = defaultFont(this.sheetCtx.defaultFontSize);
      renderCtx.textBaseline = defaultStyle.textBaseline;
      renderCtx.fillStyle = defaultStyle.fillStyle;
      var dataset_row_st;
      var dataset_row_ed;
      dataset_row_st = _.sortedIndex(this.sheetCtx.visibledatarow, scrollHeight);
      dataset_row_ed = _.sortedIndex(this.sheetCtx.visibledatarow, scrollHeight + drawHeight);

      if (dataset_row_st === -1) {
        dataset_row_st = 0;
      }

      if (dataset_row_ed === -1) {
        dataset_row_ed = this.sheetCtx.visibledatarow.length - 1;
      }

      renderCtx.save();
      renderCtx.beginPath();
      renderCtx.rect(0, offsetTop - 1, this.sheetCtx.rowHeaderWidth - 1, drawHeight - 2);
      renderCtx.clip();
      var end_r;
      var start_r;
      var bodrder05 = 0.5;
      var preEndR;

      for (var r = dataset_row_st; r <= dataset_row_ed; r += 1) {
        var _this$sheetCtx$hooks$, _this$sheetCtx$hooks, _this$sheetCtx$config, _this$sheetCtx$config2, _this$sheetCtx$config3, _this$sheetCtx$config4, _this$sheetCtx$hooks$2, _this$sheetCtx$hooks2;

        if (r === 0) {
          start_r = -scrollHeight - 1;
        } else {
          start_r = this.sheetCtx.visibledatarow[r - 1] - scrollHeight - 1;
        }

        end_r = this.sheetCtx.visibledatarow[r] - scrollHeight;
        var firstOffset = dataset_row_st === r ? -2 : 0;
        var lastOffset = dataset_row_ed === r ? -2 : 0;

        if (((_this$sheetCtx$hooks$ = (_this$sheetCtx$hooks = this.sheetCtx.hooks).beforeRenderRowHeaderCell) === null || _this$sheetCtx$hooks$ === void 0 ? void 0 : _this$sheetCtx$hooks$.call(_this$sheetCtx$hooks, "".concat(r + 1), r, start_r + offsetTop + firstOffset, this.sheetCtx.rowHeaderWidth - 1, end_r - start_r + 1 + lastOffset - firstOffset, renderCtx)) === false) {
          continue;
        }

        if (((_this$sheetCtx$config = this.sheetCtx.config) === null || _this$sheetCtx$config === void 0 ? void 0 : (_this$sheetCtx$config2 = _this$sheetCtx$config.rowhidden) === null || _this$sheetCtx$config2 === void 0 ? void 0 : _this$sheetCtx$config2[r]) == null) {
          renderCtx.fillStyle = "#ffffff";
          renderCtx.fillRect(0, start_r + offsetTop + firstOffset, this.sheetCtx.rowHeaderWidth - 1, end_r - start_r + 1 + lastOffset - firstOffset);
          renderCtx.fillStyle = "#000000";
          renderCtx.save();
          renderCtx.scale(this.sheetCtx.zoomRatio, this.sheetCtx.zoomRatio);
          var textMetrics = getMeasureText(r + 1, renderCtx, this.sheetCtx);
          var horizonAlignPos = (this.sheetCtx.rowHeaderWidth - textMetrics.width) / 2;
          var verticalAlignPos = start_r + (end_r - start_r) / 2 + offsetTop;
          renderCtx.fillText("".concat(r + 1), horizonAlignPos / this.sheetCtx.zoomRatio, verticalAlignPos / this.sheetCtx.zoomRatio);
          renderCtx.restore();
        }

        renderCtx.beginPath();
        renderCtx.moveTo(this.sheetCtx.rowHeaderWidth - 2 + bodrder05, start_r + offsetTop - 2);
        renderCtx.lineTo(this.sheetCtx.rowHeaderWidth - 2 + bodrder05, end_r + offsetTop - 2);
        renderCtx.lineWidth = 1;
        renderCtx.strokeStyle = defaultStyle.strokeStyle;
        renderCtx.stroke();
        renderCtx.closePath();

        if (this.sheetCtx.config.rowhidden && this.sheetCtx.config.rowhidden[r] == null && this.sheetCtx.config.rowhidden[r + 1] != null) {
          renderCtx.beginPath();
          renderCtx.moveTo(-1, end_r + offsetTop - 4 + bodrder05);
          renderCtx.lineTo(this.sheetCtx.rowHeaderWidth - 1, end_r + offsetTop - 4 + bodrder05);
          renderCtx.closePath();
          renderCtx.stroke();
        } else if (this.sheetCtx.config.rowhidden == null || this.sheetCtx.config.rowhidden[r] == null) {
          renderCtx.beginPath();
          renderCtx.moveTo(-1, end_r + offsetTop - 2 + bodrder05);
          renderCtx.lineTo(this.sheetCtx.rowHeaderWidth - 1, end_r + offsetTop - 2 + bodrder05);
          renderCtx.closePath();
          renderCtx.stroke();
        }

        if (((_this$sheetCtx$config3 = this.sheetCtx.config) === null || _this$sheetCtx$config3 === void 0 ? void 0 : (_this$sheetCtx$config4 = _this$sheetCtx$config3.rowhidden) === null || _this$sheetCtx$config4 === void 0 ? void 0 : _this$sheetCtx$config4[r - 1]) != null && preEndR !== undefined) {
          renderCtx.beginPath();
          renderCtx.moveTo(-1, preEndR + offsetTop + bodrder05);
          renderCtx.lineTo(this.sheetCtx.rowHeaderWidth - 1, preEndR + offsetTop + bodrder05);
          renderCtx.closePath();
          renderCtx.stroke();
        }

        preEndR = end_r;
        (_this$sheetCtx$hooks$2 = (_this$sheetCtx$hooks2 = this.sheetCtx.hooks).afterRenderRowHeaderCell) === null || _this$sheetCtx$hooks$2 === void 0 ? void 0 : _this$sheetCtx$hooks$2.call(_this$sheetCtx$hooks2, "".concat(r + 1), r, start_r + offsetTop + firstOffset, this.sheetCtx.rowHeaderWidth - 1, end_r - start_r + 1 + lastOffset - firstOffset, renderCtx);
      }

      renderCtx.restore();
      renderCtx.restore();
    }
  }, {
    key: "drawColumnHeader",
    value: function drawColumnHeader(scrollWidth, drawWidth, offsetLeft) {
      if (drawWidth === undefined) {
        var _this$sheetCtx$luckys2 = _slicedToArray(this.sheetCtx.luckysheetTableContentHW, 1);

        drawWidth = _this$sheetCtx$luckys2[0];
      }

      if (offsetLeft === undefined) {
        offsetLeft = this.sheetCtx.rowHeaderWidth;
      }

      var renderCtx = this.canvasElement.getContext("2d");
      if (!renderCtx) return;
      renderCtx.save();
      renderCtx.scale(this.sheetCtx.devicePixelRatio, this.sheetCtx.devicePixelRatio);
      renderCtx.clearRect(offsetLeft, 0, drawWidth, this.sheetCtx.columnHeaderHeight - 1);
      renderCtx.font = defaultFont(this.sheetCtx.defaultFontSize);
      renderCtx.textBaseline = defaultStyle.textBaseline;
      renderCtx.fillStyle = defaultStyle.fillStyle;
      var dataset_col_st;
      var dataset_col_ed;
      dataset_col_st = _.sortedIndex(this.sheetCtx.visibledatacolumn, scrollWidth);
      dataset_col_ed = _.sortedIndex(this.sheetCtx.visibledatacolumn, scrollWidth + drawWidth);

      if (dataset_col_st === -1) {
        dataset_col_st = 0;
      }

      if (dataset_col_ed === -1) {
        dataset_col_ed = this.sheetCtx.visibledatacolumn.length - 1;
      }

      renderCtx.save();
      renderCtx.beginPath();
      renderCtx.rect(offsetLeft - 1, 0, drawWidth, this.sheetCtx.columnHeaderHeight - 1);
      renderCtx.clip();
      var end_c;
      var start_c;
      var bodrder05 = 0.5;
      var preEndC;

      for (var c = dataset_col_st; c <= dataset_col_ed; c += 1) {
        var _this$sheetCtx$hooks$3, _this$sheetCtx$hooks3, _this$sheetCtx$config5, _this$sheetCtx$config6, _this$sheetCtx$config7, _this$sheetCtx$config8, _this$sheetCtx$hooks$4, _this$sheetCtx$hooks4;

        if (c === 0) {
          start_c = -scrollWidth;
        } else {
          start_c = this.sheetCtx.visibledatacolumn[c - 1] - scrollWidth;
        }

        end_c = this.sheetCtx.visibledatacolumn[c] - scrollWidth;
        var abc = indexToColumnChar(c);

        if (((_this$sheetCtx$hooks$3 = (_this$sheetCtx$hooks3 = this.sheetCtx.hooks).beforeRenderColumnHeaderCell) === null || _this$sheetCtx$hooks$3 === void 0 ? void 0 : _this$sheetCtx$hooks$3.call(_this$sheetCtx$hooks3, abc, c, start_c + offsetLeft - 1, end_c - start_c, this.sheetCtx.columnHeaderHeight - 1, renderCtx)) === false) {
          continue;
        }

        if (((_this$sheetCtx$config5 = this.sheetCtx.config) === null || _this$sheetCtx$config5 === void 0 ? void 0 : (_this$sheetCtx$config6 = _this$sheetCtx$config5.colhidden) === null || _this$sheetCtx$config6 === void 0 ? void 0 : _this$sheetCtx$config6[c]) == null) {
          renderCtx.fillStyle = "#ffffff";
          renderCtx.fillRect(start_c + offsetLeft - 1, 0, end_c - start_c, this.sheetCtx.columnHeaderHeight - 1);
          renderCtx.fillStyle = "#000000";
          renderCtx.save();
          renderCtx.scale(this.sheetCtx.zoomRatio, this.sheetCtx.zoomRatio);
          var textMetrics = getMeasureText(abc, renderCtx, this.sheetCtx);
          var horizonAlignPos = Math.round(start_c + (end_c - start_c) / 2 + offsetLeft - textMetrics.width / 2);
          var verticalAlignPos = Math.round(this.sheetCtx.columnHeaderHeight / 2);
          renderCtx.fillText(abc, horizonAlignPos / this.sheetCtx.zoomRatio, verticalAlignPos / this.sheetCtx.zoomRatio);
          renderCtx.restore();
        }

        if (this.sheetCtx.config.colhidden && this.sheetCtx.config.colhidden[c] != null && this.sheetCtx.config.colhidden[c + 1] != null) {
          renderCtx.beginPath();
          renderCtx.moveTo(end_c + offsetLeft - 4 + bodrder05, 0);
          renderCtx.lineTo(end_c + offsetLeft - 4 + bodrder05, this.sheetCtx.columnHeaderHeight - 2);
          renderCtx.lineWidth = 1;
          renderCtx.strokeStyle = defaultStyle.strokeStyle;
          renderCtx.closePath();
          renderCtx.stroke();
        } else if (this.sheetCtx.config.colhidden == null || this.sheetCtx.config.colhidden[c] == null) {
          renderCtx.beginPath();
          renderCtx.moveTo(end_c + offsetLeft - 2 + bodrder05, 0);
          renderCtx.lineTo(end_c + offsetLeft - 2 + bodrder05, this.sheetCtx.columnHeaderHeight - 2);
          renderCtx.lineWidth = 1;
          renderCtx.strokeStyle = defaultStyle.strokeStyle;
          renderCtx.closePath();
          renderCtx.stroke();
        }

        if (((_this$sheetCtx$config7 = this.sheetCtx.config) === null || _this$sheetCtx$config7 === void 0 ? void 0 : (_this$sheetCtx$config8 = _this$sheetCtx$config7.colhidden) === null || _this$sheetCtx$config8 === void 0 ? void 0 : _this$sheetCtx$config8[c - 1]) != null && preEndC !== undefined) {
          renderCtx.beginPath();
          renderCtx.moveTo(preEndC + offsetLeft + bodrder05, 0);
          renderCtx.lineTo(preEndC + offsetLeft + bodrder05, this.sheetCtx.columnHeaderHeight - 2);
          renderCtx.closePath();
          renderCtx.stroke();
        }

        renderCtx.beginPath();
        renderCtx.moveTo(start_c + offsetLeft - 1, this.sheetCtx.columnHeaderHeight - 2 + bodrder05);
        renderCtx.lineTo(end_c + offsetLeft - 1, this.sheetCtx.columnHeaderHeight - 2 + bodrder05);
        renderCtx.stroke();
        renderCtx.closePath();
        preEndC = end_c;
        (_this$sheetCtx$hooks$4 = (_this$sheetCtx$hooks4 = this.sheetCtx.hooks).afterRenderColumnHeaderCell) === null || _this$sheetCtx$hooks$4 === void 0 ? void 0 : _this$sheetCtx$hooks$4.call(_this$sheetCtx$hooks4, abc, c, start_c + offsetLeft - 1, end_c - start_c, this.sheetCtx.columnHeaderHeight - 1, renderCtx);
      }

      renderCtx.restore();
      renderCtx.restore();
    }
  }, {
    key: "drawMain",
    value: function drawMain(_ref) {
      var _this$sheetCtx$hooks$5,
          _this$sheetCtx$hooks5,
          _this$sheetCtx$config15,
          _this$sheetCtx$config16,
          _this$sheetCtx$config17,
          _this = this;

      var scrollWidth = _ref.scrollWidth,
          scrollHeight = _ref.scrollHeight,
          drawWidth = _ref.drawWidth,
          drawHeight = _ref.drawHeight,
          offsetLeft = _ref.offsetLeft,
          offsetTop = _ref.offsetTop,
          columnOffsetCell = _ref.columnOffsetCell,
          rowOffsetCell = _ref.rowOffsetCell,
          clear = _ref.clear;
      var flowdata = getFlowdata(this.sheetCtx);

      if (_.isNil(flowdata)) {
        return;
      }

      clearTimeout(this.measureTextCacheTimeOut);

      if (drawWidth === undefined) {
        var _this$sheetCtx$luckys3 = _slicedToArray(this.sheetCtx.luckysheetTableContentHW, 1);

        drawWidth = _this$sheetCtx$luckys3[0];
      }

      if (drawHeight === undefined) {
        var _this$sheetCtx$luckys4 = _slicedToArray(this.sheetCtx.luckysheetTableContentHW, 2);

        drawHeight = _this$sheetCtx$luckys4[1];
      }

      if (offsetLeft === undefined) {
        offsetLeft = this.sheetCtx.rowHeaderWidth;
      }

      if (offsetTop === undefined) {
        offsetTop = this.sheetCtx.columnHeaderHeight;
      }

      if (columnOffsetCell === undefined) {
        columnOffsetCell = 0;
      }

      if (rowOffsetCell === undefined) {
        rowOffsetCell = 0;
      }

      var renderCtx = this.canvasElement.getContext("2d");
      if (!renderCtx) return;
      renderCtx.save();
      renderCtx.scale(this.sheetCtx.devicePixelRatio, this.sheetCtx.devicePixelRatio);

      if (clear) {
        renderCtx.clearRect(0, 0, this.sheetCtx.luckysheetTableContentHW[0], this.sheetCtx.luckysheetTableContentHW[1]);
      }

      var rowStart;
      var rowEnd;
      var colStart;
      var colEnd;
      rowStart = _.sortedIndex(this.sheetCtx.visibledatarow, scrollHeight);
      rowEnd = _.sortedIndex(this.sheetCtx.visibledatarow, scrollHeight + drawHeight);

      if (rowStart === -1) {
        rowStart = 0;
      }

      rowStart += rowOffsetCell;

      if (rowEnd === -1) {
        rowEnd = this.sheetCtx.visibledatarow.length - 1;
      }

      rowEnd += rowOffsetCell;

      if (rowEnd >= this.sheetCtx.visibledatarow.length) {
        rowEnd = this.sheetCtx.visibledatarow.length - 1;
      }

      colStart = _.sortedIndex(this.sheetCtx.visibledatacolumn, scrollWidth);
      colEnd = _.sortedIndex(this.sheetCtx.visibledatacolumn, scrollWidth + drawWidth);

      if (colStart === -1) {
        colStart = 0;
      }

      colStart += columnOffsetCell;

      if (colEnd === -1) {
        colEnd = this.sheetCtx.visibledatacolumn.length - 1;
      }

      colEnd += columnOffsetCell;

      if (colEnd >= this.sheetCtx.visibledatacolumn.length) {
        colEnd = this.sheetCtx.visibledatacolumn.length - 1;
      }

      var rowEndY = this.sheetCtx.visibledatarow[rowEnd];
      var colEndX = this.sheetCtx.visibledatacolumn[colEnd];
      renderCtx.fillStyle = "#ffffff";
      renderCtx.fillRect(offsetLeft - 1, offsetTop - 1, colEndX - scrollWidth, rowEndY - scrollHeight);
      renderCtx.font = defaultFont(this.sheetCtx.defaultFontSize);
      renderCtx.fillStyle = defaultStyle.fillStyle;
      var cellupdate = [];
      var mergeCache = {};
      var borderOffset = {};
      var bodrder05 = 0.5;
      (_this$sheetCtx$hooks$5 = (_this$sheetCtx$hooks5 = this.sheetCtx.hooks).beforeRenderCellArea) === null || _this$sheetCtx$hooks$5 === void 0 ? void 0 : _this$sheetCtx$hooks$5.call(_this$sheetCtx$hooks5, flowdata, renderCtx);

      for (var r = rowStart; r <= rowEnd; r += 1) {
        var _this$sheetCtx$config9, _this$sheetCtx$config10;

        var startY = void 0;

        if (r === 0) {
          startY = -scrollHeight - 1;
        } else {
          startY = this.sheetCtx.visibledatarow[r - 1] - scrollHeight - 1;
        }

        var endY = this.sheetCtx.visibledatarow[r] - scrollHeight;

        if (((_this$sheetCtx$config9 = this.sheetCtx.config) === null || _this$sheetCtx$config9 === void 0 ? void 0 : (_this$sheetCtx$config10 = _this$sheetCtx$config9.rowhidden) === null || _this$sheetCtx$config10 === void 0 ? void 0 : _this$sheetCtx$config10[r]) != null) {
          continue;
        }

        for (var c = colStart; c <= colEnd; c += 1) {
          var _this$sheetCtx$config11, _this$sheetCtx$config12, _this$sheetCtx$config13, _this$sheetCtx$config14, _flowdata$r;

          var startX = void 0;

          if (c === 0) {
            startX = -scrollWidth;
          } else {
            startX = this.sheetCtx.visibledatacolumn[c - 1] - scrollWidth;
          }

          var endX = this.sheetCtx.visibledatacolumn[c] - scrollWidth;

          if (((_this$sheetCtx$config11 = this.sheetCtx.config) === null || _this$sheetCtx$config11 === void 0 ? void 0 : (_this$sheetCtx$config12 = _this$sheetCtx$config11.colhidden) === null || _this$sheetCtx$config12 === void 0 ? void 0 : _this$sheetCtx$config12[c]) != null) {
            continue;
          }

          var firstcolumnlen = this.sheetCtx.defaultcollen;

          if ((_this$sheetCtx$config13 = this.sheetCtx.config) === null || _this$sheetCtx$config13 === void 0 ? void 0 : (_this$sheetCtx$config14 = _this$sheetCtx$config13.columnlen) === null || _this$sheetCtx$config14 === void 0 ? void 0 : _this$sheetCtx$config14[c]) {
            firstcolumnlen = this.sheetCtx.config.columnlen[c];
          }

          if (flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$r = flowdata[r]) === null || _flowdata$r === void 0 ? void 0 : _flowdata$r[c]) {
            var value = flowdata[r][c];

            if (value === null || value === void 0 ? void 0 : value.mc) {
              borderOffset["".concat(r, "_").concat(c)] = {
                startY: startY,
                startX: startX,
                endY: endY,
                endX: endX
              };

              if ("rs" in value.mc) {
                var key = "r".concat(r, "c").concat(c);
                mergeCache[key] = cellupdate.length;
              } else {
                var _key = "r".concat(value.mc.r, "c").concat(value.mc.c);

                var margeMain = cellupdate[mergeCache[_key]];

                if (_.isNil(margeMain)) {
                  mergeCache[_key] = cellupdate.length;
                  cellupdate.push({
                    r: r,
                    c: c,
                    startX: startX,
                    startY: startY,
                    endY: endY,
                    endX: endX,
                    firstcolumnlen: firstcolumnlen
                  });
                } else {
                  if (margeMain.c === c) {
                    margeMain.endY += endY - startY - 1;
                  }

                  if (margeMain.r === r) {
                    margeMain.endX += endX - startX;
                    margeMain.firstcolumnlen += firstcolumnlen;
                  }
                }

                continue;
              }
            }
          }

          cellupdate.push({
            r: r,
            c: c,
            startY: startY,
            startX: startX,
            endY: endY,
            endX: endX,
            firstcolumnlen: firstcolumnlen
          });
          borderOffset["".concat(r, "_").concat(c)] = {
            startY: startY,
            startX: startX,
            endY: endY,
            endX: endX
          };
        }
      }

      var dynamicArrayCompute = {};
      var afCompute = {};
      var cfCompute = getComputeMap(this.sheetCtx);
      var cellOverflowMap = this.getCellOverflowMap(renderCtx, colStart, colEnd, rowStart, rowEnd);
      var mcArr = [];

      for (var cud = 0; cud < cellupdate.length; cud += 1) {
        var item = cellupdate[cud];
        var _r = item.r;
        var _c = item.c;
        var _startY = item.startY;
        var _startX = item.startX;
        var _endY = item.endY;
        var _endX = item.endX;

        if (_.isNil(flowdata[_r])) {
          continue;
        }

        if (_.isNil(flowdata[_r][_c])) {
          this.nullCellRender(_r, _c, _startY, _startX, _endY, _endX, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05);
        } else {
          var cell = flowdata[_r][_c];
          var _value2 = null;

          if (cell === null || cell === void 0 ? void 0 : cell.mc) {
            mcArr.push(cellupdate[cud]);
          } else {
            _value2 = getRealCellValue(_r, _c, flowdata);
          }

          if (_.isNil(_value2) || _value2.toString().length === 0) {
            this.nullCellRender(_r, _c, _startY, _startX, _endY, _endX, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05);
          } else {
            if ("".concat(_r, "_").concat(_c) in dynamicArrayCompute) {
              _value2 = dynamicArrayCompute["".concat(_r, "_").concat(_c)].v;
            }

            this.cellRender(_r, _c, _startY, _startX, _endY, _endX, _value2, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05);
          }
        }
      }

      for (var m = 0; m < mcArr.length; m += 1) {
        var _mainCell$mc, _mainCell$mc2;

        var _item = mcArr[m];
        var _r2 = _item.r;
        var _c2 = _item.c;
        var _startY2 = _item.startY;
        var _startX2 = _item.startX;

        var _endY2 = _item.endY - 1;

        var _endX2 = _item.endX - 1;

        var _cell = flowdata[_r2][_c2];
        if (!_cell) continue;
        var _value3 = null;
        var mergeMaindata = _cell.mc;
        if (!mergeMaindata) continue;
        _value3 = getRealCellValue(mergeMaindata.r, mergeMaindata.c, flowdata);
        _r2 = mergeMaindata.r;
        _c2 = mergeMaindata.c;
        var mainCell = flowdata[_r2][_c2];

        if (!(mainCell === null || mainCell === void 0 ? void 0 : (_mainCell$mc = mainCell.mc) === null || _mainCell$mc === void 0 ? void 0 : _mainCell$mc.rs) || !((_mainCell$mc2 = mainCell.mc) === null || _mainCell$mc2 === void 0 ? void 0 : _mainCell$mc2.cs)) {
          continue;
        }

        if (_c2 === 0) {
          _startX2 = -scrollWidth;
        } else {
          _startX2 = this.sheetCtx.visibledatacolumn[_c2 - 1] - scrollWidth;
        }

        if (_r2 === 0) {
          _startY2 = -scrollHeight - 1;
        } else {
          _startY2 = this.sheetCtx.visibledatarow[_r2 - 1] - scrollHeight - 1;
        }

        _endY2 = this.sheetCtx.visibledatarow[_r2 + mainCell.mc.rs - 1] - scrollHeight;
        _endX2 = this.sheetCtx.visibledatacolumn[_c2 + mainCell.mc.cs - 1] - scrollWidth;

        if (_.isNil(_value3) || _value3.toString().length === 0) {
          this.nullCellRender(_r2, _c2, _startY2, _startX2, _endY2, _endX2, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05, true);
        } else {
          if ("".concat(_r2, "_").concat(_c2) in dynamicArrayCompute) {
            _value3 = dynamicArrayCompute["".concat(_r2, "_").concat(_c2)].v;
          }

          this.cellRender(_r2, _c2, _startY2, _startX2, _endY2, _endX2, _value3, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05, true);
        }
      }

      if (((_this$sheetCtx$config15 = (_this$sheetCtx$config16 = this.sheetCtx.config) === null || _this$sheetCtx$config16 === void 0 ? void 0 : (_this$sheetCtx$config17 = _this$sheetCtx$config16.borderInfo) === null || _this$sheetCtx$config17 === void 0 ? void 0 : _this$sheetCtx$config17.length) !== null && _this$sheetCtx$config15 !== void 0 ? _this$sheetCtx$config15 : 0) > 0) {
        var borderSlashRender = function borderSlashRender(style, color, startY, startX, endY, endX, _offsetLeft, _offsetTop, canvas) {
          var linetype = style;
          var moveX = startX - 2 + bodrder05 + _offsetLeft;
          var moveY = startY + _offsetTop;
          var toX = endX - 2 + bodrder05 + _offsetLeft;
          var toY = endY - 2 + bodrder05 + _offsetTop;
          canvas.save();
          setLineDash(canvas, linetype, "v", moveX, moveY, toX, toY);
          canvas.strokeStyle = color;
          canvas.stroke();
          canvas.closePath();
          canvas.restore();
        };

        var borderLeftRender = function borderLeftRender(style, color, startY, startX, endY, endX, _offsetLeft, _offsetTop, canvas) {
          var linetype = style;
          var moveX = startX - 2 + bodrder05 + _offsetLeft;
          var moveY = startY + _offsetTop - 1;
          var toX = startX - 2 + bodrder05 + _offsetLeft;
          var toY = endY - 2 + bodrder05 + _offsetTop;
          canvas.save();
          setLineDash(canvas, linetype, "v", moveX, moveY, toX, toY);
          canvas.strokeStyle = color;
          canvas.stroke();
          canvas.closePath();
          canvas.restore();
        };

        var borderRightRender = function borderRightRender(style, color, startY, startX, endY, endX, _offsetLeft, _offsetTop, canvas) {
          var linetype = style;
          var moveX = endX - 2 + bodrder05 + _offsetLeft;
          var moveY = startY + _offsetTop - 1;
          var toX = endX - 2 + bodrder05 + _offsetLeft;
          var toY = endY - 2 + bodrder05 + _offsetTop;
          canvas.save();
          setLineDash(canvas, linetype, "v", moveX, moveY, toX, toY);
          canvas.strokeStyle = color;
          canvas.stroke();
          canvas.closePath();
          canvas.restore();
        };

        var borderBottomRender = function borderBottomRender(style, color, startY, startX, endY, endX, _offsetLeft, _offsetTop, canvas) {
          var linetype = style;
          var moveX = startX - 2 + bodrder05 + _offsetLeft;
          var moveY = endY - 2 + bodrder05 + _offsetTop;
          var toX = endX - 2 + bodrder05 + _offsetLeft;
          var toY = endY - 2 + bodrder05 + _offsetTop;
          canvas.save();
          setLineDash(canvas, linetype, "h", moveX, moveY, toX, toY);
          canvas.strokeStyle = color;
          canvas.stroke();
          canvas.closePath();
          canvas.restore();
        };

        var borderTopRender = function borderTopRender(style, color, startY, startX, endY, endX, _offsetLeft, _offsetTop, canvas) {
          var linetype = style;
          var moveX = startX - 2 + bodrder05 + _offsetLeft;
          var moveY = startY - 1 + bodrder05 + _offsetTop;
          var toX = endX - 2 + bodrder05 + _offsetLeft;
          var toY = startY - 1 + bodrder05 + _offsetTop;
          canvas.save();
          setLineDash(canvas, linetype, "h", moveX, moveY, toX, toY);
          canvas.strokeStyle = color;
          canvas.stroke();
          canvas.closePath();
          canvas.restore();
        };

        var borderInfoCompute = getBorderInfoComputeRange(this.sheetCtx, rowStart, rowEnd, colStart, colEnd);
        Object.keys(borderInfoCompute).forEach(function (x) {
          var bdRow = Number(x.substring(0, x.indexOf("_")));
          var bdCol = Number(x.substring(x.indexOf("_") + 1));

          if (borderOffset["".concat(bdRow, "_").concat(bdCol)]) {
            var _startY3 = borderOffset["".concat(bdRow, "_").concat(bdCol)].startY;
            var _startX3 = borderOffset["".concat(bdRow, "_").concat(bdCol)].startX;
            var _endY3 = borderOffset["".concat(bdRow, "_").concat(bdCol)].endY;
            var _endX3 = borderOffset["".concat(bdRow, "_").concat(bdCol)].endX;

            var cellOverflow_colInObj = _this.cellOverflow_colIn(cellOverflowMap, bdRow, bdCol, colStart, colEnd);

            var borderSlash = borderInfoCompute[x].s;

            if (borderSlash && (!cellOverflow_colInObj.colIn || cellOverflow_colInObj.stc === bdCol)) {
              var _mergeCellEndY, _mergeCellEndX;

              var mergeMap = _this.sheetCtx.config.merge;
              var mergeCell = mergeMap === null || mergeMap === void 0 ? void 0 : mergeMap["".concat(bdRow, "_").concat(bdCol)];
              var mergeCellEndX;
              var mergeCellEndY;

              if (mergeCell) {
                var mergeCellOffset = borderOffset["".concat(bdRow + mergeCell.rs - 1, "_").concat(bdCol + mergeCell.cs - 1)];
                mergeCellEndX = mergeCellOffset.endX;
                mergeCellEndY = mergeCellOffset.endY;
              }

              borderSlashRender(borderSlash.style, borderSlash.color, _startY3, _startX3, (_mergeCellEndY = mergeCellEndY) !== null && _mergeCellEndY !== void 0 ? _mergeCellEndY : _endY3, (_mergeCellEndX = mergeCellEndX) !== null && _mergeCellEndX !== void 0 ? _mergeCellEndX : _endX3, offsetLeft, offsetTop, renderCtx);
            }

            var borderLeft = borderInfoCompute[x].l;

            if (borderLeft && (!cellOverflow_colInObj.colIn || cellOverflow_colInObj.stc === bdCol)) {
              borderLeftRender(borderLeft.style, borderLeft.color, _startY3, _startX3, _endY3, _endX3, offsetLeft, offsetTop, renderCtx);
            }

            var borderRight = borderInfoCompute[x].r;

            if (borderRight && (!cellOverflow_colInObj.colIn || cellOverflow_colInObj.colLast)) {
              borderRightRender(borderRight.style, borderRight.color, _startY3, _startX3, _endY3, _endX3, offsetLeft, offsetTop, renderCtx);
            }

            var borderTop = borderInfoCompute[x].t;

            if (borderTop) {
              borderTopRender(borderTop.style, borderTop.color, _startY3, _startX3, _endY3, _endX3, offsetLeft, offsetTop, renderCtx);
            }

            var borderBottom = borderInfoCompute[x].b;

            if (borderBottom) {
              borderBottomRender(borderBottom.style, borderBottom.color, _startY3, _startX3, _endY3, _endX3, offsetLeft, offsetTop, renderCtx);
            }
          }
        });
      }

      if (colEnd === this.sheetCtx.visibledatacolumn.length - 1) {
        renderCtx.clearRect(colEndX - scrollWidth + offsetLeft - 1, offsetTop - 1, this.sheetCtx.ch_width - this.sheetCtx.visibledatacolumn[colEnd], rowEndY - scrollHeight);
      }

      renderCtx.restore();
      this.measureTextCacheTimeOut = setTimeout(function () {
        clearMeasureTextCache();
        _this.cellOverflowMapCache = {};
      }, 100);
    }
  }, {
    key: "getCellOverflowMap",
    value: function getCellOverflowMap(canvas, colStart, colEnd, rowStart, rowEnd) {
      var flowdata = getFlowdata(this.sheetCtx);
      var map = {};
      var data = flowdata;

      if (!data) {
        return map;
      }

      for (var r = rowStart; r <= rowEnd; r += 1) {
        if (_.isNil(data[r])) {
          continue;
        }

        if (this.cellOverflowMapCache[r]) {
          map[r] = this.cellOverflowMapCache[r];
          continue;
        }

        var hasCellOver = false;

        for (var c = 0; c < data[r].length; c += 1) {
          var _this$sheetCtx$config18, _this$sheetCtx$config19;

          var cell = data[r][c];

          if (((_this$sheetCtx$config18 = this.sheetCtx.config) === null || _this$sheetCtx$config18 === void 0 ? void 0 : (_this$sheetCtx$config19 = _this$sheetCtx$config18.colhidden) === null || _this$sheetCtx$config19 === void 0 ? void 0 : _this$sheetCtx$config19[c]) != null) {
            continue;
          }

          if (cell && (!_.isEmpty(cell.v) || isInlineStringCell(cell)) && _.isNil(cell.mc) && cell.tb === "1") {
            var horizonAlign = normalizedAttr(data, r, c, "ht");
            var textMetricsObj = getCellTextInfo(cell, canvas, this.sheetCtx, {
              r: r,
              c: c
            });
            var textMetrics = 0;

            if (textMetricsObj) {
              textMetrics = textMetricsObj.textWidthAll;
            }

            var startX = c - 1 < 0 ? 0 : this.sheetCtx.visibledatacolumn[c - 1];
            var endX = this.sheetCtx.visibledatacolumn[c];
            var stc = void 0;
            var edc = void 0;

            if (endX - startX < textMetrics) {
              if (horizonAlign === "0") {
                var trace_forward = this.cellOverflow_trace(r, c, c - 1, "forward", horizonAlign, textMetrics);
                var trace_backward = this.cellOverflow_trace(r, c, c + 1, "backward", horizonAlign, textMetrics);

                if (trace_forward.success) {
                  stc = trace_forward.c;
                } else {
                  stc = trace_forward.c + 1;
                }

                if (trace_backward.success) {
                  edc = trace_backward.c;
                } else {
                  edc = trace_backward.c - 1;
                }
              } else if (horizonAlign === "1") {
                var trace = this.cellOverflow_trace(r, c, c + 1, "backward", horizonAlign, textMetrics);
                stc = c;

                if (trace.success) {
                  edc = trace.c;
                } else {
                  edc = trace.c - 1;
                }
              } else if (horizonAlign === "2") {
                var _trace = this.cellOverflow_trace(r, c, c - 1, "forward", horizonAlign, textMetrics);

                edc = c;

                if (_trace.success) {
                  stc = _trace.c;
                } else {
                  stc = _trace.c + 1;
                }
              }
            } else {
              stc = c;
              edc = c;
            }

            if ((stc <= colEnd || edc >= colStart) && stc < edc) {
              var item = {
                r: r,
                stc: stc,
                edc: edc
              };

              if (_.isNil(map[r])) {
                map[r] = {};
              }

              map[r][c] = item;
              hasCellOver = true;
            }
          }
        }

        if (hasCellOver) {
          this.cellOverflowMapCache[r] = map[r];
        }
      }

      return map;
    }
  }, {
    key: "nullCellRender",
    value: function nullCellRender(r, c, startY, startX, endY, endX, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05) {
      var _this$sheetCtx$hooks$6, _this$sheetCtx$hooks6, _flowdata$r2, _flowdata$r2$c, _this$sheetCtx$hooks$7, _this$sheetCtx$hooks7;

      var isMerge = arguments.length > 18 && arguments[18] !== undefined ? arguments[18] : false;
      var checksCF = checkCF(r, c, cfCompute);
      var flowdata = getFlowdata(this.sheetCtx);
      if (!flowdata) return;
      var borderfix = getBorderFix();
      var fillStyle = normalizedAttr(flowdata, r, c, "bg");

      if (!_.isNil(checksCF) && !_.isNil(checksCF.cellColor)) {
        fillStyle = checksCF.cellColor;
      }

      if (!fillStyle) {
        renderCtx.fillStyle = "#FFFFFF";
      } else {
        renderCtx.fillStyle = fillStyle;
      }

      var cellsize = [startX + offsetLeft + borderfix[0], startY + offsetTop + borderfix[1], endX - startX + borderfix[2] - (isMerge ? 1 : 0), endY - startY + borderfix[3]];

      if (((_this$sheetCtx$hooks$6 = (_this$sheetCtx$hooks6 = this.sheetCtx.hooks).beforeRenderCell) === null || _this$sheetCtx$hooks$6 === void 0 ? void 0 : _this$sheetCtx$hooks$6.call(_this$sheetCtx$hooks6, flowdata[r][c], {
        row: r,
        column: c,
        startX: cellsize[0],
        startY: cellsize[1],
        endX: cellsize[2] + cellsize[0],
        endY: cellsize[3] + cellsize[1]
      }, renderCtx)) === false) {
        return;
      }

      renderCtx.fillRect(cellsize[0], cellsize[1], cellsize[2], cellsize[3]);

      if ("".concat(r, "_").concat(c) in dynamicArrayCompute) {
        var value = dynamicArrayCompute["".concat(r, "_").concat(c)].v;
        renderCtx.fillStyle = "#000000";
        var fontset = defaultFont(this.sheetCtx.defaultFontSize);
        renderCtx.font = fontset;
        var horizonAlignPos = startX + 4 + offsetLeft;
        var verticalAlignPos = endY + offsetTop - 2;
        renderCtx.textBaseline = "bottom";
        renderCtx.fillText(_.isNil(value) ? "" : value, horizonAlignPos, verticalAlignPos);
      }

      if (flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$r2 = flowdata[r]) === null || _flowdata$r2 === void 0 ? void 0 : (_flowdata$r2$c = _flowdata$r2[c]) === null || _flowdata$r2$c === void 0 ? void 0 : _flowdata$r2$c.ps) {
        var ps_w = 8 * this.sheetCtx.zoomRatio;
        var ps_h = 8 * this.sheetCtx.zoomRatio;
        renderCtx.beginPath();
        renderCtx.moveTo(endX + offsetLeft - 1 - ps_w, startY + offsetTop);
        renderCtx.lineTo(endX + offsetLeft - 1, startY + offsetTop);
        renderCtx.lineTo(endX + offsetLeft - 1, startY + offsetTop + ps_h);
        renderCtx.fillStyle = "#FC6666";
        renderCtx.fill();
        renderCtx.closePath();
      }

      var cellOverflow_colInObj = this.cellOverflow_colIn(cellOverflowMap, r, c, colStart, colEnd);

      if (cellOverflow_colInObj.colLast && !_.isNil(cellOverflow_colInObj.rowIndex) && !_.isNil(cellOverflow_colInObj.colIndex) && !_.isNil(cellOverflow_colInObj.stc) && !_.isNil(cellOverflow_colInObj.edc)) {
        this.cellOverflowRender(cellOverflow_colInObj.rowIndex, cellOverflow_colInObj.colIndex, cellOverflow_colInObj.stc, cellOverflow_colInObj.edc, renderCtx, scrollHeight, scrollWidth, offsetLeft, offsetTop, afCompute, cfCompute);
      }

      if (!cellOverflow_colInObj.colIn || cellOverflow_colInObj.colLast) {
        if (!this.sheetCtx.luckysheetcurrentisPivotTable && this.sheetCtx.showGridLines) {
          renderCtx.beginPath();
          renderCtx.moveTo(endX + offsetLeft - 2 + bodrder05, startY + offsetTop);
          renderCtx.lineTo(endX + offsetLeft - 2 + bodrder05, endY + offsetTop);
          renderCtx.lineWidth = 1;
          renderCtx.strokeStyle = defaultStyle.strokeStyle;
          renderCtx.stroke();
          renderCtx.closePath();
        }
      }

      if (!this.sheetCtx.luckysheetcurrentisPivotTable && this.sheetCtx.showGridLines) {
        renderCtx.beginPath();
        renderCtx.moveTo(startX + offsetLeft - 1, endY + offsetTop - 2 + bodrder05);
        renderCtx.lineTo(endX + offsetLeft - 1, endY + offsetTop - 2 + bodrder05);
        renderCtx.lineWidth = 1;
        renderCtx.strokeStyle = defaultStyle.strokeStyle;
        renderCtx.stroke();
        renderCtx.closePath();
      }

      (_this$sheetCtx$hooks$7 = (_this$sheetCtx$hooks7 = this.sheetCtx.hooks).afterRenderCell) === null || _this$sheetCtx$hooks$7 === void 0 ? void 0 : _this$sheetCtx$hooks$7.call(_this$sheetCtx$hooks7, flowdata[r][c], {
        row: r,
        column: c,
        startY: cellsize[1],
        startX: cellsize[0],
        endY: cellsize[3] + cellsize[1],
        endX: cellsize[2] + cellsize[0]
      }, renderCtx);
    }
  }, {
    key: "cellRender",
    value: function cellRender(r, c, startY, startX, endY, endX, value, renderCtx, afCompute, cfCompute, offsetLeft, offsetTop, dynamicArrayCompute, cellOverflowMap, colStart, colEnd, scrollHeight, scrollWidth, bodrder05) {
      var _this$sheetCtx$hooks$8, _this$sheetCtx$hooks8, _dataVerification$, _this$sheetCtx$hooks$9, _this$sheetCtx$hooks9, _flowdata$r3;

      var isMerge = arguments.length > 19 && arguments[19] !== undefined ? arguments[19] : false;
      var flowdata = getFlowdata(this.sheetCtx);

      if (!flowdata) {
        return;
      }

      var cell = flowdata[r][c];
      var cellWidth = endX - startX - 2;
      var cellHeight = endY - startY - 2;
      var space_width = 2;
      var space_height = 2;
      var horizonAlign = Number(normalizedAttr(flowdata, r, c, "ht"));
      var verticalAlign = Number(normalizedAttr(flowdata, r, c, "vt"));
      var checksAF = {};
      var checksCF = checkCF(r, c, cfCompute);
      var fillStyle = normalizedAttr(flowdata, r, c, "bg");

      if (!_.isNil(checksCF) && !_.isNil(checksCF.cellColor)) {
        fillStyle = checksCF.cellColor;
      }

      if (!fillStyle) {
        renderCtx.fillStyle = "#FFFFFF";
      } else {
        renderCtx.fillStyle = fillStyle;
      }

      var borderfix = getBorderFix();
      var cellsize = [startX + offsetLeft + borderfix[0], startY + offsetTop + borderfix[1], endX - startX + borderfix[2] - (isMerge ? 1 : 0), endY - startY + borderfix[3]];

      if (((_this$sheetCtx$hooks$8 = (_this$sheetCtx$hooks8 = this.sheetCtx.hooks).beforeRenderCell) === null || _this$sheetCtx$hooks$8 === void 0 ? void 0 : _this$sheetCtx$hooks$8.call(_this$sheetCtx$hooks8, flowdata[r][c], {
        row: r,
        column: c,
        startY: cellsize[1],
        startX: cellsize[0],
        endY: cellsize[3] + cellsize[1],
        endX: cellsize[2] + cellsize[0]
      }, renderCtx)) === false) {
        return;
      }

      renderCtx.fillRect(cellsize[0], cellsize[1], cellsize[2], cellsize[3]);
      var index = getSheetIndex(this.sheetCtx, this.sheetCtx.currentSheetId);
      var dataVerification = this.sheetCtx.luckysheetfile[index].dataVerification;

      if ((dataVerification === null || dataVerification === void 0 ? void 0 : dataVerification["".concat(r, "_").concat(c)]) && !validateCellData(this.sheetCtx, dataVerification["".concat(r, "_").concat(c)], value)) {
        var dv_w = 5 * this.sheetCtx.zoomRatio;
        var dv_h = 5 * this.sheetCtx.zoomRatio;
        renderCtx.beginPath();
        renderCtx.moveTo(startX + offsetLeft, startY + offsetTop);
        renderCtx.lineTo(startX + offsetLeft + dv_w, startY + offsetTop);
        renderCtx.lineTo(startX + offsetLeft, startY + offsetTop + dv_h);
        renderCtx.fillStyle = "#FC6666";
        renderCtx.fill();
        renderCtx.closePath();
      }

      if (cell === null || cell === void 0 ? void 0 : cell.ps) {
        var ps_w = 8 * this.sheetCtx.zoomRatio;
        var ps_h = 8 * this.sheetCtx.zoomRatio;
        renderCtx.beginPath();
        renderCtx.moveTo(endX + offsetLeft - ps_w, startY + offsetTop);
        renderCtx.lineTo(endX + offsetLeft, startY + offsetTop);
        renderCtx.lineTo(endX + offsetLeft, startY + offsetTop + ps_h);
        renderCtx.fillStyle = "#FC6666";
        renderCtx.fill();
        renderCtx.closePath();
      }

      if ((cell === null || cell === void 0 ? void 0 : cell.qp) === 1 && isRealNum$1(cell === null || cell === void 0 ? void 0 : cell.v)) {
        var _ps_w = 6 * this.sheetCtx.zoomRatio;

        var _ps_h = 6 * this.sheetCtx.zoomRatio;

        renderCtx.beginPath();
        renderCtx.moveTo(startX + offsetLeft + _ps_w - 1, startY + offsetTop);
        renderCtx.lineTo(startX + offsetLeft - 1, startY + offsetTop);
        renderCtx.lineTo(startX + offsetLeft - 1, startY + offsetTop + _ps_h);
        renderCtx.fillStyle = "#487f1e";
        renderCtx.fill();
        renderCtx.closePath();
      }

      var cellOverflow_bd_r_render = true;
      var cellOverflow_colInObj = this.cellOverflow_colIn(cellOverflowMap, r, c, colStart, colEnd);

      if ((cell === null || cell === void 0 ? void 0 : cell.tb) === "1" && cellOverflow_colInObj.colIn) {
        if (cellOverflow_colInObj.colLast && !_.isNil(cellOverflow_colInObj.rowIndex) && !_.isNil(cellOverflow_colInObj.colIndex) && !_.isNil(cellOverflow_colInObj.stc) && !_.isNil(cellOverflow_colInObj.edc)) {
          this.cellOverflowRender(cellOverflow_colInObj.rowIndex, cellOverflow_colInObj.colIndex, cellOverflow_colInObj.stc, cellOverflow_colInObj.edc, renderCtx, scrollHeight, scrollWidth, offsetLeft, offsetTop, afCompute, cfCompute);
        } else {
          cellOverflow_bd_r_render = false;
        }
      } else if ((dataVerification === null || dataVerification === void 0 ? void 0 : (_dataVerification$ = dataVerification["".concat(r, "_").concat(c)]) === null || _dataVerification$ === void 0 ? void 0 : _dataVerification$.type) === "checkbox") {
        var pos_x = startX + offsetLeft;
        var pos_y = startY + offsetTop + 1;
        renderCtx.save();
        renderCtx.beginPath();
        renderCtx.rect(pos_x, pos_y, cellWidth, cellHeight);
        renderCtx.clip();
        renderCtx.scale(this.sheetCtx.zoomRatio, this.sheetCtx.zoomRatio);
        var measureText = getMeasureText(value, renderCtx, this.sheetCtx);
        var textMetrics = measureText.width + 14;
        var oneLineTextHeight = measureText.actualBoundingBoxDescent + measureText.actualBoundingBoxAscent;
        var horizonAlignPos = pos_x + space_width;

        if (horizonAlign === 0) {
          horizonAlignPos = pos_x + cellWidth / 2 - textMetrics / 2;
        } else if (horizonAlign === 2) {
          horizonAlignPos = pos_x + cellWidth - space_width - textMetrics;
        }

        var verticalCellHeight = cellHeight > oneLineTextHeight ? cellHeight : oneLineTextHeight;
        var verticalAlignPos_text = pos_y + verticalCellHeight - space_height;
        renderCtx.textBaseline = "bottom";
        var verticalAlignPos_checkbox = verticalAlignPos_text - 13 * this.sheetCtx.zoomRatio;

        if (verticalAlign === 0) {
          verticalAlignPos_text = pos_y + verticalCellHeight / 2;
          renderCtx.textBaseline = "middle";
          verticalAlignPos_checkbox = verticalAlignPos_text - 6 * this.sheetCtx.zoomRatio;
        } else if (verticalAlign === 1) {
          verticalAlignPos_text = pos_y + space_height;
          renderCtx.textBaseline = "top";
          verticalAlignPos_checkbox = verticalAlignPos_text + 1 * this.sheetCtx.zoomRatio;
        }

        horizonAlignPos /= this.sheetCtx.zoomRatio;
        verticalAlignPos_text /= this.sheetCtx.zoomRatio;
        verticalAlignPos_checkbox /= this.sheetCtx.zoomRatio;
        renderCtx.lineWidth = 1;
        renderCtx.strokeStyle = "#000";
        renderCtx.strokeRect(horizonAlignPos, verticalAlignPos_checkbox, 10, 10);

        if (dataVerification["".concat(r, "_").concat(c)].checked) {
          renderCtx.beginPath();
          renderCtx.lineTo(horizonAlignPos + 1, verticalAlignPos_checkbox + 6);
          renderCtx.lineTo(horizonAlignPos + 4, verticalAlignPos_checkbox + 9);
          renderCtx.lineTo(horizonAlignPos + 9, verticalAlignPos_checkbox + 2);
          renderCtx.stroke();
          renderCtx.closePath();
        }

        renderCtx.fillStyle = normalizedAttr(flowdata, r, c, "fc");
        renderCtx.fillText(_.isNil(value) ? "" : value, horizonAlignPos + 14, verticalAlignPos_text);
        renderCtx.restore();
      } else {
        var _checksCF$dataBar, _checksCF$dataBar2, _checksCF$dataBar2$va, _cell$ct$fa$indexOf, _cell$ct, _cell$ct$fa, _cell$ct2;

        if ((checksCF === null || checksCF === void 0 ? void 0 : (_checksCF$dataBar = checksCF.dataBar) === null || _checksCF$dataBar === void 0 ? void 0 : _checksCF$dataBar.valueLen) && (checksCF === null || checksCF === void 0 ? void 0 : (_checksCF$dataBar2 = checksCF.dataBar) === null || _checksCF$dataBar2 === void 0 ? void 0 : (_checksCF$dataBar2$va = _checksCF$dataBar2.valueLen) === null || _checksCF$dataBar2$va === void 0 ? void 0 : _checksCF$dataBar2$va.toString()) !== "NaN") {
          var x = startX + offsetLeft + space_width;
          var y = startY + offsetTop + space_height;
          var w = cellWidth - space_width * 2;
          var h = cellHeight - space_height * 2;
          var valueType = checksCF.dataBar.valueType;
          var valueLen = checksCF.dataBar.valueLen;
          var format = checksCF.dataBar.format;

          if (valueType === "minus") {
            var minusLen = checksCF.dataBar.minusLen;

            if (format.length > 1) {
              var my_gradient = renderCtx.createLinearGradient(x + w * minusLen * (1 - valueLen), y, x + w * minusLen, y);
              my_gradient.addColorStop(0, "#ffffff");
              my_gradient.addColorStop(1, "#ff0000");
              renderCtx.fillStyle = my_gradient;
            } else {
              renderCtx.fillStyle = "#ff0000";
            }

            renderCtx.fillRect(x + w * minusLen * (1 - valueLen), y, w * minusLen * valueLen, h);
            renderCtx.beginPath();
            renderCtx.moveTo(x + w * minusLen * (1 - valueLen), y);
            renderCtx.lineTo(x + w * minusLen * (1 - valueLen), y + h);
            renderCtx.lineTo(x + w * minusLen, y + h);
            renderCtx.lineTo(x + w * minusLen, y);
            renderCtx.lineTo(x + w * minusLen * (1 - valueLen), y);
            renderCtx.lineWidth = 1;
            renderCtx.strokeStyle = "#ff0000";
            renderCtx.stroke();
            renderCtx.closePath();
          } else if (valueType === "plus") {
            var plusLen = checksCF.dataBar.plusLen;

            if (plusLen === 1) {
              if (format.length > 1) {
                var _my_gradient = renderCtx.createLinearGradient(x, y, x + w * valueLen, y);

                _my_gradient.addColorStop(0, format[0]);

                _my_gradient.addColorStop(1, format[1]);

                renderCtx.fillStyle = _my_gradient;
              } else {
                var _format = _slicedToArray(format, 1);

                renderCtx.fillStyle = _format[0];
              }

              renderCtx.fillRect(x, y, w * valueLen, h);
              renderCtx.beginPath();
              renderCtx.moveTo(x, y);
              renderCtx.lineTo(x, y + h);
              renderCtx.lineTo(x + w * valueLen, y + h);
              renderCtx.lineTo(x + w * valueLen, y);
              renderCtx.lineTo(x, y);
              renderCtx.lineWidth = 1;

              var _format2 = _slicedToArray(format, 1);

              renderCtx.strokeStyle = _format2[0];
              renderCtx.stroke();
              renderCtx.closePath();
            } else {
              var _minusLen = checksCF.dataBar.minusLen;

              if (format.length > 1) {
                var _my_gradient2 = renderCtx.createLinearGradient(x + w * _minusLen, y, x + w * _minusLen + w * plusLen * valueLen, y);

                _my_gradient2.addColorStop(0, format[0]);

                _my_gradient2.addColorStop(1, format[1]);

                renderCtx.fillStyle = _my_gradient2;
              } else {
                var _format3 = _slicedToArray(format, 1);

                renderCtx.fillStyle = _format3[0];
              }

              renderCtx.fillRect(x + w * _minusLen, y, w * plusLen * valueLen, h);
              renderCtx.beginPath();
              renderCtx.moveTo(x + w * _minusLen, y);
              renderCtx.lineTo(x + w * _minusLen, y + h);
              renderCtx.lineTo(x + w * _minusLen + w * plusLen * valueLen, y + h);
              renderCtx.lineTo(x + w * _minusLen + w * plusLen * valueLen, y);
              renderCtx.lineTo(x + w * _minusLen, y);
              renderCtx.lineWidth = 1;

              var _format4 = _slicedToArray(format, 1);

              renderCtx.strokeStyle = _format4[0];
              renderCtx.stroke();
              renderCtx.closePath();
            }
          }
        }

        var _pos_x = startX + offsetLeft;

        var _pos_y = startY + offsetTop + 1;

        renderCtx.save();
        renderCtx.beginPath();
        renderCtx.rect(_pos_x, _pos_y, cellWidth, cellHeight);
        renderCtx.clip();
        renderCtx.scale(this.sheetCtx.zoomRatio, this.sheetCtx.zoomRatio);
        var textInfo = cell ? getCellTextInfo(cell, renderCtx, this.sheetCtx, {
          cellWidth: cellWidth,
          cellHeight: cellHeight,
          space_width: space_width,
          space_height: space_height,
          r: r,
          c: c
        }, this.sheetCtx) : undefined;

        if ((checksCF === null || checksCF === void 0 ? void 0 : checksCF.icons) && textInfo.type === "plain") {
          var l = checksCF.icons.left;
          var t = checksCF.icons.top;
          var _value = textInfo.values[0];
          var verticalAlignPos = _pos_y + _value.top - textInfo.textHeightAll;

          if (verticalAlign === 0) {
            verticalAlignPos = _pos_y + cellHeight / 2 - textInfo.textHeightAll / 2;
          } else if (verticalAlign === 1) {
            verticalAlignPos = _pos_y;
          } else if (verticalAlign === 2) {
            verticalAlignPos -= textInfo.desc;
          }

          verticalAlignPos /= this.sheetCtx.zoomRatio;
          renderCtx.drawImage(getCfIconsImg(), l * 42, t * 32, 32, 32, _pos_x / this.sheetCtx.zoomRatio, verticalAlignPos, textInfo.textHeightAll / this.sheetCtx.zoomRatio, textInfo.textHeightAll / this.sheetCtx.zoomRatio);
        }

        renderCtx.fillStyle = normalizedAttr(flowdata, r, c, "fc");

        if (checksAF === null || checksAF === void 0 ? void 0 : checksAF[0]) {
          var _checksAF = _slicedToArray(checksAF, 1);

          renderCtx.fillStyle = _checksAF[0];
        }

        if (checksCF === null || checksCF === void 0 ? void 0 : checksCF.textColor) {
          renderCtx.fillStyle = checksCF.textColor;
        }

        if (((_cell$ct$fa$indexOf = cell === null || cell === void 0 ? void 0 : (_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : (_cell$ct$fa = _cell$ct.fa) === null || _cell$ct$fa === void 0 ? void 0 : _cell$ct$fa.indexOf("[Red]")) !== null && _cell$ct$fa$indexOf !== void 0 ? _cell$ct$fa$indexOf : -1) > -1 && (cell === null || cell === void 0 ? void 0 : (_cell$ct2 = cell.ct) === null || _cell$ct2 === void 0 ? void 0 : _cell$ct2.t) === "n" && (cell === null || cell === void 0 ? void 0 : cell.v) < 0) {
          renderCtx.fillStyle = "#ff0000";
        }

        this.cellTextRender(textInfo, renderCtx, {
          pos_x: _pos_x,
          pos_y: _pos_y
        });
        renderCtx.restore();
      }

      if (cellOverflow_bd_r_render) {
        if (!this.sheetCtx.luckysheetcurrentisPivotTable && this.sheetCtx.showGridLines) {
          renderCtx.beginPath();
          renderCtx.moveTo(endX + offsetLeft - 2 + bodrder05, startY + offsetTop);
          renderCtx.lineTo(endX + offsetLeft - 2 + bodrder05, endY + offsetTop);
          renderCtx.lineWidth = 1;
          renderCtx.strokeStyle = defaultStyle.strokeStyle;
          renderCtx.stroke();
          renderCtx.closePath();
        }
      }

      if (!this.sheetCtx.luckysheetcurrentisPivotTable && this.sheetCtx.showGridLines) {
        renderCtx.beginPath();
        renderCtx.moveTo(startX + offsetLeft - 1, endY + offsetTop - 2 + bodrder05);
        renderCtx.lineTo(endX + offsetLeft - 1, endY + offsetTop - 2 + bodrder05);
        renderCtx.lineWidth = 1;
        renderCtx.strokeStyle = defaultStyle.strokeStyle;
        renderCtx.stroke();
        renderCtx.closePath();
      }

      (_this$sheetCtx$hooks$9 = (_this$sheetCtx$hooks9 = this.sheetCtx.hooks).afterRenderCell) === null || _this$sheetCtx$hooks$9 === void 0 ? void 0 : _this$sheetCtx$hooks$9.call(_this$sheetCtx$hooks9, (_flowdata$r3 = flowdata[r]) === null || _flowdata$r3 === void 0 ? void 0 : _flowdata$r3[c], {
        row: r,
        column: c,
        startX: cellsize[0],
        startY: cellsize[1],
        endX: cellsize[2] + cellsize[0],
        endY: cellsize[3] + cellsize[1]
      }, renderCtx);
    }
  }, {
    key: "cellOverflowRender",
    value: function cellOverflowRender(r, c, stc, edc, renderCtx, scrollHeight, scrollWidth, offsetLeft, offsetTop, afCompute, cfCompute) {
      var startY;

      if (r === 0) {
        startY = -scrollHeight - 1;
      } else {
        startY = this.sheetCtx.visibledatarow[r - 1] - scrollHeight - 1;
      }

      var endY = this.sheetCtx.visibledatarow[r] - scrollHeight;
      var startX;

      if (stc === 0) {
        startX = -scrollWidth;
      } else {
        startX = this.sheetCtx.visibledatacolumn[stc - 1] - scrollWidth;
      }

      var endX = this.sheetCtx.visibledatacolumn[edc] - scrollWidth;
      var flowdata = getFlowdata(this.sheetCtx);

      if (!flowdata) {
        return;
      }

      var cell = flowdata[r][c];
      var cellWidth = endX - startX - 2;
      var cellHeight = endY - startY - 2;
      var space_width = 2;
      var space_height = 2;
      var pos_x = startX + offsetLeft;
      var pos_y = startY + offsetTop + 1;
      var fontset = getFontSet(cell, this.sheetCtx.defaultFontSize, this.sheetCtx);
      renderCtx.font = fontset;
      renderCtx.save();
      renderCtx.beginPath();
      renderCtx.rect(pos_x, pos_y, cellWidth, cellHeight);
      renderCtx.clip();
      renderCtx.scale(this.sheetCtx.zoomRatio, this.sheetCtx.zoomRatio);
      var textInfo = cell ? getCellTextInfo(cell, renderCtx, this.sheetCtx, {
        cellWidth: cellWidth,
        cellHeight: cellHeight,
        space_width: space_width,
        space_height: space_height,
        r: r,
        c: c
      }, this.sheetCtx) : undefined;
      var checksAF = {};
      var checksCF = checkCF(r, c, cfCompute);
      renderCtx.fillStyle = normalizedAttr(flowdata, r, c, "fc");

      if (checksAF === null || checksAF === void 0 ? void 0 : checksAF[0]) {
        var _checksAF2 = _slicedToArray(checksAF, 1);

        renderCtx.fillStyle = _checksAF2[0];
      }

      if (checksCF === null || checksCF === void 0 ? void 0 : checksCF.textColor) {
        renderCtx.fillStyle = checksCF.textColor;
      }

      this.cellTextRender(textInfo, renderCtx, {
        pos_x: pos_x,
        pos_y: pos_y
      });
      renderCtx.restore();
    }
  }, {
    key: "cellOverflow_trace",
    value: function cellOverflow_trace(r, curC, traceC, traceDir, horizonAlign, textMetrics) {
      var flowdata = getFlowdata(this.sheetCtx);
      if (!flowdata) return {};
      var data = flowdata;

      if (traceDir === "forward" && traceC < 0) {
        return {
          success: false,
          r: r,
          c: traceC
        };
      }

      if (traceDir === "backward" && traceC > data[r].length - 1) {
        return {
          success: false,
          r: r,
          c: traceC
        };
      }

      var cell = data[r][traceC];

      if (cell && (!_.isEmpty(cell.v) || cell.mc)) {
        return {
          success: false,
          r: r,
          c: traceC
        };
      }

      var start_curC = curC - 1 < 0 ? 0 : this.sheetCtx.visibledatacolumn[curC - 1];
      var end_curC = this.sheetCtx.visibledatacolumn[curC];
      var w = textMetrics - (end_curC - start_curC);

      if (horizonAlign === "0") {
        start_curC -= w / 2;
        end_curC += w / 2;
      } else if (horizonAlign === "1") {
        end_curC += w;
      } else if (horizonAlign === "2") {
        start_curC -= w;
      }

      var start_traceC = traceC - 1 < 0 ? 0 : this.sheetCtx.visibledatacolumn[traceC - 1];
      var end_traceC = this.sheetCtx.visibledatacolumn[traceC];

      if (traceDir === "forward") {
        if (start_curC < start_traceC) {
          return this.cellOverflow_trace(r, curC, traceC - 1, traceDir, horizonAlign, textMetrics);
        }

        if (start_curC < end_traceC) {
          return {
            success: true,
            r: r,
            c: traceC
          };
        }

        return {
          success: false,
          r: r,
          c: traceC
        };
      }

      if (traceDir === "backward") {
        if (end_curC > end_traceC) {
          return this.cellOverflow_trace(r, curC, traceC + 1, traceDir, horizonAlign, textMetrics);
        }

        if (end_curC > start_traceC) {
          return {
            success: true,
            r: r,
            c: traceC
          };
        }

        return {
          success: false,
          r: r,
          c: traceC
        };
      }

      return null;
    }
  }, {
    key: "cellOverflow_colIn",
    value: function cellOverflow_colIn(map, r, c, col_st, col_ed) {
      var colIn = false;
      var colLast = false;
      var rowIndex;
      var colIndex;
      var stc;
      var edc;

      _.forEach(map, function (row, rkey) {
        _.forEach(row, function (mapItem, ckey) {
          rowIndex = Number(rkey);
          colIndex = Number(ckey);
          stc = mapItem.stc;
          edc = mapItem.edc;

          if (rowIndex === r) {
            if (c >= stc && c <= edc) {
              colIn = true;

              if (c === edc || c === col_ed) {
                colLast = true;
                return false;
              }
            }
          }

          return true;
        });

        return !colLast;
      });

      return {
        colIn: colIn,
        colLast: colLast,
        rowIndex: rowIndex,
        colIndex: colIndex,
        stc: stc,
        edc: edc
      };
    }
  }, {
    key: "cellTextRender",
    value: function cellTextRender(textInfo, ctx, option) {
      if (!textInfo) {
        return;
      }

      var values = textInfo.values;
      var pos_x = option.pos_x;
      var pos_y = option.pos_y;

      if (!values) {
        return;
      }

      if (textInfo.rotate !== 0 && textInfo.type !== "verticalWrap") {
        ctx.save();
        ctx.translate((pos_x + textInfo.textLeftAll) / this.sheetCtx.zoomRatio, (pos_y + textInfo.textTopAll) / this.sheetCtx.zoomRatio);
        ctx.rotate(-textInfo.rotate * Math.PI / 180);
        ctx.translate(-(textInfo.textLeftAll + pos_x) / this.sheetCtx.zoomRatio, -(pos_y + textInfo.textTopAll) / this.sheetCtx.zoomRatio);
      }

      for (var i = 0; i < values.length; i += 1) {
        var word = values[i];

        if (word.inline === true && word.style) {
          ctx.font = word.style.fontset;
          ctx.fillStyle = word.style.fc;
        } else {
          ctx.font = word.style;
        }

        var txt = _.isPlainObject(word.content) ? word.content.m : word.content;
        ctx.fillText(txt, (pos_x + word.left) / this.sheetCtx.zoomRatio, (pos_y + word.top) / this.sheetCtx.zoomRatio);

        if (word.cancelLine) {
          var c = word.cancelLine;
          ctx.beginPath();
          ctx.moveTo(Math.floor((pos_x + c.startX) / this.sheetCtx.zoomRatio) + 0.5, Math.floor((pos_y + c.startY) / this.sheetCtx.zoomRatio) + 0.5);
          ctx.lineTo(Math.floor((pos_x + c.endX) / this.sheetCtx.zoomRatio) + 0.5, Math.floor((pos_y + c.endY) / this.sheetCtx.zoomRatio) + 0.5);
          ctx.lineWidth = Math.floor(c.fs / 9);
          ctx.strokeStyle = ctx.fillStyle;
          ctx.stroke();
          ctx.closePath();
        }

        if (word.underLine) {
          var underLines = word.underLine;

          for (var a = 0; a < underLines.length; a += 1) {
            var item = underLines[a];
            ctx.beginPath();
            ctx.moveTo(Math.floor((pos_x + item.startX) / this.sheetCtx.zoomRatio) + 0.5, Math.floor((pos_y + item.startY) / this.sheetCtx.zoomRatio));
            ctx.lineTo(Math.floor((pos_x + item.endX) / this.sheetCtx.zoomRatio) + 0.5, Math.floor((pos_y + item.endY) / this.sheetCtx.zoomRatio) + 0.5);
            ctx.lineWidth = Math.floor(item.fs / 9);
            ctx.strokeStyle = ctx.fillStyle;
            ctx.stroke();
            ctx.closePath();
          }
        }
      }

      if (textInfo.rotate !== 0 && textInfo.type !== "verticalWrap") {
        ctx.restore();
      }
    }
  }, {
    key: "drawFreezeLine",
    value: function drawFreezeLine(_ref2) {
      var horizontalTop = _ref2.horizontalTop,
          verticalLeft = _ref2.verticalLeft;
      var renderCtx = this.canvasElement.getContext("2d");
      if (!renderCtx) return;
      renderCtx.save();
      renderCtx.scale(this.sheetCtx.devicePixelRatio, this.sheetCtx.devicePixelRatio);
      renderCtx.strokeStyle = "#ccc";
      renderCtx.lineWidth = 2;

      if (horizontalTop) {
        renderCtx.beginPath();
        renderCtx.moveTo(0, horizontalTop);
        renderCtx.lineTo(this.canvasElement.width, horizontalTop);
        renderCtx.stroke();
        renderCtx.closePath();
      }

      if (verticalLeft) {
        renderCtx.beginPath();
        renderCtx.moveTo(verticalLeft, 0);
        renderCtx.lineTo(verticalLeft, this.canvasElement.height);
        renderCtx.stroke();
        renderCtx.closePath();
      }

      renderCtx.restore();
    }
  }]);

  return Canvas;
}();

function handleScreenShot(ctx) {
  if (ctx.luckysheet_select_save == null) return undefined;

  if (ctx.luckysheet_select_save.length === 0) {
    return undefined;
  }

  if (ctx.luckysheet_select_save.length > 1) {
    return undefined;
  }

  if (ctx.config.merge != null) {
    var has_PartMC = false;

    for (var s = 0; s < ctx.luckysheet_select_save.length; s += 1) {
      var r1 = ctx.luckysheet_select_save[s].row[0];
      var r2 = ctx.luckysheet_select_save[s].row[1];
      var c1 = ctx.luckysheet_select_save[s].column[0];
      var c2 = ctx.luckysheet_select_save[s].column[1];
      has_PartMC = hasPartMC(ctx, ctx.config, r1, r2, c1, c2);

      if (has_PartMC) {
        break;
      }
    }

    if (has_PartMC) {
      return undefined;
    }
  }

  var st_r = ctx.luckysheet_select_save[0].row[0];
  var ed_r = ctx.luckysheet_select_save[0].row[1];
  var st_c = ctx.luckysheet_select_save[0].column[0];
  var ed_c = ctx.luckysheet_select_save[0].column[1];
  var scrollHeight;
  var rh_height;

  if (st_r - 1 < 0) {
    scrollHeight = 0;
    rh_height = ctx.visibledatarow[ed_r];
  } else {
    scrollHeight = ctx.visibledatarow[st_r - 1];
    rh_height = ctx.visibledatarow[ed_r] - ctx.visibledatarow[st_r - 1];
  }

  var scrollWidth;
  var ch_width;

  if (st_c - 1 < 0) {
    scrollWidth = 0;
    ch_width = ctx.visibledatacolumn[ed_c];
  } else {
    scrollWidth = ctx.visibledatacolumn[st_c - 1];
    ch_width = ctx.visibledatacolumn[ed_c] - ctx.visibledatacolumn[st_c - 1];
  }

  var newCanvasElement = document.createElement("canvas");
  newCanvasElement.width = Math.ceil(ch_width * devicePixelRatio);
  newCanvasElement.height = Math.ceil(rh_height * devicePixelRatio);
  newCanvasElement.style.width = "".concat(ch_width, "px");
  newCanvasElement.style.height = "".concat(rh_height, "px");
  var newCanvas = new Canvas(newCanvasElement, ctx);
  newCanvas.drawMain({
    scrollWidth: scrollWidth,
    scrollHeight: scrollHeight,
    drawWidth: ch_width,
    drawHeight: rh_height,
    offsetLeft: 1,
    offsetTop: 1,
    clear: true
  });
  var ctx_newCanvas = newCanvasElement.getContext("2d");
  if (ctx_newCanvas == null) return undefined;
  ctx_newCanvas.beginPath();
  ctx_newCanvas.moveTo(0, 0);
  ctx_newCanvas.lineTo(0, ctx.devicePixelRatio * rh_height);
  ctx_newCanvas.lineWidth = ctx.devicePixelRatio * 2;
  ctx_newCanvas.strokeStyle = defaultStyle.strokeStyle;
  ctx_newCanvas.stroke();
  ctx_newCanvas.closePath();
  ctx_newCanvas.beginPath();
  ctx_newCanvas.moveTo(0, 0);
  ctx_newCanvas.lineTo(ctx.devicePixelRatio * ch_width, 0);
  ctx_newCanvas.lineWidth = ctx.devicePixelRatio * 2;
  ctx_newCanvas.strokeStyle = defaultStyle.strokeStyle;
  ctx_newCanvas.stroke();
  ctx_newCanvas.closePath();
  var image = new Image();
  var url = newCanvasElement.toDataURL("image/png");
  image.src = url;

  if (ch_width > rh_height) {
    image.style.width = "100%";
  } else {
    image.style.height = "100%";
  }

  newCanvasElement.remove();
  return image.src;
}

function getSearchIndexArr(searchText, range, flowdata) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    regCheck: false,
    wordCheck: false,
    caseCheck: false
  },
      regCheck = _ref.regCheck,
      wordCheck = _ref.wordCheck,
      caseCheck = _ref.caseCheck;

  var arr = [];
  var obj = {};

  for (var s = 0; s < range.length; s += 1) {
    var r1 = range[s].row[0];
    var r2 = range[s].row[1];
    var c1 = range[s].column[0];
    var c2 = range[s].column[1];

    for (var r = r1; r <= r2; r += 1) {
      for (var c = c1; c <= c2; c += 1) {
        var cell = flowdata[r][c];

        if (cell != null) {
          var value = valueShowEs(r, c, flowdata);

          if (value === 0) {
            value = value.toString();
          }

          if (value != null && value !== "") {
            value = value.toString();

            if (wordCheck) {
              if (caseCheck) {
                if (searchText === value) {
                  if (!("".concat(r, "_").concat(c) in obj)) {
                    _.set(obj, "".concat(r, "_").concat(c), 0);

                    arr.push({
                      r: r,
                      c: c
                    });
                  }
                }
              } else {
                var txt = searchText.toLowerCase();

                if (txt === value.toLowerCase()) {
                  if (!("".concat(r, "_").concat(c) in obj)) {
                    _.set(obj, "".concat(r, "_").concat(c), 0);

                    arr.push({
                      r: r,
                      c: c
                    });
                  }
                }
              }
            } else if (regCheck) {
              var reg = void 0;

              if (caseCheck) {
                reg = new RegExp(getRegExpStr(searchText), "g");
              } else {
                reg = new RegExp(getRegExpStr(searchText), "ig");
              }

              if (reg.test(value)) {
                if (!("".concat(r, "_").concat(c) in obj)) {
                  _.set(obj, "".concat(r, "_").concat(c), 0);

                  arr.push({
                    r: r,
                    c: c
                  });
                }
              }
            } else {
              if (caseCheck) {
                if (~value.indexOf(searchText)) {
                  if (!("".concat(r, "_").concat(c) in obj)) {
                    _.set(obj, "".concat(r, "_").concat(c), 0);

                    arr.push({
                      r: r,
                      c: c
                    });
                  }
                }
              } else {
                if (~value.toLowerCase().indexOf(searchText.toLowerCase())) {
                  if (!("".concat(r, "_").concat(c) in obj)) {
                    _.set(obj, "".concat(r, "_").concat(c), 0);

                    arr.push({
                      r: r,
                      c: c
                    });
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  return arr;
}
function searchNext(ctx, searchText, checkModes) {
  var _ctx$luckysheet_selec, _ctx$luckysheet_selec2;

  var _locale = locale(ctx),
      findAndReplace = _locale.findAndReplace;

  var flowdata = getFlowdata(ctx);

  if (searchText === "" || searchText == null || flowdata == null) {
    return findAndReplace.searchInputTip;
  }

  var range;

  if (_.size(ctx.luckysheet_select_save) === 0 || ((_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    range = [{
      row: [0, flowdata.length - 1],
      column: [0, flowdata[0].length - 1],
      row_focus: 0,
      column_focus: 0
    }];
  } else {
    range = _.assign([], ctx.luckysheet_select_save);
  }

  var searchIndexArr = getSearchIndexArr(searchText, range, flowdata, checkModes);

  if (searchIndexArr.length === 0) {
    return findAndReplace.noFindTip;
  }

  var count = 0;

  if (_.size(ctx.luckysheet_select_save) === 0 || ((_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    if (_.size(ctx.luckysheet_select_save) === 0) {
      count = 0;
    } else {
      for (var i = 0; i < searchIndexArr.length; i += 1) {
        if (searchIndexArr[i].r === ctx.luckysheet_select_save[0].row[0] && searchIndexArr[i].c === ctx.luckysheet_select_save[0].column[0]) {
          if (i === searchIndexArr.length - 1) {
            count = 0;
          } else {
            count = i + 1;
          }

          break;
        }
      }
    }

    ctx.luckysheet_select_save = normalizeSelection(ctx, [{
      row: [searchIndexArr[count].r, searchIndexArr[count].r],
      column: [searchIndexArr[count].c, searchIndexArr[count].c]
    }]);
  } else {
    var rf = range[range.length - 1].row_focus;
    var cf = range[range.length - 1].column_focus;

    for (var _i = 0; _i < searchIndexArr.length; _i += 1) {
      if (searchIndexArr[_i].r === rf && searchIndexArr[_i].c === cf) {
        if (_i === searchIndexArr.length - 1) {
          count = 0;
        } else {
          count = _i + 1;
        }

        break;
      }
    }

    for (var s = 0; s < range.length; s += 1) {
      var r1 = range[s].row[0];
      var r2 = range[s].row[1];
      var c1 = range[s].column[0];
      var c2 = range[s].column[1];

      if (searchIndexArr[count].r >= r1 && searchIndexArr[count].r <= r2 && searchIndexArr[count].c >= c1 && searchIndexArr[count].c <= c2) {
        var obj = range[s];
        obj.row_focus = searchIndexArr[count].r;
        obj.column_focus = searchIndexArr[count].c;
        range.splice(s, 1);
        range.push(obj);
        break;
      }
    }

    ctx.luckysheet_select_save = range;
  }

  scrollToHighlightCell(ctx, searchIndexArr[count].r, searchIndexArr[count].c);
  return null;
}
function searchAll(ctx, searchText, checkModes) {
  var _ctx$luckysheet_selec3;

  var flowdata = getFlowdata(ctx);
  var searchResult = [];

  if (searchText === "" || searchText == null || flowdata == null) {
    return searchResult;
  }

  var range;

  if (_.size(ctx.luckysheet_select_save) === 0 || ((_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    range = [{
      row: [0, flowdata.length - 1],
      column: [0, flowdata[0].length - 1]
    }];
  } else {
    range = _.assign([], ctx.luckysheet_select_save);
  }

  var searchIndexArr = getSearchIndexArr(searchText, range, flowdata, checkModes);

  if (searchIndexArr.length === 0) {
    return searchResult;
  }

  for (var i = 0; i < searchIndexArr.length; i += 1) {
    var _ctx$luckysheetfile;

    var value_ShowEs = valueShowEs(searchIndexArr[i].r, searchIndexArr[i].c, flowdata).toString();
    searchResult.push({
      r: searchIndexArr[i].r,
      c: searchIndexArr[i].c,
      sheetName: (_ctx$luckysheetfile = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId) || 0]) === null || _ctx$luckysheetfile === void 0 ? void 0 : _ctx$luckysheetfile.name,
      sheetId: ctx.currentSheetId,
      cellPosition: "".concat(chatatABC(searchIndexArr[i].c)).concat(searchIndexArr[i].r + 1),
      value: value_ShowEs
    });
  }

  ctx.luckysheet_select_save = normalizeSelection(ctx, [{
    row: [searchIndexArr[0].r, searchIndexArr[0].r],
    column: [searchIndexArr[0].c, searchIndexArr[0].c]
  }]);
  return searchResult;
}
function onSearchDialogMoveStart(globalCache, e, container) {
  var box = document.getElementById("fortune-search-replace");
  if (!box) return;

  var _box$getBoundingClien = box.getBoundingClientRect(),
      top = _box$getBoundingClien.top,
      left = _box$getBoundingClien.left,
      width = _box$getBoundingClien.width,
      height = _box$getBoundingClien.height;

  var rect = container.getBoundingClientRect();
  left -= rect.left;
  top -= rect.top;
  var initialPosition = {
    left: left,
    top: top,
    width: width,
    height: height
  };

  _.set(globalCache, "searchDialog.moveProps", {
    cursorMoveStartPosition: {
      x: e.pageX,
      y: e.pageY
    },
    initialPosition: initialPosition
  });
}
function onSearchDialogMove(globalCache, e) {
  var searchDialog = globalCache === null || globalCache === void 0 ? void 0 : globalCache.searchDialog;
  var moveProps = searchDialog === null || searchDialog === void 0 ? void 0 : searchDialog.moveProps;
  if (moveProps == null) return;
  var dialog = document.getElementById("fortune-search-replace");
  var _moveProps$cursorMove = moveProps.cursorMoveStartPosition,
      startX = _moveProps$cursorMove.x,
      startY = _moveProps$cursorMove.y;
  var _moveProps$initialPos = moveProps.initialPosition,
      top = _moveProps$initialPos.top,
      left = _moveProps$initialPos.left;
  left += e.pageX - startX;
  top += e.pageY - startY;
  if (top < 0) top = 0;
  dialog.style.left = "".concat(left, "px");
  dialog.style.top = "".concat(top, "px");
}
function onSearchDialogMoveEnd(globalCache) {
  _.set(globalCache, "searchDialog.moveProps", undefined);
}
function replace(ctx, searchText, replaceText, checkModes) {
  var _ctx$luckysheet_selec4, _ctx$luckysheet_selec5;

  var _locale2 = locale(ctx),
      findAndReplace = _locale2.findAndReplace;

  var allowEdit = isAllowEdit(ctx);

  if (!allowEdit) {
    return findAndReplace.modeTip;
  }

  var flowdata = getFlowdata(ctx);

  if (searchText === "" || searchText == null || flowdata == null) {
    return findAndReplace.searchInputTip;
  }

  var range;

  if (_.size(ctx.luckysheet_select_save) === 0 || ((_ctx$luckysheet_selec4 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec4 === void 0 ? void 0 : _ctx$luckysheet_selec4.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    range = [{
      row: [0, flowdata.length - 1],
      column: [0, flowdata[0].length - 1]
    }];
  } else {
    range = _.assign([], ctx.luckysheet_select_save);
  }

  var searchIndexArr = getSearchIndexArr(searchText, range, flowdata, checkModes);

  if (searchIndexArr.length === 0) {
    return findAndReplace.noReplceTip;
  }

  var count = null;
  var last = (_ctx$luckysheet_selec5 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec5 === void 0 ? void 0 : _ctx$luckysheet_selec5[ctx.luckysheet_select_save.length - 1];
  var rf = last === null || last === void 0 ? void 0 : last.row_focus;
  var cf = last === null || last === void 0 ? void 0 : last.column_focus;

  for (var i = 0; i < searchIndexArr.length; i += 1) {
    if (searchIndexArr[i].r === rf && searchIndexArr[i].c === cf) {
      count = i;
      break;
    }
  }

  if (count == null) {
    if (searchIndexArr.length === 0) {
      return findAndReplace.noMatchTip;
    }

    count = 0;
  }

  var d = flowdata;
  var r;
  var c;

  if (checkModes.wordCheck) {
    r = searchIndexArr[count].r;
    c = searchIndexArr[count].c;
    var v = replaceText;
    setCellValue(ctx, r, c, d, v);
  } else {
    var reg;

    if (checkModes.caseCheck) {
      reg = new RegExp(getRegExpStr(searchText), "g");
    } else {
      reg = new RegExp(getRegExpStr(searchText), "ig");
    }

    r = searchIndexArr[count].r;
    c = searchIndexArr[count].c;

    var _v = valueShowEs(r, c, d).toString().replace(reg, replaceText);

    setCellValue(ctx, r, c, d, _v);
  }

  ctx.luckysheet_select_save = normalizeSelection(ctx, [{
    row: [r, r],
    column: [c, c]
  }]);
  scrollToHighlightCell(ctx, r, c);
  return null;
}
function replaceAll(ctx, searchText, replaceText, checkModes) {
  var _ctx$luckysheet_selec6;

  var _locale3 = locale(ctx),
      findAndReplace = _locale3.findAndReplace;

  var allowEdit = isAllowEdit(ctx);

  if (!allowEdit) {
    return findAndReplace.modeTip;
  }

  var flowdata = getFlowdata(ctx);

  if (searchText === "" || searchText == null || flowdata == null) {
    return findAndReplace.searchInputTip;
  }

  var range;

  if (_.size(ctx.luckysheet_select_save) === 0 || ((_ctx$luckysheet_selec6 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec6 === void 0 ? void 0 : _ctx$luckysheet_selec6.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    range = [{
      row: [0, flowdata.length - 1],
      column: [0, flowdata[0].length - 1]
    }];
  } else {
    range = _.assign([], ctx.luckysheet_select_save);
  }

  var searchIndexArr = getSearchIndexArr(searchText, range, flowdata, checkModes);

  if (searchIndexArr.length === 0) {
    return findAndReplace.noReplceTip;
  }

  var d = flowdata;
  var replaceCount = 0;

  if (checkModes.wordCheck) {
    for (var i = 0; i < searchIndexArr.length; i += 1) {
      var r = searchIndexArr[i].r;
      var c = searchIndexArr[i].c;
      var v = replaceText;
      setCellValue(ctx, r, c, d, v);
      range.push({
        row: [r, r],
        column: [c, c]
      });
      replaceCount += 1;
    }
  } else {
    var reg;

    if (checkModes.caseCheck) {
      reg = new RegExp(getRegExpStr(searchText), "g");
    } else {
      reg = new RegExp(getRegExpStr(searchText), "ig");
    }

    for (var _i2 = 0; _i2 < searchIndexArr.length; _i2 += 1) {
      var _r = searchIndexArr[_i2].r;
      var _c = searchIndexArr[_i2].c;

      var _v2 = valueShowEs(_r, _c, d).toString().replace(reg, replaceText);

      setCellValue(ctx, _r, _c, d, _v2);
      range.push({
        row: [_r, _r],
        column: [_c, _c]
      });
      replaceCount += 1;
    }
  }

  ctx.luckysheet_select_save = normalizeSelection(ctx, range);
  var succeedInfo = replaceHtml(findAndReplace.successTip, {
    xlength: replaceCount
  });
  return succeedInfo;
}

function labelFilterOptionState(ctx, optionstate, rowhidden, caljs, str, edr, cindex, stc, edc, saveData) {
  var param = {
    caljs: caljs,
    rowhidden: rowhidden,
    optionstate: optionstate,
    str: str,
    edr: edr,
    cindex: cindex,
    stc: stc,
    edc: edc
  };

  if (optionstate) {
    ctx.filter[cindex - stc] = param;
  } else {
    delete ctx.filter[cindex - stc];
  }

  if (saveData) {
    var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
    if (sheetIndex == null) return;
    var file = ctx.luckysheetfile[sheetIndex];

    if (file.filter == null) {
      file.filter = {};
    }

    if (optionstate) {
      file.filter[cindex - stc] = param;
    } else {
      delete file.filter[cindex - stc];
    }
  }
}
function orderbydatafiler(ctx, str, stc, edr, edc, curr, asc) {
  var d = getFlowdata(ctx);

  if (d == null) {
    return null;
  }

  str += 1;
  var hasMc = false;
  var data = [];

  for (var r = str; r <= edr; r += 1) {
    var data_row = [];

    for (var c = stc; c <= edc; c += 1) {
      var _d$r$c;

      if (d[r][c] != null && ((_d$r$c = d[r][c]) === null || _d$r$c === void 0 ? void 0 : _d$r$c.mc) != null) {
        hasMc = true;
        break;
      }

      data_row.push(d[r][c]);
    }

    data.push(data_row);
  }

  if (hasMc) {
    var _locale = locale(ctx),
        filter = _locale.filter;

    return filter.mergeError;
  }

  sortDataRange(ctx, d, data, curr - stc, asc, str, edr, stc, edc);
  return null;
}
function createFilterOptions(ctx, luckysheet_filter_save, sheetId, filterObj, saveData) {
  var _ctx$visibledatarow$r, _ctx$visibledatarow, _ctx$visibledatacolum, _ctx$visibledatacolum2;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  if (sheetId != null && sheetId !== ctx.currentSheetId) return;
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);
  if (sheetIndex == null) return;

  if (luckysheet_filter_save == null || _.size(luckysheet_filter_save) === 0) {
    delete ctx.filterOptions;
    return;
  }

  var r1 = luckysheet_filter_save.row[0];
  var r2 = luckysheet_filter_save.row[1];
  var c1 = luckysheet_filter_save.column[0];
  var c2 = luckysheet_filter_save.column[1];
  var row = (_ctx$visibledatarow$r = ctx.visibledatarow[r2]) !== null && _ctx$visibledatarow$r !== void 0 ? _ctx$visibledatarow$r : 0;
  var row_pre = r1 - 1 === -1 ? 0 : (_ctx$visibledatarow = ctx.visibledatarow[r1 - 1]) !== null && _ctx$visibledatarow !== void 0 ? _ctx$visibledatarow : 0;
  var col = (_ctx$visibledatacolum = ctx.visibledatacolumn[c2]) !== null && _ctx$visibledatacolum !== void 0 ? _ctx$visibledatacolum : 0;
  var col_pre = c1 - 1 === -1 ? 0 : (_ctx$visibledatacolum2 = ctx.visibledatacolumn[c1 - 1]) !== null && _ctx$visibledatacolum2 !== void 0 ? _ctx$visibledatacolum2 : 0;
  var options = {
    startRow: r1,
    endRow: r2,
    startCol: c1,
    endCol: c2,
    left: col_pre,
    top: row_pre,
    width: col - col_pre - 1,
    height: row - row_pre - 1,
    items: []
  };

  for (var c = c1; c <= c2; c += 1) {
    if (filterObj == null || (filterObj === null || filterObj === void 0 ? void 0 : filterObj[c - c1]) == null) ;

    var left = 0;

    if (ctx.visibledatacolumn[c]) {
      left = ctx.visibledatacolumn[c] - 20;
    }

    options.items.push({
      col: c,
      left: left,
      top: row_pre
    });
  }

  if (saveData) {
    var file = ctx.luckysheetfile[sheetIndex];
    file.filter_select = luckysheet_filter_save;
  }

  ctx.filterOptions = options;
}
function clearFilter(ctx) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

  var hiddenRows = _.reduce(ctx.filter, function (pre, curr) {
    return _.assign(pre, (curr === null || curr === void 0 ? void 0 : curr.rowhidden) || {});
  }, {});

  ctx.config.rowhidden = _.omit(ctx.config.rowhidden, _.keys(hiddenRows));
  ctx.luckysheet_filter_save = undefined;
  ctx.filterOptions = undefined;
  ctx.filterContextMenu = undefined;
  ctx.filter = {};

  if (sheetIndex != null) {
    ctx.luckysheetfile[sheetIndex].filter = undefined;
    ctx.luckysheetfile[sheetIndex].filter_select = undefined;
    ctx.luckysheetfile[sheetIndex].config = _.assign({}, ctx.config);
  }
}
function createFilter(ctx) {
  var _ctx$luckysheet_selec, _filterSave, _ctx$luckysheet_selec2;

  if (_.size(ctx.luckysheet_select_save) > 1) {
    return;
  }

  if (_.size(ctx.luckysheet_filter_save) > 0) {
    clearFilter(ctx);
    return;
  }

  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

  if (sheetIndex == null || ctx.luckysheetfile[sheetIndex].isPivotTable) {
    return;
  }

  var last = (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec[0];
  var flowdata = getFlowdata(ctx);
  var filterSave;
  if (last == null || flowdata == null) return;

  if (last.row[0] === last.row[1] && last.column[0] === last.column[1]) {
    var st_c;
    var ed_c;
    var curR = last.row[1];

    for (var c = 0; c < flowdata[curR].length; c += 1) {
      var cell = flowdata[curR][c];

      if (cell != null && !isRealNull(cell.v)) {
        if (st_c == null) {
          st_c = c;
        }
      } else if (st_c != null) {
        ed_c = c - 1;
        break;
      }
    }

    if (ed_c == null) {
      ed_c = flowdata[curR].length - 1;
    }

    filterSave = normalizeSelection(ctx, [{
      row: [curR, curR],
      column: [st_c || 0, ed_c]
    }]);
    ctx.luckysheet_select_save = filterSave;
    ctx.luckysheet_shiftpositon = _.assign({}, last);
  } else if (last.row[1] - last.row[0] < 2) {
    ctx.luckysheet_shiftpositon = _.assign({}, last);
  }

  ctx.luckysheet_filter_save = _.assign({}, ((_filterSave = filterSave) === null || _filterSave === void 0 ? void 0 : _filterSave[0]) || ((_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2[0]));
  createFilterOptions(ctx, ctx.luckysheet_filter_save, undefined, {}, true);
}

function getFilterHiddenRows(ctx, col, startCol) {
  var _ctx$filter;

  var otherHiddenRows = _.reduce(ctx.filter, function (pre, curr) {
    return _.assign(pre, (curr === null || curr === void 0 ? void 0 : curr.cindex) !== col && (curr === null || curr === void 0 ? void 0 : curr.rowhidden) || {});
  }, {});

  var hiddenRows = ((_ctx$filter = ctx.filter[col - startCol]) === null || _ctx$filter === void 0 ? void 0 : _ctx$filter.rowhidden) || {};
  return {
    otherHiddenRows: otherHiddenRows,
    hiddenRows: hiddenRows
  };
}

function getFilterColumnValues(ctx, col, startRow, endRow, startCol) {
  var _getFilterHiddenRows = getFilterHiddenRows(ctx, col, startCol),
      otherHiddenRows = _getFilterHiddenRows.otherHiddenRows,
      hiddenRows = _getFilterHiddenRows.hiddenRows;

  var visibleRows = [];
  var flattenValues = [];
  var dates = [];
  var datesUncheck = [];
  var dateRowMap = {};
  var valuesMap = new Map();
  var valuesUncheck = [];
  var valueRowMap = {};
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return {
    dates: dates,
    datesUncheck: datesUncheck,
    dateRowMap: dateRowMap,
    values: [],
    valuesUncheck: valuesUncheck,
    valueRowMap: valueRowMap,
    visibleRows: visibleRows,
    flattenValues: flattenValues
  };
  var cell;

  var _locale2 = locale(ctx),
      filter = _locale2.filter;

  for (var r = startRow + 1; r <= endRow; r += 1) {
    if (r in otherHiddenRows) {
      continue;
    }

    visibleRows.push(r);
    cell = flowdata[r][col];

    if (cell != null && !isRealNull(cell.v) && cell.ct != null && cell.ct.t === "d") {
      (function () {
        var dateStr = update("YYYY-MM-DD", cell.v);
        var y = dateStr.split("-")[0];
        var m = dateStr.split("-")[1];
        var d = dateStr.split("-")[2];

        var yearValue = _.find(dates, function (v) {
          return v.value === y;
        });

        if (yearValue == null) {
          yearValue = {
            key: y,
            type: "year",
            value: y,
            text: y + filter.filiterYearText,
            children: [],
            rows: [],
            dateValues: []
          };
          dates.push(yearValue);
          flattenValues.push(dateStr);
        }

        var monthValue = _.find(yearValue.children, function (v) {
          return v.value === m;
        });

        if (monthValue == null) {
          monthValue = {
            key: "".concat(y, "-").concat(m),
            type: "month",
            value: m,
            text: m + filter.filiterMonthText,
            children: [],
            rows: [],
            dateValues: []
          };
          yearValue.children.push(monthValue);
        }

        var dayValue = _.find(monthValue.children, function (v) {
          return v.value === d;
        });

        if (dayValue == null) {
          dayValue = {
            key: dateStr,
            type: "day",
            value: d,
            text: d,
            children: [],
            rows: [],
            dateValues: []
          };
          monthValue.children.push(dayValue);
        }

        yearValue.rows.push(r);
        yearValue.dateValues.push(dateStr);
        monthValue.rows.push(r);
        monthValue.dateValues.push(dateStr);
        dayValue.rows.push(r);
        dayValue.dateValues.push(dateStr);
        dateRowMap[dateStr] = (dateRowMap[dateStr] || []).concat(r);

        if (r in hiddenRows) {
          datesUncheck = _.union(datesUncheck, [dateStr]);
        }
      })();
    } else {
      (function () {
        var v = void 0;
        var m = void 0;

        if (cell == null || isRealNull(cell.v)) {
          v = null;
          m = null;
        } else {
          v = cell.v;
          m = cell.m;
        }

        var data = valuesMap.get("".concat(v));
        var text = m == null ? filter.valueBlank : "".concat(m);
        var key = "".concat(v, "#$$$#").concat(m);

        if (data != null) {
          var maskValue = _.find(data, function (value) {
            return value.mask === m;
          });

          if (maskValue == null) {
            maskValue = {
              key: key,
              value: v,
              text: text,
              mask: m,
              rows: []
            };
            data.push(maskValue);
            flattenValues.push(text);
          }

          maskValue.rows.push(r);
        } else {
          valuesMap.set("".concat(v), [{
            key: key,
            value: v,
            text: text,
            mask: m,
            rows: [r]
          }]);
          flattenValues.push(text);
        }

        if (r in hiddenRows) {
          valuesUncheck = _.union(valuesUncheck, [key]);
        }

        valueRowMap[key] = (valueRowMap[key] || []).concat(r);
      })();
    }
  }

  return {
    dates: dates,
    datesUncheck: datesUncheck,
    dateRowMap: dateRowMap,
    values: _.flatten(Array.from(valuesMap.values())),
    valuesUncheck: valuesUncheck,
    valueRowMap: valueRowMap,
    visibleRows: visibleRows,
    flattenValues: flattenValues
  };
}
function getFilterColumnColors(ctx, col, startRow, endRow) {
  var bgMap = new Map();
  var fcMap = new Map();
  var cf_compute = getComputeMap(ctx);
  var flowdata = getFlowdata(ctx);
  if (flowdata == null) return {
    bgColors: [],
    fcColors: []
  };

  for (var r = startRow + 1; r <= endRow; r += 1) {
    var _ctx$config;

    var cell = flowdata[r][col];
    var bg = normalizedAttr(flowdata, r, col, "bg");

    if (bg == null) {
      bg = "#ffffff";
    }

    var checksAF = [];

    if (checksAF.length > 1) {
      bg = checksAF[1];
    }

    var checksCF = checkCF(r, col, cf_compute);

    if (checksCF != null && checksCF.cellColor != null) {
      bg = checksCF.cellColor;
    }

    if (bg.indexOf("rgb") > -1) {
      bg = rgbToHex(bg);
    }

    if (bg.length === 4) {
      bg = bg.substr(0, 1) + bg.substr(1, 1).repeat(2) + bg.substr(2, 1).repeat(2) + bg.substr(3, 1).repeat(2);
    }

    var fc = normalizedAttr(flowdata, r, col, "fc");

    if (checksAF.length > 0) {
      fc = checksAF[0];
    }

    if (checksCF != null && checksCF.textColor != null) {
      fc = checksCF.textColor;
    }

    if (fc != null) {
      if (fc.indexOf("rgb") > -1) {
        fc = rgbToHex(fc);
      }

      if (fc.length === 4) {
        fc = fc.substr(0, 1) + fc.substr(1, 1).repeat(2) + fc.substr(2, 1).repeat(2) + fc.substr(3, 1).repeat(2);
      }
    }

    var isRowHidden = (r in (((_ctx$config = ctx.config) === null || _ctx$config === void 0 ? void 0 : _ctx$config.rowhidden) || {}));
    var bgData = bgMap.get(bg);

    if (bgData != null) {
      bgData.rows.push(r);
      if (isRowHidden) bgData.checked = false;
    } else {
      bgMap.set(bg, {
        color: bg,
        checked: !isRowHidden,
        rows: [r]
      });
    }

    if (fc != null) {
      var fcData = fcMap.get(fc);

      if (fcData != null && cell != null && !isRealNull(cell.v)) {
        fcData.rows.push(r);
        if (isRowHidden) fcData.checked = false;
      } else if (cell != null && !isRealNull(cell.v)) {
        fcMap.set(fc, {
          color: fc,
          checked: !isRowHidden,
          rows: [r]
        });
      }
    }
  }

  var bgColors = _.flatten(Array.from(bgMap.values()));

  var fcColors = _.flatten(Array.from(fcMap.values()));

  return {
    bgColors: bgColors.length < 2 ? [] : bgColors,
    fcColors: fcColors.length < 2 ? [] : fcColors
  };
}
function saveFilter(ctx, optionState, hiddenRows, caljs, st_r, ed_r, cindex, st_c, ed_c) {
  var _getFilterHiddenRows2 = getFilterHiddenRows(ctx, cindex, st_c),
      otherHiddenRows = _getFilterHiddenRows2.otherHiddenRows;

  var rowHiddenAll = _.assign(otherHiddenRows, hiddenRows);

  labelFilterOptionState(ctx, optionState, hiddenRows, caljs, st_r, ed_r, cindex, st_c, ed_c, true);

  var cfg = _.assign({}, ctx.config);

  cfg.rowhidden = rowHiddenAll;
  ctx.config = cfg;
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

  if (sheetIndex == null) {
    return;
  }

  ctx.luckysheetfile[sheetIndex].config = cfg;
}

var dragCellThreshold = 8;

function getCellLocationByMouse(ctx, e, scrollbarX, scrollbarY, container) {
  var rect = container.getBoundingClientRect();
  var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollbarX.scrollLeft;
  var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollbarY.scrollTop;
  return {
    row: rowLocation(y, ctx.visibledatarow),
    column: colLocation(x, ctx.visibledatacolumn)
  };
}

function onCellsMoveStart(ctx, globalCache, e, scrollbarX, scrollbarY, container) {
  var allowEdit = isAllowEdit(ctx);

  if (allowEdit === false) {
    return;
  }

  globalCache.dragCellStartPos = {
    x: e.pageX,
    y: e.pageY
  };
  ctx.luckysheet_cell_selected_move = true;
  ctx.luckysheet_scroll_status = true;

  var _getCellLocationByMou = getCellLocationByMouse(ctx, e, scrollbarX, scrollbarY, container),
      _getCellLocationByMou2 = _slicedToArray(_getCellLocationByMou.row, 3),
      row_pre = _getCellLocationByMou2[0],
      row = _getCellLocationByMou2[1],
      row_index = _getCellLocationByMou2[2],
      _getCellLocationByMou3 = _slicedToArray(_getCellLocationByMou.column, 3),
      col_pre = _getCellLocationByMou3[0],
      col = _getCellLocationByMou3[1],
      col_index = _getCellLocationByMou3[2];

  var range = _.last(ctx.luckysheet_select_save);

  if (range == null) return;

  if (row_index < range.row[0]) {
    var _range$row = _slicedToArray(range.row, 1);

    row_index = _range$row[0];
  } else if (row_index > range.row[1]) {
    var _range$row2 = _slicedToArray(range.row, 2);

    row_index = _range$row2[1];
  }

  if (col_index < range.column[0]) {
    var _range$column = _slicedToArray(range.column, 1);

    col_index = _range$column[0];
  } else if (col_index > range.column[1]) {
    var _range$column2 = _slicedToArray(range.column, 2);

    col_index = _range$column2[1];
  }

  var _rowLocationByIndex = rowLocationByIndex(row_index, ctx.visibledatarow);

  var _rowLocationByIndex2 = _slicedToArray(_rowLocationByIndex, 2);

  row_pre = _rowLocationByIndex2[0];
  row = _rowLocationByIndex2[1];

  var _colLocationByIndex = colLocationByIndex(col_index, ctx.visibledatacolumn);

  var _colLocationByIndex2 = _slicedToArray(_colLocationByIndex, 2);

  col_pre = _colLocationByIndex2[0];
  col = _colLocationByIndex2[1];
  ctx.luckysheet_cell_selected_move_index = [row_index, col_index];
  var ele = document.getElementById("fortune-cell-selected-move");
  if (ele == null) return;
  ele.style.left = "".concat(col_pre, "px");
  ele.style.top = "".concat(row_pre, "px");
  ele.style.width = "".concat(col - col_pre - 1, "px");
  ele.style.height = "".concat(row - row_pre - 1, "px");
  ele.style.display = "block";
  e.stopPropagation();
}
function onCellsMove(ctx, globalCache, e, scrollbarX, scrollbarY, container) {
  if (!ctx.luckysheet_cell_selected_move) return;

  if (globalCache.dragCellStartPos != null) {
    var deltaX = Math.abs(globalCache.dragCellStartPos.x - e.pageX);
    var deltaY = Math.abs(globalCache.dragCellStartPos.y - e.pageY);

    if (deltaX < dragCellThreshold && deltaY < dragCellThreshold) {
      return;
    }

    globalCache.dragCellStartPos = undefined;
  }

  var _mousePosition = mousePosition(e.pageX, e.pageY, ctx),
      _mousePosition2 = _slicedToArray(_mousePosition, 2),
      x = _mousePosition2[0],
      y = _mousePosition2[1];

  var rect = container.getBoundingClientRect();
  var winH = rect.height - 20 * ctx.zoomRatio;
  var winW = rect.width - 60 * ctx.zoomRatio;

  var _getCellLocationByMou4 = getCellLocationByMouse(ctx, e, scrollbarX, scrollbarY, container),
      rowL = _getCellLocationByMou4.row,
      column = _getCellLocationByMou4.column;

  var _rowL = _slicedToArray(rowL, 2),
      row_pre = _rowL[0],
      row = _rowL[1];

  var _column = _slicedToArray(column, 2),
      col_pre = _column[0],
      col = _column[1];

  var row_index = rowL[2];
  var col_index = column[2];
  var row_index_original = ctx.luckysheet_cell_selected_move_index[0];
  var col_index_original = ctx.luckysheet_cell_selected_move_index[1];
  if (ctx.luckysheet_select_save == null) return;
  var row_s = ctx.luckysheet_select_save[0].row[0] - row_index_original + row_index;
  var row_e = ctx.luckysheet_select_save[0].row[1] - row_index_original + row_index;
  var col_s = ctx.luckysheet_select_save[0].column[0] - col_index_original + col_index;
  var col_e = ctx.luckysheet_select_save[0].column[1] - col_index_original + col_index;

  if (row_s < 0 || y < 0) {
    row_s = 0;
    row_e = ctx.luckysheet_select_save[0].row[1] - ctx.luckysheet_select_save[0].row[0];
  }

  if (col_s < 0 || x < 0) {
    col_s = 0;
    col_e = ctx.luckysheet_select_save[0].column[1] - ctx.luckysheet_select_save[0].column[0];
  }

  if (row_e >= ctx.visibledatarow.length - 1 || y > winH) {
    row_s = ctx.visibledatarow.length - 1 - ctx.luckysheet_select_save[0].row[1] + ctx.luckysheet_select_save[0].row[0];
    row_e = ctx.visibledatarow.length - 1;
  }

  if (col_e >= ctx.visibledatacolumn.length - 1 || x > winW) {
    col_s = ctx.visibledatacolumn.length - 1 - ctx.luckysheet_select_save[0].column[1] + ctx.luckysheet_select_save[0].column[0];
    col_e = ctx.visibledatacolumn.length - 1;
  }

  col_pre = col_s - 1 === -1 ? 0 : ctx.visibledatacolumn[col_s - 1];
  col = ctx.visibledatacolumn[col_e];
  row_pre = row_s - 1 === -1 ? 0 : ctx.visibledatarow[row_s - 1];
  row = ctx.visibledatarow[row_e];
  var ele = document.getElementById("fortune-cell-selected-move");
  if (ele == null) return;
  ele.style.left = "".concat(col_pre, "px");
  ele.style.top = "".concat(row_pre, "px");
  ele.style.width = "".concat(col - col_pre - 2, "px");
  ele.style.height = "".concat(row - row_pre - 2, "px");
  ele.style.display = "block";
}
function onCellsMoveEnd(ctx, globalCache, e, scrollbarX, scrollbarY, container) {
  var _ctx$luckysheetfile$g2;

  if (!ctx.luckysheet_cell_selected_move) return;
  ctx.luckysheet_cell_selected_move = false;
  var ele = document.getElementById("fortune-cell-selected-move");
  if (ele != null) ele.style.display = "none";

  if (globalCache.dragCellStartPos != null) {
    globalCache.dragCellStartPos = undefined;
    return;
  }

  var _mousePosition3 = mousePosition(e.pageX, e.pageY, ctx),
      _mousePosition4 = _slicedToArray(_mousePosition3, 2),
      x = _mousePosition4[0],
      y = _mousePosition4[1];

  var rect = container.getBoundingClientRect();
  var winH = rect.height - 20 * ctx.zoomRatio;
  var winW = rect.width - 60 * ctx.zoomRatio;

  var _getCellLocationByMou5 = getCellLocationByMouse(ctx, e, scrollbarX, scrollbarY, container),
      _getCellLocationByMou6 = _slicedToArray(_getCellLocationByMou5.row, 3),
      row_index = _getCellLocationByMou6[2],
      _getCellLocationByMou7 = _slicedToArray(_getCellLocationByMou5.column, 3),
      col_index = _getCellLocationByMou7[2];

  var allowEdit = isAllowEdit(ctx, [{
    row: [row_index, row_index],
    column: [col_index, col_index]
  }]);
  if (!allowEdit) return;
  var row_index_original = ctx.luckysheet_cell_selected_move_index[0];
  var col_index_original = ctx.luckysheet_cell_selected_move_index[1];

  if (row_index === row_index_original && col_index === col_index_original) {
    return;
  }

  var d = getFlowdata(ctx);
  if (d == null || ctx.luckysheet_select_save == null) return;
  var last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];

  var data = _.cloneDeep(getdatabyselection(ctx, last, ctx.currentSheetId));

  var cfg = ctx.config;

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  if (cfg.rowlen == null) {
    cfg.rowlen = {};
  }

  var _locale = locale(ctx),
      locale_drag = _locale.drag;

  if (hasPartMC(ctx, cfg, last.row[0], last.row[1], last.column[0], last.column[1])) {
    throw new Error(locale_drag.noMerge);
  }

  var row_s = last.row[0] - row_index_original + row_index;
  var row_e = last.row[1] - row_index_original + row_index;
  var col_s = last.column[0] - col_index_original + col_index;
  var col_e = last.column[1] - col_index_original + col_index;

  if (row_s < 0 || y < 0) {
    row_s = 0;
    row_e = last.row[1] - last.row[0];
  }

  if (col_s < 0 || x < 0) {
    col_s = 0;
    col_e = last.column[1] - last.column[0];
  }

  if (row_e >= ctx.visibledatarow.length - 1 || y > winH) {
    row_s = ctx.visibledatarow.length - 1 - last.row[1] + last.row[0];
    row_e = ctx.visibledatarow.length - 1;
  }

  if (col_e >= ctx.visibledatacolumn.length - 1 || x > winW) {
    col_s = ctx.visibledatacolumn.length - 1 - last.column[1] + last.column[0];
    col_e = ctx.visibledatacolumn.length - 1;
  }

  if (hasPartMC(ctx, cfg, row_s, row_e, col_s, col_e)) {
    throw new Error(locale_drag.noMerge);
  }

  var borderInfoCompute = getBorderInfoCompute(ctx, ctx.currentSheetId);
  var hyperLinkList = {};
  var index = getSheetIndex(ctx, ctx.currentSheetId);

  for (var r = last.row[0]; r <= last.row[1]; r += 1) {
    for (var c = last.column[0]; c <= last.column[1]; c += 1) {
      var _ctx$luckysheetfile$i;

      var cellData = d[r][c];

      if ((cellData === null || cellData === void 0 ? void 0 : cellData.mc) != null) {
        var mergeKey = "".concat(cellData.mc.r, "_").concat(c);

        if (cfg.merge[mergeKey] != null) {
          delete cfg.merge[mergeKey];
        }
      }

      d[r][c] = null;

      if ((_ctx$luckysheetfile$i = ctx.luckysheetfile[index].hyperlink) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i["".concat(r, "_").concat(c)]) {
        var _ctx$luckysheetfile$i2, _ctx$luckysheetfile$g;

        hyperLinkList["".concat(r, "_").concat(c)] = (_ctx$luckysheetfile$i2 = ctx.luckysheetfile[index].hyperlink) === null || _ctx$luckysheetfile$i2 === void 0 ? void 0 : _ctx$luckysheetfile$i2["".concat(r, "_").concat(c)];
        (_ctx$luckysheetfile$g = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].hyperlink) === null || _ctx$luckysheetfile$g === void 0 ? true : delete _ctx$luckysheetfile$g["".concat(r, "_").concat(c)];
      }
    }
  }

  if (cfg.borderInfo && cfg.borderInfo.length > 0) {
    var borderInfo = [];

    for (var i = 0; i < cfg.borderInfo.length; i += 1) {
      var bd_rangeType = cfg.borderInfo[i].rangeType;

      if (bd_rangeType === "range" && cfg.borderInfo[i].borderType !== "border-slash") {
        var bd_range = cfg.borderInfo[i].range;
        var bd_emptyRange = [];

        for (var j = 0; j < bd_range.length; j += 1) {
          bd_emptyRange = bd_emptyRange.concat(cfSplitRange(bd_range[j], {
            row: last.row,
            column: last.column
          }, {
            row: [row_s, row_e],
            column: [col_s, col_e]
          }, "restPart"));
        }

        cfg.borderInfo[i].range = bd_emptyRange;
        borderInfo.push(cfg.borderInfo[i]);
      } else if (bd_rangeType === "cell") {
        var bd_r = cfg.borderInfo[i].value.row_index;
        var bd_c = cfg.borderInfo[i].value.col_index;

        if (!(bd_r >= last.row[0] && bd_r <= last.row[1] && bd_c >= last.column[0] && bd_c <= last.column[1])) {
          borderInfo.push(cfg.borderInfo[i]);
        }
      } else if (bd_rangeType === "range" && cfg.borderInfo[i].borderType === "border-slash" && !(cfg.borderInfo[i].range[0].row[0] >= last.row[0] && cfg.borderInfo[i].range[0].row[0] <= last.row[1] && cfg.borderInfo[i].range[0].column[0] >= last.column[0] && cfg.borderInfo[i].range[0].column[0] <= last.column[1])) {
        borderInfo.push(cfg.borderInfo[i]);
      }
    }

    cfg.borderInfo = borderInfo;
  }

  var offsetMC = {};

  for (var _r = 0; _r < data.length; _r += 1) {
    for (var _c = 0; _c < data[0].length; _c += 1) {
      var _value;

      if (borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])] && !borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].s) {
        var bd_obj = {
          rangeType: "cell",
          value: {
            row_index: _r + row_s,
            col_index: _c + col_s,
            l: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].l,
            r: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].r,
            t: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].t,
            b: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].b
          }
        };

        if (cfg.borderInfo == null) {
          cfg.borderInfo = [];
        }

        cfg.borderInfo.push(bd_obj);
      } else if (borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])]) {
        var _bd_obj = {
          rangeType: "range",
          borderType: "border-slash",
          color: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].s.color,
          style: borderInfoCompute["".concat(_r + last.row[0], "_").concat(_c + last.column[0])].s.style,
          range: normalizeSelection(ctx, [{
            row: [_r + row_s, _r + row_s],
            column: [_c + col_s, _c + col_s]
          }])
        };

        if (cfg.borderInfo == null) {
          cfg.borderInfo = [];
        }

        cfg.borderInfo.push(_bd_obj);
      }

      var value = null;

      if (data[_r] != null && data[_r][_c] != null) {
        value = data[_r][_c];
      }

      if (((_value = value) === null || _value === void 0 ? void 0 : _value.mc) != null) {
        var mc = _.assign({}, value.mc);

        if ("rs" in value.mc) {
          _.set(offsetMC, "".concat(mc.r, "_").concat(mc.c), [_r + row_s, _c + col_s]);

          value.mc.r = _r + row_s;
          value.mc.c = _c + col_s;

          _.set(cfg.merge, "".concat(_r + row_s, "_").concat(_c + col_s), value.mc);
        } else {
          _.set(value.mc, "r", offsetMC["".concat(mc.r, "_").concat(mc.c)][0]);

          _.set(value.mc, "c", offsetMC["".concat(mc.r, "_").concat(mc.c)][1]);
        }
      }

      d[_r + row_s][_c + col_s] = value;

      if (hyperLinkList === null || hyperLinkList === void 0 ? void 0 : hyperLinkList["".concat(_r + last.row[0], "_").concat(_c + last.column[0])]) {
        ctx.luckysheetfile[index].hyperlink["".concat(_r + row_s, "_").concat(_c + col_s)] = hyperLinkList === null || hyperLinkList === void 0 ? void 0 : hyperLinkList["".concat(_r + last.row[0], "_").concat(_c + last.column[0])];
      }
    }
  }

  var cdformat = (_ctx$luckysheetfile$g2 = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].luckysheet_conditionformat_save) !== null && _ctx$luckysheetfile$g2 !== void 0 ? _ctx$luckysheetfile$g2 : [];

  if (cdformat != null && cdformat.length > 0) {
    for (var _i = 0; _i < cdformat.length; _i += 1) {
      var cdformat_cellrange = cdformat[_i].cellrange;
      var emptyRange = [];

      for (var _j = 0; _j < cdformat_cellrange.length; _j += 1) {
        var _range = CFSplitRange(cdformat_cellrange[_j], {
          row: last.row,
          column: last.column
        }, {
          row: [row_s, row_e],
          column: [col_s, col_e]
        }, "allPart");

        emptyRange = emptyRange.concat(_range);
      }

      cdformat[_i].cellrange = emptyRange;
    }
  }

  var rf;

  if (ctx.luckysheet_select_save[0].row_focus === ctx.luckysheet_select_save[0].row[0]) {
    rf = row_s;
  } else {
    rf = row_e;
  }

  var cf;

  if (ctx.luckysheet_select_save[0].column_focus === ctx.luckysheet_select_save[0].column[0]) {
    cf = col_s;
  } else {
    cf = col_e;
  }

  var range = [];
  range.push({
    row: last.row,
    column: last.column
  });
  range.push({
    row: [row_s, row_e],
    column: [col_s, col_e]
  });
  last.row = [row_s, row_e];
  last.column = [col_s, col_e];
  last.row_focus = rf;
  last.column_focus = cf;
  ctx.luckysheet_select_save = normalizeSelection(ctx, [last]);
  var sheetIndex = getSheetIndex(ctx, ctx.currentSheetId);

  if (sheetIndex != null) {
    ctx.luckysheetfile[sheetIndex].config = _.assign({}, cfg);
  }

  jfrefreshgrid(ctx, d, range);
}

function getNullData(rlen, clen) {
  var arr = [];

  for (var r = 0; r < rlen; r += 1) {
    var rowArr = [];

    for (var c = 0; c < clen; c += 1) {
      rowArr.push("");
    }

    arr.push(rowArr);
  }

  return arr;
}
function updateMoreCell(r, c, dataMatrix, ctx) {
  if (ctx.allowEdit === false) return;
  var flowdata = getFlowdata(ctx);
  dataMatrix.forEach(function (datas, i) {
    datas.forEach(function (data, j) {
      var v = dataMatrix[i][j];
      setCellValue(ctx, r + i, c + j, flowdata, v);
    });
  });
}
function getRegStr(regStr, splitSymbols) {
  regStr = "";
  var mark = 0;

  for (var i = 0; i < splitSymbols.length; i += 1) {
    var split = splitSymbols[i];
    var inputNode = split.childNodes[0];

    if (inputNode.checked) {
      var id = inputNode.id;

      if (id === "Tab") {
        regStr += "\\t";
        mark += 1;
      } else if (id === "semicolon") {
        if (mark > 0) {
          regStr += "|";
        }

        regStr += ";";
        mark = 1;
      } else if (id === "comma") {
        if (mark > 0) {
          regStr += "|";
        }

        regStr += ",";
        mark += 1;
      } else if (id === "space") {
        if (mark > 0) {
          regStr += "|";
        }

        regStr += "\\s";
        mark += 1;
      } else if (id === "splitsimple") {
        regStr = "[".concat(regStr, "]+");
      } else if (id === "other") {
        var txt = split.childNodes[2].value;

        if (txt !== "") {
          if (mark > 0) {
            regStr += "|";
          }

          regStr += txt;
        }
      }
    }
  }

  return regStr;
}
function getDataArr(regStr, ctx) {
  var arr = [];
  var r1 = ctx.luckysheet_select_save[0].row[0];
  var r2 = ctx.luckysheet_select_save[0].row[1];
  var c = ctx.luckysheet_select_save[0].column[0];
  var data = getFlowdata(ctx);

  if (!_.isNull(regStr) && regStr !== "") {
    var reg = new RegExp(regStr, "g");
    var dataArr = [];

    for (var r = r1; r <= r2; r += 1) {
      var rowArr = [];
      var cell = data[r][c];
      var value = void 0;

      if (!_.isNull(cell) && !_.isNull(cell.m)) {
        value = cell.m;
      } else {
        value = getCellValue(r, c, data);
      }

      if (_.isNull(value) || _.isUndefined(value)) {
        value = "";
      }

      rowArr = value.toString().split(reg);
      dataArr.push(rowArr);
    }

    var rlen = dataArr.length;
    var clen = 0;

    for (var i = 0; i < rlen; i += 1) {
      if (dataArr[i].length > clen) {
        clen = dataArr[i].length;
      }
    }

    arr = getNullData(rlen, clen);

    for (var _i = 0; _i < arr.length; _i += 1) {
      for (var j = 0; j < arr[0].length; j += 1) {
        if (dataArr[_i][j] != null) {
          arr[_i][j] = dataArr[_i][j];
        }
      }
    }
  } else {
    for (var _r = r1; _r <= r2; _r += 1) {
      var _rowArr = [];
      var _cell = data[_r][c];

      var _value = void 0;

      if (!_.isNull(_cell) && !_.isNull(_cell.m)) {
        _value = _cell.m;
      } else {
        _value = getCellValue(_r, c, data);
      }

      if (_.isNull(_value)) {
        _value = "";
      }

      _rowArr.push(_value);

      arr.push(_rowArr);
    }
  }

  return arr;
}

function deleteCellInSave(cellSave, range) {
  for (var r = range.row[0]; r <= range.row[1]; r += 1) {
    for (var c = range.column[0]; c <= range.column[1]; c += 1) {
      delete cellSave["".concat(r, "_").concat(c)];
    }
  }

  return cellSave;
}
function getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx) {
  if (Object.keys(cellSave).length === 0) {
    return rangeArr;
  }

  var stack_str = null;
  var stack_edr = null;
  var stack_stc = null;
  var stack_edc = null;
  var flowData = getFlowdata(ctx, ctx.currentSheetId);

  for (var r = minR; r <= maxR; r += 1) {
    for (var c = minC; c <= maxC; c += 1) {
      if (_.isNil(flowData)) break;
      var cell = flowData[r][c];

      if ("".concat(r, "_").concat(c) in cellSave) {
        var _cell$mc, _cell$mc2, _cell$mc3;

        if (!!(cell === null || cell === void 0 ? void 0 : (_cell$mc = cell.mc) === null || _cell$mc === void 0 ? void 0 : _cell$mc.cs) && !!(cell === null || cell === void 0 ? void 0 : (_cell$mc2 = cell.mc) === null || _cell$mc2 === void 0 ? void 0 : _cell$mc2.rs) && !!(cell === null || cell === void 0 ? void 0 : (_cell$mc3 = cell.mc) === null || _cell$mc3 === void 0 ? void 0 : _cell$mc3.r)) {
          if (stack_stc === null) {
            var range = {
              row: [cell.mc.r, cell.mc.r + cell.mc.rs - 1],
              column: [cell.mc.c, cell.mc.c + cell.mc.cs - 1]
            };
            rangeArr.push(range);
            cellSave = deleteCellInSave(cellSave, range);
            return getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx);
          }

          if (stack_edc !== null && c < stack_edc) {
            var _range = {
              row: [stack_str, stack_edr],
              column: [stack_stc, stack_edc]
            };
            rangeArr.push(_range);
            cellSave = deleteCellInSave(cellSave, _range);
            return getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx);
          }

          break;
        } else if (stack_stc === null) {
          stack_stc = c;
          stack_edc = c;
          stack_str = r;
          stack_edr = r;
        } else if (stack_edc !== null && c > stack_edc) {
          stack_edc = c;
        }
      } else if (stack_stc !== null) {
        if (cell !== null && cell.mc !== null) {
          break;
        } else if (c < stack_stc) ; else if (stack_edc !== null && c <= stack_edc) {
          var _range2 = {
            row: [stack_str, stack_edr],
            column: [stack_stc, stack_edc]
          };
          rangeArr.push(_range2);
          cellSave = deleteCellInSave(cellSave, _range2);
          return getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx);
        } else {
          stack_edr = r;
        }
      }
    }
  }

  if (stack_stc !== null) {
    var _range3 = {
      row: [stack_str, stack_edr],
      column: [stack_stc, stack_edc]
    };
    rangeArr.push(_range3);
    cellSave = deleteCellInSave(cellSave, _range3);
    return getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx);
  }

  return rangeArr;
}
function getOptionValue(constants) {
  var tempConstans = _.cloneDeep(constants);

  var len = _.filter(tempConstans, function (o) {
    return o;
  }).length;

  var value;

  if (len === 0) {
    value = "";
  } else if (len === 5) {
    value = "all";
  } else {
    var arr = [];

    _.toPairs(constants).forEach(function (entry) {
      var _entry = _slicedToArray(entry, 2),
          k = _entry[0],
          v = _entry[1];

      if (v) {
        if (k === "locationDate") {
          arr.push("d");
        } else if (k === "locationDigital") {
          arr.push("n");
        } else if (k === "locationString") {
          arr.push("s,g");
        } else if (k === "locationBool") {
          arr.push("b");
        } else if (k === "locationError") {
          arr.push("e");
        }
      }
    });

    value = arr.join(",");
  }

  return value;
}
function getSelectRange(ctx) {
  var _ctx$luckysheet_selec, _ctx$luckysheet_selec2;

  var range;

  if (((_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec.length) === 0 || ((_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2.length) === 1 && ctx.luckysheet_select_save[0].row[0] === ctx.luckysheet_select_save[0].row[1] && ctx.luckysheet_select_save[0].column[0] === ctx.luckysheet_select_save[0].column[1]) {
    var flowdata = getFlowdata(ctx, ctx.currentSheetId);
    if (_.isNil(flowdata)) return [];
    range = [{
      row: [0, flowdata.length - 1],
      column: [0, flowdata[0].length - 1]
    }];
  } else {
    range = _.assignIn([], ctx.luckysheet_select_save);
  }

  return range;
}
function applyLocation(range, type, value, ctx) {
  var rangeArr = [];

  if (type === "locationFormula" || type === "locationConstant" || type === "locationNull") {
    var minR = null;
    var maxR = null;
    var minC = null;
    var maxC = null;
    var cellSave = {};
    var flowData = getFlowdata(ctx, ctx.currentSheetId);
    if (_.isNil(flowData)) return [];

    for (var s = 0; s < range.length; s += 1) {
      var st_r = range[s].row[0];
      var ed_r = range[s].row[1];
      var st_c = range[s].column[0];
      var ed_c = range[s].column[1];

      if (minR === null || minR < st_r) {
        minR = st_r;
      }

      if (maxR === null || maxR > ed_r) {
        maxR = ed_r;
      }

      if (minC === null || minC < st_c) {
        minC = st_c;
      }

      if (maxC === null || maxC > ed_c) {
        maxC = ed_c;
      }

      for (var r = st_r; r <= ed_r; r += 1) {
        for (var c = st_c; c <= ed_c; c += 1) {
          var _cell, _cell2, _cell3, _cell3$ct;

          var cell = flowData[r][c];

          if ((_cell = cell) === null || _cell === void 0 ? void 0 : _cell.mc) {
            cell = flowData[cell.mc.r][cell.mc.c];
          }

          if (type === "locationFormula" && !!cell && cell.v !== null && !!cell.f && (value === "all" || !!cell.ct && !!value && !!cell.ct.t && value.indexOf(cell.ct.t) > -1)) {
            cellSave["".concat(r, "_").concat(c)] = 0;
          } else if (type === "locationConstant" && ((_cell2 = cell) === null || _cell2 === void 0 ? void 0 : _cell2.v) && (value === "all" || ((_cell3 = cell) === null || _cell3 === void 0 ? void 0 : (_cell3$ct = _cell3.ct) === null || _cell3$ct === void 0 ? void 0 : _cell3$ct.t) && value.indexOf(cell.ct.t) > -1)) {
            cellSave["".concat(r, "_").concat(c)] = 0;
          } else if (type === "locationNull" && (cell === null || cell.v === null)) {
            cellSave["".concat(r, "_").concat(c)] = 0;
          }
        }
      }
    }

    rangeArr = getRangeArr(minR, maxR, minC, maxC, cellSave, rangeArr, ctx);
  } else if (type === "locationCF") ; else if (type === "locationRowSpan") {
    for (var _s = 0; _s < range.length; _s += 1) {
      if (range[_s].row[0] === range[_s].row[1]) {
        continue;
      }

      var _st_r = range[_s].row[0];
      var _ed_r = range[_s].row[1];
      var _st_c = range[_s].column[0];
      var _ed_c = range[_s].column[1];

      for (var _r = _st_r; _r <= _ed_r; _r += 1) {
        if ((_r - _st_r) % 2 === 0) {
          rangeArr.push({
            row: [_r, _r],
            column: [_st_c, _ed_c]
          });
        }
      }
    }
  } else if (type === "locationColumnSpan") {
    for (var _s2 = 0; _s2 < range.length; _s2 += 1) {
      if (range[_s2].column[0] === range[_s2].column[1]) {
        continue;
      }

      var _st_r2 = range[_s2].row[0];
      var _ed_r2 = range[_s2].row[1];
      var _st_c2 = range[_s2].column[0];
      var _ed_c2 = range[_s2].column[1];

      for (var _c = _st_c2; _c <= _ed_c2; _c += 1) {
        if ((_c - _st_c2) % 2 === 0) {
          rangeArr.push({
            row: [_st_r2, _ed_r2],
            column: [_c, _c]
          });
        }
      }
    }
  }

  if (rangeArr.length === 0) {
    return rangeArr;
  }

  ctx.luckysheet_select_save = normalizeSelection(ctx, rangeArr);
  return rangeArr;
}

var ZOOM_STEP = 0.1;
var MAX_ZOOM_RATIO = 4;
var MIN_ZOOM_RATIO = 0.1;
function handleKeydownForZoom(ev, currentZoom) {
  if (!ev.ctrlKey) {
    return currentZoom;
  }

  var handled = false;
  var zoom = currentZoom || 1;

  if (ev.key === "-" || ev.which === 189) {
    zoom -= ZOOM_STEP;
    handled = true;
  } else if (ev.key === "+" || ev.which === 187) {
    zoom += ZOOM_STEP;
    handled = true;
  } else if (ev.key === "0" || ev.which === 48) {
    zoom = 1;
    handled = true;
  }

  if (handled) {
    ev.preventDefault();

    if (zoom >= MAX_ZOOM_RATIO) {
      zoom = MAX_ZOOM_RATIO;
    } else if (zoom < MIN_ZOOM_RATIO) {
      zoom = MIN_ZOOM_RATIO;
    }
  }

  return parseFloat(zoom.toFixed(1));
}

var addtionalMergeOps = function addtionalMergeOps(ops, id) {
  var merge_new = {};
  ops.some(function (op) {
    if (op.op === "replace" && op.path[0] === "config" && op.path[1] === "merge") {
      merge_new = op.value;
      return true;
    }

    return false;
  });
  var new_ops = [];
  Object.entries(merge_new).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        v = _ref2[1];

    var r = v.r,
        c = v.c,
        rs = v.rs,
        cs = v.cs;
    var headerOp = {
      op: "replace",
      path: ["data", r, c, "mc"],
      id: id,
      value: v
    };

    for (var i = r; i < r + rs; i += 1) {
      for (var j = c; j < c + cs; j += 1) {
        new_ops.push({
          op: "replace",
          path: ["data", i, j, "mc"],
          id: id,
          value: {
            r: r,
            c: c
          }
        });
      }
    }

    new_ops.push(headerOp);
  });
  return new_ops;
};

function additionalCellOps(ctx, insertRowColOp) {
  var id = insertRowColOp.id,
      index = insertRowColOp.index,
      direction = insertRowColOp.direction,
      count = insertRowColOp.count,
      type = insertRowColOp.type;
  var d = getFlowdata(ctx, id);
  var startIndex = index + (direction === "rightbottom" ? 1 : 0);

  if (d == null) {
    return [];
  }

  var cellOps = [];

  if (type === "row") {
    for (var i = 0; i < d[startIndex].length; i += 1) {
      var cell = d[startIndex][i];

      if (cell != null) {
        for (var j = 0; j < count; j += 1) {
          cellOps.push({
            op: "replace",
            id: id,
            path: ["data", startIndex + j, i],
            value: cell
          });
        }
      }
    }
  } else {
    for (var _i = 0; _i < d.length; _i += 1) {
      var _cell = d[_i][startIndex];

      if (_cell != null) {
        for (var _j = 0; _j < count; _j += 1) {
          cellOps.push({
            op: "replace",
            id: id,
            path: ["data", _i, startIndex + _j],
            value: _cell
          });
        }
      }
    }
  }

  return cellOps;
}

function filterPatch(patches) {
  return _.filter(patches, function (p) {
    return p.path[0] === "luckysheetfile" && p.path[2] !== "luckysheet_select_save";
  });
}
function extractFormulaCellOps(ops) {
  var formulaOps = [];
  ops.forEach(function (op) {
    var _op$value;

    if (op.op === "remove") return;

    if (op.path.length === 2 && Array.isArray(op.value)) {
      for (var i = 0; i < op.value.length; i += 1) {
        var _op$value$i;

        if ((_op$value$i = op.value[i]) === null || _op$value$i === void 0 ? void 0 : _op$value$i.f) {
          formulaOps.push({
            op: "replace",
            id: op.id,
            path: [].concat(_toConsumableArray(op.path), [i]),
            value: op.value[i]
          });
        }
      }
    } else if (op.path.length === 3 && ((_op$value = op.value) === null || _op$value === void 0 ? void 0 : _op$value.f)) {
      formulaOps.push(op);
    } else if (op.path.length === 4 && op.path[3] === "f") {
      formulaOps.push(op);
    }
  });
  return formulaOps;
}
function patchToOp(ctx, patches, options) {
  var undo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var ops = patches.map(function (p) {
    var op = {
      op: p.op,
      value: p.value,
      path: p.path
    };

    if (p.path[0] === "luckysheetfile" && _.isNumber(p.path[1])) {
      var id = ctx.luckysheetfile[p.path[1]].id;
      op.id = id;
      op.path = p.path.slice(2);

      if (_.isEqual(op.path, ["calcChain", "length"])) {
        op.path = ["calcChain"];
        op.value = ctx.luckysheetfile[p.path[1]].calcChain;
      }
    }

    return op;
  });

  _.every(ops, function (p) {
    var _p$value;

    if (p.op === "replace" && !_.isNil((_p$value = p.value) === null || _p$value === void 0 ? void 0 : _p$value.hl) && p.path.length === 3 && p.path[0] === "data") {
      var index = getSheetIndex(ctx, p.id);
      ops.push({
        id: p.id,
        op: "replace",
        path: ["hyperlink", "".concat(p.path[1], "_").concat(p.path[2])],
        value: ctx.luckysheetfile[index].hyperlink["".concat(p.value.hl.r, "_").concat(p.value.hl.c)]
      });
    }
  });

  if (options === null || options === void 0 ? void 0 : options.insertRowColOp) {
    var _$partition = _.partition(ops, function (p) {
      return p.path[0] !== "data";
    }),
        _$partition2 = _slicedToArray(_$partition, 2),
        nonDataOps = _$partition2[0],
        dataOps = _$partition2[1];

    var formulaOps = extractFormulaCellOps(dataOps);
    ops = nonDataOps;
    ops.push({
      op: "insertRowCol",
      id: options.insertRowColOp.id,
      path: [],
      value: options.insertRowColOp
    });
    ops = [].concat(_toConsumableArray(ops), _toConsumableArray(formulaOps));
    var mergeOps = addtionalMergeOps(ops, ctx.currentSheetId);
    ops = [].concat(_toConsumableArray(ops), _toConsumableArray(mergeOps));

    if (options === null || options === void 0 ? void 0 : options.restoreDeletedCells) {
      var restoreCellsOps = [];
      var flowdata = getFlowdata(ctx);

      if (flowdata) {
        var rowlen = flowdata.length;
        var collen = flowdata[0].length;

        for (var i = 0; i < rowlen; i += 1) {
          for (var j = 0; j < collen; j += 1) {
            var cell = flowdata[i][j];
            if (!cell) continue;

            if (options.insertRowColOp.type === "row" && i >= options.insertRowColOp.index && i < options.insertRowColOp.index + options.insertRowColOp.count || options.insertRowColOp.type === "column" && j >= options.insertRowColOp.index && j < options.insertRowColOp.index + options.insertRowColOp.count) {
              restoreCellsOps.push({
                op: "replace",
                path: ["data", i, j],
                id: ctx.currentSheetId,
                value: cell
              });
            }
          }
        }
      }

      ops = [].concat(_toConsumableArray(ops), restoreCellsOps);
    } else {
      var cellOps = additionalCellOps(ctx, options.insertRowColOp);
      ops = [].concat(_toConsumableArray(ops), _toConsumableArray(cellOps));
    }
  } else if (options === null || options === void 0 ? void 0 : options.deleteRowColOp) {
    var _$partition3 = _.partition(ops, function (p) {
      return p.path[0] !== "data";
    }),
        _$partition4 = _slicedToArray(_$partition3, 2),
        _nonDataOps = _$partition4[0],
        _dataOps = _$partition4[1];

    var _formulaOps = extractFormulaCellOps(_dataOps);

    ops = _nonDataOps;
    ops.push({
      op: "deleteRowCol",
      id: options.deleteRowColOp.id,
      path: [],
      value: options.deleteRowColOp
    });
    ops = [].concat(_toConsumableArray(ops), _toConsumableArray(_formulaOps));

    var _mergeOps = addtionalMergeOps(ops, ctx.currentSheetId);

    ops = [].concat(_toConsumableArray(ops), _toConsumableArray(_mergeOps));
  } else if (options === null || options === void 0 ? void 0 : options.addSheetOp) {
    var _$partition5 = _.partition(ops, function (op) {
      return op.path.length === 0 && op.op === "add";
    }),
        _$partition6 = _slicedToArray(_$partition5, 2),
        addSheetOps = _$partition6[0],
        otherOps = _$partition6[1];

    options.id = options.addSheet.id;

    if (undo) {
      var _options$addSheet, _options$addSheet$val, _options$addSheet2;

      var index = getSheetIndex(ctx, options.addSheet.id);
      var order = (_options$addSheet = options.addSheet) === null || _options$addSheet === void 0 ? void 0 : (_options$addSheet$val = _options$addSheet.value) === null || _options$addSheet$val === void 0 ? void 0 : _options$addSheet$val.order;
      ops = otherOps;
      ops.push({
        op: "deleteSheet",
        id: (_options$addSheet2 = options.addSheet) === null || _options$addSheet2 === void 0 ? void 0 : _options$addSheet2.id,
        path: [],
        value: options.addSheet
      });

      if (index !== ctx.luckysheetfile.length) {
        var sheetsRight = ctx.luckysheetfile.filter(function (sheet) {
          return (sheet === null || sheet === void 0 ? void 0 : sheet.order) >= order;
        });

        _.forEach(sheetsRight, function (sheet) {
          ops.push({
            id: sheet.id,
            op: "replace",
            path: ["order"],
            value: (sheet === null || sheet === void 0 ? void 0 : sheet.order) - 1
          });
        });
      }
    } else {
      var _options$addSheet3, _addSheetOps$;

      ops = otherOps;
      ops.push({
        op: "addSheet",
        id: (_options$addSheet3 = options.addSheet) === null || _options$addSheet3 === void 0 ? void 0 : _options$addSheet3.id,
        path: [],
        value: (_addSheetOps$ = addSheetOps[0]) === null || _addSheetOps$ === void 0 ? void 0 : _addSheetOps$.value
      });
    }
  } else if (options === null || options === void 0 ? void 0 : options.deleteSheetOp) {
    options.id = options.deleteSheetOp.id;

    if (undo) {
      var _options$deletedSheet, _options$deletedSheet2, _options$deletedSheet3, _options$deletedSheet4, _options$deletedSheet5;

      ops = [{
        op: "addSheet",
        id: options.deleteSheetOp.id,
        path: [],
        value: (_options$deletedSheet = options.deletedSheet) === null || _options$deletedSheet === void 0 ? void 0 : _options$deletedSheet.value
      }, {
        id: options.deleteSheetOp.id,
        op: "replace",
        path: ["name"],
        value: (_options$deletedSheet2 = options.deletedSheet) === null || _options$deletedSheet2 === void 0 ? void 0 : (_options$deletedSheet3 = _options$deletedSheet2.value) === null || _options$deletedSheet3 === void 0 ? void 0 : _options$deletedSheet3.name
      }];

      var _order = (_options$deletedSheet4 = options.deletedSheet) === null || _options$deletedSheet4 === void 0 ? void 0 : (_options$deletedSheet5 = _options$deletedSheet4.value) === null || _options$deletedSheet5 === void 0 ? void 0 : _options$deletedSheet5.order;

      var _sheetsRight = ctx.luckysheetfile.filter(function (sheet) {
        var _options$deleteSheetO;

        return (sheet === null || sheet === void 0 ? void 0 : sheet.order) >= _order && sheet.id !== ((_options$deleteSheetO = options.deleteSheetOp) === null || _options$deleteSheetO === void 0 ? void 0 : _options$deleteSheetO.id);
      });

      _.forEach(_sheetsRight, function (sheet) {
        ops.push({
          id: sheet.id,
          op: "replace",
          path: ["order"],
          value: sheet === null || sheet === void 0 ? void 0 : sheet.order
        });
      });
    } else {
      var _options$deletedSheet6, _options$deletedSheet7, _options$deletedSheet8;

      ops = [{
        op: "deleteSheet",
        id: options.deleteSheetOp.id,
        path: [],
        value: options.deletedSheet
      }];

      var _order2 = (_options$deletedSheet6 = options.deletedSheet) === null || _options$deletedSheet6 === void 0 ? void 0 : (_options$deletedSheet7 = _options$deletedSheet6.value) === null || _options$deletedSheet7 === void 0 ? void 0 : _options$deletedSheet7.order;

      if (((_options$deletedSheet8 = options.deletedSheet) === null || _options$deletedSheet8 === void 0 ? void 0 : _options$deletedSheet8.order) !== ctx.luckysheetfile.length) {
        var _sheetsRight2 = ctx.luckysheetfile.filter(function (sheet) {
          return (sheet === null || sheet === void 0 ? void 0 : sheet.order) >= _order2;
        });

        _.forEach(_sheetsRight2, function (sheet) {
          ops.push({
            id: sheet.id,
            op: "replace",
            path: ["order"],
            value: sheet === null || sheet === void 0 ? void 0 : sheet.order
          });
        });
      }
    }
  }

  return ops;
}
function opToPatch(ctx, ops) {
  var _$partition7 = _.partition(ops, function (op) {
    return op.op === "add" || op.op === "remove" || op.op === "replace";
  }),
      _$partition8 = _slicedToArray(_$partition7, 2),
      normalOps = _$partition8[0],
      specialOps = _$partition8[1];

  var additionalPatches = [];
  var patches = normalOps.map(function (op) {
    var patch = {
      op: op.op,
      value: op.value,
      path: op.path
    };

    if (op.id) {
      var i = getSheetIndex(ctx, op.id);

      if (i != null) {
        patch.path = ["luckysheetfile", i].concat(_toConsumableArray(op.path));
      }

      if (op.path[0] === "images" && op.id === ctx.currentSheetId) {
        additionalPatches.push(_objectSpread2(_objectSpread2({}, patch), {}, {
          path: ["insertedImgs"]
        }));
      }
    }

    return patch;
  });
  return [patches.concat(additionalPatches), specialOps];
}
function inverseRowColOptions(options) {
  if (!options) return options;

  if (options.insertRowColOp) {
    var index = options.insertRowColOp.index;

    if (options.insertRowColOp.direction === "rightbottom") {
      index += 1;
    }

    return {
      deleteRowColOp: {
        type: options.insertRowColOp.type,
        id: options.insertRowColOp.id,
        start: index,
        end: index + options.insertRowColOp.count - 1
      }
    };
  }

  if (options.deleteRowColOp) {
    return {
      insertRowColOp: {
        type: options.deleteRowColOp.type,
        id: options.deleteRowColOp.id,
        index: options.deleteRowColOp.start,
        count: options.deleteRowColOp.end - options.deleteRowColOp.start + 1,
        direction: "lefttop"
      }
    };
  }

  return options;
}

function generateRandomSheetName(file, isPivotTable, ctx) {
  var index = file.length;
  var locale_pivotTable = locale(ctx).pivotTable;
  var title = locale_pivotTable.title;

  for (var i = 0; i < file.length; i += 1) {
    if (file[i].name.indexOf("Sheet") > -1 || file[i].name.indexOf(title) > -1) {
      var suffix = parseFloat(file[i].name.replace("Sheet", "").replace(title, ""));

      if (!Number.isNaN(suffix) && Math.ceil(suffix) > index) {
        index = Math.ceil(suffix);
      }
    }
  }

  if (isPivotTable) {
    return title + (index + 1);
  }

  return "Sheet".concat(index + 1);
}
function rgbToHex(color) {
  var rgb;

  if (color.indexOf("rgba") > -1) {
    rgb = color.replace("rgba(", "").replace(")", "").split(",");
  } else {
    rgb = color.replace("rgb(", "").replace(")", "").split(",");
  }

  var r = Number(rgb[0]);
  var g = Number(rgb[1]);
  var b = Number(rgb[2]);
  return "#".concat(((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1));
}
function indexToColumnChar(n) {
  var orda = "a".charCodeAt(0);
  var ordz = "z".charCodeAt(0);
  var len = ordz - orda + 1;
  var s = "";

  while (n >= 0) {
    s = String.fromCharCode(n % len + orda) + s;
    n = Math.floor(n / len) - 1;
  }

  return s.toUpperCase();
}
function columnCharToIndex(a) {
  if (a == null || a.length === 0) {
    return NaN;
  }

  var str = a.toLowerCase().split("");
  var al = str.length;

  var getCharNumber = function getCharNumber(charx) {
    return charx.charCodeAt(0) - 96;
  };

  var numout = 0;
  var charnum = 0;

  for (var i = 0; i < al; i += 1) {
    charnum = getCharNumber(str[i]);
    numout += charnum * Math.pow(26, al - i - 1);
  }

  if (numout === 0) {
    return NaN;
  }

  return numout - 1;
}
function escapeScriptTag(str) {
  if (typeof str !== "string") return str;
  return str.replace(/<script>/g, "&lt;script&gt;").replace(/<\/script>/, "&lt;/script&gt;");
}
function escapeHTMLTag(str) {
  if (typeof str !== "string") return str;

  if (str.substr(0, 5) === "<span" || _.startsWith(str, "=")) {
    return str;
  }

  return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function getSheetIndex(ctx, id) {
  for (var i = 0; i < ctx.luckysheetfile.length; i += 1) {
    var _ctx$luckysheetfile$i;

    if (((_ctx$luckysheetfile$i = ctx.luckysheetfile[i]) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i.id) === id) {
      return i;
    }
  }

  return null;
}
function getSheetIdByName(ctx, name) {
  for (var i = 0; i < ctx.luckysheetfile.length; i += 1) {
    if (ctx.luckysheetfile[i].name === name) {
      return ctx.luckysheetfile[i].id;
    }
  }

  return null;
}
function getSheetByIndex(ctx, id) {
  if (_.isNil(id)) {
    id = ctx.currentSheetId;
  }

  var i = getSheetIndex(ctx, id);

  if (_.isNil(i)) {
    return null;
  }

  return ctx.luckysheetfile[i];
}
function getNowDateTime(format) {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var date = now.getDate();
  var hour = now.getHours();
  var minu = now.getMinutes();
  var sec = now.getSeconds();
  month += 1;
  if (month < 10) month = "0".concat(month);
  if (date < 10) date = "0".concat(date);
  if (hour < 10) hour = "0".concat(hour);
  if (minu < 10) minu = "0".concat(minu);
  if (sec < 10) sec = "0".concat(sec);
  var time = "";

  if (format === 1) {
    time = "".concat(year, "-").concat(month, "-").concat(date);
  } else if (format === 2) {
    time = "".concat(year, "-").concat(month, "-").concat(date, " ").concat(hour, ":").concat(minu, ":").concat(sec);
  }

  return time;
}
function replaceHtml(temp, dataarry) {
  return temp.replace(/\$\{([\w]+)\}/g, function (s1, s2) {
    var s = dataarry[s2];

    if (typeof s !== "undefined") {
      return s;
    }

    return s1;
  });
}
function getRegExpStr(str) {
  return str.replace("~*", "\\*").replace("~?", "\\?").replace(".", "\\.").replace("*", ".*").replace("?", ".");
}
function chatatABC(n) {
  var orda = "a".charCodeAt(0);
  var ordz = "z".charCodeAt(0);
  var len = ordz - orda + 1;
  var s = "";

  while (n >= 0) {
    s = String.fromCharCode(n % len + orda) + s;
    n = Math.floor(n / len) - 1;
  }

  return s.toUpperCase();
}
function isAllowEdit(ctx, range) {
  var cfg = ctx.config;
  var judgeRange = _.isUndefined(range) ? ctx.luckysheet_select_save : range;
  return _.every(judgeRange, function (selection) {
    for (var r = selection.row[0]; r <= selection.row[1]; r += 1) {
      var _cfg$rowReadOnly;

      if ((_cfg$rowReadOnly = cfg.rowReadOnly) === null || _cfg$rowReadOnly === void 0 ? void 0 : _cfg$rowReadOnly[r]) {
        return false;
      }
    }

    for (var c = selection.column[0]; c <= selection.column[1]; c += 1) {
      var _cfg$colReadOnly;

      if ((_cfg$colReadOnly = cfg.colReadOnly) === null || _cfg$colReadOnly === void 0 ? void 0 : _cfg$colReadOnly[c]) {
        return false;
      }
    }

    for (var _r = selection.row[0]; _r <= selection.row[1]; _r += 1) {
      for (var _c = selection.column[0]; _c <= selection.column[1]; _c += 1) {
        if (checkCellIsLocked(ctx, _r, _c, ctx.currentSheetId)) {
          return false;
        }
      }
    }

    return true;
  }) && (_.isUndefined(ctx.allowEdit) ? true : ctx.allowEdit);
}

var INVALID_PARAMS = new Error("invalid params");
var SHEET_NOT_FOUND = new Error("sheet not found");

var dataToCelldata = function dataToCelldata(data) {
  var celldata = [];

  if (data == null) {
    return celldata;
  }

  for (var r = 0; r < data.length; r += 1) {
    for (var c = 0; c < data[r].length; c += 1) {
      var v = data[r][c];

      if (v != null) {
        celldata.push({
          r: r,
          c: c,
          v: v
        });
      }
    }
  }

  return celldata;
};
var celldataToData = function celldataToData(celldata, rowCount, colCount) {
  var _lastRow$r, _lastCol$c;

  var lastRow = _.maxBy(celldata, "r");

  var lastCol = _.maxBy(celldata, "c");

  var lastRowNum = ((_lastRow$r = lastRow === null || lastRow === void 0 ? void 0 : lastRow.r) !== null && _lastRow$r !== void 0 ? _lastRow$r : 0) + 1;
  var lastColNum = ((_lastCol$c = lastCol === null || lastCol === void 0 ? void 0 : lastCol.c) !== null && _lastCol$c !== void 0 ? _lastCol$c : 0) + 1;

  if (rowCount != null && colCount != null && rowCount > 0 && colCount > 0) {
    lastRowNum = Math.max(lastRowNum, rowCount);
    lastColNum = Math.max(lastColNum, colCount);
  }

  if (lastRowNum && lastColNum) {
    var expandedData = _.times(lastRowNum, function () {
      return _.times(lastColNum, function () {
        return null;
      });
    });

    celldata === null || celldata === void 0 ? void 0 : celldata.forEach(function (d) {
      expandedData[d.r][d.c] = d.v;
    });
    return expandedData;
  }

  return null;
};
function getSheet(ctx) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$index = options.index,
      index = _options$index === void 0 ? getSheetIndex(ctx, options.id || ctx.currentSheetId) : _options$index;

  if (index == null) {
    throw SHEET_NOT_FOUND;
  }

  var sheet = ctx.luckysheetfile[index];

  if (sheet == null) {
    throw SHEET_NOT_FOUND;
  }

  return sheet;
}
function getSheetWithLatestCelldata(ctx) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sheet = getSheet(ctx, options);
  return _objectSpread2(_objectSpread2({}, sheet), {}, {
    celldata: dataToCelldata(sheet.data)
  });
}

function getCellValue$1(ctx, row, column) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!_.isNumber(row) || !_.isNumber(column)) {
    throw new Error("row or column cannot be null or undefined");
  }

  var sheet = getSheet(ctx, options);
  var _options$type = options.type,
      type = _options$type === void 0 ? "v" : _options$type;
  var targetSheetData = sheet.data;

  if (!targetSheetData) {
    throw SHEET_NOT_FOUND;
  }

  var cellData = targetSheetData[row][column];
  var ret;

  if (cellData && _.isPlainObject(cellData)) {
    var _cellData$ct;

    ret = cellData[type];

    if (type === "f" && ret != null) {
      ret = functionHTMLGenerate(ret);
    } else if (type === "f") {
      ret = cellData.v;
    } else if (cellData && cellData.ct && cellData.ct.fa === "yyyy-MM-dd") {
      ret = cellData.m;
    } else if (((_cellData$ct = cellData.ct) === null || _cellData$ct === void 0 ? void 0 : _cellData$ct.t) === "inlineStr") {
      ret = cellData.ct.s.reduce(function (prev, cur) {
        var _cur$v;

        return prev + ((_cur$v = cur.v) !== null && _cur$v !== void 0 ? _cur$v : "");
      }, "");
    }
  }

  if (ret === undefined) {
    ret = null;
  }

  return ret;
}
function setCellValue$1(ctx, row, column, value, cellInput) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (!_.isNumber(row) || !_.isNumber(column)) {
    throw new Error("row or column cannot be null or undefined");
  }

  var sheet = getSheet(ctx, options);
  var data = sheet.data;
  var formatList = {
    bg: 1,
    ff: 1,
    fc: 1,
    bl: 1,
    it: 1,
    fs: 1,
    cl: 1,
    un: 1,
    vt: 1,
    ht: 1,
    mc: 1,
    tr: 1,
    tb: 1,
    rt: 1,
    qp: 1
  };

  if (value == null || value.toString().length === 0) {
    delFunctionGroup(ctx, row, column);
    setCellValue(ctx, row, column, data, value);
  } else if (value instanceof Object) {
    var _data$row;

    var curv = {};

    if ((data === null || data === void 0 ? void 0 : (_data$row = data[row]) === null || _data$row === void 0 ? void 0 : _data$row[column]) == null) {
      data[row][column] = {};
    }

    var cell = data[row][column];

    if (value.f != null && value.v == null) {
      curv.f = value.f;

      if (value.ct != null) {
        curv.ct = value.ct;
      }

      updateCell(ctx, row, column, cellInput, curv);
    } else {
      if (value.ct != null) {
        curv.ct = value.ct;
      }

      if (value.f != null) {
        curv.f = value.f;
      }

      if (value.v != null) {
        curv.v = value.v;
      } else {
        curv.v = cell.v;
      }

      if (value.m != null) {
        curv.m = value.m;
      }

      delFunctionGroup(ctx, row, column);
      setCellValue(ctx, row, column, data, curv);
    }

    _.forEach(value, function (v, attr) {
      if (attr in formatList) {
        updateFormatCell(ctx, data, attr, v, row, row, column, column);
      } else {
        cell[attr] = v;
      }
    });

    data[row][column] = cell;
  } else {
    if (value.toString().substr(0, 1) === "=" || value.toString().substr(0, 5) === "<span") {
      updateCell(ctx, row, column, cellInput, value);
    } else {
      delFunctionGroup(ctx, row, column);
      setCellValue(ctx, row, column, data, value);
    }
  }
}
function clearCell(ctx, row, column) {
  var _sheet$data, _sheet$data$row;

  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!_.isNumber(row) || !_.isNumber(column)) {
    throw new Error("row or column cannot be null or undefined");
  }

  var sheet = getSheet(ctx, options);
  var cell = (_sheet$data = sheet.data) === null || _sheet$data === void 0 ? void 0 : (_sheet$data$row = _sheet$data[row]) === null || _sheet$data$row === void 0 ? void 0 : _sheet$data$row[column];

  if (cell && _.isPlainObject(cell)) {
    delete cell.m;
    delete cell.v;

    if (cell.f != null) {
      delete cell.f;
      delFunctionGroup(ctx, row, column, sheet.id);
      delete cell.spl;
    }
  }
}
function setCellFormat(ctx, row, column, attr, value) {
  var _targetSheetData$row;

  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (!_.isNumber(row) || !_.isNumber(column)) {
    throw new Error("row or column cannot be null or undefined");
  }

  if (!attr) {
    throw new Error("attr cannot be null or undefined");
  }

  var sheet = getSheet(ctx, options);
  var targetSheetData = sheet.data;
  var cellData = (targetSheetData === null || targetSheetData === void 0 ? void 0 : (_targetSheetData$row = targetSheetData[row]) === null || _targetSheetData$row === void 0 ? void 0 : _targetSheetData$row[column]) || {};
  var cfg = sheet.config || {};

  if (attr === "ct" && (!value || value.fa == null || value.t == null)) {
    throw new Error("'fa' and 't' should be present in value when attr is 'ct'");
  } else if (attr === "ct" && !_.isNil(cellData.v)) {
    cellData.m = SSF.format(value.fa, cellData.v);
  }

  if (attr === "bd") {
    if (cfg.borderInfo == null) {
      cfg.borderInfo = [];
    }

    var borderInfo = _objectSpread2({
      rangeType: "range",
      borderType: "border-all",
      color: "#000",
      style: "1",
      range: [{
        column: [column, column],
        row: [row, row]
      }]
    }, value);

    cfg.borderInfo.push(borderInfo);
  } else {
    cellData[attr] = value;
  }

  targetSheetData[row][column] = cellData;
  sheet.config = cfg;
  ctx.config = cfg;
}
function autoFillCell(ctx, copyRange, applyRange, direction) {
  dropCellCache.copyRange = copyRange;
  dropCellCache.applyRange = applyRange;
  dropCellCache.direction = direction;
  var typeItemHide = getTypeItemHide(ctx);

  if (!typeItemHide[0] && !typeItemHide[1] && !typeItemHide[2] && !typeItemHide[3] && !typeItemHide[4] && !typeItemHide[5] && !typeItemHide[6]) {
    dropCellCache.applyType = "0";
  } else {
    dropCellCache.applyType = "1";
  }

  updateDropCell(ctx);
}

function freeze(ctx, type, range) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var sheet = getSheet(ctx, options);
  var typeMap = {
    row: "rangeRow",
    column: "rangeColumn",
    both: "rangeBoth"
  };
  var innerType = typeMap[type];
  sheet.frozen = {
    type: innerType,
    range: {
      column_focus: range.column,
      row_focus: range.row
    }
  };
}
function insertRowOrColumn(ctx, type, index, count, direction) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (!["row", "column"].includes(type) || !_.isNumber(index) || !_.isNumber(count) || !["lefttop", "rightbottom"].includes(direction)) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);

  try {
    insertRowCol(ctx, {
      type: type,
      index: index,
      count: count,
      direction: direction,
      id: sheet.id
    });
  } catch (e) {
    console.error(e);
  }
}
function deleteRowOrColumn(ctx, type, start, end) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  if (!["row", "column"].includes(type) || !_.isNumber(start) || !_.isNumber(end)) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);
  deleteRowCol(ctx, {
    type: type,
    start: start,
    end: end,
    id: sheet.id
  });
}
function hideRowOrColumn(ctx, rowColInfo, type) {
  if (!["row", "column"].includes(type)) {
    throw INVALID_PARAMS;
  }

  if (!ctx || !ctx.config) return;
  var index = getSheetIndex(ctx, ctx.currentSheetId);

  if (type === "row") {
    var _ctx$config$rowhidden;

    var rowhidden = (_ctx$config$rowhidden = ctx.config.rowhidden) !== null && _ctx$config$rowhidden !== void 0 ? _ctx$config$rowhidden : {};
    rowColInfo.forEach(function (r) {
      rowhidden[r] = 0;
    });
    ctx.config.rowhidden = rowhidden;
  } else if (type === "column") {
    var _ctx$config$colhidden;

    var colhidden = (_ctx$config$colhidden = ctx.config.colhidden) !== null && _ctx$config$colhidden !== void 0 ? _ctx$config$colhidden : {};
    rowColInfo.forEach(function (r) {
      colhidden[r] = 0;
    });
    ctx.config.colhidden = colhidden;
  }

  ctx.luckysheetfile[index].config = ctx.config;
}
function showRowOrColumn(ctx, rowColInfo, type) {
  if (!["row", "column"].includes(type)) {
    throw INVALID_PARAMS;
  }

  if (!ctx || !ctx.config) return;
  var index = getSheetIndex(ctx, ctx.currentSheetId);

  if (type === "row") {
    var _ctx$config$rowhidden2;

    var rowhidden = (_ctx$config$rowhidden2 = ctx.config.rowhidden) !== null && _ctx$config$rowhidden2 !== void 0 ? _ctx$config$rowhidden2 : {};
    rowColInfo.forEach(function (r) {
      delete rowhidden[r];
    });
    ctx.config.rowhidden = rowhidden;
  } else if (type === "column") {
    var _ctx$config$colhidden2;

    var colhidden = (_ctx$config$colhidden2 = ctx.config.colhidden) !== null && _ctx$config$colhidden2 !== void 0 ? _ctx$config$colhidden2 : {};
    rowColInfo.forEach(function (r) {
      delete colhidden[r];
    });
    ctx.config.colhidden = colhidden;
  }

  ctx.luckysheetfile[index].config = ctx.config;
}
function setRowHeight(ctx, rowInfo) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!_.isPlainObject(rowInfo)) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);
  var cfg = sheet.config || {};

  if (cfg.rowlen == null) {
    cfg.rowlen = {};
  }

  _.forEach(rowInfo, function (len, r) {
    if (Number(r) >= 0) {
      if (Number(len) >= 0) {
        cfg.rowlen[Number(r)] = Number(len);

        if (custom && _.isUndefined(cfg.customHeight)) {
          cfg.customHeight = _defineProperty({}, r, 1);
        } else if (custom) {
          cfg.customHeight[r] = 1;
        }
      }
    }
  });

  sheet.config = cfg;

  if (ctx.currentSheetId === sheet.id) {
    ctx.config = cfg;
  }
}
function setColumnWidth(ctx, columnInfo) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!_.isPlainObject(columnInfo)) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);
  var cfg = sheet.config || {};

  if (cfg.columnlen == null) {
    cfg.columnlen = {};
  }

  _.forEach(columnInfo, function (len, c) {
    if (Number(c) >= 0) {
      if (Number(len) >= 0) {
        cfg.columnlen[Number(c)] = Number(len);

        if (custom && _.isUndefined(cfg.customWidth)) {
          cfg.customWidth = _defineProperty({}, c, 1);
        } else if (custom) {
          cfg.customWidth[c] = 1;
        }
      }
    }
  });

  sheet.config = cfg;

  if (ctx.currentSheetId === sheet.id) {
    ctx.config = cfg;
  }
}
function getRowHeight(ctx, rows) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!_.isArray(rows) || rows.length === 0) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);
  var cfg = sheet.config || {};
  var rowlen = cfg.rowlen || {};
  var rowlenObj = {};
  rows.forEach(function (item) {
    if (Number(item) >= 0) {
      var size = rowlen[Number(item)] || ctx.defaultrowlen;
      rowlenObj[Number(item)] = size;
    }
  });
  return rowlenObj;
}
function getColumnWidth(ctx, columns) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!_.isArray(columns) || columns.length === 0) {
    throw INVALID_PARAMS;
  }

  var sheet = getSheet(ctx, options);
  var cfg = sheet.config || {};
  var columnlen = cfg.columnlen || {};
  var columnlenObj = {};
  columns.forEach(function (item) {
    if (Number(item) >= 0) {
      var size = columnlen[Number(item)] || ctx.defaultcollen;
      columnlenObj[Number(item)] = size;
    }
  });
  return columnlenObj;
}

function getSelection(ctx) {
  var _ctx$luckysheet_selec;

  return (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec.map(function (selection) {
    return {
      row: selection.row,
      column: selection.column
    };
  });
}
function getFlattenRange(ctx, range) {
  var _range;

  range = range || getSelection(ctx);
  var result = [];
  (_range = range) === null || _range === void 0 ? void 0 : _range.forEach(function (ele) {
    var rs = ele.row;
    var cs = ele.column;

    for (var r = rs[0]; r <= rs[1]; r += 1) {
      for (var c = cs[0]; c <= cs[1]; c += 1) {
        result.push({
          r: r,
          c: c
        });
      }
    }
  });
  return result;
}
function getCellsByFlattenRange(ctx, range) {
  range = range || getFlattenRange(ctx);
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return [];
  return range.map(function (item) {
    var _flowdata$item$r;

    return (_flowdata$item$r = flowdata[item.r]) === null || _flowdata$item$r === void 0 ? void 0 : _flowdata$item$r[item.c];
  });
}
function getSelectionCoordinates(ctx) {
  var result = [];

  var rangeArr = _.cloneDeep(ctx.luckysheet_select_save);

  var sheetId = ctx.currentSheetId;
  rangeArr === null || rangeArr === void 0 ? void 0 : rangeArr.forEach(function (ele) {
    var rangeText = getRangetxt(ctx, sheetId, {
      column: ele.column,
      row: ele.row
    });
    result.push(rangeText);
  });
  return result;
}
function getCellsByRange(ctx, range) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sheet = getSheet(ctx, options);

  if (!range || _typeof(range) === "object") {
    return getdatabyselection(ctx, range, sheet.id);
  }

  throw INVALID_PARAMS;
}
function getHtmlByRange(ctx, range) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sheet = getSheet(ctx, options);
  return rangeValueToHtml(ctx, sheet.id, range);
}
function setSelection(ctx, range, options) {
  var sheet = getSheet(ctx, options);
  sheet.luckysheet_select_save = normalizeSelection(ctx, range);

  if (ctx.currentSheetId === sheet.id) {
    ctx.luckysheet_select_save = sheet.luckysheet_select_save;
  }
}
function setCellValuesByRange(ctx, data, range, cellInput) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  if (data == null) {
    throw INVALID_PARAMS;
  }

  if (range instanceof Array) {
    throw new Error("setCellValuesByRange does not support multiple ranges");
  }

  if (!_.isPlainObject(range)) {
    throw INVALID_PARAMS;
  }

  var rowCount = range.row[1] - range.row[0] + 1;
  var columnCount = range.column[1] - range.column[0] + 1;

  if (data.length !== rowCount || data[0].length !== columnCount) {
    throw new Error("data size does not match range");
  }

  for (var i = 0; i < rowCount; i += 1) {
    for (var j = 0; j < columnCount; j += 1) {
      var row = range.row[0] + i;
      var column = range.column[0] + j;
      setCellValue$1(ctx, row, column, data[i][j], cellInput, options);
    }
  }
}
function setCellFormatByRange(ctx, attr, value, range) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  if (_.isPlainObject(range)) {
    range = [range];
  }

  if (!_.isArray(range)) {
    throw INVALID_PARAMS;
  }

  range.forEach(function (singleRange) {
    for (var r = singleRange.row[0]; r <= singleRange.row[1]; r += 1) {
      for (var c = singleRange.column[0]; c <= singleRange.column[1]; c += 1) {
        setCellFormat(ctx, r, c, attr, value, options);
      }
    }
  });
}

function mergeCells$1(ctx, ranges, type) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var sheet = getSheet(ctx, options);
  mergeCells(ctx, sheet.id, ranges, type);
}
function cancelMerge(ctx, ranges) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  mergeCells$1(ctx, ranges, "merge-cancel", options);
}

function addSheet$1(ctx, settings, newSheetID) {
  var isPivotTable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sheetname = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var sheetData = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  addSheet(ctx, settings, newSheetID, isPivotTable, sheetname, sheetData);
}
function deleteSheet$1(ctx) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sheet = getSheet(ctx, options);
  deleteSheet(ctx, sheet.id);
}
function updateSheet$1(ctx, data) {
  updateSheet(ctx, data);
}
function activateSheet(ctx) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sheet = getSheet(ctx, options);
  ctx.currentSheetId = sheet.id;
}
function setSheetName(ctx, name) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sheet = getSheet(ctx, options);
  sheet.name = name;
}
function setSheetOrder(ctx, orderList) {
  var _ctx$luckysheetfile;

  (_ctx$luckysheetfile = ctx.luckysheetfile) === null || _ctx$luckysheetfile === void 0 ? void 0 : _ctx$luckysheetfile.forEach(function (sheet) {
    if (sheet.id in orderList) {
      sheet.order = orderList[sheet.id];
    }
  });

  _.sortBy(ctx.luckysheetfile, ["order"]).forEach(function (sheet, i) {
    sheet.order = i;
  });
}
function scroll(ctx, scrollbarX, scrollbarY, options) {
  if (options.scrollLeft != null) {
    if (!_.isNumber(options.scrollLeft)) {
      throw INVALID_PARAMS;
    }

    if (scrollbarX) {
      scrollbarX.scrollLeft = options.scrollLeft;
    }
  } else if (options.targetColumn != null) {
    if (!_.isNumber(options.targetColumn)) {
      throw INVALID_PARAMS;
    }

    var col_pre = options.targetColumn <= 0 ? 0 : ctx.visibledatacolumn[options.targetColumn - 1];

    if (scrollbarX) {
      scrollbarX.scrollLeft = col_pre;
    }
  }

  if (options.scrollTop != null) {
    if (!_.isNumber(options.scrollTop)) {
      throw INVALID_PARAMS;
    }

    if (scrollbarY) {
      scrollbarY.scrollTop = options.scrollTop;
    }
  } else if (options.targetRow != null) {
    if (!_.isNumber(options.targetRow)) {
      throw INVALID_PARAMS;
    }

    var row_pre = options.targetRow <= 0 ? 0 : ctx.visibledatarow[options.targetRow - 1];

    if (scrollbarY) {
      scrollbarY.scrollTop = row_pre;
    }
  }
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSheetWithLatestCelldata: getSheetWithLatestCelldata,
  dataToCelldata: dataToCelldata,
  celldataToData: celldataToData,
  getCellValue: getCellValue$1,
  setCellValue: setCellValue$1,
  clearCell: clearCell,
  setCellFormat: setCellFormat,
  autoFillCell: autoFillCell,
  freeze: freeze,
  insertRowOrColumn: insertRowOrColumn,
  deleteRowOrColumn: deleteRowOrColumn,
  hideRowOrColumn: hideRowOrColumn,
  showRowOrColumn: showRowOrColumn,
  setRowHeight: setRowHeight,
  setColumnWidth: setColumnWidth,
  getRowHeight: getRowHeight,
  getColumnWidth: getColumnWidth,
  getSelection: getSelection,
  getFlattenRange: getFlattenRange,
  getCellsByFlattenRange: getCellsByFlattenRange,
  getSelectionCoordinates: getSelectionCoordinates,
  getCellsByRange: getCellsByRange,
  getHtmlByRange: getHtmlByRange,
  setSelection: setSelection,
  setCellValuesByRange: setCellValuesByRange,
  setCellFormatByRange: setCellFormatByRange,
  mergeCells: mergeCells$1,
  cancelMerge: cancelMerge,
  getAllSheets: getAllSheets,
  getSheet: getSheet,
  initSheetData: initSheetData,
  hideSheet: hideSheet,
  showSheet: showSheet,
  copySheet: copySheet,
  calculateSheetFromula: calculateSheetFromula,
  addSheet: addSheet$1,
  deleteSheet: deleteSheet$1,
  updateSheet: updateSheet$1,
  activateSheet: activateSheet,
  setSheetName: setSheetName,
  setSheetOrder: setSheetOrder,
  scroll: scroll
});

var defaultSettings = {
  column: 60,
  row: 84,
  addRows: 50,
  showToolbar: true,
  showFormulaBar: true,
  showSheetTabs: true,
  data: [],
  config: {},
  devicePixelRatio: 0,
  allowEdit: true,
  lang: null,
  forceCalculation: false,
  rowHeaderWidth: 46,
  columnHeaderHeight: 20,
  defaultColWidth: 73,
  defaultRowHeight: 19,
  defaultFontSize: 10,
  toolbarItems: ["undo", "redo", "format-painter", "clear-format", "|", "currency-format", "percentage-format", "number-decrease", "number-increase", "format", "|", "font", "|", "font-size", "|", "bold", "italic", "strike-through", "underline", "|", "font-color", "background", "border", "merge-cell", "|", "horizontal-align", "vertical-align", "text-wrap", "text-rotation", "|", "freeze", "conditionFormat", "filter", "link", "image", "comment", "quick-formula", "dataVerification", "splitColumn", "locationCondition", "screenshot", "search"],
  cellContextMenu: ["copy", "paste", "|", "insert-row", "insert-column", "delete-row", "delete-column", "delete-cell", "hide-row", "hide-column", "set-row-height", "set-column-width", "|", "clear", "sort", "orderAZ", "orderZA", "filter", "chart", "image", "link", "data", "cell-format"],
  headerContextMenu: ["copy", "paste", "|", "insert-row", "insert-column", "delete-row", "delete-column", "delete-cell", "hide-row", "hide-column", "set-row-height", "set-column-width", "|", "clear", "sort", "orderAZ", "orderZA"],
  sheetTabContextMenu: ["delete", "copy", "rename", "color", "hide", "|", "move"],
  filterContextMenu: ["sort-by-asc", "sort-by-desc", "|", "filter-by-color", "|", "filter-by-value"],
  generateSheetId: function generateSheetId() {
    return v4();
  },
  hooks: {},
  customToolbarItems: [],
  currency: "¥"
};

function handleCopy(ctx) {
  if (ctx.luckysheetPaintModelOn) {
    cancelPaintModel(ctx);
  }

  var selection = ctx.luckysheet_select_save;

  if (!selection || _.isEmpty(selection)) {
    return;
  }

  if (ctx.config.merge != null) {
    var has_PartMC = false;

    for (var s = 0; s < selection.length; s += 1) {
      var r1 = selection[s].row[0];
      var r2 = selection[s].row[1];
      var c1 = selection[s].column[0];
      var c2 = selection[s].column[1];
      has_PartMC = hasPartMC(ctx, ctx.config, r1, r2, c1, c2);

      if (has_PartMC) {
        break;
      }
    }

    if (has_PartMC) {
      return;
    }
  }

  var cdformat = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].luckysheet_conditionformat_save;

  if (!_.isNil(ctx.luckysheet_select_save) && ctx.luckysheet_select_save.length > 1 && !_.isNil(cdformat) && cdformat.length > 0) {
    var hasCF = false;
    var cf_compute = getComputeMap(ctx);

    for (var _s = 0; _s < ctx.luckysheet_select_save.length; _s += 1) {
      if (hasCF) {
        break;
      }

      var _r = ctx.luckysheet_select_save[_s].row[0];
      var _r2 = ctx.luckysheet_select_save[_s].row[1];
      var _c = ctx.luckysheet_select_save[_s].column[0];
      var _c2 = ctx.luckysheet_select_save[_s].column[1];

      for (var r = _r; r <= _r2; r += 1) {
        if (hasCF) {
          break;
        }

        for (var c = _c; c <= _c2; c += 1) {
          if (!_.isNil(checkCF(r, c, cf_compute))) {
            hasCF = true;
            break;
          }
        }
      }
    }

    if (hasCF) {
      return;
    }
  }

  if (selection.length > 1) {
    var isSameRow = true;
    var str_r = selection[0].row[0];
    var end_r = selection[0].row[1];
    var isSameCol = true;
    var str_c = selection[0].column[0];
    var end_c = selection[0].column[1];

    for (var _s2 = 1; _s2 < selection.length; _s2 += 1) {
      if (selection[_s2].row[0] !== str_r || selection[_s2].row[1] !== end_r) {
        isSameRow = false;
      }

      if (selection[_s2].column[0] !== str_c || selection[_s2].column[1] !== end_c) {
        isSameCol = false;
      }
    }

    if (!isSameRow && !isSameCol || selectIsOverlap(ctx)) {
      return;
    }
  }

  copy(ctx);
  ctx.luckysheet_paste_iscut = false;
}

function handleGlobalEnter(ctx, cellInput, e, canvas) {
  if ((e.altKey || e.metaKey) && ctx.luckysheetCellUpdate.length > 0) {
    var _ctx$luckysheet_selec;

    var last = (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec[ctx.luckysheet_select_save.length - 1];

    if (last && !_.isNil(last.row_focus) && !_.isNil(last.column_focus)) ;

    e.preventDefault();
  } else if (ctx.luckysheetCellUpdate.length > 0) {
    var lastCellUpdate = _.clone(ctx.luckysheetCellUpdate);

    updateCell(ctx, ctx.luckysheetCellUpdate[0], ctx.luckysheetCellUpdate[1], cellInput, undefined, canvas);
    ctx.luckysheet_select_save = [{
      row: [lastCellUpdate[0], lastCellUpdate[0]],
      column: [lastCellUpdate[1], lastCellUpdate[1]],
      row_focus: lastCellUpdate[0],
      column_focus: lastCellUpdate[1]
    }];
    moveHighlightCell(ctx, "down", 1, "rangeOfSelect");
    e.preventDefault();
  } else {
    var _ctx$luckysheet_selec2, _ctx$luckysheet_selec3;

    if (((_ctx$luckysheet_selec2 = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3.length) !== null && _ctx$luckysheet_selec2 !== void 0 ? _ctx$luckysheet_selec2 : 0) > 0) {
      var _last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
      var row_index = _last.row_focus;
      var col_index = _last.column_focus;
      ctx.luckysheetCellUpdate = [row_index, col_index];
      e.preventDefault();
    }
  }
}

function moveToEdge(sheetData, key, curr, rowDelta, colDelta, startR, endR, startC, endC, maxRow, maxCol) {
  var selectedLimit = -1;
  if (key === "ArrowUp") selectedLimit = startR - 1;else if (key === "ArrowDown") selectedLimit = endR + 1;else if (key === "ArrowLeft") selectedLimit = startC - 1;else if (key === "ArrowRight") selectedLimit = endC + 1;
  var maxRowCol = colDelta === 0 ? maxRow : maxCol;
  var r = colDelta === 0 ? selectedLimit : curr;
  var c = colDelta === 0 ? curr : selectedLimit;

  while (r >= 0 && c >= 0 && (colDelta === 0 ? r : c) < maxRowCol - 1) {
    var _sheetData$r, _sheetData$r$c, _sheetData, _sheetData2, _sheetData3, _sheetData4;

    if (!_.isNil(sheetData === null || sheetData === void 0 ? void 0 : (_sheetData$r = sheetData[r]) === null || _sheetData$r === void 0 ? void 0 : (_sheetData$r$c = _sheetData$r[c]) === null || _sheetData$r$c === void 0 ? void 0 : _sheetData$r$c.v) && (_.isNil(sheetData === null || sheetData === void 0 ? void 0 : (_sheetData = sheetData[r - rowDelta]) === null || _sheetData === void 0 ? void 0 : (_sheetData2 = _sheetData[c - colDelta]) === null || _sheetData2 === void 0 ? void 0 : _sheetData2.v) || _.isNil(sheetData === null || sheetData === void 0 ? void 0 : (_sheetData3 = sheetData[r + rowDelta]) === null || _sheetData3 === void 0 ? void 0 : (_sheetData4 = _sheetData3[c + colDelta]) === null || _sheetData4 === void 0 ? void 0 : _sheetData4.v))) {
      break;
    } else {
      r += 1 * rowDelta;
      c += 1 * colDelta;
    }
  }

  return colDelta === 0 ? r : c;
}

function handleControlPlusArrowKey(ctx, e, shiftPressed) {
  if (ctx.luckysheetCellUpdate.length > 0) return;
  var idx = getSheetIndex(ctx, ctx.currentSheetId);
  if (_.isNil(idx)) return;
  var file = ctx.luckysheetfile[idx];
  if (!file || !file.row || !file.column) return;
  var maxRow = file.row;
  var maxCol = file.column;
  var last;
  if (ctx.luckysheet_select_save && ctx.luckysheet_select_save.length > 0) last = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
  if (!last) return;
  var currR = last.row_focus;
  var currC = last.column_focus;
  if (_.isNil(currR) || _.isNil(currC)) return;
  var startR = last.row[0];
  var endR = last.row[1];
  var startC = last.column[0];
  var endC = last.column[1];
  var horizontalOffset = currC - endC !== 0 ? currC - endC : currC - startC;
  var verticalOffset = currR - endR !== 0 ? currR - endR : currR - startR;
  var sheetData = file.data;
  if (!sheetData) return;
  var selectedLimit;

  switch (e.key) {
    case "ArrowUp":
      selectedLimit = moveToEdge(sheetData, e.key, currC, -1, 0, startR, endR, startC, endC, maxRow, maxCol);

      if (shiftPressed) {
        moveHighlightRange(ctx, "down", verticalOffset, "rangeOfSelect");
        moveHighlightRange(ctx, "down", selectedLimit - currR, "rangeOfSelect");
      } else {
        moveHighlightCell(ctx, "down", selectedLimit - currR, "rangeOfSelect");
      }

      break;

    case "ArrowDown":
      selectedLimit = moveToEdge(sheetData, e.key, currC, 1, 0, startR, endR, startC, endC, maxRow, maxCol);

      if (shiftPressed) {
        moveHighlightRange(ctx, "down", verticalOffset, "rangeOfSelect");
        moveHighlightRange(ctx, "down", selectedLimit - currR, "rangeOfSelect");
      } else {
        moveHighlightCell(ctx, "down", selectedLimit - currR, "rangeOfSelect");
      }

      break;

    case "ArrowLeft":
      selectedLimit = moveToEdge(sheetData, e.key, currR, 0, -1, startR, endR, startC, endC, maxRow, maxCol);

      if (shiftPressed) {
        moveHighlightRange(ctx, "right", horizontalOffset, "rangeOfSelect");
        moveHighlightRange(ctx, "right", selectedLimit - currC, "rangeOfSelect");
      } else {
        moveHighlightCell(ctx, "right", selectedLimit - currC, "rangeOfSelect");
      }

      break;

    case "ArrowRight":
      selectedLimit = moveToEdge(sheetData, e.key, currR, 0, 1, startR, endR, startC, endC, maxRow, maxCol);

      if (shiftPressed) {
        moveHighlightRange(ctx, "right", horizontalOffset, "rangeOfSelect");
        moveHighlightRange(ctx, "right", selectedLimit - currC, "rangeOfSelect");
      } else {
        moveHighlightCell(ctx, "right", selectedLimit - currC, "rangeOfSelect");
      }

      break;
  }
}

function handleWithCtrlOrMetaKey(ctx, cache, e, cellInput, fxInput, handleUndo, handleRedo) {
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;

  if (e.shiftKey) {
    var _ctx$luckysheet_selec4;

    ctx.luckysheet_shiftpositon = _.cloneDeep((_ctx$luckysheet_selec4 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec4 === void 0 ? void 0 : _ctx$luckysheet_selec4[ctx.luckysheet_select_save.length - 1]);
    ctx.luckysheet_shiftkeydown = true;

    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
      handleControlPlusArrowKey(ctx, e, true);
    } else if (_.includes([";", '"', ":", "'"], e.key)) {
      var _ctx$luckysheet_selec5;

      var last = (_ctx$luckysheet_selec5 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec5 === void 0 ? void 0 : _ctx$luckysheet_selec5[ctx.luckysheet_select_save.length - 1];
      if (!last) return;
      var row_index = last.row_focus;
      var col_index = last.column_focus;
      updateCell(ctx, row_index, col_index, cellInput);
      ctx.luckysheetCellUpdate = [row_index, col_index];
      cache.ignoreWriteCell = true;
      var value = getNowDateTime(2);
      cellInput.innerText = value;
      handleFormulaInput(ctx, fxInput, cellInput, e.keyCode);
    } else if (e.code === "KeyZ") {
      handleRedo();
      e.stopPropagation();
      return;
    }
  } else if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
    handleControlPlusArrowKey(ctx, e, false);
  } else if (e.code === "KeyB") {
    handleBold(ctx, cellInput);
  } else if (e.code === "KeyC") {
    handleCopy(ctx);
    e.stopPropagation();
    return;
  } else if (e.code === "KeyF") {
    ctx.showSearch = true;
  } else if (e.code === "KeyH") {
    ctx.showReplace = true;
  } else if (e.code === "KeyV") {
    var _ctx$luckysheet_selec6, _ctx$luckysheet_selec7;

    if (((_ctx$luckysheet_selec6 = (_ctx$luckysheet_selec7 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec7 === void 0 ? void 0 : _ctx$luckysheet_selec7.length) !== null && _ctx$luckysheet_selec6 !== void 0 ? _ctx$luckysheet_selec6 : 0) > 1) {
      return;
    }

    selectionCache.isPasteAction = true;
    e.stopPropagation();
    return;
  } else if (e.code === "KeyX") {
    if (ctx.luckysheetPaintModelOn) {
      cancelPaintModel(ctx);
    }

    var selection = ctx.luckysheet_select_save;

    if (!selection || _.isEmpty(selection)) {
      return;
    }

    if (ctx.config.merge != null) {
      var has_PartMC = false;

      for (var s = 0; s < selection.length; s += 1) {
        var r1 = selection[s].row[0];
        var r2 = selection[s].row[1];
        var c1 = selection[s].column[0];
        var c2 = selection[s].column[1];
        has_PartMC = hasPartMC(ctx, ctx.config, r1, r2, c1, c2);

        if (has_PartMC) {
          break;
        }
      }

      if (has_PartMC) {
        return;
      }
    }

    if (selection.length > 1) {
      return;
    }

    copy(ctx);
    ctx.luckysheet_paste_iscut = true;
    e.stopPropagation();
    return;
  } else if (e.code === "KeyZ") {
    handleUndo();
    e.stopPropagation();
    return;
  } else if (e.code === "KeyA") {
    selectAll(ctx);
  }

  e.preventDefault();
}

function handleShiftWithArrowKey(ctx, e) {
  var _ctx$luckysheet_selec8;

  if (ctx.luckysheetCellUpdate.length > 0) {
    return;
  }

  ctx.luckysheet_shiftpositon = _.cloneDeep((_ctx$luckysheet_selec8 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec8 === void 0 ? void 0 : _ctx$luckysheet_selec8[ctx.luckysheet_select_save.length - 1]);
  ctx.luckysheet_shiftkeydown = true;

  switch (e.key) {
    case "ArrowUp":
      moveHighlightRange(ctx, "down", -1, "rangeOfSelect");
      break;

    case "ArrowDown":
      moveHighlightRange(ctx, "down", 1, "rangeOfSelect");
      break;

    case "ArrowLeft":
      moveHighlightRange(ctx, "right", -1, "rangeOfSelect");
      break;

    case "ArrowRight":
      moveHighlightRange(ctx, "right", 1, "rangeOfSelect");
      break;
  }

  e.preventDefault();
}

function handleArrowKey(ctx, e) {
  if (ctx.luckysheetCellUpdate.length > 0 || ctx.luckysheet_cell_selected_move || ctx.luckysheet_cell_selected_extend) {
    return;
  }

  var moveCount = hideCRCount(ctx, e.key);

  switch (e.key) {
    case "ArrowUp":
      moveHighlightCell(ctx, "down", -moveCount, "rangeOfSelect");
      break;

    case "ArrowDown":
      moveHighlightCell(ctx, "down", moveCount, "rangeOfSelect");
      break;

    case "ArrowLeft":
      moveHighlightCell(ctx, "right", -moveCount, "rangeOfSelect");
      break;

    case "ArrowRight":
      moveHighlightCell(ctx, "right", moveCount, "rangeOfSelect");
      break;
  }
}
function handleGlobalKeyDown(ctx, cellInput, fxInput, e, cache, handleUndo, handleRedo, canvas) {
  ctx.luckysheet_select_status = false;
  var kcode = e.keyCode;
  var kstr = e.key;

  if (!_.isEmpty(ctx.contextMenu) || ctx.filterContextMenu) {
    return;
  }

  if (kstr === "Escape" && !!ctx.luckysheet_selection_range) {
    ctx.luckysheet_selection_range = [];
  }

  var allowEdit = isAllowEdit(ctx);

  if (ctx.luckysheetCellUpdate.length > 0 && kstr !== "Enter" && kstr !== "Tab" && kstr !== "ArrowUp" && kstr !== "ArrowDown" && kstr !== "ArrowLeft" && kstr !== "ArrowRight") {
    return;
  }

  if (kstr === "Enter") {
    if (!allowEdit) return;
    handleGlobalEnter(ctx, cellInput, e, canvas);
  } else if (kstr === "Tab") {
    if (ctx.luckysheetCellUpdate.length > 0) {
      return;
    }

    if (e.shiftKey) {
      moveHighlightCell(ctx, "right", -1, "rangeOfSelect");
    } else {
      moveHighlightCell(ctx, "right", 1, "rangeOfSelect");
    }

    e.preventDefault();
  } else if (kstr === "F2") {
    var _ctx$luckysheet_selec9;

    if (!allowEdit) return;

    if (ctx.luckysheetCellUpdate.length > 0) {
      return;
    }

    var last = (_ctx$luckysheet_selec9 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec9 === void 0 ? void 0 : _ctx$luckysheet_selec9[ctx.luckysheet_select_save.length - 1];
    if (!last) return;
    var row_index = last.row_focus;
    var col_index = last.column_focus;
    ctx.luckysheetCellUpdate = [row_index, col_index];
    e.preventDefault();
  } else if (kstr === "F4" && ctx.luckysheetCellUpdate.length > 0) {
    e.preventDefault();
  } else if (kstr === "Escape" && ctx.luckysheetCellUpdate.length > 0) {
    cancelNormalSelected(ctx);
    moveHighlightCell(ctx, "down", 0, "rangeOfSelect");
    e.preventDefault();
  } else {
    if (e.ctrlKey || e.metaKey) {
      handleWithCtrlOrMetaKey(ctx, cache, e, cellInput, fxInput, handleUndo, handleRedo);
      return;
    }

    if (e.shiftKey && (kstr === "ArrowUp" || kstr === "ArrowDown" || kstr === "ArrowLeft" || kstr === "ArrowRight")) {
      handleShiftWithArrowKey(ctx, e);
    } else if (kstr === "Escape") {
      ctx.contextMenu = {};
    } else if (kstr === "Delete" || kstr === "Backspace") {
      if (!allowEdit) return;

      if (ctx.activeImg != null) {
        removeActiveImage(ctx);
      } else {
        deleteSelectedCellText(ctx);
      }

      jfrefreshgrid(ctx, null, undefined);
      e.preventDefault();
    } else if (kstr === "ArrowUp" || kstr === "ArrowDown" || kstr === "ArrowLeft" || kstr === "ArrowRight") {
      handleArrowKey(ctx, e);
    } else if (!(kcode >= 112 && kcode <= 123 || kcode <= 46 || kcode === 144 || kcode === 108 || e.ctrlKey || e.altKey || e.shiftKey && (kcode === 37 || kcode === 38 || kcode === 39 || kcode === 40)) || kcode === 8 || kcode === 32 || kcode === 46 || kcode === 0 || e.ctrlKey && kcode === 86) {
      if (!allowEdit) return;

      if (String.fromCharCode(kcode) != null && !_.isEmpty(ctx.luckysheet_select_save) && kstr !== "CapsLock" && kstr !== "Win" && kcode !== 18) {
        var _last2 = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1];
        var _row_index = _last2.row_focus;
        var _col_index = _last2.column_focus;
        ctx.luckysheetCellUpdate = [_row_index, _col_index];
        cache.overwriteCell = true;
        handleFormulaInput(ctx, fxInput, cellInput, kcode);
      }
    }
  }

  if (cellInput !== document.activeElement) {
    cellInput === null || cellInput === void 0 ? void 0 : cellInput.focus();
  }

  e.stopPropagation();
}

var mouseWheelUniqueTimeout;
var scrollLockTimeout;
function handleGlobalWheel(ctx, e, cache, scrollbarX, scrollbarY) {
  var _cache$searchDialog;

  if (((_cache$searchDialog = cache.searchDialog) === null || _cache$searchDialog === void 0 ? void 0 : _cache$searchDialog.mouseEnter) && ctx.showSearch && ctx.showReplace) return;
  if (ctx.filterContextMenu != null) return;
  var scrollLeft = scrollbarX.scrollLeft;
  var scrollTop = scrollbarY.scrollTop;
  var visibledatacolumn_c = ctx.visibledatacolumn;
  var visibledatarow_c = ctx.visibledatarow;
  clearTimeout(mouseWheelUniqueTimeout);
  clearTimeout(scrollLockTimeout);

  if (cache.visibleColumnsUnique != null) {
    visibledatacolumn_c = cache.visibleColumnsUnique;
  } else {
    visibledatacolumn_c = _.uniq(visibledatacolumn_c);
    cache.visibleColumnsUnique = visibledatacolumn_c;
  }

  if (cache.visibleRowsUnique != null) {
    visibledatarow_c = cache.visibleRowsUnique;
  } else {
    visibledatarow_c = _.uniq(visibledatarow_c);
    cache.visibleRowsUnique = visibledatarow_c;
  }

  var row_st = _.sortedIndex(visibledatarow_c, scrollTop) + 1;
  var rowscroll = 0;
  var scrollNum = 1;

  if (e.deltaY !== 0 && !cache.verticalScrollLock) {
    cache.horizontalScrollLock = true;
    var row_ed;
    var step = Math.round(scrollNum / ctx.zoomRatio);
    step = step < 1 ? 1 : step;

    if (e.deltaY > 0) {
      row_ed = row_st + step;

      if (row_ed >= visibledatarow_c.length) {
        row_ed = visibledatarow_c.length - 1;
      }
    } else {
      row_ed = row_st - step;

      if (row_ed < 0) {
        row_ed = 0;
      }
    }

    rowscroll = row_ed === 0 ? 0 : visibledatarow_c[row_ed - 1];
    scrollbarY.scrollTop = rowscroll;
  } else if (e.deltaX !== 0 && !cache.horizontalScrollLock) {
    cache.verticalScrollLock = true;

    if (e.deltaX > 0) {
      scrollLeft += 20 * ctx.zoomRatio;
    } else {
      scrollLeft -= 20 * ctx.zoomRatio;
    }

    scrollbarX.scrollLeft = scrollLeft;
  }

  mouseWheelUniqueTimeout = setTimeout(function () {
    delete cache.visibleColumnsUnique;
    delete cache.visibleRowsUnique;
  }, 500);
  scrollLockTimeout = setTimeout(function () {
    delete cache.verticalScrollLock;
    delete cache.horizontalScrollLock;
  }, 50);
  e.preventDefault();
}
function fixPositionOnFrozenCells(freeze, x, y, mouseX, mouseY) {
  var _freeze$vertical, _freeze$horizontal;

  var inHorizontalFreeze = false;
  var inVerticalFreeze = false;
  if (!freeze) return {
    x: x,
    y: y,
    inHorizontalFreeze: inHorizontalFreeze,
    inVerticalFreeze: inVerticalFreeze
  };
  var freezenverticaldata = freeze === null || freeze === void 0 ? void 0 : (_freeze$vertical = freeze.vertical) === null || _freeze$vertical === void 0 ? void 0 : _freeze$vertical.freezenverticaldata;
  var freezenhorizontaldata = freeze === null || freeze === void 0 ? void 0 : (_freeze$horizontal = freeze.horizontal) === null || _freeze$horizontal === void 0 ? void 0 : _freeze$horizontal.freezenhorizontaldata;

  if (freezenverticaldata != null && mouseX < freezenverticaldata[0] - freezenverticaldata[2]) {
    x = mouseX + freezenverticaldata[2];
    inVerticalFreeze = true;
  }

  if (freezenhorizontaldata != null && mouseY < freezenhorizontaldata[0] - freezenhorizontaldata[2]) {
    y = mouseY + freezenhorizontaldata[2];
    inHorizontalFreeze = true;
  }

  return {
    x: x,
    y: y,
    inHorizontalFreeze: inHorizontalFreeze,
    inVerticalFreeze: inVerticalFreeze
  };
}
function handleCellAreaMouseDown(ctx, globalCache, e, cellInput, container, fxInput, canvas) {
  var _globalCache$freezen, _ctx$hooks$beforeCell, _ctx$hooks, _flowdata$row_index;

  ctx.contextMenu = {};
  ctx.filterContextMenu = undefined;
  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  var rect = container.getBoundingClientRect();
  var mouseX = e.pageX - rect.left - window.scrollX;
  var mouseY = e.pageY - rect.top - window.scrollY;

  var _x = mouseX + ctx.scrollLeft;

  var _y = mouseY + ctx.scrollTop;

  if (_x >= rect.width + ctx.scrollLeft || _y >= rect.height + ctx.scrollTop) {
    return;
  }

  var freeze = (_globalCache$freezen = globalCache.freezen) === null || _globalCache$freezen === void 0 ? void 0 : _globalCache$freezen[ctx.currentSheetId];

  var _fixPositionOnFrozenC = fixPositionOnFrozenCells(freeze, _x, _y, mouseX, mouseY),
      x = _fixPositionOnFrozenC.x,
      y = _fixPositionOnFrozenC.y,
      inHorizontalFreeze = _fixPositionOnFrozenC.inHorizontalFreeze,
      inVerticalFreeze = _fixPositionOnFrozenC.inVerticalFreeze;

  var row_location = rowLocation(y, ctx.visibledatarow);
  var row = row_location[1];
  var row_pre = row_location[0];
  var row_index = row_location[2];
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col = col_location[1];
  var col_pre = col_location[0];
  var col_index = col_location[2];
  var row_index_ed = row_index;
  var col_index_ed = col_index;
  var margeset = mergeBorder(ctx, flowdata, row_index, col_index);

  if (margeset) {
    var _margeset$row = _slicedToArray(margeset.row, 4);

    row_pre = _margeset$row[0];
    row = _margeset$row[1];
    row_index = _margeset$row[2];
    row_index_ed = _margeset$row[3];

    var _margeset$column = _slicedToArray(margeset.column, 4);

    col_pre = _margeset$column[0];
    col = _margeset$column[1];
    col_index = _margeset$column[2];
    col_index_ed = _margeset$column[3];
  }

  showLinkCard(ctx, row_index, col_index, false, true);

  if (((_ctx$hooks$beforeCell = (_ctx$hooks = ctx.hooks).beforeCellMouseDown) === null || _ctx$hooks$beforeCell === void 0 ? void 0 : _ctx$hooks$beforeCell.call(_ctx$hooks, (_flowdata$row_index = flowdata[row_index]) === null || _flowdata$row_index === void 0 ? void 0 : _flowdata$row_index[col_index], {
    row: row_index,
    column: col_index,
    startRow: row_pre,
    startColumn: col_pre,
    endRow: row,
    endColumn: col
  })) === false) {
    return;
  }

  cellFocus(ctx, row_index, col_index, true);

  if (!inHorizontalFreeze && !inVerticalFreeze) {
    if (col_pre < ctx.scrollLeft) {
      ctx.scrollLeft = col_pre;
    }

    if (row_pre < ctx.scrollTop) {
      ctx.scrollTop = row_pre;
    }
  }

  if (e.button === 2) {
    var isInSelection = _.some(ctx.luckysheet_select_save, function (obj_s) {
      return obj_s.row != null && row_index >= obj_s.row[0] && row_index <= obj_s.row[1] && col_index >= obj_s.column[0] && col_index <= obj_s.column[1];
    });

    if (isInSelection) return;
  }

  ctx.luckysheet_scroll_status = true;

  if (ctx.luckysheetCellUpdate.length > 0) {
    if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
      var _$last;

      var rowseleted = [row_index, row_index_ed];
      var columnseleted = [col_index, col_index_ed];
      var left = col_pre;
      var width = col - col_pre - 1;
      var top = row_pre;
      var height = row - row_pre - 1;

      if (e.shiftKey) {
        var last = ctx.formulaCache.func_selectedrange;
        top = 0;
        height = 0;
        rowseleted = [];
        if (last == null || last.top == null || last.height == null || last.row_focus == null || last.left == null || last.width == null) return;

        if (last.top > row_pre) {
          top = row_pre;
          height = last.top + last.height - row_pre;

          if (last.row[1] > last.row_focus) {
            last.row[1] = last.row_focus;
          }

          rowseleted = [row_index, last.row[1]];
        } else if (last.top === row_pre) {
          top = row_pre;
          height = last.top + last.height - row_pre;
          rowseleted = [row_index, last.row[0]];
        } else {
          top = last.top;
          height = row - last.top - 1;

          if (last.row[0] < last.row_focus) {
            last.row[0] = last.row_focus;
          }

          rowseleted = [last.row[0], row_index];
        }

        left = 0;
        width = 0;
        columnseleted = [];

        if (last.left > col_pre) {
          left = col_pre;
          width = last.left + last.width - col_pre;
          if (last.column == null || last.column_focus == null) return;

          if (last.column[1] > last.column_focus) {
            last.column[1] = last.column_focus;
          }

          columnseleted = [col_index, last.column[1]];
        } else if (last.left === col_pre) {
          left = col_pre;
          width = last.left + last.width - col_pre;
          columnseleted = [col_index, last.column[0]];
        } else {
          left = last.left;
          width = col - last.left - 1;
          if (last.column == null || last.column_focus == null) return;

          if (last.column[0] < last.column_focus) {
            last.column[0] = last.column_focus;
          }

          columnseleted = [last.column[0], col_index];
        }

        var changeparam = mergeMoveMain(ctx, columnseleted, rowseleted, last, top, height, left, width);

        if (changeparam != null) {
          var _changeparam = _slicedToArray(changeparam, 6);

          columnseleted = _changeparam[0];
          rowseleted = _changeparam[1];
          top = _changeparam[2];
          height = _changeparam[3];
          left = _changeparam[4];
          width = _changeparam[5];
        }

        last.row = rowseleted;
        last.column = columnseleted;
        last.left_move = left;
        last.width_move = width;
        last.top_move = top;
        last.height_move = height;
        ctx.formulaCache.func_selectedrange = last;
      } else if (e.ctrlKey && ((_$last = _.last(cellInput.querySelectorAll("span"))) === null || _$last === void 0 ? void 0 : _$last.innerText) !== ",") {
        var vText = cellInput.innerText;

        if (vText[vText.length - 1] === ")") {
          vText = vText.substring(0, vText.length - 1);
        }

        if (vText.length > 0) {
          var lastWord = vText.substring(vText.length - 1, 1);

          if (lastWord !== "," && lastWord !== "=" && lastWord !== "(") {
            vText += ",";
          }
        }

        if (vText.length > 0 && vText.substring(0, 1) === "=") {
          vText = functionHTMLGenerate(vText);

          if (window.getSelection) {
            var _currSelection$anchor, _currSelection$anchor2, _currSelection$anchor3, _currSelection$anchor4;

            var currSelection = window.getSelection();
            if (currSelection == null) return;
            ctx.formulaCache.functionRangeIndex = [_.indexOf((_currSelection$anchor = currSelection.anchorNode) === null || _currSelection$anchor === void 0 ? void 0 : (_currSelection$anchor2 = _currSelection$anchor.parentNode) === null || _currSelection$anchor2 === void 0 ? void 0 : (_currSelection$anchor3 = _currSelection$anchor2.parentNode) === null || _currSelection$anchor3 === void 0 ? void 0 : _currSelection$anchor3.childNodes, (_currSelection$anchor4 = currSelection.anchorNode) === null || _currSelection$anchor4 === void 0 ? void 0 : _currSelection$anchor4.parentNode), currSelection.anchorOffset];
          } else {
            var textRange = document.selection.createRange();
            ctx.formulaCache.functionRangeIndex = textRange;
          }

          cellInput.innerHTML = vText;
          cancelFunctionrangeSelected(ctx);
          createRangeHightlight(ctx, vText);
        }

        ctx.formulaCache.rangestart = false;
        ctx.formulaCache.rangedrag_column_start = false;
        ctx.formulaCache.rangedrag_row_start = false;
        if (fxInput) fxInput.innerHTML = vText;
        rangeHightlightselected(ctx, cellInput);
        israngeseleciton(ctx);
        ctx.formulaCache.func_selectedrange = {
          left: left,
          width: width,
          top: top,
          height: height,
          left_move: left,
          width_move: width,
          top_move: top,
          height_move: height,
          row: rowseleted,
          column: columnseleted,
          row_focus: row_index,
          column_focus: col_index
        };
      } else {
        ctx.formulaCache.func_selectedrange = {
          left: left,
          width: width,
          top: top,
          height: height,
          left_move: left,
          width_move: width,
          top_move: top,
          height_move: height,
          row: rowseleted,
          column: columnseleted,
          row_focus: row_index,
          column_focus: col_index
        };
      }

      rangeSetValue(ctx, cellInput, {
        row: rowseleted,
        column: columnseleted
      }, fxInput);
      ctx.formulaCache.rangestart = true;
      ctx.formulaCache.rangedrag_column_start = false;
      ctx.formulaCache.rangedrag_row_start = false;
      ctx.formulaCache.selectingRangeIndex = ctx.formulaCache.rangechangeindex;

      if (ctx.formulaCache.rangechangeindex > ctx.formulaRangeHighlight.length) {
        createRangeHightlight(ctx, cellInput.innerHTML, ctx.formulaCache.rangechangeindex);
      }

      createFormulaRangeSelect(ctx, {
        rangeIndex: ctx.formulaCache.rangechangeindex || 0,
        left: left,
        top: top,
        width: width,
        height: height
      });
      e.preventDefault();
      return;
    }

    updateCell(ctx, ctx.luckysheetCellUpdate[0], ctx.luckysheetCellUpdate[1], cellInput, undefined, canvas);
    ctx.luckysheet_select_status = true;
  }

  if (checkProtectionSelectLockedOrUnLockedCells(ctx, row_index, col_index, ctx.currentSheetId)) {
    ctx.luckysheet_select_status = true;
  }

  if (ctx.luckysheet_select_status) {
    if (e.shiftKey) {
      var _ctx$luckysheet_selec;

      var _last = (_ctx$luckysheet_selec = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec === void 0 ? void 0 : _ctx$luckysheet_selec[ctx.luckysheet_select_save.length - 1];

      if (_last && _last.top != null && _last.left != null && _last.height != null && _last.width != null && _last.row_focus != null && _last.column_focus != null) {
        var _top2 = 0;
        var _height2 = 0;
        var _rowseleted2 = [];

        if (_last.top > row_pre) {
          _top2 = row_pre;
          _height2 = _last.top + _last.height - row_pre;

          if (_last.row[1] > _last.row_focus) {
            _last.row[1] = _last.row_focus;
          }

          _rowseleted2 = [row_index, _last.row[1]];
        } else if (_last.top === row_pre) {
          _top2 = row_pre;
          _height2 = _last.top + _last.height - row_pre;
          _rowseleted2 = [row_index, _last.row[0]];
        } else {
          _top2 = _last.top;
          _height2 = row - _last.top - 1;

          if (_last.row[0] < _last.row_focus) {
            _last.row[0] = _last.row_focus;
          }

          _rowseleted2 = [_last.row[0], row_index];
        }

        var _left2 = 0;
        var _width2 = 0;
        var _columnseleted2 = [];

        if (_last.left > col_pre) {
          _left2 = col_pre;
          _width2 = _last.left + _last.width - col_pre;

          if (_last.column[1] > _last.column_focus) {
            _last.column[1] = _last.column_focus;
          }

          _columnseleted2 = [col_index, _last.column[1]];
        } else if (_last.left === col_pre) {
          _left2 = col_pre;
          _width2 = _last.left + _last.width - col_pre;
          _columnseleted2 = [col_index, _last.column[0]];
        } else {
          _left2 = _last.left;
          _width2 = col - _last.left - 1;

          if (_last.column[0] < _last.column_focus) {
            _last.column[0] = _last.column_focus;
          }

          _columnseleted2 = [_last.column[0], col_index];
        }

        var _changeparam2 = mergeMoveMain(ctx, _columnseleted2, _rowseleted2, _last, _top2, _height2, _left2, _width2);

        if (_changeparam2 != null) {
          var _changeparam3 = _slicedToArray(_changeparam2, 6);

          _columnseleted2 = _changeparam3[0];
          _rowseleted2 = _changeparam3[1];
          _top2 = _changeparam3[2];
          _height2 = _changeparam3[3];
          _left2 = _changeparam3[4];
          _width2 = _changeparam3[5];
        }

        _last.row = _rowseleted2;
        _last.column = _columnseleted2;
        _last.left_move = _left2;
        _last.width_move = _width2;
        _last.top_move = _top2;
        _last.height_move = _height2;
        ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1] = _last;
      }
    } else if (e.ctrlKey || e.metaKey) {
      var _ctx$luckysheet_selec2;

      (_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2.push({
        left: col_pre,
        width: col - col_pre - 1,
        top: row_pre,
        height: row - row_pre - 1,
        left_move: col_pre,
        width_move: col - col_pre - 1,
        top_move: row_pre,
        height_move: row - row_pre - 1,
        row: [row_index, row_index_ed],
        column: [col_index, col_index_ed],
        row_focus: row_index,
        column_focus: col_index
      });
    } else {
      ctx.luckysheet_select_save = [{
        left: col_pre,
        width: col - col_pre - 1,
        top: row_pre,
        height: row - row_pre - 1,
        left_move: col_pre,
        width_move: col - col_pre - 1,
        top_move: row_pre,
        height_move: row - row_pre - 1,
        row: [row_index, row_index_ed],
        column: [col_index, col_index_ed],
        row_focus: row_index,
        column_focus: col_index
      }];
    }
  }

  ctx.luckysheet_select_save = normalizeSelection(ctx, ctx.luckysheet_select_save);

  if (ctx.hooks.afterCellMouseDown) {
    setTimeout(function () {
      var _ctx$hooks$afterCellM, _ctx$hooks2, _flowdata$row_index2;

      (_ctx$hooks$afterCellM = (_ctx$hooks2 = ctx.hooks).afterCellMouseDown) === null || _ctx$hooks$afterCellM === void 0 ? void 0 : _ctx$hooks$afterCellM.call(_ctx$hooks2, (_flowdata$row_index2 = flowdata[row_index]) === null || _flowdata$row_index2 === void 0 ? void 0 : _flowdata$row_index2[col_index], {
        row: row_index,
        column: col_index,
        startRow: row_pre,
        startColumn: col_pre,
        endRow: row,
        endColumn: col
      });
    });
  }
}
function handleCellAreaDoubleClick(ctx, globalCache, settings, e, container) {
  var _globalCache$freezen2;

  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;

  if (ctx.luckysheetCellUpdate.length > 0 && ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
    return;
  }

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  var rect = container.getBoundingClientRect();
  var mouseX = e.pageX - rect.left;
  var mouseY = e.pageY - rect.top;

  var _x = mouseX + ctx.scrollLeft;

  var _y = mouseY + ctx.scrollTop;

  var freeze = (_globalCache$freezen2 = globalCache.freezen) === null || _globalCache$freezen2 === void 0 ? void 0 : _globalCache$freezen2[ctx.currentSheetId];

  var _fixPositionOnFrozenC2 = fixPositionOnFrozenCells(freeze, _x, _y, mouseX, mouseY),
      x = _fixPositionOnFrozenC2.x,
      y = _fixPositionOnFrozenC2.y;

  var row_location = rowLocation(y, ctx.visibledatarow);
  var row_index = row_location[2];
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col_index = col_location[2];
  var index = getSheetIndex(ctx, ctx.currentSheetId);
  var dataVerification = ctx.luckysheetfile[index].dataVerification;

  if (dataVerification) {
    var item = dataVerification["".concat(row_index, "_").concat(col_index)];
    if (item && item.type === "checkbox") return;
  }

  var margeset = mergeBorder(ctx, flowdata, row_index, col_index);

  if (margeset) {
    var _margeset$row2 = _slicedToArray(margeset.row, 3);

    row_index = _margeset$row2[2];

    var _margeset$column2 = _slicedToArray(margeset.column, 3);

    col_index = _margeset$column2[2];
  }

  var _ctx$luckysheet_selec3 = ctx.luckysheet_select_save[0],
      column_focus = _ctx$luckysheet_selec3.column_focus,
      row_focus = _ctx$luckysheet_selec3.row_focus;

  if (!_.isNil(column_focus) && !_.isNil(row_focus) && (column_focus !== col_index || row_focus !== row_index)) {
    row_index = row_focus;
    col_index = column_focus;
  }

  luckysheetUpdateCell(ctx, row_index, col_index);
}
function handleContextMenu(ctx, settings, e, workbookContainer, container, area) {
  if (!ctx.allowEdit) {
    return;
  }

  var flowdata = getFlowdata(ctx);
  if (!flowdata) return;
  var workbookRect = workbookContainer.getBoundingClientRect();
  var cellContextMenu = settings.cellContextMenu;

  if (_.isEmpty(cellContextMenu)) {
    return;
  }

  var x = e.pageX - workbookRect.left;
  var y = e.pageY - workbookRect.top;
  ctx.contextMenu = {
    x: x,
    y: y,
    pageX: e.pageX,
    pageY: e.pageY
  };
  e.preventDefault();

  if (area === "cell") {
    var _ctx$getRefs$globalCa, _flowdata$row_index$c2;

    _.set(ctx.contextMenu, "headerMenu", undefined);

    var rect = container.getBoundingClientRect();
    var mouseX = e.pageX - rect.left - window.scrollX;
    var mouseY = e.pageY - rect.top - window.scrollY;

    var _selected_x = mouseX + ctx.scrollLeft;

    var _selected_y = mouseY + ctx.scrollTop;

    var _fixPositionOnFrozenC3 = fixPositionOnFrozenCells((_ctx$getRefs$globalCa = ctx.getRefs().globalCache.freezen) === null || _ctx$getRefs$globalCa === void 0 ? void 0 : _ctx$getRefs$globalCa[ctx.currentSheetId], _selected_x, _selected_y, mouseX, mouseY),
        selected_x = _fixPositionOnFrozenC3.x,
        selected_y = _fixPositionOnFrozenC3.y;

    var row_location = rowLocation(selected_y, ctx.visibledatarow);
    var row = row_location[1];
    var row_pre = row_location[0];
    var row_index = row_location[2];
    var col_location = colLocation(selected_x, ctx.visibledatacolumn);
    var col = col_location[1];
    var col_pre = col_location[0];
    var col_index = col_location[2];

    var isInSelection = _.some(ctx.luckysheet_select_save, function (obj_s) {
      return obj_s.row != null && row_index >= obj_s.row[0] && row_index <= obj_s.row[1] && col_index >= obj_s.column[0] && col_index <= obj_s.column[1];
    });

    if (!isInSelection && (e.metaKey || e.ctrlKey)) {
      var _flowdata$row_index$c, _ctx$luckysheet_selec5;

      if ((_flowdata$row_index$c = flowdata[row_index][col_index]) === null || _flowdata$row_index$c === void 0 ? void 0 : _flowdata$row_index$c.mc) {
        var changeparam = mergeMoveMain(ctx, [col_index, col_index], [row_index, row_index], {
          row_focus: row_index,
          column_focus: col_index
        }, row_pre, row, col_pre, col);

        if (changeparam != null) {
          var _ctx$luckysheet_selec4;

          var _changeparam4 = _slicedToArray(changeparam, 6),
              columnseleted = _changeparam4[0],
              rowseleted = _changeparam4[1],
              top = _changeparam4[2],
              height = _changeparam4[3],
              left = _changeparam4[4],
              width = _changeparam4[5];

          (_ctx$luckysheet_selec4 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec4 === void 0 ? void 0 : _ctx$luckysheet_selec4.push({
            left: left,
            width: width - 1,
            top: top,
            height: height - 1,
            left_move: left,
            width_move: width,
            top_move: top,
            height_move: height,
            row: rowseleted,
            column: columnseleted,
            row_focus: rowseleted[0],
            column_focus: columnseleted[0]
          });
          return;
        }
      }

      (_ctx$luckysheet_selec5 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec5 === void 0 ? void 0 : _ctx$luckysheet_selec5.push({
        left: col_pre,
        width: col - col_pre - 1,
        top: row_pre,
        height: row - row_pre - 1,
        left_move: col_pre,
        width_move: col - col_pre - 1,
        top_move: row_pre,
        height_move: row - row_pre - 1,
        row: [row_index, row_index],
        column: [col_index, col_index],
        row_focus: row_index,
        column_focus: col_index
      });
      return;
    }

    if (isInSelection) return;
    var row_index_ed = row_index;
    var col_index_ed = col_index;

    if ((_flowdata$row_index$c2 = flowdata[row_index][col_index]) === null || _flowdata$row_index$c2 === void 0 ? void 0 : _flowdata$row_index$c2.mc) {
      var _changeparam5 = mergeMoveMain(ctx, [col_index, col_index], [row_index, row_index], {
        row_focus: row_index,
        column_focus: col_index
      }, row_pre, row, col_pre, col);

      if (_changeparam5 != null) {
        var _changeparam6 = _slicedToArray(_changeparam5, 6),
            _columnseleted3 = _changeparam6[0],
            _rowseleted3 = _changeparam6[1],
            _top3 = _changeparam6[2],
            _height3 = _changeparam6[3],
            _left3 = _changeparam6[4],
            _width3 = _changeparam6[5];

        ctx.luckysheet_select_save = [{
          left: _left3,
          width: _width3 - 1,
          top: _top3,
          height: _height3 - 1,
          left_move: _left3,
          width_move: _width3,
          top_move: _top3,
          height_move: _height3,
          row: _rowseleted3,
          column: _columnseleted3,
          row_focus: _rowseleted3[0],
          column_focus: _columnseleted3[0]
        }];
        return;
      }
    }

    ctx.luckysheet_select_save = [{
      left: col_pre,
      width: col - col_pre - 1,
      top: row_pre,
      height: row - row_pre - 1,
      left_move: col_pre,
      width_move: col - col_pre - 1,
      top_move: row_pre,
      height_move: row - row_pre - 1,
      row: [row_index, row_index_ed],
      column: [col_index, col_index_ed],
      row_focus: row_index,
      column_focus: col_index
    }];
  } else if (area === "rowHeader") {
    var _ctx$getRefs$globalCa2;

    _.set(ctx.contextMenu, "headerMenu", "row");

    var _rect = container.getBoundingClientRect();

    var _mouseY = e.pageY - _rect.top - window.scrollY;

    var _selected_y2 = _mouseY + ctx.scrollTop;

    var _fixPositionOnFrozenC4 = fixPositionOnFrozenCells((_ctx$getRefs$globalCa2 = ctx.getRefs().globalCache.freezen) === null || _ctx$getRefs$globalCa2 === void 0 ? void 0 : _ctx$getRefs$globalCa2[ctx.currentSheetId], 0, _selected_y2, 0, _mouseY),
        _selected_y3 = _fixPositionOnFrozenC4.y;

    var _row_location = rowLocation(_selected_y3, ctx.visibledatarow);

    var _row = _row_location[1];
    var _row_pre = _row_location[0];
    var _row_index = _row_location[2];

    var _isInSelection = _.some(ctx.luckysheet_select_save, function (obj_s) {
      return obj_s.row != null && _row_index >= obj_s.row[0] && _row_index <= obj_s.row[1] && !obj_s.column_select;
    });

    if (_isInSelection) return;

    var _col_index = ctx.visibledatacolumn.length - 1;

    var _col = ctx.visibledatacolumn[_col_index];
    var _col_pre = 0;
    var _top4 = _row_pre;

    var _height4 = _row - _row_pre - 1;

    var _rowseleted4 = [_row_index, _row_index];
    ctx.luckysheet_select_save = [];
    ctx.luckysheet_select_save.push({
      left: colLocationByIndex(0, ctx.visibledatacolumn)[0],
      width: colLocationByIndex(0, ctx.visibledatacolumn)[1] - colLocationByIndex(0, ctx.visibledatacolumn)[0] - 1,
      top: _top4,
      height: _height4,
      left_move: _col_pre,
      width_move: _col - _col_pre - 1,
      top_move: _top4,
      height_move: _height4,
      row: _rowseleted4,
      column: [0, _col_index],
      row_focus: _row_index,
      column_focus: 0,
      row_select: true
    });
  } else if (area === "columnHeader") {
    var _ctx$getRefs$globalCa3;

    _.set(ctx.contextMenu, "headerMenu", "column");

    var _rect2 = container.getBoundingClientRect();

    var _mouseX = e.pageX - _rect2.left - window.scrollX;

    var _selected_x2 = _mouseX + ctx.scrollLeft;

    var _fixPositionOnFrozenC5 = fixPositionOnFrozenCells((_ctx$getRefs$globalCa3 = ctx.getRefs().globalCache.freezen) === null || _ctx$getRefs$globalCa3 === void 0 ? void 0 : _ctx$getRefs$globalCa3[ctx.currentSheetId], _selected_x2, 0, _mouseX, 0),
        _selected_x3 = _fixPositionOnFrozenC5.x;

    var _row_index2 = ctx.visibledatarow.length - 1;

    var _row2 = ctx.visibledatarow[_row_index2];
    var _row_pre2 = 0;

    var _col_location = colLocation(_selected_x3, ctx.visibledatacolumn);

    var _col2 = _col_location[1];
    var _col_pre2 = _col_location[0];
    var _col_index2 = _col_location[2];

    var _isInSelection2 = _.some(ctx.luckysheet_select_save, function (obj_s) {
      return obj_s.row != null && _col_index2 >= obj_s.column[0] && _col_index2 <= obj_s.column[1] && !obj_s.row_select;
    });

    if (_isInSelection2) return;
    var _left4 = _col_pre2;

    var _width4 = _col2 - _col_pre2 - 1;

    var _columnseleted4 = [_col_index2, _col_index2];
    ctx.luckysheet_select_save = [];
    ctx.luckysheet_select_save.push({
      left: _left4,
      width: _width4,
      top: rowLocationByIndex(0, ctx.visibledatarow)[0],
      height: rowLocationByIndex(0, ctx.visibledatarow)[1] - rowLocationByIndex(0, ctx.visibledatarow)[0] - 1,
      left_move: _left4,
      width_move: _width4,
      top_move: _row_pre2,
      height_move: _row2 - _row_pre2 - 1,
      row: [0, _row_index2],
      column: _columnseleted4,
      row_focus: 0,
      column_focus: _col_index2,
      column_select: true
    });
  }
}

function mouseRender(ctx, globalCache, e, cellInput, scrollX, scrollY, container, fxInput) {
  var _ctx$rangeDialog;

  var rect = container.getBoundingClientRect();

  if (ctx.luckysheet_scroll_status && !ctx.luckysheet_cols_change_size && !ctx.luckysheet_rows_change_size) {
    var left = ctx.scrollLeft;
    var top = ctx.scrollTop;
    var x = e.pageX - rect.left - window.scrollX;
    var y = e.pageY - rect.top - window.scrollY;
    var winH = rect.height - 20 * ctx.zoomRatio;
    var winW = rect.width - 60 * ctx.zoomRatio;

    if (y < 0 || y > winH) {
      var stop;

      if (y < 0) {
        stop = top + y / 2;
      } else {
        stop = top + (y - winH) / 2;
      }

      scrollY.scrollTop = stop;
    }

    if (x < 0 || x > winW) {
      var sleft;

      if (x < 0) {
        sleft = left + x / 2;
      } else {
        sleft = left + (x - winW) / 2;
      }

      scrollX.scrollLeft = sleft;
    }
  }

  if ((_ctx$rangeDialog = ctx.rangeDialog) === null || _ctx$rangeDialog === void 0 ? void 0 : _ctx$rangeDialog.singleSelect) {
    return;
  }

  if (ctx.luckysheet_select_status) {
    var _globalCache$freezen3, _ctx$luckysheet_selec6, _globalCache$freezen4;

    var mouseX = e.pageX - rect.left - window.scrollX;
    var mouseY = e.pageY - rect.top - window.scrollY;

    var _x = mouseX - ctx.rowHeaderWidth + ctx.scrollLeft;

    var _y = mouseY - ctx.columnHeaderHeight + ctx.scrollTop;

    var freeze = (_globalCache$freezen3 = globalCache.freezen) === null || _globalCache$freezen3 === void 0 ? void 0 : _globalCache$freezen3[ctx.currentSheetId];

    var _fixPositionOnFrozenC6 = fixPositionOnFrozenCells(freeze, _x, _y, mouseX - ctx.rowHeaderWidth, mouseY - ctx.columnHeaderHeight),
        _x2 = _fixPositionOnFrozenC6.x,
        _y2 = _fixPositionOnFrozenC6.y;

    var row_location = rowLocation(_y2, ctx.visibledatarow);
    var row = row_location[1];
    var row_pre = row_location[0];
    var row_index = row_location[2];
    var col_location = colLocation(_x2, ctx.visibledatacolumn);
    var col = col_location[1];
    var col_pre = col_location[0];
    var col_index = col_location[2];

    if (!checkProtectionSelectLockedOrUnLockedCells(ctx, row_index, col_index, ctx.currentSheetId)) {
      ctx.luckysheet_select_status = false;
      return;
    }

    var last = _.cloneDeep((_ctx$luckysheet_selec6 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec6 === void 0 ? void 0 : _ctx$luckysheet_selec6[ctx.luckysheet_select_save.length - 1]);

    if (!last || _.isNil(last.left) || _.isNil(last.top) || _.isNil(last.height) || _.isNil(last.width) || _.isNil(last.row_focus) || _.isNil(last.column_focus)) {
      return;
    }

    var _top5 = 0;
    var height = 0;
    var rowseleted = [];

    if (last.top > row_pre) {
      _top5 = row_pre;
      height = last.top + last.height - row_pre;

      if (last.row[1] > last.row_focus) {
        last.row[1] = last.row_focus;
      }

      rowseleted = [row_index, last.row[1]];
    } else if (last.top === row_pre) {
      _top5 = row_pre;
      height = last.top + last.height - row_pre;
      rowseleted = [row_index, last.row[0]];
    } else {
      _top5 = last.top;
      height = row - last.top - 1;

      if (last.row[0] < last.row_focus) {
        last.row[0] = last.row_focus;
      }

      rowseleted = [last.row[0], row_index];
    }

    var _left5 = 0;
    var width = 0;
    var columnseleted = [];

    if (last.left > col_pre) {
      _left5 = col_pre;
      width = last.left + last.width - col_pre;

      if (last.column[1] > last.column_focus) {
        last.column[1] = last.column_focus;
      }

      columnseleted = [col_index, last.column[1]];
    } else if (last.left === col_pre) {
      _left5 = col_pre;
      width = last.left + last.width - col_pre;
      columnseleted = [col_index, last.column[0]];
    } else {
      _left5 = last.left;
      width = col - last.left - 1;

      if (last.column[0] < last.column_focus) {
        last.column[0] = last.column_focus;
      }

      columnseleted = [last.column[0], col_index];
    }

    var changeparam = mergeMoveMain(ctx, columnseleted, rowseleted, last, _top5, height, _left5, width);

    if (changeparam != null) {
      var _changeparam7 = _slicedToArray(changeparam, 6);

      columnseleted = _changeparam7[0];
      rowseleted = _changeparam7[1];
      _top5 = _changeparam7[2];
      height = _changeparam7[3];
      _left5 = _changeparam7[4];
      width = _changeparam7[5];
    }

    last.row = rowseleted;
    last.column = columnseleted;
    last.left_move = _left5;
    last.width_move = width;
    last.top_move = _top5;
    last.height_move = height;
    var isMaxColumn = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1].column;
    var colMax = ctx.visibledatacolumn.length - 1;

    if (isMaxColumn[0] === 0 && isMaxColumn[1] === colMax) {
      last.column[1] = colMax;
      last.width_move = ctx.visibledatacolumn[colMax] - 1;
    }

    var isMaxRow = ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1].row;
    var rowMax = ctx.visibledatarow.length - 1;

    if (isMaxRow[0] === 0 && isMaxRow[1] === rowMax) {
      last.row[1] = rowMax;
      last.height_move = ctx.visibledatarow[rowMax] - 1;
    }

    ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1] = last;
    scrollToFrozenRowCol(ctx, (_globalCache$freezen4 = globalCache.freezen) === null || _globalCache$freezen4 === void 0 ? void 0 : _globalCache$freezen4[ctx.currentSheetId]);
  } else if (ctx.formulaCache.rangestart) {
    rangeDrag(ctx, e, cellInput, scrollX.scrollLeft, scrollY.scrollTop, container, fxInput);
  } else if (ctx.formulaCache.rangedrag_row_start) {
    rangeDragRow(ctx, e, cellInput, scrollX.scrollLeft, scrollY.scrollTop, container, fxInput);
  } else if (ctx.formulaCache.rangedrag_column_start) {
    rangeDragColumn(ctx, e, cellInput, scrollX.scrollLeft, scrollY.scrollTop, container, fxInput);
  } else if (ctx.luckysheet_rows_selected_status) ; else if (ctx.luckysheet_cols_selected_status) ; else if (ctx.luckysheet_cell_selected_move) ; else if (ctx.luckysheet_cell_selected_extend) {
    onDropCellSelect(ctx, e, scrollX, scrollY, container);
  } else if (ctx.luckysheet_cols_change_size) {
    var _x3 = e.pageX - rect.left - ctx.rowHeaderWidth + scrollX.scrollLeft - window.scrollX;

    if (_x3 < rect.width + ctx.scrollLeft - 100) {
      var changeSizeLine = container.querySelector(".fortune-change-size-line");

      if (changeSizeLine) {
        changeSizeLine.style.left = "".concat(_x3, "px");
      }

      var changeSizeCol = container.querySelector(".fortune-cols-change-size");

      if (changeSizeCol) {
        changeSizeCol.style.left = "".concat(_x3 - 2, "px");
      }
    }
  } else if (ctx.luckysheet_rows_change_size) {
    var _y3 = e.pageY - rect.top - ctx.columnHeaderHeight + scrollY.scrollTop - window.scrollY;

    if (_y3 < rect.height + ctx.scrollTop - 20) {
      var _changeSizeLine = container.querySelector(".fortune-change-size-line");

      if (_changeSizeLine) {
        _changeSizeLine.style.top = "".concat(_y3, "px");
      }

      var changeSizeRow = container.querySelector(".fortune-rows-change-size");

      if (changeSizeRow) {
        changeSizeRow.style.top = "".concat(_y3, "px");
      }
    }
  } else if (ctx.luckysheet_cols_freeze_drag) {
    var _x4 = e.pageX - rect.left - ctx.rowHeaderWidth + ctx.scrollLeft - window.scrollX;

    var _colLocation = colLocation(_x4, ctx.visibledatacolumn),
        _colLocation2 = _slicedToArray(_colLocation, 2),
        _col_pre3 = _colLocation2[0],
        col_curr = _colLocation2[1];

    var _col3 = _x4 > (_col_pre3 + col_curr) / 2 ? col_curr : _col_pre3;

    if (_x4 < rect.width + ctx.scrollLeft - 100) {
      var freezeLine = container.querySelector(".fortune-freeze-drag-line");

      if (freezeLine) {
        freezeLine.style.left = "".concat(Math.max(0, _col3 - 2), "px");
      }

      var freezeHandle = container.querySelector(".fortune-cols-freeze-handle");

      if (freezeHandle) {
        freezeHandle.style.left = "".concat(_x4, "px");
      }

      var _changeSizeLine2 = container.querySelector(".fortune-change-size-line");

      if (_changeSizeLine2) {
        _changeSizeLine2.style.left = "".concat(_x4, "px");
      }
    }
  } else if (ctx.luckysheet_rows_freeze_drag) {
    var _y4 = e.pageY - rect.top - ctx.columnHeaderHeight + ctx.scrollTop - window.scrollY;

    var _rowLocation = rowLocation(_y4, ctx.visibledatarow),
        _rowLocation2 = _slicedToArray(_rowLocation, 2),
        _row_pre3 = _rowLocation2[0],
        row_curr = _rowLocation2[1];

    var _row3 = _y4 > (row_curr + _row_pre3) / 2 ? row_curr : _row_pre3;

    if (_y4 < rect.height + ctx.scrollTop - 20) {
      var _freezeLine = container.querySelector(".fortune-freeze-drag-line");

      if (_freezeLine) {
        _freezeLine.style.top = "".concat(Math.max(0, _row3 - 2), "px");
      }

      var _freezeHandle = container.querySelector(".fortune-rows-freeze-handle");

      if (_freezeHandle) {
        _freezeHandle.style.top = "".concat(_y4, "px");
      }

      var _changeSizeLine3 = container.querySelector(".fortune-change-size-line");

      if (_changeSizeLine3) {
        _changeSizeLine3.style.top = "".concat(_y4, "px");
      }
    }
  }
}

function handleOverlayMouseMove(ctx, globalCache, e, cellInput, scrollX, scrollY, container, fxInput) {
  if (onCommentBoxResize(ctx, globalCache, e)) return;
  if (onCommentBoxMove(ctx, globalCache, e)) return;
  if (onImageMove(ctx, globalCache, e)) return;
  if (onImageResize(ctx, globalCache, e)) return;
  onCellsMove(ctx, globalCache, e, scrollX, scrollY, container);
  overShowComment(ctx, e, scrollX, scrollY, container);
  onSearchDialogMove(globalCache, e);
  onRangeSelectionModalMove(globalCache, e);

  if (!!ctx.luckysheet_scroll_status || !!ctx.luckysheet_select_status || !!ctx.luckysheet_rows_selected_status || !!ctx.luckysheet_cols_selected_status || !!ctx.luckysheet_cell_selected_move || !!ctx.luckysheet_cell_selected_extend || !!ctx.luckysheet_cols_change_size || !!ctx.luckysheet_rows_change_size) {
    mouseRender(ctx, globalCache, e, cellInput, scrollX, scrollY, container, fxInput);
  }
}
function handleOverlayMouseUp(ctx, globalCache, settings, e, scrollbarX, scrollbarY, container, cellInput, fxInput) {
  var rect = container.getBoundingClientRect();
  onImageMoveEnd(ctx, globalCache);
  onImageResizeEnd(ctx, globalCache);
  onCommentBoxMoveEnd(ctx, globalCache);
  onCommentBoxResizeEnd(ctx, globalCache);
  onFormulaRangeDragEnd(ctx);
  onSearchDialogMoveEnd(globalCache);
  onRangeSelectionModalMoveEnd(globalCache);
  onCellsMoveEnd(ctx, globalCache, e, scrollbarX, scrollbarY, container);

  if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start) {
    var _document$activeEleme;

    if (((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.id) === "luckysheet-functionbox-cell") {
      handleFormulaInput(ctx, cellInput, fxInput, 0, undefined, false);
    } else {
      handleFormulaInput(ctx, fxInput, cellInput, 0, undefined, false);
    }
  }

  if (ctx.luckysheet_select_status) {
    if (ctx.luckysheetPaintModelOn) {
      pasteHandlerOfPaintModel(ctx, ctx.luckysheet_copy_save);

      if (ctx.luckysheetPaintSingle) {
        cancelPaintModel(ctx);
      }
    }
  }

  ctx.luckysheet_select_status = false;
  ctx.luckysheet_scroll_status = false;
  ctx.luckysheet_rows_selected_status = false;
  ctx.luckysheet_cols_selected_status = false;
  ctx.luckysheet_model_move_state = false;

  if (ctx.luckysheet_rows_change_size) {
    var _ctx$luckysheet_selec7, _ctx$luckysheet_selec8;

    ctx.luckysheet_rows_change_size = false;
    var scrollTop = ctx.scrollTop;
    var y = e.pageY - rect.top - ctx.columnHeaderHeight + scrollTop - window.scrollY;
    var winH = rect.height;
    var delta = y + 3 - ctx.luckysheet_rows_change_size_start[0];

    if (y >= winH - 20 + scrollTop) {
      delta = winH - 20 - ctx.luckysheet_rows_change_size_start[0] + scrollTop;
    }

    var cfg = ctx.config;

    if (cfg.rowlen == null) {
      cfg.rowlen = {};
    }

    if (cfg.customHeight == null) {
      cfg.customHeight = {};
    }

    var size = ctx.defaultrowlen;

    if (ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1]] != null) {
      size = ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1]] - (ctx.visibledatarow[ctx.luckysheet_rows_change_size_start[1] - 1] || 0);
    }

    size += delta;

    if (size < 10) {
      size = 10;
    }

    cfg.customHeight[ctx.luckysheet_rows_change_size_start[1]] = 1;
    var changeRowIndex = ctx.luckysheet_rows_change_size_start[1];
    var changeRowSelected = false;

    if (((_ctx$luckysheet_selec7 = (_ctx$luckysheet_selec8 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec8 === void 0 ? void 0 : _ctx$luckysheet_selec8.length) !== null && _ctx$luckysheet_selec7 !== void 0 ? _ctx$luckysheet_selec7 : 0) > 0) {
      var _ctx$luckysheet_selec9, _ctx$luckysheet_selec10;

      (_ctx$luckysheet_selec9 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec9 === void 0 ? void 0 : (_ctx$luckysheet_selec10 = _ctx$luckysheet_selec9.filter(function (select) {
        return select.row_select;
      })) === null || _ctx$luckysheet_selec10 === void 0 ? void 0 : _ctx$luckysheet_selec10.some(function (select) {
        if (changeRowIndex >= select.row[0] && changeRowIndex <= select.row[1]) {
          changeRowSelected = true;
        }

        return changeRowSelected;
      });
    }

    if (changeRowSelected) {
      var _ctx$luckysheet_selec11, _ctx$luckysheet_selec12;

      cfg.rowlen || (cfg.rowlen = {});
      (_ctx$luckysheet_selec11 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec11 === void 0 ? void 0 : (_ctx$luckysheet_selec12 = _ctx$luckysheet_selec11.filter(function (select) {
        return select.row_select;
      })) === null || _ctx$luckysheet_selec12 === void 0 ? void 0 : _ctx$luckysheet_selec12.forEach(function (select) {
        for (var r = select.row[0]; r <= select.row[1]; r += 1) {
          cfg.rowlen[r] = Math.ceil(size / ctx.zoomRatio);
        }
      });
    } else {
      cfg.rowlen[ctx.luckysheet_rows_change_size_start[1]] = Math.ceil(size / ctx.zoomRatio);
    }

    ctx.config = cfg;
    var idx = getSheetIndex(ctx, ctx.currentSheetId);
    if (idx == null) return;
    ctx.luckysheetfile[idx].config = ctx.config;
  }

  if (ctx.luckysheet_cols_change_size) {
    var _ctx$luckysheet_selec13, _ctx$luckysheet_selec14;

    ctx.luckysheet_cols_change_size = false;
    var scrollLeft = ctx.scrollLeft;
    var x = e.pageX - rect.left - ctx.rowHeaderWidth + scrollLeft - window.scrollX;
    var winW = rect.width;

    var _delta = x + 3 - ctx.luckysheet_cols_change_size_start[0];

    if (x >= winW - 100 + scrollLeft) {
      _delta = winW - 100 - ctx.luckysheet_cols_change_size_start[0] + scrollLeft;
    }

    _delta /= ctx.zoomRatio;
    var _cfg = ctx.config;

    if (_cfg.columnlen == null) {
      _cfg.columnlen = {};
    }

    if (_cfg.customWidth == null) {
      _cfg.customWidth = {};
    }

    var firstcolumnlen = ctx.defaultcollen;

    if (ctx.config.columnlen != null && ctx.config.columnlen[ctx.luckysheet_cols_change_size_start[1]] != null) {
      firstcolumnlen = ctx.config.columnlen[ctx.luckysheet_cols_change_size_start[1]];
    }

    var _size = (_cfg.columnlen[ctx.luckysheet_cols_change_size_start[1]] || ctx.defaultcollen) + _delta;

    if (Math.abs(_size - firstcolumnlen) < 3) {
      return;
    }

    if (_size < 10) {
      _size = 10;
    }

    _cfg.customWidth[ctx.luckysheet_cols_change_size_start[1]] = 1;
    var changeColumnIndex = ctx.luckysheet_cols_change_size_start[1];
    var changeColumnSelected = false;

    if (((_ctx$luckysheet_selec13 = (_ctx$luckysheet_selec14 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec14 === void 0 ? void 0 : _ctx$luckysheet_selec14.length) !== null && _ctx$luckysheet_selec13 !== void 0 ? _ctx$luckysheet_selec13 : 0) > 0) {
      var _ctx$luckysheet_selec15, _ctx$luckysheet_selec16;

      (_ctx$luckysheet_selec15 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec15 === void 0 ? void 0 : (_ctx$luckysheet_selec16 = _ctx$luckysheet_selec15.filter(function (select) {
        return select.column_select;
      })) === null || _ctx$luckysheet_selec16 === void 0 ? void 0 : _ctx$luckysheet_selec16.some(function (select) {
        if (changeColumnIndex >= select.column[0] && changeColumnIndex <= select.column[1]) {
          changeColumnSelected = true;
        }

        return changeColumnSelected;
      });
    }

    if (changeColumnSelected) {
      var _ctx$luckysheet_selec17, _ctx$luckysheet_selec18;

      _cfg.columnlen || (_cfg.columnlen = {});
      (_ctx$luckysheet_selec17 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec17 === void 0 ? void 0 : (_ctx$luckysheet_selec18 = _ctx$luckysheet_selec17.filter(function (select) {
        return select.column_select;
      })) === null || _ctx$luckysheet_selec18 === void 0 ? void 0 : _ctx$luckysheet_selec18.forEach(function (select) {
        for (var r = select.column[0]; r <= select.column[1]; r += 1) {
          _cfg.columnlen[r] = Math.ceil(_size / ctx.zoomRatio);
        }
      });
    } else {
      _cfg.columnlen[ctx.luckysheet_cols_change_size_start[1]] = Math.ceil(_size / ctx.zoomRatio);
    }

    ctx.config = _cfg;

    var _idx = getSheetIndex(ctx, ctx.currentSheetId);

    if (_idx == null) return;
    ctx.luckysheetfile[_idx].config = ctx.config;
  }

  if (ctx.luckysheet_cols_freeze_drag) {
    ctx.luckysheet_cols_freeze_drag = false;
    var _scrollLeft = ctx.scrollLeft;

    var _x5 = e.pageX - rect.left - ctx.rowHeaderWidth + _scrollLeft - window.scrollX;

    var _colLocation3 = colLocation(_x5, ctx.visibledatacolumn),
        _colLocation4 = _slicedToArray(_colLocation3, 3),
        col_pre = _colLocation4[0],
        col_curr = _colLocation4[1],
        col_index_curr = _colLocation4[2];

    var col_index = _x5 > (col_curr + col_pre) / 2 ? col_index_curr : col_index_curr - 1;

    var _idx2 = getSheetIndex(ctx, ctx.currentSheetId);

    if (_idx2 == null) return;

    if (col_index < 0) {
      var frozen = ctx.luckysheetfile[_idx2].frozen;

      if (frozen) {
        if (frozen.type === "rangeBoth" || frozen.type === "both") {
          frozen.type = "rangeRow";
        } else if (frozen.type === "column" || frozen.type === "rangeColumn") {
          delete ctx.luckysheetfile[_idx2].frozen;
        }
      }

      var _freezeHandle2 = container.querySelector(".fortune-cols-freeze-handle");

      if (_freezeHandle2) {
        _freezeHandle2.style.left = "".concat(ctx.scrollLeft, "px");
      }
    } else if (!ctx.luckysheetfile[_idx2].frozen) {
      ctx.luckysheetfile[_idx2].frozen = {
        type: "rangeColumn",
        range: {
          column_focus: col_index,
          row_focus: 0
        }
      };
    } else {
      var _frozen = ctx.luckysheetfile[_idx2].frozen;

      if (!_frozen.range) {
        _frozen.range = {
          column_focus: col_index,
          row_focus: 0
        };
      } else {
        _frozen.range.column_focus = col_index;
      }

      if ((_frozen === null || _frozen === void 0 ? void 0 : _frozen.type) === "rangeRow" || (_frozen === null || _frozen === void 0 ? void 0 : _frozen.type) === "row") {
        _frozen.type = "rangeBoth";
      }
    }

    var freezeHandle = container.querySelector(".fortune-cols-freeze-handle");

    if (freezeHandle) {
      freezeHandle.style.left = "".concat(getFrozenHandleLeft(ctx), "px");
    }
  }

  if (ctx.luckysheet_rows_freeze_drag) {
    ctx.luckysheet_rows_freeze_drag = false;
    var _scrollTop = ctx.scrollTop;

    var _y5 = e.pageY - rect.top - ctx.columnHeaderHeight + _scrollTop - window.scrollY;

    var _rowLocation3 = rowLocation(_y5, ctx.visibledatarow),
        _rowLocation4 = _slicedToArray(_rowLocation3, 3),
        row_pre = _rowLocation4[0],
        row_curr = _rowLocation4[1],
        row_index_curr = _rowLocation4[2];

    var row_index = _y5 > (row_curr + row_pre) / 2 ? row_index_curr : row_index_curr - 1;

    var _idx3 = getSheetIndex(ctx, ctx.currentSheetId);

    if (_idx3 == null) return;

    if (row_index < 0) {
      var _frozen2 = ctx.luckysheetfile[_idx3].frozen;

      if (_frozen2) {
        if (_frozen2.type === "rangeBoth" || _frozen2.type === "both") {
          _frozen2.type = "rangeColumn";
        } else if (_frozen2.type === "row" || _frozen2.type === "rangeRow") {
          delete ctx.luckysheetfile[_idx3].frozen;
        }
      }
    } else if (!ctx.luckysheetfile[_idx3].frozen) {
      ctx.luckysheetfile[_idx3].frozen = {
        type: "rangeRow",
        range: {
          column_focus: 0,
          row_focus: row_index
        }
      };
    } else {
      var _frozen3 = ctx.luckysheetfile[_idx3].frozen;

      if (!_frozen3.range) {
        _frozen3.range = {
          column_focus: 0,
          row_focus: row_index
        };
      } else {
        _frozen3.range.row_focus = row_index;
      }

      if ((_frozen3 === null || _frozen3 === void 0 ? void 0 : _frozen3.type) === "rangeColumn" || (_frozen3 === null || _frozen3 === void 0 ? void 0 : _frozen3.type) === "column") {
        _frozen3.type = "rangeBoth";
      }
    }

    var _freezeHandle3 = container.querySelector(".fortune-rows-freeze-handle");

    if (_freezeHandle3) {
      _freezeHandle3.style.top = "".concat(getFrozenHandleTop(ctx), "px");
    }
  }

  if (ctx.luckysheet_cell_selected_extend) {
    onDropCellSelectEnd(ctx, e, container);
  }
}
function handleRowHeaderMouseDown(ctx, globalCache, e, container, cellInput, fxInput) {
  var _globalCache$freezen5;

  if (!checkProtectionAllSelected(ctx, ctx.currentSheetId)) {
    return;
  }

  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  var rect = container.getBoundingClientRect();
  var mouseY = e.pageY - rect.top - window.scrollY;

  var _y = mouseY + ctx.scrollTop;

  var freeze = (_globalCache$freezen5 = globalCache.freezen) === null || _globalCache$freezen5 === void 0 ? void 0 : _globalCache$freezen5[ctx.currentSheetId];

  var _fixPositionOnFrozenC7 = fixPositionOnFrozenCells(freeze, 0, _y, 0, mouseY),
      y = _fixPositionOnFrozenC7.y;

  var row_location = rowLocation(y, ctx.visibledatarow);
  var row = row_location[1];
  var row_pre = row_location[0];
  var row_index = row_location[2];
  var col_index = ctx.visibledatacolumn.length - 1;
  var col = ctx.visibledatacolumn[col_index];
  var col_pre = 0;

  if (e.button === 2) {
    var flowdata = getFlowdata(ctx);

    var isInSelection = _.some(ctx.luckysheet_select_save, function (obj_s) {
      var _flowdata$0$length, _flowdata$;

      return obj_s.row != null && row_index >= obj_s.row[0] && row_index <= obj_s.row[1] && obj_s.column[0] === 0 && obj_s.column[1] === ((_flowdata$0$length = flowdata === null || flowdata === void 0 ? void 0 : (_flowdata$ = flowdata[0]) === null || _flowdata$ === void 0 ? void 0 : _flowdata$.length) !== null && _flowdata$0$length !== void 0 ? _flowdata$0$length : 0) - 1;
    });

    if (isInSelection) return;
  }

  var top = row_pre;
  var height = row - row_pre - 1;
  var rowseleted = [row_index, row_index];
  ctx.luckysheet_scroll_status = true;

  if (!_.isEmpty(ctx.luckysheetCellUpdate)) {
    if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
      var _$last2;

      var changeparam = mergeMoveMain(ctx, [0, col_index], rowseleted, {
        row_focus: row_index,
        column_focus: 0
      }, top, height, col_pre, col);

      if (changeparam != null) {
        var _ref = [changeparam[1], changeparam[2], changeparam[3]];
        rowseleted = _ref[0];
        top = _ref[1];
        height = _ref[2];
      }

      if (e.shiftKey) {
        var last = ctx.formulaCache.func_selectedrange;
        top = 0;
        height = 0;
        rowseleted = [];
        if (last == null || last.top == null || last.height == null || last.row == null || last.row_focus == null) return;

        if (last.top > row_pre) {
          top = row_pre;
          height = last.top + last.height - row_pre;

          if (last.row[1] > last.row_focus) {
            last.row[1] = last.row_focus;
          }

          rowseleted = [row_index, last.row[1]];
        } else if (last.top === row_pre) {
          top = row_pre;
          height = last.top + last.height - row_pre;
          rowseleted = [row_index, last.row[0]];
        } else {
          top = last.top;
          height = row - last.top - 1;

          if (last.row[0] < last.row_focus) {
            last.row[0] = last.row_focus;
          }

          rowseleted = [last.row[0], row_index];
        }

        changeparam = mergeMoveMain(ctx, [0, col_index], rowseleted, {
          row_focus: row_index,
          column_focus: 0
        }, top, height, col_pre, col);

        if (changeparam != null) {
          var _ref2 = [changeparam[1], changeparam[2], changeparam[3]];
          rowseleted = _ref2[0];
          top = _ref2[1];
          height = _ref2[2];
        }

        last.row = rowseleted;
        last.top_move = top;
        last.height_move = height;
        ctx.formulaCache.func_selectedrange = last;
      } else if (e.ctrlKey && ((_$last2 = _.last(cellInput.querySelectorAll("span"))) === null || _$last2 === void 0 ? void 0 : _$last2.innerText) !== ",") {
        var vText = "".concat(cellInput.innerText, ",");

        if (vText.length > 0 && vText.substring(0, 1) === "=") {
          vText = functionHTMLGenerate(vText);

          if (window.getSelection) {
            var _currSelection$anchor5, _currSelection$anchor6, _currSelection$anchor7, _currSelection$anchor8;

            var currSelection = window.getSelection();
            if (currSelection == null) return;
            ctx.formulaCache.functionRangeIndex = [_.indexOf((_currSelection$anchor5 = currSelection.anchorNode) === null || _currSelection$anchor5 === void 0 ? void 0 : (_currSelection$anchor6 = _currSelection$anchor5.parentNode) === null || _currSelection$anchor6 === void 0 ? void 0 : (_currSelection$anchor7 = _currSelection$anchor6.parentNode) === null || _currSelection$anchor7 === void 0 ? void 0 : _currSelection$anchor7.childNodes, (_currSelection$anchor8 = currSelection.anchorNode) === null || _currSelection$anchor8 === void 0 ? void 0 : _currSelection$anchor8.parentNode), currSelection.anchorOffset];
          } else {
            var textRange = document.selection.createRange();
            ctx.formulaCache.functionRangeIndex = textRange;
          }

          cellInput.innerHTML = vText;
          cancelFunctionrangeSelected(ctx);
          createRangeHightlight(ctx, vText);
        }

        ctx.formulaCache.rangestart = false;
        ctx.formulaCache.rangedrag_column_start = false;
        ctx.formulaCache.rangedrag_row_start = false;
        if (fxInput) fxInput.innerHTML = vText;
        rangeHightlightselected(ctx, cellInput);
        israngeseleciton(ctx);
        ctx.formulaCache.func_selectedrange = {
          left: colLocationByIndex(0, ctx.visibledatacolumn)[0],
          width: colLocationByIndex(0, ctx.visibledatacolumn)[1] - colLocationByIndex(0, ctx.visibledatacolumn)[0] - 1,
          top: top,
          height: height,
          left_move: col_pre,
          width_move: col - col_pre - 1,
          top_move: top,
          height_move: height,
          row: rowseleted,
          column: [0, col_index],
          row_focus: row_index,
          column_focus: 0
        };
      } else {
        ctx.formulaCache.func_selectedrange = {
          left: colLocationByIndex(0, ctx.visibledatacolumn)[0],
          width: colLocationByIndex(0, ctx.visibledatacolumn)[1] - colLocationByIndex(0, ctx.visibledatacolumn)[0] - 1,
          top: top,
          height: height,
          left_move: col_pre,
          width_move: col - col_pre - 1,
          top_move: top,
          height_move: height,
          row: rowseleted,
          column: [0, col_index],
          row_focus: row_index,
          column_focus: 0
        };
      }

      if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
        rangeSetValue(ctx, cellInput, {
          row: rowseleted,
          column: [null, null]
        }, fxInput);
      }

      ctx.formulaCache.rangedrag_row_start = true;
      ctx.formulaCache.rangestart = false;
      ctx.formulaCache.rangedrag_column_start = false;
      ctx.formulaCache.selectingRangeIndex = ctx.formulaCache.rangechangeindex;

      if (ctx.formulaCache.rangechangeindex > ctx.formulaRangeHighlight.length) {
        createRangeHightlight(ctx, cellInput.innerHTML, ctx.formulaCache.rangechangeindex);
      }

      createFormulaRangeSelect(ctx, {
        rangeIndex: ctx.formulaCache.rangechangeindex || 0,
        left: col_pre,
        top: top,
        width: col - col_pre - 1,
        height: height
      });
      e.preventDefault();
      return;
    }

    updateCell(ctx, ctx.luckysheetCellUpdate[0], ctx.luckysheetCellUpdate[1], cellInput);
    ctx.luckysheet_rows_selected_status = true;
  } else {
    ctx.luckysheet_rows_selected_status = true;
  }

  if (ctx.luckysheet_rows_selected_status) {
    if (e.shiftKey) {
      var _ctx$luckysheet_selec19;

      var _last2 = _.cloneDeep((_ctx$luckysheet_selec19 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec19 === void 0 ? void 0 : _ctx$luckysheet_selec19[ctx.luckysheet_select_save.length - 1]);

      if (!_last2 || _.isNil(_last2.top) || _.isNil(_last2.height) || _.isNil(_last2.row_focus)) {
        return;
      }

      var _top = 0;
      var _height = 0;
      var _rowseleted = [];

      if (_last2.top > row_pre) {
        _top = row_pre;
        _height = _last2.top + _last2.height - row_pre;

        if (_last2.row[1] > _last2.row_focus) {
          _last2.row[1] = _last2.row_focus;
        }

        _rowseleted = [row_index, _last2.row[1]];
      } else if (_last2.top === row_pre) {
        _top = row_pre;
        _height = _last2.top + _last2.height - row_pre;
        _rowseleted = [row_index, _last2.row[0]];
      } else {
        _top = _last2.top;
        _height = row - _last2.top - 1;

        if (_last2.row[0] < _last2.row_focus) {
          _last2.row[0] = _last2.row_focus;
        }

        _rowseleted = [_last2.row[0], row_index];
      }

      _last2.row = _rowseleted;
      _last2.top_move = _top;
      _last2.height_move = _height;
      ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1] = _last2;
    } else if (e.ctrlKey || e.metaKey) {
      var _ctx$luckysheet_selec20;

      (_ctx$luckysheet_selec20 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec20 === void 0 ? void 0 : _ctx$luckysheet_selec20.push({
        left: colLocationByIndex(0, ctx.visibledatacolumn)[0],
        width: colLocationByIndex(0, ctx.visibledatacolumn)[1] - colLocationByIndex(0, ctx.visibledatacolumn)[0] - 1,
        top: top,
        height: height,
        left_move: col_pre,
        width_move: col - col_pre - 1,
        top_move: top,
        height_move: height,
        row: rowseleted,
        column: [0, col_index],
        row_focus: row_index,
        column_focus: 0,
        row_select: true
      });
    } else {
      ctx.luckysheet_select_save = [];
      ctx.luckysheet_select_save.push({
        left: colLocationByIndex(0, ctx.visibledatacolumn)[0],
        width: colLocationByIndex(0, ctx.visibledatacolumn)[1] - colLocationByIndex(0, ctx.visibledatacolumn)[0] - 1,
        top: top,
        height: height,
        left_move: col_pre,
        width_move: col - col_pre - 1,
        top_move: top,
        height_move: height,
        row: rowseleted,
        column: [0, col_index],
        row_focus: row_index,
        column_focus: 0,
        row_select: true
      });
      ctx.luckysheet_select_status = true;
      ctx.luckysheet_scroll_status = true;
    }
  }
}
function handleColumnHeaderMouseDown(ctx, globalCache, e, container, cellInput, fxInput) {
  var _globalCache$freezen6;

  if (!checkProtectionAllSelected(ctx, ctx.currentSheetId)) {
    return;
  }

  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  var rect = container.getBoundingClientRect();
  var mouseX = e.pageX - rect.left - window.scrollX;

  var _x = mouseX + ctx.scrollLeft;

  var freeze = (_globalCache$freezen6 = globalCache.freezen) === null || _globalCache$freezen6 === void 0 ? void 0 : _globalCache$freezen6[ctx.currentSheetId];

  var _fixPositionOnFrozenC8 = fixPositionOnFrozenCells(freeze, _x, 0, mouseX, 0),
      x = _fixPositionOnFrozenC8.x;

  var row_index = ctx.visibledatarow.length - 1;
  var row = ctx.visibledatarow[row_index];
  var row_pre = 0;
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col = col_location[1];
  var col_pre = col_location[0];
  var col_index = col_location[2];
  ctx.orderbyindex = col_index;

  if (e.button === 2) {
    var flowdata = getFlowdata(ctx);

    var isInSelection = _.some(ctx.luckysheet_select_save, function (obj_s) {
      var _flowdata$length;

      return obj_s.column != null && col_index >= obj_s.column[0] && col_index <= obj_s.column[1] && obj_s.row[0] === 0 && obj_s.row[1] === ((_flowdata$length = flowdata === null || flowdata === void 0 ? void 0 : flowdata.length) !== null && _flowdata$length !== void 0 ? _flowdata$length : 0) - 1;
    });

    if (isInSelection) return;
  }

  var left = col_pre;
  var width = col - col_pre - 1;
  var columnseleted = [col_index, col_index];
  ctx.luckysheet_scroll_status = true;

  if (!_.isEmpty(ctx.luckysheetCellUpdate)) {
    if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
      var _$last3;

      var changeparam = mergeMoveMain(ctx, columnseleted, [0, row_index], {
        row_focus: 0,
        column_focus: col_index
      }, row_pre, row, left, width);

      if (changeparam != null) {
        var _ref3 = [changeparam[0], changeparam[4], changeparam[5]];
        columnseleted = _ref3[0];
        left = _ref3[1];
        width = _ref3[2];
      }

      if (e.shiftKey) {
        var last = ctx.formulaCache.func_selectedrange;
        left = 0;
        width = 0;
        columnseleted = [];
        if (last == null || last.width == null || last.height == null || last.left == null || last.column_focus == null) return;

        if (last.left > col_pre) {
          left = col_pre;
          width = last.left + last.width - col_pre;

          if (last.column[1] > last.column_focus) {
            last.column[1] = last.column_focus;
          }

          columnseleted = [col_index, last.column[1]];
        } else if (last.left === col_pre) {
          left = col_pre;
          width = last.left + last.width - col_pre;
          columnseleted = [col_index, last.column[0]];
        } else {
          left = last.left;
          width = col - last.left - 1;

          if (last.column[0] < last.column_focus) {
            last.column[0] = last.column_focus;
          }

          columnseleted = [last.column[0], col_index];
        }

        changeparam = mergeMoveMain(ctx, columnseleted, [0, row_index], {
          row_focus: 0,
          column_focus: col_index
        }, row_pre, row, left, width);

        if (changeparam != null) {
          var _ref4 = [changeparam[0], changeparam[4], changeparam[5]];
          columnseleted = _ref4[0];
          left = _ref4[1];
          width = _ref4[2];
        }

        last.column = columnseleted;
        last.left_move = left;
        last.width_move = width;
        ctx.formulaCache.func_selectedrange = last;
      } else if (e.ctrlKey && ((_$last3 = _.last(cellInput.querySelectorAll("span"))) === null || _$last3 === void 0 ? void 0 : _$last3.innerText) !== ",") {
        var vText = "".concat(cellInput.innerText, ",");

        if (vText.length > 0 && vText.substring(0, 1) === "=") {
          vText = functionHTMLGenerate(vText);

          if (window.getSelection) {
            var _currSelection$anchor9, _currSelection$anchor10, _currSelection$anchor11, _currSelection$anchor12;

            var currSelection = window.getSelection();
            if (currSelection == null) return;
            ctx.formulaCache.functionRangeIndex = [_.indexOf((_currSelection$anchor9 = currSelection.anchorNode) === null || _currSelection$anchor9 === void 0 ? void 0 : (_currSelection$anchor10 = _currSelection$anchor9.parentNode) === null || _currSelection$anchor10 === void 0 ? void 0 : (_currSelection$anchor11 = _currSelection$anchor10.parentNode) === null || _currSelection$anchor11 === void 0 ? void 0 : _currSelection$anchor11.childNodes, (_currSelection$anchor12 = currSelection.anchorNode) === null || _currSelection$anchor12 === void 0 ? void 0 : _currSelection$anchor12.parentNode), currSelection.anchorOffset];
          } else {
            var textRange = document.selection.createRange();
            ctx.formulaCache.functionRangeIndex = textRange;
          }

          cellInput.innerHTML = vText;
          cancelFunctionrangeSelected(ctx);
          createRangeHightlight(ctx, vText);
        }

        ctx.formulaCache.rangestart = false;
        ctx.formulaCache.rangedrag_column_start = false;
        ctx.formulaCache.rangedrag_row_start = false;

        if (fxInput) {
          fxInput.innerHTML = vText;
        }

        rangeHightlightselected(ctx, cellInput);
        israngeseleciton(ctx);
        ctx.formulaCache.func_selectedrange = {
          left: left,
          width: width,
          top: rowLocationByIndex(0, ctx.visibledatarow)[0],
          height: rowLocationByIndex(0, ctx.visibledatarow)[1] - rowLocationByIndex(0, ctx.visibledatarow)[0] - 1,
          left_move: left,
          width_move: width,
          top_move: row_pre,
          height_move: row - row_pre - 1,
          row: [0, row_index],
          column: columnseleted,
          row_focus: 0,
          column_focus: col_index
        };
      } else {
        ctx.formulaCache.func_selectedrange = {
          left: left,
          width: width,
          top: rowLocationByIndex(0, ctx.visibledatarow)[0],
          height: rowLocationByIndex(0, ctx.visibledatarow)[1] - rowLocationByIndex(0, ctx.visibledatarow)[0] - 1,
          left_move: left,
          width_move: width,
          top_move: row_pre,
          height_move: row - row_pre - 1,
          row: [0, row_index],
          column: columnseleted,
          row_focus: 0,
          column_focus: col_index
        };
      }

      if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) {
        rangeSetValue(ctx, cellInput, {
          row: [null, null],
          column: columnseleted
        }, fxInput);
      }

      ctx.formulaCache.rangedrag_column_start = true;
      ctx.formulaCache.rangestart = false;
      ctx.formulaCache.rangedrag_row_start = false;
      ctx.formulaCache.selectingRangeIndex = ctx.formulaCache.rangechangeindex;

      if (ctx.formulaCache.rangechangeindex > ctx.formulaRangeHighlight.length) {
        createRangeHightlight(ctx, cellInput.innerHTML, ctx.formulaCache.rangechangeindex);
      }

      createFormulaRangeSelect(ctx, {
        rangeIndex: ctx.formulaCache.rangechangeindex || 0,
        left: left,
        top: row_pre,
        width: width,
        height: row - row_pre - 1
      });
      e.preventDefault();
      return;
    }

    updateCell(ctx, ctx.luckysheetCellUpdate[0], ctx.luckysheetCellUpdate[1], cellInput);
    ctx.luckysheet_cols_selected_status = true;
  } else {
    ctx.luckysheet_cols_selected_status = true;
  }

  if (ctx.luckysheet_cols_selected_status) {
    if (e.shiftKey) {
      var _ctx$luckysheet_selec21;

      var _last3 = _.cloneDeep((_ctx$luckysheet_selec21 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec21 === void 0 ? void 0 : _ctx$luckysheet_selec21[ctx.luckysheet_select_save.length - 1]);

      var _left = 0;
      var _width = 0;
      var _columnseleted = [];

      if (!_last3 || _.isNil(_last3.left) || _.isNil(_last3.width) || _.isNil(_last3.column_focus)) {
        return;
      }

      if (_last3.left > col_pre) {
        _left = col_pre;
        _width = _last3.left + _last3.width - col_pre;

        if (_last3.column[1] > _last3.column_focus) {
          _last3.column[1] = _last3.column_focus;
        }

        _columnseleted = [col_index, _last3.column[1]];
      } else if (_last3.left === col_pre) {
        _left = col_pre;
        _width = _last3.left + _last3.width - col_pre;
        _columnseleted = [col_index, _last3.column[0]];
      } else {
        _left = _last3.left;
        _width = col - _last3.left - 1;

        if (_last3.column[0] < _last3.column_focus) {
          _last3.column[0] = _last3.column_focus;
        }

        _columnseleted = [_last3.column[0], col_index];
      }

      _last3.column = _columnseleted;
      _last3.left_move = _left;
      _last3.width_move = _width;
      ctx.luckysheet_select_save[ctx.luckysheet_select_save.length - 1] = _last3;
    } else if (e.ctrlKey || e.metaKey) {
      var _ctx$luckysheet_selec22;

      (_ctx$luckysheet_selec22 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec22 === void 0 ? void 0 : _ctx$luckysheet_selec22.push({
        left: left,
        width: width,
        top: rowLocationByIndex(0, ctx.visibledatarow)[0],
        height: rowLocationByIndex(0, ctx.visibledatarow)[1] - rowLocationByIndex(0, ctx.visibledatarow)[0] - 1,
        left_move: left,
        width_move: width,
        top_move: row_pre,
        height_move: row - row_pre - 1,
        row: [0, row_index],
        column: columnseleted,
        row_focus: 0,
        column_focus: col_index,
        column_select: true
      });
    } else {
      ctx.luckysheet_select_save = [];
      ctx.luckysheet_select_save.push({
        left: left,
        width: width,
        top: rowLocationByIndex(0, ctx.visibledatarow)[0],
        height: rowLocationByIndex(0, ctx.visibledatarow)[1] - rowLocationByIndex(0, ctx.visibledatarow)[0] - 1,
        left_move: left,
        width_move: width,
        top_move: row_pre,
        height_move: row - row_pre - 1,
        row: [0, row_index],
        column: columnseleted,
        row_focus: 0,
        column_focus: col_index,
        column_select: true
      });
      ctx.luckysheet_select_status = true;
      ctx.luckysheet_scroll_status = true;
    }
  }
}
function handleColSizeHandleMouseDown(ctx, globalCache, e, headerContainer, workbookContainer, cellArea) {
  var _globalCache$freezen7;

  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  ctx.luckysheetCellUpdate = [];
  var scrollLeft = ctx.scrollLeft;
  var scrollTop = ctx.scrollTop;
  var mouseX = e.pageX - headerContainer.getBoundingClientRect().left - window.scrollX;

  var _x = mouseX + scrollLeft;

  var freeze = (_globalCache$freezen7 = globalCache.freezen) === null || _globalCache$freezen7 === void 0 ? void 0 : _globalCache$freezen7[ctx.currentSheetId];

  var _fixPositionOnFrozenC9 = fixPositionOnFrozenCells(freeze, _x, 0, mouseX, 0),
      x = _fixPositionOnFrozenC9.x;

  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col = col_location[1];
  var col_index = col_location[2];
  ctx.luckysheet_cols_change_size = true;
  ctx.luckysheet_scroll_status = true;
  var changeSizeLine = workbookContainer.querySelector(".fortune-change-size-line");

  if (changeSizeLine) {
    var ele = changeSizeLine;
    ele.style.height = "".concat(cellArea.getBoundingClientRect().height + scrollTop, "px");
    ele.style.borderWidth = "0 1px 0 0";
    ele.style.top = "0";
    ele.style.left = "".concat(col - 3, "px");
    ele.style.width = "1px";
  }

  ctx.luckysheet_cols_change_size_start = [_x, col_index];
  e.stopPropagation();
}
function handleRowSizeHandleMouseDown(ctx, globalCache, e, headerContainer, workbookContainer, cellArea) {
  var _globalCache$freezen8;

  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  if (ctx.formulaCache.rangestart || ctx.formulaCache.rangedrag_column_start || ctx.formulaCache.rangedrag_row_start || israngeseleciton(ctx)) return;
  ctx.luckysheetCellUpdate = [];
  var scrollLeft = ctx.scrollLeft;
  var scrollTop = ctx.scrollTop;
  var mouseY = e.pageY - headerContainer.getBoundingClientRect().top - window.scrollY;

  var _y = mouseY + scrollTop;

  var freeze = (_globalCache$freezen8 = globalCache.freezen) === null || _globalCache$freezen8 === void 0 ? void 0 : _globalCache$freezen8[ctx.currentSheetId];

  var _fixPositionOnFrozenC10 = fixPositionOnFrozenCells(freeze, 0, _y, 0, mouseY),
      y = _fixPositionOnFrozenC10.y;

  var row_location = rowLocation(y, ctx.visibledatarow);
  var row = row_location[1];
  var row_index = row_location[2];
  ctx.luckysheet_rows_change_size = true;
  ctx.luckysheet_scroll_status = true;
  var changeSizeLine = workbookContainer.querySelector(".fortune-change-size-line");

  if (changeSizeLine) {
    var ele = changeSizeLine;
    ele.style.width = "".concat(cellArea.getBoundingClientRect().width + scrollLeft, "px");
    ele.style.borderWidth = "0 0 1px 0";
    ele.style.top = "".concat(row - 3, "px");
    ele.style.left = "0";
    ele.style.height = "1px";
  }

  ctx.luckysheet_rows_change_size_start = [_y, row_index];
  e.stopPropagation();
}
function handleColFreezeHandleMouseDown(ctx, globalCache, e, headerContainer, workbookContainer, cellArea) {
  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  ctx.luckysheetCellUpdate = [];
  var scrollLeft = ctx.scrollLeft;
  var scrollTop = ctx.scrollTop;
  var x = e.pageX - headerContainer.getBoundingClientRect().left + scrollLeft;
  var col_location = colLocation(x, ctx.visibledatacolumn);
  var col = col_location[1];
  ctx.luckysheet_cols_freeze_drag = true;
  ctx.luckysheet_scroll_status = true;
  var freezeDragLine = workbookContainer.querySelector(".fortune-freeze-drag-line");

  if (freezeDragLine) {
    var ele = freezeDragLine;
    ele.style.height = "".concat(cellArea.getBoundingClientRect().height + scrollTop, "px");
    ele.style.borderWidth = "0 3px 0 0";
    ele.style.top = "0";
    ele.style.left = "".concat(col - 3, "px");
    ele.style.width = "1px";
  }

  var changeSizeLine = workbookContainer.querySelector(".fortune-change-size-line");

  if (changeSizeLine) {
    var _ele = changeSizeLine;
    _ele.style.height = "".concat(cellArea.getBoundingClientRect().height + scrollTop, "px");
    _ele.style.borderWidth = "0 1px 0 0";
    _ele.style.top = "0";
    _ele.style.left = "".concat(col - 3, "px");
    _ele.style.width = "1px";
  }

  e.stopPropagation();
}
function handleRowFreezeHandleMouseDown(ctx, globalCache, e, headerContainer, workbookContainer, cellArea) {
  removeEditingComment(ctx, globalCache);
  cancelActiveImgItem(ctx, globalCache);
  ctx.luckysheetCellUpdate = [];
  var scrollLeft = ctx.scrollLeft;
  var scrollTop = ctx.scrollTop;
  var y = e.pageY - headerContainer.getBoundingClientRect().top + scrollTop;
  var row_location = rowLocation(y, ctx.visibledatarow);
  var row = row_location[1];
  ctx.luckysheet_rows_freeze_drag = true;
  ctx.luckysheet_scroll_status = true;
  var freezeDragLine = workbookContainer.querySelector(".fortune-freeze-drag-line");

  if (freezeDragLine) {
    var ele = freezeDragLine;
    ele.style.width = "".concat(cellArea.getBoundingClientRect().width + scrollLeft, "px");
    ele.style.borderWidth = "0 0 3px 0";
    ele.style.top = "".concat(row - 3, "px");
    ele.style.left = "0";
    ele.style.height = "1px";
  }

  var changeSizeLine = workbookContainer.querySelector(".fortune-change-size-line");

  if (changeSizeLine) {
    var _ele2 = changeSizeLine;
    _ele2.style.width = "".concat(cellArea.getBoundingClientRect().width + scrollLeft, "px");
    _ele2.style.borderWidth = "0 0 1px 0";
    _ele2.style.top = "".concat(row - 3, "px");
    _ele2.style.left = "0";
    _ele2.style.height = "1px";
  }

  e.stopPropagation();
}

function postPasteCut(ctx, source, target, RowlChange) {
  var execF_rc = {};
  ctx.formulaCache.execFunctionExist = [];

  for (var r = source.range.row[0]; r <= source.range.row[1]; r += 1) {
    for (var c = source.range.column[0]; c <= source.range.column[1]; c += 1) {
      if ("".concat(r, "_").concat(c, "_").concat(source.sheetId) in execF_rc) {
        continue;
      }

      execF_rc["".concat(r, "_").concat(c, "_").concat(source.sheetId)] = 0;
      ctx.formulaCache.execFunctionExist.push({
        r: r,
        c: c,
        i: source.sheetId
      });
    }
  }

  for (var _r = target.range.row[0]; _r <= target.range.row[1]; _r += 1) {
    for (var _c = target.range.column[0]; _c <= target.range.column[1]; _c += 1) {
      if ("".concat(_r, "_").concat(_c, "_").concat(target.sheetId) in execF_rc) {
        continue;
      }

      execF_rc["".concat(_r, "_").concat(_c, "_").concat(target.sheetId)] = 0;
      ctx.formulaCache.execFunctionExist.push({
        r: _r,
        c: _c,
        i: target.sheetId
      });
    }
  }

  var rowHeight;

  if (ctx.currentSheetId === source.sheetId) {
    ctx.config = source.curConfig;
    rowHeight = source.curData.length;
    ctx.luckysheetfile[getSheetIndex(ctx, target.sheetId)].config = target.curConfig;
  } else if (ctx.currentSheetId === target.sheetId) {
    ctx.config = target.curConfig;
    rowHeight = target.curData.length;
    ctx.luckysheetfile[getSheetIndex(ctx, source.sheetId)].config = source.curConfig;
  }

  if (RowlChange) {
    ctx.visibledatarow = [];
    ctx.rh_height = 0;

    for (var i = 0; i < rowHeight; i += 1) {
      var rowlen = ctx.defaultrowlen;

      if (ctx.config.rowlen != null && ctx.config.rowlen[i] != null) {
        rowlen = ctx.config.rowlen[i];
      }

      if (ctx.config.rowhidden != null && ctx.config.rowhidden[i] != null) {
        rowlen = ctx.config.rowhidden[i];
        ctx.visibledatarow.push(ctx.rh_height);
        continue;
      } else {
        ctx.rh_height += rowlen + 1;
      }

      ctx.visibledatarow.push(ctx.rh_height);
    }

    ctx.rh_height += 80;

    if (ctx.currentSheetId === source.sheetId) ; else if (ctx.currentSheetId === target.sheetId) ;
  }

  if (ctx.currentSheetId === source.sheetId) {
    ctx.luckysheetfile[getSheetIndex(ctx, target.sheetId)].data = target.curData;
  } else if (ctx.currentSheetId === target.sheetId) {
    ctx.luckysheetfile[getSheetIndex(ctx, source.sheetId)].data = source.curData;
  }

  if (ctx.currentSheetId === target.sheetId) {
    ctx.luckysheet_select_save = [{
      row: target.range.row,
      column: target.range.column
    }];
  } else {
    ctx.luckysheet_select_save = [{
      row: source.range.row,
      column: source.range.column
    }];
  }

  if (ctx.luckysheet_select_save.length > 0) ;

  ctx.luckysheetfile[getSheetIndex(ctx, source.sheetId)].luckysheet_conditionformat_save = source.curCdformat;
  ctx.luckysheetfile[getSheetIndex(ctx, target.sheetId)].luckysheet_conditionformat_save = target.curCdformat;
  ctx.luckysheetfile[getSheetIndex(ctx, source.sheetId)].dataVerification = source.curDataVerification;
  ctx.luckysheetfile[getSheetIndex(ctx, target.sheetId)].dataVerification = target.curDataVerification;
  ctx.formulaCache.execFunctionExist.reverse();
  execFunctionGroup(ctx, null, null, null, null, target.curData);
  ctx.formulaCache.execFunctionGlobalData = null;
  storeSheetParamALL(ctx);
}

function pasteHandler(ctx, data, borderInfo) {
  var _ctx$luckysheet_selec, _ctx$luckysheet_selec2;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (((_ctx$luckysheet_selec = (_ctx$luckysheet_selec2 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec2 === void 0 ? void 0 : _ctx$luckysheet_selec2.length) !== null && _ctx$luckysheet_selec !== void 0 ? _ctx$luckysheet_selec : 0) !== 1) {
    return;
  }

  if (_typeof(data) === "object") {
    if (data.length === 0) {
      return;
    }

    var cfg = ctx.config || {};

    if (cfg.merge == null) {
      cfg.merge = {};
    }

    if (JSON.stringify(borderInfo).length > 2 && cfg.borderInfo == null) {
      cfg.borderInfo = [];
    }

    var copyh = data.length;
    var copyc = data[0].length;
    var minh = ctx.luckysheet_select_save[0].row[0];
    var maxh = minh + copyh - 1;
    var minc = ctx.luckysheet_select_save[0].column[0];
    var maxc = minc + copyc - 1;
    var has_PartMC = false;

    if (cfg.merge != null) {
      has_PartMC = hasPartMC(ctx, cfg, minh, maxh, minc, maxc);
    }

    if (has_PartMC) {
      return;
    }

    var d = getFlowdata(ctx);
    if (!d) return;
    var rowMaxLength = d.length;
    var cellMaxLength = d[0].length;
    var addr = maxh - rowMaxLength + 1;
    var addc = maxc - cellMaxLength + 1;

    if (addr > 0 || addc > 0) {
      expandRowsAndColumns(d, addr, addc);
    }

    if (!d) return;

    if (cfg.rowlen == null) {
      cfg.rowlen = {};
    }

    var RowlChange = false;
    var offsetMC = {};

    for (var h = minh; h <= maxh; h += 1) {
      var x = d[h];
      var currentRowLen = ctx.defaultrowlen;

      if (cfg.rowlen[h] != null) {
        currentRowLen = cfg.rowlen[h];
      }

      for (var c = minc; c <= maxc; c += 1) {
        var _x$c, _x$c2;

        if (x === null || x === void 0 ? void 0 : (_x$c = x[c]) === null || _x$c === void 0 ? void 0 : _x$c.mc) {
          if ("rs" in x[c].mc) {
            delete cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)];
          }

          delete x[c].mc;
        }

        var value = null;

        if (data[h - minh] != null && data[h - minh][c - minc] != null) {
          value = data[h - minh][c - minc];
        }

        x[c] = value;

        if (value != null && (x === null || x === void 0 ? void 0 : (_x$c2 = x[c]) === null || _x$c2 === void 0 ? void 0 : _x$c2.mc)) {
          if (x[c].mc.rs != null) {
            x[c].mc.r = h;
            x[c].mc.c = c;
            cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)] = x[c].mc;
            offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)] = [x[c].mc.r, x[c].mc.c];
          } else {
            x[c] = {
              mc: {
                r: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][0],
                c: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][1]
              }
            };
          }
        }

        if (borderInfo["".concat(h - minh, "_").concat(c - minc)]) {
          var _cfg$borderInfo;

          var bd_obj = {
            rangeType: "cell",
            value: {
              row_index: h,
              col_index: c,
              l: borderInfo["".concat(h - minh, "_").concat(c - minc)].l,
              r: borderInfo["".concat(h - minh, "_").concat(c - minc)].r,
              t: borderInfo["".concat(h - minh, "_").concat(c - minc)].t,
              b: borderInfo["".concat(h - minh, "_").concat(c - minc)].b
            }
          };
          (_cfg$borderInfo = cfg.borderInfo) === null || _cfg$borderInfo === void 0 ? void 0 : _cfg$borderInfo.push(bd_obj);
        }
      }

      d[h] = x;

      if (currentRowLen !== ctx.defaultrowlen) {
        cfg.rowlen[h] = currentRowLen;
      }
    }

    ctx.luckysheet_select_save = [{
      row: [minh, maxh],
      column: [minc, maxc]
    }];

    if (addr > 0 || addc > 0 || RowlChange) {
      ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].config = cfg;
    } else {
      ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].config = cfg;
    }

    jfrefreshgrid(ctx, null, undefined);
  } else {
    var _ctx$luckysheet_selec3;

    data = data.replace(/\r/g, "");
    var dataChe = [];
    var che = data.split("\n");
    var colchelen = che[0].split("\t").length;

    for (var i = 0; i < che.length; i += 1) {
      if (che[i].split("\t").length < colchelen) {
        continue;
      }

      dataChe.push(che[i].split("\t"));
    }

    var _d = getFlowdata(ctx);

    if (!_d) return;
    var last = (_ctx$luckysheet_selec3 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec3 === void 0 ? void 0 : _ctx$luckysheet_selec3[ctx.luckysheet_select_save.length - 1];
    if (!last) return;
    var curR = last.row == null ? 0 : last.row[0];
    var curC = last.column == null ? 0 : last.column[0];
    var rlen = dataChe.length;
    var clen = dataChe[0].length;
    var _has_PartMC = false;

    if (ctx.config.merge != null) {
      _has_PartMC = hasPartMC(ctx, ctx.config, curR, curR + rlen - 1, curC, curC + clen - 1);
    }

    if (_has_PartMC) {
      return;
    }

    var _addr = curR + rlen - _d.length;

    var _addc = curC + clen - _d[0].length;

    if (_addr > 0 || _addc > 0) {
      expandRowsAndColumns(_d, _addr, _addc);
    }

    if (!_d) return;

    for (var r = 0; r < rlen; r += 1) {
      var _x = _d[r + curR];

      for (var _c2 = 0; _c2 < clen; _c2 += 1) {
        var originCell = _x[_c2 + curC];
        var _value = dataChe[r][_c2];

        if (isRealNum(_value)) {
          if (originCell && originCell.ct && originCell.ct.fa === "@") {
            _value = String(_value);
          } else {
            _value = parseFloat(_value);
          }
        }

        if (originCell) {
          originCell.v = _value;

          if (originCell.ct != null && originCell.ct.fa != null) {
            originCell.m = update(originCell.ct.fa, _value);
          } else {
            originCell.m = _value;
          }

          if (originCell.f != null && originCell.f.length > 0) {
            originCell.f = "";
            delFunctionGroup(ctx, r + curR, _c2 + curC, ctx.currentSheetId);
          }
        } else {
          var cell = {};
          var mask = genarate(_value);

          var _mask = _slicedToArray(mask, 3);

          cell.m = _mask[0];
          cell.ct = _mask[1];
          cell.v = _mask[2];
          _x[_c2 + curC] = cell;
        }
      }

      _d[r + curR] = _x;
    }

    last.row = [curR, curR + rlen - 1];
    last.column = [curC, curC + clen - 1];
    jfrefreshgrid(ctx, null, undefined);
  }
}

function setCellHyperlink(ctx, id, r, c, link) {
  var index = getSheetIndex(ctx, id);

  if (!ctx.luckysheetfile[index].hyperlink) {
    ctx.luckysheetfile[index].hyperlink = {};
  }

  ctx.luckysheetfile[index].hyperlink["".concat(r, "_").concat(c)] = link;
}

function pasteHandlerOfCutPaste(ctx, copyRange) {
  var _ctx$luckysheet_selec4, _ctx$luckysheet_selec5, _ctx$luckysheet_copy_;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  if (!copyRange) return;
  var cfg = ctx.config || {};

  if (cfg.merge == null) {
    cfg.merge = {};
  }

  var copyHasMC = copyRange.HasMC;
  var copyRowlChange = copyRange.RowlChange;
  var copySheetId = copyRange.dataSheetId;
  var c_r1 = copyRange.copyRange[0].row[0];
  var c_r2 = copyRange.copyRange[0].row[1];
  var c_c1 = copyRange.copyRange[0].column[0];
  var c_c2 = copyRange.copyRange[0].column[1];

  var copyData = _.cloneDeep(getdatabyselection(ctx, {
    row: [c_r1, c_r2],
    column: [c_c1, c_c2]
  }, copySheetId));

  var copyh = copyData.length;
  var copyc = copyData[0].length;
  var last = (_ctx$luckysheet_selec4 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec4 === void 0 ? void 0 : _ctx$luckysheet_selec4[ctx.luckysheet_select_save.length - 1];
  if (!last || last.row_focus == null || last.column_focus == null) return;
  var minh = last.row_focus;
  var maxh = minh + copyh - 1;
  var minc = last.column_focus;
  var maxc = minc + copyc - 1;
  var has_PartMC = false;

  if (cfg.merge != null) {
    has_PartMC = hasPartMC(ctx, cfg, minh, maxh, minc, maxc);
  }

  if (has_PartMC) {
    return;
  }

  var d = getFlowdata(ctx);
  if (!d) return;
  var rowMaxLength = d.length;
  var cellMaxLength = d[0].length;
  var addr = copyh + minh - rowMaxLength;
  var addc = copyc + minc - cellMaxLength;

  if (addr > 0 || addc > 0) {
    expandRowsAndColumns(d, addr, addc);
  }

  var borderInfoCompute = getBorderInfoCompute(ctx, copySheetId);
  var c_dataVerification = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetId)].dataVerification) || {};
  var dataVerification = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification) || {};

  if (((_ctx$luckysheet_selec5 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec5 === void 0 ? void 0 : _ctx$luckysheet_selec5.length) === 1 && ((_ctx$luckysheet_copy_ = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_ === void 0 ? void 0 : _ctx$luckysheet_copy_.copyRange.length) === 1) {
    var _ctx$luckysheet_copy_2;

    _.forEach((_ctx$luckysheet_copy_2 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_2 === void 0 ? void 0 : _ctx$luckysheet_copy_2.copyRange, function (range) {
      for (var r = 0; r <= range.row[1] - range.row[0]; r += 1) {
        for (var c = 0; c <= range.column[1] - range.column[0]; c += 1) {
          var _ctx$luckysheet_copy_3, _ctx$luckysheetfile$i;

          var index = getSheetIndex(ctx, (_ctx$luckysheet_copy_3 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_3 === void 0 ? void 0 : _ctx$luckysheet_copy_3.dataSheetId);

          if (((_ctx$luckysheetfile$i = ctx.luckysheetfile[index].data[r + range.row[0]][c + range.column[0]]) === null || _ctx$luckysheetfile$i === void 0 ? void 0 : _ctx$luckysheetfile$i.hl) && ctx.luckysheetfile[index].hyperlink["".concat(r, "_").concat(c)]) {
            var _ctx$luckysheet_copy_4;

            setCellHyperlink(ctx, (_ctx$luckysheet_copy_4 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_4 === void 0 ? void 0 : _ctx$luckysheet_copy_4.dataSheetId, r + ctx.luckysheet_select_save[0].row[0], c + ctx.luckysheet_select_save[0].column[0], ctx.luckysheetfile[index].hyperlink["".concat(r, "_").concat(c)]);
          }
        }
      }
    });
  }

  if (ctx.currentSheetId === copySheetId) {
    for (var i = c_r1; i <= c_r2; i += 1) {
      for (var j = c_c1; j <= c_c2; j += 1) {
        var _ctx$luckysheetfile$g;

        var cell = d[i][j];

        if (cell && _.isPlainObject(cell) && "mc" in cell) {
          var _cell$mc;

          if (((_cell$mc = cell.mc) === null || _cell$mc === void 0 ? void 0 : _cell$mc.rs) != null) {
            delete cfg.merge["".concat(cell.mc.r, "_").concat(cell.mc.c)];
          }

          delete cell.mc;
        }

        d[i][j] = null;
        delete dataVerification["".concat(i, "_").concat(j)];
        (_ctx$luckysheetfile$g = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].hyperlink) === null || _ctx$luckysheetfile$g === void 0 ? true : delete _ctx$luckysheetfile$g["".concat(i, "_").concat(j)];
      }
    }

    if (cfg.borderInfo && cfg.borderInfo.length > 0) {
      var source_borderInfo = [];

      for (var _i = 0; _i < cfg.borderInfo.length; _i += 1) {
        var bd_rangeType = cfg.borderInfo[_i].rangeType;

        if (bd_rangeType === "range") {
          var bd_range = cfg.borderInfo[_i].range;
          var bd_emptyRange = [];

          for (var _j = 0; _j < bd_range.length; _j += 1) {
            bd_emptyRange = bd_emptyRange.concat(CFSplitRange(bd_range[_j], {
              row: [c_r1, c_r2],
              column: [c_c1, c_c2]
            }, {
              row: [minh, maxh],
              column: [minc, maxc]
            }, "restPart"));
          }

          cfg.borderInfo[_i].range = bd_emptyRange;
          source_borderInfo.push(cfg.borderInfo[_i]);
        } else if (bd_rangeType === "cell") {
          var bd_r = cfg.borderInfo[_i].value.row_index;
          var bd_c = cfg.borderInfo[_i].value.col_index;

          if (!(bd_r >= c_r1 && bd_r <= c_r2 && bd_c >= c_c1 && bd_c <= c_c2)) {
            source_borderInfo.push(cfg.borderInfo[_i]);
          }
        }
      }

      cfg.borderInfo = source_borderInfo;
    }
  }

  var offsetMC = {};

  for (var h = minh; h <= maxh; h += 1) {
    var x = d[h];

    for (var c = minc; c <= maxc; c += 1) {
      var _x$c3, _x$c5;

      if (borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)] && !borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].s) {
        var bd_obj = {
          rangeType: "cell",
          value: {
            row_index: h,
            col_index: c,
            l: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].l,
            r: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].r,
            t: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].t,
            b: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].b
          }
        };

        if (cfg.borderInfo == null) {
          cfg.borderInfo = [];
        }

        cfg.borderInfo.push(bd_obj);
      } else if (borderInfoCompute["".concat(h, "_").concat(c)]) {
        var _bd_obj = {
          rangeType: "cell",
          value: {
            row_index: h,
            col_index: c,
            l: null,
            r: null,
            t: null,
            b: null
          }
        };

        if (cfg.borderInfo == null) {
          cfg.borderInfo = [];
        }

        cfg.borderInfo.push(_bd_obj);
      } else if (borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)]) {
        var _bd_obj2 = {
          rangeType: "range",
          borderType: "border-slash",
          color: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].s.color,
          style: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].s.style,
          range: normalizeSelection(ctx, [{
            row: [h, h],
            column: [c, c]
          }])
        };

        if (cfg.borderInfo == null) {
          cfg.borderInfo = [];
        }

        cfg.borderInfo.push(_bd_obj2);
      }

      if (c_dataVerification["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)]) {
        dataVerification["".concat(h, "_").concat(c)] = c_dataVerification["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)];
      }

      if ((_x$c3 = x[c]) === null || _x$c3 === void 0 ? void 0 : _x$c3.mc) {
        var _x$c4, _x$c4$mc;

        if (((_x$c4 = x[c]) === null || _x$c4 === void 0 ? void 0 : (_x$c4$mc = _x$c4.mc) === null || _x$c4$mc === void 0 ? void 0 : _x$c4$mc.rs) != null) {
          delete cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)];
        }

        delete x[c].mc;
      }

      var value = null;

      if (copyData[h - minh] != null && copyData[h - minh][c - minc] != null) {
        value = copyData[h - minh][c - minc];
      }

      x[c] = _.cloneDeep(value);

      if (value != null && copyHasMC && ((_x$c5 = x[c]) === null || _x$c5 === void 0 ? void 0 : _x$c5.mc)) {
        if (x[c].mc.rs != null) {
          x[c].mc.r = h;
          x[c].mc.c = c;
          cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)] = x[c].mc;
          offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)] = [x[c].mc.r, x[c].mc.c];
        } else {
          x[c] = {
            mc: {
              r: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][0],
              c: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][1]
            }
          };
        }
      }
    }

    d[h] = x;
  }

  last.row = [minh, maxh];
  last.column = [minc, maxc];

  var source;
  var target;

  if (ctx.currentSheetId !== copySheetId) {
    var sourceData = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetId)].data);

    var sourceConfig = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetId)].config);

    var sourceCurData = _.cloneDeep(sourceData);

    var sourceCurConfig = _.cloneDeep(sourceConfig) || {};

    if (sourceCurConfig.merge == null) {
      sourceCurConfig.merge = {};
    }

    for (var source_r = c_r1; source_r <= c_r2; source_r += 1) {
      for (var source_c = c_c1; source_c <= c_c2; source_c += 1) {
        var _cell = sourceCurData[source_r][source_c];

        if (_cell === null || _cell === void 0 ? void 0 : _cell.mc) {
          if ("rs" in _cell.mc) {
            delete sourceCurConfig.merge["".concat(_cell.mc.r, "_").concat(_cell.mc.c)];
          }

          delete _cell.mc;
        }

        sourceCurData[source_r][source_c] = null;
      }
    }

    if (sourceCurConfig.borderInfo && sourceCurConfig.borderInfo.length > 0) {
      var _source_borderInfo = [];

      for (var _i2 = 0; _i2 < sourceCurConfig.borderInfo.length; _i2 += 1) {
        var _bd_rangeType = sourceCurConfig.borderInfo[_i2].rangeType;

        if (_bd_rangeType === "range") {
          var _bd_range = sourceCurConfig.borderInfo[_i2].range;
          var _bd_emptyRange = [];

          for (var _j2 = 0; _j2 < _bd_range.length; _j2 += 1) {
            _bd_emptyRange = _bd_emptyRange.concat(CFSplitRange(_bd_range[_j2], {
              row: [c_r1, c_r2],
              column: [c_c1, c_c2]
            }, {
              row: [minh, maxh],
              column: [minc, maxc]
            }, "restPart"));
          }

          sourceCurConfig.borderInfo[_i2].range = _bd_emptyRange;

          _source_borderInfo.push(sourceCurConfig.borderInfo[_i2]);
        } else if (_bd_rangeType === "cell") {
          var _bd_r = sourceCurConfig.borderInfo[_i2].value.row_index;
          var _bd_c = sourceCurConfig.borderInfo[_i2].value.col_index;

          if (!(_bd_r >= c_r1 && _bd_r <= c_r2 && _bd_c >= c_c1 && _bd_c <= c_c2)) {
            _source_borderInfo.push(sourceCurConfig.borderInfo[_i2]);
          }
        }
      }

      sourceCurConfig.borderInfo = _source_borderInfo;
    }

    var source_cdformat = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetId)].luckysheet_conditionformat_save);

    var source_curCdformat = _.cloneDeep(source_cdformat);

    var ruleArr = [];

    if (source_curCdformat != null && source_curCdformat.length > 0) {
      for (var _i3 = 0; _i3 < source_curCdformat.length; _i3 += 1) {
        var source_curCdformat_cellrange = source_curCdformat[_i3].cellrange;
        var emptyRange = [];
        var emptyRange2 = [];

        for (var _j3 = 0; _j3 < source_curCdformat_cellrange.length; _j3 += 1) {
          var range = CFSplitRange(source_curCdformat_cellrange[_j3], {
            row: [c_r1, c_r2],
            column: [c_c1, c_c2]
          }, {
            row: [minh, maxh],
            column: [minc, maxc]
          }, "restPart");
          emptyRange = emptyRange.concat(range);
          var range2 = CFSplitRange(source_curCdformat_cellrange[_j3], {
            row: [c_r1, c_r2],
            column: [c_c1, c_c2]
          }, {
            row: [minh, maxh],
            column: [minc, maxc]
          }, "operatePart");

          if (range2.length > 0) {
            emptyRange2 = emptyRange2.concat(range2);
          }
        }

        source_curCdformat[_i3].cellrange = emptyRange;

        if (emptyRange2.length > 0) {
          var _source_curCdformat$_;

          var ruleObj = (_source_curCdformat$_ = source_curCdformat[_i3]) !== null && _source_curCdformat$_ !== void 0 ? _source_curCdformat$_ : {};
          ruleObj.cellrange = emptyRange2;
          ruleArr.push(ruleObj);
        }
      }
    }

    var target_cdformat = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].luckysheet_conditionformat_save);

    var target_curCdformat = _.cloneDeep(target_cdformat);

    if (ruleArr.length > 0) {
      var _target_curCdformat;

      target_curCdformat = (_target_curCdformat = target_curCdformat) === null || _target_curCdformat === void 0 ? void 0 : _target_curCdformat.concat(ruleArr);
    }

    for (var _i4 = c_r1; _i4 <= c_r2; _i4 += 1) {
      for (var _j4 = c_c1; _j4 <= c_c2; _j4 += 1) {
        delete c_dataVerification["".concat(_i4, "_").concat(_j4)];
      }
    }

    source = {
      sheetId: copySheetId,
      data: sourceData,
      curData: sourceCurData,
      config: sourceConfig,
      curConfig: sourceCurConfig,
      cdformat: source_cdformat,
      curCdformat: source_curCdformat,
      dataVerification: _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetId)].dataVerification),
      curDataVerification: c_dataVerification,
      range: {
        row: [c_r1, c_r2],
        column: [c_c1, c_c2]
      }
    };
    target = {
      sheetId: ctx.currentSheetId,
      data: getFlowdata(ctx),
      curData: d,
      config: _.cloneDeep(ctx.config),
      curConfig: cfg,
      cdformat: target_cdformat,
      curCdformat: target_curCdformat,
      dataVerification: _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification),
      curDataVerification: dataVerification,
      range: {
        row: [minh, maxh],
        column: [minc, maxc]
      }
    };
  } else {
    var cdformat = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].luckysheet_conditionformat_save);

    var curCdformat = _.cloneDeep(cdformat);

    if (curCdformat != null && curCdformat.length > 0) {
      for (var _i5 = 0; _i5 < curCdformat.length; _i5 += 1) {
        var cellrange = curCdformat[_i5].cellrange;
        var _emptyRange = [];

        for (var _j5 = 0; _j5 < cellrange.length; _j5 += 1) {
          var _range = CFSplitRange(cellrange[_j5], {
            row: [c_r1, c_r2],
            column: [c_c1, c_c2]
          }, {
            row: [minh, maxh],
            column: [minc, maxc]
          }, "allPart");

          _emptyRange = _emptyRange.concat(_range);
        }

        curCdformat[_i5].cellrange = _emptyRange;
      }
    }

    source = {
      sheetId: ctx.currentSheetId,
      data: getFlowdata(ctx),
      curData: d,
      config: _.cloneDeep(ctx.config),
      curConfig: cfg,
      cdformat: cdformat,
      curCdformat: curCdformat,
      dataVerification: _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification),
      curDataVerification: dataVerification,
      range: {
        row: [c_r1, c_r2],
        column: [c_c1, c_c2]
      }
    };
    target = {
      sheetId: ctx.currentSheetId,
      data: getFlowdata(ctx),
      curData: d,
      config: _.cloneDeep(ctx.config),
      curConfig: cfg,
      cdformat: cdformat,
      curCdformat: curCdformat,
      dataVerification: _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)].dataVerification),
      curDataVerification: dataVerification,
      range: {
        row: [minh, maxh],
        column: [minc, maxc]
      }
    };
  }

  if (addr > 0 || addc > 0) {
    postPasteCut(ctx, source, target, true);
  } else {
    postPasteCut(ctx, source, target, copyRowlChange);
  }
}

function pasteHandlerOfCopyPaste(ctx, copyRange) {
  var _ctx$luckysheet_selec6, _file$config, _file$config2, _ctx$luckysheet_selec7, _ctx$luckysheet_copy_5;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  if (!copyRange) return;
  var cfg = ctx.config;

  if (_.isNil(cfg.merge)) {
    cfg.merge = {};
  }

  var copyHasMC = copyRange.HasMC;
  var copyRowlChange = copyRange.RowlChange;
  var copySheetIndex = copyRange.dataSheetId;
  var c_r1 = copyRange.copyRange[0].row[0];
  var c_r2 = copyRange.copyRange[0].row[1];
  var c_c1 = copyRange.copyRange[0].column[0];
  var c_c2 = copyRange.copyRange[0].column[1];
  var arr = [];
  var isSameRow = false;

  var _loop = function _loop(i) {
    var arrData = getdatabyselection(ctx, {
      row: copyRange.copyRange[i].row,
      column: copyRange.copyRange[i].column
    }, copySheetIndex);

    if (copyRange.copyRange.length > 1) {
      if (c_r1 === copyRange.copyRange[1].row[0] && c_r2 === copyRange.copyRange[1].row[1]) {
        arrData = arrData[0].map(function (col, a) {
          return arrData.map(function (row) {
            return row[a];
          });
        });
        arr = arr.concat(arrData);
        isSameRow = true;
      } else if (c_c1 === copyRange.copyRange[1].column[0] && c_c2 === copyRange.copyRange[1].column[1]) {
        arr = arr.concat(arrData);
      }
    } else {
      arr = arrData;
    }
  };

  for (var i = 0; i < copyRange.copyRange.length; i += 1) {
    _loop(i);
  }

  if (isSameRow) {
    arr = arr[0].map(function (col, b) {
      return arr.map(function (row) {
        return row[b];
      });
    });
  }

  var copyData = _.cloneDeep(arr);

  if (copyRange.copyRange.length > 1) {
    for (var _i6 = 0; _i6 < copyData.length; _i6 += 1) {
      for (var j = 0; j < copyData[_i6].length; j += 1) {
        if (copyData[_i6][j] != null && copyData[_i6][j].f != null) {
          delete copyData[_i6][j].f;
          delete copyData[_i6][j].spl;
        }
      }
    }
  }

  var copyh = copyData.length;
  var copyc = copyData[0].length;
  var last = (_ctx$luckysheet_selec6 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec6 === void 0 ? void 0 : _ctx$luckysheet_selec6[ctx.luckysheet_select_save.length - 1];
  if (!last) return;
  var minh = last.row[0];
  var maxh = last.row[1];
  var minc = last.column[0];
  var maxc = last.column[1];
  var mh = (maxh - minh + 1) % copyh;
  var mc = (maxc - minc + 1) % copyc;

  if (mh !== 0 || mc !== 0) {
    maxh = minh + copyh - 1;
    maxc = minc + copyc - 1;
  }

  var has_PartMC = false;

  if (!_.isNil(cfg.merge)) {
    has_PartMC = hasPartMC(ctx, cfg, minh, maxh, minc, maxc);
  }

  if (has_PartMC) {
    return;
  }

  var timesH = (maxh - minh + 1) / copyh;
  var timesC = (maxc - minc + 1) / copyc;
  var d = getFlowdata(ctx);
  if (!d) return;
  var rowMaxLength = d.length;
  var cellMaxLength = d[0].length;
  var addr = copyh + minh - rowMaxLength;
  var addc = copyc + minc - cellMaxLength;

  if (addr > 0 || addc > 0) {
    expandRowsAndColumns(d, addr, addc);
  }

  var borderInfoCompute = getBorderInfoCompute(ctx, copySheetIndex);
  var c_dataVerification = _.cloneDeep(ctx.luckysheetfile[getSheetIndex(ctx, copySheetIndex)].dataVerification) || {};
  var dataVerification = null;
  var mth = 0;
  var mtc = 0;
  var maxcellCahe = 0;
  var maxrowCache = 0;
  var file = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)];
  var hiddenRows = new Set(Object.keys(((_file$config = file.config) === null || _file$config === void 0 ? void 0 : _file$config.rowhidden) || {}));
  var hiddenCols = new Set(Object.keys(((_file$config2 = file.config) === null || _file$config2 === void 0 ? void 0 : _file$config2.colhidden) || {}));

  for (var th = 1; th <= timesH; th += 1) {
    for (var tc = 1; tc <= timesC; tc += 1) {
      mth = minh + (th - 1) * copyh;
      mtc = minc + (tc - 1) * copyc;
      maxrowCache = minh + th * copyh;
      maxcellCahe = minc + tc * copyc;
      var offsetRow = mth - c_r1;
      var offsetCol = mtc - c_c1;
      var offsetMC = {};

      for (var h = mth; h < maxrowCache; h += 1) {
        if (hiddenRows === null || hiddenRows === void 0 ? void 0 : hiddenRows.has(h.toString())) continue;
        var x = d[h];

        for (var c = mtc; c < maxcellCahe; c += 1) {
          var _x$c6, _copyData, _x$c7;

          if (hiddenCols === null || hiddenCols === void 0 ? void 0 : hiddenCols.has(c.toString())) continue;

          if (borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)] && !borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].s) {
            var bd_obj = {
              rangeType: "cell",
              value: {
                row_index: h,
                col_index: c,
                l: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].l,
                r: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].r,
                t: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].t,
                b: borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)].b
              }
            };

            if (_.isNil(cfg.borderInfo)) {
              cfg.borderInfo = [];
            }

            cfg.borderInfo.push(bd_obj);
          } else if (borderInfoCompute["".concat(h, "_").concat(c)]) {
            var _bd_obj3 = {
              rangeType: "cell",
              value: {
                row_index: h,
                col_index: c,
                l: null,
                r: null,
                t: null,
                b: null
              }
            };

            if (_.isNil(cfg.borderInfo)) {
              cfg.borderInfo = [];
            }

            cfg.borderInfo.push(_bd_obj3);
          } else if (borderInfoCompute["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)]) {
            var _bd_obj4 = {
              rangeType: "range",
              borderType: "border-slash",
              color: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].s.color,
              style: borderInfoCompute["".concat(c_r1 + h - minh, "_").concat(c_c1 + c - minc)].s.style,
              range: normalizeSelection(ctx, [{
                row: [h, h],
                column: [c, c]
              }])
            };

            if (cfg.borderInfo == null) {
              cfg.borderInfo = [];
            }

            cfg.borderInfo.push(_bd_obj4);
          }

          if (c_dataVerification["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)]) {
            if (_.isNil(dataVerification)) {
              var _ctx$luckysheetfile$g2;

              dataVerification = _.cloneDeep(((_ctx$luckysheetfile$g2 = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)]) === null || _ctx$luckysheetfile$g2 === void 0 ? void 0 : _ctx$luckysheetfile$g2.dataVerification) || {});
            }

            dataVerification["".concat(h, "_").concat(c)] = c_dataVerification["".concat(c_r1 + h - mth, "_").concat(c_c1 + c - mtc)];
          }

          if (((_x$c6 = x[c]) === null || _x$c6 === void 0 ? void 0 : _x$c6.mc) != null) {
            if ("rs" in x[c].mc) {
              delete cfg.merge["".concat(x[c].mc.r, "_").concat(x[c].mc.c)];
            }

            delete x[c].mc;
          }

          var value = null;

          if ((_copyData = copyData[h - mth]) === null || _copyData === void 0 ? void 0 : _copyData[c - mtc]) {
            value = _.cloneDeep(copyData[h - mth][c - mtc]);
          }

          if (!_.isNil(value) && !_.isNil(value.f)) {
            var func = value.f;

            if (offsetRow > 0) {
              func = "=".concat(functionCopy(ctx, func, "down", offsetRow));
            }

            if (offsetRow < 0) {
              func = "=".concat(functionCopy(ctx, func, "up", Math.abs(offsetRow)));
            }

            if (offsetCol > 0) {
              func = "=".concat(functionCopy(ctx, func, "right", offsetCol));
            }

            if (offsetCol < 0) {
              func = "=".concat(functionCopy(ctx, func, "left", Math.abs(offsetCol)));
            }

            var funcV = execfunction(ctx, func, h, c, undefined, undefined, true);

            if (!_.isNil(value.spl)) ; else {
              var _funcV = _slicedToArray(funcV, 3);

              value.v = _funcV[1];
              value.f = _funcV[2];

              if (!_.isNil(value.ct) && !_.isNil(value.ct.fa)) {
                value.m = update(value.ct.fa, funcV[1]);
              } else {
                value.m = update("General", funcV[1]);
              }
            }
          }

          x[c] = _.cloneDeep(value);

          if (value != null && copyHasMC && (x === null || x === void 0 ? void 0 : (_x$c7 = x[c]) === null || _x$c7 === void 0 ? void 0 : _x$c7.mc)) {
            var _x$c8, _x$c8$mc;

            if ((x === null || x === void 0 ? void 0 : (_x$c8 = x[c]) === null || _x$c8 === void 0 ? void 0 : (_x$c8$mc = _x$c8.mc) === null || _x$c8$mc === void 0 ? void 0 : _x$c8$mc.rs) != null) {
              x[c].mc.r = h;
              x[c].mc.c = c;
              cfg.merge["".concat(h, "_").concat(c)] = x[c].mc;
              offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)] = [x[c].mc.r, x[c].mc.c];
            } else {
              x[c] = {
                mc: {
                  r: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][0],
                  c: offsetMC["".concat(value.mc.r, "_").concat(value.mc.c)][1]
                }
              };
            }
          }
        }

        d[h] = x;
      }
    }
  }

  var cdformat = null;

  if (copyRange.copyRange.length === 1) {
    var c_file = ctx.luckysheetfile[getSheetIndex(ctx, copySheetIndex)];
    var a_file = ctx.luckysheetfile[getSheetIndex(ctx, ctx.currentSheetId)];

    var ruleArr_cf = _.cloneDeep(c_file.luckysheet_conditionformat_save);

    if (!_.isNil(ruleArr_cf) && ruleArr_cf.length > 0) {
      var _$cloneDeep;

      cdformat = (_$cloneDeep = _.cloneDeep(a_file.luckysheet_conditionformat_save)) !== null && _$cloneDeep !== void 0 ? _$cloneDeep : [];

      for (var _i7 = 0; _i7 < ruleArr_cf.length; _i7 += 1) {
        var cf_range = ruleArr_cf[_i7].cellrange;
        var emptyRange = [];

        for (var _th = 1; _th <= timesH; _th += 1) {
          for (var _tc = 1; _tc <= timesC; _tc += 1) {
            mth = minh + (_th - 1) * copyh;
            mtc = minc + (_tc - 1) * copyc;
            maxrowCache = minh + _th * copyh;
            maxcellCahe = minc + _tc * copyc;

            for (var _j6 = 0; _j6 < cf_range.length; _j6 += 1) {
              var range = CFSplitRange(cf_range[_j6], {
                row: [c_r1, c_r2],
                column: [c_c1, c_c2]
              }, {
                row: [mth, maxrowCache - 1],
                column: [mtc, maxcellCahe - 1]
              }, "operatePart");

              if (range.length > 0) {
                emptyRange = emptyRange.concat(range);
              }
            }
          }
        }

        if (emptyRange.length > 0) {
          ruleArr_cf[_i7].cellrange = emptyRange;
          cdformat.push(ruleArr_cf[_i7]);
        }
      }
    }
  }

  last.row = [minh, maxh];
  last.column = [minc, maxc];
  file.config = cfg;
  file.luckysheet_conditionformat_save = cdformat;
  file.dataVerification = _objectSpread2(_objectSpread2({}, file.dataVerification), dataVerification);

  if (((_ctx$luckysheet_selec7 = ctx.luckysheet_select_save) === null || _ctx$luckysheet_selec7 === void 0 ? void 0 : _ctx$luckysheet_selec7.length) === 1 && ((_ctx$luckysheet_copy_5 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_5 === void 0 ? void 0 : _ctx$luckysheet_copy_5.copyRange.length) === 1) {
    var _ctx$luckysheet_copy_6;

    _.forEach((_ctx$luckysheet_copy_6 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_6 === void 0 ? void 0 : _ctx$luckysheet_copy_6.copyRange, function (range) {
      for (var r = 0; r <= range.row[1] - range.row[0]; r += 1) {
        for (var _c3 = 0; _c3 <= range.column[1] - range.column[0]; _c3 += 1) {
          var _ctx$luckysheet_copy_7, _ctx$luckysheetfile$i2;

          var index = getSheetIndex(ctx, (_ctx$luckysheet_copy_7 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_7 === void 0 ? void 0 : _ctx$luckysheet_copy_7.dataSheetId);

          if (((_ctx$luckysheetfile$i2 = ctx.luckysheetfile[index].data[r + range.row[0]][_c3 + range.column[0]]) === null || _ctx$luckysheetfile$i2 === void 0 ? void 0 : _ctx$luckysheetfile$i2.hl) && ctx.luckysheetfile[index].hyperlink["".concat(r, "_").concat(_c3)]) {
            var _ctx$luckysheet_copy_8;

            setCellHyperlink(ctx, (_ctx$luckysheet_copy_8 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_8 === void 0 ? void 0 : _ctx$luckysheet_copy_8.dataSheetId, r + ctx.luckysheet_select_save[0].row[0], _c3 + ctx.luckysheet_select_save[0].column[0], ctx.luckysheetfile[index].hyperlink["".concat(r, "_").concat(_c3)]);
          }
        }
      }
    });
  }

  if (copyRowlChange || addr > 0 || addc > 0) {
    jfrefreshgrid(ctx, d, ctx.luckysheet_select_save);
  } else {
    jfrefreshgrid(ctx, d, ctx.luckysheet_select_save);
  }
}

function handleFormulaStringPaste(ctx, formulaStr) {
  var r = ctx.luckysheet_select_save[0].row[0];
  var c = ctx.luckysheet_select_save[0].column[0];
  var funcV = execfunction(ctx, formulaStr, r, c, undefined, undefined, true);
  var val = funcV[1];
  var d = getFlowdata(ctx);
  if (!d) return;
  if (!d[r][c]) d[r][c] = {};
  d[r][c].m = val.toString();
  d[r][c].v = val;
  d[r][c].f = formulaStr;
}

function handlePaste(ctx, e) {
  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;

  if (selectionCache.isPasteAction) {
    var _ctx$luckysheet_copy_9, _ctx$hooks$beforePast, _ctx$hooks, _ctx$luckysheet_copy_10;

    ctx.luckysheetCellUpdate = [];
    selectionCache.isPasteAction = false;
    var clipboardData = e.clipboardData;

    if (!clipboardData) {
      clipboardData = window.clipboardData;
    }

    if (!clipboardData) return;
    var txtdata = clipboardData.getData("text/html") || clipboardData.getData("text/plain");
    var isEqual = true;

    if (txtdata.indexOf("fortune-copy-action-table") > -1 && ((_ctx$luckysheet_copy_9 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_9 === void 0 ? void 0 : _ctx$luckysheet_copy_9.copyRange) != null && ctx.luckysheet_copy_save.copyRange.length > 0) {
      var cpDataArr = [];
      var reg = /<tr.*?>(.*?)<\/tr>/g;
      var reg2 = /<td.*?>(.*?)<\/td>/g;
      var regArr = txtdata.match(reg) || [];

      for (var i = 0; i < regArr.length; i += 1) {
        var cpRowArr = [];
        var reg2Arr = regArr[i].match(reg2);

        if (!_.isNil(reg2Arr)) {
          for (var j = 0; j < reg2Arr.length; j += 1) {
            var cpValue = reg2Arr[j].replace(/<td.*?>/g, "").replace(/<\/td>/g, "");
            cpRowArr.push(cpValue);
          }
        }

        cpDataArr.push(cpRowArr);
      }

      var copy_r1 = ctx.luckysheet_copy_save.copyRange[0].row[0];
      var copy_r2 = ctx.luckysheet_copy_save.copyRange[0].row[1];
      var copy_c1 = ctx.luckysheet_copy_save.copyRange[0].column[0];
      var copy_c2 = ctx.luckysheet_copy_save.copyRange[0].column[1];
      var copy_index = ctx.luckysheet_copy_save.dataSheetId;
      var d;

      if (copy_index === ctx.currentSheetId) {
        d = getFlowdata(ctx);
      } else {
        var index = getSheetIndex(ctx, copy_index);
        if (_.isNil(index)) return;
        d = ctx.luckysheetfile[index].data;
      }

      if (!d) return;

      for (var r = copy_r1; r <= copy_r2; r += 1) {
        if (r - copy_r1 > cpDataArr.length - 1) {
          break;
        }

        for (var c = copy_c1; c <= copy_c2; c += 1) {
          var _d$r3, _d$r3$c, _d$r3$c$ct;

          var cell = d[r][c];
          var isInlineStr = false;

          if (!_.isNil(cell) && !_.isNil(cell.mc) && _.isNil(cell.mc.rs)) {
            continue;
          }

          var v = void 0;

          if (!_.isNil(cell)) {
            var _cell$ct$fa$indexOf, _cell$ct, _cell$ct$fa;

            if (((_cell$ct$fa$indexOf = (_cell$ct = cell.ct) === null || _cell$ct === void 0 ? void 0 : (_cell$ct$fa = _cell$ct.fa) === null || _cell$ct$fa === void 0 ? void 0 : _cell$ct$fa.indexOf("w")) !== null && _cell$ct$fa$indexOf !== void 0 ? _cell$ct$fa$indexOf : -1) > -1) {
              var _d$r, _d$r$c;

              v = (_d$r = d[r]) === null || _d$r === void 0 ? void 0 : (_d$r$c = _d$r[c]) === null || _d$r$c === void 0 ? void 0 : _d$r$c.v;
            } else {
              var _d$r2, _d$r2$c;

              v = (_d$r2 = d[r]) === null || _d$r2 === void 0 ? void 0 : (_d$r2$c = _d$r2[c]) === null || _d$r2$c === void 0 ? void 0 : _d$r2$c.m;
            }
          } else {
            v = "";
          }

          if (_.isNil(v) && ((_d$r3 = d[r]) === null || _d$r3 === void 0 ? void 0 : (_d$r3$c = _d$r3[c]) === null || _d$r3$c === void 0 ? void 0 : (_d$r3$c$ct = _d$r3$c.ct) === null || _d$r3$c$ct === void 0 ? void 0 : _d$r3$c$ct.t) === "inlineStr") {
            v = d[r][c].ct.s.map(function (val) {
              return val.v;
            }).join("");
            isInlineStr = true;
          }

          if (_.isNil(v)) {
            v = "";
          }

          if (isInlineStr) ; else {
            if (_.trim(cpDataArr[r - copy_r1][c - copy_c1]) !== _.trim(v)) {
              isEqual = false;
              break;
            }
          }
        }
      }
    }

    var locale_fontjson = locale(ctx).fontjson;

    if (((_ctx$hooks$beforePast = (_ctx$hooks = ctx.hooks).beforePaste) === null || _ctx$hooks$beforePast === void 0 ? void 0 : _ctx$hooks$beforePast.call(_ctx$hooks, ctx.luckysheet_select_save, txtdata)) === false) {
      return;
    }

    if (txtdata.indexOf("fortune-copy-action-table") > -1 && ((_ctx$luckysheet_copy_10 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_10 === void 0 ? void 0 : _ctx$luckysheet_copy_10.copyRange) != null && ctx.luckysheet_copy_save.copyRange.length > 0 && isEqual) {
      if (ctx.luckysheet_paste_iscut) {
        ctx.luckysheet_paste_iscut = false;
        pasteHandlerOfCutPaste(ctx, ctx.luckysheet_copy_save);
        ctx.luckysheet_selection_range = [];
      } else {
        pasteHandlerOfCopyPaste(ctx, ctx.luckysheet_copy_save);
      }
    } else if (txtdata.indexOf("fortune-copy-action-image") > -1) ; else {
      if (txtdata.indexOf("table") > -1) {
        var _ele$querySelectorAll;

        var ele = document.createElement("div");
        ele.innerHTML = txtdata;
        var trList = ele.querySelectorAll("table tr");

        if (trList.length === 0) {
          ele.remove();
          return;
        }

        var data = new Array(trList.length);
        var colLen = 0;

        _.forEach(trList[0].querySelectorAll("td"), function (td) {
          var colspan = td.colSpan;

          if (Number.isNaN(colspan)) {
            colspan = 1;
          }

          colLen += colspan;
        });

        for (var _i8 = 0; _i8 < data.length; _i8 += 1) {
          data[_i8] = new Array(colLen);
        }

        var _r2 = 0;
        var borderInfo = {};
        var styleInner = ((_ele$querySelectorAll = ele.querySelectorAll("style")[0]) === null || _ele$querySelectorAll === void 0 ? void 0 : _ele$querySelectorAll.innerHTML) || "";
        var patternReg = /{([^}]*)}/g;
        var patternStyle = styleInner.match(patternReg);
        var nameReg = /^[^\t].*/gm;

        var patternName = _.initial(styleInner.match(nameReg));

        var allStyleList = patternName.length === (patternStyle === null || patternStyle === void 0 ? void 0 : patternStyle.length) && _typeof(patternName) === _typeof(patternStyle) ? _.fromPairs(_.zip(patternName, patternStyle)) : {};

        var _index = getSheetIndex(ctx, ctx.currentSheetId);

        if (!_.isNil(_index)) {
          if (_.isNil(ctx.luckysheetfile[_index].config)) {
            ctx.luckysheetfile[_index].config = {};
          }

          if (_.isNil(ctx.luckysheetfile[_index].config.rowlen)) {
            ctx.luckysheetfile[_index].config.rowlen = {};
          }

          var rowHeightList = ctx.luckysheetfile[_index].config.rowlen;

          _.forEach(trList, function (tr) {
            var c = 0;
            var targetR = ctx.luckysheet_select_save[0].row[0] + _r2;
            var targetRowHeight = !_.isNil(tr.getAttribute("height")) ? parseInt(tr.getAttribute("height"), 10) : null;

            if (_.has(ctx.luckysheetfile[_index].config.rowlen, targetR) && ctx.luckysheetfile[_index].config.rowlen[targetR] !== targetRowHeight || !_.has(ctx.luckysheetfile[_index].config.rowlen, targetR) && ctx.luckysheetfile[_index].defaultRowHeight !== targetRowHeight) {
              rowHeightList[targetR] = targetRowHeight;
            }

            _.forEach(tr.querySelectorAll("td"), function (td) {
              var className = td.className;
              var cell = {};
              var txt = td.innerText || td.innerHTML;

              if (_.trim(txt).length === 0) {
                cell.v = undefined;
                cell.m = "";
              } else {
                var mask = genarate(txt);

                var _mask2 = _slicedToArray(mask, 3);

                cell.m = _mask2[0];
                cell.ct = _mask2[1];
                cell.v = _mask2[2];
              }

              var styleString = typeof allStyleList[".".concat(className)] === "string" ? allStyleList[".".concat(className)].substring(1, allStyleList[".".concat(className)].length - 1).split("\n\t") : [];
              var styles = {};

              _.forEach(styleString, function (s) {
                var styleList = s.split(":");
                styles[styleList[0]] = styleList === null || styleList === void 0 ? void 0 : styleList[1].replace(";", "");
              });

              if (!_.isNil(styles.border)) td.style.border = styles.border;
              var bg = td.style.backgroundColor || styles.background;

              if (bg === "rgba(0, 0, 0, 0)" || _.isEmpty(bg)) {
                bg = undefined;
              }

              cell.bg = bg;
              var fontWight = td.style.fontWeight;
              cell.bl = (fontWight.toString() === "400" || fontWight === "normal" || _.isEmpty(fontWight)) && !_.includes(styles["font-style"], "bold") && (!styles["font-weight"] || styles["font-weight"] === "400") ? 0 : 1;
              cell.it = (td.style.fontStyle === "normal" || _.isEmpty(td.style.fontStyle)) && !_.includes(styles["font-style"], "italic") ? 0 : 1;
              cell.un = !_.includes(styles["text-decoration"], "underline") ? undefined : 1;
              cell.cl = !_.includes(td.innerHTML, "<s>") ? undefined : 1;
              var ff = td.style.fontFamily || styles["font-family"] || "";
              var ffs = ff.split(",");

              for (var _i9 = 0; _i9 < ffs.length; _i9 += 1) {
                var fa = _.trim(ffs[_i9].toLowerCase());

                fa = locale_fontjson[fa];

                if (_.isNil(fa)) {
                  cell.ff = 0;
                } else {
                  cell.ff = fa;
                  break;
                }
              }

              var fs = Math.round(styles["font-size"] ? parseInt(styles["font-size"].replace("pt", ""), 10) : parseInt(td.style.fontSize || "13", 10) * 72 / 96);
              cell.fs = fs;
              cell.fc = td.style.color || styles.color;
              var ht = td.style.textAlign || styles["text-align"] || "left";

              if (ht === "center") {
                cell.ht = 0;
              } else if (ht === "right") {
                cell.ht = 2;
              } else {
                cell.ht = 1;
              }

              var regex = /vertical-align:\s*(.*?);/;
              var vt = td.style.verticalAlign || styles["vertical-align"] || !_.isNil(allStyleList.td) && allStyleList.td.match(regex).length > 0 && allStyleList.td.match(regex)[1] || "top";

              if (vt === "middle") {
                cell.vt = 0;
              } else if (vt === "top" || vt === "text-top") {
                cell.vt = 1;
              } else {
                cell.vt = 2;
              }

              if ("mso-rotate" in styles) {
                var rt = styles["mso-rotate"];
                cell.rt = parseFloat(rt);
              }

              while (c < colLen && !_.isNil(data[_r2][c])) {
                c += 1;
              }

              if (c === colLen) {
                return true;
              }

              if (_.isNil(data[_r2][c])) {
                data[_r2][c] = cell;
                var rowspan = parseInt(td.getAttribute("rowspan"), 10);
                var colspan = parseInt(td.getAttribute("colspan"), 10);

                if (Number.isNaN(rowspan)) {
                  rowspan = 1;
                }

                if (Number.isNaN(colspan)) {
                  colspan = 1;
                }

                var r_ab = ctx.luckysheet_select_save[0].row[0] + _r2;
                var c_ab = ctx.luckysheet_select_save[0].column[0] + c;

                for (var rp = 0; rp < rowspan; rp += 1) {
                  for (var cp = 0; cp < colspan; cp += 1) {
                    if (rp === 0) {
                      var bt = td.style.borderTop;

                      if (!_.isEmpty(bt) && bt.substring(0, 3).toLowerCase() !== "0px") {
                        var width = td.style.borderTopWidth;
                        var type = td.style.borderTopStyle;
                        var color = td.style.borderTopColor;
                        var borderconfig = getQKBorder(width, type, color);

                        if (!borderInfo["".concat(_r2 + rp, "_").concat(c + cp)]) {
                          borderInfo["".concat(_r2 + rp, "_").concat(c + cp)] = {};
                        }

                        borderInfo["".concat(_r2 + rp, "_").concat(c + cp)].t = {
                          style: borderconfig[0],
                          color: borderconfig[1]
                        };
                      }
                    }

                    if (rp === rowspan - 1) {
                      var bb = td.style.borderBottom;

                      if (!_.isEmpty(bb) && bb.substring(0, 3).toLowerCase() !== "0px") {
                        var _width = td.style.borderBottomWidth;
                        var _type = td.style.borderBottomStyle;
                        var _color = td.style.borderBottomColor;

                        var _borderconfig = getQKBorder(_width, _type, _color);

                        if (!borderInfo["".concat(_r2 + rp, "_").concat(c + cp)]) {
                          borderInfo["".concat(_r2 + rp, "_").concat(c + cp)] = {};
                        }

                        borderInfo["".concat(_r2 + rp, "_").concat(c + cp)].b = {
                          style: _borderconfig[0],
                          color: _borderconfig[1]
                        };
                      }
                    }

                    if (cp === 0) {
                      var bl = td.style.borderLeft;

                      if (!_.isEmpty(bl) && bl.substring(0, 3).toLowerCase() !== "0px") {
                        var _width2 = td.style.borderLeftWidth;
                        var _type2 = td.style.borderLeftStyle;
                        var _color2 = td.style.borderLeftColor;

                        var _borderconfig2 = getQKBorder(_width2, _type2, _color2);

                        if (!borderInfo["".concat(_r2 + rp, "_").concat(c + cp)]) {
                          borderInfo["".concat(_r2 + rp, "_").concat(c + cp)] = {};
                        }

                        borderInfo["".concat(_r2 + rp, "_").concat(c + cp)].l = {
                          style: _borderconfig2[0],
                          color: _borderconfig2[1]
                        };
                      }
                    }

                    if (cp === colspan - 1) {
                      var br = td.style.borderLeft;

                      if (!_.isEmpty(br) && br.substring(0, 3).toLowerCase() !== "0px") {
                        var _width3 = td.style.borderRightWidth;
                        var _type3 = td.style.borderRightStyle;
                        var _color3 = td.style.borderRightColor;

                        var _borderconfig3 = getQKBorder(_width3, _type3, _color3);

                        if (!borderInfo["".concat(_r2 + rp, "_").concat(c + cp)]) {
                          borderInfo["".concat(_r2 + rp, "_").concat(c + cp)] = {};
                        }

                        borderInfo["".concat(_r2 + rp, "_").concat(c + cp)].r = {
                          style: _borderconfig3[0],
                          color: _borderconfig3[1]
                        };
                      }
                    }

                    if (rp === 0 && cp === 0) {
                      continue;
                    }

                    data[_r2 + rp][c + cp] = {
                      mc: {
                        r: r_ab,
                        c: c_ab
                      }
                    };
                  }
                }

                if (rowspan > 1 || colspan > 1) {
                  var first = {
                    rs: rowspan,
                    cs: colspan,
                    r: r_ab,
                    c: c_ab
                  };
                  data[_r2][c].mc = first;
                }
              }

              c += 1;

              if (c === colLen) {
                return true;
              }

              return true;
            });

            _r2 += 1;
          });

          setRowHeight(ctx, rowHeightList);
        }

        ctx.luckysheet_selection_range = [];
        pasteHandler(ctx, data, borderInfo);
        ele.remove();
      } else if (clipboardData.files.length === 1 && clipboardData.files[0].type.indexOf("image") > -1) ; else {
        txtdata = clipboardData.getData("text/plain");
        var isExcelFormula = txtdata.startsWith("=");

        if (isExcelFormula) {
          handleFormulaStringPaste(ctx, txtdata);
        } else {
          pasteHandler(ctx, txtdata);
        }
      }
    }
  } else if (ctx.luckysheetCellUpdate.length > 0) {
    var _clipboardData2;

    e.preventDefault();
    var _clipboardData = e.clipboardData;

    if (!_clipboardData) {
      _clipboardData = window.clipboardData;
    }

    var text = (_clipboardData2 = _clipboardData) === null || _clipboardData2 === void 0 ? void 0 : _clipboardData2.getData("text/plain");

    if (text) {
      document.execCommand("insertText", false, text);
    }
  }
}
function handlePasteByClick(ctx, clipboardData, triggerType) {
  var _ctx$hooks$beforePast2, _ctx$hooks2, _ctx$luckysheet_copy_11;

  var allowEdit = isAllowEdit(ctx);
  if (!allowEdit) return;
  if (clipboardData) clipboard.writeHtml(clipboardData);
  var textarea = document.querySelector("#fortune-copy-content");
  var data = (textarea === null || textarea === void 0 ? void 0 : textarea.innerHTML) || (textarea === null || textarea === void 0 ? void 0 : textarea.textContent);
  if (!data) return;

  if (((_ctx$hooks$beforePast2 = (_ctx$hooks2 = ctx.hooks).beforePaste) === null || _ctx$hooks$beforePast2 === void 0 ? void 0 : _ctx$hooks$beforePast2.call(_ctx$hooks2, ctx.luckysheet_select_save, data)) === false) {
    return;
  }

  if (data.indexOf("fortune-copy-action-table") > -1 && ((_ctx$luckysheet_copy_11 = ctx.luckysheet_copy_save) === null || _ctx$luckysheet_copy_11 === void 0 ? void 0 : _ctx$luckysheet_copy_11.copyRange) != null && ctx.luckysheet_copy_save.copyRange.length > 0) {
    if (ctx.luckysheet_paste_iscut) {
      ctx.luckysheet_paste_iscut = false;
      pasteHandlerOfCutPaste(ctx, ctx.luckysheet_copy_save);
    } else {
      pasteHandlerOfCopyPaste(ctx, ctx.luckysheet_copy_save);
    }
  } else if (data.indexOf("fortune-copy-action-image") > -1) ; else if (triggerType !== "btn") {
    var isExcelFormula = clipboardData.startsWith("=");

    if (isExcelFormula) {
      handleFormulaStringPaste(ctx, clipboardData);
    } else {
      pasteHandler(ctx, clipboardData);
    }
  } else ;
}

export { CFSplitRange, Canvas, FormulaCache, MAX_ZOOM_RATIO, MIN_ZOOM_RATIO, addSheet, index as api, applyLocation, attrToCssName, autoSelectionFormula, calcSelectionInfo, cancelActiveImgItem, cancelFunctionrangeSelected, cancelNormalSelected, cancelPaintModel, cellFocus, cfSplitRange, changeSheet, chatatABC, checkCF, checkCellIsLocked, checkProtectionAllSelected, checkProtectionFormatCells, checkProtectionSelectLockedOrUnLockedCells, checkboxChange, clearFilter, clearMeasureTextCache, colHasMerged, colLocation, colLocationByIndex, colors, columnCharToIndex, commentBoxProps, compute, computeRowlenArr, confirmMessage, convertCssToStyleList, convertSpanToShareString, copy, createDropCellRange, createFilter, createFilterOptions, createFormulaRangeSelect, createRangeHightlight, dataRangeSelection, datenum_local, defaultContext, defaultFont, defaultSettings, defaultStyle, delFunctionGroup, deleteCellInSave, deleteComment, deleteRowCol, deleteSelectedCellText, deleteSheet, diff, drawArrow, drawLineInfo, dropCellCache, editComment, editSheetName, ensureSheetIndex, error, escapeHTMLTag, escapeScriptTag, execFunctionGroup, execfunction, expandRowsAndColumns, extractFormulaCellOps, filterPatch, fixColumnStyleOverflowInFreeze, fixPositionOnFrozenCells, fixRowStyleOverflowInFreeze, functionCopy, functionHTMLGenerate, functionStrChange, genarate, generateRandomId, generateRandomSheetName, getAllFunctionGroup, getArrowCanvasSize, getBorderInfoCompute, getBorderInfoComputeRange, getCellHyperlink, getCellRowColumn, getCellTextInfo, getCellTopRightPostion, getCellValue, getColMerge, getColorGradation, getCommentBoxByRC, getCommentBoxPosition, getComputeMap, getCurrentRules, getDataArr, getDataBySelectionNoCopy, getDropdownList, getFailureText, getFilterColumnColors, getFilterColumnValues, getFlattenedRange, getFlowdata, getFontSet, getFontStyleByCell, getFrozenHandleLeft, getFrozenHandleTop, getHintText, getHistoryRules, getInlineStringHTML, getInlineStringNoStyle, getMeasureText, getNowDateTime, getNullData, getOptionValue, getOrigincell, getQKBorder, getRange, getRangeArr, getRangeByTxt, getRangetxt, getRealCellValue, getRegExpStr, getRegStr, getRowMerge, getSearchIndexArr, getSelectRange, getSheetByIndex, getSheetIdByName, getSheetIndex, getStyleByCell, getTypeItemHide, getcellFormula, getcellrange, getdatabyselection, getrangeseleciton, goToLink, groupValuesRefresh, handleArrowKey, handleBold, handleBorder, handleCellAreaDoubleClick, handleCellAreaMouseDown, handleClearFormat, handleColFreezeHandleMouseDown, handleColSizeHandleMouseDown, handleColumnHeaderMouseDown, handleContextMenu, handleCopy, handleCurrencyFormat, handleFormatPainter, handleFormulaInput, handleFreeze, handleGlobalEnter, handleGlobalKeyDown, handleGlobalWheel, handleHorizontalAlign, handleItalic, handleKeydownForZoom, handleLink, handleMerge, handleNumberDecrease, handleNumberIncrease, handleOverlayMouseMove, handleOverlayMouseUp, handleOverlayTouchEnd, handleOverlayTouchMove, handleOverlayTouchStart, handlePaste, handlePasteByClick, handlePercentageFormat, handleRowFreezeHandleMouseDown, handleRowHeaderMouseDown, handleRowSizeHandleMouseDown, handleScreenShot, handleSort, handleStrikeThrough, handleSum, handleTextBackground, handleTextColor, handleTextSize, handleUnderline, handleVerticalAlign, handleWithCtrlOrMetaKey, hasChinaword, hasPartMC, hideCRCount, hideDropCellSelection, hideSelected, imageProps, indexToColumnChar, initFreeze, initSheetIndex, inlineStyleAffectAttribute, inlineStyleAffectCssName, insertImage, insertRowCol, insertUpdateFunctionGroup, inverseRowColOptions, isAllSelectedCellsInStatus, isAllowEdit, isInlineStringCT, isInlineStringCell, isLinkValid, isRealNull, isRealNum, isShowHidenCR, isSupportBoundingBox, is_date, iscelldata, isdatatype, isdatatypemulti, isdatetime, israngeseleciton, jfrefreshgrid, labelFilterOptionState, locale, luckysheetUpdateCell, mergeBorder, mergeCells, mergeMoveMain, mousePosition, moveHighlightCell, moveHighlightRange, moveToEnd, newComment, normalizeSelection, normalizedAttr, normalizedCellAttr, onCellsMove, onCellsMoveEnd, onCellsMoveStart, onCommentBoxMove, onCommentBoxMoveEnd, onCommentBoxMoveStart, onCommentBoxResize, onCommentBoxResizeEnd, onCommentBoxResizeStart, onDropCellSelect, onDropCellSelectEnd, onFormulaRangeDragEnd, onImageMove, onImageMoveEnd, onImageMoveStart, onImageResize, onImageResizeEnd, onImageResizeStart, onRangeSelectionModalMove, onRangeSelectionModalMoveEnd, onRangeSelectionModalMoveStart, onSearchDialogMove, onSearchDialogMoveEnd, onSearchDialogMoveStart, opToPatch, orderbydata, orderbydatafiler, overShowComment, pasteHandlerOfPaintModel, patchToOp, rangeDrag, rangeDragColumn, rangeDragRow, rangeHightlightselected, rangeSetValue, rangeValueToHtml, removeActiveImage, removeEditingComment, removeHyperlink, replace, replaceAll, replaceHtml, rgbToHex, rowHasMerged, rowLocation, rowLocationByIndex, saveFilter, saveHyperlink, saveImage, scrollToFrozenRowCol, scrollToHighlightCell, searchAll, searchNext, selectAll, selectIsOverlap, selectTextContent, selectTextContentCross, selectTitlesMap, selectTitlesRange, selectionCache, selectionCopyShow, seletedHighlistByindex, setCaretPosition, setCellValue, setConditionRules, setDropcownValue, setEditingComment, showComments, showDropCellSelection, showHideAllComments, showHideComment, showImgChooser, showLinkCard, showSelected, sortDataRange, sortSelection, storeSheetParamALL, toolbarItemClickHandler, toolbarItemSelectedFunc, update, updateCell, updateContextWithCanvas, updateContextWithSheetData, updateDropCell, updateFormat, updateFormatCell, updateInlineStringFormat, updateInlineStringFormatOutside, updateItem, updateMoreCell, updateSheet, validateCellData, validateIdCard, valueIsError, valueShowEs };
